export const worldCities = [
  {
    name: "les Escaldes",
    country: "Andorra",
    subcountry: "Escaldes-Engordany",
    geonameid: 3040051,
  },
  {
    name: "Andorra la Vella",
    country: "Andorra",
    subcountry: "Andorra la Vella",
    geonameid: 3041563,
  },
  {
    name: "Umm Al Quwain City",
    country: "United Arab Emirates",
    subcountry: "Imārat Umm al Qaywayn",
    geonameid: 290594,
  },
  {
    name: "Ras Al Khaimah City",
    country: "United Arab Emirates",
    subcountry: "Raʼs al Khaymah",
    geonameid: 291074,
  },
  {
    name: "Zayed City",
    country: "United Arab Emirates",
    subcountry: "Abu Dhabi",
    geonameid: 291580,
  },
  {
    name: "Khawr Fakkān",
    country: "United Arab Emirates",
    subcountry: "Sharjah",
    geonameid: 291696,
  },
  {
    name: "Dubai",
    country: "United Arab Emirates",
    subcountry: "Dubai",
    geonameid: 292223,
  },
  {
    name: "Dibba Al-Fujairah",
    country: "United Arab Emirates",
    subcountry: "Fujairah",
    geonameid: 292231,
  },
  {
    name: "Dibba Al-Hisn",
    country: "United Arab Emirates",
    subcountry: "Fujairah",
    geonameid: 292239,
  },
  {
    name: "Sharjah",
    country: "United Arab Emirates",
    subcountry: "Sharjah",
    geonameid: 292672,
  },
  {
    name: "Ar Ruways",
    country: "United Arab Emirates",
    subcountry: "Abu Dhabi",
    geonameid: 292688,
  },
  {
    name: "Al Fujairah City",
    country: "United Arab Emirates",
    subcountry: "Fujairah",
    geonameid: 292878,
  },
  {
    name: "Al Ain City",
    country: "United Arab Emirates",
    subcountry: "Abu Dhabi",
    geonameid: 292913,
  },
  {
    name: "Ajman City",
    country: "United Arab Emirates",
    subcountry: "Ajman",
    geonameid: 292932,
  },
  {
    name: "Adh Dhayd",
    country: "United Arab Emirates",
    subcountry: "Sharjah",
    geonameid: 292953,
  },
  {
    name: "Abu Dhabi",
    country: "United Arab Emirates",
    subcountry: "Abu Dhabi",
    geonameid: 292968,
  },
  {
    name: "Khalifah A City",
    country: "United Arab Emirates",
    subcountry: "Abu Dhabi",
    geonameid: 8057551,
  },
  {
    name: "Bani Yas City",
    country: "United Arab Emirates",
    subcountry: "Abu Dhabi",
    geonameid: 12042052,
  },
  {
    name: "Musaffah",
    country: "United Arab Emirates",
    subcountry: "Abu Dhabi",
    geonameid: 12042053,
  },
  {
    name: "Al Shamkhah City",
    country: "United Arab Emirates",
    subcountry: "Abu Dhabi",
    geonameid: 12047416,
  },
  {
    name: "Reef Al Fujairah City",
    country: "United Arab Emirates",
    subcountry: "Fujairah",
    geonameid: 12047417,
  },
  {
    name: "Zaranj",
    country: "Afghanistan",
    subcountry: "Nimroz",
    geonameid: 1120985,
  },
  {
    name: "Bāzār-e Yakāwlang",
    country: "Afghanistan",
    subcountry: "Bamyan",
    geonameid: 1121381,
  },
  {
    name: "Taloqan",
    country: "Afghanistan",
    subcountry: "Takhar",
    geonameid: 1123004,
  },
  {
    name: "Shīnḏanḏ",
    country: "Afghanistan",
    subcountry: "Herat",
    geonameid: 1125155,
  },
  {
    name: "Shibirghān",
    country: "Afghanistan",
    subcountry: "Jowzjan",
    geonameid: 1125444,
  },
  {
    name: "Shahrak",
    country: "Afghanistan",
    subcountry: "Ghowr",
    geonameid: 1125896,
  },
  {
    name: "Sar-e Pul",
    country: "Afghanistan",
    subcountry: "Sar-e Pol Province",
    geonameid: 1127110,
  },
  {
    name: "Sang-e Chārak",
    country: "Afghanistan",
    subcountry: "Sar-e Pol Province",
    geonameid: 1127628,
  },
  {
    name: "Aībak",
    country: "Afghanistan",
    subcountry: "Samangan",
    geonameid: 1127768,
  },
  {
    name: "Rustāq",
    country: "Afghanistan",
    subcountry: "Takhar",
    geonameid: 1128265,
  },
  {
    name: "Qarqīn",
    country: "Afghanistan",
    subcountry: "Jowzjan",
    geonameid: 1129516,
  },
  {
    name: "Qarāwul",
    country: "Afghanistan",
    subcountry: "Kunduz",
    geonameid: 1129648,
  },
  {
    name: "Pul-e Khumrī",
    country: "Afghanistan",
    subcountry: "Baghlan",
    geonameid: 1130490,
  },
  {
    name: "Paghmān",
    country: "Afghanistan",
    subcountry: "Kabul",
    geonameid: 1131316,
  },
  {
    name: "Nahrīn",
    country: "Afghanistan",
    subcountry: "Baghlan",
    geonameid: 1132495,
  },
  {
    name: "Maymana",
    country: "Afghanistan",
    subcountry: "Faryab",
    geonameid: 1133453,
  },
  {
    name: "Mehtar Lām",
    country: "Afghanistan",
    subcountry: "Laghman",
    geonameid: 1133574,
  },
  {
    name: "Mazār-e Sharīf",
    country: "Afghanistan",
    subcountry: "Balkh",
    geonameid: 1133616,
  },
  {
    name: "Lashkar Gāh",
    country: "Afghanistan",
    subcountry: "Helmand",
    geonameid: 1134720,
  },
  {
    name: "Kushk",
    country: "Afghanistan",
    subcountry: "Herat",
    geonameid: 1135158,
  },
  {
    name: "Kunduz",
    country: "Afghanistan",
    subcountry: "Kunduz",
    geonameid: 1135689,
  },
  {
    name: "Khōst",
    country: "Afghanistan",
    subcountry: "Khowst",
    geonameid: 1136469,
  },
  {
    name: "Khulm",
    country: "Afghanistan",
    subcountry: "Balkh",
    geonameid: 1136575,
  },
  {
    name: "Khāsh",
    country: "Afghanistan",
    subcountry: "Nimroz",
    geonameid: 1136863,
  },
  {
    name: "Khanabad",
    country: "Afghanistan",
    subcountry: "Kunduz",
    geonameid: 1137168,
  },
  {
    name: "Karukh",
    country: "Afghanistan",
    subcountry: "Herat",
    geonameid: 1137807,
  },
  {
    name: "Kandahār",
    country: "Afghanistan",
    subcountry: "Kandahar",
    geonameid: 1138336,
  },
  {
    name: "Kabul",
    country: "Afghanistan",
    subcountry: "Kabul",
    geonameid: 1138958,
  },
  {
    name: "Jalālābād",
    country: "Afghanistan",
    subcountry: "Nangarhar",
    geonameid: 1139715,
  },
  {
    name: "Jabal os Saraj",
    country: "Afghanistan",
    subcountry: "Parwan",
    geonameid: 1139807,
  },
  {
    name: "Herāt",
    country: "Afghanistan",
    subcountry: "Herat",
    geonameid: 1140026,
  },
  {
    name: "Ghormach",
    country: "Afghanistan",
    subcountry: "Badghis",
    geonameid: 1141089,
  },
  {
    name: "Ghazni",
    country: "Afghanistan",
    subcountry: "Ghazni",
    geonameid: 1141269,
  },
  {
    name: "Gereshk",
    country: "Afghanistan",
    subcountry: "Helmand",
    geonameid: 1141540,
  },
  {
    name: "Gardez",
    country: "Afghanistan",
    subcountry: "Paktia",
    geonameid: 1141857,
  },
  {
    name: "Fayzabad",
    country: "Afghanistan",
    subcountry: "Badakhshan",
    geonameid: 1142170,
  },
  {
    name: "Farah",
    country: "Afghanistan",
    subcountry: "Farah",
    geonameid: 1142264,
  },
  {
    name: "Eslam Qaleh",
    country: "Afghanistan",
    subcountry: "Herat",
    geonameid: 1142404,
  },
  {
    name: "Charikar",
    country: "Afghanistan",
    subcountry: "Parwan",
    geonameid: 1145352,
  },
  {
    name: "Baraki Barak",
    country: "Afghanistan",
    subcountry: "Logar",
    geonameid: 1147066,
  },
  {
    name: "Bāmyān",
    country: "Afghanistan",
    subcountry: "Bamyan",
    geonameid: 1147242,
  },
  {
    name: "Balkh",
    country: "Afghanistan",
    subcountry: "Balkh",
    geonameid: 1147290,
  },
  {
    name: "Baghlān",
    country: "Afghanistan",
    subcountry: "Baghlan",
    geonameid: 1147540,
  },
  {
    name: "Ārt Khwājah",
    country: "Afghanistan",
    subcountry: "Takhar",
    geonameid: 1148106,
  },
  {
    name: "Āsmār",
    country: "Afghanistan",
    subcountry: "Kunar",
    geonameid: 1148205,
  },
  {
    name: "Asadābād",
    country: "Afghanistan",
    subcountry: "Kunar",
    geonameid: 1148311,
  },
  {
    name: "Andkhōy",
    country: "Afghanistan",
    subcountry: "Faryab",
    geonameid: 1148658,
  },
  {
    name: "Bāzārak",
    country: "Afghanistan",
    subcountry: "Panjshir",
    geonameid: 1429434,
  },
  {
    name: "Markaz-e Woluswalī-ye Āchīn",
    country: "Afghanistan",
    subcountry: "Nangarhar",
    geonameid: 1469706,
  },
  {
    name: "Saint John’s",
    country: "Antigua and Barbuda",
    subcountry: "Saint John",
    geonameid: 3576022,
  },
  {
    name: "The Valley",
    country: "Anguilla",
    subcountry: "The Valley",
    geonameid: 3573374,
  },
  {
    name: "Sarandë",
    country: "Albania",
    subcountry: "Vlorë County",
    geonameid: 363243,
  },
  {
    name: "Pogradec",
    country: "Albania",
    subcountry: "Korçë County",
    geonameid: 781988,
  },
  {
    name: "Kukës",
    country: "Albania",
    subcountry: "Kukës County",
    geonameid: 782661,
  },
  {
    name: "Korçë",
    country: "Albania",
    subcountry: "Korçë County",
    geonameid: 782756,
  },
  {
    name: "Gjirokastër",
    country: "Albania",
    subcountry: "Gjirokastër County",
    geonameid: 783148,
  },
  {
    name: "Elbasan",
    country: "Albania",
    subcountry: "Elbasan County",
    geonameid: 783263,
  },
  {
    name: "Burrel",
    country: "Albania",
    subcountry: "Dibër County",
    geonameid: 783493,
  },
  {
    name: "Vlorë",
    country: "Albania",
    subcountry: "Vlorë County",
    geonameid: 3183719,
  },
  {
    name: "Tirana",
    country: "Albania",
    subcountry: "Tirana",
    geonameid: 3183875,
  },
  {
    name: "Shkodër",
    country: "Albania",
    subcountry: "Shkodër County",
    geonameid: 3184081,
  },
  {
    name: "Patos Fshat",
    country: "Albania",
    subcountry: "Fier County",
    geonameid: 3184517,
  },
  {
    name: "Patos",
    country: "Albania",
    subcountry: "Fier County",
    geonameid: 3184518,
  },
  {
    name: "Lushnjë",
    country: "Albania",
    subcountry: "Fier County",
    geonameid: 3184862,
  },
  {
    name: "Lezhë",
    country: "Albania",
    subcountry: "Lezhë County",
    geonameid: 3184935,
  },
  {
    name: "Laç",
    country: "Albania",
    subcountry: "Lezhë County",
    geonameid: 3185012,
  },
  {
    name: "Krujë",
    country: "Albania",
    subcountry: "Durrës County",
    geonameid: 3185082,
  },
  {
    name: "Kavajë",
    country: "Albania",
    subcountry: "Tirana",
    geonameid: 3185211,
  },
  {
    name: "Fier-Çifçi",
    country: "Albania",
    subcountry: "Fier County",
    geonameid: 3185670,
  },
  {
    name: "Fier",
    country: "Albania",
    subcountry: "Fier County",
    geonameid: 3185672,
  },
  {
    name: "Durrës",
    country: "Albania",
    subcountry: "Durrës County",
    geonameid: 3185728,
  },
  {
    name: "Berat",
    country: "Albania",
    subcountry: "Berat County",
    geonameid: 3186084,
  },
  {
    name: "Kapan",
    country: "Armenia",
    subcountry: "Syunik",
    geonameid: 174875,
  },
  {
    name: "Goris",
    country: "Armenia",
    subcountry: "Syunik",
    geonameid: 174895,
  },
  {
    name: "Hats’avan",
    country: "Armenia",
    subcountry: "Syunik",
    geonameid: 174972,
  },
  {
    name: "Artashat",
    country: "Armenia",
    subcountry: "Ararat",
    geonameid: 174979,
  },
  {
    name: "Ararat",
    country: "Armenia",
    subcountry: "Ararat",
    geonameid: 174991,
  },
  {
    name: "Yerevan",
    country: "Armenia",
    subcountry: "Yerevan",
    geonameid: 616052,
  },
  {
    name: "Vagharshapat",
    country: "Armenia",
    subcountry: "Armavir",
    geonameid: 616062,
  },
  {
    name: "Stepanavan",
    country: "Armenia",
    subcountry: "Lori",
    geonameid: 616194,
  },
  {
    name: "Spitak",
    country: "Armenia",
    subcountry: "Lori",
    geonameid: 616199,
  },
  {
    name: "Sevan",
    country: "Armenia",
    subcountry: "Gegharkunik",
    geonameid: 616250,
  },
  {
    name: "Masis",
    country: "Armenia",
    subcountry: "Ararat",
    geonameid: 616435,
  },
  {
    name: "Vanadzor",
    country: "Armenia",
    subcountry: "Lori",
    geonameid: 616530,
  },
  {
    name: "Gavar",
    country: "Armenia",
    subcountry: "Gegharkunik",
    geonameid: 616599,
  },
  {
    name: "Hrazdan",
    country: "Armenia",
    subcountry: "Kotayk",
    geonameid: 616629,
  },
  {
    name: "Armavir",
    country: "Armenia",
    subcountry: "Armavir",
    geonameid: 616631,
  },
  {
    name: "Gyumri",
    country: "Armenia",
    subcountry: "Shirak",
    geonameid: 616635,
  },
  {
    name: "Ch’arents’avan",
    country: "Armenia",
    subcountry: "Kotayk",
    geonameid: 616785,
  },
  {
    name: "Ashtarak",
    country: "Armenia",
    subcountry: "Aragatsotn",
    geonameid: 616877,
  },
  {
    name: "Abovyan",
    country: "Armenia",
    subcountry: "Kotayk",
    geonameid: 617026,
  },
  {
    name: "Saurimo",
    country: "Angola",
    subcountry: "Lunda Sul",
    geonameid: 145531,
  },
  {
    name: "Lucapa",
    country: "Angola",
    subcountry: "Luanda Norte",
    geonameid: 145724,
  },
  {
    name: "Luau",
    country: "Angola",
    subcountry: "Moxico",
    geonameid: 876177,
  },
  {
    name: "Uíge",
    country: "Angola",
    subcountry: "Uíge",
    geonameid: 2236568,
  },
  {
    name: "Soio",
    country: "Angola",
    subcountry: "Zaire",
    geonameid: 2236967,
  },
  {
    name: "N'zeto",
    country: "Angola",
    subcountry: "Zaire",
    geonameid: 2239001,
  },
  {
    name: "N’dalatando",
    country: "Angola",
    subcountry: "Cuanza Norte",
    geonameid: 2239076,
  },
  {
    name: "Mbanza Kongo",
    country: "Angola",
    subcountry: "Zaire",
    geonameid: 2239520,
  },
  {
    name: "Malanje",
    country: "Angola",
    subcountry: "Malanje",
    geonameid: 2239862,
  },
  {
    name: "Luanda",
    country: "Angola",
    subcountry: "Luanda",
    geonameid: 2240449,
  },
  {
    name: "Caxito",
    country: "Angola",
    subcountry: "Bengo",
    geonameid: 2242001,
  },
  {
    name: "Cabinda",
    country: "Angola",
    subcountry: "Cabinda",
    geonameid: 2243271,
  },
  {
    name: "Sumbe",
    country: "Angola",
    subcountry: "Kwanza Sul",
    geonameid: 3346015,
  },
  {
    name: "Moçâmedes",
    country: "Angola",
    subcountry: "Namibe",
    geonameid: 3347019,
  },
  {
    name: "Menongue",
    country: "Angola",
    subcountry: "Cuando Cobango",
    geonameid: 3347353,
  },
  {
    name: "Luena",
    country: "Angola",
    subcountry: "Moxico",
    geonameid: 3347719,
  },
  {
    name: "Lubango",
    country: "Angola",
    subcountry: "Huíla",
    geonameid: 3347762,
  },
  {
    name: "Longonjo",
    country: "Angola",
    subcountry: "Huambo",
    geonameid: 3347853,
  },
  {
    name: "Lobito",
    country: "Angola",
    subcountry: "Benguela",
    geonameid: 3347939,
  },
  {
    name: "Cuito",
    country: "Angola",
    subcountry: "Bíe",
    geonameid: 3348078,
  },
  {
    name: "Huambo",
    country: "Angola",
    subcountry: "Huambo",
    geonameid: 3348313,
  },
  {
    name: "Catumbela",
    country: "Angola",
    subcountry: "Benguela",
    geonameid: 3350246,
  },
  {
    name: "Catabola",
    country: "Angola",
    subcountry: "Bíe",
    geonameid: 3350372,
  },
  {
    name: "Camacupa",
    country: "Angola",
    subcountry: "Bíe",
    geonameid: 3351014,
  },
  {
    name: "Caála",
    country: "Angola",
    subcountry: "Huambo",
    geonameid: 3351500,
  },
  {
    name: "Benguela",
    country: "Angola",
    subcountry: "Benguela",
    geonameid: 3351663,
  },
  {
    name: "Zárate",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3427213,
  },
  {
    name: "Wanda",
    country: "Argentina",
    subcountry: "Misiones",
    geonameid: 3427327,
  },
  {
    name: "Villa Ortúzar",
    country: "Argentina",
    subcountry: "Buenos Aires F.D.",
    geonameid: 3427387,
  },
  {
    name: "Villa Ocampo",
    country: "Argentina",
    subcountry: "Santa Fe",
    geonameid: 3427388,
  },
  {
    name: "Villa Lugano",
    country: "Argentina",
    subcountry: "Buenos Aires F.D.",
    geonameid: 3427408,
  },
  {
    name: "Villaguay",
    country: "Argentina",
    subcountry: "Entre Rios",
    geonameid: 3427428,
  },
  {
    name: "Villa Gesell",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3427431,
  },
  {
    name: "Villa de Mayo",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3427453,
  },
  {
    name: "Tortuguitas",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3427687,
  },
  {
    name: "Tigre",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3427761,
  },
  {
    name: "Tandil",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3427833,
  },
  {
    name: "San Vicente",
    country: "Argentina",
    subcountry: "Misiones",
    geonameid: 3428068,
  },
  {
    name: "Santo Tomé",
    country: "Argentina",
    subcountry: "Corrientes",
    geonameid: 3428071,
  },
  {
    name: "Santos Lugares",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3428075,
  },
  {
    name: "Santa Elena",
    country: "Argentina",
    subcountry: "Entre Rios",
    geonameid: 3428359,
  },
  {
    name: "San Pedro",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3428576,
  },
  {
    name: "San Pedro",
    country: "Argentina",
    subcountry: "Misiones",
    geonameid: 3428577,
  },
  {
    name: "San Luis del Palmar",
    country: "Argentina",
    subcountry: "Corrientes",
    geonameid: 3428708,
  },
  {
    name: "San Lorenzo",
    country: "Argentina",
    subcountry: "Corrientes",
    geonameid: 3428759,
  },
  {
    name: "San Javier",
    country: "Argentina",
    subcountry: "Santa Fe",
    geonameid: 3428975,
  },
  {
    name: "San Isidro",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3428992,
  },
  {
    name: "Saladas",
    country: "Argentina",
    subcountry: "Corrientes",
    geonameid: 3429403,
  },
  {
    name: "Retiro",
    country: "Argentina",
    subcountry: "Buenos Aires F.D.",
    geonameid: 3429576,
  },
  {
    name: "Resistencia",
    country: "Argentina",
    subcountry: "Chaco",
    geonameid: 3429577,
  },
  {
    name: "Reconquista",
    country: "Argentina",
    subcountry: "Santa Fe",
    geonameid: 3429594,
  },
  {
    name: "Quilmes",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3429652,
  },
  {
    name: "Puerto Rico",
    country: "Argentina",
    subcountry: "Misiones",
    geonameid: 3429732,
  },
  {
    name: "Puerto Iguazú",
    country: "Argentina",
    subcountry: "Misiones",
    geonameid: 3429777,
  },
  {
    name: "Puerto Esperanza",
    country: "Argentina",
    subcountry: "Misiones",
    geonameid: 3429786,
  },
  {
    name: "Puerto Eldorado",
    country: "Argentina",
    subcountry: "Misiones",
    geonameid: 3429790,
  },
  {
    name: "Posadas",
    country: "Argentina",
    subcountry: "Misiones",
    geonameid: 3429886,
  },
  {
    name: "Pontevedra",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3429902,
  },
  {
    name: "Pirané",
    country: "Argentina",
    subcountry: "Formosa",
    geonameid: 3429949,
  },
  {
    name: "Pilar",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3429980,
  },
  {
    name: "Paso de los Libres",
    country: "Argentina",
    subcountry: "Corrientes",
    geonameid: 3430104,
  },
  {
    name: "Oberá",
    country: "Argentina",
    subcountry: "Misiones",
    geonameid: 3430340,
  },
  {
    name: "Necochea",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3430443,
  },
  {
    name: "Muñiz",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3430513,
  },
  {
    name: "Morón",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3430545,
  },
  {
    name: "Monte Caseros",
    country: "Argentina",
    subcountry: "Corrientes",
    geonameid: 3430598,
  },
  {
    name: "Montecarlo",
    country: "Argentina",
    subcountry: "Misiones",
    geonameid: 3430601,
  },
  {
    name: "Merlo",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3430697,
  },
  {
    name: "Mercedes",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3430708,
  },
  {
    name: "Mercedes",
    country: "Argentina",
    subcountry: "Corrientes",
    geonameid: 3430709,
  },
  {
    name: "Mar del Plata",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3430863,
  },
  {
    name: "Luján",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3430988,
  },
  {
    name: "Los Polvorines",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3431057,
  },
  {
    name: "La Plata",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3432043,
  },
  {
    name: "La Paz",
    country: "Argentina",
    subcountry: "Entre Rios",
    geonameid: 3432079,
  },
  {
    name: "Jardín América",
    country: "Argentina",
    subcountry: "Misiones",
    geonameid: 3433349,
  },
  {
    name: "Hurlingham",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3433522,
  },
  {
    name: "Gualeguaychú",
    country: "Argentina",
    subcountry: "Entre Rios",
    geonameid: 3433658,
  },
  {
    name: "Gualeguay",
    country: "Argentina",
    subcountry: "Entre Rios",
    geonameid: 3433663,
  },
  {
    name: "Goya",
    country: "Argentina",
    subcountry: "Corrientes",
    geonameid: 3433715,
  },
  {
    name: "Gobernador Virasora",
    country: "Argentina",
    subcountry: "Corrientes",
    geonameid: 3433753,
  },
  {
    name: "General Pacheco",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3433787,
  },
  {
    name: "General José de San Martín",
    country: "Argentina",
    subcountry: "Chaco",
    geonameid: 3433803,
  },
  {
    name: "Garupá",
    country: "Argentina",
    subcountry: "Misiones",
    geonameid: 3433836,
  },
  {
    name: "Formosa",
    country: "Argentina",
    subcountry: "Formosa",
    geonameid: 3433899,
  },
  {
    name: "Fontana",
    country: "Argentina",
    subcountry: "Chaco",
    geonameid: 3433901,
  },
  {
    name: "Federal",
    country: "Argentina",
    subcountry: "Entre Rios",
    geonameid: 3433956,
  },
  {
    name: "Esquina",
    country: "Argentina",
    subcountry: "Corrientes",
    geonameid: 3434095,
  },
  {
    name: "El Soberbio",
    country: "Argentina",
    subcountry: "Misiones",
    geonameid: 3434291,
  },
  {
    name: "Don Torcuato",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3435010,
  },
  {
    name: "Dolores",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3435038,
  },
  {
    name: "Curuzú Cuatiá",
    country: "Argentina",
    subcountry: "Corrientes",
    geonameid: 3435103,
  },
  {
    name: "Corrientes",
    country: "Argentina",
    subcountry: "Corrientes",
    geonameid: 3435217,
  },
  {
    name: "Concordia",
    country: "Argentina",
    subcountry: "Entre Rios",
    geonameid: 3435261,
  },
  {
    name: "Concepción del Uruguay",
    country: "Argentina",
    subcountry: "Entre Rios",
    geonameid: 3435264,
  },
  {
    name: "Colegiales",
    country: "Argentina",
    subcountry: "Buenos Aires F.D.",
    geonameid: 3435356,
  },
  {
    name: "Chajarí",
    country: "Argentina",
    subcountry: "Entre Rios",
    geonameid: 3435486,
  },
  {
    name: "Campana",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3435810,
  },
  {
    name: "Buenos Aires",
    country: "Argentina",
    subcountry: "Buenos Aires F.D.",
    geonameid: 3435910,
  },
  {
    name: "Boedo",
    country: "Argentina",
    subcountry: "Buenos Aires F.D.",
    geonameid: 3436003,
  },
  {
    name: "Berazategui",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3436043,
  },
  {
    name: "Bella Vista",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3436061,
  },
  {
    name: "Belgrano",
    country: "Argentina",
    subcountry: "Buenos Aires F.D.",
    geonameid: 3436077,
  },
  {
    name: "Barranqueras",
    country: "Argentina",
    subcountry: "Chaco",
    geonameid: 3436124,
  },
  {
    name: "Barracas",
    country: "Argentina",
    subcountry: "Buenos Aires F.D.",
    geonameid: 3436134,
  },
  {
    name: "Balcarce",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3436177,
  },
  {
    name: "Azul",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3436199,
  },
  {
    name: "Avellaneda",
    country: "Argentina",
    subcountry: "Santa Fe",
    geonameid: 3436230,
  },
  {
    name: "Aristóbulo del Valle",
    country: "Argentina",
    subcountry: "Misiones",
    geonameid: 3436287,
  },
  {
    name: "Zapala",
    country: "Argentina",
    subcountry: "Neuquen",
    geonameid: 3832132,
  },
  {
    name: "Yerba Buena",
    country: "Argentina",
    subcountry: "Tucuman",
    geonameid: 3832260,
  },
  {
    name: "Villa Regina",
    country: "Argentina",
    subcountry: "Rio Negro",
    geonameid: 3832647,
  },
  {
    name: "Villa Paula de Sarmiento",
    country: "Argentina",
    subcountry: "San Juan",
    geonameid: 3832653,
  },
  {
    name: "Villa Nueva",
    country: "Argentina",
    subcountry: "Cordoba",
    geonameid: 3832662,
  },
  {
    name: "Villa María",
    country: "Argentina",
    subcountry: "Cordoba",
    geonameid: 3832694,
  },
  {
    name: "Villa Dolores",
    country: "Argentina",
    subcountry: "Cordoba",
    geonameid: 3832756,
  },
  {
    name: "Villa Constitución",
    country: "Argentina",
    subcountry: "Santa Fe",
    geonameid: 3832778,
  },
  {
    name: "Villa Carlos Paz",
    country: "Argentina",
    subcountry: "Cordoba",
    geonameid: 3832791,
  },
  {
    name: "Villa Ángela",
    country: "Argentina",
    subcountry: "Chaco",
    geonameid: 3832811,
  },
  {
    name: "Villa Allende",
    country: "Argentina",
    subcountry: "Cordoba",
    geonameid: 3832815,
  },
  {
    name: "Viedma",
    country: "Argentina",
    subcountry: "Rio Negro",
    geonameid: 3832899,
  },
  {
    name: "Victoria",
    country: "Argentina",
    subcountry: "Entre Rios",
    geonameid: 3832934,
  },
  {
    name: "Vera",
    country: "Argentina",
    subcountry: "Santa Fe",
    geonameid: 3833027,
  },
  {
    name: "Venado Tuerto",
    country: "Argentina",
    subcountry: "Santa Fe",
    geonameid: 3833062,
  },
  {
    name: "Veinticinco de Mayo",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3833112,
  },
  {
    name: "Ushuaia",
    country: "Argentina",
    subcountry: "Tierra del Fuego",
    geonameid: 3833367,
  },
  {
    name: "Unquillo",
    country: "Argentina",
    subcountry: "Cordoba",
    geonameid: 3833412,
  },
  {
    name: "Tres Isletas",
    country: "Argentina",
    subcountry: "Chaco",
    geonameid: 3833794,
  },
  {
    name: "Tres Arroyos",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3833859,
  },
  {
    name: "Trelew",
    country: "Argentina",
    subcountry: "Chubut",
    geonameid: 3833883,
  },
  {
    name: "Termas de Río Hondo",
    country: "Argentina",
    subcountry: "Santiago del Estero",
    geonameid: 3834502,
  },
  {
    name: "Tartagal",
    country: "Argentina",
    subcountry: "Salta",
    geonameid: 3834601,
  },
  {
    name: "Tafí Viejo",
    country: "Argentina",
    subcountry: "Tucuman",
    geonameid: 3834813,
  },
  {
    name: "Sunchales",
    country: "Argentina",
    subcountry: "Santa Fe",
    geonameid: 3834971,
  },
  {
    name: "Santo Tomé",
    country: "Argentina",
    subcountry: "Santa Fe",
    geonameid: 3835793,
  },
  {
    name: "Santiago del Estero",
    country: "Argentina",
    subcountry: "Santiago del Estero",
    geonameid: 3835869,
  },
  {
    name: "Santa Rosa",
    country: "Argentina",
    subcountry: "La Pampa",
    geonameid: 3835994,
  },
  {
    name: "Santa Lucía",
    country: "Argentina",
    subcountry: "San Juan",
    geonameid: 3836194,
  },
  {
    name: "Santa Fe",
    country: "Argentina",
    subcountry: "Santa Fe",
    geonameid: 3836277,
  },
  {
    name: "San Salvador de Jujuy",
    country: "Argentina",
    subcountry: "Jujuy",
    geonameid: 3836564,
  },
  {
    name: "San Ramón de la Nueva Orán",
    country: "Argentina",
    subcountry: "Salta",
    geonameid: 3836620,
  },
  {
    name: "San Rafael",
    country: "Argentina",
    subcountry: "Mendoza",
    geonameid: 3836669,
  },
  {
    name: "San Pedro de Jujuy",
    country: "Argentina",
    subcountry: "Jujuy",
    geonameid: 3836772,
  },
  {
    name: "San Nicolás de los Arroyos",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3836846,
  },
  {
    name: "San Miguel de Tucumán",
    country: "Argentina",
    subcountry: "Tucuman",
    geonameid: 3836873,
  },
  {
    name: "San Martín de los Andes",
    country: "Argentina",
    subcountry: "Neuquen",
    geonameid: 3836951,
  },
  {
    name: "San Martín",
    country: "Argentina",
    subcountry: "Mendoza",
    geonameid: 3836992,
  },
  {
    name: "San Luis",
    country: "Argentina",
    subcountry: "San Luis",
    geonameid: 3837056,
  },
  {
    name: "San Justo",
    country: "Argentina",
    subcountry: "Santa Fe",
    geonameid: 3837124,
  },
  {
    name: "San Juan",
    country: "Argentina",
    subcountry: "San Juan",
    geonameid: 3837213,
  },
  {
    name: "San José de Jáchal",
    country: "Argentina",
    subcountry: "San Juan",
    geonameid: 3837240,
  },
  {
    name: "San Jorge",
    country: "Argentina",
    subcountry: "Santa Fe",
    geonameid: 3837441,
  },
  {
    name: "San Francisco",
    country: "Argentina",
    subcountry: "Cordoba",
    geonameid: 3837675,
  },
  {
    name: "Catamarca",
    country: "Argentina",
    subcountry: "Catamarca",
    geonameid: 3837702,
  },
  {
    name: "San Antonio Oeste",
    country: "Argentina",
    subcountry: "Rio Negro",
    geonameid: 3837980,
  },
  {
    name: "Salta",
    country: "Argentina",
    subcountry: "Salta",
    geonameid: 3838233,
  },
  {
    name: "Rufino",
    country: "Argentina",
    subcountry: "Santa Fe",
    geonameid: 3838506,
  },
  {
    name: "Rosario",
    country: "Argentina",
    subcountry: "Santa Fe",
    geonameid: 3838583,
  },
  {
    name: "Río Tercero",
    country: "Argentina",
    subcountry: "Cordoba",
    geonameid: 3838793,
  },
  {
    name: "Río Segundo",
    country: "Argentina",
    subcountry: "Cordoba",
    geonameid: 3838797,
  },
  {
    name: "Río Grande",
    country: "Argentina",
    subcountry: "Tierra del Fuego",
    geonameid: 3838854,
  },
  {
    name: "Río Gallegos",
    country: "Argentina",
    subcountry: "Santa Cruz",
    geonameid: 3838859,
  },
  {
    name: "Río Cuarto",
    country: "Argentina",
    subcountry: "Cordoba",
    geonameid: 3838874,
  },
  {
    name: "Río Ceballos",
    country: "Argentina",
    subcountry: "Cordoba",
    geonameid: 3838902,
  },
  {
    name: "Rawson",
    country: "Argentina",
    subcountry: "Chubut",
    geonameid: 3839307,
  },
  {
    name: "Rafaela",
    country: "Argentina",
    subcountry: "Santa Fe",
    geonameid: 3839479,
  },
  {
    name: "Quitilipi",
    country: "Argentina",
    subcountry: "Chaco",
    geonameid: 3839490,
  },
  {
    name: "Punta Alta",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3839982,
  },
  {
    name: "Puerto Madryn",
    country: "Argentina",
    subcountry: "Chubut",
    geonameid: 3840092,
  },
  {
    name: "Presidencia Roque Sáenz Peña",
    country: "Argentina",
    subcountry: "Chaco",
    geonameid: 3840300,
  },
  {
    name: "Pocito",
    country: "Argentina",
    subcountry: "San Juan",
    geonameid: 3840860,
  },
  {
    name: "Plottier",
    country: "Argentina",
    subcountry: "Neuquen",
    geonameid: 3840885,
  },
  {
    name: "Pergamino",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3841490,
  },
  {
    name: "Pérez",
    country: "Argentina",
    subcountry: "Santa Fe",
    geonameid: 3841500,
  },
  {
    name: "Paraná",
    country: "Argentina",
    subcountry: "Entre Rios",
    geonameid: 3841956,
  },
  {
    name: "Palpalá",
    country: "Argentina",
    subcountry: "Jujuy",
    geonameid: 3842190,
  },
  {
    name: "Olavarría",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3842670,
  },
  {
    name: "Nueve de Julio",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3842881,
  },
  {
    name: "Neuquén",
    country: "Argentina",
    subcountry: "Neuquen",
    geonameid: 3843123,
  },
  {
    name: "Morteros",
    country: "Argentina",
    subcountry: "Cordoba",
    geonameid: 3843619,
  },
  {
    name: "Monteros",
    country: "Argentina",
    subcountry: "Tucuman",
    geonameid: 3843803,
  },
  {
    name: "Mendoza",
    country: "Argentina",
    subcountry: "Mendoza",
    geonameid: 3844421,
  },
  {
    name: "Marcos Juárez",
    country: "Argentina",
    subcountry: "Cordoba",
    geonameid: 3844899,
  },
  {
    name: "Machagai",
    country: "Argentina",
    subcountry: "Chaco",
    geonameid: 3845330,
  },
  {
    name: "Lincoln",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3846864,
  },
  {
    name: "Libertador General San Martín",
    country: "Argentina",
    subcountry: "Jujuy",
    geonameid: 3846915,
  },
  {
    name: "Las Breñas",
    country: "Argentina",
    subcountry: "Chaco",
    geonameid: 3848687,
  },
  {
    name: "La Rioja",
    country: "Argentina",
    subcountry: "La Rioja",
    geonameid: 3848950,
  },
  {
    name: "La Falda",
    country: "Argentina",
    subcountry: "Cordoba",
    geonameid: 3851331,
  },
  {
    name: "La Calera",
    country: "Argentina",
    subcountry: "Cordoba",
    geonameid: 3852374,
  },
  {
    name: "Laboulaye",
    country: "Argentina",
    subcountry: "Cordoba",
    geonameid: 3852468,
  },
  {
    name: "Junín",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3853354,
  },
  {
    name: "Joaquín V. González",
    country: "Argentina",
    subcountry: "Salta",
    geonameid: 3853491,
  },
  {
    name: "Jesús María",
    country: "Argentina",
    subcountry: "Cordoba",
    geonameid: 3853510,
  },
  {
    name: "Granadero Baigorria",
    country: "Argentina",
    subcountry: "Santa Fe",
    geonameid: 3854895,
  },
  {
    name: "Gobernador Gálvez",
    country: "Argentina",
    subcountry: "Santa Fe",
    geonameid: 3854985,
  },
  {
    name: "General Villegas",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3855041,
  },
  {
    name: "General Roca",
    country: "Argentina",
    subcountry: "Rio Negro",
    geonameid: 3855065,
  },
  {
    name: "General Pinedo",
    country: "Argentina",
    subcountry: "Chaco",
    geonameid: 3855074,
  },
  {
    name: "General Pico",
    country: "Argentina",
    subcountry: "La Pampa",
    geonameid: 3855075,
  },
  {
    name: "General Mosconi",
    country: "Argentina",
    subcountry: "Salta",
    geonameid: 3855116,
  },
  {
    name: "Gálvez",
    country: "Argentina",
    subcountry: "Santa Fe",
    geonameid: 3855244,
  },
  {
    name: "Firmat",
    country: "Argentina",
    subcountry: "Santa Fe",
    geonameid: 3855554,
  },
  {
    name: "Famaillá",
    country: "Argentina",
    subcountry: "Tucuman",
    geonameid: 3855666,
  },
  {
    name: "Esquel",
    country: "Argentina",
    subcountry: "Chubut",
    geonameid: 3855974,
  },
  {
    name: "Esperanza",
    country: "Argentina",
    subcountry: "Santa Fe",
    geonameid: 3856022,
  },
  {
    name: "Embarcación",
    country: "Argentina",
    subcountry: "Salta",
    geonameid: 3856231,
  },
  {
    name: "Embalse",
    country: "Argentina",
    subcountry: "Cordoba",
    geonameid: 3856235,
  },
  {
    name: "El Bolsón",
    country: "Argentina",
    subcountry: "Rio Negro",
    geonameid: 3858765,
  },
  {
    name: "Diamante",
    country: "Argentina",
    subcountry: "Entre Rios",
    geonameid: 3859384,
  },
  {
    name: "Deán Funes",
    country: "Argentina",
    subcountry: "Cordoba",
    geonameid: 3859512,
  },
  {
    name: "Cutral-Có",
    country: "Argentina",
    subcountry: "Neuquen",
    geonameid: 3859552,
  },
  {
    name: "Cruz del Eje",
    country: "Argentina",
    subcountry: "Cordoba",
    geonameid: 3859828,
  },
  {
    name: "Crespo",
    country: "Argentina",
    subcountry: "Entre Rios",
    geonameid: 3859904,
  },
  {
    name: "Cosquín",
    country: "Argentina",
    subcountry: "Cordoba",
    geonameid: 3859965,
  },
  {
    name: "Coronel Suárez",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3860164,
  },
  {
    name: "Coronda",
    country: "Argentina",
    subcountry: "Santa Fe",
    geonameid: 3860217,
  },
  {
    name: "Córdoba",
    country: "Argentina",
    subcountry: "Cordoba",
    geonameid: 3860259,
  },
  {
    name: "Comodoro Rivadavia",
    country: "Argentina",
    subcountry: "Chubut",
    geonameid: 3860443,
  },
  {
    name: "Cipolletti",
    country: "Argentina",
    subcountry: "Rio Negro",
    geonameid: 3861056,
  },
  {
    name: "Cinco Saltos",
    country: "Argentina",
    subcountry: "Rio Negro",
    geonameid: 3861061,
  },
  {
    name: "Chivilcoy",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3861344,
  },
  {
    name: "Chimbas",
    country: "Argentina",
    subcountry: "San Juan",
    geonameid: 3861416,
  },
  {
    name: "Chilecito",
    country: "Argentina",
    subcountry: "La Rioja",
    geonameid: 3861445,
  },
  {
    name: "Charata",
    country: "Argentina",
    subcountry: "Chaco",
    geonameid: 3861678,
  },
  {
    name: "Chacabuco",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3861953,
  },
  {
    name: "Centenario",
    country: "Argentina",
    subcountry: "Neuquen",
    geonameid: 3862144,
  },
  {
    name: "Caucete",
    country: "Argentina",
    subcountry: "San Juan",
    geonameid: 3862240,
  },
  {
    name: "Catriel",
    country: "Argentina",
    subcountry: "Rio Negro",
    geonameid: 3862254,
  },
  {
    name: "Castelli",
    country: "Argentina",
    subcountry: "Chaco",
    geonameid: 3862320,
  },
  {
    name: "Casilda",
    country: "Argentina",
    subcountry: "Santa Fe",
    geonameid: 3862351,
  },
  {
    name: "Carcarañá",
    country: "Argentina",
    subcountry: "Santa Fe",
    geonameid: 3862655,
  },
  {
    name: "Capitán Bermúdez",
    country: "Argentina",
    subcountry: "Santa Fe",
    geonameid: 3862738,
  },
  {
    name: "Cañada de Gómez",
    country: "Argentina",
    subcountry: "Santa Fe",
    geonameid: 3862981,
  },
  {
    name: "Caleta Olivia",
    country: "Argentina",
    subcountry: "Santa Cruz",
    geonameid: 3863379,
  },
  {
    name: "Bell Ville",
    country: "Argentina",
    subcountry: "Cordoba",
    geonameid: 3864331,
  },
  {
    name: "Bella Vista",
    country: "Argentina",
    subcountry: "Tucuman",
    geonameid: 3864375,
  },
  {
    name: "Bahía Blanca",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 3865086,
  },
  {
    name: "Arroyo Seco",
    country: "Argentina",
    subcountry: "Santa Fe",
    geonameid: 3865385,
  },
  {
    name: "Arroyito",
    country: "Argentina",
    subcountry: "Cordoba",
    geonameid: 3865424,
  },
  {
    name: "Añatuya",
    country: "Argentina",
    subcountry: "Santiago del Estero",
    geonameid: 3865840,
  },
  {
    name: "Alta Gracia",
    country: "Argentina",
    subcountry: "Cordoba",
    geonameid: 3866163,
  },
  {
    name: "Allen",
    country: "Argentina",
    subcountry: "Rio Negro",
    geonameid: 3866242,
  },
  {
    name: "Alderetes",
    country: "Argentina",
    subcountry: "Tucuman",
    geonameid: 3866367,
  },
  {
    name: "Albardón",
    country: "Argentina",
    subcountry: "San Juan",
    geonameid: 3866425,
  },
  {
    name: "Aguilares",
    country: "Argentina",
    subcountry: "Tucuman",
    geonameid: 3866496,
  },
  {
    name: "Balvanera",
    country: "Argentina",
    subcountry: "Buenos Aires F.D.",
    geonameid: 6693228,
  },
  {
    name: "Villa Santa Rita",
    country: "Argentina",
    subcountry: "Buenos Aires F.D.",
    geonameid: 6693230,
  },
  {
    name: "Villa Mercedes",
    country: "Argentina",
    subcountry: "San Luis",
    geonameid: 7116866,
  },
  {
    name: "San Miguel",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 7645166,
  },
  {
    name: "San Carlos de Bariloche",
    country: "Argentina",
    subcountry: "Rio Negro",
    geonameid: 7647007,
  },
  {
    name: "Adrogué",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 10172104,
  },
  {
    name: "Ingeniero Pablo Nogués",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 11147723,
  },
  {
    name: "José C. Paz",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 12076997,
  },
  {
    name: "Santa María",
    country: "Argentina",
    subcountry: "Buenos Aires",
    geonameid: 12501204,
  },
  {
    name: "Pago Pago",
    country: "American Samoa",
    subcountry: "Eastern District",
    geonameid: 5881576,
  },
  {
    name: "Wilten",
    country: "Austria",
    subcountry: "Tyrol",
    geonameid: 2761164,
  },
  {
    name: "Wiener Neustadt",
    country: "Austria",
    subcountry: "Lower Austria",
    geonameid: 2761353,
  },
  {
    name: "Vienna",
    country: "Austria",
    subcountry: "Vienna",
    geonameid: 2761369,
  },
  {
    name: "Wetzelsdorf",
    country: "Austria",
    subcountry: "Styria",
    geonameid: 2761436,
  },
  {
    name: "Wels",
    country: "Austria",
    subcountry: "Upper Austria",
    geonameid: 2761524,
  },
  {
    name: "Weinzierl bei Krems",
    country: "Austria",
    subcountry: "Lower Austria",
    geonameid: 2761669,
  },
  {
    name: "Villach",
    country: "Austria",
    subcountry: "Carinthia",
    geonameid: 2762372,
  },
  {
    name: "Telfs",
    country: "Austria",
    subcountry: "Tyrol",
    geonameid: 2763810,
  },
  {
    name: "Straßgang",
    country: "Austria",
    subcountry: "Styria",
    geonameid: 2764178,
  },
  {
    name: "Stockerau",
    country: "Austria",
    subcountry: "Lower Austria",
    geonameid: 2764279,
  },
  {
    name: "Steyr",
    country: "Austria",
    subcountry: "Upper Austria",
    geonameid: 2764359,
  },
  {
    name: "Simmering",
    country: "Austria",
    subcountry: "Vienna",
    geonameid: 2765028,
  },
  {
    name: "Sankt Pölten",
    country: "Austria",
    subcountry: "Lower Austria",
    geonameid: 2766429,
  },
  {
    name: "Sankt Peter",
    country: "Austria",
    subcountry: "Styria",
    geonameid: 2766446,
  },
  {
    name: "Sankt Peter",
    country: "Austria",
    subcountry: "Carinthia",
    geonameid: 2766447,
  },
  {
    name: "Sankt Martin",
    country: "Austria",
    subcountry: "Carinthia",
    geonameid: 2766522,
  },
  {
    name: "Salzburg",
    country: "Austria",
    subcountry: "Salzburg",
    geonameid: 2766824,
  },
  {
    name: "Saalfelden am Steinernen Meer",
    country: "Austria",
    subcountry: "Salzburg",
    geonameid: 2766922,
  },
  {
    name: "Pradl",
    country: "Austria",
    subcountry: "Tyrol",
    geonameid: 2768442,
  },
  {
    name: "Perchtoldsdorf",
    country: "Austria",
    subcountry: "Lower Austria",
    geonameid: 2769110,
  },
  {
    name: "Ottakring",
    country: "Austria",
    subcountry: "Vienna",
    geonameid: 2769359,
  },
  {
    name: "Mödling",
    country: "Austria",
    subcountry: "Lower Austria",
    geonameid: 2771335,
  },
  {
    name: "Meidling",
    country: "Austria",
    subcountry: "Vienna",
    geonameid: 2771706,
  },
  {
    name: "Lustenau",
    country: "Austria",
    subcountry: "Vorarlberg",
    geonameid: 2772173,
  },
  {
    name: "Linz",
    country: "Austria",
    subcountry: "Upper Austria",
    geonameid: 2772400,
  },
  {
    name: "Klosterneuburg",
    country: "Austria",
    subcountry: "Lower Austria",
    geonameid: 2773913,
  },
  {
    name: "Klagenfurt am Wörthersee",
    country: "Austria",
    subcountry: "Carinthia",
    geonameid: 2774326,
  },
  {
    name: "Innsbruck",
    country: "Austria",
    subcountry: "Tyrol",
    geonameid: 2775220,
  },
  {
    name: "Innere Stadt",
    country: "Austria",
    subcountry: "Vienna",
    geonameid: 2775260,
  },
  {
    name: "Hötting",
    country: "Austria",
    subcountry: "Tyrol",
    geonameid: 2775479,
  },
  {
    name: "Hohenems",
    country: "Austria",
    subcountry: "Vorarlberg",
    geonameid: 2775742,
  },
  {
    name: "Hietzing",
    country: "Austria",
    subcountry: "Vienna",
    geonameid: 2776421,
  },
  {
    name: "Hernals",
    country: "Austria",
    subcountry: "Vienna",
    geonameid: 2776488,
  },
  {
    name: "Graz",
    country: "Austria",
    subcountry: "Styria",
    geonameid: 2778067,
  },
  {
    name: "Floridsdorf",
    country: "Austria",
    subcountry: "Vienna",
    geonameid: 2779469,
  },
  {
    name: "Feldkirch",
    country: "Austria",
    subcountry: "Vorarlberg",
    geonameid: 2779674,
  },
  {
    name: "Eggenberg",
    country: "Austria",
    subcountry: "Styria",
    geonameid: 2780361,
  },
  {
    name: "Dornbirn",
    country: "Austria",
    subcountry: "Vorarlberg",
    geonameid: 2780741,
  },
  {
    name: "Bregenz",
    country: "Austria",
    subcountry: "Vorarlberg",
    geonameid: 2781503,
  },
  {
    name: "Baden",
    country: "Austria",
    subcountry: "Lower Austria",
    geonameid: 2782067,
  },
  {
    name: "Amstetten",
    country: "Austria",
    subcountry: "Lower Austria",
    geonameid: 2782555,
  },
  {
    name: "Favoriten",
    country: "Austria",
    subcountry: "Vienna",
    geonameid: 8063098,
  },
  {
    name: "Donaustadt",
    country: "Austria",
    subcountry: "Vienna",
    geonameid: 11903636,
  },
  {
    name: "Jakomini",
    country: "Austria",
    subcountry: "Styria",
    geonameid: 11903637,
  },
  {
    name: "Lend",
    country: "Austria",
    subcountry: "Styria",
    geonameid: 11903638,
  },
  {
    name: "Geidorf",
    country: "Austria",
    subcountry: "Styria",
    geonameid: 11903639,
  },
  {
    name: "Sankt Leonhard",
    country: "Austria",
    subcountry: "Styria",
    geonameid: 11903640,
  },
  {
    name: "Andritz",
    country: "Austria",
    subcountry: "Styria",
    geonameid: 11903641,
  },
  {
    name: "Gries",
    country: "Austria",
    subcountry: "Styria",
    geonameid: 11903642,
  },
  {
    name: "Scarborough",
    country: "Australia",
    subcountry: "Western Australia",
    geonameid: 2061840,
  },
  {
    name: "Rockingham",
    country: "Australia",
    subcountry: "Western Australia",
    geonameid: 2062338,
  },
  {
    name: "Perth",
    country: "Australia",
    subcountry: "Western Australia",
    geonameid: 2063523,
  },
  {
    name: "Mount Isa",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 2065594,
  },
  {
    name: "Morphett Vale",
    country: "Australia",
    subcountry: "South Australia",
    geonameid: 2065740,
  },
  {
    name: "Mandurah",
    country: "Australia",
    subcountry: "Western Australia",
    geonameid: 2067119,
  },
  {
    name: "Kwinana",
    country: "Australia",
    subcountry: "Western Australia",
    geonameid: 2068079,
  },
  {
    name: "Gosnells",
    country: "Australia",
    subcountry: "Western Australia",
    geonameid: 2070571,
  },
  {
    name: "Geraldton",
    country: "Australia",
    subcountry: "Western Australia",
    geonameid: 2070998,
  },
  {
    name: "Gawler",
    country: "Australia",
    subcountry: "South Australia",
    geonameid: 2071059,
  },
  {
    name: "Darwin",
    country: "Australia",
    subcountry: "Northern Territory",
    geonameid: 2073124,
  },
  {
    name: "Byford",
    country: "Australia",
    subcountry: "Western Australia",
    geonameid: 2075230,
  },
  {
    name: "Busselton",
    country: "Australia",
    subcountry: "Western Australia",
    geonameid: 2075265,
  },
  {
    name: "Bunbury",
    country: "Australia",
    subcountry: "Western Australia",
    geonameid: 2075432,
  },
  {
    name: "Australind",
    country: "Australia",
    subcountry: "Western Australia",
    geonameid: 2077454,
  },
  {
    name: "Alice Springs",
    country: "Australia",
    subcountry: "Northern Territory",
    geonameid: 2077895,
  },
  {
    name: "Albany",
    country: "Australia",
    subcountry: "Western Australia",
    geonameid: 2077963,
  },
  {
    name: "Adelaide",
    country: "Australia",
    subcountry: "South Australia",
    geonameid: 2078025,
  },
  {
    name: "Yarraville",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2142457,
  },
  {
    name: "Wollert",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2143255,
  },
  {
    name: "Wodonga",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2143285,
  },
  {
    name: "Wheelers Hill",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2143887,
  },
  {
    name: "Westmead",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2143973,
  },
  {
    name: "Werribee",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2144095,
  },
  {
    name: "Warwick",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 2144502,
  },
  {
    name: "Warrnambool",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2144528,
  },
  {
    name: "Warragul",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2144604,
  },
  {
    name: "Wantirna South",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2144728,
  },
  {
    name: "Wangaratta",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2144764,
  },
  {
    name: "Wahroonga",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2145092,
  },
  {
    name: "Upper Coomera",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 2145461,
  },
  {
    name: "Truganina",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2145990,
  },
  {
    name: "Traralgon",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2146108,
  },
  {
    name: "Townsville",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 2146142,
  },
  {
    name: "Toowoomba",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 2146268,
  },
  {
    name: "Thornbury",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2146793,
  },
  {
    name: "Thomastown",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2146827,
  },
  {
    name: "Templestowe",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2147140,
  },
  {
    name: "Tarneit",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2147357,
  },
  {
    name: "Taree",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2147381,
  },
  {
    name: "Tamworth",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2147497,
  },
  {
    name: "Sydney",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2147714,
  },
  {
    name: "Surry Hills",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2147821,
  },
  {
    name: "Surfers Paradise",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 2147849,
  },
  {
    name: "Sunbury",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2147914,
  },
  {
    name: "Strathfield",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2148088,
  },
  {
    name: "Springvale",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2148591,
  },
  {
    name: "South Yarra",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2148876,
  },
  {
    name: "Southport",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 2148928,
  },
  {
    name: "Shepparton",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2149645,
  },
  {
    name: "Seven Hills",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2149847,
  },
  {
    name: "Seaford",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2149975,
  },
  {
    name: "Saint Kilda",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2150660,
  },
  {
    name: "Saint Ives",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2150669,
  },
  {
    name: "Saint Albans",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2150717,
  },
  {
    name: "Ryde",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2150767,
  },
  {
    name: "Rowville",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2150894,
  },
  {
    name: "Rockhampton",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 2151437,
  },
  {
    name: "Rockdale",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2151443,
  },
  {
    name: "Ringwood",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2151576,
  },
  {
    name: "Richmond",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2151649,
  },
  {
    name: "Reservoir",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2151716,
  },
  {
    name: "Quakers Hill",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2152329,
  },
  {
    name: "Preston",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2152558,
  },
  {
    name: "Port Melbourne",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2152658,
  },
  {
    name: "Port Macquarie",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2152659,
  },
  {
    name: "Point Cook",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2152819,
  },
  {
    name: "Pascoe Vale",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2153720,
  },
  {
    name: "Palm Beach",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 2153925,
  },
  {
    name: "Pakenham",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2153953,
  },
  {
    name: "Orange",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2154219,
  },
  {
    name: "Officer",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2154481,
  },
  {
    name: "North Melbourne",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2154912,
  },
  {
    name: "Northcote",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2155001,
  },
  {
    name: "Noble Park",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2155204,
  },
  {
    name: "Newcastle",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2155472,
  },
  {
    name: "Nerang",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 2155542,
  },
  {
    name: "Narre Warren",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2155718,
  },
  {
    name: "Narangba",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 2155787,
  },
  {
    name: "Mulgrave",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2156340,
  },
  {
    name: "Mount Waverley",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2156492,
  },
  {
    name: "Mount Martha",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2156578,
  },
  {
    name: "Mount Gambier",
    country: "Australia",
    subcountry: "South Australia",
    geonameid: 2156643,
  },
  {
    name: "Mount Eliza",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2156663,
  },
  {
    name: "Mount Druitt",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2156671,
  },
  {
    name: "Mosman",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2156813,
  },
  {
    name: "Mornington",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2156878,
  },
  {
    name: "Morayfield",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 2156934,
  },
  {
    name: "South Morang",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2156942,
  },
  {
    name: "Mooroolbark",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2156977,
  },
  {
    name: "Moonee Ponds",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2157056,
  },
  {
    name: "Mitcham",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2157410,
  },
  {
    name: "Miranda",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2157495,
  },
  {
    name: "Mill Park",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2157635,
  },
  {
    name: "Mildura",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2157698,
  },
  {
    name: "Merrylands",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2157995,
  },
  {
    name: "Mernda",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2158051,
  },
  {
    name: "Melbourne",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2158177,
  },
  {
    name: "Mascot",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2158538,
  },
  {
    name: "Maryborough",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 2158562,
  },
  {
    name: "Marrickville",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2158626,
  },
  {
    name: "Maroubra",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2158651,
  },
  {
    name: "Manly",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2158867,
  },
  {
    name: "Maitland",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2159045,
  },
  {
    name: "Mackay",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 2159220,
  },
  {
    name: "Liverpool",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2159851,
  },
  {
    name: "Lilydale",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2160188,
  },
  {
    name: "Lidcombe",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2160258,
  },
  {
    name: "Launceston",
    country: "Australia",
    subcountry: "Tasmania",
    geonameid: 2160517,
  },
  {
    name: "Lara",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2160560,
  },
  {
    name: "Langwarrin",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2160582,
  },
  {
    name: "Lalor",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2160706,
  },
  {
    name: "Lakemba",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2160744,
  },
  {
    name: "Kogarah",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2161185,
  },
  {
    name: "Keysborough",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2161532,
  },
  {
    name: "Kew",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2161540,
  },
  {
    name: "Kensington",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2161608,
  },
  {
    name: "Hornsby",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2163137,
  },
  {
    name: "Hobart",
    country: "Australia",
    subcountry: "Tasmania",
    geonameid: 2163355,
  },
  {
    name: "Hawthorn South",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2163776,
  },
  {
    name: "Hawthorn",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2163782,
  },
  {
    name: "Hampton Park",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2163990,
  },
  {
    name: "Griffith",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2164422,
  },
  {
    name: "Greenvale",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2164495,
  },
  {
    name: "Greensborough",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2164515,
  },
  {
    name: "Granville",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2164691,
  },
  {
    name: "Goulburn",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2164837,
  },
  {
    name: "Gold Coast",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 2165087,
  },
  {
    name: "Glen Waverley",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2165171,
  },
  {
    name: "Glenroy",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2165200,
  },
  {
    name: "Glen Iris",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2165290,
  },
  {
    name: "Glenferrie",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2165329,
  },
  {
    name: "Gladstone",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 2165478,
  },
  {
    name: "Geelong",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2165798,
  },
  {
    name: "Frankston East",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2166143,
  },
  {
    name: "Frankston",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2166144,
  },
  {
    name: "Footscray",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2166370,
  },
  {
    name: "Fairfield",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2166952,
  },
  {
    name: "Essendon",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2167208,
  },
  {
    name: "Epping",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2167279,
  },
  {
    name: "Epping",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2167280,
  },
  {
    name: "Engadine",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2167312,
  },
  {
    name: "Eltham",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2167445,
  },
  {
    name: "Eight Mile Plains",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 2167651,
  },
  {
    name: "Eastwood",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2167840,
  },
  {
    name: "Earlwood",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2167949,
  },
  {
    name: "Dubbo",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2168305,
  },
  {
    name: "Doreen",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2168537,
  },
  {
    name: "Doncaster East",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2168605,
  },
  {
    name: "Doncaster",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2168607,
  },
  {
    name: "Deer Park",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2169145,
  },
  {
    name: "Deception Bay",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 2169220,
  },
  {
    name: "Dandenong",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2169460,
  },
  {
    name: "Croydon",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2169867,
  },
  {
    name: "Cronulla",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2169956,
  },
  {
    name: "Cranbourne",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2170079,
  },
  {
    name: "Craigieburn",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2170089,
  },
  {
    name: "Corio",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2170307,
  },
  {
    name: "Coorparoo",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 2170435,
  },
  {
    name: "Coogee",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2170697,
  },
  {
    name: "Coffs Harbour",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2171085,
  },
  {
    name: "Coburg",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2171168,
  },
  {
    name: "Clayton",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2171400,
  },
  {
    name: "Wollongong",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2171507,
  },
  {
    name: "Chatswood",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2171707,
  },
  {
    name: "Cessnock",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2171845,
  },
  {
    name: "Caulfield North",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2171945,
  },
  {
    name: "Castle Hill",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2172111,
  },
  {
    name: "Carrum Downs",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2172191,
  },
  {
    name: "Carnegie",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2172264,
  },
  {
    name: "Carlton",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2172293,
  },
  {
    name: "Carlingford",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2172303,
  },
  {
    name: "Capalaba",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 2172434,
  },
  {
    name: "Canberra",
    country: "Australia",
    subcountry: "Australian Capital Territory",
    geonameid: 2172517,
  },
  {
    name: "Camberwell",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2172686,
  },
  {
    name: "Cairns",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 2172797,
  },
  {
    name: "Caboolture",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 2172832,
  },
  {
    name: "Burwood",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2172995,
  },
  {
    name: "Burnie",
    country: "Australia",
    subcountry: "Tasmania",
    geonameid: 2173125,
  },
  {
    name: "Bundaberg",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 2173323,
  },
  {
    name: "Buderim",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 2173605,
  },
  {
    name: "Brunswick",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2173741,
  },
  {
    name: "Broken Hill",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2173911,
  },
  {
    name: "Brisbane",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 2174003,
  },
  {
    name: "Brighton",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2174039,
  },
  {
    name: "Boronia",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2174580,
  },
  {
    name: "Blacktown",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2175411,
  },
  {
    name: "Bexley",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2175974,
  },
  {
    name: "Berwick",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2176031,
  },
  {
    name: "Bentleigh East",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2176122,
  },
  {
    name: "Bentleigh",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2176123,
  },
  {
    name: "Bendigo",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2176187,
  },
  {
    name: "Baulkham Hills",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2176592,
  },
  {
    name: "Bathurst",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2176632,
  },
  {
    name: "Banora Point",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2176934,
  },
  {
    name: "Bankstown",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2176947,
  },
  {
    name: "Ballarat",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2177091,
  },
  {
    name: "Bairnsdale",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2177233,
  },
  {
    name: "Auburn",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2177513,
  },
  {
    name: "Ashfield",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2177565,
  },
  {
    name: "Ascot Vale",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2177576,
  },
  {
    name: "Armidale",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2177671,
  },
  {
    name: "Albany Creek",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 2178208,
  },
  {
    name: "Maroochydore",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 2207268,
  },
  {
    name: "Cheltenham",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 2207618,
  },
  {
    name: "Randwick",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2208285,
  },
  {
    name: "Dee Why",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2208305,
  },
  {
    name: "Umina Beach",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 2208313,
  },
  {
    name: "Palmerston",
    country: "Australia",
    subcountry: "Northern Territory",
    geonameid: 6301965,
  },
  {
    name: "Hervey Bay",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 6354957,
  },
  {
    name: "Sydney Central Business District",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 6619280,
  },
  {
    name: "Kingsford",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 6621337,
  },
  {
    name: "Springfield Lakes",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 6693094,
  },
  {
    name: "Bracken Ridge",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 6943558,
  },
  {
    name: "Kallangur",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 6943560,
  },
  {
    name: "North Lakes",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 6943562,
  },
  {
    name: "The Gap",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 6943585,
  },
  {
    name: "Caroline Springs",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 7281805,
  },
  {
    name: "Hoppers Crossing",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 7281807,
  },
  {
    name: "Logan City",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 7281838,
  },
  {
    name: "Carindale",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 7281839,
  },
  {
    name: "Parramatta",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 7281840,
  },
  {
    name: "Ferntree Gully",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 7281850,
  },
  {
    name: "Adelaide Hills",
    country: "Australia",
    subcountry: "South Australia",
    geonameid: 7302628,
  },
  {
    name: "Canning Vale",
    country: "Australia",
    subcountry: "Western Australia",
    geonameid: 7302631,
  },
  {
    name: "Glenmore Park",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 7302642,
  },
  {
    name: "Southbank",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 7302683,
  },
  {
    name: "Docklands",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 7521471,
  },
  {
    name: "Helensvale",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 7576707,
  },
  {
    name: "Elwood",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 7932620,
  },
  {
    name: "Balwyn North",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 7932629,
  },
  {
    name: "Malvern East",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 7932638,
  },
  {
    name: "Brighton East",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 7932646,
  },
  {
    name: "Redbank Plains",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 7932670,
  },
  {
    name: "Labrador",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 8012683,
  },
  {
    name: "St Albans",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 8015209,
  },
  {
    name: "Endeavour Hills",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 8347325,
  },
  {
    name: "Kellyville",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 8347736,
  },
  {
    name: "Taylors Lakes",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 8347847,
  },
  {
    name: "Cherrybrook",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 8347871,
  },
  {
    name: "Roxburgh Park",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 8347896,
  },
  {
    name: "Prestons",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 8347914,
  },
  {
    name: "Wyndham Vale",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 8348078,
  },
  {
    name: "Ballajura",
    country: "Australia",
    subcountry: "Western Australia",
    geonameid: 8348081,
  },
  {
    name: "Willetton",
    country: "Australia",
    subcountry: "Western Australia",
    geonameid: 8348101,
  },
  {
    name: "Glenwood",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 8348142,
  },
  {
    name: "Cabramatta",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 8348460,
  },
  {
    name: "Campsie",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 8348466,
  },
  {
    name: "Casula",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 8348477,
  },
  {
    name: "Cranebrook",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 8348511,
  },
  {
    name: "Greenacre",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 8348574,
  },
  {
    name: "Greystanes",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 8348582,
  },
  {
    name: "Ellenbrook",
    country: "Australia",
    subcountry: "Western Australia",
    geonameid: 8348596,
  },
  {
    name: "Alexandra Hills",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 8348615,
  },
  {
    name: "Calamvale",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 8348765,
  },
  {
    name: "Yagoona",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 8348768,
  },
  {
    name: "Highton",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 8348824,
  },
  {
    name: "Pacific Pines",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 8348920,
  },
  {
    name: "Robina",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 8348930,
  },
  {
    name: "Paralowie",
    country: "Australia",
    subcountry: "South Australia",
    geonameid: 8349003,
  },
  {
    name: "Baldivis",
    country: "Australia",
    subcountry: "Western Australia",
    geonameid: 8349017,
  },
  {
    name: "Dianella",
    country: "Australia",
    subcountry: "Western Australia",
    geonameid: 8349051,
  },
  {
    name: "Duncraig",
    country: "Australia",
    subcountry: "Western Australia",
    geonameid: 8349052,
  },
  {
    name: "Morley",
    country: "Australia",
    subcountry: "Western Australia",
    geonameid: 8349083,
  },
  {
    name: "Thornlie",
    country: "Australia",
    subcountry: "Western Australia",
    geonameid: 8349108,
  },
  {
    name: "Landsdale",
    country: "Australia",
    subcountry: "Western Australia",
    geonameid: 8349177,
  },
  {
    name: "Punchbowl",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 8349222,
  },
  {
    name: "Parafield Gardens",
    country: "Australia",
    subcountry: "South Australia",
    geonameid: 8349238,
  },
  {
    name: "Hillside",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 8349243,
  },
  {
    name: "St Clair",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 8349321,
  },
  {
    name: "Kirwan",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 8349354,
  },
  {
    name: "Bundoora",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 8349381,
  },
  {
    name: "Forest Lake",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 9957340,
  },
  {
    name: "Sunnybank Hills",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 9957350,
  },
  {
    name: "Rochedale South",
    country: "Australia",
    subcountry: "Queensland",
    geonameid: 9958114,
  },
  {
    name: "Keilor East",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 9972422,
  },
  {
    name: "Cranbourne East",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 9972515,
  },
  {
    name: "Cranbourne North",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 9972516,
  },
  {
    name: "Cranbourne West",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 9972517,
  },
  {
    name: "Narre Warren South",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 9972518,
  },
  {
    name: "Dandenong North",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 9972522,
  },
  {
    name: "Frankston South",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 9972527,
  },
  {
    name: "Sunshine West",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 9972578,
  },
  {
    name: "Altona Meadows",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 9972579,
  },
  {
    name: "Taylors Hill",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 9972586,
  },
  {
    name: "Hurstville",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 9972762,
  },
  {
    name: "West Pennant Hills",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 9972964,
  },
  {
    name: "Melbourne City Centre",
    country: "Australia",
    subcountry: "Victoria",
    geonameid: 11523810,
  },
  {
    name: "Adelaide city centre",
    country: "Australia",
    subcountry: "South Australia",
    geonameid: 11523825,
  },
  {
    name: "Wollongong city centre",
    country: "Australia",
    subcountry: "New South Wales",
    geonameid: 11523847,
  },
  {
    name: "Tanki Leendert",
    country: "Aruba",
    subcountry: "N/A",
    geonameid: 3577072,
  },
  {
    name: "San Nicolas",
    country: "Aruba",
    subcountry: "N/A",
    geonameid: 3577089,
  },
  {
    name: "Oranjestad",
    country: "Aruba",
    subcountry: "N/A",
    geonameid: 3577154,
  },
  {
    name: "Mariehamn",
    country: "Aland Islands",
    subcountry: "Mariehamns stad",
    geonameid: 3041732,
  },
  {
    name: "Xankandi",
    country: "Azerbaijan",
    subcountry: "Xankǝndi",
    geonameid: 146970,
  },
  {
    name: "Əhmədbəyli",
    country: "Azerbaijan",
    subcountry: "Saatlı",
    geonameid: 147059,
  },
  {
    name: "Şuşa",
    country: "Azerbaijan",
    subcountry: "Shusha",
    geonameid: 147105,
  },
  {
    name: "Salyan",
    country: "Azerbaijan",
    subcountry: "Salyan",
    geonameid: 147271,
  },
  {
    name: "Saatlı",
    country: "Azerbaijan",
    subcountry: "Saatlı",
    geonameid: 147288,
  },
  {
    name: "Neftçala",
    country: "Azerbaijan",
    subcountry: "Neftçala",
    geonameid: 147425,
  },
  {
    name: "Nakhchivan",
    country: "Azerbaijan",
    subcountry: "Nakhichevan",
    geonameid: 147429,
  },
  {
    name: "Lerik",
    country: "Azerbaijan",
    subcountry: "Lerik",
    geonameid: 147611,
  },
  {
    name: "Lankaran",
    country: "Azerbaijan",
    subcountry: "Lənkəran",
    geonameid: 147622,
  },
  {
    name: "Imishli",
    country: "Azerbaijan",
    subcountry: "İmişli",
    geonameid: 147982,
  },
  {
    name: "Fizuli",
    country: "Azerbaijan",
    subcountry: "Füzuli",
    geonameid: 148106,
  },
  {
    name: "Jalilabad",
    country: "Azerbaijan",
    subcountry: "Jalilabad",
    geonameid: 148290,
  },
  {
    name: "Pushkino",
    country: "Azerbaijan",
    subcountry: "Bilǝsuvar",
    geonameid: 148340,
  },
  {
    name: "Beylagan",
    country: "Azerbaijan",
    subcountry: "Beyləqan",
    geonameid: 148354,
  },
  {
    name: "Astara",
    country: "Azerbaijan",
    subcountry: "Astara",
    geonameid: 148445,
  },
  {
    name: "Şirvan",
    country: "Azerbaijan",
    subcountry: "Shirvan",
    geonameid: 148565,
  },
  {
    name: "Ağdam",
    country: "Azerbaijan",
    subcountry: "Ağdam",
    geonameid: 148619,
  },
  {
    name: "Zaqatala",
    country: "Azerbaijan",
    subcountry: "Zaqatala",
    geonameid: 584596,
  },
  {
    name: "Zabrat",
    country: "Azerbaijan",
    subcountry: "Baki",
    geonameid: 584614,
  },
  {
    name: "Yevlakh",
    country: "Azerbaijan",
    subcountry: "Yevlax City",
    geonameid: 584649,
  },
  {
    name: "Göygöl",
    country: "Azerbaijan",
    subcountry: "Goygol Rayon",
    geonameid: 584716,
  },
  {
    name: "Xaçmaz",
    country: "Azerbaijan",
    subcountry: "Xaçmaz",
    geonameid: 584717,
  },
  {
    name: "Ujar",
    country: "Azerbaijan",
    subcountry: "Ucar",
    geonameid: 584791,
  },
  {
    name: "Tovuz",
    country: "Azerbaijan",
    subcountry: "Tovuz",
    geonameid: 584821,
  },
  {
    name: "Terter",
    country: "Azerbaijan",
    subcountry: "Tǝrtǝr",
    geonameid: 584871,
  },
  {
    name: "Sumqayıt",
    country: "Azerbaijan",
    subcountry: "Sumqayit",
    geonameid: 584923,
  },
  {
    name: "Qaraçuxur",
    country: "Azerbaijan",
    subcountry: "Baki",
    geonameid: 585103,
  },
  {
    name: "Shamkhor",
    country: "Azerbaijan",
    subcountry: "Şǝmkir",
    geonameid: 585152,
  },
  {
    name: "Shamakhi",
    country: "Azerbaijan",
    subcountry: "Şamaxı",
    geonameid: 585156,
  },
  {
    name: "Sheki",
    country: "Azerbaijan",
    subcountry: "Shaki City",
    geonameid: 585170,
  },
  {
    name: "Sabunçu",
    country: "Azerbaijan",
    subcountry: "Baki",
    geonameid: 585184,
  },
  {
    name: "Sabirabad",
    country: "Azerbaijan",
    subcountry: "Sabirabad",
    geonameid: 585187,
  },
  {
    name: "Qusar",
    country: "Azerbaijan",
    subcountry: "Qusar",
    geonameid: 585220,
  },
  {
    name: "Quba",
    country: "Azerbaijan",
    subcountry: "Quba",
    geonameid: 585221,
  },
  {
    name: "Hacıqabul",
    country: "Azerbaijan",
    subcountry: "Hacıqabul",
    geonameid: 585225,
  },
  {
    name: "Qazax",
    country: "Azerbaijan",
    subcountry: "Qazax",
    geonameid: 585226,
  },
  {
    name: "Hacı Zeynalabdin",
    country: "Azerbaijan",
    subcountry: "Sumqayit",
    geonameid: 585379,
  },
  {
    name: "Mingelchaur",
    country: "Azerbaijan",
    subcountry: "Mingǝcevir",
    geonameid: 585514,
  },
  {
    name: "Maştağa",
    country: "Azerbaijan",
    subcountry: "Baki",
    geonameid: 585557,
  },
  {
    name: "Mardakan",
    country: "Azerbaijan",
    subcountry: "Baki",
    geonameid: 585568,
  },
  {
    name: "Lokbatan",
    country: "Azerbaijan",
    subcountry: "Baki",
    geonameid: 585630,
  },
  {
    name: "Kyurdarmir",
    country: "Azerbaijan",
    subcountry: "Kürdǝmir",
    geonameid: 585763,
  },
  {
    name: "Khirdalan",
    country: "Azerbaijan",
    subcountry: "Abşeron",
    geonameid: 585915,
  },
  {
    name: "İsmayıllı",
    country: "Azerbaijan",
    subcountry: "İsmayıllı",
    geonameid: 586318,
  },
  {
    name: "Yeni Suraxanı",
    country: "Azerbaijan",
    subcountry: "Baki",
    geonameid: 586340,
  },
  {
    name: "Göyçay",
    country: "Azerbaijan",
    subcountry: "Göyçay",
    geonameid: 586427,
  },
  {
    name: "Hövsan",
    country: "Azerbaijan",
    subcountry: "Baki",
    geonameid: 586429,
  },
  {
    name: "Ganja",
    country: "Azerbaijan",
    subcountry: "Gǝncǝ",
    geonameid: 586523,
  },
  {
    name: "Divichibazar",
    country: "Azerbaijan",
    subcountry: "Shabran",
    geonameid: 586763,
  },
  {
    name: "Buzovna",
    country: "Azerbaijan",
    subcountry: "Baki",
    geonameid: 586925,
  },
  {
    name: "Biny Selo",
    country: "Azerbaijan",
    subcountry: "Baki",
    geonameid: 586968,
  },
  {
    name: "Barda",
    country: "Azerbaijan",
    subcountry: "Barda",
    geonameid: 587057,
  },
  {
    name: "Bilajari",
    country: "Azerbaijan",
    subcountry: "Baki",
    geonameid: 587078,
  },
  {
    name: "Baku",
    country: "Azerbaijan",
    subcountry: "Baki",
    geonameid: 587084,
  },
  {
    name: "Amirdzhan",
    country: "Azerbaijan",
    subcountry: "Baki",
    geonameid: 587261,
  },
  {
    name: "Aghsu",
    country: "Azerbaijan",
    subcountry: "Ağsu",
    geonameid: 587361,
  },
  {
    name: "Ağdaş",
    country: "Azerbaijan",
    subcountry: "Ağdaş",
    geonameid: 587378,
  },
  {
    name: "Agdzhabedy",
    country: "Azerbaijan",
    subcountry: "Ağcabǝdi",
    geonameid: 587384,
  },
  {
    name: "Bakıxanov",
    country: "Azerbaijan",
    subcountry: "Baki",
    geonameid: 824003,
  },
  {
    name: "Zenica",
    country: "Bosnia and Herzegovina",
    subcountry: "Federation of B&H",
    geonameid: 3186573,
  },
  {
    name: "Visoko",
    country: "Bosnia and Herzegovina",
    subcountry: "Federation of B&H",
    geonameid: 3187609,
  },
  {
    name: "Velika Kladuša",
    country: "Bosnia and Herzegovina",
    subcountry: "Federation of B&H",
    geonameid: 3188225,
  },
  {
    name: "Tuzla",
    country: "Bosnia and Herzegovina",
    subcountry: "Federation of B&H",
    geonameid: 3188582,
  },
  {
    name: "Trebinje",
    country: "Bosnia and Herzegovina",
    subcountry: "Srpska",
    geonameid: 3188893,
  },
  {
    name: "Travnik",
    country: "Bosnia and Herzegovina",
    subcountry: "Federation of B&H",
    geonameid: 3188924,
  },
  {
    name: "Sarajevo",
    country: "Bosnia and Herzegovina",
    subcountry: "Federation of B&H",
    geonameid: 3191281,
  },
  {
    name: "Prijedor",
    country: "Bosnia and Herzegovina",
    subcountry: "Srpska",
    geonameid: 3192409,
  },
  {
    name: "Mostar",
    country: "Bosnia and Herzegovina",
    subcountry: "Federation of B&H",
    geonameid: 3194828,
  },
  {
    name: "Lukavac",
    country: "Bosnia and Herzegovina",
    subcountry: "Federation of B&H",
    geonameid: 3196079,
  },
  {
    name: "Gradačac",
    country: "Bosnia and Herzegovina",
    subcountry: "Federation of B&H",
    geonameid: 3199744,
  },
  {
    name: "Gračanica",
    country: "Bosnia and Herzegovina",
    subcountry: "Federation of B&H",
    geonameid: 3199779,
  },
  {
    name: "Goražde",
    country: "Bosnia and Herzegovina",
    subcountry: "Federation of B&H",
    geonameid: 3200396,
  },
  {
    name: "Doboj",
    country: "Bosnia and Herzegovina",
    subcountry: "Srpska",
    geonameid: 3201984,
  },
  {
    name: "Cazin",
    country: "Bosnia and Herzegovina",
    subcountry: "Federation of B&H",
    geonameid: 3202822,
  },
  {
    name: "Bugojno",
    country: "Bosnia and Herzegovina",
    subcountry: "Federation of B&H",
    geonameid: 3203099,
  },
  {
    name: "Brčko",
    country: "Bosnia and Herzegovina",
    subcountry: "Brčko",
    geonameid: 3203521,
  },
  {
    name: "Bosanska Krupa",
    country: "Bosnia and Herzegovina",
    subcountry: "Federation of B&H",
    geonameid: 3203653,
  },
  {
    name: "Bijeljina",
    country: "Bosnia and Herzegovina",
    subcountry: "Srpska",
    geonameid: 3204186,
  },
  {
    name: "Bihać",
    country: "Bosnia and Herzegovina",
    subcountry: "Federation of B&H",
    geonameid: 3204222,
  },
  {
    name: "Banja Luka",
    country: "Bosnia and Herzegovina",
    subcountry: "Srpska",
    geonameid: 3204541,
  },
  {
    name: "Konjic",
    country: "Bosnia and Herzegovina",
    subcountry: "Federation of B&H",
    geonameid: 3337476,
  },
  {
    name: "Bridgetown",
    country: "Barbados",
    subcountry: "Saint Michael",
    geonameid: 3374036,
  },
  {
    name: "Thākurgaon",
    country: "Bangladesh",
    subcountry: "Rangpur Division",
    geonameid: 1185092,
  },
  {
    name: "Teknāf",
    country: "Bangladesh",
    subcountry: "Chittagong",
    geonameid: 1185095,
  },
  {
    name: "Tungi",
    country: "Bangladesh",
    subcountry: "Dhaka",
    geonameid: 1185098,
  },
  {
    name: "Sylhet",
    country: "Bangladesh",
    subcountry: "Sylhet",
    geonameid: 1185099,
  },
  {
    name: "Dohār",
    country: "Bangladesh",
    subcountry: "Dhaka",
    geonameid: 1185100,
  },
  {
    name: "Jamālpur",
    country: "Bangladesh",
    subcountry: "Mymensingh Division",
    geonameid: 1185106,
  },
  {
    name: "Shibganj",
    country: "Bangladesh",
    subcountry: "Rajshahi Division",
    geonameid: 1185107,
  },
  {
    name: "Shibganj",
    country: "Bangladesh",
    subcountry: "Rajshahi Division",
    geonameid: 1185108,
  },
  {
    name: "Sātkhira",
    country: "Bangladesh",
    subcountry: "Khulna",
    geonameid: 1185111,
  },
  {
    name: "Sirajganj",
    country: "Bangladesh",
    subcountry: "Rajshahi Division",
    geonameid: 1185115,
  },
  {
    name: "Netrakona",
    country: "Bangladesh",
    subcountry: "Mymensingh Division",
    geonameid: 1185116,
  },
  {
    name: "Narsingdi",
    country: "Bangladesh",
    subcountry: "Dhaka",
    geonameid: 1185117,
  },
  {
    name: "Sandwīp",
    country: "Bangladesh",
    subcountry: "Chittagong",
    geonameid: 1185120,
  },
  {
    name: "Shāhzādpur",
    country: "Bangladesh",
    subcountry: "Rajshahi Division",
    geonameid: 1185121,
  },
  {
    name: "Rāmganj",
    country: "Bangladesh",
    subcountry: "Chittagong",
    geonameid: 1185127,
  },
  {
    name: "Rājshāhi",
    country: "Bangladesh",
    subcountry: "Rajshahi Division",
    geonameid: 1185128,
  },
  {
    name: "Pirojpur",
    country: "Bangladesh",
    subcountry: "Barisāl",
    geonameid: 1185138,
  },
  {
    name: "Panchagarh",
    country: "Bangladesh",
    subcountry: "Rangpur Division",
    geonameid: 1185141,
  },
  {
    name: "Patiya",
    country: "Bangladesh",
    subcountry: "Chittagong",
    geonameid: 1185148,
  },
  {
    name: "Parbatipur",
    country: "Bangladesh",
    subcountry: "Rangpur Division",
    geonameid: 1185149,
  },
  {
    name: "Nārāyanganj",
    country: "Bangladesh",
    subcountry: "Dhaka",
    geonameid: 1185155,
  },
  {
    name: "Nālchiti",
    country: "Bangladesh",
    subcountry: "Barisāl",
    geonameid: 1185156,
  },
  {
    name: "Nāgarpur",
    country: "Bangladesh",
    subcountry: "Dhaka",
    geonameid: 1185159,
  },
  {
    name: "Nageswari",
    country: "Bangladesh",
    subcountry: "Rangpur Division",
    geonameid: 1185160,
  },
  {
    name: "Mymensingh",
    country: "Bangladesh",
    subcountry: "Mymensingh Division",
    geonameid: 1185162,
  },
  {
    name: "Muktāgācha",
    country: "Bangladesh",
    subcountry: "Mymensingh Division",
    geonameid: 1185164,
  },
  {
    name: "Mirzāpur",
    country: "Bangladesh",
    subcountry: "Dhaka",
    geonameid: 1185165,
  },
  {
    name: "Maulavi Bāzār",
    country: "Bangladesh",
    subcountry: "Sylhet",
    geonameid: 1185166,
  },
  {
    name: "Morrelgonj",
    country: "Bangladesh",
    subcountry: "Khulna",
    geonameid: 1185167,
  },
  {
    name: "Mehendiganj",
    country: "Bangladesh",
    subcountry: "Barisāl",
    geonameid: 1185171,
  },
  {
    name: "Mathba",
    country: "Bangladesh",
    subcountry: "Barisāl",
    geonameid: 1185173,
  },
  {
    name: "Lalmonirhat",
    country: "Bangladesh",
    subcountry: "Rangpur Division",
    geonameid: 1185181,
  },
  {
    name: "Lākshām",
    country: "Bangladesh",
    subcountry: "Chittagong",
    geonameid: 1185183,
  },
  {
    name: "Comilla",
    country: "Bangladesh",
    subcountry: "Chittagong",
    geonameid: 1185186,
  },
  {
    name: "Rangpur",
    country: "Bangladesh",
    subcountry: "Rangpur Division",
    geonameid: 1185188,
  },
  {
    name: "Kushtia",
    country: "Bangladesh",
    subcountry: "Khulna",
    geonameid: 1185191,
  },
  {
    name: "Kālīganj",
    country: "Bangladesh",
    subcountry: "Khulna",
    geonameid: 1185199,
  },
  {
    name: "Jhingergācha",
    country: "Bangladesh",
    subcountry: "Khulna",
    geonameid: 1185204,
  },
  {
    name: "Joypur Hāt",
    country: "Bangladesh",
    subcountry: "Rajshahi Division",
    geonameid: 1185206,
  },
  {
    name: "Ishurdi",
    country: "Bangladesh",
    subcountry: "Rajshahi Division",
    geonameid: 1185207,
  },
  {
    name: "Habiganj",
    country: "Bangladesh",
    subcountry: "Sylhet",
    geonameid: 1185209,
  },
  {
    name: "Gaurnadi",
    country: "Bangladesh",
    subcountry: "Barisāl",
    geonameid: 1185210,
  },
  {
    name: "Gafargaon",
    country: "Bangladesh",
    subcountry: "Mymensingh Division",
    geonameid: 1185218,
  },
  {
    name: "Feni",
    country: "Bangladesh",
    subcountry: "Chittagong",
    geonameid: 1185224,
  },
  {
    name: "Rāipur",
    country: "Bangladesh",
    subcountry: "Chittagong",
    geonameid: 1185236,
  },
  {
    name: "Sarankhola",
    country: "Bangladesh",
    subcountry: "Khulna",
    geonameid: 1185239,
  },
  {
    name: "Dhaka",
    country: "Bangladesh",
    subcountry: "Dhaka",
    geonameid: 1185241,
  },
  {
    name: "Chilmāri",
    country: "Bangladesh",
    subcountry: "Rangpur Division",
    geonameid: 1185247,
  },
  {
    name: "Chhāgalnāiya",
    country: "Bangladesh",
    subcountry: "Chittagong",
    geonameid: 1185249,
  },
  {
    name: "Lālmohan",
    country: "Bangladesh",
    subcountry: "Barisāl",
    geonameid: 1185251,
  },
  {
    name: "Khagrachhari",
    country: "Bangladesh",
    subcountry: "Chittagong",
    geonameid: 1185252,
  },
  {
    name: "Chhātak",
    country: "Bangladesh",
    subcountry: "Sylhet",
    geonameid: 1185254,
  },
  {
    name: "Bhātpāra Abhaynagar",
    country: "Bangladesh",
    subcountry: "Khulna",
    geonameid: 1185260,
  },
  {
    name: "Bherāmāra",
    country: "Bangladesh",
    subcountry: "Khulna",
    geonameid: 1185262,
  },
  {
    name: "Bhairab Bāzār",
    country: "Bangladesh",
    subcountry: "Dhaka",
    geonameid: 1185263,
  },
  {
    name: "Bāndarban",
    country: "Bangladesh",
    subcountry: "Chittagong",
    geonameid: 1185270,
  },
  {
    name: "Kālia",
    country: "Bangladesh",
    subcountry: "Khulna",
    geonameid: 1185272,
  },
  {
    name: "Baniachang",
    country: "Bangladesh",
    subcountry: "Sylhet",
    geonameid: 1185274,
  },
  {
    name: "Bājitpur",
    country: "Bangladesh",
    subcountry: "Dhaka",
    geonameid: 1185276,
  },
  {
    name: "Bagerhat",
    country: "Bangladesh",
    subcountry: "Khulna",
    geonameid: 1185281,
  },
  {
    name: "Badarganj",
    country: "Bangladesh",
    subcountry: "Rangpur Division",
    geonameid: 1185283,
  },
  {
    name: "Narail",
    country: "Bangladesh",
    subcountry: "Khulna",
    geonameid: 1185293,
  },
  {
    name: "Tungipāra",
    country: "Bangladesh",
    subcountry: "Dhaka",
    geonameid: 1185920,
  },
  {
    name: "Sonārgaon",
    country: "Bangladesh",
    subcountry: "Dhaka",
    geonameid: 1187530,
  },
  {
    name: "Sarishābāri",
    country: "Bangladesh",
    subcountry: "Mymensingh Division",
    geonameid: 1188569,
  },
  {
    name: "Sakhipur",
    country: "Bangladesh",
    subcountry: "Dhaka",
    geonameid: 1189056,
  },
  {
    name: "Raojān",
    country: "Bangladesh",
    subcountry: "Chittagong",
    geonameid: 1189638,
  },
  {
    name: "Phultala",
    country: "Bangladesh",
    subcountry: "Khulna",
    geonameid: 1191139,
  },
  {
    name: "Pālang",
    country: "Bangladesh",
    subcountry: "Dhaka",
    geonameid: 1191368,
  },
  {
    name: "Pār Naogaon",
    country: "Bangladesh",
    subcountry: "Rajshahi Division",
    geonameid: 1192366,
  },
  {
    name: "Nabīnagar",
    country: "Bangladesh",
    subcountry: "Chittagong",
    geonameid: 1193823,
  },
  {
    name: "Lakshmīpur",
    country: "Bangladesh",
    subcountry: "Chittagong",
    geonameid: 1196292,
  },
  {
    name: "Kesabpur",
    country: "Bangladesh",
    subcountry: "Khulna",
    geonameid: 1197895,
  },
  {
    name: "Hājīganj",
    country: "Bangladesh",
    subcountry: "Chittagong",
    geonameid: 1201753,
  },
  {
    name: "Farīdpur",
    country: "Bangladesh",
    subcountry: "Dhaka",
    geonameid: 1203344,
  },
  {
    name: "Dinājpur",
    country: "Bangladesh",
    subcountry: "Rangpur Division",
    geonameid: 1203891,
  },
  {
    name: "Uttar Char Fasson",
    country: "Bangladesh",
    subcountry: "Khulna",
    geonameid: 1205481,
  },
  {
    name: "Chattogram",
    country: "Bangladesh",
    subcountry: "Chittagong",
    geonameid: 1205733,
  },
  {
    name: "Char Bhadrāsan",
    country: "Bangladesh",
    subcountry: "Dhaka",
    geonameid: 1207047,
  },
  {
    name: "Bera",
    country: "Bangladesh",
    subcountry: "Rajshahi Division",
    geonameid: 1209562,
  },
  {
    name: "Burhānuddin",
    country: "Bangladesh",
    subcountry: "Barisāl",
    geonameid: 1210565,
  },
  {
    name: "Sātkania",
    country: "Bangladesh",
    subcountry: "Chittagong",
    geonameid: 1336133,
  },
  {
    name: "Cox’s Bāzār",
    country: "Bangladesh",
    subcountry: "Chittagong",
    geonameid: 1336134,
  },
  {
    name: "Khulna",
    country: "Bangladesh",
    subcountry: "Khulna",
    geonameid: 1336135,
  },
  {
    name: "Bhola",
    country: "Bangladesh",
    subcountry: "Barisāl",
    geonameid: 1336136,
  },
  {
    name: "Barishal",
    country: "Bangladesh",
    subcountry: "Barisāl",
    geonameid: 1336137,
  },
  {
    name: "Jessore",
    country: "Bangladesh",
    subcountry: "Khulna",
    geonameid: 1336140,
  },
  {
    name: "Pābna",
    country: "Bangladesh",
    subcountry: "Rajshahi Division",
    geonameid: 1336143,
  },
  {
    name: "Tāngāil",
    country: "Bangladesh",
    subcountry: "Dhaka",
    geonameid: 1336144,
  },
  {
    name: "Bogra",
    country: "Bangladesh",
    subcountry: "Rajshahi Division",
    geonameid: 1337233,
  },
  {
    name: "Pīrgaaj",
    country: "Bangladesh",
    subcountry: "Rangpur Division",
    geonameid: 1337239,
  },
  {
    name: "Nawābganj",
    country: "Bangladesh",
    subcountry: "Rajshahi Division",
    geonameid: 1337240,
  },
  {
    name: "Madaripur",
    country: "Bangladesh",
    subcountry: "Dhaka",
    geonameid: 1337245,
  },
  {
    name: "Sherpur",
    country: "Bangladesh",
    subcountry: "Mymensingh Division",
    geonameid: 1337248,
  },
  {
    name: "Kishorganj",
    country: "Bangladesh",
    subcountry: "Dhaka",
    geonameid: 1337249,
  },
  {
    name: "Manikchari",
    country: "Bangladesh",
    subcountry: "Chittagong",
    geonameid: 1462681,
  },
  {
    name: "Bhāndāria",
    country: "Bangladesh",
    subcountry: "Barisāl",
    geonameid: 1477498,
  },
  {
    name: "Bibir Hat",
    country: "Bangladesh",
    subcountry: "Chittagong",
    geonameid: 6414184,
  },
  {
    name: "Saidpur",
    country: "Bangladesh",
    subcountry: "Rangpur Division",
    geonameid: 6545349,
  },
  {
    name: "Puthia",
    country: "Bangladesh",
    subcountry: "Rajshahi Division",
    geonameid: 7483743,
  },
  {
    name: "Natore",
    country: "Bangladesh",
    subcountry: "Rajshahi Division",
    geonameid: 7483813,
  },
  {
    name: "Azimpur",
    country: "Bangladesh",
    subcountry: "Dhaka",
    geonameid: 7701354,
  },
  {
    name: "Paotana Hat",
    country: "Bangladesh",
    subcountry: "Rangpur Division",
    geonameid: 7926419,
  },
  {
    name: "Paltan",
    country: "Bangladesh",
    subcountry: "Dhaka",
    geonameid: 9827976,
  },
  {
    name: "Joymontop",
    country: "Bangladesh",
    subcountry: "Dhaka",
    geonameid: 11609988,
  },
  {
    name: "Zwijndrecht",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2783081,
  },
  {
    name: "Zwevegem",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2783089,
  },
  {
    name: "Zottegem",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2783175,
  },
  {
    name: "Zonhoven",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2783188,
  },
  {
    name: "Zolder",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2783197,
  },
  {
    name: "Zemst",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2783274,
  },
  {
    name: "Zele",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2783293,
  },
  {
    name: "Zedelgem",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2783308,
  },
  {
    name: "Zaventem",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2783310,
  },
  {
    name: "Wondelgem",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2783456,
  },
  {
    name: "Woluwe-Saint-Lambert",
    country: "Belgium",
    subcountry: "Brussels Capital",
    geonameid: 2783476,
  },
  {
    name: "Wilrijk",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2783615,
  },
  {
    name: "Willebroek",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2783632,
  },
  {
    name: "Wevelgem",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2783759,
  },
  {
    name: "Wetteren",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2783763,
  },
  {
    name: "Westerlo",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2783801,
  },
  {
    name: "Wervik",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2783820,
  },
  {
    name: "Wavre",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2783941,
  },
  {
    name: "Watermael-Boitsfort",
    country: "Belgium",
    subcountry: "Brussels Capital",
    geonameid: 2783979,
  },
  {
    name: "Waterloo",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2783985,
  },
  {
    name: "Waregem",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2784068,
  },
  {
    name: "Walcourt",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2784189,
  },
  {
    name: "Visé",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2784548,
  },
  {
    name: "Vilvoorde",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2784604,
  },
  {
    name: "Verviers",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2784821,
  },
  {
    name: "Uccle",
    country: "Belgium",
    subcountry: "Brussels Capital",
    geonameid: 2785123,
  },
  {
    name: "Turnhout",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2785141,
  },
  {
    name: "Tubize",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2785169,
  },
  {
    name: "Tournai",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2785341,
  },
  {
    name: "Torhout",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2785364,
  },
  {
    name: "Tongeren",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2785389,
  },
  {
    name: "Tienen",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2785470,
  },
  {
    name: "Tielt",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2785476,
  },
  {
    name: "Tessenderlo",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2785612,
  },
  {
    name: "Tervuren",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2785622,
  },
  {
    name: "Temse",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2785778,
  },
  {
    name: "Stekene",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2786087,
  },
  {
    name: "Stabroek",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2786229,
  },
  {
    name: "Soumagne",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2786344,
  },
  {
    name: "Soignies",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2786420,
  },
  {
    name: "Sint-Truiden",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2786545,
  },
  {
    name: "Sint-Pieters-Leeuw",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2786559,
  },
  {
    name: "Sint-Niklaas",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2786578,
  },
  {
    name: "Sint-Kruis",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2786634,
  },
  {
    name: "Sint-Katelijne-Waver",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2786641,
  },
  {
    name: "Sint-Gillis-Waas",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2786694,
  },
  {
    name: "Sint-Genesius-Rode",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2786700,
  },
  {
    name: "Sint-Andries",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2786739,
  },
  {
    name: "Sint-Amandsberg",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2786743,
  },
  {
    name: "Seraing",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2786824,
  },
  {
    name: "Schoten",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2786963,
  },
  {
    name: "Schilde",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2787048,
  },
  {
    name: "Schaerbeek",
    country: "Belgium",
    subcountry: "Brussels Capital",
    geonameid: 2787149,
  },
  {
    name: "Saint-Nicolas",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2787356,
  },
  {
    name: "Saint-Josse-ten-Noode",
    country: "Belgium",
    subcountry: "Brussels Capital",
    geonameid: 2787387,
  },
  {
    name: "Saint-Gilles",
    country: "Belgium",
    subcountry: "Brussels Capital",
    geonameid: 2787413,
  },
  {
    name: "Saint-Ghislain",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2787416,
  },
  {
    name: "Rotselaar",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2787662,
  },
  {
    name: "Ronse",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2787769,
  },
  {
    name: "Roeselare",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2787889,
  },
  {
    name: "Rixensart",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2787989,
  },
  {
    name: "Riemst",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2788088,
  },
  {
    name: "Ranst",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2788348,
  },
  {
    name: "Quaregnon",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2788499,
  },
  {
    name: "Puurs",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2788506,
  },
  {
    name: "Putte",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2788521,
  },
  {
    name: "Poperinge",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2788726,
  },
  {
    name: "Pont-à-Celles",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2788765,
  },
  {
    name: "Péruwelz",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2789162,
  },
  {
    name: "Peer",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2789232,
  },
  {
    name: "Overijse",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2789413,
  },
  {
    name: "Oupeye",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2789471,
  },
  {
    name: "Oudenaarde",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2789529,
  },
  {
    name: "Oostkamp",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2789751,
  },
  {
    name: "Ostend",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2789786,
  },
  {
    name: "Nivelles",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2790101,
  },
  {
    name: "Ninove",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2790114,
  },
  {
    name: "Nijlen",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2790135,
  },
  {
    name: "Neerpelt",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2790357,
  },
  {
    name: "Namur",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2790471,
  },
  {
    name: "Mouscron",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2790595,
  },
  {
    name: "Mortsel",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2790676,
  },
  {
    name: "Morlanwelz-Mariemont",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2790697,
  },
  {
    name: "Montignies-sur-Sambre",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2790796,
  },
  {
    name: "Mons",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2790869,
  },
  {
    name: "Molenbeek-Saint-Jean",
    country: "Belgium",
    subcountry: "Brussels Capital",
    geonameid: 2791018,
  },
  {
    name: "Mol",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2791067,
  },
  {
    name: "Middelkerke",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2791194,
  },
  {
    name: "Merksem",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2791301,
  },
  {
    name: "Merelbeke",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2791315,
  },
  {
    name: "Menen",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2791343,
  },
  {
    name: "Meise",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2791424,
  },
  {
    name: "Mechelen-aan-de-Maas",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2791534,
  },
  {
    name: "Mechelen",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2791537,
  },
  {
    name: "Mariakerke",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2791700,
  },
  {
    name: "Marcinelle",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2791726,
  },
  {
    name: "Marchienne-au-Pont",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2791735,
  },
  {
    name: "Marche-en-Famenne",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2791744,
  },
  {
    name: "Manage",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2791814,
  },
  {
    name: "Maldegem",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2791857,
  },
  {
    name: "Maasmechelen",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2791961,
  },
  {
    name: "Maaseik",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2791964,
  },
  {
    name: "Louvain-la-Neuve",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2792073,
  },
  {
    name: "Lommel",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2792179,
  },
  {
    name: "Lokeren",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2792196,
  },
  {
    name: "Lochristi",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2792235,
  },
  {
    name: "Lille",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2792360,
  },
  {
    name: "Lier",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2792397,
  },
  {
    name: "Liège",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2792413,
  },
  {
    name: "Leuven",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2792482,
  },
  {
    name: "Lessines",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2792567,
  },
  {
    name: "Lede",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2793077,
  },
  {
    name: "Lebbeke",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2793144,
  },
  {
    name: "Lanaken",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2793446,
  },
  {
    name: "La Louvière",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2793508,
  },
  {
    name: "Kortrijk",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2794055,
  },
  {
    name: "Kortenberg",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2794070,
  },
  {
    name: "Kontich",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2794117,
  },
  {
    name: "Koksijde",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2794166,
  },
  {
    name: "Koersel",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2794179,
  },
  {
    name: "Koekelberg",
    country: "Belgium",
    subcountry: "Brussels Capital",
    geonameid: 2794190,
  },
  {
    name: "Knokke-Heist",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2794210,
  },
  {
    name: "Kessel-Lo",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2794507,
  },
  {
    name: "Kasterlee",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2794663,
  },
  {
    name: "Kapellen",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2794730,
  },
  {
    name: "Kalmthout",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2794788,
  },
  {
    name: "Jumet",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2794860,
  },
  {
    name: "Jette",
    country: "Belgium",
    subcountry: "Brussels Capital",
    geonameid: 2794914,
  },
  {
    name: "Jambes",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2794981,
  },
  {
    name: "Izegem",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2795009,
  },
  {
    name: "Ixelles",
    country: "Belgium",
    subcountry: "Brussels Capital",
    geonameid: 2795011,
  },
  {
    name: "Ieper",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2795100,
  },
  {
    name: "Huy",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2795113,
  },
  {
    name: "Houthalen",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2795261,
  },
  {
    name: "Hoogstraten",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2795398,
  },
  {
    name: "Hoboken",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2795730,
  },
  {
    name: "Heverlee",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2795783,
  },
  {
    name: "Heusy",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2795795,
  },
  {
    name: "Heusden",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2795800,
  },
  {
    name: "Herzele",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2795908,
  },
  {
    name: "Herve",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2795912,
  },
  {
    name: "Herstal",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2795930,
  },
  {
    name: "Herentals",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2796009,
  },
  {
    name: "Herent",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2796012,
  },
  {
    name: "Helchteren",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2796132,
  },
  {
    name: "Heist-op-den-Berg",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2796153,
  },
  {
    name: "Hasselt",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2796491,
  },
  {
    name: "Harelbeke",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2796542,
  },
  {
    name: "Hamme",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2796637,
  },
  {
    name: "Halle",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2796696,
  },
  {
    name: "Haaltert",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2796833,
  },
  {
    name: "Grivegnée",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2797096,
  },
  {
    name: "Grimbergen",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2797114,
  },
  {
    name: "Gilly",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2797532,
  },
  {
    name: "Geraardsbergen",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2797638,
  },
  {
    name: "Gentbrugge",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2797652,
  },
  {
    name: "Gent",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2797656,
  },
  {
    name: "Genk",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2797670,
  },
  {
    name: "Gembloux",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2797713,
  },
  {
    name: "Geel",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2797779,
  },
  {
    name: "Ganshoren",
    country: "Belgium",
    subcountry: "Brussels Capital",
    geonameid: 2797844,
  },
  {
    name: "Frameries",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2798023,
  },
  {
    name: "Forest",
    country: "Belgium",
    subcountry: "Brussels Capital",
    geonameid: 2798139,
  },
  {
    name: "Fleurus",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2798297,
  },
  {
    name: "Fléron",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2798301,
  },
  {
    name: "Flémalle-Haute",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2798307,
  },
  {
    name: "Evergem",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2798551,
  },
  {
    name: "Evere",
    country: "Belgium",
    subcountry: "Brussels Capital",
    geonameid: 2798554,
  },
  {
    name: "Eupen",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2798573,
  },
  {
    name: "Etterbeek",
    country: "Belgium",
    subcountry: "Brussels Capital",
    geonameid: 2798578,
  },
  {
    name: "Ekeren",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2798873,
  },
  {
    name: "Eeklo",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2798987,
  },
  {
    name: "Edegem",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2799007,
  },
  {
    name: "Duffel",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2799090,
  },
  {
    name: "Dour",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2799226,
  },
  {
    name: "Dilbeek",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2799365,
  },
  {
    name: "Diksmuide",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2799369,
  },
  {
    name: "Diest",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2799397,
  },
  {
    name: "Diepenbeek",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2799412,
  },
  {
    name: "Deurne",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2799478,
  },
  {
    name: "Destelbergen",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2799496,
  },
  {
    name: "Dendermonde",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2799645,
  },
  {
    name: "Denderleeuw",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2799647,
  },
  {
    name: "Deinze",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2799746,
  },
  {
    name: "Courcelles",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2800063,
  },
  {
    name: "Colfontaine",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2800220,
  },
  {
    name: "Chaudfontaine",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2800438,
  },
  {
    name: "Châtelineau",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2800445,
  },
  {
    name: "Châtelet",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2800448,
  },
  {
    name: "Chasse Royale",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2800461,
  },
  {
    name: "Charleroi",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2800481,
  },
  {
    name: "Brussels",
    country: "Belgium",
    subcountry: "Brussels Capital",
    geonameid: 2800866,
  },
  {
    name: "Brugge",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2800931,
  },
  {
    name: "Brasschaat",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2801117,
  },
  {
    name: "Braine-le-Comte",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2801150,
  },
  {
    name: "Braine-l'Alleud",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2801154,
  },
  {
    name: "Boussu",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2801226,
  },
  {
    name: "Bornem",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2801447,
  },
  {
    name: "Borgerhout",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2801471,
  },
  {
    name: "Boom",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2801494,
  },
  {
    name: "Blauwput",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2801824,
  },
  {
    name: "Blankenberge",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2801858,
  },
  {
    name: "Binche",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2801922,
  },
  {
    name: "Bilzen",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2801924,
  },
  {
    name: "Beveren",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2802031,
  },
  {
    name: "Bevere",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2802039,
  },
  {
    name: "Beringen",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2802170,
  },
  {
    name: "Berchem-Sainte-Agathe",
    country: "Belgium",
    subcountry: "Brussels Capital",
    geonameid: 2802247,
  },
  {
    name: "Berchem",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2802249,
  },
  {
    name: "Beersel",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2802433,
  },
  {
    name: "Beerse",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2802435,
  },
  {
    name: "Balen",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2802743,
  },
  {
    name: "Auderghem",
    country: "Belgium",
    subcountry: "Brussels Capital",
    geonameid: 2802960,
  },
  {
    name: "Ath",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2803010,
  },
  {
    name: "Assebroek",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2803030,
  },
  {
    name: "Asse",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2803033,
  },
  {
    name: "Arlon",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2803073,
  },
  {
    name: "Antwerpen",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2803138,
  },
  {
    name: "Ans",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2803160,
  },
  {
    name: "Anderlecht",
    country: "Belgium",
    subcountry: "Brussels Capital",
    geonameid: 2803201,
  },
  {
    name: "Andenne",
    country: "Belgium",
    subcountry: "Wallonia",
    geonameid: 2803204,
  },
  {
    name: "Aarschot",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2803429,
  },
  {
    name: "Aalter",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2803443,
  },
  {
    name: "Aalst",
    country: "Belgium",
    subcountry: "Flanders",
    geonameid: 2803448,
  },
  {
    name: "Zorgo",
    country: "Burkina Faso",
    subcountry: "Plateau-Central",
    geonameid: 2353197,
  },
  {
    name: "Ziniaré",
    country: "Burkina Faso",
    subcountry: "Plateau-Central",
    geonameid: 2353257,
  },
  {
    name: "Yako",
    country: "Burkina Faso",
    subcountry: "Nord",
    geonameid: 2353688,
  },
  {
    name: "Tougan",
    country: "Burkina Faso",
    subcountry: "Boucle du Mouhoun",
    geonameid: 2354176,
  },
  {
    name: "Toma",
    country: "Burkina Faso",
    subcountry: "Boucle du Mouhoun",
    geonameid: 2354265,
  },
  {
    name: "Titao",
    country: "Burkina Faso",
    subcountry: "Nord",
    geonameid: 2354349,
  },
  {
    name: "Tenkodogo",
    country: "Burkina Faso",
    subcountry: "Centre-Est",
    geonameid: 2354675,
  },
  {
    name: "Salanso",
    country: "Burkina Faso",
    subcountry: "Boucle du Mouhoun",
    geonameid: 2355404,
  },
  {
    name: "Sapouy",
    country: "Burkina Faso",
    subcountry: "Centre-Ouest",
    geonameid: 2355869,
  },
  {
    name: "Réo",
    country: "Burkina Faso",
    subcountry: "Centre-Ouest",
    geonameid: 2356228,
  },
  {
    name: "Pô",
    country: "Burkina Faso",
    subcountry: "Centre-Sud",
    geonameid: 2356454,
  },
  {
    name: "Ouahigouya",
    country: "Burkina Faso",
    subcountry: "Nord",
    geonameid: 2357043,
  },
  {
    name: "Ouagadougou",
    country: "Burkina Faso",
    subcountry: "Centre",
    geonameid: 2357048,
  },
  {
    name: "Nouna",
    country: "Burkina Faso",
    subcountry: "Boucle du Mouhoun",
    geonameid: 2357163,
  },
  {
    name: "Manga",
    country: "Burkina Faso",
    subcountry: "Centre-Sud",
    geonameid: 2358100,
  },
  {
    name: "Léo",
    country: "Burkina Faso",
    subcountry: "Centre-Ouest",
    geonameid: 2358382,
  },
  {
    name: "Koupéla",
    country: "Burkina Faso",
    subcountry: "Centre-Est",
    geonameid: 2358738,
  },
  {
    name: "Koudougou",
    country: "Burkina Faso",
    subcountry: "Centre-Ouest",
    geonameid: 2358946,
  },
  {
    name: "Kongoussi",
    country: "Burkina Faso",
    subcountry: "Centre-Nord",
    geonameid: 2359142,
  },
  {
    name: "Kombissiri",
    country: "Burkina Faso",
    subcountry: "Centre-Sud",
    geonameid: 2359227,
  },
  {
    name: "Kokologo",
    country: "Burkina Faso",
    subcountry: "Centre-Ouest",
    geonameid: 2359317,
  },
  {
    name: "Kaya",
    country: "Burkina Faso",
    subcountry: "Centre-Nord",
    geonameid: 2359608,
  },
  {
    name: "Houndé",
    country: "Burkina Faso",
    subcountry: "Hauts-Bassins",
    geonameid: 2360073,
  },
  {
    name: "Gourcy",
    country: "Burkina Faso",
    subcountry: "Nord",
    geonameid: 2360238,
  },
  {
    name: "Gayéri",
    country: "Burkina Faso",
    subcountry: "Est",
    geonameid: 2360541,
  },
  {
    name: "Garango",
    country: "Burkina Faso",
    subcountry: "Centre-Est",
    geonameid: 2360615,
  },
  {
    name: "Gaoua",
    country: "Burkina Faso",
    subcountry: "Sud-Ouest",
    geonameid: 2360620,
  },
  {
    name: "Fada N'gourma",
    country: "Burkina Faso",
    subcountry: "Est",
    geonameid: 2360886,
  },
  {
    name: "Dori",
    country: "Burkina Faso",
    subcountry: "Sahel",
    geonameid: 2361082,
  },
  {
    name: "Djibo",
    country: "Burkina Faso",
    subcountry: "Sahel",
    geonameid: 2361177,
  },
  {
    name: "Diébougou",
    country: "Burkina Faso",
    subcountry: "Sud-Ouest",
    geonameid: 2361342,
  },
  {
    name: "Diapaga",
    country: "Burkina Faso",
    subcountry: "Est",
    geonameid: 2361373,
  },
  {
    name: "Dédougou",
    country: "Burkina Faso",
    subcountry: "Boucle du Mouhoun",
    geonameid: 2361477,
  },
  {
    name: "Dano",
    country: "Burkina Faso",
    subcountry: "Sud-Ouest",
    geonameid: 2361586,
  },
  {
    name: "Boussé",
    country: "Burkina Faso",
    subcountry: "Plateau-Central",
    geonameid: 2361845,
  },
  {
    name: "Boulsa",
    country: "Burkina Faso",
    subcountry: "Centre-Nord",
    geonameid: 2361946,
  },
  {
    name: "Boromo",
    country: "Burkina Faso",
    subcountry: "Boucle du Mouhoun",
    geonameid: 2362150,
  },
  {
    name: "Bogandé",
    country: "Burkina Faso",
    subcountry: "Est",
    geonameid: 2362323,
  },
  {
    name: "Bobo-Dioulasso",
    country: "Burkina Faso",
    subcountry: "Hauts-Bassins",
    geonameid: 2362344,
  },
  {
    name: "Batié",
    country: "Burkina Faso",
    subcountry: "Sud-Ouest",
    geonameid: 2362669,
  },
  {
    name: "Banfora",
    country: "Burkina Faso",
    subcountry: "Cascades",
    geonameid: 2362909,
  },
  {
    name: "Yambol",
    country: "Bulgaria",
    subcountry: "Yambol",
    geonameid: 725578,
  },
  {
    name: "Vratsa",
    country: "Bulgaria",
    subcountry: "Vratsa",
    geonameid: 725712,
  },
  {
    name: "Vidin",
    country: "Bulgaria",
    subcountry: "Vidin",
    geonameid: 725905,
  },
  {
    name: "Velingrad",
    country: "Bulgaria",
    subcountry: "Pazardzhik",
    geonameid: 725988,
  },
  {
    name: "Veliko Tŭrnovo",
    country: "Bulgaria",
    subcountry: "Veliko Tarnovo",
    geonameid: 725993,
  },
  {
    name: "Varna",
    country: "Bulgaria",
    subcountry: "Varna",
    geonameid: 726050,
  },
  {
    name: "Targovishte",
    country: "Bulgaria",
    subcountry: "Targovishte",
    geonameid: 726174,
  },
  {
    name: "Troyan",
    country: "Bulgaria",
    subcountry: "Lovech",
    geonameid: 726320,
  },
  {
    name: "Dobrich",
    country: "Bulgaria",
    subcountry: "Dobrich",
    geonameid: 726418,
  },
  {
    name: "Svishtov",
    country: "Bulgaria",
    subcountry: "Veliko Tarnovo",
    geonameid: 726534,
  },
  {
    name: "Svilengrad",
    country: "Bulgaria",
    subcountry: "Haskovo",
    geonameid: 726546,
  },
  {
    name: "Stara Zagora",
    country: "Bulgaria",
    subcountry: "Stara Zagora",
    geonameid: 726848,
  },
  {
    name: "Dupnitsa",
    country: "Bulgaria",
    subcountry: "Kyustendil",
    geonameid: 726872,
  },
  {
    name: "Sofia",
    country: "Bulgaria",
    subcountry: "Sofia-Capital",
    geonameid: 727011,
  },
  {
    name: "Smolyan",
    country: "Bulgaria",
    subcountry: "Smolyan",
    geonameid: 727030,
  },
  {
    name: "Sliven",
    country: "Bulgaria",
    subcountry: "Sliven",
    geonameid: 727079,
  },
  {
    name: "Silistra",
    country: "Bulgaria",
    subcountry: "Silistra",
    geonameid: 727221,
  },
  {
    name: "Shumen",
    country: "Bulgaria",
    subcountry: "Shumen",
    geonameid: 727233,
  },
  {
    name: "Sevlievo",
    country: "Bulgaria",
    subcountry: "Gabrovo",
    geonameid: 727337,
  },
  {
    name: "Sandanski",
    country: "Bulgaria",
    subcountry: "Blagoevgrad",
    geonameid: 727447,
  },
  {
    name: "Samokov",
    country: "Bulgaria",
    subcountry: "Sofia",
    geonameid: 727462,
  },
  {
    name: "Ruse",
    country: "Bulgaria",
    subcountry: "Ruse",
    geonameid: 727523,
  },
  {
    name: "Razgrad",
    country: "Bulgaria",
    subcountry: "Razgrad",
    geonameid: 727696,
  },
  {
    name: "Rakovski",
    country: "Bulgaria",
    subcountry: "Plovdiv",
    geonameid: 727791,
  },
  {
    name: "Parvomay",
    country: "Bulgaria",
    subcountry: "Plovdiv",
    geonameid: 727886,
  },
  {
    name: "Popovo",
    country: "Bulgaria",
    subcountry: "Targovishte",
    geonameid: 728075,
  },
  {
    name: "Plovdiv",
    country: "Bulgaria",
    subcountry: "Plovdiv",
    geonameid: 728193,
  },
  {
    name: "Pleven",
    country: "Bulgaria",
    subcountry: "Pleven",
    geonameid: 728203,
  },
  {
    name: "Petrich",
    country: "Bulgaria",
    subcountry: "Blagoevgrad",
    geonameid: 728288,
  },
  {
    name: "Peshtera",
    country: "Bulgaria",
    subcountry: "Pazardzhik",
    geonameid: 728317,
  },
  {
    name: "Pernik",
    country: "Bulgaria",
    subcountry: "Pernik",
    geonameid: 728330,
  },
  {
    name: "Pazardzhik",
    country: "Bulgaria",
    subcountry: "Pazardzhik",
    geonameid: 728378,
  },
  {
    name: "Panagyurishte",
    country: "Bulgaria",
    subcountry: "Pazardzhik",
    geonameid: 728448,
  },
  {
    name: "Nova Zagora",
    country: "Bulgaria",
    subcountry: "Sliven",
    geonameid: 728742,
  },
  {
    name: "Montana",
    country: "Bulgaria",
    subcountry: "Montana",
    geonameid: 729114,
  },
  {
    name: "Lovech",
    country: "Bulgaria",
    subcountry: "Lovech",
    geonameid: 729559,
  },
  {
    name: "Lom",
    country: "Bulgaria",
    subcountry: "Montana",
    geonameid: 729581,
  },
  {
    name: "Kyustendil",
    country: "Bulgaria",
    subcountry: "Kyustendil",
    geonameid: 729730,
  },
  {
    name: "Kardzhali",
    country: "Bulgaria",
    subcountry: "Kardzhali",
    geonameid: 729794,
  },
  {
    name: "Haskovo",
    country: "Bulgaria",
    subcountry: "Haskovo",
    geonameid: 730435,
  },
  {
    name: "Harmanli",
    country: "Bulgaria",
    subcountry: "Haskovo",
    geonameid: 730442,
  },
  {
    name: "Kazanlak",
    country: "Bulgaria",
    subcountry: "Stara Zagora",
    geonameid: 730496,
  },
  {
    name: "Karnobat",
    country: "Bulgaria",
    subcountry: "Burgas",
    geonameid: 730559,
  },
  {
    name: "Karlovo",
    country: "Bulgaria",
    subcountry: "Plovdiv",
    geonameid: 730565,
  },
  {
    name: "Gotse Delchev",
    country: "Bulgaria",
    subcountry: "Blagoevgrad",
    geonameid: 731108,
  },
  {
    name: "Gorna Oryahovitsa",
    country: "Bulgaria",
    subcountry: "Veliko Tarnovo",
    geonameid: 731233,
  },
  {
    name: "Gabrovo",
    country: "Bulgaria",
    subcountry: "Gabrovo",
    geonameid: 731549,
  },
  {
    name: "Dimitrovgrad",
    country: "Bulgaria",
    subcountry: "Haskovo",
    geonameid: 732263,
  },
  {
    name: "Chirpan",
    country: "Bulgaria",
    subcountry: "Stara Zagora",
    geonameid: 732452,
  },
  {
    name: "Burgas",
    country: "Bulgaria",
    subcountry: "Burgas",
    geonameid: 732770,
  },
  {
    name: "Botevgrad",
    country: "Bulgaria",
    subcountry: "Sofia",
    geonameid: 733014,
  },
  {
    name: "Blagoevgrad",
    country: "Bulgaria",
    subcountry: "Blagoevgrad",
    geonameid: 733191,
  },
  {
    name: "Berkovitsa",
    country: "Bulgaria",
    subcountry: "Montana",
    geonameid: 733264,
  },
  {
    name: "Aytos",
    country: "Bulgaria",
    subcountry: "Burgas",
    geonameid: 733579,
  },
  {
    name: "Asparuhovo",
    country: "Bulgaria",
    subcountry: "Varna",
    geonameid: 733606,
  },
  {
    name: "Asenovgrad",
    country: "Bulgaria",
    subcountry: "Plovdiv",
    geonameid: 733618,
  },
  {
    name: "Sitrah",
    country: "Bahrain",
    subcountry: "Manama",
    geonameid: 290104,
  },
  {
    name: "Madīnat ‘Īsá",
    country: "Bahrain",
    subcountry: "Southern Governorate",
    geonameid: 290187,
  },
  {
    name: "Jidd Ḩafş",
    country: "Bahrain",
    subcountry: "Manama",
    geonameid: 290215,
  },
  {
    name: "Madīnat Ḩamad",
    country: "Bahrain",
    subcountry: "Northern",
    geonameid: 290247,
  },
  {
    name: "Dār Kulayb",
    country: "Bahrain",
    subcountry: "Southern Governorate",
    geonameid: 290269,
  },
  {
    name: "Al Muharraq",
    country: "Bahrain",
    subcountry: "Muharraq",
    geonameid: 290332,
  },
  {
    name: "Manama",
    country: "Bahrain",
    subcountry: "Manama",
    geonameid: 290340,
  },
  {
    name: "Ar Rifā‘",
    country: "Bahrain",
    subcountry: "Southern Governorate",
    geonameid: 385038,
  },
  {
    name: "Makamba",
    country: "Burundi",
    subcountry: "Makamba",
    geonameid: 422232,
  },
  {
    name: "Bururi",
    country: "Burundi",
    subcountry: "Bururi",
    geonameid: 423328,
  },
  {
    name: "Bujumbura",
    country: "Burundi",
    subcountry: "Bujumbura Mairie",
    geonameid: 425378,
  },
  {
    name: "Muramvya",
    country: "Burundi",
    subcountry: "Muramvya",
    geonameid: 425551,
  },
  {
    name: "Gitega",
    country: "Burundi",
    subcountry: "Gitega",
    geonameid: 426272,
  },
  {
    name: "Ruyigi",
    country: "Burundi",
    subcountry: "Ruyigi",
    geonameid: 426700,
  },
  {
    name: "Ngozi",
    country: "Burundi",
    subcountry: "Ngozi",
    geonameid: 430569,
  },
  {
    name: "Kayanza",
    country: "Burundi",
    subcountry: "Kayanza",
    geonameid: 430952,
  },
  {
    name: "Muyinga",
    country: "Burundi",
    subcountry: "Muyinga",
    geonameid: 431748,
  },
  {
    name: "Rutana",
    country: "Burundi",
    subcountry: "Rutana",
    geonameid: 433635,
  },
  {
    name: "Tchaourou",
    country: "Benin",
    subcountry: "Borgou",
    geonameid: 2391377,
  },
  {
    name: "Tanguiéta",
    country: "Benin",
    subcountry: "Atakora",
    geonameid: 2391455,
  },
  {
    name: "Savé",
    country: "Benin",
    subcountry: "Collines",
    geonameid: 2391893,
  },
  {
    name: "Savalou",
    country: "Benin",
    subcountry: "Collines",
    geonameid: 2391895,
  },
  {
    name: "Sakété",
    country: "Benin",
    subcountry: "Plateau",
    geonameid: 2392009,
  },
  {
    name: "Porto-Novo",
    country: "Benin",
    subcountry: "Ouémé",
    geonameid: 2392087,
  },
  {
    name: "Pobé",
    country: "Benin",
    subcountry: "Plateau",
    geonameid: 2392108,
  },
  {
    name: "Parakou",
    country: "Benin",
    subcountry: "Borgou",
    geonameid: 2392204,
  },
  {
    name: "Ouidah",
    country: "Benin",
    subcountry: "Atlantique",
    geonameid: 2392308,
  },
  {
    name: "Nikki",
    country: "Benin",
    subcountry: "Borgou",
    geonameid: 2392505,
  },
  {
    name: "Natitingou",
    country: "Benin",
    subcountry: "Atakora",
    geonameid: 2392601,
  },
  {
    name: "Malanville",
    country: "Benin",
    subcountry: "Alibori",
    geonameid: 2392837,
  },
  {
    name: "Lokossa",
    country: "Benin",
    subcountry: "Mono",
    geonameid: 2392897,
  },
  {
    name: "Kétou",
    country: "Benin",
    subcountry: "Plateau",
    geonameid: 2393551,
  },
  {
    name: "Kandi",
    country: "Benin",
    subcountry: "Alibori",
    geonameid: 2393693,
  },
  {
    name: "Dogbo",
    country: "Benin",
    subcountry: "Kouffo",
    geonameid: 2394545,
  },
  {
    name: "Djougou",
    country: "Benin",
    subcountry: "Donga",
    geonameid: 2394560,
  },
  {
    name: "Dassa-Zoumé",
    country: "Benin",
    subcountry: "Collines",
    geonameid: 2394711,
  },
  {
    name: "Cové",
    country: "Benin",
    subcountry: "Zou",
    geonameid: 2394814,
  },
  {
    name: "Cotonou",
    country: "Benin",
    subcountry: "Littoral",
    geonameid: 2394819,
  },
  {
    name: "Comé",
    country: "Benin",
    subcountry: "Collines",
    geonameid: 2394824,
  },
  {
    name: "Bohicon",
    country: "Benin",
    subcountry: "Zou",
    geonameid: 2395049,
  },
  {
    name: "Bembèrèkè",
    country: "Benin",
    subcountry: "Borgou",
    geonameid: 2395182,
  },
  {
    name: "Bassila",
    country: "Benin",
    subcountry: "Donga",
    geonameid: 2395261,
  },
  {
    name: "Banikoara",
    country: "Benin",
    subcountry: "Alibori",
    geonameid: 2395317,
  },
  {
    name: "Aplahoué",
    country: "Benin",
    subcountry: "Kouffo",
    geonameid: 2395568,
  },
  {
    name: "Allada",
    country: "Benin",
    subcountry: "Atlantique",
    geonameid: 2395635,
  },
  {
    name: "Abomey-Calavi",
    country: "Benin",
    subcountry: "Atlantique",
    geonameid: 2395914,
  },
  {
    name: "Abomey",
    country: "Benin",
    subcountry: "Zou",
    geonameid: 2395915,
  },
  {
    name: "Gustavia",
    country: "Saint Barthelemy",
    subcountry: "N/A",
    geonameid: 3579132,
  },
  {
    name: "Hamilton",
    country: "Bermuda",
    subcountry: "Hamilton city",
    geonameid: 3573197,
  },
  {
    name: "Tutong",
    country: "Brunei",
    subcountry: "Tutong",
    geonameid: 1820071,
  },
  {
    name: "Seria",
    country: "Brunei",
    subcountry: "Belait",
    geonameid: 1820187,
  },
  {
    name: "Kuala Belait",
    country: "Brunei",
    subcountry: "Belait",
    geonameid: 1820491,
  },
  {
    name: "Bandar Seri Begawan",
    country: "Brunei",
    subcountry: "Brunei-Muara District",
    geonameid: 1820906,
  },
  {
    name: "Yacuiba",
    country: "Bolivia",
    subcountry: "Tarija Department",
    geonameid: 3901178,
  },
  {
    name: "Warnes",
    country: "Bolivia",
    subcountry: "Santa Cruz Department",
    geonameid: 3901301,
  },
  {
    name: "Vinto",
    country: "Bolivia",
    subcountry: "Cochabamba",
    geonameid: 3901435,
  },
  {
    name: "Villazón",
    country: "Bolivia",
    subcountry: "Potosí Department",
    geonameid: 3901501,
  },
  {
    name: "Villa Yapacaní",
    country: "Bolivia",
    subcountry: "Santa Cruz Department",
    geonameid: 3901504,
  },
  {
    name: "Villamontes",
    country: "Bolivia",
    subcountry: "Tarija Department",
    geonameid: 3901547,
  },
  {
    name: "Viacha",
    country: "Bolivia",
    subcountry: "La Paz Department",
    geonameid: 3901742,
  },
  {
    name: "Tupiza",
    country: "Bolivia",
    subcountry: "Potosí Department",
    geonameid: 3902202,
  },
  {
    name: "Trinidad",
    country: "Bolivia",
    subcountry: "Beni Department",
    geonameid: 3902377,
  },
  {
    name: "Tiquipaya",
    country: "Bolivia",
    subcountry: "Cochabamba",
    geonameid: 3902949,
  },
  {
    name: "Tarija",
    country: "Bolivia",
    subcountry: "Tarija Department",
    geonameid: 3903320,
  },
  {
    name: "Sucre",
    country: "Bolivia",
    subcountry: "Chuquisaca Department",
    geonameid: 3903987,
  },
  {
    name: "Sipe Sipe",
    country: "Bolivia",
    subcountry: "Cochabamba",
    geonameid: 3904221,
  },
  {
    name: "El Torno",
    country: "Bolivia",
    subcountry: "Santa Cruz Department",
    geonameid: 3904666,
  },
  {
    name: "Santa Cruz de la Sierra",
    country: "Bolivia",
    subcountry: "Santa Cruz Department",
    geonameid: 3904906,
  },
  {
    name: "San Ignacio de Velasco",
    country: "Bolivia",
    subcountry: "Santa Cruz Department",
    geonameid: 3905658,
  },
  {
    name: "Sacaba",
    country: "Bolivia",
    subcountry: "Cochabamba",
    geonameid: 3906194,
  },
  {
    name: "Riberalta",
    country: "Bolivia",
    subcountry: "Beni Department",
    geonameid: 3906466,
  },
  {
    name: "Quillacollo",
    country: "Bolivia",
    subcountry: "Cochabamba",
    geonameid: 3906791,
  },
  {
    name: "Punata",
    country: "Bolivia",
    subcountry: "Cochabamba",
    geonameid: 3907080,
  },
  {
    name: "Potosí",
    country: "Bolivia",
    subcountry: "Potosí Department",
    geonameid: 3907584,
  },
  {
    name: "Oruro",
    country: "Bolivia",
    subcountry: "Oruro",
    geonameid: 3909234,
  },
  {
    name: "Montero",
    country: "Bolivia",
    subcountry: "Santa Cruz Department",
    geonameid: 3910027,
  },
  {
    name: "Mizque",
    country: "Bolivia",
    subcountry: "Cochabamba",
    geonameid: 3910291,
  },
  {
    name: "Llallagua",
    country: "Bolivia",
    subcountry: "Potosí Department",
    geonameid: 3911409,
  },
  {
    name: "La Paz",
    country: "Bolivia",
    subcountry: "La Paz Department",
    geonameid: 3911925,
  },
  {
    name: "Laja",
    country: "Bolivia",
    subcountry: "La Paz Department",
    geonameid: 3912103,
  },
  {
    name: "Huanuni",
    country: "Bolivia",
    subcountry: "Oruro",
    geonameid: 3914839,
  },
  {
    name: "Guayaramerín",
    country: "Bolivia",
    subcountry: "Beni Department",
    geonameid: 3915350,
  },
  {
    name: "Cotoca",
    country: "Bolivia",
    subcountry: "Santa Cruz Department",
    geonameid: 3918937,
  },
  {
    name: "Colcapirhua",
    country: "Bolivia",
    subcountry: "Cochabamba",
    geonameid: 3919902,
  },
  {
    name: "Cochabamba",
    country: "Bolivia",
    subcountry: "Cochabamba",
    geonameid: 3919968,
  },
  {
    name: "Cobija",
    country: "Bolivia",
    subcountry: "Pando",
    geonameid: 3919998,
  },
  {
    name: "Caranavi",
    country: "Bolivia",
    subcountry: "La Paz Department",
    geonameid: 3922037,
  },
  {
    name: "Camiri",
    country: "Bolivia",
    subcountry: "Santa Cruz Department",
    geonameid: 3922414,
  },
  {
    name: "Bermejo",
    country: "Bolivia",
    subcountry: "Tarija Department",
    geonameid: 3923154,
  },
  {
    name: "Achocalla",
    country: "Bolivia",
    subcountry: "La Paz Department",
    geonameid: 3924569,
  },
  {
    name: "Ascención de Guarayos",
    country: "Bolivia",
    subcountry: "Santa Cruz Department",
    geonameid: 9129422,
  },
  {
    name: "San Borja",
    country: "Bolivia",
    subcountry: "Beni Department",
    geonameid: 11467676,
  },
  {
    name: "Kralendijk",
    country: "Bonaire, Saint Eustatius and Saba ",
    subcountry: "Bonaire",
    geonameid: 3513563,
  },
  {
    name: "Vitória do Mearim",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3384986,
  },
  {
    name: "Vitória de Santo Antão",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3384987,
  },
  {
    name: "Viseu",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3385022,
  },
  {
    name: "Conde",
    country: "Brazil",
    subcountry: "Paraíba",
    geonameid: 3385077,
  },
  {
    name: "Vigia",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3385088,
  },
  {
    name: "Viçosa do Ceará",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3385106,
  },
  {
    name: "Viçosa",
    country: "Brazil",
    subcountry: "Alagoas",
    geonameid: 3385109,
  },
  {
    name: "Viana",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3385122,
  },
  {
    name: "Várzea Alegre",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3385467,
  },
  {
    name: "Varjota",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3385504,
  },
  {
    name: "Vargem Grande",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3385538,
  },
  {
    name: "Valença do Piauí",
    country: "Brazil",
    subcountry: "Piauí",
    geonameid: 3385592,
  },
  {
    name: "União dos Palmares",
    country: "Brazil",
    subcountry: "Alagoas",
    geonameid: 3385742,
  },
  {
    name: "União",
    country: "Brazil",
    subcountry: "Piauí",
    geonameid: 3385745,
  },
  {
    name: "Tuntum",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3385922,
  },
  {
    name: "Tucuruí",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3385935,
  },
  {
    name: "Tucumã",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3385980,
  },
  {
    name: "Trindade",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3386042,
  },
  {
    name: "Trairi",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3386177,
  },
  {
    name: "Toritama",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3386264,
  },
  {
    name: "Tomé Açu",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3386279,
  },
  {
    name: "Timon",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3386361,
  },
  {
    name: "Timbiras",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3386372,
  },
  {
    name: "Timbaúba",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3386396,
  },
  {
    name: "Tianguá",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3386449,
  },
  {
    name: "Teresina",
    country: "Brazil",
    subcountry: "Piauí",
    geonameid: 3386496,
  },
  {
    name: "São João dos Inhamuns",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3386567,
  },
  {
    name: "Tamandaré",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3386931,
  },
  {
    name: "Tabira",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3387082,
  },
  {
    name: "Surubim",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3387115,
  },
  {
    name: "Sousa",
    country: "Brazil",
    subcountry: "Paraíba",
    geonameid: 3387202,
  },
  {
    name: "Soure",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3387204,
  },
  {
    name: "Solânea",
    country: "Brazil",
    subcountry: "Paraíba",
    geonameid: 3387266,
  },
  {
    name: "Sobral",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3387296,
  },
  {
    name: "Sirinhaém",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3387604,
  },
  {
    name: "Sertânia",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3387663,
  },
  {
    name: "Serra Talhada",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3387786,
  },
  {
    name: "Senador Pompeu",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3387926,
  },
  {
    name: "Satuba",
    country: "Brazil",
    subcountry: "Alagoas",
    geonameid: 3387987,
  },
  {
    name: "São Raimundo Nonato",
    country: "Brazil",
    subcountry: "Piauí",
    geonameid: 3388145,
  },
  {
    name: "São Miguel dos Campos",
    country: "Brazil",
    subcountry: "Alagoas",
    geonameid: 3388269,
  },
  {
    name: "São Miguel do Guamá",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3388270,
  },
  {
    name: "São Mateus do Maranhão",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3388318,
  },
  {
    name: "São Luís do Quitunde",
    country: "Brazil",
    subcountry: "Alagoas",
    geonameid: 3388341,
  },
  {
    name: "São Luís",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3388368,
  },
  {
    name: "São Lourenço da Mata",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3388376,
  },
  {
    name: "São José do Egito",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3388435,
  },
  {
    name: "São José de Ribamar",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3388441,
  },
  {
    name: "São José de Mipibu",
    country: "Brazil",
    subcountry: "Rio Grande do Norte",
    geonameid: 3388443,
  },
  {
    name: "São João dos Patos",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3388615,
  },
  {
    name: "São Gonçalo do Amarante",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3388714,
  },
  {
    name: "São Félix do Xingu",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3388847,
  },
  {
    name: "São Domingos do Maranhão",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3388868,
  },
  {
    name: "São Bento",
    country: "Brazil",
    subcountry: "Paraíba",
    geonameid: 3388991,
  },
  {
    name: "São Bento",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3389006,
  },
  {
    name: "Santa Rita",
    country: "Brazil",
    subcountry: "Paraíba",
    geonameid: 3389321,
  },
  {
    name: "Santarém",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3389353,
  },
  {
    name: "Santa Quitéria do Maranhão",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3389358,
  },
  {
    name: "Santa Quitéria",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3389361,
  },
  {
    name: "Santana do Ipanema",
    country: "Brazil",
    subcountry: "Alagoas",
    geonameid: 3389384,
  },
  {
    name: "Santa Luzia",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3389557,
  },
  {
    name: "Santa Inês",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3389609,
  },
  {
    name: "Santa Helena",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3389622,
  },
  {
    name: "Santa Cruz do Capibaribe",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3389652,
  },
  {
    name: "Santa Cruz",
    country: "Brazil",
    subcountry: "Rio Grande do Norte",
    geonameid: 3389673,
  },
  {
    name: "Salinópolis",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3389822,
  },
  {
    name: "Salgueiro",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3389860,
  },
  {
    name: "Russas",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3390160,
  },
  {
    name: "Rio Largo",
    country: "Brazil",
    subcountry: "Alagoas",
    geonameid: 3390288,
  },
  {
    name: "Rio Formoso",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3390295,
  },
  {
    name: "Ribeirão",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3390326,
  },
  {
    name: "Recife",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3390760,
  },
  {
    name: "Quixeramobim",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3390901,
  },
  {
    name: "Quixadá",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3390907,
  },
  {
    name: "Presidente Dutra",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3391220,
  },
  {
    name: "Santana",
    country: "Brazil",
    subcountry: "Amapá",
    geonameid: 3391360,
  },
  {
    name: "Porto Calvo",
    country: "Brazil",
    subcountry: "Alagoas",
    geonameid: 3391397,
  },
  {
    name: "Portel",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3391412,
  },
  {
    name: "Pombos",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3391556,
  },
  {
    name: "Pombal",
    country: "Brazil",
    subcountry: "Paraíba",
    geonameid: 3391571,
  },
  {
    name: "Piripiri",
    country: "Brazil",
    subcountry: "Piauí",
    geonameid: 3391908,
  },
  {
    name: "Piracuruca",
    country: "Brazil",
    subcountry: "Piauí",
    geonameid: 3391991,
  },
  {
    name: "Pinheiro",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3392054,
  },
  {
    name: "Pindaré Mirim",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3392088,
  },
  {
    name: "Pilar",
    country: "Brazil",
    subcountry: "Alagoas",
    geonameid: 3392126,
  },
  {
    name: "Picos",
    country: "Brazil",
    subcountry: "Piauí",
    geonameid: 3392167,
  },
  {
    name: "Petrolina",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3392242,
  },
  {
    name: "Jatobá",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3392243,
  },
  {
    name: "Pesqueira",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3392251,
  },
  {
    name: "Pentecoste",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3392345,
  },
  {
    name: "Penalva",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3392368,
  },
  {
    name: "Pedro II",
    country: "Brazil",
    subcountry: "Piauí",
    geonameid: 3392431,
  },
  {
    name: "Pedra Branca",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3392629,
  },
  {
    name: "Paulo Afonso",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3392734,
  },
  {
    name: "Paulista",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3392740,
  },
  {
    name: "Patos",
    country: "Brazil",
    subcountry: "Paraíba",
    geonameid: 3392887,
  },
  {
    name: "Parnamirim",
    country: "Brazil",
    subcountry: "Rio Grande do Norte",
    geonameid: 3392998,
  },
  {
    name: "Parnaíba",
    country: "Brazil",
    subcountry: "Piauí",
    geonameid: 3393001,
  },
  {
    name: "Parintins",
    country: "Brazil",
    subcountry: "Amazonas",
    geonameid: 3393008,
  },
  {
    name: "Parelhas",
    country: "Brazil",
    subcountry: "Rio Grande do Norte",
    geonameid: 3393017,
  },
  {
    name: "Paraipaba",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3393091,
  },
  {
    name: "Paragominas",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3393106,
  },
  {
    name: "Paracuru",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3393115,
  },
  {
    name: "Palmares",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3393264,
  },
  {
    name: "Pacatuba",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3393400,
  },
  {
    name: "Pacajus",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3393409,
  },
  {
    name: "Ouricuri",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3393452,
  },
  {
    name: "Orós",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3393465,
  },
  {
    name: "Oriximiná",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3393471,
  },
  {
    name: "Olinda",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3393536,
  },
  {
    name: "Oeiras",
    country: "Brazil",
    subcountry: "Piauí",
    geonameid: 3393764,
  },
  {
    name: "Óbidos",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3393768,
  },
  {
    name: "Nova Russas",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3393832,
  },
  {
    name: "Nova Cruz",
    country: "Brazil",
    subcountry: "Rio Grande do Norte",
    geonameid: 3393876,
  },
  {
    name: "Nazaré da Mata",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3393972,
  },
  {
    name: "Natal",
    country: "Brazil",
    subcountry: "Rio Grande do Norte",
    geonameid: 3394023,
  },
  {
    name: "Murici",
    country: "Brazil",
    subcountry: "Alagoas",
    geonameid: 3394116,
  },
  {
    name: "Moreno",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3394453,
  },
  {
    name: "Morada Nova",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3394500,
  },
  {
    name: "Monteiro",
    country: "Brazil",
    subcountry: "Paraíba",
    geonameid: 3394549,
  },
  {
    name: "Monte Alegre",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3394605,
  },
  {
    name: "Mombaça",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3394649,
  },
  {
    name: "Moju",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3394661,
  },
  {
    name: "Mossoró",
    country: "Brazil",
    subcountry: "Rio Grande do Norte",
    geonameid: 3394682,
  },
  {
    name: "Mocajuba",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3394745,
  },
  {
    name: "Miracema do Tocantins",
    country: "Brazil",
    subcountry: "Tocantins",
    geonameid: 3394817,
  },
  {
    name: "Maués",
    country: "Brazil",
    subcountry: "Amazonas",
    geonameid: 3395062,
  },
  {
    name: "Matriz de Camaragibe",
    country: "Brazil",
    subcountry: "Alagoas",
    geonameid: 3395077,
  },
  {
    name: "Mari",
    country: "Brazil",
    subcountry: "Paraíba",
    geonameid: 3395380,
  },
  {
    name: "Marechal Deodoro",
    country: "Brazil",
    subcountry: "Alagoas",
    geonameid: 3395395,
  },
  {
    name: "Maragogi",
    country: "Brazil",
    subcountry: "Alagoas",
    geonameid: 3395458,
  },
  {
    name: "Maracanaú",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3395473,
  },
  {
    name: "Marabá",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3395503,
  },
  {
    name: "Mamanguape",
    country: "Brazil",
    subcountry: "Paraíba",
    geonameid: 3395717,
  },
  {
    name: "Maceió",
    country: "Brazil",
    subcountry: "Alagoas",
    geonameid: 3395981,
  },
  {
    name: "Macau",
    country: "Brazil",
    subcountry: "Rio Grande do Norte",
    geonameid: 3395998,
  },
  {
    name: "Macapá",
    country: "Brazil",
    subcountry: "Amapá",
    geonameid: 3396016,
  },
  {
    name: "Macaíba",
    country: "Brazil",
    subcountry: "Rio Grande do Norte",
    geonameid: 3396048,
  },
  {
    name: "Limoeiro do Norte",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3396266,
  },
  {
    name: "Limoeiro",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3396277,
  },
  {
    name: "Lavras da Mangabeira",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3396364,
  },
  {
    name: "Lajedo",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3396496,
  },
  {
    name: "Lago da Pedra",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3396601,
  },
  {
    name: "Lagoa do Itaenga",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3396769,
  },
  {
    name: "Juazeiro do Norte",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3397147,
  },
  {
    name: "José de Freitas",
    country: "Brazil",
    subcountry: "Piauí",
    geonameid: 3397230,
  },
  {
    name: "João Pessoa",
    country: "Brazil",
    subcountry: "Paraíba",
    geonameid: 3397277,
  },
  {
    name: "João Câmara",
    country: "Brazil",
    subcountry: "Rio Grande do Norte",
    geonameid: 3397315,
  },
  {
    name: "Jaguaruana",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3397665,
  },
  {
    name: "Jaguaribe",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3397675,
  },
  {
    name: "Jaboatão",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3397838,
  },
  {
    name: "Itupiranga",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3397851,
  },
  {
    name: "Itacoatiara",
    country: "Brazil",
    subcountry: "Amazonas",
    geonameid: 3397893,
  },
  {
    name: "Itaporanga",
    country: "Brazil",
    subcountry: "Paraíba",
    geonameid: 3397898,
  },
  {
    name: "Itapissuma",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3397904,
  },
  {
    name: "Itapipoca",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3397909,
  },
  {
    name: "Itapecuru Mirim",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3397936,
  },
  {
    name: "Itapagé",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3397941,
  },
  {
    name: "Itaituba",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3397967,
  },
  {
    name: "Itaitinga",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3397969,
  },
  {
    name: "Itabaiana",
    country: "Brazil",
    subcountry: "Paraíba",
    geonameid: 3398003,
  },
  {
    name: "Ipueiras",
    country: "Brazil",
    subcountry: "Piauí",
    geonameid: 3398076,
  },
  {
    name: "Ipubi",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3398105,
  },
  {
    name: "Ipu",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3398112,
  },
  {
    name: "Ipojuca",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3398115,
  },
  {
    name: "Imperatriz",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3398269,
  },
  {
    name: "Iguatu",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3398331,
  },
  {
    name: "Igarapé Miri",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3398343,
  },
  {
    name: "Igarapé Açu",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3398350,
  },
  {
    name: "Igarassu",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3398352,
  },
  {
    name: "Icó",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3398379,
  },
  {
    name: "Horizonte",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3398450,
  },
  {
    name: "Guaraciaba do Norte",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3398569,
  },
  {
    name: "Guarabira",
    country: "Brazil",
    subcountry: "Paraíba",
    geonameid: 3398570,
  },
  {
    name: "Guaiúba",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3398614,
  },
  {
    name: "Gravatá",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3398691,
  },
  {
    name: "Granja",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3398706,
  },
  {
    name: "Grajaú",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3398856,
  },
  {
    name: "Goiana",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3398904,
  },
  {
    name: "Glória do Goitá",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3398920,
  },
  {
    name: "Garanhuns",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3399058,
  },
  {
    name: "Gameleira",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3399132,
  },
  {
    name: "Fortaleza",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3399415,
  },
  {
    name: "Floriano",
    country: "Brazil",
    subcountry: "Piauí",
    geonameid: 3399506,
  },
  {
    name: "Floresta",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3399518,
  },
  {
    name: "Eusébio",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3400558,
  },
  {
    name: "Extremoz",
    country: "Brazil",
    subcountry: "Rio Grande do Norte",
    geonameid: 3400567,
  },
  {
    name: "Estreito",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3400617,
  },
  {
    name: "Esperantina",
    country: "Brazil",
    subcountry: "Piauí",
    geonameid: 3400740,
  },
  {
    name: "Esperança",
    country: "Brazil",
    subcountry: "Paraíba",
    geonameid: 3400752,
  },
  {
    name: "Escada",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3400804,
  },
  {
    name: "Dom Pedro",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3400969,
  },
  {
    name: "Demerval Lobão",
    country: "Brazil",
    subcountry: "Piauí",
    geonameid: 3401106,
  },
  {
    name: "Delmiro Gouveia",
    country: "Brazil",
    subcountry: "Alagoas",
    geonameid: 3401109,
  },
  {
    name: "Custódia",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3401138,
  },
  {
    name: "Cururupu",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3401148,
  },
  {
    name: "Currais Novos",
    country: "Brazil",
    subcountry: "Rio Grande do Norte",
    geonameid: 3401283,
  },
  {
    name: "Cupira",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3401340,
  },
  {
    name: "Crato",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3401545,
  },
  {
    name: "Crateús",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3401548,
  },
  {
    name: "Coroatá",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3401703,
  },
  {
    name: "Condado",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3401830,
  },
  {
    name: "Conceição do Araguaia",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3401845,
  },
  {
    name: "Colinas",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3401963,
  },
  {
    name: "Coelho Neto",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3401992,
  },
  {
    name: "Codó",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3402000,
  },
  {
    name: "Chapadinha",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3402229,
  },
  {
    name: "Chã Grande",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3402271,
  },
  {
    name: "Ceará Mirim",
    country: "Brazil",
    subcountry: "Rio Grande do Norte",
    geonameid: 3402360,
  },
  {
    name: "Caxias",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3402383,
  },
  {
    name: "Caucaia",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3402429,
  },
  {
    name: "Catolé do Rocha",
    country: "Brazil",
    subcountry: "Paraíba",
    geonameid: 3402465,
  },
  {
    name: "Catende",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3402528,
  },
  {
    name: "Castanhal",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3402591,
  },
  {
    name: "Cascavel",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3402613,
  },
  {
    name: "Caruaru",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3402655,
  },
  {
    name: "Carpina",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3402721,
  },
  {
    name: "Carolina",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3402724,
  },
  {
    name: "Capitão Poço",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3403127,
  },
  {
    name: "Capanema",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3403208,
  },
  {
    name: "Canindé",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3403353,
  },
  {
    name: "Canguaretama",
    country: "Brazil",
    subcountry: "Rio Grande do Norte",
    geonameid: 3403362,
  },
  {
    name: "Campos Sales",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3403534,
  },
  {
    name: "Campo Maior",
    country: "Brazil",
    subcountry: "Piauí",
    geonameid: 3403566,
  },
  {
    name: "Campo Alegre",
    country: "Brazil",
    subcountry: "Alagoas",
    geonameid: 3403611,
  },
  {
    name: "Campina Grande",
    country: "Brazil",
    subcountry: "Paraíba",
    geonameid: 3403642,
  },
  {
    name: "Camocim",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3403687,
  },
  {
    name: "Cametá",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3403697,
  },
  {
    name: "Cajueiro",
    country: "Brazil",
    subcountry: "Alagoas",
    geonameid: 3403941,
  },
  {
    name: "Cajazeiras",
    country: "Brazil",
    subcountry: "Paraíba",
    geonameid: 3404020,
  },
  {
    name: "Caicó",
    country: "Brazil",
    subcountry: "Rio Grande do Norte",
    geonameid: 3404117,
  },
  {
    name: "Cabrobó",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3404513,
  },
  {
    name: "Cabo",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3404545,
  },
  {
    name: "Cabedelo",
    country: "Brazil",
    subcountry: "Paraíba",
    geonameid: 3404558,
  },
  {
    name: "Buriti Bravo",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3404722,
  },
  {
    name: "Buíque",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3404766,
  },
  {
    name: "Breves",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3404817,
  },
  {
    name: "Brejo Santo",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3404833,
  },
  {
    name: "Brejo da Madre de Deus",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3404862,
  },
  {
    name: "Bragança",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3405006,
  },
  {
    name: "Bom Conselho",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3405380,
  },
  {
    name: "Boa Viagem",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3405616,
  },
  {
    name: "Bezerros",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3405738,
  },
  {
    name: "Benevides",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3405792,
  },
  {
    name: "Belo Jardim",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3405812,
  },
  {
    name: "Belém",
    country: "Brazil",
    subcountry: "Paraíba",
    geonameid: 3405863,
  },
  {
    name: "Belém",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3405870,
  },
  {
    name: "Beberibe",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3405924,
  },
  {
    name: "Bayeux",
    country: "Brazil",
    subcountry: "Paraíba",
    geonameid: 3405940,
  },
  {
    name: "Baturité",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3405954,
  },
  {
    name: "Barreiros",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3406160,
  },
  {
    name: "Barreirinhas",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3406196,
  },
  {
    name: "Barras",
    country: "Brazil",
    subcountry: "Piauí",
    geonameid: 3406263,
  },
  {
    name: "Barra do Corda",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3406317,
  },
  {
    name: "Barcarena",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3406429,
  },
  {
    name: "Barbalha",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3406442,
  },
  {
    name: "Balsas",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3406545,
  },
  {
    name: "Bacabal",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3406910,
  },
  {
    name: "Augusto Corrêa",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3406961,
  },
  {
    name: "Atalaia",
    country: "Brazil",
    subcountry: "Alagoas",
    geonameid: 3406996,
  },
  {
    name: "Areia Branca",
    country: "Brazil",
    subcountry: "Rio Grande do Norte",
    geonameid: 3407194,
  },
  {
    name: "Arcoverde",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3407216,
  },
  {
    name: "Araripina",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3407243,
  },
  {
    name: "Arari",
    country: "Brazil",
    subcountry: "Maranhão",
    geonameid: 3407258,
  },
  {
    name: "Arapiraca",
    country: "Brazil",
    subcountry: "Alagoas",
    geonameid: 3407327,
  },
  {
    name: "Araguaína",
    country: "Brazil",
    subcountry: "Tocantins",
    geonameid: 3407357,
  },
  {
    name: "Aracati",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3407378,
  },
  {
    name: "Aquiraz",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3407407,
  },
  {
    name: "Apodi",
    country: "Brazil",
    subcountry: "Rio Grande do Norte",
    geonameid: 3407440,
  },
  {
    name: "Ananindeua",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3407669,
  },
  {
    name: "Amaraji",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3407758,
  },
  {
    name: "Altos",
    country: "Brazil",
    subcountry: "Piauí",
    geonameid: 3407797,
  },
  {
    name: "Altamira",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3407882,
  },
  {
    name: "Almeirim",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3407903,
  },
  {
    name: "Alenquer",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3407980,
  },
  {
    name: "Alagoa Grande",
    country: "Brazil",
    subcountry: "Paraíba",
    geonameid: 3408100,
  },
  {
    name: "Águas Belas",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3408166,
  },
  {
    name: "Água Preta",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3408175,
  },
  {
    name: "Afogados da Ingazeira",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3408274,
  },
  {
    name: "Açu",
    country: "Brazil",
    subcountry: "Rio Grande do Norte",
    geonameid: 3408337,
  },
  {
    name: "Acopiara",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3408343,
  },
  {
    name: "Acaraú",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 3408368,
  },
  {
    name: "Abreu e Lima",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 3408404,
  },
  {
    name: "Abaetetuba",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 3408424,
  },
  {
    name: "Xique Xique",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3444823,
  },
  {
    name: "Xanxerê",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3444848,
  },
  {
    name: "Votuporanga",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3444864,
  },
  {
    name: "Votorantim",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3444866,
  },
  {
    name: "Volta Redonda",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3444876,
  },
  {
    name: "Vitória da Conquista",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3444914,
  },
  {
    name: "Vitória",
    country: "Brazil",
    subcountry: "Espírito Santo",
    geonameid: 3444924,
  },
  {
    name: "Visconde do Rio Branco",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3444969,
  },
  {
    name: "Viradouro",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3444997,
  },
  {
    name: "Vinhedo",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3445014,
  },
  {
    name: "Vila Velha",
    country: "Brazil",
    subcountry: "Espírito Santo",
    geonameid: 3445026,
  },
  {
    name: "Videira",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3445126,
  },
  {
    name: "Viçosa",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3445133,
  },
  {
    name: "Viana",
    country: "Brazil",
    subcountry: "Espírito Santo",
    geonameid: 3445153,
  },
  {
    name: "Viamão",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3445156,
  },
  {
    name: "Vespasiano",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3445162,
  },
  {
    name: "Veranópolis",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3445299,
  },
  {
    name: "Vera Cruz",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3445307,
  },
  {
    name: "Wenceslau Braz",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3445348,
  },
  {
    name: "Venâncio Aires",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3445350,
  },
  {
    name: "Vazante",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3445418,
  },
  {
    name: "Vassouras",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3445433,
  },
  {
    name: "Várzea Paulista",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3445446,
  },
  {
    name: "Várzea Grande",
    country: "Brazil",
    subcountry: "Mato Grosso",
    geonameid: 3445451,
  },
  {
    name: "Várzea da Palma",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3445459,
  },
  {
    name: "Varginha",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3445487,
  },
  {
    name: "Vargem Grande do Sul",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3445500,
  },
  {
    name: "Valparaíso",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3445575,
  },
  {
    name: "Valinhos",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3445578,
  },
  {
    name: "Valença",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3445596,
  },
  {
    name: "Valença",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3445597,
  },
  {
    name: "Vacaria",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3445630,
  },
  {
    name: "Uruguaiana",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3445679,
  },
  {
    name: "Uruçuca",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3445690,
  },
  {
    name: "Uruaçu",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3445713,
  },
  {
    name: "União da Vitória",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3445746,
  },
  {
    name: "Unaí",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3445764,
  },
  {
    name: "Una",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3445781,
  },
  {
    name: "Umuarama",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3445782,
  },
  {
    name: "Uberlândia",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3445831,
  },
  {
    name: "Uberaba",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3445839,
  },
  {
    name: "Ubatuba",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3445847,
  },
  {
    name: "Ubatã",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3445849,
  },
  {
    name: "Ubaitaba",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3445853,
  },
  {
    name: "Ubá",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3445859,
  },
  {
    name: "Tupanciretã",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3445939,
  },
  {
    name: "Tupaciguara",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3445941,
  },
  {
    name: "Tupã",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3445942,
  },
  {
    name: "Tucano",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3445983,
  },
  {
    name: "Tubarão",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3445993,
  },
  {
    name: "Trindade",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3446038,
  },
  {
    name: "Três Rios",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3446065,
  },
  {
    name: "Três Pontas",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3446077,
  },
  {
    name: "Três Passos",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3446087,
  },
  {
    name: "Três Lagoas",
    country: "Brazil",
    subcountry: "Mato Grosso do Sul",
    geonameid: 3446098,
  },
  {
    name: "Três de Maio",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3446130,
  },
  {
    name: "Três Coroas",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3446137,
  },
  {
    name: "Três Corações",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3446138,
  },
  {
    name: "Tremembé",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3446194,
  },
  {
    name: "Tramandaí",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3446232,
  },
  {
    name: "Torres",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3446295,
  },
  {
    name: "Toledo",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3446370,
  },
  {
    name: "Tobias Barreto",
    country: "Brazil",
    subcountry: "Sergipe",
    geonameid: 3446400,
  },
  {
    name: "Timóteo",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3446445,
  },
  {
    name: "Timbó",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3446465,
  },
  {
    name: "Tijucas",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3446500,
  },
  {
    name: "Tietê",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3446539,
  },
  {
    name: "Teutônia",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3446556,
  },
  {
    name: "Teresópolis",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3446606,
  },
  {
    name: "Teófilo Otoni",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3446621,
  },
  {
    name: "Teodoro Sampaio",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3446625,
  },
  {
    name: "Telêmaco Borba",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3446652,
  },
  {
    name: "Taubaté",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3446682,
  },
  {
    name: "Tatuí",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3446692,
  },
  {
    name: "Taquarituba",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3446752,
  },
  {
    name: "Taquaritinga",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3446753,
  },
  {
    name: "Taquari",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3446783,
  },
  {
    name: "Taquara",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3446847,
  },
  {
    name: "Tapiramutá",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3446866,
  },
  {
    name: "Tapes",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3446880,
  },
  {
    name: "Tanguá",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3446974,
  },
  {
    name: "Tanabi",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3446979,
  },
  {
    name: "Tambaú",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3447005,
  },
  {
    name: "Taiobeiras",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3447059,
  },
  {
    name: "Taboão da Serra",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3447186,
  },
  {
    name: "Suzano",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3447212,
  },
  {
    name: "Sumaré",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3447259,
  },
  {
    name: "Sorocaba",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3447399,
  },
  {
    name: "Soledade",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3447423,
  },
  {
    name: "Socorro",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3447437,
  },
  {
    name: "Sobradinho",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3447473,
  },
  {
    name: "Simão Dias",
    country: "Brazil",
    subcountry: "Sergipe",
    geonameid: 3447562,
  },
  {
    name: "Silva Jardim",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3447591,
  },
  {
    name: "Sidrolândia",
    country: "Brazil",
    subcountry: "Mato Grosso do Sul",
    geonameid: 3447597,
  },
  {
    name: "Sete Lagoas",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3447624,
  },
  {
    name: "Sertãozinho",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3447651,
  },
  {
    name: "Serrinha",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3447690,
  },
  {
    name: "Serra Negra",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3447718,
  },
  {
    name: "Serrana",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3447720,
  },
  {
    name: "Serra",
    country: "Brazil",
    subcountry: "Espírito Santo",
    geonameid: 3447779,
  },
  {
    name: "Seropédica",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3447785,
  },
  {
    name: "Senhor do Bonfim",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3447839,
  },
  {
    name: "Senador Canedo",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3447854,
  },
  {
    name: "Seabra",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3447928,
  },
  {
    name: "Schroeder",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3447929,
  },
  {
    name: "Saubara",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3447961,
  },
  {
    name: "Sarzedo",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3447969,
  },
  {
    name: "Sarandi",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3447997,
  },
  {
    name: "Sarandi",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3447998,
  },
  {
    name: "Saquarema",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3448011,
  },
  {
    name: "Sapucaia",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3448031,
  },
  {
    name: "Sapiranga",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3448063,
  },
  {
    name: "São Vicente",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3448136,
  },
  {
    name: "São Sepé",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3448207,
  },
  {
    name: "São Sebastião do Passé",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3448219,
  },
  {
    name: "São Sebastião do Paraíso",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3448221,
  },
  {
    name: "São Sebastião do Caí",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3448227,
  },
  {
    name: "São Sebastião",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3448257,
  },
  {
    name: "São Roque",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3448300,
  },
  {
    name: "São Pedro da Aldeia",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3448351,
  },
  {
    name: "São Pedro",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3448403,
  },
  {
    name: "São Paulo",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3448439,
  },
  {
    name: "São Miguel do Iguaçu",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3448453,
  },
  {
    name: "São Miguel do Araguaia",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3448455,
  },
  {
    name: "São Mateus do Sul",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3448502,
  },
  {
    name: "São Mateus",
    country: "Brazil",
    subcountry: "Espírito Santo",
    geonameid: 3448519,
  },
  {
    name: "São Marcos",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3448533,
  },
  {
    name: "São Manuel",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3448545,
  },
  {
    name: "São Luiz Gonzaga",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3448552,
  },
  {
    name: "São Luís de Montes Belos",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3448558,
  },
  {
    name: "São Lourenço do Sul",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3448596,
  },
  {
    name: "São Lourenço",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3448616,
  },
  {
    name: "São Leopoldo",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3448622,
  },
  {
    name: "São José dos Pinhais",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3448632,
  },
  {
    name: "São José dos Campos",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3448636,
  },
  {
    name: "São José do Rio Preto",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3448639,
  },
  {
    name: "São José do Rio Pardo",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3448640,
  },
  {
    name: "São José",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3448742,
  },
  {
    name: "São Joaquim da Barra",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3448825,
  },
  {
    name: "São Joaquim",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3448828,
  },
  {
    name: "São João Nepomuceno",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3448846,
  },
  {
    name: "São João de Meriti",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3448877,
  },
  {
    name: "São João del Rei",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3448879,
  },
  {
    name: "São João da Boa Vista",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3448902,
  },
  {
    name: "São João da Barra",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3448903,
  },
  {
    name: "São Jerônimo",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3449045,
  },
  {
    name: "São Gotardo",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3449053,
  },
  {
    name: "São Gonçalo do Sapucaí",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3449056,
  },
  {
    name: "São Gabriel",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3449099,
  },
  {
    name: "São Francisco do Sul",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3449112,
  },
  {
    name: "São Francisco do Conde",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3449116,
  },
  {
    name: "São Francisco",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3449176,
  },
  {
    name: "São Fidélis",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3449195,
  },
  {
    name: "São Cristóvão",
    country: "Brazil",
    subcountry: "Sergipe",
    geonameid: 3449310,
  },
  {
    name: "São Carlos",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3449319,
  },
  {
    name: "São Caetano do Sul",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3449324,
  },
  {
    name: "São Borja",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3449340,
  },
  {
    name: "São Bernardo do Campo",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3449344,
  },
  {
    name: "São Bento do Sul",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3449350,
  },
  {
    name: "Santos Dumont",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3449427,
  },
  {
    name: "Santos",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3449433,
  },
  {
    name: "Santo Estêvão",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3449467,
  },
  {
    name: "Santo Antônio do Monte",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3449500,
  },
  {
    name: "Santo Antônio do Amparo",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3449516,
  },
  {
    name: "Santo Antônio de Posse",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3449518,
  },
  {
    name: "Santo Antônio de Pádua",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3449519,
  },
  {
    name: "Santo Antônio de Jesus",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3449521,
  },
  {
    name: "Santo Antônio da Platina",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3449529,
  },
  {
    name: "Santo Ângelo",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3449696,
  },
  {
    name: "Santo André",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3449701,
  },
  {
    name: "Santo Anastácio",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3449707,
  },
  {
    name: "Santo Amaro da Imperatriz",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3449711,
  },
  {
    name: "Santo Amaro",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3449720,
  },
  {
    name: "Santiago",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3449741,
  },
  {
    name: "Santa Vitória do Palmar",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3449747,
  },
  {
    name: "Santa Rosa de Viterbo",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3449793,
  },
  {
    name: "Santa Rosa",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3449822,
  },
  {
    name: "Santa Rita do Sapucaí",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3449847,
  },
  {
    name: "Santa Rita do Passa Quatro",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3449851,
  },
  {
    name: "Santana do Paraíso",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3449933,
  },
  {
    name: "Santana do Livramento",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3449936,
  },
  {
    name: "Santana de Parnaíba",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3449948,
  },
  {
    name: "Santa Maria da Vitória",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3450063,
  },
  {
    name: "Santa Maria",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3450083,
  },
  {
    name: "Santa Luzia",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3450144,
  },
  {
    name: "Santaluz",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3450157,
  },
  {
    name: "Santa Isabel",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3450188,
  },
  {
    name: "Santa Helena de Goiás",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3450206,
  },
  {
    name: "Santa Gertrudes",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3450225,
  },
  {
    name: "Santa Fé do Sul",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3450232,
  },
  {
    name: "Santa Cruz do Sul",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3450269,
  },
  {
    name: "Santa Cruz do Rio Pardo",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3450272,
  },
  {
    name: "Santa Cruz das Palmeiras",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3450283,
  },
  {
    name: "Santa Cruz Cabrália",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3450288,
  },
  {
    name: "Santa Cecília",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3450376,
  },
  {
    name: "Santa Bárbara d'Oeste",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3450404,
  },
  {
    name: "Salvador",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3450554,
  },
  {
    name: "Salto de Pirapora",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3450563,
  },
  {
    name: "Salto",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3450594,
  },
  {
    name: "Salinas",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3450671,
  },
  {
    name: "Sacramento",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3450759,
  },
  {
    name: "Ruy Barbosa",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3450832,
  },
  {
    name: "Rubiataba",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3450843,
  },
  {
    name: "Rosário do Sul",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3450873,
  },
  {
    name: "Rondonópolis",
    country: "Brazil",
    subcountry: "Mato Grosso",
    geonameid: 3450909,
  },
  {
    name: "Rolante",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3450963,
  },
  {
    name: "Rolândia",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3450964,
  },
  {
    name: "Rio Verde de Mato Grosso",
    country: "Brazil",
    subcountry: "Mato Grosso do Sul",
    geonameid: 3451051,
  },
  {
    name: "Rio Verde",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3451055,
  },
  {
    name: "Rio Real",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3451071,
  },
  {
    name: "Rio Pardo",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3451102,
  },
  {
    name: "Rio Negro",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3451121,
  },
  {
    name: "Rio Negrinho",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3451124,
  },
  {
    name: "Rio Grande da Serra",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3451134,
  },
  {
    name: "Rio Grande",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3451138,
  },
  {
    name: "Rio do Sul",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3451152,
  },
  {
    name: "Rio de Janeiro",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3451190,
  },
  {
    name: "Rio das Pedras",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3451202,
  },
  {
    name: "Rio das Ostras",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3451205,
  },
  {
    name: "Rio Claro",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3451234,
  },
  {
    name: "Rio Brilhante",
    country: "Brazil",
    subcountry: "Mato Grosso do Sul",
    geonameid: 3451241,
  },
  {
    name: "Rio Branco do Sul",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3451242,
  },
  {
    name: "Rio Bonito",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3451261,
  },
  {
    name: "Ribeirão Preto",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3451328,
  },
  {
    name: "Ribeirão Pires",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3451329,
  },
  {
    name: "Ribeirão das Neves",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3451353,
  },
  {
    name: "Ribeirão da Ilha",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3451357,
  },
  {
    name: "Ribeira do Pombal",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3451383,
  },
  {
    name: "Riachão do Jacuípe",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3451474,
  },
  {
    name: "Resplendor",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3451650,
  },
  {
    name: "Resende",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3451668,
  },
  {
    name: "Registro",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3451704,
  },
  {
    name: "Regente Feijó",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3451709,
  },
  {
    name: "Rancharia",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3451856,
  },
  {
    name: "Quirinópolis",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3451931,
  },
  {
    name: "Queimados",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3452073,
  },
  {
    name: "Quatro Barras",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3452141,
  },
  {
    name: "Quaraí",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3452179,
  },
  {
    name: "Prudentópolis",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3452216,
  },
  {
    name: "Propriá",
    country: "Brazil",
    subcountry: "Sergipe",
    geonameid: 3452233,
  },
  {
    name: "Promissão",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3452237,
  },
  {
    name: "Presidente Venceslau",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3452320,
  },
  {
    name: "Presidente Prudente",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3452324,
  },
  {
    name: "Presidente Epitácio",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3452331,
  },
  {
    name: "Prata",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3452440,
  },
  {
    name: "Praia Grande",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3452465,
  },
  {
    name: "Prado",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3452483,
  },
  {
    name: "Pouso Alegre",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3452525,
  },
  {
    name: "Posse",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3452599,
  },
  {
    name: "Porto União",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3452623,
  },
  {
    name: "Porto Seguro",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3452640,
  },
  {
    name: "Porto Ferreira",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3452775,
  },
  {
    name: "Porto Feliz",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3452779,
  },
  {
    name: "Porto Alegre",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3452925,
  },
  {
    name: "Portão",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3452982,
  },
  {
    name: "Porangatu",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3453014,
  },
  {
    name: "Pontes e Lacerda",
    country: "Brazil",
    subcountry: "Mato Grosso",
    geonameid: 3453060,
  },
  {
    name: "Ponte Nova",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3453078,
  },
  {
    name: "Ponta Porã",
    country: "Brazil",
    subcountry: "Mato Grosso do Sul",
    geonameid: 3453150,
  },
  {
    name: "Pontal",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3453171,
  },
  {
    name: "Ponta Grossa",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3453186,
  },
  {
    name: "Pompéu",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3453240,
  },
  {
    name: "Pompéia",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3453242,
  },
  {
    name: "Pomerode",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3453245,
  },
  {
    name: "Poços de Caldas",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3453303,
  },
  {
    name: "Poconé",
    country: "Brazil",
    subcountry: "Mato Grosso",
    geonameid: 3453315,
  },
  {
    name: "Poções",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3453337,
  },
  {
    name: "Poá",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3453406,
  },
  {
    name: "Planaltina",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3453420,
  },
  {
    name: "Piúma",
    country: "Brazil",
    subcountry: "Espírito Santo",
    geonameid: 3453435,
  },
  {
    name: "Piuí",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3453439,
  },
  {
    name: "Pitangui",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3453457,
  },
  {
    name: "Pitangueiras",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3453467,
  },
  {
    name: "Pitanga",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3453478,
  },
  {
    name: "Piritiba",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3453494,
  },
  {
    name: "Pires do Rio",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3453503,
  },
  {
    name: "Piraquara",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3453535,
  },
  {
    name: "Pirapozinho",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3453542,
  },
  {
    name: "Pirapora",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3453546,
  },
  {
    name: "Pirajuí",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3453605,
  },
  {
    name: "Piraju",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3453610,
  },
  {
    name: "Piraí do Sul",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3453622,
  },
  {
    name: "Piraí",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3453635,
  },
  {
    name: "Pirassununga",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3453639,
  },
  {
    name: "Piracicaba",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3453643,
  },
  {
    name: "Piracanjuba",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3453659,
  },
  {
    name: "Piracaia",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3453661,
  },
  {
    name: "Pinheiral",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3453767,
  },
  {
    name: "Pinhão",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3453777,
  },
  {
    name: "Espírito Santo do Pinhal",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3453807,
  },
  {
    name: "Pindobaçu",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3453827,
  },
  {
    name: "Pindamonhangaba",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3453837,
  },
  {
    name: "Pilar do Sul",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3453896,
  },
  {
    name: "Piedade",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3453926,
  },
  {
    name: "Petrópolis",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3454031,
  },
  {
    name: "Peruíbe",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3454061,
  },
  {
    name: "Pereira Barreto",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3454131,
  },
  {
    name: "Perdões",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3454139,
  },
  {
    name: "Penha",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3454213,
  },
  {
    name: "Penedo",
    country: "Brazil",
    subcountry: "Alagoas",
    geonameid: 3454231,
  },
  {
    name: "Penápolis",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3454235,
  },
  {
    name: "Pelotas",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3454244,
  },
  {
    name: "Pedro Leopoldo",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3454358,
  },
  {
    name: "Pedreira",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3454407,
  },
  {
    name: "Pedra Azul",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3454578,
  },
  {
    name: "Pederneiras",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3454620,
  },
  {
    name: "Paulínia",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3454690,
  },
  {
    name: "Patrocínio",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3454763,
  },
  {
    name: "Patos de Minas",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3454783,
  },
  {
    name: "Pato Branco",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3454818,
  },
  {
    name: "Paty do Alferes",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3454827,
  },
  {
    name: "Posto da Mata",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3454839,
  },
  {
    name: "Passos",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3454847,
  },
  {
    name: "Passo Fundo",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3454857,
  },
  {
    name: "Parobé",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3454954,
  },
  {
    name: "Paraty",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3455036,
  },
  {
    name: "Paranavaí",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3455051,
  },
  {
    name: "Paranapanema",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3455061,
  },
  {
    name: "Paranaíba",
    country: "Brazil",
    subcountry: "Mato Grosso do Sul",
    geonameid: 3455065,
  },
  {
    name: "Paranaguá",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3455070,
  },
  {
    name: "Paraíba do Sul",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3455141,
  },
  {
    name: "Paraguaçu Paulista",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3455152,
  },
  {
    name: "Paraguaçu",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3455155,
  },
  {
    name: "Pará de Minas",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3455161,
  },
  {
    name: "Paracatu",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3455168,
  },
  {
    name: "Paracambi",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3455170,
  },
  {
    name: "Panambi",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3455281,
  },
  {
    name: "Palotina",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3455298,
  },
  {
    name: "Palmital",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3455342,
  },
  {
    name: "Palmeira das Missões",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3455416,
  },
  {
    name: "Palmeira",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3455425,
  },
  {
    name: "Palmas",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3455459,
  },
  {
    name: "Palhoça",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3455478,
  },
  {
    name: "Paiçandu",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3455553,
  },
  {
    name: "Padre Bernardo",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3455580,
  },
  {
    name: "Ouro Preto",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3455671,
  },
  {
    name: "Ouro Branco",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3455689,
  },
  {
    name: "Ourinhos",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3455729,
  },
  {
    name: "Osvaldo Cruz",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3455756,
  },
  {
    name: "Osório",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3455769,
  },
  {
    name: "Osasco",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3455775,
  },
  {
    name: "Orleans",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3455784,
  },
  {
    name: "Orlândia",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3455785,
  },
  {
    name: "Oliveira",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3455908,
  },
  {
    name: "Olímpia",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3455923,
  },
  {
    name: "Novo Horizonte",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3456060,
  },
  {
    name: "Novo Hamburgo",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3456068,
  },
  {
    name: "Nova Viçosa",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3456102,
  },
  {
    name: "Nova Venécia",
    country: "Brazil",
    subcountry: "Espírito Santo",
    geonameid: 3456110,
  },
  {
    name: "Nova Prata",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3456125,
  },
  {
    name: "Nova Petrópolis",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3456127,
  },
  {
    name: "Nova Olímpia",
    country: "Brazil",
    subcountry: "Mato Grosso",
    geonameid: 3456137,
  },
  {
    name: "Nova Odessa",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3456138,
  },
  {
    name: "Nova Lima",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3456147,
  },
  {
    name: "Nova Iguaçu",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3456160,
  },
  {
    name: "Nova Granada",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3456164,
  },
  {
    name: "Nova Friburgo",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3456166,
  },
  {
    name: "Nova Era",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3456176,
  },
  {
    name: "Nossa Senhora do Socorro",
    country: "Brazil",
    subcountry: "Sergipe",
    geonameid: 3456223,
  },
  {
    name: "Nossa Senhora da Glória",
    country: "Brazil",
    subcountry: "Sergipe",
    geonameid: 3456240,
  },
  {
    name: "Niterói",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3456283,
  },
  {
    name: "Niquelândia",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3456285,
  },
  {
    name: "Nilópolis",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3456290,
  },
  {
    name: "Nerópolis",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3456322,
  },
  {
    name: "Nepomuceno",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3456324,
  },
  {
    name: "Nazaré",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3456366,
  },
  {
    name: "Naviraí",
    country: "Brazil",
    subcountry: "Mato Grosso do Sul",
    geonameid: 3456368,
  },
  {
    name: "Navegantes",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3456370,
  },
  {
    name: "Nanuque",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3456398,
  },
  {
    name: "Muzambinho",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3456412,
  },
  {
    name: "Muritiba",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3456483,
  },
  {
    name: "Muriaé",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3456500,
  },
  {
    name: "Mucuri",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3456593,
  },
  {
    name: "Morro do Chapéu",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3456696,
  },
  {
    name: "Morro Agudo",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3456724,
  },
  {
    name: "Morrinhos",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3456735,
  },
  {
    name: "Montes Claros",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3456814,
  },
  {
    name: "Monte Santo de Minas",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3456816,
  },
  {
    name: "Montenegro",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3456826,
  },
  {
    name: "Monte Mor",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3456827,
  },
  {
    name: "Monte Carmelo",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3456848,
  },
  {
    name: "Monte Azul Paulista",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3456863,
  },
  {
    name: "Monte Aprazível",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3456866,
  },
  {
    name: "Monte Alto",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3456873,
  },
  {
    name: "Mongaguá",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3456944,
  },
  {
    name: "Mogi Mirim",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3456998,
  },
  {
    name: "Mogi Guaçu",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3457000,
  },
  {
    name: "Mogi das Cruzes",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3457001,
  },
  {
    name: "Mococa",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3457025,
  },
  {
    name: "Mirandopólis",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3457107,
  },
  {
    name: "Miracema",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3457133,
  },
  {
    name: "Miracatu",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3457135,
  },
  {
    name: "Mineiros",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3457147,
  },
  {
    name: "Miguel Pereira",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3457191,
  },
  {
    name: "Miguelópolis",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3457192,
  },
  {
    name: "Mendes",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3457247,
  },
  {
    name: "Medianeira",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3457359,
  },
  {
    name: "Medeiros Neto",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3457360,
  },
  {
    name: "Mauá",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3457381,
  },
  {
    name: "Matozinhos",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3457393,
  },
  {
    name: "Mateus Leme",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3457484,
  },
  {
    name: "Matão",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3457509,
  },
  {
    name: "Mata de São João",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3457528,
  },
  {
    name: "Mascote",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3457566,
  },
  {
    name: "Martinópolis",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3457595,
  },
  {
    name: "Maringá",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3457671,
  },
  {
    name: "Marília",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3457692,
  },
  {
    name: "Maricá",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3457708,
  },
  {
    name: "Mariana",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3457736,
  },
  {
    name: "Marialva",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3457741,
  },
  {
    name: "Marechal Cândido Rondon",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3457772,
  },
  {
    name: "Marau",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3457817,
  },
  {
    name: "Marataizes",
    country: "Brazil",
    subcountry: "Espírito Santo",
    geonameid: 3457819,
  },
  {
    name: "Maragogipe",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3457850,
  },
  {
    name: "Maracás",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3457854,
  },
  {
    name: "Maracaju",
    country: "Brazil",
    subcountry: "Mato Grosso do Sul",
    geonameid: 3457859,
  },
  {
    name: "Manhumirim",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3457950,
  },
  {
    name: "Manhuaçu",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3457952,
  },
  {
    name: "Mangaratiba",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3457991,
  },
  {
    name: "Mandaguari",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3458049,
  },
  {
    name: "Mairiporã",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3458131,
  },
  {
    name: "Mairinque",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3458132,
  },
  {
    name: "Mafra",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3458147,
  },
  {
    name: "Machado",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3458211,
  },
  {
    name: "Macatuba",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3458245,
  },
  {
    name: "Macaé",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3458266,
  },
  {
    name: "Luziânia",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3458329,
  },
  {
    name: "Lucas",
    country: "Brazil",
    subcountry: "Mato Grosso",
    geonameid: 3458397,
  },
  {
    name: "Louveira",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3458406,
  },
  {
    name: "Lorena",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3458425,
  },
  {
    name: "Londrina",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3458449,
  },
  {
    name: "Loanda",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3458479,
  },
  {
    name: "Livramento do Brumado",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3458481,
  },
  {
    name: "Lins",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3458494,
  },
  {
    name: "Linhares",
    country: "Brazil",
    subcountry: "Espírito Santo",
    geonameid: 3458498,
  },
  {
    name: "Limeira",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3458575,
  },
  {
    name: "Leopoldina",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3458632,
  },
  {
    name: "Lençóis Paulista",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3458645,
  },
  {
    name: "Leme",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3458662,
  },
  {
    name: "Lavras",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3458696,
  },
  {
    name: "Laranjeiras do Sul",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3458746,
  },
  {
    name: "Laranjeiras",
    country: "Brazil",
    subcountry: "Sergipe",
    geonameid: 3458778,
  },
  {
    name: "Laranjal Paulista",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3458786,
  },
  {
    name: "Lapa",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3458826,
  },
  {
    name: "Lajinha",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3458902,
  },
  {
    name: "Lages",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3458930,
  },
  {
    name: "Lajeado",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3459035,
  },
  {
    name: "Laguna",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3459094,
  },
  {
    name: "Lagoa Vermelha",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3459126,
  },
  {
    name: "Lagoa Santa",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3459138,
  },
  {
    name: "Lagoa da Prata",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3459251,
  },
  {
    name: "Lagarto",
    country: "Brazil",
    subcountry: "Sergipe",
    geonameid: 3459342,
  },
  {
    name: "Ladário",
    country: "Brazil",
    subcountry: "Mato Grosso do Sul",
    geonameid: 3459352,
  },
  {
    name: "Jundiaí",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3459462,
  },
  {
    name: "Júlio de Castilhos",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3459495,
  },
  {
    name: "Juiz de Fora",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3459505,
  },
  {
    name: "Juatuba",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3459550,
  },
  {
    name: "José Bonifácio",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3459667,
  },
  {
    name: "Joinville",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3459712,
  },
  {
    name: "João Pinheiro",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3459785,
  },
  {
    name: "João Monlevade",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3459796,
  },
  {
    name: "Joaçaba",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3459869,
  },
  {
    name: "Jeremoabo",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3459922,
  },
  {
    name: "Jequitinhonha",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3459925,
  },
  {
    name: "Jequié",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3459943,
  },
  {
    name: "Jaú",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3460005,
  },
  {
    name: "Jataí",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3460064,
  },
  {
    name: "Jarinu",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3460068,
  },
  {
    name: "Jardinópolis",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3460071,
  },
  {
    name: "Jardim",
    country: "Brazil",
    subcountry: "Mato Grosso do Sul",
    geonameid: 3460087,
  },
  {
    name: "Jaraguá do Sul",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3460102,
  },
  {
    name: "Jaraguá",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3460107,
  },
  {
    name: "Japeri",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3460132,
  },
  {
    name: "Januária",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3460148,
  },
  {
    name: "Jandira",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3460170,
  },
  {
    name: "Jandaia do Sul",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3460172,
  },
  {
    name: "Janaúba",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3460174,
  },
  {
    name: "Jales",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3460186,
  },
  {
    name: "Jaguariúna",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3460200,
  },
  {
    name: "Jaguariaíva",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3460214,
  },
  {
    name: "Jaguarari",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3460225,
  },
  {
    name: "Jaguarão",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3460232,
  },
  {
    name: "Jaguaquara",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3460242,
  },
  {
    name: "Jacutinga",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3460267,
  },
  {
    name: "Jacobina",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3460344,
  },
  {
    name: "Jaciara",
    country: "Brazil",
    subcountry: "Mato Grosso",
    geonameid: 3460355,
  },
  {
    name: "Jacarezinho",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3460362,
  },
  {
    name: "Jacareí",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3460370,
  },
  {
    name: "Jaboticabal",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3460441,
  },
  {
    name: "Ivoti",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3460484,
  },
  {
    name: "Ituverava",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3460511,
  },
  {
    name: "Iturama",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3460513,
  },
  {
    name: "Itupeva",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3460516,
  },
  {
    name: "Itumbiara",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3460522,
  },
  {
    name: "Ituiutaba",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3460523,
  },
  {
    name: "Ituberá",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3460530,
  },
  {
    name: "Itu",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3460535,
  },
  {
    name: "Itororó",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3460542,
  },
  {
    name: "Itaúna",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3460584,
  },
  {
    name: "Itatinga",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3460594,
  },
  {
    name: "Itatiba",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3460598,
  },
  {
    name: "Itararé",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3460620,
  },
  {
    name: "Itaqui",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3460629,
  },
  {
    name: "Itaquaquecetuba",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3460644,
  },
  {
    name: "Itapuranga",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3460648,
  },
  {
    name: "Itápolis",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3460671,
  },
  {
    name: "Itapira",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3460699,
  },
  {
    name: "Itapevi",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3460718,
  },
  {
    name: "Itapeva",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3460723,
  },
  {
    name: "Itapetininga",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3460728,
  },
  {
    name: "Itapetinga",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3460730,
  },
  {
    name: "Itaperuna",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3460733,
  },
  {
    name: "Itaperuçu",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3460734,
  },
  {
    name: "Itapemirim",
    country: "Brazil",
    subcountry: "Espírito Santo",
    geonameid: 3460738,
  },
  {
    name: "Itapema",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3460740,
  },
  {
    name: "Itapecerica da Serra",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3460748,
  },
  {
    name: "Itapecerica",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3460752,
  },
  {
    name: "Itaparica",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3460764,
  },
  {
    name: "Itapaci",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3460773,
  },
  {
    name: "Itaocara",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3460774,
  },
  {
    name: "Itanhaém",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3460791,
  },
  {
    name: "Itambé",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3460813,
  },
  {
    name: "Itamarandiba",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3460825,
  },
  {
    name: "Itamaraju",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3460826,
  },
  {
    name: "Itajuípe",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3460831,
  },
  {
    name: "Itajubá",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3460834,
  },
  {
    name: "Itajaí",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3460845,
  },
  {
    name: "Itaí",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3460887,
  },
  {
    name: "Itaguaí",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3460899,
  },
  {
    name: "Itabuna",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3460949,
  },
  {
    name: "Itaboraí",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3460950,
  },
  {
    name: "Itabirito",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3460954,
  },
  {
    name: "Itabira",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3460960,
  },
  {
    name: "Itaberaí",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3460963,
  },
  {
    name: "Itaberaba",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3460966,
  },
  {
    name: "Itabaianinha",
    country: "Brazil",
    subcountry: "Sergipe",
    geonameid: 3460971,
  },
  {
    name: "Itabaiana",
    country: "Brazil",
    subcountry: "Sergipe",
    geonameid: 3460974,
  },
  {
    name: "Irecê",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3461013,
  },
  {
    name: "Irati",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3461017,
  },
  {
    name: "Iracemápolis",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3461055,
  },
  {
    name: "Iporá",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3461090,
  },
  {
    name: "Ipirá",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3461124,
  },
  {
    name: "Ipiaú",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3461129,
  },
  {
    name: "Iperó",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3461134,
  },
  {
    name: "Ipatinga",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3461144,
  },
  {
    name: "Ipameri",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3461151,
  },
  {
    name: "Ipaba",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3461153,
  },
  {
    name: "Inhumas",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3461194,
  },
  {
    name: "Indaiatuba",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3461311,
  },
  {
    name: "Indaial",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3461316,
  },
  {
    name: "Imbituva",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3461368,
  },
  {
    name: "Imbituba",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3461370,
  },
  {
    name: "Ilhéus",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3461408,
  },
  {
    name: "Ilha Solteira",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3461411,
  },
  {
    name: "Ilhabela",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3461425,
  },
  {
    name: "Ijuí",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3461444,
  },
  {
    name: "Iguape",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3461465,
  },
  {
    name: "Igrejinha",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3461481,
  },
  {
    name: "Igarapé",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3461498,
  },
  {
    name: "Igarapava",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3461499,
  },
  {
    name: "Igaraçu do Tietê",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3461501,
  },
  {
    name: "Içara",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3461519,
  },
  {
    name: "Ibotirama",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3461525,
  },
  {
    name: "Ibiúna",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3461528,
  },
  {
    name: "Ibitinga",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3461550,
  },
  {
    name: "Ibirité",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3461563,
  },
  {
    name: "Ibirataia",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3461565,
  },
  {
    name: "Ibirama",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3461576,
  },
  {
    name: "Ibiporã",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3461588,
  },
  {
    name: "Ibicaraí",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3461606,
  },
  {
    name: "Ibiá",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3461620,
  },
  {
    name: "Ibaté",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3461625,
  },
  {
    name: "Ibaiti",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3461628,
  },
  {
    name: "Iaçu",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3461638,
  },
  {
    name: "Hortolândia",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3461655,
  },
  {
    name: "Herval",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3461680,
  },
  {
    name: "Gurupi",
    country: "Brazil",
    subcountry: "Tocantins",
    geonameid: 3461724,
  },
  {
    name: "Guaxupé",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3461763,
  },
  {
    name: "Guarulhos",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3461786,
  },
  {
    name: "Guarujá",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3461789,
  },
  {
    name: "Guariba",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3461824,
  },
  {
    name: "Guaratuba",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3461857,
  },
  {
    name: "Guaratinguetá",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3461859,
  },
  {
    name: "Guararema",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3461871,
  },
  {
    name: "Guararapes",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3461874,
  },
  {
    name: "Guarapuava",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3461879,
  },
  {
    name: "Guarapari",
    country: "Brazil",
    subcountry: "Espírito Santo",
    geonameid: 3461888,
  },
  {
    name: "Guaranésia",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3461910,
  },
  {
    name: "Guaramirim",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3461914,
  },
  {
    name: "Guará",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3461935,
  },
  {
    name: "Guaporé",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3461941,
  },
  {
    name: "Guapimirim",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3461949,
  },
  {
    name: "Guanhães",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3461958,
  },
  {
    name: "Guanambi",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3461973,
  },
  {
    name: "Guaíra",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3461995,
  },
  {
    name: "Guaçuí",
    country: "Brazil",
    subcountry: "Espírito Santo",
    geonameid: 3462022,
  },
  {
    name: "Gravataí",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3462089,
  },
  {
    name: "Governador Valadares",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3462315,
  },
  {
    name: "Goiatuba",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3462371,
  },
  {
    name: "Goiás",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3462374,
  },
  {
    name: "Goianira",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3462376,
  },
  {
    name: "Goiânia",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3462377,
  },
  {
    name: "Goianésia",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3462378,
  },
  {
    name: "Gaspar",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3462535,
  },
  {
    name: "Garibaldi",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3462557,
  },
  {
    name: "Garça",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3462580,
  },
  {
    name: "Gandu",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3462601,
  },
  {
    name: "Frutal",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3462916,
  },
  {
    name: "Frederico Westphalen",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3462956,
  },
  {
    name: "Franco da Rocha",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3462964,
  },
  {
    name: "Francisco Morato",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3462980,
  },
  {
    name: "Francisco Beltrão",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3462996,
  },
  {
    name: "Franca",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3463011,
  },
  {
    name: "Foz do Iguaçu",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3463030,
  },
  {
    name: "Forquilhinha",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3463066,
  },
  {
    name: "Formosa",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3463140,
  },
  {
    name: "Formiga",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3463174,
  },
  {
    name: "Florianópolis",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3463237,
  },
  {
    name: "Flores da Cunha",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3463271,
  },
  {
    name: "Ferraz de Vasconcelos",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3463422,
  },
  {
    name: "Fernandópolis",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3463432,
  },
  {
    name: "Feira de Santana",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3463478,
  },
  {
    name: "Farroupilha",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3463605,
  },
  {
    name: "Eunápolis",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3463690,
  },
  {
    name: "Euclides da Cunha",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3463698,
  },
  {
    name: "Estrela",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3463762,
  },
  {
    name: "Esteio",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3463859,
  },
  {
    name: "Estância Velha",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3463865,
  },
  {
    name: "Estância",
    country: "Brazil",
    subcountry: "Sergipe",
    geonameid: 3463900,
  },
  {
    name: "Esplanada",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3463920,
  },
  {
    name: "Espinosa",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3463939,
  },
  {
    name: "Esmeraldas",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3464008,
  },
  {
    name: "Erechim",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3464073,
  },
  {
    name: "Entre Rios",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3464100,
  },
  {
    name: "Encruzilhada do Sul",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3464255,
  },
  {
    name: "Encantado",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3464274,
  },
  {
    name: "Embu Guaçu",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3464304,
  },
  {
    name: "Embu",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3464305,
  },
  {
    name: "Elói Mendes",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3464329,
  },
  {
    name: "Duque de Caxias",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3464374,
  },
  {
    name: "Dourados",
    country: "Brazil",
    subcountry: "Mato Grosso do Sul",
    geonameid: 3464460,
  },
  {
    name: "Dom Pedrito",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3464547,
  },
  {
    name: "Dois Vizinhos",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3464579,
  },
  {
    name: "Dois Córregos",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3464618,
  },
  {
    name: "Divinópolis",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3464688,
  },
  {
    name: "Diamantino",
    country: "Brazil",
    subcountry: "Mato Grosso",
    geonameid: 3464724,
  },
  {
    name: "Diamantina",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3464728,
  },
  {
    name: "Diadema",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3464739,
  },
  {
    name: "Descalvado",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3464809,
  },
  {
    name: "Curvelo",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3464891,
  },
  {
    name: "Curitibanos",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3464974,
  },
  {
    name: "Curitiba",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3464975,
  },
  {
    name: "Cuiabá",
    country: "Brazil",
    subcountry: "Mato Grosso",
    geonameid: 3465038,
  },
  {
    name: "Cubatão",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3465059,
  },
  {
    name: "Cruzeiro do Oeste",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3465083,
  },
  {
    name: "Cruzeiro",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3465090,
  },
  {
    name: "Cruz das Almas",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3465105,
  },
  {
    name: "Cruz Alta",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3465108,
  },
  {
    name: "Cristalina",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3465164,
  },
  {
    name: "Criciúma",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3465196,
  },
  {
    name: "Cravinhos",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3465209,
  },
  {
    name: "Coxim",
    country: "Brazil",
    subcountry: "Mato Grosso do Sul",
    geonameid: 3465228,
  },
  {
    name: "Cotia",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3465284,
  },
  {
    name: "Cosmópolis",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3465320,
  },
  {
    name: "Coruripe",
    country: "Brazil",
    subcountry: "Alagoas",
    geonameid: 3465329,
  },
  {
    name: "Corumbá",
    country: "Brazil",
    subcountry: "Mato Grosso do Sul",
    geonameid: 3465342,
  },
  {
    name: "Coronel Vivida",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3465459,
  },
  {
    name: "Coronel Fabriciano",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3465476,
  },
  {
    name: "Coromandel",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3465487,
  },
  {
    name: "Cornélio Procópio",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3465508,
  },
  {
    name: "Corinto",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3465512,
  },
  {
    name: "Cordeirópolis",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3465524,
  },
  {
    name: "Cordeiro",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3465527,
  },
  {
    name: "Contagem",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3465624,
  },
  {
    name: "Conselheiro Lafaiete",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3465644,
  },
  {
    name: "Congonhas",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3465671,
  },
  {
    name: "Conde",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3465713,
  },
  {
    name: "Concórdia",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3465721,
  },
  {
    name: "Conchal",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3465731,
  },
  {
    name: "Conceição do Coité",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3465748,
  },
  {
    name: "Conceição do Jacuípe",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3465758,
  },
  {
    name: "Conceição das Alagoas",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3465764,
  },
  {
    name: "Conceição da Feira",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3465767,
  },
  {
    name: "Conceição da Barra",
    country: "Brazil",
    subcountry: "Espírito Santo",
    geonameid: 3465769,
  },
  {
    name: "Colorado",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3465881,
  },
  {
    name: "Colombo",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3465927,
  },
  {
    name: "Colatina",
    country: "Brazil",
    subcountry: "Espírito Santo",
    geonameid: 3465944,
  },
  {
    name: "Coaraci",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3466041,
  },
  {
    name: "Cláudio",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3466062,
  },
  {
    name: "Cícero Dantas",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3466171,
  },
  {
    name: "Cianorte",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3466174,
  },
  {
    name: "Nova Xavantina",
    country: "Brazil",
    subcountry: "Mato Grosso",
    geonameid: 3466255,
  },
  {
    name: "Charqueadas",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3466261,
  },
  {
    name: "Chapecó",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3466296,
  },
  {
    name: "Cerquilho",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3466429,
  },
  {
    name: "Ceres",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3466436,
  },
  {
    name: "Celso Ramos",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3466481,
  },
  {
    name: "Caxias do Sul",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3466537,
  },
  {
    name: "Caxambu",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3466547,
  },
  {
    name: "Catu",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3466641,
  },
  {
    name: "Catanduva",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3466692,
  },
  {
    name: "Catalão",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3466696,
  },
  {
    name: "Cataguases",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3466698,
  },
  {
    name: "Castro",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3466704,
  },
  {
    name: "Castelo",
    country: "Brazil",
    subcountry: "Espírito Santo",
    geonameid: 3466723,
  },
  {
    name: "Cassilândia",
    country: "Brazil",
    subcountry: "Mato Grosso do Sul",
    geonameid: 3466750,
  },
  {
    name: "Casimiro de Abreu",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3466763,
  },
  {
    name: "Cascavel",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3466779,
  },
  {
    name: "Casa Branca",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3466824,
  },
  {
    name: "Carmo do Paranaíba",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3466902,
  },
  {
    name: "Carmo do Cajuru",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3466903,
  },
  {
    name: "Carlos Barbosa",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3466933,
  },
  {
    name: "Carazinho",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3466978,
  },
  {
    name: "Caratinga",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3466988,
  },
  {
    name: "Carapicuíba",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3466998,
  },
  {
    name: "Carangola",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3467012,
  },
  {
    name: "Carandaí",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3467026,
  },
  {
    name: "Caraguatatuba",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3467081,
  },
  {
    name: "Capivari",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3467197,
  },
  {
    name: "Capinzal",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3467261,
  },
  {
    name: "Capim Grosso",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3467272,
  },
  {
    name: "Capelinha",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3467305,
  },
  {
    name: "Capela",
    country: "Brazil",
    subcountry: "Sergipe",
    geonameid: 3467319,
  },
  {
    name: "Capão da Canoa",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3467362,
  },
  {
    name: "Capâo Bonito",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3467371,
  },
  {
    name: "Canoinhas",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3467452,
  },
  {
    name: "Canoas",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3467467,
  },
  {
    name: "Canguçu",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3467512,
  },
  {
    name: "Canela",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3467530,
  },
  {
    name: "Cândido Mota",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3467542,
  },
  {
    name: "Candelária",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3467550,
  },
  {
    name: "Canavieiras",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3467577,
  },
  {
    name: "Campo Verde",
    country: "Brazil",
    subcountry: "Mato Grosso do Sul",
    geonameid: 3467673,
  },
  {
    name: "Campos Novos",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3467677,
  },
  {
    name: "Campos Gerais",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3467680,
  },
  {
    name: "Campos do Jordão",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3467684,
  },
  {
    name: "Campos Belos",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3467687,
  },
  {
    name: "Campos dos Goytacazes",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3467693,
  },
  {
    name: "Campo Mourão",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3467717,
  },
  {
    name: "Campo Largo",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3467736,
  },
  {
    name: "Campo Grande",
    country: "Brazil",
    subcountry: "Mato Grosso do Sul",
    geonameid: 3467747,
  },
  {
    name: "Campo Formoso",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3467760,
  },
  {
    name: "Campo Belo",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3467796,
  },
  {
    name: "Campinas",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3467865,
  },
  {
    name: "Campina Grande do Sul",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3467877,
  },
  {
    name: "Cambuí",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3467956,
  },
  {
    name: "Cambé",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3467978,
  },
  {
    name: "Cambará",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3467985,
  },
  {
    name: "Amaral Ferrador",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3468014,
  },
  {
    name: "Camanducaia",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3468023,
  },
  {
    name: "Camaçari",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3468031,
  },
  {
    name: "Caldas Novas",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3468100,
  },
  {
    name: "Cajuru",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3468121,
  },
  {
    name: "Cajati",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3468157,
  },
  {
    name: "Cajamar",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3468158,
  },
  {
    name: "Caieiras",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3468215,
  },
  {
    name: "Caetité",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3468317,
  },
  {
    name: "Caeté",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3468327,
  },
  {
    name: "Cachoeiro de Itapemirim",
    country: "Brazil",
    subcountry: "Espírito Santo",
    geonameid: 3468376,
  },
  {
    name: "Cachoeirinha",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3468403,
  },
  {
    name: "Cachoeiras de Macacu",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3468425,
  },
  {
    name: "Cachoeira do Sul",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3468436,
  },
  {
    name: "Cachoeira",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3468535,
  },
  {
    name: "Caçapava do Sul",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3468560,
  },
  {
    name: "Caçapava",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3468562,
  },
  {
    name: "Caçador",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3468570,
  },
  {
    name: "Cabreúva",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3468592,
  },
  {
    name: "Cabo Frio",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3468615,
  },
  {
    name: "Butiá",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3468704,
  },
  {
    name: "Buritizeiro",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3468720,
  },
  {
    name: "Buritis",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3468732,
  },
  {
    name: "Buri",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3468802,
  },
  {
    name: "Buerarema",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3468858,
  },
  {
    name: "Brusque",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3468879,
  },
  {
    name: "Brumado",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3468893,
  },
  {
    name: "Brumadinho",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3468894,
  },
  {
    name: "Brotas",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3468899,
  },
  {
    name: "Brodósqui",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3468902,
  },
  {
    name: "Brasília",
    country: "Brazil",
    subcountry: "Federal District",
    geonameid: 3469058,
  },
  {
    name: "Bragança Paulista",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3469092,
  },
  {
    name: "Braço do Norte",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3469115,
  },
  {
    name: "Botucatu",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3469136,
  },
  {
    name: "Bom Jesus do Itabapoana",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3469425,
  },
  {
    name: "Bom Jesus da Lapa",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3469437,
  },
  {
    name: "Bom Despacho",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3469516,
  },
  {
    name: "Boituva",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3469540,
  },
  {
    name: "Bocaiúva",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3469601,
  },
  {
    name: "Boa Esperança",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3469932,
  },
  {
    name: "Blumenau",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3469968,
  },
  {
    name: "Biritiba Mirim",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3469984,
  },
  {
    name: "Birigui",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3469989,
  },
  {
    name: "Biguaçu",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3470003,
  },
  {
    name: "Betim",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3470044,
  },
  {
    name: "Bertioga",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3470052,
  },
  {
    name: "Bento Gonçalves",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3470073,
  },
  {
    name: "Belo Oriente",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3470117,
  },
  {
    name: "Belo Horizonte",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3470127,
  },
  {
    name: "Belford Roxo",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3470142,
  },
  {
    name: "Bela Vista",
    country: "Brazil",
    subcountry: "Mato Grosso do Sul",
    geonameid: 3470177,
  },
  {
    name: "Bebedouro",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3470264,
  },
  {
    name: "Bauru",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3470279,
  },
  {
    name: "Batatais",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3470324,
  },
  {
    name: "Bastos",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3470341,
  },
  {
    name: "Barueri",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3470353,
  },
  {
    name: "Barroso",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3470369,
  },
  {
    name: "Barrinha",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3470428,
  },
  {
    name: "Barretos",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3470451,
  },
  {
    name: "Barreiro do Jaíba",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3470470,
  },
  {
    name: "Barreiras",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3470583,
  },
  {
    name: "Barra Velha",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3470597,
  },
  {
    name: "Barra Mansa",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3470636,
  },
  {
    name: "Barra dos Coqueiros",
    country: "Brazil",
    subcountry: "Sergipe",
    geonameid: 3470674,
  },
  {
    name: "Barra do Piraí",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3470691,
  },
  {
    name: "Barra do Garças",
    country: "Brazil",
    subcountry: "Mato Grosso",
    geonameid: 3470709,
  },
  {
    name: "Barra do Bugres",
    country: "Brazil",
    subcountry: "Mato Grosso",
    geonameid: 3470718,
  },
  {
    name: "Barra de São Francisco",
    country: "Brazil",
    subcountry: "Espírito Santo",
    geonameid: 3470730,
  },
  {
    name: "Barra Bonita",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3470776,
  },
  {
    name: "Barra",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3470821,
  },
  {
    name: "Bariri",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3470825,
  },
  {
    name: "Barbacena",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3470858,
  },
  {
    name: "Barão de Cocais",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3470878,
  },
  {
    name: "Bandeirantes",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3470912,
  },
  {
    name: "Bambuí",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3471005,
  },
  {
    name: "Balneário Camboriú",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3471039,
  },
  {
    name: "Baixo Guandu",
    country: "Brazil",
    subcountry: "Espírito Santo",
    geonameid: 3471061,
  },
  {
    name: "Bagé",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3471196,
  },
  {
    name: "Avaré",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3471291,
  },
  {
    name: "Atibaia",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3471335,
  },
  {
    name: "Astorga",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3471368,
  },
  {
    name: "Assis",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3471374,
  },
  {
    name: "Arujá",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3471393,
  },
  {
    name: "Artur Nogueira",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3471395,
  },
  {
    name: "Arroio Grande",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3471422,
  },
  {
    name: "Arroio do Meio",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3471428,
  },
  {
    name: "Arraial do Cabo",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3471451,
  },
  {
    name: "Armação de Búzios",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3471487,
  },
  {
    name: "Arcos",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3471683,
  },
  {
    name: "Araxá",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3471691,
  },
  {
    name: "Araucária",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3471697,
  },
  {
    name: "Araruama",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3471715,
  },
  {
    name: "Araras",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3471758,
  },
  {
    name: "Araraquara",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3471766,
  },
  {
    name: "Araranguá",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 3471772,
  },
  {
    name: "Arapongas",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3471798,
  },
  {
    name: "Araguari",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3471830,
  },
  {
    name: "Aragarças",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3471840,
  },
  {
    name: "Araçuaí",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3471846,
  },
  {
    name: "Aracruz",
    country: "Brazil",
    subcountry: "Espírito Santo",
    geonameid: 3471848,
  },
  {
    name: "Araçoiaba da Serra",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3471849,
  },
  {
    name: "Araci",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3471854,
  },
  {
    name: "Araçatuba",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3471859,
  },
  {
    name: "Aracaju",
    country: "Brazil",
    subcountry: "Sergipe",
    geonameid: 3471872,
  },
  {
    name: "Aquidauana",
    country: "Brazil",
    subcountry: "Mato Grosso do Sul",
    geonameid: 3471896,
  },
  {
    name: "Apucarana",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3471910,
  },
  {
    name: "Apiaí",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3471927,
  },
  {
    name: "Aparecida do Taboado",
    country: "Brazil",
    subcountry: "Mato Grosso do Sul",
    geonameid: 3471940,
  },
  {
    name: "Aparecida",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3471949,
  },
  {
    name: "Antonina",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3472048,
  },
  {
    name: "Anicuns",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3472138,
  },
  {
    name: "Angra dos Reis",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 3472177,
  },
  {
    name: "Andradina",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3472248,
  },
  {
    name: "Andradas",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3472254,
  },
  {
    name: "Anastácio",
    country: "Brazil",
    subcountry: "Mato Grosso do Sul",
    geonameid: 3472284,
  },
  {
    name: "Anápolis",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 3472287,
  },
  {
    name: "Amparo",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3472311,
  },
  {
    name: "Américo Brasiliense",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3472338,
  },
  {
    name: "Americana",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3472343,
  },
  {
    name: "Amargosa",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3472370,
  },
  {
    name: "Álvares Machado",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3472417,
  },
  {
    name: "Almirante Tamandaré",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 3472518,
  },
  {
    name: "Almenara",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3472520,
  },
  {
    name: "Alfenas",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3472603,
  },
  {
    name: "Além Paraíba",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3472609,
  },
  {
    name: "Alegrete",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3472638,
  },
  {
    name: "Alegre",
    country: "Brazil",
    subcountry: "Espírito Santo",
    geonameid: 3472666,
  },
  {
    name: "Alagoinhas",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 3472766,
  },
  {
    name: "Aimorés",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3472808,
  },
  {
    name: "Agudos",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3472825,
  },
  {
    name: "Águas Vermelhas",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3472848,
  },
  {
    name: "Águas de Lindóia",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3472869,
  },
  {
    name: "Aguaí",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3472969,
  },
  {
    name: "Adamantina",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 3473157,
  },
  {
    name: "Abaeté",
    country: "Brazil",
    subcountry: "Minas Gerais",
    geonameid: 3473267,
  },
  {
    name: "Guaíba",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 3473964,
  },
  {
    name: "Palmas",
    country: "Brazil",
    subcountry: "Tocantins",
    geonameid: 3474574,
  },
  {
    name: "Tefé",
    country: "Brazil",
    subcountry: "Amazonas",
    geonameid: 3661944,
  },
  {
    name: "Tarauacá",
    country: "Brazil",
    subcountry: "Acre",
    geonameid: 3661980,
  },
  {
    name: "Tabatinga",
    country: "Brazil",
    subcountry: "Amazonas",
    geonameid: 3662075,
  },
  {
    name: "Sena Madureira",
    country: "Brazil",
    subcountry: "Acre",
    geonameid: 3662155,
  },
  {
    name: "São Gabriel da Cachoeira",
    country: "Brazil",
    subcountry: "Amazonas",
    geonameid: 3662342,
  },
  {
    name: "Rio Branco",
    country: "Brazil",
    subcountry: "Acre",
    geonameid: 3662574,
  },
  {
    name: "Porto Velho",
    country: "Brazil",
    subcountry: "Rondônia",
    geonameid: 3662762,
  },
  {
    name: "Manaus",
    country: "Brazil",
    subcountry: "Amazonas",
    geonameid: 3663517,
  },
  {
    name: "Manacapuru",
    country: "Brazil",
    subcountry: "Amazonas",
    geonameid: 3663529,
  },
  {
    name: "Humaitá",
    country: "Brazil",
    subcountry: "Amazonas",
    geonameid: 3664078,
  },
  {
    name: "Fonte Boa",
    country: "Brazil",
    subcountry: "Amazonas",
    geonameid: 3664207,
  },
  {
    name: "Eirunepé",
    country: "Brazil",
    subcountry: "Amazonas",
    geonameid: 3664321,
  },
  {
    name: "Cruzeiro do Sul",
    country: "Brazil",
    subcountry: "Acre",
    geonameid: 3664464,
  },
  {
    name: "Coari",
    country: "Brazil",
    subcountry: "Amazonas",
    geonameid: 3664539,
  },
  {
    name: "Carauari",
    country: "Brazil",
    subcountry: "Amazonas",
    geonameid: 3664659,
  },
  {
    name: "Boa Vista",
    country: "Brazil",
    subcountry: "Roraima",
    geonameid: 3664980,
  },
  {
    name: "Ariquemes",
    country: "Brazil",
    subcountry: "Rondônia",
    geonameid: 3665199,
  },
  {
    name: "Aripuanã",
    country: "Brazil",
    subcountry: "Mato Grosso",
    geonameid: 3665202,
  },
  {
    name: "Vilhena",
    country: "Brazil",
    subcountry: "Rondônia",
    geonameid: 3924679,
  },
  {
    name: "Senador Guiomard",
    country: "Brazil",
    subcountry: "Acre",
    geonameid: 3924752,
  },
  {
    name: "Pôsto Fiscal Rolim de Moura",
    country: "Brazil",
    subcountry: "Rondônia",
    geonameid: 3924877,
  },
  {
    name: "Pimenta Bueno",
    country: "Brazil",
    subcountry: "Rondônia",
    geonameid: 3924908,
  },
  {
    name: "Ouro Preto do Oeste",
    country: "Brazil",
    subcountry: "Rondônia",
    geonameid: 3924948,
  },
  {
    name: "Ji Paraná",
    country: "Brazil",
    subcountry: "Rondônia",
    geonameid: 3925033,
  },
  {
    name: "Jaru",
    country: "Brazil",
    subcountry: "Rondônia",
    geonameid: 3925040,
  },
  {
    name: "Guajará Mirim",
    country: "Brazil",
    subcountry: "Rondônia",
    geonameid: 3925075,
  },
  {
    name: "Cacoal",
    country: "Brazil",
    subcountry: "Rondônia",
    geonameid: 3925212,
  },
  {
    name: "Aparecida de Goiânia",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 6316406,
  },
  {
    name: "Campinas",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 6316729,
  },
  {
    name: "Jaboatão dos Guararapes",
    country: "Brazil",
    subcountry: "Pernambuco",
    geonameid: 6317344,
  },
  {
    name: "Lauro de Freitas",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 6317464,
  },
  {
    name: "Minaçu",
    country: "Brazil",
    subcountry: "Goiás",
    geonameid: 6317592,
  },
  {
    name: "Ourilândia do Norte",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 6317824,
  },
  {
    name: "Parauapebas",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 6317872,
  },
  {
    name: "Pinhais",
    country: "Brazil",
    subcountry: "Paraná",
    geonameid: 6317953,
  },
  {
    name: "Redenção",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 6318107,
  },
  {
    name: "Rio Preto da Eva",
    country: "Brazil",
    subcountry: "Amazonas",
    geonameid: 6318165,
  },
  {
    name: "Simões Filho",
    country: "Brazil",
    subcountry: "Bahia",
    geonameid: 6318694,
  },
  {
    name: "Sinop",
    country: "Brazil",
    subcountry: "Mato Grosso",
    geonameid: 6318696,
  },
  {
    name: "Tucumã",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 6318807,
  },
  {
    name: "Xinguara",
    country: "Brazil",
    subcountry: "Pará",
    geonameid: 6318968,
  },
  {
    name: "Cambebba",
    country: "Brazil",
    subcountry: "Ceará",
    geonameid: 6693804,
  },
  {
    name: "Jardim Paulista",
    country: "Brazil",
    subcountry: "São Paulo",
    geonameid: 7615262,
  },
  {
    name: "Trindade",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 7874479,
  },
  {
    name: "Freguesia do Ribeirao da Ilha",
    country: "Brazil",
    subcountry: "Santa Catarina",
    geonameid: 7874492,
  },
  {
    name: "Planaltina",
    country: "Brazil",
    subcountry: "Federal District",
    geonameid: 11184422,
  },
  {
    name: "São Pedro",
    country: "Brazil",
    subcountry: "Rio de Janeiro",
    geonameid: 11980142,
  },
  {
    name: "Alvorada",
    country: "Brazil",
    subcountry: "Rio Grande do Sul",
    geonameid: 12199880,
  },
  {
    name: "Nassau",
    country: "Bahamas",
    subcountry: "New Providence",
    geonameid: 3571824,
  },
  {
    name: "Lucaya",
    country: "Bahamas",
    subcountry: "Freeport",
    geonameid: 3571971,
  },
  {
    name: "Freeport",
    country: "Bahamas",
    subcountry: "Freeport",
    geonameid: 3572375,
  },
  {
    name: "Thimphu",
    country: "Bhutan",
    subcountry: "Thimphu District",
    geonameid: 1252416,
  },
  {
    name: "Punākha",
    country: "Bhutan",
    subcountry: "Punakha",
    geonameid: 1252479,
  },
  {
    name: "Phuntsholing",
    country: "Bhutan",
    subcountry: "Chukha",
    geonameid: 1252484,
  },
  {
    name: "Tsirang",
    country: "Bhutan",
    subcountry: "Tsirang District",
    geonameid: 1252608,
  },
  {
    name: "Tonota",
    country: "Botswana",
    subcountry: "Central",
    geonameid: 933000,
  },
  {
    name: "Thamaga",
    country: "Botswana",
    subcountry: "Kweneng",
    geonameid: 933018,
  },
  {
    name: "Serowe",
    country: "Botswana",
    subcountry: "Central",
    geonameid: 933088,
  },
  {
    name: "Selebi-Phikwe",
    country: "Botswana",
    subcountry: "Selibe Phikwe",
    geonameid: 933099,
  },
  {
    name: "Ramotswa",
    country: "Botswana",
    subcountry: "South-East",
    geonameid: 933141,
  },
  {
    name: "Palapye",
    country: "Botswana",
    subcountry: "Central",
    geonameid: 933182,
  },
  {
    name: "Mosopa",
    country: "Botswana",
    subcountry: "Ngwaketsi",
    geonameid: 933271,
  },
  {
    name: "Molepolole",
    country: "Botswana",
    subcountry: "Kweneng",
    geonameid: 933305,
  },
  {
    name: "Mogoditshane",
    country: "Botswana",
    subcountry: "Kweneng",
    geonameid: 933331,
  },
  {
    name: "Mochudi",
    country: "Botswana",
    subcountry: "Kgatleng",
    geonameid: 933340,
  },
  {
    name: "Maun",
    country: "Botswana",
    subcountry: "North-West",
    geonameid: 933366,
  },
  {
    name: "Mahalapye",
    country: "Botswana",
    subcountry: "Central",
    geonameid: 933471,
  },
  {
    name: "Lobatse",
    country: "Botswana",
    subcountry: "Lobatse",
    geonameid: 933521,
  },
  {
    name: "Letlhakane",
    country: "Botswana",
    subcountry: "Central",
    geonameid: 933535,
  },
  {
    name: "Kanye",
    country: "Botswana",
    subcountry: "Ngwaketsi",
    geonameid: 933685,
  },
  {
    name: "Janeng",
    country: "Botswana",
    subcountry: "South-East",
    geonameid: 933719,
  },
  {
    name: "Gaborone",
    country: "Botswana",
    subcountry: "Gaborone",
    geonameid: 933773,
  },
  {
    name: "Francistown",
    country: "Botswana",
    subcountry: "City of Francistown",
    geonameid: 933778,
  },
  {
    name: "Horad Zhodzina",
    country: "Belarus",
    subcountry: "Minsk",
    geonameid: 618800,
  },
  {
    name: "Zhlobin",
    country: "Belarus",
    subcountry: "Gomel Oblast",
    geonameid: 618806,
  },
  {
    name: "Vitebsk",
    country: "Belarus",
    subcountry: "Vitebsk",
    geonameid: 620127,
  },
  {
    name: "Vilyeyka",
    country: "Belarus",
    subcountry: "Minsk",
    geonameid: 620181,
  },
  {
    name: "Volkovysk",
    country: "Belarus",
    subcountry: "Grodnenskaya",
    geonameid: 620391,
  },
  {
    name: "Svyetlahorsk",
    country: "Belarus",
    subcountry: "Gomel Oblast",
    geonameid: 621074,
  },
  {
    name: "Stowbtsy",
    country: "Belarus",
    subcountry: "Minsk",
    geonameid: 621266,
  },
  {
    name: "Smarhoń",
    country: "Belarus",
    subcountry: "Grodnenskaya",
    geonameid: 621713,
  },
  {
    name: "Smaliavičy",
    country: "Belarus",
    subcountry: "Minsk",
    geonameid: 621729,
  },
  {
    name: "Slutsk",
    country: "Belarus",
    subcountry: "Minsk",
    geonameid: 621741,
  },
  {
    name: "Slonim",
    country: "Belarus",
    subcountry: "Grodnenskaya",
    geonameid: 621754,
  },
  {
    name: "Shchuchyn",
    country: "Belarus",
    subcountry: "Grodnenskaya",
    geonameid: 622113,
  },
  {
    name: "Salihorsk",
    country: "Belarus",
    subcountry: "Minsk",
    geonameid: 622428,
  },
  {
    name: "Rahachow",
    country: "Belarus",
    subcountry: "Gomel Oblast",
    geonameid: 622739,
  },
  {
    name: "Rechytsa",
    country: "Belarus",
    subcountry: "Gomel Oblast",
    geonameid: 622794,
  },
  {
    name: "Pruzhany",
    country: "Belarus",
    subcountry: "Brest",
    geonameid: 622997,
  },
  {
    name: "Polatsk",
    country: "Belarus",
    subcountry: "Vitebsk",
    geonameid: 623317,
  },
  {
    name: "Pinsk",
    country: "Belarus",
    subcountry: "Brest",
    geonameid: 623549,
  },
  {
    name: "Pastavy",
    country: "Belarus",
    subcountry: "Vitebsk",
    geonameid: 623760,
  },
  {
    name: "Asipovichy",
    country: "Belarus",
    subcountry: "Mogilev",
    geonameid: 624034,
  },
  {
    name: "Orsha",
    country: "Belarus",
    subcountry: "Vitebsk",
    geonameid: 624079,
  },
  {
    name: "Navapolatsk",
    country: "Belarus",
    subcountry: "Vitebsk",
    geonameid: 624784,
  },
  {
    name: "Novogrudok",
    country: "Belarus",
    subcountry: "Grodnenskaya",
    geonameid: 624785,
  },
  {
    name: "Minsk",
    country: "Belarus",
    subcountry: "Minsk City",
    geonameid: 625144,
  },
  {
    name: "Mazyr",
    country: "Belarus",
    subcountry: "Gomel Oblast",
    geonameid: 625324,
  },
  {
    name: "Mosty",
    country: "Belarus",
    subcountry: "Grodnenskaya",
    geonameid: 625367,
  },
  {
    name: "Mar’’ina Horka",
    country: "Belarus",
    subcountry: "Minsk",
    geonameid: 625409,
  },
  {
    name: "Maladziečna",
    country: "Belarus",
    subcountry: "Minsk",
    geonameid: 625625,
  },
  {
    name: "Mahilyow",
    country: "Belarus",
    subcountry: "Mogilev",
    geonameid: 625665,
  },
  {
    name: "Lyepyel’",
    country: "Belarus",
    subcountry: "Vitebsk",
    geonameid: 625743,
  },
  {
    name: "Luninyets",
    country: "Belarus",
    subcountry: "Brest",
    geonameid: 625818,
  },
  {
    name: "Lida",
    country: "Belarus",
    subcountry: "Grodnenskaya",
    geonameid: 626081,
  },
  {
    name: "Krychaw",
    country: "Belarus",
    subcountry: "Mogilev",
    geonameid: 626450,
  },
  {
    name: "Kalodzishchy",
    country: "Belarus",
    subcountry: "Minsk",
    geonameid: 627083,
  },
  {
    name: "Kobryn",
    country: "Belarus",
    subcountry: "Brest",
    geonameid: 627145,
  },
  {
    name: "Kalinkavichy",
    country: "Belarus",
    subcountry: "Gomel Oblast",
    geonameid: 627751,
  },
  {
    name: "Ivatsevichy",
    country: "Belarus",
    subcountry: "Brest",
    geonameid: 627800,
  },
  {
    name: "Hrodna",
    country: "Belarus",
    subcountry: "Grodnenskaya",
    geonameid: 627904,
  },
  {
    name: "Horki",
    country: "Belarus",
    subcountry: "Mogilev",
    geonameid: 627905,
  },
  {
    name: "Homyel'",
    country: "Belarus",
    subcountry: "Gomel Oblast",
    geonameid: 627907,
  },
  {
    name: "Hlybokaye",
    country: "Belarus",
    subcountry: "Vitebsk",
    geonameid: 627908,
  },
  {
    name: "Dzyarzhynsk",
    country: "Belarus",
    subcountry: "Minsk",
    geonameid: 628634,
  },
  {
    name: "Dobrush",
    country: "Belarus",
    subcountry: "Gomel Oblast",
    geonameid: 629018,
  },
  {
    name: "Bykhaw",
    country: "Belarus",
    subcountry: "Mogilev",
    geonameid: 629447,
  },
  {
    name: "Byaroza",
    country: "Belarus",
    subcountry: "Brest",
    geonameid: 629454,
  },
  {
    name: "Brest",
    country: "Belarus",
    subcountry: "Brest",
    geonameid: 629634,
  },
  {
    name: "Barysaw",
    country: "Belarus",
    subcountry: "Minsk",
    geonameid: 630376,
  },
  {
    name: "Baranovichi",
    country: "Belarus",
    subcountry: "Brest",
    geonameid: 630429,
  },
  {
    name: "Babruysk",
    country: "Belarus",
    subcountry: "Mogilev",
    geonameid: 630468,
  },
  {
    name: "San Pedro",
    country: "Belize",
    subcountry: "Belize",
    geonameid: 3581164,
  },
  {
    name: "San Ignacio",
    country: "Belize",
    subcountry: "Cayo",
    geonameid: 3581194,
  },
  {
    name: "Orange Walk",
    country: "Belize",
    subcountry: "Orange Walk District",
    geonameid: 3581514,
  },
  {
    name: "Belmopan",
    country: "Belize",
    subcountry: "Cayo",
    geonameid: 3582672,
  },
  {
    name: "Belize City",
    country: "Belize",
    subcountry: "Belize",
    geonameid: 3582677,
  },
  {
    name: "Abbotsford",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 5881791,
  },
  {
    name: "Agincourt North",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5882600,
  },
  {
    name: "Airdrie",
    country: "Canada",
    subcountry: "Alberta",
    geonameid: 5882799,
  },
  {
    name: "Ajax",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5882873,
  },
  {
    name: "Alliston",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5884051,
  },
  {
    name: "Alma",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 5884083,
  },
  {
    name: "Amos",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 5884588,
  },
  {
    name: "Aurora",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5888377,
  },
  {
    name: "Baie-Comeau",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 5889745,
  },
  {
    name: "Barrie",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5894171,
  },
  {
    name: "Bayview Village",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5895482,
  },
  {
    name: "Beaconsfield",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 5895650,
  },
  {
    name: "Belleville",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5897884,
  },
  {
    name: "Beloeil",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 5898138,
  },
  {
    name: "Bendale",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5898265,
  },
  {
    name: "Blainville",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 5903510,
  },
  {
    name: "Boisbriand",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 5905132,
  },
  {
    name: "Boucherville",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 5906267,
  },
  {
    name: "Bracebridge",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5907092,
  },
  {
    name: "Brampton",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5907364,
  },
  {
    name: "Brandon",
    country: "Canada",
    subcountry: "Manitoba",
    geonameid: 5907896,
  },
  {
    name: "Brant",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5907983,
  },
  {
    name: "Brantford",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5907990,
  },
  {
    name: "Brockville",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5909294,
  },
  {
    name: "Brossard",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 5909629,
  },
  {
    name: "Burlington",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5911592,
  },
  {
    name: "Burnaby",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 5911606,
  },
  {
    name: "Caledon",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5913414,
  },
  {
    name: "Calgary",
    country: "Canada",
    subcountry: "Alberta",
    geonameid: 5913490,
  },
  {
    name: "Cambridge",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5913695,
  },
  {
    name: "Campbell River",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 5914132,
  },
  {
    name: "Camrose",
    country: "Canada",
    subcountry: "Alberta",
    geonameid: 5914653,
  },
  {
    name: "Candiac",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 5914826,
  },
  {
    name: "Chambly",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 5919566,
  },
  {
    name: "Charlottetown",
    country: "Canada",
    subcountry: "Prince Edward Island",
    geonameid: 5920288,
  },
  {
    name: "Châteauguay",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 5920433,
  },
  {
    name: "Chatham",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5920457,
  },
  {
    name: "Chilliwack",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 5921356,
  },
  {
    name: "Clarence-Rockland",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5923101,
  },
  {
    name: "Cliffcrest",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5923921,
  },
  {
    name: "Cobourg",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5924579,
  },
  {
    name: "Cochrane",
    country: "Canada",
    subcountry: "Alberta",
    geonameid: 5924618,
  },
  {
    name: "Collingwood",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5925975,
  },
  {
    name: "Colwood",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 5926268,
  },
  {
    name: "Conception Bay South",
    country: "Canada",
    subcountry: "Newfoundland and Labrador",
    geonameid: 5926511,
  },
  {
    name: "Coquitlam",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 5927690,
  },
  {
    name: "Corner Brook",
    country: "Canada",
    subcountry: "Newfoundland and Labrador",
    geonameid: 5927969,
  },
  {
    name: "Cornwall",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5928065,
  },
  {
    name: "Côte-Saint-Luc",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 5928488,
  },
  {
    name: "Courtenay",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 5930890,
  },
  {
    name: "Cranbrook",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 5931800,
  },
  {
    name: "Dartmouth",
    country: "Canada",
    subcountry: "Nova Scotia",
    geonameid: 5935277,
  },
  {
    name: "Delta",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 5937615,
  },
  {
    name: "Deux-Montagnes",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 5938513,
  },
  {
    name: "Dieppe",
    country: "Canada",
    subcountry: "New Brunswick",
    geonameid: 5939219,
  },
  {
    name: "Dollard-Des Ormeaux",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 5940956,
  },
  {
    name: "Dorset Park",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5941905,
  },
  {
    name: "Dorval",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 5941925,
  },
  {
    name: "Drummondville",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 5942845,
  },
  {
    name: "Duncan",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 5943865,
  },
  {
    name: "East Gwillimbury",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5945707,
  },
  {
    name: "Edmonton",
    country: "Canada",
    subcountry: "Alberta",
    geonameid: 5946768,
  },
  {
    name: "Humbermede",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5948587,
  },
  {
    name: "Esquimalt",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 5949512,
  },
  {
    name: "Flemingdon Park",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5954579,
  },
  {
    name: "Fort Erie",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5955815,
  },
  {
    name: "Fort McMurray",
    country: "Canada",
    subcountry: "Alberta",
    geonameid: 5955895,
  },
  {
    name: "Fort St. John",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 5955960,
  },
  {
    name: "Fredericton",
    country: "Canada",
    subcountry: "New Brunswick",
    geonameid: 5957776,
  },
  {
    name: "Gatineau",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 5959974,
  },
  {
    name: "Glace Bay",
    country: "Canada",
    subcountry: "Nova Scotia",
    geonameid: 5961564,
  },
  {
    name: "Granby",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 5964215,
  },
  {
    name: "Grande Prairie",
    country: "Canada",
    subcountry: "Alberta",
    geonameid: 5964347,
  },
  {
    name: "Greater Sudbury",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5964700,
  },
  {
    name: "Greater Napanee",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5965812,
  },
  {
    name: "Grimsby",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5967149,
  },
  {
    name: "Guelph",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5967629,
  },
  {
    name: "Hamilton",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5969782,
  },
  {
    name: "Henry Farm",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5973973,
  },
  {
    name: "Hillcrest Village",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5975182,
  },
  {
    name: "Huntsville",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5978765,
  },
  {
    name: "Joliette",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 5987650,
  },
  {
    name: "Kamloops",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 5989045,
  },
  {
    name: "Kanata",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5989117,
  },
  {
    name: "Kelowna",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 5990579,
  },
  {
    name: "Kennedy Park",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5990916,
  },
  {
    name: "Kenora",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5991055,
  },
  {
    name: "Keswick",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5991370,
  },
  {
    name: "Kingston",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5992500,
  },
  {
    name: "Kirkland",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 5992830,
  },
  {
    name: "Kitchener",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 5992996,
  },
  {
    name: "Langford",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 6049388,
  },
  {
    name: "Langley",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 6049429,
  },
  {
    name: "La Prairie",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6049863,
  },
  {
    name: "L'Assomption",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6050263,
  },
  {
    name: "Laval",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6050610,
  },
  {
    name: "Leamington",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6051122,
  },
  {
    name: "Leduc",
    country: "Canada",
    subcountry: "Alberta",
    geonameid: 6051562,
  },
  {
    name: "Les Coteaux",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6052788,
  },
  {
    name: "Lethbridge",
    country: "Canada",
    subcountry: "Alberta",
    geonameid: 6053154,
  },
  {
    name: "Lindsay",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6054350,
  },
  {
    name: "Lloydminster",
    country: "Canada",
    subcountry: "Alberta",
    geonameid: 6058024,
  },
  {
    name: "London",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6058560,
  },
  {
    name: "Longueuil",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6059891,
  },
  {
    name: "Lutes Mountain",
    country: "Canada",
    subcountry: "New Brunswick",
    geonameid: 6062163,
  },
  {
    name: "Magog",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6064180,
  },
  {
    name: "Malvern",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6064969,
  },
  {
    name: "Maple Ridge",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 6065686,
  },
  {
    name: "Markham",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6066513,
  },
  {
    name: "Mascouche",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6067494,
  },
  {
    name: "Medicine Hat",
    country: "Canada",
    subcountry: "Alberta",
    geonameid: 6071618,
  },
  {
    name: "Midland",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6073363,
  },
  {
    name: "Milliken",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6074143,
  },
  {
    name: "Milton",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6074377,
  },
  {
    name: "Mimico",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6074409,
  },
  {
    name: "Mirabel",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6075061,
  },
  {
    name: "Miramichi",
    country: "Canada",
    subcountry: "New Brunswick",
    geonameid: 6075081,
  },
  {
    name: "Mission",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 6075292,
  },
  {
    name: "Mississauga",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6075357,
  },
  {
    name: "Moncton",
    country: "Canada",
    subcountry: "New Brunswick",
    geonameid: 6076211,
  },
  {
    name: "Montréal",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6077243,
  },
  {
    name: "Mont-Royal",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6077315,
  },
  {
    name: "Mont-Saint-Hilaire",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6077340,
  },
  {
    name: "Moose Jaw",
    country: "Canada",
    subcountry: "Saskatchewan",
    geonameid: 6078112,
  },
  {
    name: "Mount Pearl",
    country: "Canada",
    subcountry: "Newfoundland and Labrador",
    geonameid: 6082231,
  },
  {
    name: "Nanaimo",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 6085772,
  },
  {
    name: "Nepean",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6087029,
  },
  {
    name: "New Glasgow",
    country: "Canada",
    subcountry: "Nova Scotia",
    geonameid: 6087579,
  },
  {
    name: "Newmarket",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6087701,
  },
  {
    name: "New Westminster",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 6087844,
  },
  {
    name: "Niagara Falls",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6087892,
  },
  {
    name: "Niagara-on-the-Lake",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6087905,
  },
  {
    name: "Norfolk County",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6089125,
  },
  {
    name: "North Battleford",
    country: "Canada",
    subcountry: "Saskatchewan",
    geonameid: 6089404,
  },
  {
    name: "North Bay",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6089426,
  },
  {
    name: "North Cowichan",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 6089661,
  },
  {
    name: "North Vancouver",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 6090785,
  },
  {
    name: "Notre-Dame-de-Grâce",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6091314,
  },
  {
    name: "Oak Bay",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 6091919,
  },
  {
    name: "Oakville",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6092122,
  },
  {
    name: "Oakwood Village",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6092125,
  },
  {
    name: "Orangeville",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6094201,
  },
  {
    name: "Orillia",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6094325,
  },
  {
    name: "Oshawa",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6094578,
  },
  {
    name: "Ottawa",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6094817,
  },
  {
    name: "Owen Sound",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6095645,
  },
  {
    name: "Penticton",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 6101141,
  },
  {
    name: "Petawawa",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6101606,
  },
  {
    name: "Peterborough",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6101645,
  },
  {
    name: "Pickering",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6104111,
  },
  {
    name: "Pitt Meadows",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 6105815,
  },
  {
    name: "Pointe-Claire",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6107325,
  },
  {
    name: "Port Alberni",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 6111632,
  },
  {
    name: "Port Colborne",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6111704,
  },
  {
    name: "Port Coquitlam",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 6111706,
  },
  {
    name: "Port Moody",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 6111962,
  },
  {
    name: "Prince Albert",
    country: "Canada",
    subcountry: "Saskatchewan",
    geonameid: 6113335,
  },
  {
    name: "Prince Edward",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6113355,
  },
  {
    name: "Prince George",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 6113365,
  },
  {
    name: "Quinte West",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6115355,
  },
  {
    name: "Red Deer",
    country: "Canada",
    subcountry: "Alberta",
    geonameid: 6118158,
  },
  {
    name: "Regina",
    country: "Canada",
    subcountry: "Saskatchewan",
    geonameid: 6119109,
  },
  {
    name: "Repentigny",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6119518,
  },
  {
    name: "Richmond",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 6122085,
  },
  {
    name: "Richmond Hill",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6122091,
  },
  {
    name: "Rock Forest",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6126305,
  },
  {
    name: "Rouge",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6128081,
  },
  {
    name: "Rouyn-Noranda",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6128577,
  },
  {
    name: "Saguenay",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6137270,
  },
  {
    name: "Saint-Basile-le-Grand",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6137489,
  },
  {
    name: "Saint-Bruno-de-Montarville",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6137540,
  },
  {
    name: "Saint-Constant",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6137633,
  },
  {
    name: "Sainte-Catherine",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6137780,
  },
  {
    name: "Sainte-Catherine",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6137781,
  },
  {
    name: "Sainte-Julie",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6137941,
  },
  {
    name: "Sainte-Thérèse",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6138121,
  },
  {
    name: "Saint-Eustache",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6138175,
  },
  {
    name: "Saint-Hyacinthe",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6138374,
  },
  {
    name: "Saint-Jean-sur-Richelieu",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6138495,
  },
  {
    name: "Saint-Jérôme",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6138501,
  },
  {
    name: "Saint John",
    country: "Canada",
    subcountry: "New Brunswick",
    geonameid: 6138517,
  },
  {
    name: "Saint-Laurent",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6138610,
  },
  {
    name: "Saint-Lazare",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6138617,
  },
  {
    name: "Saint-Léonard",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6138625,
  },
  {
    name: "Saint-Lin-Laurentides",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6138643,
  },
  {
    name: "Salaberry-de-Valleyfield",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6139289,
  },
  {
    name: "Sarnia",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6141190,
  },
  {
    name: "Saskatoon",
    country: "Canada",
    subcountry: "Saskatchewan",
    geonameid: 6141256,
  },
  {
    name: "Sault Ste. Marie",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6141439,
  },
  {
    name: "Scarborough Village",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6141900,
  },
  {
    name: "Sept-Îles",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6144312,
  },
  {
    name: "Shawinigan",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6145489,
  },
  {
    name: "Sherbrooke",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6146143,
  },
  {
    name: "Sherwood Park",
    country: "Canada",
    subcountry: "Alberta",
    geonameid: 6146279,
  },
  {
    name: "Sorel-Tracy",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6151350,
  },
  {
    name: "Spruce Grove",
    country: "Canada",
    subcountry: "Alberta",
    geonameid: 6154383,
  },
  {
    name: "Squamish",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 6154636,
  },
  {
    name: "St. Albert",
    country: "Canada",
    subcountry: "Alberta",
    geonameid: 6155033,
  },
  {
    name: "St. Catharines",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6155721,
  },
  {
    name: "Steeles",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6155938,
  },
  {
    name: "Steinbach",
    country: "Canada",
    subcountry: "Manitoba",
    geonameid: 6156102,
  },
  {
    name: "Stratford",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6157977,
  },
  {
    name: "St. Thomas",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6158357,
  },
  {
    name: "Surrey",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 6159905,
  },
  {
    name: "Swift Current",
    country: "Canada",
    subcountry: "Saskatchewan",
    geonameid: 6160603,
  },
  {
    name: "Tam O'Shanter-Sullivan",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6161443,
  },
  {
    name: "Tecumseh",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6162416,
  },
  {
    name: "Terrace",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 6162949,
  },
  {
    name: "Terrebonne",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6163012,
  },
  {
    name: "The Beaches",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6163363,
  },
  {
    name: "Thorold",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6165719,
  },
  {
    name: "Thunder Bay",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6166142,
  },
  {
    name: "Timmins",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6166739,
  },
  {
    name: "Toronto",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6167865,
  },
  {
    name: "Trois-Rivières",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6169141,
  },
  {
    name: "Tsawwassen",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 6169661,
  },
  {
    name: "Uxbridge",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6172932,
  },
  {
    name: "Val-d'Or",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6173017,
  },
  {
    name: "Vancouver",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 6173331,
  },
  {
    name: "Vanier",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6173404,
  },
  {
    name: "Varennes",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6173508,
  },
  {
    name: "Vaudreuil-Dorion",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6173570,
  },
  {
    name: "Vaughan",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6173577,
  },
  {
    name: "Vernon",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 6173864,
  },
  {
    name: "Victoria",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 6174041,
  },
  {
    name: "Victoriaville",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6174151,
  },
  {
    name: "Wasaga Beach",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6176421,
  },
  {
    name: "Waterloo",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6176823,
  },
  {
    name: "Welland",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6177869,
  },
  {
    name: "West End",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 6178582,
  },
  {
    name: "West Hill",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6178999,
  },
  {
    name: "Westmount",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6179226,
  },
  {
    name: "Weston",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6179268,
  },
  {
    name: "Whitehorse",
    country: "Canada",
    subcountry: "Yukon",
    geonameid: 6180550,
  },
  {
    name: "White Rock",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 6180961,
  },
  {
    name: "Windsor",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6182962,
  },
  {
    name: "Winnipeg",
    country: "Canada",
    subcountry: "Manitoba",
    geonameid: 6183235,
  },
  {
    name: "Woburn",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6183590,
  },
  {
    name: "Woodstock",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 6184365,
  },
  {
    name: "Yellowknife",
    country: "Canada",
    subcountry: "Northwest Territories",
    geonameid: 6185377,
  },
  {
    name: "Yorkton",
    country: "Canada",
    subcountry: "Saskatchewan",
    geonameid: 6185607,
  },
  {
    name: "Halifax",
    country: "Canada",
    subcountry: "Nova Scotia",
    geonameid: 6324729,
  },
  {
    name: "St. John's",
    country: "Canada",
    subcountry: "Newfoundland and Labrador",
    geonameid: 6324733,
  },
  {
    name: "Québec",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6325494,
  },
  {
    name: "Lévis",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6325521,
  },
  {
    name: "Rimouski",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6354895,
  },
  {
    name: "Rivière-du-Loup",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6354897,
  },
  {
    name: "Sydney",
    country: "Canada",
    subcountry: "Nova Scotia",
    geonameid: 6354908,
  },
  {
    name: "L'Ancienne-Lorette",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6534203,
  },
  {
    name: "Edmundston",
    country: "Canada",
    subcountry: "New Brunswick",
    geonameid: 6545023,
  },
  {
    name: "Saint-Georges",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6620953,
  },
  {
    name: "Buckingham",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6942645,
  },
  {
    name: "Thetford-Mines",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 6943827,
  },
  {
    name: "Cole Harbour",
    country: "Canada",
    subcountry: "Nova Scotia",
    geonameid: 7280414,
  },
  {
    name: "Okanagan",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 7281931,
  },
  {
    name: "West Kelowna",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 7281936,
  },
  {
    name: "Jonquière",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 7303786,
  },
  {
    name: "Saint-Augustin-de-Desmaures",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 7535681,
  },
  {
    name: "Ladner",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 7602078,
  },
  {
    name: "Walnut Grove",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 7669012,
  },
  {
    name: "Moss Park",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 7870782,
  },
  {
    name: "High Park North",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 7870882,
  },
  {
    name: "Little Portugal",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 7870917,
  },
  {
    name: "Niagara",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 7870919,
  },
  {
    name: "Trinity-Bellwoods",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 7870920,
  },
  {
    name: "Morningside",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 7871306,
  },
  {
    name: "Eglinton East",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 7871311,
  },
  {
    name: "Pleasant View",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 7871317,
  },
  {
    name: "Fergus",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 7871320,
  },
  {
    name: "Ancaster",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 8285452,
  },
  {
    name: "West Vancouver",
    country: "Canada",
    subcountry: "British Columbia",
    geonameid: 8533869,
  },
  {
    name: "Willowdale",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 8558534,
  },
  {
    name: "Lower Sackville",
    country: "Canada",
    subcountry: "Nova Scotia",
    geonameid: 10287505,
  },
  {
    name: "La Haute-Saint-Charles",
    country: "Canada",
    subcountry: "Quebec",
    geonameid: 11838435,
  },
  {
    name: "Fallingbrook",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12070742,
  },
  {
    name: "Valley East",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12070764,
  },
  {
    name: "York University Heights",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156817,
  },
  {
    name: "Parkwoods-Donalda",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156818,
  },
  {
    name: "South Parkdale",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156819,
  },
  {
    name: "South Riverdale",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156820,
  },
  {
    name: "North St.James Town",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156821,
  },
  {
    name: "Waterfront Communities-The Island",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156822,
  },
  {
    name: "West Humber-Clairville",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156823,
  },
  {
    name: "Banbury-Don Mills",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156824,
  },
  {
    name: "Birchcliffe-Cliffside",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156825,
  },
  {
    name: "Islington-City Centre West",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156826,
  },
  {
    name: "Mount Pleasant West",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156828,
  },
  {
    name: "Eringate-Centennial-West Deane",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156835,
  },
  {
    name: "Dovercourt-Wallace Emerson-Junction",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156838,
  },
  {
    name: "Edenbridge-Humber Valley",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156839,
  },
  {
    name: "Newtonbrook East",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156840,
  },
  {
    name: "Newtonbrook West",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156842,
  },
  {
    name: "L'Amoreaux",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156843,
  },
  {
    name: "Taylor-Massey",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156845,
  },
  {
    name: "Lansing-Westgate",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156849,
  },
  {
    name: "Lawrence Park South",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156850,
  },
  {
    name: "Leaside-Bennington",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156851,
  },
  {
    name: "Mount Olive-Silverstone-Jamestown",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156853,
  },
  {
    name: "Mount Pleasant East",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156854,
  },
  {
    name: "Willowdale West",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156857,
  },
  {
    name: "Black Creek",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156858,
  },
  {
    name: "Rockcliffe-Smythe",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156859,
  },
  {
    name: "Rosedale-Moore Park",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156862,
  },
  {
    name: "Stonegate-Queensway",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156865,
  },
  {
    name: "Danforth East York",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156867,
  },
  {
    name: "St.Andrew-Windfields",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156868,
  },
  {
    name: "Annex",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156871,
  },
  {
    name: "Thorncliffe Park",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156872,
  },
  {
    name: "Victoria Village",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156873,
  },
  {
    name: "Wexford/Maryvale",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156875,
  },
  {
    name: "Westminster-Branson",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156877,
  },
  {
    name: "Willowdale East",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156878,
  },
  {
    name: "Willowridge-Martingrove-Richview",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156881,
  },
  {
    name: "Church-Yonge Corridor",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156882,
  },
  {
    name: "Brookhaven-Amesbury",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156883,
  },
  {
    name: "O'Connor-Parkview",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156884,
  },
  {
    name: "Kensington-Chinatown",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156886,
  },
  {
    name: "Bay Street Corridor",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156887,
  },
  {
    name: "Agincourt South-Malvern West",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156888,
  },
  {
    name: "East End-Danforth",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156890,
  },
  {
    name: "Englemount-Lawrence",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156893,
  },
  {
    name: "Bedford Park-Nortown",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156896,
  },
  {
    name: "Bathurst Manor",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156897,
  },
  {
    name: "Clanton Park",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156898,
  },
  {
    name: "Clairlea-Birchmount",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156899,
  },
  {
    name: "Don Valley Village",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156901,
  },
  {
    name: "Downsview-Roding-CFB",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156903,
  },
  {
    name: "Glenfield-Jane Heights",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156904,
  },
  {
    name: "High Park-Swansea",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156905,
  },
  {
    name: "Kingsview Village-The Westway",
    country: "Canada",
    subcountry: "Ontario",
    geonameid: 12156906,
  },
  {
    name: "West Island",
    country: "Cocos Islands",
    subcountry: "N/A",
    geonameid: 7304591,
  },
  {
    name: "Yangambi",
    country: "Democratic Republic of the Congo",
    subcountry: "Tshopo",
    geonameid: 203717,
  },
  {
    name: "Watsa",
    country: "Democratic Republic of the Congo",
    subcountry: "Haut-Uele",
    geonameid: 204283,
  },
  {
    name: "Wamba",
    country: "Democratic Republic of the Congo",
    subcountry: "Haut-Uele",
    geonameid: 204318,
  },
  {
    name: "Uvira",
    country: "Democratic Republic of the Congo",
    subcountry: "South Kivu",
    geonameid: 204405,
  },
  {
    name: "Tshikapa",
    country: "Democratic Republic of the Congo",
    subcountry: "Kasai",
    geonameid: 204953,
  },
  {
    name: "Sake",
    country: "Democratic Republic of the Congo",
    subcountry: "Nord Kivu",
    geonameid: 205970,
  },
  {
    name: "Mwene-Ditu",
    country: "Democratic Republic of the Congo",
    subcountry: "Lomami",
    geonameid: 207570,
  },
  {
    name: "Mweka",
    country: "Democratic Republic of the Congo",
    subcountry: "Kasai",
    geonameid: 207596,
  },
  {
    name: "Mbuji-Mayi",
    country: "Democratic Republic of the Congo",
    subcountry: "Kasaï-Oriental",
    geonameid: 209228,
  },
  {
    name: "Lusambo",
    country: "Democratic Republic of the Congo",
    subcountry: "Sankuru",
    geonameid: 210379,
  },
  {
    name: "Luebo",
    country: "Democratic Republic of the Congo",
    subcountry: "Kasai",
    geonameid: 210939,
  },
  {
    name: "Lubao",
    country: "Democratic Republic of the Congo",
    subcountry: "Lomami",
    geonameid: 211098,
  },
  {
    name: "Lodja",
    country: "Democratic Republic of the Congo",
    subcountry: "Sankuru",
    geonameid: 211647,
  },
  {
    name: "Lisala",
    country: "Democratic Republic of the Congo",
    subcountry: "Mongala",
    geonameid: 211734,
  },
  {
    name: "Kongolo",
    country: "Democratic Republic of the Congo",
    subcountry: "Tanganyika",
    geonameid: 212360,
  },
  {
    name: "Kisangani",
    country: "Democratic Republic of the Congo",
    subcountry: "Tshopo",
    geonameid: 212730,
  },
  {
    name: "Kindu",
    country: "Democratic Republic of the Congo",
    subcountry: "Maniema",
    geonameid: 212902,
  },
  {
    name: "Kasongo",
    country: "Democratic Republic of the Congo",
    subcountry: "Maniema",
    geonameid: 213940,
  },
  {
    name: "Kananga",
    country: "Democratic Republic of the Congo",
    subcountry: "Kasai-Central",
    geonameid: 214481,
  },
  {
    name: "Kampene",
    country: "Democratic Republic of the Congo",
    subcountry: "Maniema",
    geonameid: 214575,
  },
  {
    name: "Kamina",
    country: "Democratic Republic of the Congo",
    subcountry: "Haut-Lomami",
    geonameid: 214614,
  },
  {
    name: "Kalemie",
    country: "Democratic Republic of the Congo",
    subcountry: "Tanganyika",
    geonameid: 214974,
  },
  {
    name: "Kabinda",
    country: "Democratic Republic of the Congo",
    subcountry: "Lomami",
    geonameid: 215527,
  },
  {
    name: "Kabare",
    country: "Democratic Republic of the Congo",
    subcountry: "South Kivu",
    geonameid: 215605,
  },
  {
    name: "Kabalo",
    country: "Democratic Republic of the Congo",
    subcountry: "Tanganyika",
    geonameid: 215668,
  },
  {
    name: "Isiro",
    country: "Democratic Republic of the Congo",
    subcountry: "Haut-Uele",
    geonameid: 215771,
  },
  {
    name: "Ilebo",
    country: "Democratic Republic of the Congo",
    subcountry: "Kasai",
    geonameid: 215976,
  },
  {
    name: "Goma",
    country: "Democratic Republic of the Congo",
    subcountry: "Nord Kivu",
    geonameid: 216281,
  },
  {
    name: "Gbadolite",
    country: "Democratic Republic of the Congo",
    subcountry: "Nord-Ubangi",
    geonameid: 216404,
  },
  {
    name: "Gandajika",
    country: "Democratic Republic of the Congo",
    subcountry: "Lomami",
    geonameid: 216449,
  },
  {
    name: "Demba",
    country: "Democratic Republic of the Congo",
    subcountry: "Kasai-Central",
    geonameid: 217389,
  },
  {
    name: "Butembo",
    country: "Democratic Republic of the Congo",
    subcountry: "Nord Kivu",
    geonameid: 217562,
  },
  {
    name: "Buta",
    country: "Democratic Republic of the Congo",
    subcountry: "Bas-Uele",
    geonameid: 217570,
  },
  {
    name: "Businga",
    country: "Democratic Republic of the Congo",
    subcountry: "Nord-Ubangi",
    geonameid: 217637,
  },
  {
    name: "Bunia",
    country: "Democratic Republic of the Congo",
    subcountry: "Ituri",
    geonameid: 217695,
  },
  {
    name: "Bumba",
    country: "Democratic Republic of the Congo",
    subcountry: "Mongala",
    geonameid: 217745,
  },
  {
    name: "Bukavu",
    country: "Democratic Republic of the Congo",
    subcountry: "South Kivu",
    geonameid: 217831,
  },
  {
    name: "Bukama",
    country: "Democratic Republic of the Congo",
    subcountry: "Haut-Lomami",
    geonameid: 217834,
  },
  {
    name: "Bondo",
    country: "Democratic Republic of the Congo",
    subcountry: "Bas-Uele",
    geonameid: 218253,
  },
  {
    name: "Boende",
    country: "Democratic Republic of the Congo",
    subcountry: "Tshuapa",
    geonameid: 218680,
  },
  {
    name: "Beni",
    country: "Democratic Republic of the Congo",
    subcountry: "Nord Kivu",
    geonameid: 219057,
  },
  {
    name: "Basoko",
    country: "Democratic Republic of the Congo",
    subcountry: "Tshopo",
    geonameid: 219414,
  },
  {
    name: "Aketi",
    country: "Democratic Republic of the Congo",
    subcountry: "Bas-Uele",
    geonameid: 220448,
  },
  {
    name: "Lubumbashi",
    country: "Democratic Republic of the Congo",
    subcountry: "Haut-Katanga",
    geonameid: 922704,
  },
  {
    name: "Likasi",
    country: "Democratic Republic of the Congo",
    subcountry: "Haut-Katanga",
    geonameid: 922741,
  },
  {
    name: "Kolwezi",
    country: "Democratic Republic of the Congo",
    subcountry: "Lualaba",
    geonameid: 922773,
  },
  {
    name: "Kipushi",
    country: "Democratic Republic of the Congo",
    subcountry: "Haut-Katanga",
    geonameid: 922806,
  },
  {
    name: "Kambove",
    country: "Democratic Republic of the Congo",
    subcountry: "Haut-Katanga",
    geonameid: 923058,
  },
  {
    name: "Tshela",
    country: "Democratic Republic of the Congo",
    subcountry: "Bas-Congo",
    geonameid: 2311127,
  },
  {
    name: "Nioki",
    country: "Democratic Republic of the Congo",
    subcountry: "Mai-Ndombe",
    geonameid: 2311968,
  },
  {
    name: "Mushie",
    country: "Democratic Republic of the Congo",
    subcountry: "Mai-Ndombe",
    geonameid: 2312249,
  },
  {
    name: "Moanda",
    country: "Democratic Republic of the Congo",
    subcountry: "Bas-Congo",
    geonameid: 2312393,
  },
  {
    name: "Mbanza-Ngungu",
    country: "Democratic Republic of the Congo",
    subcountry: "Bas-Congo",
    geonameid: 2312888,
  },
  {
    name: "Mbandaka",
    country: "Democratic Republic of the Congo",
    subcountry: "Équateur",
    geonameid: 2312895,
  },
  {
    name: "Matadi",
    country: "Democratic Republic of the Congo",
    subcountry: "Bas-Congo",
    geonameid: 2313002,
  },
  {
    name: "Mangai",
    country: "Democratic Republic of the Congo",
    subcountry: "Kwilu",
    geonameid: 2313084,
  },
  {
    name: "Libenge",
    country: "Democratic Republic of the Congo",
    subcountry: "Sud-Ubangi",
    geonameid: 2313762,
  },
  {
    name: "Kinshasa",
    country: "Democratic Republic of the Congo",
    subcountry: "Kinshasa",
    geonameid: 2314302,
  },
  {
    name: "Kikwit",
    country: "Democratic Republic of the Congo",
    subcountry: "Kwilu",
    geonameid: 2314705,
  },
  {
    name: "Kasongo-Lunda",
    country: "Democratic Republic of the Congo",
    subcountry: "Kwango",
    geonameid: 2315026,
  },
  {
    name: "Kasangulu",
    country: "Democratic Republic of the Congo",
    subcountry: "Bas-Congo",
    geonameid: 2315057,
  },
  {
    name: "Inongo",
    country: "Democratic Republic of the Congo",
    subcountry: "Mai-Ndombe",
    geonameid: 2315417,
  },
  {
    name: "Gemena",
    country: "Democratic Republic of the Congo",
    subcountry: "Sud-Ubangi",
    geonameid: 2315728,
  },
  {
    name: "Bulungu",
    country: "Democratic Republic of the Congo",
    subcountry: "Kwilu",
    geonameid: 2316259,
  },
  {
    name: "Boma",
    country: "Democratic Republic of the Congo",
    subcountry: "Bas-Congo",
    geonameid: 2316702,
  },
  {
    name: "Bolobo",
    country: "Democratic Republic of the Congo",
    subcountry: "Mai-Ndombe",
    geonameid: 2316748,
  },
  {
    name: "Bandundu",
    country: "Democratic Republic of the Congo",
    subcountry: "Kwilu",
    geonameid: 2317397,
  },
  {
    name: "Masina",
    country: "Democratic Republic of the Congo",
    subcountry: "Kinshasa",
    geonameid: 2593460,
  },
  {
    name: "Mobaye",
    country: "Central African Republic",
    subcountry: "Basse-Kotto",
    geonameid: 237478,
  },
  {
    name: "Ippy",
    country: "Central African Republic",
    subcountry: "Ouaka",
    geonameid: 238566,
  },
  {
    name: "Bria",
    country: "Central African Republic",
    subcountry: "Haute-Kotto",
    geonameid: 239899,
  },
  {
    name: "Bangassou",
    country: "Central African Republic",
    subcountry: "Mbomou",
    geonameid: 240498,
  },
  {
    name: "Bambari",
    country: "Central African Republic",
    subcountry: "Ouaka",
    geonameid: 240604,
  },
  {
    name: "Sibut",
    country: "Central African Republic",
    subcountry: "Kémo",
    geonameid: 2383119,
  },
  {
    name: "Paoua",
    country: "Central African Republic",
    subcountry: "Ouham-Pendé",
    geonameid: 2383523,
  },
  {
    name: "Nola",
    country: "Central African Republic",
    subcountry: "Sangha-Mbaéré",
    geonameid: 2383827,
  },
  {
    name: "Mbaïki",
    country: "Central African Republic",
    subcountry: "Lobaye",
    geonameid: 2384770,
  },
  {
    name: "Kaga Bandoro",
    country: "Central African Republic",
    subcountry: "Nana-Grébizi",
    geonameid: 2386012,
  },
  {
    name: "Damara",
    country: "Central African Republic",
    subcountry: "Ombella-M'Poko",
    geonameid: 2387435,
  },
  {
    name: "Carnot",
    country: "Central African Republic",
    subcountry: "Mambéré-Kadéï",
    geonameid: 2387495,
  },
  {
    name: "Bozoum",
    country: "Central African Republic",
    subcountry: "Ouham-Pendé",
    geonameid: 2387546,
  },
  {
    name: "Bouar",
    country: "Central African Republic",
    subcountry: "Nana-Mambéré",
    geonameid: 2387926,
  },
  {
    name: "Bossangoa",
    country: "Central African Republic",
    subcountry: "Ouham",
    geonameid: 2388036,
  },
  {
    name: "Boda",
    country: "Central African Republic",
    subcountry: "Lobaye",
    geonameid: 2388614,
  },
  {
    name: "Bimbo",
    country: "Central African Republic",
    subcountry: "Ombella-M'Poko",
    geonameid: 2388873,
  },
  {
    name: "Berbérati",
    country: "Central African Republic",
    subcountry: "Mambéré-Kadéï",
    geonameid: 2389086,
  },
  {
    name: "Batangafo",
    country: "Central African Republic",
    subcountry: "Ouham",
    geonameid: 2389691,
  },
  {
    name: "Bangui",
    country: "Central African Republic",
    subcountry: "Bangui",
    geonameid: 2389853,
  },
  {
    name: "Sibiti",
    country: "Republic of the Congo",
    subcountry: "Lékoumou",
    geonameid: 2255285,
  },
  {
    name: "Pointe-Noire",
    country: "Republic of the Congo",
    subcountry: "Pointe-Noire",
    geonameid: 2255414,
  },
  {
    name: "Owando",
    country: "Republic of the Congo",
    subcountry: "Cuvette",
    geonameid: 2255542,
  },
  {
    name: "Ouésso",
    country: "Republic of the Congo",
    subcountry: "Sangha",
    geonameid: 2255564,
  },
  {
    name: "Mossendjo",
    country: "Republic of the Congo",
    subcountry: "Niari",
    geonameid: 2256895,
  },
  {
    name: "Madingou",
    country: "Republic of the Congo",
    subcountry: "Bouenza",
    geonameid: 2257990,
  },
  {
    name: "Dolisie",
    country: "Republic of the Congo",
    subcountry: "Niari",
    geonameid: 2258261,
  },
  {
    name: "Loandjili",
    country: "Republic of the Congo",
    subcountry: "Pointe-Noire",
    geonameid: 2258378,
  },
  {
    name: "Kayes",
    country: "Republic of the Congo",
    subcountry: "Bouenza",
    geonameid: 2259383,
  },
  {
    name: "Impfondo",
    country: "Republic of the Congo",
    subcountry: "Likouala",
    geonameid: 2259655,
  },
  {
    name: "Gamboma",
    country: "Republic of the Congo",
    subcountry: "Plateaux",
    geonameid: 2259947,
  },
  {
    name: "Brazzaville",
    country: "Republic of the Congo",
    subcountry: "Brazzaville",
    geonameid: 2260535,
  },
  {
    name: "Zürich",
    country: "Switzerland",
    subcountry: "Zurich",
    geonameid: 2657896,
  },
  {
    name: "Zug",
    country: "Switzerland",
    subcountry: "Zug",
    geonameid: 2657908,
  },
  {
    name: "Yverdon-les-Bains",
    country: "Switzerland",
    subcountry: "Vaud",
    geonameid: 2657941,
  },
  {
    name: "Winterthur",
    country: "Switzerland",
    subcountry: "Zurich",
    geonameid: 2657970,
  },
  {
    name: "Wil",
    country: "Switzerland",
    subcountry: "Saint Gallen",
    geonameid: 2657996,
  },
  {
    name: "Wetzikon",
    country: "Switzerland",
    subcountry: "Zurich",
    geonameid: 2658010,
  },
  {
    name: "Wettingen",
    country: "Switzerland",
    subcountry: "Aargau",
    geonameid: 2658011,
  },
  {
    name: "Vevey",
    country: "Switzerland",
    subcountry: "Vaud",
    geonameid: 2658145,
  },
  {
    name: "Vernier",
    country: "Switzerland",
    subcountry: "Geneva",
    geonameid: 2658154,
  },
  {
    name: "Uster",
    country: "Switzerland",
    subcountry: "Zurich",
    geonameid: 2658216,
  },
  {
    name: "Thun",
    country: "Switzerland",
    subcountry: "Bern",
    geonameid: 2658377,
  },
  {
    name: "Steffisburg",
    country: "Switzerland",
    subcountry: "Bern",
    geonameid: 2658494,
  },
  {
    name: "Sitten",
    country: "Switzerland",
    subcountry: "Valais",
    geonameid: 2658576,
  },
  {
    name: "Sierre",
    country: "Switzerland",
    subcountry: "Valais",
    geonameid: 2658606,
  },
  {
    name: "Zürich (Kreis 11) / Seebach",
    country: "Switzerland",
    subcountry: "Zurich",
    geonameid: 2658656,
  },
  {
    name: "Schaffhausen",
    country: "Switzerland",
    subcountry: "Schaffhausen",
    geonameid: 2658761,
  },
  {
    name: "Sankt Gallen",
    country: "Switzerland",
    subcountry: "Saint Gallen",
    geonameid: 2658822,
  },
  {
    name: "Renens",
    country: "Switzerland",
    subcountry: "Vaud",
    geonameid: 2659070,
  },
  {
    name: "Rapperswil",
    country: "Switzerland",
    subcountry: "Saint Gallen",
    geonameid: 2659099,
  },
  {
    name: "Pully",
    country: "Switzerland",
    subcountry: "Vaud",
    geonameid: 2659127,
  },
  {
    name: "Onex",
    country: "Switzerland",
    subcountry: "Geneva",
    geonameid: 2659296,
  },
  {
    name: "Olten",
    country: "Switzerland",
    subcountry: "Solothurn",
    geonameid: 2659297,
  },
  {
    name: "Zürich (Kreis 11) / Oerlikon",
    country: "Switzerland",
    subcountry: "Zurich",
    geonameid: 2659310,
  },
  {
    name: "Nyon",
    country: "Switzerland",
    subcountry: "Vaud",
    geonameid: 2659422,
  },
  {
    name: "Neuchâtel",
    country: "Switzerland",
    subcountry: "Neuchâtel",
    geonameid: 2659496,
  },
  {
    name: "Muttenz",
    country: "Switzerland",
    subcountry: "Basel-Landschaft",
    geonameid: 2659522,
  },
  {
    name: "Montreux",
    country: "Switzerland",
    subcountry: "Vaud",
    geonameid: 2659601,
  },
  {
    name: "Monthey",
    country: "Switzerland",
    subcountry: "Valais",
    geonameid: 2659613,
  },
  {
    name: "Meyrin",
    country: "Switzerland",
    subcountry: "Geneva",
    geonameid: 2659667,
  },
  {
    name: "Luzern",
    country: "Switzerland",
    subcountry: "Lucerne",
    geonameid: 2659811,
  },
  {
    name: "Lugano",
    country: "Switzerland",
    subcountry: "Ticino",
    geonameid: 2659836,
  },
  {
    name: "Littau",
    country: "Switzerland",
    subcountry: "Lucerne",
    geonameid: 2659873,
  },
  {
    name: "Lausanne",
    country: "Switzerland",
    subcountry: "Vaud",
    geonameid: 2659994,
  },
  {
    name: "La Chaux-de-Fonds",
    country: "Switzerland",
    subcountry: "Neuchâtel",
    geonameid: 2660076,
  },
  {
    name: "Kriens",
    country: "Switzerland",
    subcountry: "Lucerne",
    geonameid: 2660104,
  },
  {
    name: "Kreuzlingen",
    country: "Switzerland",
    subcountry: "Thurgau",
    geonameid: 2660108,
  },
  {
    name: "Köniz",
    country: "Switzerland",
    subcountry: "Bern",
    geonameid: 2660119,
  },
  {
    name: "Kloten",
    country: "Switzerland",
    subcountry: "Zurich",
    geonameid: 2660127,
  },
  {
    name: "Jona",
    country: "Switzerland",
    subcountry: "Saint Gallen",
    geonameid: 2660221,
  },
  {
    name: "Horgen",
    country: "Switzerland",
    subcountry: "Zurich",
    geonameid: 2660305,
  },
  {
    name: "Zürich (Kreis 10) / Höngg",
    country: "Switzerland",
    subcountry: "Zurich",
    geonameid: 2660306,
  },
  {
    name: "Herisau",
    country: "Switzerland",
    subcountry: "Appenzell Ausserrhoden",
    geonameid: 2660365,
  },
  {
    name: "Grenchen",
    country: "Switzerland",
    subcountry: "Solothurn",
    geonameid: 2660512,
  },
  {
    name: "Gossau",
    country: "Switzerland",
    subcountry: "Saint Gallen",
    geonameid: 2660549,
  },
  {
    name: "Genève",
    country: "Switzerland",
    subcountry: "Geneva",
    geonameid: 2660646,
  },
  {
    name: "Fribourg",
    country: "Switzerland",
    subcountry: "Fribourg",
    geonameid: 2660718,
  },
  {
    name: "Frauenfeld",
    country: "Switzerland",
    subcountry: "Thurgau",
    geonameid: 2660727,
  },
  {
    name: "Emmen",
    country: "Switzerland",
    subcountry: "Lucerne",
    geonameid: 2660911,
  },
  {
    name: "Dübendorf",
    country: "Switzerland",
    subcountry: "Zurich",
    geonameid: 2660971,
  },
  {
    name: "Dietikon",
    country: "Switzerland",
    subcountry: "Zurich",
    geonameid: 2661015,
  },
  {
    name: "Chur",
    country: "Switzerland",
    subcountry: "Grisons",
    geonameid: 2661169,
  },
  {
    name: "Cham",
    country: "Switzerland",
    subcountry: "Zug",
    geonameid: 2661228,
  },
  {
    name: "Carouge",
    country: "Switzerland",
    subcountry: "Geneva",
    geonameid: 2661265,
  },
  {
    name: "Burgdorf",
    country: "Switzerland",
    subcountry: "Bern",
    geonameid: 2661321,
  },
  {
    name: "Bulle",
    country: "Switzerland",
    subcountry: "Fribourg",
    geonameid: 2661337,
  },
  {
    name: "Biel/Bienne",
    country: "Switzerland",
    subcountry: "Bern",
    geonameid: 2661513,
  },
  {
    name: "Bern",
    country: "Switzerland",
    subcountry: "Bern",
    geonameid: 2661552,
  },
  {
    name: "Bellinzona",
    country: "Switzerland",
    subcountry: "Ticino",
    geonameid: 2661567,
  },
  {
    name: "Basel",
    country: "Switzerland",
    subcountry: "Basel-City",
    geonameid: 2661604,
  },
  {
    name: "Baden",
    country: "Switzerland",
    subcountry: "Aargau",
    geonameid: 2661646,
  },
  {
    name: "Baar",
    country: "Switzerland",
    subcountry: "Zug",
    geonameid: 2661653,
  },
  {
    name: "Zürich (Kreis 4) / Aussersihl",
    country: "Switzerland",
    subcountry: "Zurich",
    geonameid: 2661666,
  },
  {
    name: "Allschwil",
    country: "Switzerland",
    subcountry: "Basel-Landschaft",
    geonameid: 2661810,
  },
  {
    name: "Adliswil",
    country: "Switzerland",
    subcountry: "Zurich",
    geonameid: 2661861,
  },
  {
    name: "Aarau",
    country: "Switzerland",
    subcountry: "Aargau",
    geonameid: 2661881,
  },
  {
    name: "Riehen",
    country: "Switzerland",
    subcountry: "Basel-City",
    geonameid: 3206590,
  },
  {
    name: "Zürich (Kreis 10) / Wipkingen",
    country: "Switzerland",
    subcountry: "Zurich",
    geonameid: 6295475,
  },
  {
    name: "Zürich (Kreis 11) / Affoltern",
    country: "Switzerland",
    subcountry: "Zurich",
    geonameid: 6295484,
  },
  {
    name: "Zürich (Kreis 2) / Wollishofen",
    country: "Switzerland",
    subcountry: "Zurich",
    geonameid: 6295495,
  },
  {
    name: "Zürich (Kreis 3) / Sihlfeld",
    country: "Switzerland",
    subcountry: "Zurich",
    geonameid: 6295498,
  },
  {
    name: "Zürich (Kreis 6) / Unterstrass",
    country: "Switzerland",
    subcountry: "Zurich",
    geonameid: 6295504,
  },
  {
    name: "Zürich (Kreis 9) / Albisrieden",
    country: "Switzerland",
    subcountry: "Zurich",
    geonameid: 6295512,
  },
  {
    name: "Zürich (Kreis 9) / Altstetten",
    country: "Switzerland",
    subcountry: "Zurich",
    geonameid: 6295513,
  },
  {
    name: "Stadt Winterthur (Kreis 1)",
    country: "Switzerland",
    subcountry: "Zurich",
    geonameid: 6295520,
  },
  {
    name: "Zürich (Kreis 12)",
    country: "Switzerland",
    subcountry: "Zurich",
    geonameid: 6295523,
  },
  {
    name: "Seen (Kreis 3)",
    country: "Switzerland",
    subcountry: "Zurich",
    geonameid: 6295531,
  },
  {
    name: "Zürich (Kreis 3)",
    country: "Switzerland",
    subcountry: "Zurich",
    geonameid: 6295532,
  },
  {
    name: "Zürich (Kreis 11)",
    country: "Switzerland",
    subcountry: "Zurich",
    geonameid: 6295533,
  },
  {
    name: "Zürich (Kreis 9)",
    country: "Switzerland",
    subcountry: "Zurich",
    geonameid: 6295534,
  },
  {
    name: "Oberwinterthur (Kreis 2)",
    country: "Switzerland",
    subcountry: "Zurich",
    geonameid: 6295536,
  },
  {
    name: "Zürich (Kreis 10)",
    country: "Switzerland",
    subcountry: "Zurich",
    geonameid: 6295539,
  },
  {
    name: "Zürich (Kreis 2)",
    country: "Switzerland",
    subcountry: "Zurich",
    geonameid: 6295540,
  },
  {
    name: "Zürich (Kreis 8)",
    country: "Switzerland",
    subcountry: "Zurich",
    geonameid: 6295542,
  },
  {
    name: "Zürich (Kreis 7)",
    country: "Switzerland",
    subcountry: "Zurich",
    geonameid: 6295548,
  },
  {
    name: "Zürich (Kreis 6)",
    country: "Switzerland",
    subcountry: "Zurich",
    geonameid: 6295550,
  },
  {
    name: "Lancy",
    country: "Switzerland",
    subcountry: "Geneva",
    geonameid: 6691640,
  },
  {
    name: "Zuénoula",
    country: "Ivory Coast",
    subcountry: "Sassandra-Marahoué",
    geonameid: 2279172,
  },
  {
    name: "Yamoussoukro",
    country: "Ivory Coast",
    subcountry: "Lacs",
    geonameid: 2279755,
  },
  {
    name: "Vavoua",
    country: "Ivory Coast",
    subcountry: "Sassandra-Marahoué",
    geonameid: 2280045,
  },
  {
    name: "Toumodi",
    country: "Ivory Coast",
    subcountry: "Lacs",
    geonameid: 2280316,
  },
  {
    name: "Touba",
    country: "Ivory Coast",
    subcountry: "Woroba",
    geonameid: 2280376,
  },
  {
    name: "Tengréla",
    country: "Ivory Coast",
    subcountry: "Savanes",
    geonameid: 2280589,
  },
  {
    name: "Tiassalé",
    country: "Ivory Coast",
    subcountry: "Lagunes",
    geonameid: 2280761,
  },
  {
    name: "Tanda",
    country: "Ivory Coast",
    subcountry: "Zanzan",
    geonameid: 2280995,
  },
  {
    name: "Tabou",
    country: "Ivory Coast",
    subcountry: "Bas-Sassandra",
    geonameid: 2281120,
  },
  {
    name: "Sinfra",
    country: "Ivory Coast",
    subcountry: "Zanzan",
    geonameid: 2281606,
  },
  {
    name: "Sassandra",
    country: "Ivory Coast",
    subcountry: "Bas-Sassandra",
    geonameid: 2281951,
  },
  {
    name: "San-Pédro",
    country: "Ivory Coast",
    subcountry: "Bas-Sassandra",
    geonameid: 2282006,
  },
  {
    name: "Sakassou",
    country: "Ivory Coast",
    subcountry: "Vallée du Bandama",
    geonameid: 2282178,
  },
  {
    name: "Oumé",
    country: "Ivory Coast",
    subcountry: "Gôh-Djiboua",
    geonameid: 2282827,
  },
  {
    name: "Odienné",
    country: "Ivory Coast",
    subcountry: "Denguélé",
    geonameid: 2283016,
  },
  {
    name: "Mankono",
    country: "Ivory Coast",
    subcountry: "Woroba",
    geonameid: 2284589,
  },
  {
    name: "Man",
    country: "Ivory Coast",
    subcountry: "Montagnes",
    geonameid: 2284647,
  },
  {
    name: "Lakota",
    country: "Ivory Coast",
    subcountry: "Gôh-Djiboua",
    geonameid: 2285449,
  },
  {
    name: "Korhogo",
    country: "Ivory Coast",
    subcountry: "Savanes",
    geonameid: 2286304,
  },
  {
    name: "Katiola",
    country: "Ivory Coast",
    subcountry: "Vallée du Bandama",
    geonameid: 2287298,
  },
  {
    name: "Issia",
    country: "Ivory Coast",
    subcountry: "Sassandra-Marahoué",
    geonameid: 2287790,
  },
  {
    name: "Guiglo",
    country: "Ivory Coast",
    subcountry: "Montagnes",
    geonameid: 2287958,
  },
  {
    name: "Guibéroua",
    country: "Ivory Coast",
    subcountry: "Gôh-Djiboua",
    geonameid: 2287970,
  },
  {
    name: "Grand-Bassam",
    country: "Ivory Coast",
    subcountry: "Comoé",
    geonameid: 2288115,
  },
  {
    name: "Affery",
    country: "Ivory Coast",
    subcountry: "Lagunes",
    geonameid: 2288118,
  },
  {
    name: "Gagnoa",
    country: "Ivory Coast",
    subcountry: "Gôh-Djiboua",
    geonameid: 2288829,
  },
  {
    name: "Ferkessédougou",
    country: "Ivory Coast",
    subcountry: "Savanes",
    geonameid: 2289049,
  },
  {
    name: "Duekoué",
    country: "Ivory Coast",
    subcountry: "Montagnes",
    geonameid: 2289549,
  },
  {
    name: "Doropo",
    country: "Ivory Coast",
    subcountry: "Zanzan",
    geonameid: 2289724,
  },
  {
    name: "Divo",
    country: "Ivory Coast",
    subcountry: "Gôh-Djiboua",
    geonameid: 2289887,
  },
  {
    name: "Dimbokro",
    country: "Ivory Coast",
    subcountry: "Lacs",
    geonameid: 2289983,
  },
  {
    name: "Daoukro",
    country: "Ivory Coast",
    subcountry: "Lacs",
    geonameid: 2290412,
  },
  {
    name: "Danané",
    country: "Ivory Coast",
    subcountry: "Montagnes",
    geonameid: 2290462,
  },
  {
    name: "Daloa",
    country: "Ivory Coast",
    subcountry: "Sassandra-Marahoué",
    geonameid: 2290486,
  },
  {
    name: "Dabou",
    country: "Ivory Coast",
    subcountry: "Lagunes",
    geonameid: 2290582,
  },
  {
    name: "Boundiali",
    country: "Ivory Coast",
    subcountry: "Savanes",
    geonameid: 2290836,
  },
  {
    name: "Bouna",
    country: "Ivory Coast",
    subcountry: "Zanzan",
    geonameid: 2290849,
  },
  {
    name: "Bouaké",
    country: "Ivory Coast",
    subcountry: "Vallée du Bandama",
    geonameid: 2290956,
  },
  {
    name: "Bouaflé",
    country: "Ivory Coast",
    subcountry: "Sassandra-Marahoué",
    geonameid: 2290964,
  },
  {
    name: "Bonoua",
    country: "Ivory Coast",
    subcountry: "Comoé",
    geonameid: 2291087,
  },
  {
    name: "Bongouanou",
    country: "Ivory Coast",
    subcountry: "Lacs",
    geonameid: 2291113,
  },
  {
    name: "Bondoukou",
    country: "Ivory Coast",
    subcountry: "Zanzan",
    geonameid: 2291136,
  },
  {
    name: "Bingerville",
    country: "Ivory Coast",
    subcountry: "Abidjan",
    geonameid: 2291580,
  },
  {
    name: "Biankouma",
    country: "Ivory Coast",
    subcountry: "Montagnes",
    geonameid: 2291666,
  },
  {
    name: "Béoumi",
    country: "Ivory Coast",
    subcountry: "Vallée du Bandama",
    geonameid: 2291779,
  },
  {
    name: "Bangolo",
    country: "Ivory Coast",
    subcountry: "Montagnes",
    geonameid: 2292179,
  },
  {
    name: "Arrah",
    country: "Ivory Coast",
    subcountry: "Lacs",
    geonameid: 2292755,
  },
  {
    name: "Anyama",
    country: "Ivory Coast",
    subcountry: "Abidjan",
    geonameid: 2292852,
  },
  {
    name: "Akoupé",
    country: "Ivory Coast",
    subcountry: "Lagunes",
    geonameid: 2293107,
  },
  {
    name: "Agnibilékrou",
    country: "Ivory Coast",
    subcountry: "Comoé",
    geonameid: 2293260,
  },
  {
    name: "Agboville",
    country: "Ivory Coast",
    subcountry: "Lagunes",
    geonameid: 2293268,
  },
  {
    name: "Adzopé",
    country: "Ivory Coast",
    subcountry: "Lagunes",
    geonameid: 2293342,
  },
  {
    name: "Adiaké",
    country: "Ivory Coast",
    subcountry: "Comoé",
    geonameid: 2293428,
  },
  {
    name: "Aboisso",
    country: "Ivory Coast",
    subcountry: "Comoé",
    geonameid: 2293507,
  },
  {
    name: "Abobo",
    country: "Ivory Coast",
    subcountry: "Abidjan",
    geonameid: 2293521,
  },
  {
    name: "Abidjan",
    country: "Ivory Coast",
    subcountry: "Abidjan",
    geonameid: 2293538,
  },
  {
    name: "Abengourou",
    country: "Ivory Coast",
    subcountry: "Comoé",
    geonameid: 2293549,
  },
  {
    name: "Marcory",
    country: "Ivory Coast",
    subcountry: "Abidjan",
    geonameid: 2595323,
  },
  {
    name: "Ahouanou",
    country: "Ivory Coast",
    subcountry: "Lagunes",
    geonameid: 2596898,
  },
  {
    name: "Séguéla",
    country: "Ivory Coast",
    subcountry: "Woroba",
    geonameid: 2596934,
  },
  {
    name: "Avarua",
    country: "Cook Islands",
    subcountry: "Rarotonga",
    geonameid: 4035715,
  },
  {
    name: "Viña del Mar",
    country: "Chile",
    subcountry: "Valparaíso",
    geonameid: 3868121,
  },
  {
    name: "Villarrica",
    country: "Chile",
    subcountry: "Araucanía",
    geonameid: 3868158,
  },
  {
    name: "Villa Alemana",
    country: "Chile",
    subcountry: "Valparaíso",
    geonameid: 3868192,
  },
  {
    name: "Victoria",
    country: "Chile",
    subcountry: "Araucanía",
    geonameid: 3868326,
  },
  {
    name: "Valparaíso",
    country: "Chile",
    subcountry: "Valparaíso",
    geonameid: 3868626,
  },
  {
    name: "Vallenar",
    country: "Chile",
    subcountry: "Atacama",
    geonameid: 3868633,
  },
  {
    name: "Valdivia",
    country: "Chile",
    subcountry: "Los Ríos Region",
    geonameid: 3868707,
  },
  {
    name: "Tomé",
    country: "Chile",
    subcountry: "Biobío",
    geonameid: 3869657,
  },
  {
    name: "Tocopilla",
    country: "Chile",
    subcountry: "Antofagasta",
    geonameid: 3869716,
  },
  {
    name: "Temuco",
    country: "Chile",
    subcountry: "Araucanía",
    geonameid: 3870011,
  },
  {
    name: "Talcahuano",
    country: "Chile",
    subcountry: "Biobío",
    geonameid: 3870282,
  },
  {
    name: "Talca",
    country: "Chile",
    subcountry: "Maule Region",
    geonameid: 3870294,
  },
  {
    name: "Talagante",
    country: "Chile",
    subcountry: "Santiago Metropolitan",
    geonameid: 3870306,
  },
  {
    name: "San Vicente de Tagua Tagua",
    country: "Chile",
    subcountry: "O'Higgins Region",
    geonameid: 3871276,
  },
  {
    name: "San Vicente",
    country: "Chile",
    subcountry: "O'Higgins Region",
    geonameid: 3871286,
  },
  {
    name: "Santiago",
    country: "Chile",
    subcountry: "Santiago Metropolitan",
    geonameid: 3871336,
  },
  {
    name: "Santa Cruz",
    country: "Chile",
    subcountry: "O'Higgins Region",
    geonameid: 3871616,
  },
  {
    name: "San Javier",
    country: "Chile",
    subcountry: "Maule Region",
    geonameid: 3872154,
  },
  {
    name: "San Felipe",
    country: "Chile",
    subcountry: "Valparaíso",
    geonameid: 3872255,
  },
  {
    name: "San Carlos",
    country: "Chile",
    subcountry: "Ñuble",
    geonameid: 3872326,
  },
  {
    name: "San Bernardo",
    country: "Chile",
    subcountry: "Santiago Metropolitan",
    geonameid: 3872348,
  },
  {
    name: "San Antonio",
    country: "Chile",
    subcountry: "Valparaíso",
    geonameid: 3872395,
  },
  {
    name: "Río Bueno",
    country: "Chile",
    subcountry: "Los Ríos Region",
    geonameid: 3873145,
  },
  {
    name: "Rengo",
    country: "Chile",
    subcountry: "O'Higgins Region",
    geonameid: 3873441,
  },
  {
    name: "Rancagua",
    country: "Chile",
    subcountry: "O'Higgins Region",
    geonameid: 3873775,
  },
  {
    name: "Quilpué",
    country: "Chile",
    subcountry: "Valparaíso",
    geonameid: 3874096,
  },
  {
    name: "Quillota",
    country: "Chile",
    subcountry: "Valparaíso",
    geonameid: 3874119,
  },
  {
    name: "Punta Arenas",
    country: "Chile",
    subcountry: "Region of Magallanes",
    geonameid: 3874787,
  },
  {
    name: "Puerto Varas",
    country: "Chile",
    subcountry: "Los Lagos Region",
    geonameid: 3874930,
  },
  {
    name: "Quellón",
    country: "Chile",
    subcountry: "Los Lagos Region",
    geonameid: 3874943,
  },
  {
    name: "Puerto Natales",
    country: "Chile",
    subcountry: "Region of Magallanes",
    geonameid: 3874958,
  },
  {
    name: "Puerto Montt",
    country: "Chile",
    subcountry: "Los Lagos Region",
    geonameid: 3874960,
  },
  {
    name: "Puerto Aysén",
    country: "Chile",
    subcountry: "Aysén",
    geonameid: 3874997,
  },
  {
    name: "Puente Alto",
    country: "Chile",
    subcountry: "Santiago Metropolitan",
    geonameid: 3875024,
  },
  {
    name: "Pucón",
    country: "Chile",
    subcountry: "Araucanía",
    geonameid: 3875070,
  },
  {
    name: "Pozo Almonte",
    country: "Chile",
    subcountry: "Tarapacá",
    geonameid: 3875235,
  },
  {
    name: "Penco",
    country: "Chile",
    subcountry: "Biobío",
    geonameid: 3876664,
  },
  {
    name: "Peñaflor",
    country: "Chile",
    subcountry: "Santiago Metropolitan",
    geonameid: 3876685,
  },
  {
    name: "Parral",
    country: "Chile",
    subcountry: "Maule Region",
    geonameid: 3877146,
  },
  {
    name: "Panguipulli",
    country: "Chile",
    subcountry: "Los Ríos Region",
    geonameid: 3877348,
  },
  {
    name: "Paine",
    country: "Chile",
    subcountry: "Santiago Metropolitan",
    geonameid: 3877739,
  },
  {
    name: "Ovalle",
    country: "Chile",
    subcountry: "Coquimbo Region",
    geonameid: 3877918,
  },
  {
    name: "Osorno",
    country: "Chile",
    subcountry: "Los Lagos Region",
    geonameid: 3877949,
  },
  {
    name: "Nueva Imperial",
    country: "Chile",
    subcountry: "Araucanía",
    geonameid: 3878456,
  },
  {
    name: "Nacimiento",
    country: "Chile",
    subcountry: "Biobío",
    geonameid: 3879123,
  },
  {
    name: "Mulchén",
    country: "Chile",
    subcountry: "Biobío",
    geonameid: 3879200,
  },
  {
    name: "Molina",
    country: "Chile",
    subcountry: "Maule Region",
    geonameid: 3879627,
  },
  {
    name: "Melipilla",
    country: "Chile",
    subcountry: "Santiago Metropolitan",
    geonameid: 3880107,
  },
  {
    name: "Machalí",
    country: "Chile",
    subcountry: "O'Higgins Region",
    geonameid: 3881102,
  },
  {
    name: "Lota",
    country: "Chile",
    subcountry: "Biobío",
    geonameid: 3881276,
  },
  {
    name: "Los Ángeles",
    country: "Chile",
    subcountry: "Biobío",
    geonameid: 3882428,
  },
  {
    name: "Los Andes",
    country: "Chile",
    subcountry: "Valparaíso",
    geonameid: 3882434,
  },
  {
    name: "Loncoche",
    country: "Chile",
    subcountry: "Araucanía",
    geonameid: 3882582,
  },
  {
    name: "Llaillay",
    country: "Chile",
    subcountry: "Valparaíso",
    geonameid: 3883035,
  },
  {
    name: "Linares",
    country: "Chile",
    subcountry: "Maule Region",
    geonameid: 3883167,
  },
  {
    name: "Limache",
    country: "Chile",
    subcountry: "Valparaíso",
    geonameid: 3883214,
  },
  {
    name: "Lebu",
    country: "Chile",
    subcountry: "Biobío",
    geonameid: 3883457,
  },
  {
    name: "Lautaro",
    country: "Chile",
    subcountry: "Araucanía",
    geonameid: 3883615,
  },
  {
    name: "La Unión",
    country: "Chile",
    subcountry: "Los Ríos Region",
    geonameid: 3883629,
  },
  {
    name: "La Serena",
    country: "Chile",
    subcountry: "Coquimbo Region",
    geonameid: 3884373,
  },
  {
    name: "Lampa",
    country: "Chile",
    subcountry: "Santiago Metropolitan",
    geonameid: 3885273,
  },
  {
    name: "La Ligua",
    country: "Chile",
    subcountry: "Valparaíso",
    geonameid: 3885456,
  },
  {
    name: "Laja",
    country: "Chile",
    subcountry: "Biobío",
    geonameid: 3885509,
  },
  {
    name: "Iquique",
    country: "Chile",
    subcountry: "Tarapacá",
    geonameid: 3887127,
  },
  {
    name: "Illapel",
    country: "Chile",
    subcountry: "Coquimbo Region",
    geonameid: 3887344,
  },
  {
    name: "Hacienda La Calera",
    country: "Chile",
    subcountry: "Valparaíso",
    geonameid: 3888214,
  },
  {
    name: "Graneros",
    country: "Chile",
    subcountry: "O'Higgins Region",
    geonameid: 3888749,
  },
  {
    name: "El Monte",
    country: "Chile",
    subcountry: "Santiago Metropolitan",
    geonameid: 3890949,
  },
  {
    name: "Diego de Almagro",
    country: "Chile",
    subcountry: "Atacama",
    geonameid: 3892454,
  },
  {
    name: "Curicó",
    country: "Chile",
    subcountry: "Maule Region",
    geonameid: 3892870,
  },
  {
    name: "Curanilahue",
    country: "Chile",
    subcountry: "Biobío",
    geonameid: 3892892,
  },
  {
    name: "Coronel",
    country: "Chile",
    subcountry: "Biobío",
    geonameid: 3893532,
  },
  {
    name: "Coquimbo",
    country: "Chile",
    subcountry: "Coquimbo Region",
    geonameid: 3893629,
  },
  {
    name: "Copiapó",
    country: "Chile",
    subcountry: "Atacama",
    geonameid: 3893656,
  },
  {
    name: "Constitución",
    country: "Chile",
    subcountry: "Maule Region",
    geonameid: 3893726,
  },
  {
    name: "Concepción",
    country: "Chile",
    subcountry: "Biobío",
    geonameid: 3893894,
  },
  {
    name: "Collipulli",
    country: "Chile",
    subcountry: "Araucanía",
    geonameid: 3894177,
  },
  {
    name: "Coyhaique",
    country: "Chile",
    subcountry: "Aysén",
    geonameid: 3894426,
  },
  {
    name: "Chimbarongo",
    country: "Chile",
    subcountry: "O'Higgins Region",
    geonameid: 3895061,
  },
  {
    name: "Chillán",
    country: "Chile",
    subcountry: "Ñuble",
    geonameid: 3895088,
  },
  {
    name: "Chiguayante",
    country: "Chile",
    subcountry: "Biobío",
    geonameid: 3895138,
  },
  {
    name: "Chicureo",
    country: "Chile",
    subcountry: "Santiago Metropolitan",
    geonameid: 3895165,
  },
  {
    name: "Cavancha",
    country: "Chile",
    subcountry: "Tarapacá",
    geonameid: 3896085,
  },
  {
    name: "Cauquenes",
    country: "Chile",
    subcountry: "Maule Region",
    geonameid: 3896105,
  },
  {
    name: "Castro",
    country: "Chile",
    subcountry: "Los Lagos Region",
    geonameid: 3896218,
  },
  {
    name: "Cartagena",
    country: "Chile",
    subcountry: "Valparaíso",
    geonameid: 3896433,
  },
  {
    name: "Cañete",
    country: "Chile",
    subcountry: "Biobío",
    geonameid: 3896924,
  },
  {
    name: "Calama",
    country: "Chile",
    subcountry: "Antofagasta",
    geonameid: 3897347,
  },
  {
    name: "Cabrero",
    country: "Chile",
    subcountry: "Biobío",
    geonameid: 3897557,
  },
  {
    name: "Buin",
    country: "Chile",
    subcountry: "Santiago Metropolitan",
    geonameid: 3897774,
  },
  {
    name: "Arica",
    country: "Chile",
    subcountry: "Arica y Parinacota",
    geonameid: 3899361,
  },
  {
    name: "Arauco",
    country: "Chile",
    subcountry: "Biobío",
    geonameid: 3899462,
  },
  {
    name: "Antofagasta",
    country: "Chile",
    subcountry: "Antofagasta",
    geonameid: 3899539,
  },
  {
    name: "Angol",
    country: "Chile",
    subcountry: "Araucanía",
    geonameid: 3899629,
  },
  {
    name: "Ancud",
    country: "Chile",
    subcountry: "Los Lagos Region",
    geonameid: 3899695,
  },
  {
    name: "Alto Hospicio",
    country: "Chile",
    subcountry: "Tarapacá",
    geonameid: 3899887,
  },
  {
    name: "Las Animas",
    country: "Chile",
    subcountry: "Los Ríos Region",
    geonameid: 6458708,
  },
  {
    name: "La Pintana",
    country: "Chile",
    subcountry: "Santiago Metropolitan",
    geonameid: 7281017,
  },
  {
    name: "Lo Prado",
    country: "Chile",
    subcountry: "Santiago Metropolitan",
    geonameid: 7281020,
  },
  {
    name: "Goméz Carreño",
    country: "Chile",
    subcountry: "Tarapacá",
    geonameid: 12094914,
  },
  {
    name: "Playa Brava",
    country: "Chile",
    subcountry: "Tarapacá",
    geonameid: 12094915,
  },
  {
    name: "La Tirana",
    country: "Chile",
    subcountry: "Tarapacá",
    geonameid: 12094916,
  },
  {
    name: "Caupolicán",
    country: "Chile",
    subcountry: "Tarapacá",
    geonameid: 12094917,
  },
  {
    name: "Yaoundé",
    country: "Cameroon",
    subcountry: "Centre",
    geonameid: 2220957,
  },
  {
    name: "Yagoua",
    country: "Cameroon",
    subcountry: "Far North",
    geonameid: 2221030,
  },
  {
    name: "Wum",
    country: "Cameroon",
    subcountry: "North-West",
    geonameid: 2221053,
  },
  {
    name: "Tonga",
    country: "Cameroon",
    subcountry: "West",
    geonameid: 2221394,
  },
  {
    name: "Tiko",
    country: "Cameroon",
    subcountry: "South-West",
    geonameid: 2221504,
  },
  {
    name: "Tibati",
    country: "Cameroon",
    subcountry: "Adamaoua",
    geonameid: 2221530,
  },
  {
    name: "Tcholliré",
    country: "Cameroon",
    subcountry: "North",
    geonameid: 2221607,
  },
  {
    name: "Sangmélima",
    country: "Cameroon",
    subcountry: "South",
    geonameid: 2222230,
  },
  {
    name: "Penja",
    country: "Cameroon",
    subcountry: "Littoral",
    geonameid: 2222623,
  },
  {
    name: "Obala",
    country: "Cameroon",
    subcountry: "Centre",
    geonameid: 2223293,
  },
  {
    name: "Nkoteng",
    country: "Cameroon",
    subcountry: "Centre",
    geonameid: 2223734,
  },
  {
    name: "Nkongsamba",
    country: "Cameroon",
    subcountry: "Littoral",
    geonameid: 2223763,
  },
  {
    name: "Ngaoundéré",
    country: "Cameroon",
    subcountry: "Adamaoua",
    geonameid: 2224827,
  },
  {
    name: "Nanga Eboko",
    country: "Cameroon",
    subcountry: "Centre",
    geonameid: 2225457,
  },
  {
    name: "Muyuka",
    country: "Cameroon",
    subcountry: "South-West",
    geonameid: 2225726,
  },
  {
    name: "Mutengene",
    country: "Cameroon",
    subcountry: "South-West",
    geonameid: 2225728,
  },
  {
    name: "Mora",
    country: "Cameroon",
    subcountry: "Far North",
    geonameid: 2225991,
  },
  {
    name: "Mokolo",
    country: "Cameroon",
    subcountry: "Far North",
    geonameid: 2226275,
  },
  {
    name: "Melong",
    country: "Cameroon",
    subcountry: "Littoral",
    geonameid: 2227230,
  },
  {
    name: "Meïganga",
    country: "Cameroon",
    subcountry: "Adamaoua",
    geonameid: 2227402,
  },
  {
    name: "Mbouda",
    country: "Cameroon",
    subcountry: "West",
    geonameid: 2227613,
  },
  {
    name: "Mbanga",
    country: "Cameroon",
    subcountry: "Littoral",
    geonameid: 2228005,
  },
  {
    name: "Mbandjok",
    country: "Cameroon",
    subcountry: "Centre",
    geonameid: 2228028,
  },
  {
    name: "Mbalmayo",
    country: "Cameroon",
    subcountry: "Centre",
    geonameid: 2228079,
  },
  {
    name: "Maroua",
    country: "Cameroon",
    subcountry: "Far North",
    geonameid: 2228373,
  },
  {
    name: "Manjo",
    country: "Cameroon",
    subcountry: "Littoral",
    geonameid: 2228499,
  },
  {
    name: "Mamfe",
    country: "Cameroon",
    subcountry: "South-West",
    geonameid: 2228675,
  },
  {
    name: "Loum",
    country: "Cameroon",
    subcountry: "Littoral",
    geonameid: 2229152,
  },
  {
    name: "Lolodorf",
    country: "Cameroon",
    subcountry: "South",
    geonameid: 2229267,
  },
  {
    name: "Limbe",
    country: "Cameroon",
    subcountry: "South-West",
    geonameid: 2229411,
  },
  {
    name: "Lagdo",
    country: "Cameroon",
    subcountry: "North",
    geonameid: 2229681,
  },
  {
    name: "Kumbo",
    country: "Cameroon",
    subcountry: "North-West",
    geonameid: 2229748,
  },
  {
    name: "Kumba",
    country: "Cameroon",
    subcountry: "South-West",
    geonameid: 2229752,
  },
  {
    name: "Kribi",
    country: "Cameroon",
    subcountry: "South",
    geonameid: 2229761,
  },
  {
    name: "Kousséri",
    country: "Cameroon",
    subcountry: "Far North",
    geonameid: 2229798,
  },
  {
    name: "Kaélé",
    country: "Cameroon",
    subcountry: "Far North",
    geonameid: 2230599,
  },
  {
    name: "Guider",
    country: "Cameroon",
    subcountry: "North",
    geonameid: 2230876,
  },
  {
    name: "Garoua Boulaï",
    country: "Cameroon",
    subcountry: "East",
    geonameid: 2231319,
  },
  {
    name: "Garoua",
    country: "Cameroon",
    subcountry: "North",
    geonameid: 2231320,
  },
  {
    name: "Fundong",
    country: "Cameroon",
    subcountry: "North-West",
    geonameid: 2231482,
  },
  {
    name: "Foumbot",
    country: "Cameroon",
    subcountry: "West",
    geonameid: 2231504,
  },
  {
    name: "Foumban",
    country: "Cameroon",
    subcountry: "West",
    geonameid: 2231506,
  },
  {
    name: "Fontem",
    country: "Cameroon",
    subcountry: "South-West",
    geonameid: 2231564,
  },
  {
    name: "Eséka",
    country: "Cameroon",
    subcountry: "Centre",
    geonameid: 2231881,
  },
  {
    name: "Edéa",
    country: "Cameroon",
    subcountry: "Littoral",
    geonameid: 2232239,
  },
  {
    name: "Ébolowa",
    country: "Cameroon",
    subcountry: "South",
    geonameid: 2232283,
  },
  {
    name: "Dschang",
    country: "Cameroon",
    subcountry: "West",
    geonameid: 2232444,
  },
  {
    name: "Douala",
    country: "Cameroon",
    subcountry: "Littoral",
    geonameid: 2232593,
  },
  {
    name: "Dizangué",
    country: "Cameroon",
    subcountry: "Littoral",
    geonameid: 2232997,
  },
  {
    name: "Buea",
    country: "Cameroon",
    subcountry: "South-West",
    geonameid: 2233410,
  },
  {
    name: "Bogo",
    country: "Cameroon",
    subcountry: "Far North",
    geonameid: 2233805,
  },
  {
    name: "Bertoua",
    country: "Cameroon",
    subcountry: "East",
    geonameid: 2234359,
  },
  {
    name: "Bélabo",
    country: "Cameroon",
    subcountry: "East",
    geonameid: 2234536,
  },
  {
    name: "Batouri",
    country: "Cameroon",
    subcountry: "East",
    geonameid: 2234663,
  },
  {
    name: "Banyo",
    country: "Cameroon",
    subcountry: "Adamaoua",
    geonameid: 2234794,
  },
  {
    name: "Bangangté",
    country: "Cameroon",
    subcountry: "West",
    geonameid: 2234865,
  },
  {
    name: "Bamusso",
    country: "Cameroon",
    subcountry: "South-West",
    geonameid: 2234941,
  },
  {
    name: "Bamenda",
    country: "Cameroon",
    subcountry: "North-West",
    geonameid: 2234974,
  },
  {
    name: "Bali",
    country: "Cameroon",
    subcountry: "North-West",
    geonameid: 2235029,
  },
  {
    name: "Bafoussam",
    country: "Cameroon",
    subcountry: "West",
    geonameid: 2235189,
  },
  {
    name: "Bafia",
    country: "Cameroon",
    subcountry: "Centre",
    geonameid: 2235194,
  },
  {
    name: "Bafang",
    country: "Cameroon",
    subcountry: "West",
    geonameid: 2235196,
  },
  {
    name: "Akonolinga",
    country: "Cameroon",
    subcountry: "Centre",
    geonameid: 2235776,
  },
  {
    name: "Zhefang",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1279471,
  },
  {
    name: "Zhangfeng",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1279485,
  },
  {
    name: "Zepu",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1279501,
  },
  {
    name: "Zibihu",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1279553,
  },
  {
    name: "Yingpan",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1279575,
  },
  {
    name: "Rikaze",
    country: "China",
    subcountry: "Tibet",
    geonameid: 1279715,
  },
  {
    name: "Tengyue",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1279891,
  },
  {
    name: "Jiuquan",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1279945,
  },
  {
    name: "Shigu",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1280006,
  },
  {
    name: "Shangyun",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1280023,
  },
  {
    name: "Shangpa",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1280031,
  },
  {
    name: "Shache",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1280037,
  },
  {
    name: "Ruidian",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1280124,
  },
  {
    name: "Qushi",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1280186,
  },
  {
    name: "Qiemo",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1280249,
  },
  {
    name: "Qarek",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1280267,
  },
  {
    name: "Qamdo",
    country: "China",
    subcountry: "Tibet",
    geonameid: 1280281,
  },
  {
    name: "Yingjiang",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1280328,
  },
  {
    name: "Oytograk",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1280361,
  },
  {
    name: "Nagqu",
    country: "China",
    subcountry: "Tibet",
    geonameid: 1280517,
  },
  {
    name: "Qaraqash",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1280541,
  },
  {
    name: "Mengmao",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1280570,
  },
  {
    name: "Menglang",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1280574,
  },
  {
    name: "Mangshi",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1280623,
  },
  {
    name: "Liuku",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1280703,
  },
  {
    name: "Lhasa",
    country: "China",
    subcountry: "Tibet",
    geonameid: 1280737,
  },
  {
    name: "Laojunmiao",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1280757,
  },
  {
    name: "Bonan",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1280759,
  },
  {
    name: "Langru",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1280763,
  },
  {
    name: "Kokyar",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1280822,
  },
  {
    name: "Kashgar",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1280849,
  },
  {
    name: "Kaqun",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1280873,
  },
  {
    name: "Judian",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1280921,
  },
  {
    name: "Jinhua",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1280945,
  },
  {
    name: "Jinding",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1280948,
  },
  {
    name: "Jietou",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1280951,
  },
  {
    name: "Jiayuguan",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1280957,
  },
  {
    name: "Houqiao",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1281015,
  },
  {
    name: "Hotan",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1281019,
  },
  {
    name: "Gudong",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1281157,
  },
  {
    name: "Elixku",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1281278,
  },
  {
    name: "Dêqên",
    country: "China",
    subcountry: "Tibet",
    geonameid: 1281368,
  },
  {
    name: "Langgar",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1281622,
  },
  {
    name: "Baoshan",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1281673,
  },
  {
    name: "Layka",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1346629,
  },
  {
    name: "Saybag",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1346630,
  },
  {
    name: "Arix",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1346644,
  },
  {
    name: "Xambabazar",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1346645,
  },
  {
    name: "Xinyuan",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1529046,
  },
  {
    name: "Wusu",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1529099,
  },
  {
    name: "Ürümqi",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1529102,
  },
  {
    name: "Turpan",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1529114,
  },
  {
    name: "Tacheng",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1529167,
  },
  {
    name: "Shihezi",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1529195,
  },
  {
    name: "Sandaohezi",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1529239,
  },
  {
    name: "Qapqal",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1529279,
  },
  {
    name: "Kuqa",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1529363,
  },
  {
    name: "Korla",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1529376,
  },
  {
    name: "Karamay",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1529401,
  },
  {
    name: "Jelilyüzi",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1529420,
  },
  {
    name: "Yili",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1529435,
  },
  {
    name: "Hoxtolgay",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1529452,
  },
  {
    name: "Hami",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1529484,
  },
  {
    name: "Fuyun",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1529504,
  },
  {
    name: "Emin",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1529522,
  },
  {
    name: "Dushanzi",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1529528,
  },
  {
    name: "Dure",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1529529,
  },
  {
    name: "Dunhuang",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1529531,
  },
  {
    name: "Changji",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1529569,
  },
  {
    name: "Burqin",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1529574,
  },
  {
    name: "Baijiantan",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1529626,
  },
  {
    name: "Aral",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1529641,
  },
  {
    name: "Altay",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1529651,
  },
  {
    name: "Aksu",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1529660,
  },
  {
    name: "Oymak",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1538338,
  },
  {
    name: "Kax",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1538369,
  },
  {
    name: "Baytokay",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1538370,
  },
  {
    name: "Yengitam",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1538371,
  },
  {
    name: "Dadamtu",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1538375,
  },
  {
    name: "Yuqunweng",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1538377,
  },
  {
    name: "Panjim",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 1538378,
  },
  {
    name: "Liangji",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1549360,
  },
  {
    name: "Lanshan",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1549362,
  },
  {
    name: "Qing’an",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1549365,
  },
  {
    name: "Malingshan",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1549428,
  },
  {
    name: "Chenlou",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1549500,
  },
  {
    name: "Hegou",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1549510,
  },
  {
    name: "Gangshang",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1549538,
  },
  {
    name: "Zouzhuang",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1549554,
  },
  {
    name: "Tangzhang",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1549622,
  },
  {
    name: "Hanwang",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1549635,
  },
  {
    name: "Yitang",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1549651,
  },
  {
    name: "Xuzhuang",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1549660,
  },
  {
    name: "Nianzhuang",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1549667,
  },
  {
    name: "Tashan",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1549691,
  },
  {
    name: "Zizhuang",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1549693,
  },
  {
    name: "Liuji",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1549696,
  },
  {
    name: "Jiangzhuang",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1549734,
  },
  {
    name: "Daizhuang",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1549741,
  },
  {
    name: "Zhangzhuang",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1549743,
  },
  {
    name: "Xinglou",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1549747,
  },
  {
    name: "Huzhai",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1549750,
  },
  {
    name: "Heqiao",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1549754,
  },
  {
    name: "Fanlou",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1549756,
  },
  {
    name: "Hekou",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1549771,
  },
  {
    name: "Songlou",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1549774,
  },
  {
    name: "Sunlou",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1549795,
  },
  {
    name: "Zhuzhai",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1549804,
  },
  {
    name: "Zhaozhuang",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1549810,
  },
  {
    name: "Anguo",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1549817,
  },
  {
    name: "Shizhai",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1549819,
  },
  {
    name: "Yaxing",
    country: "China",
    subcountry: "Hainan",
    geonameid: 1783554,
  },
  {
    name: "Lintan Chengguanzhen",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1783557,
  },
  {
    name: "Zunyi",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 1783621,
  },
  {
    name: "Zuitai",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1783626,
  },
  {
    name: "Zoucheng",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1783633,
  },
  {
    name: "Nima",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1783666,
  },
  {
    name: "Ziyang Chengguanzhen",
    country: "China",
    subcountry: "Shaanxi",
    geonameid: 1783682,
  },
  {
    name: "Ziyang",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1783683,
  },
  {
    name: "Zitong",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1783700,
  },
  {
    name: "Zishui",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1783701,
  },
  {
    name: "Zigong",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1783745,
  },
  {
    name: "Zhuzhou",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1783763,
  },
  {
    name: "Zhuyuan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1783771,
  },
  {
    name: "Zhuyang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1783782,
  },
  {
    name: "Zhuxi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1783793,
  },
  {
    name: "Zhutuo",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1783802,
  },
  {
    name: "Zhuoshui",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1783858,
  },
  {
    name: "Zhumadian",
    country: "China",
    subcountry: "Henan",
    geonameid: 1783873,
  },
  {
    name: "Zhujiajiao",
    country: "China",
    subcountry: "Shanghai",
    geonameid: 1783920,
  },
  {
    name: "Shangqiu",
    country: "China",
    subcountry: "Henan",
    geonameid: 1783934,
  },
  {
    name: "Zhuji",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1783940,
  },
  {
    name: "Zhouqu Chengguanzhen",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1783956,
  },
  {
    name: "Zhucheng",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1783988,
  },
  {
    name: "Zhuanghe",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 1784055,
  },
  {
    name: "Zhouzhuang",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1784074,
  },
  {
    name: "Zhouxi",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 1784089,
  },
  {
    name: "Zhoukou",
    country: "China",
    subcountry: "Henan",
    geonameid: 1784130,
  },
  {
    name: "Zhoujia",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1784157,
  },
  {
    name: "Zhoucun",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1784178,
  },
  {
    name: "Yuxi",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1784185,
  },
  {
    name: "Zhongzhai",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1784207,
  },
  {
    name: "Zhongxing",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1784253,
  },
  {
    name: "Zhongxin",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1784272,
  },
  {
    name: "Zhongshu",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1784310,
  },
  {
    name: "Zhonghe",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1784388,
  },
  {
    name: "Zhonghe",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1784393,
  },
  {
    name: "Zhongduo",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1784417,
  },
  {
    name: "Gusong",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1784450,
  },
  {
    name: "Zhongchao",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 1784452,
  },
  {
    name: "Zhong’ao",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1784475,
  },
  {
    name: "Zhigou",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1784527,
  },
  {
    name: "Zhicheng",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1784553,
  },
  {
    name: "Zhicheng",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1784554,
  },
  {
    name: "Zhenzhou",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1784580,
  },
  {
    name: "Zhenxi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1784595,
  },
  {
    name: "Zhenping Chengguanzhen",
    country: "China",
    subcountry: "Henan",
    geonameid: 1784617,
  },
  {
    name: "Zhenjiang",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1784642,
  },
  {
    name: "Zhaobaoshan",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1784647,
  },
  {
    name: "Zhengzhou",
    country: "China",
    subcountry: "Henan",
    geonameid: 1784658,
  },
  {
    name: "Zhengxing",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1784669,
  },
  {
    name: "Zhengji",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1784697,
  },
  {
    name: "Zhengding",
    country: "China",
    subcountry: "Hebei",
    geonameid: 1784712,
  },
  {
    name: "Zhelou",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 1784750,
  },
  {
    name: "Xinghua",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1784820,
  },
  {
    name: "Zhaotong",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1784841,
  },
  {
    name: "Zhaoqing",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1784853,
  },
  {
    name: "Zhaogezhuang",
    country: "China",
    subcountry: "Hebei",
    geonameid: 1784929,
  },
  {
    name: "Zhaodun",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1784939,
  },
  {
    name: "Zhaoyuan",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1784953,
  },
  {
    name: "Zhanjiang",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1784990,
  },
  {
    name: "Zhanhe",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1784994,
  },
  {
    name: "Zhangzhou",
    country: "China",
    subcountry: "Fujian",
    geonameid: 1785018,
  },
  {
    name: "Zhangzhai",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1785022,
  },
  {
    name: "Zhangye",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1785036,
  },
  {
    name: "Zhangjiachuan",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1785212,
  },
  {
    name: "Zhangji",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1785222,
  },
  {
    name: "Zibo",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1785286,
  },
  {
    name: "Anyang",
    country: "China",
    subcountry: "Henan",
    geonameid: 1785294,
  },
  {
    name: "Zhancheng",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1785345,
  },
  {
    name: "Zhabei",
    country: "China",
    subcountry: "Shanghai",
    geonameid: 1785412,
  },
  {
    name: "Zaozhuang",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1785453,
  },
  {
    name: "Zaoyang",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1785462,
  },
  {
    name: "Yuyao",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1785545,
  },
  {
    name: "Yingchuan",
    country: "China",
    subcountry: "Henan",
    geonameid: 1785566,
  },
  {
    name: "Yuxia",
    country: "China",
    subcountry: "Shaanxi",
    geonameid: 1785572,
  },
  {
    name: "Yuxi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1785577,
  },
  {
    name: "Yushan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1785616,
  },
  {
    name: "Kunshan",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1785623,
  },
  {
    name: "Yunyang",
    country: "China",
    subcountry: "Henan",
    geonameid: 1785655,
  },
  {
    name: "Yuntai",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1785685,
  },
  {
    name: "Yunshan",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1785688,
  },
  {
    name: "Yunnanyi",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1785692,
  },
  {
    name: "Yunmeng Chengguanzhen",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1785698,
  },
  {
    name: "Yunmen",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1785699,
  },
  {
    name: "Jinghong",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1785710,
  },
  {
    name: "Yunjin",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1785711,
  },
  {
    name: "Pizhou",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1785716,
  },
  {
    name: "Yunfu",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1785725,
  },
  {
    name: "Yuncheng",
    country: "China",
    subcountry: "Shanxi",
    geonameid: 1785738,
  },
  {
    name: "Yulinshi",
    country: "China",
    subcountry: "Shaanxi",
    geonameid: 1785777,
  },
  {
    name: "Yulin",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1785781,
  },
  {
    name: "Wulingyuan",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1785805,
  },
  {
    name: "Yujia",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1785827,
  },
  {
    name: "Yuexi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1785891,
  },
  {
    name: "Yudong",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1785964,
  },
  {
    name: "Yuci",
    country: "China",
    subcountry: "Shanxi",
    geonameid: 1785974,
  },
  {
    name: "Yucheng",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1785980,
  },
  {
    name: "Yuanyang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1786016,
  },
  {
    name: "Huaiyang",
    country: "China",
    subcountry: "Hebei",
    geonameid: 1786042,
  },
  {
    name: "Yuanshang",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1786043,
  },
  {
    name: "Yuanping",
    country: "China",
    subcountry: "Shanxi",
    geonameid: 1786060,
  },
  {
    name: "Qianjiang",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1786067,
  },
  {
    name: "Heyuan",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1786112,
  },
  {
    name: "Youxi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1786145,
  },
  {
    name: "Youting",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1786150,
  },
  {
    name: "Youchou",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1786209,
  },
  {
    name: "Yongzhou",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1786217,
  },
  {
    name: "Yongxing",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1786232,
  },
  {
    name: "Yongxing",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1786242,
  },
  {
    name: "Yongxin",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1786249,
  },
  {
    name: "Yongqing",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1786272,
  },
  {
    name: "Yongning",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1786291,
  },
  {
    name: "Yongjia",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1786330,
  },
  {
    name: "Yongfeng",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1786357,
  },
  {
    name: "Yongchuan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1786378,
  },
  {
    name: "Yongbei",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1786382,
  },
  {
    name: "Yong’an",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1786395,
  },
  {
    name: "Yizhuang",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1786408,
  },
  {
    name: "Yishui",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1786455,
  },
  {
    name: "Yinma",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1786515,
  },
  {
    name: "Zhongxiang",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1786546,
  },
  {
    name: "Yingtan",
    country: "China",
    subcountry: "Jiangxi",
    geonameid: 1786577,
  },
  {
    name: "Yingshang Chengguanzhen",
    country: "China",
    subcountry: "Anhui",
    geonameid: 1786587,
  },
  {
    name: "Chengzhong",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1786640,
  },
  {
    name: "Yinchuan",
    country: "China",
    subcountry: "Ningxia Hui Autonomous Region",
    geonameid: 1786657,
  },
  {
    name: "Yima",
    country: "China",
    subcountry: "Henan",
    geonameid: 1786676,
  },
  {
    name: "Yigou",
    country: "China",
    subcountry: "Henan",
    geonameid: 1786720,
  },
  {
    name: "Qingzhou",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1786731,
  },
  {
    name: "Yichun",
    country: "China",
    subcountry: "Jiangxi",
    geonameid: 1786746,
  },
  {
    name: "Yicheng",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1786759,
  },
  {
    name: "Yixing",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1786760,
  },
  {
    name: "Yichang",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1786764,
  },
  {
    name: "Yibin",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1786770,
  },
  {
    name: "Yezhou",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1786778,
  },
  {
    name: "Yeyuan",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1786783,
  },
  {
    name: "Yatou",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1786855,
  },
  {
    name: "Yashan",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1786867,
  },
  {
    name: "Yaowan",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1786910,
  },
  {
    name: "Yaoji",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1786969,
  },
  {
    name: "Yanzibu",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1787019,
  },
  {
    name: "Yanzhou",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1787031,
  },
  {
    name: "Yantai",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1787093,
  },
  {
    name: "Yanliang",
    country: "China",
    subcountry: "Shaanxi",
    geonameid: 1787144,
  },
  {
    name: "Yanjing",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1787162,
  },
  {
    name: "Yanjia",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1787188,
  },
  {
    name: "Yangzhou",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1787227,
  },
  {
    name: "Yangzhou",
    country: "China",
    subcountry: "Shaanxi",
    geonameid: 1787266,
  },
  {
    name: "Yanguan",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1787292,
  },
  {
    name: "Yangtun",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1787297,
  },
  {
    name: "Yangshuo",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1787323,
  },
  {
    name: "Zhangjiagang",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1787331,
  },
  {
    name: "Yangquan",
    country: "China",
    subcountry: "Shanxi",
    geonameid: 1787351,
  },
  {
    name: "Yangliuqing",
    country: "China",
    subcountry: "Tianjin",
    geonameid: 1787437,
  },
  {
    name: "Yanghe",
    country: "China",
    subcountry: "Ningxia Hui Autonomous Region",
    geonameid: 1787587,
  },
  {
    name: "Yanggu",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1787601,
  },
  {
    name: "Yangcun",
    country: "China",
    subcountry: "Tianjin",
    geonameid: 1787646,
  },
  {
    name: "Yancheng",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1787746,
  },
  {
    name: "Yan’an",
    country: "China",
    subcountry: "Shaanxi",
    geonameid: 1787765,
  },
  {
    name: "Yajiang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1787786,
  },
  {
    name: "Ya'an",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1787816,
  },
  {
    name: "Tongshan",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1787824,
  },
  {
    name: "Xuyong",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1787828,
  },
  {
    name: "Xucheng",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1787837,
  },
  {
    name: "Shangrao",
    country: "China",
    subcountry: "Jiangxi",
    geonameid: 1787858,
  },
  {
    name: "Xunyang",
    country: "China",
    subcountry: "Shaanxi",
    geonameid: 1787873,
  },
  {
    name: "Xunsi",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1787879,
  },
  {
    name: "Xunchang",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1787901,
  },
  {
    name: "Xujiang",
    country: "China",
    subcountry: "Jiangxi",
    geonameid: 1787925,
  },
  {
    name: "Xuchang",
    country: "China",
    subcountry: "Henan",
    geonameid: 1788046,
  },
  {
    name: "Xuantan",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1788061,
  },
  {
    name: "Xuanzhou",
    country: "China",
    subcountry: "Anhui",
    geonameid: 1788081,
  },
  {
    name: "Xixiang",
    country: "China",
    subcountry: "Henan",
    geonameid: 1788206,
  },
  {
    name: "Xixiang",
    country: "China",
    subcountry: "Shaanxi",
    geonameid: 1788207,
  },
  {
    name: "Xiuying",
    country: "China",
    subcountry: "Hainan",
    geonameid: 1788245,
  },
  {
    name: "Xiulin",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1788268,
  },
  {
    name: "Xiugu",
    country: "China",
    subcountry: "Jiangxi",
    geonameid: 1788269,
  },
  {
    name: "Xituo",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1788272,
  },
  {
    name: "Xiongzhou",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1788402,
  },
  {
    name: "Guixi",
    country: "China",
    subcountry: "Jiangxi",
    geonameid: 1788406,
  },
  {
    name: "Xinzhou",
    country: "China",
    subcountry: "Shanxi",
    geonameid: 1788450,
  },
  {
    name: "Xinzhou",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1788452,
  },
  {
    name: "Xinzhou",
    country: "China",
    subcountry: "Hainan",
    geonameid: 1788461,
  },
  {
    name: "Xinzhi",
    country: "China",
    subcountry: "Shanxi",
    geonameid: 1788462,
  },
  {
    name: "Xinzhai",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1788492,
  },
  {
    name: "Xinyu",
    country: "China",
    subcountry: "Jiangxi",
    geonameid: 1788508,
  },
  {
    name: "Hancheng",
    country: "China",
    subcountry: "Henan",
    geonameid: 1788522,
  },
  {
    name: "Xinyang",
    country: "China",
    subcountry: "Henan",
    geonameid: 1788534,
  },
  {
    name: "Xinxing",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1788561,
  },
  {
    name: "Xinxiang",
    country: "China",
    subcountry: "Henan",
    geonameid: 1788572,
  },
  {
    name: "Xintian",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1788590,
  },
  {
    name: "Xintai",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1788618,
  },
  {
    name: "Xinshi",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1788638,
  },
  {
    name: "Xinmin",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1788720,
  },
  {
    name: "Xinmiao",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1788725,
  },
  {
    name: "Xinji",
    country: "China",
    subcountry: "Hebei",
    geonameid: 1788816,
  },
  {
    name: "Xining",
    country: "China",
    subcountry: "Qinghai",
    geonameid: 1788852,
  },
  {
    name: "Shangmei",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1788869,
  },
  {
    name: "Xinhe",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1788887,
  },
  {
    name: "Xingtai",
    country: "China",
    subcountry: "Hebei",
    geonameid: 1788927,
  },
  {
    name: "Xingren",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 1788944,
  },
  {
    name: "Xinglong",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1788974,
  },
  {
    name: "Xinglong",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1788984,
  },
  {
    name: "Xingguo",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1789030,
  },
  {
    name: "Ankang",
    country: "China",
    subcountry: "Shaanxi",
    geonameid: 1789065,
  },
  {
    name: "Wenfeng",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1789101,
  },
  {
    name: "Xindian",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1789118,
  },
  {
    name: "Xindi",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1789137,
  },
  {
    name: "Feicheng",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1789176,
  },
  {
    name: "Xincheng",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1789181,
  },
  {
    name: "Xinshi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1789198,
  },
  {
    name: "Xinyi",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1789262,
  },
  {
    name: "Sanshui",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1789273,
  },
  {
    name: "Ximeicun",
    country: "China",
    subcountry: "Fujian",
    geonameid: 1789289,
  },
  {
    name: "Wacheng Neighborhood",
    country: "China",
    subcountry: "Henan",
    geonameid: 1789427,
  },
  {
    name: "Xihe",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1789462,
  },
  {
    name: "Xigang",
    country: "China",
    subcountry: "Ningxia Hui Autonomous Region",
    geonameid: 1789496,
  },
  {
    name: "Xiema",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1789546,
  },
  {
    name: "Xichang",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1789647,
  },
  {
    name: "Xichang",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1789649,
  },
  {
    name: "Xiazhuang",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1789691,
  },
  {
    name: "Xiazhuang",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1789693,
  },
  {
    name: "Xiazhuang",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1789699,
  },
  {
    name: "Xiazhen",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1789703,
  },
  {
    name: "Xiasi",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 1789787,
  },
  {
    name: "Haining",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1789799,
  },
  {
    name: "Gongyi",
    country: "China",
    subcountry: "Henan",
    geonameid: 1789897,
  },
  {
    name: "Xiaoweizhai",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 1789945,
  },
  {
    name: "Xiaoshan",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1789998,
  },
  {
    name: "Xiaomian",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1790059,
  },
  {
    name: "Xiaolingwei",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1790100,
  },
  {
    name: "Xiaogang",
    country: "China",
    subcountry: "Jiangxi",
    geonameid: 1790251,
  },
  {
    name: "Xiaogan",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1790254,
  },
  {
    name: "Xiaochuan",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1790296,
  },
  {
    name: "Xianyang",
    country: "China",
    subcountry: "Shaanxi",
    geonameid: 1790353,
  },
  {
    name: "Xiantao",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1790371,
  },
  {
    name: "Xianshuigu",
    country: "China",
    subcountry: "Tianjin",
    geonameid: 1790379,
  },
  {
    name: "Xiannü",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1790392,
  },
  {
    name: "Xianning",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1790396,
  },
  {
    name: "Xianju",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1790413,
  },
  {
    name: "Xiangzhou",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1790434,
  },
  {
    name: "Zhuhai",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1790437,
  },
  {
    name: "Xiangcheng",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1790442,
  },
  {
    name: "Wenxing",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1790451,
  },
  {
    name: "Xiangxiang",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1790471,
  },
  {
    name: "Xiangtan",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1790492,
  },
  {
    name: "Xiangshui",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1790497,
  },
  {
    name: "Xiangyang",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1790587,
  },
  {
    name: "Xiangcheng Chengguanzhen",
    country: "China",
    subcountry: "Henan",
    geonameid: 1790601,
  },
  {
    name: "Xianfeng",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1790615,
  },
  {
    name: "Xi’an",
    country: "China",
    subcountry: "Shaanxi",
    geonameid: 1790630,
  },
  {
    name: "Xiamen",
    country: "China",
    subcountry: "Fujian",
    geonameid: 1790645,
  },
  {
    name: "Xiagezhuang",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1790744,
  },
  {
    name: "Wuzhou",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1790840,
  },
  {
    name: "Wuzhen",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1790848,
  },
  {
    name: "Wuyang",
    country: "China",
    subcountry: "Anhui",
    geonameid: 1790885,
  },
  {
    name: "Wuxue",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1790894,
  },
  {
    name: "Wushan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1790920,
  },
  {
    name: "Wuxi",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1790923,
  },
  {
    name: "Wutongshu",
    country: "China",
    subcountry: "Ningxia Hui Autonomous Region",
    geonameid: 1790938,
  },
  {
    name: "Wushan",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1791007,
  },
  {
    name: "Wuqiao",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1791036,
  },
  {
    name: "Dongyang",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1791056,
  },
  {
    name: "Wuling",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1791119,
  },
  {
    name: "Changde",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1791121,
  },
  {
    name: "Wujing",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1791161,
  },
  {
    name: "Wujia",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1791188,
  },
  {
    name: "Wujia",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1791214,
  },
  {
    name: "Wuhu",
    country: "China",
    subcountry: "Anhui",
    geonameid: 1791236,
  },
  {
    name: "Wuhan",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1791247,
  },
  {
    name: "Wuhai",
    country: "China",
    subcountry: "Inner Mongolia",
    geonameid: 1791249,
  },
  {
    name: "Wugang",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1791272,
  },
  {
    name: "Wudong",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1791300,
  },
  {
    name: "Wuda",
    country: "China",
    subcountry: "Inner Mongolia",
    geonameid: 1791325,
  },
  {
    name: "Wucheng",
    country: "China",
    subcountry: "Anhui",
    geonameid: 1791347,
  },
  {
    name: "Wenzhou",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1791388,
  },
  {
    name: "Wenxian Chengguanzhen",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1791406,
  },
  {
    name: "Wenshang",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1791428,
  },
  {
    name: "Wenquan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1791439,
  },
  {
    name: "Wenling",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1791464,
  },
  {
    name: "Wenjiang",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1791484,
  },
  {
    name: "Wenheng",
    country: "China",
    subcountry: "Fujian",
    geonameid: 1791493,
  },
  {
    name: "Tianfu",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1791536,
  },
  {
    name: "Wenchang",
    country: "China",
    subcountry: "Hainan",
    geonameid: 1791544,
  },
  {
    name: "Weituo",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1791596,
  },
  {
    name: "Weinan",
    country: "China",
    subcountry: "Shaanxi",
    geonameid: 1791636,
  },
  {
    name: "Weimiao",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1791638,
  },
  {
    name: "Weiji",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1791663,
  },
  {
    name: "Weihai",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1791673,
  },
  {
    name: "Weifang",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1791681,
  },
  {
    name: "Wayaobu",
    country: "China",
    subcountry: "Shaanxi",
    geonameid: 1791706,
  },
  {
    name: "Wayao",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1791707,
  },
  {
    name: "Wanxian",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1791748,
  },
  {
    name: "Wanshun",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1791760,
  },
  {
    name: "Wanshui",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 1791762,
  },
  {
    name: "Wansheng",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1791765,
  },
  {
    name: "Wanning",
    country: "China",
    subcountry: "Hainan",
    geonameid: 1791779,
  },
  {
    name: "Wangwu",
    country: "China",
    subcountry: "Hainan",
    geonameid: 1791867,
  },
  {
    name: "Wangu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1791875,
  },
  {
    name: "Wangpu",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1791925,
  },
  {
    name: "Wangji",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1792052,
  },
  {
    name: "Yinzhu",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1792087,
  },
  {
    name: "Wangfen",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1792105,
  },
  {
    name: "Waina",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1792232,
  },
  {
    name: "Wafangdian",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 1792260,
  },
  {
    name: "Tuxiang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1792289,
  },
  {
    name: "Tushan",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1792301,
  },
  {
    name: "Huangshan",
    country: "China",
    subcountry: "Anhui",
    geonameid: 1792359,
  },
  {
    name: "Loushanguan",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 1792516,
  },
  {
    name: "Tongzhou",
    country: "China",
    subcountry: "Beijing",
    geonameid: 1792520,
  },
  {
    name: "Tongxi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1792557,
  },
  {
    name: "Fuding",
    country: "China",
    subcountry: "Fujian",
    geonameid: 1792585,
  },
  {
    name: "Tongren",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 1792592,
  },
  {
    name: "Tongling",
    country: "China",
    subcountry: "Anhui",
    geonameid: 1792621,
  },
  {
    name: "Tongjing",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1792636,
  },
  {
    name: "Tongchuan",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1792692,
  },
  {
    name: "Tieqiao",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1792760,
  },
  {
    name: "Tiefu",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1792795,
  },
  {
    name: "Tiaoshi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1792818,
  },
  {
    name: "Tianzhuang",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1792834,
  },
  {
    name: "Tianshui",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1792892,
  },
  {
    name: "Tianpeng",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1792916,
  },
  {
    name: "Tianliu",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1792936,
  },
  {
    name: "Tianjin",
    country: "China",
    subcountry: "Tianjin",
    geonameid: 1792947,
  },
  {
    name: "Chengtangcun",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1793036,
  },
  {
    name: "Taozhuang",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1793089,
  },
  {
    name: "Taoyuan",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1793102,
  },
  {
    name: "Taoluo",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1793139,
  },
  {
    name: "Taolin",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1793142,
  },
  {
    name: "Tantou",
    country: "China",
    subcountry: "Fujian",
    geonameid: 1793230,
  },
  {
    name: "Tanjia",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1793274,
  },
  {
    name: "Tangzhai",
    country: "China",
    subcountry: "Anhui",
    geonameid: 1793286,
  },
  {
    name: "Tangwu",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1793315,
  },
  {
    name: "Tangshan",
    country: "China",
    subcountry: "Hebei",
    geonameid: 1793346,
  },
  {
    name: "Tangping",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1793364,
  },
  {
    name: "Tangjiazhuang",
    country: "China",
    subcountry: "Hebei",
    geonameid: 1793385,
  },
  {
    name: "Binhe",
    country: "China",
    subcountry: "Henan",
    geonameid: 1793419,
  },
  {
    name: "Tanggu",
    country: "China",
    subcountry: "Tianjin",
    geonameid: 1793424,
  },
  {
    name: "Tangba",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1793463,
  },
  {
    name: "Taizhou",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1793505,
  },
  {
    name: "Taiyuan",
    country: "China",
    subcountry: "Shanxi",
    geonameid: 1793511,
  },
  {
    name: "Taixing",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1793533,
  },
  {
    name: "Taiping",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1793614,
  },
  {
    name: "Shanghe",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1793674,
  },
  {
    name: "Taihe",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1793685,
  },
  {
    name: "Taishan",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1793700,
  },
  {
    name: "Taicang",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1793703,
  },
  {
    name: "Tai’an",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1793724,
  },
  {
    name: "Tai’an",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1793725,
  },
  {
    name: "Suzhou",
    country: "China",
    subcountry: "Anhui",
    geonameid: 1793743,
  },
  {
    name: "Suyangshan",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1793747,
  },
  {
    name: "Suqian",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1793771,
  },
  {
    name: "Suozhen",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1793774,
  },
  {
    name: "Suizhou",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1793879,
  },
  {
    name: "Suixi",
    country: "China",
    subcountry: "Anhui",
    geonameid: 1793889,
  },
  {
    name: "Suicheng",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1793899,
  },
  {
    name: "Suining",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1793900,
  },
  {
    name: "Songjiang",
    country: "China",
    subcountry: "Shanghai",
    geonameid: 1794035,
  },
  {
    name: "Songcheng",
    country: "China",
    subcountry: "Fujian",
    geonameid: 1794060,
  },
  {
    name: "Songbai",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1794067,
  },
  {
    name: "Shangsi",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1794103,
  },
  {
    name: "Sitou",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1794126,
  },
  {
    name: "Sishui",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1794140,
  },
  {
    name: "Simen",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1794203,
  },
  {
    name: "Simao",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1794209,
  },
  {
    name: "Dachang Shandao",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 1794227,
  },
  {
    name: "Sihu",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1794254,
  },
  {
    name: "Shunhe",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1794348,
  },
  {
    name: "Shuizhai",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1794371,
  },
  {
    name: "Shuitu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1794395,
  },
  {
    name: "Shuikou",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 1794461,
  },
  {
    name: "Shuikou",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1794465,
  },
  {
    name: "Shuijiang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1794478,
  },
  {
    name: "Laixi",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1794479,
  },
  {
    name: "Shuangshi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1794592,
  },
  {
    name: "Shuanglong",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1794650,
  },
  {
    name: "Shuangjiang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1794682,
  },
  {
    name: "Shuangjiang",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 1794686,
  },
  {
    name: "Shuanghe",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1794700,
  },
  {
    name: "Shuanggou",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1794725,
  },
  {
    name: "Shouxian",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1794782,
  },
  {
    name: "Shouguang",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1794794,
  },
  {
    name: "Shizuishan",
    country: "China",
    subcountry: "Ningxia Hui Autonomous Region",
    geonameid: 1794806,
  },
  {
    name: "Shizilu",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1794825,
  },
  {
    name: "Shiyan",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1794903,
  },
  {
    name: "Shiwan",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1794947,
  },
  {
    name: "Shiwan",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1794948,
  },
  {
    name: "Shituo",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1794949,
  },
  {
    name: "Shitanjing",
    country: "China",
    subcountry: "Ningxia Hui Autonomous Region",
    geonameid: 1794971,
  },
  {
    name: "Shiquan",
    country: "China",
    subcountry: "Shaanxi",
    geonameid: 1795026,
  },
  {
    name: "Shiqiaozi",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1795029,
  },
  {
    name: "Shiqiao",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1795055,
  },
  {
    name: "Shiqi",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1795060,
  },
  {
    name: "Shimen",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1795140,
  },
  {
    name: "Shima",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1795164,
  },
  {
    name: "Shima",
    country: "China",
    subcountry: "Fujian",
    geonameid: 1795166,
  },
  {
    name: "Xianglong",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1795179,
  },
  {
    name: "Shilong",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1795184,
  },
  {
    name: "Tongchuanshi",
    country: "China",
    subcountry: "Shaanxi",
    geonameid: 1795196,
  },
  {
    name: "Shikang",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1795241,
  },
  {
    name: "Shijiazhuang",
    country: "China",
    subcountry: "Hebei",
    geonameid: 1795270,
  },
  {
    name: "Shijiao",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1795299,
  },
  {
    name: "Shiji",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1795320,
  },
  {
    name: "Shihui",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1795330,
  },
  {
    name: "Shidui",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1795411,
  },
  {
    name: "Shichuan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1795443,
  },
  {
    name: "Shibuzi",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1795470,
  },
  {
    name: "Shetan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1795544,
  },
  {
    name: "Shenzhen",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1795565,
  },
  {
    name: "Yanta",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1795579,
  },
  {
    name: "Chentuan",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1795587,
  },
  {
    name: "Shenjiamen",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1795632,
  },
  {
    name: "Yunlong",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1795751,
  },
  {
    name: "Shawan",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1795776,
  },
  {
    name: "Rensha",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1795811,
  },
  {
    name: "Shaping",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1795833,
  },
  {
    name: "Shaping",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1795842,
  },
  {
    name: "Shaoxing",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1795855,
  },
  {
    name: "Shaowu",
    country: "China",
    subcountry: "Fujian",
    geonameid: 1795857,
  },
  {
    name: "Shaoguan",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1795874,
  },
  {
    name: "Shaodian",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1795880,
  },
  {
    name: "Shancheng",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1795919,
  },
  {
    name: "Shanwei",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1795928,
  },
  {
    name: "Shantou",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1795940,
  },
  {
    name: "Shanting",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1795941,
  },
  {
    name: "Shankou",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1795986,
  },
  {
    name: "Shanji",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1795993,
  },
  {
    name: "Shangluo",
    country: "China",
    subcountry: "Shaanxi",
    geonameid: 1796068,
  },
  {
    name: "Shangkou",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1796186,
  },
  {
    name: "Shanghuang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1796209,
  },
  {
    name: "Shanghai",
    country: "China",
    subcountry: "Shanghai",
    geonameid: 1796236,
  },
  {
    name: "Shaji",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1796385,
  },
  {
    name: "Shahecheng",
    country: "China",
    subcountry: "Hebei",
    geonameid: 1796421,
  },
  {
    name: "Shahe",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1796427,
  },
  {
    name: "Shagang",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1796449,
  },
  {
    name: "Sanzhuang",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1796506,
  },
  {
    name: "Sanya",
    country: "China",
    subcountry: "Hainan",
    geonameid: 1796556,
  },
  {
    name: "Sanqu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1796642,
  },
  {
    name: "Sanming",
    country: "China",
    subcountry: "Fujian",
    geonameid: 1796663,
  },
  {
    name: "Sanmenxia",
    country: "China",
    subcountry: "Henan",
    geonameid: 1796669,
  },
  {
    name: "Sanjiao",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1796755,
  },
  {
    name: "Sanjiang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1796771,
  },
  {
    name: "Sanhui",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1796797,
  },
  {
    name: "Xiaodu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1796799,
  },
  {
    name: "Sangzhe",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1796841,
  },
  {
    name: "Runing",
    country: "China",
    subcountry: "Henan",
    geonameid: 1797038,
  },
  {
    name: "Rui’an",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1797063,
  },
  {
    name: "Ronglong",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1797100,
  },
  {
    name: "Rongjiang",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1797106,
  },
  {
    name: "Fuqing",
    country: "China",
    subcountry: "Fujian",
    geonameid: 1797120,
  },
  {
    name: "Jieyang",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1797121,
  },
  {
    name: "Rizhuang",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1797126,
  },
  {
    name: "Renzhao",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1797158,
  },
  {
    name: "Renyi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1797161,
  },
  {
    name: "Renxian",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1797172,
  },
  {
    name: "Renqiu",
    country: "China",
    subcountry: "Hebei",
    geonameid: 1797181,
  },
  {
    name: "Renhe",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1797213,
  },
  {
    name: "Quzhou",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1797264,
  },
  {
    name: "Qujing",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1797318,
  },
  {
    name: "Qufu",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1797333,
  },
  {
    name: "Quanzhou",
    country: "China",
    subcountry: "Fujian",
    geonameid: 1797353,
  },
  {
    name: "Wuxi",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1797417,
  },
  {
    name: "Zhuangyuan",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1797438,
  },
  {
    name: "Qiuji",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1797471,
  },
  {
    name: "Qishan",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1797505,
  },
  {
    name: "Qiongshan",
    country: "China",
    subcountry: "Hainan",
    geonameid: 1797535,
  },
  {
    name: "Qionghu",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1797543,
  },
  {
    name: "Qinzhou",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1797551,
  },
  {
    name: "Qinnan",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1797575,
  },
  {
    name: "Qinhuangdao",
    country: "China",
    subcountry: "Hebei",
    geonameid: 1797595,
  },
  {
    name: "Yizhou",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1797632,
  },
  {
    name: "Jinjiang",
    country: "China",
    subcountry: "Fujian",
    geonameid: 1797658,
  },
  {
    name: "Qingshuping",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1797715,
  },
  {
    name: "Qingshizui",
    country: "China",
    subcountry: "Qinghai",
    geonameid: 1797755,
  },
  {
    name: "Qingshanquan",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1797766,
  },
  {
    name: "Qingquan",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1797793,
  },
  {
    name: "Qingping",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1797804,
  },
  {
    name: "Huai'an",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1797873,
  },
  {
    name: "Qingfu",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1797915,
  },
  {
    name: "Qingdao",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1797929,
  },
  {
    name: "Qingyuan",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1797945,
  },
  {
    name: "Qincheng",
    country: "China",
    subcountry: "Jiangxi",
    geonameid: 1797959,
  },
  {
    name: "Qina",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1797962,
  },
  {
    name: "Qishan",
    country: "China",
    subcountry: "Anhui",
    geonameid: 1797972,
  },
  {
    name: "Hongqiao",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1798082,
  },
  {
    name: "Qiaotou",
    country: "China",
    subcountry: "Qinghai",
    geonameid: 1798131,
  },
  {
    name: "Qiaotou",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1798134,
  },
  {
    name: "Qiaoguan",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1798182,
  },
  {
    name: "Qianliu",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1798290,
  },
  {
    name: "Puzi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1798408,
  },
  {
    name: "Puyang Chengguanzhen",
    country: "China",
    subcountry: "Henan",
    geonameid: 1798422,
  },
  {
    name: "Puyang",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1798425,
  },
  {
    name: "Putian",
    country: "China",
    subcountry: "Fujian",
    geonameid: 1798449,
  },
  {
    name: "Puji",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1798462,
  },
  {
    name: "Puqi",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1798473,
  },
  {
    name: "Yongning",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1798480,
  },
  {
    name: "Pulandian",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 1798490,
  },
  {
    name: "Pu’an",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1798537,
  },
  {
    name: "Poyang",
    country: "China",
    subcountry: "Jiangxi",
    geonameid: 1798548,
  },
  {
    name: "Pingyin",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1798632,
  },
  {
    name: "Pingyi",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1798634,
  },
  {
    name: "Gutao",
    country: "China",
    subcountry: "Shanxi",
    geonameid: 1798636,
  },
  {
    name: "Pingxiang",
    country: "China",
    subcountry: "Jiangxi",
    geonameid: 1798654,
  },
  {
    name: "Pingtan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1798684,
  },
  {
    name: "Pingshan",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1798713,
  },
  {
    name: "Pingnan",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1798733,
  },
  {
    name: "Pingliang",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1798760,
  },
  {
    name: "Pingli",
    country: "China",
    subcountry: "Shaanxi",
    geonameid: 1798763,
  },
  {
    name: "Pingjin",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1798778,
  },
  {
    name: "Pingdu",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1798821,
  },
  {
    name: "Pingdingshan",
    country: "China",
    subcountry: "Henan",
    geonameid: 1798827,
  },
  {
    name: "Pianjiao",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1798886,
  },
  {
    name: "Pengcheng",
    country: "China",
    subcountry: "Hebei",
    geonameid: 1798946,
  },
  {
    name: "Peicheng",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1798972,
  },
  {
    name: "Picheng",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1798973,
  },
  {
    name: "Panlong",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1799037,
  },
  {
    name: "Panghai",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 1799084,
  },
  {
    name: "Pan’an",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1799100,
  },
  {
    name: "Paipu",
    country: "China",
    subcountry: "Hainan",
    geonameid: 1799117,
  },
  {
    name: "Guang’an",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1799194,
  },
  {
    name: "Ningyang",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1799348,
  },
  {
    name: "Yutan",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1799352,
  },
  {
    name: "Hanyuan",
    country: "China",
    subcountry: "Shaanxi",
    geonameid: 1799362,
  },
  {
    name: "Ninghai",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1799383,
  },
  {
    name: "Ninghai",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1799384,
  },
  {
    name: "Ningbo",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1799397,
  },
  {
    name: "Nianbo",
    country: "China",
    subcountry: "Qinghai",
    geonameid: 1799471,
  },
  {
    name: "Neijiang",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1799491,
  },
  {
    name: "Nanzhou",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1799552,
  },
  {
    name: "Nanzhang Chengguanzhen",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1799574,
  },
  {
    name: "Nanyang",
    country: "China",
    subcountry: "Henan",
    geonameid: 1799629,
  },
  {
    name: "Nanxi",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1799686,
  },
  {
    name: "Nantong",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1799722,
  },
  {
    name: "Nanshu",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1799749,
  },
  {
    name: "Pucheng",
    country: "China",
    subcountry: "Fujian",
    geonameid: 1799832,
  },
  {
    name: "Nanping",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1799845,
  },
  {
    name: "Nanping",
    country: "China",
    subcountry: "Fujian",
    geonameid: 1799846,
  },
  {
    name: "Nanning",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1799869,
  },
  {
    name: "Nanma",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1799897,
  },
  {
    name: "Nanlong",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1799908,
  },
  {
    name: "Nanjing",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1799962,
  },
  {
    name: "Nanjian",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1799986,
  },
  {
    name: "Nanhu",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1800006,
  },
  {
    name: "Nangong",
    country: "China",
    subcountry: "Hebei",
    geonameid: 1800065,
  },
  {
    name: "Nanfeng",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1800088,
  },
  {
    name: "Nanfeng",
    country: "China",
    subcountry: "Hainan",
    geonameid: 1800089,
  },
  {
    name: "Nandu",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1800101,
  },
  {
    name: "Nanding",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1800107,
  },
  {
    name: "Nancun",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1800130,
  },
  {
    name: "Nanchong",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1800146,
  },
  {
    name: "Nanchang",
    country: "China",
    subcountry: "Jiangxi",
    geonameid: 1800163,
  },
  {
    name: "Nanbin",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1800175,
  },
  {
    name: "Naliang",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1800217,
  },
  {
    name: "Nada",
    country: "China",
    subcountry: "Hainan",
    geonameid: 1800234,
  },
  {
    name: "Mu’er",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1800333,
  },
  {
    name: "Mudong",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1800334,
  },
  {
    name: "Miyang",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1800430,
  },
  {
    name: "Mingshui",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1800498,
  },
  {
    name: "Mingguang",
    country: "China",
    subcountry: "Anhui",
    geonameid: 1800519,
  },
  {
    name: "Minggang",
    country: "China",
    subcountry: "Henan",
    geonameid: 1800521,
  },
  {
    name: "Mingcun",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1800524,
  },
  {
    name: "Micheng",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1800544,
  },
  {
    name: "Miaoyu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1800557,
  },
  {
    name: "Mianyang",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1800627,
  },
  {
    name: "Mianyang",
    country: "China",
    subcountry: "Shaanxi",
    geonameid: 1800629,
  },
  {
    name: "Mentougou",
    country: "China",
    subcountry: "Beijing",
    geonameid: 1800657,
  },
  {
    name: "Mengyin",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1800675,
  },
  {
    name: "Mengcheng Chengguanzhen",
    country: "China",
    subcountry: "Anhui",
    geonameid: 1800764,
  },
  {
    name: "Meizhou",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1800779,
  },
  {
    name: "Meishan",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1800818,
  },
  {
    name: "Wuchuan",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1800829,
  },
  {
    name: "Meijiang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1800854,
  },
  {
    name: "Mawu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1800966,
  },
  {
    name: "Mawang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1800982,
  },
  {
    name: "Mapo",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1801098,
  },
  {
    name: "Maoming",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1801180,
  },
  {
    name: "Maocun",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1801243,
  },
  {
    name: "Malianzhuang",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1801355,
  },
  {
    name: "Majie",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1801401,
  },
  {
    name: "Zhijiang",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1801455,
  },
  {
    name: "Macheng",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1801582,
  },
  {
    name: "Maba",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1801615,
  },
  {
    name: "Ma’anshan",
    country: "China",
    subcountry: "Anhui",
    geonameid: 1801620,
  },
  {
    name: "Luzhou",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1801640,
  },
  {
    name: "Lüshun",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 1801722,
  },
  {
    name: "Lushar",
    country: "China",
    subcountry: "Qinghai",
    geonameid: 1801734,
  },
  {
    name: "Lushan",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 1801740,
  },
  {
    name: "Luoyang",
    country: "China",
    subcountry: "Henan",
    geonameid: 1801792,
  },
  {
    name: "Luoyang",
    country: "China",
    subcountry: "Fujian",
    geonameid: 1801797,
  },
  {
    name: "Luoyang",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1801799,
  },
  {
    name: "Luorong",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1801850,
  },
  {
    name: "Luoqi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1801859,
  },
  {
    name: "Luoping",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1801862,
  },
  {
    name: "Luomen",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1801876,
  },
  {
    name: "Luolong",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1801885,
  },
  {
    name: "Luojiang",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1801909,
  },
  {
    name: "Luohuang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1801926,
  },
  {
    name: "Luohe",
    country: "China",
    subcountry: "Henan",
    geonameid: 1801934,
  },
  {
    name: "Luocheng",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1801983,
  },
  {
    name: "Lulou",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1802020,
  },
  {
    name: "Lucheng",
    country: "China",
    subcountry: "Anhui",
    geonameid: 1802068,
  },
  {
    name: "Lüeyang Chengguanzhen",
    country: "China",
    subcountry: "Shaanxi",
    geonameid: 1802136,
  },
  {
    name: "Kangding",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1802171,
  },
  {
    name: "Lubu",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1802177,
  },
  {
    name: "Luancheng",
    country: "China",
    subcountry: "Hebei",
    geonameid: 1802204,
  },
  {
    name: "Lu’an",
    country: "China",
    subcountry: "Anhui",
    geonameid: 1802206,
  },
  {
    name: "Loudi",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1802238,
  },
  {
    name: "Longyan",
    country: "China",
    subcountry: "Fujian",
    geonameid: 1802276,
  },
  {
    name: "Longxing",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1802296,
  },
  {
    name: "Longtan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1802407,
  },
  {
    name: "Longtan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1802408,
  },
  {
    name: "Longshui",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1802420,
  },
  {
    name: "Longshi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1802426,
  },
  {
    name: "Longshan",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1802441,
  },
  {
    name: "Longquan",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1802476,
  },
  {
    name: "Longmen",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1802501,
  },
  {
    name: "Longhua",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1802523,
  },
  {
    name: "Longlin",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1802541,
  },
  {
    name: "Longgang",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1802550,
  },
  {
    name: "Longju",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1802563,
  },
  {
    name: "Longgu",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1802640,
  },
  {
    name: "Longgang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1802651,
  },
  {
    name: "Longfeng",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1802659,
  },
  {
    name: "Long’e",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 1802665,
  },
  {
    name: "Longchi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1802685,
  },
  {
    name: "Longcheng",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1802686,
  },
  {
    name: "Longchang",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 1802695,
  },
  {
    name: "Licheng",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1802788,
  },
  {
    name: "Lixin",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1802802,
  },
  {
    name: "Lixian",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1802811,
  },
  {
    name: "Liuyin",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1802870,
  },
  {
    name: "Guankou",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1802875,
  },
  {
    name: "Liuxin",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1802880,
  },
  {
    name: "Liutuan",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1802901,
  },
  {
    name: "Puning",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1802940,
  },
  {
    name: "Liuquan",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1802949,
  },
  {
    name: "Lishui",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1803245,
  },
  {
    name: "Lishi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1803257,
  },
  {
    name: "Lintong",
    country: "China",
    subcountry: "Shaanxi",
    geonameid: 1803266,
  },
  {
    name: "Liuzhou",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1803300,
  },
  {
    name: "Linyi",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1803318,
  },
  {
    name: "Linxia Chengguanzhen",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1803331,
  },
  {
    name: "Linxi",
    country: "China",
    subcountry: "Hebei",
    geonameid: 1803334,
  },
  {
    name: "Linshui",
    country: "China",
    subcountry: "Hebei",
    geonameid: 1803352,
  },
  {
    name: "Linshi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1803353,
  },
  {
    name: "Linqu",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1803364,
  },
  {
    name: "Linqiong",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1803365,
  },
  {
    name: "Qingnian",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1803367,
  },
  {
    name: "Linping",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1803374,
  },
  {
    name: "Linjiang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1803395,
  },
  {
    name: "Linjiang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1803397,
  },
  {
    name: "Linjiacun",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1803402,
  },
  {
    name: "Dongta",
    country: "China",
    subcountry: "Ningxia Hui Autonomous Region",
    geonameid: 1803449,
  },
  {
    name: "Linghe",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1803522,
  },
  {
    name: "Lingcheng",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1803549,
  },
  {
    name: "Beiliu",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1803551,
  },
  {
    name: "Lingao",
    country: "China",
    subcountry: "Hainan",
    geonameid: 1803560,
  },
  {
    name: "Linfeng",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1803564,
  },
  {
    name: "Linfen",
    country: "China",
    subcountry: "Shanxi",
    geonameid: 1803567,
  },
  {
    name: "Lincang",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1803590,
  },
  {
    name: "Xishan",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1803616,
  },
  {
    name: "Liji",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1803698,
  },
  {
    name: "Ligezhuang",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1803728,
  },
  {
    name: "Lidu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1803753,
  },
  {
    name: "Lichuan",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1803782,
  },
  {
    name: "Licheng",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1803791,
  },
  {
    name: "Licha",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1803793,
  },
  {
    name: "Liaolan",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1803822,
  },
  {
    name: "Liaocheng",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1803834,
  },
  {
    name: "Lianzhou",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1803841,
  },
  {
    name: "Hepu",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1803842,
  },
  {
    name: "Anning",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1803886,
  },
  {
    name: "Wuwei",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1803936,
  },
  {
    name: "Liangzhai",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1803940,
  },
  {
    name: "Liangxiang",
    country: "China",
    subcountry: "Beijing",
    geonameid: 1803948,
  },
  {
    name: "Liangshui",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1803979,
  },
  {
    name: "Jiangbei",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1803998,
  },
  {
    name: "Liancheng",
    country: "China",
    subcountry: "Fujian",
    geonameid: 1804106,
  },
  {
    name: "Lianjiang",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1804120,
  },
  {
    name: "Leshan",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1804153,
  },
  {
    name: "Lengshuitan",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1804162,
  },
  {
    name: "Lengshuijiang",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1804169,
  },
  {
    name: "Leiyang",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1804208,
  },
  {
    name: "Lecheng",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1804252,
  },
  {
    name: "Laohekou",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1804386,
  },
  {
    name: "Lanzhou",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1804430,
  },
  {
    name: "Lanxi",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1804442,
  },
  {
    name: "Lianyuan",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1804451,
  },
  {
    name: "Langfang",
    country: "China",
    subcountry: "Hebei",
    geonameid: 1804540,
  },
  {
    name: "Langao Chengguanzhen",
    country: "China",
    subcountry: "Shaanxi",
    geonameid: 1804550,
  },
  {
    name: "Laizhou",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1804578,
  },
  {
    name: "Laiyang",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1804586,
  },
  {
    name: "Laiwu",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1804591,
  },
  {
    name: "Laisu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1804593,
  },
  {
    name: "Laibin",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1804609,
  },
  {
    name: "Labuleng",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1804618,
  },
  {
    name: "Kunyang",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1804645,
  },
  {
    name: "Kunming",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1804651,
  },
  {
    name: "Kuangshi",
    country: "China",
    subcountry: "Hebei",
    geonameid: 1804687,
  },
  {
    name: "Kongtan",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1804730,
  },
  {
    name: "Kaiyuan",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1804850,
  },
  {
    name: "Kaili",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 1804866,
  },
  {
    name: "Kaihua",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1804874,
  },
  {
    name: "Kaifeng",
    country: "China",
    subcountry: "Henan",
    geonameid: 1804879,
  },
  {
    name: "Juye",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1804892,
  },
  {
    name: "Junlian",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1804935,
  },
  {
    name: "Juexi",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1804976,
  },
  {
    name: "Juegang",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1804979,
  },
  {
    name: "Liulin",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1804996,
  },
  {
    name: "Jiyuan",
    country: "China",
    subcountry: "Henan",
    geonameid: 1805012,
  },
  {
    name: "Jizhou",
    country: "China",
    subcountry: "Hebei",
    geonameid: 1805029,
  },
  {
    name: "Jiuxian",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1805093,
  },
  {
    name: "Jiushan",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1805117,
  },
  {
    name: "Jiujiang",
    country: "China",
    subcountry: "Jiangxi",
    geonameid: 1805179,
  },
  {
    name: "Jiudian",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1805220,
  },
  {
    name: "Jishui",
    country: "China",
    subcountry: "Henan",
    geonameid: 1805267,
  },
  {
    name: "Qianzhou",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1805270,
  },
  {
    name: "Jinzhou",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 1805298,
  },
  {
    name: "Jinxiang",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1805334,
  },
  {
    name: "Jinshi",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1805379,
  },
  {
    name: "Jinsha",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1805408,
  },
  {
    name: "Jinjiang",
    country: "China",
    subcountry: "Jiangxi",
    geonameid: 1805501,
  },
  {
    name: "Jinjiang",
    country: "China",
    subcountry: "Hainan",
    geonameid: 1805505,
  },
  {
    name: "Jinji",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1805515,
  },
  {
    name: "Jining",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1805518,
  },
  {
    name: "Jinhua",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1805528,
  },
  {
    name: "Jingzhou",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1805540,
  },
  {
    name: "Jingzhi",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1805543,
  },
  {
    name: "Tianchang",
    country: "China",
    subcountry: "Hebei",
    geonameid: 1805563,
  },
  {
    name: "Jingui",
    country: "China",
    subcountry: "Ningxia Hui Autonomous Region",
    geonameid: 1805576,
  },
  {
    name: "Jingmen",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1805611,
  },
  {
    name: "Jingling",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1805618,
  },
  {
    name: "Jingguan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1805661,
  },
  {
    name: "Jingdezhen",
    country: "China",
    subcountry: "Jiangxi",
    geonameid: 1805680,
  },
  {
    name: "Jinchang",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1805733,
  },
  {
    name: "Jincheng",
    country: "China",
    subcountry: "Shanxi",
    geonameid: 1805741,
  },
  {
    name: "Jinan",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1805753,
  },
  {
    name: "Jimo",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1805757,
  },
  {
    name: "Jijiang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1805798,
  },
  {
    name: "Jiexiu",
    country: "China",
    subcountry: "Shanxi",
    geonameid: 1805833,
  },
  {
    name: "Jieshou",
    country: "China",
    subcountry: "Anhui",
    geonameid: 1805844,
  },
  {
    name: "Jieshi",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1805857,
  },
  {
    name: "Jielong",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1805873,
  },
  {
    name: "Jiehu",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1805884,
  },
  {
    name: "Jiazi",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1805935,
  },
  {
    name: "Jiayue",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1805947,
  },
  {
    name: "Jiaxing",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1805953,
  },
  {
    name: "Jiawang",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1805962,
  },
  {
    name: "Jiasi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1805967,
  },
  {
    name: "Jiaozuo",
    country: "China",
    subcountry: "Henan",
    geonameid: 1805987,
  },
  {
    name: "Jiaoshi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1806020,
  },
  {
    name: "Jiaogong",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1806079,
  },
  {
    name: "Jiaozhou",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1806096,
  },
  {
    name: "Ningde",
    country: "China",
    subcountry: "Fujian",
    geonameid: 1806097,
  },
  {
    name: "Jianshan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1806155,
  },
  {
    name: "Jian’ou",
    country: "China",
    subcountry: "Fujian",
    geonameid: 1806167,
  },
  {
    name: "Jiangzhuang",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1806188,
  },
  {
    name: "Jiangyan",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1806218,
  },
  {
    name: "Jianguang",
    country: "China",
    subcountry: "Jiangxi",
    geonameid: 1806248,
  },
  {
    name: "Jiangshan",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1806271,
  },
  {
    name: "Jiangping",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1806282,
  },
  {
    name: "Jiangmen",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1806299,
  },
  {
    name: "Jiangluo",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1806300,
  },
  {
    name: "Jiangkou",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1806316,
  },
  {
    name: "Jiangkou",
    country: "China",
    subcountry: "Fujian",
    geonameid: 1806327,
  },
  {
    name: "Jiangjia",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1806368,
  },
  {
    name: "Yangjiang",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1806408,
  },
  {
    name: "Jiang’an",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1806422,
  },
  {
    name: "Jianchang",
    country: "China",
    subcountry: "Jiangxi",
    geonameid: 1806439,
  },
  {
    name: "Ji’an",
    country: "China",
    subcountry: "Jiangxi",
    geonameid: 1806445,
  },
  {
    name: "Guangyuan",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1806466,
  },
  {
    name: "Qionghai",
    country: "China",
    subcountry: "Hainan",
    geonameid: 1806488,
  },
  {
    name: "Jiachuan",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1806516,
  },
  {
    name: "Huzhou",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1806535,
  },
  {
    name: "Hutang",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1806591,
  },
  {
    name: "Cixi",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1806602,
  },
  {
    name: "Huoqiu Chengguanzhen",
    country: "China",
    subcountry: "Anhui",
    geonameid: 1806651,
  },
  {
    name: "Huolu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1806657,
  },
  {
    name: "Humen",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1806696,
  },
  {
    name: "Huizhou",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1806776,
  },
  {
    name: "Huixian Chengguanzhen",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1806788,
  },
  {
    name: "Huilong",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1806840,
  },
  {
    name: "Huicheng",
    country: "China",
    subcountry: "Anhui",
    geonameid: 1806880,
  },
  {
    name: "Huicheng",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1806881,
  },
  {
    name: "Huguo",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1806900,
  },
  {
    name: "Hufeng",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1806912,
  },
  {
    name: "Huazhou",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1806960,
  },
  {
    name: "Huayin",
    country: "China",
    subcountry: "Shaanxi",
    geonameid: 1806988,
  },
  {
    name: "Huashan",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1807035,
  },
  {
    name: "Huankou",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1807090,
  },
  {
    name: "Huangzhou",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1807112,
  },
  {
    name: "Huangshi",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1807234,
  },
  {
    name: "Huangshan",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1807259,
  },
  {
    name: "Dasha",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1807301,
  },
  {
    name: "Huangpi",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1807308,
  },
  {
    name: "Huangmei",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1807339,
  },
  {
    name: "Huangji",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1807452,
  },
  {
    name: "Huanghua",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1807467,
  },
  {
    name: "Huanggang",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1807508,
  },
  {
    name: "Daxing",
    country: "China",
    subcountry: "Beijing",
    geonameid: 1807544,
  },
  {
    name: "Dingcheng",
    country: "China",
    subcountry: "Henan",
    geonameid: 1807553,
  },
  {
    name: "Xingyi",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 1807566,
  },
  {
    name: "Huaiyuan Chengguanzhen",
    country: "China",
    subcountry: "Anhui",
    geonameid: 1807645,
  },
  {
    name: "Huainan",
    country: "China",
    subcountry: "Anhui",
    geonameid: 1807681,
  },
  {
    name: "Huaicheng",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1807687,
  },
  {
    name: "Huaihua",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1807689,
  },
  {
    name: "Huaidian",
    country: "China",
    subcountry: "Henan",
    geonameid: 1807695,
  },
  {
    name: "Huaibei",
    country: "China",
    subcountry: "Anhui",
    geonameid: 1807700,
  },
  {
    name: "Huacheng",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1807738,
  },
  {
    name: "Houzhen",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1807761,
  },
  {
    name: "Hongzhou",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 1807916,
  },
  {
    name: "Honglu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1808075,
  },
  {
    name: "Donghe",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1808103,
  },
  {
    name: "Hongjiang",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1808106,
  },
  {
    name: "Honghe",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1808133,
  },
  {
    name: "Hong’an",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1808176,
  },
  {
    name: "Hezuo",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1808181,
  },
  {
    name: "Heze",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1808198,
  },
  {
    name: "Hechuan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1808212,
  },
  {
    name: "Hetoudian",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1808249,
  },
  {
    name: "Yiyang",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1808316,
  },
  {
    name: "Hepo",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1808336,
  },
  {
    name: "Hengyang",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1808370,
  },
  {
    name: "Hengshui",
    country: "China",
    subcountry: "Hebei",
    geonameid: 1808392,
  },
  {
    name: "Hengbei",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1808517,
  },
  {
    name: "Helin",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1808541,
  },
  {
    name: "Hejiang",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1808612,
  },
  {
    name: "Heishui",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1808652,
  },
  {
    name: "Hefei",
    country: "China",
    subcountry: "Anhui",
    geonameid: 1808722,
  },
  {
    name: "Hede",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1808744,
  },
  {
    name: "Hecun",
    country: "China",
    subcountry: "Hebei",
    geonameid: 1808747,
  },
  {
    name: "Hebian",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1808769,
  },
  {
    name: "Hebi",
    country: "China",
    subcountry: "Henan",
    geonameid: 1808770,
  },
  {
    name: "Heba",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1808783,
  },
  {
    name: "Haomen",
    country: "China",
    subcountry: "Qinghai",
    geonameid: 1808820,
  },
  {
    name: "Haojiaqiao",
    country: "China",
    subcountry: "Ningxia Hui Autonomous Region",
    geonameid: 1808829,
  },
  {
    name: "Hanzhong",
    country: "China",
    subcountry: "Shaanxi",
    geonameid: 1808857,
  },
  {
    name: "Hanyuan",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1808861,
  },
  {
    name: "Hanyin Chengguanzhen",
    country: "China",
    subcountry: "Shaanxi",
    geonameid: 1808863,
  },
  {
    name: "Fu’an",
    country: "China",
    subcountry: "Fujian",
    geonameid: 1808872,
  },
  {
    name: "Hanting",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1808879,
  },
  {
    name: "Hanjia",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1808916,
  },
  {
    name: "Hangzhou",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1808926,
  },
  {
    name: "Hangu",
    country: "China",
    subcountry: "Tianjin",
    geonameid: 1808931,
  },
  {
    name: "Hanfeng",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1808950,
  },
  {
    name: "Changzhi",
    country: "China",
    subcountry: "Shanxi",
    geonameid: 1808956,
  },
  {
    name: "Handan",
    country: "China",
    subcountry: "Hebei",
    geonameid: 1808963,
  },
  {
    name: "Hanchuan",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1808977,
  },
  {
    name: "Hancheng",
    country: "China",
    subcountry: "Shaanxi",
    geonameid: 1808981,
  },
  {
    name: "Haizhou",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1809003,
  },
  {
    name: "Haiyang",
    country: "China",
    subcountry: "Anhui",
    geonameid: 1809023,
  },
  {
    name: "Haitou",
    country: "China",
    subcountry: "Hainan",
    geonameid: 1809034,
  },
  {
    name: "Jiaojiang",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1809061,
  },
  {
    name: "Haimen",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1809062,
  },
  {
    name: "Haikou",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1809077,
  },
  {
    name: "Haikou",
    country: "China",
    subcountry: "Hainan",
    geonameid: 1809078,
  },
  {
    name: "Guyuan",
    country: "China",
    subcountry: "Ningxia Hui Autonomous Region",
    geonameid: 1809152,
  },
  {
    name: "Guye",
    country: "China",
    subcountry: "Hebei",
    geonameid: 1809159,
  },
  {
    name: "Guxian",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1809178,
  },
  {
    name: "Guxi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1809193,
  },
  {
    name: "Gupi",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1809250,
  },
  {
    name: "Guozhen",
    country: "China",
    subcountry: "Shaanxi",
    geonameid: 1809263,
  },
  {
    name: "Guofu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1809338,
  },
  {
    name: "Gunan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1809380,
  },
  {
    name: "Gulin",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1809408,
  },
  {
    name: "Guli",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1809412,
  },
  {
    name: "Guiyang",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 1809461,
  },
  {
    name: "Guixi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1809467,
  },
  {
    name: "Guiren",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1809483,
  },
  {
    name: "Guiping",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1809486,
  },
  {
    name: "Guilin",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1809498,
  },
  {
    name: "Guigang",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1809532,
  },
  {
    name: "Gucheng Chengguanzhen",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1809610,
  },
  {
    name: "Guanzhuang",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1809646,
  },
  {
    name: "Guanyin",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1809677,
  },
  {
    name: "Guanhu",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1809849,
  },
  {
    name: "Guangzhou",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1809858,
  },
  {
    name: "Guangshun",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1809877,
  },
  {
    name: "Guangshui",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1809879,
  },
  {
    name: "Guandu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1809962,
  },
  {
    name: "Guandu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1809963,
  },
  {
    name: "Gongtan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1810085,
  },
  {
    name: "Gongping",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1810101,
  },
  {
    name: "Gongmen",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1810107,
  },
  {
    name: "Gongguan",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1810136,
  },
  {
    name: "Gelan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1810235,
  },
  {
    name: "Gejiu",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1810240,
  },
  {
    name: "Gecheng",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1810266,
  },
  {
    name: "Gaozuo",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1810279,
  },
  {
    name: "Gaozhou",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1810295,
  },
  {
    name: "Gaoyou",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1810309,
  },
  {
    name: "Gaoping",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1810437,
  },
  {
    name: "Gaomi",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1810458,
  },
  {
    name: "Gaoliu",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1810472,
  },
  {
    name: "Gaoliu",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1810473,
  },
  {
    name: "Gaojia",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1810509,
  },
  {
    name: "Gaogu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1810552,
  },
  {
    name: "Gaogou",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1810553,
  },
  {
    name: "Gao’an",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1810625,
  },
  {
    name: "Ganzhou",
    country: "China",
    subcountry: "Jiangxi",
    geonameid: 1810638,
  },
  {
    name: "Gantang",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1810668,
  },
  {
    name: "Gantang",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1810672,
  },
  {
    name: "Ganshui",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1810677,
  },
  {
    name: "Gangu Chengguanzhen",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1810724,
  },
  {
    name: "Gangtou",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1810725,
  },
  {
    name: "Fuzhou",
    country: "China",
    subcountry: "Jiangxi",
    geonameid: 1810820,
  },
  {
    name: "Fuzhou",
    country: "China",
    subcountry: "Fujian",
    geonameid: 1810821,
  },
  {
    name: "Fujia",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1810822,
  },
  {
    name: "Fuyang",
    country: "China",
    subcountry: "Anhui",
    geonameid: 1810845,
  },
  {
    name: "Fuyang",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1810846,
  },
  {
    name: "Wofo",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1810870,
  },
  {
    name: "Qingyang",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1810920,
  },
  {
    name: "Fulu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1810963,
  },
  {
    name: "Fuling",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1810979,
  },
  {
    name: "Fuji",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1811028,
  },
  {
    name: "Foshan",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1811103,
  },
  {
    name: "Fenyi",
    country: "China",
    subcountry: "Jiangxi",
    geonameid: 1811114,
  },
  {
    name: "Fenshui",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1811140,
  },
  {
    name: "Fengyi",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1811184,
  },
  {
    name: "Fengcheng",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1811200,
  },
  {
    name: "Fengrun",
    country: "China",
    subcountry: "Hebei",
    geonameid: 1811260,
  },
  {
    name: "Fengkou",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1811305,
  },
  {
    name: "Fengjia",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1811327,
  },
  {
    name: "Fenggao",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1811374,
  },
  {
    name: "Fenggang",
    country: "China",
    subcountry: "Jiangxi",
    geonameid: 1811378,
  },
  {
    name: "Feicheng",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1811440,
  },
  {
    name: "Fangshan",
    country: "China",
    subcountry: "Beijing",
    geonameid: 1811542,
  },
  {
    name: "Fangcun",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1811583,
  },
  {
    name: "Fangcheng Chengguanzhen",
    country: "China",
    subcountry: "Henan",
    geonameid: 1811594,
  },
  {
    name: "Ezhou",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1811619,
  },
  {
    name: "Enshi",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1811720,
  },
  {
    name: "Encheng",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1811729,
  },
  {
    name: "Eman",
    country: "China",
    subcountry: "Hainan",
    geonameid: 1811737,
  },
  {
    name: "Ehen Hudag",
    country: "China",
    subcountry: "Inner Mongolia",
    geonameid: 1811746,
  },
  {
    name: "Duzhou",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1811758,
  },
  {
    name: "Duyun",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 1811764,
  },
  {
    name: "Dushi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1811786,
  },
  {
    name: "Dushan",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 1811794,
  },
  {
    name: "Duobao",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1811829,
  },
  {
    name: "Dunhou",
    country: "China",
    subcountry: "Jiangxi",
    geonameid: 1811844,
  },
  {
    name: "Ducheng",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1811929,
  },
  {
    name: "Duoba",
    country: "China",
    subcountry: "Qinghai",
    geonameid: 1811970,
  },
  {
    name: "Xinyi",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1812057,
  },
  {
    name: "Dongying",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1812101,
  },
  {
    name: "Dongxing",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1812138,
  },
  {
    name: "Dongxi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1812168,
  },
  {
    name: "Dongtai",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1812228,
  },
  {
    name: "Dongsheng",
    country: "China",
    subcountry: "Inner Mongolia",
    geonameid: 1812256,
  },
  {
    name: "Dongkan",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1812427,
  },
  {
    name: "Donghai",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1812521,
  },
  {
    name: "Dongguan",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1812545,
  },
  {
    name: "Dongdu",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1812597,
  },
  {
    name: "Dongcun",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1812621,
  },
  {
    name: "Dongchuan",
    country: "China",
    subcountry: "Qinghai",
    geonameid: 1812630,
  },
  {
    name: "Xinle",
    country: "China",
    subcountry: "Hebei",
    geonameid: 1812647,
  },
  {
    name: "Dingzhou",
    country: "China",
    subcountry: "Hebei",
    geonameid: 1812728,
  },
  {
    name: "Dingxi",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1812749,
  },
  {
    name: "Dingtao",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1812754,
  },
  {
    name: "Dingshi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1812760,
  },
  {
    name: "Dingjia",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1812792,
  },
  {
    name: "Dezhou",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1812955,
  },
  {
    name: "Deyang",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1812961,
  },
  {
    name: "Deqing",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1812981,
  },
  {
    name: "Dengzhou",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1812988,
  },
  {
    name: "Dengzhou",
    country: "China",
    subcountry: "Henan",
    geonameid: 1812990,
  },
  {
    name: "Songyang",
    country: "China",
    subcountry: "Henan",
    geonameid: 1813016,
  },
  {
    name: "Degan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1813032,
  },
  {
    name: "Liping",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 1813033,
  },
  {
    name: "Dazhong",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1813088,
  },
  {
    name: "Zhangjiajie",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1813171,
  },
  {
    name: "Daye",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1813206,
  },
  {
    name: "Lijiang",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1813253,
  },
  {
    name: "Daxing",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1813299,
  },
  {
    name: "Daxie",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1813315,
  },
  {
    name: "Dazhou",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1813325,
  },
  {
    name: "Dawukou",
    country: "China",
    subcountry: "Ningxia Hui Autonomous Region",
    geonameid: 1813344,
  },
  {
    name: "Datun",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1813425,
  },
  {
    name: "Datong",
    country: "China",
    subcountry: "Anhui",
    geonameid: 1813451,
  },
  {
    name: "Dashun",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1813520,
  },
  {
    name: "Dashan",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1813591,
  },
  {
    name: "Fenghua",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1813658,
  },
  {
    name: "Daotian",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1813755,
  },
  {
    name: "Daokou",
    country: "China",
    subcountry: "Henan",
    geonameid: 1813775,
  },
  {
    name: "Danshui",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1813812,
  },
  {
    name: "Danjiangkou",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1813828,
  },
  {
    name: "Gushu",
    country: "China",
    subcountry: "Anhui",
    geonameid: 1813851,
  },
  {
    name: "Dangjiang",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1813868,
  },
  {
    name: "Tanchang Chengguanzhen",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1813875,
  },
  {
    name: "Xincheng",
    country: "China",
    subcountry: "Henan",
    geonameid: 1813892,
  },
  {
    name: "Damiao",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1813927,
  },
  {
    name: "Dalu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1814001,
  },
  {
    name: "Daliang",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1814082,
  },
  {
    name: "Dalian",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 1814087,
  },
  {
    name: "Dali",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1814093,
  },
  {
    name: "Dajin",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1814161,
  },
  {
    name: "Dahuangshan",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1814272,
  },
  {
    name: "Daguan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1814385,
  },
  {
    name: "Dafengdong",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 1814430,
  },
  {
    name: "Dachang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1814545,
  },
  {
    name: "Shuren",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1814612,
  },
  {
    name: "Da’an",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1814646,
  },
  {
    name: "Cuijiaji",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1814693,
  },
  {
    name: "Cizhu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1814712,
  },
  {
    name: "Chuzhou",
    country: "China",
    subcountry: "Anhui",
    geonameid: 1814757,
  },
  {
    name: "Yangchun",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1814786,
  },
  {
    name: "Yiwu",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1814870,
  },
  {
    name: "Chongxing",
    country: "China",
    subcountry: "Ningxia Hui Autonomous Region",
    geonameid: 1814882,
  },
  {
    name: "Chongqing",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1814906,
  },
  {
    name: "Chonglong",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1814919,
  },
  {
    name: "Chongkan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1814921,
  },
  {
    name: "Chizhou",
    country: "China",
    subcountry: "Anhui",
    geonameid: 1814934,
  },
  {
    name: "Chenzhou",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1815059,
  },
  {
    name: "Chengyang",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1815184,
  },
  {
    name: "Chengxian Chengguanzhen",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1815188,
  },
  {
    name: "Chengxi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1815193,
  },
  {
    name: "Chengjiang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1815249,
  },
  {
    name: "Jiangyin",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1815251,
  },
  {
    name: "Chenggu",
    country: "China",
    subcountry: "Shaanxi",
    geonameid: 1815276,
  },
  {
    name: "Chengdu",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1815286,
  },
  {
    name: "Chenghua",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1815302,
  },
  {
    name: "Chefushan",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1815345,
  },
  {
    name: "Chaozhou",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1815395,
  },
  {
    name: "Chaotian",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1815413,
  },
  {
    name: "Chaohu",
    country: "China",
    subcountry: "Anhui",
    geonameid: 1815427,
  },
  {
    name: "Changzhou",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1815456,
  },
  {
    name: "Changzhi",
    country: "China",
    subcountry: "Shanxi",
    geonameid: 1815463,
  },
  {
    name: "Changyuan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1815477,
  },
  {
    name: "Changyi",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1815482,
  },
  {
    name: "Changxin",
    country: "China",
    subcountry: "Ningxia Hui Autonomous Region",
    geonameid: 1815494,
  },
  {
    name: "Changsha",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1815577,
  },
  {
    name: "Changqing",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1815585,
  },
  {
    name: "Changning",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1815617,
  },
  {
    name: "Changli",
    country: "China",
    subcountry: "Hebei",
    geonameid: 1815656,
  },
  {
    name: "Changleng",
    country: "China",
    subcountry: "Jiangxi",
    geonameid: 1815667,
  },
  {
    name: "Changle",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1815669,
  },
  {
    name: "Changle",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1815678,
  },
  {
    name: "Changdian",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1815758,
  },
  {
    name: "Changcheng",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1815779,
  },
  {
    name: "Changba",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1815797,
  },
  {
    name: "Chaigou",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1815847,
  },
  {
    name: "Chahe",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1815856,
  },
  {
    name: "Longxing",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1815878,
  },
  {
    name: "Caoqiao",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1815971,
  },
  {
    name: "Caohe",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1816026,
  },
  {
    name: "Weining",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 1816028,
  },
  {
    name: "Cangzhou",
    country: "China",
    subcountry: "Hebei",
    geonameid: 1816080,
  },
  {
    name: "Caijia",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1816162,
  },
  {
    name: "Caidian",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1816176,
  },
  {
    name: "Buhe",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1816221,
  },
  {
    name: "Bozhou",
    country: "China",
    subcountry: "Anhui",
    geonameid: 1816234,
  },
  {
    name: "Botou",
    country: "China",
    subcountry: "Hebei",
    geonameid: 1816256,
  },
  {
    name: "Boshan",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1816265,
  },
  {
    name: "Baise",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1816269,
  },
  {
    name: "Biyang",
    country: "China",
    subcountry: "Anhui",
    geonameid: 1816316,
  },
  {
    name: "Bishan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1816329,
  },
  {
    name: "Binzhou",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1816336,
  },
  {
    name: "Bikou",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1816369,
  },
  {
    name: "Bijie",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 1816373,
  },
  {
    name: "Bianzhuang",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1816406,
  },
  {
    name: "Biantang",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1816412,
  },
  {
    name: "Bengbu",
    country: "China",
    subcountry: "Anhui",
    geonameid: 1816440,
  },
  {
    name: "Beiwangli",
    country: "China",
    subcountry: "Hebei",
    geonameid: 1816535,
  },
  {
    name: "Beisu",
    country: "China",
    subcountry: "Hebei",
    geonameid: 1816560,
  },
  {
    name: "Beimeng",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1816620,
  },
  {
    name: "Beijing",
    country: "China",
    subcountry: "Beijing",
    geonameid: 1816670,
  },
  {
    name: "Beihai",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1816705,
  },
  {
    name: "Beidao",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1816751,
  },
  {
    name: "Beidaihehaibin",
    country: "China",
    subcountry: "Hebei",
    geonameid: 1816753,
  },
  {
    name: "Beibei",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1816790,
  },
  {
    name: "Bayiji",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1816813,
  },
  {
    name: "Bayan Hot",
    country: "China",
    subcountry: "Inner Mongolia",
    geonameid: 1816821,
  },
  {
    name: "Baiyang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1816824,
  },
  {
    name: "Shuanglong",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1816838,
  },
  {
    name: "Batang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1816851,
  },
  {
    name: "Basuo",
    country: "China",
    subcountry: "Hainan",
    geonameid: 1816858,
  },
  {
    name: "Bashan",
    country: "China",
    subcountry: "Jiangxi",
    geonameid: 1816865,
  },
  {
    name: "Baoying",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1816890,
  },
  {
    name: "Shaoyang",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1816920,
  },
  {
    name: "Langzhong",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1816924,
  },
  {
    name: "Baoluan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1816929,
  },
  {
    name: "Baojia",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1816942,
  },
  {
    name: "Baoding",
    country: "China",
    subcountry: "Hebei",
    geonameid: 1816971,
  },
  {
    name: "Banqiao",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1817038,
  },
  {
    name: "Balu",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1817137,
  },
  {
    name: "Baizi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1817193,
  },
  {
    name: "Baiyin",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1817240,
  },
  {
    name: "Baixi",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1817294,
  },
  {
    name: "Baituo",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1817306,
  },
  {
    name: "Baitu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1817310,
  },
  {
    name: "Baitao",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1817330,
  },
  {
    name: "Baisha",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1817441,
  },
  {
    name: "Baisha",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1817456,
  },
  {
    name: "Baimajing",
    country: "China",
    subcountry: "Hainan",
    geonameid: 1817543,
  },
  {
    name: "Baima",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1817553,
  },
  {
    name: "Bailin",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1817589,
  },
  {
    name: "Baihua",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1817676,
  },
  {
    name: "Baihecun",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1817701,
  },
  {
    name: "Shangyu",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1817720,
  },
  {
    name: "Baichihe",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1817762,
  },
  {
    name: "Bachuan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1817848,
  },
  {
    name: "Babu",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 1817858,
  },
  {
    name: "Qilian",
    country: "China",
    subcountry: "Qinghai",
    geonameid: 1817862,
  },
  {
    name: "Aoxi",
    country: "China",
    subcountry: "Jiangxi",
    geonameid: 1817884,
  },
  {
    name: "Qingyang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1817925,
  },
  {
    name: "Anyuan",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1817932,
  },
  {
    name: "Anxiang",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1817952,
  },
  {
    name: "Anshun",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 1817968,
  },
  {
    name: "Anqiu",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1817990,
  },
  {
    name: "Anqing",
    country: "China",
    subcountry: "Anhui",
    geonameid: 1817993,
  },
  {
    name: "Anping",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1818002,
  },
  {
    name: "Mabai",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 1818004,
  },
  {
    name: "Anlu",
    country: "China",
    subcountry: "Hubei",
    geonameid: 1818016,
  },
  {
    name: "Anlong",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 1818019,
  },
  {
    name: "Anliu",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1818020,
  },
  {
    name: "Anju",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1818042,
  },
  {
    name: "Anjiang",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1818051,
  },
  {
    name: "Anhua",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1818062,
  },
  {
    name: "Anfu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1818082,
  },
  {
    name: "Naxi",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1818086,
  },
  {
    name: "Anbu",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1818116,
  },
  {
    name: "Ahu",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1818165,
  },
  {
    name: "Zhonghe",
    country: "China",
    subcountry: "Hainan",
    geonameid: 1885400,
  },
  {
    name: "Jiangyou",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1885823,
  },
  {
    name: "Suzhou",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1886760,
  },
  {
    name: "Zhoushan",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1886762,
  },
  {
    name: "Dacheng",
    country: "China",
    subcountry: "Hainan",
    geonameid: 1893595,
  },
  {
    name: "Wuduan",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1897997,
  },
  {
    name: "Guanshan",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1898013,
  },
  {
    name: "Mudu",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1898359,
  },
  {
    name: "Songling",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 1898494,
  },
  {
    name: "Lüfeng",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1904024,
  },
  {
    name: "Xinsheng",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1904026,
  },
  {
    name: "Yongxi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1904046,
  },
  {
    name: "Pulü",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1904048,
  },
  {
    name: "Caijiagang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1904050,
  },
  {
    name: "Tieshan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1904058,
  },
  {
    name: "Hebao",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1904071,
  },
  {
    name: "Baoxing",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1904072,
  },
  {
    name: "Damiao",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1904076,
  },
  {
    name: "Daxing",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1904080,
  },
  {
    name: "Jinlong",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1904091,
  },
  {
    name: "Sanjiao",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1904094,
  },
  {
    name: "Guangpu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1904121,
  },
  {
    name: "Chenshi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1904136,
  },
  {
    name: "Qingfeng",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1904138,
  },
  {
    name: "Wutan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1904163,
  },
  {
    name: "Wujian",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1904172,
  },
  {
    name: "Hegeng",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1904174,
  },
  {
    name: "Xianlong",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1904187,
  },
  {
    name: "Ji’an",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1904188,
  },
  {
    name: "Kaitang",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 1905431,
  },
  {
    name: "Bibo",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 1905846,
  },
  {
    name: "Jiuchao",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 1906074,
  },
  {
    name: "Zhaoxing",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 1906095,
  },
  {
    name: "Anfu",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1907959,
  },
  {
    name: "Baijiawan",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1907960,
  },
  {
    name: "Baliwan",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1907961,
  },
  {
    name: "Dashi",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1907965,
  },
  {
    name: "Dazhuang",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1907966,
  },
  {
    name: "Guochuan",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1907969,
  },
  {
    name: "Jinshan",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1907975,
  },
  {
    name: "Jutou",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1907976,
  },
  {
    name: "Kuanchuan",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1907977,
  },
  {
    name: "Liuping",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1907979,
  },
  {
    name: "Qianhu",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1907990,
  },
  {
    name: "Shiqiao",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1907994,
  },
  {
    name: "Suhe",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1907996,
  },
  {
    name: "Wangyao",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1908000,
  },
  {
    name: "Wangyin",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1908001,
  },
  {
    name: "Wenquan",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1908004,
  },
  {
    name: "Xingfeng",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1908009,
  },
  {
    name: "Xinglong",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1908010,
  },
  {
    name: "Xinxing",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1908011,
  },
  {
    name: "Yebao",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1908015,
  },
  {
    name: "Yongping",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1908016,
  },
  {
    name: "Zhongshan",
    country: "China",
    subcountry: "Gansu",
    geonameid: 1908018,
  },
  {
    name: "Shima",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1909053,
  },
  {
    name: "Banan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1909733,
  },
  {
    name: "Dianbu",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1912383,
  },
  {
    name: "Yunshan",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1912420,
  },
  {
    name: "Xiasi",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 1914158,
  },
  {
    name: "Conglin",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1914235,
  },
  {
    name: "Ciyun",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1914237,
  },
  {
    name: "Xiaba",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1914240,
  },
  {
    name: "Anlan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1914248,
  },
  {
    name: "Shilong",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1914250,
  },
  {
    name: "Nanpeng",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1914252,
  },
  {
    name: "Huimin",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1914255,
  },
  {
    name: "Ersheng",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1914256,
  },
  {
    name: "Yufengshan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1914265,
  },
  {
    name: "Tongjiaxi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1914267,
  },
  {
    name: "Dasheng",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1914274,
  },
  {
    name: "Taiping",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1914275,
  },
  {
    name: "Tuchang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1914276,
  },
  {
    name: "Honghu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1914280,
  },
  {
    name: "Lanyang",
    country: "China",
    subcountry: "Hainan",
    geonameid: 1914825,
  },
  {
    name: "Guangcun",
    country: "China",
    subcountry: "Hainan",
    geonameid: 1914915,
  },
  {
    name: "Sandu",
    country: "China",
    subcountry: "Hainan",
    geonameid: 1914927,
  },
  {
    name: "Mutang",
    country: "China",
    subcountry: "Hainan",
    geonameid: 1914932,
  },
  {
    name: "Dongcheng",
    country: "China",
    subcountry: "Hainan",
    geonameid: 1914952,
  },
  {
    name: "Heqing",
    country: "China",
    subcountry: "Hainan",
    geonameid: 1914965,
  },
  {
    name: "Wuzhishan",
    country: "China",
    subcountry: "Hainan",
    geonameid: 1916012,
  },
  {
    name: "Lianghu",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 1919014,
  },
  {
    name: "Zhoucheng",
    country: "China",
    subcountry: "Shandong",
    geonameid: 1920772,
  },
  {
    name: "Dalianwan",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 1921372,
  },
  {
    name: "Xiaochangshan",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 1921495,
  },
  {
    name: "Wuyishan",
    country: "China",
    subcountry: "Fujian",
    geonameid: 1922014,
  },
  {
    name: "Yueyang",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1927639,
  },
  {
    name: "Bojia",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1929434,
  },
  {
    name: "Santangpu",
    country: "China",
    subcountry: "Hunan",
    geonameid: 1930074,
  },
  {
    name: "Zhaojia",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1942226,
  },
  {
    name: "Gulu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1942230,
  },
  {
    name: "Zouma",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1942248,
  },
  {
    name: "Yantai",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1942254,
  },
  {
    name: "Sanmiao",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1942265,
  },
  {
    name: "Rongxi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1942269,
  },
  {
    name: "Longsheng",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1942274,
  },
  {
    name: "Lixi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 1948720,
  },
  {
    name: "Hedong",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 1997228,
  },
  {
    name: "Zhenlai",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2033128,
  },
  {
    name: "Shuangliao",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2033135,
  },
  {
    name: "Zhaozhou",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2033147,
  },
  {
    name: "Zhaoyuan",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2033149,
  },
  {
    name: "Zhaodong",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2033168,
  },
  {
    name: "Zhangjiakou",
    country: "China",
    subcountry: "Hebei",
    geonameid: 2033196,
  },
  {
    name: "Zhalantun",
    country: "China",
    subcountry: "Inner Mongolia",
    geonameid: 2033225,
  },
  {
    name: "Yushu",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2033242,
  },
  {
    name: "Youhao",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2033301,
  },
  {
    name: "Yingkou",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2033370,
  },
  {
    name: "Yilan",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2033403,
  },
  {
    name: "Yichun",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2033413,
  },
  {
    name: "Yebaishou",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2033423,
  },
  {
    name: "Yantongshan",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2033449,
  },
  {
    name: "Yanji",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2033467,
  },
  {
    name: "Yakeshi",
    country: "China",
    subcountry: "Inner Mongolia",
    geonameid: 2033536,
  },
  {
    name: "Xuanhua",
    country: "China",
    subcountry: "Hebei",
    geonameid: 2033574,
  },
  {
    name: "Xiuyan",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2033602,
  },
  {
    name: "Xinqing",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2033667,
  },
  {
    name: "Xinmin",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2033675,
  },
  {
    name: "Xinglongshan",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2033739,
  },
  {
    name: "Xingcheng",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2033766,
  },
  {
    name: "Xilin Hot",
    country: "China",
    subcountry: "Inner Mongolia",
    geonameid: 2033824,
  },
  {
    name: "Xifeng",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2033866,
  },
  {
    name: "Xiaoshi",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2033934,
  },
  {
    name: "Wuchang",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2034141,
  },
  {
    name: "Wangqing",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2034221,
  },
  {
    name: "Hepingjie",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2034226,
  },
  {
    name: "Wangkui",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2034228,
  },
  {
    name: "Ulanhot",
    country: "China",
    subcountry: "Inner Mongolia",
    geonameid: 2034312,
  },
  {
    name: "Tumen",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2034340,
  },
  {
    name: "Tongliao",
    country: "China",
    subcountry: "Inner Mongolia",
    geonameid: 2034400,
  },
  {
    name: "Tonghua",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2034414,
  },
  {
    name: "Tieling",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2034439,
  },
  {
    name: "Tieli",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2034440,
  },
  {
    name: "Taonan",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2034497,
  },
  {
    name: "Tailai",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2034599,
  },
  {
    name: "Dorbod",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2034600,
  },
  {
    name: "Tahe",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2034615,
  },
  {
    name: "Sujiatun",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2034638,
  },
  {
    name: "Suiling",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2034651,
  },
  {
    name: "Suihua",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2034655,
  },
  {
    name: "Suifenhe",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2034657,
  },
  {
    name: "Songjianghe",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2034691,
  },
  {
    name: "Siping",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2034714,
  },
  {
    name: "Shunyi",
    country: "China",
    subcountry: "Beijing",
    geonameid: 2034754,
  },
  {
    name: "Shulan",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2034761,
  },
  {
    name: "Shuangyashan",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2034786,
  },
  {
    name: "Shuangyang",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2034791,
  },
  {
    name: "Shuangcheng",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2034834,
  },
  {
    name: "Shiguai",
    country: "China",
    subcountry: "Inner Mongolia",
    geonameid: 2034918,
  },
  {
    name: "Shenyang",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2034937,
  },
  {
    name: "Shanhecun",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2034995,
  },
  {
    name: "Shanhaiguan",
    country: "China",
    subcountry: "Hebei",
    geonameid: 2034996,
  },
  {
    name: "Shangzhi",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2035002,
  },
  {
    name: "Sanchazi",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2035182,
  },
  {
    name: "Salaqi",
    country: "China",
    subcountry: "Inner Mongolia",
    geonameid: 2035196,
  },
  {
    name: "Fendou",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2035225,
  },
  {
    name: "Qitaihe",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2035261,
  },
  {
    name: "Qiqihar",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2035265,
  },
  {
    name: "Qinggang",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2035325,
  },
  {
    name: "Songyuan",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2035399,
  },
  {
    name: "Pingzhuang",
    country: "China",
    subcountry: "Inner Mongolia",
    geonameid: 2035453,
  },
  {
    name: "Panshi",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2035511,
  },
  {
    name: "Panshan",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2035513,
  },
  {
    name: "Nianzishan",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2035593,
  },
  {
    name: "Nenjiang",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2035601,
  },
  {
    name: "Nehe",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2035610,
  },
  {
    name: "Nantai",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2035635,
  },
  {
    name: "Nanpiao",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2035644,
  },
  {
    name: "Lianhe",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2035669,
  },
  {
    name: "Mujiayingzi",
    country: "China",
    subcountry: "Inner Mongolia",
    geonameid: 2035707,
  },
  {
    name: "Mudanjiang",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2035715,
  },
  {
    name: "Mishan",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2035746,
  },
  {
    name: "Antu",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2035754,
  },
  {
    name: "Mingshui",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2035758,
  },
  {
    name: "Meihekou",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2035801,
  },
  {
    name: "Manzhouli",
    country: "China",
    subcountry: "Inner Mongolia",
    geonameid: 2035836,
  },
  {
    name: "Longjing",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2035966,
  },
  {
    name: "Longjiang",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2035970,
  },
  {
    name: "Longfeng",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2035980,
  },
  {
    name: "Liuhe",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2036033,
  },
  {
    name: "Lishu",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2036055,
  },
  {
    name: "Linkou",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2036066,
  },
  {
    name: "Linjiang",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2036069,
  },
  {
    name: "Lingyuan",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2036075,
  },
  {
    name: "Lingdong",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2036081,
  },
  {
    name: "Liaozhong",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2036106,
  },
  {
    name: "Liaoyuan",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2036109,
  },
  {
    name: "Liaoyang",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2036113,
  },
  {
    name: "Lanxi",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2036226,
  },
  {
    name: "Langxiang",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2036237,
  },
  {
    name: "Langtoucun",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2036241,
  },
  {
    name: "Kuandian",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2036283,
  },
  {
    name: "Kaiyuan",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2036337,
  },
  {
    name: "Kaitong",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2036338,
  },
  {
    name: "Jixi",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2036389,
  },
  {
    name: "Jiutai",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2036401,
  },
  {
    name: "Jiupu",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2036403,
  },
  {
    name: "Jishu",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2036418,
  },
  {
    name: "Jinzhou",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2036427,
  },
  {
    name: "Lianshan",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2036434,
  },
  {
    name: "Jining",
    country: "China",
    subcountry: "Inner Mongolia",
    geonameid: 2036458,
  },
  {
    name: "Jilin",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2036502,
  },
  {
    name: "Jidong",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2036519,
  },
  {
    name: "Jiaohe",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2036536,
  },
  {
    name: "Jiamusi",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2036581,
  },
  {
    name: "Jalai Nur",
    country: "China",
    subcountry: "Inner Mongolia",
    geonameid: 2036595,
  },
  {
    name: "Jiagedaqi",
    country: "China",
    subcountry: "Inner Mongolia",
    geonameid: 2036597,
  },
  {
    name: "Hushitai",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2036619,
  },
  {
    name: "Hunchun",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2036653,
  },
  {
    name: "Hulan Ergi",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2036670,
  },
  {
    name: "Hulan",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2036671,
  },
  {
    name: "Huinan",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2036685,
  },
  {
    name: "Huanren",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2036713,
  },
  {
    name: "Huangnihe",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2036734,
  },
  {
    name: "Huanan",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2036753,
  },
  {
    name: "Huadian",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2036776,
  },
  {
    name: "Honggang",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2036876,
  },
  {
    name: "Hohhot",
    country: "China",
    subcountry: "Inner Mongolia",
    geonameid: 2036892,
  },
  {
    name: "Hengshan",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2036920,
  },
  {
    name: "Helong",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2036933,
  },
  {
    name: "Heishan",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2036959,
  },
  {
    name: "Heihe",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2036973,
  },
  {
    name: "Hegang",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2036986,
  },
  {
    name: "Harbin",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2037013,
  },
  {
    name: "Hailun",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2037069,
  },
  {
    name: "Hailin",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2037075,
  },
  {
    name: "Hailar",
    country: "China",
    subcountry: "Inner Mongolia",
    geonameid: 2037078,
  },
  {
    name: "Haicheng",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2037086,
  },
  {
    name: "Gongzhuling",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2037222,
  },
  {
    name: "Gongchangling",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2037240,
  },
  {
    name: "Genhe",
    country: "China",
    subcountry: "Inner Mongolia",
    geonameid: 2037252,
  },
  {
    name: "Gannan",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2037311,
  },
  {
    name: "Fuyuan",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2037330,
  },
  {
    name: "Fuyu",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2037334,
  },
  {
    name: "Fuyu",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2037335,
  },
  {
    name: "Fuxin",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2037346,
  },
  {
    name: "Fushun",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2037355,
  },
  {
    name: "Jixian",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2037370,
  },
  {
    name: "Fujin",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2037375,
  },
  {
    name: "Beichengqu",
    country: "China",
    subcountry: "Inner Mongolia",
    geonameid: 2037391,
  },
  {
    name: "Luobei",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2037393,
  },
  {
    name: "Fengcheng",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2037411,
  },
  {
    name: "Erenhot",
    country: "China",
    subcountry: "Inner Mongolia",
    geonameid: 2037485,
  },
  {
    name: "Erdaojiang",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2037494,
  },
  {
    name: "Dunhua",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2037534,
  },
  {
    name: "Dongning",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2037611,
  },
  {
    name: "Dongling",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2037620,
  },
  {
    name: "Dongfeng",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2037658,
  },
  {
    name: "Didao",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2037685,
  },
  {
    name: "Dehui",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2037712,
  },
  {
    name: "Datong",
    country: "China",
    subcountry: "Shanxi",
    geonameid: 2037799,
  },
  {
    name: "Dashitou",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2037820,
  },
  {
    name: "Dashiqiao",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2037823,
  },
  {
    name: "Daqing",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2037860,
  },
  {
    name: "Dandong",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2037886,
  },
  {
    name: "Linghai",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2037913,
  },
  {
    name: "Dalain Hob",
    country: "China",
    subcountry: "Inner Mongolia",
    geonameid: 2037927,
  },
  {
    name: "Dalai",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2037930,
  },
  {
    name: "Chifeng",
    country: "China",
    subcountry: "Inner Mongolia",
    geonameid: 2038067,
  },
  {
    name: "Chengzihe",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2038080,
  },
  {
    name: "Chengde",
    country: "China",
    subcountry: "Hebei",
    geonameid: 2038087,
  },
  {
    name: "Chaoyang",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2038118,
  },
  {
    name: "Chaoyang",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2038120,
  },
  {
    name: "Changtu",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2038139,
  },
  {
    name: "Changping",
    country: "China",
    subcountry: "Beijing",
    geonameid: 2038154,
  },
  {
    name: "Changling",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2038158,
  },
  {
    name: "Changchun",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2038180,
  },
  {
    name: "Chaihe",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2038198,
  },
  {
    name: "Boli",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2038274,
  },
  {
    name: "Bin Xian",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2038283,
  },
  {
    name: "Benxi",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2038300,
  },
  {
    name: "Beipiao",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2038342,
  },
  {
    name: "Bei’an",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2038365,
  },
  {
    name: "Bayan",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2038421,
  },
  {
    name: "Baotou",
    country: "China",
    subcountry: "Inner Mongolia",
    geonameid: 2038432,
  },
  {
    name: "Baoshan",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2038438,
  },
  {
    name: "Baoqing",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2038446,
  },
  {
    name: "Muling",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2038482,
  },
  {
    name: "Baishishan",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2038529,
  },
  {
    name: "Baiquan",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2038541,
  },
  {
    name: "Baicheng",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2038569,
  },
  {
    name: "Baishan",
    country: "China",
    subcountry: "Jilin",
    geonameid: 2038584,
  },
  {
    name: "Anshan",
    country: "China",
    subcountry: "Liaoning",
    geonameid: 2038632,
  },
  {
    name: "Anda",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2038650,
  },
  {
    name: "Oroqen Zizhiqi",
    country: "China",
    subcountry: "Inner Mongolia",
    geonameid: 2038665,
  },
  {
    name: "Acheng",
    country: "China",
    subcountry: "Heilongjiang",
    geonameid: 2038679,
  },
  {
    name: "Songling",
    country: "China",
    subcountry: "Hebei",
    geonameid: 2047837,
  },
  {
    name: "Shigang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 6310890,
  },
  {
    name: "E’zhou",
    country: "China",
    subcountry: "Hubei",
    geonameid: 6642286,
  },
  {
    name: "Jinniu",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 6644097,
  },
  {
    name: "Xiangjiaba",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 6648023,
  },
  {
    name: "Shilin",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 6825277,
  },
  {
    name: "Bowangshan",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 6913329,
  },
  {
    name: "Shuanglong",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 6921777,
  },
  {
    name: "Panzhihua",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 6929460,
  },
  {
    name: "Taifu",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 6963006,
  },
  {
    name: "Zhongshan",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 6986104,
  },
  {
    name: "Tongchuan",
    country: "China",
    subcountry: "Shaanxi",
    geonameid: 7064006,
  },
  {
    name: "Changshu",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 7283386,
  },
  {
    name: "Shixing",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 7290013,
  },
  {
    name: "Jiashan",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 7303248,
  },
  {
    name: "Fenghuang",
    country: "China",
    subcountry: "Hunan",
    geonameid: 7304020,
  },
  {
    name: "Baiguan",
    country: "China",
    subcountry: "Gansu",
    geonameid: 7326405,
  },
  {
    name: "Zhongba",
    country: "China",
    subcountry: "Gansu",
    geonameid: 7326411,
  },
  {
    name: "Dengbu",
    country: "China",
    subcountry: "Jiangxi",
    geonameid: 7328899,
  },
  {
    name: "Baihe",
    country: "China",
    subcountry: "Gansu",
    geonameid: 7329905,
  },
  {
    name: "Puchi",
    country: "China",
    subcountry: "Gansu",
    geonameid: 7338243,
  },
  {
    name: "Maying",
    country: "China",
    subcountry: "Gansu",
    geonameid: 7338250,
  },
  {
    name: "Hanwang",
    country: "China",
    subcountry: "Gansu",
    geonameid: 7340457,
  },
  {
    name: "Majie",
    country: "China",
    subcountry: "Gansu",
    geonameid: 7340460,
  },
  {
    name: "Dianga",
    country: "China",
    subcountry: "Gansu",
    geonameid: 7342980,
  },
  {
    name: "Dongjiang",
    country: "China",
    subcountry: "Gansu",
    geonameid: 7347727,
  },
  {
    name: "Chengjiao",
    country: "China",
    subcountry: "Gansu",
    geonameid: 7347732,
  },
  {
    name: "Wuying",
    country: "China",
    subcountry: "Gansu",
    geonameid: 7348380,
  },
  {
    name: "Lianhua",
    country: "China",
    subcountry: "Gansu",
    geonameid: 7348465,
  },
  {
    name: "Weidian",
    country: "China",
    subcountry: "Gansu",
    geonameid: 7348537,
  },
  {
    name: "Shibao",
    country: "China",
    subcountry: "Gansu",
    geonameid: 7352509,
  },
  {
    name: "Luotang",
    country: "China",
    subcountry: "Gansu",
    geonameid: 7372475,
  },
  {
    name: "Yulong",
    country: "China",
    subcountry: "Gansu",
    geonameid: 7372977,
  },
  {
    name: "Paosha",
    country: "China",
    subcountry: "Gansu",
    geonameid: 7373299,
  },
  {
    name: "Xigaoshan",
    country: "China",
    subcountry: "Gansu",
    geonameid: 7373329,
  },
  {
    name: "Luoyu",
    country: "China",
    subcountry: "Gansu",
    geonameid: 7373480,
  },
  {
    name: "Shili",
    country: "China",
    subcountry: "Gansu",
    geonameid: 7373600,
  },
  {
    name: "Jiangxi",
    country: "China",
    subcountry: "Gansu",
    geonameid: 7373656,
  },
  {
    name: "Luhe",
    country: "China",
    subcountry: "Gansu",
    geonameid: 7373672,
  },
  {
    name: "Xiyu",
    country: "China",
    subcountry: "Gansu",
    geonameid: 7373724,
  },
  {
    name: "Shaoyu",
    country: "China",
    subcountry: "Gansu",
    geonameid: 7373739,
  },
  {
    name: "Hadapu Zhen",
    country: "China",
    subcountry: "Gansu",
    geonameid: 7516804,
  },
  {
    name: "Lichuan Zhen",
    country: "China",
    subcountry: "Gansu",
    geonameid: 7516812,
  },
  {
    name: "Tange",
    country: "China",
    subcountry: "Gansu",
    geonameid: 7517266,
  },
  {
    name: "Mali",
    country: "China",
    subcountry: "Gansu",
    geonameid: 7517321,
  },
  {
    name: "Shandan",
    country: "China",
    subcountry: "Gansu",
    geonameid: 7517450,
  },
  {
    name: "Gaolou",
    country: "China",
    subcountry: "Gansu",
    geonameid: 7517492,
  },
  {
    name: "Yuanyang",
    country: "China",
    subcountry: "Gansu",
    geonameid: 7517497,
  },
  {
    name: "Hualin",
    country: "China",
    subcountry: "Gansu",
    geonameid: 7517557,
  },
  {
    name: "Hezhou",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 7576887,
  },
  {
    name: "Zhu Cheng City",
    country: "China",
    subcountry: "Shandong",
    geonameid: 7602670,
  },
  {
    name: "Shangri-La",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 7910932,
  },
  {
    name: "Ordos",
    country: "China",
    subcountry: "Inner Mongolia",
    geonameid: 8347664,
  },
  {
    name: "Daocheng",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 8395541,
  },
  {
    name: "Chengxiang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8397870,
  },
  {
    name: "Tangfang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8397876,
  },
  {
    name: "Fengling",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8397878,
  },
  {
    name: "Longjing",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8398262,
  },
  {
    name: "Baolong",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8398265,
  },
  {
    name: "Tonggu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8398266,
  },
  {
    name: "Sanxi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8398672,
  },
  {
    name: "Liangping",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8398673,
  },
  {
    name: "Longxi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8398676,
  },
  {
    name: "Futian",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8398677,
  },
  {
    name: "Dashu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8399036,
  },
  {
    name: "Kangle",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8399040,
  },
  {
    name: "Fenhe",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8399041,
  },
  {
    name: "Baidi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8399042,
  },
  {
    name: "Caotang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8399043,
  },
  {
    name: "Yongle",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8399044,
  },
  {
    name: "Jiagao",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8399045,
  },
  {
    name: "Qinglong",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8399049,
  },
  {
    name: "Wuma",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8399050,
  },
  {
    name: "Fengping",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8399052,
  },
  {
    name: "Qinglian",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8399478,
  },
  {
    name: "Heqian",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8400052,
  },
  {
    name: "Maliu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8400053,
  },
  {
    name: "Heyan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8400054,
  },
  {
    name: "Guojia",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8400056,
  },
  {
    name: "Baihe",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8400057,
  },
  {
    name: "Dunhao",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8400058,
  },
  {
    name: "Gaoqiao",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8400059,
  },
  {
    name: "Yihe",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8400137,
  },
  {
    name: "Jiulongshan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8400138,
  },
  {
    name: "Zhen’an",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8400139,
  },
  {
    name: "Dade",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8400140,
  },
  {
    name: "Fengle",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8400141,
  },
  {
    name: "Zhendong",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8400142,
  },
  {
    name: "Houba",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8400143,
  },
  {
    name: "Changsha",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8400146,
  },
  {
    name: "Nanmen",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8400147,
  },
  {
    name: "Wushan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8400149,
  },
  {
    name: "Nanya",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8400150,
  },
  {
    name: "Zhuxi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8400151,
  },
  {
    name: "Taizhou",
    country: "China",
    subcountry: "Zhejiang",
    geonameid: 8400694,
  },
  {
    name: "Houshan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8403605,
  },
  {
    name: "Lihe",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8403607,
  },
  {
    name: "Xiongjia",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8403609,
  },
  {
    name: "Tiancheng",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8403610,
  },
  {
    name: "Zhoujiaba",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8403611,
  },
  {
    name: "Taibai",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8403612,
  },
  {
    name: "Gaoliang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8403613,
  },
  {
    name: "Zhonggulou",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8403614,
  },
  {
    name: "Jiuchi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8403615,
  },
  {
    name: "Pailou",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8403616,
  },
  {
    name: "Chenjiaba",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8403617,
  },
  {
    name: "Bai’anba",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8403618,
  },
  {
    name: "Shuanghekou",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8403619,
  },
  {
    name: "Zhushan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8403620,
  },
  {
    name: "Danzi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8403846,
  },
  {
    name: "Changtan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8403867,
  },
  {
    name: "Tai’an",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8403868,
  },
  {
    name: "Luotian",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8403872,
  },
  {
    name: "Guocun",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8403877,
  },
  {
    name: "Longsha",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8403881,
  },
  {
    name: "Ganning",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8403882,
  },
  {
    name: "Gaofeng",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8403883,
  },
  {
    name: "Linxi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8404735,
  },
  {
    name: "Xialu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8404770,
  },
  {
    name: "Caohui",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8405691,
  },
  {
    name: "Xinmin",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8405692,
  },
  {
    name: "Changlong",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8405693,
  },
  {
    name: "Yong’an",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8405694,
  },
  {
    name: "Pushun",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8405695,
  },
  {
    name: "Gangjia",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8405696,
  },
  {
    name: "Gaofeng",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8405699,
  },
  {
    name: "Pingshan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8405701,
  },
  {
    name: "Baijia",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8405703,
  },
  {
    name: "Panlong",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8405713,
  },
  {
    name: "Yinping",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8405715,
  },
  {
    name: "Jukui",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8405717,
  },
  {
    name: "Bishan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8405721,
  },
  {
    name: "Huilong",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8405722,
  },
  {
    name: "Mingda",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8405727,
  },
  {
    name: "Lirang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8405728,
  },
  {
    name: "Hucheng",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8405731,
  },
  {
    name: "Xinsheng",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8405732,
  },
  {
    name: "Hexing",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8405736,
  },
  {
    name: "Baohe",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8406198,
  },
  {
    name: "Dongjia",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8406200,
  },
  {
    name: "Shizhi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8406204,
  },
  {
    name: "Huwei",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8406205,
  },
  {
    name: "Sanhe",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8406214,
  },
  {
    name: "Xingyi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8406218,
  },
  {
    name: "Longkong",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8406221,
  },
  {
    name: "Longhe",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8406223,
  },
  {
    name: "Qingxichang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8406649,
  },
  {
    name: "Pingkai",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8406650,
  },
  {
    name: "Zhongling",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8406675,
  },
  {
    name: "Erong",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8406677,
  },
  {
    name: "Guanzhuang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8406686,
  },
  {
    name: "Wanmu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8407506,
  },
  {
    name: "Tonggu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8407510,
  },
  {
    name: "Apengjiang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8407595,
  },
  {
    name: "Qianjiang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8408334,
  },
  {
    name: "Zhoubai",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8408335,
  },
  {
    name: "Dianshui",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8408394,
  },
  {
    name: "Sanhe",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8408551,
  },
  {
    name: "Xintian",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8408661,
  },
  {
    name: "Longshe",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8409070,
  },
  {
    name: "Lianhu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8409075,
  },
  {
    name: "Tongle",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8416210,
  },
  {
    name: "Zengfu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8416213,
  },
  {
    name: "Longqiao",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8416217,
  },
  {
    name: "Lizhi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8416218,
  },
  {
    name: "Nantuo",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8416236,
  },
  {
    name: "Qingxi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8416237,
  },
  {
    name: "Baisheng",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8416240,
  },
  {
    name: "Yihe",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8416247,
  },
  {
    name: "Yunji",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8416620,
  },
  {
    name: "Changshouhu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8416622,
  },
  {
    name: "Haitang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8416623,
  },
  {
    name: "Shiyan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8416624,
  },
  {
    name: "Longhe",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8416625,
  },
  {
    name: "Fengcheng",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8416626,
  },
  {
    name: "Jiangnan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8416627,
  },
  {
    name: "Bake",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8416628,
  },
  {
    name: "Dawan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8416813,
  },
  {
    name: "Gulu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8416814,
  },
  {
    name: "Lijia",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8416930,
  },
  {
    name: "Shuangfengqiao",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8416931,
  },
  {
    name: "Huixing",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8416933,
  },
  {
    name: "Cuiyun",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8416934,
  },
  {
    name: "Wangjia",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8416968,
  },
  {
    name: "Tianfu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8417103,
  },
  {
    name: "Fuxing",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8417104,
  },
  {
    name: "Dongyang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8417106,
  },
  {
    name: "Longfeng",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8417108,
  },
  {
    name: "Shuanghuai",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8417530,
  },
  {
    name: "Shuangfeng",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8417531,
  },
  {
    name: "Shitan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8417532,
  },
  {
    name: "Xiaojia",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8417533,
  },
  {
    name: "Laitan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8417596,
  },
  {
    name: "Qiantang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8417598,
  },
  {
    name: "Dashi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8417599,
  },
  {
    name: "Gulou",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8417600,
  },
  {
    name: "Yanwo",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8417601,
  },
  {
    name: "Erlang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8417602,
  },
  {
    name: "Longfeng",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8417603,
  },
  {
    name: "Longxing",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8417604,
  },
  {
    name: "Yangcheng",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8417605,
  },
  {
    name: "Diaoyucheng",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8417606,
  },
  {
    name: "Nanjin",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8417607,
  },
  {
    name: "Baoding",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8418557,
  },
  {
    name: "Zhifeng",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8418559,
  },
  {
    name: "Shiwan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8418560,
  },
  {
    name: "Yulong",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8418561,
  },
  {
    name: "Shuanglu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8418584,
  },
  {
    name: "Tangxiang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8418585,
  },
  {
    name: "Guchang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8418774,
  },
  {
    name: "Shenglilu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8419424,
  },
  {
    name: "Nandajie",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8419425,
  },
  {
    name: "Shaoyun",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8419799,
  },
  {
    name: "Qinggang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8420195,
  },
  {
    name: "Jianlong",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8420197,
  },
  {
    name: "Shuangfu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8421327,
  },
  {
    name: "Zhiping",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8421919,
  },
  {
    name: "Wenshan City",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 8505006,
  },
  {
    name: "Tuanbao",
    country: "China",
    subcountry: "Hubei",
    geonameid: 8516975,
  },
  {
    name: "Bole",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 8521718,
  },
  {
    name: "Liupanshui",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 8533133,
  },
  {
    name: "Huanggang",
    country: "China",
    subcountry: "Hubei",
    geonameid: 8537264,
  },
  {
    name: "Nanchuan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8544703,
  },
  {
    name: "Anwen",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8549392,
  },
  {
    name: "Datong",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8549394,
  },
  {
    name: "Guanba",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8549410,
  },
  {
    name: "Nantong",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8549414,
  },
  {
    name: "Maliuzui",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 8549445,
  },
  {
    name: "Anxiang",
    country: "China",
    subcountry: "Henan",
    geonameid: 8561889,
  },
  {
    name: "Mugala",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 8562558,
  },
  {
    name: "Xingning",
    country: "China",
    subcountry: "Guangdong",
    geonameid: 8594670,
  },
  {
    name: "Damoujia",
    country: "China",
    subcountry: "Shandong",
    geonameid: 8668394,
  },
  {
    name: "Bageqi",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 8992399,
  },
  {
    name: "Tawakule",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 8992603,
  },
  {
    name: "Han’airike",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 8992614,
  },
  {
    name: "Ying’awati",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 9019368,
  },
  {
    name: "Rizhao",
    country: "China",
    subcountry: "Shandong",
    geonameid: 9072919,
  },
  {
    name: "Shanwang",
    country: "China",
    subcountry: "Shandong",
    geonameid: 9123882,
  },
  {
    name: "Puyang",
    country: "China",
    subcountry: "Henan",
    geonameid: 9181182,
  },
  {
    name: "Taxkowrük",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 9884157,
  },
  {
    name: "Onyar",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 9884161,
  },
  {
    name: "Fudong",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 9924467,
  },
  {
    name: "Jianshui",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 9931406,
  },
  {
    name: "Tuantian",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 9939651,
  },
  {
    name: "Zhonghe",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 9988213,
  },
  {
    name: "Liuzhi",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 10020191,
  },
  {
    name: "Taoyuan",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 10137154,
  },
  {
    name: "Wanghong",
    country: "China",
    subcountry: "Ningxia Hui Autonomous Region",
    geonameid: 10188281,
  },
  {
    name: "Hongguang Qidui",
    country: "China",
    subcountry: "Ningxia Hui Autonomous Region",
    geonameid: 10188419,
  },
  {
    name: "Linhe",
    country: "China",
    subcountry: "Ningxia Hui Autonomous Region",
    geonameid: 10189869,
  },
  {
    name: "Sansheng",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 10315178,
  },
  {
    name: "Gongqingcheng",
    country: "China",
    subcountry: "Jiangxi",
    geonameid: 10378130,
  },
  {
    name: "Xiping",
    country: "China",
    subcountry: "Gansu",
    geonameid: 10429089,
  },
  {
    name: "Xuzhou",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 10630003,
  },
  {
    name: "Xichuan",
    country: "China",
    subcountry: "Gansu",
    geonameid: 10741023,
  },
  {
    name: "Lianyungang",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 10859300,
  },
  {
    name: "Rugao",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 10942183,
  },
  {
    name: "Jinzhong",
    country: "China",
    subcountry: "Shanxi",
    geonameid: 10942283,
  },
  {
    name: "Baoji",
    country: "China",
    subcountry: "Shaanxi",
    geonameid: 10942359,
  },
  {
    name: "Qipan",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 11530931,
  },
  {
    name: "Huocheng",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 11694038,
  },
  {
    name: "Longnan",
    country: "China",
    subcountry: "Gansu",
    geonameid: 11778484,
  },
  {
    name: "Bayan Nur",
    country: "China",
    subcountry: "Inner Mongolia",
    geonameid: 11838258,
  },
  {
    name: "Huoshilafu",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 11890268,
  },
  {
    name: "Gulebage",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 11890878,
  },
  {
    name: "Sandaoling Lutiankuang Wuqi Nongchang",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 11895138,
  },
  {
    name: "Siyeke",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 11916190,
  },
  {
    name: "Tumxuk",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12022102,
  },
  {
    name: "Wulong",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 12110889,
  },
  {
    name: "Chongzuo",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 12159964,
  },
  {
    name: "Zhakou",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 12252444,
  },
  {
    name: "Fangchenggang",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 12269572,
  },
  {
    name: "Dali Old Town",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 12277235,
  },
  {
    name: "Haidong Zhen",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 12277236,
  },
  {
    name: "Yinqiao Zhen",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 12277237,
  },
  {
    name: "Wanqiao Zhen",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 12277238,
  },
  {
    name: "Yunlong",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 12277239,
  },
  {
    name: "Shuangtang",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 12277242,
  },
  {
    name: "Xindian",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 12277243,
  },
  {
    name: "Xinhe",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 12277244,
  },
  {
    name: "Dapeng",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 12277245,
  },
  {
    name: "Daxu",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 12277246,
  },
  {
    name: "Liguo",
    country: "China",
    subcountry: "Shandong",
    geonameid: 12277994,
  },
  {
    name: "Jiawang Zhen",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 12277995,
  },
  {
    name: "Dashahe",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 12279163,
  },
  {
    name: "Wanggou",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 12279164,
  },
  {
    name: "Jing'an",
    country: "China",
    subcountry: "Jiangsu",
    geonameid: 12324233,
  },
  {
    name: "Yingqiu",
    country: "China",
    subcountry: "Shandong",
    geonameid: 12324243,
  },
  {
    name: "Liushan",
    country: "China",
    subcountry: "Shandong",
    geonameid: 12324245,
  },
  {
    name: "Yishan",
    country: "China",
    subcountry: "Shandong",
    geonameid: 12324246,
  },
  {
    name: "Dasheng",
    country: "China",
    subcountry: "Shandong",
    geonameid: 12324247,
  },
  {
    name: "Huiqu",
    country: "China",
    subcountry: "Shandong",
    geonameid: 12324248,
  },
  {
    name: "Jinzhongzi",
    country: "China",
    subcountry: "Shandong",
    geonameid: 12324249,
  },
  {
    name: "Wushan",
    country: "China",
    subcountry: "Shandong",
    geonameid: 12324259,
  },
  {
    name: "Zheshan",
    country: "China",
    subcountry: "Shandong",
    geonameid: 12324260,
  },
  {
    name: "Buzhuang",
    country: "China",
    subcountry: "Shandong",
    geonameid: 12324261,
  },
  {
    name: "Longchi",
    country: "China",
    subcountry: "Shandong",
    geonameid: 12324285,
  },
  {
    name: "Xiaying",
    country: "China",
    subcountry: "Shandong",
    geonameid: 12324286,
  },
  {
    name: "Baicheng",
    country: "China",
    subcountry: "Shandong",
    geonameid: 12324287,
  },
  {
    name: "Jinggou",
    country: "China",
    subcountry: "Shandong",
    geonameid: 12324298,
  },
  {
    name: "Kanjia",
    country: "China",
    subcountry: "Shandong",
    geonameid: 12324299,
  },
  {
    name: "Huanglou",
    country: "China",
    subcountry: "Shandong",
    geonameid: 12324301,
  },
  {
    name: "Yidu",
    country: "China",
    subcountry: "Shandong",
    geonameid: 12324302,
  },
  {
    name: "Dongxia",
    country: "China",
    subcountry: "Shandong",
    geonameid: 12324303,
  },
  {
    name: "Heguan",
    country: "China",
    subcountry: "Shandong",
    geonameid: 12324304,
  },
  {
    name: "Miaozi",
    country: "China",
    subcountry: "Shandong",
    geonameid: 12324438,
  },
  {
    name: "Mihe",
    country: "China",
    subcountry: "Shandong",
    geonameid: 12324439,
  },
  {
    name: "Shaozhuang",
    country: "China",
    subcountry: "Shandong",
    geonameid: 12324473,
  },
  {
    name: "Tanfang",
    country: "China",
    subcountry: "Shandong",
    geonameid: 12324474,
  },
  {
    name: "Gucheng",
    country: "China",
    subcountry: "Shandong",
    geonameid: 12324486,
  },
  {
    name: "Hualong",
    country: "China",
    subcountry: "Shandong",
    geonameid: 12324487,
  },
  {
    name: "Jitai",
    country: "China",
    subcountry: "Shandong",
    geonameid: 12324507,
  },
  {
    name: "Taitou",
    country: "China",
    subcountry: "Shandong",
    geonameid: 12324508,
  },
  {
    name: "Yingli",
    country: "China",
    subcountry: "Shandong",
    geonameid: 12324512,
  },
  {
    name: "Siwei",
    country: "China",
    subcountry: "Hebei",
    geonameid: 12324548,
  },
  {
    name: "Ligang",
    country: "China",
    subcountry: "Ningxia Hui Autonomous Region",
    geonameid: 12324549,
  },
  {
    name: "Lingwu",
    country: "China",
    subcountry: "Ningxia Hui Autonomous Region",
    geonameid: 12324550,
  },
  {
    name: "Ningdong",
    country: "China",
    subcountry: "Ningxia Hui Autonomous Region",
    geonameid: 12324552,
  },
  {
    name: "Wangyuan",
    country: "China",
    subcountry: "Ningxia Hui Autonomous Region",
    geonameid: 12324553,
  },
  {
    name: "Minning",
    country: "China",
    subcountry: "Ningxia Hui Autonomous Region",
    geonameid: 12324554,
  },
  {
    name: "Lijun",
    country: "China",
    subcountry: "Ningxia Hui Autonomous Region",
    geonameid: 12324555,
  },
  {
    name: "Shizuishan",
    country: "China",
    subcountry: "Ningxia Hui Autonomous Region",
    geonameid: 12324556,
  },
  {
    name: "Heshan",
    country: "China",
    subcountry: "Shandong",
    geonameid: 12358444,
  },
  {
    name: "Xihu",
    country: "China",
    subcountry: "Shandong",
    geonameid: 12358445,
  },
  {
    name: "Shangchong",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 12358473,
  },
  {
    name: "Sankeshu",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 12358475,
  },
  {
    name: "Hechi",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 12358476,
  },
  {
    name: "Xingdaohu",
    country: "China",
    subcountry: "Guangxi",
    geonameid: 12358477,
  },
  {
    name: "Donghui",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 12358502,
  },
  {
    name: "Fazhanhe",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 12358503,
  },
  {
    name: "Fubang",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 12358504,
  },
  {
    name: "Huimin",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 12358505,
  },
  {
    name: "Mujia",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 12358507,
  },
  {
    name: "Nanling",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 12358508,
  },
  {
    name: "Nuofu",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 12358509,
  },
  {
    name: "Nuozhadu",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 12358510,
  },
  {
    name: "Zhutang",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 12358511,
  },
  {
    name: "Menghuan",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 12358512,
  },
  {
    name: "Fengping",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 12358513,
  },
  {
    name: "Nongzhang",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 12358514,
  },
  {
    name: "Taiping",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 12358515,
  },
  {
    name: "Beihai",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 12358538,
  },
  {
    name: "Hehua",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 12358539,
  },
  {
    name: "Mangbang",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 12358540,
  },
  {
    name: "Mazhan",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 12358541,
  },
  {
    name: "Mingguang",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 12358542,
  },
  {
    name: "Puchuan",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 12358543,
  },
  {
    name: "Wuhe",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 12358564,
  },
  {
    name: "Xinhua",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 12358565,
  },
  {
    name: "Miaojie",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 12358566,
  },
  {
    name: "Yongjian",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 12358567,
  },
  {
    name: "Yousuo",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 12358568,
  },
  {
    name: "Sanchuan",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 12358569,
  },
  {
    name: "Chenghai",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 12358570,
  },
  {
    name: "Shunzhou",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 12358571,
  },
  {
    name: "Jiuhe",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 12358572,
  },
  {
    name: "Xinyingpan",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 12358573,
  },
  {
    name: "Shilongba",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 12358574,
  },
  {
    name: "Hongqiao",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 12358575,
  },
  {
    name: "Wanzhou",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 12358576,
  },
  {
    name: "Zhuyi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 12358614,
  },
  {
    name: "Yintai",
    country: "China",
    subcountry: "Shaanxi",
    geonameid: 12358616,
  },
  {
    name: "Jifeng",
    country: "China",
    subcountry: "Gansu",
    geonameid: 12358632,
  },
  {
    name: "Changdao",
    country: "China",
    subcountry: "Gansu",
    geonameid: 12358707,
  },
  {
    name: "Liufeng",
    country: "China",
    subcountry: "Gansu",
    geonameid: 12358729,
  },
  {
    name: "Xiejiawan",
    country: "China",
    subcountry: "Gansu",
    geonameid: 12358745,
  },
  {
    name: "Guojia",
    country: "China",
    subcountry: "Gansu",
    geonameid: 12358747,
  },
  {
    name: "Hongbao",
    country: "China",
    subcountry: "Gansu",
    geonameid: 12358802,
  },
  {
    name: "Dayang",
    country: "China",
    subcountry: "Gansu",
    geonameid: 12359284,
  },
  {
    name: "Maguan",
    country: "China",
    subcountry: "Gansu",
    geonameid: 12359299,
  },
  {
    name: "Muhe",
    country: "China",
    subcountry: "Gansu",
    geonameid: 12359301,
  },
  {
    name: "Qingyang",
    country: "China",
    subcountry: "Gansu",
    geonameid: 12359313,
  },
  {
    name: "Quankou",
    country: "China",
    subcountry: "Qinghai",
    geonameid: 12382532,
  },
  {
    name: "Alamaiti",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12420915,
  },
  {
    name: "Arele",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12420916,
  },
  {
    name: "Awati",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12420917,
  },
  {
    name: "Azhatebage",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12420918,
  },
  {
    name: "Bage'awati",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12420919,
  },
  {
    name: "Baishikante",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12420920,
  },
  {
    name: "Dunbage",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12420927,
  },
  {
    name: "Huangdi",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12420928,
  },
  {
    name: "Kuoshi'airike",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12420930,
  },
  {
    name: "Mixia",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12420931,
  },
  {
    name: "Paikeqi",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12420932,
  },
  {
    name: "Tage'erqi",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12420934,
  },
  {
    name: "Tuomuwusitang",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12420983,
  },
  {
    name: "Wudalike",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12420984,
  },
  {
    name: "Yigai'erqi",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12440484,
  },
  {
    name: "Yishikuli",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12440486,
  },
  {
    name: "Bayandai",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12440489,
  },
  {
    name: "Hudiyuzi",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12440491,
  },
  {
    name: "Arewusitang",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12440503,
  },
  {
    name: "Awuliya",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12440504,
  },
  {
    name: "Samuyuzi",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12450711,
  },
  {
    name: "Weiwu'eryuqiwen",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12450712,
  },
  {
    name: "Arele",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12450713,
  },
  {
    name: "Jiayi",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12450714,
  },
  {
    name: "Buzhake",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12450717,
  },
  {
    name: "Yisilamu'awati",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12450721,
  },
  {
    name: "Akesalayi",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12450722,
  },
  {
    name: "Jiahanbage",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12450725,
  },
  {
    name: "Ka'ersai",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12450862,
  },
  {
    name: "Kuiya",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12450864,
  },
  {
    name: "Kuoyiqi",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12450865,
  },
  {
    name: "Manglai",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12450866,
  },
  {
    name: "Puqiakeqi",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12450867,
  },
  {
    name: "Tuohula",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12450868,
  },
  {
    name: "Tuwaite",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12450869,
  },
  {
    name: "Wu'erqi",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12450870,
  },
  {
    name: "Yawa",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12450871,
  },
  {
    name: "Zhawa",
    country: "China",
    subcountry: "Xinjiang",
    geonameid: 12450873,
  },
  {
    name: "Dazeshan",
    country: "China",
    subcountry: "Shandong",
    geonameid: 12450879,
  },
  {
    name: "Dianzi",
    country: "China",
    subcountry: "Shandong",
    geonameid: 12450880,
  },
  {
    name: "Yanghe",
    country: "China",
    subcountry: "Shandong",
    geonameid: 12450881,
  },
  {
    name: "Dongwenquan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 12450883,
  },
  {
    name: "Jieshi",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 12450884,
  },
  {
    name: "Qitang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 12450886,
  },
  {
    name: "Shuanglonghu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 12450887,
  },
  {
    name: "Jiaping",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 12450916,
  },
  {
    name: "Xihu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 12450949,
  },
  {
    name: "Zhongshan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 12450950,
  },
  {
    name: "Mingshan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 12450984,
  },
  {
    name: "Caojie",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 12489669,
  },
  {
    name: "Liangping",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 12489673,
  },
  {
    name: "Xinglong",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 12489685,
  },
  {
    name: "Fuhuan",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 12489793,
  },
  {
    name: "Qingnian",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 12489814,
  },
  {
    name: "Shihao",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 12489815,
  },
  {
    name: "Yongcheng",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 12489817,
  },
  {
    name: "Zhuantang",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 12489819,
  },
  {
    name: "Guiyang, Guizhou",
    country: "China",
    subcountry: "Guizhou",
    geonameid: 12492648,
  },
  {
    name: "Longling County",
    country: "China",
    subcountry: "Yunnan",
    geonameid: 12492660,
  },
  {
    name: "Mianzhu, Deyang, Sichuan",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 12492662,
  },
  {
    name: "Pingwu County",
    country: "China",
    subcountry: "Sichuan",
    geonameid: 12492669,
  },
  {
    name: "Tianjia",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 12492805,
  },
  {
    name: "Changling",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 12493241,
  },
  {
    name: "Weixinghu",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 12495683,
  },
  {
    name: "Zhuhai",
    country: "China",
    subcountry: "Chongqing",
    geonameid: 12495684,
  },
  {
    name: "Zipaquirá",
    country: "Colombia",
    subcountry: "Cundinamarca",
    geonameid: 3665542,
  },
  {
    name: "Zarzal",
    country: "Colombia",
    subcountry: "Valle del Cauca",
    geonameid: 3665559,
  },
  {
    name: "Zaragoza",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3665566,
  },
  {
    name: "Yumbo",
    country: "Colombia",
    subcountry: "Valle del Cauca",
    geonameid: 3665657,
  },
  {
    name: "Yopal",
    country: "Colombia",
    subcountry: "Casanare Department",
    geonameid: 3665688,
  },
  {
    name: "Yondó",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3665691,
  },
  {
    name: "Yarumal",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3665741,
  },
  {
    name: "Villeta",
    country: "Colombia",
    subcountry: "Cundinamarca",
    geonameid: 3665895,
  },
  {
    name: "Villavicencio",
    country: "Colombia",
    subcountry: "Meta",
    geonameid: 3665900,
  },
  {
    name: "Villa del Rosario",
    country: "Colombia",
    subcountry: "Norte de Santander Department",
    geonameid: 3665913,
  },
  {
    name: "Villanueva",
    country: "Colombia",
    subcountry: "La Guajira Department",
    geonameid: 3665934,
  },
  {
    name: "Villanueva",
    country: "Colombia",
    subcountry: "Casanare Department",
    geonameid: 3665951,
  },
  {
    name: "Villamaría",
    country: "Colombia",
    subcountry: "Caldas Department",
    geonameid: 3665973,
  },
  {
    name: "Vélez",
    country: "Colombia",
    subcountry: "Santander",
    geonameid: 3666232,
  },
  {
    name: "Valledupar",
    country: "Colombia",
    subcountry: "Cesar",
    geonameid: 3666304,
  },
  {
    name: "Urrao",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3666395,
  },
  {
    name: "Villa de San Diego de Ubaté",
    country: "Colombia",
    subcountry: "Cundinamarca",
    geonameid: 3666519,
  },
  {
    name: "Turbo",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3666570,
  },
  {
    name: "Turbaco",
    country: "Colombia",
    subcountry: "Bolívar",
    geonameid: 3666577,
  },
  {
    name: "Túquerres",
    country: "Colombia",
    subcountry: "Nariño",
    geonameid: 3666582,
  },
  {
    name: "Tunja",
    country: "Colombia",
    subcountry: "Boyacá",
    geonameid: 3666608,
  },
  {
    name: "Tumaco",
    country: "Colombia",
    subcountry: "Nariño",
    geonameid: 3666640,
  },
  {
    name: "Tuluá",
    country: "Colombia",
    subcountry: "Valle del Cauca",
    geonameid: 3666645,
  },
  {
    name: "Tolú Viejo",
    country: "Colombia",
    subcountry: "Sucre",
    geonameid: 3666936,
  },
  {
    name: "Santiago de Tolú",
    country: "Colombia",
    subcountry: "Sucre",
    geonameid: 3666939,
  },
  {
    name: "Timbiquí",
    country: "Colombia",
    subcountry: "Cauca",
    geonameid: 3667070,
  },
  {
    name: "Tierralta",
    country: "Colombia",
    subcountry: "Córdoba",
    geonameid: 3667158,
  },
  {
    name: "Tauramena",
    country: "Colombia",
    subcountry: "Casanare Department",
    geonameid: 3667355,
  },
  {
    name: "Tarqui",
    country: "Colombia",
    subcountry: "Huila",
    geonameid: 3667386,
  },
  {
    name: "Tame",
    country: "Colombia",
    subcountry: "Departamento de Arauca",
    geonameid: 3667478,
  },
  {
    name: "Tadó",
    country: "Colombia",
    subcountry: "Chocó",
    geonameid: 3667579,
  },
  {
    name: "Supía",
    country: "Colombia",
    subcountry: "Caldas Department",
    geonameid: 3667697,
  },
  {
    name: "Sucre",
    country: "Colombia",
    subcountry: "Sucre",
    geonameid: 3667728,
  },
  {
    name: "Suárez",
    country: "Colombia",
    subcountry: "Cauca",
    geonameid: 3667773,
  },
  {
    name: "Sonsón",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3667820,
  },
  {
    name: "Soledad",
    country: "Colombia",
    subcountry: "Atlántico",
    geonameid: 3667849,
  },
  {
    name: "Sogamoso",
    country: "Colombia",
    subcountry: "Boyacá",
    geonameid: 3667873,
  },
  {
    name: "Socorro",
    country: "Colombia",
    subcountry: "Santander",
    geonameid: 3667887,
  },
  {
    name: "Soacha",
    country: "Colombia",
    subcountry: "Cundinamarca",
    geonameid: 3667905,
  },
  {
    name: "Sitionuevo",
    country: "Colombia",
    subcountry: "Magdalena",
    geonameid: 3667918,
  },
  {
    name: "Sincelejo",
    country: "Colombia",
    subcountry: "Sucre",
    geonameid: 3667983,
  },
  {
    name: "San Luis de Sincé",
    country: "Colombia",
    subcountry: "Sucre",
    geonameid: 3667991,
  },
  {
    name: "Simití",
    country: "Colombia",
    subcountry: "Bolívar",
    geonameid: 3668012,
  },
  {
    name: "Silvania",
    country: "Colombia",
    subcountry: "Cundinamarca",
    geonameid: 3668028,
  },
  {
    name: "Sibaté",
    country: "Colombia",
    subcountry: "Cundinamarca",
    geonameid: 3668087,
  },
  {
    name: "Sevilla",
    country: "Colombia",
    subcountry: "Valle del Cauca",
    geonameid: 3668132,
  },
  {
    name: "Segovia",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3668175,
  },
  {
    name: "San Vicente",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3668302,
  },
  {
    name: "Santuario",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3668323,
  },
  {
    name: "Santo Tomás",
    country: "Colombia",
    subcountry: "Atlántico",
    geonameid: 3668332,
  },
  {
    name: "Santa Rosa de Osos",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3668451,
  },
  {
    name: "Santa Rosa de Cabal",
    country: "Colombia",
    subcountry: "Risaralda",
    geonameid: 3668454,
  },
  {
    name: "Santa Rosa",
    country: "Colombia",
    subcountry: "Bolívar",
    geonameid: 3668472,
  },
  {
    name: "Santander de Quilichao",
    country: "Colombia",
    subcountry: "Cauca",
    geonameid: 3668572,
  },
  {
    name: "Santa Marta",
    country: "Colombia",
    subcountry: "Magdalena",
    geonameid: 3668605,
  },
  {
    name: "Santa Lucía",
    country: "Colombia",
    subcountry: "Atlántico",
    geonameid: 3668655,
  },
  {
    name: "San Pedro de Urabá",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3669087,
  },
  {
    name: "San Pablo",
    country: "Colombia",
    subcountry: "Bolívar",
    geonameid: 3669188,
  },
  {
    name: "San Onofre",
    country: "Colombia",
    subcountry: "Sucre",
    geonameid: 3669218,
  },
  {
    name: "San Martín",
    country: "Colombia",
    subcountry: "Meta",
    geonameid: 3669332,
  },
  {
    name: "San Marcos",
    country: "Colombia",
    subcountry: "Sucre",
    geonameid: 3669346,
  },
  {
    name: "San Lorenzo",
    country: "Colombia",
    subcountry: "Nariño",
    geonameid: 3669440,
  },
  {
    name: "San Juan Nepomuceno",
    country: "Colombia",
    subcountry: "Bolívar",
    geonameid: 3669454,
  },
  {
    name: "San Juan de Urabá",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3669461,
  },
  {
    name: "San Juan del Cesar",
    country: "Colombia",
    subcountry: "La Guajira Department",
    geonameid: 3669469,
  },
  {
    name: "San Jacinto",
    country: "Colombia",
    subcountry: "Bolívar",
    geonameid: 3669736,
  },
  {
    name: "San Gil",
    country: "Colombia",
    subcountry: "Santander",
    geonameid: 3669808,
  },
  {
    name: "San Estanislao",
    country: "Colombia",
    subcountry: "Bolívar",
    geonameid: 3669929,
  },
  {
    name: "San Diego",
    country: "Colombia",
    subcountry: "Cesar",
    geonameid: 3669947,
  },
  {
    name: "San Carlos",
    country: "Colombia",
    subcountry: "Córdoba",
    geonameid: 3669997,
  },
  {
    name: "San Benito Abad",
    country: "Colombia",
    subcountry: "Sucre",
    geonameid: 3670038,
  },
  {
    name: "San Antero",
    country: "Colombia",
    subcountry: "Córdoba",
    geonameid: 3670199,
  },
  {
    name: "San Andrés",
    country: "Colombia",
    subcountry: "San Andres y Providencia",
    geonameid: 3670218,
  },
  {
    name: "Sampués",
    country: "Colombia",
    subcountry: "Sucre",
    geonameid: 3670280,
  },
  {
    name: "Samaniego",
    country: "Colombia",
    subcountry: "Nariño",
    geonameid: 3670293,
  },
  {
    name: "Salgar",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3670350,
  },
  {
    name: "Salamina",
    country: "Colombia",
    subcountry: "Caldas Department",
    geonameid: 3670370,
  },
  {
    name: "Sahagún",
    country: "Colombia",
    subcountry: "Córdoba",
    geonameid: 3670419,
  },
  {
    name: "Sabaneta",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3670475,
  },
  {
    name: "Sabanalarga",
    country: "Colombia",
    subcountry: "Atlántico",
    geonameid: 3670502,
  },
  {
    name: "Sabanagrande",
    country: "Colombia",
    subcountry: "Atlántico",
    geonameid: 3670513,
  },
  {
    name: "Sabana de Torres",
    country: "Colombia",
    subcountry: "Santander",
    geonameid: 3670520,
  },
  {
    name: "Rovira",
    country: "Colombia",
    subcountry: "Tolima",
    geonameid: 3670587,
  },
  {
    name: "Roldanillo",
    country: "Colombia",
    subcountry: "Valle del Cauca",
    geonameid: 3670644,
  },
  {
    name: "Rivera",
    country: "Colombia",
    subcountry: "Huila",
    geonameid: 3670692,
  },
  {
    name: "Riosucio",
    country: "Colombia",
    subcountry: "Caldas Department",
    geonameid: 3670719,
  },
  {
    name: "Rionegro",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3670730,
  },
  {
    name: "Riohacha",
    country: "Colombia",
    subcountry: "La Guajira Department",
    geonameid: 3670745,
  },
  {
    name: "Rioblanco",
    country: "Colombia",
    subcountry: "Tolima",
    geonameid: 3670764,
  },
  {
    name: "Retiro",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3670849,
  },
  {
    name: "Restrepo",
    country: "Colombia",
    subcountry: "Meta",
    geonameid: 3670855,
  },
  {
    name: "Repelón",
    country: "Colombia",
    subcountry: "Atlántico",
    geonameid: 3670874,
  },
  {
    name: "Quinchía",
    country: "Colombia",
    subcountry: "Risaralda",
    geonameid: 3671091,
  },
  {
    name: "Quimbaya",
    country: "Colombia",
    subcountry: "Quindío",
    geonameid: 3671098,
  },
  {
    name: "Quibdó",
    country: "Colombia",
    subcountry: "Chocó",
    geonameid: 3671116,
  },
  {
    name: "Purificación",
    country: "Colombia",
    subcountry: "Tolima",
    geonameid: 3671208,
  },
  {
    name: "Pupiales",
    country: "Colombia",
    subcountry: "Nariño",
    geonameid: 3671228,
  },
  {
    name: "Puerto Wilches",
    country: "Colombia",
    subcountry: "Santander",
    geonameid: 3671287,
  },
  {
    name: "Puerto Triunfo",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3671308,
  },
  {
    name: "Puerto Tejada",
    country: "Colombia",
    subcountry: "Cauca",
    geonameid: 3671315,
  },
  {
    name: "Puerto Santander",
    country: "Colombia",
    subcountry: "Norte de Santander Department",
    geonameid: 3671325,
  },
  {
    name: "Puerto Salgar",
    country: "Colombia",
    subcountry: "Cundinamarca",
    geonameid: 3671330,
  },
  {
    name: "Puerto Rico",
    country: "Colombia",
    subcountry: "Caquetá",
    geonameid: 3671348,
  },
  {
    name: "Puerto López",
    country: "Colombia",
    subcountry: "Meta",
    geonameid: 3671418,
  },
  {
    name: "Puerto Leguízamo",
    country: "Colombia",
    subcountry: "Putumayo",
    geonameid: 3671437,
  },
  {
    name: "Puerto Colombia",
    country: "Colombia",
    subcountry: "Atlántico",
    geonameid: 3671497,
  },
  {
    name: "Puerto Carreño",
    country: "Colombia",
    subcountry: "Vichada",
    geonameid: 3671519,
  },
  {
    name: "Puerto Boyacá",
    country: "Colombia",
    subcountry: "Boyacá",
    geonameid: 3671531,
  },
  {
    name: "Puerto Berrío",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3671540,
  },
  {
    name: "Puerto Asís",
    country: "Colombia",
    subcountry: "Putumayo",
    geonameid: 3671549,
  },
  {
    name: "Puebloviejo",
    country: "Colombia",
    subcountry: "Magdalena",
    geonameid: 3671615,
  },
  {
    name: "Pradera",
    country: "Colombia",
    subcountry: "Valle del Cauca",
    geonameid: 3671772,
  },
  {
    name: "Popayán",
    country: "Colombia",
    subcountry: "Cauca",
    geonameid: 3671916,
  },
  {
    name: "Ponedera",
    country: "Colombia",
    subcountry: "Atlántico",
    geonameid: 3671936,
  },
  {
    name: "Polonuevo",
    country: "Colombia",
    subcountry: "Atlántico",
    geonameid: 3671950,
  },
  {
    name: "Planeta Rica",
    country: "Colombia",
    subcountry: "Córdoba",
    geonameid: 3672068,
  },
  {
    name: "Planadas",
    country: "Colombia",
    subcountry: "Tolima",
    geonameid: 3672077,
  },
  {
    name: "Pizarro",
    country: "Colombia",
    subcountry: "Chocó",
    geonameid: 3672086,
  },
  {
    name: "Pivijay",
    country: "Colombia",
    subcountry: "Magdalena",
    geonameid: 3672093,
  },
  {
    name: "Pitalito",
    country: "Colombia",
    subcountry: "Huila",
    geonameid: 3672110,
  },
  {
    name: "Pinillos",
    country: "Colombia",
    subcountry: "Bolívar",
    geonameid: 3672197,
  },
  {
    name: "Piedecuesta",
    country: "Colombia",
    subcountry: "Santander",
    geonameid: 3672328,
  },
  {
    name: "Pereira",
    country: "Colombia",
    subcountry: "Risaralda",
    geonameid: 3672486,
  },
  {
    name: "Payandé",
    country: "Colombia",
    subcountry: "Tolima",
    geonameid: 3672664,
  },
  {
    name: "Patía",
    country: "Colombia",
    subcountry: "Cauca",
    geonameid: 3672761,
  },
  {
    name: "Pasto",
    country: "Colombia",
    subcountry: "Nariño",
    geonameid: 3672778,
  },
  {
    name: "Pamplona",
    country: "Colombia",
    subcountry: "Norte de Santander Department",
    geonameid: 3673045,
  },
  {
    name: "Palmira",
    country: "Colombia",
    subcountry: "Valle del Cauca",
    geonameid: 3673164,
  },
  {
    name: "Palmar de Varela",
    country: "Colombia",
    subcountry: "Atlántico",
    geonameid: 3673220,
  },
  {
    name: "Pailitas",
    country: "Colombia",
    subcountry: "Cesar",
    geonameid: 3673379,
  },
  {
    name: "Belalcázar",
    country: "Colombia",
    subcountry: "Cauca",
    geonameid: 3673398,
  },
  {
    name: "Padua",
    country: "Colombia",
    subcountry: "Tolima",
    geonameid: 3673404,
  },
  {
    name: "Pacho",
    country: "Colombia",
    subcountry: "Cundinamarca",
    geonameid: 3673424,
  },
  {
    name: "Ocaña",
    country: "Colombia",
    subcountry: "Norte de Santander Department",
    geonameid: 3673662,
  },
  {
    name: "Nueva Granada",
    country: "Colombia",
    subcountry: "Magdalena",
    geonameid: 3673756,
  },
  {
    name: "Neiva",
    country: "Colombia",
    subcountry: "Huila",
    geonameid: 3673899,
  },
  {
    name: "Neira",
    country: "Colombia",
    subcountry: "Caldas Department",
    geonameid: 3673902,
  },
  {
    name: "Nechí",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3673976,
  },
  {
    name: "Natagaima",
    country: "Colombia",
    subcountry: "Tolima",
    geonameid: 3674010,
  },
  {
    name: "Mosquera",
    country: "Colombia",
    subcountry: "Cundinamarca",
    geonameid: 3674292,
  },
  {
    name: "Morales",
    country: "Colombia",
    subcountry: "Bolívar",
    geonameid: 3674412,
  },
  {
    name: "Montería",
    country: "Colombia",
    subcountry: "Córdoba",
    geonameid: 3674453,
  },
  {
    name: "Montenegro",
    country: "Colombia",
    subcountry: "Quindío",
    geonameid: 3674463,
  },
  {
    name: "Montelíbano",
    country: "Colombia",
    subcountry: "Córdoba",
    geonameid: 3674470,
  },
  {
    name: "Moniquirá",
    country: "Colombia",
    subcountry: "Boyacá",
    geonameid: 3674572,
  },
  {
    name: "Mompós",
    country: "Colombia",
    subcountry: "Bolívar",
    geonameid: 3674597,
  },
  {
    name: "Momil",
    country: "Colombia",
    subcountry: "Córdoba",
    geonameid: 3674603,
  },
  {
    name: "Mocoa",
    country: "Colombia",
    subcountry: "Putumayo",
    geonameid: 3674654,
  },
  {
    name: "Mitú",
    country: "Colombia",
    subcountry: "Vaupés",
    geonameid: 3674676,
  },
  {
    name: "Miranda",
    country: "Colombia",
    subcountry: "Cauca",
    geonameid: 3674702,
  },
  {
    name: "Melgar",
    country: "Colombia",
    subcountry: "Tolima",
    geonameid: 3674885,
  },
  {
    name: "Medellín",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3674962,
  },
  {
    name: "Marsella",
    country: "Colombia",
    subcountry: "Risaralda",
    geonameid: 3675212,
  },
  {
    name: "San Sebastián de Mariquita",
    country: "Colombia",
    subcountry: "Tolima",
    geonameid: 3675252,
  },
  {
    name: "Marinilla",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3675263,
  },
  {
    name: "María la Baja",
    country: "Colombia",
    subcountry: "Bolívar",
    geonameid: 3675287,
  },
  {
    name: "Manzanares",
    country: "Colombia",
    subcountry: "Caldas Department",
    geonameid: 3675409,
  },
  {
    name: "Manizales",
    country: "Colombia",
    subcountry: "Caldas Department",
    geonameid: 3675443,
  },
  {
    name: "Manatí",
    country: "Colombia",
    subcountry: "Atlántico",
    geonameid: 3675512,
  },
  {
    name: "Malambo",
    country: "Colombia",
    subcountry: "Atlántico",
    geonameid: 3675595,
  },
  {
    name: "Málaga",
    country: "Colombia",
    subcountry: "Santander",
    geonameid: 3675605,
  },
  {
    name: "Maicao",
    country: "Colombia",
    subcountry: "La Guajira Department",
    geonameid: 3675657,
  },
  {
    name: "Mahates",
    country: "Colombia",
    subcountry: "Bolívar",
    geonameid: 3675668,
  },
  {
    name: "Magangué",
    country: "Colombia",
    subcountry: "Bolívar",
    geonameid: 3675692,
  },
  {
    name: "Madrid",
    country: "Colombia",
    subcountry: "Cundinamarca",
    geonameid: 3675707,
  },
  {
    name: "Luruaco",
    country: "Colombia",
    subcountry: "Atlántico",
    geonameid: 3675826,
  },
  {
    name: "Los Patios",
    country: "Colombia",
    subcountry: "Norte de Santander Department",
    geonameid: 3675975,
  },
  {
    name: "Lorica",
    country: "Colombia",
    subcountry: "Córdoba",
    geonameid: 3676397,
  },
  {
    name: "Líbano",
    country: "Colombia",
    subcountry: "Tolima",
    geonameid: 3676604,
  },
  {
    name: "Leticia",
    country: "Colombia",
    subcountry: "Amazonas",
    geonameid: 3676623,
  },
  {
    name: "Lérida",
    country: "Colombia",
    subcountry: "Tolima",
    geonameid: 3676626,
  },
  {
    name: "La Virginia",
    country: "Colombia",
    subcountry: "Risaralda",
    geonameid: 3676720,
  },
  {
    name: "La Unión",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3676923,
  },
  {
    name: "La Unión",
    country: "Colombia",
    subcountry: "Valle del Cauca",
    geonameid: 3676928,
  },
  {
    name: "La Unión",
    country: "Colombia",
    subcountry: "Nariño",
    geonameid: 3676934,
  },
  {
    name: "La Tebaida",
    country: "Colombia",
    subcountry: "Quindío",
    geonameid: 3677010,
  },
  {
    name: "La Plata",
    country: "Colombia",
    subcountry: "Huila",
    geonameid: 3678097,
  },
  {
    name: "La Mesa",
    country: "Colombia",
    subcountry: "Cundinamarca",
    geonameid: 3678405,
  },
  {
    name: "La Jagua de Ibirico",
    country: "Colombia",
    subcountry: "Cesar",
    geonameid: 3678674,
  },
  {
    name: "La Estrella",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3679065,
  },
  {
    name: "La Dorada",
    country: "Colombia",
    subcountry: "Caldas Department",
    geonameid: 3679277,
  },
  {
    name: "La Ceja",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3679554,
  },
  {
    name: "Juan de Acosta",
    country: "Colombia",
    subcountry: "Atlántico",
    geonameid: 3680176,
  },
  {
    name: "Jamundí",
    country: "Colombia",
    subcountry: "Valle del Cauca",
    geonameid: 3680387,
  },
  {
    name: "Ituango",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3680434,
  },
  {
    name: "Itagüí",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3680450,
  },
  {
    name: "Ipiales",
    country: "Colombia",
    subcountry: "Nariño",
    geonameid: 3680539,
  },
  {
    name: "Ibagué",
    country: "Colombia",
    subcountry: "Tolima",
    geonameid: 3680656,
  },
  {
    name: "Honda",
    country: "Colombia",
    subcountry: "Tolima",
    geonameid: 3680840,
  },
  {
    name: "Guamo",
    country: "Colombia",
    subcountry: "Tolima",
    geonameid: 3681563,
  },
  {
    name: "Guamal",
    country: "Colombia",
    subcountry: "Magdalena",
    geonameid: 3681596,
  },
  {
    name: "Guaduas",
    country: "Colombia",
    subcountry: "Cundinamarca",
    geonameid: 3681702,
  },
  {
    name: "Guadalupe",
    country: "Colombia",
    subcountry: "Huila",
    geonameid: 3681733,
  },
  {
    name: "Guacarí",
    country: "Colombia",
    subcountry: "Valle del Cauca",
    geonameid: 3681797,
  },
  {
    name: "Granada",
    country: "Colombia",
    subcountry: "Meta",
    geonameid: 3681957,
  },
  {
    name: "Girón",
    country: "Colombia",
    subcountry: "Santander",
    geonameid: 3682018,
  },
  {
    name: "Girardot City",
    country: "Colombia",
    subcountry: "Cundinamarca",
    geonameid: 3682028,
  },
  {
    name: "Gigante",
    country: "Colombia",
    subcountry: "Huila",
    geonameid: 3682047,
  },
  {
    name: "Garzón",
    country: "Colombia",
    subcountry: "Huila",
    geonameid: 3682108,
  },
  {
    name: "Nueva Granada",
    country: "Colombia",
    subcountry: "Sucre",
    geonameid: 3682232,
  },
  {
    name: "Galapa",
    country: "Colombia",
    subcountry: "Atlántico",
    geonameid: 3682238,
  },
  {
    name: "Fusagasugá",
    country: "Colombia",
    subcountry: "Cundinamarca",
    geonameid: 3682274,
  },
  {
    name: "Funza",
    country: "Colombia",
    subcountry: "Cundinamarca",
    geonameid: 3682281,
  },
  {
    name: "Fundación",
    country: "Colombia",
    subcountry: "Magdalena",
    geonameid: 3682292,
  },
  {
    name: "Frontino",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3682313,
  },
  {
    name: "Fresno",
    country: "Colombia",
    subcountry: "Tolima",
    geonameid: 3682330,
  },
  {
    name: "Fonseca",
    country: "Colombia",
    subcountry: "La Guajira Department",
    geonameid: 3682374,
  },
  {
    name: "Floridablanca",
    country: "Colombia",
    subcountry: "Santander",
    geonameid: 3682385,
  },
  {
    name: "Florida",
    country: "Colombia",
    subcountry: "Valle del Cauca",
    geonameid: 3682393,
  },
  {
    name: "Florencia",
    country: "Colombia",
    subcountry: "Caquetá",
    geonameid: 3682426,
  },
  {
    name: "Flandes",
    country: "Colombia",
    subcountry: "Tolima",
    geonameid: 3682458,
  },
  {
    name: "Facatativá",
    country: "Colombia",
    subcountry: "Cundinamarca",
    geonameid: 3682516,
  },
  {
    name: "Espinal",
    country: "Colombia",
    subcountry: "Tolima",
    geonameid: 3682573,
  },
  {
    name: "Envigado",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3682631,
  },
  {
    name: "El Zulia",
    country: "Colombia",
    subcountry: "Norte de Santander Department",
    geonameid: 3682682,
  },
  {
    name: "El Retén",
    country: "Colombia",
    subcountry: "Magdalena",
    geonameid: 3683233,
  },
  {
    name: "El Doncello",
    country: "Colombia",
    subcountry: "Caquetá",
    geonameid: 3684276,
  },
  {
    name: "El Copey",
    country: "Colombia",
    subcountry: "Cesar",
    geonameid: 3684452,
  },
  {
    name: "El Charco",
    country: "Colombia",
    subcountry: "Nariño",
    geonameid: 3684579,
  },
  {
    name: "El Cerrito",
    country: "Colombia",
    subcountry: "Valle del Cauca",
    geonameid: 3684615,
  },
  {
    name: "El Carmen de Bolívar",
    country: "Colombia",
    subcountry: "Bolívar",
    geonameid: 3684666,
  },
  {
    name: "El Carmen de Chucurí",
    country: "Colombia",
    subcountry: "Santander",
    geonameid: 3684689,
  },
  {
    name: "El Banco",
    country: "Colombia",
    subcountry: "Magdalena",
    geonameid: 3684917,
  },
  {
    name: "El Bagre",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3684945,
  },
  {
    name: "Duitama",
    country: "Colombia",
    subcountry: "Boyacá",
    geonameid: 3685084,
  },
  {
    name: "Dosquebradas",
    country: "Colombia",
    subcountry: "Risaralda",
    geonameid: 3685095,
  },
  {
    name: "Darien",
    country: "Colombia",
    subcountry: "Valle del Cauca",
    geonameid: 3685273,
  },
  {
    name: "Dabeiba",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3685295,
  },
  {
    name: "Curumaní",
    country: "Colombia",
    subcountry: "Cesar",
    geonameid: 3685335,
  },
  {
    name: "Cumaribo",
    country: "Colombia",
    subcountry: "Vichada",
    geonameid: 3685435,
  },
  {
    name: "Cúcuta",
    country: "Colombia",
    subcountry: "Norte de Santander Department",
    geonameid: 3685533,
  },
  {
    name: "Cotorra",
    country: "Colombia",
    subcountry: "Córdoba",
    geonameid: 3685724,
  },
  {
    name: "Corozal",
    country: "Colombia",
    subcountry: "Sucre",
    geonameid: 3685823,
  },
  {
    name: "Corinto",
    country: "Colombia",
    subcountry: "Cauca",
    geonameid: 3685871,
  },
  {
    name: "Copacabana",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3685949,
  },
  {
    name: "Concordia",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3686013,
  },
  {
    name: "Circasia",
    country: "Colombia",
    subcountry: "Quindío",
    geonameid: 3686233,
  },
  {
    name: "Cimitarra",
    country: "Colombia",
    subcountry: "Santander",
    geonameid: 3686255,
  },
  {
    name: "Ciénaga de Oro",
    country: "Colombia",
    subcountry: "Córdoba",
    geonameid: 3686272,
  },
  {
    name: "Ciénaga",
    country: "Colombia",
    subcountry: "Magdalena",
    geonameid: 3686279,
  },
  {
    name: "Chivolo",
    country: "Colombia",
    subcountry: "Magdalena",
    geonameid: 3686445,
  },
  {
    name: "Chiriguaná",
    country: "Colombia",
    subcountry: "Cesar",
    geonameid: 3686479,
  },
  {
    name: "Chiquinquirá",
    country: "Colombia",
    subcountry: "Boyacá",
    geonameid: 3686513,
  },
  {
    name: "Chinú",
    country: "Colombia",
    subcountry: "Córdoba",
    geonameid: 3686540,
  },
  {
    name: "Chinchiná",
    country: "Colombia",
    subcountry: "Caldas Department",
    geonameid: 3686561,
  },
  {
    name: "Chimichagua",
    country: "Colombia",
    subcountry: "Cesar",
    geonameid: 3686585,
  },
  {
    name: "Chigorodó",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3686636,
  },
  {
    name: "Chía",
    country: "Colombia",
    subcountry: "Cundinamarca",
    geonameid: 3686675,
  },
  {
    name: "Chaparral",
    country: "Colombia",
    subcountry: "Tolima",
    geonameid: 3686793,
  },
  {
    name: "Cereté",
    country: "Colombia",
    subcountry: "Córdoba",
    geonameid: 3686922,
  },
  {
    name: "Caucasia",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3687025,
  },
  {
    name: "Cartago",
    country: "Colombia",
    subcountry: "Valle del Cauca",
    geonameid: 3687230,
  },
  {
    name: "Cartagena",
    country: "Colombia",
    subcountry: "Bolívar",
    geonameid: 3687238,
  },
  {
    name: "Carmen de Viboral",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3687318,
  },
  {
    name: "Candelaria",
    country: "Colombia",
    subcountry: "Atlántico",
    geonameid: 3687634,
  },
  {
    name: "Candelaria",
    country: "Colombia",
    subcountry: "Valle del Cauca",
    geonameid: 3687644,
  },
  {
    name: "Campo de la Cruz",
    country: "Colombia",
    subcountry: "Atlántico",
    geonameid: 3687758,
  },
  {
    name: "Campoalegre",
    country: "Colombia",
    subcountry: "Huila",
    geonameid: 3687806,
  },
  {
    name: "Cali",
    country: "Colombia",
    subcountry: "Valle del Cauca",
    geonameid: 3687925,
  },
  {
    name: "Caldas",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3687952,
  },
  {
    name: "Calarcá",
    country: "Colombia",
    subcountry: "Quindío",
    geonameid: 3687964,
  },
  {
    name: "Cajicá",
    country: "Colombia",
    subcountry: "Cundinamarca",
    geonameid: 3688006,
  },
  {
    name: "Caicedonia",
    country: "Colombia",
    subcountry: "Valle del Cauca",
    geonameid: 3688071,
  },
  {
    name: "Guadalajara de Buga",
    country: "Colombia",
    subcountry: "Valle del Cauca",
    geonameid: 3688256,
  },
  {
    name: "Buesaco",
    country: "Colombia",
    subcountry: "Nariño",
    geonameid: 3688266,
  },
  {
    name: "Buenaventura",
    country: "Colombia",
    subcountry: "Valle del Cauca",
    geonameid: 3688451,
  },
  {
    name: "Buenaventura",
    country: "Colombia",
    subcountry: "Valle del Cauca",
    geonameid: 3688452,
  },
  {
    name: "Bucaramanga",
    country: "Colombia",
    subcountry: "Santander",
    geonameid: 3688465,
  },
  {
    name: "Bogotá",
    country: "Colombia",
    subcountry: "Bogota D.C.",
    geonameid: 3688689,
  },
  {
    name: "Betulia",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3688840,
  },
  {
    name: "Bello",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3688928,
  },
  {
    name: "Belén de Umbría",
    country: "Colombia",
    subcountry: "Risaralda",
    geonameid: 3688989,
  },
  {
    name: "Becerril",
    country: "Colombia",
    subcountry: "Cesar",
    geonameid: 3689026,
  },
  {
    name: "Barranquilla",
    country: "Colombia",
    subcountry: "Atlántico",
    geonameid: 3689147,
  },
  {
    name: "Barrancas",
    country: "Colombia",
    subcountry: "La Guajira Department",
    geonameid: 3689162,
  },
  {
    name: "Barrancabermeja",
    country: "Colombia",
    subcountry: "Santander",
    geonameid: 3689169,
  },
  {
    name: "Barbosa",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3689205,
  },
  {
    name: "Barbosa",
    country: "Colombia",
    subcountry: "Santander",
    geonameid: 3689206,
  },
  {
    name: "Baranoa",
    country: "Colombia",
    subcountry: "Atlántico",
    geonameid: 3689235,
  },
  {
    name: "Balboa",
    country: "Colombia",
    subcountry: "Cauca",
    geonameid: 3689292,
  },
  {
    name: "Ayapel",
    country: "Colombia",
    subcountry: "Córdoba",
    geonameid: 3689381,
  },
  {
    name: "Astrea",
    country: "Colombia",
    subcountry: "Cesar",
    geonameid: 3689458,
  },
  {
    name: "Armenia",
    country: "Colombia",
    subcountry: "Quindío",
    geonameid: 3689560,
  },
  {
    name: "Arjona",
    country: "Colombia",
    subcountry: "Bolívar",
    geonameid: 3689570,
  },
  {
    name: "Ariguaní",
    country: "Colombia",
    subcountry: "Cesar",
    geonameid: 3689589,
  },
  {
    name: "Arauca",
    country: "Colombia",
    subcountry: "Departamento de Arauca",
    geonameid: 3689718,
  },
  {
    name: "Aracataca",
    country: "Colombia",
    subcountry: "Magdalena",
    geonameid: 3689759,
  },
  {
    name: "Apartadó",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3689798,
  },
  {
    name: "Santa Fe de Antioquia",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3689816,
  },
  {
    name: "Anserma",
    country: "Colombia",
    subcountry: "Risaralda",
    geonameid: 3689833,
  },
  {
    name: "Andes",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3689899,
  },
  {
    name: "Andalucía",
    country: "Colombia",
    subcountry: "Valle del Cauca",
    geonameid: 3689905,
  },
  {
    name: "Anaime",
    country: "Colombia",
    subcountry: "Tolima",
    geonameid: 3689952,
  },
  {
    name: "Albania",
    country: "Colombia",
    subcountry: "La Guajira Department",
    geonameid: 3690250,
  },
  {
    name: "Aguazul",
    country: "Colombia",
    subcountry: "Casanare Department",
    geonameid: 3690316,
  },
  {
    name: "Aguadas",
    country: "Colombia",
    subcountry: "Caldas Department",
    geonameid: 3690431,
  },
  {
    name: "Aguachica",
    country: "Colombia",
    subcountry: "Cesar",
    geonameid: 3690465,
  },
  {
    name: "Acacías",
    country: "Colombia",
    subcountry: "Meta",
    geonameid: 3690577,
  },
  {
    name: "Abejorral",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3690592,
  },
  {
    name: "Morales",
    country: "Colombia",
    subcountry: "Cauca",
    geonameid: 3770718,
  },
  {
    name: "Villa Rica",
    country: "Colombia",
    subcountry: "Cauca",
    geonameid: 3770955,
  },
  {
    name: "Fredonia",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3780602,
  },
  {
    name: "Carepa",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3792375,
  },
  {
    name: "Ciudad Bolívar",
    country: "Colombia",
    subcountry: "Antioquia",
    geonameid: 3792376,
  },
  {
    name: "Tiquisio",
    country: "Colombia",
    subcountry: "Bolívar",
    geonameid: 3792380,
  },
  {
    name: "Agustín Codazzi",
    country: "Colombia",
    subcountry: "Cesar",
    geonameid: 3792383,
  },
  {
    name: "San Martín",
    country: "Colombia",
    subcountry: "Cesar",
    geonameid: 3792385,
  },
  {
    name: "Isnos",
    country: "Colombia",
    subcountry: "Huila",
    geonameid: 3792389,
  },
  {
    name: "Plato",
    country: "Colombia",
    subcountry: "Magdalena",
    geonameid: 3792392,
  },
  {
    name: "San José del Guaviare",
    country: "Colombia",
    subcountry: "Guaviare",
    geonameid: 3828545,
  },
  {
    name: "Orito",
    country: "Colombia",
    subcountry: "Putumayo",
    geonameid: 3829343,
  },
  {
    name: "Piendamo",
    country: "Colombia",
    subcountry: "Cauca",
    geonameid: 8633918,
  },
  {
    name: "Turrialba",
    country: "Costa Rica",
    subcountry: "Cartago Province",
    geonameid: 3621184,
  },
  {
    name: "Tejar",
    country: "Costa Rica",
    subcountry: "San José",
    geonameid: 3621335,
  },
  {
    name: "Siquirres",
    country: "Costa Rica",
    subcountry: "Limón Province",
    geonameid: 3621440,
  },
  {
    name: "San Vicente",
    country: "Costa Rica",
    subcountry: "San José",
    geonameid: 3621505,
  },
  {
    name: "San Rafael Arriba",
    country: "Costa Rica",
    subcountry: "San José",
    geonameid: 3621655,
  },
  {
    name: "San Rafael Abajo",
    country: "Costa Rica",
    subcountry: "San José",
    geonameid: 3621659,
  },
  {
    name: "San Rafael",
    country: "Costa Rica",
    subcountry: "San José",
    geonameid: 3621689,
  },
  {
    name: "San Pedro",
    country: "Costa Rica",
    subcountry: "San José",
    geonameid: 3621717,
  },
  {
    name: "San Pablo",
    country: "Costa Rica",
    subcountry: "Heredia Province",
    geonameid: 3621729,
  },
  {
    name: "San Miguel",
    country: "Costa Rica",
    subcountry: "San José",
    geonameid: 3621753,
  },
  {
    name: "San Juan de Dios",
    country: "Costa Rica",
    subcountry: "San José",
    geonameid: 3621804,
  },
  {
    name: "San Juan",
    country: "Costa Rica",
    subcountry: "San José",
    geonameid: 3621819,
  },
  {
    name: "San José",
    country: "Costa Rica",
    subcountry: "Alajuela Province",
    geonameid: 3621841,
  },
  {
    name: "San José",
    country: "Costa Rica",
    subcountry: "San José",
    geonameid: 3621849,
  },
  {
    name: "San Isidro",
    country: "Costa Rica",
    subcountry: "San José",
    geonameid: 3621889,
  },
  {
    name: "San Francisco",
    country: "Costa Rica",
    subcountry: "Heredia Province",
    geonameid: 3621911,
  },
  {
    name: "San Felipe",
    country: "Costa Rica",
    subcountry: "San José",
    geonameid: 3621922,
  },
  {
    name: "San Diego",
    country: "Costa Rica",
    subcountry: "Cartago Province",
    geonameid: 3621926,
  },
  {
    name: "Quesada",
    country: "Costa Rica",
    subcountry: "Alajuela Province",
    geonameid: 3622190,
  },
  {
    name: "Purral",
    country: "Costa Rica",
    subcountry: "San José",
    geonameid: 3622217,
  },
  {
    name: "Puntarenas",
    country: "Costa Rica",
    subcountry: "Puntarenas Province",
    geonameid: 3622228,
  },
  {
    name: "Limón",
    country: "Costa Rica",
    subcountry: "Limón Province",
    geonameid: 3622247,
  },
  {
    name: "Patarrá",
    country: "Costa Rica",
    subcountry: "San José",
    geonameid: 3622507,
  },
  {
    name: "Paraíso",
    country: "Costa Rica",
    subcountry: "Cartago Province",
    geonameid: 3622547,
  },
  {
    name: "Nicoya",
    country: "Costa Rica",
    subcountry: "Guanacaste Province",
    geonameid: 3622716,
  },
  {
    name: "Mercedes Norte",
    country: "Costa Rica",
    subcountry: "Heredia Province",
    geonameid: 3622881,
  },
  {
    name: "Liberia",
    country: "Costa Rica",
    subcountry: "Guanacaste Province",
    geonameid: 3623076,
  },
  {
    name: "Ipís",
    country: "Costa Rica",
    subcountry: "San José",
    geonameid: 3623394,
  },
  {
    name: "Heredia",
    country: "Costa Rica",
    subcountry: "Heredia Province",
    geonameid: 3623486,
  },
  {
    name: "Guápiles",
    country: "Costa Rica",
    subcountry: "Limón Province",
    geonameid: 3623580,
  },
  {
    name: "Guadalupe",
    country: "Costa Rica",
    subcountry: "San José",
    geonameid: 3623593,
  },
  {
    name: "Esparza",
    country: "Costa Rica",
    subcountry: "Puntarenas Province",
    geonameid: 3623781,
  },
  {
    name: "Curridabat",
    country: "Costa Rica",
    subcountry: "San José",
    geonameid: 3623977,
  },
  {
    name: "Colima",
    country: "Costa Rica",
    subcountry: "San José",
    geonameid: 3624174,
  },
  {
    name: "Chacarita",
    country: "Costa Rica",
    subcountry: "Puntarenas Province",
    geonameid: 3624288,
  },
  {
    name: "Cartago",
    country: "Costa Rica",
    subcountry: "Cartago Province",
    geonameid: 3624370,
  },
  {
    name: "Cañas",
    country: "Costa Rica",
    subcountry: "Guanacaste Province",
    geonameid: 3624468,
  },
  {
    name: "Calle Blancos",
    country: "Costa Rica",
    subcountry: "San José",
    geonameid: 3624509,
  },
  {
    name: "Aserrí",
    country: "Costa Rica",
    subcountry: "San José",
    geonameid: 3624848,
  },
  {
    name: "Alajuela",
    country: "Costa Rica",
    subcountry: "Alajuela Province",
    geonameid: 3624955,
  },
  {
    name: "San Vicente de Moravia",
    country: "Costa Rica",
    subcountry: "San José",
    geonameid: 6612154,
  },
  {
    name: "Yara",
    country: "Cuba",
    subcountry: "Granma Province",
    geonameid: 3533753,
  },
  {
    name: "Yaguajay",
    country: "Cuba",
    subcountry: "Sancti Spíritus Province",
    geonameid: 3533826,
  },
  {
    name: "Viñales",
    country: "Cuba",
    subcountry: "Pinar del Río",
    geonameid: 3534094,
  },
  {
    name: "Vertientes",
    country: "Cuba",
    subcountry: "Camagüey",
    geonameid: 3534363,
  },
  {
    name: "Venezuela",
    country: "Cuba",
    subcountry: "Ciego de Ávila Province",
    geonameid: 3534432,
  },
  {
    name: "Varadero",
    country: "Cuba",
    subcountry: "Matanzas Province",
    geonameid: 3534632,
  },
  {
    name: "San Germán",
    country: "Cuba",
    subcountry: "Holguín Province",
    geonameid: 3534749,
  },
  {
    name: "Unión de Reyes",
    country: "Cuba",
    subcountry: "Matanzas Province",
    geonameid: 3534761,
  },
  {
    name: "Trinidad",
    country: "Cuba",
    subcountry: "Sancti Spíritus Province",
    geonameid: 3534915,
  },
  {
    name: "Sibanicú",
    country: "Cuba",
    subcountry: "Camagüey",
    geonameid: 3536259,
  },
  {
    name: "Santo Domingo",
    country: "Cuba",
    subcountry: "Villa Clara Province",
    geonameid: 3536640,
  },
  {
    name: "Santiago de las Vegas",
    country: "Cuba",
    subcountry: "Havana",
    geonameid: 3536724,
  },
  {
    name: "Santiago de Cuba",
    country: "Cuba",
    subcountry: "Santiago de Cuba",
    geonameid: 3536729,
  },
  {
    name: "Santa Cruz del Sur",
    country: "Cuba",
    subcountry: "Camagüey",
    geonameid: 3537840,
  },
  {
    name: "Santa Cruz del Norte",
    country: "Cuba",
    subcountry: "Mayabeque",
    geonameid: 3537845,
  },
  {
    name: "Santa Clara",
    country: "Cuba",
    subcountry: "Villa Clara Province",
    geonameid: 3537906,
  },
  {
    name: "San Miguel del Padrón",
    country: "Cuba",
    subcountry: "Havana",
    geonameid: 3538803,
  },
  {
    name: "San Luis",
    country: "Cuba",
    subcountry: "Santiago de Cuba",
    geonameid: 3539093,
  },
  {
    name: "San José de las Lajas",
    country: "Cuba",
    subcountry: "Mayabeque",
    geonameid: 3539560,
  },
  {
    name: "Sancti Spíritus",
    country: "Cuba",
    subcountry: "Sancti Spíritus Province",
    geonameid: 3540667,
  },
  {
    name: "San Cristobal",
    country: "Cuba",
    subcountry: "Artemisa",
    geonameid: 3540680,
  },
  {
    name: "San Antonio de los Baños",
    country: "Cuba",
    subcountry: "Artemisa",
    geonameid: 3540885,
  },
  {
    name: "Sagua la Grande",
    country: "Cuba",
    subcountry: "Villa Clara Province",
    geonameid: 3541440,
  },
  {
    name: "Sagua de Tánamo",
    country: "Cuba",
    subcountry: "Holguín Province",
    geonameid: 3541446,
  },
  {
    name: "Rodas",
    country: "Cuba",
    subcountry: "Cienfuegos Province",
    geonameid: 3541999,
  },
  {
    name: "Río Guayabal de Yateras",
    country: "Cuba",
    subcountry: "Guantánamo Province",
    geonameid: 3542137,
  },
  {
    name: "Río Cauto",
    country: "Cuba",
    subcountry: "Granma Province",
    geonameid: 3542167,
  },
  {
    name: "Remedios",
    country: "Cuba",
    subcountry: "Villa Clara Province",
    geonameid: 3542455,
  },
  {
    name: "Regla",
    country: "Cuba",
    subcountry: "Havana",
    geonameid: 3542502,
  },
  {
    name: "Ranchuelo",
    country: "Cuba",
    subcountry: "Villa Clara Province",
    geonameid: 3542744,
  },
  {
    name: "Puerto Padre",
    country: "Cuba",
    subcountry: "Las Tunas",
    geonameid: 3543299,
  },
  {
    name: "Primero de Enero",
    country: "Cuba",
    subcountry: "Ciego de Ávila Province",
    geonameid: 3543498,
  },
  {
    name: "Placetas",
    country: "Cuba",
    subcountry: "Villa Clara Province",
    geonameid: 3543961,
  },
  {
    name: "Pinar del Río",
    country: "Cuba",
    subcountry: "Pinar del Río",
    geonameid: 3544091,
  },
  {
    name: "Perico",
    country: "Cuba",
    subcountry: "Matanzas Province",
    geonameid: 3544393,
  },
  {
    name: "Pedro Betancourt",
    country: "Cuba",
    subcountry: "Matanzas Province",
    geonameid: 3544607,
  },
  {
    name: "Palmira",
    country: "Cuba",
    subcountry: "Cienfuegos Province",
    geonameid: 3545040,
  },
  {
    name: "Palma Soriano",
    country: "Cuba",
    subcountry: "Santiago de Cuba",
    geonameid: 3545064,
  },
  {
    name: "Nuevitas",
    country: "Cuba",
    subcountry: "Camagüey",
    geonameid: 3545841,
  },
  {
    name: "Nueva Gerona",
    country: "Cuba",
    subcountry: "Isla de la Juventud",
    geonameid: 3545867,
  },
  {
    name: "Niquero",
    country: "Cuba",
    subcountry: "Granma Province",
    geonameid: 3545981,
  },
  {
    name: "Morón",
    country: "Cuba",
    subcountry: "Ciego de Ávila Province",
    geonameid: 3546434,
  },
  {
    name: "Moa",
    country: "Cuba",
    subcountry: "Holguín Province",
    geonameid: 3546791,
  },
  {
    name: "Minas de Matahambre",
    country: "Cuba",
    subcountry: "Pinar del Río",
    geonameid: 3546882,
  },
  {
    name: "Minas",
    country: "Cuba",
    subcountry: "Camagüey",
    geonameid: 3546894,
  },
  {
    name: "Media Luna",
    country: "Cuba",
    subcountry: "Granma Province",
    geonameid: 3547260,
  },
  {
    name: "Matanzas",
    country: "Cuba",
    subcountry: "Matanzas Province",
    geonameid: 3547398,
  },
  {
    name: "Mariel",
    country: "Cuba",
    subcountry: "Artemisa",
    geonameid: 3547600,
  },
  {
    name: "Manzanillo",
    country: "Cuba",
    subcountry: "Granma Province",
    geonameid: 3547867,
  },
  {
    name: "Manicaragua",
    country: "Cuba",
    subcountry: "Villa Clara Province",
    geonameid: 3547976,
  },
  {
    name: "Maisí",
    country: "Cuba",
    subcountry: "Guantánamo Province",
    geonameid: 3548441,
  },
  {
    name: "Madruga",
    country: "Cuba",
    subcountry: "Mayabeque",
    geonameid: 3548529,
  },
  {
    name: "Los Palacios",
    country: "Cuba",
    subcountry: "Pinar del Río",
    geonameid: 3548993,
  },
  {
    name: "Limonar",
    country: "Cuba",
    subcountry: "Matanzas Province",
    geonameid: 3549835,
  },
  {
    name: "Las Tunas",
    country: "Cuba",
    subcountry: "Las Tunas",
    geonameid: 3550598,
  },
  {
    name: "La Sierpe",
    country: "Cuba",
    subcountry: "Sancti Spíritus Province",
    geonameid: 3551184,
  },
  {
    name: "La Salud",
    country: "Cuba",
    subcountry: "Mayabeque",
    geonameid: 3551608,
  },
  {
    name: "Lajas",
    country: "Cuba",
    subcountry: "Cienfuegos Province",
    geonameid: 3553343,
  },
  {
    name: "Havana",
    country: "Cuba",
    subcountry: "Havana",
    geonameid: 3553478,
  },
  {
    name: "Jovellanos",
    country: "Cuba",
    subcountry: "Matanzas Province",
    geonameid: 3555907,
  },
  {
    name: "Jobabo",
    country: "Cuba",
    subcountry: "Holguín Province",
    geonameid: 3556077,
  },
  {
    name: "Jobabo",
    country: "Cuba",
    subcountry: "Las Tunas",
    geonameid: 3556078,
  },
  {
    name: "Jiguaní",
    country: "Cuba",
    subcountry: "Granma Province",
    geonameid: 3556168,
  },
  {
    name: "Jesús Menéndez",
    country: "Cuba",
    subcountry: "Las Tunas",
    geonameid: 3556268,
  },
  {
    name: "Jatibonico",
    country: "Cuba",
    subcountry: "Sancti Spíritus Province",
    geonameid: 3556334,
  },
  {
    name: "Jaruco",
    country: "Cuba",
    subcountry: "Mayabeque",
    geonameid: 3556351,
  },
  {
    name: "Jagüey Grande",
    country: "Cuba",
    subcountry: "Matanzas Province",
    geonameid: 3556437,
  },
  {
    name: "Holguín",
    country: "Cuba",
    subcountry: "Holguín Province",
    geonameid: 3556969,
  },
  {
    name: "Guisa",
    country: "Cuba",
    subcountry: "Granma Province",
    geonameid: 3557332,
  },
  {
    name: "Güira de Melena",
    country: "Cuba",
    subcountry: "Artemisa",
    geonameid: 3557347,
  },
  {
    name: "Güines",
    country: "Cuba",
    subcountry: "Mayabeque",
    geonameid: 3557378,
  },
  {
    name: "Guantánamo",
    country: "Cuba",
    subcountry: "Guantánamo Province",
    geonameid: 3557689,
  },
  {
    name: "Guane",
    country: "Cuba",
    subcountry: "Pinar del Río",
    geonameid: 3557758,
  },
  {
    name: "Guanajay",
    country: "Cuba",
    subcountry: "Artemisa",
    geonameid: 3557801,
  },
  {
    name: "Guanabacoa",
    country: "Cuba",
    subcountry: "Havana",
    geonameid: 3557846,
  },
  {
    name: "Guáimaro",
    country: "Cuba",
    subcountry: "Camagüey",
    geonameid: 3557923,
  },
  {
    name: "Gibara",
    country: "Cuba",
    subcountry: "Holguín Province",
    geonameid: 3558315,
  },
  {
    name: "Fomento",
    country: "Cuba",
    subcountry: "Sancti Spíritus Province",
    geonameid: 3558744,
  },
  {
    name: "Florida",
    country: "Cuba",
    subcountry: "Camagüey",
    geonameid: 3558771,
  },
  {
    name: "Florencia",
    country: "Cuba",
    subcountry: "Ciego de Ávila Province",
    geonameid: 3558792,
  },
  {
    name: "Esmeralda",
    country: "Cuba",
    subcountry: "Camagüey",
    geonameid: 3559318,
  },
  {
    name: "Encrucijada",
    country: "Cuba",
    subcountry: "Villa Clara Province",
    geonameid: 3559416,
  },
  {
    name: "Cumanayagua",
    country: "Cuba",
    subcountry: "Cienfuegos Province",
    geonameid: 3562827,
  },
  {
    name: "Cueto",
    country: "Cuba",
    subcountry: "Holguín Province",
    geonameid: 3562895,
  },
  {
    name: "Cruces",
    country: "Cuba",
    subcountry: "Cienfuegos Province",
    geonameid: 3563145,
  },
  {
    name: "Corralillo",
    country: "Cuba",
    subcountry: "Villa Clara Province",
    geonameid: 3563317,
  },
  {
    name: "Contramaestre",
    country: "Cuba",
    subcountry: "Santiago de Cuba",
    geonameid: 3563504,
  },
  {
    name: "Consolación del Sur",
    country: "Cuba",
    subcountry: "Pinar del Río",
    geonameid: 3563559,
  },
  {
    name: "Condado",
    country: "Cuba",
    subcountry: "Sancti Spíritus Province",
    geonameid: 3563609,
  },
  {
    name: "Colón",
    country: "Cuba",
    subcountry: "Matanzas Province",
    geonameid: 3563843,
  },
  {
    name: "Colombia",
    country: "Cuba",
    subcountry: "Las Tunas",
    geonameid: 3563856,
  },
  {
    name: "Ciro Redondo",
    country: "Cuba",
    subcountry: "Ciego de Ávila Province",
    geonameid: 3564084,
  },
  {
    name: "Cifuentes",
    country: "Cuba",
    subcountry: "Villa Clara Province",
    geonameid: 3564114,
  },
  {
    name: "Cienfuegos",
    country: "Cuba",
    subcountry: "Cienfuegos Province",
    geonameid: 3564124,
  },
  {
    name: "Ciego de Ávila",
    country: "Cuba",
    subcountry: "Ciego de Ávila Province",
    geonameid: 3564178,
  },
  {
    name: "Chambas",
    country: "Cuba",
    subcountry: "Ciego de Ávila Province",
    geonameid: 3564394,
  },
  {
    name: "Cerro",
    country: "Cuba",
    subcountry: "Havana",
    geonameid: 3564436,
  },
  {
    name: "Cauto Cristo",
    country: "Cuba",
    subcountry: "Granma Province",
    geonameid: 3564885,
  },
  {
    name: "Cárdenas",
    country: "Cuba",
    subcountry: "Matanzas Province",
    geonameid: 3565432,
  },
  {
    name: "Campechuela",
    country: "Cuba",
    subcountry: "Granma Province",
    geonameid: 3565951,
  },
  {
    name: "Camajuaní",
    country: "Cuba",
    subcountry: "Villa Clara Province",
    geonameid: 3566054,
  },
  {
    name: "Camagüey",
    country: "Cuba",
    subcountry: "Camagüey",
    geonameid: 3566067,
  },
  {
    name: "Calimete",
    country: "Cuba",
    subcountry: "Matanzas Province",
    geonameid: 3566134,
  },
  {
    name: "Caibarién",
    country: "Cuba",
    subcountry: "Villa Clara Province",
    geonameid: 3566356,
  },
  {
    name: "Cacocum",
    country: "Cuba",
    subcountry: "Holguín Province",
    geonameid: 3566429,
  },
  {
    name: "Cabaiguán",
    country: "Cuba",
    subcountry: "Sancti Spíritus Province",
    geonameid: 3566603,
  },
  {
    name: "Bejucal",
    country: "Cuba",
    subcountry: "Mayabeque",
    geonameid: 3567546,
  },
  {
    name: "Bayamo",
    country: "Cuba",
    subcountry: "Granma Province",
    geonameid: 3567597,
  },
  {
    name: "Bauta",
    country: "Cuba",
    subcountry: "Artemisa",
    geonameid: 3567612,
  },
  {
    name: "Bartolomé Masó",
    country: "Cuba",
    subcountry: "Granma Province",
    geonameid: 3567669,
  },
  {
    name: "Baraguá",
    country: "Cuba",
    subcountry: "Ciego de Ávila Province",
    geonameid: 3567823,
  },
  {
    name: "Baracoa",
    country: "Cuba",
    subcountry: "Guantánamo Province",
    geonameid: 3567834,
  },
  {
    name: "Banes",
    country: "Cuba",
    subcountry: "Holguín Province",
    geonameid: 3567869,
  },
  {
    name: "Bahía Honda",
    country: "Cuba",
    subcountry: "Artemisa",
    geonameid: 3567995,
  },
  {
    name: "Artemisa",
    country: "Cuba",
    subcountry: "Artemisa",
    geonameid: 3568312,
  },
  {
    name: "Arroyo Naranjo",
    country: "Cuba",
    subcountry: "Havana",
    geonameid: 3568342,
  },
  {
    name: "Amancio",
    country: "Cuba",
    subcountry: "Las Tunas",
    geonameid: 3569024,
  },
  {
    name: "Alquízar",
    country: "Cuba",
    subcountry: "Artemisa",
    geonameid: 3569136,
  },
  {
    name: "Alamar",
    country: "Cuba",
    subcountry: "Havana",
    geonameid: 3569370,
  },
  {
    name: "Aguada de Pasajeros",
    country: "Cuba",
    subcountry: "Cienfuegos Province",
    geonameid: 3569546,
  },
  {
    name: "Abreus",
    country: "Cuba",
    subcountry: "Cienfuegos Province",
    geonameid: 3569741,
  },
  {
    name: "Ciudad Camilo Cienfuegos",
    country: "Cuba",
    subcountry: "Havana",
    geonameid: 3746181,
  },
  {
    name: "Centro Habana",
    country: "Cuba",
    subcountry: "Havana",
    geonameid: 3746183,
  },
  {
    name: "La Habana Vieja",
    country: "Cuba",
    subcountry: "Havana",
    geonameid: 3746184,
  },
  {
    name: "Jimaguayú",
    country: "Cuba",
    subcountry: "Camagüey",
    geonameid: 3754915,
  },
  {
    name: "Boyeros",
    country: "Cuba",
    subcountry: "Havana",
    geonameid: 6956647,
  },
  {
    name: "Diez de Octubre",
    country: "Cuba",
    subcountry: "Havana",
    geonameid: 6956648,
  },
  {
    name: "Santa Maria",
    country: "Cabo Verde",
    subcountry: "Sal",
    geonameid: 3374218,
  },
  {
    name: "Praia",
    country: "Cabo Verde",
    subcountry: "Praia",
    geonameid: 3374333,
  },
  {
    name: "Mindelo",
    country: "Cabo Verde",
    subcountry: "São Vicente",
    geonameid: 3374462,
  },
  {
    name: "Cova Figueira",
    country: "Cabo Verde",
    subcountry: "Santa Catarina do Fogo",
    geonameid: 3374707,
  },
  {
    name: "Willemstad",
    country: "Curacao",
    subcountry: "N/A",
    geonameid: 3513090,
  },
  {
    name: "Flying Fish Cove",
    country: "Christmas Island",
    subcountry: "N/A",
    geonameid: 2078127,
  },
  {
    name: "Protaras",
    country: "Cyprus",
    subcountry: "Ammochostos",
    geonameid: 18918,
  },
  {
    name: "Stróvolos",
    country: "Cyprus",
    subcountry: "Nicosia",
    geonameid: 146054,
  },
  {
    name: "Paphos",
    country: "Cyprus",
    subcountry: "Pafos",
    geonameid: 146214,
  },
  {
    name: "Nicosia",
    country: "Cyprus",
    subcountry: "Nicosia",
    geonameid: 146268,
  },
  {
    name: "Mórfou",
    country: "Cyprus",
    subcountry: "Nicosia",
    geonameid: 146286,
  },
  {
    name: "Limassol",
    country: "Cyprus",
    subcountry: "Limassol",
    geonameid: 146384,
  },
  {
    name: "Larnaca",
    country: "Cyprus",
    subcountry: "Larnaka",
    geonameid: 146400,
  },
  {
    name: "Kyrenia",
    country: "Cyprus",
    subcountry: "Keryneia",
    geonameid: 146412,
  },
  {
    name: "Famagusta",
    country: "Cyprus",
    subcountry: "Ammochostos",
    geonameid: 146617,
  },
  {
    name: "Dvůr Králové nad Labem",
    country: "Czechia",
    subcountry: "Královéhradecký kraj",
    geonameid: 3061284,
  },
  {
    name: "Znojmo",
    country: "Czechia",
    subcountry: "South Moravian",
    geonameid: 3061344,
  },
  {
    name: "Zlín",
    country: "Czechia",
    subcountry: "Zlín",
    geonameid: 3061370,
  },
  {
    name: "Žďár nad Sázavou",
    country: "Czechia",
    subcountry: "Vysočina",
    geonameid: 3061695,
  },
  {
    name: "Žatec",
    country: "Czechia",
    subcountry: "Ústecký kraj",
    geonameid: 3061822,
  },
  {
    name: "Vyškov",
    country: "Czechia",
    subcountry: "South Moravian",
    geonameid: 3062283,
  },
  {
    name: "Vsetín",
    country: "Czechia",
    subcountry: "Zlín",
    geonameid: 3062339,
  },
  {
    name: "Varnsdorf",
    country: "Czechia",
    subcountry: "Ústecký kraj",
    geonameid: 3063375,
  },
  {
    name: "Valašské Meziříčí",
    country: "Czechia",
    subcountry: "Zlín",
    geonameid: 3063447,
  },
  {
    name: "Ústí nad Orlicí",
    country: "Czechia",
    subcountry: "Pardubický",
    geonameid: 3063546,
  },
  {
    name: "Ústí nad Labem",
    country: "Czechia",
    subcountry: "Ústecký kraj",
    geonameid: 3063548,
  },
  {
    name: "Uherský Brod",
    country: "Czechia",
    subcountry: "Zlín",
    geonameid: 3063736,
  },
  {
    name: "Uherské Hradiště",
    country: "Czechia",
    subcountry: "Zlín",
    geonameid: 3063739,
  },
  {
    name: "Trutnov",
    country: "Czechia",
    subcountry: "Královéhradecký kraj",
    geonameid: 3063907,
  },
  {
    name: "Třinec",
    country: "Czechia",
    subcountry: "Moravskoslezský",
    geonameid: 3064000,
  },
  {
    name: "Třebíč",
    country: "Czechia",
    subcountry: "Vysočina",
    geonameid: 3064104,
  },
  {
    name: "Teplice",
    country: "Czechia",
    subcountry: "Ústecký kraj",
    geonameid: 3064288,
  },
  {
    name: "Tábor",
    country: "Czechia",
    subcountry: "Jihočeský kraj",
    geonameid: 3064379,
  },
  {
    name: "Svitavy",
    country: "Czechia",
    subcountry: "Pardubický",
    geonameid: 3064454,
  },
  {
    name: "Šumperk",
    country: "Czechia",
    subcountry: "Olomoucký",
    geonameid: 3064673,
  },
  {
    name: "Strakonice",
    country: "Czechia",
    subcountry: "Jihočeský kraj",
    geonameid: 3065067,
  },
  {
    name: "Starý Bohumín",
    country: "Czechia",
    subcountry: "Moravskoslezský",
    geonameid: 3065281,
  },
  {
    name: "Sokolov",
    country: "Czechia",
    subcountry: "Karlovarský kraj",
    geonameid: 3065617,
  },
  {
    name: "Slaný",
    country: "Czechia",
    subcountry: "Central Bohemia",
    geonameid: 3065903,
  },
  {
    name: "Rožnov pod Radhoštěm",
    country: "Czechia",
    subcountry: "Zlín",
    geonameid: 3066651,
  },
  {
    name: "Rakovník",
    country: "Czechia",
    subcountry: "Central Bohemia",
    geonameid: 3067051,
  },
  {
    name: "Prostějov",
    country: "Czechia",
    subcountry: "Olomoucký",
    geonameid: 3067421,
  },
  {
    name: "Prosek",
    country: "Czechia",
    subcountry: "Prague",
    geonameid: 3067433,
  },
  {
    name: "Příbram",
    country: "Czechia",
    subcountry: "Central Bohemia",
    geonameid: 3067542,
  },
  {
    name: "Přerov",
    country: "Czechia",
    subcountry: "Olomoucký",
    geonameid: 3067580,
  },
  {
    name: "Prague",
    country: "Czechia",
    subcountry: "Prague",
    geonameid: 3067696,
  },
  {
    name: "Pilsen",
    country: "Czechia",
    subcountry: "Plzeň Region",
    geonameid: 3068160,
  },
  {
    name: "Písek",
    country: "Czechia",
    subcountry: "Jihočeský kraj",
    geonameid: 3068293,
  },
  {
    name: "Pelhřimov",
    country: "Czechia",
    subcountry: "Vysočina",
    geonameid: 3068445,
  },
  {
    name: "Pardubice",
    country: "Czechia",
    subcountry: "Pardubický",
    geonameid: 3068582,
  },
  {
    name: "Otrokovice",
    country: "Czechia",
    subcountry: "Zlín",
    geonameid: 3068690,
  },
  {
    name: "Ostrov",
    country: "Czechia",
    subcountry: "Karlovarský kraj",
    geonameid: 3068766,
  },
  {
    name: "Ostrava",
    country: "Czechia",
    subcountry: "Moravskoslezský",
    geonameid: 3068799,
  },
  {
    name: "Orlová",
    country: "Czechia",
    subcountry: "Moravskoslezský",
    geonameid: 3068873,
  },
  {
    name: "Opava",
    country: "Czechia",
    subcountry: "Moravskoslezský",
    geonameid: 3068927,
  },
  {
    name: "Olomouc",
    country: "Czechia",
    subcountry: "Olomoucký",
    geonameid: 3069011,
  },
  {
    name: "Nový Jičín",
    country: "Czechia",
    subcountry: "Moravskoslezský",
    geonameid: 3069305,
  },
  {
    name: "Neratovice",
    country: "Czechia",
    subcountry: "Central Bohemia",
    geonameid: 3069844,
  },
  {
    name: "Náchod",
    country: "Czechia",
    subcountry: "Královéhradecký kraj",
    geonameid: 3070122,
  },
  {
    name: "Most",
    country: "Czechia",
    subcountry: "Ústecký kraj",
    geonameid: 3070291,
  },
  {
    name: "Modřany",
    country: "Czechia",
    subcountry: "Prague",
    geonameid: 3070420,
  },
  {
    name: "Mladá Boleslav",
    country: "Czechia",
    subcountry: "Central Bohemia",
    geonameid: 3070544,
  },
  {
    name: "Mělník",
    country: "Czechia",
    subcountry: "Central Bohemia",
    geonameid: 3070862,
  },
  {
    name: "Louny",
    country: "Czechia",
    subcountry: "Ústecký kraj",
    geonameid: 3071507,
  },
  {
    name: "Litvínov",
    country: "Czechia",
    subcountry: "Ústecký kraj",
    geonameid: 3071665,
  },
  {
    name: "Litoměřice",
    country: "Czechia",
    subcountry: "Ústecký kraj",
    geonameid: 3071677,
  },
  {
    name: "Liberec",
    country: "Czechia",
    subcountry: "Liberecký kraj",
    geonameid: 3071961,
  },
  {
    name: "Libeň",
    country: "Czechia",
    subcountry: "Prague",
    geonameid: 3071966,
  },
  {
    name: "Letňany",
    country: "Czechia",
    subcountry: "Prague",
    geonameid: 3072137,
  },
  {
    name: "Kutná Hora",
    country: "Czechia",
    subcountry: "Central Bohemia",
    geonameid: 3072463,
  },
  {
    name: "Kroměříž",
    country: "Czechia",
    subcountry: "Zlín",
    geonameid: 3072649,
  },
  {
    name: "Krnov",
    country: "Czechia",
    subcountry: "Moravskoslezský",
    geonameid: 3072656,
  },
  {
    name: "Kralupy nad Vltavou",
    country: "Czechia",
    subcountry: "Central Bohemia",
    geonameid: 3072929,
  },
  {
    name: "Kopřivnice",
    country: "Czechia",
    subcountry: "Moravskoslezský",
    geonameid: 3073254,
  },
  {
    name: "Kolín",
    country: "Czechia",
    subcountry: "Central Bohemia",
    geonameid: 3073371,
  },
  {
    name: "Klatovy",
    country: "Czechia",
    subcountry: "Plzeň Region",
    geonameid: 3073660,
  },
  {
    name: "Klášterec nad Ohří",
    country: "Czechia",
    subcountry: "Ústecký kraj",
    geonameid: 3073668,
  },
  {
    name: "Kladno",
    country: "Czechia",
    subcountry: "Central Bohemia",
    geonameid: 3073699,
  },
  {
    name: "Karviná",
    country: "Czechia",
    subcountry: "Moravskoslezský",
    geonameid: 3073789,
  },
  {
    name: "Karlovy Vary",
    country: "Czechia",
    subcountry: "Karlovarský kraj",
    geonameid: 3073803,
  },
  {
    name: "Kadaň",
    country: "Czechia",
    subcountry: "Ústecký kraj",
    geonameid: 3074020,
  },
  {
    name: "Jirkov",
    country: "Czechia",
    subcountry: "Ústecký kraj",
    geonameid: 3074110,
  },
  {
    name: "Jindřichův Hradec",
    country: "Czechia",
    subcountry: "Jihočeský kraj",
    geonameid: 3074149,
  },
  {
    name: "Jihlava",
    country: "Czechia",
    subcountry: "Vysočina",
    geonameid: 3074199,
  },
  {
    name: "Jičín",
    country: "Czechia",
    subcountry: "Královéhradecký kraj",
    geonameid: 3074204,
  },
  {
    name: "Jablonec nad Nisou",
    country: "Czechia",
    subcountry: "Liberecký kraj",
    geonameid: 3074603,
  },
  {
    name: "Hranice",
    country: "Czechia",
    subcountry: "Olomoucký",
    geonameid: 3074893,
  },
  {
    name: "Hradec Králové",
    country: "Czechia",
    subcountry: "Královéhradecký kraj",
    geonameid: 3074967,
  },
  {
    name: "Hodonín",
    country: "Czechia",
    subcountry: "South Moravian",
    geonameid: 3075654,
  },
  {
    name: "Havlíčkův Brod",
    country: "Czechia",
    subcountry: "Vysočina",
    geonameid: 3075919,
  },
  {
    name: "Havířov",
    country: "Czechia",
    subcountry: "Moravskoslezský",
    geonameid: 3075921,
  },
  {
    name: "Frýdek-Místek",
    country: "Czechia",
    subcountry: "Moravskoslezský",
    geonameid: 3076127,
  },
  {
    name: "Děčín",
    country: "Czechia",
    subcountry: "Ústecký kraj",
    geonameid: 3077244,
  },
  {
    name: "Chrudim",
    country: "Czechia",
    subcountry: "Pardubický",
    geonameid: 3077539,
  },
  {
    name: "Chomutov",
    country: "Czechia",
    subcountry: "Ústecký kraj",
    geonameid: 3077685,
  },
  {
    name: "Cheb",
    country: "Czechia",
    subcountry: "Karlovarský kraj",
    geonameid: 3077835,
  },
  {
    name: "Český Těšín",
    country: "Czechia",
    subcountry: "Moravskoslezský",
    geonameid: 3077882,
  },
  {
    name: "České Budějovice",
    country: "Czechia",
    subcountry: "Jihočeský kraj",
    geonameid: 3077916,
  },
  {
    name: "Česká Třebová",
    country: "Czechia",
    subcountry: "Pardubický",
    geonameid: 3077920,
  },
  {
    name: "Česká Lípa",
    country: "Czechia",
    subcountry: "Liberecký kraj",
    geonameid: 3077929,
  },
  {
    name: "Bruntál",
    country: "Czechia",
    subcountry: "Moravskoslezský",
    geonameid: 3078545,
  },
  {
    name: "Brno",
    country: "Czechia",
    subcountry: "South Moravian",
    geonameid: 3078610,
  },
  {
    name: "Břeclav",
    country: "Czechia",
    subcountry: "South Moravian",
    geonameid: 3078773,
  },
  {
    name: "Braník",
    country: "Czechia",
    subcountry: "Prague",
    geonameid: 3078833,
  },
  {
    name: "Brandýs nad Labem-Stará Boleslav",
    country: "Czechia",
    subcountry: "Central Bohemia",
    geonameid: 3078837,
  },
  {
    name: "Bohumín",
    country: "Czechia",
    subcountry: "Moravskoslezský",
    geonameid: 3079129,
  },
  {
    name: "Blansko",
    country: "Czechia",
    subcountry: "South Moravian",
    geonameid: 3079273,
  },
  {
    name: "Bílina",
    country: "Czechia",
    subcountry: "Ústecký kraj",
    geonameid: 3079348,
  },
  {
    name: "Beroun",
    country: "Czechia",
    subcountry: "Central Bohemia",
    geonameid: 3079467,
  },
  {
    name: "Benešov",
    country: "Czechia",
    subcountry: "Central Bohemia",
    geonameid: 3079508,
  },
  {
    name: "Černý Most",
    country: "Czechia",
    subcountry: "Prague",
    geonameid: 6269470,
  },
  {
    name: "Zwickau",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2803560,
  },
  {
    name: "Zweibrücken",
    country: "Germany",
    subcountry: "Rheinland-Pfalz",
    geonameid: 2803620,
  },
  {
    name: "Zülpich",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2803723,
  },
  {
    name: "Zossen",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2803870,
  },
  {
    name: "Zittau",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2804008,
  },
  {
    name: "Zirndorf",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2804034,
  },
  {
    name: "Zerbst",
    country: "Germany",
    subcountry: "Saxony-Anhalt",
    geonameid: 2804748,
  },
  {
    name: "Zeitz",
    country: "Germany",
    subcountry: "Saxony-Anhalt",
    geonameid: 2804922,
  },
  {
    name: "Zehlendorf",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2805059,
  },
  {
    name: "Xanten",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2805385,
  },
  {
    name: "Wurzen",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2805597,
  },
  {
    name: "Würzburg",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2805615,
  },
  {
    name: "Würselen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2805644,
  },
  {
    name: "Wuppertal",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2805753,
  },
  {
    name: "Wunstorf",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2805761,
  },
  {
    name: "Wülfrath",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2805910,
  },
  {
    name: "Wörth am Rhein",
    country: "Germany",
    subcountry: "Rheinland-Pfalz",
    geonameid: 2806081,
  },
  {
    name: "Worms",
    country: "Germany",
    subcountry: "Rheinland-Pfalz",
    geonameid: 2806142,
  },
  {
    name: "Wolfsburg",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2806654,
  },
  {
    name: "Wolfratshausen",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2806768,
  },
  {
    name: "Wolfenbüttel",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2806914,
  },
  {
    name: "Wolfen",
    country: "Germany",
    subcountry: "Saxony-Anhalt",
    geonameid: 2806919,
  },
  {
    name: "Witzenhausen",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2807184,
  },
  {
    name: "Wittstock",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2807201,
  },
  {
    name: "Wittmund",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2807218,
  },
  {
    name: "Wittlich",
    country: "Germany",
    subcountry: "Rheinland-Pfalz",
    geonameid: 2807240,
  },
  {
    name: "Wittenberge",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2807344,
  },
  {
    name: "Wittenau",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2807360,
  },
  {
    name: "Witten",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2807363,
  },
  {
    name: "Wismar",
    country: "Germany",
    subcountry: "Mecklenburg-Vorpommern",
    geonameid: 2807465,
  },
  {
    name: "Wipperfürth",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2807594,
  },
  {
    name: "Winterhude",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 2807748,
  },
  {
    name: "Winsen",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2807845,
  },
  {
    name: "Winnenden",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2807872,
  },
  {
    name: "Wilnsdorf",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2808461,
  },
  {
    name: "Wilmersdorf",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2808473,
  },
  {
    name: "Willich",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2808559,
  },
  {
    name: "Wilhelmstadt",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2808662,
  },
  {
    name: "Wilhelmshaven",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2808720,
  },
  {
    name: "Wilhelmsburg",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 2808747,
  },
  {
    name: "Wildeshausen",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2808893,
  },
  {
    name: "Wiesloch",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2809138,
  },
  {
    name: "Wiesbaden",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2809346,
  },
  {
    name: "Wiehl",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2809517,
  },
  {
    name: "Wetzlar",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2809889,
  },
  {
    name: "Wetter",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2809984,
  },
  {
    name: "Westerstede",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2810188,
  },
  {
    name: "Westend",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2810538,
  },
  {
    name: "Wesseling",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2810612,
  },
  {
    name: "Wesel",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2810678,
  },
  {
    name: "Wertheim",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2810716,
  },
  {
    name: "Wersten",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2810730,
  },
  {
    name: "Wernigerode",
    country: "Germany",
    subcountry: "Saxony-Anhalt",
    geonameid: 2810808,
  },
  {
    name: "Werne",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2810833,
  },
  {
    name: "Wermelskirchen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2810855,
  },
  {
    name: "Werl",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2810878,
  },
  {
    name: "Werdohl",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2810919,
  },
  {
    name: "Werder",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2810945,
  },
  {
    name: "Werdau",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2810969,
  },
  {
    name: "Wendlingen am Neckar",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2811204,
  },
  {
    name: "Wenden",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2811278,
  },
  {
    name: "Wendelstein",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2811292,
  },
  {
    name: "Weiterstadt",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2811644,
  },
  {
    name: "Weißwasser",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2811698,
  },
  {
    name: "Weißenfels",
    country: "Germany",
    subcountry: "Saxony-Anhalt",
    geonameid: 2811899,
  },
  {
    name: "Weißenburg in Bayern",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2811909,
  },
  {
    name: "Weinstadt-Endersbach",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2812145,
  },
  {
    name: "Weinheim",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2812174,
  },
  {
    name: "Weingarten",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2812204,
  },
  {
    name: "Weimar",
    country: "Germany",
    subcountry: "Thuringia",
    geonameid: 2812482,
  },
  {
    name: "Weilheim",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2812515,
  },
  {
    name: "Weilerswist",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2812522,
  },
  {
    name: "Weil der Stadt",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2812625,
  },
  {
    name: "Weil am Rhein",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2812636,
  },
  {
    name: "Weiden",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2813040,
  },
  {
    name: "Weißensee",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2813187,
  },
  {
    name: "Wegberg",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2813390,
  },
  {
    name: "Weener",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2813433,
  },
  {
    name: "Wedel",
    country: "Germany",
    subcountry: "Schleswig-Holstein",
    geonameid: 2813464,
  },
  {
    name: "Wedding",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2813472,
  },
  {
    name: "Wassenberg",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2813786,
  },
  {
    name: "Warstein",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2814005,
  },
  {
    name: "Warendorf",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2814127,
  },
  {
    name: "Waren",
    country: "Germany",
    subcountry: "Mecklenburg-Vorpommern",
    geonameid: 2814131,
  },
  {
    name: "Wardenburg",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2814146,
  },
  {
    name: "Warburg",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2814153,
  },
  {
    name: "Wangen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2814270,
  },
  {
    name: "Wandlitz",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2814305,
  },
  {
    name: "Waltrop",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2814362,
  },
  {
    name: "Walsrode",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2814462,
  },
  {
    name: "Wallenhorst",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2814632,
  },
  {
    name: "Waldshut-Tiengen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2814791,
  },
  {
    name: "Waldkraiburg",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2814874,
  },
  {
    name: "Waldkirch",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2814883,
  },
  {
    name: "Waldbröl",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2815137,
  },
  {
    name: "Waiblingen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2815330,
  },
  {
    name: "Waghäusel",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2815487,
  },
  {
    name: "Wadgassen",
    country: "Germany",
    subcountry: "Saarland",
    geonameid: 2815559,
  },
  {
    name: "Wadern",
    country: "Germany",
    subcountry: "Saarland",
    geonameid: 2815565,
  },
  {
    name: "Wachtberg",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2815678,
  },
  {
    name: "Vreden",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2815824,
  },
  {
    name: "Volksdorf",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 2816607,
  },
  {
    name: "Völklingen",
    country: "Germany",
    subcountry: "Saarland",
    geonameid: 2816630,
  },
  {
    name: "Voerde",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2817065,
  },
  {
    name: "Vlotho",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2817105,
  },
  {
    name: "Vilshofen",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2817202,
  },
  {
    name: "Villingen-Schwenningen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2817220,
  },
  {
    name: "Viersen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2817311,
  },
  {
    name: "Viernheim",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2817324,
  },
  {
    name: "Versmold",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2817537,
  },
  {
    name: "Verl",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2817576,
  },
  {
    name: "Verden",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2817599,
  },
  {
    name: "Velbert",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2817724,
  },
  {
    name: "Vegesack",
    country: "Germany",
    subcountry: "Bremen",
    geonameid: 2817783,
  },
  {
    name: "Vechta",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2817812,
  },
  {
    name: "Vechelde",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2817813,
  },
  {
    name: "Vaterstetten",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2817818,
  },
  {
    name: "Varel",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2817873,
  },
  {
    name: "Vaihingen an der Enz",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2817927,
  },
  {
    name: "Uetersen",
    country: "Germany",
    subcountry: "Schleswig-Holstein",
    geonameid: 2818067,
  },
  {
    name: "Uslar",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2818094,
  },
  {
    name: "Unterschleißheim",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2818766,
  },
  {
    name: "Unterhaching",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2819465,
  },
  {
    name: "Unterkrozingen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2819974,
  },
  {
    name: "Unna",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2820087,
  },
  {
    name: "Ulm",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2820256,
  },
  {
    name: "Uerdingen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2820447,
  },
  {
    name: "Uelzen",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2820456,
  },
  {
    name: "Überlingen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2820577,
  },
  {
    name: "Übach-Palenberg",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2820621,
  },
  {
    name: "Tuttlingen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2820693,
  },
  {
    name: "Tübingen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2820860,
  },
  {
    name: "Trossingen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2820973,
  },
  {
    name: "Troisdorf",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2821029,
  },
  {
    name: "Trier",
    country: "Germany",
    subcountry: "Rheinland-Pfalz",
    geonameid: 2821164,
  },
  {
    name: "Traunstein",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2821515,
  },
  {
    name: "Traunreut",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2821517,
  },
  {
    name: "Torgau",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2821807,
  },
  {
    name: "Tönisvorst",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2821899,
  },
  {
    name: "Tettnang",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2823368,
  },
  {
    name: "Templin",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2823533,
  },
  {
    name: "Tempelhof",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2823538,
  },
  {
    name: "Teltow",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2823567,
  },
  {
    name: "Telgte",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2823590,
  },
  {
    name: "Tegel",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2823708,
  },
  {
    name: "Taunusstein",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2823799,
  },
  {
    name: "Taufkirchen",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2823812,
  },
  {
    name: "Syke",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2824461,
  },
  {
    name: "Sundern",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2824655,
  },
  {
    name: "Sulzbach-Rosenberg",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2824801,
  },
  {
    name: "Sulzbach",
    country: "Germany",
    subcountry: "Saarland",
    geonameid: 2824841,
  },
  {
    name: "Suhl",
    country: "Germany",
    subcountry: "Thuringia",
    geonameid: 2824948,
  },
  {
    name: "Stuttgart",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2825297,
  },
  {
    name: "Stuhr",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2825422,
  },
  {
    name: "Strausberg",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2826082,
  },
  {
    name: "Straubing",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2826099,
  },
  {
    name: "Stralsund",
    country: "Germany",
    subcountry: "Mecklenburg-Vorpommern",
    geonameid: 2826287,
  },
  {
    name: "Straelen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2826304,
  },
  {
    name: "Stolberg",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2826595,
  },
  {
    name: "Stockelsdorf",
    country: "Germany",
    subcountry: "Schleswig-Holstein",
    geonameid: 2826861,
  },
  {
    name: "Stockach",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2826909,
  },
  {
    name: "Stendal",
    country: "Germany",
    subcountry: "Saxony-Anhalt",
    geonameid: 2827479,
  },
  {
    name: "Stellingen",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 2827552,
  },
  {
    name: "Steinhagen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2828050,
  },
  {
    name: "Steinfurt",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2828105,
  },
  {
    name: "Steilshoop",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 2828994,
  },
  {
    name: "Steglitz",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2829109,
  },
  {
    name: "Staßfurt",
    country: "Germany",
    subcountry: "Saxony-Anhalt",
    geonameid: 2829422,
  },
  {
    name: "Starnberg",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2829457,
  },
  {
    name: "Stadtlohn",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2829758,
  },
  {
    name: "Stadthagen",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2829777,
  },
  {
    name: "Stadtallendorf",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2829804,
  },
  {
    name: "Stade",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2829901,
  },
  {
    name: "Staaken",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2829962,
  },
  {
    name: "Sprockhövel",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2829998,
  },
  {
    name: "Springe",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2830035,
  },
  {
    name: "Speyer",
    country: "Germany",
    subcountry: "Rheinland-Pfalz",
    geonameid: 2830582,
  },
  {
    name: "Spenge",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2830637,
  },
  {
    name: "Sonthofen",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2831088,
  },
  {
    name: "Sonneberg",
    country: "Germany",
    subcountry: "Thuringia",
    geonameid: 2831250,
  },
  {
    name: "Sondershausen",
    country: "Germany",
    subcountry: "Thuringia",
    geonameid: 2831276,
  },
  {
    name: "Sömmerda",
    country: "Germany",
    subcountry: "Thuringia",
    geonameid: 2831403,
  },
  {
    name: "Soltau",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2831486,
  },
  {
    name: "Solingen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2831580,
  },
  {
    name: "Soest",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2831708,
  },
  {
    name: "Sinzig",
    country: "Germany",
    subcountry: "Rheinland-Pfalz",
    geonameid: 2831852,
  },
  {
    name: "Sinsheim",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2831872,
  },
  {
    name: "Singen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2831924,
  },
  {
    name: "Sindelfingen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2831948,
  },
  {
    name: "Simmerath",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2832023,
  },
  {
    name: "Sigmaringen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2832232,
  },
  {
    name: "Siegen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2832495,
  },
  {
    name: "Siegburg",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2832521,
  },
  {
    name: "Langenhorn",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 2832561,
  },
  {
    name: "Senftenberg",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2833073,
  },
  {
    name: "Senden",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2833079,
  },
  {
    name: "Senden",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2833080,
  },
  {
    name: "Selm",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2833170,
  },
  {
    name: "Seligenstadt",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2833242,
  },
  {
    name: "Selb",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2833296,
  },
  {
    name: "Sehnde",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2833475,
  },
  {
    name: "Seevetal",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2833564,
  },
  {
    name: "Seesen",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2833592,
  },
  {
    name: "Seelze",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2833641,
  },
  {
    name: "Schwetzingen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2834240,
  },
  {
    name: "Schwerte",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2834265,
  },
  {
    name: "Schwerin",
    country: "Germany",
    subcountry: "Mecklenburg-Vorpommern",
    geonameid: 2834282,
  },
  {
    name: "Schwelm",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2834372,
  },
  {
    name: "Schweinfurt",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2834498,
  },
  {
    name: "Schwedt (Oder)",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2834629,
  },
  {
    name: "Schwarzenberg",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2834978,
  },
  {
    name: "Schwanewede",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2835260,
  },
  {
    name: "Schwandorf in Bayern",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2835297,
  },
  {
    name: "Schwalmtal",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2835342,
  },
  {
    name: "Schwalmstadt",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2835345,
  },
  {
    name: "Schwalbach",
    country: "Germany",
    subcountry: "Saarland",
    geonameid: 2835382,
  },
  {
    name: "Schwäbisch Hall",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2835481,
  },
  {
    name: "Schwäbisch Gmünd",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2835482,
  },
  {
    name: "Schwabach",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2835537,
  },
  {
    name: "Schrobenhausen",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2836084,
  },
  {
    name: "Schramberg",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2836203,
  },
  {
    name: "Schortens",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2836282,
  },
  {
    name: "Schorndorf",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2836320,
  },
  {
    name: "Schopfheim",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2836413,
  },
  {
    name: "Schöneberg",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2836788,
  },
  {
    name: "Schönebeck",
    country: "Germany",
    subcountry: "Saxony-Anhalt",
    geonameid: 2836809,
  },
  {
    name: "Schneverdingen",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2837291,
  },
  {
    name: "Schnelsen",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 2837343,
  },
  {
    name: "Schneeberg",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2837470,
  },
  {
    name: "Schmelz",
    country: "Germany",
    subcountry: "Saarland",
    geonameid: 2837954,
  },
  {
    name: "Schmargendorf",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2838009,
  },
  {
    name: "Schmallenberg",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2838053,
  },
  {
    name: "Schmalkalden",
    country: "Germany",
    subcountry: "Thuringia",
    geonameid: 2838059,
  },
  {
    name: "Schlüchtern",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2838201,
  },
  {
    name: "Schleswig",
    country: "Germany",
    subcountry: "Schleswig-Holstein",
    geonameid: 2838634,
  },
  {
    name: "Schkeuditz",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2839050,
  },
  {
    name: "Schiffweiler",
    country: "Germany",
    subcountry: "Saarland",
    geonameid: 2839316,
  },
  {
    name: "Schifferstadt",
    country: "Germany",
    subcountry: "Rheinland-Pfalz",
    geonameid: 2839335,
  },
  {
    name: "Bad Saulgau",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2841125,
  },
  {
    name: "Sasel",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 2841374,
  },
  {
    name: "Sarstedt",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2841386,
  },
  {
    name: "Sankt Wendel",
    country: "Germany",
    subcountry: "Saarland",
    geonameid: 2841463,
  },
  {
    name: "Sankt Ingbert",
    country: "Germany",
    subcountry: "Saarland",
    geonameid: 2841590,
  },
  {
    name: "Sankt Augustin",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2841648,
  },
  {
    name: "Sangerhausen",
    country: "Germany",
    subcountry: "Saxony-Anhalt",
    geonameid: 2841693,
  },
  {
    name: "Salzwedel",
    country: "Germany",
    subcountry: "Saxony-Anhalt",
    geonameid: 2842112,
  },
  {
    name: "Salzkotten",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2842131,
  },
  {
    name: "Salzgitter",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2842150,
  },
  {
    name: "Saarlouis",
    country: "Germany",
    subcountry: "Saarland",
    geonameid: 2842632,
  },
  {
    name: "Saarbrücken",
    country: "Germany",
    subcountry: "Saarland",
    geonameid: 2842647,
  },
  {
    name: "Saalfeld",
    country: "Germany",
    subcountry: "Thuringia",
    geonameid: 2842688,
  },
  {
    name: "Rüsselsheim",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2842884,
  },
  {
    name: "Rummelsburg",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2843106,
  },
  {
    name: "Rudow",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2843350,
  },
  {
    name: "Rudolstadt",
    country: "Germany",
    subcountry: "Thuringia",
    geonameid: 2843355,
  },
  {
    name: "Rottweil",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2843636,
  },
  {
    name: "Rottenburg",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2843729,
  },
  {
    name: "Rotherbaum",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 2843965,
  },
  {
    name: "Roth",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2844265,
  },
  {
    name: "Rotenburg",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2844437,
  },
  {
    name: "Rostock",
    country: "Germany",
    subcountry: "Mecklenburg-Vorpommern",
    geonameid: 2844588,
  },
  {
    name: "Rösrath",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2844862,
  },
  {
    name: "Rosenheim",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2844988,
  },
  {
    name: "Ronnenberg",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2845222,
  },
  {
    name: "Rissen",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 2846455,
  },
  {
    name: "Rinteln",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2846523,
  },
  {
    name: "Rietberg",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2846843,
  },
  {
    name: "Riesa",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2846939,
  },
  {
    name: "Riegelsberg",
    country: "Germany",
    subcountry: "Saarland",
    geonameid: 2847033,
  },
  {
    name: "Ribnitz-Damgarten",
    country: "Germany",
    subcountry: "Mecklenburg-Vorpommern",
    geonameid: 2847524,
  },
  {
    name: "Rheinhausen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2847631,
  },
  {
    name: "Rheinfelden",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2847639,
  },
  {
    name: "Rheine",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2847645,
  },
  {
    name: "Rheinberg",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2847662,
  },
  {
    name: "Rheinbach",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2847666,
  },
  {
    name: "Rhede",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2847689,
  },
  {
    name: "Rheda-Wiedenbrück",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2847690,
  },
  {
    name: "Reutlingen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2847736,
  },
  {
    name: "Renningen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2848175,
  },
  {
    name: "Rendsburg",
    country: "Germany",
    subcountry: "Schleswig-Holstein",
    geonameid: 2848245,
  },
  {
    name: "Remscheid",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2848273,
  },
  {
    name: "Remagen",
    country: "Germany",
    subcountry: "Rheinland-Pfalz",
    geonameid: 2848335,
  },
  {
    name: "Reinickendorf",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2848756,
  },
  {
    name: "Reinheim",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2848762,
  },
  {
    name: "Reinbek",
    country: "Germany",
    subcountry: "Schleswig-Holstein",
    geonameid: 2848845,
  },
  {
    name: "Reichenbach/Vogtland",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2849156,
  },
  {
    name: "Regensburg",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2849483,
  },
  {
    name: "Rees",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2849548,
  },
  {
    name: "Recklinghausen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2849647,
  },
  {
    name: "Ravensburg",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2849802,
  },
  {
    name: "Ratingen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2850174,
  },
  {
    name: "Rathenow",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2850213,
  },
  {
    name: "Ratekau",
    country: "Germany",
    subcountry: "Schleswig-Holstein",
    geonameid: 2850235,
  },
  {
    name: "Rastede",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2850253,
  },
  {
    name: "Rastatt",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2850257,
  },
  {
    name: "Rahlstedt",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 2850872,
  },
  {
    name: "Rahden",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2850887,
  },
  {
    name: "Radolfzell",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2850954,
  },
  {
    name: "Radevormwald",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2850995,
  },
  {
    name: "Radebeul",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2851077,
  },
  {
    name: "Radeberg",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2851079,
  },
  {
    name: "Quickborn",
    country: "Germany",
    subcountry: "Schleswig-Holstein",
    geonameid: 2851343,
  },
  {
    name: "Quedlinburg",
    country: "Germany",
    subcountry: "Saxony-Anhalt",
    geonameid: 2851465,
  },
  {
    name: "Püttlingen",
    country: "Germany",
    subcountry: "Saarland",
    geonameid: 2851584,
  },
  {
    name: "Pulheim",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2851746,
  },
  {
    name: "Puchheim",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2851782,
  },
  {
    name: "Prenzlauer Berg",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2852217,
  },
  {
    name: "Prenzlau",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2852218,
  },
  {
    name: "Preetz",
    country: "Germany",
    subcountry: "Schleswig-Holstein",
    geonameid: 2852280,
  },
  {
    name: "Potsdam",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2852458,
  },
  {
    name: "Porz am Rhein",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2852566,
  },
  {
    name: "Porta Westfalica",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2852577,
  },
  {
    name: "Poppenbüttel",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 2852673,
  },
  {
    name: "Plettenberg",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2853209,
  },
  {
    name: "Plauen",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2853292,
  },
  {
    name: "Pirna",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2853572,
  },
  {
    name: "Pirmasens",
    country: "Germany",
    subcountry: "Rheinland-Pfalz",
    geonameid: 2853574,
  },
  {
    name: "Pinneberg",
    country: "Germany",
    subcountry: "Schleswig-Holstein",
    geonameid: 2853658,
  },
  {
    name: "Pfungstadt",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2853924,
  },
  {
    name: "Pfullingen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2853928,
  },
  {
    name: "Pforzheim",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2853969,
  },
  {
    name: "Pfaffenhofen an der Ilm",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2854386,
  },
  {
    name: "Petershagen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2854655,
  },
  {
    name: "Penzberg",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2854923,
  },
  {
    name: "Peine",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2855047,
  },
  {
    name: "Passau",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2855328,
  },
  {
    name: "Pasing",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2855334,
  },
  {
    name: "Parchim",
    country: "Germany",
    subcountry: "Mecklenburg-Vorpommern",
    geonameid: 2855441,
  },
  {
    name: "Papenburg",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2855525,
  },
  {
    name: "Pankow",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2855598,
  },
  {
    name: "Paderborn",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2855745,
  },
  {
    name: "Oyten",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2855794,
  },
  {
    name: "Overath",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2855859,
  },
  {
    name: "Ottweiler",
    country: "Germany",
    subcountry: "Saarland",
    geonameid: 2855917,
  },
  {
    name: "Ottobrunn bei München",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2855935,
  },
  {
    name: "Ottensen",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 2856075,
  },
  {
    name: "Othmarschen",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 2856163,
  },
  {
    name: "Osterholz-Scharmbeck",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2856500,
  },
  {
    name: "Osnabrück",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2856883,
  },
  {
    name: "Osdorf",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 2856915,
  },
  {
    name: "Oschersleben",
    country: "Germany",
    subcountry: "Saxony-Anhalt",
    geonameid: 2856930,
  },
  {
    name: "Oschatz",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2856944,
  },
  {
    name: "Oranienburg",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2857129,
  },
  {
    name: "Opladen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2857185,
  },
  {
    name: "Olsberg",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2857291,
  },
  {
    name: "Olpe",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2857306,
  },
  {
    name: "Oldenburg",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2857458,
  },
  {
    name: "Olching",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2857472,
  },
  {
    name: "Öhringen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2857565,
  },
  {
    name: "Offenburg",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2857798,
  },
  {
    name: "Offenbach",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2857807,
  },
  {
    name: "Oerlinghausen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2857900,
  },
  {
    name: "Oer-Erkenschwick",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2857904,
  },
  {
    name: "Oelde",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2857943,
  },
  {
    name: "Odenthal",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2858103,
  },
  {
    name: "Ochtrup",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2858245,
  },
  {
    name: "Oberursel",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2858738,
  },
  {
    name: "Obertshausen",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2858763,
  },
  {
    name: "Oberschöneweide",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2859103,
  },
  {
    name: "Ober-Ramstadt",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2859380,
  },
  {
    name: "Oberkirch",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2860080,
  },
  {
    name: "Oberhausen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2860410,
  },
  {
    name: "Oberasbach",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2861402,
  },
  {
    name: "Nürtingen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2861632,
  },
  {
    name: "Nürnberg",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2861650,
  },
  {
    name: "Nümbrecht",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2861677,
  },
  {
    name: "Nottuln",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2861733,
  },
  {
    name: "Northeim",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2861814,
  },
  {
    name: "Nördlingen",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2861914,
  },
  {
    name: "Nordhorn",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2861934,
  },
  {
    name: "Nordhausen",
    country: "Germany",
    subcountry: "Thuringia",
    geonameid: 2861982,
  },
  {
    name: "Norderstedt",
    country: "Germany",
    subcountry: "Schleswig-Holstein",
    geonameid: 2862026,
  },
  {
    name: "Nordenham",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2862104,
  },
  {
    name: "Norden",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2862118,
  },
  {
    name: "Nippes",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2862375,
  },
  {
    name: "Niendorf",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 2862606,
  },
  {
    name: "Nienburg",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2862620,
  },
  {
    name: "Niederschönhausen",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2862888,
  },
  {
    name: "Niederkrüchten",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2863199,
  },
  {
    name: "Niederkassel",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2863223,
  },
  {
    name: "Nieder-Ingelheim",
    country: "Germany",
    subcountry: "Rheinland-Pfalz",
    geonameid: 2863240,
  },
  {
    name: "Nidderau",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2863712,
  },
  {
    name: "Nidda",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2863716,
  },
  {
    name: "Neu Wulmstorf",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2863795,
  },
  {
    name: "Neuwied",
    country: "Germany",
    subcountry: "Rheinland-Pfalz",
    geonameid: 2863840,
  },
  {
    name: "Neu-Ulm",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2863941,
  },
  {
    name: "Neustrelitz",
    country: "Germany",
    subcountry: "Mecklenburg-Vorpommern",
    geonameid: 2864005,
  },
  {
    name: "Neustadt in Holstein",
    country: "Germany",
    subcountry: "Schleswig-Holstein",
    geonameid: 2864034,
  },
  {
    name: "Neustadt bei Coburg",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2864053,
  },
  {
    name: "Neustadt an der Weinstraße",
    country: "Germany",
    subcountry: "Rheinland-Pfalz",
    geonameid: 2864054,
  },
  {
    name: "Neustadt am Rübenberge",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2864058,
  },
  {
    name: "Neue Neustadt",
    country: "Germany",
    subcountry: "Saxony-Anhalt",
    geonameid: 2864072,
  },
  {
    name: "Neuss",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2864118,
  },
  {
    name: "Neuruppin",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2864276,
  },
  {
    name: "Neunkirchen",
    country: "Germany",
    subcountry: "Saarland",
    geonameid: 2864435,
  },
  {
    name: "Neumünster",
    country: "Germany",
    subcountry: "Schleswig-Holstein",
    geonameid: 2864475,
  },
  {
    name: "Neumarkt in der Oberpfalz",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2864549,
  },
  {
    name: "Neukölln",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2864695,
  },
  {
    name: "Neu-Isenburg",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2864820,
  },
  {
    name: "Neugraben-Fischbek",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 2865260,
  },
  {
    name: "Neufahrn bei Freising",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2865376,
  },
  {
    name: "Neuenhagen",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2865716,
  },
  {
    name: "Neuburg an der Donau",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2866070,
  },
  {
    name: "Neubrück",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2866110,
  },
  {
    name: "Neubrandenburg",
    country: "Germany",
    subcountry: "Mecklenburg-Vorpommern",
    geonameid: 2866135,
  },
  {
    name: "Neu-Anspach",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2866280,
  },
  {
    name: "Nettetal",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2866333,
  },
  {
    name: "Netphen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2866375,
  },
  {
    name: "Neckarsulm",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2866758,
  },
  {
    name: "Naumburg",
    country: "Germany",
    subcountry: "Saxony-Anhalt",
    geonameid: 2866906,
  },
  {
    name: "Nauen",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2866930,
  },
  {
    name: "Nagold",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2867164,
  },
  {
    name: "Munster",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2867542,
  },
  {
    name: "Münster",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2867543,
  },
  {
    name: "Hannoversch Münden",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2867613,
  },
  {
    name: "Munich",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2867714,
  },
  {
    name: "Müllheim",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2867770,
  },
  {
    name: "Mülheim",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2867838,
  },
  {
    name: "Mühlheim am Main",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2867985,
  },
  {
    name: "Stuttgart Mühlhausen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2867993,
  },
  {
    name: "Mühlhausen",
    country: "Germany",
    subcountry: "Thuringia",
    geonameid: 2867996,
  },
  {
    name: "Mühldorf",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2868506,
  },
  {
    name: "Mühlacker",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2868788,
  },
  {
    name: "Much",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2868936,
  },
  {
    name: "Mössingen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2869019,
  },
  {
    name: "Mosbach",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2869120,
  },
  {
    name: "Moosburg",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2869449,
  },
  {
    name: "Monheim am Rhein",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2869791,
  },
  {
    name: "Mönchengladbach",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2869894,
  },
  {
    name: "Mölln",
    country: "Germany",
    subcountry: "Schleswig-Holstein",
    geonameid: 2869994,
  },
  {
    name: "Moers",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2870221,
  },
  {
    name: "Moabit",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2870310,
  },
  {
    name: "Mittweida",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2870318,
  },
  {
    name: "Minden",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2871039,
  },
  {
    name: "Michelstadt",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2871284,
  },
  {
    name: "Metzingen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2871486,
  },
  {
    name: "Mettmann",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2871535,
  },
  {
    name: "Meschede",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2871668,
  },
  {
    name: "Merzig",
    country: "Germany",
    subcountry: "Saarland",
    geonameid: 2871675,
  },
  {
    name: "Merseburg",
    country: "Germany",
    subcountry: "Saxony-Anhalt",
    geonameid: 2871736,
  },
  {
    name: "Meppen",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2871845,
  },
  {
    name: "Menden",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2871983,
  },
  {
    name: "Memmingen",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2871992,
  },
  {
    name: "Melle",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2872079,
  },
  {
    name: "Meissen",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2872155,
  },
  {
    name: "Meiningen",
    country: "Germany",
    subcountry: "Thuringia",
    geonameid: 2872225,
  },
  {
    name: "Meinerzhagen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2872237,
  },
  {
    name: "Meiderich",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2872347,
  },
  {
    name: "Meerbusch",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2872504,
  },
  {
    name: "Meerane",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2872519,
  },
  {
    name: "Meckenheim",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2872582,
  },
  {
    name: "Mechernich",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2872611,
  },
  {
    name: "Mayen",
    country: "Germany",
    subcountry: "Rheinland-Pfalz",
    geonameid: 2872649,
  },
  {
    name: "Marzahn",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2873074,
  },
  {
    name: "Marsberg",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2873211,
  },
  {
    name: "Marl",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2873263,
  },
  {
    name: "Marktredwitz",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2873289,
  },
  {
    name: "Marktoberdorf",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2873291,
  },
  {
    name: "Markkleeberg",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2873352,
  },
  {
    name: "Märkisches Viertel",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2873356,
  },
  {
    name: "Marienfelde",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2873589,
  },
  {
    name: "Mariendorf",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2873606,
  },
  {
    name: "Marienberg",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2873632,
  },
  {
    name: "Marburg an der Lahn",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2873759,
  },
  {
    name: "Marbach am Neckar",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2873776,
  },
  {
    name: "Mannheim",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2873891,
  },
  {
    name: "Mainz",
    country: "Germany",
    subcountry: "Rheinland-Pfalz",
    geonameid: 2874225,
  },
  {
    name: "Maintal",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2874230,
  },
  {
    name: "Mahlsdorf",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2874455,
  },
  {
    name: "Magdeburg",
    country: "Germany",
    subcountry: "Saxony-Anhalt",
    geonameid: 2874545,
  },
  {
    name: "Lurup",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 2875023,
  },
  {
    name: "Lünen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2875107,
  },
  {
    name: "Lüneburg",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2875115,
  },
  {
    name: "Ludwigshafen am Rhein",
    country: "Germany",
    subcountry: "Rheinland-Pfalz",
    geonameid: 2875376,
  },
  {
    name: "Ludwigsfelde",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2875379,
  },
  {
    name: "Ludwigsburg",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2875392,
  },
  {
    name: "Lüdinghausen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2875417,
  },
  {
    name: "Lüdenscheid",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2875457,
  },
  {
    name: "Luckenwalde",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2875484,
  },
  {
    name: "Lübeck",
    country: "Germany",
    subcountry: "Schleswig-Holstein",
    geonameid: 2875601,
  },
  {
    name: "Lubnjow",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2875623,
  },
  {
    name: "Lübbecke",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2875626,
  },
  {
    name: "Loxstedt",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2875645,
  },
  {
    name: "Losheim",
    country: "Germany",
    subcountry: "Saarland",
    geonameid: 2875831,
  },
  {
    name: "Loschwitz",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2875846,
  },
  {
    name: "Lörrach",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2875881,
  },
  {
    name: "Lohr am Main",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2876147,
  },
  {
    name: "Lohne",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2876185,
  },
  {
    name: "Löhne",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2876187,
  },
  {
    name: "Lohmar",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2876218,
  },
  {
    name: "Löbtau",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2876683,
  },
  {
    name: "Löbau",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2876755,
  },
  {
    name: "Lippstadt",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2876865,
  },
  {
    name: "Lingen",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2877088,
  },
  {
    name: "Lindlar",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2877142,
  },
  {
    name: "Lindau",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2877550,
  },
  {
    name: "Limburg an der Lahn",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2877648,
  },
  {
    name: "Limbach-Oberfrohna",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2877673,
  },
  {
    name: "Lilienthal",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2877709,
  },
  {
    name: "Lichterfelde",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2878018,
  },
  {
    name: "Lichtenrade",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2878044,
  },
  {
    name: "Lichtenfels",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2878074,
  },
  {
    name: "Lichtenberg",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2878102,
  },
  {
    name: "Leverkusen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2878234,
  },
  {
    name: "Leutkirch",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2878270,
  },
  {
    name: "Leuben",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2878396,
  },
  {
    name: "Leopoldshöhe",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2878673,
  },
  {
    name: "Leonberg",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2878695,
  },
  {
    name: "Lennestadt",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2878784,
  },
  {
    name: "Lengerich",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2878840,
  },
  {
    name: "Lemgo",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2878943,
  },
  {
    name: "Leipzig",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2879139,
  },
  {
    name: "Leinfelden-Echterdingen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2879185,
  },
  {
    name: "Leimen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2879241,
  },
  {
    name: "Leichlingen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2879315,
  },
  {
    name: "Lehrte",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2879367,
  },
  {
    name: "Leer",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2879697,
  },
  {
    name: "Lebach",
    country: "Germany",
    subcountry: "Saarland",
    geonameid: 2879832,
  },
  {
    name: "Laupheim",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2880077,
  },
  {
    name: "Lauf an der Pegnitz",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2880144,
  },
  {
    name: "Lauchhammer",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2880221,
  },
  {
    name: "Lankwitz",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2880498,
  },
  {
    name: "Langenhagen",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2881062,
  },
  {
    name: "Langenfeld",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2881085,
  },
  {
    name: "Langen",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2881276,
  },
  {
    name: "Langen",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2881279,
  },
  {
    name: "Landshut",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2881485,
  },
  {
    name: "Landsberg am Lech",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2881509,
  },
  {
    name: "Landau in der Pfalz",
    country: "Germany",
    subcountry: "Rheinland-Pfalz",
    geonameid: 2881646,
  },
  {
    name: "Lampertheim",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2881695,
  },
  {
    name: "Lahr",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2881885,
  },
  {
    name: "Lahnstein",
    country: "Germany",
    subcountry: "Rheinland-Pfalz",
    geonameid: 2881889,
  },
  {
    name: "Lage",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2881956,
  },
  {
    name: "Laatzen",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2882087,
  },
  {
    name: "Bad Laasphe",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2882091,
  },
  {
    name: "Kürten",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2882318,
  },
  {
    name: "Künzelsau",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2882439,
  },
  {
    name: "Künzell",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2882440,
  },
  {
    name: "Kulmbach",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2882588,
  },
  {
    name: "Kronberg",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2883754,
  },
  {
    name: "Kronach",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2883784,
  },
  {
    name: "Kreuztal",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2884050,
  },
  {
    name: "Kreuzberg",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2884161,
  },
  {
    name: "Kreuzau",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2884245,
  },
  {
    name: "Krefeld",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2884509,
  },
  {
    name: "Köthen",
    country: "Germany",
    subcountry: "Saxony-Anhalt",
    geonameid: 2885237,
  },
  {
    name: "Korschenbroich",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2885397,
  },
  {
    name: "Kornwestheim",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2885408,
  },
  {
    name: "Korntal",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2885412,
  },
  {
    name: "Korbach",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2885536,
  },
  {
    name: "Köpenick",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2885656,
  },
  {
    name: "Berlin Köpenick",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2885657,
  },
  {
    name: "Konz",
    country: "Germany",
    subcountry: "Rheinland-Pfalz",
    geonameid: 2885672,
  },
  {
    name: "Konstanz",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2885679,
  },
  {
    name: "Königs Wusterhausen",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2885732,
  },
  {
    name: "Königswinter",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2885734,
  },
  {
    name: "Königstein im Taunus",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2885760,
  },
  {
    name: "Königslutter am Elm",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2885800,
  },
  {
    name: "Königsbrunn",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2885908,
  },
  {
    name: "Köln",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2886242,
  },
  {
    name: "Kolbermoor",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2886446,
  },
  {
    name: "Koblenz",
    country: "Germany",
    subcountry: "Rheinland-Pfalz",
    geonameid: 2886946,
  },
  {
    name: "Klotzsche",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2887366,
  },
  {
    name: "Klingenstein",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2887716,
  },
  {
    name: "Kleve",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2887835,
  },
  {
    name: "Kleinzschocher",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2887933,
  },
  {
    name: "Kleinmachnow",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2888523,
  },
  {
    name: "Kladow",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2890136,
  },
  {
    name: "Kitzingen",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2890158,
  },
  {
    name: "Kirchlengern",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2890425,
  },
  {
    name: "Kirchheim unter Teck",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2890473,
  },
  {
    name: "Kirchhain",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2890504,
  },
  {
    name: "Kierspe",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2891014,
  },
  {
    name: "Kiel",
    country: "Germany",
    subcountry: "Schleswig-Holstein",
    geonameid: 2891122,
  },
  {
    name: "Kevelaer",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2891258,
  },
  {
    name: "Kerpen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2891524,
  },
  {
    name: "Kempten (Allgäu)",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2891621,
  },
  {
    name: "Kempen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2891643,
  },
  {
    name: "Kelkheim",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2891832,
  },
  {
    name: "Kelheim",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2891834,
  },
  {
    name: "Kehl",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2891951,
  },
  {
    name: "Kaulsdorf",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2892051,
  },
  {
    name: "Kaufbeuren",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2892080,
  },
  {
    name: "Kassel",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2892518,
  },
  {
    name: "Karow",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2892705,
  },
  {
    name: "Karlstadt",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2892786,
  },
  {
    name: "Karlsruhe",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2892794,
  },
  {
    name: "Karlshorst",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2892811,
  },
  {
    name: "Karlsfeld",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2892874,
  },
  {
    name: "Karben",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2892980,
  },
  {
    name: "Kamp-Lintfort",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2893264,
  },
  {
    name: "Kamenz",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2893437,
  },
  {
    name: "Kamen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2893438,
  },
  {
    name: "Kaltenkirchen",
    country: "Germany",
    subcountry: "Schleswig-Holstein",
    geonameid: 2893544,
  },
  {
    name: "Kaiserslautern",
    country: "Germany",
    subcountry: "Rheinland-Pfalz",
    geonameid: 2894003,
  },
  {
    name: "Kaarst",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2894375,
  },
  {
    name: "Jülich",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2894553,
  },
  {
    name: "Jüchen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2894637,
  },
  {
    name: "Johannisthal",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2894755,
  },
  {
    name: "Jena",
    country: "Germany",
    subcountry: "Thuringia",
    geonameid: 2895044,
  },
  {
    name: "Itzehoe",
    country: "Germany",
    subcountry: "Schleswig-Holstein",
    geonameid: 2895569,
  },
  {
    name: "Isernhagen Farster Bauerschaft",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2895664,
  },
  {
    name: "Iserlohn",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2895669,
  },
  {
    name: "Ingolstadt",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2895992,
  },
  {
    name: "Ingelheim am Rhein",
    country: "Germany",
    subcountry: "Rheinland-Pfalz",
    geonameid: 2896020,
  },
  {
    name: "Ilmenau",
    country: "Germany",
    subcountry: "Thuringia",
    geonameid: 2896514,
  },
  {
    name: "Illingen",
    country: "Germany",
    subcountry: "Saarland",
    geonameid: 2896538,
  },
  {
    name: "Illertissen",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2896546,
  },
  {
    name: "Idstein",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2896736,
  },
  {
    name: "Idar-Oberstein",
    country: "Germany",
    subcountry: "Rheinland-Pfalz",
    geonameid: 2896753,
  },
  {
    name: "Ibbenbüren",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2896817,
  },
  {
    name: "Husum",
    country: "Germany",
    subcountry: "Schleswig-Holstein",
    geonameid: 2897132,
  },
  {
    name: "Hürth",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2897216,
  },
  {
    name: "Hünfeld",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2897436,
  },
  {
    name: "Hummelsbüttel",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 2897674,
  },
  {
    name: "Humboldtkolonie",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2897732,
  },
  {
    name: "Hude",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2898079,
  },
  {
    name: "Hückeswagen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2898098,
  },
  {
    name: "Hückelhoven",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2898111,
  },
  {
    name: "Hoyerswerda",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2898304,
  },
  {
    name: "Höxter",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2898321,
  },
  {
    name: "Hövelhof",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2898364,
  },
  {
    name: "Hörstel",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2898603,
  },
  {
    name: "Horn",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 2898917,
  },
  {
    name: "Horb am Neckar",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2899101,
  },
  {
    name: "Homburg",
    country: "Germany",
    subcountry: "Saarland",
    geonameid: 2899449,
  },
  {
    name: "Holzwickede",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2899538,
  },
  {
    name: "Holzminden",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2899601,
  },
  {
    name: "Holzkirchen",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2899676,
  },
  {
    name: "Hohenstein-Ernstthal",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2901420,
  },
  {
    name: "Hohen Neuendorf",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2901588,
  },
  {
    name: "Hofheim am Taunus",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2902533,
  },
  {
    name: "Hofgeismar",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2902559,
  },
  {
    name: "Hof",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2902768,
  },
  {
    name: "Hockenheim",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2902852,
  },
  {
    name: "Hochheim am Main",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2903175,
  },
  {
    name: "Hochfeld",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2903237,
  },
  {
    name: "Hille",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2904725,
  },
  {
    name: "Hildesheim",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2904789,
  },
  {
    name: "Hilden",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2904795,
  },
  {
    name: "Hilchenbach",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2904808,
  },
  {
    name: "Hiddenhausen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2904886,
  },
  {
    name: "Heusweiler",
    country: "Germany",
    subcountry: "Saarland",
    geonameid: 2904985,
  },
  {
    name: "Heusenstamm",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2904992,
  },
  {
    name: "Hettstedt",
    country: "Germany",
    subcountry: "Saxony-Anhalt",
    geonameid: 2905206,
  },
  {
    name: "Hessisch Oldendorf",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2905290,
  },
  {
    name: "Herzogenrath",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2905455,
  },
  {
    name: "Herzogenaurach",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2905457,
  },
  {
    name: "Herten",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2905560,
  },
  {
    name: "Herrenberg",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2905826,
  },
  {
    name: "Herne",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2905891,
  },
  {
    name: "Hermsdorf",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2905904,
  },
  {
    name: "Herford",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2906121,
  },
  {
    name: "Herdecke",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2906152,
  },
  {
    name: "Herborn",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2906199,
  },
  {
    name: "Heppenheim an der Bergstrasse",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2906268,
  },
  {
    name: "Hennigsdorf",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2906331,
  },
  {
    name: "Hennef (Sieg)",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2906376,
  },
  {
    name: "Hemmingen",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2906530,
  },
  {
    name: "Hemer",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2906595,
  },
  {
    name: "Helmstedt",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2906676,
  },
  {
    name: "Hellersdorf",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2906809,
  },
  {
    name: "Heinsberg",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2907201,
  },
  {
    name: "Heilbad Heiligenstadt",
    country: "Germany",
    subcountry: "Thuringia",
    geonameid: 2907545,
  },
  {
    name: "Heiligensee",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2907551,
  },
  {
    name: "Heiligenhaus",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2907585,
  },
  {
    name: "Heilbronn",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2907669,
  },
  {
    name: "Heidenheim an der Brenz",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2907851,
  },
  {
    name: "Heidenau",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2907887,
  },
  {
    name: "Heidelberg",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2907911,
  },
  {
    name: "Heide",
    country: "Germany",
    subcountry: "Schleswig-Holstein",
    geonameid: 2908032,
  },
  {
    name: "Hechingen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2908495,
  },
  {
    name: "Hausbruch",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 2908942,
  },
  {
    name: "Hattingen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2909230,
  },
  {
    name: "Hattersheim",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2909240,
  },
  {
    name: "Haßloch",
    country: "Germany",
    subcountry: "Rheinland-Pfalz",
    geonameid: 2909313,
  },
  {
    name: "Haselhorst",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2909794,
  },
  {
    name: "Harvestehude",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 2909972,
  },
  {
    name: "Harsewinkel",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2910278,
  },
  {
    name: "Haren",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2910514,
  },
  {
    name: "Harburg",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 2910685,
  },
  {
    name: "Hannover",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2910831,
  },
  {
    name: "Hanau am Main",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2911007,
  },
  {
    name: "Hamminkeln",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2911051,
  },
  {
    name: "Hamm",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 2911234,
  },
  {
    name: "Hamm",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2911240,
  },
  {
    name: "Hameln",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2911271,
  },
  {
    name: "Wandsbek",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 2911285,
  },
  {
    name: "Marienthal",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 2911287,
  },
  {
    name: "Hamburg-Mitte",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 2911288,
  },
  {
    name: "Eimsbüttel",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 2911293,
  },
  {
    name: "Altona",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 2911296,
  },
  {
    name: "Hamburg",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 2911298,
  },
  {
    name: "Halver",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2911384,
  },
  {
    name: "Haltern am See",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2911395,
  },
  {
    name: "Halstenbek",
    country: "Germany",
    subcountry: "Schleswig-Holstein",
    geonameid: 2911408,
  },
  {
    name: "Halle",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2911520,
  },
  {
    name: "Halle (Saale)",
    country: "Germany",
    subcountry: "Saxony-Anhalt",
    geonameid: 2911522,
  },
  {
    name: "Haldensleben I",
    country: "Germany",
    subcountry: "Saxony-Anhalt",
    geonameid: 2911584,
  },
  {
    name: "Halberstadt",
    country: "Germany",
    subcountry: "Saxony-Anhalt",
    geonameid: 2911665,
  },
  {
    name: "Hakenfelde",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2911710,
  },
  {
    name: "Haiger",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2911964,
  },
  {
    name: "Hagen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2912621,
  },
  {
    name: "Haar",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2913192,
  },
  {
    name: "Haan",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2913195,
  },
  {
    name: "Gütersloh",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2913366,
  },
  {
    name: "Güstrow",
    country: "Germany",
    subcountry: "Mecklenburg-Vorpommern",
    geonameid: 2913433,
  },
  {
    name: "Gunzenhausen",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2913537,
  },
  {
    name: "Günzburg",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2913555,
  },
  {
    name: "Gummersbach",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2913761,
  },
  {
    name: "Guben",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2913922,
  },
  {
    name: "Großzschocher",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2914796,
  },
  {
    name: "Groß-Umstadt",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2914929,
  },
  {
    name: "Großostheim",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2915196,
  },
  {
    name: "Groß-Gerau",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2915613,
  },
  {
    name: "Großenhain",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2916630,
  },
  {
    name: "Gronau",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2917138,
  },
  {
    name: "Gröbenzell",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2917221,
  },
  {
    name: "Grimma",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2917325,
  },
  {
    name: "Griesheim",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2917412,
  },
  {
    name: "Grevenbroich",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2917540,
  },
  {
    name: "Greven",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2917544,
  },
  {
    name: "Greiz",
    country: "Germany",
    subcountry: "Thuringia",
    geonameid: 2917737,
  },
  {
    name: "Greifswald",
    country: "Germany",
    subcountry: "Mecklenburg-Vorpommern",
    geonameid: 2917788,
  },
  {
    name: "Grefrath",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2917816,
  },
  {
    name: "Göttingen",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2918632,
  },
  {
    name: "Gotha",
    country: "Germany",
    subcountry: "Thuringia",
    geonameid: 2918752,
  },
  {
    name: "Goslar",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2918840,
  },
  {
    name: "Görlitz",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2918987,
  },
  {
    name: "Gorbitz",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2919039,
  },
  {
    name: "Göppingen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2919054,
  },
  {
    name: "Gohlis",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2919502,
  },
  {
    name: "Goch",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2919625,
  },
  {
    name: "Glinde",
    country: "Germany",
    subcountry: "Schleswig-Holstein",
    geonameid: 2919880,
  },
  {
    name: "Glauchau",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2920020,
  },
  {
    name: "Gladbeck",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2920236,
  },
  {
    name: "Ginsheim-Gustavsburg",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2920329,
  },
  {
    name: "Gilching",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2920433,
  },
  {
    name: "Gifhorn",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2920478,
  },
  {
    name: "Gießen",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2920512,
  },
  {
    name: "Giengen an der Brenz",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2920620,
  },
  {
    name: "Gevelsberg",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2920757,
  },
  {
    name: "Gesundbrunnen",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2920789,
  },
  {
    name: "Geseke",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2920834,
  },
  {
    name: "Gescher",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2920842,
  },
  {
    name: "Gersthofen",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2920891,
  },
  {
    name: "Germersheim",
    country: "Germany",
    subcountry: "Rheinland-Pfalz",
    geonameid: 2921034,
  },
  {
    name: "Germering",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2921039,
  },
  {
    name: "Gerlingen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2921061,
  },
  {
    name: "Geretsried",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2921139,
  },
  {
    name: "Gera",
    country: "Germany",
    subcountry: "Thuringia",
    geonameid: 2921232,
  },
  {
    name: "Georgsmarienhütte",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2921242,
  },
  {
    name: "Gelsenkirchen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2921466,
  },
  {
    name: "Gelnhausen",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2921473,
  },
  {
    name: "Geldern",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2921528,
  },
  {
    name: "Geislingen an der Steige",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2921653,
  },
  {
    name: "Geilenkirchen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2921837,
  },
  {
    name: "Geesthacht",
    country: "Germany",
    subcountry: "Schleswig-Holstein",
    geonameid: 2922102,
  },
  {
    name: "Gauting",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2922230,
  },
  {
    name: "Garmisch-Partenkirchen",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2922530,
  },
  {
    name: "Garching",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2922582,
  },
  {
    name: "Garbsen",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2922586,
  },
  {
    name: "Ganderkesee",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2922731,
  },
  {
    name: "Gaggenau",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2923362,
  },
  {
    name: "Füssen",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2923507,
  },
  {
    name: "Fürth",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2923544,
  },
  {
    name: "Fürstenwalde",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2923588,
  },
  {
    name: "Fürstenfeldbruck",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2923625,
  },
  {
    name: "Fulda",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2923822,
  },
  {
    name: "Fröndenberg",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2924206,
  },
  {
    name: "Frohnau",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2924302,
  },
  {
    name: "Friesoythe",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2924360,
  },
  {
    name: "Friedrichshain",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2924573,
  },
  {
    name: "Friedrichshagen",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2924577,
  },
  {
    name: "Friedrichshafen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2924585,
  },
  {
    name: "Friedrichsfelde",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2924599,
  },
  {
    name: "Friedrichsdorf",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2924625,
  },
  {
    name: "Friedenau",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2924770,
  },
  {
    name: "Friedberg",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2924802,
  },
  {
    name: "Friedberg",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2924803,
  },
  {
    name: "Freudenstadt",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2924894,
  },
  {
    name: "Freudenberg",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2924915,
  },
  {
    name: "Freital",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2925017,
  },
  {
    name: "Freising",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2925034,
  },
  {
    name: "Freilassing",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2925080,
  },
  {
    name: "Freiburg",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2925177,
  },
  {
    name: "Freiberg am Neckar",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2925189,
  },
  {
    name: "Freiberg",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2925192,
  },
  {
    name: "Frechen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2925259,
  },
  {
    name: "Frankfurt am Main",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2925533,
  },
  {
    name: "Frankfurt (Oder)",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2925535,
  },
  {
    name: "Frankenthal",
    country: "Germany",
    subcountry: "Rheinland-Pfalz",
    geonameid: 2925550,
  },
  {
    name: "Frankenberg",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2925629,
  },
  {
    name: "Frankenberg",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2925630,
  },
  {
    name: "Forst",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2925832,
  },
  {
    name: "Forchheim",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2925910,
  },
  {
    name: "Flörsheim",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2926120,
  },
  {
    name: "Flensburg",
    country: "Germany",
    subcountry: "Schleswig-Holstein",
    geonameid: 2926271,
  },
  {
    name: "Fischeln",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2926565,
  },
  {
    name: "Finsterwalde",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2926670,
  },
  {
    name: "Stuttgart Feuerbach",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2927043,
  },
  {
    name: "Fellbach",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2927268,
  },
  {
    name: "Falkensee",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2927930,
  },
  {
    name: "Eving",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2928313,
  },
  {
    name: "Eutin",
    country: "Germany",
    subcountry: "Schleswig-Holstein",
    geonameid: 2928381,
  },
  {
    name: "Euskirchen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2928396,
  },
  {
    name: "Ettlingen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2928615,
  },
  {
    name: "Esslingen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2928751,
  },
  {
    name: "Essen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2928810,
  },
  {
    name: "Espelkamp",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2928874,
  },
  {
    name: "Eschweiler",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2928963,
  },
  {
    name: "Eschwege",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2928967,
  },
  {
    name: "Eschborn",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2929134,
  },
  {
    name: "Erwitte",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2929247,
  },
  {
    name: "Erlangen",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2929567,
  },
  {
    name: "Erkrath",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2929600,
  },
  {
    name: "Erkelenz",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2929622,
  },
  {
    name: "Erfurt",
    country: "Germany",
    subcountry: "Thuringia",
    geonameid: 2929670,
  },
  {
    name: "Erftstadt",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2929671,
  },
  {
    name: "Erding",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2929715,
  },
  {
    name: "Eppingen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2929831,
  },
  {
    name: "Eppendorf",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 2929853,
  },
  {
    name: "Eppelborn",
    country: "Germany",
    subcountry: "Saarland",
    geonameid: 2929865,
  },
  {
    name: "Ennigerloh",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2930030,
  },
  {
    name: "Ennepetal",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2930043,
  },
  {
    name: "Enger",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2930182,
  },
  {
    name: "Engelskirchen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2930216,
  },
  {
    name: "Emsdetten",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2930449,
  },
  {
    name: "Emmerich",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2930509,
  },
  {
    name: "Emmendingen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2930523,
  },
  {
    name: "Emden",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2930596,
  },
  {
    name: "Eltville",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2930646,
  },
  {
    name: "Elsdorf",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2930778,
  },
  {
    name: "Elmshorn",
    country: "Germany",
    subcountry: "Schleswig-Holstein",
    geonameid: 2930821,
  },
  {
    name: "Ellwangen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2930889,
  },
  {
    name: "Eitorf",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2931361,
  },
  {
    name: "Eißendorf",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 2931396,
  },
  {
    name: "Eislingen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2931414,
  },
  {
    name: "Eisenhüttenstadt",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2931481,
  },
  {
    name: "Eisenach",
    country: "Germany",
    subcountry: "Thuringia",
    geonameid: 2931574,
  },
  {
    name: "Einbeck",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2931804,
  },
  {
    name: "Eilenburg",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2931871,
  },
  {
    name: "Eilbek",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 2931877,
  },
  {
    name: "Ehingen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2932924,
  },
  {
    name: "Eggenstein-Leopoldshafen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2933101,
  },
  {
    name: "Edewecht",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2933364,
  },
  {
    name: "Eckernförde",
    country: "Germany",
    subcountry: "Schleswig-Holstein",
    geonameid: 2933627,
  },
  {
    name: "Eberswalde",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2933882,
  },
  {
    name: "Ebersbach an der Fils",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2933959,
  },
  {
    name: "Eberbach",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2934020,
  },
  {
    name: "Düsseldorf",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2934246,
  },
  {
    name: "Düren",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2934486,
  },
  {
    name: "Dülmen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2934662,
  },
  {
    name: "Duisburg",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2934691,
  },
  {
    name: "Duderstadt",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2934728,
  },
  {
    name: "Dresden",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2935022,
  },
  {
    name: "Drensteinfurt",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2935042,
  },
  {
    name: "Dreieich",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2935220,
  },
  {
    name: "Dotzheim",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2935414,
  },
  {
    name: "Dortmund",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2935517,
  },
  {
    name: "Dorsten",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2935530,
  },
  {
    name: "Dormagen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2935825,
  },
  {
    name: "Donauwörth",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2936253,
  },
  {
    name: "Donaueschingen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2936267,
  },
  {
    name: "Döbeln",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2936658,
  },
  {
    name: "Ditzingen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2936705,
  },
  {
    name: "Dinslaken",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2936871,
  },
  {
    name: "Dingolfing",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2936909,
  },
  {
    name: "Dillingen an der Donau",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2936974,
  },
  {
    name: "Dillingen",
    country: "Germany",
    subcountry: "Saarland",
    geonameid: 2936977,
  },
  {
    name: "Dillenburg",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2936985,
  },
  {
    name: "Dietzenbach",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2937040,
  },
  {
    name: "Diepholz",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2937317,
  },
  {
    name: "Dieburg",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2937591,
  },
  {
    name: "Deutz",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2937790,
  },
  {
    name: "Detmold",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2937936,
  },
  {
    name: "Dessau",
    country: "Germany",
    subcountry: "Saxony-Anhalt",
    geonameid: 2937959,
  },
  {
    name: "Delmenhorst",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2938323,
  },
  {
    name: "Delitzsch",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2938376,
  },
  {
    name: "Delbrück",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2938389,
  },
  {
    name: "Deggendorf",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2938540,
  },
  {
    name: "Datteln",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2938784,
  },
  {
    name: "Darmstadt",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2938913,
  },
  {
    name: "Damme",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2939167,
  },
  {
    name: "Dahlem",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2939440,
  },
  {
    name: "Dachau",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2939623,
  },
  {
    name: "Cuxhaven",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2939658,
  },
  {
    name: "Crimmitschau",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2939747,
  },
  {
    name: "Crailsheim",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2939797,
  },
  {
    name: "Cottbus",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2939811,
  },
  {
    name: "Coswig",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2939820,
  },
  {
    name: "Coesfeld",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2939945,
  },
  {
    name: "Coburg",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2939951,
  },
  {
    name: "Cloppenburg",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2939969,
  },
  {
    name: "Clausthal-Zellerfeld",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2939995,
  },
  {
    name: "Chemnitz",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2940132,
  },
  {
    name: "Charlottenburg",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2940187,
  },
  {
    name: "Cham",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2940204,
  },
  {
    name: "Celle",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2940213,
  },
  {
    name: "Castrop-Rauxel",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2940231,
  },
  {
    name: "Calw",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2940383,
  },
  {
    name: "Buxtehude",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2940451,
  },
  {
    name: "Butzbach",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2940512,
  },
  {
    name: "Bürstadt",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2940938,
  },
  {
    name: "Burscheid",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2940942,
  },
  {
    name: "Burghausen",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2941279,
  },
  {
    name: "Burgdorf",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2941405,
  },
  {
    name: "Burg bei Magdeburg",
    country: "Germany",
    subcountry: "Saxony-Anhalt",
    geonameid: 2941501,
  },
  {
    name: "Büren",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2941570,
  },
  {
    name: "Bünde",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2941694,
  },
  {
    name: "Bühl",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2941976,
  },
  {
    name: "Büdingen",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2942073,
  },
  {
    name: "Buckow",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2942122,
  },
  {
    name: "Bückeburg",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2942159,
  },
  {
    name: "Buchholz in der Nordheide",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2942323,
  },
  {
    name: "Französisch Buchholz",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2942341,
  },
  {
    name: "Buchen in Odenwald",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2942634,
  },
  {
    name: "Brühl",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2943320,
  },
  {
    name: "Brüggen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2943336,
  },
  {
    name: "Bruckmühl",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2943408,
  },
  {
    name: "Bruchsal",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2943560,
  },
  {
    name: "Bruchköbel",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2943573,
  },
  {
    name: "Britz",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2944027,
  },
  {
    name: "Brilon",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2944079,
  },
  {
    name: "Bretten",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2944200,
  },
  {
    name: "Bremervörde",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2944354,
  },
  {
    name: "Bremerhaven",
    country: "Germany",
    subcountry: "Bremen",
    geonameid: 2944368,
  },
  {
    name: "Bremen",
    country: "Germany",
    subcountry: "Bremen",
    geonameid: 2944388,
  },
  {
    name: "Braunschweig",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2945024,
  },
  {
    name: "Brandenburg an der Havel",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2945358,
  },
  {
    name: "Bramsche",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2945474,
  },
  {
    name: "Brakel",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2945542,
  },
  {
    name: "Brake (Unterweser)",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2945545,
  },
  {
    name: "Brackenheim",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2945591,
  },
  {
    name: "Bottrop",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2945756,
  },
  {
    name: "Bornheim",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2946111,
  },
  {
    name: "Borna",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2946172,
  },
  {
    name: "Borken",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2946228,
  },
  {
    name: "Boppard",
    country: "Germany",
    subcountry: "Rheinland-Pfalz",
    geonameid: 2946366,
  },
  {
    name: "Bonn",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2946447,
  },
  {
    name: "Bönen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2946478,
  },
  {
    name: "Bogenhausen",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2947022,
  },
  {
    name: "Bockum",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2947214,
  },
  {
    name: "Bochum",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2947416,
  },
  {
    name: "Bocholt",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2947421,
  },
  {
    name: "Böblingen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2947444,
  },
  {
    name: "Bobingen",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2947449,
  },
  {
    name: "Blomberg",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2947641,
  },
  {
    name: "Blieskastel",
    country: "Germany",
    subcountry: "Saarland",
    geonameid: 2947739,
  },
  {
    name: "Blasewitz",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2948000,
  },
  {
    name: "Blankenburg",
    country: "Germany",
    subcountry: "Saxony-Anhalt",
    geonameid: 2948071,
  },
  {
    name: "Bitterfeld-Wolfen",
    country: "Germany",
    subcountry: "Saxony-Anhalt",
    geonameid: 2948164,
  },
  {
    name: "Bingen am Rhein",
    country: "Germany",
    subcountry: "Rheinland-Pfalz",
    geonameid: 2948825,
  },
  {
    name: "Billstedt",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 2948917,
  },
  {
    name: "Bietigheim-Bissingen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2949012,
  },
  {
    name: "Biesdorf",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2949073,
  },
  {
    name: "Bielefeld",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2949186,
  },
  {
    name: "Biebrich",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2949235,
  },
  {
    name: "Biberach an der Riß",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2949423,
  },
  {
    name: "Bexbach",
    country: "Germany",
    subcountry: "Saarland",
    geonameid: 2949470,
  },
  {
    name: "Beverungen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2949475,
  },
  {
    name: "Bernburg",
    country: "Germany",
    subcountry: "Saxony-Anhalt",
    geonameid: 2950073,
  },
  {
    name: "Bernau bei Berlin",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2950096,
  },
  {
    name: "Berlin",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2950159,
  },
  {
    name: "Bergneustadt",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2950294,
  },
  {
    name: "Bergkamen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2950344,
  },
  {
    name: "Bergisch Gladbach",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2950349,
  },
  {
    name: "Bergheim",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2950438,
  },
  {
    name: "Bensheim",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2950978,
  },
  {
    name: "Bendorf",
    country: "Germany",
    subcountry: "Rheinland-Pfalz",
    geonameid: 2951111,
  },
  {
    name: "Bedburg",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2951648,
  },
  {
    name: "Beckum",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2951654,
  },
  {
    name: "Beckingen",
    country: "Germany",
    subcountry: "Saarland",
    geonameid: 2951679,
  },
  {
    name: "Bayreuth",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2951825,
  },
  {
    name: "Bautzen",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2951881,
  },
  {
    name: "Baunatal",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2951923,
  },
  {
    name: "Baumschulenweg",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2951935,
  },
  {
    name: "Bassum",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2952252,
  },
  {
    name: "Bamberg",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2952984,
  },
  {
    name: "Balingen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2953089,
  },
  {
    name: "Baiersbronn",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2953197,
  },
  {
    name: "Baesweiler",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2953302,
  },
  {
    name: "Bad Zwischenahn",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2953310,
  },
  {
    name: "Bad Wildungen",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2953317,
  },
  {
    name: "Bad Waldsee",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2953320,
  },
  {
    name: "Bad Vilbel",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2953321,
  },
  {
    name: "Bad Tölz",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2953324,
  },
  {
    name: "Bad Soden am Taunus",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2953339,
  },
  {
    name: "Bad Segeberg",
    country: "Germany",
    subcountry: "Schleswig-Holstein",
    geonameid: 2953341,
  },
  {
    name: "Bad Schwartau",
    country: "Germany",
    subcountry: "Schleswig-Holstein",
    geonameid: 2953347,
  },
  {
    name: "Bad Salzungen",
    country: "Germany",
    subcountry: "Thuringia",
    geonameid: 2953357,
  },
  {
    name: "Bad Salzuflen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2953358,
  },
  {
    name: "Bad Säckingen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2953363,
  },
  {
    name: "Bad Reichenhall",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2953371,
  },
  {
    name: "Bad Rappenau",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2953374,
  },
  {
    name: "Bad Pyrmont",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2953379,
  },
  {
    name: "Bad Oldesloe",
    country: "Germany",
    subcountry: "Schleswig-Holstein",
    geonameid: 2953385,
  },
  {
    name: "Bad Oeynhausen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2953386,
  },
  {
    name: "Bad Neustadt an der Saale",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2953389,
  },
  {
    name: "Bad Neuenahr-Ahrweiler",
    country: "Germany",
    subcountry: "Rheinland-Pfalz",
    geonameid: 2953391,
  },
  {
    name: "Bad Nauheim",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2953395,
  },
  {
    name: "Bad Münstereifel",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2953398,
  },
  {
    name: "Bad Münder am Deister",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2953400,
  },
  {
    name: "Bad Mergentheim",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2953402,
  },
  {
    name: "Bad Lippspringe",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2953405,
  },
  {
    name: "Bad Langensalza",
    country: "Germany",
    subcountry: "Thuringia",
    geonameid: 2953413,
  },
  {
    name: "Bad Kreuznach",
    country: "Germany",
    subcountry: "Rheinland-Pfalz",
    geonameid: 2953416,
  },
  {
    name: "Bad Kissingen",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2953424,
  },
  {
    name: "Bad Honnef",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2953435,
  },
  {
    name: "Bad Homburg vor der Höhe",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2953436,
  },
  {
    name: "Bad Hersfeld",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2953439,
  },
  {
    name: "Bad Harzburg",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2953449,
  },
  {
    name: "Bad Essen",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2953464,
  },
  {
    name: "Baden-Baden",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2953504,
  },
  {
    name: "Bad Dürkheim",
    country: "Germany",
    subcountry: "Rheinland-Pfalz",
    geonameid: 2953522,
  },
  {
    name: "Bad Driburg",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2953525,
  },
  {
    name: "Bad Berleburg",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2953545,
  },
  {
    name: "Bad Bentheim",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2953552,
  },
  {
    name: "Bad Aibling",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2953558,
  },
  {
    name: "Backnang",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2953568,
  },
  {
    name: "Babenhausen",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2953770,
  },
  {
    name: "Aurich",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2954006,
  },
  {
    name: "Augsburg",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2954172,
  },
  {
    name: "Auerbach",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2954602,
  },
  {
    name: "Aue",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2954695,
  },
  {
    name: "Attendorn",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2954932,
  },
  {
    name: "Aschersleben",
    country: "Germany",
    subcountry: "Saxony-Anhalt",
    geonameid: 2955168,
  },
  {
    name: "Ascheberg",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2955224,
  },
  {
    name: "Aschaffenburg",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2955272,
  },
  {
    name: "Bad Arolsen",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2955421,
  },
  {
    name: "Arnstadt",
    country: "Germany",
    subcountry: "Thuringia",
    geonameid: 2955439,
  },
  {
    name: "Arnsberg",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2955471,
  },
  {
    name: "Apolda",
    country: "Germany",
    subcountry: "Thuringia",
    geonameid: 2955770,
  },
  {
    name: "Aplerbeck",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2955773,
  },
  {
    name: "Ansbach",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2955936,
  },
  {
    name: "Annaberg-Buchholz",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 2956005,
  },
  {
    name: "Angermünde",
    country: "Germany",
    subcountry: "Brandenburg",
    geonameid: 2956093,
  },
  {
    name: "Andernach",
    country: "Germany",
    subcountry: "Rheinland-Pfalz",
    geonameid: 2956206,
  },
  {
    name: "Amberg",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2956656,
  },
  {
    name: "Alzey",
    country: "Germany",
    subcountry: "Rheinland-Pfalz",
    geonameid: 2956710,
  },
  {
    name: "Alzenau in Unterfranken",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2956715,
  },
  {
    name: "Altglienicke",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2957185,
  },
  {
    name: "Altenburg",
    country: "Germany",
    subcountry: "Thuringia",
    geonameid: 2957773,
  },
  {
    name: "Altena",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2957886,
  },
  {
    name: "Altdorf bei Nurnberg",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2958024,
  },
  {
    name: "Alsterdorf",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 2958105,
  },
  {
    name: "Alsfeld",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 2958128,
  },
  {
    name: "Alsdorf",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2958141,
  },
  {
    name: "Alfter",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2958516,
  },
  {
    name: "Alfeld",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2958533,
  },
  {
    name: "Albstadt",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2958595,
  },
  {
    name: "Aichach",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 2958975,
  },
  {
    name: "Ahrensburg",
    country: "Germany",
    subcountry: "Schleswig-Holstein",
    geonameid: 2959083,
  },
  {
    name: "Ahlen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2959223,
  },
  {
    name: "Ahaus",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 2959279,
  },
  {
    name: "Adlershof",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 2959441,
  },
  {
    name: "Achim",
    country: "Germany",
    subcountry: "Lower Saxony",
    geonameid: 2959681,
  },
  {
    name: "Achern",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2959686,
  },
  {
    name: "Aalen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 2959927,
  },
  {
    name: "Vellmar",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 3207197,
  },
  {
    name: "Aachen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 3247449,
  },
  {
    name: "Mörfelden-Walldorf",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 3272460,
  },
  {
    name: "Riedstadt",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 3272941,
  },
  {
    name: "Lauda-Königshofen",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 3274966,
  },
  {
    name: "Filderstadt",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 3336891,
  },
  {
    name: "Ostfildern",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 3336892,
  },
  {
    name: "Rodgau",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 3336893,
  },
  {
    name: "Gropiusstadt",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 3337408,
  },
  {
    name: "Seeheim-Jugenheim",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 3337504,
  },
  {
    name: "Charlottenburg-Nord",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 6545288,
  },
  {
    name: "Mitte",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 6545310,
  },
  {
    name: "Rheinstetten",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 6558039,
  },
  {
    name: "Altstadt Sud",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 6691072,
  },
  {
    name: "Altstadt Nord",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 6691073,
  },
  {
    name: "Neuehrenfeld",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 6691076,
  },
  {
    name: "Bilderstöckchen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 6691078,
  },
  {
    name: "Stuttgart-Ost",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 6930414,
  },
  {
    name: "Bochum-Hordel",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 6941055,
  },
  {
    name: "St. Pauli",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 6944296,
  },
  {
    name: "Gallus",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 7118093,
  },
  {
    name: "Eidelstedt",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 7274677,
  },
  {
    name: "Eisleben Lutherstadt",
    country: "Germany",
    subcountry: "Saxony-Anhalt",
    geonameid: 7284571,
  },
  {
    name: "Halle Neustadt",
    country: "Germany",
    subcountry: "Saxony-Anhalt",
    geonameid: 7289614,
  },
  {
    name: "Bergedorf",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 7290243,
  },
  {
    name: "Spandau",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 7290252,
  },
  {
    name: "Berlin Treptow",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 7290255,
  },
  {
    name: "Niederrad",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 7290401,
  },
  {
    name: "Haselbachtal",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 7302786,
  },
  {
    name: "Wittenberg",
    country: "Germany",
    subcountry: "Saxony-Anhalt",
    geonameid: 7303020,
  },
  {
    name: "Äußere Neustadt",
    country: "Germany",
    subcountry: "Saxony",
    geonameid: 7627288,
  },
  {
    name: "Barmbek-Nord",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 7932342,
  },
  {
    name: "Barmbek-Süd",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 7932343,
  },
  {
    name: "Farmsen-Berne",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 7932386,
  },
  {
    name: "Falkenhagener Feld",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 8334621,
  },
  {
    name: "Neu-Hohenschönhausen",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 8334622,
  },
  {
    name: "Alt-Hohenschönhausen",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 8334624,
  },
  {
    name: "Fennpfuhl",
    country: "Germany",
    subcountry: "Berlin",
    geonameid: 8334625,
  },
  {
    name: "Hamburg-Nord",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 8354626,
  },
  {
    name: "Burg Unter-Falkenstein",
    country: "Germany",
    subcountry: "Bavaria",
    geonameid: 8378906,
  },
  {
    name: "Neustadt/Nord",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 8593855,
  },
  {
    name: "Neustadt/Süd",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 8593856,
  },
  {
    name: "Kalk",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 8593861,
  },
  {
    name: "Rodenkirchen",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 8593863,
  },
  {
    name: "Mülheim",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 8593865,
  },
  {
    name: "Gartenstadt",
    country: "Germany",
    subcountry: "Rheinland-Pfalz",
    geonameid: 8642860,
  },
  {
    name: "Kröpeliner-Tor-Vorstadt",
    country: "Germany",
    subcountry: "Mecklenburg-Vorpommern",
    geonameid: 9238414,
  },
  {
    name: "Düsseldorf-Pempelfort",
    country: "Germany",
    subcountry: "North Rhine-Westphalia",
    geonameid: 11258605,
  },
  {
    name: "Burglesum",
    country: "Germany",
    subcountry: "Bremen",
    geonameid: 11594317,
  },
  {
    name: "Altona-Altstadt",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 11669492,
  },
  {
    name: "Altona-Nord",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 11669493,
  },
  {
    name: "Dulsberg",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 11669496,
  },
  {
    name: "Hoheluft-Ost",
    country: "Germany",
    subcountry: "Hamburg",
    geonameid: 11669497,
  },
  {
    name: "Sachsenheim",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 11951298,
  },
  {
    name: "Petershausen-West",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 11952858,
  },
  {
    name: "Kronberg Tal",
    country: "Germany",
    subcountry: "Hesse",
    geonameid: 12035575,
  },
  {
    name: "Remseck am Neckar",
    country: "Germany",
    subcountry: "Baden-Wurttemberg",
    geonameid: 12188617,
  },
  {
    name: "Altstadt",
    country: "Germany",
    subcountry: "Rheinland-Pfalz",
    geonameid: 12492033,
  },
  {
    name: "Tadjourah",
    country: "Djibouti",
    subcountry: "Tadjourah",
    geonameid: 220782,
  },
  {
    name: "Obock",
    country: "Djibouti",
    subcountry: "Obock",
    geonameid: 221527,
  },
  {
    name: "Djibouti",
    country: "Djibouti",
    subcountry: "Djibouti",
    geonameid: 223817,
  },
  {
    name: "'Ali Sabieh",
    country: "Djibouti",
    subcountry: "Ali Sabieh",
    geonameid: 225284,
  },
  {
    name: "Vordingborg",
    country: "Denmark",
    subcountry: "Zealand",
    geonameid: 2610020,
  },
  {
    name: "Viborg",
    country: "Denmark",
    subcountry: "Central Jutland",
    geonameid: 2610319,
  },
  {
    name: "Vejle",
    country: "Denmark",
    subcountry: "South Denmark",
    geonameid: 2610613,
  },
  {
    name: "Vanløse",
    country: "Denmark",
    subcountry: "Capital Region",
    geonameid: 2610734,
  },
  {
    name: "Vallensbæk",
    country: "Denmark",
    subcountry: "Capital Region",
    geonameid: 2610789,
  },
  {
    name: "Valby",
    country: "Denmark",
    subcountry: "Capital Region",
    geonameid: 2610802,
  },
  {
    name: "Tønder",
    country: "Denmark",
    subcountry: "South Denmark",
    geonameid: 2611497,
  },
  {
    name: "Taastrup",
    country: "Denmark",
    subcountry: "Capital Region",
    geonameid: 2611828,
  },
  {
    name: "Svendborg",
    country: "Denmark",
    subcountry: "South Denmark",
    geonameid: 2612045,
  },
  {
    name: "Stenløse",
    country: "Denmark",
    subcountry: "Capital Region",
    geonameid: 2612629,
  },
  {
    name: "Sønderborg",
    country: "Denmark",
    subcountry: "South Denmark",
    geonameid: 2613102,
  },
  {
    name: "Solrød Strand",
    country: "Denmark",
    subcountry: "Zealand",
    geonameid: 2613233,
  },
  {
    name: "Slagelse",
    country: "Denmark",
    subcountry: "Zealand",
    geonameid: 2613460,
  },
  {
    name: "Skive",
    country: "Denmark",
    subcountry: "Central Jutland",
    geonameid: 2613731,
  },
  {
    name: "Silkeborg",
    country: "Denmark",
    subcountry: "Central Jutland",
    geonameid: 2614030,
  },
  {
    name: "Roskilde",
    country: "Denmark",
    subcountry: "Zealand",
    geonameid: 2614481,
  },
  {
    name: "Rødovre",
    country: "Denmark",
    subcountry: "Capital Region",
    geonameid: 2614600,
  },
  {
    name: "Ringsted",
    country: "Denmark",
    subcountry: "Zealand",
    geonameid: 2614764,
  },
  {
    name: "Randers",
    country: "Denmark",
    subcountry: "Central Jutland",
    geonameid: 2615006,
  },
  {
    name: "Odense",
    country: "Denmark",
    subcountry: "South Denmark",
    geonameid: 2615876,
  },
  {
    name: "Nykøbing Falster",
    country: "Denmark",
    subcountry: "Zealand",
    geonameid: 2615961,
  },
  {
    name: "Nyborg",
    country: "Denmark",
    subcountry: "South Denmark",
    geonameid: 2616015,
  },
  {
    name: "Næstved",
    country: "Denmark",
    subcountry: "Zealand",
    geonameid: 2616038,
  },
  {
    name: "Nørresundby",
    country: "Denmark",
    subcountry: "North Denmark",
    geonameid: 2616235,
  },
  {
    name: "Middelfart",
    country: "Denmark",
    subcountry: "South Denmark",
    geonameid: 2616933,
  },
  {
    name: "Lillerød",
    country: "Denmark",
    subcountry: "Capital Region",
    geonameid: 2617658,
  },
  {
    name: "Køge",
    country: "Denmark",
    subcountry: "Zealand",
    geonameid: 2618415,
  },
  {
    name: "Copenhagen",
    country: "Denmark",
    subcountry: "Capital Region",
    geonameid: 2618425,
  },
  {
    name: "Kolding",
    country: "Denmark",
    subcountry: "South Denmark",
    geonameid: 2618528,
  },
  {
    name: "Kalundborg",
    country: "Denmark",
    subcountry: "Zealand",
    geonameid: 2619154,
  },
  {
    name: "Ishøj",
    country: "Denmark",
    subcountry: "Capital Region",
    geonameid: 2619377,
  },
  {
    name: "Hvidovre",
    country: "Denmark",
    subcountry: "Capital Region",
    geonameid: 2619528,
  },
  {
    name: "Horsens",
    country: "Denmark",
    subcountry: "Central Jutland",
    geonameid: 2619771,
  },
  {
    name: "Hørsholm",
    country: "Denmark",
    subcountry: "Capital Region",
    geonameid: 2619856,
  },
  {
    name: "Holstebro",
    country: "Denmark",
    subcountry: "Central Jutland",
    geonameid: 2620046,
  },
  {
    name: "Holbæk",
    country: "Denmark",
    subcountry: "Zealand",
    geonameid: 2620147,
  },
  {
    name: "Hjørring",
    country: "Denmark",
    subcountry: "North Denmark",
    geonameid: 2620214,
  },
  {
    name: "Hillerød",
    country: "Denmark",
    subcountry: "Capital Region",
    geonameid: 2620320,
  },
  {
    name: "Herning",
    country: "Denmark",
    subcountry: "Central Jutland",
    geonameid: 2620425,
  },
  {
    name: "Helsingør",
    country: "Denmark",
    subcountry: "Capital Region",
    geonameid: 2620473,
  },
  {
    name: "Hedensted",
    country: "Denmark",
    subcountry: "Central Jutland",
    geonameid: 2620583,
  },
  {
    name: "Haderslev",
    country: "Denmark",
    subcountry: "South Denmark",
    geonameid: 2620964,
  },
  {
    name: "Greve",
    country: "Denmark",
    subcountry: "Zealand",
    geonameid: 2621215,
  },
  {
    name: "Glostrup",
    country: "Denmark",
    subcountry: "Capital Region",
    geonameid: 2621356,
  },
  {
    name: "Frederikssund",
    country: "Denmark",
    subcountry: "Capital Region",
    geonameid: 2621912,
  },
  {
    name: "Frederikshavn",
    country: "Denmark",
    subcountry: "North Denmark",
    geonameid: 2621927,
  },
  {
    name: "Frederiksberg",
    country: "Denmark",
    subcountry: "Capital Region",
    geonameid: 2621942,
  },
  {
    name: "Fredericia",
    country: "Denmark",
    subcountry: "South Denmark",
    geonameid: 2621951,
  },
  {
    name: "Farum",
    country: "Denmark",
    subcountry: "Capital Region",
    geonameid: 2622306,
  },
  {
    name: "Esbjerg",
    country: "Denmark",
    subcountry: "South Denmark",
    geonameid: 2622447,
  },
  {
    name: "Charlottenlund",
    country: "Denmark",
    subcountry: "Capital Region",
    geonameid: 2623188,
  },
  {
    name: "Brøndbyvester",
    country: "Denmark",
    subcountry: "Capital Region",
    geonameid: 2623340,
  },
  {
    name: "Birkerød",
    country: "Denmark",
    subcountry: "Capital Region",
    geonameid: 2624112,
  },
  {
    name: "Ballerup",
    country: "Denmark",
    subcountry: "Capital Region",
    geonameid: 2624341,
  },
  {
    name: "Århus",
    country: "Denmark",
    subcountry: "Central Jutland",
    geonameid: 2624652,
  },
  {
    name: "Allerød",
    country: "Denmark",
    subcountry: "Capital Region",
    geonameid: 2624843,
  },
  {
    name: "Aalborg",
    country: "Denmark",
    subcountry: "North Denmark",
    geonameid: 2624886,
  },
  {
    name: "Albertslund",
    country: "Denmark",
    subcountry: "Capital Region",
    geonameid: 2624906,
  },
  {
    name: "Aabenraa",
    country: "Denmark",
    subcountry: "South Denmark",
    geonameid: 2625070,
  },
  {
    name: "Roseau",
    country: "Dominica",
    subcountry: "Saint George",
    geonameid: 3575635,
  },
  {
    name: "Villa Francisca",
    country: "Dominican Republic",
    subcountry: "Nacional",
    geonameid: 3491941,
  },
  {
    name: "Villa Consuelo",
    country: "Dominican Republic",
    subcountry: "Nacional",
    geonameid: 3491946,
  },
  {
    name: "Villa Bisonó",
    country: "Dominican Republic",
    subcountry: "Santiago",
    geonameid: 3491948,
  },
  {
    name: "Villa Altagracia",
    country: "Dominican Republic",
    subcountry: "San Cristóbal",
    geonameid: 3491952,
  },
  {
    name: "Tamboril",
    country: "Dominican Republic",
    subcountry: "Santiago",
    geonameid: 3492517,
  },
  {
    name: "Santo Domingo",
    country: "Dominican Republic",
    subcountry: "Nacional",
    geonameid: 3492908,
  },
  {
    name: "Santiago de los Caballeros",
    country: "Dominican Republic",
    subcountry: "Santiago",
    geonameid: 3492914,
  },
  {
    name: "Santa Cruz de El Seibo",
    country: "Dominican Republic",
    subcountry: "El Seíbo",
    geonameid: 3492984,
  },
  {
    name: "Santa Cruz de Barahona",
    country: "Dominican Republic",
    subcountry: "Barahona",
    geonameid: 3492985,
  },
  {
    name: "San Pedro de Macorís",
    country: "Dominican Republic",
    subcountry: "San Pedro de Macorís",
    geonameid: 3493032,
  },
  {
    name: "San Juan de la Maguana",
    country: "Dominican Republic",
    subcountry: "San Juan",
    geonameid: 3493081,
  },
  {
    name: "San José de Ocoa",
    country: "Dominican Republic",
    subcountry: "San José de Ocoa",
    geonameid: 3493100,
  },
  {
    name: "San Francisco de Macorís",
    country: "Dominican Republic",
    subcountry: "Duarte",
    geonameid: 3493146,
  },
  {
    name: "San Fernando de Monte Cristi",
    country: "Dominican Republic",
    subcountry: "Monte Cristi",
    geonameid: 3493174,
  },
  {
    name: "Puerto Plata",
    country: "Dominican Republic",
    subcountry: "Puerto Plata",
    geonameid: 3493175,
  },
  {
    name: "Salvaleón de Higüey",
    country: "Dominican Republic",
    subcountry: "La Altagracia",
    geonameid: 3493240,
  },
  {
    name: "Salcedo",
    country: "Dominican Republic",
    subcountry: "Hermanas Mirabal",
    geonameid: 3493283,
  },
  {
    name: "Sabaneta",
    country: "Dominican Republic",
    subcountry: "Santiago Rodríguez",
    geonameid: 3493383,
  },
  {
    name: "Sabana Grande de Boyá",
    country: "Dominican Republic",
    subcountry: "Monte Plata",
    geonameid: 3493482,
  },
  {
    name: "Río Grande",
    country: "Dominican Republic",
    subcountry: "Puerto Plata",
    geonameid: 3493769,
  },
  {
    name: "Quisqueya",
    country: "Dominican Republic",
    subcountry: "San Pedro de Macorís",
    geonameid: 3494121,
  },
  {
    name: "Punta Cana",
    country: "Dominican Republic",
    subcountry: "La Altagracia",
    geonameid: 3494242,
  },
  {
    name: "Neiba",
    country: "Dominican Republic",
    subcountry: "Baoruco",
    geonameid: 3495857,
  },
  {
    name: "Nagua",
    country: "Dominican Republic",
    subcountry: "María Trinidad Sánchez",
    geonameid: 3496021,
  },
  {
    name: "Monte Plata",
    country: "Dominican Republic",
    subcountry: "Monte Plata",
    geonameid: 3496134,
  },
  {
    name: "Monte Llano",
    country: "Dominican Republic",
    subcountry: "Puerto Plata",
    geonameid: 3496150,
  },
  {
    name: "Moca",
    country: "Dominican Republic",
    subcountry: "Espaillat",
    geonameid: 3496331,
  },
  {
    name: "Mao",
    country: "Dominican Republic",
    subcountry: "Valverde",
    geonameid: 3496831,
  },
  {
    name: "Las Matas de Farfán",
    country: "Dominican Republic",
    subcountry: "San Juan",
    geonameid: 3500370,
  },
  {
    name: "La Romana",
    country: "Dominican Republic",
    subcountry: "La Romana",
    geonameid: 3500957,
  },
  {
    name: "Jarabacoa",
    country: "Dominican Republic",
    subcountry: "La Vega",
    geonameid: 3504158,
  },
  {
    name: "Hato Mayor del Rey",
    country: "Dominican Republic",
    subcountry: "Hato Mayor",
    geonameid: 3504765,
  },
  {
    name: "Esperanza",
    country: "Dominican Republic",
    subcountry: "Valverde",
    geonameid: 3505855,
  },
  {
    name: "Dajabón",
    country: "Dominican Republic",
    subcountry: "Dajabón",
    geonameid: 3508952,
  },
  {
    name: "Cotuí",
    country: "Dominican Republic",
    subcountry: "Sánchez Ramírez",
    geonameid: 3509207,
  },
  {
    name: "Constanza",
    country: "Dominican Republic",
    subcountry: "La Vega",
    geonameid: 3509363,
  },
  {
    name: "Concepción de La Vega",
    country: "Dominican Republic",
    subcountry: "La Vega",
    geonameid: 3509382,
  },
  {
    name: "Ciudad Nueva",
    country: "Dominican Republic",
    subcountry: "Nacional",
    geonameid: 3509578,
  },
  {
    name: "Bonao",
    country: "Dominican Republic",
    subcountry: "Monseñor Nouel",
    geonameid: 3511233,
  },
  {
    name: "Boca Chica",
    country: "Dominican Republic",
    subcountry: "Santo Domingo",
    geonameid: 3511336,
  },
  {
    name: "San Cristóbal",
    country: "Dominican Republic",
    subcountry: "San Cristóbal",
    geonameid: 3511540,
  },
  {
    name: "Bella Vista",
    country: "Dominican Republic",
    subcountry: "Nacional",
    geonameid: 3511550,
  },
  {
    name: "Bayaguana",
    country: "Dominican Republic",
    subcountry: "Monte Plata",
    geonameid: 3511626,
  },
  {
    name: "Baní",
    country: "Dominican Republic",
    subcountry: "Peravia",
    geonameid: 3512067,
  },
  {
    name: "Bajos de Haina",
    country: "Dominican Republic",
    subcountry: "San Cristóbal",
    geonameid: 3512128,
  },
  {
    name: "Azua",
    country: "Dominican Republic",
    subcountry: "Azua",
    geonameid: 3512208,
  },
  {
    name: "Santo Domingo Oeste",
    country: "Dominican Republic",
    subcountry: "Santo Domingo",
    geonameid: 7874116,
  },
  {
    name: "Santo Domingo Este",
    country: "Dominican Republic",
    subcountry: "Santo Domingo",
    geonameid: 8601412,
  },
  {
    name: "Boumerdas",
    country: "Algeria",
    subcountry: "Boumerdes",
    geonameid: 2474141,
  },
  {
    name: "Zeribet el Oued",
    country: "Algeria",
    subcountry: "Biskra",
    geonameid: 2474506,
  },
  {
    name: "Zeralda",
    country: "Algeria",
    subcountry: "Algiers",
    geonameid: 2474583,
  },
  {
    name: "Zemoura",
    country: "Algeria",
    subcountry: "Relizane",
    geonameid: 2474638,
  },
  {
    name: "Touggourt",
    country: "Algeria",
    subcountry: "Touggourt",
    geonameid: 2475475,
  },
  {
    name: "Tolga",
    country: "Algeria",
    subcountry: "Biskra",
    geonameid: 2475612,
  },
  {
    name: "Tlemcen",
    country: "Algeria",
    subcountry: "Tlemcen",
    geonameid: 2475687,
  },
  {
    name: "Tizi Rached",
    country: "Algeria",
    subcountry: "Tizi Ouzou",
    geonameid: 2475740,
  },
  {
    name: "Tizi Ouzou",
    country: "Algeria",
    subcountry: "Tizi Ouzou",
    geonameid: 2475744,
  },
  {
    name: "Tizi-n-Tleta",
    country: "Algeria",
    subcountry: "Tizi Ouzou",
    geonameid: 2475752,
  },
  {
    name: "Tizi Gheniff",
    country: "Algeria",
    subcountry: "Tizi Ouzou",
    geonameid: 2475764,
  },
  {
    name: "Tissemsilt",
    country: "Algeria",
    subcountry: "Tissemsilt",
    geonameid: 2475860,
  },
  {
    name: "Tirmitine",
    country: "Algeria",
    subcountry: "Tizi Ouzou",
    geonameid: 2475921,
  },
  {
    name: "Tipaza",
    country: "Algeria",
    subcountry: "Tipaza",
    geonameid: 2476028,
  },
  {
    name: "Tindouf",
    country: "Algeria",
    subcountry: "Tindouf",
    geonameid: 2476301,
  },
  {
    name: "Timizart",
    country: "Algeria",
    subcountry: "Tizi Ouzou",
    geonameid: 2476396,
  },
  {
    name: "Timimoun",
    country: "Algeria",
    subcountry: "Timimoun",
    geonameid: 2476403,
  },
  {
    name: "el hed",
    country: "Algeria",
    subcountry: "Béjaïa",
    geonameid: 2476412,
  },
  {
    name: "Tiaret",
    country: "Algeria",
    subcountry: "Tiaret",
    geonameid: 2476897,
  },
  {
    name: "Theniet el Had",
    country: "Algeria",
    subcountry: "Tissemsilt",
    geonameid: 2476915,
  },
  {
    name: "Thenia",
    country: "Algeria",
    subcountry: "Boumerdes",
    geonameid: 2476917,
  },
  {
    name: "Telerghma",
    country: "Algeria",
    subcountry: "Mila",
    geonameid: 2477255,
  },
  {
    name: "Tébessa",
    country: "Algeria",
    subcountry: "Tébessa",
    geonameid: 2477461,
  },
  {
    name: "Tebesbest",
    country: "Algeria",
    subcountry: "Touggourt",
    geonameid: 2477462,
  },
  {
    name: "Tazoult-Lambese",
    country: "Algeria",
    subcountry: "Batna",
    geonameid: 2477528,
  },
  {
    name: "Tamanrasset",
    country: "Algeria",
    subcountry: "Tamanrasset",
    geonameid: 2478216,
  },
  {
    name: "Tamalous",
    country: "Algeria",
    subcountry: "Skikda",
    geonameid: 2478226,
  },
  {
    name: "Taïbet",
    country: "Algeria",
    subcountry: "Touggourt",
    geonameid: 2478509,
  },
  {
    name: "Tadmaït",
    country: "Algeria",
    subcountry: "Tizi Ouzou",
    geonameid: 2478831,
  },
  {
    name: "Sour el Ghozlane",
    country: "Algeria",
    subcountry: "Bouira",
    geonameid: 2479161,
  },
  {
    name: "Souma",
    country: "Algeria",
    subcountry: "Blida",
    geonameid: 2479183,
  },
  {
    name: "Lardjem",
    country: "Algeria",
    subcountry: "Tissemsilt",
    geonameid: 2479203,
  },
  {
    name: "Souk Ahras",
    country: "Algeria",
    subcountry: "Souk Ahras",
    geonameid: 2479215,
  },
  {
    name: "Sougueur",
    country: "Algeria",
    subcountry: "Tiaret",
    geonameid: 2479247,
  },
  {
    name: "Skikda",
    country: "Algeria",
    subcountry: "Skikda",
    geonameid: 2479536,
  },
  {
    name: "Sig",
    country: "Algeria",
    subcountry: "Mascara",
    geonameid: 2479609,
  },
  {
    name: "Sidi Okba",
    country: "Algeria",
    subcountry: "Biskra",
    geonameid: 2479916,
  },
  {
    name: "Sidi Moussa",
    country: "Algeria",
    subcountry: "Algiers",
    geonameid: 2479966,
  },
  {
    name: "Sidi Mérouane",
    country: "Algeria",
    subcountry: "Mila",
    geonameid: 2480198,
  },
  {
    name: "Sidi Khaled",
    country: "Algeria",
    subcountry: "Ouled Djellal",
    geonameid: 2480368,
  },
  {
    name: "Sidi ech Chahmi",
    country: "Algeria",
    subcountry: "Oran",
    geonameid: 2480618,
  },
  {
    name: "Sidi Bel Abbès",
    country: "Algeria",
    subcountry: "Sidi Bel Abbès",
    geonameid: 2481007,
  },
  {
    name: "Sidi Amrane",
    country: "Algeria",
    subcountry: "El Mghair",
    geonameid: 2481058,
  },
  {
    name: "Sidi Akkacha",
    country: "Algeria",
    subcountry: "Chlef",
    geonameid: 2481207,
  },
  {
    name: "Sidi Aïssa",
    country: "Algeria",
    subcountry: "M'Sila",
    geonameid: 2481246,
  },
  {
    name: "Sidi Abdelli",
    country: "Algeria",
    subcountry: "Tlemcen",
    geonameid: 2481389,
  },
  {
    name: "Sfizef",
    country: "Algeria",
    subcountry: "Sidi Bel Abbès",
    geonameid: 2481639,
  },
  {
    name: "Sétif",
    country: "Algeria",
    subcountry: "Sétif",
    geonameid: 2481700,
  },
  {
    name: "Sedrata",
    country: "Algeria",
    subcountry: "Souk Ahras",
    geonameid: 2482090,
  },
  {
    name: "Seddouk",
    country: "Algeria",
    subcountry: "Béjaïa",
    geonameid: 2482159,
  },
  {
    name: "Sebdou",
    country: "Algeria",
    subcountry: "Tlemcen",
    geonameid: 2482211,
  },
  {
    name: "Saoula",
    country: "Algeria",
    subcountry: "Algiers",
    geonameid: 2482390,
  },
  {
    name: "Salah Bey",
    country: "Algeria",
    subcountry: "Sétif",
    geonameid: 2482447,
  },
  {
    name: "Saïda",
    country: "Algeria",
    subcountry: "Saida",
    geonameid: 2482572,
  },
  {
    name: "Rouissat",
    country: "Algeria",
    subcountry: "Ouargla",
    geonameid: 2482886,
  },
  {
    name: "Rouiba",
    country: "Algeria",
    subcountry: "Algiers",
    geonameid: 2482908,
  },
  {
    name: "Rouached",
    country: "Algeria",
    subcountry: "Mila",
    geonameid: 2482939,
  },
  {
    name: "Robbah",
    country: "Algeria",
    subcountry: "El Oued",
    geonameid: 2483000,
  },
  {
    name: "Remchi",
    country: "Algeria",
    subcountry: "Tlemcen",
    geonameid: 2483649,
  },
  {
    name: "Relizane",
    country: "Algeria",
    subcountry: "Relizane",
    geonameid: 2483668,
  },
  {
    name: "Reguiba",
    country: "Algeria",
    subcountry: "El Oued",
    geonameid: 2483746,
  },
  {
    name: "Reghaïa",
    country: "Algeria",
    subcountry: "Algiers",
    geonameid: 2483757,
  },
  {
    name: "Reggane",
    country: "Algeria",
    subcountry: "Adrar",
    geonameid: 2483761,
  },
  {
    name: "Râs el Oued",
    country: "Algeria",
    subcountry: "Bordj Bou Arréridj",
    geonameid: 2483936,
  },
  {
    name: "Râs el Aïoun",
    country: "Algeria",
    subcountry: "Batna",
    geonameid: 2483968,
  },
  {
    name: "Oum el Bouaghi",
    country: "Algeria",
    subcountry: "Oum el Bouaghi",
    geonameid: 2484620,
  },
  {
    name: "Ouled Mimoun",
    country: "Algeria",
    subcountry: "Tlemcen",
    geonameid: 2484846,
  },
  {
    name: "Oued Sly",
    country: "Algeria",
    subcountry: "Chlef",
    geonameid: 2485572,
  },
  {
    name: "Oued Rhiou",
    country: "Algeria",
    subcountry: "Relizane",
    geonameid: 2485582,
  },
  {
    name: "Oued Fodda",
    country: "Algeria",
    subcountry: "Chlef",
    geonameid: 2485618,
  },
  {
    name: "Oued el Alleug",
    country: "Algeria",
    subcountry: "Blida",
    geonameid: 2485633,
  },
  {
    name: "Oued el Abtal",
    country: "Algeria",
    subcountry: "Mascara",
    geonameid: 2485636,
  },
  {
    name: "Ouargla",
    country: "Algeria",
    subcountry: "Ouargla",
    geonameid: 2485801,
  },
  {
    name: "Oran",
    country: "Algeria",
    subcountry: "Oran",
    geonameid: 2485926,
  },
  {
    name: "Nedroma",
    country: "Algeria",
    subcountry: "Tlemcen",
    geonameid: 2486284,
  },
  {
    name: "Naciria",
    country: "Algeria",
    subcountry: "Boumerdes",
    geonameid: 2486505,
  },
  {
    name: "M’sila",
    country: "Algeria",
    subcountry: "M'Sila",
    geonameid: 2486690,
  },
  {
    name: "Mouzaïa",
    country: "Algeria",
    subcountry: "Blida",
    geonameid: 2486825,
  },
  {
    name: "Mostaganem",
    country: "Algeria",
    subcountry: "Mostaganem",
    geonameid: 2487134,
  },
  {
    name: "Mila",
    country: "Algeria",
    subcountry: "Mila",
    geonameid: 2487452,
  },
  {
    name: "Metlili Chaamba",
    country: "Algeria",
    subcountry: "Ghardaia",
    geonameid: 2487620,
  },
  {
    name: "Messaad",
    country: "Algeria",
    subcountry: "Djelfa",
    geonameid: 2487772,
  },
  {
    name: "Meskiana",
    country: "Algeria",
    subcountry: "Oum el Bouaghi",
    geonameid: 2487805,
  },
  {
    name: "Mers el Kebir",
    country: "Algeria",
    subcountry: "Oran",
    geonameid: 2487852,
  },
  {
    name: "Merouana",
    country: "Algeria",
    subcountry: "Batna",
    geonameid: 2487882,
  },
  {
    name: "Melouza",
    country: "Algeria",
    subcountry: "M'Sila",
    geonameid: 2488202,
  },
  {
    name: "Mekla",
    country: "Algeria",
    subcountry: "Tizi Ouzou",
    geonameid: 2488500,
  },
  {
    name: "Mehdia daira de meghila",
    country: "Algeria",
    subcountry: "Tiaret",
    geonameid: 2488616,
  },
  {
    name: "Megarine",
    country: "Algeria",
    subcountry: "Touggourt",
    geonameid: 2488716,
  },
  {
    name: "Meftah",
    country: "Algeria",
    subcountry: "Blida",
    geonameid: 2488722,
  },
  {
    name: "Médéa",
    country: "Algeria",
    subcountry: "Medea",
    geonameid: 2488835,
  },
  {
    name: "Mazouna",
    country: "Algeria",
    subcountry: "Relizane",
    geonameid: 2489987,
  },
  {
    name: "Mascara",
    country: "Algeria",
    subcountry: "Mascara",
    geonameid: 2490098,
  },
  {
    name: "Mansourah",
    country: "Algeria",
    subcountry: "Bordj Bou Arréridj",
    geonameid: 2490180,
  },
  {
    name: "Mansoûra",
    country: "Algeria",
    subcountry: "Tlemcen",
    geonameid: 2490183,
  },
  {
    name: "Makouda",
    country: "Algeria",
    subcountry: "Tizi Ouzou",
    geonameid: 2490297,
  },
  {
    name: "L’Arbaa Naït Irathen",
    country: "Algeria",
    subcountry: "Tizi Ouzou",
    geonameid: 2491042,
  },
  {
    name: "Larbaâ",
    country: "Algeria",
    subcountry: "Blida",
    geonameid: 2491050,
  },
  {
    name: "Lakhdaria",
    country: "Algeria",
    subcountry: "Bouira",
    geonameid: 2491134,
  },
  {
    name: "Laghouat",
    country: "Algeria",
    subcountry: "Laghouat",
    geonameid: 2491191,
  },
  {
    name: "Ksar el Boukhari",
    country: "Algeria",
    subcountry: "Medea",
    geonameid: 2491323,
  },
  {
    name: "Ksar Chellala",
    country: "Algeria",
    subcountry: "Tiaret",
    geonameid: 2491335,
  },
  {
    name: "Kolea",
    country: "Algeria",
    subcountry: "Tipaza",
    geonameid: 2491578,
  },
  {
    name: "Khenchela",
    country: "Algeria",
    subcountry: "Khenchela",
    geonameid: 2491889,
  },
  {
    name: "Khemis Miliana",
    country: "Algeria",
    subcountry: "Aïn Defla",
    geonameid: 2491911,
  },
  {
    name: "Khemis el Khechna",
    country: "Algeria",
    subcountry: "Boumerdes",
    geonameid: 2491913,
  },
  {
    name: "Kerkera",
    country: "Algeria",
    subcountry: "Skikda",
    geonameid: 2492345,
  },
  {
    name: "Jijel",
    country: "Algeria",
    subcountry: "Jijel",
    geonameid: 2492913,
  },
  {
    name: "Djidiouia",
    country: "Algeria",
    subcountry: "Relizane",
    geonameid: 2492920,
  },
  {
    name: "Ighram",
    country: "Algeria",
    subcountry: "Béjaïa",
    geonameid: 2493605,
  },
  {
    name: "Hennaya",
    country: "Algeria",
    subcountry: "Tlemcen",
    geonameid: 2493918,
  },
  {
    name: "Héliopolis",
    country: "Algeria",
    subcountry: "Guelma",
    geonameid: 2493956,
  },
  {
    name: "Hassi Messaoud",
    country: "Algeria",
    subcountry: "Ouargla",
    geonameid: 2494029,
  },
  {
    name: "Hammamet",
    country: "Algeria",
    subcountry: "Tébessa",
    geonameid: 2494548,
  },
  {
    name: "Hammam Bou Hadjar",
    country: "Algeria",
    subcountry: "Aïn Témouchent",
    geonameid: 2494554,
  },
  {
    name: "Hamma Bouziane",
    country: "Algeria",
    subcountry: "Constantine",
    geonameid: 2494610,
  },
  {
    name: "Hadjout",
    country: "Algeria",
    subcountry: "Tipaza",
    geonameid: 2494962,
  },
  {
    name: "Guelma",
    country: "Algeria",
    subcountry: "Guelma",
    geonameid: 2495662,
  },
  {
    name: "Ghardaïa",
    country: "Algeria",
    subcountry: "Ghardaia",
    geonameid: 2496049,
  },
  {
    name: "Frenda",
    country: "Algeria",
    subcountry: "Tiaret",
    geonameid: 2496232,
  },
  {
    name: "Freha",
    country: "Algeria",
    subcountry: "Tizi Ouzou",
    geonameid: 2496241,
  },
  {
    name: "Feraoun",
    country: "Algeria",
    subcountry: "Béjaïa",
    geonameid: 2496573,
  },
  {
    name: "Es Senia",
    country: "Algeria",
    subcountry: "Oran",
    geonameid: 2497060,
  },
  {
    name: "El Tarf",
    country: "Algeria",
    subcountry: "El Tarf",
    geonameid: 2497323,
  },
  {
    name: "El Oued",
    country: "Algeria",
    subcountry: "El Oued",
    geonameid: 2497411,
  },
  {
    name: "El Meghaier",
    country: "Algeria",
    subcountry: "El Mghair",
    geonameid: 2497655,
  },
  {
    name: "El Malah",
    country: "Algeria",
    subcountry: "Aïn Témouchent",
    geonameid: 2497714,
  },
  {
    name: "El Kseur",
    country: "Algeria",
    subcountry: "Béjaïa",
    geonameid: 2497796,
  },
  {
    name: "El Khroub",
    country: "Algeria",
    subcountry: "Constantine",
    geonameid: 2497849,
  },
  {
    name: "El Kala",
    country: "Algeria",
    subcountry: "El Tarf",
    geonameid: 2497988,
  },
  {
    name: "El Idrissia",
    country: "Algeria",
    subcountry: "Djelfa",
    geonameid: 2498000,
  },
  {
    name: "El Hadjira",
    country: "Algeria",
    subcountry: "Ouargla",
    geonameid: 2498172,
  },
  {
    name: "El Hadjar",
    country: "Algeria",
    subcountry: "Annaba",
    geonameid: 2498183,
  },
  {
    name: "El Meniaa",
    country: "Algeria",
    subcountry: "El Menia",
    geonameid: 2498305,
  },
  {
    name: "El Eulma",
    country: "Algeria",
    subcountry: "Sétif",
    geonameid: 2498392,
  },
  {
    name: "El Bayadh",
    country: "Algeria",
    subcountry: "El Bayadh",
    geonameid: 2498543,
  },
  {
    name: "El Attaf",
    country: "Algeria",
    subcountry: "Aïn Defla",
    geonameid: 2498590,
  },
  {
    name: "Chlef",
    country: "Algeria",
    subcountry: "Chlef",
    geonameid: 2498611,
  },
  {
    name: "El Aouinet",
    country: "Algeria",
    subcountry: "Tébessa",
    geonameid: 2498667,
  },
  {
    name: "El Amria",
    country: "Algeria",
    subcountry: "Aïn Témouchent",
    geonameid: 2498704,
  },
  {
    name: "El Affroun",
    country: "Algeria",
    subcountry: "Blida",
    geonameid: 2498752,
  },
  {
    name: "El Achir",
    country: "Algeria",
    subcountry: "Bordj Bou Arréridj",
    geonameid: 2498766,
  },
  {
    name: "El Abiodh Sidi Cheikh",
    country: "Algeria",
    subcountry: "El Bayadh",
    geonameid: 2498775,
  },
  {
    name: "El Abadia",
    country: "Algeria",
    subcountry: "Aïn Defla",
    geonameid: 2498782,
  },
  {
    name: "Ech Chettia",
    country: "Algeria",
    subcountry: "Chlef",
    geonameid: 2498954,
  },
  {
    name: "Drean",
    country: "Algeria",
    subcountry: "El Tarf",
    geonameid: 2499055,
  },
  {
    name: "Draa el Mizan",
    country: "Algeria",
    subcountry: "Tizi Ouzou",
    geonameid: 2499104,
  },
  {
    name: "Draa Ben Khedda",
    country: "Algeria",
    subcountry: "Tizi Ouzou",
    geonameid: 2499116,
  },
  {
    name: "Douera",
    country: "Algeria",
    subcountry: "Algiers",
    geonameid: 2499193,
  },
  {
    name: "Djelfa",
    country: "Algeria",
    subcountry: "Djelfa",
    geonameid: 2500017,
  },
  {
    name: "Djamaa",
    country: "Algeria",
    subcountry: "El Mghair",
    geonameid: 2500282,
  },
  {
    name: "Didouche Mourad",
    country: "Algeria",
    subcountry: "Constantine",
    geonameid: 2500401,
  },
  {
    name: "Dellys",
    country: "Algeria",
    subcountry: "Boumerdes",
    geonameid: 2500583,
  },
  {
    name: "Debila",
    country: "Algeria",
    subcountry: "El Oued",
    geonameid: 2500737,
  },
  {
    name: "Dar el Beïda",
    country: "Algeria",
    subcountry: "Algiers",
    geonameid: 2500889,
  },
  {
    name: "Dar Chioukh",
    country: "Algeria",
    subcountry: "Djelfa",
    geonameid: 2500904,
  },
  {
    name: "Constantine",
    country: "Algeria",
    subcountry: "Constantine",
    geonameid: 2501152,
  },
  {
    name: "Chorfa",
    country: "Algeria",
    subcountry: "Bouira",
    geonameid: 2501289,
  },
  {
    name: "Chiffa",
    country: "Algeria",
    subcountry: "Blida",
    geonameid: 2501323,
  },
  {
    name: "Chetouane",
    country: "Algeria",
    subcountry: "Tlemcen",
    geonameid: 2501362,
  },
  {
    name: "Cheria",
    country: "Algeria",
    subcountry: "Tébessa",
    geonameid: 2501404,
  },
  {
    name: "Cheraga",
    country: "Algeria",
    subcountry: "Algiers",
    geonameid: 2501465,
  },
  {
    name: "Chemini",
    country: "Algeria",
    subcountry: "Béjaïa",
    geonameid: 2501508,
  },
  {
    name: "Chelghoum el Aïd",
    country: "Algeria",
    subcountry: "Mila",
    geonameid: 2501541,
  },
  {
    name: "Chebli",
    country: "Algeria",
    subcountry: "Blida",
    geonameid: 2501680,
  },
  {
    name: "Charef",
    country: "Algeria",
    subcountry: "Djelfa",
    geonameid: 2501767,
  },
  {
    name: "Chabet el Ameur",
    country: "Algeria",
    subcountry: "Boumerdes",
    geonameid: 2501873,
  },
  {
    name: "Brezina",
    country: "Algeria",
    subcountry: "El Bayadh",
    geonameid: 2502034,
  },
  {
    name: "Bou Tlelis",
    country: "Algeria",
    subcountry: "Oran",
    geonameid: 2502239,
  },
  {
    name: "Boumahra Ahmed",
    country: "Algeria",
    subcountry: "Guelma",
    geonameid: 2502686,
  },
  {
    name: "Boukadir",
    country: "Algeria",
    subcountry: "Chlef",
    geonameid: 2502924,
  },
  {
    name: "Bou Ismaïl",
    country: "Algeria",
    subcountry: "Tipaza",
    geonameid: 2502939,
  },
  {
    name: "Bouïra",
    country: "Algeria",
    subcountry: "Bouira",
    geonameid: 2502958,
  },
  {
    name: "Bouinan",
    country: "Algeria",
    subcountry: "Blida",
    geonameid: 2502962,
  },
  {
    name: "Bou Hanifia el Hamamat",
    country: "Algeria",
    subcountry: "Mascara",
    geonameid: 2503033,
  },
  {
    name: "Bougara",
    country: "Algeria",
    subcountry: "Blida",
    geonameid: 2503147,
  },
  {
    name: "Bougaa",
    country: "Algeria",
    subcountry: "Sétif",
    geonameid: 2503156,
  },
  {
    name: "Boufarik",
    country: "Algeria",
    subcountry: "Blida",
    geonameid: 2503181,
  },
  {
    name: "Boudouaou",
    country: "Algeria",
    subcountry: "Boumerdes",
    geonameid: 2503229,
  },
  {
    name: "Boudjima",
    country: "Algeria",
    subcountry: "Tizi Ouzou",
    geonameid: 2503237,
  },
  {
    name: "Boû Arfa",
    country: "Algeria",
    subcountry: "Blida",
    geonameid: 2503468,
  },
  {
    name: "Bordj Zemoura",
    country: "Algeria",
    subcountry: "Bordj Bou Arréridj",
    geonameid: 2503620,
  },
  {
    name: "Bordj Ghdir",
    country: "Algeria",
    subcountry: "Bordj Bou Arréridj",
    geonameid: 2503654,
  },
  {
    name: "Bordj el Kiffan",
    country: "Algeria",
    subcountry: "Algiers",
    geonameid: 2503661,
  },
  {
    name: "Bordj Bou Arréridj",
    country: "Algeria",
    subcountry: "Bordj Bou Arréridj",
    geonameid: 2503701,
  },
  {
    name: "Boghni",
    country: "Algeria",
    subcountry: "Tizi Ouzou",
    geonameid: 2503755,
  },
  {
    name: "Blida",
    country: "Algeria",
    subcountry: "Blida",
    geonameid: 2503769,
  },
  {
    name: "Biskra",
    country: "Algeria",
    subcountry: "Biskra",
    geonameid: 2503826,
  },
  {
    name: "Birkhadem",
    country: "Algeria",
    subcountry: "Algiers",
    geonameid: 2503847,
  },
  {
    name: "Birine",
    country: "Algeria",
    subcountry: "Djelfa",
    geonameid: 2503852,
  },
  {
    name: "Bir el Djir",
    country: "Algeria",
    subcountry: "Oran",
    geonameid: 2503874,
  },
  {
    name: "Bir el Ater",
    country: "Algeria",
    subcountry: "Tébessa",
    geonameid: 2503878,
  },
  {
    name: "Besbes",
    country: "Algeria",
    subcountry: "El Tarf",
    geonameid: 2504072,
  },
  {
    name: "Berrouaghia",
    country: "Algeria",
    subcountry: "Medea",
    geonameid: 2504099,
  },
  {
    name: "Berriane",
    country: "Algeria",
    subcountry: "Ghardaia",
    geonameid: 2504110,
  },
  {
    name: "Berrahal",
    country: "Algeria",
    subcountry: "Annaba",
    geonameid: 2504136,
  },
  {
    name: "Bensekrane",
    country: "Algeria",
    subcountry: "Tlemcen",
    geonameid: 2504385,
  },
  {
    name: "Ben Mehidi",
    country: "Algeria",
    subcountry: "El Tarf",
    geonameid: 2504486,
  },
  {
    name: "Beni Saf",
    country: "Algeria",
    subcountry: "Aïn Témouchent",
    geonameid: 2504581,
  },
  {
    name: "Beni Mester",
    country: "Algeria",
    subcountry: "Tlemcen",
    geonameid: 2504616,
  },
  {
    name: "Beni Mered",
    country: "Algeria",
    subcountry: "Blida",
    geonameid: 2504622,
  },
  {
    name: "Beni Douala",
    country: "Algeria",
    subcountry: "Tizi Ouzou",
    geonameid: 2504703,
  },
  {
    name: "Beni Amrane",
    country: "Algeria",
    subcountry: "Boumerdes",
    geonameid: 2504739,
  },
  {
    name: "Bejaïa",
    country: "Algeria",
    subcountry: "Béjaïa",
    geonameid: 2505329,
  },
  {
    name: "Béchar",
    country: "Algeria",
    subcountry: "Béchar",
    geonameid: 2505530,
  },
  {
    name: "Batna",
    country: "Algeria",
    subcountry: "Batna",
    geonameid: 2505572,
  },
  {
    name: "Barika",
    country: "Algeria",
    subcountry: "Batna",
    geonameid: 2505629,
  },
  {
    name: "Barbacha",
    country: "Algeria",
    subcountry: "Béjaïa",
    geonameid: 2505651,
  },
  {
    name: "Baraki",
    country: "Algeria",
    subcountry: "Algiers",
    geonameid: 2505653,
  },
  {
    name: "Bab Ezzouar",
    country: "Algeria",
    subcountry: "Algiers",
    geonameid: 2505854,
  },
  {
    name: "Azzaba",
    country: "Algeria",
    subcountry: "Skikda",
    geonameid: 2505915,
  },
  {
    name: "Azazga",
    country: "Algeria",
    subcountry: "Tizi Ouzou",
    geonameid: 2506043,
  },
  {
    name: "Arris",
    country: "Algeria",
    subcountry: "Batna",
    geonameid: 2506404,
  },
  {
    name: "Arhribs",
    country: "Algeria",
    subcountry: "Tizi Ouzou",
    geonameid: 2506519,
  },
  {
    name: "Arbatache",
    country: "Algeria",
    subcountry: "Boumerdes",
    geonameid: 2506623,
  },
  {
    name: "Aoulef",
    country: "Algeria",
    subcountry: "Adrar",
    geonameid: 2506795,
  },
  {
    name: "Annaba",
    country: "Algeria",
    subcountry: "Annaba",
    geonameid: 2506999,
  },
  {
    name: "Ammi Moussa",
    country: "Algeria",
    subcountry: "Relizane",
    geonameid: 2507155,
  },
  {
    name: "Amizour",
    country: "Algeria",
    subcountry: "Béjaïa",
    geonameid: 2507169,
  },
  {
    name: "Algiers",
    country: "Algeria",
    subcountry: "Algiers",
    geonameid: 2507480,
  },
  {
    name: "Akbou",
    country: "Algeria",
    subcountry: "Béjaïa",
    geonameid: 2507646,
  },
  {
    name: "Aïn Touta",
    country: "Algeria",
    subcountry: "Batna",
    geonameid: 2507877,
  },
  {
    name: "Aïn Temouchent",
    country: "Algeria",
    subcountry: "Aïn Témouchent",
    geonameid: 2507901,
  },
  {
    name: "Aïn Taya",
    country: "Algeria",
    subcountry: "Algiers",
    geonameid: 2507912,
  },
  {
    name: "Aïn Smara",
    country: "Algeria",
    subcountry: "Constantine",
    geonameid: 2507926,
  },
  {
    name: "Aïn Sefra",
    country: "Algeria",
    subcountry: "Naama",
    geonameid: 2507943,
  },
  {
    name: "Aïn Oussera",
    country: "Algeria",
    subcountry: "Djelfa",
    geonameid: 2507972,
  },
  {
    name: "’Aïn Merane",
    country: "Algeria",
    subcountry: "Chlef",
    geonameid: 2508010,
  },
  {
    name: "Aïn Kercha",
    country: "Algeria",
    subcountry: "Oum el Bouaghi",
    geonameid: 2508059,
  },
  {
    name: "Aïn Fakroun",
    country: "Algeria",
    subcountry: "Oum el Bouaghi",
    geonameid: 2508102,
  },
  {
    name: "’Aïn el Turk",
    country: "Algeria",
    subcountry: "Oran",
    geonameid: 2508119,
  },
  {
    name: "’Aïn el Melh",
    country: "Algeria",
    subcountry: "M'Sila",
    geonameid: 2508130,
  },
  {
    name: "’Aïn el Hammam",
    country: "Algeria",
    subcountry: "Tizi Ouzou",
    geonameid: 2508152,
  },
  {
    name: "‘Aïn el Hadjel",
    country: "Algeria",
    subcountry: "M'Sila",
    geonameid: 2508157,
  },
  {
    name: "Aïn el Bya",
    country: "Algeria",
    subcountry: "Oran",
    geonameid: 2508174,
  },
  {
    name: "’Aïn el Berd",
    country: "Algeria",
    subcountry: "Sidi Bel Abbès",
    geonameid: 2508180,
  },
  {
    name: "’Aïn el Bell",
    country: "Algeria",
    subcountry: "Djelfa",
    geonameid: 2508184,
  },
  {
    name: "’Aïn Deheb",
    country: "Algeria",
    subcountry: "Tiaret",
    geonameid: 2508225,
  },
  {
    name: "Aïn Defla",
    country: "Algeria",
    subcountry: "Aïn Defla",
    geonameid: 2508228,
  },
  {
    name: "Aïn Bessem",
    country: "Algeria",
    subcountry: "Bouira",
    geonameid: 2508268,
  },
  {
    name: "’Aïn Benian",
    country: "Algeria",
    subcountry: "Algiers",
    geonameid: 2508275,
  },
  {
    name: "Aïn Beïda",
    country: "Algeria",
    subcountry: "Oum el Bouaghi",
    geonameid: 2508287,
  },
  {
    name: "Aïn Arnat",
    country: "Algeria",
    subcountry: "Sétif",
    geonameid: 2508297,
  },
  {
    name: "’Aïn Abid",
    country: "Algeria",
    subcountry: "Constantine",
    geonameid: 2508309,
  },
  {
    name: "Aflou",
    country: "Algeria",
    subcountry: "Laghouat",
    geonameid: 2508737,
  },
  {
    name: "Adrar",
    country: "Algeria",
    subcountry: "Adrar",
    geonameid: 2508813,
  },
  {
    name: "Abou el Hassan",
    country: "Algeria",
    subcountry: "Chlef",
    geonameid: 2509031,
  },
  {
    name: "BABOR - VILLE",
    country: "Algeria",
    subcountry: "Sétif",
    geonameid: 6698360,
  },
  {
    name: "In Salah",
    country: "Algeria",
    subcountry: "In Salah",
    geonameid: 6930641,
  },
  {
    name: "District of Taher",
    country: "Algeria",
    subcountry: "Jijel",
    geonameid: 12326384,
  },
  {
    name: "Zamora",
    country: "Ecuador",
    subcountry: "Zamora-Chinchipe",
    geonameid: 3649959,
  },
  {
    name: "Yaguachi Nuevo",
    country: "Ecuador",
    subcountry: "Guayas",
    geonameid: 3650121,
  },
  {
    name: "Vinces",
    country: "Ecuador",
    subcountry: "Los Ríos",
    geonameid: 3650186,
  },
  {
    name: "Ventanas",
    country: "Ecuador",
    subcountry: "Los Ríos",
    geonameid: 3650267,
  },
  {
    name: "Velasco Ibarra",
    country: "Ecuador",
    subcountry: "Guayas",
    geonameid: 3650273,
  },
  {
    name: "Tulcán",
    country: "Ecuador",
    subcountry: "Carchi",
    geonameid: 3650472,
  },
  {
    name: "Tena",
    country: "Ecuador",
    subcountry: "Napo",
    geonameid: 3650721,
  },
  {
    name: "Sucre",
    country: "Ecuador",
    subcountry: "Manabí",
    geonameid: 3650960,
  },
  {
    name: "Santo Domingo de los Colorados",
    country: "Ecuador",
    subcountry: "Santo Domingo de los Tsáchilas",
    geonameid: 3651297,
  },
  {
    name: "Santa Rosa",
    country: "Ecuador",
    subcountry: "El Oro",
    geonameid: 3651356,
  },
  {
    name: "Santa Elena",
    country: "Ecuador",
    subcountry: "Santa Elena",
    geonameid: 3651438,
  },
  {
    name: "San Lorenzo de Esmeraldas",
    country: "Ecuador",
    subcountry: "Esmeraldas",
    geonameid: 3651694,
  },
  {
    name: "Samborondón",
    country: "Ecuador",
    subcountry: "Guayas",
    geonameid: 3652065,
  },
  {
    name: "Salinas",
    country: "Ecuador",
    subcountry: "Santa Elena",
    geonameid: 3652100,
  },
  {
    name: "Rosa Zarate",
    country: "Ecuador",
    subcountry: "Esmeraldas",
    geonameid: 3652257,
  },
  {
    name: "Riobamba",
    country: "Ecuador",
    subcountry: "Chimborazo",
    geonameid: 3652350,
  },
  {
    name: "Quito",
    country: "Ecuador",
    subcountry: "Pichincha",
    geonameid: 3652462,
  },
  {
    name: "Quevedo",
    country: "Ecuador",
    subcountry: "Los Ríos",
    geonameid: 3652567,
  },
  {
    name: "Puyo",
    country: "Ecuador",
    subcountry: "Pastaza",
    geonameid: 3652584,
  },
  {
    name: "Pujilí",
    country: "Ecuador",
    subcountry: "Cotopaxi",
    geonameid: 3652684,
  },
  {
    name: "Puerto Francisco de Orellana",
    country: "Ecuador",
    subcountry: "Orellana",
    geonameid: 3652743,
  },
  {
    name: "Portoviejo",
    country: "Ecuador",
    subcountry: "Manabí",
    geonameid: 3652941,
  },
  {
    name: "Playas",
    country: "Ecuador",
    subcountry: "Guayas",
    geonameid: 3653015,
  },
  {
    name: "Piñas",
    country: "Ecuador",
    subcountry: "El Oro",
    geonameid: 3653130,
  },
  {
    name: "Pelileo",
    country: "Ecuador",
    subcountry: "Tungurahua",
    geonameid: 3653287,
  },
  {
    name: "Pedro Carbo",
    country: "Ecuador",
    subcountry: "Guayas",
    geonameid: 3653295,
  },
  {
    name: "Pasaje",
    country: "Ecuador",
    subcountry: "El Oro",
    geonameid: 3653403,
  },
  {
    name: "Otavalo",
    country: "Ecuador",
    subcountry: "Imbabura",
    geonameid: 3653693,
  },
  {
    name: "Naranjito",
    country: "Ecuador",
    subcountry: "Guayas",
    geonameid: 3653873,
  },
  {
    name: "Naranjal",
    country: "Ecuador",
    subcountry: "Guayas",
    geonameid: 3653882,
  },
  {
    name: "Montecristi",
    country: "Ecuador",
    subcountry: "Manabí",
    geonameid: 3654055,
  },
  {
    name: "Montalvo",
    country: "Ecuador",
    subcountry: "Los Ríos",
    geonameid: 3654064,
  },
  {
    name: "Milagro",
    country: "Ecuador",
    subcountry: "Guayas",
    geonameid: 3654215,
  },
  {
    name: "Manta",
    country: "Ecuador",
    subcountry: "Manabí",
    geonameid: 3654410,
  },
  {
    name: "Machala",
    country: "Ecuador",
    subcountry: "El Oro",
    geonameid: 3654533,
  },
  {
    name: "Machachi",
    country: "Ecuador",
    subcountry: "Pichincha",
    geonameid: 3654536,
  },
  {
    name: "Macas",
    country: "Ecuador",
    subcountry: "Morona-Santiago",
    geonameid: 3654541,
  },
  {
    name: "Loja",
    country: "Ecuador",
    subcountry: "Loja",
    geonameid: 3654667,
  },
  {
    name: "La Troncal",
    country: "Ecuador",
    subcountry: "Cañar",
    geonameid: 3654853,
  },
  {
    name: "Latacunga",
    country: "Ecuador",
    subcountry: "Cotopaxi",
    geonameid: 3654870,
  },
  {
    name: "La Maná",
    country: "Ecuador",
    subcountry: "Cotopaxi",
    geonameid: 3655117,
  },
  {
    name: "La Libertad",
    country: "Ecuador",
    subcountry: "Guayas",
    geonameid: 3655131,
  },
  {
    name: "Nueva Loja",
    country: "Ecuador",
    subcountry: "Sucumbios",
    geonameid: 3655185,
  },
  {
    name: "Jipijapa",
    country: "Ecuador",
    subcountry: "Manabí",
    geonameid: 3655446,
  },
  {
    name: "Ibarra",
    country: "Ecuador",
    subcountry: "Imbabura",
    geonameid: 3655673,
  },
  {
    name: "Huaquillas",
    country: "Ecuador",
    subcountry: "El Oro",
    geonameid: 3655720,
  },
  {
    name: "Guayaquil",
    country: "Ecuador",
    subcountry: "Guayas",
    geonameid: 3657509,
  },
  {
    name: "Guaranda",
    country: "Ecuador",
    subcountry: "Bolívar",
    geonameid: 3657571,
  },
  {
    name: "Gualaceo",
    country: "Ecuador",
    subcountry: "Azuay",
    geonameid: 3657670,
  },
  {
    name: "Esmeraldas",
    country: "Ecuador",
    subcountry: "Esmeraldas",
    geonameid: 3657990,
  },
  {
    name: "El Triunfo",
    country: "Ecuador",
    subcountry: "Guayas",
    geonameid: 3658053,
  },
  {
    name: "Eloy Alfaro",
    country: "Ecuador",
    subcountry: "Guayas",
    geonameid: 3658192,
  },
  {
    name: "Daule",
    country: "Ecuador",
    subcountry: "Guayas",
    geonameid: 3658501,
  },
  {
    name: "Cuenca",
    country: "Ecuador",
    subcountry: "Azuay",
    geonameid: 3658666,
  },
  {
    name: "Chone",
    country: "Ecuador",
    subcountry: "Manabí",
    geonameid: 3659139,
  },
  {
    name: "Cayambe",
    country: "Ecuador",
    subcountry: "Pichincha",
    geonameid: 3659578,
  },
  {
    name: "Catamayo",
    country: "Ecuador",
    subcountry: "Loja",
    geonameid: 3659599,
  },
  {
    name: "Cariamanga",
    country: "Ecuador",
    subcountry: "Loja",
    geonameid: 3659711,
  },
  {
    name: "Calceta",
    country: "Ecuador",
    subcountry: "Manabí",
    geonameid: 3659926,
  },
  {
    name: "Boca Suno",
    country: "Ecuador",
    subcountry: "Orellana",
    geonameid: 3660152,
  },
  {
    name: "Balzar",
    country: "Ecuador",
    subcountry: "Guayas",
    geonameid: 3660361,
  },
  {
    name: "Bahía de Caráquez",
    country: "Ecuador",
    subcountry: "Manabí",
    geonameid: 3660401,
  },
  {
    name: "Babahoyo",
    country: "Ecuador",
    subcountry: "Los Ríos",
    geonameid: 3660418,
  },
  {
    name: "Azogues",
    country: "Ecuador",
    subcountry: "Cañar",
    geonameid: 3660434,
  },
  {
    name: "Atuntaqui",
    country: "Ecuador",
    subcountry: "Imbabura",
    geonameid: 3660478,
  },
  {
    name: "Ambato",
    country: "Ecuador",
    subcountry: "Tungurahua",
    geonameid: 3660689,
  },
  {
    name: "Viljandi",
    country: "Estonia",
    subcountry: "Viljandimaa",
    geonameid: 587577,
  },
  {
    name: "Tartu",
    country: "Estonia",
    subcountry: "Tartu",
    geonameid: 588335,
  },
  {
    name: "Tallinn",
    country: "Estonia",
    subcountry: "Harjumaa",
    geonameid: 588409,
  },
  {
    name: "Pärnu",
    country: "Estonia",
    subcountry: "Pärnumaa",
    geonameid: 589580,
  },
  {
    name: "Nõmme",
    country: "Estonia",
    subcountry: "Harjumaa",
    geonameid: 589947,
  },
  {
    name: "Narva",
    country: "Estonia",
    subcountry: "Ida-Virumaa",
    geonameid: 590031,
  },
  {
    name: "Maardu",
    country: "Estonia",
    subcountry: "Harjumaa",
    geonameid: 590447,
  },
  {
    name: "Kohtla-Järve",
    country: "Estonia",
    subcountry: "Ida-Virumaa",
    geonameid: 591260,
  },
  {
    name: "Zefta",
    country: "Egypt",
    subcountry: "Gharbia",
    geonameid: 346030,
  },
  {
    name: "Ţūkh",
    country: "Egypt",
    subcountry: "Qalyubia",
    geonameid: 347236,
  },
  {
    name: "Ţimā",
    country: "Egypt",
    subcountry: "Sohag",
    geonameid: 347296,
  },
  {
    name: "Ţanţā",
    country: "Egypt",
    subcountry: "Gharbia",
    geonameid: 347497,
  },
  {
    name: "Ţāmiyah",
    country: "Egypt",
    subcountry: "Faiyum",
    geonameid: 347542,
  },
  {
    name: "Ţalkhā",
    country: "Egypt",
    subcountry: "Dakahlia",
    geonameid: 347591,
  },
  {
    name: "Talā",
    country: "Egypt",
    subcountry: "Monufia",
    geonameid: 347612,
  },
  {
    name: "Ţahţā",
    country: "Egypt",
    subcountry: "Sohag",
    geonameid: 347634,
  },
  {
    name: "Sumusţā as Sulţānī",
    country: "Egypt",
    subcountry: "Beni Suweif",
    geonameid: 347749,
  },
  {
    name: "Sohag",
    country: "Egypt",
    subcountry: "Sohag",
    geonameid: 347796,
  },
  {
    name: "Sinnūris",
    country: "Egypt",
    subcountry: "Faiyum",
    geonameid: 347907,
  },
  {
    name: "Sīdī Sālim",
    country: "Egypt",
    subcountry: "Kafr el-Sheikh",
    geonameid: 348112,
  },
  {
    name: "Sīdī Barānī",
    country: "Egypt",
    subcountry: "Matruh",
    geonameid: 348548,
  },
  {
    name: "Shubrā al Khaymah",
    country: "Egypt",
    subcountry: "Qalyubia",
    geonameid: 349076,
  },
  {
    name: "Shirbīn",
    country: "Egypt",
    subcountry: "Dakahlia",
    geonameid: 349114,
  },
  {
    name: "Shibīn al Qanāṭir",
    country: "Egypt",
    subcountry: "Qalyubia",
    geonameid: 349156,
  },
  {
    name: "Shibīn al Kawm",
    country: "Egypt",
    subcountry: "Monufia",
    geonameid: 349158,
  },
  {
    name: "Samannūd",
    country: "Egypt",
    subcountry: "Gharbia",
    geonameid: 349715,
  },
  {
    name: "Samālūţ",
    country: "Egypt",
    subcountry: "Minya",
    geonameid: 349717,
  },
  {
    name: "Rosetta",
    country: "Egypt",
    subcountry: "Beheira",
    geonameid: 350203,
  },
  {
    name: "Ras Gharib",
    country: "Egypt",
    subcountry: "Red Sea",
    geonameid: 350207,
  },
  {
    name: "Quwaysinā",
    country: "Egypt",
    subcountry: "Monufia",
    geonameid: 350370,
  },
  {
    name: "Quţūr",
    country: "Egypt",
    subcountry: "Gharbia",
    geonameid: 350376,
  },
  {
    name: "Qūş",
    country: "Egypt",
    subcountry: "Qena",
    geonameid: 350422,
  },
  {
    name: "Qinā",
    country: "Egypt",
    subcountry: "Qena",
    geonameid: 350550,
  },
  {
    name: "Qalyūb",
    country: "Egypt",
    subcountry: "Qalyubia",
    geonameid: 350789,
  },
  {
    name: "Naja' Ḥammādī",
    country: "Egypt",
    subcountry: "Qena",
    geonameid: 351434,
  },
  {
    name: "Mīt Ghamr",
    country: "Egypt",
    subcountry: "Dakahlia",
    geonameid: 352181,
  },
  {
    name: "Minyat an Naşr",
    country: "Egypt",
    subcountry: "Dakahlia",
    geonameid: 352344,
  },
  {
    name: "Munūf",
    country: "Egypt",
    subcountry: "Monufia",
    geonameid: 352354,
  },
  {
    name: "Maţāy",
    country: "Egypt",
    subcountry: "Minya",
    geonameid: 352628,
  },
  {
    name: "Mashtūl as Sūq",
    country: "Egypt",
    subcountry: "Sharqia",
    geonameid: 352679,
  },
  {
    name: "Mersa Matruh",
    country: "Egypt",
    subcountry: "Matruh",
    geonameid: 352733,
  },
  {
    name: "Manfalūţ",
    country: "Egypt",
    subcountry: "Asyut",
    geonameid: 352913,
  },
  {
    name: "Mallawī",
    country: "Egypt",
    subcountry: "Minya",
    geonameid: 352951,
  },
  {
    name: "Maghāghah",
    country: "Egypt",
    subcountry: "Minya",
    geonameid: 353183,
  },
  {
    name: "Madīnat Sittah Uktūbar",
    country: "Egypt",
    subcountry: "Giza",
    geonameid: 353219,
  },
  {
    name: "Madīnat an Naşr",
    country: "Egypt",
    subcountry: "Cairo",
    geonameid: 353225,
  },
  {
    name: "Al ‘Āshir min Ramaḑān",
    country: "Egypt",
    subcountry: "Sharqia",
    geonameid: 353229,
  },
  {
    name: "Kirdāsah",
    country: "Egypt",
    subcountry: "Giza",
    geonameid: 353492,
  },
  {
    name: "Kawm Umbū",
    country: "Egypt",
    subcountry: "Aswan",
    geonameid: 353802,
  },
  {
    name: "Kawm Ḩamādah",
    country: "Egypt",
    subcountry: "Beheira",
    geonameid: 353828,
  },
  {
    name: "Kafr Şaqr",
    country: "Egypt",
    subcountry: "Sharqia",
    geonameid: 354105,
  },
  {
    name: "Kafr az Zayyāt",
    country: "Egypt",
    subcountry: "Gharbia",
    geonameid: 354365,
  },
  {
    name: "Kafr ash Shaykh",
    country: "Egypt",
    subcountry: "Kafr el-Sheikh",
    geonameid: 354502,
  },
  {
    name: "Kafr ad Dawwār",
    country: "Egypt",
    subcountry: "Beheira",
    geonameid: 354775,
  },
  {
    name: "Juhaynah",
    country: "Egypt",
    subcountry: "Sohag",
    geonameid: 354981,
  },
  {
    name: "Girga",
    country: "Egypt",
    subcountry: "Sohag",
    geonameid: 355026,
  },
  {
    name: "‘Izbat al Burj",
    country: "Egypt",
    subcountry: "Dakahlia",
    geonameid: 355392,
  },
  {
    name: "Iţsā",
    country: "Egypt",
    subcountry: "Faiyum",
    geonameid: 355420,
  },
  {
    name: "Isnā",
    country: "Egypt",
    subcountry: "Qena",
    geonameid: 355449,
  },
  {
    name: "Idkū",
    country: "Egypt",
    subcountry: "Beheira",
    geonameid: 355628,
  },
  {
    name: "Idfū",
    country: "Egypt",
    subcountry: "Aswan",
    geonameid: 355635,
  },
  {
    name: "Ibshawāy",
    country: "Egypt",
    subcountry: "Faiyum",
    geonameid: 355648,
  },
  {
    name: "Ḩalwān",
    country: "Egypt",
    subcountry: "Cairo",
    geonameid: 355795,
  },
  {
    name: "Hihyā",
    country: "Egypt",
    subcountry: "Sharqia",
    geonameid: 355939,
  },
  {
    name: "Ḩawsh ‘Īsá",
    country: "Egypt",
    subcountry: "Beheira",
    geonameid: 356000,
  },
  {
    name: "Fuwwah",
    country: "Egypt",
    subcountry: "Kafr el-Sheikh",
    geonameid: 356806,
  },
  {
    name: "Farshūţ",
    country: "Egypt",
    subcountry: "Qena",
    geonameid: 356933,
  },
  {
    name: "Fāraskūr",
    country: "Egypt",
    subcountry: "Damietta",
    geonameid: 356945,
  },
  {
    name: "Fāqūs",
    country: "Egypt",
    subcountry: "Sharqia",
    geonameid: 356989,
  },
  {
    name: "Damietta",
    country: "Egypt",
    subcountry: "Damietta",
    geonameid: 358048,
  },
  {
    name: "Diyarb Najm",
    country: "Egypt",
    subcountry: "Sharqia",
    geonameid: 358095,
  },
  {
    name: "Disūq",
    country: "Egypt",
    subcountry: "Kafr el-Sheikh",
    geonameid: 358108,
  },
  {
    name: "Dishnā",
    country: "Egypt",
    subcountry: "Qena",
    geonameid: 358115,
  },
  {
    name: "Dikirnis",
    country: "Egypt",
    subcountry: "Dakahlia",
    geonameid: 358172,
  },
  {
    name: "Dayrūţ",
    country: "Egypt",
    subcountry: "Asyut",
    geonameid: 358269,
  },
  {
    name: "Dayr Mawās",
    country: "Egypt",
    subcountry: "Minya",
    geonameid: 358274,
  },
  {
    name: "Damanhūr",
    country: "Egypt",
    subcountry: "Beheira",
    geonameid: 358448,
  },
  {
    name: "Būsh",
    country: "Egypt",
    subcountry: "Beni Suweif",
    geonameid: 358600,
  },
  {
    name: "Port Said",
    country: "Egypt",
    subcountry: "Port Said",
    geonameid: 358619,
  },
  {
    name: "Safaga",
    country: "Egypt",
    subcountry: "Red Sea",
    geonameid: 358620,
  },
  {
    name: "Bilqās",
    country: "Egypt",
    subcountry: "Dakahlia",
    geonameid: 358821,
  },
  {
    name: "Bilbays",
    country: "Egypt",
    subcountry: "Sharqia",
    geonameid: 358840,
  },
  {
    name: "Basyūn",
    country: "Egypt",
    subcountry: "Gharbia",
    geonameid: 358970,
  },
  {
    name: "Banī Suwayf",
    country: "Egypt",
    subcountry: "Beni Suweif",
    geonameid: 359173,
  },
  {
    name: "Banī Mazār",
    country: "Egypt",
    subcountry: "Minya",
    geonameid: 359212,
  },
  {
    name: "Banhā",
    country: "Egypt",
    subcountry: "Qalyubia",
    geonameid: 359280,
  },
  {
    name: "Zagazig",
    country: "Egypt",
    subcountry: "Sharqia",
    geonameid: 359493,
  },
  {
    name: "Awsīm",
    country: "Egypt",
    subcountry: "Giza",
    geonameid: 359576,
  },
  {
    name: "At Tall al Kabīr",
    country: "Egypt",
    subcountry: "Sharqia",
    geonameid: 359710,
  },
  {
    name: "Asyūţ",
    country: "Egypt",
    subcountry: "Asyut",
    geonameid: 359783,
  },
  {
    name: "Aswan",
    country: "Egypt",
    subcountry: "Aswan",
    geonameid: 359792,
  },
  {
    name: "Suez",
    country: "Egypt",
    subcountry: "Suez",
    geonameid: 359796,
  },
  {
    name: "As Sinbillāwayn",
    country: "Egypt",
    subcountry: "Dakahlia",
    geonameid: 359815,
  },
  {
    name: "Aş Şaff",
    country: "Egypt",
    subcountry: "Giza",
    geonameid: 359900,
  },
  {
    name: "Ash Shuhadā’",
    country: "Egypt",
    subcountry: "Monufia",
    geonameid: 359953,
  },
  {
    name: "Ashmūn",
    country: "Egypt",
    subcountry: "Monufia",
    geonameid: 360048,
  },
  {
    name: "Al Wāsiţah",
    country: "Egypt",
    subcountry: "Faiyum",
    geonameid: 360464,
  },
  {
    name: "Luxor",
    country: "Egypt",
    subcountry: "Luxor",
    geonameid: 360502,
  },
  {
    name: "Al Qūşīyah",
    country: "Egypt",
    subcountry: "Asyut",
    geonameid: 360526,
  },
  {
    name: "Al Quşayr",
    country: "Egypt",
    subcountry: "Red Sea",
    geonameid: 360531,
  },
  {
    name: "Al Qurayn",
    country: "Egypt",
    subcountry: "Sharqia",
    geonameid: 360542,
  },
  {
    name: "Al Qanāyāt",
    country: "Egypt",
    subcountry: "Sharqia",
    geonameid: 360612,
  },
  {
    name: "Al Qanāţir al Khayrīyah",
    country: "Egypt",
    subcountry: "Qalyubia",
    geonameid: 360615,
  },
  {
    name: "Cairo",
    country: "Egypt",
    subcountry: "Cairo",
    geonameid: 360630,
  },
  {
    name: "Al Minyā",
    country: "Egypt",
    subcountry: "Minya",
    geonameid: 360686,
  },
  {
    name: "Al Maţarīyah",
    country: "Egypt",
    subcountry: "Dakahlia",
    geonameid: 360716,
  },
  {
    name: "Al Manzalah",
    country: "Egypt",
    subcountry: "Dakahlia",
    geonameid: 360754,
  },
  {
    name: "Al Manşūrah",
    country: "Egypt",
    subcountry: "Dakahlia",
    geonameid: 360761,
  },
  {
    name: "Al Minshāh",
    country: "Egypt",
    subcountry: "Sohag",
    geonameid: 360773,
  },
  {
    name: "Al Maḩallah al Kubrá",
    country: "Egypt",
    subcountry: "Gharbia",
    geonameid: 360829,
  },
  {
    name: "Al Khuşūş",
    country: "Egypt",
    subcountry: "Qalyubia",
    geonameid: 360890,
  },
  {
    name: "Al Khārjah",
    country: "Egypt",
    subcountry: "New Valley",
    geonameid: 360923,
  },
  {
    name: "Al Khānkah",
    country: "Egypt",
    subcountry: "Qalyubia",
    geonameid: 360928,
  },
  {
    name: "Giza",
    country: "Egypt",
    subcountry: "Giza",
    geonameid: 360995,
  },
  {
    name: "Al Jammālīyah",
    country: "Egypt",
    subcountry: "Dakahlia",
    geonameid: 361029,
  },
  {
    name: "Ismailia",
    country: "Egypt",
    subcountry: "Ismailia",
    geonameid: 361055,
  },
  {
    name: "Alexandria",
    country: "Egypt",
    subcountry: "Alexandria",
    geonameid: 361058,
  },
  {
    name: "Al Ibrāhīmīyah",
    country: "Egypt",
    subcountry: "Sharqia",
    geonameid: 361103,
  },
  {
    name: "Al Ḩawāmidīyah",
    country: "Egypt",
    subcountry: "Giza",
    geonameid: 361179,
  },
  {
    name: "Al Ḩāmūl",
    country: "Egypt",
    subcountry: "Kafr el-Sheikh",
    geonameid: 361213,
  },
  {
    name: "Hurghada",
    country: "Egypt",
    subcountry: "Red Sea",
    geonameid: 361291,
  },
  {
    name: "Al Fayyūm",
    country: "Egypt",
    subcountry: "Faiyum",
    geonameid: 361320,
  },
  {
    name: "Al Fashn",
    country: "Egypt",
    subcountry: "Beni Suweif",
    geonameid: 361329,
  },
  {
    name: "Al Bawīţī",
    country: "Egypt",
    subcountry: "Giza",
    geonameid: 361394,
  },
  {
    name: "Al Balyanā",
    country: "Egypt",
    subcountry: "Sohag",
    geonameid: 361435,
  },
  {
    name: "Al Bājūr",
    country: "Egypt",
    subcountry: "Monufia",
    geonameid: 361457,
  },
  {
    name: "Al Badārī",
    country: "Egypt",
    subcountry: "Asyut",
    geonameid: 361478,
  },
  {
    name: "Al ‘Ayyāţ",
    country: "Egypt",
    subcountry: "Giza",
    geonameid: 361495,
  },
  {
    name: "Arish",
    country: "Egypt",
    subcountry: "North Sinai",
    geonameid: 361546,
  },
  {
    name: "Akhmīm",
    country: "Egypt",
    subcountry: "Sohag",
    geonameid: 361661,
  },
  {
    name: "Ajā",
    country: "Egypt",
    subcountry: "Dakahlia",
    geonameid: 361702,
  },
  {
    name: "Ad Dilinjāt",
    country: "Egypt",
    subcountry: "Beheira",
    geonameid: 361827,
  },
  {
    name: "Abū Tīj",
    country: "Egypt",
    subcountry: "Asyut",
    geonameid: 362004,
  },
  {
    name: "Abū Qurqāş",
    country: "Egypt",
    subcountry: "Minya",
    geonameid: 362277,
  },
  {
    name: "Abū Kabīr",
    country: "Egypt",
    subcountry: "Sharqia",
    geonameid: 362485,
  },
  {
    name: "Abū al Maţāmīr",
    country: "Egypt",
    subcountry: "Beheira",
    geonameid: 362882,
  },
  {
    name: "Abnūb",
    country: "Egypt",
    subcountry: "Asyut",
    geonameid: 362973,
  },
  {
    name: "Az Zarqā",
    country: "Egypt",
    subcountry: "Damietta",
    geonameid: 419435,
  },
  {
    name: "Ain Sukhna",
    country: "Egypt",
    subcountry: "Suez",
    geonameid: 7521348,
  },
  {
    name: "New Cairo",
    country: "Egypt",
    subcountry: "Cairo",
    geonameid: 7799991,
  },
  {
    name: "Al-'Ubūr",
    country: "Egypt",
    subcountry: "Qalyubia",
    geonameid: 12451089,
  },
  {
    name: "Laayoune",
    country: "Western Sahara",
    subcountry: "N/A",
    geonameid: 2462881,
  },
  {
    name: "Boujdour",
    country: "Western Sahara",
    subcountry: "N/A",
    geonameid: 2463029,
  },
  {
    name: "Dakhla",
    country: "Western Sahara",
    subcountry: "N/A",
    geonameid: 2463447,
  },
  {
    name: "Massawa",
    country: "Eritrea",
    subcountry: "Northern Red Sea",
    geonameid: 330546,
  },
  {
    name: "Keren",
    country: "Eritrea",
    subcountry: "Anseba",
    geonameid: 333287,
  },
  {
    name: "Barentu",
    country: "Eritrea",
    subcountry: "Gash-Barka",
    geonameid: 342711,
  },
  {
    name: "Asmara",
    country: "Eritrea",
    subcountry: "Maekel",
    geonameid: 343300,
  },
  {
    name: "Assab",
    country: "Eritrea",
    subcountry: "Southern Red Sea",
    geonameid: 343386,
  },
  {
    name: "Mendefera",
    country: "Eritrea",
    subcountry: "Debub",
    geonameid: 344901,
  },
  {
    name: "Zubia",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2509305,
  },
  {
    name: "Zafra",
    country: "Spain",
    subcountry: "Extremadura",
    geonameid: 2509377,
  },
  {
    name: "Yecla",
    country: "Spain",
    subcountry: "Murcia",
    geonameid: 2509402,
  },
  {
    name: "Villena",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2509463,
  },
  {
    name: "Villarrobledo",
    country: "Spain",
    subcountry: "Castille-La Mancha",
    geonameid: 2509491,
  },
  {
    name: "Vila-real",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2509509,
  },
  {
    name: "Villanueva de la Serena",
    country: "Spain",
    subcountry: "Extremadura",
    geonameid: 2509553,
  },
  {
    name: "Villajoyosa",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2509588,
  },
  {
    name: "Vícar",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2509650,
  },
  {
    name: "Vélez-Málaga",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2509769,
  },
  {
    name: "Valencia",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2509954,
  },
  {
    name: "Valdepeñas",
    country: "Spain",
    subcountry: "Castille-La Mancha",
    geonameid: 2509982,
  },
  {
    name: "Utrera",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2510073,
  },
  {
    name: "Ubrique",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2510112,
  },
  {
    name: "Úbeda",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2510116,
  },
  {
    name: "Totana",
    country: "Spain",
    subcountry: "Murcia",
    geonameid: 2510224,
  },
  {
    name: "Torrox",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2510245,
  },
  {
    name: "Torrevieja",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2510253,
  },
  {
    name: "Torre-Pacheco",
    country: "Spain",
    subcountry: "Murcia",
    geonameid: 2510271,
  },
  {
    name: "Torrent",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2510279,
  },
  {
    name: "Torremolinos",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2510281,
  },
  {
    name: "Torre del Mar",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2510309,
  },
  {
    name: "Tomelloso",
    country: "Spain",
    subcountry: "Castille-La Mancha",
    geonameid: 2510392,
  },
  {
    name: "Tomares",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2510394,
  },
  {
    name: "Toledo",
    country: "Spain",
    subcountry: "Castille-La Mancha",
    geonameid: 2510409,
  },
  {
    name: "Tías",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 2510485,
  },
  {
    name: "Telde",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 2510542,
  },
  {
    name: "Teguise",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 2510573,
  },
  {
    name: "Tarifa",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2510599,
  },
  {
    name: "Talavera de la Reina",
    country: "Spain",
    subcountry: "Castille-La Mancha",
    geonameid: 2510693,
  },
  {
    name: "Tacoronte",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 2510725,
  },
  {
    name: "Tavernes de la Valldigna",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2510743,
  },
  {
    name: "Sueca",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2510764,
  },
  {
    name: "Silla",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2510880,
  },
  {
    name: "Sevilla",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2510911,
  },
  {
    name: "San Vicent del Raspeig",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2511032,
  },
  {
    name: "Santomera",
    country: "Spain",
    subcountry: "Murcia",
    geonameid: 2511050,
  },
  {
    name: "Santa Pola",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2511102,
  },
  {
    name: "Santa Lucía",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 2511150,
  },
  {
    name: "Santafé",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2511160,
  },
  {
    name: "Santa Eulària des Riu",
    country: "Spain",
    subcountry: "Balearic Islands",
    geonameid: 2511162,
  },
  {
    name: "Santa Cruz de Tenerife",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 2511174,
  },
  {
    name: "Santa Cruz de la Palma",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 2511180,
  },
  {
    name: "Santa Brígida",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 2511202,
  },
  {
    name: "San Roque",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2511239,
  },
  {
    name: "San Pedro del Pinatar",
    country: "Spain",
    subcountry: "Murcia",
    geonameid: 2511247,
  },
  {
    name: "San Pedro de Alcántara",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2511250,
  },
  {
    name: "San Miguel De Abona",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 2511287,
  },
  {
    name: "Sanlúcar de Barrameda",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2511306,
  },
  {
    name: "San Juan de Aznalfarache",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2511329,
  },
  {
    name: "Sant Joan d'Alacant",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2511330,
  },
  {
    name: "San Javier",
    country: "Spain",
    subcountry: "Murcia",
    geonameid: 2511366,
  },
  {
    name: "San Isidro",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 2511371,
  },
  {
    name: "San Fernando",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2511388,
  },
  {
    name: "La Laguna",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 2511401,
  },
  {
    name: "San Bartolomé de Tirajana",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 2511440,
  },
  {
    name: "San Bartolomé",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 2511447,
  },
  {
    name: "Sant Antoni de Portmany",
    country: "Spain",
    subcountry: "Balearic Islands",
    geonameid: 2511448,
  },
  {
    name: "Sagunto",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2511619,
  },
  {
    name: "Rota",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2511700,
  },
  {
    name: "Roquetas de Mar",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2511716,
  },
  {
    name: "Ronda",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2511730,
  },
  {
    name: "Rojales",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2511752,
  },
  {
    name: "Rincón de la Victoria",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2511852,
  },
  {
    name: "Ribarroja del Turia",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2511880,
  },
  {
    name: "Requena",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2511930,
  },
  {
    name: "Realejo Alto",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 2511994,
  },
  {
    name: "Puçol",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2512127,
  },
  {
    name: "Puerto Real",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2512169,
  },
  {
    name: "Puertollano",
    country: "Spain",
    subcountry: "Castille-La Mancha",
    geonameid: 2512177,
  },
  {
    name: "Puerto del Rosario",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 2512186,
  },
  {
    name: "Puerto de la Cruz",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 2512196,
  },
  {
    name: "Puente-Genil",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2512232,
  },
  {
    name: "La Pobla de Vallbona",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2512251,
  },
  {
    name: "Priego de Córdoba",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2512282,
  },
  {
    name: "Pozoblanco",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2512340,
  },
  {
    name: "Pollença",
    country: "Spain",
    subcountry: "Balearic Islands",
    geonameid: 2512432,
  },
  {
    name: "Pilar de la Horadada",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2512581,
  },
  {
    name: "Picassent",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2512620,
  },
  {
    name: "Paterna",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2512862,
  },
  {
    name: "Palma",
    country: "Spain",
    subcountry: "Balearic Islands",
    geonameid: 2512989,
  },
  {
    name: "Palma del Río",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2512990,
  },
  {
    name: "Pájara",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 2513026,
  },
  {
    name: "Paiporta",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2513029,
  },
  {
    name: "Osuna",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2513052,
  },
  {
    name: "Orihuela",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2513076,
  },
  {
    name: "Ontinyent",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2513106,
  },
  {
    name: "Onda",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2513115,
  },
  {
    name: "Oliva",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2513145,
  },
  {
    name: "Novelda",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2513195,
  },
  {
    name: "Níjar",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2513222,
  },
  {
    name: "Nerja",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2513240,
  },
  {
    name: "Navalmoral de la Mata",
    country: "Spain",
    subcountry: "Extremadura",
    geonameid: 2513324,
  },
  {
    name: "Murcia",
    country: "Spain",
    subcountry: "Murcia",
    geonameid: 2513416,
  },
  {
    name: "Mula",
    country: "Spain",
    subcountry: "Murcia",
    geonameid: 2513436,
  },
  {
    name: "Mutxamel",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2513465,
  },
  {
    name: "Motril",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2513477,
  },
  {
    name: "Morón de la Frontera",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2513509,
  },
  {
    name: "Montilla",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2513601,
  },
  {
    name: "Montijo",
    country: "Spain",
    subcountry: "Extremadura",
    geonameid: 2513604,
  },
  {
    name: "Moncada",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2513703,
  },
  {
    name: "Molina de Segura",
    country: "Spain",
    subcountry: "Murcia",
    geonameid: 2513759,
  },
  {
    name: "Moguer",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2513791,
  },
  {
    name: "Mogán",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 2513798,
  },
  {
    name: "Mislata",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2513811,
  },
  {
    name: "Mijas",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2513882,
  },
  {
    name: "Miguelturra",
    country: "Spain",
    subcountry: "Castille-La Mancha",
    geonameid: 2513885,
  },
  {
    name: "Mérida",
    country: "Spain",
    subcountry: "Extremadura",
    geonameid: 2513917,
  },
  {
    name: "Melilla",
    country: "Spain",
    subcountry: "Melilla",
    geonameid: 2513947,
  },
  {
    name: "Mazarrón",
    country: "Spain",
    subcountry: "Murcia",
    geonameid: 2513983,
  },
  {
    name: "Maspalomas",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 2514042,
  },
  {
    name: "Massamagrell",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2514066,
  },
  {
    name: "Martos",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2514073,
  },
  {
    name: "Marratxí",
    country: "Spain",
    subcountry: "Balearic Islands",
    geonameid: 2514097,
  },
  {
    name: "Marchena",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2514158,
  },
  {
    name: "Marbella",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2514169,
  },
  {
    name: "Maracena",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2514176,
  },
  {
    name: "Manzanares",
    country: "Spain",
    subcountry: "Castille-La Mancha",
    geonameid: 2514190,
  },
  {
    name: "Manises",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2514197,
  },
  {
    name: "Manacor",
    country: "Spain",
    subcountry: "Balearic Islands",
    geonameid: 2514216,
  },
  {
    name: "Málaga",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2514256,
  },
  {
    name: "Mairena del Aljarafe",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2514287,
  },
  {
    name: "Mairena del Alcor",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2514288,
  },
  {
    name: "Maó",
    country: "Spain",
    subcountry: "Balearic Islands",
    geonameid: 2514301,
  },
  {
    name: "Lucena",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2514392,
  },
  {
    name: "Los Palacios y Villafranca",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2514553,
  },
  {
    name: "Los Llanos de Aridane",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 2514651,
  },
  {
    name: "Los Barrios",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2514824,
  },
  {
    name: "Los Alcázares",
    country: "Spain",
    subcountry: "Murcia",
    geonameid: 2514868,
  },
  {
    name: "Lorca",
    country: "Spain",
    subcountry: "Murcia",
    geonameid: 2514891,
  },
  {
    name: "Lora del Río",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2514893,
  },
  {
    name: "Loja",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2514946,
  },
  {
    name: "Llucmajor",
    country: "Spain",
    subcountry: "Balearic Islands",
    geonameid: 2514984,
  },
  {
    name: "Llíria",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2515036,
  },
  {
    name: "Linares",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2515045,
  },
  {
    name: "Lepe",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2515072,
  },
  {
    name: "Lebrija",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2515096,
  },
  {
    name: "La Unión",
    country: "Spain",
    subcountry: "Murcia",
    geonameid: 2515151,
  },
  {
    name: "Las Torres de Cotillas",
    country: "Spain",
    subcountry: "Murcia",
    geonameid: 2515219,
  },
  {
    name: "Las Palmas de Gran Canaria",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 2515270,
  },
  {
    name: "La Solana",
    country: "Spain",
    subcountry: "Castille-La Mancha",
    geonameid: 2515284,
  },
  {
    name: "Las Cabezas de San Juan",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2515493,
  },
  {
    name: "La Roda",
    country: "Spain",
    subcountry: "Castille-La Mancha",
    geonameid: 2515555,
  },
  {
    name: "La Rinconada",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2515562,
  },
  {
    name: "La Orotava",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 2515692,
  },
  {
    name: "La Oliva",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 2515698,
  },
  {
    name: "la Nucia",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2515701,
  },
  {
    name: "La Línea de la Concepción",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2515812,
  },
  {
    name: "L'Eliana",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2516004,
  },
  {
    name: "La Carolina",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2516088,
  },
  {
    name: "La Algaba",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2516217,
  },
  {
    name: "Jumilla",
    country: "Spain",
    subcountry: "Murcia",
    geonameid: 2516255,
  },
  {
    name: "Jerez de la Frontera",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2516326,
  },
  {
    name: "Javea",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2516336,
  },
  {
    name: "Xàtiva",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2516345,
  },
  {
    name: "Jaén",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2516395,
  },
  {
    name: "Isla Cristina",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2516431,
  },
  {
    name: "Ingenio",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 2516443,
  },
  {
    name: "Inca",
    country: "Spain",
    subcountry: "Balearic Islands",
    geonameid: 2516452,
  },
  {
    name: "Icod de los Vinos",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 2516474,
  },
  {
    name: "Ibiza",
    country: "Spain",
    subcountry: "Balearic Islands",
    geonameid: 2516479,
  },
  {
    name: "Ibi",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2516480,
  },
  {
    name: "Huércal-Overa",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2516542,
  },
  {
    name: "Huelva",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2516548,
  },
  {
    name: "Hellín",
    country: "Spain",
    subcountry: "Castille-La Mancha",
    geonameid: 2516797,
  },
  {
    name: "Güimar",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 2516852,
  },
  {
    name: "Guía de Isora",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 2516860,
  },
  {
    name: "Guardamar del Segura",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2516902,
  },
  {
    name: "Guadix",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2516925,
  },
  {
    name: "Granadilla de Abona",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 2517111,
  },
  {
    name: "Granada",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2517117,
  },
  {
    name: "Gandia",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2517367,
  },
  {
    name: "Gáldar",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 2517436,
  },
  {
    name: "Fuengirola",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2517595,
  },
  {
    name: "Felanitx",
    country: "Spain",
    subcountry: "Balearic Islands",
    geonameid: 2517750,
  },
  {
    name: "Estepona",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2517816,
  },
  {
    name: "El Viso del Alcor",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2518040,
  },
  {
    name: "El Puerto de Santa María",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2518207,
  },
  {
    name: "El Grao",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2518444,
  },
  {
    name: "El Ejido",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2518494,
  },
  {
    name: "Elda",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2518505,
  },
  {
    name: "Elche",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2518559,
  },
  {
    name: "El Arahal",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2518729,
  },
  {
    name: "Écija",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2518770,
  },
  {
    name: "Dos Hermanas",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2518794,
  },
  {
    name: "Don Benito",
    country: "Spain",
    subcountry: "Extremadura",
    geonameid: 2518820,
  },
  {
    name: "Denia",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2518878,
  },
  {
    name: "Daimiel",
    country: "Spain",
    subcountry: "Castille-La Mancha",
    geonameid: 2518924,
  },
  {
    name: "Cullera",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2518949,
  },
  {
    name: "Quart de Poblet",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2519068,
  },
  {
    name: "Crevillente",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2519110,
  },
  {
    name: "Coria del Río",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2519233,
  },
  {
    name: "Córdoba",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2519240,
  },
  {
    name: "Conil de la Frontera",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2519289,
  },
  {
    name: "Coín",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2519367,
  },
  {
    name: "Ciudad Real",
    country: "Spain",
    subcountry: "Castille-La Mancha",
    geonameid: 2519402,
  },
  {
    name: "Cieza",
    country: "Spain",
    subcountry: "Murcia",
    geonameid: 2519425,
  },
  {
    name: "Xirivella",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2519466,
  },
  {
    name: "Chipiona",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2519477,
  },
  {
    name: "Chiclana de la Frontera",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2519513,
  },
  {
    name: "Cehegín",
    country: "Spain",
    subcountry: "Murcia",
    geonameid: 2519651,
  },
  {
    name: "Catarroja",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2519690,
  },
  {
    name: "Castilleja de la Cuesta",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2519738,
  },
  {
    name: "Castelló de la Plana",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2519752,
  },
  {
    name: "Cartaya",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2520052,
  },
  {
    name: "Cártama",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2520055,
  },
  {
    name: "Cartagena",
    country: "Spain",
    subcountry: "Murcia",
    geonameid: 2520058,
  },
  {
    name: "Carrizal",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 2520069,
  },
  {
    name: "Carmona",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2520118,
  },
  {
    name: "Carlet",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2520121,
  },
  {
    name: "Carcaixent",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2520150,
  },
  {
    name: "Caravaca",
    country: "Spain",
    subcountry: "Murcia",
    geonameid: 2520171,
  },
  {
    name: "Candelaria",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 2520283,
  },
  {
    name: "Campo de Criptana",
    country: "Spain",
    subcountry: "Castille-La Mancha",
    geonameid: 2520413,
  },
  {
    name: "Campiña",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2520425,
  },
  {
    name: "El Campello",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2520447,
  },
  {
    name: "Camas",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2520477,
  },
  {
    name: "Calvià",
    country: "Spain",
    subcountry: "Balearic Islands",
    geonameid: 2520493,
  },
  {
    name: "Calp",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2520496,
  },
  {
    name: "Callosa de Segura",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2520502,
  },
  {
    name: "Cadiz",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2520600,
  },
  {
    name: "Cáceres",
    country: "Spain",
    subcountry: "Extremadura",
    geonameid: 2520611,
  },
  {
    name: "Cabra",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2520645,
  },
  {
    name: "Burriana",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2520709,
  },
  {
    name: "Burjassot",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2520712,
  },
  {
    name: "Bormujos",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2520833,
  },
  {
    name: "Bétera",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2520968,
  },
  {
    name: "Berja",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2521016,
  },
  {
    name: "Benidorm",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2521088,
  },
  {
    name: "Benetússer",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2521105,
  },
  {
    name: "Benalmádena",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2521139,
  },
  {
    name: "Baza",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2521215,
  },
  {
    name: "Barbate",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2521335,
  },
  {
    name: "Bailén",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2521410,
  },
  {
    name: "Baeza",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2521413,
  },
  {
    name: "Baena",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2521415,
  },
  {
    name: "Badajoz",
    country: "Spain",
    subcountry: "Extremadura",
    geonameid: 2521420,
  },
  {
    name: "Ayamonte",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2521456,
  },
  {
    name: "Atarfe",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2521485,
  },
  {
    name: "Atamaría",
    country: "Spain",
    subcountry: "Murcia",
    geonameid: 2521486,
  },
  {
    name: "Aspe",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2521510,
  },
  {
    name: "Arucas",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 2521519,
  },
  {
    name: "Arroyo de la Miel",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2521554,
  },
  {
    name: "Arrecife",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 2521570,
  },
  {
    name: "Arona",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 2521582,
  },
  {
    name: "Armilla",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2521590,
  },
  {
    name: "Arcos de la Frontera",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2521665,
  },
  {
    name: "Archena",
    country: "Spain",
    subcountry: "Murcia",
    geonameid: 2521676,
  },
  {
    name: "Antequera",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2521710,
  },
  {
    name: "Andújar",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2521738,
  },
  {
    name: "Altea",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2521804,
  },
  {
    name: "Almuñécar",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2521847,
  },
  {
    name: "Almoradí",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2521855,
  },
  {
    name: "Almonte",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2521857,
  },
  {
    name: "Almería",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2521886,
  },
  {
    name: "Almendralejo",
    country: "Spain",
    subcountry: "Extremadura",
    geonameid: 2521893,
  },
  {
    name: "Almassora",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2521909,
  },
  {
    name: "Almansa",
    country: "Spain",
    subcountry: "Castille-La Mancha",
    geonameid: 2521923,
  },
  {
    name: "Aljaraque",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2521964,
  },
  {
    name: "Alicante",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2521978,
  },
  {
    name: "Alhaurín el Grande",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2521985,
  },
  {
    name: "Alhaurín de la Torre",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2521986,
  },
  {
    name: "Alhama de Murcia",
    country: "Spain",
    subcountry: "Murcia",
    geonameid: 2521992,
  },
  {
    name: "Algemesí",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2522012,
  },
  {
    name: "Algeciras",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2522013,
  },
  {
    name: "Alfafar",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2522057,
  },
  {
    name: "Aldaia",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2522077,
  },
  {
    name: "Alcúdia",
    country: "Spain",
    subcountry: "Balearic Islands",
    geonameid: 2522091,
  },
  {
    name: "Alcoy",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2522098,
  },
  {
    name: "Alzira",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2522129,
  },
  {
    name: "Alcázar de San Juan",
    country: "Spain",
    subcountry: "Castille-La Mancha",
    geonameid: 2522131,
  },
  {
    name: "Alcantarilla",
    country: "Spain",
    subcountry: "Murcia",
    geonameid: 2522152,
  },
  {
    name: "Alcalá la Real",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2522160,
  },
  {
    name: "Alcalá de Guadaira",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2522165,
  },
  {
    name: "Alboraya",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2522203,
  },
  {
    name: "Albolote",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2522208,
  },
  {
    name: "Albal",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2522250,
  },
  {
    name: "Albacete",
    country: "Spain",
    subcountry: "Castille-La Mancha",
    geonameid: 2522258,
  },
  {
    name: "Alaquàs",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2522297,
  },
  {
    name: "Agüimes",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 2522325,
  },
  {
    name: "Águilas",
    country: "Spain",
    subcountry: "Murcia",
    geonameid: 2522333,
  },
  {
    name: "Adra",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 2522430,
  },
  {
    name: "Adeje",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 2522437,
  },
  {
    name: "Grao de Murviedro",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 2567529,
  },
  {
    name: "Zarautz",
    country: "Spain",
    subcountry: "Basque Country",
    geonameid: 3104316,
  },
  {
    name: "Zaragoza",
    country: "Spain",
    subcountry: "Aragon",
    geonameid: 3104324,
  },
  {
    name: "Zamora",
    country: "Spain",
    subcountry: "Castille and León",
    geonameid: 3104342,
  },
  {
    name: "Viveiro",
    country: "Spain",
    subcountry: "Galicia",
    geonameid: 3104475,
  },
  {
    name: "Gasteiz / Vitoria",
    country: "Spain",
    subcountry: "Basque Country",
    geonameid: 3104499,
  },
  {
    name: "Vinaròs",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 3104584,
  },
  {
    name: "Villaviciosa de Odón",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3104703,
  },
  {
    name: "Villaverde",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3104748,
  },
  {
    name: "Villaquilambre",
    country: "Spain",
    subcountry: "Castille and León",
    geonameid: 3105148,
  },
  {
    name: "Vilanova i la Geltrú",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3105184,
  },
  {
    name: "Villanueva del Pardillo",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3105214,
  },
  {
    name: "Villanueva de la Cañada",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3105247,
  },
  {
    name: "Vilalba",
    country: "Spain",
    subcountry: "Galicia",
    geonameid: 3105522,
  },
  {
    name: "Vilagarcía de Arousa",
    country: "Spain",
    subcountry: "Galicia",
    geonameid: 3105575,
  },
  {
    name: "Vilafranca del Penedès",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3105600,
  },
  {
    name: "Vila-seca",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3105803,
  },
  {
    name: "Vilaseca",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3105805,
  },
  {
    name: "Viladecans",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3105935,
  },
  {
    name: "Vigo",
    country: "Spain",
    subcountry: "Galicia",
    geonameid: 3105976,
  },
  {
    name: "Vic",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3106050,
  },
  {
    name: "Vicálvaro",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3106054,
  },
  {
    name: "El Vendrell",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3106180,
  },
  {
    name: "Valls",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3106492,
  },
  {
    name: "Valladolid",
    country: "Spain",
    subcountry: "Castille and León",
    geonameid: 3106672,
  },
  {
    name: "Valdemoro",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3106868,
  },
  {
    name: "Rivas-Vaciamadrid",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3107112,
  },
  {
    name: "Utebo",
    country: "Spain",
    subcountry: "Aragon",
    geonameid: 3107139,
  },
  {
    name: "Tui",
    country: "Spain",
    subcountry: "Galicia",
    geonameid: 3107364,
  },
  {
    name: "Tudela",
    country: "Spain",
    subcountry: "Navarre",
    geonameid: 3107418,
  },
  {
    name: "Tortosa",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3107677,
  },
  {
    name: "Torrelodones",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3107765,
  },
  {
    name: "Torrelavega",
    country: "Spain",
    subcountry: "Cantabria",
    geonameid: 3107775,
  },
  {
    name: "Torrejón de Ardoz",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3107784,
  },
  {
    name: "Torredembarra",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3107807,
  },
  {
    name: "Tordera",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3107955,
  },
  {
    name: "Tolosa",
    country: "Spain",
    subcountry: "Basque Country",
    geonameid: 3108008,
  },
  {
    name: "Tetuán de las Victorias",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3108118,
  },
  {
    name: "Teruel",
    country: "Spain",
    subcountry: "Aragon",
    geonameid: 3108126,
  },
  {
    name: "Teo",
    country: "Spain",
    subcountry: "Galicia",
    geonameid: 3108165,
  },
  {
    name: "Tàrrega",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3108285,
  },
  {
    name: "Terrassa",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3108286,
  },
  {
    name: "Tarragona",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3108288,
  },
  {
    name: "Tarancón",
    country: "Spain",
    subcountry: "Castille-La Mancha",
    geonameid: 3108317,
  },
  {
    name: "Soria",
    country: "Spain",
    subcountry: "Castille and León",
    geonameid: 3108681,
  },
  {
    name: "Sitges",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3108877,
  },
  {
    name: "Sestao",
    country: "Spain",
    subcountry: "Basque Country",
    geonameid: 3109041,
  },
  {
    name: "Seseña",
    country: "Spain",
    subcountry: "Castille-La Mancha",
    geonameid: 3109050,
  },
  {
    name: "Segovia",
    country: "Spain",
    subcountry: "Castille and León",
    geonameid: 3109256,
  },
  {
    name: "Cerdanyola del Vallès",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3109402,
  },
  {
    name: "Sant Vicenç dels Horts",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3109442,
  },
  {
    name: "Barakaldo",
    country: "Spain",
    subcountry: "Basque Country",
    geonameid: 3109453,
  },
  {
    name: "Santurtzi",
    country: "Spain",
    subcountry: "Basque Country",
    geonameid: 3109481,
  },
  {
    name: "Sants",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3109493,
  },
  {
    name: "Sant Just Desvern",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3109546,
  },
  {
    name: "Santiago de Compostela",
    country: "Spain",
    subcountry: "Galicia",
    geonameid: 3109642,
  },
  {
    name: "Santa Perpètua de Mogoda",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3109689,
  },
  {
    name: "Santander",
    country: "Spain",
    subcountry: "Cantabria",
    geonameid: 3109718,
  },
  {
    name: "Barberà del Vallès",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3109804,
  },
  {
    name: "Santa Uxía de Ribeira",
    country: "Spain",
    subcountry: "Galicia",
    geonameid: 3109897,
  },
  {
    name: "Santa Coloma de Gramenet",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3109981,
  },
  {
    name: "San Sebastián de los Reyes",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3110040,
  },
  {
    name: "Donostia / San Sebastián",
    country: "Spain",
    subcountry: "Basque Country",
    geonameid: 3110044,
  },
  {
    name: "Sant Quirze del Vallès",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3110101,
  },
  {
    name: "Sant Pere de Ribes",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3110143,
  },
  {
    name: "San Martín de la Vega",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3110360,
  },
  {
    name: "San Lorenzo de El Escorial",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3110458,
  },
  {
    name: "Vilassar de Mar",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3110516,
  },
  {
    name: "Sant Joan Despí",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3110519,
  },
  {
    name: "Sanxenxo",
    country: "Spain",
    subcountry: "Galicia",
    geonameid: 3110610,
  },
  {
    name: "San Fernando de Henares",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3110627,
  },
  {
    name: "Sant Feliu de Llobregat",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3110642,
  },
  {
    name: "Sant Feliu de Guíxols",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3110643,
  },
  {
    name: "Sant Cugat del Vallès",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3110718,
  },
  {
    name: "Sant Celoni",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3110813,
  },
  {
    name: "Sant Carles de la Ràpita",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3110821,
  },
  {
    name: "Sant Boi de Llobregat",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3110834,
  },
  {
    name: "Sant Andreu",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3110876,
  },
  {
    name: "San Andrés del Rabanedo",
    country: "Spain",
    subcountry: "Castille and León",
    geonameid: 3110880,
  },
  {
    name: "Sant Andreu de la Barca",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3110885,
  },
  {
    name: "Sant Adrià de Besòs",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3110921,
  },
  {
    name: "Sama",
    country: "Spain",
    subcountry: "Asturias",
    geonameid: 3110962,
  },
  {
    name: "Salt",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3110983,
  },
  {
    name: "Salou",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3110986,
  },
  {
    name: "Salamanca",
    country: "Spain",
    subcountry: "Castille and León",
    geonameid: 3111108,
  },
  {
    name: "Sabadell",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3111199,
  },
  {
    name: "Rubí",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3111294,
  },
  {
    name: "Roses",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3111348,
  },
  {
    name: "Ripollet",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3111605,
  },
  {
    name: "Ribeira",
    country: "Spain",
    subcountry: "Galicia",
    geonameid: 3111807,
  },
  {
    name: "Reus",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3111933,
  },
  {
    name: "Errenteria",
    country: "Spain",
    subcountry: "Basque Country",
    geonameid: 3112011,
  },
  {
    name: "Redondela",
    country: "Spain",
    subcountry: "Galicia",
    geonameid: 3112154,
  },
  {
    name: "Puente de Vallecas",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3112737,
  },
  {
    name: "Ponteareas",
    country: "Spain",
    subcountry: "Galicia",
    geonameid: 3112761,
  },
  {
    name: "Premià de Mar",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3112866,
  },
  {
    name: "Pozuelo de Alarcón",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3112989,
  },
  {
    name: "Poio",
    country: "Spain",
    subcountry: "Galicia",
    geonameid: 3113035,
  },
  {
    name: "Portugalete",
    country: "Spain",
    subcountry: "Basque Country",
    geonameid: 3113082,
  },
  {
    name: "Porriño",
    country: "Spain",
    subcountry: "Galicia",
    geonameid: 3113157,
  },
  {
    name: "Pontevedra",
    country: "Spain",
    subcountry: "Galicia",
    geonameid: 3113209,
  },
  {
    name: "Ponferrada",
    country: "Spain",
    subcountry: "Castille and León",
    geonameid: 3113236,
  },
  {
    name: "Plasencia",
    country: "Spain",
    subcountry: "Extremadura",
    geonameid: 3113331,
  },
  {
    name: "Pinto",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3113415,
  },
  {
    name: "Pineda de Mar",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3113526,
  },
  {
    name: "Piera",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3113576,
  },
  {
    name: "Parla",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3114256,
  },
  {
    name: "Parets del Vallès",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3114267,
  },
  {
    name: "Pamplona",
    country: "Spain",
    subcountry: "Navarre",
    geonameid: 3114472,
  },
  {
    name: "Palencia",
    country: "Spain",
    subcountry: "Castille and León",
    geonameid: 3114531,
  },
  {
    name: "Palamós",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3114566,
  },
  {
    name: "Palafrugell",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3114567,
  },
  {
    name: "Oviedo",
    country: "Spain",
    subcountry: "Asturias",
    geonameid: 3114711,
  },
  {
    name: "Oria",
    country: "Spain",
    subcountry: "Basque Country",
    geonameid: 3114957,
  },
  {
    name: "Ourense",
    country: "Spain",
    subcountry: "Galicia",
    geonameid: 3114965,
  },
  {
    name: "Olot",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3115093,
  },
  {
    name: "Olesa de Montserrat",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3115171,
  },
  {
    name: "Oleiros",
    country: "Spain",
    subcountry: "Galicia",
    geonameid: 3115177,
  },
  {
    name: "Nigrán",
    country: "Spain",
    subcountry: "Galicia",
    geonameid: 3115463,
  },
  {
    name: "Navalcarnero",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3115659,
  },
  {
    name: "Narón",
    country: "Spain",
    subcountry: "Galicia",
    geonameid: 3115739,
  },
  {
    name: "Mungia",
    country: "Spain",
    subcountry: "Basque Country",
    geonameid: 3115907,
  },
  {
    name: "Móstoles",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3116025,
  },
  {
    name: "Moratalaz",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3116156,
  },
  {
    name: "Monzón",
    country: "Spain",
    subcountry: "Aragon",
    geonameid: 3116224,
  },
  {
    name: "Montornès del Vallès",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3116262,
  },
  {
    name: "Monforte de Lemos",
    country: "Spain",
    subcountry: "Galicia",
    geonameid: 3116478,
  },
  {
    name: "Arrasate / Mondragón",
    country: "Spain",
    subcountry: "Basque Country",
    geonameid: 3116503,
  },
  {
    name: "Montcada i Reixac",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3116527,
  },
  {
    name: "Mollet del Vallès",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3116553,
  },
  {
    name: "Molins de Rei",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3116562,
  },
  {
    name: "Moaña",
    country: "Spain",
    subcountry: "Galicia",
    geonameid: 3116653,
  },
  {
    name: "Miranda de Ebro",
    country: "Spain",
    subcountry: "Castille and León",
    geonameid: 3116689,
  },
  {
    name: "Mieres",
    country: "Spain",
    subcountry: "Asturias",
    geonameid: 3116789,
  },
  {
    name: "Mejorada del Campo",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3116963,
  },
  {
    name: "Medina del Campo",
    country: "Spain",
    subcountry: "Castille and León",
    geonameid: 3117010,
  },
  {
    name: "Mataró",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3117164,
  },
  {
    name: "El Masnou",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3117232,
  },
  {
    name: "Martorell",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3117331,
  },
  {
    name: "Marín",
    country: "Spain",
    subcountry: "Galicia",
    geonameid: 3117409,
  },
  {
    name: "Manresa",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3117533,
  },
  {
    name: "Manlleu",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3117539,
  },
  {
    name: "Malgrat de Mar",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3117636,
  },
  {
    name: "Majadahonda",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3117667,
  },
  {
    name: "Madrid",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3117735,
  },
  {
    name: "Lugo",
    country: "Spain",
    subcountry: "Galicia",
    geonameid: 3117814,
  },
  {
    name: "Logroño",
    country: "Spain",
    subcountry: "La Rioja",
    geonameid: 3118150,
  },
  {
    name: "Lloret de Mar",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3118212,
  },
  {
    name: "Laudio / Llodio",
    country: "Spain",
    subcountry: "Basque Country",
    geonameid: 3118228,
  },
  {
    name: "Lleida",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3118514,
  },
  {
    name: "León",
    country: "Spain",
    subcountry: "Castille and León",
    geonameid: 3118532,
  },
  {
    name: "Leioa",
    country: "Spain",
    subcountry: "Basque Country",
    geonameid: 3118554,
  },
  {
    name: "Leganés",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3118594,
  },
  {
    name: "Las Rozas de Madrid",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3118848,
  },
  {
    name: "Lasarte",
    country: "Spain",
    subcountry: "Basque Country",
    geonameid: 3119027,
  },
  {
    name: "La Sagrera",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3119045,
  },
  {
    name: "Sant Pere, Santa Caterina i La Ribera",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3119123,
  },
  {
    name: "La Pineda",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3119231,
  },
  {
    name: "Lalín",
    country: "Spain",
    subcountry: "Galicia",
    geonameid: 3119536,
  },
  {
    name: "Laguna de Duero",
    country: "Spain",
    subcountry: "Castille and León",
    geonameid: 3119631,
  },
  {
    name: "A Estrada",
    country: "Spain",
    subcountry: "Galicia",
    geonameid: 3119746,
  },
  {
    name: "A Coruña",
    country: "Spain",
    subcountry: "Galicia",
    geonameid: 3119841,
  },
  {
    name: "Irun",
    country: "Spain",
    subcountry: "Basque Country",
    geonameid: 3120304,
  },
  {
    name: "Illescas",
    country: "Spain",
    subcountry: "Castille-La Mancha",
    geonameid: 3120410,
  },
  {
    name: "Igualada",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3120431,
  },
  {
    name: "Humanes de Madrid",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3120501,
  },
  {
    name: "Huesca",
    country: "Spain",
    subcountry: "Aragon",
    geonameid: 3120514,
  },
  {
    name: "L'Hospitalet de Llobregat",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3120619,
  },
  {
    name: "Hortaleza",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3120635,
  },
  {
    name: "Horta",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3120637,
  },
  {
    name: "Hernani",
    country: "Spain",
    subcountry: "Basque Country",
    geonameid: 3120811,
  },
  {
    name: "Gernika-Lumo",
    country: "Spain",
    subcountry: "Basque Country",
    geonameid: 3120989,
  },
  {
    name: "Getxo",
    country: "Spain",
    subcountry: "Basque Country",
    geonameid: 3121007,
  },
  {
    name: "Guadalajara",
    country: "Spain",
    subcountry: "Castille-La Mancha",
    geonameid: 3121070,
  },
  {
    name: "Granollers",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3121145,
  },
  {
    name: "Gràcia",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3121245,
  },
  {
    name: "Gijón",
    country: "Spain",
    subcountry: "Asturias",
    geonameid: 3121424,
  },
  {
    name: "Getafe",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3121437,
  },
  {
    name: "Girona",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3121456,
  },
  {
    name: "Gavà",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3121519,
  },
  {
    name: "Gamonal",
    country: "Spain",
    subcountry: "Castille and León",
    geonameid: 3121663,
  },
  {
    name: "Galdakao",
    country: "Spain",
    subcountry: "Basque Country",
    geonameid: 3121751,
  },
  {
    name: "Galapagar",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3121766,
  },
  {
    name: "Hondarribia",
    country: "Spain",
    subcountry: "Basque Country",
    geonameid: 3121881,
  },
  {
    name: "Fuenlabrada",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3121960,
  },
  {
    name: "Figueres",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3122453,
  },
  {
    name: "Esplugues de Llobregat",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3122826,
  },
  {
    name: "Esparreguera",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3122912,
  },
  {
    name: "Ermua",
    country: "Spain",
    subcountry: "Basque Country",
    geonameid: 3123063,
  },
  {
    name: "Erandio",
    country: "Spain",
    subcountry: "Basque Country",
    geonameid: 3123104,
  },
  {
    name: "El Prat de Llobregat",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3123329,
  },
  {
    name: "Ferrol",
    country: "Spain",
    subcountry: "Galicia",
    geonameid: 3123493,
  },
  {
    name: "El Escorial",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3123504,
  },
  {
    name: "El Astillero",
    country: "Spain",
    subcountry: "Cantabria",
    geonameid: 3123667,
  },
  {
    name: "el Raval",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3123673,
  },
  {
    name: "Ejea de los Caballeros",
    country: "Spain",
    subcountry: "Aragon",
    geonameid: 3123688,
  },
  {
    name: "Eibar",
    country: "Spain",
    subcountry: "Basque Country",
    geonameid: 3123709,
  },
  {
    name: "Durango",
    country: "Spain",
    subcountry: "Basque Country",
    geonameid: 3123773,
  },
  {
    name: "Culleredo",
    country: "Spain",
    subcountry: "Galicia",
    geonameid: 3124041,
  },
  {
    name: "Cuenca",
    country: "Spain",
    subcountry: "Castille-La Mancha",
    geonameid: 3124132,
  },
  {
    name: "Coslada",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3124408,
  },
  {
    name: "Cornellà de Llobregat",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3124569,
  },
  {
    name: "Colmenar Viejo",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3124765,
  },
  {
    name: "Collado-Villalba",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3124794,
  },
  {
    name: "el Clot",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3124932,
  },
  {
    name: "Ciudad Lineal",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3124964,
  },
  {
    name: "Ciutadella",
    country: "Spain",
    subcountry: "Balearic Islands",
    geonameid: 3124967,
  },
  {
    name: "Ciempozuelos",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3125082,
  },
  {
    name: "Chamartín",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3125239,
  },
  {
    name: "Castro-Urdiales",
    country: "Spain",
    subcountry: "Cantabria",
    geonameid: 3125621,
  },
  {
    name: "Castelldefels",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3125897,
  },
  {
    name: "Castellar del Vallès",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3125915,
  },
  {
    name: "Cardedeu",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3126317,
  },
  {
    name: "Carballo",
    country: "Spain",
    subcountry: "Galicia",
    geonameid: 3126369,
  },
  {
    name: "Canovelles",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3126534,
  },
  {
    name: "Cangas do Morrazo",
    country: "Spain",
    subcountry: "Galicia",
    geonameid: 3126577,
  },
  {
    name: "Cambrils",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3126888,
  },
  {
    name: "Cambre",
    country: "Spain",
    subcountry: "Galicia",
    geonameid: 3126890,
  },
  {
    name: "Camargo",
    country: "Spain",
    subcountry: "Cantabria",
    geonameid: 3126917,
  },
  {
    name: "Calella",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3127007,
  },
  {
    name: "Caldes de Montbui",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3127035,
  },
  {
    name: "Calatayud",
    country: "Spain",
    subcountry: "Aragon",
    geonameid: 3127047,
  },
  {
    name: "Calahorra",
    country: "Spain",
    subcountry: "La Rioja",
    geonameid: 3127065,
  },
  {
    name: "Calafell",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3127066,
  },
  {
    name: "Burlata",
    country: "Spain",
    subcountry: "Navarre",
    geonameid: 3127451,
  },
  {
    name: "Burgos",
    country: "Spain",
    subcountry: "Castille and León",
    geonameid: 3127461,
  },
  {
    name: "Boiro",
    country: "Spain",
    subcountry: "Galicia",
    geonameid: 3127889,
  },
  {
    name: "Boadilla del Monte",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3127958,
  },
  {
    name: "Blanes",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3127978,
  },
  {
    name: "Bilbao",
    country: "Spain",
    subcountry: "Basque Country",
    geonameid: 3128026,
  },
  {
    name: "Bermeo",
    country: "Spain",
    subcountry: "Basque Country",
    geonameid: 3128174,
  },
  {
    name: "Berga",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3128201,
  },
  {
    name: "Benicàssim",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 3128272,
  },
  {
    name: "Benicarló",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 3128273,
  },
  {
    name: "Benavente",
    country: "Spain",
    subcountry: "Castille and León",
    geonameid: 3128291,
  },
  {
    name: "Béjar",
    country: "Spain",
    subcountry: "Castille and León",
    geonameid: 3128382,
  },
  {
    name: "la Barceloneta",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3128757,
  },
  {
    name: "Barcelona",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3128760,
  },
  {
    name: "Barbastro",
    country: "Spain",
    subcountry: "Aragon",
    geonameid: 3128795,
  },
  {
    name: "Barañáin",
    country: "Spain",
    subcountry: "Navarre",
    geonameid: 3128824,
  },
  {
    name: "Barajas de Madrid",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3128832,
  },
  {
    name: "Banyoles",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3128885,
  },
  {
    name: "Balaguer",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3128978,
  },
  {
    name: "Badalona",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3129028,
  },
  {
    name: "Azuqueca de Henares",
    country: "Spain",
    subcountry: "Castille-La Mancha",
    geonameid: 3129046,
  },
  {
    name: "Avilés",
    country: "Spain",
    subcountry: "Asturias",
    geonameid: 3129135,
  },
  {
    name: "Ávila",
    country: "Spain",
    subcountry: "Castille and León",
    geonameid: 3129136,
  },
  {
    name: "Arteixo",
    country: "Spain",
    subcountry: "Galicia",
    geonameid: 3129329,
  },
  {
    name: "Arroyomolinos",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3129356,
  },
  {
    name: "Arganda",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3129636,
  },
  {
    name: "Arenys de Mar",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3129661,
  },
  {
    name: "Aranjuez",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3129857,
  },
  {
    name: "Aranda de Duero",
    country: "Spain",
    subcountry: "Castille and León",
    geonameid: 3129877,
  },
  {
    name: "Amposta",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 3130131,
  },
  {
    name: "Amorebieta",
    country: "Spain",
    subcountry: "Basque Country",
    geonameid: 3130137,
  },
  {
    name: "Algorta",
    country: "Spain",
    subcountry: "Basque Country",
    geonameid: 3130380,
  },
  {
    name: "Algete",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3130383,
  },
  {
    name: "Alcorcón",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3130564,
  },
  {
    name: "Alcobendas",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3130583,
  },
  {
    name: "Alcañiz",
    country: "Spain",
    subcountry: "Aragon",
    geonameid: 3130606,
  },
  {
    name: "Alcalá de Henares",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 3130616,
  },
  {
    name: "Nou Barris",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 6252065,
  },
  {
    name: "Pinar de Chamartín",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 6324376,
  },
  {
    name: "Playa del Ingles",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 6354969,
  },
  {
    name: "Puerto del Carmen",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 6355013,
  },
  {
    name: "Ceuta",
    country: "Spain",
    subcountry: "Ceuta",
    geonameid: 6362987,
  },
  {
    name: "Moncloa-Aravaca",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 6544099,
  },
  {
    name: "Eixample",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 6544100,
  },
  {
    name: "Les Corts",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 6544101,
  },
  {
    name: "Sarrià-Sant Gervasi",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 6544102,
  },
  {
    name: "Horta-Guinardó",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 6544103,
  },
  {
    name: "Sants-Montjuïc",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 6544104,
  },
  {
    name: "Sant Martí",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 6544105,
  },
  {
    name: "Ciutat Vella",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 6544106,
  },
  {
    name: "Arganzuela",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 6544487,
  },
  {
    name: "San Blas-Canillejas",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 6544488,
  },
  {
    name: "Latina",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 6544489,
  },
  {
    name: "Usera",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 6544490,
  },
  {
    name: "Salamanca",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 6544491,
  },
  {
    name: "Chamberí",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 6544492,
  },
  {
    name: "Carabanchel",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 6544493,
  },
  {
    name: "Madrid Centro",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 6544494,
  },
  {
    name: "Retiro",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 6544495,
  },
  {
    name: "Barri Gòtic",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 6544577,
  },
  {
    name: "Poble Sec",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 6545103,
  },
  {
    name: "Hostafrancs",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 6545104,
  },
  {
    name: "La Bordeta",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 6545105,
  },
  {
    name: "La Bonanova",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 6545107,
  },
  {
    name: "Las Tres Torres",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 6545108,
  },
  {
    name: "el Poblenou",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 6545114,
  },
  {
    name: "El Carmel",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 6545261,
  },
  {
    name: "l'Alfàs del Pi",
    country: "Spain",
    subcountry: "Valencia",
    geonameid: 6559503,
  },
  {
    name: "Las Gabias",
    country: "Spain",
    subcountry: "Andalusia",
    geonameid: 6559641,
  },
  {
    name: "Delicias",
    country: "Spain",
    subcountry: "Aragon",
    geonameid: 6615440,
  },
  {
    name: "Almozara",
    country: "Spain",
    subcountry: "Aragon",
    geonameid: 6615442,
  },
  {
    name: "Montecanal",
    country: "Spain",
    subcountry: "Aragon",
    geonameid: 6615443,
  },
  {
    name: "Oliver-Valdefierro",
    country: "Spain",
    subcountry: "Aragon",
    geonameid: 6615444,
  },
  {
    name: "Santutxu",
    country: "Spain",
    subcountry: "Basque Country",
    geonameid: 6618856,
  },
  {
    name: "Fort Pienc",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 6690784,
  },
  {
    name: "Dreta de l'Eixample",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 6690786,
  },
  {
    name: "Vallcarca",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 6690791,
  },
  {
    name: "Sagrada Família",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 6690794,
  },
  {
    name: "Sant Martí de Provençals",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 6690839,
  },
  {
    name: "Los Realejos",
    country: "Spain",
    subcountry: "Canary Islands",
    geonameid: 6692471,
  },
  {
    name: "Pasaia",
    country: "Spain",
    subcountry: "Basque Country",
    geonameid: 6693088,
  },
  {
    name: "Basauri",
    country: "Spain",
    subcountry: "Basque Country",
    geonameid: 6697039,
  },
  {
    name: "Llefià",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 6943537,
  },
  {
    name: "Corvera de Asturias",
    country: "Spain",
    subcountry: "Asturias",
    geonameid: 7115111,
  },
  {
    name: "Tres Cantos",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 7577022,
  },
  {
    name: "Iturrama",
    country: "Spain",
    subcountry: "Navarre",
    geonameid: 8050879,
  },
  {
    name: "Ermitagaña",
    country: "Spain",
    subcountry: "Navarre",
    geonameid: 8050880,
  },
  {
    name: "Primer Ensanche",
    country: "Spain",
    subcountry: "Navarre",
    geonameid: 8050888,
  },
  {
    name: "Segundo Ensanche",
    country: "Spain",
    subcountry: "Navarre",
    geonameid: 8050889,
  },
  {
    name: "Fuencarral-El Pardo",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 8285534,
  },
  {
    name: "Villa de Vallecas",
    country: "Spain",
    subcountry: "Madrid",
    geonameid: 8285535,
  },
  {
    name: "Natahoyo",
    country: "Spain",
    subcountry: "Asturias",
    geonameid: 8629192,
  },
  {
    name: "Sarrià",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 11549772,
  },
  {
    name: "l'Antiga Esquerra de l'Eixample",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 11549773,
  },
  {
    name: "el Baix Guinardó",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 11549774,
  },
  {
    name: "la Prosperitat",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 11549776,
  },
  {
    name: "el Putxet i el Farró",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 11549777,
  },
  {
    name: "Provenals del Poblenou",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 11549778,
  },
  {
    name: "Sant Antoni",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 11549779,
  },
  {
    name: "la Vila de Gràcia",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 11549783,
  },
  {
    name: "la Nova Esquerra de l'Eixample",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 11549784,
  },
  {
    name: "Porta",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 11549785,
  },
  {
    name: "Sants - Badal",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 11549787,
  },
  {
    name: "la Maternitat i Sant Ramon",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 11549788,
  },
  {
    name: "Sant Gervasi - Galvany",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 11549789,
  },
  {
    name: "el Camp d'en Grassot i Gràcia Nova",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 11549791,
  },
  {
    name: "la Marina de Port",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 11549793,
  },
  {
    name: "Vilapicina i la Torre Llobeta",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 11549794,
  },
  {
    name: "el Camp de l'Arpa del Clot",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 11549795,
  },
  {
    name: "Navas",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 11549805,
  },
  {
    name: "la Guineueta",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 11549806,
  },
  {
    name: "les Roquetes",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 11549807,
  },
  {
    name: "la Verneda i la Pau",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 11549811,
  },
  {
    name: "el Turó de la Peira",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 11549813,
  },
  {
    name: "el Besòs i el Maresme",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 11549814,
  },
  {
    name: "el Guinardó",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 11549815,
  },
  {
    name: "Barri de Sant Andreu",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 11549820,
  },
  {
    name: "Barri de les Corts",
    country: "Spain",
    subcountry: "Catalonia",
    geonameid: 11549821,
  },
  {
    name: "Addis Ababa",
    country: "Ethiopia",
    subcountry: "Addis Ababa",
    geonameid: 344979,
  },
  {
    name: "Nazret",
    country: "Ethiopia",
    subcountry: "Oromiya",
    geonameid: 330186,
  },
  {
    name: "Hawassa",
    country: "Ethiopia",
    subcountry: "SNNPR",
    geonameid: 343137,
  },
  {
    name: "Bishoftu",
    country: "Ethiopia",
    subcountry: "Oromiya",
    geonameid: 339666,
  },
  {
    name: "Dire Dawa",
    country: "Ethiopia",
    subcountry: "Dire Dawa",
    geonameid: 338832,
  },
  {
    name: "Mekele",
    country: "Ethiopia",
    subcountry: "Tigray",
    geonameid: 331180,
  },
  {
    name: "Bahir Dar",
    country: "Ethiopia",
    subcountry: "Amhara",
    geonameid: 342884,
  },
  {
    name: "Dila",
    country: "Ethiopia",
    subcountry: "SNNPR",
    geonameid: 338998,
  },
  {
    name: "Ziway",
    country: "Ethiopia",
    subcountry: "Oromiya",
    geonameid: 325579,
  },
  {
    name: "Yirga Alem",
    country: "Ethiopia",
    subcountry: "SNNPR",
    geonameid: 325780,
  },
  {
    name: "Yabelo",
    country: "Ethiopia",
    subcountry: "Oromiya",
    geonameid: 326036,
  },
  {
    name: "Werota",
    country: "Ethiopia",
    subcountry: "Amhara",
    geonameid: 326206,
  },
  {
    name: "Wenji",
    country: "Ethiopia",
    subcountry: "Oromiya",
    geonameid: 326308,
  },
  {
    name: "Tepi",
    country: "Ethiopia",
    subcountry: "SNNPR",
    geonameid: 327694,
  },
  {
    name: "Shashemene",
    country: "Ethiopia",
    subcountry: "Oromiya",
    geonameid: 328689,
  },
  {
    name: "Shambu",
    country: "Ethiopia",
    subcountry: "Oromiya",
    geonameid: 328709,
  },
  {
    name: "Shakiso",
    country: "Ethiopia",
    subcountry: "Oromiya",
    geonameid: 328716,
  },
  {
    name: "Sebeta",
    country: "Ethiopia",
    subcountry: "Oromiya",
    geonameid: 329114,
  },
  {
    name: "Robit",
    country: "Ethiopia",
    subcountry: "Amhara",
    geonameid: 329586,
  },
  {
    name: "Waal",
    country: "Ethiopia",
    subcountry: "Somali",
    geonameid: 53904,
  },
  {
    name: "Fadhigaradle",
    country: "Ethiopia",
    subcountry: "Somali",
    geonameid: 62780,
  },
  {
    name: "Nejo",
    country: "Ethiopia",
    subcountry: "Oromiya",
    geonameid: 330120,
  },

  {
    name: "Mojo",
    country: "Ethiopia",
    subcountry: "Oromiya",
    geonameid: 330491,
  },
  {
    name: "Metu",
    country: "Ethiopia",
    subcountry: "Oromiya",
    geonameid: 330764,
  },
  {
    name: "Metahara",
    country: "Ethiopia",
    subcountry: "Oromiya",
    geonameid: 330811,
  },
  {
    name: "Mendi",
    country: "Ethiopia",
    subcountry: "Oromiya",
    geonameid: 331038,
  },

  {
    name: "Maychew",
    country: "Ethiopia",
    subcountry: "Tigray",
    geonameid: 331416,
  },
  {
    name: "Korem",
    country: "Ethiopia",
    subcountry: "Tigray",
    geonameid: 332746,
  },
  {
    name: "Kolito",
    country: "Ethiopia",
    subcountry: "SNNPR",
    geonameid: 332880,
  },
  {
    name: "Kibre Mengist",
    country: "Ethiopia",
    subcountry: "Oromiya",
    geonameid: 333103,
  },
  {
    name: "Kemise",
    country: "Ethiopia",
    subcountry: "Amhara",
    geonameid: 333356,
  },
  {
    name: "Kombolcha",
    country: "Ethiopia",
    subcountry: "Amhara",
    geonameid: 333373,
  },
  {
    name: "Jinka",
    country: "Ethiopia",
    subcountry: "SNNPR",
    geonameid: 333750,
  },
  {
    name: "Jimma",
    country: "Ethiopia",
    subcountry: "Oromiya",
    geonameid: 333772,
  },
  {
    name: "Jijiga",
    country: "Ethiopia",
    subcountry: "Somali",
    geonameid: 333795,
  },
  {
    name: "Inda Silase",
    country: "Ethiopia",
    subcountry: "Tigray",
    geonameid: 334227,
  },
  {
    name: "Hosaina",
    country: "Ethiopia",
    subcountry: "SNNPR",
    geonameid: 334609,
  },
  {
    name: "Harar",
    country: "Ethiopia",
    subcountry: "Harari",
    geonameid: 335035,
  },
  {
    name: "Hagere Hiywet",
    country: "Ethiopia",
    subcountry: "Oromiya",
    geonameid: 335288,
  },
  {
    name: "El Bahay",
    country: "Ethiopia",
    subcountry: "Somali",
    geonameid: 335425,
  },
  {
    name: "Gondar",
    country: "Ethiopia",
    subcountry: "Amhara",
    geonameid: 336014,
  },
  {
    name: "Goba",
    country: "Ethiopia",
    subcountry: "Oromiya",
    geonameid: 336350,
  },
  {
    name: "Waliso",
    country: "Ethiopia",
    subcountry: "Oromiya",
    geonameid: 336372,
  },
  {
    name: "Ginir",
    country: "Ethiopia",
    subcountry: "Oromiya",
    geonameid: 336454,
  },
  {
    name: "Gimbi",
    country: "Ethiopia",
    subcountry: "Oromiya",
    geonameid: 336496,
  },
  {
    name: "Raqo",
    country: "Ethiopia",
    subcountry: "Somali",
    geonameid: 336511,
  },
  {
    name: "Genet",
    country: "Ethiopia",
    subcountry: "Oromiya",
    geonameid: 336931,
  },
  {
    name: "Gelemso",
    country: "Ethiopia",
    subcountry: "Oromiya",
    geonameid: 337010,
  },
  {
    name: "Gebre Guracha",
    country: "Ethiopia",
    subcountry: "Oromiya",
    geonameid: 337152,
  },
  {
    name: "Gambela",
    country: "Ethiopia",
    subcountry: "Gambela",
    geonameid: 337405,
  },
  {
    name: "Finote Selam",
    country: "Ethiopia",
    subcountry: "Amhara",
    geonameid: 337712,
  },
  {
    name: "Fiche",
    country: "Ethiopia",
    subcountry: "Oromiya",
    geonameid: 337771,
  },
  {
    name: "Felege Neway",
    country: "Ethiopia",
    subcountry: "SNNPR",
    geonameid: 337853,
  },
  {
    name: "Golwayn",
    country: "Ethiopia",
    subcountry: "Somali",
    geonameid: 338123,
  },
  {
    name: "Dubti",
    country: "Ethiopia",
    subcountry: "Āfar",
    geonameid: 338554,
  },
  {
    name: "Dodola",
    country: "Ethiopia",
    subcountry: "Oromiya",
    geonameid: 338726,
  },

  {
    name: "Dese",
    country: "Ethiopia",
    subcountry: "Amhara",
    geonameid: 339219,
  },
  {
    name: "Dembi Dolo",
    country: "Ethiopia",
    subcountry: "Oromiya",
    geonameid: 339448,
  },

  {
    name: "Debre Tabor",
    country: "Ethiopia",
    subcountry: "Amhara",
    geonameid: 339686,
  },
  {
    name: "Debre Markos",
    country: "Ethiopia",
    subcountry: "Amhara",
    geonameid: 339708,
  },
  {
    name: "Debre Birhan",
    country: "Ethiopia",
    subcountry: "Amhara",
    geonameid: 339734,
  },
  {
    name: "Debark",
    country: "Ethiopia",
    subcountry: "Amhara",
    geonameid: 339823,
  },
  {
    name: "Butajira",
    country: "Ethiopia",
    subcountry: "SNNPR",
    geonameid: 341297,
  },
  {
    name: "Bure",
    country: "Ethiopia",
    subcountry: "Amhara",
    geonameid: 341397,
  },
  {
    name: "Bonga",
    country: "Ethiopia",
    subcountry: "SNNPR",
    geonameid: 341742,
  },
  {
    name: "Boditi",
    country: "Ethiopia",
    subcountry: "SNNPR",
    geonameid: 341877,
  },
  {
    name: "Bichena",
    country: "Ethiopia",
    subcountry: "Amhara",
    geonameid: 342190,
  },
  {
    name: "Bedesa",
    country: "Ethiopia",
    subcountry: "Oromiya",
    geonameid: 342559,
  },
  {
    name: "Bedele",
    country: "Ethiopia",
    subcountry: "Oromiya",
    geonameid: 342567,
  },
  {
    name: "Bati",
    country: "Ethiopia",
    subcountry: "Amhara",
    geonameid: 342641,
  },
  {
    name: "Bako",
    country: "Ethiopia",
    subcountry: "SNNPR",
    geonameid: 342856,
  },

  {
    name: "Āsosa",
    country: "Ethiopia",
    subcountry: "Bīnshangul Gumuz",
    geonameid: 343292,
  },
  {
    name: "Asbe Teferi",
    country: "Ethiopia",
    subcountry: "Oromiya",
    geonameid: 343402,
  },
  {
    name: "Asaita",
    country: "Ethiopia",
    subcountry: "Āfar",
    geonameid: 343409,
  },
  {
    name: "Asasa",
    country: "Ethiopia",
    subcountry: "Oromiya",
    geonameid: 343413,
  },
  {
    name: "Areka",
    country: "Ethiopia",
    subcountry: "SNNPR",
    geonameid: 343593,
  },
  {
    name: "Arba Minch",
    country: "Ethiopia",
    subcountry: "SNNPR",
    geonameid: 343663,
  },
  {
    name: "Axum",
    country: "Ethiopia",
    subcountry: "Tigray",
    geonameid: 344420,
  },
  {
    name: "Hagere Maryam",
    country: "Ethiopia",
    subcountry: "Oromiya",
    geonameid: 344620,
  },
  {
    name: "Agaro",
    country: "Ethiopia",
    subcountry: "Oromiya",
    geonameid: 344661,
  },
  {
    name: "Ādis Zemen",
    country: "Ethiopia",
    subcountry: "Amhara",
    geonameid: 344923,
  },

  {
    name: "Adigrat",
    country: "Ethiopia",
    subcountry: "Tigray",
    geonameid: 345149,
  },
  {
    name: "Adet",
    country: "Ethiopia",
    subcountry: "Amhara",
    geonameid: 345353,
  },
  {
    name: "Abomsa",
    country: "Ethiopia",
    subcountry: "Amhara",
    geonameid: 345704,
  },
  {
    name: "Qorof",
    country: "Ethiopia",
    subcountry: "Somali",
    geonameid: 444998,
  },
  {
    name: "Kahandhale",
    country: "Ethiopia",
    subcountry: "Somali",
    geonameid: 6311119,
  },
  {
    name: "Lasoano",
    country: "Ethiopia",
    subcountry: "Somali",
    geonameid: 6311120,
  },
  {
    name: "Neefkuceliye",
    country: "Ethiopia",
    subcountry: "Somali",
    geonameid: 6311121,
  },
  {
    name: "Yamarugley",
    country: "Ethiopia",
    subcountry: "Somali",
    geonameid: 6311122,
  },
  {
    name: "Sodo",
    country: "Ethiopia",
    subcountry: "SNNPR",
    geonameid: 7910079,
  },
  {
    name: "Digih Habar Es",
    country: "Ethiopia",
    subcountry: "Somali",
    geonameid: 10239401,
  },
  {
    name: "Ylojarvi",
    country: "Finland",
    subcountry: "Pirkanmaa",
    geonameid: 630752,
  },
  {
    name: "Vuosaari",
    country: "Finland",
    subcountry: "Uusimaa",
    geonameid: 631077,
  },
  {
    name: "Vihti",
    country: "Finland",
    subcountry: "Uusimaa",
    geonameid: 631707,
  },
  {
    name: "Varkaus",
    country: "Finland",
    subcountry: "North Savo",
    geonameid: 632370,
  },
  {
    name: "Vantaa",
    country: "Finland",
    subcountry: "Uusimaa",
    geonameid: 632453,
  },
  {
    name: "Valkeakoski",
    country: "Finland",
    subcountry: "Pirkanmaa",
    geonameid: 632672,
  },
  {
    name: "Vaasa",
    country: "Finland",
    subcountry: "Ostrobothnia",
    geonameid: 632978,
  },
  {
    name: "Uusikaupunki",
    country: "Finland",
    subcountry: "Southwest Finland",
    geonameid: 633221,
  },
  {
    name: "Tuusula",
    country: "Finland",
    subcountry: "Uusimaa",
    geonameid: 633591,
  },
  {
    name: "Turku",
    country: "Finland",
    subcountry: "Southwest Finland",
    geonameid: 633679,
  },
  {
    name: "Tornio",
    country: "Finland",
    subcountry: "Lapland",
    geonameid: 634093,
  },
  {
    name: "Tampere",
    country: "Finland",
    subcountry: "Pirkanmaa",
    geonameid: 634963,
  },
  {
    name: "Siilinjärvi",
    country: "Finland",
    subcountry: "North Savo",
    geonameid: 636947,
  },
  {
    name: "Sibbo",
    country: "Finland",
    subcountry: "Uusimaa",
    geonameid: 637067,
  },
  {
    name: "Seinäjoki",
    country: "Finland",
    subcountry: "South Ostrobothnia",
    geonameid: 637219,
  },
  {
    name: "Savonlinna",
    country: "Finland",
    subcountry: "South Savo",
    geonameid: 637292,
  },
  {
    name: "Salo",
    country: "Finland",
    subcountry: "Southwest Finland",
    geonameid: 637948,
  },
  {
    name: "Rovaniemi",
    country: "Finland",
    subcountry: "Lapland",
    geonameid: 638936,
  },
  {
    name: "Riihimäki",
    country: "Finland",
    subcountry: "Kanta-Häme",
    geonameid: 639406,
  },
  {
    name: "Rauma",
    country: "Finland",
    subcountry: "Satakunta",
    geonameid: 639734,
  },
  {
    name: "Raisio",
    country: "Finland",
    subcountry: "Southwest Finland",
    geonameid: 640124,
  },
  {
    name: "Raahe",
    country: "Finland",
    subcountry: "North Ostrobothnia",
    geonameid: 640276,
  },
  {
    name: "Pori",
    country: "Finland",
    subcountry: "Satakunta",
    geonameid: 640999,
  },
  {
    name: "Pirkkala",
    country: "Finland",
    subcountry: "Pirkanmaa",
    geonameid: 641489,
  },
  {
    name: "Oulu",
    country: "Finland",
    subcountry: "North Ostrobothnia",
    geonameid: 643492,
  },
  {
    name: "Nurmijärvi",
    country: "Finland",
    subcountry: "Uusimaa",
    geonameid: 644171,
  },
  {
    name: "Nokia",
    country: "Finland",
    subcountry: "Pirkanmaa",
    geonameid: 644450,
  },
  {
    name: "Munkkiniemi",
    country: "Finland",
    subcountry: "Uusimaa",
    geonameid: 645691,
  },
  {
    name: "Mikkeli",
    country: "Finland",
    subcountry: "South Savo",
    geonameid: 646005,
  },
  {
    name: "Mellunkylä",
    country: "Finland",
    subcountry: "Uusimaa",
    geonameid: 646218,
  },
  {
    name: "Mäntsälä",
    country: "Finland",
    subcountry: "Uusimaa",
    geonameid: 646723,
  },
  {
    name: "Lovisa",
    country: "Finland",
    subcountry: "Uusimaa",
    geonameid: 647571,
  },
  {
    name: "Loimaa",
    country: "Finland",
    subcountry: "Southwest Finland",
    geonameid: 647731,
  },
  {
    name: "Lohja",
    country: "Finland",
    subcountry: "Uusimaa",
    geonameid: 647751,
  },
  {
    name: "Lieto",
    country: "Finland",
    subcountry: "Southwest Finland",
    geonameid: 648056,
  },
  {
    name: "Lempäälä",
    country: "Finland",
    subcountry: "Pirkanmaa",
    geonameid: 648366,
  },
  {
    name: "Lauttasaari",
    country: "Finland",
    subcountry: "Uusimaa",
    geonameid: 648635,
  },
  {
    name: "Laukaa",
    country: "Finland",
    subcountry: "Central Finland",
    geonameid: 648738,
  },
  {
    name: "Lappeenranta",
    country: "Finland",
    subcountry: "South Karelia",
    geonameid: 648900,
  },
  {
    name: "Lahti",
    country: "Finland",
    subcountry: "Paijat-Hame",
    geonameid: 649360,
  },
  {
    name: "Kirkkonummi",
    country: "Finland",
    subcountry: "Uusimaa",
    geonameid: 649630,
  },
  {
    name: "Kuusamo",
    country: "Finland",
    subcountry: "North Ostrobothnia",
    geonameid: 649924,
  },
  {
    name: "Kuopio",
    country: "Finland",
    subcountry: "North Savo",
    geonameid: 650224,
  },
  {
    name: "Kouvola",
    country: "Finland",
    subcountry: "Kymenlaakso",
    geonameid: 650859,
  },
  {
    name: "Kotka",
    country: "Finland",
    subcountry: "Kymenlaakso",
    geonameid: 650946,
  },
  {
    name: "Korsholm",
    country: "Finland",
    subcountry: "Ostrobothnia",
    geonameid: 651299,
  },
  {
    name: "Kokkola",
    country: "Finland",
    subcountry: "Central Ostrobothnia",
    geonameid: 651943,
  },
  {
    name: "Klaukkala",
    country: "Finland",
    subcountry: "Uusimaa",
    geonameid: 652305,
  },
  {
    name: "Kerava",
    country: "Finland",
    subcountry: "Uusimaa",
    geonameid: 653185,
  },
  {
    name: "Kemi",
    country: "Finland",
    subcountry: "Lapland",
    geonameid: 653281,
  },
  {
    name: "Karhula",
    country: "Finland",
    subcountry: "Kymenlaakso",
    geonameid: 654137,
  },
  {
    name: "Kangasala",
    country: "Finland",
    subcountry: "Pirkanmaa",
    geonameid: 654440,
  },
  {
    name: "Kallio",
    country: "Finland",
    subcountry: "Uusimaa",
    geonameid: 654706,
  },
  {
    name: "Kajaani",
    country: "Finland",
    subcountry: "Kainuu",
    geonameid: 654899,
  },
  {
    name: "Kaarina",
    country: "Finland",
    subcountry: "Southwest Finland",
    geonameid: 655130,
  },
  {
    name: "Kaarela",
    country: "Finland",
    subcountry: "Uusimaa",
    geonameid: 655143,
  },
  {
    name: "Jyväskylä",
    country: "Finland",
    subcountry: "Central Finland",
    geonameid: 655194,
  },
  {
    name: "Joensuu",
    country: "Finland",
    subcountry: "North Karelia",
    geonameid: 655808,
  },
  {
    name: "Järvenpää",
    country: "Finland",
    subcountry: "Uusimaa",
    geonameid: 655958,
  },
  {
    name: "Janakkala",
    country: "Finland",
    subcountry: "Kanta-Häme",
    geonameid: 656073,
  },
  {
    name: "Jämsä",
    country: "Finland",
    subcountry: "Central Finland",
    geonameid: 656083,
  },
  {
    name: "Jakobstad",
    country: "Finland",
    subcountry: "Ostrobothnia",
    geonameid: 656130,
  },
  {
    name: "Imatra",
    country: "Finland",
    subcountry: "South Karelia",
    geonameid: 656688,
  },
  {
    name: "Iisalmi",
    country: "Finland",
    subcountry: "North Savo",
    geonameid: 656820,
  },
  {
    name: "Hyvinge",
    country: "Finland",
    subcountry: "Uusimaa",
    geonameid: 656913,
  },
  {
    name: "Hollola",
    country: "Finland",
    subcountry: "Paijat-Hame",
    geonameid: 657530,
  },
  {
    name: "Helsinki",
    country: "Finland",
    subcountry: "Uusimaa",
    geonameid: 658225,
  },
  {
    name: "Heinola",
    country: "Finland",
    subcountry: "Paijat-Hame",
    geonameid: 658288,
  },
  {
    name: "Haukipudas",
    country: "Finland",
    subcountry: "North Ostrobothnia",
    geonameid: 658629,
  },
  {
    name: "Hamina",
    country: "Finland",
    subcountry: "Kymenlaakso",
    geonameid: 659169,
  },
  {
    name: "Hämeenlinna",
    country: "Finland",
    subcountry: "Kanta-Häme",
    geonameid: 659180,
  },
  {
    name: "Forssa",
    country: "Finland",
    subcountry: "Kanta-Häme",
    geonameid: 659935,
  },
  {
    name: "Espoo",
    country: "Finland",
    subcountry: "Uusimaa",
    geonameid: 660158,
  },
  {
    name: "Porvoo",
    country: "Finland",
    subcountry: "Uusimaa",
    geonameid: 660561,
  },
  {
    name: "Anjala",
    country: "Finland",
    subcountry: "Kymenlaakso",
    geonameid: 661164,
  },
  {
    name: "Väståboland",
    country: "Finland",
    subcountry: "Southwest Finland",
    geonameid: 7911309,
  },
  {
    name: "Suva",
    country: "Fiji",
    subcountry: "Central",
    geonameid: 2198148,
  },
  {
    name: "Sigatoka",
    country: "Fiji",
    subcountry: "Western",
    geonameid: 2198365,
  },
  {
    name: "Nadi",
    country: "Fiji",
    subcountry: "Western",
    geonameid: 2202064,
  },
  {
    name: "Lautoka",
    country: "Fiji",
    subcountry: "Western",
    geonameid: 2204506,
  },
  {
    name: "Labasa",
    country: "Fiji",
    subcountry: "Northern",
    geonameid: 2204582,
  },
  {
    name: "Nasinu",
    country: "Fiji",
    subcountry: "Central",
    geonameid: 8740209,
  },
  {
    name: "Stanley",
    country: "Falkland Islands",
    subcountry: "N/A",
    geonameid: 3426691,
  },
  {
    name: "Palikir - National Government Center",
    country: "Micronesia",
    subcountry: "Pohnpei",
    geonameid: 2081986,
  },
  {
    name: "Tórshavn",
    country: "Faroe Islands",
    subcountry: "Streymoy",
    geonameid: 2611396,
  },
  {
    name: "Yerres",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2967245,
  },
  {
    name: "Wittenheim",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 2967318,
  },
  {
    name: "Wattrelos",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 2967421,
  },
  {
    name: "Wasquehal",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 2967438,
  },
  {
    name: "Voiron",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 2967758,
  },
  {
    name: "Vitry-sur-Seine",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2967849,
  },
  {
    name: "Vitry-le-François",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 2967856,
  },
  {
    name: "Vitrolles",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 2967870,
  },
  {
    name: "Vitré",
    country: "France",
    subcountry: "Brittany",
    geonameid: 2967879,
  },
  {
    name: "Viry-Châtillon",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2967917,
  },
  {
    name: "Viroflay",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2967934,
  },
  {
    name: "Vincennes",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2968054,
  },
  {
    name: "Villiers-sur-Marne",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2968142,
  },
  {
    name: "Villiers-le-Bel",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2968176,
  },
  {
    name: "Villeurbanne",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 2968254,
  },
  {
    name: "Villers-lès-Nancy",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 2968368,
  },
  {
    name: "Villepinte",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2968482,
  },
  {
    name: "Villeparisis",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2968496,
  },
  {
    name: "Villeneuve-sur-Lot",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 2968515,
  },
  {
    name: "Villeneuve-Saint-Georges",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2968529,
  },
  {
    name: "Villeneuve-le-Roi",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2968546,
  },
  {
    name: "Villeneuve-la-Garenne",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2968555,
  },
  {
    name: "Villenave-d'Ornon",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 2968620,
  },
  {
    name: "Villemomble",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2968653,
  },
  {
    name: "Villejuif",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2968705,
  },
  {
    name: "Villefranche-sur-Saône",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 2968748,
  },
  {
    name: "Villefontaine",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 2968771,
  },
  {
    name: "Vigneux-sur-Seine",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2969109,
  },
  {
    name: "Vierzon",
    country: "France",
    subcountry: "Centre",
    geonameid: 2969257,
  },
  {
    name: "Vienne",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 2969284,
  },
  {
    name: "Vichy",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 2969392,
  },
  {
    name: "Vesoul",
    country: "France",
    subcountry: "Bourgogne-Franche-Comté",
    geonameid: 2969562,
  },
  {
    name: "Vertou",
    country: "France",
    subcountry: "Pays de la Loire",
    geonameid: 2969612,
  },
  {
    name: "Versailles",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2969679,
  },
  {
    name: "Verrières-le-Buisson",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2969692,
  },
  {
    name: "Vernon",
    country: "France",
    subcountry: "Normandy",
    geonameid: 2969766,
  },
  {
    name: "Verneuil-sur-Seine",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2969796,
  },
  {
    name: "Verdun",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 2969958,
  },
  {
    name: "Vénissieux",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 2970072,
  },
  {
    name: "Vendôme",
    country: "France",
    subcountry: "Centre",
    geonameid: 2970110,
  },
  {
    name: "Vence",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 2970148,
  },
  {
    name: "Vélizy-Villacoublay",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2970203,
  },
  {
    name: "Vauréal",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2970432,
  },
  {
    name: "Vaulx-en-Velin",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 2970456,
  },
  {
    name: "Vanves",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2970761,
  },
  {
    name: "Vannes",
    country: "France",
    subcountry: "Brittany",
    geonameid: 2970777,
  },
  {
    name: "Vandœuvre-lès-Nancy",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 2970797,
  },
  {
    name: "Vallauris",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 2970962,
  },
  {
    name: "Valenciennes",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 2971041,
  },
  {
    name: "Valence",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 2971053,
  },
  {
    name: "Tulle",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 2971482,
  },
  {
    name: "Troyes",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 2971549,
  },
  {
    name: "Tremblay-en-France",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2971874,
  },
  {
    name: "Trappes",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2972049,
  },
  {
    name: "Tours",
    country: "France",
    subcountry: "Centre",
    geonameid: 2972191,
  },
  {
    name: "Tournefeuille",
    country: "France",
    subcountry: "Occitanie",
    geonameid: 2972237,
  },
  {
    name: "Tourlaville",
    country: "France",
    subcountry: "Normandy",
    geonameid: 2972270,
  },
  {
    name: "Tourcoing",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 2972284,
  },
  {
    name: "Toulouse",
    country: "France",
    subcountry: "Occitanie",
    geonameid: 2972315,
  },
  {
    name: "Toulon",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 2972328,
  },
  {
    name: "Toul",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 2972350,
  },
  {
    name: "Torcy",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2972444,
  },
  {
    name: "Thonon-les-Bains",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 2972742,
  },
  {
    name: "Thionville",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 2972811,
  },
  {
    name: "Thiais",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2972893,
  },
  {
    name: "Tergnier",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 2973146,
  },
  {
    name: "Taverny",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2973258,
  },
  {
    name: "Tassin-la-Demi-Lune",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 2973317,
  },
  {
    name: "Tarbes",
    country: "France",
    subcountry: "Occitanie",
    geonameid: 2973385,
  },
  {
    name: "Talence",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 2973495,
  },
  {
    name: "Suresnes",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2973675,
  },
  {
    name: "Sucy-en-Brie",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2973745,
  },
  {
    name: "Strasbourg",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 2973783,
  },
  {
    name: "Stains",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2973841,
  },
  {
    name: "Sotteville-lès-Rouen",
    country: "France",
    subcountry: "Normandy",
    geonameid: 2974153,
  },
  {
    name: "Sorgues",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 2974188,
  },
  {
    name: "Soisy-sous-Montmorency",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2974385,
  },
  {
    name: "Soissons",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 2974389,
  },
  {
    name: "Six-Fours-les-Plages",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 2974427,
  },
  {
    name: "Sin-le-Noble",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 2974494,
  },
  {
    name: "Seynod",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 2974655,
  },
  {
    name: "Sèvres",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2974678,
  },
  {
    name: "Sevran",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2974681,
  },
  {
    name: "Sète",
    country: "France",
    subcountry: "Occitanie",
    geonameid: 2974733,
  },
  {
    name: "Sens",
    country: "France",
    subcountry: "Bourgogne-Franche-Comté",
    geonameid: 2975050,
  },
  {
    name: "Senlis",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 2975088,
  },
  {
    name: "Sélestat",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 2975233,
  },
  {
    name: "Sedan",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 2975349,
  },
  {
    name: "Schiltigheim",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 2975446,
  },
  {
    name: "Sceaux",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2975469,
  },
  {
    name: "Savigny-sur-Orge",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2975525,
  },
  {
    name: "Savigny-le-Temple",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2975536,
  },
  {
    name: "Saumur",
    country: "France",
    subcountry: "Pays de la Loire",
    geonameid: 2975758,
  },
  {
    name: "Sartrouville",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2975921,
  },
  {
    name: "Sarreguemines",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 2975964,
  },
  {
    name: "Sarcelles",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2976043,
  },
  {
    name: "Saran",
    country: "France",
    subcountry: "Centre",
    geonameid: 2976050,
  },
  {
    name: "Sannois",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2976179,
  },
  {
    name: "Sanary-sur-Mer",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 2976258,
  },
  {
    name: "Salon-de-Provence",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 2976341,
  },
  {
    name: "Sallanches",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 2976406,
  },
  {
    name: "Saint-Sébastien-sur-Loire",
    country: "France",
    subcountry: "Pays de la Loire",
    geonameid: 2976984,
  },
  {
    name: "Saint-Raphaël",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 2977246,
  },
  {
    name: "Saint-Quentin",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 2977295,
  },
  {
    name: "Saint-Priest",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 2977356,
  },
  {
    name: "Saint-Pol-sur-Mer",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 2977388,
  },
  {
    name: "Saint-Pierre-des-Corps",
    country: "France",
    subcountry: "Centre",
    geonameid: 2977491,
  },
  {
    name: "Saint-Ouen-l'Aumône",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2977800,
  },
  {
    name: "Saint-Ouen",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2977824,
  },
  {
    name: "Saint-Omer",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 2977845,
  },
  {
    name: "Saint-Nazaire",
    country: "France",
    subcountry: "Pays de la Loire",
    geonameid: 2977921,
  },
  {
    name: "Saint-Michel-sur-Orge",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2977952,
  },
  {
    name: "Saint-Médard-en-Jalles",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 2978072,
  },
  {
    name: "Saint-Maximin-la-Sainte-Baume",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 2978100,
  },
  {
    name: "Saint-Maur-des-Fossés",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2978179,
  },
  {
    name: "Saint-Martin-d'Hères",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 2978317,
  },
  {
    name: "Saint-Mandé",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2978621,
  },
  {
    name: "Saint-Malo",
    country: "France",
    subcountry: "Brittany",
    geonameid: 2978640,
  },
  {
    name: "Saint-Loup",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 2978722,
  },
  {
    name: "Saint-Louis",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 2978742,
  },
  {
    name: "Saint-Lô",
    country: "France",
    subcountry: "Normandy",
    geonameid: 2978758,
  },
  {
    name: "Saint-Leu-la-Forêt",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2978768,
  },
  {
    name: "Saint-Leu",
    country: "France",
    subcountry: "Bourgogne-Franche-Comté",
    geonameid: 2978771,
  },
  {
    name: "Saint-Laurent-du-Var",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 2978891,
  },
  {
    name: "Saint-Jean-de-la-Ruelle",
    country: "France",
    subcountry: "Centre",
    geonameid: 2979316,
  },
  {
    name: "Saint-Jean-de-Braye",
    country: "France",
    subcountry: "Centre",
    geonameid: 2979341,
  },
  {
    name: "Saint-Herblain",
    country: "France",
    subcountry: "Pays de la Loire",
    geonameid: 2979590,
  },
  {
    name: "Saint-Gratien",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2979627,
  },
  {
    name: "Saint-Germain-en-Laye",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2979783,
  },
  {
    name: "Saint-Genis-Laval",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 2979985,
  },
  {
    name: "Saint-Fons",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 2980097,
  },
  {
    name: "Saint-Étienne-du-Rouvray",
    country: "France",
    subcountry: "Normandy",
    geonameid: 2980236,
  },
  {
    name: "Saint-Étienne",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 2980291,
  },
  {
    name: "Saintes",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 2980340,
  },
  {
    name: "Sainte-Marguerite",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 2980467,
  },
  {
    name: "Sainte-Geneviève-des-Bois",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2980558,
  },
  {
    name: "Sainte-Foy-lès-Lyon",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 2980586,
  },
  {
    name: "Saint-Égrève",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 2980636,
  },
  {
    name: "Saint-Dizier",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 2980816,
  },
  {
    name: "Saint-Dié-des-Vosges",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 2980827,
  },
  {
    name: "Saint-Denis",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2980916,
  },
  {
    name: "Saint-Cyr-sur-Loire",
    country: "France",
    subcountry: "Centre",
    geonameid: 2980935,
  },
  {
    name: "Saint-Cyr-l'École",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2980942,
  },
  {
    name: "Saint-Cloud",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2981041,
  },
  {
    name: "Saint-Chamond",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 2981206,
  },
  {
    name: "Saint-Brieuc",
    country: "France",
    subcountry: "Brittany",
    geonameid: 2981280,
  },
  {
    name: "Saint-Avold",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 2981492,
  },
  {
    name: "Saint-Avertin",
    country: "France",
    subcountry: "Centre",
    geonameid: 2981512,
  },
  {
    name: "Saint-Amand-les-Eaux",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 2981839,
  },
  {
    name: "Rueil-Malmaison",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2982235,
  },
  {
    name: "Royan",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 2982343,
  },
  {
    name: "Rouen",
    country: "France",
    subcountry: "Normandy",
    geonameid: 2982652,
  },
  {
    name: "Roubaix",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 2982681,
  },
  {
    name: "Rosny-sous-Bois",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2982757,
  },
  {
    name: "Ronchin",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 2982944,
  },
  {
    name: "Romorantin-Lanthenay",
    country: "France",
    subcountry: "Centre",
    geonameid: 2982967,
  },
  {
    name: "Romans-sur-Isère",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 2983011,
  },
  {
    name: "Romainville",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2983026,
  },
  {
    name: "Roissy-en-Brie",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2983074,
  },
  {
    name: "Rodez",
    country: "France",
    subcountry: "Occitanie",
    geonameid: 2983154,
  },
  {
    name: "Rochefort",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 2983276,
  },
  {
    name: "Roanne",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 2983362,
  },
  {
    name: "Ris-Orangis",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2983440,
  },
  {
    name: "Riom",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 2983489,
  },
  {
    name: "Rillieux-la-Pape",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 2983536,
  },
  {
    name: "Rezé",
    country: "France",
    subcountry: "Pays de la Loire",
    geonameid: 2983770,
  },
  {
    name: "Rennes",
    country: "France",
    subcountry: "Brittany",
    geonameid: 2983990,
  },
  {
    name: "Reims",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 2984114,
  },
  {
    name: "Rambouillet",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2984513,
  },
  {
    name: "Quimper",
    country: "France",
    subcountry: "Brittany",
    geonameid: 2984701,
  },
  {
    name: "Puteaux",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2985034,
  },
  {
    name: "Port-de-Bouc",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 2986025,
  },
  {
    name: "Pontoise",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2986140,
  },
  {
    name: "Pontivy",
    country: "France",
    subcountry: "Brittany",
    geonameid: 2986160,
  },
  {
    name: "Pontarlier",
    country: "France",
    subcountry: "Bourgogne-Franche-Comté",
    geonameid: 2986302,
  },
  {
    name: "Pont-à-Mousson",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 2986306,
  },
  {
    name: "Poitiers",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 2986495,
  },
  {
    name: "Poissy",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2986501,
  },
  {
    name: "Ploemeur",
    country: "France",
    subcountry: "Brittany",
    geonameid: 2986732,
  },
  {
    name: "Plaisir",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2986930,
  },
  {
    name: "Plaisance-du-Touch",
    country: "France",
    subcountry: "Occitanie",
    geonameid: 2986933,
  },
  {
    name: "Pierrefitte-sur-Seine",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2987271,
  },
  {
    name: "Pessac",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 2987805,
  },
  {
    name: "Pertuis",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 2987825,
  },
  {
    name: "Perpignan",
    country: "France",
    subcountry: "Occitanie",
    geonameid: 2987914,
  },
  {
    name: "Périgueux",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 2987967,
  },
  {
    name: "Pau",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 2988358,
  },
  {
    name: "Paris",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2988507,
  },
  {
    name: "Pantin",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2988621,
  },
  {
    name: "Pamiers",
    country: "France",
    subcountry: "Occitanie",
    geonameid: 2988670,
  },
  {
    name: "Palaiseau",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2988758,
  },
  {
    name: "Ozoir-la-Ferrière",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2988867,
  },
  {
    name: "Oyonnax",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 2988888,
  },
  {
    name: "Outreau",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 2988936,
  },
  {
    name: "Oullins",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 2988998,
  },
  {
    name: "Osny",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2989130,
  },
  {
    name: "Orvault",
    country: "France",
    subcountry: "Pays de la Loire",
    geonameid: 2989170,
  },
  {
    name: "Orsay",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2989204,
  },
  {
    name: "Orly",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2989297,
  },
  {
    name: "Orléans",
    country: "France",
    subcountry: "Centre",
    geonameid: 2989317,
  },
  {
    name: "Orange",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 2989460,
  },
  {
    name: "Olivet",
    country: "France",
    subcountry: "Centre",
    geonameid: 2989611,
  },
  {
    name: "Octeville",
    country: "France",
    subcountry: "Normandy",
    geonameid: 2989755,
  },
  {
    name: "Noyon",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 2989877,
  },
  {
    name: "Noisy-le-Sec",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2990187,
  },
  {
    name: "Noisy-le-Grand",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2990189,
  },
  {
    name: "Noisiel",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2990192,
  },
  {
    name: "Nogent-sur-Oise",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 2990264,
  },
  {
    name: "Nogent-sur-Marne",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2990265,
  },
  {
    name: "Niort",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 2990355,
  },
  {
    name: "Nîmes",
    country: "France",
    subcountry: "Occitanie",
    geonameid: 2990363,
  },
  {
    name: "Nice",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 2990440,
  },
  {
    name: "Nevers",
    country: "France",
    subcountry: "Bourgogne-Franche-Comté",
    geonameid: 2990474,
  },
  {
    name: "Neuilly-sur-Seine",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2990611,
  },
  {
    name: "Neuilly-sur-Marne",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2990612,
  },
  {
    name: "Neuilly-Plaisance",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2990616,
  },
  {
    name: "Narbonne",
    country: "France",
    subcountry: "Occitanie",
    geonameid: 2990919,
  },
  {
    name: "Nantes",
    country: "France",
    subcountry: "Pays de la Loire",
    geonameid: 2990969,
  },
  {
    name: "Nanterre",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2990970,
  },
  {
    name: "Nancy",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 2990999,
  },
  {
    name: "Muret",
    country: "France",
    subcountry: "Occitanie",
    geonameid: 2991153,
  },
  {
    name: "Mulhouse",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 2991214,
  },
  {
    name: "Moulins",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 2991481,
  },
  {
    name: "Mougins",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 2991551,
  },
  {
    name: "Morsang-sur-Orge",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2991719,
  },
  {
    name: "Morlaix",
    country: "France",
    subcountry: "Brittany",
    geonameid: 2991772,
  },
  {
    name: "Mont-Saint-Aignan",
    country: "France",
    subcountry: "Normandy",
    geonameid: 2992003,
  },
  {
    name: "Montrouge",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2992017,
  },
  {
    name: "Montreuil",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2992090,
  },
  {
    name: "Montpellier",
    country: "France",
    subcountry: "Occitanie",
    geonameid: 2992166,
  },
  {
    name: "Montmorency",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2992229,
  },
  {
    name: "Montluçon",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 2992292,
  },
  {
    name: "Montivilliers",
    country: "France",
    subcountry: "Normandy",
    geonameid: 2992367,
  },
  {
    name: "Montigny-lès-Metz",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 2992402,
  },
  {
    name: "Montigny-lès-Cormeilles",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2992404,
  },
  {
    name: "Montigny-le-Bretonneux",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2992415,
  },
  {
    name: "Montgeron",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2992536,
  },
  {
    name: "Montfermeil",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2992616,
  },
  {
    name: "Montesson",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2992650,
  },
  {
    name: "Montereau-Fault-Yonne",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2992671,
  },
  {
    name: "Montélimar",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 2992703,
  },
  {
    name: "Mont-de-Marsan",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 2992771,
  },
  {
    name: "Montceau-les-Mines",
    country: "France",
    subcountry: "Bourgogne-Franche-Comté",
    geonameid: 2992863,
  },
  {
    name: "Montbrison",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 2992890,
  },
  {
    name: "Montbéliard",
    country: "France",
    subcountry: "Bourgogne-Franche-Comté",
    geonameid: 2992938,
  },
  {
    name: "Montauban",
    country: "France",
    subcountry: "Occitanie",
    geonameid: 2993002,
  },
  {
    name: "Montargis",
    country: "France",
    subcountry: "Centre",
    geonameid: 2993024,
  },
  {
    name: "Mons-en-Barœul",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 2993207,
  },
  {
    name: "Moissy-Cramayel",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2993572,
  },
  {
    name: "Mitry-Mory",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2993679,
  },
  {
    name: "Miramas",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 2993760,
  },
  {
    name: "Millau",
    country: "France",
    subcountry: "Occitanie",
    geonameid: 2993875,
  },
  {
    name: "Meyzieu",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 2994048,
  },
  {
    name: "Meylan",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 2994087,
  },
  {
    name: "Meudon",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2994144,
  },
  {
    name: "Metz",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 2994160,
  },
  {
    name: "Mérignac",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 2994393,
  },
  {
    name: "Menton",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 2994497,
  },
  {
    name: "Melun",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2994651,
  },
  {
    name: "Meaux",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2994798,
  },
  {
    name: "Mazargues",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 2994895,
  },
  {
    name: "Mayenne",
    country: "France",
    subcountry: "Pays de la Loire",
    geonameid: 2994935,
  },
  {
    name: "Maurepas",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2995041,
  },
  {
    name: "Mauguio",
    country: "France",
    subcountry: "Occitanie",
    geonameid: 2995121,
  },
  {
    name: "Maubeuge",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 2995150,
  },
  {
    name: "Massy",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2995206,
  },
  {
    name: "Martigues",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 2995387,
  },
  {
    name: "Marseille",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 2995469,
  },
  {
    name: "Marmande",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 2995642,
  },
  {
    name: "Marly-le-Roi",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2995652,
  },
  {
    name: "Marignane",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 2995750,
  },
  {
    name: "Marcq-en-Barœul",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 2995908,
  },
  {
    name: "Mantes-la-Ville",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2996146,
  },
  {
    name: "Mantes-la-Jolie",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2996148,
  },
  {
    name: "Manosque",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 2996180,
  },
  {
    name: "Mandelieu-la-Napoule",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 2996255,
  },
  {
    name: "Malakoff",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2996514,
  },
  {
    name: "Maisons-Laffitte",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2996564,
  },
  {
    name: "Maisons-Alfort",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2996568,
  },
  {
    name: "Mâcon",
    country: "France",
    subcountry: "Bourgogne-Franche-Comté",
    geonameid: 2996882,
  },
  {
    name: "Lyon",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 2996944,
  },
  {
    name: "Lunéville",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 2997110,
  },
  {
    name: "Lunel",
    country: "France",
    subcountry: "Occitanie",
    geonameid: 2997116,
  },
  {
    name: "Lucé",
    country: "France",
    subcountry: "Centre",
    geonameid: 2997246,
  },
  {
    name: "Louviers",
    country: "France",
    subcountry: "Normandy",
    geonameid: 2997336,
  },
  {
    name: "Lourdes",
    country: "France",
    subcountry: "Occitanie",
    geonameid: 2997395,
  },
  {
    name: "Lormont",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 2997556,
  },
  {
    name: "Lorient",
    country: "France",
    subcountry: "Brittany",
    geonameid: 2997577,
  },
  {
    name: "Loos",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 2997620,
  },
  {
    name: "Lons-le-Saunier",
    country: "France",
    subcountry: "Bourgogne-Franche-Comté",
    geonameid: 2997626,
  },
  {
    name: "Longjumeau",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2997712,
  },
  {
    name: "Lomme",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 2997803,
  },
  {
    name: "Lognes",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2997904,
  },
  {
    name: "Livry-Gargan",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2998056,
  },
  {
    name: "L'Isle-sur-la-Sorgue",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 2998127,
  },
  {
    name: "Lisieux",
    country: "France",
    subcountry: "Normandy",
    geonameid: 2998150,
  },
  {
    name: "Lingolsheim",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 2998224,
  },
  {
    name: "Limoges",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 2998286,
  },
  {
    name: "Limeil-Brévannes",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2998305,
  },
  {
    name: "Limay",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2998311,
  },
  {
    name: "Lille",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 2998324,
  },
  {
    name: "Liévin",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 2998431,
  },
  {
    name: "Libourne",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 2998517,
  },
  {
    name: "L'Haÿ-les-Roses",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2998632,
  },
  {
    name: "Le Vésinet",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2998854,
  },
  {
    name: "Levallois-Perret",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 2998975,
  },
  {
    name: "Les Sables-d'Olonne",
    country: "France",
    subcountry: "Pays de la Loire",
    geonameid: 2999683,
  },
  {
    name: "Les Pennes-Mirabeau",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 3000047,
  },
  {
    name: "Les Pavillons-sous-Bois",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3000060,
  },
  {
    name: "Les Olives",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 3000138,
  },
  {
    name: "Les Mureaux",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3000192,
  },
  {
    name: "Les Lilas",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3000491,
  },
  {
    name: "Les Herbiers",
    country: "France",
    subcountry: "Pays de la Loire",
    geonameid: 3000648,
  },
  {
    name: "Les Clayes-sous-Bois",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3001402,
  },
  {
    name: "Le Puy-en-Velay",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 3002465,
  },
  {
    name: "Le Pré-Saint-Gervais",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3002499,
  },
  {
    name: "Le Pontet",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 3002570,
  },
  {
    name: "Le Plessis-Trévise",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3002647,
  },
  {
    name: "Le Plessis-Robinson",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3002650,
  },
  {
    name: "Le Petit-Quevilly",
    country: "France",
    subcountry: "Normandy",
    geonameid: 3002880,
  },
  {
    name: "Le Perreux-sur-Marne",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3002965,
  },
  {
    name: "Le Pecq",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3002984,
  },
  {
    name: "Lens",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 3003093,
  },
  {
    name: "Le Mée-sur-Seine",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3003481,
  },
  {
    name: "Le Mans",
    country: "France",
    subcountry: "Pays de la Loire",
    geonameid: 3003603,
  },
  {
    name: "Le Kremlin-Bicêtre",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3003737,
  },
  {
    name: "Le Havre",
    country: "France",
    subcountry: "Normandy",
    geonameid: 3003796,
  },
  {
    name: "Le Grand-Quevilly",
    country: "France",
    subcountry: "Normandy",
    geonameid: 3003952,
  },
  {
    name: "Le Creusot",
    country: "France",
    subcountry: "Bourgogne-Franche-Comté",
    geonameid: 3004427,
  },
  {
    name: "Le Chesnay",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3004630,
  },
  {
    name: "Le Cannet",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 3004871,
  },
  {
    name: "Le Bouscat",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 3005066,
  },
  {
    name: "Le Blanc-Mesnil",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3005269,
  },
  {
    name: "Laxou",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 3005417,
  },
  {
    name: "La Valette-du-Var",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 3005825,
  },
  {
    name: "Laval",
    country: "France",
    subcountry: "Pays de la Loire",
    geonameid: 3005866,
  },
  {
    name: "Lattes",
    country: "France",
    subcountry: "Occitanie",
    geonameid: 3006121,
  },
  {
    name: "La Teste-de-Buch",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 3006283,
  },
  {
    name: "La Seyne-sur-Mer",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 3006414,
  },
  {
    name: "La Roche-sur-Yon",
    country: "France",
    subcountry: "Pays de la Loire",
    geonameid: 3006767,
  },
  {
    name: "La Rochelle",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 3006787,
  },
  {
    name: "La Pomme",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 3007221,
  },
  {
    name: "Laon",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 3007477,
  },
  {
    name: "Lannion",
    country: "France",
    subcountry: "Brittany",
    geonameid: 3007609,
  },
  {
    name: "Lanester",
    country: "France",
    subcountry: "Brittany",
    geonameid: 3007794,
  },
  {
    name: "Landerneau",
    country: "France",
    subcountry: "Brittany",
    geonameid: 3007874,
  },
  {
    name: "Lambersart",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 3008218,
  },
  {
    name: "La Madeleine",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 3008379,
  },
  {
    name: "Lagny-sur-Marne",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3009071,
  },
  {
    name: "La Garenne-Colombes",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3009169,
  },
  {
    name: "La Garde",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 3009223,
  },
  {
    name: "La Flèche",
    country: "France",
    subcountry: "Pays de la Loire",
    geonameid: 3009443,
  },
  {
    name: "La Crau",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 3009791,
  },
  {
    name: "La Courneuve",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3009824,
  },
  {
    name: "La Ciotat",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 3010025,
  },
  {
    name: "La Chapelle-sur-Erdre",
    country: "France",
    subcountry: "Pays de la Loire",
    geonameid: 3010237,
  },
  {
    name: "La Celle-Saint-Cloud",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3010529,
  },
  {
    name: "Jouy-le-Moutier",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3012162,
  },
  {
    name: "Joué-lès-Tours",
    country: "France",
    subcountry: "Centre",
    geonameid: 3012219,
  },
  {
    name: "Joinville-le-Pont",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3012313,
  },
  {
    name: "Ivry-sur-Seine",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3012621,
  },
  {
    name: "Istres",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 3012647,
  },
  {
    name: "Issy-les-Moulineaux",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3012649,
  },
  {
    name: "Issoire",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 3012664,
  },
  {
    name: "Illzach",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 3012829,
  },
  {
    name: "Illkirch-Graffenstaden",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 3012834,
  },
  {
    name: "Hyères",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 3012937,
  },
  {
    name: "Houilles",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3013097,
  },
  {
    name: "Hérouville-Saint-Clair",
    country: "France",
    subcountry: "Normandy",
    geonameid: 3013403,
  },
  {
    name: "Herblay",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3013477,
  },
  {
    name: "Hénin-Beaumont",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 3013525,
  },
  {
    name: "Hem",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 3013549,
  },
  {
    name: "Hazebrouck",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 3013619,
  },
  {
    name: "Hayange",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 3013627,
  },
  {
    name: "Hautmont",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 3013681,
  },
  {
    name: "Yutz",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 3013701,
  },
  {
    name: "Haubourdin",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 3013862,
  },
  {
    name: "Halluin",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 3014034,
  },
  {
    name: "Haguenau",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 3014078,
  },
  {
    name: "Guyancourt",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3014143,
  },
  {
    name: "Gujan-Mestras",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 3014175,
  },
  {
    name: "Guéret",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 3014383,
  },
  {
    name: "Guérande",
    country: "France",
    subcountry: "Pays de la Loire",
    geonameid: 3014392,
  },
  {
    name: "Grigny",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3014646,
  },
  {
    name: "Grenoble",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 3014728,
  },
  {
    name: "Grasse",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 3014856,
  },
  {
    name: "Grande-Synthe",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 3015160,
  },
  {
    name: "Gradignan",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 3015419,
  },
  {
    name: "Goussainville",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3015490,
  },
  {
    name: "Gonesse",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3015689,
  },
  {
    name: "Givors",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 3015902,
  },
  {
    name: "Gif-sur-Yvette",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3016078,
  },
  {
    name: "Gien",
    country: "France",
    subcountry: "Centre",
    geonameid: 3016097,
  },
  {
    name: "Gentilly",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3016292,
  },
  {
    name: "Gennevilliers",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3016321,
  },
  {
    name: "Garges-lès-Gonesse",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3016621,
  },
  {
    name: "Gardanne",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 3016667,
  },
  {
    name: "Garches",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3016675,
  },
  {
    name: "Gap",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 3016702,
  },
  {
    name: "Gagny",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3016830,
  },
  {
    name: "Frontignan",
    country: "France",
    subcountry: "Occitanie",
    geonameid: 3016956,
  },
  {
    name: "Fresnes",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3017178,
  },
  {
    name: "Fréjus",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 3017253,
  },
  {
    name: "Franconville",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3017341,
  },
  {
    name: "Fougères",
    country: "France",
    subcountry: "Brittany",
    geonameid: 3017609,
  },
  {
    name: "Fos-sur-Mer",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 3017651,
  },
  {
    name: "Forbach",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 3017805,
  },
  {
    name: "Fontenay-sous-Bois",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3017910,
  },
  {
    name: "Fontenay-le-Comte",
    country: "France",
    subcountry: "Pays de la Loire",
    geonameid: 3017921,
  },
  {
    name: "Fontenay-aux-Roses",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3017924,
  },
  {
    name: "Fontainebleau",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3018074,
  },
  {
    name: "Fontaine",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 3018095,
  },
  {
    name: "Floirac",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 3018246,
  },
  {
    name: "Fleury-les-Aubrais",
    country: "France",
    subcountry: "Centre",
    geonameid: 3018280,
  },
  {
    name: "Flers",
    country: "France",
    subcountry: "Normandy",
    geonameid: 3018339,
  },
  {
    name: "Firminy",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 3018455,
  },
  {
    name: "Fécamp",
    country: "France",
    subcountry: "Normandy",
    geonameid: 3018794,
  },
  {
    name: "Faches-Thumesnil",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 3019153,
  },
  {
    name: "Eysines",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 3019193,
  },
  {
    name: "Évry",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3019256,
  },
  {
    name: "Évreux",
    country: "France",
    subcountry: "Normandy",
    geonameid: 3019265,
  },
  {
    name: "Étampes",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3019459,
  },
  {
    name: "La Baule-Escoublac",
    country: "France",
    subcountry: "Pays de la Loire",
    geonameid: 3019766,
  },
  {
    name: "Ermont",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3019897,
  },
  {
    name: "Éragny",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3019952,
  },
  {
    name: "Équeurdreville-Hainneville",
    country: "France",
    subcountry: "Normandy",
    geonameid: 3019960,
  },
  {
    name: "Épinay-sur-Seine",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3020020,
  },
  {
    name: "Épinal",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 3020035,
  },
  {
    name: "Épernay",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 3020062,
  },
  {
    name: "Elbeuf",
    country: "France",
    subcountry: "Normandy",
    geonameid: 3020307,
  },
  {
    name: "Élancourt",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3020310,
  },
  {
    name: "Écully",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 3020392,
  },
  {
    name: "Échirolles",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 3020495,
  },
  {
    name: "Eaubonne",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3020601,
  },
  {
    name: "Dunkerque",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 3020686,
  },
  {
    name: "Dreux",
    country: "France",
    subcountry: "Centre",
    geonameid: 3020810,
  },
  {
    name: "Draveil",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3020832,
  },
  {
    name: "Drancy",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3020839,
  },
  {
    name: "Draguignan",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 3020850,
  },
  {
    name: "Douarnenez",
    country: "France",
    subcountry: "Brittany",
    geonameid: 3020996,
  },
  {
    name: "Douai",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 3021000,
  },
  {
    name: "Domont",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3021150,
  },
  {
    name: "Dole",
    country: "France",
    subcountry: "Bourgogne-Franche-Comté",
    geonameid: 3021263,
  },
  {
    name: "Dijon",
    country: "France",
    subcountry: "Bourgogne-Franche-Comté",
    geonameid: 3021372,
  },
  {
    name: "Digne-les-Bains",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 3021382,
  },
  {
    name: "Dieppe",
    country: "France",
    subcountry: "Normandy",
    geonameid: 3021411,
  },
  {
    name: "Deuil-la-Barre",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3021516,
  },
  {
    name: "Denain",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 3021605,
  },
  {
    name: "Décines-Charpieu",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 3021662,
  },
  {
    name: "Dax",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 3021670,
  },
  {
    name: "Dammarie-les-Lys",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3021852,
  },
  {
    name: "Cugnaux",
    country: "France",
    subcountry: "Occitanie",
    geonameid: 3022151,
  },
  {
    name: "Croix",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 3022376,
  },
  {
    name: "Créteil",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3022530,
  },
  {
    name: "Crépy-en-Valois",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 3022569,
  },
  {
    name: "Creil",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 3022610,
  },
  {
    name: "Cran-Gevrier",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 3022700,
  },
  {
    name: "Cournon-d'Auvergne",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 3022988,
  },
  {
    name: "Courbevoie",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3023141,
  },
  {
    name: "Coulommiers",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3023240,
  },
  {
    name: "Couëron",
    country: "France",
    subcountry: "Pays de la Loire",
    geonameid: 3023324,
  },
  {
    name: "Coudekerque-Branche",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 3023356,
  },
  {
    name: "Cormeilles-en-Parisis",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3023645,
  },
  {
    name: "Corbeil-Essonnes",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3023763,
  },
  {
    name: "Conflans-Sainte-Honorine",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3023924,
  },
  {
    name: "Concarneau",
    country: "France",
    subcountry: "Brittany",
    geonameid: 3024035,
  },
  {
    name: "Compiègne",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 3024066,
  },
  {
    name: "Combs-la-Ville",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3024107,
  },
  {
    name: "Pontault-Combault",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3024195,
  },
  {
    name: "Colomiers",
    country: "France",
    subcountry: "Occitanie",
    geonameid: 3024223,
  },
  {
    name: "Colombes",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3024266,
  },
  {
    name: "Colmar",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 3024297,
  },
  {
    name: "Cognac",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 3024440,
  },
  {
    name: "Cluses",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 3024532,
  },
  {
    name: "Clichy-sous-Bois",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3024596,
  },
  {
    name: "Clichy",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3024597,
  },
  {
    name: "Clermont-Ferrand",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 3024635,
  },
  {
    name: "Clamart",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3024783,
  },
  {
    name: "Cholet",
    country: "France",
    subcountry: "Pays de la Loire",
    geonameid: 3025053,
  },
  {
    name: "Choisy-le-Roi",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3025055,
  },
  {
    name: "Chilly-Mazarin",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3025144,
  },
  {
    name: "Chevilly-Larue",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3025314,
  },
  {
    name: "Cherbourg-Octeville",
    country: "France",
    subcountry: "Normandy",
    geonameid: 3025466,
  },
  {
    name: "Chenôve",
    country: "France",
    subcountry: "Bourgogne-Franche-Comté",
    geonameid: 3025496,
  },
  {
    name: "Chennevières-sur-Marne",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3025509,
  },
  {
    name: "Chelles",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3025622,
  },
  {
    name: "Chaville",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3025715,
  },
  {
    name: "Chaumont",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 3025892,
  },
  {
    name: "Chatou",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3026033,
  },
  {
    name: "Châtillon",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3026083,
  },
  {
    name: "Châtenay-Malabry",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3026108,
  },
  {
    name: "Châtellerault",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 3026141,
  },
  {
    name: "Château-Thierry",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 3026194,
  },
  {
    name: "Châteauroux",
    country: "France",
    subcountry: "Centre",
    geonameid: 3026204,
  },
  {
    name: "Châteaudun",
    country: "France",
    subcountry: "Centre",
    geonameid: 3026285,
  },
  {
    name: "Chartres",
    country: "France",
    subcountry: "Centre",
    geonameid: 3026467,
  },
  {
    name: "Charleville-Mézières",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 3026613,
  },
  {
    name: "Charenton-le-Pont",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3026637,
  },
  {
    name: "Champs-sur-Marne",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3027014,
  },
  {
    name: "Champigny-sur-Marne",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3027105,
  },
  {
    name: "Chambéry",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 3027422,
  },
  {
    name: "Chamalières",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 3027453,
  },
  {
    name: "Chalon-sur-Saône",
    country: "France",
    subcountry: "Bourgogne-Franche-Comté",
    geonameid: 3027484,
  },
  {
    name: "Châlons-en-Champagne",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 3027487,
  },
  {
    name: "Challans",
    country: "France",
    subcountry: "Pays de la Loire",
    geonameid: 3027513,
  },
  {
    name: "Cestas",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 3027763,
  },
  {
    name: "Cesson-Sévigné",
    country: "France",
    subcountry: "Brittany",
    geonameid: 3027767,
  },
  {
    name: "Cergy",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3027883,
  },
  {
    name: "Cenon",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 3027950,
  },
  {
    name: "Cavaillon",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 3028134,
  },
  {
    name: "Castres",
    country: "France",
    subcountry: "Occitanie",
    geonameid: 3028263,
  },
  {
    name: "Castelnau-le-Lez",
    country: "France",
    subcountry: "Occitanie",
    geonameid: 3028337,
  },
  {
    name: "Carvin",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 3028486,
  },
  {
    name: "Carrières-sous-Poissy",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3028521,
  },
  {
    name: "Carquefou",
    country: "France",
    subcountry: "Pays de la Loire",
    geonameid: 3028535,
  },
  {
    name: "Carpentras",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 3028542,
  },
  {
    name: "Carcassonne",
    country: "France",
    subcountry: "Occitanie",
    geonameid: 3028641,
  },
  {
    name: "Canteleu",
    country: "France",
    subcountry: "Normandy",
    geonameid: 3028779,
  },
  {
    name: "Cannes",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 3028808,
  },
  {
    name: "Cambrai",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 3029030,
  },
  {
    name: "Caluire-et-Cuire",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 3029096,
  },
  {
    name: "Calais",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 3029162,
  },
  {
    name: "Cahors",
    country: "France",
    subcountry: "Occitanie",
    geonameid: 3029213,
  },
  {
    name: "Cagnes-sur-Mer",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 3029227,
  },
  {
    name: "Caen",
    country: "France",
    subcountry: "Normandy",
    geonameid: 3029241,
  },
  {
    name: "Cachan",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3029276,
  },
  {
    name: "Bry-sur-Marne",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3029706,
  },
  {
    name: "Brunoy",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3029748,
  },
  {
    name: "Bruay-la-Buissière",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 3029825,
  },
  {
    name: "Bron",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 3029931,
  },
  {
    name: "Brive-la-Gaillarde",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 3029974,
  },
  {
    name: "Brignoles",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 3030057,
  },
  {
    name: "Brie-Comte-Robert",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3030101,
  },
  {
    name: "Brétigny-sur-Orge",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3030257,
  },
  {
    name: "Brest",
    country: "France",
    subcountry: "Brittany",
    geonameid: 3030300,
  },
  {
    name: "Bressuire",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 3030303,
  },
  {
    name: "Bourg-lès-Valence",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 3030985,
  },
  {
    name: "Bourg-la-Reine",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3030990,
  },
  {
    name: "Bourges",
    country: "France",
    subcountry: "Centre",
    geonameid: 3031005,
  },
  {
    name: "Bourg-en-Bresse",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 3031009,
  },
  {
    name: "Boulogne-sur-Mer",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 3031133,
  },
  {
    name: "Boulogne-Billancourt",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3031137,
  },
  {
    name: "Bouguenais",
    country: "France",
    subcountry: "Pays de la Loire",
    geonameid: 3031268,
  },
  {
    name: "Bordeaux",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 3031582,
  },
  {
    name: "Bonneuil-sur-Marne",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3031709,
  },
  {
    name: "Bondy",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3031815,
  },
  {
    name: "Boissy-Saint-Léger",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3031898,
  },
  {
    name: "Bois-Colombes",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3032070,
  },
  {
    name: "Bobigny",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3032179,
  },
  {
    name: "Blois",
    country: "France",
    subcountry: "Centre",
    geonameid: 3032213,
  },
  {
    name: "Blanquefort",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 3032340,
  },
  {
    name: "Blagnac",
    country: "France",
    subcountry: "Occitanie",
    geonameid: 3032469,
  },
  {
    name: "Bischheim",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 3032551,
  },
  {
    name: "Biarritz",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 3032797,
  },
  {
    name: "Bezons",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3032824,
  },
  {
    name: "Béziers",
    country: "France",
    subcountry: "Occitanie",
    geonameid: 3032833,
  },
  {
    name: "Béthune",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 3033002,
  },
  {
    name: "Besançon",
    country: "France",
    subcountry: "Bourgogne-Franche-Comté",
    geonameid: 3033123,
  },
  {
    name: "Bergerac",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 3033391,
  },
  {
    name: "Berck",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 3033415,
  },
  {
    name: "Berck-Plage",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 3033416,
  },
  {
    name: "Belfort",
    country: "France",
    subcountry: "Bourgogne-Franche-Comté",
    geonameid: 3033791,
  },
  {
    name: "Bègles",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 3033881,
  },
  {
    name: "Beauvais",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 3034006,
  },
  {
    name: "Beaune",
    country: "France",
    subcountry: "Bourgogne-Franche-Comté",
    geonameid: 3034126,
  },
  {
    name: "Bayonne",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 3034475,
  },
  {
    name: "Bayeux",
    country: "France",
    subcountry: "Normandy",
    geonameid: 3034483,
  },
  {
    name: "Bastia",
    country: "France",
    subcountry: "Corsica",
    geonameid: 3034640,
  },
  {
    name: "Bar-le-Duc",
    country: "France",
    subcountry: "Grand Est",
    geonameid: 3034911,
  },
  {
    name: "Balma",
    country: "France",
    subcountry: "Occitanie",
    geonameid: 3035204,
  },
  {
    name: "Bagnols-sur-Cèze",
    country: "France",
    subcountry: "Occitanie",
    geonameid: 3035396,
  },
  {
    name: "Bagnolet",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3035403,
  },
  {
    name: "Bagneux",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3035409,
  },
  {
    name: "Avon",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3035654,
  },
  {
    name: "Avion",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 3035667,
  },
  {
    name: "Avignon",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 3035681,
  },
  {
    name: "Auxerre",
    country: "France",
    subcountry: "Bourgogne-Franche-Comté",
    geonameid: 3035843,
  },
  {
    name: "Autun",
    country: "France",
    subcountry: "Bourgogne-Franche-Comté",
    geonameid: 3035883,
  },
  {
    name: "Aurillac",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 3036016,
  },
  {
    name: "Aulnay-sous-Bois",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3036145,
  },
  {
    name: "Audincourt",
    country: "France",
    subcountry: "Bourgogne-Franche-Comté",
    geonameid: 3036240,
  },
  {
    name: "Auch",
    country: "France",
    subcountry: "Occitanie",
    geonameid: 3036281,
  },
  {
    name: "Aubervilliers",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3036386,
  },
  {
    name: "Aubagne",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 3036433,
  },
  {
    name: "Athis-Mons",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3036460,
  },
  {
    name: "Asnières-sur-Seine",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3036572,
  },
  {
    name: "Arras",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 3036784,
  },
  {
    name: "Armentières",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 3036903,
  },
  {
    name: "Arles",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 3036938,
  },
  {
    name: "Argenteuil",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3037044,
  },
  {
    name: "Argentan",
    country: "France",
    subcountry: "Normandy",
    geonameid: 3037051,
  },
  {
    name: "Arcueil",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3037157,
  },
  {
    name: "Antony",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3037423,
  },
  {
    name: "Antibes",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 3037456,
  },
  {
    name: "Annonay",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 3037514,
  },
  {
    name: "Annemasse",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 3037538,
  },
  {
    name: "Annecy-le-Vieux",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 3037540,
  },
  {
    name: "Annecy",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 3037543,
  },
  {
    name: "Angoulême",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 3037598,
  },
  {
    name: "Anglet",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 3037612,
  },
  {
    name: "Angers",
    country: "France",
    subcountry: "Pays de la Loire",
    geonameid: 3037656,
  },
  {
    name: "Amiens",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 3037854,
  },
  {
    name: "Allauch",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 3038159,
  },
  {
    name: "Alfortville",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3038213,
  },
  {
    name: "Alès",
    country: "France",
    subcountry: "Occitanie",
    geonameid: 3038224,
  },
  {
    name: "Alençon",
    country: "France",
    subcountry: "Normandy",
    geonameid: 3038230,
  },
  {
    name: "Albi",
    country: "France",
    subcountry: "Occitanie",
    geonameid: 3038261,
  },
  {
    name: "Albertville",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 3038266,
  },
  {
    name: "Ajaccio",
    country: "France",
    subcountry: "Corsica",
    geonameid: 3038334,
  },
  {
    name: "Aix-les-Bains",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 3038350,
  },
  {
    name: "Aix-en-Provence",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 3038354,
  },
  {
    name: "Agen",
    country: "France",
    subcountry: "Nouvelle-Aquitaine",
    geonameid: 3038634,
  },
  {
    name: "Agde",
    country: "France",
    subcountry: "Occitanie",
    geonameid: 3038638,
  },
  {
    name: "Achères",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 3038712,
  },
  {
    name: "Abbeville",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 3038789,
  },
  {
    name: "Villeneuve-d'Ascq",
    country: "France",
    subcountry: "Hauts-de-France",
    geonameid: 6543862,
  },
  {
    name: "Lyon 02",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 6543968,
  },
  {
    name: "Lyon 03",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 6543969,
  },
  {
    name: "Lyon 04",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 6543970,
  },
  {
    name: "Lyon 05",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 6543971,
  },
  {
    name: "Lyon 06",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 6543972,
  },
  {
    name: "Lyon 07",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 6543973,
  },
  {
    name: "Lyon 08",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 6543974,
  },
  {
    name: "Lyon 09",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 6543975,
  },
  {
    name: "Les Ulis",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 6615536,
  },
  {
    name: "Bourgoin-Jallieu",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 6615539,
  },
  {
    name: "Lyon 01",
    country: "France",
    subcountry: "Auvergne-Rhône-Alpes",
    geonameid: 6949674,
  },
  {
    name: "Marseille 01",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 7284882,
  },
  {
    name: "Marseille 02",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 7284883,
  },
  {
    name: "Marseille 03",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 7284884,
  },
  {
    name: "Marseille 04",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 7284885,
  },
  {
    name: "Marseille 05",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 7284886,
  },
  {
    name: "Marseille 06",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 7284887,
  },
  {
    name: "Marseille 07",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 7284888,
  },
  {
    name: "Marseille 08",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 7284889,
  },
  {
    name: "Marseille 10",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 7284890,
  },
  {
    name: "Marseille 09",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 7284891,
  },
  {
    name: "Marseille 11",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 7284892,
  },
  {
    name: "Marseille 12",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 7284893,
  },
  {
    name: "Marseille 13",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 7284894,
  },
  {
    name: "Marseille 14",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 7284895,
  },
  {
    name: "Marseille 15",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 7284896,
  },
  {
    name: "Marseille 16",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 7284897,
  },
  {
    name: "La Defense",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 8504417,
  },
  {
    name: "Saint-Quentin-en-Yvelines",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 8533870,
  },
  {
    name: "Cergy-Pontoise",
    country: "France",
    subcountry: "Île-de-France",
    geonameid: 8555643,
  },
  {
    name: "La Blancarde",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 11919748,
  },
  {
    name: "Le Camas",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 11919749,
  },
  {
    name: "Saint-Barthélémy",
    country: "France",
    subcountry: "Provence-Alpes-Côte d'Azur",
    geonameid: 11919779,
  },
  {
    name: "Tchibanga",
    country: "Gabon",
    subcountry: "Nyanga",
    geonameid: 2396253,
  },
  {
    name: "Port-Gentil",
    country: "Gabon",
    subcountry: "Ogooué-Maritime",
    geonameid: 2396518,
  },
  {
    name: "Oyem",
    country: "Gabon",
    subcountry: "Woleu-Ntem",
    geonameid: 2396646,
  },
  {
    name: "Mouila",
    country: "Gabon",
    subcountry: "Ngouni",
    geonameid: 2398073,
  },
  {
    name: "Moanda",
    country: "Gabon",
    subcountry: "Haut-Ogooué",
    geonameid: 2398269,
  },
  {
    name: "Libreville",
    country: "Gabon",
    subcountry: "Estuaire",
    geonameid: 2399697,
  },
  {
    name: "Lambaréné",
    country: "Gabon",
    subcountry: "Moyen-Ogooué",
    geonameid: 2399888,
  },
  {
    name: "Koulamoutou",
    country: "Gabon",
    subcountry: "Ogooué-Lolo",
    geonameid: 2399959,
  },
  {
    name: "Franceville",
    country: "Gabon",
    subcountry: "Haut-Ogooué",
    geonameid: 2400555,
  },
  {
    name: "York",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2633352,
  },
  {
    name: "Yeovil",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2633373,
  },
  {
    name: "Yeadon",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2633397,
  },
  {
    name: "Yate",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2633406,
  },
  {
    name: "Yarm",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2633415,
  },
  {
    name: "Wrexham",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2633485,
  },
  {
    name: "Worthing",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2633521,
  },
  {
    name: "Worksop",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2633551,
  },
  {
    name: "Workington",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2633553,
  },
  {
    name: "Worcester Park",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2633561,
  },
  {
    name: "Worcester",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2633563,
  },
  {
    name: "Wood Green",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2633653,
  },
  {
    name: "Woodford Green",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2633655,
  },
  {
    name: "Wombwell",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2633681,
  },
  {
    name: "Wolverhampton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2633691,
  },
  {
    name: "Wokingham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2633708,
  },
  {
    name: "Woking",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2633709,
  },
  {
    name: "Witney",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2633729,
  },
  {
    name: "Witham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2633749,
  },
  {
    name: "Wishaw",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2633765,
  },
  {
    name: "Wisbech",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2633771,
  },
  {
    name: "Winsford",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2633810,
  },
  {
    name: "Windsor",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2633842,
  },
  {
    name: "Winchester",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2633858,
  },
  {
    name: "Wimbledon",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2633866,
  },
  {
    name: "Wilmslow",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2633883,
  },
  {
    name: "Willesden",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2633907,
  },
  {
    name: "Willenhall",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2633912,
  },
  {
    name: "Wigston Magna",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2633936,
  },
  {
    name: "Wigan",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2633948,
  },
  {
    name: "Widnes",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2633954,
  },
  {
    name: "Wickford",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2633976,
  },
  {
    name: "Whitstable",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634021,
  },
  {
    name: "Whitley Bay",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634032,
  },
  {
    name: "Whitehaven",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634096,
  },
  {
    name: "Whitefield",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634103,
  },
  {
    name: "Whickham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634155,
  },
  {
    name: "Weymouth",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634202,
  },
  {
    name: "Weybridge",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634204,
  },
  {
    name: "Weston-super-Mare",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634308,
  },
  {
    name: "West Molesey",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634340,
  },
  {
    name: "City of Westminster",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634341,
  },
  {
    name: "Westhoughton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634387,
  },
  {
    name: "West Ham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634403,
  },
  {
    name: "Westbury",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634483,
  },
  {
    name: "West Bromwich",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634491,
  },
  {
    name: "West Bridgford",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634493,
  },
  {
    name: "Wembley",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634549,
  },
  {
    name: "Welwyn Garden City",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634552,
  },
  {
    name: "Wellington",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634573,
  },
  {
    name: "Wellingborough",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634578,
  },
  {
    name: "Welling",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634579,
  },
  {
    name: "Wednesfield",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634616,
  },
  {
    name: "Wednesbury",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634617,
  },
  {
    name: "Wath upon Dearne",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634672,
  },
  {
    name: "Watford",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634677,
  },
  {
    name: "Waterlooville",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634686,
  },
  {
    name: "Washington",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634715,
  },
  {
    name: "Warwick",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634725,
  },
  {
    name: "Warrington",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634739,
  },
  {
    name: "Warminster",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634755,
  },
  {
    name: "Ware",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634777,
  },
  {
    name: "Wantage",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634801,
  },
  {
    name: "Walton-on-Thames",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634825,
  },
  {
    name: "Walton-on-the-Naze",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634826,
  },
  {
    name: "Walthamstow",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634838,
  },
  {
    name: "Waltham Abbey",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634843,
  },
  {
    name: "Walsall",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634853,
  },
  {
    name: "Wallsend",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634864,
  },
  {
    name: "Wallington",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634867,
  },
  {
    name: "Wallasey",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634873,
  },
  {
    name: "Walkden",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634887,
  },
  {
    name: "Wakefield",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2634910,
  },
  {
    name: "Uxbridge",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2635042,
  },
  {
    name: "Urmston",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2635062,
  },
  {
    name: "Upper Norwood",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2635113,
  },
  {
    name: "Uckfield",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2635243,
  },
  {
    name: "Tynemouth",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2635269,
  },
  {
    name: "Tyldesley",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2635281,
  },
  {
    name: "Truro",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2635412,
  },
  {
    name: "Trowbridge",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2635427,
  },
  {
    name: "Totton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2635603,
  },
  {
    name: "Totteridge",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2635607,
  },
  {
    name: "Tottenham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2635608,
  },
  {
    name: "Torquay",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2635650,
  },
  {
    name: "Tonbridge",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2635703,
  },
  {
    name: "Tiverton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2635762,
  },
  {
    name: "Tipton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2635785,
  },
  {
    name: "Thorne",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2635997,
  },
  {
    name: "Thornaby-on-Tees",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2636005,
  },
  {
    name: "Thetford",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2636032,
  },
  {
    name: "Thatcham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2636049,
  },
  {
    name: "Tewkesbury",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2636071,
  },
  {
    name: "Teignmouth",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2636132,
  },
  {
    name: "Taunton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2636177,
  },
  {
    name: "Tamworth",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2636276,
  },
  {
    name: "Tadley",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2636333,
  },
  {
    name: "Swinton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2636373,
  },
  {
    name: "Swindon",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2636389,
  },
  {
    name: "Swansea",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2636432,
  },
  {
    name: "Swanscombe",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2636433,
  },
  {
    name: "Swanley",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2636439,
  },
  {
    name: "Swadlincote",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2636465,
  },
  {
    name: "Sutton in Ashfield",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2636484,
  },
  {
    name: "Sutton Coldfield",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2636486,
  },
  {
    name: "Sutton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2636503,
  },
  {
    name: "Sunderland",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2636531,
  },
  {
    name: "Sunbury-on-Thames",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2636534,
  },
  {
    name: "Sudbury",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2636564,
  },
  {
    name: "Stroud",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2636616,
  },
  {
    name: "Strood",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2636619,
  },
  {
    name: "Stretford",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2636663,
  },
  {
    name: "Streatham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2636675,
  },
  {
    name: "Stratford-upon-Avon",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2636713,
  },
  {
    name: "Stratford",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2636714,
  },
  {
    name: "Stowmarket",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2636749,
  },
  {
    name: "Stourport-on-Severn",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2636767,
  },
  {
    name: "Stourbridge",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2636769,
  },
  {
    name: "Stoke-on-Trent",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2636841,
  },
  {
    name: "Stockton-on-Tees",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2636876,
  },
  {
    name: "Stockport",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2636882,
  },
  {
    name: "Stirling",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2636910,
  },
  {
    name: "Stevenage",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2636940,
  },
  {
    name: "Stepney",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2636948,
  },
  {
    name: "Staveley",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2636995,
  },
  {
    name: "Stanford-le-Hope",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2637087,
  },
  {
    name: "Stamford",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2637104,
  },
  {
    name: "Stalybridge",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2637106,
  },
  {
    name: "Staines",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2637126,
  },
  {
    name: "Stafford",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2637142,
  },
  {
    name: "Spennymoor",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2637235,
  },
  {
    name: "Spalding",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2637265,
  },
  {
    name: "South Shields",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2637329,
  },
  {
    name: "Southsea",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2637330,
  },
  {
    name: "Southport",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2637343,
  },
  {
    name: "South Ockendon",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2637355,
  },
  {
    name: "South Norwood",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2637357,
  },
  {
    name: "South Hayling",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2637407,
  },
  {
    name: "Southend-on-Sea",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2637433,
  },
  {
    name: "South Elmsall",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2637435,
  },
  {
    name: "South Benfleet",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2637476,
  },
  {
    name: "Southampton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2637487,
  },
  {
    name: "Southall",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2637490,
  },
  {
    name: "Solihull",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2637546,
  },
  {
    name: "Slough",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2637627,
  },
  {
    name: "Sleaford",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2637659,
  },
  {
    name: "Skelmersdale",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2637752,
  },
  {
    name: "Skegness",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2637762,
  },
  {
    name: "Sittingbourne",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2637802,
  },
  {
    name: "Shrewsbury",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2637891,
  },
  {
    name: "Shoreham-by-Sea",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2637916,
  },
  {
    name: "Shipley",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2637958,
  },
  {
    name: "Shepherds Bush",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2638043,
  },
  {
    name: "Sheffield",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2638077,
  },
  {
    name: "Sevenoaks",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2638187,
  },
  {
    name: "Selby",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2638235,
  },
  {
    name: "Seaham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2638302,
  },
  {
    name: "Seaford",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2638311,
  },
  {
    name: "Scunthorpe",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2638324,
  },
  {
    name: "Scarborough",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2638419,
  },
  {
    name: "Sandown",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2638568,
  },
  {
    name: "Sandhurst",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2638580,
  },
  {
    name: "Sandbach",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2638600,
  },
  {
    name: "Saltash",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2638651,
  },
  {
    name: "Salisbury",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2638664,
  },
  {
    name: "Salford",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2638671,
  },
  {
    name: "Sale",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2638678,
  },
  {
    name: "Saint Peters",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2638703,
  },
  {
    name: "Saint Neots",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2638717,
  },
  {
    name: "St Helens",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2638785,
  },
  {
    name: "St Austell",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2638853,
  },
  {
    name: "Saint Andrews",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2638864,
  },
  {
    name: "St Albans",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2638867,
  },
  {
    name: "Saffron Walden",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2638878,
  },
  {
    name: "Ryton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2638894,
  },
  {
    name: "Ryde",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2638911,
  },
  {
    name: "Rutherglen",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2638926,
  },
  {
    name: "Rushden",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2638946,
  },
  {
    name: "Runcorn",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2638960,
  },
  {
    name: "Ruislip",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2638976,
  },
  {
    name: "Rugeley",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2638977,
  },
  {
    name: "Rugby",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2638978,
  },
  {
    name: "Royton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2639015,
  },
  {
    name: "Royston",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2639018,
  },
  {
    name: "Royal Tunbridge Wells",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2639022,
  },
  {
    name: "Rottingdean",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2639069,
  },
  {
    name: "Rotherham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2639093,
  },
  {
    name: "Romsey",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2639189,
  },
  {
    name: "Romford",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2639192,
  },
  {
    name: "Roehampton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2639223,
  },
  {
    name: "Rochford",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2639265,
  },
  {
    name: "Rochester",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2639268,
  },
  {
    name: "Rochdale",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2639272,
  },
  {
    name: "Risca",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2639317,
  },
  {
    name: "Ripon",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2639323,
  },
  {
    name: "Ripley",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2639325,
  },
  {
    name: "Richmond",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2639389,
  },
  {
    name: "Rhyl",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2639409,
  },
  {
    name: "Rhosllanerchrugog",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2639436,
  },
  {
    name: "Rhondda",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2639447,
  },
  {
    name: "Renfrew",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2639495,
  },
  {
    name: "Reigate",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2639506,
  },
  {
    name: "Redruth",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2639524,
  },
  {
    name: "Redhill",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2639545,
  },
  {
    name: "Redditch",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2639557,
  },
  {
    name: "Redcar",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2639563,
  },
  {
    name: "Reading",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2639577,
  },
  {
    name: "Rayleigh",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2639583,
  },
  {
    name: "Rawtenstall",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2639586,
  },
  {
    name: "Rawmarsh",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2639588,
  },
  {
    name: "Ramsgate",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2639660,
  },
  {
    name: "Ramsbottom",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2639668,
  },
  {
    name: "Putney",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2639835,
  },
  {
    name: "Purley",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2639842,
  },
  {
    name: "Pudsey",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2639866,
  },
  {
    name: "Prestwich",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2639897,
  },
  {
    name: "Preston",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2639912,
  },
  {
    name: "Prestatyn",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2639926,
  },
  {
    name: "Prescot",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2639928,
  },
  {
    name: "Poulton-le-Fylde",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2639958,
  },
  {
    name: "Potters Bar",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2639970,
  },
  {
    name: "Portsmouth",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2639996,
  },
  {
    name: "Portslade",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2639998,
  },
  {
    name: "Portishead",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2640037,
  },
  {
    name: "Porthcawl",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2640054,
  },
  {
    name: "Port Glasgow",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2640060,
  },
  {
    name: "Portadown",
    country: "United Kingdom",
    subcountry: "Northern Ireland",
    geonameid: 2640085,
  },
  {
    name: "Poole",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2640101,
  },
  {
    name: "Pontypridd",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2640104,
  },
  {
    name: "Pontypool",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2640106,
  },
  {
    name: "Pontefract",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2640132,
  },
  {
    name: "Ponders End",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2640140,
  },
  {
    name: "Plymstock",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2640190,
  },
  {
    name: "Plymouth",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2640194,
  },
  {
    name: "Plumstead",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2640201,
  },
  {
    name: "Pitsea",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2640246,
  },
  {
    name: "Pinner",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2640275,
  },
  {
    name: "Peterlee",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2640349,
  },
  {
    name: "Peterhead",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2640351,
  },
  {
    name: "Peterborough",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2640354,
  },
  {
    name: "Perth",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2640358,
  },
  {
    name: "Penzance",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2640377,
  },
  {
    name: "Penrith",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2640416,
  },
  {
    name: "Penicuik",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2640465,
  },
  {
    name: "Penarth",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2640496,
  },
  {
    name: "Palmers Green",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2640667,
  },
  {
    name: "Paisley",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2640677,
  },
  {
    name: "Paignton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2640681,
  },
  {
    name: "Oxford",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2640729,
  },
  {
    name: "Oswestry",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2640861,
  },
  {
    name: "Ossett",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2640869,
  },
  {
    name: "Orpington",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2640894,
  },
  {
    name: "Ormskirk",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2640908,
  },
  {
    name: "Omagh",
    country: "United Kingdom",
    subcountry: "Northern Ireland",
    geonameid: 2640967,
  },
  {
    name: "Oldham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2641022,
  },
  {
    name: "Oadby",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2641134,
  },
  {
    name: "Nuneaton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2641157,
  },
  {
    name: "Nottingham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2641170,
  },
  {
    name: "Norwich",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2641181,
  },
  {
    name: "Northwich",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2641224,
  },
  {
    name: "North Shields",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2641267,
  },
  {
    name: "Northolt",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2641290,
  },
  {
    name: "Lancing",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2641319,
  },
  {
    name: "Northampton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2641430,
  },
  {
    name: "Northallerton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2641435,
  },
  {
    name: "Norbury",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2641462,
  },
  {
    name: "Newtownards",
    country: "United Kingdom",
    subcountry: "Northern Ireland",
    geonameid: 2641519,
  },
  {
    name: "Newtownabbey",
    country: "United Kingdom",
    subcountry: "Northern Ireland",
    geonameid: 2641520,
  },
  {
    name: "Newton Mearns",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2641544,
  },
  {
    name: "Newton-le-Willows",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2641546,
  },
  {
    name: "Newton Aycliffe",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2641555,
  },
  {
    name: "Newton Abbot",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2641557,
  },
  {
    name: "Newry",
    country: "United Kingdom",
    subcountry: "Northern Ireland",
    geonameid: 2641581,
  },
  {
    name: "Newquay",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2641589,
  },
  {
    name: "Newport Pagnell",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2641591,
  },
  {
    name: "Newport",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2641598,
  },
  {
    name: "Newport",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2641599,
  },
  {
    name: "New Milton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2641609,
  },
  {
    name: "New Mills",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2641612,
  },
  {
    name: "Newmarket",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2641616,
  },
  {
    name: "New Malden",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2641617,
  },
  {
    name: "New Cross",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2641661,
  },
  {
    name: "Newcastle upon Tyne",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2641673,
  },
  {
    name: "Newcastle under Lyme",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2641674,
  },
  {
    name: "Newbury",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2641689,
  },
  {
    name: "Newburn",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2641690,
  },
  {
    name: "Newark on Trent",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2641731,
  },
  {
    name: "Neston",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2641795,
  },
  {
    name: "Nelson",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2641810,
  },
  {
    name: "Neath",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2641843,
  },
  {
    name: "Nantwich",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2641892,
  },
  {
    name: "Nailsea",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2641913,
  },
  {
    name: "Musselburgh",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2641942,
  },
  {
    name: "Mountsorrel",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2642096,
  },
  {
    name: "Motherwell",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2642135,
  },
  {
    name: "Morley",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2642189,
  },
  {
    name: "Moreton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2642204,
  },
  {
    name: "Morecambe",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2642214,
  },
  {
    name: "Morden",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2642233,
  },
  {
    name: "Mitcham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2642414,
  },
  {
    name: "Mirfield",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2642423,
  },
  {
    name: "Milton Keynes",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2642465,
  },
  {
    name: "Middleton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2642593,
  },
  {
    name: "Middlesbrough",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2642607,
  },
  {
    name: "Mexborough",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2642683,
  },
  {
    name: "Merthyr Tydfil",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2642705,
  },
  {
    name: "Melton Mowbray",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2642763,
  },
  {
    name: "Melksham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2642786,
  },
  {
    name: "Meikle Earnock",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2642814,
  },
  {
    name: "Marple",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2642999,
  },
  {
    name: "Marlow",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2643003,
  },
  {
    name: "Market Harborough",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2643027,
  },
  {
    name: "Margate",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2643044,
  },
  {
    name: "March",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2643071,
  },
  {
    name: "Mansfield Woodhouse",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2643096,
  },
  {
    name: "Mansfield",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2643097,
  },
  {
    name: "Mangotsfield",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2643116,
  },
  {
    name: "Manchester",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2643123,
  },
  {
    name: "Maltby",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2643144,
  },
  {
    name: "Maldon",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2643160,
  },
  {
    name: "Maidstone",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2643179,
  },
  {
    name: "Maidenhead",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2643186,
  },
  {
    name: "Maghull",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2643198,
  },
  {
    name: "Maesteg",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2643218,
  },
  {
    name: "Macclesfield",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2643266,
  },
  {
    name: "Lymington",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2643312,
  },
  {
    name: "Luton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2643339,
  },
  {
    name: "Lowestoft",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2643490,
  },
  {
    name: "Louth",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2643553,
  },
  {
    name: "Loughborough",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2643567,
  },
  {
    name: "Longfield",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2643696,
  },
  {
    name: "Long Eaton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2643697,
  },
  {
    name: "Londonderry County Borough",
    country: "United Kingdom",
    subcountry: "Northern Ireland",
    geonameid: 2643734,
  },
  {
    name: "Derry",
    country: "United Kingdom",
    subcountry: "Northern Ireland",
    geonameid: 2643736,
  },
  {
    name: "London",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2643743,
  },
  {
    name: "Lofthouse",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2643776,
  },
  {
    name: "Llanelli",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2644100,
  },
  {
    name: "Llandudno",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2644120,
  },
  {
    name: "Livingston",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2644204,
  },
  {
    name: "Liverpool",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2644210,
  },
  {
    name: "Littlehampton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2644319,
  },
  {
    name: "Litherland",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2644386,
  },
  {
    name: "Lisburn",
    country: "United Kingdom",
    subcountry: "Northern Ireland",
    geonameid: 2644411,
  },
  {
    name: "Lincoln",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2644487,
  },
  {
    name: "Limehouse",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2644497,
  },
  {
    name: "Lichfield",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2644531,
  },
  {
    name: "Leyland",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2644547,
  },
  {
    name: "Lewes",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2644559,
  },
  {
    name: "Leighton Buzzard",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2644652,
  },
  {
    name: "Leigh",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2644660,
  },
  {
    name: "Leicester",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2644668,
  },
  {
    name: "Leek",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2644684,
  },
  {
    name: "Leeds",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2644688,
  },
  {
    name: "Leatherhead",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2644726,
  },
  {
    name: "Royal Leamington Spa",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2644737,
  },
  {
    name: "Larne",
    country: "United Kingdom",
    subcountry: "Northern Ireland",
    geonameid: 2644849,
  },
  {
    name: "Larkhall",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2644853,
  },
  {
    name: "Lancaster",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2644972,
  },
  {
    name: "Kirkintilloch",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2645261,
  },
  {
    name: "Kirkcaldy",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2645298,
  },
  {
    name: "Kirkby in Ashfield",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2645309,
  },
  {
    name: "Kirkby",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2645313,
  },
  {
    name: "Kippax",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2645347,
  },
  {
    name: "Kingswood",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2645418,
  },
  {
    name: "Kingswinford",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2645420,
  },
  {
    name: "Kingston upon Hull",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2645425,
  },
  {
    name: "King's Lynn",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2645456,
  },
  {
    name: "Kilwinning",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2645541,
  },
  {
    name: "Kilmarnock",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2645605,
  },
  {
    name: "Kidsgrove",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2645721,
  },
  {
    name: "Kidlington",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2645722,
  },
  {
    name: "Kidderminster",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2645724,
  },
  {
    name: "Keynsham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2645733,
  },
  {
    name: "Kettering",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2645753,
  },
  {
    name: "Kenilworth",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2645822,
  },
  {
    name: "Kendal",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2645826,
  },
  {
    name: "Kempston",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2645831,
  },
  {
    name: "Keighley",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2645889,
  },
  {
    name: "Johnstone",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2645951,
  },
  {
    name: "Jarrow",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2645972,
  },
  {
    name: "Islington",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2646003,
  },
  {
    name: "Isleworth",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2646004,
  },
  {
    name: "Irvine",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2646032,
  },
  {
    name: "Irlam",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2646042,
  },
  {
    name: "Ipswich",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2646057,
  },
  {
    name: "Inverness",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2646088,
  },
  {
    name: "Ilkeston",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2646274,
  },
  {
    name: "Ilford",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2646277,
  },
  {
    name: "Hythe",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2646317,
  },
  {
    name: "Hyde",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2646327,
  },
  {
    name: "Huyton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2646329,
  },
  {
    name: "Huntingdon",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2646393,
  },
  {
    name: "Huddersfield",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2646458,
  },
  {
    name: "Hucknall",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2646460,
  },
  {
    name: "Hoyland Nether",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2646471,
  },
  {
    name: "Hove",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2646504,
  },
  {
    name: "Hounslow",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2646517,
  },
  {
    name: "Houghton-Le-Spring",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2646525,
  },
  {
    name: "Horwich",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2646542,
  },
  {
    name: "Horsham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2646557,
  },
  {
    name: "Horsforth",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2646558,
  },
  {
    name: "Horley",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2646606,
  },
  {
    name: "Hook",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2646653,
  },
  {
    name: "Hoddesdon",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2646807,
  },
  {
    name: "Hitchin",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2646826,
  },
  {
    name: "Hindley",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2646862,
  },
  {
    name: "Hinckley",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2646867,
  },
  {
    name: "High Wycombe",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2646914,
  },
  {
    name: "Highbury",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2646976,
  },
  {
    name: "High Blantyre",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2646979,
  },
  {
    name: "Heysham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647001,
  },
  {
    name: "Heswall",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647026,
  },
  {
    name: "Heston",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647027,
  },
  {
    name: "Hertford",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647044,
  },
  {
    name: "Herne Bay",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647057,
  },
  {
    name: "Hereford",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647074,
  },
  {
    name: "Hemel Hempstead",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647138,
  },
  {
    name: "Hebburn",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647209,
  },
  {
    name: "Heanor",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647227,
  },
  {
    name: "Hazel Grove",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647246,
  },
  {
    name: "Haywards Heath",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647248,
  },
  {
    name: "Hayes",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647261,
  },
  {
    name: "Hayes",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647262,
  },
  {
    name: "Haydock",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647265,
  },
  {
    name: "Hawarden",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2647303,
  },
  {
    name: "Haverhill",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647310,
  },
  {
    name: "Havant",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647317,
  },
  {
    name: "Hatfield",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647349,
  },
  {
    name: "Hastings",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647356,
  },
  {
    name: "Haslingden",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647363,
  },
  {
    name: "Harwich",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647383,
  },
  {
    name: "Hartley",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647398,
  },
  {
    name: "Hartlepool",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647400,
  },
  {
    name: "Harrow",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647425,
  },
  {
    name: "Harrogate",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647428,
  },
  {
    name: "Harpenden",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647451,
  },
  {
    name: "Harlow",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647461,
  },
  {
    name: "Harlesden",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647468,
  },
  {
    name: "Hanworth",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647514,
  },
  {
    name: "Hampton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647550,
  },
  {
    name: "Hamilton",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2647570,
  },
  {
    name: "Halifax",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647632,
  },
  {
    name: "Halesowen",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647639,
  },
  {
    name: "Hale",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647644,
  },
  {
    name: "Hailsham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647655,
  },
  {
    name: "Hadleigh",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647679,
  },
  {
    name: "Guiseley",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647784,
  },
  {
    name: "Guisborough",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647785,
  },
  {
    name: "Guildford",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647793,
  },
  {
    name: "Grove",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647837,
  },
  {
    name: "Grimsby",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647878,
  },
  {
    name: "Greenock",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2647948,
  },
  {
    name: "Greenford",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647972,
  },
  {
    name: "Great Yarmouth",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647984,
  },
  {
    name: "Great Wyrley",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2647985,
  },
  {
    name: "Great Sankey",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2648026,
  },
  {
    name: "Great Malvern",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2648063,
  },
  {
    name: "Grays",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2648182,
  },
  {
    name: "Gravesend",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2648187,
  },
  {
    name: "Grantham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2648208,
  },
  {
    name: "Grangemouth",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2648215,
  },
  {
    name: "Gosport",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2648272,
  },
  {
    name: "Gosforth",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2648273,
  },
  {
    name: "Gorseinon",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2648290,
  },
  {
    name: "Goole",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2648319,
  },
  {
    name: "Golborne",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2648356,
  },
  {
    name: "Godalming",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2648372,
  },
  {
    name: "Gloucester",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2648404,
  },
  {
    name: "Glossop",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2648405,
  },
  {
    name: "Glenrothes",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2648438,
  },
  {
    name: "Glasgow",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2648579,
  },
  {
    name: "Gillingham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2648657,
  },
  {
    name: "Gelligaer",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2648728,
  },
  {
    name: "Gateshead",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2648773,
  },
  {
    name: "Gainsborough",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2648945,
  },
  {
    name: "Fylde",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2648970,
  },
  {
    name: "Fulwood",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2648988,
  },
  {
    name: "Fulham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2648997,
  },
  {
    name: "Frome",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2649024,
  },
  {
    name: "Frinton-on-Sea",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2649049,
  },
  {
    name: "Friern Barnet",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2649055,
  },
  {
    name: "Formby",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2649198,
  },
  {
    name: "Folkestone",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2649258,
  },
  {
    name: "Flint",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2649301,
  },
  {
    name: "Fleetwood",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2649312,
  },
  {
    name: "Fleet",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2649322,
  },
  {
    name: "Finchley",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2649441,
  },
  {
    name: "Feltham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2649571,
  },
  {
    name: "Felling",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2649578,
  },
  {
    name: "Felixstowe",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2649579,
  },
  {
    name: "Faversham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2649622,
  },
  {
    name: "Farnworth",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2649650,
  },
  {
    name: "Farnham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2649660,
  },
  {
    name: "Farnborough",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2649672,
  },
  {
    name: "Fareham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2649692,
  },
  {
    name: "Falmouth",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2649715,
  },
  {
    name: "Falkirk",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2649723,
  },
  {
    name: "Exmouth",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2649800,
  },
  {
    name: "Exeter",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2649808,
  },
  {
    name: "Evesham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2649833,
  },
  {
    name: "Esher",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2649911,
  },
  {
    name: "Epsom",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2649957,
  },
  {
    name: "Enfield Lock",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2649996,
  },
  {
    name: "Enfield Town",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2649997,
  },
  {
    name: "Emsworth",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2650004,
  },
  {
    name: "Ely",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2650023,
  },
  {
    name: "Eltham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2650042,
  },
  {
    name: "Ellesmere Port Town",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2650096,
  },
  {
    name: "Elland",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2650110,
  },
  {
    name: "Elgin",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2650122,
  },
  {
    name: "Egham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2650188,
  },
  {
    name: "Edmonton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2650209,
  },
  {
    name: "Edinburgh",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2650225,
  },
  {
    name: "Eccles",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2650278,
  },
  {
    name: "Ebbw Vale",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2650285,
  },
  {
    name: "Eastwood",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2650309,
  },
  {
    name: "Retford",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2650346,
  },
  {
    name: "East Molesey",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2650376,
  },
  {
    name: "Eastleigh",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2650396,
  },
  {
    name: "East Kilbride",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2650405,
  },
  {
    name: "East Grinstead",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2650435,
  },
  {
    name: "East Dereham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2650470,
  },
  {
    name: "Eastbourne",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2650497,
  },
  {
    name: "Durham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2650628,
  },
  {
    name: "Dunstable",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2650657,
  },
  {
    name: "Dunfermline",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2650732,
  },
  {
    name: "Dundee",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2650752,
  },
  {
    name: "Dumfries",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2650798,
  },
  {
    name: "Dumbarton",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2650802,
  },
  {
    name: "Dukinfield",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2650815,
  },
  {
    name: "Dudley",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2650839,
  },
  {
    name: "Droylsden",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2650962,
  },
  {
    name: "Dronfield",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2650967,
  },
  {
    name: "Droitwich",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2650983,
  },
  {
    name: "Dover",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2651048,
  },
  {
    name: "Dorking",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2651095,
  },
  {
    name: "Dorchester",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2651101,
  },
  {
    name: "Doncaster",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2651123,
  },
  {
    name: "Dinnington",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2651241,
  },
  {
    name: "Didcot",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2651269,
  },
  {
    name: "Dewsbury",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2651286,
  },
  {
    name: "Devizes",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2651294,
  },
  {
    name: "Derby",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2651347,
  },
  {
    name: "Denton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2651357,
  },
  {
    name: "Deal",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2651468,
  },
  {
    name: "Daventry",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2651485,
  },
  {
    name: "Darwen",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2651495,
  },
  {
    name: "Darton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2651497,
  },
  {
    name: "Dartford",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2651500,
  },
  {
    name: "Darlington",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2651513,
  },
  {
    name: "Dalserf",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2651558,
  },
  {
    name: "Dagenham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2651621,
  },
  {
    name: "Cwmbran",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2651654,
  },
  {
    name: "Cumbernauld",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2651715,
  },
  {
    name: "Croydon",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2651817,
  },
  {
    name: "Crowthorne",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2651831,
  },
  {
    name: "Crowborough",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2651852,
  },
  {
    name: "Cricklewood",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2651984,
  },
  {
    name: "Crewe",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2652002,
  },
  {
    name: "Crawley",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2652053,
  },
  {
    name: "Cramlington",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2652095,
  },
  {
    name: "Cowley",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2652191,
  },
  {
    name: "Cowes",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2652204,
  },
  {
    name: "Coventry",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2652221,
  },
  {
    name: "Coulsdon",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2652249,
  },
  {
    name: "Corby",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2652381,
  },
  {
    name: "Consett",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2652437,
  },
  {
    name: "Conisbrough",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2652458,
  },
  {
    name: "Congleton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2652464,
  },
  {
    name: "Colwyn Bay",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2652513,
  },
  {
    name: "Colne",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2652544,
  },
  {
    name: "Coleraine",
    country: "United Kingdom",
    subcountry: "Northern Ireland",
    geonameid: 2652586,
  },
  {
    name: "Colchester",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2652618,
  },
  {
    name: "Coity",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2652622,
  },
  {
    name: "Cobham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2652689,
  },
  {
    name: "Coatbridge",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2652696,
  },
  {
    name: "Coalville",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2652698,
  },
  {
    name: "Clydebank",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2652730,
  },
  {
    name: "Clydach",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2652734,
  },
  {
    name: "Clevedon",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2652861,
  },
  {
    name: "Cleethorpes",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2652885,
  },
  {
    name: "Cleckheaton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2652890,
  },
  {
    name: "Clacton-on-Sea",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2652974,
  },
  {
    name: "Cirencester",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2652995,
  },
  {
    name: "Christchurch",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2653075,
  },
  {
    name: "Chorley",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2653086,
  },
  {
    name: "Chiswick",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2653121,
  },
  {
    name: "Chislehurst",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2653123,
  },
  {
    name: "Chipping Sodbury",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2653137,
  },
  {
    name: "Chippenham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2653144,
  },
  {
    name: "Chingford",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2653148,
  },
  {
    name: "Chichester",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2653192,
  },
  {
    name: "Chester-le-Street",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2653224,
  },
  {
    name: "Chesterfield",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2653225,
  },
  {
    name: "Chester",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2653228,
  },
  {
    name: "Chessington",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2653229,
  },
  {
    name: "Cheshunt",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2653232,
  },
  {
    name: "Chesham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2653235,
  },
  {
    name: "Chepstow",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2653256,
  },
  {
    name: "Cheltenham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2653261,
  },
  {
    name: "Chelsea",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2653265,
  },
  {
    name: "Chelmsford",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2653266,
  },
  {
    name: "Cheadle Hulme",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2653290,
  },
  {
    name: "Chatham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2653305,
  },
  {
    name: "Chapeltown",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2653353,
  },
  {
    name: "Chalfont Saint Peter",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2653393,
  },
  {
    name: "Catford",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2653516,
  },
  {
    name: "Caterham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2653520,
  },
  {
    name: "Castlereagh",
    country: "United Kingdom",
    subcountry: "Northern Ireland",
    geonameid: 2653558,
  },
  {
    name: "Castleford",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2653584,
  },
  {
    name: "Carterton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2653634,
  },
  {
    name: "Carshalton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2653646,
  },
  {
    name: "Carrickfergus",
    country: "United Kingdom",
    subcountry: "Northern Ireland",
    geonameid: 2653680,
  },
  {
    name: "Carmarthen",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2653755,
  },
  {
    name: "Carlisle",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2653775,
  },
  {
    name: "Cardiff",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2653822,
  },
  {
    name: "Canterbury",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2653877,
  },
  {
    name: "Cannock",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2653883,
  },
  {
    name: "Cambuslang",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2653935,
  },
  {
    name: "Cambridge",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2653941,
  },
  {
    name: "Camborne",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2653945,
  },
  {
    name: "Camberley",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2653947,
  },
  {
    name: "Calne",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2653974,
  },
  {
    name: "Caerphilly",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2654089,
  },
  {
    name: "Buxton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2654141,
  },
  {
    name: "Bushey",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2654179,
  },
  {
    name: "Bury St Edmunds",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2654186,
  },
  {
    name: "Bury",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2654187,
  },
  {
    name: "Burton upon Trent",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2654200,
  },
  {
    name: "Burntwood",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2654252,
  },
  {
    name: "Burnley",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2654264,
  },
  {
    name: "Burnham-on-Sea",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2654269,
  },
  {
    name: "Burgess Hill",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2654308,
  },
  {
    name: "Buckley",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2654394,
  },
  {
    name: "Brymbo",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2654450,
  },
  {
    name: "Broxburn",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2654480,
  },
  {
    name: "Brownhills",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2654490,
  },
  {
    name: "Brough",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2654532,
  },
  {
    name: "Bromsgrove",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2654579,
  },
  {
    name: "Broadstairs",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2654635,
  },
  {
    name: "Brixham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2654663,
  },
  {
    name: "Briton Ferry",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2654668,
  },
  {
    name: "Bristol",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2654675,
  },
  {
    name: "Brighton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2654710,
  },
  {
    name: "Brighouse",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2654715,
  },
  {
    name: "Brierley Hill",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2654724,
  },
  {
    name: "Bridlington",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2654728,
  },
  {
    name: "Bridgwater",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2654730,
  },
  {
    name: "Bridgend",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2654755,
  },
  {
    name: "Brentwood",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2654782,
  },
  {
    name: "Brent",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2654789,
  },
  {
    name: "Bredbury",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2654814,
  },
  {
    name: "Bramhall",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2654927,
  },
  {
    name: "Braintree",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2654938,
  },
  {
    name: "Bradford",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2654993,
  },
  {
    name: "Bracknell",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2655009,
  },
  {
    name: "Bow",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2655076,
  },
  {
    name: "Bournemouth",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2655095,
  },
  {
    name: "Boston",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2655138,
  },
  {
    name: "Borehamwood",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2655186,
  },
  {
    name: "Bootle",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2655198,
  },
  {
    name: "Bonnyrigg",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2655210,
  },
  {
    name: "Bolton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2655237,
  },
  {
    name: "Bognor Regis",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2655262,
  },
  {
    name: "Blyth",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2655315,
  },
  {
    name: "Bloxwich",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2655329,
  },
  {
    name: "Bletchley",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2655351,
  },
  {
    name: "Blackwall",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2655438,
  },
  {
    name: "Blackpool",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2655459,
  },
  {
    name: "Blackburn",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2655524,
  },
  {
    name: "Bishopstoke",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2655557,
  },
  {
    name: "Bishops Stortford",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2655562,
  },
  {
    name: "Bishopbriggs",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2655582,
  },
  {
    name: "Bishop Auckland",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2655583,
  },
  {
    name: "Birmingham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2655603,
  },
  {
    name: "Birkenhead",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2655613,
  },
  {
    name: "Bingley",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2655642,
  },
  {
    name: "Billingham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2655664,
  },
  {
    name: "Billericay",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2655672,
  },
  {
    name: "Biggleswade",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2655689,
  },
  {
    name: "Bideford",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2655707,
  },
  {
    name: "Biddulph",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2655708,
  },
  {
    name: "Bicester",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2655729,
  },
  {
    name: "Bexley",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2655775,
  },
  {
    name: "Bexhill-on-Sea",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2655777,
  },
  {
    name: "Beverley",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2655785,
  },
  {
    name: "Berkhamsted",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2655858,
  },
  {
    name: "Bentley",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2655882,
  },
  {
    name: "Belper",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2655942,
  },
  {
    name: "Bellshill",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2655952,
  },
  {
    name: "Belfast",
    country: "United Kingdom",
    subcountry: "Northern Ireland",
    geonameid: 2655984,
  },
  {
    name: "Bedworth",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2656031,
  },
  {
    name: "Bedlington",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2656039,
  },
  {
    name: "Bedford",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2656046,
  },
  {
    name: "Beckenham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2656065,
  },
  {
    name: "Bebington",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2656070,
  },
  {
    name: "Bearsden",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2656086,
  },
  {
    name: "Batley",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2656168,
  },
  {
    name: "Bathgate",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2656169,
  },
  {
    name: "Bath",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2656173,
  },
  {
    name: "Basingstoke",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2656192,
  },
  {
    name: "Basildon",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2656194,
  },
  {
    name: "Basford",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2656196,
  },
  {
    name: "Barry",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2656235,
  },
  {
    name: "Barrow in Furness",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2656241,
  },
  {
    name: "Barrhead",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2656258,
  },
  {
    name: "Barnstaple",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2656281,
  },
  {
    name: "Barnsley",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2656284,
  },
  {
    name: "Barnet",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2656295,
  },
  {
    name: "Barnes",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2656296,
  },
  {
    name: "Barking",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2656333,
  },
  {
    name: "Banstead",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2656379,
  },
  {
    name: "Bangor",
    country: "United Kingdom",
    subcountry: "Northern Ireland",
    geonameid: 2656396,
  },
  {
    name: "Bangor",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2656397,
  },
  {
    name: "Banbury",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2656406,
  },
  {
    name: "Banbridge",
    country: "United Kingdom",
    subcountry: "Northern Ireland",
    geonameid: 2656407,
  },
  {
    name: "Ballymena",
    country: "United Kingdom",
    subcountry: "Northern Ireland",
    geonameid: 2656490,
  },
  {
    name: "Baildon",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2656627,
  },
  {
    name: "Ayr",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2656708,
  },
  {
    name: "Aylesbury",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2656719,
  },
  {
    name: "Atherton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2656847,
  },
  {
    name: "Aston",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2656867,
  },
  {
    name: "Ashton-under-Lyne",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2656915,
  },
  {
    name: "Ashton in Makerfield",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2656918,
  },
  {
    name: "Ashington",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2656946,
  },
  {
    name: "Ashford",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2656954,
  },
  {
    name: "Ashford",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2656955,
  },
  {
    name: "Ascot",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2656992,
  },
  {
    name: "Arnold",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2657030,
  },
  {
    name: "Arbroath",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2657215,
  },
  {
    name: "Antrim",
    country: "United Kingdom",
    subcountry: "Northern Ireland",
    geonameid: 2657255,
  },
  {
    name: "Andover",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2657324,
  },
  {
    name: "Ampthill",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2657337,
  },
  {
    name: "Ammanford",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2657345,
  },
  {
    name: "Amersham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2657356,
  },
  {
    name: "Altrincham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2657402,
  },
  {
    name: "Alton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2657408,
  },
  {
    name: "Alloa",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2657471,
  },
  {
    name: "Alfreton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2657508,
  },
  {
    name: "Aldridge",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2657528,
  },
  {
    name: "Aldershot",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2657540,
  },
  {
    name: "Airdrie",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2657613,
  },
  {
    name: "Adwick le Street",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2657658,
  },
  {
    name: "Acton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2657697,
  },
  {
    name: "Acocks Green",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2657703,
  },
  {
    name: "Accrington",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2657770,
  },
  {
    name: "Abingdon",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 2657780,
  },
  {
    name: "Aberystwyth",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2657782,
  },
  {
    name: "Abergele",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2657812,
  },
  {
    name: "Aberdeen",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 2657832,
  },
  {
    name: "Aberdare",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 2657835,
  },
  {
    name: "Crosby",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 3209584,
  },
  {
    name: "Tonypandy",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 3345283,
  },
  {
    name: "Blackwood",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 3345317,
  },
  {
    name: "Neston",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 3345432,
  },
  {
    name: "Camden Town",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 3345437,
  },
  {
    name: "Telford",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 3345439,
  },
  {
    name: "Craigavon",
    country: "United Kingdom",
    subcountry: "Northern Ireland",
    geonameid: 3345440,
  },
  {
    name: "Soho",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6545173,
  },
  {
    name: "Bayswater",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6545243,
  },
  {
    name: "Yateley",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6620293,
  },
  {
    name: "Bowthorpe",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6620355,
  },
  {
    name: "Hedge End",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6620360,
  },
  {
    name: "Gerrards Cross",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6620444,
  },
  {
    name: "Erskine",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 6639623,
  },
  {
    name: "Hale",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6640028,
  },
  {
    name: "Kilburn",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6690572,
  },
  {
    name: "Chalk Farm",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6690583,
  },
  {
    name: "Amersham on the Hill",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6690592,
  },
  {
    name: "Shadwell",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6690595,
  },
  {
    name: "Battersea",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6690602,
  },
  {
    name: "Tooting",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6690824,
  },
  {
    name: "South Croydon",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6690862,
  },
  {
    name: "Hornchurch",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6690863,
  },
  {
    name: "Surbiton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6690866,
  },
  {
    name: "Ewell",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6690867,
  },
  {
    name: "Becontree",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6690870,
  },
  {
    name: "Brixton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6690877,
  },
  {
    name: "Bethnal Green",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6690989,
  },
  {
    name: "Failsworth",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6691219,
  },
  {
    name: "Radcliffe",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6691227,
  },
  {
    name: "Heywood",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6691235,
  },
  {
    name: "Longsight",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6691766,
  },
  {
    name: "Heavitree",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6691884,
  },
  {
    name: "Ferndown",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6691927,
  },
  {
    name: "Canary Wharf",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6692280,
  },
  {
    name: "Leytonstone",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6692921,
  },
  {
    name: "Earl Shilton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6693007,
  },
  {
    name: "Bordon",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6693242,
  },
  {
    name: "Lytham St Annes",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6693470,
  },
  {
    name: "Hadley Wood",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6693771,
  },
  {
    name: "Muswell Hill",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6694222,
  },
  {
    name: "Chapel Allerton",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6695247,
  },
  {
    name: "Blackheath",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6947041,
  },
  {
    name: "Kempston Hardwick",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6947168,
  },
  {
    name: "Mendip",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 6947756,
  },
  {
    name: "Lower Earley",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 7290015,
  },
  {
    name: "Bartley Green",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 7302130,
  },
  {
    name: "Golders Green",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 7535506,
  },
  {
    name: "Canvey Island",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 7911271,
  },
  {
    name: "Earlsfield",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 8063096,
  },
  {
    name: "Peacehaven",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 8128721,
  },
  {
    name: "Letchworth Garden City",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 8224216,
  },
  {
    name: "Peckham",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 8224580,
  },
  {
    name: "Shirley",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 8224782,
  },
  {
    name: "Stanley",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 8224783,
  },
  {
    name: "Rossendale",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 8299614,
  },
  {
    name: "Thornton-Cleveleys",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 8299615,
  },
  {
    name: "Deeside",
    country: "United Kingdom",
    subcountry: "Wales",
    geonameid: 8299616,
  },
  {
    name: "High Peak",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 8299617,
  },
  {
    name: "Hayling Island",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 8299619,
  },
  {
    name: "Isle of Lewis",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 8299620,
  },
  {
    name: "Holloway",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 8315400,
  },
  {
    name: "Harringay",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 8581595,
  },
  {
    name: "Canning Town",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 11549407,
  },
  {
    name: "Manor Park",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 11550772,
  },
  {
    name: "Thamesmead",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 11551039,
  },
  {
    name: "Brockley",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 11551040,
  },
  {
    name: "Blantyre",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 11592111,
  },
  {
    name: "Vale of Leven",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 11592272,
  },
  {
    name: "Viewpark",
    country: "United Kingdom",
    subcountry: "Scotland",
    geonameid: 11592296,
  },
  {
    name: "Stamford Hill",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 11669854,
  },
  {
    name: "Burngreave",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 11776857,
  },
  {
    name: "Archway",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 11777624,
  },
  {
    name: "Sinfin",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 11863036,
  },
  {
    name: "Perry Vale",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 12048177,
  },
  {
    name: "Furzedown",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 12048252,
  },
  {
    name: "Seven Sisters",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 12048325,
  },
  {
    name: "Tottenham Hale",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 12048327,
  },
  {
    name: "Washwood Heath",
    country: "United Kingdom",
    subcountry: "England",
    geonameid: 12076699,
  },
  {
    name: "Saint George's",
    country: "Grenada",
    subcountry: "Saint George",
    geonameid: 3579925,
  },
  {
    name: "Zugdidi",
    country: "Georgia",
    subcountry: "Samegrelo and Zemo Svaneti",
    geonameid: 610824,
  },
  {
    name: "Zest’aponi",
    country: "Georgia",
    subcountry: "Imereti",
    geonameid: 610864,
  },
  {
    name: "Ts’khinvali",
    country: "Georgia",
    subcountry: "Shida Kartli",
    geonameid: 611403,
  },
  {
    name: "Tqvarch'eli",
    country: "Georgia",
    subcountry: "Abkhazia",
    geonameid: 611583,
  },
  {
    name: "Telavi",
    country: "Georgia",
    subcountry: "Kakheti",
    geonameid: 611694,
  },
  {
    name: "Tbilisi",
    country: "Georgia",
    subcountry: "T'bilisi",
    geonameid: 611717,
  },
  {
    name: "Sokhumi",
    country: "Georgia",
    subcountry: "Abkhazia",
    geonameid: 611847,
  },
  {
    name: "Senak’i",
    country: "Georgia",
    subcountry: "Samegrelo and Zemo Svaneti",
    geonameid: 612053,
  },
  {
    name: "Samtredia",
    country: "Georgia",
    subcountry: "Imereti",
    geonameid: 612126,
  },
  {
    name: "Rustavi",
    country: "Georgia",
    subcountry: "Kvemo Kartli",
    geonameid: 612287,
  },
  {
    name: "P’ot’i",
    country: "Georgia",
    subcountry: "Samegrelo and Zemo Svaneti",
    geonameid: 612366,
  },
  {
    name: "Och’amch’ire",
    country: "Georgia",
    subcountry: "Abkhazia",
    geonameid: 612652,
  },
  {
    name: "Marneuli",
    country: "Georgia",
    subcountry: "Kvemo Kartli",
    geonameid: 613074,
  },
  {
    name: "Kutaisi",
    country: "Georgia",
    subcountry: "Imereti",
    geonameid: 613607,
  },
  {
    name: "Kobuleti",
    country: "Georgia",
    subcountry: "Achara",
    geonameid: 613762,
  },
  {
    name: "Khashuri",
    country: "Georgia",
    subcountry: "Shida Kartli",
    geonameid: 613988,
  },
  {
    name: "Gori",
    country: "Georgia",
    subcountry: "Shida Kartli",
    geonameid: 614455,
  },
  {
    name: "Batumi",
    country: "Georgia",
    subcountry: "Achara",
    geonameid: 615532,
  },
  {
    name: "Akhaltsikhe",
    country: "Georgia",
    subcountry: "Samtskhe-Javakheti",
    geonameid: 615860,
  },
  {
    name: "Stantsiya Novyy Afon",
    country: "Georgia",
    subcountry: "Abkhazia",
    geonameid: 615912,
  },
  {
    name: "Ts’q’alt’ubo",
    country: "Georgia",
    subcountry: "Imereti",
    geonameid: 824288,
  },
  {
    name: "Saint-Laurent-du-Maroni",
    country: "French Guiana",
    subcountry: "Guyane",
    geonameid: 3380387,
  },
  {
    name: "Rémire-Montjoly",
    country: "French Guiana",
    subcountry: "Guyane",
    geonameid: 3380892,
  },
  {
    name: "Matoury",
    country: "French Guiana",
    subcountry: "Guyane",
    geonameid: 3380965,
  },
  {
    name: "Kourou",
    country: "French Guiana",
    subcountry: "Guyane",
    geonameid: 3381303,
  },
  {
    name: "Cayenne",
    country: "French Guiana",
    subcountry: "Guyane",
    geonameid: 3382160,
  },
  {
    name: "Saint Peter Port",
    country: "Guernsey",
    subcountry: "St Peter Port",
    geonameid: 3042287,
  },
  {
    name: "Yendi",
    country: "Ghana",
    subcountry: "Northern",
    geonameid: 2293801,
  },
  {
    name: "Winneba",
    country: "Ghana",
    subcountry: "Central",
    geonameid: 2294034,
  },
  {
    name: "Wankyi",
    country: "Ghana",
    subcountry: "Bono",
    geonameid: 2294086,
  },
  {
    name: "Wa",
    country: "Ghana",
    subcountry: "Upper West",
    geonameid: 2294206,
  },
  {
    name: "Teshi Old Town",
    country: "Ghana",
    subcountry: "Greater Accra",
    geonameid: 2294665,
  },
  {
    name: "Tema",
    country: "Ghana",
    subcountry: "Greater Accra",
    geonameid: 2294700,
  },
  {
    name: "Techiman",
    country: "Ghana",
    subcountry: "Bono East",
    geonameid: 2294727,
  },
  {
    name: "Tarkwa",
    country: "Ghana",
    subcountry: "Western",
    geonameid: 2294768,
  },
  {
    name: "Tamale",
    country: "Ghana",
    subcountry: "Northern",
    geonameid: 2294877,
  },
  {
    name: "Takoradi",
    country: "Ghana",
    subcountry: "Western",
    geonameid: 2294915,
  },
  {
    name: "Tafo",
    country: "Ghana",
    subcountry: "Ashanti",
    geonameid: 2294938,
  },
  {
    name: "Swedru",
    country: "Ghana",
    subcountry: "Central",
    geonameid: 2294962,
  },
  {
    name: "Sunyani",
    country: "Ghana",
    subcountry: "Bono",
    geonameid: 2295021,
  },
  {
    name: "Suhum",
    country: "Ghana",
    subcountry: "Eastern",
    geonameid: 2295065,
  },
  {
    name: "Shama Junction",
    country: "Ghana",
    subcountry: "Western",
    geonameid: 2295385,
  },
  {
    name: "Sekondi-Takoradi",
    country: "Ghana",
    subcountry: "Western",
    geonameid: 2295458,
  },
  {
    name: "Savelugu",
    country: "Ghana",
    subcountry: "Northern",
    geonameid: 2295517,
  },
  {
    name: "Saltpond",
    country: "Ghana",
    subcountry: "Central",
    geonameid: 2295672,
  },
  {
    name: "Salaga",
    country: "Ghana",
    subcountry: "Savannah",
    geonameid: 2295684,
  },
  {
    name: "Prestea",
    country: "Ghana",
    subcountry: "Western",
    geonameid: 2295840,
  },
  {
    name: "Kasoa",
    country: "Ghana",
    subcountry: "Central",
    geonameid: 2296458,
  },
  {
    name: "Akim Oda",
    country: "Ghana",
    subcountry: "Eastern",
    geonameid: 2296564,
  },
  {
    name: "Obuase",
    country: "Ghana",
    subcountry: "Ashanti",
    geonameid: 2296606,
  },
  {
    name: "Nungua",
    country: "Ghana",
    subcountry: "Greater Accra",
    geonameid: 2296969,
  },
  {
    name: "Nsawam",
    country: "Ghana",
    subcountry: "Eastern",
    geonameid: 2297141,
  },
  {
    name: "Navrongo",
    country: "Ghana",
    subcountry: "Upper East",
    geonameid: 2297505,
  },
  {
    name: "Mampong",
    country: "Ghana",
    subcountry: "Ashanti",
    geonameid: 2298264,
  },
  {
    name: "Medina Estates",
    country: "Ghana",
    subcountry: "Greater Accra",
    geonameid: 2298330,
  },
  {
    name: "Kumasi",
    country: "Ghana",
    subcountry: "Ashanti",
    geonameid: 2298890,
  },
  {
    name: "Kpandu",
    country: "Ghana",
    subcountry: "Volta",
    geonameid: 2299233,
  },
  {
    name: "Konongo",
    country: "Ghana",
    subcountry: "Ashanti",
    geonameid: 2299349,
  },
  {
    name: "Koforidua",
    country: "Ghana",
    subcountry: "Eastern",
    geonameid: 2299522,
  },
  {
    name: "Kintampo",
    country: "Ghana",
    subcountry: "Bono East",
    geonameid: 2299625,
  },
  {
    name: "Keta",
    country: "Ghana",
    subcountry: "Volta",
    geonameid: 2299645,
  },
  {
    name: "Japekrom",
    country: "Ghana",
    subcountry: "Bono",
    geonameid: 2300182,
  },
  {
    name: "Hohoe",
    country: "Ghana",
    subcountry: "Volta",
    geonameid: 2300372,
  },
  {
    name: "Ho",
    country: "Ghana",
    subcountry: "Volta",
    geonameid: 2300379,
  },
  {
    name: "Gbawe",
    country: "Ghana",
    subcountry: "Greater Accra",
    geonameid: 2300721,
  },
  {
    name: "Foso",
    country: "Ghana",
    subcountry: "Central",
    geonameid: 2300883,
  },
  {
    name: "Elmina",
    country: "Ghana",
    subcountry: "Central",
    geonameid: 2301190,
  },
  {
    name: "Ejura",
    country: "Ghana",
    subcountry: "Ashanti",
    geonameid: 2301217,
  },
  {
    name: "Dunkwa",
    country: "Ghana",
    subcountry: "Central",
    geonameid: 2301400,
  },
  {
    name: "Duayaw-Nkwanta",
    country: "Ghana",
    subcountry: "Ahafo",
    geonameid: 2301464,
  },
  {
    name: "Dome",
    country: "Ghana",
    subcountry: "Greater Accra",
    geonameid: 2301639,
  },
  {
    name: "Cape Coast",
    country: "Ghana",
    subcountry: "Central",
    geonameid: 2302357,
  },
  {
    name: "Bolgatanga",
    country: "Ghana",
    subcountry: "Upper East",
    geonameid: 2302821,
  },
  {
    name: "Bibiani",
    country: "Ghana",
    subcountry: "Western North",
    geonameid: 2303060,
  },
  {
    name: "Berekum",
    country: "Ghana",
    subcountry: "Bono",
    geonameid: 2303125,
  },
  {
    name: "Begoro",
    country: "Ghana",
    subcountry: "Eastern",
    geonameid: 2303236,
  },
  {
    name: "Bechem",
    country: "Ghana",
    subcountry: "Ahafo",
    geonameid: 2303258,
  },
  {
    name: "Bawku",
    country: "Ghana",
    subcountry: "Upper East",
    geonameid: 2303287,
  },
  {
    name: "Axim",
    country: "Ghana",
    subcountry: "Western",
    geonameid: 2303611,
  },
  {
    name: "Asamankese",
    country: "Ghana",
    subcountry: "Eastern",
    geonameid: 2304220,
  },
  {
    name: "Apam",
    country: "Ghana",
    subcountry: "Central",
    geonameid: 2304389,
  },
  {
    name: "Anloga",
    country: "Ghana",
    subcountry: "Volta",
    geonameid: 2304548,
  },
  {
    name: "Akwatia",
    country: "Ghana",
    subcountry: "Eastern",
    geonameid: 2304931,
  },
  {
    name: "Agogo",
    country: "Ghana",
    subcountry: "Ashanti",
    geonameid: 2305537,
  },
  {
    name: "Aflao",
    country: "Ghana",
    subcountry: "Volta",
    geonameid: 2305677,
  },
  {
    name: "Atsiaman",
    country: "Ghana",
    subcountry: "Greater Accra",
    geonameid: 2306079,
  },
  {
    name: "Accra",
    country: "Ghana",
    subcountry: "Greater Accra",
    geonameid: 2306104,
  },
  {
    name: "Aburi",
    country: "Ghana",
    subcountry: "Eastern",
    geonameid: 2306119,
  },
  {
    name: "Gibraltar",
    country: "Gibraltar",
    subcountry: "N/A",
    geonameid: 2411585,
  },
  {
    name: "Nuuk",
    country: "Greenland",
    subcountry: "Sermersooq",
    geonameid: 3421319,
  },
  {
    name: "Sukuta",
    country: "Gambia",
    subcountry: "Western",
    geonameid: 2411880,
  },
  {
    name: "Serekunda",
    country: "Gambia",
    subcountry: "Banjul",
    geonameid: 2411989,
  },
  {
    name: "Lamin",
    country: "Gambia",
    subcountry: "North Bank",
    geonameid: 2412749,
  },
  {
    name: "Farafenni",
    country: "Gambia",
    subcountry: "North Bank",
    geonameid: 2413515,
  },
  {
    name: "Brikama",
    country: "Gambia",
    subcountry: "Western",
    geonameid: 2413753,
  },
  {
    name: "Banjul",
    country: "Gambia",
    subcountry: "Banjul",
    geonameid: 2413876,
  },
  {
    name: "Bakau",
    country: "Gambia",
    subcountry: "Banjul",
    geonameid: 2413920,
  },
  {
    name: "Tougué",
    country: "Guinea",
    subcountry: "Labe",
    geonameid: 2414545,
  },
  {
    name: "Tomba kanssa",
    country: "Guinea",
    subcountry: "Kankan",
    geonameid: 2414635,
  },
  {
    name: "Télimélé",
    country: "Guinea",
    subcountry: "Kindia",
    geonameid: 2414926,
  },
  {
    name: "Siguiri",
    country: "Guinea",
    subcountry: "Kankan",
    geonameid: 2415703,
  },
  {
    name: "Pita",
    country: "Guinea",
    subcountry: "Mamou",
    geonameid: 2416443,
  },
  {
    name: "Nzérékoré",
    country: "Guinea",
    subcountry: "Nzerekore",
    geonameid: 2416969,
  },
  {
    name: "Mamou",
    country: "Guinea",
    subcountry: "Mamou",
    geonameid: 2417833,
  },
  {
    name: "Macenta",
    country: "Guinea",
    subcountry: "Nzerekore",
    geonameid: 2417988,
  },
  {
    name: "Labé",
    country: "Guinea",
    subcountry: "Labe",
    geonameid: 2418362,
  },
  {
    name: "Kissidougou",
    country: "Guinea",
    subcountry: "Faranah",
    geonameid: 2419472,
  },
  {
    name: "Kintinian",
    country: "Guinea",
    subcountry: "Kankan",
    geonameid: 2419498,
  },
  {
    name: "Kindia",
    country: "Guinea",
    subcountry: "Kindia",
    geonameid: 2419533,
  },
  {
    name: "Kankan",
    country: "Guinea",
    subcountry: "Kankan",
    geonameid: 2419992,
  },
  {
    name: "Gueckedou",
    country: "Guinea",
    subcountry: "Nzerekore",
    geonameid: 2420562,
  },
  {
    name: "Fria",
    country: "Guinea",
    subcountry: "Boke",
    geonameid: 2420884,
  },
  {
    name: "Coyah",
    country: "Guinea",
    subcountry: "Kindia",
    geonameid: 2422457,
  },
  {
    name: "Conakry",
    country: "Guinea",
    subcountry: "Conakry",
    geonameid: 2422465,
  },
  {
    name: "Camayenne",
    country: "Guinea",
    subcountry: "Conakry",
    geonameid: 2422488,
  },
  {
    name: "Boké",
    country: "Guinea",
    subcountry: "Boke",
    geonameid: 2422924,
  },
  {
    name: "Sainte-Rose",
    country: "Guadeloupe",
    subcountry: "Guadeloupe",
    geonameid: 3578447,
  },
  {
    name: "Sainte-Anne",
    country: "Guadeloupe",
    subcountry: "Guadeloupe",
    geonameid: 3578466,
  },
  {
    name: "Pointe-à-Pitre",
    country: "Guadeloupe",
    subcountry: "Guadeloupe",
    geonameid: 3578599,
  },
  {
    name: "Petit-Bourg",
    country: "Guadeloupe",
    subcountry: "Guadeloupe",
    geonameid: 3578682,
  },
  {
    name: "Les Abymes",
    country: "Guadeloupe",
    subcountry: "Guadeloupe",
    geonameid: 3578959,
  },
  {
    name: "Le Moule",
    country: "Guadeloupe",
    subcountry: "Guadeloupe",
    geonameid: 3578967,
  },
  {
    name: "Le Gosier",
    country: "Guadeloupe",
    subcountry: "Guadeloupe",
    geonameid: 3578978,
  },
  {
    name: "Capesterre-Belle-Eau",
    country: "Guadeloupe",
    subcountry: "Guadeloupe",
    geonameid: 3579585,
  },
  {
    name: "Basse-Terre",
    country: "Guadeloupe",
    subcountry: "Guadeloupe",
    geonameid: 3579732,
  },
  {
    name: "Baie-Mahault",
    country: "Guadeloupe",
    subcountry: "Guadeloupe",
    geonameid: 3579767,
  },
  {
    name: "Ebebiyin",
    country: "Equatorial Guinea",
    subcountry: "Kié-Ntem",
    geonameid: 2309332,
  },
  {
    name: "Malabo",
    country: "Equatorial Guinea",
    subcountry: "Bioko Norte",
    geonameid: 2309527,
  },
  {
    name: "Bata",
    country: "Equatorial Guinea",
    subcountry: "Litoral",
    geonameid: 2310046,
  },
  {
    name: "Voúla",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 251780,
  },
  {
    name: "Volos",
    country: "Greece",
    subcountry: "Thessaly",
    geonameid: 251833,
  },
  {
    name: "Výronas",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 251948,
  },
  {
    name: "Vári",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 252270,
  },
  {
    name: "Trípoli",
    country: "Greece",
    subcountry: "Peloponnese",
    geonameid: 252601,
  },
  {
    name: "Tríkala",
    country: "Greece",
    subcountry: "Thessaly",
    geonameid: 252664,
  },
  {
    name: "Thívai",
    country: "Greece",
    subcountry: "Central Greece",
    geonameid: 252910,
  },
  {
    name: "Sparta",
    country: "Greece",
    subcountry: "Peloponnese",
    geonameid: 253394,
  },
  {
    name: "Salamína",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 254144,
  },
  {
    name: "Rethymno",
    country: "Greece",
    subcountry: "Crete",
    geonameid: 254352,
  },
  {
    name: "Préveza",
    country: "Greece",
    subcountry: "Epirus",
    geonameid: 254698,
  },
  {
    name: "Pýrgos",
    country: "Greece",
    subcountry: "West Greece",
    geonameid: 255229,
  },
  {
    name: "Piraeus",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 255274,
  },
  {
    name: "Petroúpolis",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 255377,
  },
  {
    name: "Peristéri",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 255524,
  },
  {
    name: "Pérama",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 255588,
  },
  {
    name: "Pátra",
    country: "Greece",
    subcountry: "West Greece",
    geonameid: 255683,
  },
  {
    name: "Palaió Fáliro",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 256075,
  },
  {
    name: "Níkaia",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 256429,
  },
  {
    name: "Néa Smýrni",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 256575,
  },
  {
    name: "Néa Mákri",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 256598,
  },
  {
    name: "Ílion",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 256601,
  },
  {
    name: "Néa Ionía",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 256614,
  },
  {
    name: "Néa Filadélfeia",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 256621,
  },
  {
    name: "Néa Erythraía",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 256622,
  },
  {
    name: "Moskháton",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 256750,
  },
  {
    name: "Mytilene",
    country: "Greece",
    subcountry: "North Aegean",
    geonameid: 256866,
  },
  {
    name: "Melíssia",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 257302,
  },
  {
    name: "Mégara",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 257365,
  },
  {
    name: "Artémida",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 258038,
  },
  {
    name: "Livadeiá",
    country: "Greece",
    subcountry: "Central Greece",
    geonameid: 258463,
  },
  {
    name: "Lárisa",
    country: "Greece",
    subcountry: "Thessaly",
    geonameid: 258576,
  },
  {
    name: "Lamía",
    country: "Greece",
    subcountry: "Central Greece",
    geonameid: 258620,
  },
  {
    name: "Metamórfosi",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 259128,
  },
  {
    name: "Kos",
    country: "Greece",
    subcountry: "South Aegean",
    geonameid: 259245,
  },
  {
    name: "Koropí",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 259251,
  },
  {
    name: "Kórinthos",
    country: "Greece",
    subcountry: "Peloponnese",
    geonameid: 259289,
  },
  {
    name: "Kifisiá",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 259824,
  },
  {
    name: "Cholargós",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 259949,
  },
  {
    name: "Chios",
    country: "Greece",
    subcountry: "North Aegean",
    geonameid: 259973,
  },
  {
    name: "Chaniá",
    country: "Greece",
    subcountry: "Crete",
    geonameid: 260114,
  },
  {
    name: "Chalkída",
    country: "Greece",
    subcountry: "Central Greece",
    geonameid: 260133,
  },
  {
    name: "Khalándrion",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 260172,
  },
  {
    name: "Chaïdári",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 260183,
  },
  {
    name: "Keratsíni",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 260204,
  },
  {
    name: "Kardítsa",
    country: "Greece",
    subcountry: "Thessaly",
    geonameid: 260989,
  },
  {
    name: "Kamaterón",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 261249,
  },
  {
    name: "Kallithéa",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 261414,
  },
  {
    name: "Kalamata",
    country: "Greece",
    subcountry: "Peloponnese",
    geonameid: 261604,
  },
  {
    name: "Álimos",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 261614,
  },
  {
    name: "Kaisarianí",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 261678,
  },
  {
    name: "Irákleio",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 261743,
  },
  {
    name: "Irákleion",
    country: "Greece",
    subcountry: "Crete",
    geonameid: 261745,
  },
  {
    name: "Ioánnina",
    country: "Greece",
    subcountry: "Epirus",
    geonameid: 261779,
  },
  {
    name: "Glyfáda",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 262036,
  },
  {
    name: "Galátsi",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 262135,
  },
  {
    name: "Ellinikó",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 262719,
  },
  {
    name: "Elefsína",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 262752,
  },
  {
    name: "Dhafní",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 263312,
  },
  {
    name: "Agios Dimitrios",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 263986,
  },
  {
    name: "Agía Varvára",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 264111,
  },
  {
    name: "Agía Paraskeví",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 264194,
  },
  {
    name: "Athens",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 264371,
  },
  {
    name: "Asprópyrgos",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 264445,
  },
  {
    name: "Argyroúpoli",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 264516,
  },
  {
    name: "Árta",
    country: "Greece",
    subcountry: "Epirus",
    geonameid: 264559,
  },
  {
    name: "Árgos",
    country: "Greece",
    subcountry: "Peloponnese",
    geonameid: 264670,
  },
  {
    name: "Áno Liósia",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 264888,
  },
  {
    name: "Maroúsi",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 265243,
  },
  {
    name: "Amaliáda",
    country: "Greece",
    subcountry: "West Greece",
    geonameid: 265252,
  },
  {
    name: "Acharnés",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 265488,
  },
  {
    name: "Aígio",
    country: "Greece",
    subcountry: "West Greece",
    geonameid: 265500,
  },
  {
    name: "Aigáleo",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 265533,
  },
  {
    name: "Agrínio",
    country: "Greece",
    subcountry: "West Greece",
    geonameid: 265560,
  },
  {
    name: "Ródos",
    country: "Greece",
    subcountry: "South Aegean",
    geonameid: 400666,
  },
  {
    name: "Giannitsá",
    country: "Greece",
    subcountry: "Central Macedonia",
    geonameid: 733776,
  },
  {
    name: "Xánthi",
    country: "Greece",
    subcountry: "East Macedonia and Thrace",
    geonameid: 733840,
  },
  {
    name: "Véroia",
    country: "Greece",
    subcountry: "Central Macedonia",
    geonameid: 733905,
  },
  {
    name: "Thessaloníki",
    country: "Greece",
    subcountry: "Central Macedonia",
    geonameid: 734077,
  },
  {
    name: "Stavroúpoli",
    country: "Greece",
    subcountry: "Central Macedonia",
    geonameid: 734150,
  },
  {
    name: "Sykiés",
    country: "Greece",
    subcountry: "Central Macedonia",
    geonameid: 734301,
  },
  {
    name: "Sérres",
    country: "Greece",
    subcountry: "Central Macedonia",
    geonameid: 734330,
  },
  {
    name: "Ptolemaḯda",
    country: "Greece",
    subcountry: "West Macedonia",
    geonameid: 734426,
  },
  {
    name: "Políchni",
    country: "Greece",
    subcountry: "Central Macedonia",
    geonameid: 734538,
  },
  {
    name: "Pylaía",
    country: "Greece",
    subcountry: "Central Macedonia",
    geonameid: 734643,
  },
  {
    name: "Peraía",
    country: "Greece",
    subcountry: "Central Macedonia",
    geonameid: 734712,
  },
  {
    name: "Panórama",
    country: "Greece",
    subcountry: "Central Macedonia",
    geonameid: 734771,
  },
  {
    name: "Orestiáda",
    country: "Greece",
    subcountry: "East Macedonia and Thrace",
    geonameid: 734880,
  },
  {
    name: "Oraiókastro",
    country: "Greece",
    subcountry: "Central Macedonia",
    geonameid: 734883,
  },
  {
    name: "Náousa",
    country: "Greece",
    subcountry: "Central Macedonia",
    geonameid: 735030,
  },
  {
    name: "Meneméni",
    country: "Greece",
    subcountry: "Central Macedonia",
    geonameid: 735215,
  },
  {
    name: "Kozáni",
    country: "Greece",
    subcountry: "West Macedonia",
    geonameid: 735563,
  },
  {
    name: "Komotiní",
    country: "Greece",
    subcountry: "East Macedonia and Thrace",
    geonameid: 735640,
  },
  {
    name: "Kilkís",
    country: "Greece",
    subcountry: "Central Macedonia",
    geonameid: 735736,
  },
  {
    name: "Kavála",
    country: "Greece",
    subcountry: "East Macedonia and Thrace",
    geonameid: 735861,
  },
  {
    name: "Kateríni",
    country: "Greece",
    subcountry: "Central Macedonia",
    geonameid: 735914,
  },
  {
    name: "Kalamariá",
    country: "Greece",
    subcountry: "Central Macedonia",
    geonameid: 736083,
  },
  {
    name: "Flórina",
    country: "Greece",
    subcountry: "West Macedonia",
    geonameid: 736229,
  },
  {
    name: "Évosmos",
    country: "Greece",
    subcountry: "Central Macedonia",
    geonameid: 736291,
  },
  {
    name: "Elefthério - Kordelió",
    country: "Greece",
    subcountry: "Central Macedonia",
    geonameid: 736336,
  },
  {
    name: "Édessa",
    country: "Greece",
    subcountry: "Central Macedonia",
    geonameid: 736357,
  },
  {
    name: "Dráma",
    country: "Greece",
    subcountry: "East Macedonia and Thrace",
    geonameid: 736364,
  },
  {
    name: "Alexandroupoli",
    country: "Greece",
    subcountry: "East Macedonia and Thrace",
    geonameid: 736928,
  },
  {
    name: "Corfu",
    country: "Greece",
    subcountry: "Ionian Islands",
    geonameid: 2463679,
  },
  {
    name: "Vrilissia",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 6324534,
  },
  {
    name: "Gérakas",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 8201845,
  },
  {
    name: "Ilioúpoli",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 8310138,
  },
  {
    name: "Korydallós",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 8310183,
  },
  {
    name: "Zográfos",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 8358544,
  },
  {
    name: "Péfki",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 8358562,
  },
  {
    name: "Ágioi Anárgyroi",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 8358563,
  },
  {
    name: "Agios Ioannis Rentis",
    country: "Greece",
    subcountry: "Attica",
    geonameid: 8478257,
  },
  {
    name: "Néa Ionía",
    country: "Greece",
    subcountry: "Thessaly",
    geonameid: 9034728,
  },
  {
    name: "Neapoli",
    country: "Greece",
    subcountry: "Central Macedonia",
    geonameid: 11747175,
  },
  {
    name: "Grytviken",
    country: "South Georgia and the South Sandwich Islands",
    subcountry: "N/A",
    geonameid: 3426466,
  },
  {
    name: "Zaragoza",
    country: "Guatemala",
    subcountry: "Chimaltenango",
    geonameid: 3587543,
  },
  {
    name: "Zacapa",
    country: "Guatemala",
    subcountry: "Zacapa",
    geonameid: 3587587,
  },
  {
    name: "Yepocapa",
    country: "Guatemala",
    subcountry: "Chimaltenango",
    geonameid: 3587636,
  },
  {
    name: "Villa Nueva",
    country: "Guatemala",
    subcountry: "Guatemala",
    geonameid: 3587902,
  },
  {
    name: "Villa Canales",
    country: "Guatemala",
    subcountry: "Guatemala",
    geonameid: 3587923,
  },
  {
    name: "Totonicapán",
    country: "Guatemala",
    subcountry: "Totonicapán",
    geonameid: 3588258,
  },
  {
    name: "Tecpán Guatemala",
    country: "Guatemala",
    subcountry: "Chimaltenango",
    geonameid: 3588476,
  },
  {
    name: "Sumpango",
    country: "Guatemala",
    subcountry: "Sacatepéquez",
    geonameid: 3588653,
  },
  {
    name: "Soloma",
    country: "Guatemala",
    subcountry: "Huehuetenango",
    geonameid: 3588694,
  },
  {
    name: "Sololá",
    country: "Guatemala",
    subcountry: "Sololá",
    geonameid: 3588698,
  },
  {
    name: "Santiago Sacatepéquez",
    country: "Guatemala",
    subcountry: "Sacatepéquez",
    geonameid: 3589101,
  },
  {
    name: "Santiago Atitlán",
    country: "Guatemala",
    subcountry: "Sololá",
    geonameid: 3589105,
  },
  {
    name: "Santa María de Jesús",
    country: "Guatemala",
    subcountry: "Sacatepéquez",
    geonameid: 3589253,
  },
  {
    name: "Santa Lucía Cotzumalguapa",
    country: "Guatemala",
    subcountry: "Escuintla",
    geonameid: 3589289,
  },
  {
    name: "Santa Cruz del Quiché",
    country: "Guatemala",
    subcountry: "Quiché",
    geonameid: 3589404,
  },
  {
    name: "Santa Catarina Pinula",
    country: "Guatemala",
    subcountry: "Guatemala",
    geonameid: 3589452,
  },
  {
    name: "Santa Bárbara",
    country: "Guatemala",
    subcountry: "Suchitepeque",
    geonameid: 3589475,
  },
  {
    name: "San Sebastián",
    country: "Guatemala",
    subcountry: "Retalhuleu",
    geonameid: 3589548,
  },
  {
    name: "San Pedro Sacatepéquez",
    country: "Guatemala",
    subcountry: "San Marcos",
    geonameid: 3589626,
  },
  {
    name: "San Pedro Carchá",
    country: "Guatemala",
    subcountry: "Alta Verapaz",
    geonameid: 3589643,
  },
  {
    name: "San Pedro Ayampuc",
    country: "Guatemala",
    subcountry: "Guatemala",
    geonameid: 3589646,
  },
  {
    name: "San Pablo Jocopilas",
    country: "Guatemala",
    subcountry: "Suchitepeque",
    geonameid: 3589671,
  },
  {
    name: "San Marcos",
    country: "Guatemala",
    subcountry: "San Marcos",
    geonameid: 3589805,
  },
  {
    name: "San Luis Jilotepeque",
    country: "Guatemala",
    subcountry: "Jalapa",
    geonameid: 3589822,
  },
  {
    name: "San Lucas Sacatepéquez",
    country: "Guatemala",
    subcountry: "Sacatepéquez",
    geonameid: 3589852,
  },
  {
    name: "San Juan Sacatepéquez",
    country: "Guatemala",
    subcountry: "Guatemala",
    geonameid: 3589885,
  },
  {
    name: "San José Pinula",
    country: "Guatemala",
    subcountry: "Guatemala",
    geonameid: 3589977,
  },
  {
    name: "San Francisco Zapotitlán",
    country: "Guatemala",
    subcountry: "Suchitepeque",
    geonameid: 3590197,
  },
  {
    name: "San Francisco El Alto",
    country: "Guatemala",
    subcountry: "Totonicapán",
    geonameid: 3590219,
  },
  {
    name: "San Felipe",
    country: "Guatemala",
    subcountry: "Retalhuleu",
    geonameid: 3590288,
  },
  {
    name: "San Cristóbal Verapaz",
    country: "Guatemala",
    subcountry: "Alta Verapaz",
    geonameid: 3590316,
  },
  {
    name: "San Benito",
    country: "Guatemala",
    subcountry: "Petén",
    geonameid: 3590389,
  },
  {
    name: "Sanarate",
    country: "Guatemala",
    subcountry: "El Progreso",
    geonameid: 3590406,
  },
  {
    name: "San Andrés Xecul",
    country: "Guatemala",
    subcountry: "Totonicapán",
    geonameid: 3590520,
  },
  {
    name: "San Andrés Itzapa",
    country: "Guatemala",
    subcountry: "Chimaltenango",
    geonameid: 3590529,
  },
  {
    name: "Salcajá",
    country: "Guatemala",
    subcountry: "Quetzaltenango",
    geonameid: 3590605,
  },
  {
    name: "Salamá",
    country: "Guatemala",
    subcountry: "Baja Verapaz",
    geonameid: 3590616,
  },
  {
    name: "Retalhuleu",
    country: "Guatemala",
    subcountry: "Retalhuleu",
    geonameid: 3590858,
  },
  {
    name: "Rabinal",
    country: "Guatemala",
    subcountry: "Baja Verapaz",
    geonameid: 3590924,
  },
  {
    name: "Quetzaltenango",
    country: "Guatemala",
    subcountry: "Quetzaltenango",
    geonameid: 3590979,
  },
  {
    name: "Puerto San José",
    country: "Guatemala",
    subcountry: "Escuintla",
    geonameid: 3591060,
  },
  {
    name: "Puerto Barrios",
    country: "Guatemala",
    subcountry: "Izabal Department",
    geonameid: 3591062,
  },
  {
    name: "Tiquisate",
    country: "Guatemala",
    subcountry: "Escuintla",
    geonameid: 3591093,
  },
  {
    name: "Poptún",
    country: "Guatemala",
    subcountry: "Petén",
    geonameid: 3591181,
  },
  {
    name: "Petapa",
    country: "Guatemala",
    subcountry: "Guatemala",
    geonameid: 3591415,
  },
  {
    name: "Patzún",
    country: "Guatemala",
    subcountry: "Chimaltenango",
    geonameid: 3591512,
  },
  {
    name: "Patzicía",
    country: "Guatemala",
    subcountry: "Chimaltenango",
    geonameid: 3591523,
  },
  {
    name: "Patulul",
    country: "Guatemala",
    subcountry: "Suchitepeque",
    geonameid: 3591541,
  },
  {
    name: "Panzos",
    country: "Guatemala",
    subcountry: "Alta Verapaz",
    geonameid: 3591676,
  },
  {
    name: "Palín",
    country: "Guatemala",
    subcountry: "Escuintla",
    geonameid: 3591833,
  },
  {
    name: "Palencia",
    country: "Guatemala",
    subcountry: "Guatemala",
    geonameid: 3591851,
  },
  {
    name: "Ostuncalco",
    country: "Guatemala",
    subcountry: "Quetzaltenango",
    geonameid: 3591997,
  },
  {
    name: "Nuevo San Carlos",
    country: "Guatemala",
    subcountry: "Retalhuleu",
    geonameid: 3592105,
  },
  {
    name: "Nebaj",
    country: "Guatemala",
    subcountry: "Quiché",
    geonameid: 3592237,
  },
  {
    name: "Nahualá",
    country: "Guatemala",
    subcountry: "Sololá",
    geonameid: 3592286,
  },
  {
    name: "Morales",
    country: "Guatemala",
    subcountry: "Izabal Department",
    geonameid: 3592362,
  },
  {
    name: "Momostenango",
    country: "Guatemala",
    subcountry: "Totonicapán",
    geonameid: 3592483,
  },
  {
    name: "Mixco",
    country: "Guatemala",
    subcountry: "Guatemala",
    geonameid: 3592519,
  },
  {
    name: "Mazatenango",
    country: "Guatemala",
    subcountry: "Suchitepeque",
    geonameid: 3592609,
  },
  {
    name: "Masagua",
    country: "Guatemala",
    subcountry: "Escuintla",
    geonameid: 3592642,
  },
  {
    name: "Malacatán",
    country: "Guatemala",
    subcountry: "San Marcos",
    geonameid: 3592753,
  },
  {
    name: "Lívingston",
    country: "Guatemala",
    subcountry: "Izabal Department",
    geonameid: 3593376,
  },
  {
    name: "La Gomera",
    country: "Guatemala",
    subcountry: "Escuintla",
    geonameid: 3594575,
  },
  {
    name: "La Esperanza",
    country: "Guatemala",
    subcountry: "Quetzaltenango",
    geonameid: 3594703,
  },
  {
    name: "Jutiapa",
    country: "Guatemala",
    subcountry: "Jutiapa",
    geonameid: 3595069,
  },
  {
    name: "Jocotenango",
    country: "Guatemala",
    subcountry: "Sacatepéquez",
    geonameid: 3595171,
  },
  {
    name: "Jalpatagua",
    country: "Guatemala",
    subcountry: "Jutiapa",
    geonameid: 3595232,
  },
  {
    name: "Jalapa",
    country: "Guatemala",
    subcountry: "Jalapa",
    geonameid: 3595237,
  },
  {
    name: "Jacaltenango",
    country: "Guatemala",
    subcountry: "Huehuetenango",
    geonameid: 3595248,
  },
  {
    name: "Huehuetenango",
    country: "Guatemala",
    subcountry: "Huehuetenango",
    geonameid: 3595416,
  },
  {
    name: "Guazacapán",
    country: "Guatemala",
    subcountry: "Santa Rosa Department",
    geonameid: 3595503,
  },
  {
    name: "Gualán",
    country: "Guatemala",
    subcountry: "Zacapa",
    geonameid: 3595560,
  },
  {
    name: "Fraijanes",
    country: "Guatemala",
    subcountry: "Guatemala",
    geonameid: 3595714,
  },
  {
    name: "Flores",
    country: "Guatemala",
    subcountry: "Petén",
    geonameid: 3595725,
  },
  {
    name: "Esquipulas",
    country: "Guatemala",
    subcountry: "Chiquimula",
    geonameid: 3595783,
  },
  {
    name: "Escuintla",
    country: "Guatemala",
    subcountry: "Escuintla",
    geonameid: 3595803,
  },
  {
    name: "El Tejar",
    country: "Guatemala",
    subcountry: "Chimaltenango",
    geonameid: 3596041,
  },
  {
    name: "Guastatoya",
    country: "Guatemala",
    subcountry: "El Progreso",
    geonameid: 3596421,
  },
  {
    name: "El Palmar",
    country: "Guatemala",
    subcountry: "Quetzaltenango",
    geonameid: 3596644,
  },
  {
    name: "El Estor",
    country: "Guatemala",
    subcountry: "Izabal Department",
    geonameid: 3597078,
  },
  {
    name: "El Asintal",
    country: "Guatemala",
    subcountry: "Retalhuleu",
    geonameid: 3597587,
  },
  {
    name: "Cuilapa",
    country: "Guatemala",
    subcountry: "Santa Rosa Department",
    geonameid: 3597804,
  },
  {
    name: "Comitancillo",
    country: "Guatemala",
    subcountry: "San Marcos",
    geonameid: 3598025,
  },
  {
    name: "Comalapa",
    country: "Guatemala",
    subcountry: "Chimaltenango",
    geonameid: 3598034,
  },
  {
    name: "Colomba",
    country: "Guatemala",
    subcountry: "Quetzaltenango",
    geonameid: 3598073,
  },
  {
    name: "Cobán",
    country: "Guatemala",
    subcountry: "Alta Verapaz",
    geonameid: 3598119,
  },
  {
    name: "Coatepeque",
    country: "Guatemala",
    subcountry: "Quetzaltenango",
    geonameid: 3598122,
  },
  {
    name: "Ciudad Vieja",
    country: "Guatemala",
    subcountry: "Sacatepéquez",
    geonameid: 3598128,
  },
  {
    name: "Guatemala City",
    country: "Guatemala",
    subcountry: "Guatemala",
    geonameid: 3598132,
  },
  {
    name: "Chisec",
    country: "Guatemala",
    subcountry: "Alta Verapaz",
    geonameid: 3598415,
  },
  {
    name: "Chiquimula",
    country: "Guatemala",
    subcountry: "Chiquimula",
    geonameid: 3598465,
  },
  {
    name: "Chinautla",
    country: "Guatemala",
    subcountry: "Guatemala",
    geonameid: 3598529,
  },
  {
    name: "Chimaltenango",
    country: "Guatemala",
    subcountry: "Chimaltenango",
    geonameid: 3598572,
  },
  {
    name: "Chichicastenango",
    country: "Guatemala",
    subcountry: "Quiché",
    geonameid: 3598655,
  },
  {
    name: "Chicacao",
    country: "Guatemala",
    subcountry: "Suchitepeque",
    geonameid: 3598678,
  },
  {
    name: "Cantel",
    country: "Guatemala",
    subcountry: "Quetzaltenango",
    geonameid: 3599069,
  },
  {
    name: "Cabricán",
    country: "Guatemala",
    subcountry: "Quetzaltenango",
    geonameid: 3599287,
  },
  {
    name: "Barberena",
    country: "Guatemala",
    subcountry: "Santa Rosa Department",
    geonameid: 3599582,
  },
  {
    name: "Asunción Mita",
    country: "Guatemala",
    subcountry: "Jutiapa",
    geonameid: 3599639,
  },
  {
    name: "Antigua Guatemala",
    country: "Guatemala",
    subcountry: "Sacatepéquez",
    geonameid: 3599699,
  },
  {
    name: "Amatitlán",
    country: "Guatemala",
    subcountry: "Guatemala",
    geonameid: 3599735,
  },
  {
    name: "Alotenango",
    country: "Guatemala",
    subcountry: "Sacatepéquez",
    geonameid: 3599788,
  },
  {
    name: "Tamuning-Tumon-Harmon Village",
    country: "Guam",
    subcountry: "Tamuning",
    geonameid: 4038659,
  },
  {
    name: "Yigo Village",
    country: "Guam",
    subcountry: "Yigo",
    geonameid: 4038794,
  },
  {
    name: "Guam Government House",
    country: "Guam",
    subcountry: "Hagatna",
    geonameid: 4043547,
  },
  {
    name: "Dededo Village",
    country: "Guam",
    subcountry: "Dededo",
    geonameid: 4043909,
  },
  {
    name: "Hagåtña",
    country: "Guam",
    subcountry: "Hagatna",
    geonameid: 4044012,
  },
  {
    name: "Mangilao Village",
    country: "Guam",
    subcountry: "Mangilao",
    geonameid: 7268049,
  },
  {
    name: "Tamuning",
    country: "Guam",
    subcountry: "Tamuning",
    geonameid: 7874631,
  },
  {
    name: "Bissau",
    country: "Guinea-Bissau",
    subcountry: "Bissau",
    geonameid: 2374775,
  },
  {
    name: "Bafatá",
    country: "Guinea-Bissau",
    subcountry: "Bafatá",
    geonameid: 2375254,
  },
  {
    name: "New Amsterdam",
    country: "Guyana",
    subcountry: "East Berbice-Corentyne",
    geonameid: 3376762,
  },
  {
    name: "Linden",
    country: "Guyana",
    subcountry: "Upper Demerara-Berbice",
    geonameid: 3377408,
  },
  {
    name: "Georgetown",
    country: "Guyana",
    subcountry: "Demerara-Mahaica",
    geonameid: 3378644,
  },
  {
    name: "Tsuen Wan",
    country: "Hong Kong",
    subcountry: "Tsuen Wan",
    geonameid: 1818209,
  },
  {
    name: "Yuen Long Kau Hui",
    country: "Hong Kong",
    subcountry: "Yuen Long",
    geonameid: 1818223,
  },
  {
    name: "Tuen Mun",
    country: "Hong Kong",
    subcountry: "Tuen Mun",
    geonameid: 1818446,
  },
  {
    name: "Tsing Yi Town",
    country: "Hong Kong",
    subcountry: "Kwai Tsing",
    geonameid: 1818483,
  },
  {
    name: "Tseung Kwan O",
    country: "Hong Kong",
    subcountry: "Sai Kung",
    geonameid: 1818506,
  },
  {
    name: "Tin Shui Wai",
    country: "Hong Kong",
    subcountry: "Yuen Long",
    geonameid: 1818558,
  },
  {
    name: "Tai Po",
    country: "Hong Kong",
    subcountry: "Tai Po",
    geonameid: 1818673,
  },
  {
    name: "Sha Tin",
    country: "Hong Kong",
    subcountry: "Sha Tin",
    geonameid: 1818920,
  },
  {
    name: "Sai Kung",
    country: "Hong Kong",
    subcountry: "Sai Kung",
    geonameid: 1819050,
  },
  {
    name: "Pok Fu Lam",
    country: "Hong Kong",
    subcountry: "Southern",
    geonameid: 1819091,
  },
  {
    name: "Ping Shan",
    country: "Hong Kong",
    subcountry: "Yuen Long",
    geonameid: 1819101,
  },
  {
    name: "Ma On Shan",
    country: "Hong Kong",
    subcountry: "Sha Tin",
    geonameid: 1819400,
  },
  {
    name: "Kwai Chung",
    country: "Hong Kong",
    subcountry: "Tsuen Wan",
    geonameid: 1819595,
  },
  {
    name: "Kowloon",
    country: "Hong Kong",
    subcountry: "Kowloon City",
    geonameid: 1819609,
  },
  {
    name: "Hong Kong",
    country: "Hong Kong",
    subcountry: "Central and Western",
    geonameid: 1819729,
  },
  {
    name: "Aberdeen",
    country: "Hong Kong",
    subcountry: "Southern",
    geonameid: 1819757,
  },
  {
    name: "Fanling",
    country: "Hong Kong",
    subcountry: "North",
    geonameid: 1819873,
  },
  {
    name: "Victoria",
    country: "Hong Kong",
    subcountry: "Central and Western",
    geonameid: 1931681,
  },
  {
    name: "Tung Chung",
    country: "Hong Kong",
    subcountry: "Islands",
    geonameid: 11101593,
  },
  {
    name: "Puerto Cortez",
    country: "Honduras",
    subcountry: "Cortés Department",
    geonameid: 3600026,
  },
  {
    name: "Yoro",
    country: "Honduras",
    subcountry: "Yoro Department",
    geonameid: 3600195,
  },
  {
    name: "Villanueva",
    country: "Honduras",
    subcountry: "Cortés Department",
    geonameid: 3600327,
  },
  {
    name: "Tocoa",
    country: "Honduras",
    subcountry: "Colón Department",
    geonameid: 3600704,
  },
  {
    name: "Tela",
    country: "Honduras",
    subcountry: "Atlántida Department",
    geonameid: 3600931,
  },
  {
    name: "Tegucigalpa",
    country: "Honduras",
    subcountry: "Francisco Morazán Department",
    geonameid: 3600949,
  },
  {
    name: "Siguatepeque",
    country: "Honduras",
    subcountry: "Comayagua Department",
    geonameid: 3601311,
  },
  {
    name: "Santa Rosa de Copán",
    country: "Honduras",
    subcountry: "Copán Department",
    geonameid: 3601494,
  },
  {
    name: "Santa Bárbara",
    country: "Honduras",
    subcountry: "Santa Bárbara Department",
    geonameid: 3601691,
  },
  {
    name: "San Pedro Sula",
    country: "Honduras",
    subcountry: "Cortés Department",
    geonameid: 3601782,
  },
  {
    name: "San Lorenzo",
    country: "Honduras",
    subcountry: "Valle Department",
    geonameid: 3601977,
  },
  {
    name: "Potrerillos",
    country: "Honduras",
    subcountry: "Cortés Department",
    geonameid: 3603330,
  },
  {
    name: "Olanchito",
    country: "Honduras",
    subcountry: "Yoro Department",
    geonameid: 3604251,
  },
  {
    name: "La Paz",
    country: "Honduras",
    subcountry: "La Paz Department",
    geonameid: 3607254,
  },
  {
    name: "La Lima",
    country: "Honduras",
    subcountry: "Cortés Department",
    geonameid: 3607511,
  },
  {
    name: "La Ceiba",
    country: "Honduras",
    subcountry: "Atlántida Department",
    geonameid: 3608248,
  },
  {
    name: "Juticalpa",
    country: "Honduras",
    subcountry: "Olancho Department",
    geonameid: 3608503,
  },
  {
    name: "El Progreso",
    country: "Honduras",
    subcountry: "Yoro Department",
    geonameid: 3610613,
  },
  {
    name: "El Paraíso",
    country: "Honduras",
    subcountry: "El Paraíso Department",
    geonameid: 3610965,
  },
  {
    name: "Danlí",
    country: "Honduras",
    subcountry: "El Paraíso Department",
    geonameid: 3612907,
  },
  {
    name: "Comayagua",
    country: "Honduras",
    subcountry: "Comayagua Department",
    geonameid: 3613321,
  },
  {
    name: "Cofradía",
    country: "Honduras",
    subcountry: "Cortés Department",
    geonameid: 3613394,
  },
  {
    name: "Ciudad Choluteca",
    country: "Honduras",
    subcountry: "Choluteca Department",
    geonameid: 3613528,
  },
  {
    name: "Choloma",
    country: "Honduras",
    subcountry: "Cortés Department",
    geonameid: 3613533,
  },
  {
    name: "Zaprešić",
    country: "Croatia",
    subcountry: "County of Zagreb",
    geonameid: 3186781,
  },
  {
    name: "Zagreb",
    country: "Croatia",
    subcountry: "City of Zagreb",
    geonameid: 3186886,
  },
  {
    name: "Zadar",
    country: "Croatia",
    subcountry: "County of Zadar",
    geonameid: 3186952,
  },
  {
    name: "Vukovar",
    country: "Croatia",
    subcountry: "Vukovar-Sirmium",
    geonameid: 3187047,
  },
  {
    name: "Vinkovci",
    country: "Croatia",
    subcountry: "Vukovar-Sirmium",
    geonameid: 3187719,
  },
  {
    name: "Velika Gorica",
    country: "Croatia",
    subcountry: "County of Zagreb",
    geonameid: 3188244,
  },
  {
    name: "Varaždin",
    country: "Croatia",
    subcountry: "County of Varaždin",
    geonameid: 3188383,
  },
  {
    name: "Split",
    country: "Croatia",
    subcountry: "Split-Dalmatia",
    geonameid: 3190261,
  },
  {
    name: "Solin",
    country: "Croatia",
    subcountry: "Split-Dalmatia",
    geonameid: 3190359,
  },
  {
    name: "Slavonski Brod",
    country: "Croatia",
    subcountry: "Brod-Posavina",
    geonameid: 3190586,
  },
  {
    name: "Požega",
    country: "Croatia",
    subcountry: "County of Požega-Slavonia",
    geonameid: 3190589,
  },
  {
    name: "Sisak",
    country: "Croatia",
    subcountry: "County of Sisak-Moslavina",
    geonameid: 3190813,
  },
  {
    name: "Šibenik",
    country: "Croatia",
    subcountry: "Šibenik-Knin",
    geonameid: 3190941,
  },
  {
    name: "Sesvete",
    country: "Croatia",
    subcountry: "City of Zagreb",
    geonameid: 3190966,
  },
  {
    name: "Samobor",
    country: "Croatia",
    subcountry: "County of Zagreb",
    geonameid: 3191316,
  },
  {
    name: "Rijeka",
    country: "Croatia",
    subcountry: "County of Primorje-Gorski Kotar",
    geonameid: 3191648,
  },
  {
    name: "Pula",
    country: "Croatia",
    subcountry: "Istria",
    geonameid: 3192224,
  },
  {
    name: "Osijek",
    country: "Croatia",
    subcountry: "County of Osijek-Baranja",
    geonameid: 3193935,
  },
  {
    name: "Koprivnica",
    country: "Croatia",
    subcountry: "County of Koprivnica-Križevci",
    geonameid: 3197728,
  },
  {
    name: "Dubrovnik",
    country: "Croatia",
    subcountry: "Dubrovnik-Neretva",
    geonameid: 3201047,
  },
  {
    name: "Đakovo",
    country: "Croatia",
    subcountry: "County of Osijek-Baranja",
    geonameid: 3202220,
  },
  {
    name: "Čakovec",
    country: "Croatia",
    subcountry: "County of Međimurje",
    geonameid: 3202888,
  },
  {
    name: "Bjelovar",
    country: "Croatia",
    subcountry: "Bjelovar-Bilogora",
    geonameid: 3203982,
  },
  {
    name: "Karlovac",
    country: "Croatia",
    subcountry: "Karlovac",
    geonameid: 3345300,
  },
  {
    name: "Centar",
    country: "Croatia",
    subcountry: "City of Zagreb",
    geonameid: 6618983,
  },
  {
    name: "Verrettes",
    country: "Haiti",
    subcountry: "Artibonite",
    geonameid: 3716044,
  },
  {
    name: "Thomazeau",
    country: "Haiti",
    subcountry: "Ouest",
    geonameid: 3716667,
  },
  {
    name: "Saint-Raphaël",
    country: "Haiti",
    subcountry: "Nord",
    geonameid: 3717546,
  },
  {
    name: "Saint-Marc",
    country: "Haiti",
    subcountry: "Artibonite",
    geonameid: 3717588,
  },
  {
    name: "Port-de-Paix",
    country: "Haiti",
    subcountry: "Nord-Ouest",
    geonameid: 3718420,
  },
  {
    name: "Port-au-Prince",
    country: "Haiti",
    subcountry: "Ouest",
    geonameid: 3718426,
  },
  {
    name: "Tigwav",
    country: "Haiti",
    subcountry: "Ouest",
    geonameid: 3718962,
  },
  {
    name: "Pétionville",
    country: "Haiti",
    subcountry: "Ouest",
    geonameid: 3719028,
  },
  {
    name: "Miragoâne",
    country: "Haiti",
    subcountry: "Nippes",
    geonameid: 3720824,
  },
  {
    name: "Lenbe",
    country: "Haiti",
    subcountry: "Nord",
    geonameid: 3722124,
  },
  {
    name: "Léogâne",
    country: "Haiti",
    subcountry: "Ouest",
    geonameid: 3722286,
  },
  {
    name: "Kenscoff",
    country: "Haiti",
    subcountry: "Ouest",
    geonameid: 3723440,
  },
  {
    name: "Jérémie",
    country: "Haiti",
    subcountry: "GrandʼAnse",
    geonameid: 3723593,
  },
  {
    name: "Jacmel",
    country: "Haiti",
    subcountry: "Sud-Est",
    geonameid: 3723779,
  },
  {
    name: "Hinche",
    country: "Haiti",
    subcountry: "Centre",
    geonameid: 3723841,
  },
  {
    name: "Gressier",
    country: "Haiti",
    subcountry: "Ouest",
    geonameid: 3724233,
  },
  {
    name: "Grangwav",
    country: "Haiti",
    subcountry: "Ouest",
    geonameid: 3724337,
  },
  {
    name: "Gonaïves",
    country: "Haiti",
    subcountry: "Artibonite",
    geonameid: 3724696,
  },
  {
    name: "Fond Parisien",
    country: "Haiti",
    subcountry: "Ouest",
    geonameid: 3725276,
  },
  {
    name: "Désarmes",
    country: "Haiti",
    subcountry: "Artibonite",
    geonameid: 3726674,
  },
  {
    name: "Delmas 73",
    country: "Haiti",
    subcountry: "Ouest",
    geonameid: 3726786,
  },
  {
    name: "Croix-des-Bouquets",
    country: "Haiti",
    subcountry: "Ouest",
    geonameid: 3727135,
  },
  {
    name: "Les Cayes",
    country: "Haiti",
    subcountry: "Sud",
    geonameid: 3728097,
  },
  {
    name: "Carrefour",
    country: "Haiti",
    subcountry: "Ouest",
    geonameid: 3728338,
  },
  {
    name: "Cap-Haïtien",
    country: "Haiti",
    subcountry: "Nord",
    geonameid: 3728474,
  },
  {
    name: "Ti Port-de-Paix",
    country: "Haiti",
    subcountry: "Nord-Ouest",
    geonameid: 3740016,
  },
  {
    name: "Törökszentmiklós",
    country: "Hungary",
    subcountry: "Jász-Nagykun-Szolnok",
    geonameid: 714581,
  },
  {
    name: "Tiszaújváros",
    country: "Hungary",
    subcountry: "Borsod-Abaúj-Zemplén",
    geonameid: 714697,
  },
  {
    name: "Szolnok",
    country: "Hungary",
    subcountry: "Jász-Nagykun-Szolnok",
    geonameid: 715126,
  },
  {
    name: "Szeged",
    country: "Hungary",
    subcountry: "Csongrád",
    geonameid: 715429,
  },
  {
    name: "Szarvas",
    country: "Hungary",
    subcountry: "Bekes County",
    geonameid: 715466,
  },
  {
    name: "Sátoraljaújhely",
    country: "Hungary",
    subcountry: "Borsod-Abaúj-Zemplén",
    geonameid: 715839,
  },
  {
    name: "Püspökladány",
    country: "Hungary",
    subcountry: "Hajdú-Bihar",
    geonameid: 716301,
  },
  {
    name: "Ózd",
    country: "Hungary",
    subcountry: "Borsod-Abaúj-Zemplén",
    geonameid: 716671,
  },
  {
    name: "Orosháza",
    country: "Hungary",
    subcountry: "Bekes County",
    geonameid: 716736,
  },
  {
    name: "Nyíregyháza",
    country: "Hungary",
    subcountry: "Szabolcs-Szatmár-Bereg",
    geonameid: 716935,
  },
  {
    name: "Miskolc",
    country: "Hungary",
    subcountry: "Borsod-Abaúj-Zemplén",
    geonameid: 717582,
  },
  {
    name: "Mezőtúr",
    country: "Hungary",
    subcountry: "Jász-Nagykun-Szolnok",
    geonameid: 717635,
  },
  {
    name: "Mezőkövesd",
    country: "Hungary",
    subcountry: "Borsod-Abaúj-Zemplén",
    geonameid: 717652,
  },
  {
    name: "Mátészalka",
    country: "Hungary",
    subcountry: "Szabolcs-Szatmár-Bereg",
    geonameid: 717771,
  },
  {
    name: "Makó",
    country: "Hungary",
    subcountry: "Csongrád",
    geonameid: 717902,
  },
  {
    name: "Kisvárda",
    country: "Hungary",
    subcountry: "Szabolcs-Szatmár-Bereg",
    geonameid: 718739,
  },
  {
    name: "Kazincbarcika",
    country: "Hungary",
    subcountry: "Borsod-Abaúj-Zemplén",
    geonameid: 719311,
  },
  {
    name: "Karcag",
    country: "Hungary",
    subcountry: "Jász-Nagykun-Szolnok",
    geonameid: 719404,
  },
  {
    name: "Hódmezővásárhely",
    country: "Hungary",
    subcountry: "Csongrád",
    geonameid: 719965,
  },
  {
    name: "Hajdúszoboszló",
    country: "Hungary",
    subcountry: "Hajdú-Bihar",
    geonameid: 720276,
  },
  {
    name: "Hajdúnánás",
    country: "Hungary",
    subcountry: "Hajdú-Bihar",
    geonameid: 720284,
  },
  {
    name: "Hajdúböszörmény",
    country: "Hungary",
    subcountry: "Hajdú-Bihar",
    geonameid: 720292,
  },
  {
    name: "Gyula",
    country: "Hungary",
    subcountry: "Bekes County",
    geonameid: 720334,
  },
  {
    name: "Gyomaendrőd",
    country: "Hungary",
    subcountry: "Bekes County",
    geonameid: 720364,
  },
  {
    name: "Eger",
    country: "Hungary",
    subcountry: "Heves",
    geonameid: 721239,
  },
  {
    name: "Debrecen",
    country: "Hungary",
    subcountry: "Hajdú-Bihar",
    geonameid: 721472,
  },
  {
    name: "Csongrád",
    country: "Hungary",
    subcountry: "Csongrád",
    geonameid: 721592,
  },
  {
    name: "Békéscsaba",
    country: "Hungary",
    subcountry: "Bekes County",
    geonameid: 722437,
  },
  {
    name: "Békés",
    country: "Hungary",
    subcountry: "Bekes County",
    geonameid: 722439,
  },
  {
    name: "Balmazújváros",
    country: "Hungary",
    subcountry: "Hajdú-Bihar",
    geonameid: 722636,
  },
  {
    name: "Abony",
    country: "Hungary",
    subcountry: "Pest",
    geonameid: 723030,
  },
  {
    name: "Zugló",
    country: "Hungary",
    subcountry: "Budapest",
    geonameid: 3042430,
  },
  {
    name: "Zalaegerszeg",
    country: "Hungary",
    subcountry: "Zala",
    geonameid: 3042638,
  },
  {
    name: "Veszprém",
    country: "Hungary",
    subcountry: "Veszprém",
    geonameid: 3042929,
  },
  {
    name: "Veresegyház",
    country: "Hungary",
    subcountry: "Pest",
    geonameid: 3042968,
  },
  {
    name: "Vecsés",
    country: "Hungary",
    subcountry: "Pest",
    geonameid: 3043019,
  },
  {
    name: "Várpalota",
    country: "Hungary",
    subcountry: "Veszprém",
    geonameid: 3043095,
  },
  {
    name: "Vác",
    country: "Hungary",
    subcountry: "Pest",
    geonameid: 3043293,
  },
  {
    name: "Tatabánya",
    country: "Hungary",
    subcountry: "Komárom-Esztergom",
    geonameid: 3044082,
  },
  {
    name: "Tata",
    country: "Hungary",
    subcountry: "Komárom-Esztergom",
    geonameid: 3044083,
  },
  {
    name: "Tapolca",
    country: "Hungary",
    subcountry: "Veszprém",
    geonameid: 3044141,
  },
  {
    name: "Szombathely",
    country: "Hungary",
    subcountry: "Vas",
    geonameid: 3044310,
  },
  {
    name: "Szigetszentmiklós",
    country: "Hungary",
    subcountry: "Pest",
    geonameid: 3044475,
  },
  {
    name: "Szentendre",
    country: "Hungary",
    subcountry: "Pest",
    geonameid: 3044681,
  },
  {
    name: "Szekszárd",
    country: "Hungary",
    subcountry: "Tolna",
    geonameid: 3044760,
  },
  {
    name: "Székesfehérvár",
    country: "Hungary",
    subcountry: "Fejér",
    geonameid: 3044774,
  },
  {
    name: "Százhalombatta",
    country: "Hungary",
    subcountry: "Pest",
    geonameid: 3044821,
  },
  {
    name: "Sopron",
    country: "Hungary",
    subcountry: "Győr-Moson-Sopron",
    geonameid: 3045190,
  },
  {
    name: "Siófok",
    country: "Hungary",
    subcountry: "Somogy",
    geonameid: 3045332,
  },
  {
    name: "Sárvár",
    country: "Hungary",
    subcountry: "Vas",
    geonameid: 3045487,
  },
  {
    name: "Salgótarján",
    country: "Hungary",
    subcountry: "Nógrád",
    geonameid: 3045643,
  },
  {
    name: "Pécs",
    country: "Hungary",
    subcountry: "Baranya",
    geonameid: 3046526,
  },
  {
    name: "Parádsasvár",
    country: "Hungary",
    subcountry: "Heves",
    geonameid: 3046619,
  },
  {
    name: "Pápa",
    country: "Hungary",
    subcountry: "Veszprém",
    geonameid: 3046686,
  },
  {
    name: "Paks",
    country: "Hungary",
    subcountry: "Tolna",
    geonameid: 3046768,
  },
  {
    name: "Oroszlány",
    country: "Hungary",
    subcountry: "Komárom-Esztergom",
    geonameid: 3046888,
  },
  {
    name: "Nagykőrös",
    country: "Hungary",
    subcountry: "Pest",
    geonameid: 3047651,
  },
  {
    name: "Nagykanizsa",
    country: "Hungary",
    subcountry: "Zala",
    geonameid: 3047679,
  },
  {
    name: "Mosonmagyaróvár",
    country: "Hungary",
    subcountry: "Győr-Moson-Sopron",
    geonameid: 3047896,
  },
  {
    name: "Monor",
    country: "Hungary",
    subcountry: "Pest",
    geonameid: 3047942,
  },
  {
    name: "Mohács",
    country: "Hungary",
    subcountry: "Baranya",
    geonameid: 3047967,
  },
  {
    name: "Komló",
    country: "Hungary",
    subcountry: "Baranya",
    geonameid: 3049512,
  },
  {
    name: "Komárom",
    country: "Hungary",
    subcountry: "Komárom-Esztergom",
    geonameid: 3049519,
  },
  {
    name: "Kőbánya",
    country: "Hungary",
    subcountry: "Budapest",
    geonameid: 3049646,
  },
  {
    name: "Kispest",
    country: "Hungary",
    subcountry: "Budapest",
    geonameid: 3049795,
  },
  {
    name: "Kiskunhalas",
    country: "Hungary",
    subcountry: "Bács-Kiskun",
    geonameid: 3049880,
  },
  {
    name: "Kiskunfélegyháza",
    country: "Hungary",
    subcountry: "Bács-Kiskun",
    geonameid: 3049885,
  },
  {
    name: "Kiskőrös",
    country: "Hungary",
    subcountry: "Bács-Kiskun",
    geonameid: 3049896,
  },
  {
    name: "Keszthely",
    country: "Hungary",
    subcountry: "Zala",
    geonameid: 3050212,
  },
  {
    name: "Kecskemét",
    country: "Hungary",
    subcountry: "Bács-Kiskun",
    geonameid: 3050434,
  },
  {
    name: "Kaposvár",
    country: "Hungary",
    subcountry: "Somogy",
    geonameid: 3050616,
  },
  {
    name: "Kalocsa",
    country: "Hungary",
    subcountry: "Bács-Kiskun",
    geonameid: 3050719,
  },
  {
    name: "Jászberény",
    country: "Hungary",
    subcountry: "Jász-Nagykun-Szolnok",
    geonameid: 3050907,
  },
  {
    name: "Hatvan",
    country: "Hungary",
    subcountry: "Heves",
    geonameid: 3051621,
  },
  {
    name: "Győr",
    country: "Hungary",
    subcountry: "Győr-Moson-Sopron",
    geonameid: 3052009,
  },
  {
    name: "Gyöngyös",
    country: "Hungary",
    subcountry: "Heves",
    geonameid: 3052040,
  },
  {
    name: "Gyál",
    country: "Hungary",
    subcountry: "Pest",
    geonameid: 3052101,
  },
  {
    name: "Gödöllő",
    country: "Hungary",
    subcountry: "Pest",
    geonameid: 3052236,
  },
  {
    name: "Göd",
    country: "Hungary",
    subcountry: "Pest",
    geonameid: 3052241,
  },
  {
    name: "Fót",
    country: "Hungary",
    subcountry: "Pest",
    geonameid: 3052542,
  },
  {
    name: "Esztergom",
    country: "Hungary",
    subcountry: "Komárom-Esztergom",
    geonameid: 3053163,
  },
  {
    name: "Erzsébetváros",
    country: "Hungary",
    subcountry: "Budapest",
    geonameid: 3053176,
  },
  {
    name: "Érd",
    country: "Hungary",
    subcountry: "Pest",
    geonameid: 3053281,
  },
  {
    name: "Dunaújváros",
    country: "Hungary",
    subcountry: "Fejér",
    geonameid: 3053438,
  },
  {
    name: "Dunakeszi",
    country: "Hungary",
    subcountry: "Pest",
    geonameid: 3053476,
  },
  {
    name: "Dunaharaszti",
    country: "Hungary",
    subcountry: "Pest",
    geonameid: 3053485,
  },
  {
    name: "Dombóvár",
    country: "Hungary",
    subcountry: "Tolna",
    geonameid: 3053590,
  },
  {
    name: "Dabas",
    country: "Hungary",
    subcountry: "Pest",
    geonameid: 3053836,
  },
  {
    name: "Cegléd",
    country: "Hungary",
    subcountry: "Pest",
    geonameid: 3054543,
  },
  {
    name: "Budapest",
    country: "Hungary",
    subcountry: "Budapest",
    geonameid: 3054643,
  },
  {
    name: "Budaörs",
    country: "Hungary",
    subcountry: "Pest",
    geonameid: 3054646,
  },
  {
    name: "Balassagyarmat",
    country: "Hungary",
    subcountry: "Nógrád",
    geonameid: 3055601,
  },
  {
    name: "Baja",
    country: "Hungary",
    subcountry: "Bács-Kiskun",
    geonameid: 3055685,
  },
  {
    name: "Angyalföld",
    country: "Hungary",
    subcountry: "Budapest",
    geonameid: 3055970,
  },
  {
    name: "Ajka",
    country: "Hungary",
    subcountry: "Veszprém",
    geonameid: 3056357,
  },
  {
    name: "Budapest XII. kerület",
    country: "Hungary",
    subcountry: "Budapest",
    geonameid: 7284823,
  },
  {
    name: "Budapest XI. kerület",
    country: "Hungary",
    subcountry: "Budapest",
    geonameid: 7284824,
  },
  {
    name: "Budapest VIII. kerület",
    country: "Hungary",
    subcountry: "Budapest",
    geonameid: 7284826,
  },
  {
    name: "Budapest VI. kerület",
    country: "Hungary",
    subcountry: "Budapest",
    geonameid: 7284828,
  },
  {
    name: "Budapest XIII. kerület",
    country: "Hungary",
    subcountry: "Budapest",
    geonameid: 7284830,
  },
  {
    name: "Budapest IV. kerület",
    country: "Hungary",
    subcountry: "Budapest",
    geonameid: 7284831,
  },
  {
    name: "Budapest XV. kerület",
    country: "Hungary",
    subcountry: "Budapest",
    geonameid: 7284832,
  },
  {
    name: "Budapest XVI. kerület",
    country: "Hungary",
    subcountry: "Budapest",
    geonameid: 7284833,
  },
  {
    name: "Budapest XIX. kerület",
    country: "Hungary",
    subcountry: "Budapest",
    geonameid: 7284835,
  },
  {
    name: "Budapest XVIII. kerület",
    country: "Hungary",
    subcountry: "Budapest",
    geonameid: 7284836,
  },
  {
    name: "Budapest XXIII. kerület",
    country: "Hungary",
    subcountry: "Budapest",
    geonameid: 7284837,
  },
  {
    name: "Budapest XXII. kerület",
    country: "Hungary",
    subcountry: "Budapest",
    geonameid: 7284838,
  },
  {
    name: "Budapest XXI. kerület",
    country: "Hungary",
    subcountry: "Budapest",
    geonameid: 7284839,
  },
  {
    name: "Budapest XX. kerület",
    country: "Hungary",
    subcountry: "Budapest",
    geonameid: 7284840,
  },
  {
    name: "Budapest XVII. kerület",
    country: "Hungary",
    subcountry: "Budapest",
    geonameid: 7284841,
  },
  {
    name: "Budapest III. kerület",
    country: "Hungary",
    subcountry: "Budapest",
    geonameid: 7284842,
  },
  {
    name: "Budapest II. kerület",
    country: "Hungary",
    subcountry: "Budapest",
    geonameid: 7284843,
  },
  {
    name: "Budapest I. kerület",
    country: "Hungary",
    subcountry: "Budapest",
    geonameid: 7284844,
  },
  {
    name: "Józsefváros",
    country: "Hungary",
    subcountry: "Budapest",
    geonameid: 11054704,
  },
  {
    name: "Tongging",
    country: "Indonesia",
    subcountry: "North Sumatra",
    geonameid: 1213442,
  },
  {
    name: "Teluk Nibung",
    country: "Indonesia",
    subcountry: "North Sumatra",
    geonameid: 1213493,
  },
  {
    name: "Teluk Dalam",
    country: "Indonesia",
    subcountry: "North Sumatra",
    geonameid: 1213495,
  },
  {
    name: "Tebingtinggi",
    country: "Indonesia",
    subcountry: "North Sumatra",
    geonameid: 1213500,
  },
  {
    name: "Tanjungtiram",
    country: "Indonesia",
    subcountry: "North Sumatra",
    geonameid: 1213530,
  },
  {
    name: "Tanjungbalai",
    country: "Indonesia",
    subcountry: "North Sumatra",
    geonameid: 1213547,
  },
  {
    name: "Sunggal",
    country: "Indonesia",
    subcountry: "North Sumatra",
    geonameid: 1213614,
  },
  {
    name: "Stabat",
    country: "Indonesia",
    subcountry: "North Sumatra",
    geonameid: 1213655,
  },
  {
    name: "Singkil",
    country: "Indonesia",
    subcountry: "Aceh",
    geonameid: 1213713,
  },
  {
    name: "Sigli",
    country: "Indonesia",
    subcountry: "Aceh",
    geonameid: 1213821,
  },
  {
    name: "Sibolga",
    country: "Indonesia",
    subcountry: "North Sumatra",
    geonameid: 1213855,
  },
  {
    name: "Sabang",
    country: "Indonesia",
    subcountry: "Aceh",
    geonameid: 1214026,
  },
  {
    name: "Reuleuet",
    country: "Indonesia",
    subcountry: "Aceh",
    geonameid: 1214055,
  },
  {
    name: "Rantauprapat",
    country: "Indonesia",
    subcountry: "North Sumatra",
    geonameid: 1214073,
  },
  {
    name: "Percut",
    country: "Indonesia",
    subcountry: "North Sumatra",
    geonameid: 1214189,
  },
  {
    name: "Perbaungan",
    country: "Indonesia",
    subcountry: "North Sumatra",
    geonameid: 1214191,
  },
  {
    name: "Pematangsiantar",
    country: "Indonesia",
    subcountry: "North Sumatra",
    geonameid: 1214204,
  },
  {
    name: "Pangkalan Brandan",
    country: "Indonesia",
    subcountry: "North Sumatra",
    geonameid: 1214302,
  },
  {
    name: "Padangsidempuan",
    country: "Indonesia",
    subcountry: "North Sumatra",
    geonameid: 1214369,
  },
  {
    name: "Meulaboh",
    country: "Indonesia",
    subcountry: "Aceh",
    geonameid: 1214488,
  },
  {
    name: "Medan",
    country: "Indonesia",
    subcountry: "North Sumatra",
    geonameid: 1214520,
  },
  {
    name: "Lhokseumawe",
    country: "Indonesia",
    subcountry: "Aceh",
    geonameid: 1214658,
  },
  {
    name: "Langsa",
    country: "Indonesia",
    subcountry: "Aceh",
    geonameid: 1214724,
  },
  {
    name: "Labuhan Deli",
    country: "Indonesia",
    subcountry: "North Sumatra",
    geonameid: 1214800,
  },
  {
    name: "Kisaran",
    country: "Indonesia",
    subcountry: "North Sumatra",
    geonameid: 1214882,
  },
  {
    name: "Kabanjahe",
    country: "Indonesia",
    subcountry: "North Sumatra",
    geonameid: 1214965,
  },
  {
    name: "Gunungsitoli",
    country: "Indonesia",
    subcountry: "North Sumatra",
    geonameid: 1215102,
  },
  {
    name: "Deli Tua",
    country: "Indonesia",
    subcountry: "North Sumatra",
    geonameid: 1215199,
  },
  {
    name: "Blangpidie",
    country: "Indonesia",
    subcountry: "Aceh",
    geonameid: 1215326,
  },
  {
    name: "Bireun",
    country: "Indonesia",
    subcountry: "Aceh",
    geonameid: 1215350,
  },
  {
    name: "Binjai",
    country: "Indonesia",
    subcountry: "North Sumatra",
    geonameid: 1215355,
  },
  {
    name: "Berastagi",
    country: "Indonesia",
    subcountry: "North Sumatra",
    geonameid: 1215395,
  },
  {
    name: "Belawan",
    country: "Indonesia",
    subcountry: "North Sumatra",
    geonameid: 1215412,
  },
  {
    name: "Bandar",
    country: "Indonesia",
    subcountry: "North Sumatra",
    geonameid: 1215498,
  },
  {
    name: "Banda Aceh",
    country: "Indonesia",
    subcountry: "Aceh",
    geonameid: 1215502,
  },
  {
    name: "Yogyakarta",
    country: "Indonesia",
    subcountry: "Yogyakarta",
    geonameid: 1621177,
  },
  {
    name: "Wonosobo",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1621395,
  },
  {
    name: "Wonosari",
    country: "Indonesia",
    subcountry: "Yogyakarta",
    geonameid: 1621399,
  },
  {
    name: "Wonopringgo",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1621416,
  },
  {
    name: "Wongsorejo",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1621439,
  },
  {
    name: "Wiradesa",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1621520,
  },
  {
    name: "Weru",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1621613,
  },
  {
    name: "Weleri",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1621655,
  },
  {
    name: "Welahan",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1621659,
  },
  {
    name: "Wedi",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1621678,
  },
  {
    name: "Watampone",
    country: "Indonesia",
    subcountry: "South Sulawesi",
    geonameid: 1621884,
  },
  {
    name: "Wangon",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1622090,
  },
  {
    name: "Wanaraja",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1622138,
  },
  {
    name: "Waisai",
    country: "Indonesia",
    subcountry: "Southwest Papua",
    geonameid: 1622293,
  },
  {
    name: "Waingapu",
    country: "Indonesia",
    subcountry: "East Nusa Tenggara",
    geonameid: 1622318,
  },
  {
    name: "Ungaran",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1622636,
  },
  {
    name: "Makassar",
    country: "Indonesia",
    subcountry: "South Sulawesi",
    geonameid: 1622786,
  },
  {
    name: "Ubud",
    country: "Indonesia",
    subcountry: "Bali",
    geonameid: 1622846,
  },
  {
    name: "Tulungagung",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1623080,
  },
  {
    name: "Tulangan Utara",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1623096,
  },
  {
    name: "Tuban",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1623180,
  },
  {
    name: "Tual",
    country: "Indonesia",
    subcountry: "Maluku",
    geonameid: 1623197,
  },
  {
    name: "Trucuk",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1623223,
  },
  {
    name: "Trenggalek",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1623251,
  },
  {
    name: "Tondano",
    country: "Indonesia",
    subcountry: "North Sulawesi",
    geonameid: 1623424,
  },
  {
    name: "Tomohon",
    country: "Indonesia",
    subcountry: "North Sulawesi",
    geonameid: 1623446,
  },
  {
    name: "Tobelo",
    country: "Indonesia",
    subcountry: "North Maluku",
    geonameid: 1623651,
  },
  {
    name: "Ternate",
    country: "Indonesia",
    subcountry: "North Maluku",
    geonameid: 1624041,
  },
  {
    name: "Terbanggi Besar",
    country: "Indonesia",
    subcountry: "Lampung",
    geonameid: 1624058,
  },
  {
    name: "Teminabuan",
    country: "Indonesia",
    subcountry: "Southwest Papua",
    geonameid: 1624196,
  },
  {
    name: "Tegal",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1624494,
  },
  {
    name: "Tayu",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1624545,
  },
  {
    name: "Tasikmalaya",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1624647,
  },
  {
    name: "Tarub",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1624668,
  },
  {
    name: "Tarakan",
    country: "Indonesia",
    subcountry: "North Kalimantan",
    geonameid: 1624725,
  },
  {
    name: "Tanjung Selor",
    country: "Indonesia",
    subcountry: "North Kalimantan",
    geonameid: 1624827,
  },
  {
    name: "Tanjung Pinang",
    country: "Indonesia",
    subcountry: "Riau Islands",
    geonameid: 1624863,
  },
  {
    name: "Tanjung Pandan",
    country: "Indonesia",
    subcountry: "Bangka–Belitung Islands",
    geonameid: 1624877,
  },
  {
    name: "Bandar Lampung",
    country: "Indonesia",
    subcountry: "Lampung",
    geonameid: 1624917,
  },
  {
    name: "Tanjung Balai",
    country: "Indonesia",
    subcountry: "Riau Islands",
    geonameid: 1624974,
  },
  {
    name: "Tanjungagung",
    country: "Indonesia",
    subcountry: "South Sumatra",
    geonameid: 1624987,
  },
  {
    name: "Tanjung",
    country: "Indonesia",
    subcountry: "South Kalimantan",
    geonameid: 1625014,
  },
  {
    name: "Tanggulangin",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1625067,
  },
  {
    name: "Tangerang",
    country: "Indonesia",
    subcountry: "Banten",
    geonameid: 1625084,
  },
  {
    name: "Taliwang",
    country: "Indonesia",
    subcountry: "West Nusa Tenggara",
    geonameid: 1625420,
  },
  {
    name: "Tabanan",
    country: "Indonesia",
    subcountry: "Bali",
    geonameid: 1625708,
  },
  {
    name: "Surakarta",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1625812,
  },
  {
    name: "Surabaya",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1625822,
  },
  {
    name: "Sungai Raya",
    country: "Indonesia",
    subcountry: "West Kalimantan",
    geonameid: 1625908,
  },
  {
    name: "Sungai Penuh",
    country: "Indonesia",
    subcountry: "Jambi",
    geonameid: 1625929,
  },
  {
    name: "Sungailiat",
    country: "Indonesia",
    subcountry: "Bangka–Belitung Islands",
    geonameid: 1625958,
  },
  {
    name: "Sumenep",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1626099,
  },
  {
    name: "Sumedang Utara",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1626100,
  },
  {
    name: "Sumedang",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1626103,
  },
  {
    name: "Sumberpucung",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1626134,
  },
  {
    name: "Sumber",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1626183,
  },
  {
    name: "Sumbawa Besar",
    country: "Indonesia",
    subcountry: "West Nusa Tenggara",
    geonameid: 1626185,
  },
  {
    name: "Sokaraja",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1626312,
  },
  {
    name: "Sukabumi",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1626381,
  },
  {
    name: "Srono",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1626486,
  },
  {
    name: "Srandakan",
    country: "Indonesia",
    subcountry: "Yogyakarta",
    geonameid: 1626493,
  },
  {
    name: "Sragen",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1626498,
  },
  {
    name: "Sorong",
    country: "Indonesia",
    subcountry: "Southwest Papua",
    geonameid: 1626542,
  },
  {
    name: "Soreang",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1626560,
  },
  {
    name: "Solok",
    country: "Indonesia",
    subcountry: "West Sumatra",
    geonameid: 1626649,
  },
  {
    name: "Soko",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1626673,
  },
  {
    name: "Sofifi",
    country: "Indonesia",
    subcountry: "North Maluku",
    geonameid: 1626698,
  },
  {
    name: "Soe",
    country: "Indonesia",
    subcountry: "East Nusa Tenggara",
    geonameid: 1626703,
  },
  {
    name: "Sleman",
    country: "Indonesia",
    subcountry: "Yogyakarta",
    geonameid: 1626754,
  },
  {
    name: "Slawi",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1626758,
  },
  {
    name: "Situbondo",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1626801,
  },
  {
    name: "Sinjai",
    country: "Indonesia",
    subcountry: "South Sulawesi",
    geonameid: 1626895,
  },
  {
    name: "Singosari",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1626899,
  },
  {
    name: "Singojuruh",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1626903,
  },
  {
    name: "Singkawang",
    country: "Indonesia",
    subcountry: "West Kalimantan",
    geonameid: 1626916,
  },
  {
    name: "Sengkang",
    country: "Indonesia",
    subcountry: "South Sulawesi",
    geonameid: 1626921,
  },
  {
    name: "Singaraja",
    country: "Indonesia",
    subcountry: "Bali",
    geonameid: 1626932,
  },
  {
    name: "Singaparna",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1626936,
  },
  {
    name: "Simpang",
    country: "Indonesia",
    subcountry: "Jambi",
    geonameid: 1627035,
  },
  {
    name: "Sijunjung",
    country: "Indonesia",
    subcountry: "West Sumatra",
    geonameid: 1627185,
  },
  {
    name: "Sidoarjo",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1627253,
  },
  {
    name: "Sidareja",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1627267,
  },
  {
    name: "Sewon",
    country: "Indonesia",
    subcountry: "Yogyakarta",
    geonameid: 1627357,
  },
  {
    name: "Serpong",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1627459,
  },
  {
    name: "Serang",
    country: "Indonesia",
    subcountry: "Banten",
    geonameid: 1627549,
  },
  {
    name: "Sepatan",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1627610,
  },
  {
    name: "Semarang",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1627896,
  },
  {
    name: "Selong",
    country: "Indonesia",
    subcountry: "West Nusa Tenggara",
    geonameid: 1627957,
  },
  {
    name: "Selogiri",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1627969,
  },
  {
    name: "Sawangan",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1628453,
  },
  {
    name: "Sanana",
    country: "Indonesia",
    subcountry: "North Maluku",
    geonameid: 1628858,
  },
  {
    name: "Sampit",
    country: "Indonesia",
    subcountry: "Central Kalimantan",
    geonameid: 1628884,
  },
  {
    name: "Sampang",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1628899,
  },
  {
    name: "Samarinda",
    country: "Indonesia",
    subcountry: "East Kalimantan",
    geonameid: 1629001,
  },
  {
    name: "Salatiga",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1629131,
  },
  {
    name: "Ruteng",
    country: "Indonesia",
    subcountry: "East Nusa Tenggara",
    geonameid: 1629380,
  },
  {
    name: "Rengasdengklok",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1629710,
  },
  {
    name: "Rembangan",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1629749,
  },
  {
    name: "Rantepao",
    country: "Indonesia",
    subcountry: "South Sulawesi",
    geonameid: 1629974,
  },
  {
    name: "Ransiki",
    country: "Indonesia",
    subcountry: "West Papua",
    geonameid: 1630034,
  },
  {
    name: "Rangkasbitung",
    country: "Indonesia",
    subcountry: "Banten",
    geonameid: 1630058,
  },
  {
    name: "Randudongkal",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1630088,
  },
  {
    name: "Rajapolah",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1630200,
  },
  {
    name: "Raha",
    country: "Indonesia",
    subcountry: "Southeast Sulawesi",
    geonameid: 1630238,
  },
  {
    name: "Purwokerto",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1630328,
  },
  {
    name: "Purwodadi",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1630333,
  },
  {
    name: "Purwakarta",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1630341,
  },
  {
    name: "Purbalingga",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1630366,
  },
  {
    name: "Pundong",
    country: "Indonesia",
    subcountry: "Yogyakarta",
    geonameid: 1630416,
  },
  {
    name: "Probolinggo",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1630634,
  },
  {
    name: "Prigen",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1630649,
  },
  {
    name: "Praya",
    country: "Indonesia",
    subcountry: "West Nusa Tenggara",
    geonameid: 1630662,
  },
  {
    name: "Candi Prambanan",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1630681,
  },
  {
    name: "Poso",
    country: "Indonesia",
    subcountry: "Central Sulawesi",
    geonameid: 1630723,
  },
  {
    name: "Pontianak",
    country: "Indonesia",
    subcountry: "West Kalimantan",
    geonameid: 1630789,
  },
  {
    name: "Ponorogo",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1630798,
  },
  {
    name: "Polewali",
    country: "Indonesia",
    subcountry: "West Sulawesi",
    geonameid: 1630935,
  },
  {
    name: "Plumbon",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1630997,
  },
  {
    name: "Prabumulih",
    country: "Indonesia",
    subcountry: "South Sumatra",
    geonameid: 1631393,
  },
  {
    name: "Pemangkat",
    country: "Indonesia",
    subcountry: "West Kalimantan",
    geonameid: 1631637,
  },
  {
    name: "Pemalang",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1631648,
  },
  {
    name: "Pelabuhanratu",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1631733,
  },
  {
    name: "Pekanbaru",
    country: "Indonesia",
    subcountry: "Riau",
    geonameid: 1631761,
  },
  {
    name: "Pekalongan",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1631766,
  },
  {
    name: "Pecangaan",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1631851,
  },
  {
    name: "Payakumbuh",
    country: "Indonesia",
    subcountry: "West Sumatra",
    geonameid: 1631905,
  },
  {
    name: "Pati",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1631992,
  },
  {
    name: "Pasuruan",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1632033,
  },
  {
    name: "Paseh",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1632197,
  },
  {
    name: "Pasarkemis",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1632228,
  },
  {
    name: "Parung",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1632276,
  },
  {
    name: "Pariaman",
    country: "Indonesia",
    subcountry: "West Sumatra",
    geonameid: 1632334,
  },
  {
    name: "Parepare",
    country: "Indonesia",
    subcountry: "South Sulawesi",
    geonameid: 1632353,
  },
  {
    name: "Pare",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1632358,
  },
  {
    name: "Panji",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1632566,
  },
  {
    name: "Pangkalpinang",
    country: "Indonesia",
    subcountry: "Bangka–Belitung Islands",
    geonameid: 1632654,
  },
  {
    name: "Pangkalanbuun",
    country: "Indonesia",
    subcountry: "Central Kalimantan",
    geonameid: 1632694,
  },
  {
    name: "Pandeglang",
    country: "Indonesia",
    subcountry: "Banten",
    geonameid: 1632823,
  },
  {
    name: "Pandaan",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1632859,
  },
  {
    name: "Pandak",
    country: "Indonesia",
    subcountry: "Yogyakarta",
    geonameid: 1632861,
  },
  {
    name: "Panarukan",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1632903,
  },
  {
    name: "Pamulang",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1632937,
  },
  {
    name: "Pameungpeuk",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1632974,
  },
  {
    name: "Pamekasan",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1632978,
  },
  {
    name: "Pamanukan",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1632998,
  },
  {
    name: "Palu",
    country: "Indonesia",
    subcountry: "Central Sulawesi",
    geonameid: 1633034,
  },
  {
    name: "Palopo",
    country: "Indonesia",
    subcountry: "South Sulawesi",
    geonameid: 1633037,
  },
  {
    name: "Palimanan",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1633056,
  },
  {
    name: "Palembang",
    country: "Indonesia",
    subcountry: "South Sumatra",
    geonameid: 1633070,
  },
  {
    name: "Palangkaraya",
    country: "Indonesia",
    subcountry: "Central Kalimantan",
    geonameid: 1633118,
  },
  {
    name: "Pakisaji",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1633182,
  },
  {
    name: "Pagar Alam",
    country: "Indonesia",
    subcountry: "South Sumatra",
    geonameid: 1633308,
  },
  {
    name: "Padang",
    country: "Indonesia",
    subcountry: "West Sumatra",
    geonameid: 1633419,
  },
  {
    name: "Paciran",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1633442,
  },
  {
    name: "Ngunut",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1633986,
  },
  {
    name: "Ngoro",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1634010,
  },
  {
    name: "Ngawi",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1634098,
  },
  {
    name: "Nganjuk",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1634131,
  },
  {
    name: "Negara",
    country: "Indonesia",
    subcountry: "Bali",
    geonameid: 1634266,
  },
  {
    name: "Nabire",
    country: "Indonesia",
    subcountry: "Central Papua",
    geonameid: 1634614,
  },
  {
    name: "Muntok",
    country: "Indonesia",
    subcountry: "Bangka–Belitung Islands",
    geonameid: 1634678,
  },
  {
    name: "Muntilan",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1634680,
  },
  {
    name: "Muncar",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1634718,
  },
  {
    name: "Muara Teweh",
    country: "Indonesia",
    subcountry: "Central Kalimantan",
    geonameid: 1634788,
  },
  {
    name: "Muara Bungo",
    country: "Indonesia",
    subcountry: "Jambi",
    geonameid: 1634904,
  },
  {
    name: "Mranggen",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1634954,
  },
  {
    name: "Mojokerto",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1635111,
  },
  {
    name: "Mojoagung",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1635116,
  },
  {
    name: "Mlonggo",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1635164,
  },
  {
    name: "Metro",
    country: "Indonesia",
    subcountry: "Lampung",
    geonameid: 1635283,
  },
  {
    name: "Mertoyudan",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1635342,
  },
  {
    name: "Melati",
    country: "Indonesia",
    subcountry: "Yogyakarta",
    geonameid: 1635660,
  },
  {
    name: "Maumere",
    country: "Indonesia",
    subcountry: "East Nusa Tenggara",
    geonameid: 1635815,
  },
  {
    name: "Mataram",
    country: "Indonesia",
    subcountry: "West Nusa Tenggara",
    geonameid: 1635882,
  },
  {
    name: "Masamba",
    country: "Indonesia",
    subcountry: "South Sulawesi",
    geonameid: 1635984,
  },
  {
    name: "Martapura",
    country: "Indonesia",
    subcountry: "South Kalimantan",
    geonameid: 1636022,
  },
  {
    name: "Maros",
    country: "Indonesia",
    subcountry: "South Sulawesi",
    geonameid: 1636029,
  },
  {
    name: "Margasari",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1636121,
  },
  {
    name: "Margahayukencana",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1636125,
  },
  {
    name: "Manokwari",
    country: "Indonesia",
    subcountry: "West Papua",
    geonameid: 1636308,
  },
  {
    name: "Manismata",
    country: "Indonesia",
    subcountry: "West Kalimantan",
    geonameid: 1636322,
  },
  {
    name: "Manggar",
    country: "Indonesia",
    subcountry: "Bangka–Belitung Islands",
    geonameid: 1636426,
  },
  {
    name: "Mendaha",
    country: "Indonesia",
    subcountry: "Jambi",
    geonameid: 1636507,
  },
  {
    name: "Manado",
    country: "Indonesia",
    subcountry: "North Sulawesi",
    geonameid: 1636544,
  },
  {
    name: "Malinau",
    country: "Indonesia",
    subcountry: "North Kalimantan",
    geonameid: 1636657,
  },
  {
    name: "Malang",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1636722,
  },
  {
    name: "Majene",
    country: "Indonesia",
    subcountry: "West Sulawesi",
    geonameid: 1636806,
  },
  {
    name: "Majenang",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1636808,
  },
  {
    name: "Majalengka",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1636816,
  },
  {
    name: "Magelang",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1636884,
  },
  {
    name: "Madiun",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1636930,
  },
  {
    name: "Luwuk",
    country: "Indonesia",
    subcountry: "Central Sulawesi",
    geonameid: 1637001,
  },
  {
    name: "Lumajang",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1637090,
  },
  {
    name: "Lubuklinggau",
    country: "Indonesia",
    subcountry: "South Sumatra",
    geonameid: 1637158,
  },
  {
    name: "Loa Janan",
    country: "Indonesia",
    subcountry: "East Kalimantan",
    geonameid: 1637510,
  },
  {
    name: "Lembang",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1638063,
  },
  {
    name: "Lebaksiu",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1638217,
  },
  {
    name: "Lawang",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1638284,
  },
  {
    name: "Lasem",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1638352,
  },
  {
    name: "Lamongan",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1638562,
  },
  {
    name: "Lahat",
    country: "Indonesia",
    subcountry: "South Sumatra",
    geonameid: 1638775,
  },
  {
    name: "Labuan Bajo",
    country: "Indonesia",
    subcountry: "East Nusa Tenggara",
    geonameid: 1638868,
  },
  {
    name: "Labuan",
    country: "Indonesia",
    subcountry: "Banten",
    geonameid: 1638870,
  },
  {
    name: "Kutoarjo",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1638981,
  },
  {
    name: "Kuta",
    country: "Indonesia",
    subcountry: "Bali",
    geonameid: 1639002,
  },
  {
    name: "Kuningan",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1639094,
  },
  {
    name: "Kudus",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1639215,
  },
  {
    name: "Kuala Tungkal",
    country: "Indonesia",
    subcountry: "Jambi",
    geonameid: 1639286,
  },
  {
    name: "Kualakapuas",
    country: "Indonesia",
    subcountry: "Central Kalimantan",
    geonameid: 1639304,
  },
  {
    name: "Kroya",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1639337,
  },
  {
    name: "Krian",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1639356,
  },
  {
    name: "Kresek",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1639362,
  },
  {
    name: "Kraksaan",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1639431,
  },
  {
    name: "Kotabumi",
    country: "Indonesia",
    subcountry: "Lampung",
    geonameid: 1639524,
  },
  {
    name: "Klungkung",
    country: "Indonesia",
    subcountry: "Bali",
    geonameid: 1639850,
  },
  {
    name: "Klaten",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1639900,
  },
  {
    name: "Klangenan",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1639925,
  },
  {
    name: "Ketanggungan",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1640138,
  },
  {
    name: "Kertosono",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1640185,
  },
  {
    name: "Kepanjen",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1640296,
  },
  {
    name: "Kendari",
    country: "Indonesia",
    subcountry: "Southeast Sulawesi",
    geonameid: 1640344,
  },
  {
    name: "Kencong",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1640354,
  },
  {
    name: "Kefamenanu",
    country: "Indonesia",
    subcountry: "East Nusa Tenggara",
    geonameid: 1640576,
  },
  {
    name: "Kedungwuni",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1640581,
  },
  {
    name: "Kedungwaru",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1640585,
  },
  {
    name: "Kediri",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1640660,
  },
  {
    name: "Kebonarun",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1640755,
  },
  {
    name: "Kebomas",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1640765,
  },
  {
    name: "Kawalu",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1640902,
  },
  {
    name: "Katobu",
    country: "Indonesia",
    subcountry: "Southeast Sulawesi",
    geonameid: 1640972,
  },
  {
    name: "Karangsembung",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1641184,
  },
  {
    name: "Amlapura",
    country: "Indonesia",
    subcountry: "Bali",
    geonameid: 1641301,
  },
  {
    name: "Karanganom",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1641333,
  },
  {
    name: "Karangampel",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1641342,
  },
  {
    name: "Kamal",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1641792,
  },
  {
    name: "Kalianget",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1641977,
  },
  {
    name: "Juwana",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1642317,
  },
  {
    name: "Jombang",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1642414,
  },
  {
    name: "Jogonalan",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1642437,
  },
  {
    name: "Jepara",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1642548,
  },
  {
    name: "Jember",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1642588,
  },
  {
    name: "Jekulo",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1642628,
  },
  {
    name: "Jatiwangi",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1642684,
  },
  {
    name: "Jatiroto",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1642692,
  },
  {
    name: "Jatibarang",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1642726,
  },
  {
    name: "Jaten",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1642754,
  },
  {
    name: "Jambi City",
    country: "Indonesia",
    subcountry: "Jambi",
    geonameid: 1642858,
  },
  {
    name: "Jakarta",
    country: "Indonesia",
    subcountry: "Jakarta",
    geonameid: 1642911,
  },
  {
    name: "Indramayu",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1643078,
  },
  {
    name: "Grogol",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1643761,
  },
  {
    name: "Gresik",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1643776,
  },
  {
    name: "Gorontalo",
    country: "Indonesia",
    subcountry: "Gorontalo",
    geonameid: 1643837,
  },
  {
    name: "Gongdanglegi Kulon",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1643898,
  },
  {
    name: "Gombong",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1643920,
  },
  {
    name: "Godean",
    country: "Indonesia",
    subcountry: "Yogyakarta",
    geonameid: 1643981,
  },
  {
    name: "Genteng",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1644178,
  },
  {
    name: "Gedangan",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1644349,
  },
  {
    name: "Gebog",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1644360,
  },
  {
    name: "Gampengrejo",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1644522,
  },
  {
    name: "Gambiran Satu",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1644557,
  },
  {
    name: "Galesong",
    country: "Indonesia",
    subcountry: "South Sulawesi",
    geonameid: 1644605,
  },
  {
    name: "Fakfak",
    country: "Indonesia",
    subcountry: "Papua",
    geonameid: 1644833,
  },
  {
    name: "Ende",
    country: "Indonesia",
    subcountry: "East Nusa Tenggara",
    geonameid: 1644932,
  },
  {
    name: "Dumai",
    country: "Indonesia",
    subcountry: "Riau",
    geonameid: 1645133,
  },
  {
    name: "Dukuhturi",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1645154,
  },
  {
    name: "Driyorejo",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1645220,
  },
  {
    name: "Dompu",
    country: "Indonesia",
    subcountry: "West Nusa Tenggara",
    geonameid: 1645343,
  },
  {
    name: "Diwek",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1645428,
  },
  {
    name: "Depok",
    country: "Indonesia",
    subcountry: "Yogyakarta",
    geonameid: 1645518,
  },
  {
    name: "Depok",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1645524,
  },
  {
    name: "Denpasar",
    country: "Indonesia",
    subcountry: "Bali",
    geonameid: 1645528,
  },
  {
    name: "Demak",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1645559,
  },
  {
    name: "Delanggu",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1645565,
  },
  {
    name: "Dampit",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1645749,
  },
  {
    name: "Curup",
    country: "Indonesia",
    subcountry: "Bengkulu",
    geonameid: 1645875,
  },
  {
    name: "Curug",
    country: "Indonesia",
    subcountry: "Banten",
    geonameid: 1645895,
  },
  {
    name: "Comal",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1645976,
  },
  {
    name: "Colomadu",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1645978,
  },
  {
    name: "Citeureup",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1646034,
  },
  {
    name: "Cirebon",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1646170,
  },
  {
    name: "Ciputat",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1646194,
  },
  {
    name: "Cimahi",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1646448,
  },
  {
    name: "Cileunyi",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1646492,
  },
  {
    name: "Cileungsir",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1646494,
  },
  {
    name: "Cilacap",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1646559,
  },
  {
    name: "Cikarang",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1646678,
  },
  {
    name: "Cikampek",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1646698,
  },
  {
    name: "Cicurug",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1646893,
  },
  {
    name: "Cibinong",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1647003,
  },
  {
    name: "Cianjur",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1647142,
  },
  {
    name: "Ciamis",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1647149,
  },
  {
    name: "Cepu",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1647179,
  },
  {
    name: "Ceper",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1647187,
  },
  {
    name: "Caringin",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1647298,
  },
  {
    name: "Ciampea",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1647383,
  },
  {
    name: "Bulakamba",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1647834,
  },
  {
    name: "Bukittinggi",
    country: "Indonesia",
    subcountry: "West Sumatra",
    geonameid: 1647866,
  },
  {
    name: "Buduran",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1647936,
  },
  {
    name: "Buaran",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1647991,
  },
  {
    name: "Boyolangu",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1648082,
  },
  {
    name: "Boyolali",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1648084,
  },
  {
    name: "Bontang",
    country: "Indonesia",
    subcountry: "East Kalimantan",
    geonameid: 1648186,
  },
  {
    name: "Bondowoso",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1648266,
  },
  {
    name: "Bojonegoro",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1648451,
  },
  {
    name: "Bogor",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1648473,
  },
  {
    name: "Blora",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1648568,
  },
  {
    name: "Blitar",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1648580,
  },
  {
    name: "Bitung",
    country: "Indonesia",
    subcountry: "North Sulawesi",
    geonameid: 1648637,
  },
  {
    name: "Bintuni",
    country: "Indonesia",
    subcountry: "West Papua",
    geonameid: 1648691,
  },
  {
    name: "Bima",
    country: "Indonesia",
    subcountry: "West Nusa Tenggara",
    geonameid: 1648759,
  },
  {
    name: "Besuki",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1648918,
  },
  {
    name: "Bengkulu",
    country: "Indonesia",
    subcountry: "Bengkulu",
    geonameid: 1649150,
  },
  {
    name: "Bekasi",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1649378,
  },
  {
    name: "Baubau",
    country: "Indonesia",
    subcountry: "Southeast Sulawesi",
    geonameid: 1649541,
  },
  {
    name: "Baturaja",
    country: "Indonesia",
    subcountry: "South Sumatra",
    geonameid: 1649593,
  },
  {
    name: "Baturaden",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1649595,
  },
  {
    name: "Batu",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1649824,
  },
  {
    name: "Batang",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1649881,
  },
  {
    name: "Barabai",
    country: "Indonesia",
    subcountry: "South Kalimantan",
    geonameid: 1650064,
  },
  {
    name: "Banyuwangi",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1650077,
  },
  {
    name: "Banyumas",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1650095,
  },
  {
    name: "Bantul",
    country: "Indonesia",
    subcountry: "Yogyakarta",
    geonameid: 1650119,
  },
  {
    name: "Banjarmasin",
    country: "Indonesia",
    subcountry: "South Kalimantan",
    geonameid: 1650213,
  },
  {
    name: "Banjaran",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1650227,
  },
  {
    name: "Banjar",
    country: "Indonesia",
    subcountry: "Bali",
    geonameid: 1650232,
  },
  {
    name: "Banjar",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1650234,
  },
  {
    name: "Bangkalan",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1650298,
  },
  {
    name: "Bangil",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1650319,
  },
  {
    name: "Bandung",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1650357,
  },
  {
    name: "Bambanglipuro",
    country: "Indonesia",
    subcountry: "Yogyakarta",
    geonameid: 1650434,
  },
  {
    name: "Balung",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1650460,
  },
  {
    name: "Balikpapan",
    country: "Indonesia",
    subcountry: "East Kalimantan",
    geonameid: 1650527,
  },
  {
    name: "Balapulang",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1650572,
  },
  {
    name: "Balai Pungut",
    country: "Indonesia",
    subcountry: "Riau",
    geonameid: 1650600,
  },
  {
    name: "Baki",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1650670,
  },
  {
    name: "Baekrajan",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1650815,
  },
  {
    name: "Babat",
    country: "Indonesia",
    subcountry: "East Java",
    geonameid: 1650888,
  },
  {
    name: "Atambua",
    country: "Indonesia",
    subcountry: "East Nusa Tenggara",
    geonameid: 1651103,
  },
  {
    name: "Astanajapura",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1651112,
  },
  {
    name: "Arjawinangun",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1651226,
  },
  {
    name: "Amuntai",
    country: "Indonesia",
    subcountry: "South Kalimantan",
    geonameid: 1651461,
  },
  {
    name: "Ambon",
    country: "Indonesia",
    subcountry: "Maluku",
    geonameid: 1651531,
  },
  {
    name: "Ambarawa",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1651555,
  },
  {
    name: "Amahai",
    country: "Indonesia",
    subcountry: "Maluku",
    geonameid: 1651591,
  },
  {
    name: "Agats",
    country: "Indonesia",
    subcountry: "South Papua",
    geonameid: 1651852,
  },
  {
    name: "Adiwerna",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 1651887,
  },
  {
    name: "Padalarang",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1963770,
  },
  {
    name: "Ciranjang-hilir",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1964032,
  },
  {
    name: "Cikupa",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1985663,
  },
  {
    name: "Teluknaga",
    country: "Indonesia",
    subcountry: "West Java",
    geonameid: 1990589,
  },
  {
    name: "Gamping Lor",
    country: "Indonesia",
    subcountry: "Yogyakarta",
    geonameid: 2005057,
  },
  {
    name: "Kasihan",
    country: "Indonesia",
    subcountry: "Yogyakarta",
    geonameid: 2005237,
  },
  {
    name: "Ngemplak",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 2010971,
  },
  {
    name: "Kartasura",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 2010985,
  },
  {
    name: "Gatak",
    country: "Indonesia",
    subcountry: "Central Java",
    geonameid: 2011457,
  },
  {
    name: "Kupang",
    country: "Indonesia",
    subcountry: "East Nusa Tenggara",
    geonameid: 2057087,
  },
  {
    name: "Merauke",
    country: "Indonesia",
    subcountry: "South Papua",
    geonameid: 2082539,
  },
  {
    name: "Jayapura",
    country: "Indonesia",
    subcountry: "Papua",
    geonameid: 2082600,
  },
  {
    name: "Abepura",
    country: "Indonesia",
    subcountry: "Papua",
    geonameid: 2082727,
  },
  {
    name: "Batam",
    country: "Indonesia",
    subcountry: "Riau",
    geonameid: 6295587,
  },
  {
    name: "Seririt",
    country: "Indonesia",
    subcountry: "Bali",
    geonameid: 7084521,
  },
  {
    name: "Bedugul",
    country: "Indonesia",
    subcountry: "Bali",
    geonameid: 7087175,
  },
  {
    name: "Tambolaka",
    country: "Indonesia",
    subcountry: "East Nusa Tenggara",
    geonameid: 7336548,
  },
  {
    name: "Pekan Bahapal",
    country: "Indonesia",
    subcountry: "North Sumatra",
    geonameid: 8449493,
  },
  {
    name: "South Tangerang",
    country: "Indonesia",
    subcountry: "Banten",
    geonameid: 8581443,
  },
  {
    name: "Masohi",
    country: "Indonesia",
    subcountry: "Maluku",
    geonameid: 8667930,
  },
  {
    name: "Amlapura city",
    country: "Indonesia",
    subcountry: "Bali",
    geonameid: 11919949,
  },
  {
    name: "Wexford",
    country: "Ireland",
    subcountry: "Leinster",
    geonameid: 2960964,
  },
  {
    name: "Waterford",
    country: "Ireland",
    subcountry: "Munster",
    geonameid: 2960992,
  },
  {
    name: "Tralee",
    country: "Ireland",
    subcountry: "Munster",
    geonameid: 2961123,
  },
  {
    name: "Tallaght",
    country: "Ireland",
    subcountry: "Leinster",
    geonameid: 2961284,
  },
  {
    name: "Swords",
    country: "Ireland",
    subcountry: "Leinster",
    geonameid: 2961297,
  },
  {
    name: "Sligo",
    country: "Ireland",
    subcountry: "Connacht",
    geonameid: 2961423,
  },
  {
    name: "Rathfarnham",
    country: "Ireland",
    subcountry: "Leinster",
    geonameid: 2961911,
  },
  {
    name: "Droichead Nua",
    country: "Ireland",
    subcountry: "Leinster",
    geonameid: 2962290,
  },
  {
    name: "Navan",
    country: "Ireland",
    subcountry: "Leinster",
    geonameid: 2962308,
  },
  {
    name: "Naas",
    country: "Ireland",
    subcountry: "Leinster",
    geonameid: 2962334,
  },
  {
    name: "An Muileann gCearr",
    country: "Ireland",
    subcountry: "Leinster",
    geonameid: 2962361,
  },
  {
    name: "Malahide",
    country: "Ireland",
    subcountry: "Leinster",
    geonameid: 2962725,
  },
  {
    name: "Lucan",
    country: "Ireland",
    subcountry: "Leinster",
    geonameid: 2962785,
  },
  {
    name: "Limerick",
    country: "Ireland",
    subcountry: "Munster",
    geonameid: 2962943,
  },
  {
    name: "Letterkenny",
    country: "Ireland",
    subcountry: "Ulster",
    geonameid: 2962961,
  },
  {
    name: "Leixlip",
    country: "Ireland",
    subcountry: "Leinster",
    geonameid: 2962974,
  },
  {
    name: "Kilkenny",
    country: "Ireland",
    subcountry: "Leinster",
    geonameid: 2963398,
  },
  {
    name: "Greystones",
    country: "Ireland",
    subcountry: "Leinster",
    geonameid: 2963848,
  },
  {
    name: "Galway",
    country: "Ireland",
    subcountry: "Connacht",
    geonameid: 2964180,
  },
  {
    name: "Finglas",
    country: "Ireland",
    subcountry: "Leinster",
    geonameid: 2964303,
  },
  {
    name: "Ennis",
    country: "Ireland",
    subcountry: "Munster",
    geonameid: 2964405,
  },
  {
    name: "Dún Laoghaire",
    country: "Ireland",
    subcountry: "Leinster",
    geonameid: 2964506,
  },
  {
    name: "Dundalk",
    country: "Ireland",
    subcountry: "Leinster",
    geonameid: 2964540,
  },
  {
    name: "Dublin",
    country: "Ireland",
    subcountry: "Leinster",
    geonameid: 2964574,
  },
  {
    name: "Drogheda",
    country: "Ireland",
    subcountry: "Leinster",
    geonameid: 2964661,
  },
  {
    name: "Douglas",
    country: "Ireland",
    subcountry: "Munster",
    geonameid: 2964690,
  },
  {
    name: "Cork",
    country: "Ireland",
    subcountry: "Munster",
    geonameid: 2965140,
  },
  {
    name: "Cluain Meala",
    country: "Ireland",
    subcountry: "Munster",
    geonameid: 2965353,
  },
  {
    name: "Celbridge",
    country: "Ireland",
    subcountry: "Leinster",
    geonameid: 2965529,
  },
  {
    name: "Carrigaline",
    country: "Ireland",
    subcountry: "Munster",
    geonameid: 2965715,
  },
  {
    name: "Carlow",
    country: "Ireland",
    subcountry: "Leinster",
    geonameid: 2965768,
  },
  {
    name: "Bray",
    country: "Ireland",
    subcountry: "Leinster",
    geonameid: 2966022,
  },
  {
    name: "Blanchardstown",
    country: "Ireland",
    subcountry: "Leinster",
    geonameid: 2966110,
  },
  {
    name: "Ballincollig",
    country: "Ireland",
    subcountry: "Munster",
    geonameid: 2966749,
  },
  {
    name: "Balbriggan",
    country: "Ireland",
    subcountry: "Leinster",
    geonameid: 2966794,
  },
  {
    name: "Athlone",
    country: "Ireland",
    subcountry: "Leinster",
    geonameid: 3313472,
  },
  {
    name: "Sandyford",
    country: "Ireland",
    subcountry: "Leinster",
    geonameid: 3315278,
  },
  {
    name: "Donaghmede",
    country: "Ireland",
    subcountry: "Leinster",
    geonameid: 6691033,
  },
  {
    name: "South Dublin",
    country: "Ireland",
    subcountry: "Leinster",
    geonameid: 6697759,
  },
  {
    name: "Jerusalem",
    country: "Israel",
    subcountry: "Jerusalem",
    geonameid: 281184,
  },
  {
    name: "Modi‘in Makkabbim Re‘ut",
    country: "Israel",
    subcountry: "Central District",
    geonameid: 282926,
  },
  {
    name: "Zikhron Ya‘aqov",
    country: "Israel",
    subcountry: "Haifa",
    geonameid: 293067,
  },
  {
    name: "Safed",
    country: "Israel",
    subcountry: "Northern District",
    geonameid: 293100,
  },
  {
    name: "Yoqne‘am ‘Illit",
    country: "Israel",
    subcountry: "Northern District",
    geonameid: 293153,
  },
  {
    name: "Yirkā",
    country: "Israel",
    subcountry: "Northern District",
    geonameid: 293181,
  },
  {
    name: "Yehud",
    country: "Israel",
    subcountry: "Central District",
    geonameid: 293207,
  },
  {
    name: "Yavné",
    country: "Israel",
    subcountry: "Central District",
    geonameid: 293222,
  },
  {
    name: "Jaffa",
    country: "Israel",
    subcountry: "Tel Aviv",
    geonameid: 293253,
  },
  {
    name: "Yāfā",
    country: "Israel",
    subcountry: "Northern District",
    geonameid: 293254,
  },
  {
    name: "Umm el Faḥm",
    country: "Israel",
    subcountry: "Haifa",
    geonameid: 293286,
  },
  {
    name: "Tirat Karmel",
    country: "Israel",
    subcountry: "Haifa",
    geonameid: 293308,
  },
  {
    name: "Tiberias",
    country: "Israel",
    subcountry: "Northern District",
    geonameid: 293322,
  },
  {
    name: "Tel Aviv",
    country: "Israel",
    subcountry: "Tel Aviv",
    geonameid: 293397,
  },
  {
    name: "maalot Tarshīhā",
    country: "Israel",
    subcountry: "Northern District",
    geonameid: 293420,
  },
  {
    name: "Tamra",
    country: "Israel",
    subcountry: "Northern District",
    geonameid: 293426,
  },
  {
    name: "Shefar‘am",
    country: "Israel",
    subcountry: "Northern District",
    geonameid: 293539,
  },
  {
    name: "Sderot",
    country: "Israel",
    subcountry: "Southern District",
    geonameid: 293619,
  },
  {
    name: "Sakhnīn",
    country: "Israel",
    subcountry: "Northern District",
    geonameid: 293655,
  },
  {
    name: "Rosh Ha‘Ayin",
    country: "Israel",
    subcountry: "Central District",
    geonameid: 293690,
  },
  {
    name: "Rishon LeTsiyyon",
    country: "Israel",
    subcountry: "Central District",
    geonameid: 293703,
  },
  {
    name: "Reẖovot",
    country: "Israel",
    subcountry: "Central District",
    geonameid: 293725,
  },
  {
    name: "Ramla",
    country: "Israel",
    subcountry: "Central District",
    geonameid: 293768,
  },
  {
    name: "Ramat HaSharon",
    country: "Israel",
    subcountry: "Tel Aviv",
    geonameid: 293783,
  },
  {
    name: "Ramat Gan",
    country: "Israel",
    subcountry: "Tel Aviv",
    geonameid: 293788,
  },
  {
    name: "Ra'anana",
    country: "Israel",
    subcountry: "Central District",
    geonameid: 293807,
  },
  {
    name: "Qiryat Yam",
    country: "Israel",
    subcountry: "Haifa",
    geonameid: 293822,
  },
  {
    name: "Qiryat Tiv‘on",
    country: "Israel",
    subcountry: "Haifa",
    geonameid: 293823,
  },
  {
    name: "Qiryat Shmona",
    country: "Israel",
    subcountry: "Northern District",
    geonameid: 293825,
  },
  {
    name: "Qiryat Motsqin",
    country: "Israel",
    subcountry: "Haifa",
    geonameid: 293831,
  },
  {
    name: "Qiryat Mal’akhi",
    country: "Israel",
    subcountry: "Southern District",
    geonameid: 293835,
  },
  {
    name: "Kiryat Gat",
    country: "Israel",
    subcountry: "Southern District",
    geonameid: 293842,
  },
  {
    name: "Qiryat Bialik",
    country: "Israel",
    subcountry: "Haifa",
    geonameid: 293844,
  },
  {
    name: "Qiryat Ata",
    country: "Israel",
    subcountry: "Haifa",
    geonameid: 293845,
  },
  {
    name: "Qalansuwa",
    country: "Israel",
    subcountry: "Central District",
    geonameid: 293896,
  },
  {
    name: "Petaẖ Tiqva",
    country: "Israel",
    subcountry: "Central District",
    geonameid: 293918,
  },
  {
    name: "Or Yehuda",
    country: "Israel",
    subcountry: "Tel Aviv",
    geonameid: 293962,
  },
  {
    name: "Or Akiva",
    country: "Israel",
    subcountry: "Haifa",
    geonameid: 293969,
  },
  {
    name: "Ofaqim",
    country: "Israel",
    subcountry: "Southern District",
    geonameid: 293992,
  },
  {
    name: "Netivot",
    country: "Israel",
    subcountry: "Southern District",
    geonameid: 294068,
  },
  {
    name: "Netanya",
    country: "Israel",
    subcountry: "Central District",
    geonameid: 294071,
  },
  {
    name: "Ness Ziona",
    country: "Israel",
    subcountry: "Central District",
    geonameid: 294074,
  },
  {
    name: "Nesher",
    country: "Israel",
    subcountry: "Haifa",
    geonameid: 294078,
  },
  {
    name: "Naẕerat ‘Illit",
    country: "Israel",
    subcountry: "Northern District",
    geonameid: 294097,
  },
  {
    name: "Nazareth",
    country: "Israel",
    subcountry: "Northern District",
    geonameid: 294098,
  },
  {
    name: "Nahariyya",
    country: "Israel",
    subcountry: "Northern District",
    geonameid: 294117,
  },
  {
    name: "Migdal Ha‘Emeq",
    country: "Israel",
    subcountry: "Northern District",
    geonameid: 294210,
  },
  {
    name: "Mevasseret Tsiyyon",
    country: "Israel",
    subcountry: "Jerusalem",
    geonameid: 294245,
  },
  {
    name: "Majd el Kurūm",
    country: "Israel",
    subcountry: "Northern District",
    geonameid: 294373,
  },
  {
    name: "Maghār",
    country: "Israel",
    subcountry: "Northern District",
    geonameid: 294387,
  },
  {
    name: "Lod",
    country: "Israel",
    subcountry: "Central District",
    geonameid: 294421,
  },
  {
    name: "Kfar Yona",
    country: "Israel",
    subcountry: "Central District",
    geonameid: 294492,
  },
  {
    name: "Kfar Saba",
    country: "Israel",
    subcountry: "Central District",
    geonameid: 294514,
  },
  {
    name: "Karmi’el",
    country: "Israel",
    subcountry: "Northern District",
    geonameid: 294577,
  },
  {
    name: "Kafr Qāsim",
    country: "Israel",
    subcountry: "Central District",
    geonameid: 294604,
  },
  {
    name: "Kafr Qari‘",
    country: "Israel",
    subcountry: "Haifa",
    geonameid: 294605,
  },
  {
    name: "Kafr Mandā",
    country: "Israel",
    subcountry: "Northern District",
    geonameid: 294608,
  },
  {
    name: "Kafr Kannā",
    country: "Israel",
    subcountry: "Northern District",
    geonameid: 294610,
  },
  {
    name: "Judeida Makr",
    country: "Israel",
    subcountry: "Northern District",
    geonameid: 294622,
  },
  {
    name: "H̱olon",
    country: "Israel",
    subcountry: "Tel Aviv",
    geonameid: 294751,
  },
  {
    name: "Hod HaSharon",
    country: "Israel",
    subcountry: "Central District",
    geonameid: 294760,
  },
  {
    name: "Herzliya",
    country: "Israel",
    subcountry: "Tel Aviv",
    geonameid: 294778,
  },
  {
    name: "Haifa",
    country: "Israel",
    subcountry: "Haifa",
    geonameid: 294801,
  },
  {
    name: "Hadera",
    country: "Israel",
    subcountry: "Haifa",
    geonameid: 294946,
  },
  {
    name: "Giv'at Shmuel",
    country: "Israel",
    subcountry: "Tel Aviv",
    geonameid: 294981,
  },
  {
    name: "Givatayim",
    country: "Israel",
    subcountry: "Tel Aviv",
    geonameid: 294999,
  },
  {
    name: "Gedera",
    country: "Israel",
    subcountry: "Central District",
    geonameid: 295064,
  },
  {
    name: "Gan Yavne",
    country: "Israel",
    subcountry: "Central District",
    geonameid: 295080,
  },
  {
    name: "Ganei Tikva",
    country: "Israel",
    subcountry: "Central District",
    geonameid: 295089,
  },
  {
    name: "Eṭ Ṭīra",
    country: "Israel",
    subcountry: "Central District",
    geonameid: 295127,
  },
  {
    name: "Eṭ Ṭaiyiba",
    country: "Israel",
    subcountry: "Central District",
    geonameid: 295130,
  },
  {
    name: "Er Reina",
    country: "Israel",
    subcountry: "Northern District",
    geonameid: 295174,
  },
  {
    name: "Eilat",
    country: "Israel",
    subcountry: "Southern District",
    geonameid: 295277,
  },
  {
    name: "Dimona",
    country: "Israel",
    subcountry: "Southern District",
    geonameid: 295328,
  },
  {
    name: "Daliyat al Karmel",
    country: "Israel",
    subcountry: "Haifa",
    geonameid: 295365,
  },
  {
    name: "Binyamina",
    country: "Israel",
    subcountry: "Haifa",
    geonameid: 295410,
  },
  {
    name: "Bet Shemesh",
    country: "Israel",
    subcountry: "Jerusalem",
    geonameid: 295432,
  },
  {
    name: "Bet She’an",
    country: "Israel",
    subcountry: "Northern District",
    geonameid: 295435,
  },
  {
    name: "Bnei Brak",
    country: "Israel",
    subcountry: "Tel Aviv",
    geonameid: 295514,
  },
  {
    name: "Be’er Ya‘aqov",
    country: "Israel",
    subcountry: "Central District",
    geonameid: 295525,
  },
  {
    name: "Beersheba",
    country: "Israel",
    subcountry: "Southern District",
    geonameid: 295530,
  },
  {
    name: "Bat Yam",
    country: "Israel",
    subcountry: "Tel Aviv",
    geonameid: 295548,
  },
  {
    name: "Bāqa el Gharbīya",
    country: "Israel",
    subcountry: "Haifa",
    geonameid: 295571,
  },
  {
    name: "Ashkelon",
    country: "Israel",
    subcountry: "Southern District",
    geonameid: 295620,
  },
  {
    name: "Ashdod",
    country: "Israel",
    subcountry: "Southern District",
    geonameid: 295629,
  },
  {
    name: "‘Ar‘ara",
    country: "Israel",
    subcountry: "Haifa",
    geonameid: 295655,
  },
  {
    name: "Arad",
    country: "Israel",
    subcountry: "Southern District",
    geonameid: 295657,
  },
  {
    name: "Acre",
    country: "Israel",
    subcountry: "Northern District",
    geonameid: 295721,
  },
  {
    name: "Afula",
    country: "Israel",
    subcountry: "Northern District",
    geonameid: 295740,
  },
  {
    name: "West Jerusalem",
    country: "Israel",
    subcountry: "Jerusalem",
    geonameid: 7498240,
  },
  {
    name: "Rahat",
    country: "Israel",
    subcountry: "Southern District",
    geonameid: 8184212,
  },
  {
    name: "Modiin Ilit",
    country: "Israel",
    subcountry: "Jerusalem",
    geonameid: 8199378,
  },
  {
    name: "Ariel",
    country: "Israel",
    subcountry: "Judea and Samaria Area",
    geonameid: 8199394,
  },
  {
    name: "Tel Sheva‘",
    country: "Israel",
    subcountry: "Southern District",
    geonameid: 8310136,
  },
  {
    name: "‘Ar‘ara BaNegev",
    country: "Israel",
    subcountry: "Southern District",
    geonameid: 8374203,
  },
  {
    name: "H̱ura",
    country: "Israel",
    subcountry: "Southern District",
    geonameid: 8374209,
  },
  {
    name: "Kuseifa",
    country: "Israel",
    subcountry: "Southern District",
    geonameid: 8374220,
  },
  {
    name: "Shoham",
    country: "Israel",
    subcountry: "Central District",
    geonameid: 8428283,
  },
  {
    name: "El‘ad",
    country: "Israel",
    subcountry: "Central District",
    geonameid: 8428480,
  },
  {
    name: "Yehud-Monosson",
    country: "Israel",
    subcountry: "Tel Aviv",
    geonameid: 10227184,
  },
  {
    name: "Kadima Zoran",
    country: "Israel",
    subcountry: "Central District",
    geonameid: 11524864,
  },
  {
    name: "Kiryat Ono",
    country: "Israel",
    subcountry: "Tel Aviv",
    geonameid: 12031840,
  },
  {
    name: "Binyamina-Giv'at Ada",
    country: "Israel",
    subcountry: "Haifa",
    geonameid: 12156557,
  },
  {
    name: "Douglas",
    country: "Isle of Man",
    subcountry: "Douglas",
    geonameid: 3042237,
  },
  {
    name: "Pūnch",
    country: "India",
    subcountry: "Jammu and Kashmir",
    geonameid: 1167718,
  },
  {
    name: "Keelakarai",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1252646,
  },
  {
    name: "Zunheboto",
    country: "India",
    subcountry: "Nagaland",
    geonameid: 1252653,
  },
  {
    name: "Zamānia",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1252692,
  },
  {
    name: "Zaidpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1252698,
  },
  {
    name: "Zahirābād",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1252699,
  },
  {
    name: "Yeola",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1252738,
  },
  {
    name: "Yellāpur",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1252744,
  },
  {
    name: "Yellandu",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1252745,
  },
  {
    name: "Yelahanka",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1252758,
  },
  {
    name: "Yavatmāl",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1252770,
  },
  {
    name: "Yāval",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1252773,
  },
  {
    name: "Yanam",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1252795,
  },
  {
    name: "Yamunānagar",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1252797,
  },
  {
    name: "Yādgīr",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1252822,
  },
  {
    name: "Wokha",
    country: "India",
    subcountry: "Nagaland",
    geonameid: 1252840,
  },
  {
    name: "Wer",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1252885,
  },
  {
    name: "Wellington",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1252887,
  },
  {
    name: "Wazīrganj",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1252892,
  },
  {
    name: "Wāshīm",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1252908,
  },
  {
    name: "Warud",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1252919,
  },
  {
    name: "Warora",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1252925,
  },
  {
    name: "Wāris Alīganj",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1252930,
  },
  {
    name: "Wardha",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1252942,
  },
  {
    name: "Wārāseonī",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1252946,
  },
  {
    name: "Warangal",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1252948,
  },
  {
    name: "Wanparti",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1252956,
  },
  {
    name: "Wānkāner",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1252958,
  },
  {
    name: "Wani",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1252960,
  },
  {
    name: "Walajapet",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1252997,
  },
  {
    name: "Wai",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1253013,
  },
  {
    name: "Wādi",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1253041,
  },
  {
    name: "Vyāra",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1253074,
  },
  {
    name: "Vuyyūru",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1253077,
  },
  {
    name: "Vrindāvan",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1253079,
  },
  {
    name: "Vriddhāchalam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1253080,
  },
  {
    name: "Vizianagaram",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1253084,
  },
  {
    name: "Vite",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1253091,
  },
  {
    name: "Visnagar",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1253095,
  },
  {
    name: "Visakhapatnam",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1253102,
  },
  {
    name: "Vīsāvadar",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1253105,
  },
  {
    name: "Virudunagar",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1253113,
  },
  {
    name: "Vadakku Viravanallur",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1253127,
  },
  {
    name: "Virajpet",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1253132,
  },
  {
    name: "Virār",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1253133,
  },
  {
    name: "Vinukonda",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1253150,
  },
  {
    name: "Villupuram",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1253166,
  },
  {
    name: "Vikārābād",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1253182,
  },
  {
    name: "Vijayawada",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1253184,
  },
  {
    name: "Vijāpur",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1253193,
  },
  {
    name: "Vidisha",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1253200,
  },
  {
    name: "Vettūr",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1253216,
  },
  {
    name: "Vettaikkaranpudur",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1253219,
  },
  {
    name: "Vetapālem",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1253220,
  },
  {
    name: "Verāval",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1253237,
  },
  {
    name: "Vepagunta",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1253242,
  },
  {
    name: "Venkatagiri",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1253251,
  },
  {
    name: "Vemalwāda",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1253275,
  },
  {
    name: "Velur",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1253278,
  },
  {
    name: "Vellore",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1253286,
  },
  {
    name: "Vejalpur",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1253315,
  },
  {
    name: "Vedaraniyam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1253330,
  },
  {
    name: "Vayalār",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1253340,
  },
  {
    name: "Vattalkundu",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1253352,
  },
  {
    name: "Vāsudevanallūr",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1253357,
  },
  {
    name: "Vasind",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1253363,
  },
  {
    name: "Vasco da Gama",
    country: "India",
    subcountry: "Goa",
    geonameid: 1253367,
  },
  {
    name: "Vasa",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1253374,
  },
  {
    name: "Varkala",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1253392,
  },
  {
    name: "Varangaon",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1253403,
  },
  {
    name: "Varanasi",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1253405,
  },
  {
    name: "Vaniyambadi",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1253437,
  },
  {
    name: "Vandavāsi",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1253452,
  },
  {
    name: "Valsād",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1253468,
  },
  {
    name: "Valparai",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1253472,
  },
  {
    name: "Vallabh Vidyanagar",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1253482,
  },
  {
    name: "Valabhīpur",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1253512,
  },
  {
    name: "Vaikam",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1253544,
  },
  {
    name: "Vaijāpur",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1253545,
  },
  {
    name: "Vadodara",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1253573,
  },
  {
    name: "Vadnagar",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1253577,
  },
  {
    name: "Vadlapūdi",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1253578,
  },
  {
    name: "Vādippatti",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1253579,
  },
  {
    name: "Vadamadurai",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1253595,
  },
  {
    name: "Vadakku Valliyūr",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1253605,
  },
  {
    name: "Vāda",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1253610,
  },
  {
    name: "Uttiramerūr",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1253623,
  },
  {
    name: "Uttarkāshi",
    country: "India",
    subcountry: "Uttarakhand",
    geonameid: 1253628,
  },
  {
    name: "Uttamapālaiyam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1253635,
  },
  {
    name: "Utraula",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1253638,
  },
  {
    name: "Usilampatti",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1253671,
  },
  {
    name: "Usehat",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1253673,
  },
  {
    name: "Uravakonda",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1253698,
  },
  {
    name: "Uran",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1253702,
  },
  {
    name: "Upleta",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1253736,
  },
  {
    name: "Uppal Kalan",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1253744,
  },
  {
    name: "Unnāo",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1253747,
  },
  {
    name: "Unjha",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1253750,
  },
  {
    name: "Unhel",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1253754,
  },
  {
    name: "Una",
    country: "India",
    subcountry: "Himachal Pradesh",
    geonameid: 1253782,
  },
  {
    name: "Una",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1253783,
  },
  {
    name: "Ūn",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1253785,
  },
  {
    name: "Un",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1253786,
  },
  {
    name: "Umreth",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1253805,
  },
  {
    name: "Umred",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1253807,
  },
  {
    name: "Umarkot",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1253860,
  },
  {
    name: "Umarkhed",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1253861,
  },
  {
    name: "Umaria",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1253863,
  },
  {
    name: "Umarga",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1253870,
  },
  {
    name: "Ullal",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1253888,
  },
  {
    name: "Ulhasnagar",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1253894,
  },
  {
    name: "Ujjain",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1253914,
  },
  {
    name: "Ujhāni",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1253918,
  },
  {
    name: "Udumalaippettai",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1253944,
  },
  {
    name: "Udupi",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1253952,
  },
  {
    name: "Udhampur",
    country: "India",
    subcountry: "Jammu and Kashmir",
    geonameid: 1253956,
  },
  {
    name: "Udgīr",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1253958,
  },
  {
    name: "Udangudi",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1253972,
  },
  {
    name: "Udalguri",
    country: "India",
    subcountry: "Assam",
    geonameid: 1253977,
  },
  {
    name: "Udaipura",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1253984,
  },
  {
    name: "Udaipur",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1253985,
  },
  {
    name: "Udaipur",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1253986,
  },
  {
    name: "Udaipur",
    country: "India",
    subcountry: "Tripura",
    geonameid: 1253987,
  },
  {
    name: "Ooty",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1253993,
  },
  {
    name: "Bara Uchāna",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1254000,
  },
  {
    name: "Turaiyūr",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1254043,
  },
  {
    name: "Tura",
    country: "India",
    subcountry: "Meghalaya",
    geonameid: 1254046,
  },
  {
    name: "Tuni",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1254054,
  },
  {
    name: "Tūndla",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1254069,
  },
  {
    name: "Tumsar",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1254080,
  },
  {
    name: "Tumkūr",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1254089,
  },
  {
    name: "Tulsīpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1254102,
  },
  {
    name: "Tuljāpur",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1254111,
  },
  {
    name: "Tufānganj",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1254131,
  },
  {
    name: "Tuensang",
    country: "India",
    subcountry: "Nagaland",
    geonameid: 1254133,
  },
  {
    name: "Thiruvananthapuram",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1254163,
  },
  {
    name: "Thrissur",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1254187,
  },
  {
    name: "Tonk",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1254241,
  },
  {
    name: "Tondi",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1254249,
  },
  {
    name: "Tohāna",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1254274,
  },
  {
    name: "Todaraisingh",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1254282,
  },
  {
    name: "Todabhim",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1254283,
  },
  {
    name: "Titlāgarh",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1254304,
  },
  {
    name: "Titāgarh",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1254309,
  },
  {
    name: "Tisaiyanvilai",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1254317,
  },
  {
    name: "Tiruvottiyūr",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1254320,
  },
  {
    name: "Cheyyar",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1254322,
  },
  {
    name: "Tiruvannāmalai",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1254327,
  },
  {
    name: "Tiruvallur",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1254331,
  },
  {
    name: "Tiruvalla",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1254335,
  },
  {
    name: "Thiruthani",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1254342,
  },
  {
    name: "Tiruttangal",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1254343,
  },
  {
    name: "Tirur",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1254346,
  },
  {
    name: "Tiruppuvanam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1254347,
  },
  {
    name: "Tiruppur",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1254348,
  },
  {
    name: "Tirupparangunram",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1254356,
  },
  {
    name: "Tirupati",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1254360,
  },
  {
    name: "Tirunelveli",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1254361,
  },
  {
    name: "Tirumala",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1254373,
  },
  {
    name: "Tirukkoyilur",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1254377,
  },
  {
    name: "Tiruchengode",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1254385,
  },
  {
    name: "Tiruchirappalli",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1254388,
  },
  {
    name: "Tiruchchendur",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1254390,
  },
  {
    name: "Tīrthahalli",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1254396,
  },
  {
    name: "Tiptūr",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1254420,
  },
  {
    name: "Tinsukia",
    country: "India",
    subcountry: "Assam",
    geonameid: 1254432,
  },
  {
    name: "Tinnanūr",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1254436,
  },
  {
    name: "Tindivanam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1254444,
  },
  {
    name: "Tilhar",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1254481,
  },
  {
    name: "Tīkamgarh",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1254534,
  },
  {
    name: "Tijāra",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1254538,
  },
  {
    name: "Thoubāl",
    country: "India",
    subcountry: "Manipur",
    geonameid: 1254570,
  },
  {
    name: "Thiruvarur",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1254589,
  },
  {
    name: "Thāsra",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1254624,
  },
  {
    name: "Tharād",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1254638,
  },
  {
    name: "Thanjavur",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1254649,
  },
  {
    name: "Thānesar",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1254657,
  },
  {
    name: "Thāne",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1254661,
  },
  {
    name: "Thāna Bhawan",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1254673,
  },
  {
    name: "Thān",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1254675,
  },
  {
    name: "Thākurganj",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1254694,
  },
  {
    name: "Thakurdwara",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1254695,
  },
  {
    name: "Tezpur",
    country: "India",
    subcountry: "Assam",
    geonameid: 1254710,
  },
  {
    name: "Terdāl",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1254727,
  },
  {
    name: "Teonthar",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1254732,
  },
  {
    name: "Thenkasi",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1254744,
  },
  {
    name: "Teni",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1254745,
  },
  {
    name: "Tellicherry",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1254780,
  },
  {
    name: "Telhāra",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1254787,
  },
  {
    name: "Tekkali",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1254794,
  },
  {
    name: "Tekkalakote",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1254795,
  },
  {
    name: "Tekāri",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1254797,
  },
  {
    name: "Tehri",
    country: "India",
    subcountry: "Uttarakhand",
    geonameid: 1254808,
  },
  {
    name: "Teghra",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1254813,
  },
  {
    name: "Tāsgaon",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1254858,
  },
  {
    name: "Tarn Tāran",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1254868,
  },
  {
    name: "Tarikere",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1254880,
  },
  {
    name: "Tharangambadi",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1254904,
  },
  {
    name: "Tārānagar",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1254908,
  },
  {
    name: "Tarāna",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1254909,
  },
  {
    name: "Tāramangalam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1254910,
  },
  {
    name: "Tarakeswar",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1254912,
  },
  {
    name: "Tāoru",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1254948,
  },
  {
    name: "Tanuku",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1254953,
  },
  {
    name: "Tāndūr",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1255004,
  },
  {
    name: "Tānda",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1255023,
  },
  {
    name: "Tāndā",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1255024,
  },
  {
    name: "Tanakpur",
    country: "India",
    subcountry: "Uttarakhand",
    geonameid: 1255027,
  },
  {
    name: "Tamlūk",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1255046,
  },
  {
    name: "Tambaram",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1255062,
  },
  {
    name: "Talwāra",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1255076,
  },
  {
    name: "Talwandi Bhai",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1255082,
  },
  {
    name: "Taloda",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1255104,
  },
  {
    name: "Talipparamba",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1255121,
  },
  {
    name: "Tālīkota",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1255122,
  },
  {
    name: "Taleigao",
    country: "India",
    subcountry: "Goa",
    geonameid: 1255131,
  },
  {
    name: "Talegaon Dābhāde",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1255134,
  },
  {
    name: "Tālcher",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1255143,
  },
  {
    name: "Talāja",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1255175,
  },
  {
    name: "Tāki",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1255211,
  },
  {
    name: "Takhatpur",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1255212,
  },
  {
    name: "Takhatgarh",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1255213,
  },
  {
    name: "Tājpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1255224,
  },
  {
    name: "Tādpatri",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1255254,
  },
  {
    name: "Tādepallegūdem",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1255264,
  },
  {
    name: "Tādepalle",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1255265,
  },
  {
    name: "Suriāpet",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1255344,
  },
  {
    name: "Suriānwān",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1255346,
  },
  {
    name: "Surendranagar",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1255349,
  },
  {
    name: "Sūratgarh",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1255361,
  },
  {
    name: "Surat",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1255364,
  },
  {
    name: "Sūrandai",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1255372,
  },
  {
    name: "Sūrajgarh",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1255383,
  },
  {
    name: "Supaul",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1255396,
  },
  {
    name: "Sunel",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1255425,
  },
  {
    name: "Sundarnagar",
    country: "India",
    subcountry: "Himachal Pradesh",
    geonameid: 1255434,
  },
  {
    name: "Sundargarh",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1255437,
  },
  {
    name: "Sunām",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1255449,
  },
  {
    name: "Sulya",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1255482,
  },
  {
    name: "Sūlūru",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1255483,
  },
  {
    name: "Sulur",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1255484,
  },
  {
    name: "Sultanpur",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1255488,
  },
  {
    name: "Sultānpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1255491,
  },
  {
    name: "Suket",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1255551,
  },
  {
    name: "Sūjāngarh",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1255560,
  },
  {
    name: "Suār",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1255597,
  },
  {
    name: "Srivilliputhur",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1255616,
  },
  {
    name: "Srīvardhan",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1255619,
  },
  {
    name: "Srivaikuntam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1255620,
  },
  {
    name: "Srīsailain",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1255621,
  },
  {
    name: "Srīrāmnagar",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1255625,
  },
  {
    name: "Srīperumbūdūr",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1255630,
  },
  {
    name: "Srīnivāspur",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1255631,
  },
  {
    name: "Srinagar",
    country: "India",
    subcountry: "Jammu and Kashmir",
    geonameid: 1255634,
  },
  {
    name: "Srīnagar",
    country: "India",
    subcountry: "Uttarakhand",
    geonameid: 1255635,
  },
  {
    name: "Sri Mādhopur",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1255643,
  },
  {
    name: "Karanpur",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1255646,
  },
  {
    name: "Srikakulam",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1255647,
  },
  {
    name: "Sri Dūngargarh",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1255654,
  },
  {
    name: "Soygaon",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1255667,
  },
  {
    name: "Soron",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1255704,
  },
  {
    name: "Soro",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1255705,
  },
  {
    name: "Sorada",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1255712,
  },
  {
    name: "Sopur",
    country: "India",
    subcountry: "Jammu and Kashmir",
    geonameid: 1255714,
  },
  {
    name: "Sonīpat",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1255744,
  },
  {
    name: "Songadh",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1255762,
  },
  {
    name: "Sonepur",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1255763,
  },
  {
    name: "Rajpur Sonarpur",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1255783,
  },
  {
    name: "Sonāri",
    country: "India",
    subcountry: "Assam",
    geonameid: 1255788,
  },
  {
    name: "Sonāmukhi",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1255792,
  },
  {
    name: "Sompeta",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1255816,
  },
  {
    name: "Someshwar",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1255823,
  },
  {
    name: "Solan",
    country: "India",
    subcountry: "Himachal Pradesh",
    geonameid: 1255850,
  },
  {
    name: "Sojītra",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1255858,
  },
  {
    name: "Sojat",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1255860,
  },
  {
    name: "Sohna",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1255870,
  },
  {
    name: "Sohāgpur",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1255884,
  },
  {
    name: "Siwāna",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1255925,
  },
  {
    name: "Siwān",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1255927,
  },
  {
    name: "Sivakasi",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1255947,
  },
  {
    name: "Sivagiri",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1255950,
  },
  {
    name: "Sivagiri",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1255951,
  },
  {
    name: "Sivaganga",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1255953,
  },
  {
    name: "Siuri",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1255955,
  },
  {
    name: "Sitārganj",
    country: "India",
    subcountry: "Uttarakhand",
    geonameid: 1255963,
  },
  {
    name: "Sītāpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1255969,
  },
  {
    name: "Sītāmarhi",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1255983,
  },
  {
    name: "Siswā Bāzār",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1255995,
  },
  {
    name: "Sisauli",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1256003,
  },
  {
    name: "Sirūr",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1256025,
  },
  {
    name: "Sirumugai",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1256027,
  },
  {
    name: "Siruguppa",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1256029,
  },
  {
    name: "Sirsilla",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1256039,
  },
  {
    name: "Sirsi",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1256040,
  },
  {
    name: "Sirsi",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1256047,
  },
  {
    name: "Sirsāganj",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1256050,
  },
  {
    name: "Sirsa",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1256052,
  },
  {
    name: "Sironj",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1256064,
  },
  {
    name: "Sirohi",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1256067,
  },
  {
    name: "Sīrkāzhi",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1256075,
  },
  {
    name: "Sirhind",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1256087,
  },
  {
    name: "Sīra",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1256104,
  },
  {
    name: "Sinnar",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1256119,
  },
  {
    name: "Singur",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1256124,
  },
  {
    name: "Singarāyakonda",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1256176,
  },
  {
    name: "Singānallūr",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1256184,
  },
  {
    name: "Sindhnūr",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1256207,
  },
  {
    name: "Sindgi",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1256214,
  },
  {
    name: "Shimla",
    country: "India",
    subcountry: "Himachal Pradesh",
    geonameid: 1256237,
  },
  {
    name: "Simdega",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1256246,
  },
  {
    name: "Silvassa",
    country: "India",
    subcountry: "Dadra and Nagar Haveli and Daman and Diu",
    geonameid: 1256259,
  },
  {
    name: "Sillod",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1256269,
  },
  {
    name: "Silchar",
    country: "India",
    subcountry: "Assam",
    geonameid: 1256287,
  },
  {
    name: "Silao",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1256295,
  },
  {
    name: "Sīkar",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1256320,
  },
  {
    name: "Sikandra Rao",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1256322,
  },
  {
    name: "Sikandarpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1256328,
  },
  {
    name: "Sikandarābād",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1256329,
  },
  {
    name: "Sikka",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1256333,
  },
  {
    name: "Sijua",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1256335,
  },
  {
    name: "Sihorā",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1256340,
  },
  {
    name: "Sihor",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1256343,
  },
  {
    name: "Sidlaghatta",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1256363,
  },
  {
    name: "Sidhi",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1256369,
  },
  {
    name: "Sidhaulī",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1256372,
  },
  {
    name: "Siddipet",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1256377,
  },
  {
    name: "Siddhapur",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1256382,
  },
  {
    name: "Sibsāgar",
    country: "India",
    subcountry: "Assam",
    geonameid: 1256388,
  },
  {
    name: "Shyamnagar",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1256409,
  },
  {
    name: "Shujālpur",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1256418,
  },
  {
    name: "Shrīrangapattana",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1256421,
  },
  {
    name: "Shrīrāmpur",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1256422,
  },
  {
    name: "Shrīgonda",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1256426,
  },
  {
    name: "Shorāpur",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1256431,
  },
  {
    name: "Shōranūr",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1256432,
  },
  {
    name: "Sholinghur",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1256435,
  },
  {
    name: "Solāpur",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1256436,
  },
  {
    name: "Shivpuri",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1256451,
  },
  {
    name: "Shīshgarh",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1256468,
  },
  {
    name: "Shirpur",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1256475,
  },
  {
    name: "Shirhatti",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1256483,
  },
  {
    name: "Shirdi",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1256489,
  },
  {
    name: "Shimoga",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1256515,
  },
  {
    name: "Shillong",
    country: "India",
    subcountry: "Meghalaya",
    geonameid: 1256523,
  },
  {
    name: "Siliguri",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1256525,
  },
  {
    name: "Shikohābād",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1256529,
  },
  {
    name: "Shikārpūr",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1256532,
  },
  {
    name: "Shikārpur",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1256537,
  },
  {
    name: "Shiggaon",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1256539,
  },
  {
    name: "Shertallai",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1256558,
  },
  {
    name: "Sherkot",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1256569,
  },
  {
    name: "Sherghāti",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1256572,
  },
  {
    name: "Sheopur",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1256593,
  },
  {
    name: "Sheohar",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1256597,
  },
  {
    name: "Sheoganj",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1256598,
  },
  {
    name: "Shegaon",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1256620,
  },
  {
    name: "Shāntipur",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1256639,
  },
  {
    name: "Shamsābād",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1256659,
  },
  {
    name: "Shamsābād",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1256660,
  },
  {
    name: "Shāmli",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1256671,
  },
  {
    name: "Shāmgarh",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1256673,
  },
  {
    name: "Shājāpur",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1256693,
  },
  {
    name: "Sheikhpura",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1256698,
  },
  {
    name: "Shāhpura",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1256705,
  },
  {
    name: "Shāhpura",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1256706,
  },
  {
    name: "Shāhpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1256713,
  },
  {
    name: "Shāhpur",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1256715,
  },
  {
    name: "Shāhpur",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1256720,
  },
  {
    name: "Shāhpur",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1256722,
  },
  {
    name: "Shāhjānpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1256728,
  },
  {
    name: "Shāhi",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1256731,
  },
  {
    name: "Shāhganj",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1256735,
  },
  {
    name: "Shahdol",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1256739,
  },
  {
    name: "Shāhāda",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1256750,
  },
  {
    name: "Shāhābād",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1256752,
  },
  {
    name: "Shāhābād",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1256753,
  },
  {
    name: "Shāhābād",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1256755,
  },
  {
    name: "Shāhābād",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1256759,
  },
  {
    name: "Serchhīp",
    country: "India",
    subcountry: "Mizoram",
    geonameid: 1256812,
  },
  {
    name: "Seram",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1256814,
  },
  {
    name: "Seoni Mālwa",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1256823,
  },
  {
    name: "Seoni",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1256826,
  },
  {
    name: "Seondha",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1256828,
  },
  {
    name: "Seohāra",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1256832,
  },
  {
    name: "Sendhwa",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1256854,
  },
  {
    name: "Sehore",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1256913,
  },
  {
    name: "Secunderabad",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1256922,
  },
  {
    name: "Sāyla",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1256929,
  },
  {
    name: "Sawāi Mādhopur",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1256949,
  },
  {
    name: "Sāvda",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1256959,
  },
  {
    name: "Savanūr",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1256967,
  },
  {
    name: "Sāvantvādi",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1256968,
  },
  {
    name: "Sausar",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1256974,
  },
  {
    name: "Saundatti",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1256983,
  },
  {
    name: "Sathyamangalam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1256989,
  },
  {
    name: "Sattur",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1256995,
  },
  {
    name: "Sattenapalle",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1257001,
  },
  {
    name: "Satna",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1257022,
  },
  {
    name: "Satara",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1257055,
  },
  {
    name: "Satānā",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1257060,
  },
  {
    name: "Sāsvad",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1257066,
  },
  {
    name: "Sarwār",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1257093,
  },
  {
    name: "Sarkhej",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1257149,
  },
  {
    name: "Sardulgarh",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1257191,
  },
  {
    name: "Sardhana",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1257196,
  },
  {
    name: "Sardārshahr",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1257198,
  },
  {
    name: "Sarauli",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1257219,
  },
  {
    name: "Sārangpur",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1257237,
  },
  {
    name: "Saraipali",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1257259,
  },
  {
    name: "Sarāi Mīr",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1257260,
  },
  {
    name: "Sarāi Ākil",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1257268,
  },
  {
    name: "Saoner",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1257307,
  },
  {
    name: "Sānkrāil",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1257354,
  },
  {
    name: "Sankeshwar",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1257369,
  },
  {
    name: "Sangrūr",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1257402,
  },
  {
    name: "Sāngola",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1257409,
  },
  {
    name: "Sangod",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1257410,
  },
  {
    name: "Sāngli",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1257416,
  },
  {
    name: "Sangariā",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1257429,
  },
  {
    name: "Sangāreddi",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1257431,
  },
  {
    name: "Sangamner",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1257436,
  },
  {
    name: "Sandūr",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1257456,
  },
  {
    name: "Sandīla",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1257459,
  },
  {
    name: "Sāndi",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1257461,
  },
  {
    name: "Sancoale",
    country: "India",
    subcountry: "Goa",
    geonameid: 1257476,
  },
  {
    name: "Sānchor",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1257477,
  },
  {
    name: "Sanāwad",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1257481,
  },
  {
    name: "Sanaur",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1257482,
  },
  {
    name: "Sānand",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1257486,
  },
  {
    name: "Samthar",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1257498,
  },
  {
    name: "Samrāla",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1257503,
  },
  {
    name: "Samdari",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1257528,
  },
  {
    name: "Sāmbhar",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1257539,
  },
  {
    name: "Sambhal",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1257540,
  },
  {
    name: "Sambalpur",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1257542,
  },
  {
    name: "Sāmba",
    country: "India",
    subcountry: "Jammu and Kashmir",
    geonameid: 1257545,
  },
  {
    name: "Samāstipur",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1257551,
  },
  {
    name: "Sāmalkot",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1257565,
  },
  {
    name: "Samālkha",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1257566,
  },
  {
    name: "Sālūr",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1257587,
  },
  {
    name: "Sālūmbar",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1257588,
  },
  {
    name: "Salem",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1257629,
  },
  {
    name: "Salāya",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1257638,
  },
  {
    name: "Saktī",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1257673,
  },
  {
    name: "Sakleshpur",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1257698,
  },
  {
    name: "Saint Thomas Mount",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1257749,
  },
  {
    name: "Sainthia",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1257751,
  },
  {
    name: "Selu",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1257762,
  },
  {
    name: "Saiha",
    country: "India",
    subcountry: "Mizoram",
    geonameid: 1257771,
  },
  {
    name: "Saidpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1257776,
  },
  {
    name: "Sāhibganj",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1257794,
  },
  {
    name: "Sahāwar",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1257799,
  },
  {
    name: "Sahaswān",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1257800,
  },
  {
    name: "Sahaspur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1257802,
  },
  {
    name: "Saharsa",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1257804,
  },
  {
    name: "Sahāranpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1257806,
  },
  {
    name: "Sagauli",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1257830,
  },
  {
    name: "Saugor",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1257845,
  },
  {
    name: "Sāgar",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1257851,
  },
  {
    name: "Safīpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1257854,
  },
  {
    name: "Safidon",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1257855,
  },
  {
    name: "Sādri",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1257865,
  },
  {
    name: "Sadashivpet",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1257890,
  },
  {
    name: "Sadalgi",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1257895,
  },
  {
    name: "Sadābād",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1257896,
  },
  {
    name: "Sabalgarh",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1257928,
  },
  {
    name: "Rusera",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1257936,
  },
  {
    name: "Rura",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1257940,
  },
  {
    name: "Ropar",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1257951,
  },
  {
    name: "Rūdarpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1258012,
  },
  {
    name: "Roorkee",
    country: "India",
    subcountry: "Uttarakhand",
    geonameid: 1258044,
  },
  {
    name: "Ron",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1258061,
  },
  {
    name: "Rohtak",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1258076,
  },
  {
    name: "Roha",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1258099,
  },
  {
    name: "Robertsonpet",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1258109,
  },
  {
    name: "Robertsganj",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1258111,
  },
  {
    name: "Risod",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1258124,
  },
  {
    name: "Rishra",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1258126,
  },
  {
    name: "Rishīkesh",
    country: "India",
    subcountry: "Uttarakhand",
    geonameid: 1258128,
  },
  {
    name: "Rīngas",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1258140,
  },
  {
    name: "Richha",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1258164,
  },
  {
    name: "Rewāri",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1258178,
  },
  {
    name: "Rewa",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1258182,
  },
  {
    name: "Revelganj",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1258186,
  },
  {
    name: "Repalle",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1258201,
  },
  {
    name: "Reoti",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1258203,
  },
  {
    name: "Renukūt",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1258207,
  },
  {
    name: "Renigunta",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1258213,
  },
  {
    name: "Remuna",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1258229,
  },
  {
    name: "Rehli",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1258247,
  },
  {
    name: "Rāzām",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1258270,
  },
  {
    name: "Raybag",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1258278,
  },
  {
    name: "Rāyadrug",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1258290,
  },
  {
    name: "Rāyachoti",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1258291,
  },
  {
    name: "Rāya",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1258292,
  },
  {
    name: "Raxaul",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1258294,
  },
  {
    name: "Rāwatsār",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1258295,
  },
  {
    name: "Rāwatbhāta",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1258297,
  },
  {
    name: "Rāver",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1258307,
  },
  {
    name: "Raurkela",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1258315,
  },
  {
    name: "Ratnagiri",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1258338,
  },
  {
    name: "Ratlām",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1258342,
  },
  {
    name: "Ratia",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1258347,
  },
  {
    name: "Rāth",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1258352,
  },
  {
    name: "Ratanpur",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1258362,
  },
  {
    name: "Ratangarh",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1258366,
  },
  {
    name: "Rasrā",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1258380,
  },
  {
    name: "Rasipuram",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1258386,
  },
  {
    name: "Rāpar",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1258406,
  },
  {
    name: "Rānīpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1258449,
  },
  {
    name: "Rānipet",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1258451,
  },
  {
    name: "Rānikhet",
    country: "India",
    subcountry: "Uttarakhand",
    geonameid: 1258455,
  },
  {
    name: "Rānīganj",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1258470,
  },
  {
    name: "Rānībennur",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1258474,
  },
  {
    name: "Rānia",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1258477,
  },
  {
    name: "Rangia",
    country: "India",
    subcountry: "Assam",
    geonameid: 1258492,
  },
  {
    name: "Rangāpāra",
    country: "India",
    subcountry: "Assam",
    geonameid: 1258501,
  },
  {
    name: "Ranchi",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1258526,
  },
  {
    name: "Rānāvāv",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1258534,
  },
  {
    name: "Rānāghāt",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1258546,
  },
  {
    name: "Rāmtek",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1258553,
  },
  {
    name: "Rampur Hat",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1258581,
  },
  {
    name: "Rāmpura",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1258584,
  },
  {
    name: "Rāmpura",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1258592,
  },
  {
    name: "Rāmpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1258598,
  },
  {
    name: "Rāmpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1258599,
  },
  {
    name: "Rāmnagar",
    country: "India",
    subcountry: "Uttarakhand",
    geonameid: 1258637,
  },
  {
    name: "Rāmnagar",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1258639,
  },
  {
    name: "Rāmnagar",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1258642,
  },
  {
    name: "Rāmjībanpur",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1258658,
  },
  {
    name: "Rāmgundam",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1258662,
  },
  {
    name: "Rāmgarh",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1258677,
  },
  {
    name: "Rāmgarh",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1258686,
  },
  {
    name: "Rāmganj Mandi",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1258692,
  },
  {
    name: "Rameswaram",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1258698,
  },
  {
    name: "Rāmāpuram",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1258726,
  },
  {
    name: "Ramanathapuram",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1258740,
  },
  {
    name: "Closepet",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1258744,
  },
  {
    name: "Rāmachandrapuram",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1258756,
  },
  {
    name: "Rājūra",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1258786,
  },
  {
    name: "Rājula",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1258795,
  },
  {
    name: "Rājsamand",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1258797,
  },
  {
    name: "Rājpura",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1258803,
  },
  {
    name: "Rajpur",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1258815,
  },
  {
    name: "Rajpur",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1258816,
  },
  {
    name: "Rājpīpla",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1258819,
  },
  {
    name: "Rāj-Nāndgaon",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1258831,
  },
  {
    name: "Rājmahal",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1258843,
  },
  {
    name: "Rājkot",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1258847,
  },
  {
    name: "Rājgurunagar",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1258859,
  },
  {
    name: "Rājgīr",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1258864,
  },
  {
    name: "Rājgarh",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1258868,
  },
  {
    name: "Rājgarh",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1258869,
  },
  {
    name: "Rājgarh",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1258875,
  },
  {
    name: "Rājgarh",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1258876,
  },
  {
    name: "Rajaori",
    country: "India",
    subcountry: "Jammu and Kashmir",
    geonameid: 1258891,
  },
  {
    name: "Rajapalaiyam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1258916,
  },
  {
    name: "Rāzampeta",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1258922,
  },
  {
    name: "Rājaldesar",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1258928,
  },
  {
    name: "Rājākhera",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1258930,
  },
  {
    name: "Rājahmundry",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1258932,
  },
  {
    name: "Rāisinghnagar",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1258950,
  },
  {
    name: "Raisen",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1258952,
  },
  {
    name: "Rāipur",
    country: "India",
    subcountry: "Uttarakhand",
    geonameid: 1258967,
  },
  {
    name: "Raipur",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1258972,
  },
  {
    name: "Raipur",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1258980,
  },
  {
    name: "Rāikot",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1258993,
  },
  {
    name: "Raigarh",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1259005,
  },
  {
    name: "Rāiganj",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1259009,
  },
  {
    name: "Rāichūr",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1259012,
  },
  {
    name: "Rāhuri",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1259019,
  },
  {
    name: "Rahimatpur",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1259026,
  },
  {
    name: "Rāhatgarh",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1259034,
  },
  {
    name: "Raghunathpur",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1259049,
  },
  {
    name: "Rāghogarh",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1259056,
  },
  {
    name: "Rafiganj",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1259060,
  },
  {
    name: "Raebareli",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1259064,
  },
  {
    name: "Rādhanpur",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1259069,
  },
  {
    name: "Rabkavi",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1259083,
  },
  {
    name: "Kollam",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1259091,
  },
  {
    name: "Kasba",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1259108,
  },
  {
    name: "Qādiān",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1259110,
  },
  {
    name: "Puttūr",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1259123,
  },
  {
    name: "Puttūr",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1259124,
  },
  {
    name: "Pushkar",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1259148,
  },
  {
    name: "Pusad",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1259154,
  },
  {
    name: "Purwā",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1259157,
  },
  {
    name: "Puruliya",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1259163,
  },
  {
    name: "Purnia",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1259166,
  },
  {
    name: "Pūrna",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1259177,
  },
  {
    name: "Puri",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1259184,
  },
  {
    name: "Pūranpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1259190,
  },
  {
    name: "Pupri",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1259210,
  },
  {
    name: "Punjai Puliyampatti",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1259222,
  },
  {
    name: "Punganūru",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1259228,
  },
  {
    name: "Pune",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1259229,
  },
  {
    name: "Pūndri",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1259231,
  },
  {
    name: "Punāsa",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1259239,
  },
  {
    name: "Punalūr",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1259243,
  },
  {
    name: "Pūnāhāna",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1259244,
  },
  {
    name: "Pulwama",
    country: "India",
    subcountry: "Jammu and Kashmir",
    geonameid: 1259251,
  },
  {
    name: "Puliyangudi",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1259263,
  },
  {
    name: "Pulivendla",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1259264,
  },
  {
    name: "Pulgaon",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1259272,
  },
  {
    name: "Pukhrāyān",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1259283,
  },
  {
    name: "Pudukkottai",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1259297,
  },
  {
    name: "Proddatūr",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1259312,
  },
  {
    name: "Pratāpgarh",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1259338,
  },
  {
    name: "Port Blair",
    country: "India",
    subcountry: "Andaman and Nicobar",
    geonameid: 1259385,
  },
  {
    name: "Porsa",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1259388,
  },
  {
    name: "Porbandar",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1259395,
  },
  {
    name: "Poonamalle",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1259400,
  },
  {
    name: "Ponnūru",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1259408,
  },
  {
    name: "Ponneri",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1259409,
  },
  {
    name: "Ponnāni",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1259411,
  },
  {
    name: "Puducherry",
    country: "India",
    subcountry: "Puducherry",
    geonameid: 1259425,
  },
  {
    name: "Ponda",
    country: "India",
    subcountry: "Goa",
    geonameid: 1259429,
  },
  {
    name: "Polūr",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1259434,
  },
  {
    name: "Pollachi",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1259440,
  },
  {
    name: "Polavaram",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1259444,
  },
  {
    name: "Polasara",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1259446,
  },
  {
    name: "Pokaran",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1259460,
  },
  {
    name: "Pithorāgarh",
    country: "India",
    subcountry: "Uttarakhand",
    geonameid: 1259503,
  },
  {
    name: "Pithāpuram",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1259508,
  },
  {
    name: "Piro",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1259530,
  },
  {
    name: "Piriyāpatna",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1259535,
  },
  {
    name: "Piravam",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1259541,
  },
  {
    name: "Pīpri",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1259552,
  },
  {
    name: "Pipraich",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1259554,
  },
  {
    name: "Pipili",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1259592,
  },
  {
    name: "Pīpār",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1259608,
  },
  {
    name: "Pinjaur",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1259630,
  },
  {
    name: "Pindwāra",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1259638,
  },
  {
    name: "Pināhat",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1259647,
  },
  {
    name: "Pimpri",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1259652,
  },
  {
    name: "Pilkhua",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1259680,
  },
  {
    name: "Pīlibhīt",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1259686,
  },
  {
    name: "Pilibangan",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1259688,
  },
  {
    name: "Pilāni",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1259693,
  },
  {
    name: "Pihānī",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1259701,
  },
  {
    name: "Phulpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1259735,
  },
  {
    name: "Phulera",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1259744,
  },
  {
    name: "Phulbāni",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1259756,
  },
  {
    name: "Phirangipuram",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1259773,
  },
  {
    name: "Phillaur",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1259775,
  },
  {
    name: "Phek",
    country: "India",
    subcountry: "Manipur",
    geonameid: 1259784,
  },
  {
    name: "Phaphūnd",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1259801,
  },
  {
    name: "Phaltan",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1259811,
  },
  {
    name: "Phalodi",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1259813,
  },
  {
    name: "Phalauda",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1259818,
  },
  {
    name: "Phagwāra",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1259827,
  },
  {
    name: "Petlād",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1259841,
  },
  {
    name: "Perundurai",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1259855,
  },
  {
    name: "Perumpāvūr",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1259857,
  },
  {
    name: "Periyanayakkanpalaiyam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1259878,
  },
  {
    name: "Periyakulam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1259879,
  },
  {
    name: "Peravurani",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1259890,
  },
  {
    name: "Peranāmpattu",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1259892,
  },
  {
    name: "Perambalur",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1259896,
  },
  {
    name: "Penukonda",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1259905,
  },
  {
    name: "Penugonda",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1259907,
  },
  {
    name: "Pennāgaram",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1259916,
  },
  {
    name: "Pennādam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1259917,
  },
  {
    name: "Pen",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1259931,
  },
  {
    name: "Pehowa",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1259939,
  },
  {
    name: "Peddāpuram",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1259954,
  },
  {
    name: "Peddapalli",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1259961,
  },
  {
    name: "Pedana",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1259986,
  },
  {
    name: "Payyannūr",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1259994,
  },
  {
    name: "Pawāyan",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1260003,
  },
  {
    name: "Pāvugada",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1260014,
  },
  {
    name: "Pauri",
    country: "India",
    subcountry: "Uttarakhand",
    geonameid: 1260016,
  },
  {
    name: "Pawni",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1260022,
  },
  {
    name: "Pātūr",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1260035,
  },
  {
    name: "Pattukkottai",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1260040,
  },
  {
    name: "Patti",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1260045,
  },
  {
    name: "Patnāgarh",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1260082,
  },
  {
    name: "Patna",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1260086,
  },
  {
    name: "Patiāla",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1260107,
  },
  {
    name: "Pāthri",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1260120,
  },
  {
    name: "Patharia",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1260129,
  },
  {
    name: "Pāthardih",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1260134,
  },
  {
    name: "Pāthardi",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1260135,
  },
  {
    name: "Pathānkot",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1260137,
  },
  {
    name: "Pathanāmthitta",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1260138,
  },
  {
    name: "Pathalgaon",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1260141,
  },
  {
    name: "Pataudi",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1260156,
  },
  {
    name: "Patancheru",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1260168,
  },
  {
    name: "Pātan",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1260173,
  },
  {
    name: "Patāmundai",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1260178,
  },
  {
    name: "Pāsighāt",
    country: "India",
    subcountry: "Arunachal Pradesh",
    geonameid: 1260206,
  },
  {
    name: "Pasān",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1260210,
  },
  {
    name: "Parvatsar",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1260221,
  },
  {
    name: "Pārvatipuram",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1260222,
  },
  {
    name: "Partūr",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1260228,
  },
  {
    name: "Parola",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1260274,
  },
  {
    name: "Parli Vaijnāth",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1260290,
  },
  {
    name: "Parlākimidi",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1260296,
  },
  {
    name: "Pariyāpuram",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1260304,
  },
  {
    name: "Parīchhatgarh",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1260313,
  },
  {
    name: "Pārdi",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1260335,
  },
  {
    name: "Parbhani",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1260341,
  },
  {
    name: "Paravūr Tekkumbhāgam",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1260354,
  },
  {
    name: "Parāsia",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1260368,
  },
  {
    name: "Paramagudi",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1260387,
  },
  {
    name: "Parādīp Garh",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1260393,
  },
  {
    name: "Pāppinisshēri",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1260406,
  },
  {
    name: "Papanasam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1260417,
  },
  {
    name: "Pāonta Sāhib",
    country: "India",
    subcountry: "Himachal Pradesh",
    geonameid: 1260421,
  },
  {
    name: "Panvel",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1260434,
  },
  {
    name: "Panruti",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1260448,
  },
  {
    name: "Panna",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1260454,
  },
  {
    name: "Ponmana",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1260456,
  },
  {
    name: "Pānīpat",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1260476,
  },
  {
    name: "Pānihāti",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1260482,
  },
  {
    name: "Pandua",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1260527,
  },
  {
    name: "Pāndhurnā",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1260543,
  },
  {
    name: "Pandharpur",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1260546,
  },
  {
    name: "French Rocks",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1260553,
  },
  {
    name: "Panaji",
    country: "India",
    subcountry: "Goa",
    geonameid: 1260607,
  },
  {
    name: "Panāgar",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1260612,
  },
  {
    name: "Palwal",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1260637,
  },
  {
    name: "Pāloncha",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1260667,
  },
  {
    name: "Palani",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1260671,
  },
  {
    name: "Palmaner",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1260674,
  },
  {
    name: "Pallippatti",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1260681,
  },
  {
    name: "Pallikondai",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1260685,
  },
  {
    name: "Pallāvaram",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1260692,
  },
  {
    name: "Pallappatti",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1260694,
  },
  {
    name: "Palladam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1260697,
  },
  {
    name: "Pālkonda",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1260702,
  },
  {
    name: "Pālitāna",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1260707,
  },
  {
    name: "Paliā Kalān",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1260713,
  },
  {
    name: "Pāli",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1260716,
  },
  {
    name: "Pāli",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1260718,
  },
  {
    name: "Palakkad",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1260728,
  },
  {
    name: "Pālghar",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1260730,
  },
  {
    name: "Palera",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1260734,
  },
  {
    name: "Palāsa",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1260771,
  },
  {
    name: "Pālanpur",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1260777,
  },
  {
    name: "Pālakollu",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1260792,
  },
  {
    name: "Pālakkodu",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1260793,
  },
  {
    name: "Pakur",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1260824,
  },
  {
    name: "Pākāla",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1260830,
  },
  {
    name: "Paithan",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1260833,
  },
  {
    name: "Pahāsu",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1260868,
  },
  {
    name: "Padrauna",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1260909,
  },
  {
    name: "Padra",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1260911,
  },
  {
    name: "Padmanābhapuram",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1260918,
  },
  {
    name: "Padampur",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1260938,
  },
  {
    name: "Padampur",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1260940,
  },
  {
    name: "Padam",
    country: "India",
    subcountry: "Ladakh",
    geonameid: 1260942,
  },
  {
    name: "Pachperwa",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1260954,
  },
  {
    name: "Pāchora",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1260959,
  },
  {
    name: "Ottappālam",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1261008,
  },
  {
    name: "Dharashiv",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1261012,
  },
  {
    name: "Orai",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1261039,
  },
  {
    name: "Ongole",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1261045,
  },
  {
    name: "Okha",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1261066,
  },
  {
    name: "Ozar",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1261068,
  },
  {
    name: "Obra",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1261086,
  },
  {
    name: "Nūzvīd",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1261110,
  },
  {
    name: "Nūrpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1261122,
  },
  {
    name: "Nowrangapur",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1261162,
  },
  {
    name: "North Lakhimpur",
    country: "India",
    subcountry: "Assam",
    geonameid: 1261181,
  },
  {
    name: "North Guwāhāti",
    country: "India",
    subcountry: "Assam",
    geonameid: 1261186,
  },
  {
    name: "Nongstoin",
    country: "India",
    subcountry: "Meghalaya",
    geonameid: 1261205,
  },
  {
    name: "Nokha",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1261227,
  },
  {
    name: "Nohar",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1261234,
  },
  {
    name: "Noāmundi",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1261242,
  },
  {
    name: "Nizāmābād",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1261258,
  },
  {
    name: "Nirmāli",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1261285,
  },
  {
    name: "Nirmal",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1261288,
  },
  {
    name: "Nipāni",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1261309,
  },
  {
    name: "Neem ka Thana",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1261342,
  },
  {
    name: "Nīmbāhera",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1261369,
  },
  {
    name: "Nimāparha",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1261375,
  },
  {
    name: "Nīmāj",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1261378,
  },
  {
    name: "Nīlokheri",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1261382,
  },
  {
    name: "Nīlēshwar",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1261394,
  },
  {
    name: "Nilanga",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1261396,
  },
  {
    name: "Nilakottai",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1261401,
  },
  {
    name: "Nīlgiri",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1261402,
  },
  {
    name: "Nihtaur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1261415,
  },
  {
    name: "Nidadavole",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1261446,
  },
  {
    name: "Nichlaul",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1261451,
  },
  {
    name: "Neyyāttinkara",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1261470,
  },
  {
    name: "Neyveli",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1261473,
  },
  {
    name: "New Delhi",
    country: "India",
    subcountry: "Delhi",
    geonameid: 1261481,
  },
  {
    name: "Neral",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1261512,
  },
  {
    name: "Nepānagar",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1261517,
  },
  {
    name: "Nellore",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1261529,
  },
  {
    name: "Nellikkuppam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1261532,
  },
  {
    name: "Nelamangala",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1261539,
  },
  {
    name: "Nedumangād",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1261553,
  },
  {
    name: "Nāyudupet",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1261567,
  },
  {
    name: "Nayāgarh",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1261580,
  },
  {
    name: "Nawanshahr",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1261598,
  },
  {
    name: "Nawalgarh",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1261613,
  },
  {
    name: "Niwai",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1261614,
  },
  {
    name: "Nawāda",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1261631,
  },
  {
    name: "Nawābganj",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1261639,
  },
  {
    name: "Nawābganj",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1261641,
  },
  {
    name: "Nawābganj",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1261642,
  },
  {
    name: "Nāwa",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1261647,
  },
  {
    name: "Navsari",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1261653,
  },
  {
    name: "Navalgund",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1261667,
  },
  {
    name: "Navadwīp",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1261669,
  },
  {
    name: "Nautanwa",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1261672,
  },
  {
    name: "Naugachhia",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1261696,
  },
  {
    name: "Nattam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1261705,
  },
  {
    name: "Nāthdwāra",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1261711,
  },
  {
    name: "Nasrullāhganj",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1261721,
  },
  {
    name: "Nāsriganj",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1261722,
  },
  {
    name: "Nāspur",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1261726,
  },
  {
    name: "Nasīrābād",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1261727,
  },
  {
    name: "Nashik",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1261731,
  },
  {
    name: "Narwar",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1261736,
  },
  {
    name: "Narwāna",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1261739,
  },
  {
    name: "Narsīpatnam",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1261748,
  },
  {
    name: "Narsinghgarh",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1261752,
  },
  {
    name: "Narsimhapur",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1261754,
  },
  {
    name: "Nārnaund",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1261771,
  },
  {
    name: "Nārnaul",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1261772,
  },
  {
    name: "Nargund",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1261800,
  },
  {
    name: "Narela",
    country: "India",
    subcountry: "Delhi",
    geonameid: 1261809,
  },
  {
    name: "Naregal",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1261810,
  },
  {
    name: "Nārāyanpet",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1261823,
  },
  {
    name: "Narāyangarh",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1261828,
  },
  {
    name: "Nāravārikuppam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1261835,
  },
  {
    name: "Naraura",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1261837,
  },
  {
    name: "Narauli",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1261839,
  },
  {
    name: "Narasaraopet",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1261848,
  },
  {
    name: "Narasapur",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1261852,
  },
  {
    name: "Narasannapeta",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1261853,
  },
  {
    name: "Naraini",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1261871,
  },
  {
    name: "Naraina",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1261872,
  },
  {
    name: "Napāsar",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1261882,
  },
  {
    name: "Nānpāra",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1261901,
  },
  {
    name: "Nanjangūd",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1261910,
  },
  {
    name: "Nāngloi Jāt",
    country: "India",
    subcountry: "Delhi",
    geonameid: 1261913,
  },
  {
    name: "Nangal",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1261922,
  },
  {
    name: "Nandyāl",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1261927,
  },
  {
    name: "Nandurbar",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1261931,
  },
  {
    name: "Nāndūra Buzurg",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1261932,
  },
  {
    name: "Nandikotkūr",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1261957,
  },
  {
    name: "Nandigāma",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1261960,
  },
  {
    name: "Nāndgaon",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1261971,
  },
  {
    name: "Nanded",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1261977,
  },
  {
    name: "Nanauta",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1261998,
  },
  {
    name: "Nāmrup",
    country: "India",
    subcountry: "Assam",
    geonameid: 1262013,
  },
  {
    name: "Nambiyūr",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1262034,
  },
  {
    name: "Nāmakkal",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1262039,
  },
  {
    name: "Nāmagiripettai",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1262040,
  },
  {
    name: "Nalhāti",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1262065,
  },
  {
    name: "Nalgonda",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1262067,
  },
  {
    name: "Naldurg",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1262073,
  },
  {
    name: "Nakūr",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1262089,
  },
  {
    name: "Naksalbāri",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1262092,
  },
  {
    name: "Nakodar",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1262097,
  },
  {
    name: "Najībābād",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1262109,
  },
  {
    name: "Najafgarh",
    country: "India",
    subcountry: "Delhi",
    geonameid: 1262111,
  },
  {
    name: "Nainwa",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1262115,
  },
  {
    name: "Nainpur",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1262116,
  },
  {
    name: "Naini Tāl",
    country: "India",
    subcountry: "Uttarakhand",
    geonameid: 1262117,
  },
  {
    name: "Naihāti",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1262131,
  },
  {
    name: "Nahorkatiya",
    country: "India",
    subcountry: "Assam",
    geonameid: 1262140,
  },
  {
    name: "Nāhan",
    country: "India",
    subcountry: "Himachal Pradesh",
    geonameid: 1262151,
  },
  {
    name: "Nagpur",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1262180,
  },
  {
    name: "Nāgod",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1262187,
  },
  {
    name: "Nagīna",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1262200,
  },
  {
    name: "Nāgercoil",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1262204,
  },
  {
    name: "Nagda",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1262209,
  },
  {
    name: "Nāgaur",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1262216,
  },
  {
    name: "Nāgar Karnūl",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1262230,
  },
  {
    name: "Nagari",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1262240,
  },
  {
    name: "Nagar",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1262253,
  },
  {
    name: "Negapatam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1262260,
  },
  {
    name: "Nāgamangala",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1262266,
  },
  {
    name: "Naduvannūr",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1262285,
  },
  {
    name: "Nadiād",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1262292,
  },
  {
    name: "Nādbai",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1262296,
  },
  {
    name: "Nādāpuram",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1262302,
  },
  {
    name: "Nabīnagar",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1262318,
  },
  {
    name: "Nābha",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1262319,
  },
  {
    name: "Mysore",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1262321,
  },
  {
    name: "Muzaffarpur",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1262330,
  },
  {
    name: "Muzaffarnagar",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1262332,
  },
  {
    name: "Mūvattupula",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1262338,
  },
  {
    name: "Muttupet",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1262346,
  },
  {
    name: "Mussoorie",
    country: "India",
    subcountry: "Uttarakhand",
    geonameid: 1262374,
  },
  {
    name: "Musiri",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1262380,
  },
  {
    name: "Mushābani",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1262382,
  },
  {
    name: "Murwāra",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1262395,
  },
  {
    name: "Murtajāpur",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1262410,
  },
  {
    name: "Murshidābād",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1262412,
  },
  {
    name: "Murlīganj",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1262419,
  },
  {
    name: "Morinda",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1262426,
  },
  {
    name: "Murbād",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1262444,
  },
  {
    name: "Murādnagar",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1262453,
  },
  {
    name: "Munnar",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1262463,
  },
  {
    name: "Monghyr",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1262482,
  },
  {
    name: "Mungeli",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1262484,
  },
  {
    name: "Mungaoli",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1262485,
  },
  {
    name: "Mūndwa",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1262491,
  },
  {
    name: "Mundra",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1262497,
  },
  {
    name: "Mundgod",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1262510,
  },
  {
    name: "Mundargi",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1262516,
  },
  {
    name: "Multai",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1262534,
  },
  {
    name: "Mūlki",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1262546,
  },
  {
    name: "Mulgund",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1262553,
  },
  {
    name: "Mulbāgal",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1262562,
  },
  {
    name: "Muluppilagadu",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1262566,
  },
  {
    name: "Mūl",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1262574,
  },
  {
    name: "Muktsar",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1262578,
  },
  {
    name: "Mukher",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1262591,
  },
  {
    name: "Mukeriān",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1262596,
  },
  {
    name: "Muhammadābād",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1262624,
  },
  {
    name: "Muhammadābād",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1262625,
  },
  {
    name: "Muhammadābād",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1262626,
  },
  {
    name: "Mughal Sarāi",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1262634,
  },
  {
    name: "Mudkhed",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1262651,
  },
  {
    name: "Mudhol",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1262663,
  },
  {
    name: "Mudgal",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1262664,
  },
  {
    name: "Muddebihāl",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1262669,
  },
  {
    name: "Mūdbidri",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1262672,
  },
  {
    name: "Mubarakpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1262678,
  },
  {
    name: "Mothīhāri",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1262710,
  },
  {
    name: "Morwa",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1262734,
  },
  {
    name: "Morsi",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1262740,
  },
  {
    name: "Morena",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1262771,
  },
  {
    name: "Morbi",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1262775,
  },
  {
    name: "Morār",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1262783,
  },
  {
    name: "Moram",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1262794,
  },
  {
    name: "Morādābād",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1262801,
  },
  {
    name: "Mon",
    country: "India",
    subcountry: "Nagaland",
    geonameid: 1262824,
  },
  {
    name: "Mokokchūng",
    country: "India",
    subcountry: "Nagaland",
    geonameid: 1262843,
  },
  {
    name: "Mokameh",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1262852,
  },
  {
    name: "Moirāng",
    country: "India",
    subcountry: "Manipur",
    geonameid: 1262863,
  },
  {
    name: "Moga",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1262951,
  },
  {
    name: "Modāsa",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1262958,
  },
  {
    name: "Misrikh",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1262988,
  },
  {
    name: "Mirzāpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1262995,
  },
  {
    name: "Miriālgūda",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1263012,
  },
  {
    name: "Mīrganj",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1263015,
  },
  {
    name: "Mīrānpur Katra",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1263021,
  },
  {
    name: "Mīrānpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1263022,
  },
  {
    name: "Mīnjūr",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1263034,
  },
  {
    name: "Milak",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1263051,
  },
  {
    name: "Mihona",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1263057,
  },
  {
    name: "Mhāsvād",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1263083,
  },
  {
    name: "Mettur",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1263101,
  },
  {
    name: "Mettupalayam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1263103,
  },
  {
    name: "Merta",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1263120,
  },
  {
    name: "Mendarda",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1263142,
  },
  {
    name: "Memāri",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1263148,
  },
  {
    name: "Melur",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1263151,
  },
  {
    name: "Mehndāwal",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1263185,
  },
  {
    name: "Mehkar",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1263195,
  },
  {
    name: "Meerut",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1263214,
  },
  {
    name: "Medinīpur",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1263220,
  },
  {
    name: "Medak",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1263230,
  },
  {
    name: "Mayiladuthurai",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1263247,
  },
  {
    name: "Mayāng Imphāl",
    country: "India",
    subcountry: "Manipur",
    geonameid: 1263255,
  },
  {
    name: "Mawāna",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1263275,
  },
  {
    name: "Mavoor",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1263280,
  },
  {
    name: "Māvelikara",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1263285,
  },
  {
    name: "Maur",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1263293,
  },
  {
    name: "Mauganj",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1263300,
  },
  {
    name: "Maudaha",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1263303,
  },
  {
    name: "Mau Aimma",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1263306,
  },
  {
    name: "Mau",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1263309,
  },
  {
    name: "Mau",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1263311,
  },
  {
    name: "Mattanur",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1263331,
  },
  {
    name: "Mathura",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1263364,
  },
  {
    name: "Mātābhānga",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1263395,
  },
  {
    name: "Masaurhi Buzurg",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1263427,
  },
  {
    name: "Mormugao",
    country: "India",
    subcountry: "Goa",
    geonameid: 1263494,
  },
  {
    name: "Mārkāpur",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1263504,
  },
  {
    name: "Mariāni",
    country: "India",
    subcountry: "Assam",
    geonameid: 1263522,
  },
  {
    name: "Mariāhu",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1263523,
  },
  {
    name: "Marhaura",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1263528,
  },
  {
    name: "Margherita",
    country: "India",
    subcountry: "Assam",
    geonameid: 1263532,
  },
  {
    name: "Marakkanam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1263564,
  },
  {
    name: "Marayur",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1263566,
  },
  {
    name: "Mārahra",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1263567,
  },
  {
    name: "Māpuca",
    country: "India",
    subcountry: "Goa",
    geonameid: 1263580,
  },
  {
    name: "Mānwat",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1263591,
  },
  {
    name: "Mānvi",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1263594,
  },
  {
    name: "Manthani",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1263610,
  },
  {
    name: "Mānsa",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1263622,
  },
  {
    name: "Mānsa",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1263623,
  },
  {
    name: "Manoharpur",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1263649,
  },
  {
    name: "Mannargudi",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1263659,
  },
  {
    name: "Mannārakkāt",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1263661,
  },
  {
    name: "Manmād",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1263664,
  },
  {
    name: "Mankāchar",
    country: "India",
    subcountry: "Meghalaya",
    geonameid: 1263678,
  },
  {
    name: "Majalgaon",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1263684,
  },
  {
    name: "Manjhanpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1263691,
  },
  {
    name: "Manjeri",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1263694,
  },
  {
    name: "Manipal",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1263707,
  },
  {
    name: "Manihāri",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1263723,
  },
  {
    name: "Maniar",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1263730,
  },
  {
    name: "Mangrūl Pīr",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1263744,
  },
  {
    name: "Māngrol",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1263751,
  },
  {
    name: "Māngrol",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1263752,
  },
  {
    name: "Manglaur",
    country: "India",
    subcountry: "Uttarakhand",
    geonameid: 1263761,
  },
  {
    name: "Mangalore",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1263780,
  },
  {
    name: "Mangaldai",
    country: "India",
    subcountry: "Assam",
    geonameid: 1263787,
  },
  {
    name: "Mangalagiri",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1263797,
  },
  {
    name: "Maner",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1263807,
  },
  {
    name: "Mandya",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1263814,
  },
  {
    name: "Māndvi",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1263824,
  },
  {
    name: "Māndvi",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1263826,
  },
  {
    name: "Mandsaur",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1263834,
  },
  {
    name: "Mandlā",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1263852,
  },
  {
    name: "Mandi",
    country: "India",
    subcountry: "Himachal Pradesh",
    geonameid: 1263862,
  },
  {
    name: "Mandāwar",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1263879,
  },
  {
    name: "Mandapeta",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1263898,
  },
  {
    name: "Mandapam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1263900,
  },
  {
    name: "Māndalgarh",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1263911,
  },
  {
    name: "Māndal",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1263917,
  },
  {
    name: "Mancherāl",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1263936,
  },
  {
    name: "Manāwar",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1263940,
  },
  {
    name: "Mānāvadar",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1263943,
  },
  {
    name: "Manāsa",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1263949,
  },
  {
    name: "Manapparai",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1263952,
  },
  {
    name: "Manamadurai",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1263965,
  },
  {
    name: "Manali",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1263968,
  },
  {
    name: "Mālvan",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1264007,
  },
  {
    name: "Mālūr",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1264010,
  },
  {
    name: "Mālpura",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1264032,
  },
  {
    name: "Malpe",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1264037,
  },
  {
    name: "Mallasamudram",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1264047,
  },
  {
    name: "Malkāpur",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1264071,
  },
  {
    name: "Malakanagiri",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1264075,
  },
  {
    name: "Malīhābād",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1264085,
  },
  {
    name: "Māler Kotla",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1264111,
  },
  {
    name: "Mālegaon",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1264115,
  },
  {
    name: "Malavalli",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1264136,
  },
  {
    name: "Malaut",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1264138,
  },
  {
    name: "Malappuram",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1264154,
  },
  {
    name: "Mākum",
    country: "India",
    subcountry: "Assam",
    geonameid: 1264196,
  },
  {
    name: "Maksi",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1264198,
  },
  {
    name: "Makrāna",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1264206,
  },
  {
    name: "Mairwa",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1264282,
  },
  {
    name: "Mainpuri",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1264292,
  },
  {
    name: "Maināguri",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1264301,
  },
  {
    name: "Maihar",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1264317,
  },
  {
    name: "Mahwah",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1264323,
  },
  {
    name: "Mahudha",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1264344,
  },
  {
    name: "Maholi",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1264356,
  },
  {
    name: "Mahobā",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1264359,
  },
  {
    name: "Mahmudābād",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1264363,
  },
  {
    name: "Mahīshādal",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1264368,
  },
  {
    name: "Mahgawān",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1264383,
  },
  {
    name: "Maheshwar",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1264385,
  },
  {
    name: "Mahendragarh",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1264395,
  },
  {
    name: "Mahemdāvād",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1264398,
  },
  {
    name: "Mahē",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1264403,
  },
  {
    name: "Mahbūbnagar",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1264407,
  },
  {
    name: "Mahbūbābād",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1264409,
  },
  {
    name: "Mahāsamund",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1264414,
  },
  {
    name: "Mahārāganj",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1264433,
  },
  {
    name: "Mahārājgani",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1264436,
  },
  {
    name: "Maham",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1264455,
  },
  {
    name: "Mahālingpur",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1264457,
  },
  {
    name: "Mahād",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1264489,
  },
  {
    name: "Maghar",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1264504,
  },
  {
    name: "Māgadi",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1264514,
  },
  {
    name: "Madurāntakam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1264520,
  },
  {
    name: "Madurai",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1264521,
  },
  {
    name: "Madukkūr",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1264523,
  },
  {
    name: "Madukkarai",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1264524,
  },
  {
    name: "Chennai",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1264527,
  },
  {
    name: "Madikeri",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1264540,
  },
  {
    name: "Madhyamgram",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1264543,
  },
  {
    name: "Madhupur",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1264551,
  },
  {
    name: "Madhugiri",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1264553,
  },
  {
    name: "Madhubani",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1264555,
  },
  {
    name: "Madhipura",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1264570,
  },
  {
    name: "Madgaon",
    country: "India",
    subcountry: "Goa",
    geonameid: 1264588,
  },
  {
    name: "Maddūr",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1264592,
  },
  {
    name: "Madanapalle",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1264621,
  },
  {
    name: "Machilīpatnam",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1264637,
  },
  {
    name: "Machhlīshahr",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1264643,
  },
  {
    name: "Māchhīwāra",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1264644,
  },
  {
    name: "Mācherla",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1264647,
  },
  {
    name: "Lunglei",
    country: "India",
    subcountry: "Mizoram",
    geonameid: 1264688,
  },
  {
    name: "Lūnāvāda",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1264700,
  },
  {
    name: "Ludhiāna",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1264728,
  },
  {
    name: "Lucknow",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1264733,
  },
  {
    name: "Luckeesarai",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1264735,
  },
  {
    name: "Losal",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1264756,
  },
  {
    name: "Loni",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1264773,
  },
  {
    name: "Lonavla",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1264793,
  },
  {
    name: "Lonar",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1264794,
  },
  {
    name: "Lohārdagā",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1264839,
  },
  {
    name: "Lingsugūr",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1264890,
  },
  {
    name: "Limbdi",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1264912,
  },
  {
    name: "Leteri",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1264949,
  },
  {
    name: "Leh",
    country: "India",
    subcountry: "Ladakh",
    geonameid: 1264976,
  },
  {
    name: "Lāwar Khās",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1264989,
  },
  {
    name: "Laungowāl",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1265007,
  },
  {
    name: "Latur",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1265014,
  },
  {
    name: "Lāthi",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1265022,
  },
  {
    name: "Lātehār",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1265025,
  },
  {
    name: "Lar",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1265053,
  },
  {
    name: "Lālsot",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1265143,
  },
  {
    name: "Lālpur",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1265150,
  },
  {
    name: "Lalitpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1265157,
  },
  {
    name: "Lalgudi",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1265163,
  },
  {
    name: "Lālgola",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1265166,
  },
  {
    name: "Lālganj",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1265169,
  },
  {
    name: "Lālganj",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1265170,
  },
  {
    name: "Lakshmeshwar",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1265201,
  },
  {
    name: "Laksar",
    country: "India",
    subcountry: "Uttarakhand",
    geonameid: 1265208,
  },
  {
    name: "Lakhyabad",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1265220,
  },
  {
    name: "Lakhnādon",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1265233,
  },
  {
    name: "Lakhīmpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1265242,
  },
  {
    name: "Lākheri",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1265246,
  },
  {
    name: "Lāharpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1265310,
  },
  {
    name: "Lahār",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1265311,
  },
  {
    name: "Lādwa",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1265323,
  },
  {
    name: "Lādnūn",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1265331,
  },
  {
    name: "Lachhmangarh Sīkar",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1265354,
  },
  {
    name: "Kuzhithurai",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1265387,
  },
  {
    name: "Koothanallur",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1265400,
  },
  {
    name: "Kuttampuzha",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1265401,
  },
  {
    name: "Kutiyāna",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1265415,
  },
  {
    name: "Kutiatodu",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1265418,
  },
  {
    name: "Kushtagi",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1265446,
  },
  {
    name: "Kurnool",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1265491,
  },
  {
    name: "Kurinjippādi",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1265504,
  },
  {
    name: "Kurduvādi",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1265521,
  },
  {
    name: "Kurandvād",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1265539,
  },
  {
    name: "Kuppam",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1265555,
  },
  {
    name: "Kunnamkulam",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1265579,
  },
  {
    name: "Kunnamangalam",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1265580,
  },
  {
    name: "Kunigal",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1265591,
  },
  {
    name: "Kundla",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1265605,
  },
  {
    name: "Kundgol",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1265607,
  },
  {
    name: "Kundarkhi",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1265613,
  },
  {
    name: "Kunda",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1265632,
  },
  {
    name: "Kumta",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1265645,
  },
  {
    name: "Kūmher",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1265655,
  },
  {
    name: "Kumhāri",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1265660,
  },
  {
    name: "Kumbhrāj",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1265670,
  },
  {
    name: "Kumbakonam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1265683,
  },
  {
    name: "Kulu",
    country: "India",
    subcountry: "Himachal Pradesh",
    geonameid: 1265709,
  },
  {
    name: "Kulti",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1265711,
  },
  {
    name: "Kulpahār",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1265716,
  },
  {
    name: "Kulittalai",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1265723,
  },
  {
    name: "Kulgam",
    country: "India",
    subcountry: "Jammu and Kashmir",
    geonameid: 1265734,
  },
  {
    name: "Kukshi",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1265752,
  },
  {
    name: "Kūkatpalli",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1265767,
  },
  {
    name: "Kuju",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1265773,
  },
  {
    name: "Kūdligi",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1265795,
  },
  {
    name: "Kudachi",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1265811,
  },
  {
    name: "Kuchera",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1265821,
  },
  {
    name: "Kuchāman",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1265828,
  },
  {
    name: "Kuchaiburi",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1265830,
  },
  {
    name: "Krishnarājpet",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1265852,
  },
  {
    name: "Krishnanagar",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1265859,
  },
  {
    name: "Krishnagiri",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1265863,
  },
  {
    name: "Kozhikode",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1265873,
  },
  {
    name: "Koynanagar",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1265881,
  },
  {
    name: "Kovvūr",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1265886,
  },
  {
    name: "Kovūr",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1265888,
  },
  {
    name: "Kovilpatti",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1265891,
  },
  {
    name: "Kottūru",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1265905,
  },
  {
    name: "Kottayam",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1265911,
  },
  {
    name: "Kottagūdem",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1265938,
  },
  {
    name: "Kotputli",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1265961,
  },
  {
    name: "Kotma",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1265964,
  },
  {
    name: "Kotdwāra",
    country: "India",
    subcountry: "Uttarakhand",
    geonameid: 1266014,
  },
  {
    name: "Kotapārh",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1266029,
  },
  {
    name: "Kotamangalam",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1266031,
  },
  {
    name: "Kotagiri",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1266038,
  },
  {
    name: "Kota",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1266049,
  },
  {
    name: "Kotā",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1266051,
  },
  {
    name: "Kosigi",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1266070,
  },
  {
    name: "Kosi",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1266073,
  },
  {
    name: "Kosamba",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1266087,
  },
  {
    name: "Korwai",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1266092,
  },
  {
    name: "Koregaon",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1266116,
  },
  {
    name: "Korba",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1266122,
  },
  {
    name: "Koratla",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1266124,
  },
  {
    name: "Korāput",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1266128,
  },
  {
    name: "Koppal",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1266154,
  },
  {
    name: "Kopargaon",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1266162,
  },
  {
    name: "Kopāganj",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1266164,
  },
  {
    name: "Konnūr",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1266178,
  },
  {
    name: "Konnagar",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1266179,
  },
  {
    name: "Kondapalle",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1266209,
  },
  {
    name: "Kondagaon",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1266216,
  },
  {
    name: "Konch",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1266217,
  },
  {
    name: "Konārka",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1266220,
  },
  {
    name: "Kolasib",
    country: "India",
    subcountry: "Mizoram",
    geonameid: 1266258,
  },
  {
    name: "Kollegāl",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1266267,
  },
  {
    name: "Kolhāpur",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1266285,
  },
  {
    name: "Kolāras",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1266302,
  },
  {
    name: "Kolār",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1266305,
  },
  {
    name: "Colachel",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1266322,
  },
  {
    name: "Kokrajhar",
    country: "India",
    subcountry: "Assam",
    geonameid: 1266330,
  },
  {
    name: "Kohīma",
    country: "India",
    subcountry: "Nagaland",
    geonameid: 1266366,
  },
  {
    name: "Koelwār",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1266372,
  },
  {
    name: "Kodungallūr",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1266385,
  },
  {
    name: "Kodoli",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1266390,
  },
  {
    name: "Kodīnar",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1266397,
  },
  {
    name: "Kodarmā",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1266414,
  },
  {
    name: "Kodār",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1266416,
  },
  {
    name: "Kodaikānāl",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1266425,
  },
  {
    name: "Koch Bihār",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1266436,
  },
  {
    name: "Koāth",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1266448,
  },
  {
    name: "Kizhake Chālakudi",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1266452,
  },
  {
    name: "Kithor",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1266461,
  },
  {
    name: "Kishtwār",
    country: "India",
    subcountry: "Jammu and Kashmir",
    geonameid: 1266475,
  },
  {
    name: "Kishangarh",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1266486,
  },
  {
    name: "Kishanganj",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1266489,
  },
  {
    name: "Kīratpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1266509,
  },
  {
    name: "Kiraoli",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1266510,
  },
  {
    name: "Kinwat",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1266518,
  },
  {
    name: "Kichha",
    country: "India",
    subcountry: "Uttarakhand",
    geonameid: 1266575,
  },
  {
    name: "Khūtār",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1266596,
  },
  {
    name: "Khurja",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1266607,
  },
  {
    name: "Khurda",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1266616,
  },
  {
    name: "Khurai",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1266620,
  },
  {
    name: "Khunti",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1266622,
  },
  {
    name: "Khuldābād",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1266631,
  },
  {
    name: "Khowai",
    country: "India",
    subcountry: "Tripura",
    geonameid: 1266649,
  },
  {
    name: "Khopoli",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1266666,
  },
  {
    name: "Khirkiyān",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1266710,
  },
  {
    name: "Khilchipur",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1266731,
  },
  {
    name: "Khetri",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1266744,
  },
  {
    name: "Khetia",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1266746,
  },
  {
    name: "Kheri",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1266762,
  },
  {
    name: "Kherālu",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1266774,
  },
  {
    name: "Khekra",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1266794,
  },
  {
    name: "Khedbrahma",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1266806,
  },
  {
    name: "Kheda",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1266809,
  },
  {
    name: "Khātra",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1266838,
  },
  {
    name: "Khatīma",
    country: "India",
    subcountry: "Uttarakhand",
    geonameid: 1266843,
  },
  {
    name: "Khātegaon",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1266847,
  },
  {
    name: "Khatauli",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1266849,
  },
  {
    name: "Khārupatia",
    country: "India",
    subcountry: "Assam",
    geonameid: 1266862,
  },
  {
    name: "Kharsia",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1266872,
  },
  {
    name: "Kharkhauda",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1266891,
  },
  {
    name: "Khargone",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1266928,
  },
  {
    name: "Khardah",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1266945,
  },
  {
    name: "Kharar",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1266960,
  },
  {
    name: "Kharakvasla",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1266966,
  },
  {
    name: "Kharagpur",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1266975,
  },
  {
    name: "Kharagpur",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1266976,
  },
  {
    name: "Khāpa",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1267006,
  },
  {
    name: "Khanna",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1267016,
  },
  {
    name: "Khandwa",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1267031,
  },
  {
    name: "Khandela",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1267044,
  },
  {
    name: "Khānāpur",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1267065,
  },
  {
    name: "Khammam",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1267076,
  },
  {
    name: "Khāmgaon",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1267084,
  },
  {
    name: "Khambhāt",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1267090,
  },
  {
    name: "Khambhāliya",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1267091,
  },
  {
    name: "Khamaria",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1267097,
  },
  {
    name: "Khalīlābād",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1267115,
  },
  {
    name: "Khajuraho Group of Monuments",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1267154,
  },
  {
    name: "Khairāgarh",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1267173,
  },
  {
    name: "Khairāgarh",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1267174,
  },
  {
    name: "Khairābād",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1267175,
  },
  {
    name: "Khair",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1267182,
  },
  {
    name: "Khagaul",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1267187,
  },
  {
    name: "Khagaria",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1267189,
  },
  {
    name: "Khadki",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1267195,
  },
  {
    name: "Khada",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1267202,
  },
  {
    name: "Khāchrod",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1267203,
  },
  {
    name: "Kesinga",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1267222,
  },
  {
    name: "Keshorai Pātan",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1267226,
  },
  {
    name: "Keshod",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1267227,
  },
  {
    name: "Kerūr",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1267239,
  },
  {
    name: "Kendrāparha",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1267283,
  },
  {
    name: "Kenda",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1267290,
  },
  {
    name: "Kemrī",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1267297,
  },
  {
    name: "Kekri",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1267336,
  },
  {
    name: "Kāyankulam",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1267360,
  },
  {
    name: "Kayalpattinam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1267361,
  },
  {
    name: "Kawardha",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1267369,
  },
  {
    name: "Kāvali",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1267394,
  },
  {
    name: "Kattivākkam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1267433,
  },
  {
    name: "Kattanam",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1267435,
  },
  {
    name: "Kātrās",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1267439,
  },
  {
    name: "Kātpādi",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1267456,
  },
  {
    name: "Kātoya",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1267457,
  },
  {
    name: "Kātol",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1267461,
  },
  {
    name: "Katihar",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1267480,
  },
  {
    name: "Kathua",
    country: "India",
    subcountry: "Jammu and Kashmir",
    geonameid: 1267486,
  },
  {
    name: "Kāthor",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1267492,
  },
  {
    name: "Katghora",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1267517,
  },
  {
    name: "Katangi",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1267537,
  },
  {
    name: "Katangi",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1267538,
  },
  {
    name: "Kasrāwad",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1267558,
  },
  {
    name: "Kashipur",
    country: "India",
    subcountry: "Uttarakhand",
    geonameid: 1267579,
  },
  {
    name: "Kāsganj",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1267588,
  },
  {
    name: "Kāsaragod",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1267616,
  },
  {
    name: "Karwar",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1267635,
  },
  {
    name: "Karur",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1267648,
  },
  {
    name: "Kartārpur",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1267669,
  },
  {
    name: "Kārsiyāng",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1267675,
  },
  {
    name: "Karol Bāgh",
    country: "India",
    subcountry: "Delhi",
    geonameid: 1267696,
  },
  {
    name: "Karnāl",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1267708,
  },
  {
    name: "Karmāla",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1267716,
  },
  {
    name: "Kārkala",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1267739,
  },
  {
    name: "Karjat",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1267742,
  },
  {
    name: "Karīmnagar",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1267755,
  },
  {
    name: "Karīmganj",
    country: "India",
    subcountry: "Assam",
    geonameid: 1267758,
  },
  {
    name: "Karhal",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1267772,
  },
  {
    name: "Karera",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1267786,
  },
  {
    name: "Kareli",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1267794,
  },
  {
    name: "Karauli",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1267819,
  },
  {
    name: "Kāranja",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1267853,
  },
  {
    name: "Karamsad",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1267862,
  },
  {
    name: "Kāramadai",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1267869,
  },
  {
    name: "Kāraikkudi",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1267885,
  },
  {
    name: "Kāraikāl",
    country: "India",
    subcountry: "Puducherry",
    geonameid: 1267887,
  },
  {
    name: "Karād",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1267904,
  },
  {
    name: "Kapūrthala",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1267911,
  },
  {
    name: "Kāpren",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1267923,
  },
  {
    name: "Kapadvanj",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1267939,
  },
  {
    name: "Kānth",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1267972,
  },
  {
    name: "Kantābānji",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1267978,
  },
  {
    name: "Kānt",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1267979,
  },
  {
    name: "Kanpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1267995,
  },
  {
    name: "Kannod",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1268007,
  },
  {
    name: "Kanniyākumāri",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1268008,
  },
  {
    name: "Kannauj",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1268011,
  },
  {
    name: "Kānnangād",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1268015,
  },
  {
    name: "Kannad",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1268020,
  },
  {
    name: "Kānker",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1268031,
  },
  {
    name: "Kānke",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1268032,
  },
  {
    name: "Kankauli",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1268035,
  },
  {
    name: "Kanigiri",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1268059,
  },
  {
    name: "Kangayam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1268095,
  },
  {
    name: "Kandukūr",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1268111,
  },
  {
    name: "Kāndla",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1268124,
  },
  {
    name: "Kāndi",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1268135,
  },
  {
    name: "Kāndhla",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1268138,
  },
  {
    name: "Kanchipuram",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1268159,
  },
  {
    name: "Kānkānhalli",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1268189,
  },
  {
    name: "Kāmthi",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1268205,
  },
  {
    name: "Kampli",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1268214,
  },
  {
    name: "Cumbum",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1268246,
  },
  {
    name: "Kāmārhāti",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1268257,
  },
  {
    name: "Kāmāreddi",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1268259,
  },
  {
    name: "Kāman",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1268266,
  },
  {
    name: "Kamalganj",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1268276,
  },
  {
    name: "Kāmākhyānagar",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1268279,
  },
  {
    name: "Kalyani",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1268293,
  },
  {
    name: "Kalyān",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1268295,
  },
  {
    name: "Kalugumalai",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1268310,
  },
  {
    name: "Kālpi",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1268325,
  },
  {
    name: "Kalpatta",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1268327,
  },
  {
    name: "Kālol",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1268339,
  },
  {
    name: "Kālna",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1268341,
  },
  {
    name: "Kalmeshwar",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1268344,
  },
  {
    name: "Kallidaikurichi",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1268360,
  },
  {
    name: "Kallakkurichchi",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1268376,
  },
  {
    name: "Kālka",
    country: "India",
    subcountry: "Himachal Pradesh",
    geonameid: 1268381,
  },
  {
    name: "Kāliyāganj",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1268383,
  },
  {
    name: "Kālimpong",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1268403,
  },
  {
    name: "Kalghatgi",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1268434,
  },
  {
    name: "Kālāvad",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1268450,
  },
  {
    name: "Kālānwāli",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1268469,
  },
  {
    name: "Kalānaur",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1268476,
  },
  {
    name: "Kalamnūri",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1268480,
  },
  {
    name: "Kalamb",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1268484,
  },
  {
    name: "Kalakkādu",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1268495,
  },
  {
    name: "Kakrāla",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1268540,
  },
  {
    name: "Kākori",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1268545,
  },
  {
    name: "Kākināda",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1268561,
  },
  {
    name: "Kakdwip",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1268566,
  },
  {
    name: "Kakching",
    country: "India",
    subcountry: "Manipur",
    geonameid: 1268567,
  },
  {
    name: "Kaithal",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1268593,
  },
  {
    name: "Kairāna",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1268601,
  },
  {
    name: "Kaimori",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1268615,
  },
  {
    name: "Kaimganj",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1268616,
  },
  {
    name: "Kailāshahar",
    country: "India",
    subcountry: "Tripura",
    geonameid: 1268622,
  },
  {
    name: "Kailāras",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1268624,
  },
  {
    name: "Kaikalūr",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1268627,
  },
  {
    name: "Kāgal",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1268651,
  },
  {
    name: "Kadūr",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1268662,
  },
  {
    name: "Kadod",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1268667,
  },
  {
    name: "Kadiri",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1268673,
  },
  {
    name: "Kadi",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1268680,
  },
  {
    name: "Kadayanallur",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1268707,
  },
  {
    name: "Kānchrāpāra",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1268715,
  },
  {
    name: "Kachhwa",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1268722,
  },
  {
    name: "Kabrāi",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1268739,
  },
  {
    name: "Junnar",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1268761,
  },
  {
    name: "Jūnāgarh",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1268772,
  },
  {
    name: "Jūnāgadh",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1268773,
  },
  {
    name: "Jhumri Telaiya",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1268775,
  },
  {
    name: "Jalandhar",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1268782,
  },
  {
    name: "Jugsālai",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1268799,
  },
  {
    name: "Jorhāt",
    country: "India",
    subcountry: "Assam",
    geonameid: 1268820,
  },
  {
    name: "Jora",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1268823,
  },
  {
    name: "Jalārpet",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1268834,
  },
  {
    name: "Jogbani",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1268855,
  },
  {
    name: "Jodiya Bandar",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1268863,
  },
  {
    name: "Jodhpur",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1268865,
  },
  {
    name: "Jodhpur",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1268866,
  },
  {
    name: "Jintūr",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1268896,
  },
  {
    name: "Jīnd",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1268907,
  },
  {
    name: "Jhūsi",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1268929,
  },
  {
    name: "Jhunjhunūn",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1268936,
  },
  {
    name: "Jhinjhāna",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1268961,
  },
  {
    name: "Jhīnjhak",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1268962,
  },
  {
    name: "Jharsuguda",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1268977,
  },
  {
    name: "Jharia",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1268988,
  },
  {
    name: "Jhārgrām",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1268990,
  },
  {
    name: "Jhānsi",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1269006,
  },
  {
    name: "Jhanjhārpur",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1269012,
  },
  {
    name: "Jhālu",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1269019,
  },
  {
    name: "Jhālrapātan",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1269020,
  },
  {
    name: "Jhalidā",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1269026,
  },
  {
    name: "Jhālāwār",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1269027,
  },
  {
    name: "Jhajjar",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1269042,
  },
  {
    name: "Jhā-Jhā",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1269046,
  },
  {
    name: "Jhābua",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1269053,
  },
  {
    name: "Jewar",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1269056,
  },
  {
    name: "Jevargi",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1269057,
  },
  {
    name: "Jetpur",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1269065,
  },
  {
    name: "Jeypore",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1269092,
  },
  {
    name: "Jainagar",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1269093,
  },
  {
    name: "Jaynagar Majilpur",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1269094,
  },
  {
    name: "Jayamkondacholapuram",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1269102,
  },
  {
    name: "Jāwad",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1269126,
  },
  {
    name: "Jaunpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1269135,
  },
  {
    name: "Jatāra",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1269153,
  },
  {
    name: "Jatani",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1269154,
  },
  {
    name: "Jaswantnagar",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1269158,
  },
  {
    name: "Jaspur",
    country: "India",
    subcountry: "Uttarakhand",
    geonameid: 1269168,
  },
  {
    name: "Jasidih",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1269175,
  },
  {
    name: "Jashpurnagar",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1269177,
  },
  {
    name: "Jasdan",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1269179,
  },
  {
    name: "Jarwal",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1269183,
  },
  {
    name: "Jaorā",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1269217,
  },
  {
    name: "Jānsath",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1269227,
  },
  {
    name: "Jānjgīr",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1269239,
  },
  {
    name: "Jangipur",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1269247,
  },
  {
    name: "Jangaon",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1269256,
  },
  {
    name: "Jandiāla",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1269269,
  },
  {
    name: "Jāmuria",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1269280,
  },
  {
    name: "Jamūī",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1269291,
  },
  {
    name: "Jāmtāra",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1269298,
  },
  {
    name: "Jamshedpur",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1269300,
  },
  {
    name: "Jamnagar",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1269317,
  },
  {
    name: "Jammu",
    country: "India",
    subcountry: "Jammu and Kashmir",
    geonameid: 1269321,
  },
  {
    name: "Jammalamadugu",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1269323,
  },
  {
    name: "Jamkhandi",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1269328,
  },
  {
    name: "Jambusar",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1269350,
  },
  {
    name: "Jamālpur",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1269374,
  },
  {
    name: "Jāmai",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1269377,
  },
  {
    name: "Jāmadoba",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1269379,
  },
  {
    name: "Jalpāiguri",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1269388,
  },
  {
    name: "Jalor",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1269392,
  },
  {
    name: "Jālna",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1269395,
  },
  {
    name: "Jalgaon Jamod",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1269406,
  },
  {
    name: "Jalgaon",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1269407,
  },
  {
    name: "Jaleshwar",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1269413,
  },
  {
    name: "Jalesar",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1269415,
  },
  {
    name: "Jālaun",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1269422,
  },
  {
    name: "Jalālpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1269435,
  },
  {
    name: "Jalalpore",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1269439,
  },
  {
    name: "Jalālī",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1269441,
  },
  {
    name: "Jalālābād",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1269445,
  },
  {
    name: "Jalālābad",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1269446,
  },
  {
    name: "Jalālābād",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1269447,
  },
  {
    name: "Jājpur",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1269477,
  },
  {
    name: "Jaito",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1269488,
  },
  {
    name: "Jaitāran",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1269498,
  },
  {
    name: "Jaisingpur",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1269502,
  },
  {
    name: "Jaisalmer",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1269507,
  },
  {
    name: "Jais",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1269509,
  },
  {
    name: "Jaipur",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1269515,
  },
  {
    name: "Jahāzpur",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1269545,
  },
  {
    name: "Jahāngīrābād",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1269551,
  },
  {
    name: "Jahānābād",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1269557,
  },
  {
    name: "Jagtiāl",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1269562,
  },
  {
    name: "Jagraon",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1269564,
  },
  {
    name: "Jaggayyapeta",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1269570,
  },
  {
    name: "Jagdīspur",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1269573,
  },
  {
    name: "Jagdīshpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1269574,
  },
  {
    name: "Jagdalpur",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1269578,
  },
  {
    name: "Jagatsinghapur",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1269581,
  },
  {
    name: "Jagalūr",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1269602,
  },
  {
    name: "Jagādhri",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1269605,
  },
  {
    name: "Jabalpur",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1269633,
  },
  {
    name: "Itimādpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1269646,
  },
  {
    name: "Itārsi",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1269653,
  },
  {
    name: "Itānagar",
    country: "India",
    subcountry: "Arunachal Pradesh",
    geonameid: 1269655,
  },
  {
    name: "Islāmpur",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1269665,
  },
  {
    name: "Islāmpur",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1269666,
  },
  {
    name: "Islāmnagar",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1269670,
  },
  {
    name: "Irugūr",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1269690,
  },
  {
    name: "Irinjālakuda",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1269693,
  },
  {
    name: "Iringal",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1269694,
  },
  {
    name: "Ingrāj Bāzār",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1269723,
  },
  {
    name: "Indri",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1269731,
  },
  {
    name: "Indore",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1269743,
  },
  {
    name: "Indi",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1269751,
  },
  {
    name: "Indergarh",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1269752,
  },
  {
    name: "Indāpur",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1269761,
  },
  {
    name: "Imphāl",
    country: "India",
    subcountry: "Manipur",
    geonameid: 1269771,
  },
  {
    name: "Ilkal",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1269784,
  },
  {
    name: "Igatpuri",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1269810,
  },
  {
    name: "Idappadi",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1269819,
  },
  {
    name: "Ichchāpuram",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1269827,
  },
  {
    name: "Ichalkaranji",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1269834,
  },
  {
    name: "Hyderābād",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1269843,
  },
  {
    name: "Hadagalli",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1269849,
  },
  {
    name: "Husainābād",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1269862,
  },
  {
    name: "Hunsūr",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1269873,
  },
  {
    name: "Hungund",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1269876,
  },
  {
    name: "Hukeri",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1269908,
  },
  {
    name: "Hugli",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1269910,
  },
  {
    name: "Hubli",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1269920,
  },
  {
    name: "Howli",
    country: "India",
    subcountry: "Assam",
    geonameid: 1269927,
  },
  {
    name: "Hosūr",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1269934,
  },
  {
    name: "Hospet",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1269935,
  },
  {
    name: "Hoskote",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1269936,
  },
  {
    name: "Hoshiārpur",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1269937,
  },
  {
    name: "Narmadapuram",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1269939,
  },
  {
    name: "Hosdurga",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1269943,
  },
  {
    name: "Honnāli",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1269970,
  },
  {
    name: "Honavar",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1269976,
  },
  {
    name: "Homnābād",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1269979,
  },
  {
    name: "Hole Narsipur",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1269985,
  },
  {
    name: "Holalkere",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1269990,
  },
  {
    name: "Hojāi",
    country: "India",
    subcountry: "Assam",
    geonameid: 1269993,
  },
  {
    name: "Hodal",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1270000,
  },
  {
    name: "Hisuā",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1270021,
  },
  {
    name: "Hisar",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1270022,
  },
  {
    name: "Hiriyūr",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1270032,
  },
  {
    name: "Hirekerūr",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1270036,
  },
  {
    name: "Hīrākud",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1270059,
  },
  {
    name: "Hinjilikatu",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1270066,
  },
  {
    name: "Hingoli",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1270072,
  },
  {
    name: "Hinganghāt",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1270077,
  },
  {
    name: "Hindupur",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1270079,
  },
  {
    name: "Hindoria",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1270082,
  },
  {
    name: "Hindaun",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1270090,
  },
  {
    name: "Himatnagar",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1270099,
  },
  {
    name: "Hilsa",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1270102,
  },
  {
    name: "Hazāribāgh",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1270164,
  },
  {
    name: "Hāveri",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1270171,
  },
  {
    name: "Hatta",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1270185,
  },
  {
    name: "Hāthras",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1270216,
  },
  {
    name: "Hastināpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1270237,
  },
  {
    name: "Hassan",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1270239,
  },
  {
    name: "Hāsimāra",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1270245,
  },
  {
    name: "Hasanpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1270251,
  },
  {
    name: "Harūr",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1270265,
  },
  {
    name: "Harsūd",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1270271,
  },
  {
    name: "Harpanahalli",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1270287,
  },
  {
    name: "Harpālpur",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1270291,
  },
  {
    name: "Hārij",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1270343,
  },
  {
    name: "Harihar",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1270349,
  },
  {
    name: "Haridwar",
    country: "India",
    subcountry: "Uttarakhand",
    geonameid: 1270351,
  },
  {
    name: "Hardoī",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1270370,
  },
  {
    name: "Harda Khās",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1270375,
  },
  {
    name: "Hāpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1270393,
  },
  {
    name: "Hāora",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1270396,
  },
  {
    name: "Hanumāngarh",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1270407,
  },
  {
    name: "Hānsi",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1270417,
  },
  {
    name: "Hāngal",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1270435,
  },
  {
    name: "Handiā",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1270437,
  },
  {
    name: "Hamīrpur",
    country: "India",
    subcountry: "Himachal Pradesh",
    geonameid: 1270454,
  },
  {
    name: "Hamīrpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1270455,
  },
  {
    name: "Halvad",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1270466,
  },
  {
    name: "Hālol",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1270474,
  },
  {
    name: "Haliyal",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1270482,
  },
  {
    name: "Hālīsahar",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1270484,
  },
  {
    name: "Haldwani",
    country: "India",
    subcountry: "Uttarakhand",
    geonameid: 1270498,
  },
  {
    name: "Haldaur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1270509,
  },
  {
    name: "Hājo",
    country: "India",
    subcountry: "Assam",
    geonameid: 1270522,
  },
  {
    name: "Hājīpur",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1270525,
  },
  {
    name: "Hailākāndi",
    country: "India",
    subcountry: "Assam",
    geonameid: 1270530,
  },
  {
    name: "Hāflong",
    country: "India",
    subcountry: "Assam",
    geonameid: 1270543,
  },
  {
    name: "Hadgāon",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1270554,
  },
  {
    name: "Hābra",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1270568,
  },
  {
    name: "Gyānpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1270576,
  },
  {
    name: "Gwalior",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1270583,
  },
  {
    name: "Guskhara",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1270598,
  },
  {
    name: "Guruvāyūr",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1270603,
  },
  {
    name: "Guru Har Sahāi",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1270612,
  },
  {
    name: "Gursarāi",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1270618,
  },
  {
    name: "Gursahāiganj",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1270619,
  },
  {
    name: "Gurmatkāl",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1270627,
  },
  {
    name: "Gurgaon",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1270642,
  },
  {
    name: "Gunupur",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1270667,
  },
  {
    name: "Guntur",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1270668,
  },
  {
    name: "Guntakal Junction",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1270670,
  },
  {
    name: "Gunnaur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1270674,
  },
  {
    name: "Gundlupēt",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1270686,
  },
  {
    name: "Guna",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1270711,
  },
  {
    name: "Gummidipundi",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1270718,
  },
  {
    name: "Gumlā",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1270722,
  },
  {
    name: "Gumia",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1270723,
  },
  {
    name: "Guledagudda",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1270750,
  },
  {
    name: "Kalaburagi",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1270752,
  },
  {
    name: "Gulāothi",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1270759,
  },
  {
    name: "Gulābpura",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1270763,
  },
  {
    name: "Gūduvāncheri",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1270787,
  },
  {
    name: "Gūdūr",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1270791,
  },
  {
    name: "Gudiyatham",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1270800,
  },
  {
    name: "Gudivāda",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1270801,
  },
  {
    name: "Gudalur",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1270820,
  },
  {
    name: "Gubbi",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1270824,
  },
  {
    name: "Goyerkāta",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1270845,
  },
  {
    name: "Govardhan",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1270863,
  },
  {
    name: "Gosāba",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1270896,
  },
  {
    name: "Gorantla",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1270923,
  },
  {
    name: "Gorakhpur",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1270926,
  },
  {
    name: "Gorakhpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1270927,
  },
  {
    name: "Gobichettipalayam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1270947,
  },
  {
    name: "Gopālganj",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1270965,
  },
  {
    name: "Gondiā",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1270990,
  },
  {
    name: "Gondal",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1270994,
  },
  {
    name: "Gondā City",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1270996,
  },
  {
    name: "Gomoh",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1271005,
  },
  {
    name: "Gola Gokarannāth",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1271049,
  },
  {
    name: "Golāghāt",
    country: "India",
    subcountry: "Assam",
    geonameid: 1271050,
  },
  {
    name: "Gokavaram",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1271062,
  },
  {
    name: "Gokarna",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1271064,
  },
  {
    name: "Gokak",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1271067,
  },
  {
    name: "Gohāna",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1271079,
  },
  {
    name: "Gohadi",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1271083,
  },
  {
    name: "Godhra",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1271107,
  },
  {
    name: "Godda",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1271113,
  },
  {
    name: "Gobindpur",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1271131,
  },
  {
    name: "Gobārdānga",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1271142,
  },
  {
    name: "Goālpāra",
    country: "India",
    subcountry: "Assam",
    geonameid: 1271151,
  },
  {
    name: "Gīrīdīh",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1271175,
  },
  {
    name: "Gingee",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1271199,
  },
  {
    name: "Giddarbāha",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1271212,
  },
  {
    name: "Giddalūr",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1271213,
  },
  {
    name: "Ghugus",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1271244,
  },
  {
    name: "Ghoti Budrukh",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1271250,
  },
  {
    name: "Ghosī",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1271259,
  },
  {
    name: "Ghazīpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1271306,
  },
  {
    name: "Ghāziābād",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1271308,
  },
  {
    name: "Ghātsīla",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1271319,
  },
  {
    name: "Ghātanji",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1271343,
  },
  {
    name: "Ghātampur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1271345,
  },
  {
    name: "Ghātāl",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1271346,
  },
  {
    name: "Gharaunda",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1271363,
  },
  {
    name: "Gevrai",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1271413,
  },
  {
    name: "Gaya",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1271439,
  },
  {
    name: "Gauripur",
    country: "India",
    subcountry: "Assam",
    geonameid: 1271453,
  },
  {
    name: "Gauribidanur",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1271459,
  },
  {
    name: "Guwahati",
    country: "India",
    subcountry: "Assam",
    geonameid: 1271476,
  },
  {
    name: "Garhwa",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1271493,
  },
  {
    name: "Garui",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1271495,
  },
  {
    name: "Gariadhar",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1271533,
  },
  {
    name: "Garhshankar",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1271538,
  },
  {
    name: "Garhmuktesar",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1271543,
  },
  {
    name: "Garhākota",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1271563,
  },
  {
    name: "Gannavaram",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1271613,
  },
  {
    name: "Gangtok",
    country: "India",
    subcountry: "Sikkim",
    geonameid: 1271631,
  },
  {
    name: "Gangolli",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1271642,
  },
  {
    name: "Gangoh",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1271644,
  },
  {
    name: "Gangāwati",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1271662,
  },
  {
    name: "Gangārāmpur",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1271670,
  },
  {
    name: "Gangāpur",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1271675,
  },
  {
    name: "Gangāpur",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1271676,
  },
  {
    name: "Gangāpur",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1271680,
  },
  {
    name: "Gangānagar",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1271685,
  },
  {
    name: "Gangākher",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1271688,
  },
  {
    name: "Gandhinagar",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1271715,
  },
  {
    name: "Gāndhīdhām",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1271717,
  },
  {
    name: "Gandevi",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1271722,
  },
  {
    name: "Gāndarbal",
    country: "India",
    subcountry: "Jammu and Kashmir",
    geonameid: 1271729,
  },
  {
    name: "Gajraula",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1271780,
  },
  {
    name: "Gajendragarh",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1271789,
  },
  {
    name: "Gadwāl",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1271819,
  },
  {
    name: "Gadhinglaj",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1271834,
  },
  {
    name: "Gadhada",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1271839,
  },
  {
    name: "Gādarwāra",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1271847,
  },
  {
    name: "Gadag",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1271850,
  },
  {
    name: "Fort Gloster",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1271871,
  },
  {
    name: "Forbesganj",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1271874,
  },
  {
    name: "Fīrozpur Jhirka",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1271881,
  },
  {
    name: "Ferozepore",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1271883,
  },
  {
    name: "Fīrozābād",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1271885,
  },
  {
    name: "Ferokh",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1271888,
  },
  {
    name: "Fāzilka",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1271891,
  },
  {
    name: "Fatwa",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1271892,
  },
  {
    name: "Fatehpur Sīkri",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1271900,
  },
  {
    name: "Fatehpur",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1271910,
  },
  {
    name: "Fatehpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1271911,
  },
  {
    name: "Fatehpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1271912,
  },
  {
    name: "Fatehgarh Chūriān",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1271923,
  },
  {
    name: "Fatehganj West",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1271929,
  },
  {
    name: "Fatehābād",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1271934,
  },
  {
    name: "Fatehābād",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1271936,
  },
  {
    name: "Farrukhnagar",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1271940,
  },
  {
    name: "Farrukhābād",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1271942,
  },
  {
    name: "Farīdpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1271947,
  },
  {
    name: "Farīdkot",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1271949,
  },
  {
    name: "Faridabad",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1271951,
  },
  {
    name: "Farakka",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1271954,
  },
  {
    name: "Fālākāta",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1271965,
  },
  {
    name: "Faizpur",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1271975,
  },
  {
    name: "Fyzābād",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1271976,
  },
  {
    name: "Etāwah",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1271987,
  },
  {
    name: "Erraguntla",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1272008,
  },
  {
    name: "Erode",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1272013,
  },
  {
    name: "Erāttupetta",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1272022,
  },
  {
    name: "Erandol",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1272025,
  },
  {
    name: "Emmiganūr",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1272045,
  },
  {
    name: "Ellore",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1272051,
  },
  {
    name: "Elūr",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1272052,
  },
  {
    name: "Ellenabad",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1272061,
  },
  {
    name: "Elamanchili",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1272084,
  },
  {
    name: "Egra",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1272101,
  },
  {
    name: "Dwārka",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1272140,
  },
  {
    name: "Durgapur",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1272175,
  },
  {
    name: "Durgāpur",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1272177,
  },
  {
    name: "Durg",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1272181,
  },
  {
    name: "Dūngarpur",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1272201,
  },
  {
    name: "Ganj Dundwāra",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1272207,
  },
  {
    name: "Dumraon",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1272225,
  },
  {
    name: "Dumra",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1272229,
  },
  {
    name: "Dumka",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1272237,
  },
  {
    name: "Dum Duma",
    country: "India",
    subcountry: "Assam",
    geonameid: 1272242,
  },
  {
    name: "Dam Dam",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1272243,
  },
  {
    name: "Duliajan",
    country: "India",
    subcountry: "Assam",
    geonameid: 1272259,
  },
  {
    name: "Dugda",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1272277,
  },
  {
    name: "Dubrājpur",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1272320,
  },
  {
    name: "Dornakal",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1272367,
  },
  {
    name: "Dorāha",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1272375,
  },
  {
    name: "Dongargarh",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1272396,
  },
  {
    name: "Dondaicha",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1272411,
  },
  {
    name: "Dombivli",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1272423,
  },
  {
    name: "Doddaballapura",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1272473,
  },
  {
    name: "Doda",
    country: "India",
    subcountry: "Jammu and Kashmir",
    geonameid: 1272476,
  },
  {
    name: "Diu",
    country: "India",
    subcountry: "Dadra and Nagar Haveli and Daman and Diu",
    geonameid: 1272502,
  },
  {
    name: "Dīsa",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1272513,
  },
  {
    name: "Diphu",
    country: "India",
    subcountry: "Assam",
    geonameid: 1272525,
  },
  {
    name: "Dīnhāta",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1272532,
  },
  {
    name: "Dindori",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1272540,
  },
  {
    name: "Dindigul",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1272543,
  },
  {
    name: "Dīnānagar",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1272546,
  },
  {
    name: "Dimāpur",
    country: "India",
    subcountry: "Nagaland",
    geonameid: 1272552,
  },
  {
    name: "Digras",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1272596,
  },
  {
    name: "Dīglūr",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1272606,
  },
  {
    name: "Dighwāra",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1272610,
  },
  {
    name: "Digboi",
    country: "India",
    subcountry: "Assam",
    geonameid: 1272629,
  },
  {
    name: "Dīg",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1272639,
  },
  {
    name: "Dīdwāna",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1272640,
  },
  {
    name: "Dicholi",
    country: "India",
    subcountry: "Goa",
    geonameid: 1272646,
  },
  {
    name: "Dibrugarh",
    country: "India",
    subcountry: "Assam",
    geonameid: 1272648,
  },
  {
    name: "Dibai",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1272653,
  },
  {
    name: "Diamond Harbour",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1272657,
  },
  {
    name: "Dhūri",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1272670,
  },
  {
    name: "Dhupgāri",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1272674,
  },
  {
    name: "Dhuliān",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1272689,
  },
  {
    name: "Dhūlia",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1272691,
  },
  {
    name: "Dhuburi",
    country: "India",
    subcountry: "Assam",
    geonameid: 1272694,
  },
  {
    name: "Dhrol",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1272699,
  },
  {
    name: "Dhrāngadhra",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1272701,
  },
  {
    name: "Dhorāji",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1272720,
  },
  {
    name: "Dhone",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1272722,
  },
  {
    name: "Dholka",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1272733,
  },
  {
    name: "Dhing",
    country: "India",
    subcountry: "Assam",
    geonameid: 1272768,
  },
  {
    name: "Dhenkānāl",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1272780,
  },
  {
    name: "Dhekiajuli",
    country: "India",
    subcountry: "Assam",
    geonameid: 1272790,
  },
  {
    name: "Dhaurahra",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1272802,
  },
  {
    name: "Dhaulpur",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1272805,
  },
  {
    name: "Dhārūr",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1272819,
  },
  {
    name: "Dhāruhera",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1272822,
  },
  {
    name: "Dharamsala",
    country: "India",
    subcountry: "Himachal Pradesh",
    geonameid: 1272832,
  },
  {
    name: "Dharmavaram",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1272842,
  },
  {
    name: "Dharmapuri",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1272847,
  },
  {
    name: "Dharmanagar",
    country: "India",
    subcountry: "Tripura",
    geonameid: 1272852,
  },
  {
    name: "Dharmadam",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1272856,
  },
  {
    name: "Dharmābād",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1272857,
  },
  {
    name: "Dhāriwāl",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1272860,
  },
  {
    name: "Dhāri",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1272861,
  },
  {
    name: "Dharapuram",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1272873,
  },
  {
    name: "Dharangaon",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1272874,
  },
  {
    name: "Dharampur",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1272881,
  },
  {
    name: "Dhār",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1272892,
  },
  {
    name: "Dhanera",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1272962,
  },
  {
    name: "Dhandhuka",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1272970,
  },
  {
    name: "Dhanbad",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1272979,
  },
  {
    name: "Dhanaura",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1272983,
  },
  {
    name: "Dhanaula",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1272985,
  },
  {
    name: "Dhamtari",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1272997,
  },
  {
    name: "Dhāmpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1273002,
  },
  {
    name: "Dhāmnod",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1273006,
  },
  {
    name: "Dhāka",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1273043,
  },
  {
    name: "Dewas",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1273066,
  },
  {
    name: "Deoli",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1273083,
  },
  {
    name: "Devgarh",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1273098,
  },
  {
    name: "Devgadh Bāriya",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1273104,
  },
  {
    name: "Devarkonda",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1273109,
  },
  {
    name: "Devanhalli",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1273123,
  },
  {
    name: "Devakottai",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1273128,
  },
  {
    name: "Deūlgaon Rāja",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1273136,
  },
  {
    name: "Deshnoke",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1273153,
  },
  {
    name: "Depālpur",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1273181,
  },
  {
    name: "Deori Khās",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1273191,
  },
  {
    name: "Deoria",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1273193,
  },
  {
    name: "Deoraniān",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1273206,
  },
  {
    name: "Deoli",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1273228,
  },
  {
    name: "Deolāli",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1273232,
  },
  {
    name: "Deoghar",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1273241,
  },
  {
    name: "Deogarh",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1273246,
  },
  {
    name: "Deoband",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1273265,
  },
  {
    name: "Denkanikota",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1273272,
  },
  {
    name: "Delhi",
    country: "India",
    subcountry: "Delhi",
    geonameid: 1273294,
  },
  {
    name: "Dehri",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1273309,
  },
  {
    name: "Dehra Dūn",
    country: "India",
    subcountry: "Uttarakhand",
    geonameid: 1273313,
  },
  {
    name: "Davangere",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1273368,
  },
  {
    name: "Dausa",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1273369,
  },
  {
    name: "Daund",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1273374,
  },
  {
    name: "Daudnagar",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1273390,
  },
  {
    name: "Dattāpur",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1273397,
  },
  {
    name: "Datia",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1273403,
  },
  {
    name: "Dātāganj",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1273409,
  },
  {
    name: "Dasūya",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1273410,
  },
  {
    name: "Dāsna",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1273416,
  },
  {
    name: "Daryāpur",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1273434,
  },
  {
    name: "Dārwha",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1273440,
  },
  {
    name: "Darsi",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1273448,
  },
  {
    name: "Dārjiling",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1273467,
  },
  {
    name: "Darbhanga",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1273491,
  },
  {
    name: "Dandeli",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1273574,
  },
  {
    name: "Dinapore",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1273581,
  },
  {
    name: "Damoh",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1273587,
  },
  {
    name: "Dāmnagar",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1273593,
  },
  {
    name: "Daman",
    country: "India",
    subcountry: "Dadra and Nagar Haveli and Daman and Diu",
    geonameid: 1273618,
  },
  {
    name: "Daltonganj",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1273626,
  },
  {
    name: "Dalsingh Sarai",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1273628,
  },
  {
    name: "Dalkola",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1273642,
  },
  {
    name: "Dākor",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1273665,
  },
  {
    name: "Dohad",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1273687,
  },
  {
    name: "Dahegām",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1273704,
  },
  {
    name: "Dāhānu",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1273708,
  },
  {
    name: "Dādri",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1273724,
  },
  {
    name: "Dabwāli",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1273745,
  },
  {
    name: "Dabra",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1273751,
  },
  {
    name: "Daboh",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1273756,
  },
  {
    name: "Dabhoi",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1273766,
  },
  {
    name: "Cuttack",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1273780,
  },
  {
    name: "Curchorem",
    country: "India",
    subcountry: "Goa",
    geonameid: 1273788,
  },
  {
    name: "Cuncolim",
    country: "India",
    subcountry: "Goa",
    geonameid: 1273793,
  },
  {
    name: "Cumbum",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1273795,
  },
  {
    name: "Kadapa",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1273800,
  },
  {
    name: "Cuddalore",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1273802,
  },
  {
    name: "Coondapoor",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1273834,
  },
  {
    name: "Colonelganj",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1273850,
  },
  {
    name: "Colgong",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1273856,
  },
  {
    name: "Calangute",
    country: "India",
    subcountry: "Goa",
    geonameid: 1273858,
  },
  {
    name: "Coimbatore",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1273865,
  },
  {
    name: "Cochin",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1273874,
  },
  {
    name: "Clement Town",
    country: "India",
    subcountry: "Uttarakhand",
    geonameid: 1273880,
  },
  {
    name: "Chūru",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1273892,
  },
  {
    name: "Churāchāndpur",
    country: "India",
    subcountry: "Manipur",
    geonameid: 1273909,
  },
  {
    name: "Chunār",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1273923,
  },
  {
    name: "Chotila",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1273960,
  },
  {
    name: "Chopda",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1273992,
  },
  {
    name: "Chodavaram",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1274020,
  },
  {
    name: "Rampachodavaram",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1274021,
  },
  {
    name: "Chittūr",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1274032,
  },
  {
    name: "Chittaurgarh",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1274040,
  },
  {
    name: "Chittaranjan",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1274043,
  },
  {
    name: "Chitradurga",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1274056,
  },
  {
    name: "Chītāpur",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1274077,
  },
  {
    name: "Chidawa",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1274102,
  },
  {
    name: "Chīrāla",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1274106,
  },
  {
    name: "Chīpurupalle",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1274116,
  },
  {
    name: "Chiplūn",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1274119,
  },
  {
    name: "Chintāmani",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1274129,
  },
  {
    name: "Chinna Salem",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1274146,
  },
  {
    name: "Chinnamanūr",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1274151,
  },
  {
    name: "Chincholi",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1274169,
  },
  {
    name: "Chillupār",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1274195,
  },
  {
    name: "Chilakalūrupet",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1274213,
  },
  {
    name: "Chikodi",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1274218,
  },
  {
    name: "Chiknāyakanhalli",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1274219,
  },
  {
    name: "Chikmagalūr",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1274220,
  },
  {
    name: "Chikhli",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1274237,
  },
  {
    name: "Chik Ballāpur",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1274243,
  },
  {
    name: "Chidambaram",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1274256,
  },
  {
    name: "Chicholi",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1274265,
  },
  {
    name: "Chhoti Sādri",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1274284,
  },
  {
    name: "Chhota Udepur",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1274285,
  },
  {
    name: "Chhindwāra",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1274304,
  },
  {
    name: "Chhibrāmau",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1274315,
  },
  {
    name: "Chhatarpur",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1274337,
  },
  {
    name: "Chhātāpur",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1274342,
  },
  {
    name: "Chhāta",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1274343,
  },
  {
    name: "Chharra",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1274346,
  },
  {
    name: "Chhaprauli",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1274351,
  },
  {
    name: "Chāpra",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1274353,
  },
  {
    name: "Chhāpar",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1274359,
  },
  {
    name: "Chhala",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1274369,
  },
  {
    name: "Chhabra",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1274381,
  },
  {
    name: "Chettipālaiyam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1274389,
  },
  {
    name: "Chetput",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1274394,
  },
  {
    name: "Chennimalai",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1274422,
  },
  {
    name: "Chengannūr",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1274428,
  },
  {
    name: "Chengam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1274429,
  },
  {
    name: "Chengalpattu",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1274430,
  },
  {
    name: "Chetwayi",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1274468,
  },
  {
    name: "Chaksu",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1274532,
  },
  {
    name: "Chatrapur",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1274533,
  },
  {
    name: "Chatrā",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1274536,
  },
  {
    name: "Chās",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1274553,
  },
  {
    name: "Charthāwal",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1274560,
  },
  {
    name: "Charkhi Dādri",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1274571,
  },
  {
    name: "Charkhāri",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1274574,
  },
  {
    name: "Chāpar",
    country: "India",
    subcountry: "Assam",
    geonameid: 1274618,
  },
  {
    name: "Channarāyapatna",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1274640,
  },
  {
    name: "Channapatna",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1274641,
  },
  {
    name: "Channagiri",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1274642,
  },
  {
    name: "Changanācheri",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1274664,
  },
  {
    name: "Chāndor",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1274673,
  },
  {
    name: "Chāndūr Bāzār",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1274674,
  },
  {
    name: "Chāndūr",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1274675,
  },
  {
    name: "Chāndur",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1274676,
  },
  {
    name: "Chānda",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1274693,
  },
  {
    name: "Chandrakona",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1274699,
  },
  {
    name: "Chāndpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1274714,
  },
  {
    name: "Chandīgarh",
    country: "India",
    subcountry: "Chandigarh",
    geonameid: 1274746,
  },
  {
    name: "Chanderi",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1274755,
  },
  {
    name: "Chanduasi",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1274767,
  },
  {
    name: "Chandauli",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1274770,
  },
  {
    name: "Chandannagar",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1274784,
  },
  {
    name: "Chānasma",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1274807,
  },
  {
    name: "Chamrajnagar",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1274821,
  },
  {
    name: "Chāmpa",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1274837,
  },
  {
    name: "Chamba",
    country: "India",
    subcountry: "Himachal Pradesh",
    geonameid: 1274848,
  },
  {
    name: "Challapalle",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1274861,
  },
  {
    name: "Challakere",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1274862,
  },
  {
    name: "Chālisgaon",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1274868,
  },
  {
    name: "Chalāla",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1274874,
  },
  {
    name: "Chakradharpur",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1274890,
  },
  {
    name: "Chaklāsi",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1274896,
  },
  {
    name: "Chākia",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1274899,
  },
  {
    name: "Chākan",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1274914,
  },
  {
    name: "Chāībāsa",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1274928,
  },
  {
    name: "Canning",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1274984,
  },
  {
    name: "Kannur",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1274987,
  },
  {
    name: "Kolkata",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1275004,
  },
  {
    name: "Byādgi",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1275016,
  },
  {
    name: "Buxar",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1275019,
  },
  {
    name: "Burla",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1275050,
  },
  {
    name: "Burhar",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1275066,
  },
  {
    name: "Burhānpur",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1275068,
  },
  {
    name: "Būndu",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1275097,
  },
  {
    name: "Būndi",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1275103,
  },
  {
    name: "Buldāna",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1275117,
  },
  {
    name: "Bulandshahr",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1275120,
  },
  {
    name: "Budhlāda",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1275147,
  },
  {
    name: "Budhāna",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1275152,
  },
  {
    name: "Budaun",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1275163,
  },
  {
    name: "Brājarājnagar",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1275194,
  },
  {
    name: "Brahmapur",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1275198,
  },
  {
    name: "Botād",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1275218,
  },
  {
    name: "Borsad",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1275230,
  },
  {
    name: "Borivli",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1275248,
  },
  {
    name: "Bongaigaon",
    country: "India",
    subcountry: "Assam",
    geonameid: 1275321,
  },
  {
    name: "Mumbai",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1275339,
  },
  {
    name: "Bolpur",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1275346,
  },
  {
    name: "Bokāro",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1275362,
  },
  {
    name: "Bokajān",
    country: "India",
    subcountry: "Assam",
    geonameid: 1275364,
  },
  {
    name: "Boisar",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1275368,
  },
  {
    name: "Bodināyakkanūr",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1275388,
  },
  {
    name: "Buddh Gaya",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1275389,
  },
  {
    name: "Bodhan",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1275391,
  },
  {
    name: "Bobbili",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1275406,
  },
  {
    name: "Biswān",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1275435,
  },
  {
    name: "Bissāu",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1275441,
  },
  {
    name: "Bishnupur",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1275462,
  },
  {
    name: "Bisauli",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1275476,
  },
  {
    name: "Bīsalpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1275481,
  },
  {
    name: "Birūr",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1275488,
  },
  {
    name: "Bīrpur",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1275499,
  },
  {
    name: "Birmitrapur",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1275506,
  },
  {
    name: "Binka",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1275558,
  },
  {
    name: "Bindki",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1275572,
  },
  {
    name: "Etāwa",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1275582,
  },
  {
    name: "Bilthra",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1275589,
  },
  {
    name: "Bilsi",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1275590,
  },
  {
    name: "Bilsanda",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1275593,
  },
  {
    name: "Bilimora",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1275610,
  },
  {
    name: "Bilhaur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1275614,
  },
  {
    name: "Bilgrām",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1275618,
  },
  {
    name: "Bilgi",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1275619,
  },
  {
    name: "Bīlāspur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1275634,
  },
  {
    name: "Bilāspur",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1275637,
  },
  {
    name: "Bilāsipāra",
    country: "India",
    subcountry: "Assam",
    geonameid: 1275641,
  },
  {
    name: "Bilāri",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1275646,
  },
  {
    name: "Bilāra",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1275647,
  },
  {
    name: "Bikramganj",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1275655,
  },
  {
    name: "Bīkaner",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1275665,
  },
  {
    name: "Bijnor",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1275679,
  },
  {
    name: "Bijbehara",
    country: "India",
    subcountry: "Jammu and Kashmir",
    geonameid: 1275692,
  },
  {
    name: "Bijāwar",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1275694,
  },
  {
    name: "Bijapur",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1275701,
  },
  {
    name: "Bihār Sharīf",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1275716,
  },
  {
    name: "Bihārīganj",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1275719,
  },
  {
    name: "Bidhūna",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1275732,
  },
  {
    name: "Bīdar",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1275738,
  },
  {
    name: "Biaora",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1275762,
  },
  {
    name: "Kīl Bhuvanagiri",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1275768,
  },
  {
    name: "Bhusāval",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1275778,
  },
  {
    name: "Bhūm",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1275804,
  },
  {
    name: "Bhuj",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1275812,
  },
  {
    name: "Bhudgaon",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1275814,
  },
  {
    name: "Bhubaneshwar",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1275817,
  },
  {
    name: "Bhuban",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1275818,
  },
  {
    name: "Bhor",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1275836,
  },
  {
    name: "Bhopāl",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1275841,
  },
  {
    name: "Bhongīr",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1275848,
  },
  {
    name: "Bhongaon",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1275849,
  },
  {
    name: "Bhogpur",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1275882,
  },
  {
    name: "Bhiwāni",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1275899,
  },
  {
    name: "Bhiwandi",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1275901,
  },
  {
    name: "Bhitarwār",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1275905,
  },
  {
    name: "Bhīnmāl",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1275920,
  },
  {
    name: "Bhinga",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1275921,
  },
  {
    name: "Bhindār",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1275925,
  },
  {
    name: "Bhind",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1275926,
  },
  {
    name: "Bhīmunipatnam",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1275930,
  },
  {
    name: "Bhīmavaram",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1275947,
  },
  {
    name: "Bhīlwāra",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1275960,
  },
  {
    name: "Bhilai",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1275971,
  },
  {
    name: "Bhīkhi",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1275977,
  },
  {
    name: "Bhikangaon",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1275978,
  },
  {
    name: "Bhāyāvadar",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1276013,
  },
  {
    name: "Bhayandar",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1276014,
  },
  {
    name: "Bhawānipatna",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1276023,
  },
  {
    name: "Bhawānīgarh",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1276026,
  },
  {
    name: "Bhawāni Mandi",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1276027,
  },
  {
    name: "Bhavnagar",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1276032,
  },
  {
    name: "Bhavāni",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1276037,
  },
  {
    name: "Bhattiprolu",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1276054,
  },
  {
    name: "Bhātpāra",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1276058,
  },
  {
    name: "Bhatkal",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1276067,
  },
  {
    name: "Bathinda",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1276070,
  },
  {
    name: "Bhātāpāra",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1276084,
  },
  {
    name: "Bhasāwar",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1276092,
  },
  {
    name: "Bharwāri",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1276095,
  },
  {
    name: "Bharūch",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1276100,
  },
  {
    name: "Bharthana",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1276103,
  },
  {
    name: "Bharatpur",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1276128,
  },
  {
    name: "Bhānvad",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1276147,
  },
  {
    name: "Bhānpurī",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1276151,
  },
  {
    name: "Bhānpura",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1276152,
  },
  {
    name: "Bhanjanagar",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1276159,
  },
  {
    name: "Bhānder",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1276178,
  },
  {
    name: "Bhandāra",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1276191,
  },
  {
    name: "Bhālki",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1276219,
  },
  {
    name: "Bhaisa",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1276249,
  },
  {
    name: "Bhainsdehi",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1276265,
  },
  {
    name: "Bhāgalpur",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1276300,
  },
  {
    name: "Bhadreswar",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1276320,
  },
  {
    name: "Bhadrāvati",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1276321,
  },
  {
    name: "Bhadrakh",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1276325,
  },
  {
    name: "Bhadrāchalam",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1276328,
  },
  {
    name: "Bhādra",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1276330,
  },
  {
    name: "Bhadohi",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1276335,
  },
  {
    name: "Bhadaur",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1276353,
  },
  {
    name: "Bhādāsar",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1276355,
  },
  {
    name: "Bhachāu",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1276370,
  },
  {
    name: "Bhabhua",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1276371,
  },
  {
    name: "Beypore",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1276378,
  },
  {
    name: "Bewar",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1276381,
  },
  {
    name: "Betūl",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1276389,
  },
  {
    name: "Bettiah",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1276393,
  },
  {
    name: "Betamcherla",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1276416,
  },
  {
    name: "Beri Khās",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1276437,
  },
  {
    name: "Berasia",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1276449,
  },
  {
    name: "Beohāri",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1276455,
  },
  {
    name: "Bemetāra",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1276478,
  },
  {
    name: "Belūr",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1276486,
  },
  {
    name: "Belsand",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1276495,
  },
  {
    name: "Belonia",
    country: "India",
    subcountry: "Tripura",
    geonameid: 1276502,
  },
  {
    name: "Bellary",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1276509,
  },
  {
    name: "Belagavi",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1276533,
  },
  {
    name: "Beldānga",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1276548,
  },
  {
    name: "Bela",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1276574,
  },
  {
    name: "Behror",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1276589,
  },
  {
    name: "Behat",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1276600,
  },
  {
    name: "Begusarai",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1276609,
  },
  {
    name: "Begūn",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1276615,
  },
  {
    name: "Begamganj",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1276621,
  },
  {
    name: "Bedi",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1276627,
  },
  {
    name: "Beāwar",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1276634,
  },
  {
    name: "Bāzpur",
    country: "India",
    subcountry: "Uttarakhand",
    geonameid: 1276642,
  },
  {
    name: "Bayāna",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1276652,
  },
  {
    name: "Bawāna",
    country: "India",
    subcountry: "Delhi",
    geonameid: 1276663,
  },
  {
    name: "Baud",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1276686,
  },
  {
    name: "Batāla",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1276720,
  },
  {
    name: "Baswa",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1276724,
  },
  {
    name: "Bāsudebpur",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1276731,
  },
  {
    name: "Bastī",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1276736,
  },
  {
    name: "Bāsoda",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1276752,
  },
  {
    name: "Basni",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1276754,
  },
  {
    name: "Basmat",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1276757,
  },
  {
    name: "Basi",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1276764,
  },
  {
    name: "Basi",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1276765,
  },
  {
    name: "Basi",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1276767,
  },
  {
    name: "Basavana Bāgevādi",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1276782,
  },
  {
    name: "Basavakalyān",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1276783,
  },
  {
    name: "Barwāni",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1276810,
  },
  {
    name: "Barwāla",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1276815,
  },
  {
    name: "Bāruni",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1276829,
  },
  {
    name: "Baruipur",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1276832,
  },
  {
    name: "Bārsi",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1276856,
  },
  {
    name: "Barpeta",
    country: "India",
    subcountry: "Assam",
    geonameid: 1276867,
  },
  {
    name: "Barpāli",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1276870,
  },
  {
    name: "Barnāla",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1276895,
  },
  {
    name: "Bārmer",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1276901,
  },
  {
    name: "Barki Saria",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1276919,
  },
  {
    name: "Barkā Kānā",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 1276927,
  },
  {
    name: "Barjala",
    country: "India",
    subcountry: "Tripura",
    geonameid: 1276938,
  },
  {
    name: "Bari Sādri",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1276939,
  },
  {
    name: "Bāri",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1276948,
  },
  {
    name: "Barhiya",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1276954,
  },
  {
    name: "Bārh",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1276977,
  },
  {
    name: "Bargi",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1276982,
  },
  {
    name: "Bargarh",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1276988,
  },
  {
    name: "Bareilly",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1277013,
  },
  {
    name: "Bārdoli",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1277022,
  },
  {
    name: "Barddhamān",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1277029,
  },
  {
    name: "Bar Bigha",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1277038,
  },
  {
    name: "Baraut",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1277044,
  },
  {
    name: "Barauli",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1277053,
  },
  {
    name: "Bārāsat",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1277065,
  },
  {
    name: "Baranagar",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1277082,
  },
  {
    name: "Bārān",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1277084,
  },
  {
    name: "Bāramūla",
    country: "India",
    subcountry: "Jammu and Kashmir",
    geonameid: 1277085,
  },
  {
    name: "Bārāmati",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1277091,
  },
  {
    name: "Bārākpur",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1277100,
  },
  {
    name: "Bāpatla",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1277183,
  },
  {
    name: "Banūr",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1277200,
  },
  {
    name: "Bantvāl",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1277201,
  },
  {
    name: "Bāntva",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1277202,
  },
  {
    name: "Bānswāra",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1277214,
  },
  {
    name: "Bānswāda",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1277216,
  },
  {
    name: "Bānsi",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1277232,
  },
  {
    name: "Bānsdīh",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1277238,
  },
  {
    name: "Bānsbāria",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1277240,
  },
  {
    name: "Bannūr",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1277255,
  },
  {
    name: "Banmankhi",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1277263,
  },
  {
    name: "Bānkura",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1277264,
  },
  {
    name: "Bānki",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1277273,
  },
  {
    name: "Bānka",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1277289,
  },
  {
    name: "Bāngarmau",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1277318,
  },
  {
    name: "Bangarapet",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1277320,
  },
  {
    name: "Bangaon",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1277322,
  },
  {
    name: "Bangaon",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1277324,
  },
  {
    name: "Banganapalle",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1277330,
  },
  {
    name: "Bengaluru",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1277333,
  },
  {
    name: "Banga",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1277338,
  },
  {
    name: "Bandipura",
    country: "India",
    subcountry: "Jammu and Kashmir",
    geonameid: 1277358,
  },
  {
    name: "Bāndīkūi",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1277362,
  },
  {
    name: "Bānda",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1277397,
  },
  {
    name: "Banda",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1277398,
  },
  {
    name: "Banat",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1277409,
  },
  {
    name: "Bānapur",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1277426,
  },
  {
    name: "Bāmor Kalān",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1277442,
  },
  {
    name: "Bālurghāt",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1277508,
  },
  {
    name: "Bālugaon",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1277514,
  },
  {
    name: "Balrāmpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1277525,
  },
  {
    name: "Bālotra",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1277527,
  },
  {
    name: "Baloda Bāzār",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1277530,
  },
  {
    name: "Balod",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1277535,
  },
  {
    name: "Bāli",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1277539,
  },
  {
    name: "Ballālpur",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1277557,
  },
  {
    name: "Bāli",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1277590,
  },
  {
    name: "Balasore",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1277599,
  },
  {
    name: "Balarāmpur",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1277634,
  },
  {
    name: "Bālāpur",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1277636,
  },
  {
    name: "Balāngīr",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1277643,
  },
  {
    name: "Bālāghāt",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1277661,
  },
  {
    name: "Bālāchor",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1277666,
  },
  {
    name: "Bakhtiyārpur",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1277684,
  },
  {
    name: "Budge Budge",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1277723,
  },
  {
    name: "Bairāgnia",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1277748,
  },
  {
    name: "Byndoor",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1277759,
  },
  {
    name: "Bail-Hongal",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1277765,
  },
  {
    name: "Baihar",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1277776,
  },
  {
    name: "Baidyabāti",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1277780,
  },
  {
    name: "Bahraigh",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1277799,
  },
  {
    name: "Bahjoi",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1277808,
  },
  {
    name: "Baheri",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1277814,
  },
  {
    name: "Baharampur",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1277820,
  },
  {
    name: "Bahādurgarh",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1277835,
  },
  {
    name: "Bahādurganj",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1277836,
  },
  {
    name: "Bāh",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1277841,
  },
  {
    name: "Bagulā",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1277844,
  },
  {
    name: "Bāghpat",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1277882,
  },
  {
    name: "Bagdogra",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1277897,
  },
  {
    name: "Bāgha Purāna",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1277902,
  },
  {
    name: "Bāgepalli",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1277909,
  },
  {
    name: "Bagasra",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1277924,
  },
  {
    name: "Bagar",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1277930,
  },
  {
    name: "Bagalkot",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1277936,
  },
  {
    name: "Bagaha",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1277939,
  },
  {
    name: "Bagaha",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1277940,
  },
  {
    name: "Badvel",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1277949,
  },
  {
    name: "Badūria",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1277950,
  },
  {
    name: "Badnāwar",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1277970,
  },
  {
    name: "Badlapur",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1277976,
  },
  {
    name: "Bādāmi",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1278017,
  },
  {
    name: "Badagara",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1278023,
  },
  {
    name: "Bada Barabīl",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1278026,
  },
  {
    name: "Bachhraon",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1278036,
  },
  {
    name: "Babrāla",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1278052,
  },
  {
    name: "Bābra",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1278054,
  },
  {
    name: "Babīna",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1278058,
  },
  {
    name: "Baberu",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1278064,
  },
  {
    name: "Bābai",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1278073,
  },
  {
    name: "Azamgarh",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1278083,
  },
  {
    name: "Ayodhya",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1278094,
  },
  {
    name: "Ayakudi",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1278100,
  },
  {
    name: "Avanigadda",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1278122,
  },
  {
    name: "Avinashi",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1278124,
  },
  {
    name: "Āvadi",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1278130,
  },
  {
    name: "Ausa",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1278139,
  },
  {
    name: "Aurangābād",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1278148,
  },
  {
    name: "Sambhaji Nagar",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1278149,
  },
  {
    name: "Auraiya",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1278152,
  },
  {
    name: "Aurād",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1278156,
  },
  {
    name: "Attur",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1278173,
  },
  {
    name: "Attingal",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1278176,
  },
  {
    name: "Attili",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1278178,
  },
  {
    name: "Atraulī",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1278190,
  },
  {
    name: "Atmakūr",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1278201,
  },
  {
    name: "Adirampattinam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1278204,
  },
  {
    name: "Athni",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1278208,
  },
  {
    name: "Āthagarh",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1278216,
  },
  {
    name: "Atarra",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1278228,
  },
  {
    name: "Āsind",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1278278,
  },
  {
    name: "Āsika",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1278279,
  },
  {
    name: "Asifābād",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1278282,
  },
  {
    name: "Ashta",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1278294,
  },
  {
    name: "Ashta",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1278296,
  },
  {
    name: "Ashoknagar",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1278297,
  },
  {
    name: "Āsansol",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1278314,
  },
  {
    name: "Āsandh",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1278320,
  },
  {
    name: "Ārvi",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1278335,
  },
  {
    name: "Aruppukkottai",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1278340,
  },
  {
    name: "Arumuganeri",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1278343,
  },
  {
    name: "Arukutti",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1278345,
  },
  {
    name: "Arsikere",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1278354,
  },
  {
    name: "Āron",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1278365,
  },
  {
    name: "Arkalgūd",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1278393,
  },
  {
    name: "Ariyalūr",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1278405,
  },
  {
    name: "Arcot",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1278432,
  },
  {
    name: "Arāria",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1278446,
  },
  {
    name: "Arantāngi",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1278448,
  },
  {
    name: "Arni",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1278454,
  },
  {
    name: "Ārangaon",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1278455,
  },
  {
    name: "Arang",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1278458,
  },
  {
    name: "Arāmbāgh",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1278466,
  },
  {
    name: "Arakkonam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1278471,
  },
  {
    name: "Arrah",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1278483,
  },
  {
    name: "Aonla",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1278498,
  },
  {
    name: "Anūpshahr",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1278507,
  },
  {
    name: "Anūppur",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1278508,
  },
  {
    name: "Anūpgarh",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1278510,
  },
  {
    name: "Anta",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1278532,
  },
  {
    name: "Anshing",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1278534,
  },
  {
    name: "Annur",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1278539,
  },
  {
    name: "Annigeri",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1278540,
  },
  {
    name: "Ankleshwar",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1278553,
  },
  {
    name: "Anjār",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1278573,
  },
  {
    name: "Anjangaon",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1278580,
  },
  {
    name: "Anjad",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1278588,
  },
  {
    name: "Angul",
    country: "India",
    subcountry: "Odisha",
    geonameid: 1278593,
  },
  {
    name: "Angamāli",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1278602,
  },
  {
    name: "Anekal",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1278609,
  },
  {
    name: "Andol",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1278621,
  },
  {
    name: "Anthiyur",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1278622,
  },
  {
    name: "Āndippatti",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1278625,
  },
  {
    name: "Anantnag",
    country: "India",
    subcountry: "Jammu and Kashmir",
    geonameid: 1278667,
  },
  {
    name: "Anantapur",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1278672,
  },
  {
    name: "Anandpur",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1278676,
  },
  {
    name: "Anand",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1278685,
  },
  {
    name: "Anakāpalle",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1278688,
  },
  {
    name: "Anamalais",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1278692,
  },
  {
    name: "Amudālavalasa",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1278698,
  },
  {
    name: "Āmta",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1278703,
  },
  {
    name: "Amroli",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1278707,
  },
  {
    name: "Amroha",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1278708,
  },
  {
    name: "Amritsar",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1278710,
  },
  {
    name: "Amreli",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1278715,
  },
  {
    name: "Amrāvati",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1278718,
  },
  {
    name: "Amod",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1278742,
  },
  {
    name: "Āmli",
    country: "India",
    subcountry: "Dadra and Nagar Haveli and Daman and Diu",
    geonameid: 1278768,
  },
  {
    name: "Āmlāgora",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1278774,
  },
  {
    name: "Amla",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1278775,
  },
  {
    name: "Amet",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1278808,
  },
  {
    name: "Ambur",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1278815,
  },
  {
    name: "Ambikāpur",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1278827,
  },
  {
    name: "Ambattūr",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1278840,
  },
  {
    name: "Ambasamudram",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1278841,
  },
  {
    name: "Ambāla",
    country: "India",
    subcountry: "Haryana",
    geonameid: 1278860,
  },
  {
    name: "Ambājogāi",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1278862,
  },
  {
    name: "Ambāh",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1278868,
  },
  {
    name: "Ambad",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1278871,
  },
  {
    name: "Amarpur",
    country: "India",
    subcountry: "Bihar",
    geonameid: 1278895,
  },
  {
    name: "Amarpātan",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1278899,
  },
  {
    name: "Amarnāth",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1278903,
  },
  {
    name: "Amalner",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1278931,
  },
  {
    name: "Amalāpuram",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1278935,
  },
  {
    name: "Alwaye",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1278941,
  },
  {
    name: "Alwar",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1278946,
  },
  {
    name: "Alot",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1278964,
  },
  {
    name: "Along",
    country: "India",
    subcountry: "Arunachal Pradesh",
    geonameid: 1278969,
  },
  {
    name: "Alnāvar",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1278973,
  },
  {
    name: "Almora",
    country: "India",
    subcountry: "Uttarakhand",
    geonameid: 1278974,
  },
  {
    name: "Alappuzha",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1278985,
  },
  {
    name: "Prayagraj",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1278994,
  },
  {
    name: "Alīpur Duār",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1279003,
  },
  {
    name: "Alīpur",
    country: "India",
    subcountry: "Delhi",
    geonameid: 1279005,
  },
  {
    name: "Alīgarh",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1279017,
  },
  {
    name: "Alīganj",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1279023,
  },
  {
    name: "Alībāg",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1279027,
  },
  {
    name: "Ālangulam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1279058,
  },
  {
    name: "Alangāyam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1279061,
  },
  {
    name: "Alandur",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1279064,
  },
  {
    name: "Alandi",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1279066,
  },
  {
    name: "Aland",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1279068,
  },
  {
    name: "Akot",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1279094,
  },
  {
    name: "Akola",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1279105,
  },
  {
    name: "Aklera",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1279115,
  },
  {
    name: "Akivīdu",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1279123,
  },
  {
    name: "Akbarpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1279134,
  },
  {
    name: "Akbarpur",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1279135,
  },
  {
    name: "Akaltara",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 1279144,
  },
  {
    name: "Akalkot",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1279147,
  },
  {
    name: "Ajra",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1279154,
  },
  {
    name: "Ajnāla",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1279158,
  },
  {
    name: "Ajmer",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1279159,
  },
  {
    name: "Aizawl",
    country: "India",
    subcountry: "Mizoram",
    geonameid: 1279186,
  },
  {
    name: "Ahraura",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1279219,
  },
  {
    name: "Ahmadpur",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1279227,
  },
  {
    name: "Ahmadnagar",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1279228,
  },
  {
    name: "Ahmedabad",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 1279233,
  },
  {
    name: "Agra",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1279259,
  },
  {
    name: "Agartala",
    country: "India",
    subcountry: "Tripura",
    geonameid: 1279290,
  },
  {
    name: "Agar",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 1279299,
  },
  {
    name: "Afzalpur",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1279306,
  },
  {
    name: "Afzalgarh",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1279307,
  },
  {
    name: "Adūr",
    country: "India",
    subcountry: "Kerala",
    geonameid: 1279323,
  },
  {
    name: "Adra",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1279334,
  },
  {
    name: "Ādoni",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1279335,
  },
  {
    name: "Ādilābād",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1279344,
  },
  {
    name: "Addanki",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 1279356,
  },
  {
    name: "Achhnera",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 1279382,
  },
  {
    name: "Achalpur",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 1279390,
  },
  {
    name: "Ābu Road",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1279394,
  },
  {
    name: "Ābu",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 1279396,
  },
  {
    name: "Abohar",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1279403,
  },
  {
    name: "Abhayāpuri",
    country: "India",
    subcountry: "Assam",
    geonameid: 1279407,
  },
  {
    name: "Contai",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1344069,
  },
  {
    name: "Haldia",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1344377,
  },
  {
    name: "Srirāmpur",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1348562,
  },
  {
    name: "Dumjor",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1348739,
  },
  {
    name: "Bankra",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1348747,
  },
  {
    name: "Chakapara",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1348753,
  },
  {
    name: "Mahiari",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1348775,
  },
  {
    name: "Dhulagari",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1348780,
  },
  {
    name: "Pānchla",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1348785,
  },
  {
    name: "Pujali",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1348820,
  },
  {
    name: "Maheshtala",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1348843,
  },
  {
    name: "Monoharpur",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 1349041,
  },
  {
    name: "Soyībug",
    country: "India",
    subcountry: "Jammu and Kashmir",
    geonameid: 1430991,
  },
  {
    name: "Singāpur",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1445156,
  },
  {
    name: "Ghatkesar",
    country: "India",
    subcountry: "Telangana",
    geonameid: 1445378,
  },
  {
    name: "Vadigenhalli",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 1462711,
  },
  {
    name: "Adampur",
    country: "India",
    subcountry: "Punjab",
    geonameid: 1462733,
  },
  {
    name: "Porur",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1465622,
  },
  {
    name: "Madipakkam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1465825,
  },
  {
    name: "Perungudi",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1465828,
  },
  {
    name: "Madambakkam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 1465910,
  },
  {
    name: "Powai",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 6324621,
  },
  {
    name: "Navi Mumbai",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 6619347,
  },
  {
    name: "Panchkula",
    country: "India",
    subcountry: "Haryana",
    geonameid: 6690108,
  },
  {
    name: "Murudeshwara",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 6941937,
  },
  {
    name: "Shivaji Nagar",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 6943660,
  },
  {
    name: "Greater Noida",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 6954929,
  },
  {
    name: "Mohali",
    country: "India",
    subcountry: "Punjab",
    geonameid: 6992326,
  },
  {
    name: "Pithampur",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 7279595,
  },
  {
    name: "Barbil",
    country: "India",
    subcountry: "Odisha",
    geonameid: 7279597,
  },
  {
    name: "Airoli",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 7279599,
  },
  {
    name: "Aluva",
    country: "India",
    subcountry: "Kerala",
    geonameid: 7279600,
  },
  {
    name: "Kotkapura",
    country: "India",
    subcountry: "Punjab",
    geonameid: 7279734,
  },
  {
    name: "Muvattupuzha",
    country: "India",
    subcountry: "Kerala",
    geonameid: 7279735,
  },
  {
    name: "Perumbavoor",
    country: "India",
    subcountry: "Kerala",
    geonameid: 7279739,
  },
  {
    name: "Vapi",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 7279741,
  },
  {
    name: "Baddi",
    country: "India",
    subcountry: "Himachal Pradesh",
    geonameid: 7279742,
  },
  {
    name: "Noida",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 7279746,
  },
  {
    name: "Bhiwadi",
    country: "India",
    subcountry: "Rajasthan",
    geonameid: 7279747,
  },
  {
    name: "Mandideep",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 7279752,
  },
  {
    name: "Singrauli",
    country: "India",
    subcountry: "Madhya Pradesh",
    geonameid: 7279754,
  },
  {
    name: "Birpara",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 7284803,
  },
  {
    name: "Jaigaon",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 7284820,
  },
  {
    name: "Akkarampalle",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 7302805,
  },
  {
    name: "Bellampalli",
    country: "India",
    subcountry: "Telangana",
    geonameid: 7302806,
  },
  {
    name: "Chemmumiahpet",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 7302808,
  },
  {
    name: "Gaddi Annaram",
    country: "India",
    subcountry: "Telangana",
    geonameid: 7302810,
  },
  {
    name: "Dasnapur",
    country: "India",
    subcountry: "Telangana",
    geonameid: 7302812,
  },
  {
    name: "Kanuru",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 7302825,
  },
  {
    name: "Lal Bahadur Nagar",
    country: "India",
    subcountry: "Telangana",
    geonameid: 7302826,
  },
  {
    name: "Malkajgiri",
    country: "India",
    subcountry: "Telangana",
    geonameid: 7302828,
  },
  {
    name: "Mandamarri",
    country: "India",
    subcountry: "Telangana",
    geonameid: 7302829,
  },
  {
    name: "Chinnachowk",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 7302830,
  },
  {
    name: "Kyathampalle",
    country: "India",
    subcountry: "Telangana",
    geonameid: 7302832,
  },
  {
    name: "Gajuwaka",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 7302833,
  },
  {
    name: "Manuguru",
    country: "India",
    subcountry: "Telangana",
    geonameid: 7302836,
  },
  {
    name: "Kalyandurg",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 7302838,
  },
  {
    name: "Ponnur",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 7302844,
  },
  {
    name: "Quthbullapur",
    country: "India",
    subcountry: "Telangana",
    geonameid: 7302845,
  },
  {
    name: "Ramanayyapeta",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 7302846,
  },
  {
    name: "Palwancha",
    country: "India",
    subcountry: "Telangana",
    geonameid: 7302847,
  },
  {
    name: "Barpeta Road",
    country: "India",
    subcountry: "Assam",
    geonameid: 7302849,
  },
  {
    name: "Sathupalli",
    country: "India",
    subcountry: "Telangana",
    geonameid: 7302851,
  },
  {
    name: "Yanamalakuduru",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 7302853,
  },
  {
    name: "Morigaon",
    country: "India",
    subcountry: "Assam",
    geonameid: 7302854,
  },
  {
    name: "Naharlagun",
    country: "India",
    subcountry: "Arunachal Pradesh",
    geonameid: 7302855,
  },
  {
    name: "Serilingampalle",
    country: "India",
    subcountry: "Telangana",
    geonameid: 7302856,
  },
  {
    name: "Silapathar",
    country: "India",
    subcountry: "Assam",
    geonameid: 7302857,
  },
  {
    name: "Lumding Railway Colony",
    country: "India",
    subcountry: "Assam",
    geonameid: 7302859,
  },
  {
    name: "Aistala",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 7302860,
  },
  {
    name: "Ashoknagar Kalyangarh",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 7302861,
  },
  {
    name: "Bahula",
    country: "India",
    subcountry: "West Bengal",
    geonameid: 7302862,
  },
  {
    name: "Bhawanipur",
    country: "India",
    subcountry: "Bihar",
    geonameid: 7626554,
  },
  {
    name: "Zira",
    country: "India",
    subcountry: "Punjab",
    geonameid: 7645176,
  },
  {
    name: "Kumarapalayam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 8223943,
  },
  {
    name: "Ramagundam",
    country: "India",
    subcountry: "Telangana",
    geonameid: 8347656,
  },
  {
    name: "Cherpulassery",
    country: "India",
    subcountry: "Kerala",
    geonameid: 8504418,
  },
  {
    name: "Kirandul",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 8581647,
  },
  {
    name: "Thoothukudi",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 8629640,
  },
  {
    name: "Shiraguppi",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 8714565,
  },
  {
    name: "Gadag-Betageri",
    country: "India",
    subcountry: "Karnataka",
    geonameid: 8740017,
  },
  {
    name: "V.S.K.Valasai (Dindigul-Dist.)",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 8948694,
  },
  {
    name: "Neelankarai",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 9212568,
  },
  {
    name: "Injambakkam",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 9212569,
  },
  {
    name: "Shahbazpur",
    country: "India",
    subcountry: "Bihar",
    geonameid: 9794300,
  },
  {
    name: "Deoli",
    country: "India",
    subcountry: "Delhi",
    geonameid: 10263232,
  },
  {
    name: "Kumbalam",
    country: "India",
    subcountry: "Kerala",
    geonameid: 10627510,
  },
  {
    name: "Aroor",
    country: "India",
    subcountry: "Kerala",
    geonameid: 10628607,
  },
  {
    name: "Kadakkavoor",
    country: "India",
    subcountry: "Kerala",
    geonameid: 10628608,
  },
  {
    name: "Kalavoor",
    country: "India",
    subcountry: "Kerala",
    geonameid: 10629189,
  },
  {
    name: "Kalamassery",
    country: "India",
    subcountry: "Kerala",
    geonameid: 10630431,
  },
  {
    name: "Cherthala",
    country: "India",
    subcountry: "Kerala",
    geonameid: 10792588,
  },
  {
    name: "Azhiyūr",
    country: "India",
    subcountry: "Kerala",
    geonameid: 10924927,
  },
  {
    name: "Abrama",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 11102685,
  },
  {
    name: "Phusro",
    country: "India",
    subcountry: "Jharkhand",
    geonameid: 11127930,
  },
  {
    name: "Alangad",
    country: "India",
    subcountry: "Kerala",
    geonameid: 11184118,
  },
  {
    name: "Savarkundla",
    country: "India",
    subcountry: "Gujarat",
    geonameid: 11184442,
  },
  {
    name: "Malkapur",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 11185528,
  },
  {
    name: "Podaturpet",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 11421465,
  },
  {
    name: "Rohini",
    country: "India",
    subcountry: "Delhi",
    geonameid: 12069922,
  },
  {
    name: "Mulugu",
    country: "India",
    subcountry: "Telangana",
    geonameid: 12165955,
  },
  {
    name: "Kallakurichi",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 12165956,
  },
  {
    name: "Amaravati",
    country: "India",
    subcountry: "Andhra Pradesh",
    geonameid: 12261477,
  },
  {
    name: "Chirmiri",
    country: "India",
    subcountry: "Chhattisgarh",
    geonameid: 12495083,
  },
  {
    name: "Paramathi Velur",
    country: "India",
    subcountry: "Tamil Nadu",
    geonameid: 12501142,
  },
  {
    name: "Kanayannur",
    country: "India",
    subcountry: "Kerala",
    geonameid: 12501153,
  },
  {
    name: "Shahuwadi",
    country: "India",
    subcountry: "Maharashtra",
    geonameid: 12501195,
  },
  {
    name: "Lalganj",
    country: "India",
    subcountry: "Uttar Pradesh",
    geonameid: 12501265,
  },
  {
    name: "Zaxo",
    country: "Iraq",
    subcountry: "Duhok",
    geonameid: 89570,
  },
  {
    name: "Umm Qaşr",
    country: "Iraq",
    subcountry: "Basra",
    geonameid: 89824,
  },
  {
    name: "Ţūz Khūrmātū",
    country: "Iraq",
    subcountry: "Salah ad Din",
    geonameid: 90026,
  },
  {
    name: "Tikrīt",
    country: "Iraq",
    subcountry: "Salah ad Din",
    geonameid: 90150,
  },
  {
    name: "Tallkayf",
    country: "Iraq",
    subcountry: "Nineveh",
    geonameid: 90353,
  },
  {
    name: "Sīnah",
    country: "Iraq",
    subcountry: "Duhok",
    geonameid: 90708,
  },
  {
    name: "Sāmarrā’",
    country: "Iraq",
    subcountry: "Salah ad Din",
    geonameid: 91597,
  },
  {
    name: "Nāḩīyat Saddat al Hindīyah",
    country: "Iraq",
    subcountry: "Bābil",
    geonameid: 91812,
  },
  {
    name: "Ṟuwandiz",
    country: "Iraq",
    subcountry: "Arbīl",
    geonameid: 92002,
  },
  {
    name: "Al-Hamdaniya",
    country: "Iraq",
    subcountry: "Nineveh",
    geonameid: 92430,
  },
  {
    name: "Mandalī",
    country: "Iraq",
    subcountry: "Diyālá",
    geonameid: 93709,
  },
  {
    name: "Koysinceq",
    country: "Iraq",
    subcountry: "Arbīl",
    geonameid: 94220,
  },
  {
    name: "Kifrī",
    country: "Iraq",
    subcountry: "Diyālá",
    geonameid: 94298,
  },
  {
    name: "Kirkuk",
    country: "Iraq",
    subcountry: "Kirkuk",
    geonameid: 94787,
  },
  {
    name: "Karbala",
    country: "Iraq",
    subcountry: "Karbalāʼ",
    geonameid: 94824,
  },
  {
    name: "Erbil",
    country: "Iraq",
    subcountry: "Arbīl",
    geonameid: 95446,
  },
  {
    name: "Hīt",
    country: "Iraq",
    subcountry: "Al Anbar",
    geonameid: 95788,
  },
  {
    name: "Ḩalabja",
    country: "Iraq",
    subcountry: "Sulaymaniyah",
    geonameid: 96205,
  },
  {
    name: "Ḩadīthah",
    country: "Iraq",
    subcountry: "Al Anbar",
    geonameid: 96309,
  },
  {
    name: "Soran",
    country: "Iraq",
    subcountry: "Arbīl",
    geonameid: 96961,
  },
  {
    name: "Dihok",
    country: "Iraq",
    subcountry: "Duhok",
    geonameid: 96994,
  },
  {
    name: "Jamjamāl",
    country: "Iraq",
    subcountry: "Sulaymaniyah",
    geonameid: 97417,
  },
  {
    name: "Bayjī",
    country: "Iraq",
    subcountry: "Salah ad Din",
    geonameid: 97783,
  },
  {
    name: "Batifa",
    country: "Iraq",
    subcountry: "Duhok",
    geonameid: 97825,
  },
  {
    name: "Baqubah",
    country: "Iraq",
    subcountry: "Diyālá",
    geonameid: 97990,
  },
  {
    name: "Baynjiwayn",
    country: "Iraq",
    subcountry: "Sulaymaniyah",
    geonameid: 98012,
  },
  {
    name: "Balad",
    country: "Iraq",
    subcountry: "Salah ad Din",
    geonameid: 98112,
  },
  {
    name: "Baghdad",
    country: "Iraq",
    subcountry: "Baghdad",
    geonameid: 98182,
  },
  {
    name: "Az Zubayr",
    country: "Iraq",
    subcountry: "Basra",
    geonameid: 98245,
  },
  {
    name: "Aş Şuwayrah",
    country: "Iraq",
    subcountry: "Wāsiţ",
    geonameid: 98459,
  },
  {
    name: "As Sulaymānīyah",
    country: "Iraq",
    subcountry: "Sulaymaniyah",
    geonameid: 98463,
  },
  {
    name: "As Samawah",
    country: "Iraq",
    subcountry: "Al Muthanná",
    geonameid: 98530,
  },
  {
    name: "Nāḩiyat ash Shināfīyah",
    country: "Iraq",
    subcountry: "Al Qādisīyah",
    geonameid: 98589,
  },
  {
    name: "Ash Shaţrah",
    country: "Iraq",
    subcountry: "Dhi Qar",
    geonameid: 98622,
  },
  {
    name: "Ash Shāmīyah",
    country: "Iraq",
    subcountry: "Al Qādisīyah",
    geonameid: 98629,
  },
  {
    name: "Ar Ruţbah",
    country: "Iraq",
    subcountry: "Al Anbar",
    geonameid: 98677,
  },
  {
    name: "Ar Rumaythah",
    country: "Iraq",
    subcountry: "Al Muthanná",
    geonameid: 98685,
  },
  {
    name: "Ramadi",
    country: "Iraq",
    subcountry: "Al Anbar",
    geonameid: 98717,
  },
  {
    name: "‘Aqrah",
    country: "Iraq",
    subcountry: "Nineveh",
    geonameid: 98822,
  },
  {
    name: "An Nu‘mānīyah",
    country: "Iraq",
    subcountry: "Wāsiţ",
    geonameid: 98846,
  },
  {
    name: "Nasiriyah",
    country: "Iraq",
    subcountry: "Dhi Qar",
    geonameid: 98854,
  },
  {
    name: "Najaf",
    country: "Iraq",
    subcountry: "An Najaf",
    geonameid: 98860,
  },
  {
    name: "‘Anat al Qadīmah",
    country: "Iraq",
    subcountry: "Al Anbar",
    geonameid: 98885,
  },
  {
    name: "Imam Qasim",
    country: "Iraq",
    subcountry: "Bābil",
    geonameid: 99010,
  },
  {
    name: "Al Musayyib",
    country: "Iraq",
    subcountry: "Bābil",
    geonameid: 99039,
  },
  {
    name: "Al Mishkhāb",
    country: "Iraq",
    subcountry: "An Najaf",
    geonameid: 99060,
  },
  {
    name: "Al Miqdādīyah",
    country: "Iraq",
    subcountry: "Diyālá",
    geonameid: 99062,
  },
  {
    name: "Al Mawşil al Jadīdah",
    country: "Iraq",
    subcountry: "Nineveh",
    geonameid: 99071,
  },
  {
    name: "Mosul",
    country: "Iraq",
    subcountry: "Nineveh",
    geonameid: 99072,
  },
  {
    name: "Al Kūt",
    country: "Iraq",
    subcountry: "Wāsiţ",
    geonameid: 99131,
  },
  {
    name: "Kufa",
    country: "Iraq",
    subcountry: "An Najaf",
    geonameid: 99135,
  },
  {
    name: "Khāliş",
    country: "Iraq",
    subcountry: "Diyālá",
    geonameid: 99169,
  },
  {
    name: "‘Alī al Gharbī",
    country: "Iraq",
    subcountry: "Maysan",
    geonameid: 99306,
  },
  {
    name: "Al Hindīyah",
    country: "Iraq",
    subcountry: "Karbalāʼ",
    geonameid: 99344,
  },
  {
    name: "Al Ḩillah",
    country: "Iraq",
    subcountry: "Bābil",
    geonameid: 99347,
  },
  {
    name: "Al Ḩayy",
    country: "Iraq",
    subcountry: "Wāsiţ",
    geonameid: 99350,
  },
  {
    name: "Al Hārithah",
    country: "Iraq",
    subcountry: "Basra",
    geonameid: 99369,
  },
  {
    name: "Nahiyat Ghammas",
    country: "Iraq",
    subcountry: "Al Qādisīyah",
    geonameid: 99434,
  },
  {
    name: "Nāḩiyat al Fuhūd",
    country: "Iraq",
    subcountry: "Dhi Qar",
    geonameid: 99439,
  },
  {
    name: "Al Fāw",
    country: "Iraq",
    subcountry: "Basra",
    geonameid: 99446,
  },
  {
    name: "Al Fallūjah",
    country: "Iraq",
    subcountry: "Al Anbar",
    geonameid: 99454,
  },
  {
    name: "Basrah",
    country: "Iraq",
    subcountry: "Basra",
    geonameid: 99532,
  },
  {
    name: "Al ‘Azīzīyah",
    country: "Iraq",
    subcountry: "Wāsiţ",
    geonameid: 99548,
  },
  {
    name: "Al ‘Amārah",
    country: "Iraq",
    subcountry: "Maysan",
    geonameid: 99608,
  },
  {
    name: "‘Afak",
    country: "Iraq",
    subcountry: "Al Qādisīyah",
    geonameid: 99738,
  },
  {
    name: "Ad Dujayl",
    country: "Iraq",
    subcountry: "Salah ad Din",
    geonameid: 99759,
  },
  {
    name: "Ad Dīwānīyah",
    country: "Iraq",
    subcountry: "Al Qādisīyah",
    geonameid: 99762,
  },
  {
    name: "Abū Ghurayb",
    country: "Iraq",
    subcountry: "Baghdad",
    geonameid: 100077,
  },
  {
    name: "Al Başrah al Qadīmah",
    country: "Iraq",
    subcountry: "Basra",
    geonameid: 388349,
  },
  {
    name: "Hajiawa",
    country: "Iraq",
    subcountry: "Sulaymaniyah",
    geonameid: 447022,
  },
  {
    name: "Sinjār",
    country: "Iraq",
    subcountry: "Nineveh",
    geonameid: 448149,
  },
  {
    name: "‘Anah",
    country: "Iraq",
    subcountry: "Al Anbar",
    geonameid: 6765385,
  },
  {
    name: "Alvand",
    country: "Iran",
    subcountry: "Qazvīn",
    geonameid: 10570,
  },
  {
    name: "Āzādshahr",
    country: "Iran",
    subcountry: "Hamadān",
    geonameid: 14256,
  },
  {
    name: "Kahrīz",
    country: "Iran",
    subcountry: "Kermānshāh",
    geonameid: 23814,
  },
  {
    name: "Nūrābād",
    country: "Iran",
    subcountry: "Lorestan Province",
    geonameid: 24851,
  },
  {
    name: "Īstgāh-e Rāh Āhan-e Garmsār",
    country: "Iran",
    subcountry: "Semnan",
    geonameid: 32723,
  },
  {
    name: "Qarchak",
    country: "Iran",
    subcountry: "Tehran",
    geonameid: 32767,
  },
  {
    name: "Shahre Jadide Andisheh",
    country: "Iran",
    subcountry: "Tehran",
    geonameid: 32909,
  },
  {
    name: "Khorramdarreh",
    country: "Iran",
    subcountry: "Zanjan",
    geonameid: 41210,
  },
  {
    name: "Pādegān-e Manjīl",
    country: "Iran",
    subcountry: "Gīlān",
    geonameid: 41428,
  },
  {
    name: "Yasuj",
    country: "Iran",
    subcountry: "Kohgiluyeh and Boyer-Ahmad",
    geonameid: 66093,
  },
  {
    name: "Āzādshahr",
    country: "Iran",
    subcountry: "Golestan",
    geonameid: 110831,
  },
  {
    name: "Zarand",
    country: "Iran",
    subcountry: "Kerman",
    geonameid: 111421,
  },
  {
    name: "Zanjān",
    country: "Iran",
    subcountry: "Zanjan",
    geonameid: 111453,
  },
  {
    name: "Yazd",
    country: "Iran",
    subcountry: "Yazd",
    geonameid: 111822,
  },
  {
    name: "Varāmīn",
    country: "Iran",
    subcountry: "Tehran",
    geonameid: 112214,
  },
  {
    name: "Torbat-e Ḩeydarīyeh",
    country: "Iran",
    subcountry: "Razavi Khorasan",
    geonameid: 112646,
  },
  {
    name: "Tonekābon",
    country: "Iran",
    subcountry: "Māzandarān",
    geonameid: 112656,
  },
  {
    name: "Tehran",
    country: "Iran",
    subcountry: "Tehran",
    geonameid: 112931,
  },
  {
    name: "Hashtpar",
    country: "Iran",
    subcountry: "Gīlān",
    geonameid: 113343,
  },
  {
    name: "Tākestān",
    country: "Iran",
    subcountry: "Qazvīn",
    geonameid: 113491,
  },
  {
    name: "Takāb",
    country: "Iran",
    subcountry: "West Azerbaijan",
    geonameid: 113508,
  },
  {
    name: "Taft",
    country: "Iran",
    subcountry: "Yazd",
    geonameid: 113632,
  },
  {
    name: "Tabriz",
    country: "Iran",
    subcountry: "East Azerbaijan",
    geonameid: 113646,
  },
  {
    name: "Tabas",
    country: "Iran",
    subcountry: "Yazd",
    geonameid: 113659,
  },
  {
    name: "Surian",
    country: "Iran",
    subcountry: "Fars",
    geonameid: 113723,
  },
  {
    name: "Sonqor",
    country: "Iran",
    subcountry: "Kermānshāh",
    geonameid: 114049,
  },
  {
    name: "Sirjan",
    country: "Iran",
    subcountry: "Kerman",
    geonameid: 114259,
  },
  {
    name: "Shūshtar",
    country: "Iran",
    subcountry: "Khuzestan",
    geonameid: 114584,
  },
  {
    name: "Shūsh",
    country: "Iran",
    subcountry: "Khuzestan",
    geonameid: 114593,
  },
  {
    name: "Shīrvān",
    country: "Iran",
    subcountry: "North Khorasan",
    geonameid: 114930,
  },
  {
    name: "Shiraz",
    country: "Iran",
    subcountry: "Fars",
    geonameid: 115019,
  },
  {
    name: "Shahr-e Kord",
    country: "Iran",
    subcountry: "Chaharmahal and Bakhtiari",
    geonameid: 115770,
  },
  {
    name: "Shahr-e Bābak",
    country: "Iran",
    subcountry: "Kerman",
    geonameid: 115781,
  },
  {
    name: "Shādegān",
    country: "Iran",
    subcountry: "Khuzestan",
    geonameid: 116102,
  },
  {
    name: "Semnan",
    country: "Iran",
    subcountry: "Semnan",
    geonameid: 116402,
  },
  {
    name: "Semīrom",
    country: "Iran",
    subcountry: "Isfahan",
    geonameid: 116406,
  },
  {
    name: "Sāveh",
    country: "Iran",
    subcountry: "Markazi",
    geonameid: 116667,
  },
  {
    name: "Sari",
    country: "Iran",
    subcountry: "Māzandarān",
    geonameid: 116996,
  },
  {
    name: "Saqqez",
    country: "Iran",
    subcountry: "Kordestān",
    geonameid: 117392,
  },
  {
    name: "Sanandaj",
    country: "Iran",
    subcountry: "Kordestān",
    geonameid: 117574,
  },
  {
    name: "Salmās",
    country: "Iran",
    subcountry: "West Azerbaijan",
    geonameid: 117656,
  },
  {
    name: "Shāhīn Dezh",
    country: "Iran",
    subcountry: "West Azerbaijan",
    geonameid: 117793,
  },
  {
    name: "Sabzevar",
    country: "Iran",
    subcountry: "Razavi Khorasan",
    geonameid: 118063,
  },
  {
    name: "Rūdsar",
    country: "Iran",
    subcountry: "Gīlān",
    geonameid: 118191,
  },
  {
    name: "Robāţ Karīm",
    country: "Iran",
    subcountry: "Tehran",
    geonameid: 118367,
  },
  {
    name: "Rāvar",
    country: "Iran",
    subcountry: "Kerman",
    geonameid: 118704,
  },
  {
    name: "Rasht",
    country: "Iran",
    subcountry: "Gīlān",
    geonameid: 118743,
  },
  {
    name: "Rāmshīr",
    country: "Iran",
    subcountry: "Khuzestan",
    geonameid: 118805,
  },
  {
    name: "Rāmhormoz",
    country: "Iran",
    subcountry: "Khuzestan",
    geonameid: 118826,
  },
  {
    name: "Rafsanjān",
    country: "Iran",
    subcountry: "Kerman",
    geonameid: 118994,
  },
  {
    name: "Qūchān",
    country: "Iran",
    subcountry: "Razavi Khorasan",
    geonameid: 119115,
  },
  {
    name: "Qorveh",
    country: "Iran",
    subcountry: "Kordestān",
    geonameid: 119161,
  },
  { name: "Qom", country: "Iran", subcountry: "Qom", geonameid: 119208 },
  {
    name: "Qeshm",
    country: "Iran",
    subcountry: "Hormozgan",
    geonameid: 119374,
  },
  {
    name: "Qazvin",
    country: "Iran",
    subcountry: "Qazvīn",
    geonameid: 119505,
  },
  {
    name: "Qarah Ẕīā’ od Dīn",
    country: "Iran",
    subcountry: "West Azerbaijan",
    geonameid: 119730,
  },
  {
    name: "Farrokh Shahr",
    country: "Iran",
    subcountry: "Chaharmahal and Bakhtiari",
    geonameid: 120678,
  },
  {
    name: "Qā’en",
    country: "Iran",
    subcountry: "South Khorasan Province",
    geonameid: 120694,
  },
  {
    name: "Sarpol-e Z̄ahāb",
    country: "Iran",
    subcountry: "Kermānshāh",
    geonameid: 120931,
  },
  {
    name: "Pīshvā",
    country: "Iran",
    subcountry: "Tehran",
    geonameid: 120972,
  },
  {
    name: "Piranshahr",
    country: "Iran",
    subcountry: "West Azerbaijan",
    geonameid: 121110,
  },
  {
    name: "Pāveh",
    country: "Iran",
    subcountry: "Kermānshāh",
    geonameid: 121240,
  },
  {
    name: "Pārsābād",
    country: "Iran",
    subcountry: "Ardabīl",
    geonameid: 121380,
  },
  {
    name: "Oshnavīyeh",
    country: "Iran",
    subcountry: "West Azerbaijan",
    geonameid: 121795,
  },
  {
    name: "Orūmīyeh",
    country: "Iran",
    subcountry: "West Azerbaijan",
    geonameid: 121801,
  },
  {
    name: "Omīdīyeh",
    country: "Iran",
    subcountry: "Khuzestan",
    geonameid: 121861,
  },
  {
    name: "Nūrābād",
    country: "Iran",
    subcountry: "Fars",
    geonameid: 121925,
  },
  {
    name: "Nowshahr",
    country: "Iran",
    subcountry: "Māzandarān",
    geonameid: 121959,
  },
  {
    name: "Neyshābūr",
    country: "Iran",
    subcountry: "Razavi Khorasan",
    geonameid: 122285,
  },
  {
    name: "Neyrīz",
    country: "Iran",
    subcountry: "Fars",
    geonameid: 122289,
  },
  {
    name: "Nekā",
    country: "Iran",
    subcountry: "Māzandarān",
    geonameid: 122397,
  },
  {
    name: "Naz̧arābād",
    country: "Iran",
    subcountry: "Alborz Province",
    geonameid: 122438,
  },
  {
    name: "Naqadeh",
    country: "Iran",
    subcountry: "West Azerbaijan",
    geonameid: 122698,
  },
  {
    name: "Nahāvand",
    country: "Iran",
    subcountry: "Hamadān",
    geonameid: 122915,
  },
  {
    name: "Mohr",
    country: "Iran",
    subcountry: "Fars",
    geonameid: 123485,
  },
  {
    name: "Mīnāb",
    country: "Iran",
    subcountry: "Hormozgan",
    geonameid: 123941,
  },
  {
    name: "Mīāndoāb",
    country: "Iran",
    subcountry: "West Azerbaijan",
    geonameid: 124085,
  },
  {
    name: "Meybod",
    country: "Iran",
    subcountry: "Yazd",
    geonameid: 124193,
  },
  {
    name: "Mahrīz",
    country: "Iran",
    subcountry: "Yazd",
    geonameid: 124274,
  },
  {
    name: "Masjed Soleymān",
    country: "Iran",
    subcountry: "Khuzestan",
    geonameid: 124620,
  },
  {
    name: "Bardsīr",
    country: "Iran",
    subcountry: "Kerman",
    geonameid: 124647,
  },
  {
    name: "Mashhad",
    country: "Iran",
    subcountry: "Razavi Khorasan",
    geonameid: 124665,
  },
  {
    name: "Marvdasht",
    country: "Iran",
    subcountry: "Fars",
    geonameid: 124721,
  },
  {
    name: "Marīvān",
    country: "Iran",
    subcountry: "Kordestān",
    geonameid: 124778,
  },
  {
    name: "Marand",
    country: "Iran",
    subcountry: "East Azerbaijan",
    geonameid: 124862,
  },
  {
    name: "Manjīl",
    country: "Iran",
    subcountry: "Gīlān",
    geonameid: 124967,
  },
  {
    name: "Malāyer",
    country: "Iran",
    subcountry: "Hamadān",
    geonameid: 125185,
  },
  {
    name: "Malārd",
    country: "Iran",
    subcountry: "Tehran",
    geonameid: 125188,
  },
  {
    name: "Mahābād",
    country: "Iran",
    subcountry: "West Azerbaijan",
    geonameid: 125446,
  },
  {
    name: "Langarūd",
    country: "Iran",
    subcountry: "Gīlān",
    geonameid: 125897,
  },
  {
    name: "Kūhdasht",
    country: "Iran",
    subcountry: "Lorestan Province",
    geonameid: 126409,
  },
  {
    name: "Kīsh",
    country: "Iran",
    subcountry: "Hormozgan",
    geonameid: 126914,
  },
  {
    name: "Khowy",
    country: "Iran",
    subcountry: "West Azerbaijan",
    geonameid: 126972,
  },
  {
    name: "Khvānsār",
    country: "Iran",
    subcountry: "Isfahan",
    geonameid: 127033,
  },
  {
    name: "Khorramshahr",
    country: "Iran",
    subcountry: "Khuzestan",
    geonameid: 127319,
  },
  {
    name: "Khorramabad",
    country: "Iran",
    subcountry: "Lorestan Province",
    geonameid: 127349,
  },
  {
    name: "Khomeyn",
    country: "Iran",
    subcountry: "Markazi",
    geonameid: 127403,
  },
  {
    name: "Khalkhāl",
    country: "Iran",
    subcountry: "Ardabīl",
    geonameid: 128008,
  },
  {
    name: "Kermanshah",
    country: "Iran",
    subcountry: "Kermānshāh",
    geonameid: 128226,
  },
  {
    name: "Kerman",
    country: "Iran",
    subcountry: "Kerman",
    geonameid: 128234,
  },
  {
    name: "Kāzerūn",
    country: "Iran",
    subcountry: "Fars",
    geonameid: 128321,
  },
  {
    name: "Kāshmar",
    country: "Iran",
    subcountry: "Razavi Khorasan",
    geonameid: 128447,
  },
  {
    name: "Karaj",
    country: "Iran",
    subcountry: "Alborz Province",
    geonameid: 128747,
  },
  {
    name: "Kangāvar",
    country: "Iran",
    subcountry: "Kermānshāh",
    geonameid: 128831,
  },
  {
    name: "Kāmyārān",
    country: "Iran",
    subcountry: "Kordestān",
    geonameid: 128905,
  },
  {
    name: "Kalāleh",
    country: "Iran",
    subcountry: "Golestan",
    geonameid: 129512,
  },
  {
    name: "Jūybār",
    country: "Iran",
    subcountry: "Māzandarān",
    geonameid: 129933,
  },
  {
    name: "Javānrūd",
    country: "Iran",
    subcountry: "Kermānshāh",
    geonameid: 130245,
  },
  {
    name: "Īlām",
    country: "Iran",
    subcountry: "Ilam Province",
    geonameid: 130802,
  },
  {
    name: "Harsīn",
    country: "Iran",
    subcountry: "Kermānshāh",
    geonameid: 131962,
  },
  {
    name: "Hamadān",
    country: "Iran",
    subcountry: "Hamadān",
    geonameid: 132144,
  },
  {
    name: "Ḩājjīābād",
    country: "Iran",
    subcountry: "Hormozgan",
    geonameid: 132382,
  },
  {
    name: "Gorgān",
    country: "Iran",
    subcountry: "Golestan",
    geonameid: 132892,
  },
  {
    name: "Gonbad-e Kāvūs",
    country: "Iran",
    subcountry: "Golestan",
    geonameid: 132938,
  },
  {
    name: "Gonābād",
    country: "Iran",
    subcountry: "Razavi Khorasan",
    geonameid: 132961,
  },
  {
    name: "Golpāyegān",
    country: "Iran",
    subcountry: "Isfahan",
    geonameid: 133037,
  },
  {
    name: "Gerāsh",
    country: "Iran",
    subcountry: "Fars",
    geonameid: 133595,
  },
  {
    name: "Bandar-e Genāveh",
    country: "Iran",
    subcountry: "Bushehr",
    geonameid: 134217,
  },
  {
    name: "Fūman",
    country: "Iran",
    subcountry: "Gīlān",
    geonameid: 134441,
  },
  {
    name: "Fīrūzābād",
    country: "Iran",
    subcountry: "Fars",
    geonameid: 134518,
  },
  {
    name: "Fereydūn Kenār",
    country: "Iran",
    subcountry: "Māzandarān",
    geonameid: 134602,
  },
  {
    name: "Fasā",
    country: "Iran",
    subcountry: "Fars",
    geonameid: 134721,
  },
  {
    name: "Fārsān",
    country: "Iran",
    subcountry: "Chaharmahal and Bakhtiari",
    geonameid: 134762,
  },
  {
    name: "Esfarāyen",
    country: "Iran",
    subcountry: "North Khorasan",
    geonameid: 135298,
  },
  {
    name: "Shahrud",
    country: "Iran",
    subcountry: "Semnan",
    geonameid: 135423,
  },
  {
    name: "Dogonbadan",
    country: "Iran",
    subcountry: "Kohgiluyeh and Boyer-Ahmad",
    geonameid: 136014,
  },
  {
    name: "Delījān",
    country: "Iran",
    subcountry: "Markazi",
    geonameid: 136399,
  },
  {
    name: "Dehlorān",
    country: "Iran",
    subcountry: "Ilam Province",
    geonameid: 136702,
  },
  {
    name: "Dehdasht",
    country: "Iran",
    subcountry: "Kohgiluyeh and Boyer-Ahmad",
    geonameid: 136987,
  },
  {
    name: "Sūsangerd",
    country: "Iran",
    subcountry: "Khuzestan",
    geonameid: 137268,
  },
  {
    name: "Darreh Shahr",
    country: "Iran",
    subcountry: "Ilam Province",
    geonameid: 137436,
  },
  {
    name: "Dārāb",
    country: "Iran",
    subcountry: "Fars",
    geonameid: 137956,
  },
  {
    name: "Dāmghān",
    country: "Iran",
    subcountry: "Semnan",
    geonameid: 138025,
  },
  {
    name: "Damāvand",
    country: "Iran",
    subcountry: "Tehran",
    geonameid: 138042,
  },
  {
    name: "Chenārān",
    country: "Iran",
    subcountry: "Razavi Khorasan",
    geonameid: 138742,
  },
  {
    name: "Chālūs",
    country: "Iran",
    subcountry: "Māzandarān",
    geonameid: 139223,
  },
  {
    name: "Bushehr",
    country: "Iran",
    subcountry: "Bushehr",
    geonameid: 139817,
  },
  {
    name: "Būkān",
    country: "Iran",
    subcountry: "West Azerbaijan",
    geonameid: 139889,
  },
  {
    name: "Borūjerd",
    country: "Iran",
    subcountry: "Lorestan Province",
    geonameid: 140044,
  },
  {
    name: "Borūjen",
    country: "Iran",
    subcountry: "Chaharmahal and Bakhtiari",
    geonameid: 140046,
  },
  {
    name: "Borāzjān",
    country: "Iran",
    subcountry: "Bushehr",
    geonameid: 140097,
  },
  {
    name: "Bojnūrd",
    country: "Iran",
    subcountry: "North Khorasan",
    geonameid: 140380,
  },
  {
    name: "Bīrjand",
    country: "Iran",
    subcountry: "South Khorasan Province",
    geonameid: 140463,
  },
  {
    name: "Bījār",
    country: "Iran",
    subcountry: "Kordestān",
    geonameid: 140521,
  },
  {
    name: "Bonāb",
    country: "Iran",
    subcountry: "East Azerbaijan",
    geonameid: 140889,
  },
  {
    name: "Behshahr",
    country: "Iran",
    subcountry: "Māzandarān",
    geonameid: 140918,
  },
  {
    name: "Behbahān",
    country: "Iran",
    subcountry: "Khuzestan",
    geonameid: 140951,
  },
  {
    name: "Bardaskan",
    country: "Iran",
    subcountry: "Razavi Khorasan",
    geonameid: 141349,
  },
  {
    name: "Bāneh",
    country: "Iran",
    subcountry: "Kordestān",
    geonameid: 141584,
  },
  {
    name: "Bandar-e Lengeh",
    country: "Iran",
    subcountry: "Hormozgan",
    geonameid: 141665,
  },
  {
    name: "Bandar-e Anzalī",
    country: "Iran",
    subcountry: "Gīlān",
    geonameid: 141679,
  },
  {
    name: "Bandar Abbas",
    country: "Iran",
    subcountry: "Hormozgan",
    geonameid: 141681,
  },
  {
    name: "Bam",
    country: "Iran",
    subcountry: "Kerman",
    geonameid: 141736,
  },
  {
    name: "Bahār",
    country: "Iran",
    subcountry: "Hamadān",
    geonameid: 142000,
  },
  {
    name: "Bāfq",
    country: "Iran",
    subcountry: "Yazd",
    geonameid: 142255,
  },
  {
    name: "Bābolsar",
    country: "Iran",
    subcountry: "Māzandarān",
    geonameid: 142358,
  },
  {
    name: "Bābol",
    country: "Iran",
    subcountry: "Māzandarān",
    geonameid: 142363,
  },
  {
    name: "Aznā",
    country: "Iran",
    subcountry: "Lorestan Province",
    geonameid: 142496,
  },
  {
    name: "Hashtrūd",
    country: "Iran",
    subcountry: "East Azerbaijan",
    geonameid: 142554,
  },
  {
    name: "Āstārā",
    country: "Iran",
    subcountry: "Gīlān",
    geonameid: 142676,
  },
  {
    name: "Āstāneh-ye Ashrafīyeh",
    country: "Iran",
    subcountry: "Gīlān",
    geonameid: 142679,
  },
  {
    name: "Asadābād",
    country: "Iran",
    subcountry: "Hamadān",
    geonameid: 142872,
  },
  {
    name: "Ardestān",
    country: "Iran",
    subcountry: "Isfahan",
    geonameid: 143052,
  },
  {
    name: "Ardakān",
    country: "Iran",
    subcountry: "Yazd",
    geonameid: 143073,
  },
  {
    name: "Ardabīl",
    country: "Iran",
    subcountry: "Ardabīl",
    geonameid: 143083,
  },
  {
    name: "Arāk",
    country: "Iran",
    subcountry: "Markazi",
    geonameid: 143127,
  },
  {
    name: "Āmol",
    country: "Iran",
    subcountry: "Māzandarān",
    geonameid: 143534,
  },
  {
    name: "Alvand",
    country: "Iran",
    subcountry: "Zanjan",
    geonameid: 143748,
  },
  {
    name: "Shahrīār",
    country: "Iran",
    subcountry: "Tehran",
    geonameid: 143860,
  },
  {
    name: "Alīgūdarz",
    country: "Iran",
    subcountry: "Lorestan Province",
    geonameid: 143921,
  },
  {
    name: "Aleshtar",
    country: "Iran",
    subcountry: "Lorestan Province",
    geonameid: 144269,
  },
  {
    name: "Akbarābād",
    country: "Iran",
    subcountry: "Fars",
    geonameid: 144410,
  },
  {
    name: "Ajab Shīr",
    country: "Iran",
    subcountry: "East Azerbaijan",
    geonameid: 144443,
  },
  {
    name: "Ahvaz",
    country: "Iran",
    subcountry: "Khuzestan",
    geonameid: 144448,
  },
  {
    name: "Ahar",
    country: "Iran",
    subcountry: "East Azerbaijan",
    geonameid: 144616,
  },
  {
    name: "Aghajari",
    country: "Iran",
    subcountry: "Khuzestan",
    geonameid: 144696,
  },
  {
    name: "Ābyek",
    country: "Iran",
    subcountry: "Markazi",
    geonameid: 144794,
  },
  {
    name: "Abhar",
    country: "Iran",
    subcountry: "Zanjan",
    geonameid: 145034,
  },
  {
    name: "Ābdānān",
    country: "Iran",
    subcountry: "Ilam Province",
    geonameid: 145233,
  },
  {
    name: "Abadeh",
    country: "Iran",
    subcountry: "Fars",
    geonameid: 145449,
  },
  {
    name: "Abadan",
    country: "Iran",
    subcountry: "Khuzestan",
    geonameid: 145459,
  },
  {
    name: "Pāsārgād",
    country: "Iran",
    subcountry: "Fars",
    geonameid: 401202,
  },
  {
    name: "Eqbālīyeh",
    country: "Iran",
    subcountry: "Tehran",
    geonameid: 406993,
  },
  {
    name: "Rehnān",
    country: "Iran",
    subcountry: "Isfahan",
    geonameid: 418521,
  },
  {
    name: "Qahderījān",
    country: "Iran",
    subcountry: "Isfahan",
    geonameid: 418571,
  },
  {
    name: "Najafābād",
    country: "Iran",
    subcountry: "Isfahan",
    geonameid: 418606,
  },
  {
    name: "Khomeynī Shahr",
    country: "Iran",
    subcountry: "Isfahan",
    geonameid: 418710,
  },
  {
    name: "Kelīshād va Sūdarjān",
    country: "Iran",
    subcountry: "Isfahan",
    geonameid: 418723,
  },
  {
    name: "Falāvarjān",
    country: "Iran",
    subcountry: "Isfahan",
    geonameid: 418851,
  },
  {
    name: "Isfahan",
    country: "Iran",
    subcountry: "Isfahan",
    geonameid: 418863,
  },
  {
    name: "Dowlatābād",
    country: "Iran",
    subcountry: "Isfahan",
    geonameid: 418868,
  },
  {
    name: "Dorcheh Pīāz",
    country: "Iran",
    subcountry: "Isfahan",
    geonameid: 418896,
  },
  {
    name: "Abrīsham",
    country: "Iran",
    subcountry: "Isfahan",
    geonameid: 418950,
  },
  {
    name: "Zābol",
    country: "Iran",
    subcountry: "Sistan and Baluchestan",
    geonameid: 1113217,
  },
  {
    name: "Zahedan",
    country: "Iran",
    subcountry: "Sistan and Baluchestan",
    geonameid: 1159301,
  },
  {
    name: "Torbat-e Jām",
    country: "Iran",
    subcountry: "Razavi Khorasan",
    geonameid: 1159362,
  },
  {
    name: "Tāybād",
    country: "Iran",
    subcountry: "Razavi Khorasan",
    geonameid: 1159384,
  },
  {
    name: "Sarakhs",
    country: "Iran",
    subcountry: "Razavi Khorasan",
    geonameid: 1159716,
  },
  {
    name: "Qaşr-e Qand",
    country: "Iran",
    subcountry: "Sistan and Baluchestan",
    geonameid: 1159877,
  },
  {
    name: "Nīkshahr",
    country: "Iran",
    subcountry: "Sistan and Baluchestan",
    geonameid: 1160110,
  },
  {
    name: "Khāsh",
    country: "Iran",
    subcountry: "Sistan and Baluchestan",
    geonameid: 1160571,
  },
  {
    name: "Iranshahr",
    country: "Iran",
    subcountry: "Sistan and Baluchestan",
    geonameid: 1160939,
  },
  {
    name: "Chabahar",
    country: "Iran",
    subcountry: "Sistan and Baluchestan",
    geonameid: 1161724,
  },
  {
    name: "Mahdishahr",
    country: "Iran",
    subcountry: "Semnan",
    geonameid: 7100777,
  },
  {
    name: "Boshrūyeh",
    country: "Iran",
    subcountry: "South Khorasan Province",
    geonameid: 9480732,
  },
  {
    name: "Pasragad Branch",
    country: "Iran",
    subcountry: "Hamadān",
    geonameid: 10630176,
  },
  {
    name: "Akureyri",
    country: "Iceland",
    subcountry: "Northeast",
    geonameid: 2633274,
  },
  {
    name: "Reykjavík",
    country: "Iceland",
    subcountry: "Capital Region",
    geonameid: 3413829,
  },
  {
    name: "Kópavogur",
    country: "Iceland",
    subcountry: "Capital Region",
    geonameid: 3415212,
  },
  {
    name: "Keflavík",
    country: "Iceland",
    subcountry: "Southern Peninsula",
    geonameid: 3415496,
  },
  {
    name: "Hafnarfjörður",
    country: "Iceland",
    subcountry: "Capital Region",
    geonameid: 3416706,
  },
  {
    name: "Reykjanesbær",
    country: "Iceland",
    subcountry: "Southern Peninsula",
    geonameid: 8644037,
  },
  {
    name: "Vittoria",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2522713,
  },
  {
    name: "Villabate",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2522767,
  },
  {
    name: "Vibo Valentia",
    country: "Italy",
    subcountry: "Calabria",
    geonameid: 2522776,
  },
  {
    name: "Trapani",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2522876,
  },
  {
    name: "Termini Imerese",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2522960,
  },
  {
    name: "Siracusa",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2523083,
  },
  {
    name: "Sinnai",
    country: "Italy",
    subcountry: "Sardinia",
    geonameid: 2523087,
  },
  {
    name: "Siderno",
    country: "Italy",
    subcountry: "Calabria",
    geonameid: 2523113,
  },
  {
    name: "Sestu",
    country: "Italy",
    subcountry: "Sardinia",
    geonameid: 2523136,
  },
  {
    name: "Selargius",
    country: "Italy",
    subcountry: "Sardinia",
    geonameid: 2523166,
  },
  {
    name: "Scordia",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2523180,
  },
  {
    name: "Scicli",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2523192,
  },
  {
    name: "Sciacca",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2523194,
  },
  {
    name: "San Giovanni la Punta",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2523460,
  },
  {
    name: "San Giovanni in Fiore",
    country: "Italy",
    subcountry: "Calabria",
    geonameid: 2523461,
  },
  {
    name: "San Cataldo",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2523513,
  },
  {
    name: "Sambiase",
    country: "Italy",
    subcountry: "Calabria",
    geonameid: 2523535,
  },
  {
    name: "Rossano Stazione",
    country: "Italy",
    subcountry: "Calabria",
    geonameid: 2523577,
  },
  {
    name: "Rosolini",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2523581,
  },
  {
    name: "Ribera",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2523619,
  },
  {
    name: "Reggio Calabria",
    country: "Italy",
    subcountry: "Calabria",
    geonameid: 2523630,
  },
  {
    name: "Ragusa",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2523650,
  },
  {
    name: "Quattromiglia",
    country: "Italy",
    subcountry: "Calabria",
    geonameid: 2523664,
  },
  {
    name: "Quartu Sant'Elena",
    country: "Italy",
    subcountry: "Sardinia",
    geonameid: 2523665,
  },
  {
    name: "Pozzallo",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2523693,
  },
  {
    name: "Porto Empedocle",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2523705,
  },
  {
    name: "Piazza Armerina",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2523796,
  },
  {
    name: "Paternò",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2523866,
  },
  {
    name: "Partinico",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2523871,
  },
  {
    name: "Palmi",
    country: "Italy",
    subcountry: "Calabria",
    geonameid: 2523902,
  },
  {
    name: "Palma di Montechiaro",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2523908,
  },
  {
    name: "Palermo",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2523920,
  },
  {
    name: "Palagonia",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2523927,
  },
  {
    name: "Pachino",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2523938,
  },
  {
    name: "Oristano",
    country: "Italy",
    subcountry: "Sardinia",
    geonameid: 2523964,
  },
  {
    name: "Noto",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2523998,
  },
  {
    name: "Niscemi",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2524006,
  },
  {
    name: "Nicastro",
    country: "Italy",
    subcountry: "Calabria",
    geonameid: 2524013,
  },
  {
    name: "Monserrato",
    country: "Italy",
    subcountry: "Sardinia",
    geonameid: 2524084,
  },
  {
    name: "Monreale",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2524085,
  },
  {
    name: "Modica",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2524119,
  },
  {
    name: "Misterbianco",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2524123,
  },
  {
    name: "Misilmeri",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2524126,
  },
  {
    name: "Milazzo",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2524155,
  },
  {
    name: "Messina",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2524170,
  },
  {
    name: "Mazara del Vallo",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2524205,
  },
  {
    name: "Mascalucia",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2524236,
  },
  {
    name: "Marsala",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2524245,
  },
  {
    name: "Licata",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2524393,
  },
  {
    name: "Lentini",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2524410,
  },
  {
    name: "Iglesias",
    country: "Italy",
    subcountry: "Sardinia",
    geonameid: 2524533,
  },
  {
    name: "Gioia Tauro",
    country: "Italy",
    subcountry: "Calabria",
    geonameid: 2524606,
  },
  {
    name: "Giarre",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2524618,
  },
  {
    name: "Gela",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2524653,
  },
  {
    name: "Floridia",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2524734,
  },
  {
    name: "Favara",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2524786,
  },
  {
    name: "Enna",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2524819,
  },
  {
    name: "Crotone",
    country: "Italy",
    subcountry: "Calabria",
    geonameid: 2524881,
  },
  {
    name: "Cosenza",
    country: "Italy",
    subcountry: "Calabria",
    geonameid: 2524907,
  },
  {
    name: "Comiso",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2524955,
  },
  {
    name: "Catanzaro",
    country: "Italy",
    subcountry: "Calabria",
    geonameid: 2525059,
  },
  {
    name: "Catania",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2525068,
  },
  {
    name: "Castrovillari",
    country: "Italy",
    subcountry: "Calabria",
    geonameid: 2525070,
  },
  {
    name: "Castelvetrano",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2525083,
  },
  {
    name: "Casarano",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 2525207,
  },
  {
    name: "Carini",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2525350,
  },
  {
    name: "Carbonia",
    country: "Italy",
    subcountry: "Sardinia",
    geonameid: 2525362,
  },
  {
    name: "Canicattì",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2525405,
  },
  {
    name: "Caltanissetta",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2525448,
  },
  {
    name: "Caltagirone",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2525450,
  },
  {
    name: "Cagliari",
    country: "Italy",
    subcountry: "Sardinia",
    geonameid: 2525473,
  },
  {
    name: "Bronte",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2525498,
  },
  {
    name: "Biancavilla",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2525560,
  },
  {
    name: "Belpasso",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2525571,
  },
  {
    name: "Barcellona Pozzo di Gotto",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2525597,
  },
  {
    name: "Bagheria",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2525628,
  },
  {
    name: "Avola",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2525643,
  },
  {
    name: "Augusta",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2525646,
  },
  {
    name: "Assemini",
    country: "Italy",
    subcountry: "Sardinia",
    geonameid: 2525655,
  },
  {
    name: "Alcamo",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2525755,
  },
  {
    name: "Agrigento",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2525764,
  },
  {
    name: "Adrano",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2525769,
  },
  {
    name: "Acireale",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2525790,
  },
  {
    name: "Aci Catena",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2525791,
  },
  {
    name: "Aci Castello",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 2525792,
  },
  {
    name: "Zola Predosa",
    country: "Italy",
    subcountry: "Emilia-Romagna",
    geonameid: 3163853,
  },
  {
    name: "Vomero",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3163948,
  },
  {
    name: "Voghera",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3163995,
  },
  {
    name: "Vittorio Veneto",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3164028,
  },
  {
    name: "Viterbo",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3164039,
  },
  {
    name: "Vimodrone",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3164080,
  },
  {
    name: "Vimercate",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3164083,
  },
  {
    name: "Lancenigo-Villorba",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3164090,
  },
  {
    name: "Villaricca",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3164153,
  },
  {
    name: "Villafranca di Verona",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3164241,
  },
  {
    name: "Vignola",
    country: "Italy",
    subcountry: "Emilia-Romagna",
    geonameid: 3164342,
  },
  {
    name: "Vigevano",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3164376,
  },
  {
    name: "Vicenza",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3164419,
  },
  {
    name: "Viareggio",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3164433,
  },
  {
    name: "Viadana",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3164440,
  },
  {
    name: "Verona",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3164527,
  },
  {
    name: "Vercelli",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3164565,
  },
  {
    name: "Ventimiglia",
    country: "Italy",
    subcountry: "Liguria",
    geonameid: 3164582,
  },
  {
    name: "Venice",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3164603,
  },
  {
    name: "Venaria Reale",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3164617,
  },
  {
    name: "Velletri",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3164630,
  },
  {
    name: "Vasto",
    country: "Italy",
    subcountry: "Abruzzo",
    geonameid: 3164672,
  },
  {
    name: "Varese",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3164699,
  },
  {
    name: "Valenzano",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3164919,
  },
  {
    name: "Valenza",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3164920,
  },
  {
    name: "Valdagno",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3164954,
  },
  {
    name: "Udine",
    country: "Italy",
    subcountry: "Friuli Venezia Giulia",
    geonameid: 3165072,
  },
  {
    name: "Triggiano",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3165178,
  },
  {
    name: "Trieste",
    country: "Italy",
    subcountry: "Friuli Venezia Giulia",
    geonameid: 3165185,
  },
  {
    name: "Trezzano sul Naviglio",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3165198,
  },
  {
    name: "Treviso",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3165201,
  },
  {
    name: "Treviglio",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3165207,
  },
  {
    name: "Trentola-Ducenta",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3165240,
  },
  {
    name: "Trento",
    country: "Italy",
    subcountry: "Trentino-Alto Adige",
    geonameid: 3165243,
  },
  {
    name: "Trecate",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3165275,
  },
  {
    name: "Trani",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3165322,
  },
  {
    name: "Tradate",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3165340,
  },
  {
    name: "Tortona",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3165370,
  },
  {
    name: "Torremaggiore",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3165435,
  },
  {
    name: "Torre del Greco",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3165456,
  },
  {
    name: "Torre Annunziata",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3165475,
  },
  {
    name: "Turin",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3165524,
  },
  {
    name: "Tolentino",
    country: "Italy",
    subcountry: "The Marches",
    geonameid: 3165595,
  },
  {
    name: "Tivoli",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3165624,
  },
  {
    name: "Thiene",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3165698,
  },
  {
    name: "Terzigno",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3165737,
  },
  {
    name: "Terracina",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3165762,
  },
  {
    name: "Terni",
    country: "Italy",
    subcountry: "Umbria",
    geonameid: 3165771,
  },
  {
    name: "Termoli",
    country: "Italy",
    subcountry: "Molise",
    geonameid: 3165773,
  },
  {
    name: "Terlizzi",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3165788,
  },
  {
    name: "Teramo",
    country: "Italy",
    subcountry: "Abruzzo",
    geonameid: 3165803,
  },
  {
    name: "Taranto",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3165926,
  },
  {
    name: "Suzzara",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3166006,
  },
  {
    name: "Sulmona",
    country: "Italy",
    subcountry: "Abruzzo",
    geonameid: 3166034,
  },
  {
    name: "Spoleto",
    country: "Italy",
    subcountry: "Umbria",
    geonameid: 3166236,
  },
  {
    name: "Sora",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3166387,
  },
  {
    name: "Sondrio",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3166397,
  },
  {
    name: "Somma Vesuviana",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3166404,
  },
  {
    name: "Soccavo",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3166465,
  },
  {
    name: "Siena",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3166548,
  },
  {
    name: "Sezze",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3166571,
  },
  {
    name: "Seveso",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3166574,
  },
  {
    name: "Settimo Torinese",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3166576,
  },
  {
    name: "Sestri Levante",
    country: "Italy",
    subcountry: "Liguria",
    geonameid: 3166595,
  },
  {
    name: "Sesto San Giovanni",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3166598,
  },
  {
    name: "Sesto Fiorentino",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3166601,
  },
  {
    name: "Seriate",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3166706,
  },
  {
    name: "Seregno",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3166711,
  },
  {
    name: "Senigallia",
    country: "Italy",
    subcountry: "The Marches",
    geonameid: 3166740,
  },
  {
    name: "Senago",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3166753,
  },
  {
    name: "Segrate",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3166808,
  },
  {
    name: "Secondigliano",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3166830,
  },
  {
    name: "Schio",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3166917,
  },
  {
    name: "Scandicci",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3166988,
  },
  {
    name: "Scandiano",
    country: "Italy",
    subcountry: "Emilia-Romagna",
    geonameid: 3166989,
  },
  {
    name: "Scafati",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3167010,
  },
  {
    name: "Savona",
    country: "Italy",
    subcountry: "Liguria",
    geonameid: 3167022,
  },
  {
    name: "Savigliano",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3167034,
  },
  {
    name: "Sava",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3167044,
  },
  {
    name: "Sassuolo",
    country: "Italy",
    subcountry: "Emilia-Romagna",
    geonameid: 3167053,
  },
  {
    name: "Sassari",
    country: "Italy",
    subcountry: "Sardinia",
    geonameid: 3167096,
  },
  {
    name: "Sarzana",
    country: "Italy",
    subcountry: "Liguria",
    geonameid: 3167104,
  },
  {
    name: "Saronno",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3167113,
  },
  {
    name: "Sarno",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3167116,
  },
  {
    name: "San Vito dei Normanni",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3167184,
  },
  {
    name: "Santeramo in Colle",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3167327,
  },
  {
    name: "Sant'Antonio Abate",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3167393,
  },
  {
    name: "Sant'Antimo",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3167419,
  },
  {
    name: "Sant'Anastasia",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3167509,
  },
  {
    name: "Santa Maria Capua Vetere",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3167561,
  },
  {
    name: "San Severo",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3167731,
  },
  {
    name: "San Sebastiano",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3167744,
  },
  {
    name: "San Salvo",
    country: "Italy",
    subcountry: "Abruzzo",
    geonameid: 3167751,
  },
  {
    name: "San Remo",
    country: "Italy",
    subcountry: "Liguria",
    geonameid: 3167777,
  },
  {
    name: "Sannicandro Garganico",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3167940,
  },
  {
    name: "San Miniato",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3167953,
  },
  {
    name: "San Miniato Basso",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3167954,
  },
  {
    name: "San Mauro Torinese",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3167978,
  },
  {
    name: "San Lazzaro",
    country: "Italy",
    subcountry: "Emilia-Romagna",
    geonameid: 3168175,
  },
  {
    name: "San Giuseppe Vesuviano",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3168209,
  },
  {
    name: "San Giuliano Milanese",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3168222,
  },
  {
    name: "San Giovanni Valdarno",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3168231,
  },
  {
    name: "San Giovanni Rotondo",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3168234,
  },
  {
    name: "San Giovanni Lupatoto",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3168236,
  },
  {
    name: "San Giovanni in Persiceto",
    country: "Italy",
    subcountry: "Emilia-Romagna",
    geonameid: 3168239,
  },
  {
    name: "San Giovanni a Teduccio",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3168257,
  },
  {
    name: "San Giorgio a Cremano",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3168309,
  },
  {
    name: "San Donato Milanese",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3168414,
  },
  {
    name: "San Donà di Piave",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3168429,
  },
  {
    name: "San Bonifacio",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3168514,
  },
  {
    name: "San Benedetto del Tronto",
    country: "Italy",
    subcountry: "The Marches",
    geonameid: 3168550,
  },
  {
    name: "Saluzzo",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3168609,
  },
  {
    name: "Salsomaggiore Terme",
    country: "Italy",
    subcountry: "Emilia-Romagna",
    geonameid: 3168627,
  },
  {
    name: "Salerno",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3168673,
  },
  {
    name: "Sacile",
    country: "Italy",
    subcountry: "Friuli Venezia Giulia",
    geonameid: 3168730,
  },
  {
    name: "Ruvo di Puglia",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3168770,
  },
  {
    name: "Rutigliano",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3168775,
  },
  {
    name: "Rozzano",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3168837,
  },
  {
    name: "Rovigo",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3168843,
  },
  {
    name: "Rovereto",
    country: "Italy",
    subcountry: "Trentino-Alto Adige",
    geonameid: 3168854,
  },
  {
    name: "Rosignano Solvay-Castiglioncello",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3168930,
  },
  {
    name: "Roseto degli Abruzzi",
    country: "Italy",
    subcountry: "Abruzzo",
    geonameid: 3168936,
  },
  {
    name: "Romano di Lombardia",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3169056,
  },
  {
    name: "Rome",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3169070,
  },
  {
    name: "Rocca di Papa",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3169181,
  },
  {
    name: "Rivoli",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3169231,
  },
  {
    name: "Riva del Garda",
    country: "Italy",
    subcountry: "Trentino-Alto Adige",
    geonameid: 3169272,
  },
  {
    name: "Rimini",
    country: "Italy",
    subcountry: "Emilia-Romagna",
    geonameid: 3169361,
  },
  {
    name: "Rieti",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3169412,
  },
  {
    name: "Riccione",
    country: "Italy",
    subcountry: "Emilia-Romagna",
    geonameid: 3169424,
  },
  {
    name: "Rho",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3169447,
  },
  {
    name: "Reggio nell'Emilia",
    country: "Italy",
    subcountry: "Emilia-Romagna",
    geonameid: 3169522,
  },
  {
    name: "Ravenna",
    country: "Italy",
    subcountry: "Emilia-Romagna",
    geonameid: 3169561,
  },
  {
    name: "Rapallo",
    country: "Italy",
    subcountry: "Liguria",
    geonameid: 3169602,
  },
  {
    name: "Qualiano",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3169724,
  },
  {
    name: "Putignano",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3169742,
  },
  {
    name: "Prato",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3169921,
  },
  {
    name: "Pozzuoli",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3169984,
  },
  {
    name: "Potenza",
    country: "Italy",
    subcountry: "Basilicate",
    geonameid: 3170027,
  },
  {
    name: "Posillipo",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3170055,
  },
  {
    name: "Porto Torres",
    country: "Italy",
    subcountry: "Sardinia",
    geonameid: 3170069,
  },
  {
    name: "Porto Sant'Elpidio",
    country: "Italy",
    subcountry: "The Marches",
    geonameid: 3170072,
  },
  {
    name: "Porto San Giorgio",
    country: "Italy",
    subcountry: "The Marches",
    geonameid: 3170073,
  },
  {
    name: "Portogruaro",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3170086,
  },
  {
    name: "Civitanova Marche",
    country: "Italy",
    subcountry: "The Marches",
    geonameid: 3170102,
  },
  {
    name: "Portici",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3170116,
  },
  {
    name: "Pordenone",
    country: "Italy",
    subcountry: "Friuli Venezia Giulia",
    geonameid: 3170147,
  },
  {
    name: "Ponticelli",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3170206,
  },
  {
    name: "Pontedera",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3170272,
  },
  {
    name: "Pompei",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3170335,
  },
  {
    name: "Pomigliano d'Arco",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3170341,
  },
  {
    name: "Pomezia",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3170342,
  },
  {
    name: "Poggioreale",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3170446,
  },
  {
    name: "Poggiomarino",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3170457,
  },
  {
    name: "Poggibonsi",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3170504,
  },
  {
    name: "Pistoia",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3170621,
  },
  {
    name: "Piscinola",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3170631,
  },
  {
    name: "Pisa",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3170647,
  },
  {
    name: "Piossasco",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3170659,
  },
  {
    name: "Piombino",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3170674,
  },
  {
    name: "Pioltello",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3170676,
  },
  {
    name: "Pinerolo",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3170694,
  },
  {
    name: "Pietrasanta",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3170778,
  },
  {
    name: "Pianura",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3170921,
  },
  {
    name: "Piacenza",
    country: "Italy",
    subcountry: "Emilia-Romagna",
    geonameid: 3171058,
  },
  {
    name: "Pescara",
    country: "Italy",
    subcountry: "Abruzzo",
    geonameid: 3171168,
  },
  {
    name: "Pesaro",
    country: "Italy",
    subcountry: "The Marches",
    geonameid: 3171173,
  },
  {
    name: "Perugia",
    country: "Italy",
    subcountry: "Umbria",
    geonameid: 3171180,
  },
  {
    name: "Pavia",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3171366,
  },
  {
    name: "Parma",
    country: "Italy",
    subcountry: "Emilia-Romagna",
    geonameid: 3171457,
  },
  {
    name: "Parabiago",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3171484,
  },
  {
    name: "Palo del Colle",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3171562,
  },
  {
    name: "Palazzolo sull'Oglio",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3171586,
  },
  {
    name: "Palagiano",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3171664,
  },
  {
    name: "Pagani",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3171703,
  },
  {
    name: "Padova",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3171728,
  },
  {
    name: "Paderno Dugnano",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3171737,
  },
  {
    name: "Ottaviano",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3171778,
  },
  {
    name: "Ostuni",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3171786,
  },
  {
    name: "Osimo",
    country: "Italy",
    subcountry: "The Marches",
    geonameid: 3171848,
  },
  {
    name: "Orta Nova",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3171900,
  },
  {
    name: "Orbassano",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3171986,
  },
  {
    name: "Olbia",
    country: "Italy",
    subcountry: "Sardinia",
    geonameid: 3172087,
  },
  {
    name: "Oderzo",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3172116,
  },
  {
    name: "Nuoro",
    country: "Italy",
    subcountry: "Sardinia",
    geonameid: 3172154,
  },
  {
    name: "Novi Ligure",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3172170,
  },
  {
    name: "Novate Milanese",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3172184,
  },
  {
    name: "Novara",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3172189,
  },
  {
    name: "Nova Milanese",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3172191,
  },
  {
    name: "Nola",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3172227,
  },
  {
    name: "Noicattaro",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3172228,
  },
  {
    name: "Noci",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3172240,
  },
  {
    name: "Nocera Superiore",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3172243,
  },
  {
    name: "Nocera Inferiore",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3172244,
  },
  {
    name: "Nichelino",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3172269,
  },
  {
    name: "Nettuno",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3172287,
  },
  {
    name: "Nerviano",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3172297,
  },
  {
    name: "Nardò",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3172379,
  },
  {
    name: "Naples",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3172394,
  },
  {
    name: "Mugnano di Napoli",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3172472,
  },
  {
    name: "Muggiò",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3172479,
  },
  {
    name: "Monza",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3172629,
  },
  {
    name: "Montichiari",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3172681,
  },
  {
    name: "Montevarchi",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3172718,
  },
  {
    name: "Montesilvano Marina",
    country: "Italy",
    subcountry: "Abruzzo",
    geonameid: 3172729,
  },
  {
    name: "Monterotondo",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3172768,
  },
  {
    name: "Montemurlo",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3172828,
  },
  {
    name: "Montecchio Maggiore-Alte Ceccato",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3172979,
  },
  {
    name: "Montecatini-Terme",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3172996,
  },
  {
    name: "Montebelluna",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3173029,
  },
  {
    name: "Monselice",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3173124,
  },
  {
    name: "Monopoli",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3173131,
  },
  {
    name: "Monfalcone",
    country: "Italy",
    subcountry: "Friuli Venezia Giulia",
    geonameid: 3173153,
  },
  {
    name: "Mondragone",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3173160,
  },
  {
    name: "Mondovì",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3173162,
  },
  {
    name: "Moncalieri",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3173180,
  },
  {
    name: "Molfetta",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3173287,
  },
  {
    name: "Mola di Bari",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3173302,
  },
  {
    name: "Mogliano Veneto",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3173314,
  },
  {
    name: "Modugno",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3173326,
  },
  {
    name: "Modena",
    country: "Italy",
    subcountry: "Emilia-Romagna",
    geonameid: 3173331,
  },
  {
    name: "Mirano",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3173369,
  },
  {
    name: "Mirandola",
    country: "Italy",
    subcountry: "Emilia-Romagna",
    geonameid: 3173370,
  },
  {
    name: "Mira Taglio",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3173385,
  },
  {
    name: "Minturno",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3173391,
  },
  {
    name: "Milan",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3173435,
  },
  {
    name: "Miano",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3173473,
  },
  {
    name: "Mestre",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3173529,
  },
  {
    name: "Mesagne",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3173537,
  },
  {
    name: "Merano",
    country: "Italy",
    subcountry: "Trentino-Alto Adige",
    geonameid: 3173577,
  },
  {
    name: "Mentana",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3173582,
  },
  {
    name: "Melzo",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3173599,
  },
  {
    name: "Melito di Napoli",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3173614,
  },
  {
    name: "Melegnano",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3173631,
  },
  {
    name: "Meda",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3173671,
  },
  {
    name: "Matera",
    country: "Italy",
    subcountry: "Basilicate",
    geonameid: 3173721,
  },
  {
    name: "Massarosa",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3173754,
  },
  {
    name: "Massafra",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3173762,
  },
  {
    name: "Massa",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3173775,
  },
  {
    name: "Martina Franca",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3173841,
  },
  {
    name: "Marino",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3173914,
  },
  {
    name: "Marina di Massa",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3173931,
  },
  {
    name: "Marina di Carrara",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3173935,
  },
  {
    name: "Marigliano",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3173945,
  },
  {
    name: "Mariano Comense",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3173949,
  },
  {
    name: "Marcianise",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3173995,
  },
  {
    name: "Marano di Napoli",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3174021,
  },
  {
    name: "Mantova",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3174051,
  },
  {
    name: "Manfredonia",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3174092,
  },
  {
    name: "Manduria",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3174096,
  },
  {
    name: "Malnate",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3174141,
  },
  {
    name: "Magenta",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3174295,
  },
  {
    name: "Maddaloni",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3174358,
  },
  {
    name: "Macerata",
    country: "Italy",
    subcountry: "The Marches",
    geonameid: 3174380,
  },
  {
    name: "Lugo",
    country: "Italy",
    subcountry: "Emilia-Romagna",
    geonameid: 3174494,
  },
  {
    name: "Lucera",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3174526,
  },
  {
    name: "Lucca",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3174530,
  },
  {
    name: "Lodi",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3174638,
  },
  {
    name: "Livorno",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3174659,
  },
  {
    name: "Lissone",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3174679,
  },
  {
    name: "Limbiate",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3174719,
  },
  {
    name: "Lido di Ostia",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3174741,
  },
  {
    name: "Lido",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3174748,
  },
  {
    name: "Legnano",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3174921,
  },
  {
    name: "Legnago",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3174922,
  },
  {
    name: "Lecco",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3174945,
  },
  {
    name: "Lecce",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3174953,
  },
  {
    name: "Latina",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3175058,
  },
  {
    name: "La Spezia",
    country: "Italy",
    subcountry: "Liguria",
    geonameid: 3175081,
  },
  {
    name: "L'Aquila",
    country: "Italy",
    subcountry: "Abruzzo",
    geonameid: 3175121,
  },
  {
    name: "Lanciano",
    country: "Italy",
    subcountry: "Abruzzo",
    geonameid: 3175173,
  },
  {
    name: "Lainate",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3175238,
  },
  {
    name: "Ladispoli",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3175298,
  },
  {
    name: "Ivrea",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3175384,
  },
  {
    name: "Isernia",
    country: "Italy",
    subcountry: "Molise",
    geonameid: 3175445,
  },
  {
    name: "Ischia Porto",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3175453,
  },
  {
    name: "Ischia",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3175458,
  },
  {
    name: "Pallanza-Intra-Suna",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3175500,
  },
  {
    name: "Imperia",
    country: "Italy",
    subcountry: "Liguria",
    geonameid: 3175532,
  },
  {
    name: "Imola",
    country: "Italy",
    subcountry: "Emilia-Romagna",
    geonameid: 3175537,
  },
  {
    name: "Jesi",
    country: "Italy",
    subcountry: "The Marches",
    geonameid: 3175628,
  },
  {
    name: "Guidonia",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3175678,
  },
  {
    name: "Grumo Nevano",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3175743,
  },
  {
    name: "Grugliasco",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3175755,
  },
  {
    name: "Grottaglie",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3175773,
  },
  {
    name: "Grottaferrata",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3175775,
  },
  {
    name: "Grosseto",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3175786,
  },
  {
    name: "Gravina in Puglia",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3175860,
  },
  {
    name: "Gragnano",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3175952,
  },
  {
    name: "Gorizia",
    country: "Italy",
    subcountry: "Friuli Venezia Giulia",
    geonameid: 3175986,
  },
  {
    name: "Gorgonzola",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3175990,
  },
  {
    name: "Giussano",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3176041,
  },
  {
    name: "Giulianova",
    country: "Italy",
    subcountry: "Abruzzo",
    geonameid: 3176053,
  },
  {
    name: "Giugliano in Campania",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3176059,
  },
  {
    name: "Giovinazzo",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3176072,
  },
  {
    name: "Gioia del Colle",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3176090,
  },
  {
    name: "Ginosa",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3176097,
  },
  {
    name: "Ghedi",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3176177,
  },
  {
    name: "Genzano di Roma",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3176203,
  },
  {
    name: "Genoa",
    country: "Italy",
    subcountry: "Liguria",
    geonameid: 3176219,
  },
  {
    name: "Garbagnate Milanese",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3176322,
  },
  {
    name: "Gallipoli",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3176366,
  },
  {
    name: "Galliate",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3176379,
  },
  {
    name: "Gallarate",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3176391,
  },
  {
    name: "Galatina",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3176407,
  },
  {
    name: "Gaeta",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3176438,
  },
  {
    name: "Fuorigrotta",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3176477,
  },
  {
    name: "Frosinone",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3176515,
  },
  {
    name: "Frattaminore",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3176560,
  },
  {
    name: "Frattamaggiore",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3176561,
  },
  {
    name: "Frascati",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3176589,
  },
  {
    name: "Francavilla Fontana",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3176603,
  },
  {
    name: "Francavilla al Mare",
    country: "Italy",
    subcountry: "Abruzzo",
    geonameid: 3176605,
  },
  {
    name: "Fossano",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3176639,
  },
  {
    name: "Fornacelle",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3176722,
  },
  {
    name: "Formigine",
    country: "Italy",
    subcountry: "Emilia-Romagna",
    geonameid: 3176733,
  },
  {
    name: "Formia",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3176738,
  },
  {
    name: "Forlì",
    country: "Italy",
    subcountry: "Emilia-Romagna",
    geonameid: 3176746,
  },
  {
    name: "Forio",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3176748,
  },
  {
    name: "Fondi",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3176843,
  },
  {
    name: "Follonica",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3176849,
  },
  {
    name: "Foligno",
    country: "Italy",
    subcountry: "Umbria",
    geonameid: 3176854,
  },
  {
    name: "Foggia",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3176885,
  },
  {
    name: "Fiumicino",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3176923,
  },
  {
    name: "Florence",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3176959,
  },
  {
    name: "Fiorano",
    country: "Italy",
    subcountry: "Emilia-Romagna",
    geonameid: 3176970,
  },
  {
    name: "Fidenza",
    country: "Italy",
    subcountry: "Emilia-Romagna",
    geonameid: 3177029,
  },
  {
    name: "Ferrara",
    country: "Italy",
    subcountry: "Emilia-Romagna",
    geonameid: 3177090,
  },
  {
    name: "Fermo",
    country: "Italy",
    subcountry: "The Marches",
    geonameid: 3177099,
  },
  {
    name: "Fasano",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3177171,
  },
  {
    name: "Fano",
    country: "Italy",
    subcountry: "The Marches",
    geonameid: 3177219,
  },
  {
    name: "Falconara Marittima",
    country: "Italy",
    subcountry: "The Marches",
    geonameid: 3177250,
  },
  {
    name: "Faenza",
    country: "Italy",
    subcountry: "Emilia-Romagna",
    geonameid: 3177300,
  },
  {
    name: "Fabriano",
    country: "Italy",
    subcountry: "The Marches",
    geonameid: 3177315,
  },
  {
    name: "Este",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3177337,
  },
  {
    name: "Ercolano",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3177363,
  },
  {
    name: "Erba",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3177372,
  },
  {
    name: "Empoli",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3177400,
  },
  {
    name: "Eboli",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3177438,
  },
  {
    name: "Domodossola",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3177532,
  },
  {
    name: "Desio",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3177608,
  },
  {
    name: "Desenzano del Garda",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3177610,
  },
  {
    name: "Dalmine",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3177650,
  },
  {
    name: "Cusano",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3177664,
  },
  {
    name: "Cuneo",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3177700,
  },
  {
    name: "Cremona",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3177838,
  },
  {
    name: "Crema",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3177841,
  },
  {
    name: "Corsico",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3178004,
  },
  {
    name: "Correggio",
    country: "Italy",
    subcountry: "Emilia-Romagna",
    geonameid: 3178019,
  },
  {
    name: "Cornaredo",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3178074,
  },
  {
    name: "Cormano",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3178087,
  },
  {
    name: "Cordenons",
    country: "Italy",
    subcountry: "Friuli Venezia Giulia",
    geonameid: 3178112,
  },
  {
    name: "Corato",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3178131,
  },
  {
    name: "Copertino",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3178141,
  },
  {
    name: "Conversano",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3178147,
  },
  {
    name: "Conegliano",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3178197,
  },
  {
    name: "Como",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3178229,
  },
  {
    name: "Cologno Monzese",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3178283,
  },
  {
    name: "Collegno",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3178388,
  },
  {
    name: "Colleferro",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3178398,
  },
  {
    name: "Colle di Val d'Elsa",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3178402,
  },
  {
    name: "Civitavecchia",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3178587,
  },
  {
    name: "Città di Castello",
    country: "Italy",
    subcountry: "Umbria",
    geonameid: 3178619,
  },
  {
    name: "Cisterna di Latina",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3178631,
  },
  {
    name: "Ciriè",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3178650,
  },
  {
    name: "Cinisello Balsamo",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3178671,
  },
  {
    name: "Ciampino",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3178738,
  },
  {
    name: "Chivasso",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3178745,
  },
  {
    name: "Chioggia",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3178784,
  },
  {
    name: "Chieti",
    country: "Italy",
    subcountry: "Abruzzo",
    geonameid: 3178796,
  },
  {
    name: "Chieri",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3178818,
  },
  {
    name: "Chiavari",
    country: "Italy",
    subcountry: "Liguria",
    geonameid: 3178832,
  },
  {
    name: "Chiari",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3178850,
  },
  {
    name: "Cesenatico",
    country: "Italy",
    subcountry: "Emilia-Romagna",
    geonameid: 3178956,
  },
  {
    name: "Cesena",
    country: "Italy",
    subcountry: "Emilia-Romagna",
    geonameid: 3178957,
  },
  {
    name: "Cesano Maderno",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3178972,
  },
  {
    name: "Cervia",
    country: "Italy",
    subcountry: "Emilia-Romagna",
    geonameid: 3178998,
  },
  {
    name: "Cerveteri",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3178999,
  },
  {
    name: "Cernusco sul Naviglio",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3179066,
  },
  {
    name: "Cerignola",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3179075,
  },
  {
    name: "Cercola",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3179109,
  },
  {
    name: "Cento",
    country: "Italy",
    subcountry: "Emilia-Romagna",
    geonameid: 3179162,
  },
  {
    name: "Ceglie Messapica",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3179218,
  },
  {
    name: "Cecina",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3179235,
  },
  {
    name: "Cava Dè Tirreni",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3179337,
  },
  {
    name: "Cattolica",
    country: "Italy",
    subcountry: "Emilia-Romagna",
    geonameid: 3179347,
  },
  {
    name: "Castiglione delle Stiviere",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3179415,
  },
  {
    name: "Castel Volturno",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3179443,
  },
  {
    name: "Castel Maggiore",
    country: "Italy",
    subcountry: "Emilia-Romagna",
    geonameid: 3179560,
  },
  {
    name: "Castellammare di Stabia",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3179661,
  },
  {
    name: "Castelfranco Veneto",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3179684,
  },
  {
    name: "Castelfranco Emilia",
    country: "Italy",
    subcountry: "Emilia-Romagna",
    geonameid: 3179686,
  },
  {
    name: "Cassino",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3179781,
  },
  {
    name: "Cassano d'Adda",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3179795,
  },
  {
    name: "Casoria",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3179806,
  },
  {
    name: "Caserta",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3179866,
  },
  {
    name: "Cascina",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3179977,
  },
  {
    name: "Casamassima",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3180133,
  },
  {
    name: "Casalnuovo di Napoli",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3180172,
  },
  {
    name: "Casale Monferrato",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3180208,
  },
  {
    name: "Casalecchio di Reno",
    country: "Italy",
    subcountry: "Emilia-Romagna",
    geonameid: 3180224,
  },
  {
    name: "Casal di Principe",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3180240,
  },
  {
    name: "Carugate",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3180389,
  },
  {
    name: "Carrara",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3180423,
  },
  {
    name: "Carpi Centro",
    country: "Italy",
    subcountry: "Emilia-Romagna",
    geonameid: 3180445,
  },
  {
    name: "Carmagnola",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3180496,
  },
  {
    name: "Cardito",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3180541,
  },
  {
    name: "Carate Brianza",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3180581,
  },
  {
    name: "Capua",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3180601,
  },
  {
    name: "Capannori",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3180733,
  },
  {
    name: "Cantù",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3180758,
  },
  {
    name: "Canosa di Puglia",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3180792,
  },
  {
    name: "Campobasso",
    country: "Italy",
    subcountry: "Molise",
    geonameid: 3180991,
  },
  {
    name: "Campi Bisenzio",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3181018,
  },
  {
    name: "Camaiore",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3181125,
  },
  {
    name: "Caivano",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3181258,
  },
  {
    name: "Busto Arsizio",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3181355,
  },
  {
    name: "Bussolengo",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3181359,
  },
  {
    name: "Brusciano",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3181471,
  },
  {
    name: "Brugherio",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3181495,
  },
  {
    name: "Brindisi",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3181528,
  },
  {
    name: "Bresso",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3181548,
  },
  {
    name: "Bressanone",
    country: "Italy",
    subcountry: "Trentino-Alto Adige",
    geonameid: 3181550,
  },
  {
    name: "Brescia",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3181554,
  },
  {
    name: "Bra",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3181631,
  },
  {
    name: "Bovisio-Masciago",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3181641,
  },
  {
    name: "Boscoreale",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3181683,
  },
  {
    name: "Borgomanero",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3181790,
  },
  {
    name: "Bolzano",
    country: "Italy",
    subcountry: "Trentino-Alto Adige",
    geonameid: 3181913,
  },
  {
    name: "Bologna",
    country: "Italy",
    subcountry: "Emilia-Romagna",
    geonameid: 3181928,
  },
  {
    name: "Bollate",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3181931,
  },
  {
    name: "Bitonto",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3181995,
  },
  {
    name: "Bisceglie",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3182007,
  },
  {
    name: "Biella",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3182043,
  },
  {
    name: "Bergamo",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3182164,
  },
  {
    name: "Benevento",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3182179,
  },
  {
    name: "Belluno",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3182210,
  },
  {
    name: "Battipaglia",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3182272,
  },
  {
    name: "Bastia umbra",
    country: "Italy",
    subcountry: "Umbria",
    geonameid: 3182289,
  },
  {
    name: "Bassano del Grappa",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3182297,
  },
  {
    name: "Barra",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3182336,
  },
  {
    name: "Barletta",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3182340,
  },
  {
    name: "Bari",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3182351,
  },
  {
    name: "Bareggio",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3182361,
  },
  {
    name: "Bagnoli",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3182518,
  },
  {
    name: "Bacoli",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3182599,
  },
  {
    name: "Avezzano",
    country: "Italy",
    subcountry: "Abruzzo",
    geonameid: 3182636,
  },
  {
    name: "Aversa",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3182640,
  },
  {
    name: "Avellino",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3182650,
  },
  {
    name: "Asti",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3182714,
  },
  {
    name: "Ascoli Piceno",
    country: "Italy",
    subcountry: "The Marches",
    geonameid: 3182749,
  },
  {
    name: "Arzignano",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3182757,
  },
  {
    name: "Arzano",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3182765,
  },
  {
    name: "Ariccia",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3182851,
  },
  {
    name: "Arezzo",
    country: "Italy",
    subcountry: "Tuscany",
    geonameid: 3182884,
  },
  {
    name: "Arese",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3182886,
  },
  {
    name: "Ardea",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3182897,
  },
  {
    name: "Arcore",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3182904,
  },
  {
    name: "Aprilia",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3182957,
  },
  {
    name: "Aosta",
    country: "Italy",
    subcountry: "Aosta Valley",
    geonameid: 3182997,
  },
  {
    name: "Anzio",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3183005,
  },
  {
    name: "Angri",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3183063,
  },
  {
    name: "Andria",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3183072,
  },
  {
    name: "Ancona",
    country: "Italy",
    subcountry: "The Marches",
    geonameid: 3183089,
  },
  {
    name: "Altamura",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3183178,
  },
  {
    name: "Alpignano",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3183187,
  },
  {
    name: "Alghero",
    country: "Italy",
    subcountry: "Sardinia",
    geonameid: 3183284,
  },
  {
    name: "Alessandria",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3183299,
  },
  {
    name: "Albignasego",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3183319,
  },
  {
    name: "Albenga",
    country: "Italy",
    subcountry: "Liguria",
    geonameid: 3183343,
  },
  {
    name: "Albano Laziale",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3183356,
  },
  {
    name: "Alba",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3183364,
  },
  {
    name: "Agropoli",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3183412,
  },
  {
    name: "Afragola",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3183455,
  },
  {
    name: "Adelfia",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3183472,
  },
  {
    name: "Acqui Terme",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 3183490,
  },
  {
    name: "Acquaviva delle Fonti",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 3183494,
  },
  {
    name: "Acilia-Castel Fusano-Ostia Antica",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 3183539,
  },
  {
    name: "Acerra",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 3183541,
  },
  {
    name: "Abbiategrasso",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 3183573,
  },
  {
    name: "Abano Terme",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3183587,
  },
  {
    name: "Spinea-Orgnano",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 3219114,
  },
  {
    name: "Verbania",
    country: "Italy",
    subcountry: "Piedmont",
    geonameid: 6457398,
  },
  {
    name: "Lumezzane",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 6534216,
  },
  {
    name: "Guidonia Montecelio",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 6534228,
  },
  {
    name: "Lamezia Terme",
    country: "Italy",
    subcountry: "Calabria",
    geonameid: 6534232,
  },
  {
    name: "Caronno Pertusella",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 6534234,
  },
  {
    name: "Cassano Magnago",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 6534235,
  },
  {
    name: "San Felice A Cancello",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 6534252,
  },
  {
    name: "San Nicola la Strada",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 6534253,
  },
  {
    name: "Quarto",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 6534256,
  },
  {
    name: "Orta di Atella",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 6534264,
  },
  {
    name: "Casavatore",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 6534267,
  },
  {
    name: "Volla",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 6534268,
  },
  {
    name: "Gravina di Catania",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 6534275,
  },
  {
    name: "Cesano Boscone",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 6534280,
  },
  {
    name: "Tor Lupara",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 6534284,
  },
  {
    name: "Torvaianica",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 6620312,
  },
  {
    name: "Casal Palocco",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 6698333,
  },
  {
    name: "Bellaria-Igea Marina",
    country: "Italy",
    subcountry: "Emilia-Romagna",
    geonameid: 8224092,
  },
  {
    name: "Villanova",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 8378910,
  },
  {
    name: "Marina di Ardea-Tor San Lorenzo",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 8394392,
  },
  {
    name: "San Paolo",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 8948703,
  },
  {
    name: "Monterusciello",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 8948704,
  },
  {
    name: "Romano Banco",
    country: "Italy",
    subcountry: "Lombardy",
    geonameid: 8948705,
  },
  {
    name: "Casa Santa",
    country: "Italy",
    subcountry: "Sicily",
    geonameid: 8948706,
  },
  {
    name: "Arpino",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 8948708,
  },
  {
    name: "Paolo VI",
    country: "Italy",
    subcountry: "Apulia",
    geonameid: 8948709,
  },
  {
    name: "Corigliano Scalo",
    country: "Italy",
    subcountry: "Calabria",
    geonameid: 9003711,
  },
  {
    name: "Stella",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 10294260,
  },
  {
    name: "San Carlo All'Arena",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 10295350,
  },
  {
    name: "bishopric of Perugia",
    country: "Italy",
    subcountry: "Umbria",
    geonameid: 12032166,
  },
  {
    name: "Chiaia",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 12070058,
  },
  {
    name: "Chiaiano",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 12070059,
  },
  {
    name: "Vicaria",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 12070060,
  },
  {
    name: "San Ferdinando",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 12070061,
  },
  {
    name: "Pendino",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 12070063,
  },
  {
    name: "Arenella",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 12070064,
  },
  {
    name: "Avvocata",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 12070065,
  },
  {
    name: "Montecalvario",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 12070066,
  },
  {
    name: "Scampia",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 12070067,
  },
  {
    name: "San Pietro a Patierno",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 12070069,
  },
  {
    name: "San Lorenzo",
    country: "Italy",
    subcountry: "Campania",
    geonameid: 12070070,
  },
  {
    name: "Monte Rosello",
    country: "Italy",
    subcountry: "Sardinia",
    geonameid: 12188754,
  },
  {
    name: "Arcella",
    country: "Italy",
    subcountry: "Veneto",
    geonameid: 12188755,
  },
  {
    name: "Casal de' Pazzi",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 12188855,
  },
  {
    name: "Giardinetti-Tor Vergata",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 12188858,
  },
  {
    name: "Casal Bertone",
    country: "Italy",
    subcountry: "Lazio",
    geonameid: 12188859,
  },
  {
    name: "Saint Helier",
    country: "Jersey",
    subcountry: "St Helier",
    geonameid: 3042091,
  },
  {
    name: "Spanish Town",
    country: "Jamaica",
    subcountry: "Saint Catherine",
    geonameid: 3488465,
  },
  {
    name: "Savanna-la-Mar",
    country: "Jamaica",
    subcountry: "Westmoreland",
    geonameid: 3488613,
  },
  {
    name: "Portmore",
    country: "Jamaica",
    subcountry: "Saint Catherine",
    geonameid: 3488981,
  },
  {
    name: "Old Harbour",
    country: "Jamaica",
    subcountry: "Saint Catherine",
    geonameid: 3489227,
  },
  {
    name: "New Kingston",
    country: "Jamaica",
    subcountry: "St. Andrew",
    geonameid: 3489297,
  },
  {
    name: "Montego Bay",
    country: "Jamaica",
    subcountry: "St. James",
    geonameid: 3489460,
  },
  {
    name: "May Pen",
    country: "Jamaica",
    subcountry: "Clarendon",
    geonameid: 3489523,
  },
  {
    name: "Mandeville",
    country: "Jamaica",
    subcountry: "Manchester",
    geonameid: 3489577,
  },
  {
    name: "Linstead",
    country: "Jamaica",
    subcountry: "Saint Catherine",
    geonameid: 3489760,
  },
  {
    name: "Kingston",
    country: "Jamaica",
    subcountry: "Kingston",
    geonameid: 3489854,
  },
  {
    name: "Half Way Tree",
    country: "Jamaica",
    subcountry: "St. Andrew",
    geonameid: 3490165,
  },
  {
    name: "Wādī as Sīr",
    country: "Jordan",
    subcountry: "Amman",
    geonameid: 246013,
  },
  {
    name: "Umm as Summāq",
    country: "Jordan",
    subcountry: "Amman",
    geonameid: 246314,
  },
  {
    name: "Saḩāb",
    country: "Jordan",
    subcountry: "Amman",
    geonameid: 247105,
  },
  {
    name: "Mādabā",
    country: "Jordan",
    subcountry: "Madaba",
    geonameid: 248370,
  },
  {
    name: "Ma'an",
    country: "Jordan",
    subcountry: "Ma’an",
    geonameid: 248382,
  },
  {
    name: "Kurayyimah",
    country: "Jordan",
    subcountry: "Irbid",
    geonameid: 248414,
  },
  {
    name: "Judita",
    country: "Jordan",
    subcountry: "Irbid",
    geonameid: 248803,
  },
  {
    name: "Jarash",
    country: "Jordan",
    subcountry: "Jerash",
    geonameid: 248875,
  },
  {
    name: "‘Izrā",
    country: "Jordan",
    subcountry: "Karak",
    geonameid: 248923,
  },
  {
    name: "Irbid",
    country: "Jordan",
    subcountry: "Irbid",
    geonameid: 248946,
  },
  {
    name: "Zarqa",
    country: "Jordan",
    subcountry: "Zarqa",
    geonameid: 250090,
  },
  {
    name: "Aydūn",
    country: "Jordan",
    subcountry: "Irbid",
    geonameid: 250152,
  },
  {
    name: "Aţ Ţafīlah",
    country: "Jordan",
    subcountry: "Tafielah",
    geonameid: 250198,
  },
  {
    name: "As Salţ",
    country: "Jordan",
    subcountry: "Balqa",
    geonameid: 250258,
  },
  {
    name: "Safi",
    country: "Jordan",
    subcountry: "Karak",
    geonameid: 250267,
  },
  {
    name: "Ar Ramthā",
    country: "Jordan",
    subcountry: "Irbid",
    geonameid: 250336,
  },
  {
    name: "‘Anjarah",
    country: "Jordan",
    subcountry: "Ajlun",
    geonameid: 250420,
  },
  {
    name: "Amman",
    country: "Jordan",
    subcountry: "Amman",
    geonameid: 250441,
  },
  {
    name: "Ḩayy al Quwaysimah",
    country: "Jordan",
    subcountry: "Amman",
    geonameid: 250461,
  },
  {
    name: "Mafraq",
    country: "Jordan",
    subcountry: "Mafraq",
    geonameid: 250582,
  },
  {
    name: "Qīr Moāv",
    country: "Jordan",
    subcountry: "Ma’an",
    geonameid: 250624,
  },
  {
    name: "Al Jubayhah",
    country: "Jordan",
    subcountry: "Amman",
    geonameid: 250637,
  },
  {
    name: "Aqaba",
    country: "Jordan",
    subcountry: "Aqaba",
    geonameid: 250774,
  },
  {
    name: "‘Ajlūn",
    country: "Jordan",
    subcountry: "Ajlun",
    geonameid: 250799,
  },
  {
    name: "Karak City",
    country: "Jordan",
    subcountry: "Karak",
    geonameid: 6946409,
  },
  {
    name: "Russeifa",
    country: "Jordan",
    subcountry: "Zarqa",
    geonameid: 7838895,
  },
  {
    name: "Rukban",
    country: "Jordan",
    subcountry: "Mafraq",
    geonameid: 11428685,
  },
  {
    name: "Shingū",
    country: "Japan",
    subcountry: "Wakayama",
    geonameid: 1847947,
  },
  {
    name: "Atsugi",
    country: "Japan",
    subcountry: "Kanagawa",
    geonameid: 1847963,
  },
  {
    name: "Akashi",
    country: "Japan",
    subcountry: "Hyōgo",
    geonameid: 1847966,
  },
  {
    name: "Zushi",
    country: "Japan",
    subcountry: "Kanagawa",
    geonameid: 1847968,
  },
  {
    name: "Zama",
    country: "Japan",
    subcountry: "Kanagawa",
    geonameid: 1848004,
  },
  {
    name: "Gero",
    country: "Japan",
    subcountry: "Gifu",
    geonameid: 1848055,
  },
  {
    name: "Yukuhashi",
    country: "Japan",
    subcountry: "Fukuoka",
    geonameid: 1848087,
  },
  {
    name: "Yūki",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 1848096,
  },
  {
    name: "Yugawara",
    country: "Japan",
    subcountry: "Kanagawa",
    geonameid: 1848113,
  },
  {
    name: "Yoshikawa",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1848188,
  },
  {
    name: "Yoshii",
    country: "Japan",
    subcountry: "Gunma",
    geonameid: 1848194,
  },
  {
    name: "Yoshida-kasugachō",
    country: "Japan",
    subcountry: "Niigata",
    geonameid: 1848210,
  },
  {
    name: "Yorii",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1848243,
  },
  {
    name: "Yono",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1848254,
  },
  {
    name: "Yonago",
    country: "Japan",
    subcountry: "Tottori",
    geonameid: 1848277,
  },
  {
    name: "Yonabaru",
    country: "Japan",
    subcountry: "Okinawa",
    geonameid: 1848281,
  },
  {
    name: "Yokosuka",
    country: "Japan",
    subcountry: "Kanagawa",
    geonameid: 1848313,
  },
  {
    name: "Yokohama",
    country: "Japan",
    subcountry: "Kanagawa",
    geonameid: 1848354,
  },
  {
    name: "Yokkaichi",
    country: "Japan",
    subcountry: "Mie",
    geonameid: 1848373,
  },
  {
    name: "Youkaichi",
    country: "Japan",
    subcountry: "Shiga",
    geonameid: 1848382,
  },
  {
    name: "Yawata",
    country: "Japan",
    subcountry: "Kyoto",
    geonameid: 1848439,
  },
  {
    name: "Honmachi",
    country: "Japan",
    subcountry: "Kumamoto",
    geonameid: 1848445,
  },
  {
    name: "Yatsuomachi-higashikumisaka",
    country: "Japan",
    subcountry: "Toyama",
    geonameid: 1848447,
  },
  {
    name: "Yasugichō",
    country: "Japan",
    subcountry: "Shimane",
    geonameid: 1848482,
  },
  {
    name: "Yashiro",
    country: "Japan",
    subcountry: "Hyōgo",
    geonameid: 1848498,
  },
  {
    name: "Yashio",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1848499,
  },
  {
    name: "Yao",
    country: "Japan",
    subcountry: "Ōsaka",
    geonameid: 1848522,
  },
  {
    name: "Yanai",
    country: "Japan",
    subcountry: "Yamaguchi",
    geonameid: 1848550,
  },
  {
    name: "Yanagawa",
    country: "Japan",
    subcountry: "Fukuoka",
    geonameid: 1848573,
  },
  {
    name: "Yamazakichō-nakabirose",
    country: "Japan",
    subcountry: "Hyōgo",
    geonameid: 1848633,
  },
  {
    name: "Yamaguchi",
    country: "Japan",
    subcountry: "Yamaguchi",
    geonameid: 1848689,
  },
  {
    name: "Yamaga",
    country: "Japan",
    subcountry: "Kumamoto",
    geonameid: 1848705,
  },
  {
    name: "Yaizu",
    country: "Japan",
    subcountry: "Shizuoka",
    geonameid: 1848774,
  },
  {
    name: "Yaita",
    country: "Japan",
    subcountry: "Tochigi",
    geonameid: 1848776,
  },
  {
    name: "Yabu",
    country: "Japan",
    subcountry: "Hyōgo",
    geonameid: 1848852,
  },
  {
    name: "Wakimachi",
    country: "Japan",
    subcountry: "Tokushima",
    geonameid: 1848933,
  },
  {
    name: "Utsunomiya",
    country: "Japan",
    subcountry: "Tochigi",
    geonameid: 1849053,
  },
  {
    name: "Uto",
    country: "Japan",
    subcountry: "Kumamoto",
    geonameid: 1849069,
  },
  {
    name: "Utazu",
    country: "Japan",
    subcountry: "Kagawa",
    geonameid: 1849073,
  },
  {
    name: "Usuki",
    country: "Japan",
    subcountry: "Oita",
    geonameid: 1849094,
  },
  {
    name: "Ushibukamachi",
    country: "Japan",
    subcountry: "Kumamoto",
    geonameid: 1849154,
  },
  {
    name: "Ureshinomachi-shimojuku",
    country: "Japan",
    subcountry: "Saga",
    geonameid: 1849183,
  },
  {
    name: "Urayasu",
    country: "Japan",
    subcountry: "Tokyo",
    geonameid: 1849186,
  },
  {
    name: "Uozu",
    country: "Japan",
    subcountry: "Toyama",
    geonameid: 1849237,
  },
  {
    name: "Umi",
    country: "Japan",
    subcountry: "Fukuoka",
    geonameid: 1849299,
  },
  {
    name: "Ujiie",
    country: "Japan",
    subcountry: "Tochigi",
    geonameid: 1849367,
  },
  {
    name: "Uji",
    country: "Japan",
    subcountry: "Kyoto",
    geonameid: 1849372,
  },
  {
    name: "Uenohara",
    country: "Japan",
    subcountry: "Yamanashi",
    geonameid: 1849407,
  },
  {
    name: "Ueno-ebisumachi",
    country: "Japan",
    subcountry: "Mie",
    geonameid: 1849414,
  },
  {
    name: "Uekimachi-mōno",
    country: "Japan",
    subcountry: "Kumamoto",
    geonameid: 1849424,
  },
  {
    name: "Ueda",
    country: "Japan",
    subcountry: "Nagano",
    geonameid: 1849429,
  },
  {
    name: "Ube",
    country: "Japan",
    subcountry: "Yamaguchi",
    geonameid: 1849498,
  },
  {
    name: "Tsuyama",
    country: "Japan",
    subcountry: "Okayama",
    geonameid: 1849519,
  },
  {
    name: "Tsushima",
    country: "Japan",
    subcountry: "Aichi",
    geonameid: 1849539,
  },
  {
    name: "Tsurusaki",
    country: "Japan",
    subcountry: "Oita",
    geonameid: 1849561,
  },
  {
    name: "Tsuruoka",
    country: "Japan",
    subcountry: "Yamagata",
    geonameid: 1849563,
  },
  {
    name: "Tsurugi-asahimachi",
    country: "Japan",
    subcountry: "Ishikawa",
    geonameid: 1849584,
  },
  {
    name: "Tsuruga",
    country: "Japan",
    subcountry: "Fukui",
    geonameid: 1849592,
  },
  {
    name: "Tsuma",
    country: "Japan",
    subcountry: "Miyazaki",
    geonameid: 1849647,
  },
  {
    name: "Tsukumiura",
    country: "Japan",
    subcountry: "Oita",
    geonameid: 1849661,
  },
  {
    name: "Tsukawaki",
    country: "Japan",
    subcountry: "Oita",
    geonameid: 1849706,
  },
  {
    name: "Tsubata",
    country: "Japan",
    subcountry: "Ishikawa",
    geonameid: 1849782,
  },
  {
    name: "Tsubame",
    country: "Japan",
    subcountry: "Niigata",
    geonameid: 1849788,
  },
  {
    name: "Tsu",
    country: "Japan",
    subcountry: "Mie",
    geonameid: 1849796,
  },
  {
    name: "Toyota",
    country: "Japan",
    subcountry: "Aichi",
    geonameid: 1849814,
  },
  {
    name: "Toyoshina",
    country: "Japan",
    subcountry: "Nagano",
    geonameid: 1849817,
  },
  {
    name: "Toyooka",
    country: "Japan",
    subcountry: "Hyōgo",
    geonameid: 1849831,
  },
  {
    name: "Toyonaka",
    country: "Japan",
    subcountry: "Ōsaka",
    geonameid: 1849837,
  },
  {
    name: "Toyokawa",
    country: "Japan",
    subcountry: "Aichi",
    geonameid: 1849845,
  },
  {
    name: "Toyohashi",
    country: "Japan",
    subcountry: "Aichi",
    geonameid: 1849846,
  },
  {
    name: "Toyohama",
    country: "Japan",
    subcountry: "Aichi",
    geonameid: 1849850,
  },
  {
    name: "Toyama",
    country: "Japan",
    subcountry: "Toyama",
    geonameid: 1849876,
  },
  {
    name: "Tottori",
    country: "Japan",
    subcountry: "Tottori",
    geonameid: 1849892,
  },
  {
    name: "Tosu",
    country: "Japan",
    subcountry: "Saga",
    geonameid: 1849904,
  },
  {
    name: "Tondabayashichō",
    country: "Japan",
    subcountry: "Ōsaka",
    geonameid: 1850034,
  },
  {
    name: "Tomioka",
    country: "Japan",
    subcountry: "Gunma",
    geonameid: 1850091,
  },
  {
    name: "Tomigusuku",
    country: "Japan",
    subcountry: "Okinawa",
    geonameid: 1850108,
  },
  {
    name: "Tokyo",
    country: "Japan",
    subcountry: "Tokyo",
    geonameid: 1850147,
  },
  {
    name: "Tokuyama",
    country: "Japan",
    subcountry: "Yamaguchi",
    geonameid: 1850152,
  },
  {
    name: "Tokushima",
    country: "Japan",
    subcountry: "Tokushima",
    geonameid: 1850158,
  },
  {
    name: "Tokorozawa",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1850181,
  },
  {
    name: "Tokoname",
    country: "Japan",
    subcountry: "Aichi",
    geonameid: 1850185,
  },
  {
    name: "Toki",
    country: "Japan",
    subcountry: "Gifu",
    geonameid: 1850207,
  },
  {
    name: "Tōkamachi",
    country: "Japan",
    subcountry: "Niigata",
    geonameid: 1850217,
  },
  {
    name: "Togitsu",
    country: "Japan",
    subcountry: "Nagasaki",
    geonameid: 1850269,
  },
  {
    name: "Tochio-honchō",
    country: "Japan",
    subcountry: "Niigata",
    geonameid: 1850307,
  },
  {
    name: "Tochigi",
    country: "Japan",
    subcountry: "Tochigi",
    geonameid: 1850311,
  },
  {
    name: "Toba",
    country: "Japan",
    subcountry: "Mie",
    geonameid: 1850345,
  },
  {
    name: "Tenri",
    country: "Japan",
    subcountry: "Nara",
    geonameid: 1850396,
  },
  {
    name: "Tennō",
    country: "Japan",
    subcountry: "Akita",
    geonameid: 1850405,
  },
  {
    name: "Tawaramoto",
    country: "Japan",
    subcountry: "Nara",
    geonameid: 1850472,
  },
  {
    name: "Tatsuno",
    country: "Japan",
    subcountry: "Nagano",
    geonameid: 1850498,
  },
  {
    name: "Tatsunochō-tominaga",
    country: "Japan",
    subcountry: "Hyōgo",
    geonameid: 1850499,
  },
  {
    name: "Tateyama",
    country: "Japan",
    subcountry: "Chiba",
    geonameid: 1850523,
  },
  {
    name: "Tatebayashi",
    country: "Japan",
    subcountry: "Gunma",
    geonameid: 1850559,
  },
  {
    name: "Tarumizu",
    country: "Japan",
    subcountry: "Kagoshima",
    geonameid: 1850589,
  },
  {
    name: "Tarui",
    country: "Japan",
    subcountry: "Gifu",
    geonameid: 1850600,
  },
  {
    name: "Tanushimarumachi-toyoki",
    country: "Japan",
    subcountry: "Fukuoka",
    geonameid: 1850627,
  },
  {
    name: "Tanuma",
    country: "Japan",
    subcountry: "Tochigi",
    geonameid: 1850630,
  },
  {
    name: "Nishi-Tokyo-shi",
    country: "Japan",
    subcountry: "Tokyo",
    geonameid: 1850692,
  },
  {
    name: "Tanashichō",
    country: "Japan",
    subcountry: "Tokyo",
    geonameid: 1850693,
  },
  {
    name: "Tanabe",
    country: "Japan",
    subcountry: "Kyoto",
    geonameid: 1850707,
  },
  {
    name: "Tanabe",
    country: "Japan",
    subcountry: "Wakayama",
    geonameid: 1850708,
  },
  {
    name: "Tamano",
    country: "Japan",
    subcountry: "Okayama",
    geonameid: 1850742,
  },
  {
    name: "Tamana",
    country: "Japan",
    subcountry: "Kumamoto",
    geonameid: 1850745,
  },
  {
    name: "Tamamura",
    country: "Japan",
    subcountry: "Gunma",
    geonameid: 1850746,
  },
  {
    name: "Taketoyo",
    country: "Japan",
    subcountry: "Aichi",
    geonameid: 1850818,
  },
  {
    name: "Takeo",
    country: "Japan",
    subcountry: "Saga",
    geonameid: 1850834,
  },
  {
    name: "Takehara",
    country: "Japan",
    subcountry: "Hiroshima",
    geonameid: 1850860,
  },
  {
    name: "Takefu",
    country: "Japan",
    subcountry: "Fukui",
    geonameid: 1850872,
  },
  {
    name: "Takedamachi",
    country: "Japan",
    subcountry: "Oita",
    geonameid: 1850878,
  },
  {
    name: "Takayama",
    country: "Japan",
    subcountry: "Gifu",
    geonameid: 1850892,
  },
  {
    name: "Takatsuki",
    country: "Japan",
    subcountry: "Ōsaka",
    geonameid: 1850910,
  },
  {
    name: "Takasaki",
    country: "Japan",
    subcountry: "Gunma",
    geonameid: 1851002,
  },
  {
    name: "Takarazuka",
    country: "Japan",
    subcountry: "Hyōgo",
    geonameid: 1851012,
  },
  {
    name: "Takaoka",
    country: "Japan",
    subcountry: "Toyama",
    geonameid: 1851032,
  },
  {
    name: "Takanabe",
    country: "Japan",
    subcountry: "Miyazaki",
    geonameid: 1851068,
  },
  {
    name: "Takamatsu",
    country: "Japan",
    subcountry: "Kagawa",
    geonameid: 1851100,
  },
  {
    name: "Takaishi",
    country: "Japan",
    subcountry: "Ōsaka",
    geonameid: 1851125,
  },
  {
    name: "Takahashi",
    country: "Japan",
    subcountry: "Okayama",
    geonameid: 1851137,
  },
  {
    name: "Takahama",
    country: "Japan",
    subcountry: "Aichi",
    geonameid: 1851155,
  },
  {
    name: "Bungo-Takada-shi",
    country: "Japan",
    subcountry: "Oita",
    geonameid: 1851170,
  },
  {
    name: "Tajimi",
    country: "Japan",
    subcountry: "Gifu",
    geonameid: 1851193,
  },
  {
    name: "Tahara",
    country: "Japan",
    subcountry: "Aichi",
    geonameid: 1851259,
  },
  {
    name: "Tagawa",
    country: "Japan",
    subcountry: "Fukuoka",
    geonameid: 1851273,
  },
  {
    name: "Tadotsu",
    country: "Japan",
    subcountry: "Kagawa",
    geonameid: 1851282,
  },
  {
    name: "Tachiarai",
    country: "Japan",
    subcountry: "Fukuoka",
    geonameid: 1851319,
  },
  {
    name: "Suzuka",
    country: "Japan",
    subcountry: "Mie",
    geonameid: 1851348,
  },
  {
    name: "Suzaka",
    country: "Japan",
    subcountry: "Nagano",
    geonameid: 1851357,
  },
  {
    name: "Suwa",
    country: "Japan",
    subcountry: "Nagano",
    geonameid: 1851368,
  },
  {
    name: "Susaki",
    country: "Japan",
    subcountry: "Kochi",
    geonameid: 1851390,
  },
  {
    name: "Sumoto",
    country: "Japan",
    subcountry: "Hyōgo",
    geonameid: 1851426,
  },
  {
    name: "Sukumo",
    country: "Japan",
    subcountry: "Kochi",
    geonameid: 1851462,
  },
  {
    name: "Suita",
    country: "Japan",
    subcountry: "Ōsaka",
    geonameid: 1851483,
  },
  {
    name: "Suibara",
    country: "Japan",
    subcountry: "Niigata",
    geonameid: 1851494,
  },
  {
    name: "Sugito",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1851504,
  },
  {
    name: "Sueyoshichō-ninokata",
    country: "Japan",
    subcountry: "Kagoshima",
    geonameid: 1851542,
  },
  {
    name: "Sōka",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1851604,
  },
  {
    name: "Sōja",
    country: "Japan",
    subcountry: "Okayama",
    geonameid: 1851606,
  },
  {
    name: "Sobue",
    country: "Japan",
    subcountry: "Aichi",
    geonameid: 1851622,
  },
  {
    name: "Shōbu",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1851711,
  },
  {
    name: "Shōbara",
    country: "Japan",
    subcountry: "Hiroshima",
    geonameid: 1851713,
  },
  {
    name: "Shizuoka",
    country: "Japan",
    subcountry: "Shizuoka",
    geonameid: 1851717,
  },
  {
    name: "Shirone",
    country: "Japan",
    subcountry: "Niigata",
    geonameid: 1851813,
  },
  {
    name: "Shiraoka",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1851883,
  },
  {
    name: "Shirahamachō-usazakiminami",
    country: "Japan",
    subcountry: "Hyōgo",
    geonameid: 1851935,
  },
  {
    name: "Shirahama",
    country: "Japan",
    subcountry: "Wakayama",
    geonameid: 1851936,
  },
  {
    name: "Shiozawa",
    country: "Japan",
    subcountry: "Niigata",
    geonameid: 1851952,
  },
  {
    name: "Shiojiri",
    country: "Japan",
    subcountry: "Nagano",
    geonameid: 1852003,
  },
  {
    name: "Shinshiro",
    country: "Japan",
    subcountry: "Aichi",
    geonameid: 1852046,
  },
  {
    name: "Shin’ichi",
    country: "Japan",
    subcountry: "Hiroshima",
    geonameid: 1852102,
  },
  {
    name: "Shingū",
    country: "Japan",
    subcountry: "Fukuoka",
    geonameid: 1852109,
  },
  {
    name: "Shimonoseki",
    country: "Japan",
    subcountry: "Yamaguchi",
    geonameid: 1852225,
  },
  {
    name: "Shimodate",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 1852347,
  },
  {
    name: "Shimoda",
    country: "Japan",
    subcountry: "Shizuoka",
    geonameid: 1852357,
  },
  {
    name: "Minato",
    country: "Japan",
    subcountry: "Wakayama",
    geonameid: 1852383,
  },
  {
    name: "Nishishinminato",
    country: "Japan",
    subcountry: "Toyama",
    geonameid: 1852385,
  },
  {
    name: "Shimada",
    country: "Japan",
    subcountry: "Shizuoka",
    geonameid: 1852472,
  },
  {
    name: "Shimabara",
    country: "Japan",
    subcountry: "Nagasaki",
    geonameid: 1852479,
  },
  {
    name: "Shima",
    country: "Japan",
    subcountry: "Mie",
    geonameid: 1852481,
  },
  {
    name: "Shiki",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1852502,
  },
  {
    name: "Shido",
    country: "Japan",
    subcountry: "Kagawa",
    geonameid: 1852561,
  },
  {
    name: "Shibushi",
    country: "Japan",
    subcountry: "Kagoshima",
    geonameid: 1852588,
  },
  {
    name: "Shibukawa",
    country: "Japan",
    subcountry: "Gunma",
    geonameid: 1852595,
  },
  {
    name: "Shibata",
    country: "Japan",
    subcountry: "Niigata",
    geonameid: 1852607,
  },
  {
    name: "Seto",
    country: "Japan",
    subcountry: "Aichi",
    geonameid: 1852663,
  },
  {
    name: "Setakamachi-takayanagi",
    country: "Japan",
    subcountry: "Fukuoka",
    geonameid: 1852673,
  },
  {
    name: "Satsumasendai",
    country: "Japan",
    subcountry: "Kagoshima",
    geonameid: 1852736,
  },
  {
    name: "Satte",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1852849,
  },
  {
    name: "Sasebo",
    country: "Japan",
    subcountry: "Nagasaki",
    geonameid: 1852899,
  },
  {
    name: "Sasayama",
    country: "Japan",
    subcountry: "Hyōgo",
    geonameid: 1852901,
  },
  {
    name: "Sasaguri",
    country: "Japan",
    subcountry: "Fukuoka",
    geonameid: 1852915,
  },
  {
    name: "Sano",
    country: "Japan",
    subcountry: "Tochigi",
    geonameid: 1852964,
  },
  {
    name: "Sanjō",
    country: "Japan",
    subcountry: "Niigata",
    geonameid: 1852984,
  },
  {
    name: "Sandachō",
    country: "Japan",
    subcountry: "Hyōgo",
    geonameid: 1853008,
  },
  {
    name: "Sakurai",
    country: "Japan",
    subcountry: "Nara",
    geonameid: 1853066,
  },
  {
    name: "Saku",
    country: "Japan",
    subcountry: "Nagano",
    geonameid: 1853081,
  },
  {
    name: "Sakata",
    country: "Japan",
    subcountry: "Yamagata",
    geonameid: 1853140,
  },
  {
    name: "Sakaki",
    country: "Japan",
    subcountry: "Nagano",
    geonameid: 1853163,
  },
  {
    name: "Sakaiminato",
    country: "Japan",
    subcountry: "Tottori",
    geonameid: 1853174,
  },
  {
    name: "Sakaidechō",
    country: "Japan",
    subcountry: "Kagawa",
    geonameid: 1853190,
  },
  {
    name: "Sakai-nakajima",
    country: "Japan",
    subcountry: "Gunma",
    geonameid: 1853192,
  },
  {
    name: "Sakai",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 1853193,
  },
  {
    name: "Sakai",
    country: "Japan",
    subcountry: "Ōsaka",
    geonameid: 1853195,
  },
  {
    name: "Sakado",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1853209,
  },
  {
    name: "Saiki",
    country: "Japan",
    subcountry: "Oita",
    geonameid: 1853237,
  },
  {
    name: "Sagara",
    country: "Japan",
    subcountry: "Shizuoka",
    geonameid: 1853280,
  },
  {
    name: "Saga",
    country: "Japan",
    subcountry: "Saga",
    geonameid: 1853303,
  },
  {
    name: "Sabae",
    country: "Japan",
    subcountry: "Fukui",
    geonameid: 1853338,
  },
  {
    name: "Ryūō",
    country: "Japan",
    subcountry: "Yamanashi",
    geonameid: 1853354,
  },
  {
    name: "Ryōtsu-minato",
    country: "Japan",
    subcountry: "Niigata",
    geonameid: 1853371,
  },
  {
    name: "Ōzu",
    country: "Japan",
    subcountry: "Kumamoto",
    geonameid: 1853433,
  },
  {
    name: "Oyama",
    country: "Japan",
    subcountry: "Tochigi",
    geonameid: 1853483,
  },
  {
    name: "Ōyama",
    country: "Japan",
    subcountry: "Shizuoka",
    geonameid: 1853486,
  },
  {
    name: "Owase",
    country: "Japan",
    subcountry: "Mie",
    geonameid: 1853514,
  },
  {
    name: "Ōtsuki",
    country: "Japan",
    subcountry: "Yamanashi",
    geonameid: 1853564,
  },
  {
    name: "Ōtsu",
    country: "Japan",
    subcountry: "Shiga",
    geonameid: 1853574,
  },
  {
    name: "Ōtake",
    country: "Japan",
    subcountry: "Hiroshima",
    geonameid: 1853662,
  },
  {
    name: "Ōta",
    country: "Japan",
    subcountry: "Gunma",
    geonameid: 1853677,
  },
  {
    name: "Osaka",
    country: "Japan",
    subcountry: "Ōsaka",
    geonameid: 1853909,
  },
  {
    name: "Onomichi",
    country: "Japan",
    subcountry: "Hiroshima",
    geonameid: 1853992,
  },
  {
    name: "Onoda",
    country: "Japan",
    subcountry: "Yamaguchi",
    geonameid: 1854018,
  },
  {
    name: "Ono",
    country: "Japan",
    subcountry: "Fukui",
    geonameid: 1854022,
  },
  {
    name: "Ono",
    country: "Japan",
    subcountry: "Hyōgo",
    geonameid: 1854026,
  },
  {
    name: "Ōno-hara",
    country: "Japan",
    subcountry: "Hiroshima",
    geonameid: 1854028,
  },
  {
    name: "Ōmuta",
    country: "Japan",
    subcountry: "Fukuoka",
    geonameid: 1854083,
  },
  {
    name: "Ōmura",
    country: "Japan",
    subcountry: "Nagasaki",
    geonameid: 1854093,
  },
  {
    name: "Ōme",
    country: "Japan",
    subcountry: "Tokyo",
    geonameid: 1854162,
  },
  {
    name: "Ōmamachō-ōmama",
    country: "Japan",
    subcountry: "Gunma",
    geonameid: 1854177,
  },
  {
    name: "Ōmachi",
    country: "Japan",
    subcountry: "Nagano",
    geonameid: 1854186,
  },
  {
    name: "Ōkuchi-shinohara",
    country: "Japan",
    subcountry: "Kagoshima",
    geonameid: 1854246,
  },
  {
    name: "Okegawa",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1854371,
  },
  {
    name: "Okazaki",
    country: "Japan",
    subcountry: "Aichi",
    geonameid: 1854376,
  },
  {
    name: "Okayama",
    country: "Japan",
    subcountry: "Okayama",
    geonameid: 1854383,
  },
  {
    name: "Okaya",
    country: "Japan",
    subcountry: "Nagano",
    geonameid: 1854384,
  },
  {
    name: "Ōkawa",
    country: "Japan",
    subcountry: "Fukuoka",
    geonameid: 1854405,
  },
  {
    name: "Ojiya",
    country: "Japan",
    subcountry: "Niigata",
    geonameid: 1854444,
  },
  {
    name: "Ōita",
    country: "Japan",
    subcountry: "Oita",
    geonameid: 1854487,
  },
  {
    name: "Ōiso",
    country: "Japan",
    subcountry: "Kanagawa",
    geonameid: 1854492,
  },
  {
    name: "Ōi",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1854530,
  },
  {
    name: "Ogōri-shimogō",
    country: "Japan",
    subcountry: "Yamaguchi",
    geonameid: 1854629,
  },
  {
    name: "Ogawa",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1854665,
  },
  {
    name: "Ōgaki",
    country: "Japan",
    subcountry: "Gifu",
    geonameid: 1854703,
  },
  {
    name: "Odawara",
    country: "Japan",
    subcountry: "Kanagawa",
    geonameid: 1854747,
  },
  {
    name: "Ōdachō-ōda",
    country: "Japan",
    subcountry: "Shimane",
    geonameid: 1854774,
  },
  {
    name: "Ōbu",
    country: "Japan",
    subcountry: "Aichi",
    geonameid: 1854803,
  },
  {
    name: "Obita",
    country: "Japan",
    subcountry: "Nagasaki",
    geonameid: 1854807,
  },
  {
    name: "Obama",
    country: "Japan",
    subcountry: "Fukui",
    geonameid: 1854849,
  },
  {
    name: "Nyūzen",
    country: "Japan",
    subcountry: "Toyama",
    geonameid: 1854868,
  },
  {
    name: "Numazu",
    country: "Japan",
    subcountry: "Shizuoka",
    geonameid: 1854902,
  },
  {
    name: "Numata",
    country: "Japan",
    subcountry: "Gunma",
    geonameid: 1854905,
  },
  {
    name: "Nonoichi",
    country: "Japan",
    subcountry: "Ishikawa",
    geonameid: 1854979,
  },
  {
    name: "Nōgata",
    country: "Japan",
    subcountry: "Fukuoka",
    geonameid: 1855066,
  },
  {
    name: "Noda",
    country: "Japan",
    subcountry: "Chiba",
    geonameid: 1855078,
  },
  {
    name: "Nobeoka",
    country: "Japan",
    subcountry: "Miyazaki",
    geonameid: 1855095,
  },
  {
    name: "Nishiwaki",
    country: "Japan",
    subcountry: "Hyōgo",
    geonameid: 1855134,
  },
  {
    name: "Nishio",
    country: "Japan",
    subcountry: "Aichi",
    geonameid: 1855189,
  },
  {
    name: "Nishinoomote",
    country: "Japan",
    subcountry: "Kagoshima",
    geonameid: 1855203,
  },
  {
    name: "Nishinomiya-hama",
    country: "Japan",
    subcountry: "Hyōgo",
    geonameid: 1855207,
  },
  {
    name: "Nirasaki",
    country: "Japan",
    subcountry: "Yamanashi",
    geonameid: 1855363,
  },
  {
    name: "Ninomiya",
    country: "Japan",
    subcountry: "Kanagawa",
    geonameid: 1855380,
  },
  {
    name: "Nikkō",
    country: "Japan",
    subcountry: "Tochigi",
    geonameid: 1855395,
  },
  {
    name: "Niitsu-honchō",
    country: "Japan",
    subcountry: "Niigata",
    geonameid: 1855410,
  },
  {
    name: "Niimi",
    country: "Japan",
    subcountry: "Okayama",
    geonameid: 1855416,
  },
  {
    name: "Niihama",
    country: "Japan",
    subcountry: "Ehime",
    geonameid: 1855425,
  },
  {
    name: "Niigata",
    country: "Japan",
    subcountry: "Niigata",
    geonameid: 1855431,
  },
  {
    name: "Nichinan",
    country: "Japan",
    subcountry: "Miyazaki",
    geonameid: 1855476,
  },
  {
    name: "Naze",
    country: "Japan",
    subcountry: "Kagoshima",
    geonameid: 1855540,
  },
  {
    name: "Narutochō-mitsuishi",
    country: "Japan",
    subcountry: "Tokushima",
    geonameid: 1855580,
  },
  {
    name: "Nara-shi",
    country: "Japan",
    subcountry: "Nara",
    geonameid: 1855612,
  },
  {
    name: "Nanao",
    country: "Japan",
    subcountry: "Ishikawa",
    geonameid: 1855670,
  },
  {
    name: "Namerikawa",
    country: "Japan",
    subcountry: "Toyama",
    geonameid: 1855694,
  },
  {
    name: "Nakatsugawa",
    country: "Japan",
    subcountry: "Gifu",
    geonameid: 1855753,
  },
  {
    name: "Nakatsu",
    country: "Japan",
    subcountry: "Oita",
    geonameid: 1855757,
  },
  {
    name: "Nakanojōmachi",
    country: "Japan",
    subcountry: "Gunma",
    geonameid: 1855852,
  },
  {
    name: "Nakano",
    country: "Japan",
    subcountry: "Nagano",
    geonameid: 1855863,
  },
  {
    name: "Nakamura",
    country: "Japan",
    subcountry: "Kochi",
    geonameid: 1855891,
  },
  {
    name: "Nakama",
    country: "Japan",
    subcountry: "Fukuoka",
    geonameid: 1855907,
  },
  {
    name: "Naha",
    country: "Japan",
    subcountry: "Okinawa",
    geonameid: 1856035,
  },
  {
    name: "Nagoya",
    country: "Japan",
    subcountry: "Aichi",
    geonameid: 1856057,
  },
  {
    name: "Nago",
    country: "Japan",
    subcountry: "Okinawa",
    geonameid: 1856068,
  },
  {
    name: "Nagasu",
    country: "Japan",
    subcountry: "Kumamoto",
    geonameid: 1856120,
  },
  {
    name: "Nagasaki",
    country: "Japan",
    subcountry: "Nagasaki",
    geonameid: 1856177,
  },
  {
    name: "Nagareyama",
    country: "Japan",
    subcountry: "Chiba",
    geonameid: 1856184,
  },
  {
    name: "Nagaoka",
    country: "Japan",
    subcountry: "Niigata",
    geonameid: 1856199,
  },
  {
    name: "Nagano",
    country: "Japan",
    subcountry: "Nagano",
    geonameid: 1856215,
  },
  {
    name: "Nagahama",
    country: "Japan",
    subcountry: "Shiga",
    geonameid: 1856243,
  },
  {
    name: "Nabari",
    country: "Japan",
    subcountry: "Mie",
    geonameid: 1856293,
  },
  {
    name: "Musashino",
    country: "Japan",
    subcountry: "Tokyo",
    geonameid: 1856367,
  },
  {
    name: "Muroto-misakicho",
    country: "Japan",
    subcountry: "Kochi",
    geonameid: 1856392,
  },
  {
    name: "Muramatsu",
    country: "Japan",
    subcountry: "Niigata",
    geonameid: 1856426,
  },
  {
    name: "Murakami",
    country: "Japan",
    subcountry: "Niigata",
    geonameid: 1856434,
  },
  {
    name: "Mukō",
    country: "Japan",
    subcountry: "Kyoto",
    geonameid: 1856456,
  },
  {
    name: "Muikamachi",
    country: "Japan",
    subcountry: "Niigata",
    geonameid: 1856476,
  },
  {
    name: "Morohongō",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1856560,
  },
  {
    name: "Moriyama",
    country: "Japan",
    subcountry: "Shiga",
    geonameid: 1856569,
  },
  {
    name: "Moriguchi",
    country: "Japan",
    subcountry: "Ōsaka",
    geonameid: 1856584,
  },
  {
    name: "Mori",
    country: "Japan",
    subcountry: "Shizuoka",
    geonameid: 1856586,
  },
  {
    name: "Mizunami",
    country: "Japan",
    subcountry: "Gifu",
    geonameid: 1856667,
  },
  {
    name: "Miyoshi",
    country: "Japan",
    subcountry: "Hiroshima",
    geonameid: 1856698,
  },
  {
    name: "Miyazu",
    country: "Japan",
    subcountry: "Kyoto",
    geonameid: 1856703,
  },
  {
    name: "Miyazaki",
    country: "Japan",
    subcountry: "Miyazaki",
    geonameid: 1856717,
  },
  {
    name: "Miyakonojō",
    country: "Japan",
    subcountry: "Miyazaki",
    geonameid: 1856775,
  },
  {
    name: "Miyata",
    country: "Japan",
    subcountry: "Fukuoka",
    geonameid: 1856828,
  },
  {
    name: "Mitsuke",
    country: "Japan",
    subcountry: "Niigata",
    geonameid: 1856878,
  },
  {
    name: "Mitsukaidō",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 1856881,
  },
  {
    name: "Mitake",
    country: "Japan",
    subcountry: "Gifu",
    geonameid: 1856938,
  },
  {
    name: "Mishima",
    country: "Japan",
    subcountry: "Shizuoka",
    geonameid: 1856977,
  },
  {
    name: "Mino",
    country: "Japan",
    subcountry: "Ōsaka",
    geonameid: 1857046,
  },
  {
    name: "Mino",
    country: "Japan",
    subcountry: "Gifu",
    geonameid: 1857062,
  },
  {
    name: "Minamirinkan",
    country: "Japan",
    subcountry: "Kanagawa",
    geonameid: 1857144,
  },
  {
    name: "Minamata",
    country: "Japan",
    subcountry: "Kumamoto",
    geonameid: 1857208,
  },
  {
    name: "Minakuchichō-matoba",
    country: "Japan",
    subcountry: "Shiga",
    geonameid: 1857209,
  },
  {
    name: "Mikuni",
    country: "Japan",
    subcountry: "Fukui",
    geonameid: 1857260,
  },
  {
    name: "Miki",
    country: "Japan",
    subcountry: "Hyōgo",
    geonameid: 1857276,
  },
  {
    name: "Mihara",
    country: "Japan",
    subcountry: "Hiroshima",
    geonameid: 1857334,
  },
  {
    name: "Mifune",
    country: "Japan",
    subcountry: "Kumamoto",
    geonameid: 1857343,
  },
  {
    name: "Mibu",
    country: "Japan",
    subcountry: "Tochigi",
    geonameid: 1857379,
  },
  {
    name: "Menuma",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1857403,
  },
  {
    name: "Matsutō",
    country: "Japan",
    subcountry: "Ishikawa",
    geonameid: 1857470,
  },
  {
    name: "Matsumoto",
    country: "Japan",
    subcountry: "Nagano",
    geonameid: 1857519,
  },
  {
    name: "Matsue",
    country: "Japan",
    subcountry: "Shimane",
    geonameid: 1857550,
  },
  {
    name: "Matsudo",
    country: "Japan",
    subcountry: "Chiba",
    geonameid: 1857553,
  },
  {
    name: "Matsubase",
    country: "Japan",
    subcountry: "Kumamoto",
    geonameid: 1857560,
  },
  {
    name: "Matsubara",
    country: "Japan",
    subcountry: "Ōsaka",
    geonameid: 1857568,
  },
  {
    name: "Masuda",
    country: "Japan",
    subcountry: "Shimane",
    geonameid: 1857594,
  },
  {
    name: "Maruoka",
    country: "Japan",
    subcountry: "Fukui",
    geonameid: 1857651,
  },
  {
    name: "Kamimaruko",
    country: "Japan",
    subcountry: "Nagano",
    geonameid: 1857659,
  },
  {
    name: "Marugame",
    country: "Japan",
    subcountry: "Kagawa",
    geonameid: 1857665,
  },
  {
    name: "Makurazaki",
    country: "Japan",
    subcountry: "Kagoshima",
    geonameid: 1857712,
  },
  {
    name: "Maki",
    country: "Japan",
    subcountry: "Niigata",
    geonameid: 1857751,
  },
  {
    name: "Maizuru",
    country: "Japan",
    subcountry: "Kyoto",
    geonameid: 1857766,
  },
  {
    name: "Maibara",
    country: "Japan",
    subcountry: "Shiga",
    geonameid: 1857769,
  },
  {
    name: "Maebashi",
    country: "Japan",
    subcountry: "Gunma",
    geonameid: 1857843,
  },
  {
    name: "Maebaru-chūō",
    country: "Japan",
    subcountry: "Fukuoka",
    geonameid: 1857844,
  },
  {
    name: "Machida",
    country: "Japan",
    subcountry: "Tokyo",
    geonameid: 1857871,
  },
  {
    name: "Kyoto",
    country: "Japan",
    subcountry: "Kyoto",
    geonameid: 1857910,
  },
  {
    name: "Kushimoto",
    country: "Japan",
    subcountry: "Wakayama",
    geonameid: 1858033,
  },
  {
    name: "Kushikino",
    country: "Japan",
    subcountry: "Kagoshima",
    geonameid: 1858041,
  },
  {
    name: "Kusatsu",
    country: "Japan",
    subcountry: "Shiga",
    geonameid: 1858067,
  },
  {
    name: "Kurume",
    country: "Japan",
    subcountry: "Fukuoka",
    geonameid: 1858088,
  },
  {
    name: "Kuroda",
    country: "Japan",
    subcountry: "Aichi",
    geonameid: 1858249,
  },
  {
    name: "Kurihashi",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1858283,
  },
  {
    name: "Kure",
    country: "Japan",
    subcountry: "Hiroshima",
    geonameid: 1858296,
  },
  {
    name: "Kurayoshi",
    country: "Japan",
    subcountry: "Tottori",
    geonameid: 1858301,
  },
  {
    name: "Kurashiki",
    country: "Japan",
    subcountry: "Okayama",
    geonameid: 1858311,
  },
  {
    name: "Kumamoto",
    country: "Japan",
    subcountry: "Kumamoto",
    geonameid: 1858421,
  },
  {
    name: "Kumagaya",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1858428,
  },
  {
    name: "Kukichūō",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1858445,
  },
  {
    name: "Kudamatsu",
    country: "Japan",
    subcountry: "Yamaguchi",
    geonameid: 1858498,
  },
  {
    name: "Kozakai-chō",
    country: "Japan",
    subcountry: "Aichi",
    geonameid: 1858591,
  },
  {
    name: "Koshigaya",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1858729,
  },
  {
    name: "Kōnosu",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1858794,
  },
  {
    name: "Kōnan",
    country: "Japan",
    subcountry: "Aichi",
    geonameid: 1858836,
  },
  {
    name: "Komoro",
    country: "Japan",
    subcountry: "Nagano",
    geonameid: 1858858,
  },
  {
    name: "Komono",
    country: "Japan",
    subcountry: "Mie",
    geonameid: 1858866,
  },
  {
    name: "Komatsushimachō",
    country: "Japan",
    subcountry: "Tokushima",
    geonameid: 1858902,
  },
  {
    name: "Komatsu",
    country: "Japan",
    subcountry: "Ishikawa",
    geonameid: 1858910,
  },
  {
    name: "Komaki",
    country: "Japan",
    subcountry: "Aichi",
    geonameid: 1858926,
  },
  {
    name: "Kokubunji",
    country: "Japan",
    subcountry: "Tokyo",
    geonameid: 1858964,
  },
  {
    name: "Kokubu-matsuki",
    country: "Japan",
    subcountry: "Kagoshima",
    geonameid: 1858972,
  },
  {
    name: "Koga",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 1859093,
  },
  {
    name: "Koga",
    country: "Japan",
    subcountry: "Fukuoka",
    geonameid: 1859094,
  },
  {
    name: "Kōfu",
    country: "Japan",
    subcountry: "Yamanashi",
    geonameid: 1859100,
  },
  {
    name: "Kodamachō-kodamaminami",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1859113,
  },
  {
    name: "Kochi",
    country: "Japan",
    subcountry: "Kochi",
    geonameid: 1859146,
  },
  {
    name: "Kobe",
    country: "Japan",
    subcountry: "Hyōgo",
    geonameid: 1859171,
  },
  {
    name: "Kobayashi",
    country: "Japan",
    subcountry: "Miyazaki",
    geonameid: 1859175,
  },
  {
    name: "Kitsuki",
    country: "Japan",
    subcountry: "Oita",
    geonameid: 1859234,
  },
  {
    name: "Kitakyushu",
    country: "Japan",
    subcountry: "Fukuoka",
    geonameid: 1859307,
  },
  {
    name: "Kitakata",
    country: "Japan",
    subcountry: "Fukushima",
    geonameid: 1859319,
  },
  {
    name: "Kitahama",
    country: "Japan",
    subcountry: "Shiga",
    geonameid: 1859335,
  },
  {
    name: "Kitagata",
    country: "Japan",
    subcountry: "Gifu",
    geonameid: 1859355,
  },
  {
    name: "Kishiwada",
    country: "Japan",
    subcountry: "Ōsaka",
    geonameid: 1859383,
  },
  {
    name: "Kisarazu",
    country: "Japan",
    subcountry: "Chiba",
    geonameid: 1859393,
  },
  {
    name: "Kisai",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1859400,
  },
  {
    name: "Kiryū",
    country: "Japan",
    subcountry: "Gunma",
    geonameid: 1859405,
  },
  {
    name: "Kikuchi",
    country: "Japan",
    subcountry: "Kumamoto",
    geonameid: 1859492,
  },
  {
    name: "Kazo",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1859586,
  },
  {
    name: "Kawasaki",
    country: "Japan",
    subcountry: "Kanagawa",
    geonameid: 1859642,
  },
  {
    name: "Kawasaki",
    country: "Japan",
    subcountry: "Fukuoka",
    geonameid: 1859647,
  },
  {
    name: "Kawanishi",
    country: "Japan",
    subcountry: "Hyōgo",
    geonameid: 1859675,
  },
  {
    name: "Kawaminami",
    country: "Japan",
    subcountry: "Miyazaki",
    geonameid: 1859688,
  },
  {
    name: "Kawaguchi",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1859730,
  },
  {
    name: "Kawagoe",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1859740,
  },
  {
    name: "Katsuyama",
    country: "Japan",
    subcountry: "Fukui",
    geonameid: 1859765,
  },
  {
    name: "Kasukabe",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1859884,
  },
  {
    name: "Kasugai",
    country: "Japan",
    subcountry: "Aichi",
    geonameid: 1859891,
  },
  {
    name: "Kashiwazaki",
    country: "Japan",
    subcountry: "Niigata",
    geonameid: 1859908,
  },
  {
    name: "Kashiwa",
    country: "Japan",
    subcountry: "Chiba",
    geonameid: 1859924,
  },
  {
    name: "Kashima",
    country: "Japan",
    subcountry: "Saga",
    geonameid: 1859941,
  },
  {
    name: "Kashihara-shi",
    country: "Japan",
    subcountry: "Nara",
    geonameid: 1859951,
  },
  {
    name: "Kashihara",
    country: "Japan",
    subcountry: "Ōsaka",
    geonameid: 1859952,
  },
  {
    name: "Kaseda-shirakame",
    country: "Japan",
    subcountry: "Kagoshima",
    geonameid: 1859964,
  },
  {
    name: "Kasaoka",
    country: "Japan",
    subcountry: "Okayama",
    geonameid: 1859990,
  },
  {
    name: "Kasamatsuchō",
    country: "Japan",
    subcountry: "Gifu",
    geonameid: 1859998,
  },
  {
    name: "Kariya",
    country: "Japan",
    subcountry: "Aichi",
    geonameid: 1860034,
  },
  {
    name: "Karatsu",
    country: "Japan",
    subcountry: "Saga",
    geonameid: 1860063,
  },
  {
    name: "Kanzakimachi-kanzaki",
    country: "Japan",
    subcountry: "Saga",
    geonameid: 1860095,
  },
  {
    name: "Kanuma",
    country: "Japan",
    subcountry: "Tochigi",
    geonameid: 1860098,
  },
  {
    name: "Kanoya",
    country: "Japan",
    subcountry: "Kagoshima",
    geonameid: 1860112,
  },
  {
    name: "Kan’onjichō",
    country: "Japan",
    subcountry: "Kagawa",
    geonameid: 1860122,
  },
  {
    name: "Kannabechō-yahiro",
    country: "Japan",
    subcountry: "Hiroshima",
    geonameid: 1860176,
  },
  {
    name: "Kanie",
    country: "Japan",
    subcountry: "Aichi",
    geonameid: 1860191,
  },
  {
    name: "Kanekomachi",
    country: "Japan",
    subcountry: "Gunma",
    geonameid: 1860211,
  },
  {
    name: "Kanda",
    country: "Japan",
    subcountry: "Fukuoka",
    geonameid: 1860234,
  },
  {
    name: "Kanazawa",
    country: "Japan",
    subcountry: "Ishikawa",
    geonameid: 1860243,
  },
  {
    name: "Kanaya",
    country: "Japan",
    subcountry: "Shizuoka",
    geonameid: 1860256,
  },
  {
    name: "Kamojimachō-jōgejima",
    country: "Japan",
    subcountry: "Tokushima",
    geonameid: 1860321,
  },
  {
    name: "Kamogatachō-kamogata",
    country: "Japan",
    subcountry: "Okayama",
    geonameid: 1860335,
  },
  {
    name: "Kamo",
    country: "Japan",
    subcountry: "Niigata",
    geonameid: 1860341,
  },
  {
    name: "Kamirenjaku",
    country: "Japan",
    subcountry: "Tokyo",
    geonameid: 1860437,
  },
  {
    name: "Kaminokawa",
    country: "Japan",
    subcountry: "Tochigi",
    geonameid: 1860458,
  },
  {
    name: "Kamiichi",
    country: "Japan",
    subcountry: "Toyama",
    geonameid: 1860563,
  },
  {
    name: "Kamigōri",
    country: "Japan",
    subcountry: "Hyōgo",
    geonameid: 1860588,
  },
  {
    name: "Kameyama",
    country: "Japan",
    subcountry: "Mie",
    geonameid: 1860626,
  },
  {
    name: "Kameoka",
    country: "Japan",
    subcountry: "Kyoto",
    geonameid: 1860635,
  },
  {
    name: "Kameda-honchō",
    country: "Japan",
    subcountry: "Niigata",
    geonameid: 1860648,
  },
  {
    name: "Kamakura",
    country: "Japan",
    subcountry: "Kanagawa",
    geonameid: 1860672,
  },
  {
    name: "Kakogawachō-honmachi",
    country: "Japan",
    subcountry: "Hyōgo",
    geonameid: 1860704,
  },
  {
    name: "Kakegawa",
    country: "Japan",
    subcountry: "Shizuoka",
    geonameid: 1860728,
  },
  {
    name: "Kakamigahara",
    country: "Japan",
    subcountry: "Gifu",
    geonameid: 1860735,
  },
  {
    name: "Kashima-shi",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 1860748,
  },
  {
    name: "Kajiki",
    country: "Japan",
    subcountry: "Kagoshima",
    geonameid: 1860750,
  },
  {
    name: "Kaizuka",
    country: "Japan",
    subcountry: "Ōsaka",
    geonameid: 1860765,
  },
  {
    name: "Kainan",
    country: "Japan",
    subcountry: "Wakayama",
    geonameid: 1860785,
  },
  {
    name: "Kagoshima",
    country: "Japan",
    subcountry: "Kagoshima",
    geonameid: 1860827,
  },
  {
    name: "Kadoma",
    country: "Japan",
    subcountry: "Ōsaka",
    geonameid: 1860871,
  },
  {
    name: "Kadogawa",
    country: "Japan",
    subcountry: "Miyazaki",
    geonameid: 1860875,
  },
  {
    name: "Izumo",
    country: "Japan",
    subcountry: "Shimane",
    geonameid: 1861084,
  },
  {
    name: "Izumisano",
    country: "Japan",
    subcountry: "Ōsaka",
    geonameid: 1861091,
  },
  {
    name: "Izumiōtsu",
    country: "Japan",
    subcountry: "Ōsaka",
    geonameid: 1861095,
  },
  {
    name: "Izumi",
    country: "Japan",
    subcountry: "Ōsaka",
    geonameid: 1861107,
  },
  {
    name: "Izumi",
    country: "Japan",
    subcountry: "Kagoshima",
    geonameid: 1861108,
  },
  {
    name: "Iwatsuki",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1861164,
  },
  {
    name: "Iwata",
    country: "Japan",
    subcountry: "Shizuoka",
    geonameid: 1861171,
  },
  {
    name: "Iwakura",
    country: "Japan",
    subcountry: "Aichi",
    geonameid: 1861207,
  },
  {
    name: "Iwakuni",
    country: "Japan",
    subcountry: "Yamaguchi",
    geonameid: 1861212,
  },
  {
    name: "Iwai",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 1861223,
  },
  {
    name: "Iwade",
    country: "Japan",
    subcountry: "Wakayama",
    geonameid: 1861244,
  },
  {
    name: "Itsukaichi",
    country: "Japan",
    subcountry: "Tokyo",
    geonameid: 1861261,
  },
  {
    name: "Itoman",
    country: "Japan",
    subcountry: "Okinawa",
    geonameid: 1861280,
  },
  {
    name: "Itoigawa",
    country: "Japan",
    subcountry: "Niigata",
    geonameid: 1861285,
  },
  {
    name: "Itō",
    country: "Japan",
    subcountry: "Shizuoka",
    geonameid: 1861290,
  },
  {
    name: "Itami",
    country: "Japan",
    subcountry: "Hyōgo",
    geonameid: 1861310,
  },
  {
    name: "Ishiki",
    country: "Japan",
    subcountry: "Aichi",
    geonameid: 1861383,
  },
  {
    name: "Ishikawa",
    country: "Japan",
    subcountry: "Okinawa",
    geonameid: 1861393,
  },
  {
    name: "Ishii",
    country: "Japan",
    subcountry: "Tokushima",
    geonameid: 1861400,
  },
  {
    name: "Ishige",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 1861406,
  },
  {
    name: "Ishigaki",
    country: "Japan",
    subcountry: "Okinawa",
    geonameid: 1861416,
  },
  {
    name: "Isesaki",
    country: "Japan",
    subcountry: "Gunma",
    geonameid: 1861436,
  },
  {
    name: "Isehara",
    country: "Japan",
    subcountry: "Kanagawa",
    geonameid: 1861449,
  },
  {
    name: "Ise",
    country: "Japan",
    subcountry: "Mie",
    geonameid: 1861450,
  },
  {
    name: "Isawa",
    country: "Japan",
    subcountry: "Yamanashi",
    geonameid: 1861454,
  },
  {
    name: "Isahaya",
    country: "Japan",
    subcountry: "Nagasaki",
    geonameid: 1861464,
  },
  {
    name: "Inuyama",
    country: "Japan",
    subcountry: "Aichi",
    geonameid: 1861528,
  },
  {
    name: "Ino",
    country: "Japan",
    subcountry: "Kochi",
    geonameid: 1861584,
  },
  {
    name: "Innoshima",
    country: "Japan",
    subcountry: "Hiroshima",
    geonameid: 1861586,
  },
  {
    name: "Inazawa",
    country: "Japan",
    subcountry: "Aichi",
    geonameid: 1861602,
  },
  {
    name: "Ina",
    country: "Japan",
    subcountry: "Nagano",
    geonameid: 1861641,
  },
  {
    name: "Imarichō-kō",
    country: "Japan",
    subcountry: "Saga",
    geonameid: 1861677,
  },
  {
    name: "Imaichi",
    country: "Japan",
    subcountry: "Tochigi",
    geonameid: 1861699,
  },
  {
    name: "Ikoma",
    country: "Japan",
    subcountry: "Nara",
    geonameid: 1861749,
  },
  {
    name: "Ikeda",
    country: "Japan",
    subcountry: "Ōsaka",
    geonameid: 1861795,
  },
  {
    name: "Ikedachō",
    country: "Japan",
    subcountry: "Tokushima",
    geonameid: 1861799,
  },
  {
    name: "Ijūin",
    country: "Japan",
    subcountry: "Kagoshima",
    geonameid: 1861825,
  },
  {
    name: "Iizuka",
    country: "Japan",
    subcountry: "Fukuoka",
    geonameid: 1861835,
  },
  {
    name: "Iiyama",
    country: "Japan",
    subcountry: "Nagano",
    geonameid: 1861838,
  },
  {
    name: "Iida",
    country: "Japan",
    subcountry: "Nagano",
    geonameid: 1861864,
  },
  {
    name: "Ichinomiya",
    country: "Japan",
    subcountry: "Aichi",
    geonameid: 1861949,
  },
  {
    name: "Ibusuki",
    country: "Japan",
    subcountry: "Kagoshima",
    geonameid: 1862010,
  },
  {
    name: "Ibaraki",
    country: "Japan",
    subcountry: "Ōsaka",
    geonameid: 1862033,
  },
  {
    name: "Ibara",
    country: "Japan",
    subcountry: "Okayama",
    geonameid: 1862034,
  },
  {
    name: "Hotaka",
    country: "Japan",
    subcountry: "Nagano",
    geonameid: 1862098,
  },
  {
    name: "Hōryūji",
    country: "Japan",
    subcountry: "Nara",
    geonameid: 1862136,
  },
  {
    name: "Honjō",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1862198,
  },
  {
    name: "Hondomachi-hondo",
    country: "Japan",
    subcountry: "Kumamoto",
    geonameid: 1862230,
  },
  {
    name: "Hōfu",
    country: "Japan",
    subcountry: "Yamaguchi",
    geonameid: 1862302,
  },
  {
    name: "Hitoyoshi",
    country: "Japan",
    subcountry: "Kumamoto",
    geonameid: 1862352,
  },
  {
    name: "Hita",
    country: "Japan",
    subcountry: "Oita",
    geonameid: 1862373,
  },
  {
    name: "Hisai-motomachi",
    country: "Japan",
    subcountry: "Mie",
    geonameid: 1862389,
  },
  {
    name: "Hiroshima",
    country: "Japan",
    subcountry: "Hiroshima",
    geonameid: 1862415,
  },
  {
    name: "Hiratsuka",
    country: "Japan",
    subcountry: "Kanagawa",
    geonameid: 1862462,
  },
  {
    name: "Hiratachō",
    country: "Japan",
    subcountry: "Shimane",
    geonameid: 1862471,
  },
  {
    name: "Hirara",
    country: "Japan",
    subcountry: "Okinawa",
    geonameid: 1862505,
  },
  {
    name: "Hirakata",
    country: "Japan",
    subcountry: "Ōsaka",
    geonameid: 1862540,
  },
  {
    name: "Hirado",
    country: "Japan",
    subcountry: "Nagasaki",
    geonameid: 1862555,
  },
  {
    name: "Hino",
    country: "Japan",
    subcountry: "Tokyo",
    geonameid: 1862599,
  },
  {
    name: "Hino",
    country: "Japan",
    subcountry: "Shiga",
    geonameid: 1862601,
  },
  {
    name: "Himimachi",
    country: "Japan",
    subcountry: "Toyama",
    geonameid: 1862612,
  },
  {
    name: "Himeji",
    country: "Japan",
    subcountry: "Hyōgo",
    geonameid: 1862627,
  },
  {
    name: "Hikone",
    country: "Japan",
    subcountry: "Shiga",
    geonameid: 1862636,
  },
  {
    name: "Hiji",
    country: "Japan",
    subcountry: "Oita",
    geonameid: 1862689,
  },
  {
    name: "Higashi-ōsaka",
    country: "Japan",
    subcountry: "Ōsaka",
    geonameid: 1862752,
  },
  {
    name: "Hekinan",
    country: "Japan",
    subcountry: "Aichi",
    geonameid: 1862912,
  },
  {
    name: "Hayama",
    country: "Japan",
    subcountry: "Kanagawa",
    geonameid: 1862992,
  },
  {
    name: "Hatsukaichi",
    country: "Japan",
    subcountry: "Hiroshima",
    geonameid: 1863018,
  },
  {
    name: "Hatogaya-honchō",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1863023,
  },
  {
    name: "Hashimoto",
    country: "Japan",
    subcountry: "Wakayama",
    geonameid: 1863082,
  },
  {
    name: "Hanyū",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1863173,
  },
  {
    name: "Hannō",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1863183,
  },
  {
    name: "Handa",
    country: "Japan",
    subcountry: "Aichi",
    geonameid: 1863209,
  },
  {
    name: "Hamanoichi",
    country: "Japan",
    subcountry: "Kagoshima",
    geonameid: 1863279,
  },
  {
    name: "Hamamatsu",
    country: "Japan",
    subcountry: "Shizuoka",
    geonameid: 1863289,
  },
  {
    name: "Hamakita",
    country: "Japan",
    subcountry: "Shizuoka",
    geonameid: 1863293,
  },
  {
    name: "Hamada",
    country: "Japan",
    subcountry: "Shimane",
    geonameid: 1863310,
  },
  {
    name: "Hakui",
    country: "Japan",
    subcountry: "Ishikawa",
    geonameid: 1863341,
  },
  {
    name: "Haibara-akanedai",
    country: "Japan",
    subcountry: "Nara",
    geonameid: 1863398,
  },
  {
    name: "Hagi",
    country: "Japan",
    subcountry: "Yamaguchi",
    geonameid: 1863418,
  },
  {
    name: "Katsuren-haebaru",
    country: "Japan",
    subcountry: "Okinawa",
    geonameid: 1863426,
  },
  {
    name: "Hadano",
    country: "Japan",
    subcountry: "Kanagawa",
    geonameid: 1863431,
  },
  {
    name: "Hachiōji",
    country: "Japan",
    subcountry: "Tokyo",
    geonameid: 1863440,
  },
  {
    name: "Ōmihachiman",
    country: "Japan",
    subcountry: "Shiga",
    geonameid: 1863451,
  },
  {
    name: "Gyōda",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1863482,
  },
  {
    name: "Gushikawa",
    country: "Japan",
    subcountry: "Okinawa",
    geonameid: 1863495,
  },
  {
    name: "Gōtsuchō",
    country: "Japan",
    subcountry: "Shimane",
    geonameid: 1863521,
  },
  {
    name: "Gotenba",
    country: "Japan",
    subcountry: "Shizuoka",
    geonameid: 1863528,
  },
  {
    name: "Gosen",
    country: "Japan",
    subcountry: "Niigata",
    geonameid: 1863540,
  },
  {
    name: "Gose",
    country: "Japan",
    subcountry: "Nara",
    geonameid: 1863541,
  },
  {
    name: "Gojō",
    country: "Japan",
    subcountry: "Nara",
    geonameid: 1863592,
  },
  {
    name: "Gōdo",
    country: "Japan",
    subcountry: "Gifu",
    geonameid: 1863611,
  },
  {
    name: "Gobō",
    country: "Japan",
    subcountry: "Wakayama",
    geonameid: 1863614,
  },
  {
    name: "Ginowan",
    country: "Japan",
    subcountry: "Okinawa",
    geonameid: 1863627,
  },
  {
    name: "Gifu-shi",
    country: "Japan",
    subcountry: "Gifu",
    geonameid: 1863641,
  },
  {
    name: "Gamagōri",
    country: "Japan",
    subcountry: "Aichi",
    geonameid: 1863693,
  },
  {
    name: "Futtsu",
    country: "Japan",
    subcountry: "Chiba",
    geonameid: 1863713,
  },
  {
    name: "Honchō",
    country: "Japan",
    subcountry: "Chiba",
    geonameid: 1863905,
  },
  {
    name: "Fukuyama",
    country: "Japan",
    subcountry: "Hiroshima",
    geonameid: 1863917,
  },
  {
    name: "Fukuroi",
    country: "Japan",
    subcountry: "Shizuoka",
    geonameid: 1863945,
  },
  {
    name: "Fukura",
    country: "Japan",
    subcountry: "Hyōgo",
    geonameid: 1863953,
  },
  {
    name: "Fukuoka",
    country: "Japan",
    subcountry: "Fukuoka",
    geonameid: 1863967,
  },
  {
    name: "Fukumitsu",
    country: "Japan",
    subcountry: "Toyama",
    geonameid: 1863973,
  },
  {
    name: "Nishifukuma",
    country: "Japan",
    subcountry: "Fukuoka",
    geonameid: 1863978,
  },
  {
    name: "Fukui-shi",
    country: "Japan",
    subcountry: "Fukui",
    geonameid: 1863985,
  },
  {
    name: "Fukuechō",
    country: "Japan",
    subcountry: "Nagasaki",
    geonameid: 1863997,
  },
  {
    name: "Fukuchiyama",
    country: "Japan",
    subcountry: "Kyoto",
    geonameid: 1864009,
  },
  {
    name: "Fukiage-fujimi",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1864025,
  },
  {
    name: "Fukayachō",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1864031,
  },
  {
    name: "Fujisawa",
    country: "Japan",
    subcountry: "Kanagawa",
    geonameid: 1864092,
  },
  {
    name: "Fujioka",
    country: "Japan",
    subcountry: "Tochigi",
    geonameid: 1864098,
  },
  {
    name: "Fujioka",
    country: "Japan",
    subcountry: "Gunma",
    geonameid: 1864099,
  },
  {
    name: "Fujinomiya",
    country: "Japan",
    subcountry: "Shizuoka",
    geonameid: 1864105,
  },
  {
    name: "Fujieda",
    country: "Japan",
    subcountry: "Shizuoka",
    geonameid: 1864132,
  },
  {
    name: "Fuji",
    country: "Japan",
    subcountry: "Shizuoka",
    geonameid: 1864134,
  },
  {
    name: "Fuchūchō",
    country: "Japan",
    subcountry: "Hiroshima",
    geonameid: 1864155,
  },
  {
    name: "Enzan",
    country: "Japan",
    subcountry: "Yamanashi",
    geonameid: 1864180,
  },
  {
    name: "Daitō",
    country: "Japan",
    subcountry: "Ōsaka",
    geonameid: 1864416,
  },
  {
    name: "Chōfu",
    country: "Japan",
    subcountry: "Tokyo",
    geonameid: 1864518,
  },
  {
    name: "Chiryū",
    country: "Japan",
    subcountry: "Aichi",
    geonameid: 1864549,
  },
  {
    name: "Chino",
    country: "Japan",
    subcountry: "Nagano",
    geonameid: 1864557,
  },
  {
    name: "Chikushino-shi",
    country: "Japan",
    subcountry: "Fukuoka",
    geonameid: 1864572,
  },
  {
    name: "Chigasaki",
    country: "Japan",
    subcountry: "Kanagawa",
    geonameid: 1864624,
  },
  {
    name: "Chichibu",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1864637,
  },
  {
    name: "Chatan",
    country: "Japan",
    subcountry: "Okinawa",
    geonameid: 1864652,
  },
  {
    name: "Beppu",
    country: "Japan",
    subcountry: "Oita",
    geonameid: 1864750,
  },
  {
    name: "Ayabe",
    country: "Japan",
    subcountry: "Kyoto",
    geonameid: 1864873,
  },
  {
    name: "Atami",
    country: "Japan",
    subcountry: "Shizuoka",
    geonameid: 1864945,
  },
  {
    name: "Ashiya",
    country: "Japan",
    subcountry: "Hyōgo",
    geonameid: 1864985,
  },
  {
    name: "Ashikaga",
    country: "Japan",
    subcountry: "Tochigi",
    geonameid: 1865005,
  },
  {
    name: "Arita",
    country: "Japan",
    subcountry: "Saga",
    geonameid: 1865103,
  },
  {
    name: "Arai",
    country: "Japan",
    subcountry: "Niigata",
    geonameid: 1865207,
  },
  {
    name: "Arai",
    country: "Japan",
    subcountry: "Shizuoka",
    geonameid: 1865209,
  },
  {
    name: "Annaka",
    country: "Japan",
    subcountry: "Gunma",
    geonameid: 1865290,
  },
  {
    name: "Anjō",
    country: "Japan",
    subcountry: "Aichi",
    geonameid: 1865294,
  },
  {
    name: "Anan",
    country: "Japan",
    subcountry: "Tokushima",
    geonameid: 1865309,
  },
  {
    name: "Anamizu",
    country: "Japan",
    subcountry: "Ishikawa",
    geonameid: 1865312,
  },
  {
    name: "Amagi",
    country: "Japan",
    subcountry: "Fukuoka",
    geonameid: 1865375,
  },
  {
    name: "Amagasaki",
    country: "Japan",
    subcountry: "Hyōgo",
    geonameid: 1865387,
  },
  {
    name: "Akune",
    country: "Japan",
    subcountry: "Kagoshima",
    geonameid: 1865401,
  },
  {
    name: "Kariya",
    country: "Japan",
    subcountry: "Hyōgo",
    geonameid: 1865412,
  },
  {
    name: "Aki",
    country: "Japan",
    subcountry: "Kochi",
    geonameid: 1865449,
  },
  {
    name: "Aioi",
    country: "Japan",
    subcountry: "Hyōgo",
    geonameid: 1865661,
  },
  {
    name: "Ageoshimo",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1865714,
  },
  {
    name: "Okinawa",
    country: "Japan",
    subcountry: "Okinawa",
    geonameid: 1894616,
  },
  {
    name: "Kushima",
    country: "Japan",
    subcountry: "Miyazaki",
    geonameid: 1895695,
  },
  {
    name: "Hikari",
    country: "Japan",
    subcountry: "Yamaguchi",
    geonameid: 1896348,
  },
  {
    name: "Nagato",
    country: "Japan",
    subcountry: "Yamaguchi",
    geonameid: 1899102,
  },
  {
    name: "Hasuda",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1907123,
  },
  {
    name: "Kamifukuoka",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1907125,
  },
  {
    name: "Sayama",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1907146,
  },
  {
    name: "Fussa",
    country: "Japan",
    subcountry: "Tokyo",
    geonameid: 1907148,
  },
  {
    name: "Asaka",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1907299,
  },
  {
    name: "Wako",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1907300,
  },
  {
    name: "Shimotoda",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 1907301,
  },
  {
    name: "Kimitsu",
    country: "Japan",
    subcountry: "Chiba",
    geonameid: 1907307,
  },
  {
    name: "Miura",
    country: "Japan",
    subcountry: "Kanagawa",
    geonameid: 1907309,
  },
  {
    name: "Wakayama",
    country: "Japan",
    subcountry: "Wakayama",
    geonameid: 1926004,
  },
  {
    name: "Iyo",
    country: "Japan",
    subcountry: "Ehime",
    geonameid: 1926006,
  },
  {
    name: "Uwajima",
    country: "Japan",
    subcountry: "Ehime",
    geonameid: 1926020,
  },
  {
    name: "Saijō",
    country: "Japan",
    subcountry: "Ehime",
    geonameid: 1926054,
  },
  {
    name: "Ōzu",
    country: "Japan",
    subcountry: "Ehime",
    geonameid: 1926055,
  },
  {
    name: "Matsuyama",
    country: "Japan",
    subcountry: "Ehime",
    geonameid: 1926099,
  },
  {
    name: "Masaki-chō",
    country: "Japan",
    subcountry: "Ehime",
    geonameid: 1926101,
  },
  {
    name: "Kawanoechō",
    country: "Japan",
    subcountry: "Ehime",
    geonameid: 1926116,
  },
  {
    name: "Hōjō",
    country: "Japan",
    subcountry: "Ehime",
    geonameid: 1926142,
  },
  {
    name: "Yuzawa",
    country: "Japan",
    subcountry: "Akita",
    geonameid: 2110460,
  },
  {
    name: "Yotsukaidō",
    country: "Japan",
    subcountry: "Chiba",
    geonameid: 2110480,
  },
  {
    name: "Yonezawa",
    country: "Japan",
    subcountry: "Yamagata",
    geonameid: 2110498,
  },
  {
    name: "Yokote",
    country: "Japan",
    subcountry: "Akita",
    geonameid: 2110506,
  },
  {
    name: "Yōkaichiba",
    country: "Japan",
    subcountry: "Chiba",
    geonameid: 2110518,
  },
  {
    name: "Yanagawamachi-saiwaichō",
    country: "Japan",
    subcountry: "Fukushima",
    geonameid: 2110538,
  },
  {
    name: "Yamoto",
    country: "Japan",
    subcountry: "Miyagi",
    geonameid: 2110541,
  },
  {
    name: "Yamagata",
    country: "Japan",
    subcountry: "Yamagata",
    geonameid: 2110556,
  },
  {
    name: "Yamada",
    country: "Japan",
    subcountry: "Iwate",
    geonameid: 2110560,
  },
  {
    name: "Yachimata",
    country: "Japan",
    subcountry: "Chiba",
    geonameid: 2110579,
  },
  {
    name: "Yabuki",
    country: "Japan",
    subcountry: "Fukushima",
    geonameid: 2110583,
  },
  {
    name: "Watari",
    country: "Japan",
    subcountry: "Miyagi",
    geonameid: 2110586,
  },
  {
    name: "Wakuya",
    country: "Japan",
    subcountry: "Miyagi",
    geonameid: 2110596,
  },
  {
    name: "Ushiku",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 2110629,
  },
  {
    name: "Tsukuba",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 2110683,
  },
  {
    name: "Toride",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 2110729,
  },
  {
    name: "Tōno",
    country: "Japan",
    subcountry: "Iwate",
    geonameid: 2110735,
  },
  {
    name: "Tomobe",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 2110743,
  },
  {
    name: "Tomiya",
    country: "Japan",
    subcountry: "Miyagi",
    geonameid: 2110744,
  },
  {
    name: "Tōgane",
    country: "Japan",
    subcountry: "Chiba",
    geonameid: 2110774,
  },
  {
    name: "Tendō",
    country: "Japan",
    subcountry: "Yamagata",
    geonameid: 2110793,
  },
  {
    name: "Takahata",
    country: "Japan",
    subcountry: "Yamagata",
    geonameid: 2110891,
  },
  {
    name: "Takahagi",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 2110893,
  },
  {
    name: "Sukagawa",
    country: "Japan",
    subcountry: "Fukushima",
    geonameid: 2110959,
  },
  {
    name: "Shizukuishi",
    country: "Japan",
    subcountry: "Iwate",
    geonameid: 2110994,
  },
  {
    name: "Shisui",
    country: "Japan",
    subcountry: "Chiba",
    geonameid: 2111008,
  },
  {
    name: "Shiroishi",
    country: "Japan",
    subcountry: "Miyagi",
    geonameid: 2111016,
  },
  {
    name: "Shiroi",
    country: "Japan",
    subcountry: "Chiba",
    geonameid: 2111018,
  },
  {
    name: "Shiogama",
    country: "Japan",
    subcountry: "Miyagi",
    geonameid: 2111049,
  },
  {
    name: "Shinjō",
    country: "Japan",
    subcountry: "Yamagata",
    geonameid: 2111065,
  },
  {
    name: "Sendai",
    country: "Japan",
    subcountry: "Miyagi",
    geonameid: 2111149,
  },
  {
    name: "Sawara",
    country: "Japan",
    subcountry: "Chiba",
    geonameid: 2111173,
  },
  {
    name: "Sakura",
    country: "Japan",
    subcountry: "Chiba",
    geonameid: 2111220,
  },
  {
    name: "Sagae",
    country: "Japan",
    subcountry: "Yamagata",
    geonameid: 2111248,
  },
  {
    name: "Ryūgasaki",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 2111258,
  },
  {
    name: "Rifu",
    country: "Japan",
    subcountry: "Miyagi",
    geonameid: 2111277,
  },
  {
    name: "Ōtawara",
    country: "Japan",
    subcountry: "Tochigi",
    geonameid: 2111325,
  },
  {
    name: "Ōmiya",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 2111425,
  },
  {
    name: "Omigawa",
    country: "Japan",
    subcountry: "Chiba",
    geonameid: 2111429,
  },
  {
    name: "Ōmagari",
    country: "Japan",
    subcountry: "Akita",
    geonameid: 2111435,
  },
  {
    name: "Okunoya",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 2111441,
  },
  {
    name: "Ōkawara",
    country: "Japan",
    subcountry: "Miyagi",
    geonameid: 2111461,
  },
  {
    name: "Ōhara",
    country: "Japan",
    subcountry: "Chiba",
    geonameid: 2111495,
  },
  {
    name: "Ōfunato",
    country: "Japan",
    subcountry: "Iwate",
    geonameid: 2111530,
  },
  {
    name: "Obanazawa",
    country: "Japan",
    subcountry: "Yamagata",
    geonameid: 2111559,
  },
  {
    name: "Ōarai",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 2111567,
  },
  {
    name: "Ōami",
    country: "Japan",
    subcountry: "Chiba",
    geonameid: 2111568,
  },
  {
    name: "Nihommatsu",
    country: "Japan",
    subcountry: "Fukushima",
    geonameid: 2111656,
  },
  {
    name: "Narutō",
    country: "Japan",
    subcountry: "Chiba",
    geonameid: 2111677,
  },
  {
    name: "Narita",
    country: "Japan",
    subcountry: "Chiba",
    geonameid: 2111684,
  },
  {
    name: "Namie",
    country: "Japan",
    subcountry: "Fukushima",
    geonameid: 2111704,
  },
  {
    name: "Naka",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 2111749,
  },
  {
    name: "Nagai",
    country: "Japan",
    subcountry: "Yamagata",
    geonameid: 2111781,
  },
  {
    name: "Motomiya",
    country: "Japan",
    subcountry: "Fukushima",
    geonameid: 2111824,
  },
  {
    name: "Moriya",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 2111831,
  },
  {
    name: "Morioka",
    country: "Japan",
    subcountry: "Iwate",
    geonameid: 2111834,
  },
  {
    name: "Mooka",
    country: "Japan",
    subcountry: "Tochigi",
    geonameid: 2111836,
  },
  {
    name: "Mobara",
    country: "Japan",
    subcountry: "Chiba",
    geonameid: 2111855,
  },
  {
    name: "Mizusawa",
    country: "Japan",
    subcountry: "Iwate",
    geonameid: 2111859,
  },
  {
    name: "Miyako",
    country: "Japan",
    subcountry: "Iwate",
    geonameid: 2111884,
  },
  {
    name: "Mito",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 2111901,
  },
  {
    name: "Miharu",
    country: "Japan",
    subcountry: "Fukushima",
    geonameid: 2111943,
  },
  {
    name: "Matsushima",
    country: "Japan",
    subcountry: "Miyagi",
    geonameid: 2111964,
  },
  {
    name: "Mashiko",
    country: "Japan",
    subcountry: "Tochigi",
    geonameid: 2111999,
  },
  {
    name: "Makabe",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 2112019,
  },
  {
    name: "Kuroiso",
    country: "Japan",
    subcountry: "Tochigi",
    geonameid: 2112077,
  },
  {
    name: "Kōriyama",
    country: "Japan",
    subcountry: "Fukushima",
    geonameid: 2112141,
  },
  {
    name: "Kogota",
    country: "Japan",
    subcountry: "Miyagi",
    geonameid: 2112182,
  },
  {
    name: "Kitakami",
    country: "Japan",
    subcountry: "Iwate",
    geonameid: 2112227,
  },
  {
    name: "Kitaibaraki",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 2112232,
  },
  {
    name: "Kamogawa",
    country: "Japan",
    subcountry: "Chiba",
    geonameid: 2112297,
  },
  {
    name: "Katsuura",
    country: "Japan",
    subcountry: "Chiba",
    geonameid: 2112309,
  },
  {
    name: "Katsuta",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 2112312,
  },
  {
    name: "Katori-shi",
    country: "Japan",
    subcountry: "Chiba",
    geonameid: 2112319,
  },
  {
    name: "Kasama",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 2112343,
  },
  {
    name: "Karasuyama",
    country: "Japan",
    subcountry: "Tochigi",
    geonameid: 2112354,
  },
  {
    name: "Kanegasaki",
    country: "Japan",
    subcountry: "Iwate",
    geonameid: 2112370,
  },
  {
    name: "Kaminoyama",
    country: "Japan",
    subcountry: "Yamagata",
    geonameid: 2112409,
  },
  {
    name: "Kamaishi",
    country: "Japan",
    subcountry: "Iwate",
    geonameid: 2112444,
  },
  {
    name: "Kakuda",
    country: "Japan",
    subcountry: "Miyagi",
    geonameid: 2112455,
  },
  {
    name: "Iwase",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 2112521,
  },
  {
    name: "Iwanuma",
    country: "Japan",
    subcountry: "Miyagi",
    geonameid: 2112527,
  },
  {
    name: "Iwaki",
    country: "Japan",
    subcountry: "Fukushima",
    geonameid: 2112539,
  },
  {
    name: "Itako",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 2112555,
  },
  {
    name: "Ishioka",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 2112571,
  },
  {
    name: "Ishinomaki",
    country: "Japan",
    subcountry: "Miyagi",
    geonameid: 2112576,
  },
  {
    name: "Ishikawa",
    country: "Japan",
    subcountry: "Fukushima",
    geonameid: 2112583,
  },
  {
    name: "Ichinoseki",
    country: "Japan",
    subcountry: "Iwate",
    geonameid: 2112656,
  },
  {
    name: "Ichihara",
    country: "Japan",
    subcountry: "Chiba",
    geonameid: 2112664,
  },
  {
    name: "Hobaramachi",
    country: "Japan",
    subcountry: "Fukushima",
    geonameid: 2112692,
  },
  {
    name: "Hitachi",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 2112708,
  },
  {
    name: "Higashine",
    country: "Japan",
    subcountry: "Yamagata",
    geonameid: 2112758,
  },
  {
    name: "Hasaki",
    country: "Japan",
    subcountry: "Chiba",
    geonameid: 2112802,
  },
  {
    name: "Hanamaki",
    country: "Japan",
    subcountry: "Iwate",
    geonameid: 2112823,
  },
  {
    name: "Furukawa",
    country: "Japan",
    subcountry: "Miyagi",
    geonameid: 2112899,
  },
  {
    name: "Funehikimachi-funehiki",
    country: "Japan",
    subcountry: "Fukushima",
    geonameid: 2112903,
  },
  {
    name: "Funaishikawa",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 2112913,
  },
  {
    name: "Fukushima",
    country: "Japan",
    subcountry: "Fukushima",
    geonameid: 2112923,
  },
  {
    name: "Fujishiro",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 2112940,
  },
  {
    name: "Edosaki",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 2112963,
  },
  {
    name: "Date",
    country: "Japan",
    subcountry: "Fukushima",
    geonameid: 2112980,
  },
  {
    name: "Daigo",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 2112989,
  },
  {
    name: "Chiba",
    country: "Japan",
    subcountry: "Chiba",
    geonameid: 2113015,
  },
  {
    name: "Asahi",
    country: "Japan",
    subcountry: "Chiba",
    geonameid: 2113077,
  },
  {
    name: "Ami",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 2113115,
  },
  {
    name: "Akita",
    country: "Japan",
    subcountry: "Akita",
    geonameid: 2113126,
  },
  {
    name: "Abiko",
    country: "Japan",
    subcountry: "Chiba",
    geonameid: 2113164,
  },
  {
    name: "Motomachi",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2127383,
  },
  {
    name: "Wakkanai",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2127515,
  },
  {
    name: "Tomakomai",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2127733,
  },
  {
    name: "Tōbetsu",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2127802,
  },
  {
    name: "Mutsu",
    country: "Japan",
    subcountry: "Aomori",
    geonameid: 2127878,
  },
  {
    name: "Takikawa",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2127896,
  },
  {
    name: "Takanosu",
    country: "Japan",
    subcountry: "Akita",
    geonameid: 2127910,
  },
  {
    name: "Sunagawa",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2127955,
  },
  {
    name: "Shizunai-furukawachō",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2128025,
  },
  {
    name: "Shiraoi",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2128072,
  },
  {
    name: "Shimo-furano",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2128147,
  },
  {
    name: "Minamishibetsuchō",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2128205,
  },
  {
    name: "Shibetsu",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2128206,
  },
  {
    name: "Sapporo",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2128295,
  },
  {
    name: "Rumoi",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2128382,
  },
  {
    name: "Otofuke",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2128558,
  },
  {
    name: "Otaru",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2128574,
  },
  {
    name: "Ōdate",
    country: "Japan",
    subcountry: "Akita",
    geonameid: 2128787,
  },
  {
    name: "Obihiro",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2128815,
  },
  {
    name: "Noshiro",
    country: "Japan",
    subcountry: "Akita",
    geonameid: 2128867,
  },
  {
    name: "Nemuro",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2128975,
  },
  {
    name: "Nayoro",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2128983,
  },
  {
    name: "Honchō",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2129003,
  },
  {
    name: "Namioka",
    country: "Japan",
    subcountry: "Aomori",
    geonameid: 2129005,
  },
  {
    name: "Nakashibetsu",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2129034,
  },
  {
    name: "Muroran",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2129101,
  },
  {
    name: "Mombetsu",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2129163,
  },
  {
    name: "Misawa",
    country: "Japan",
    subcountry: "Aomori",
    geonameid: 2129211,
  },
  {
    name: "Yoichi",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2129218,
  },
  {
    name: "Makubetsu",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2129324,
  },
  {
    name: "Kushiro",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2129376,
  },
  {
    name: "Kuroishi",
    country: "Japan",
    subcountry: "Aomori",
    geonameid: 2129395,
  },
  {
    name: "Kuji",
    country: "Japan",
    subcountry: "Iwate",
    geonameid: 2129427,
  },
  {
    name: "Shimokizukuri",
    country: "Japan",
    subcountry: "Aomori",
    geonameid: 2129513,
  },
  {
    name: "Kitami",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2129537,
  },
  {
    name: "Kamiiso",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2129766,
  },
  {
    name: "Iwamizawa",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2129870,
  },
  {
    name: "Ishikari",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2129909,
  },
  {
    name: "Kitahiroshima",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2130054,
  },
  {
    name: "Hirosaki",
    country: "Japan",
    subcountry: "Aomori",
    geonameid: 2130057,
  },
  {
    name: "Hanawa",
    country: "Japan",
    subcountry: "Akita",
    geonameid: 2130146,
  },
  {
    name: "Hakodate",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2130188,
  },
  {
    name: "Hachinohe",
    country: "Japan",
    subcountry: "Aomori",
    geonameid: 2130203,
  },
  {
    name: "Fukagawa",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2130332,
  },
  {
    name: "Ebetsu",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2130404,
  },
  {
    name: "Date",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2130421,
  },
  {
    name: "Chitose",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2130452,
  },
  {
    name: "Bibai",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2130534,
  },
  {
    name: "Ashibetsu",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2130612,
  },
  {
    name: "Asahikawa",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2130629,
  },
  {
    name: "Aomori",
    country: "Japan",
    subcountry: "Aomori",
    geonameid: 2130658,
  },
  {
    name: "Abashiri",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 2130741,
  },
  {
    name: "Goshogawara",
    country: "Japan",
    subcountry: "Aomori",
    geonameid: 2131612,
  },
  {
    name: "Aso",
    country: "Japan",
    subcountry: "Kumamoto",
    geonameid: 6324583,
  },
  {
    name: "Nanto-shi",
    country: "Japan",
    subcountry: "Toyama",
    geonameid: 6694821,
  },
  {
    name: "Kawage",
    country: "Japan",
    subcountry: "Mie",
    geonameid: 6696932,
  },
  {
    name: "Neyagawa",
    country: "Japan",
    subcountry: "Ōsaka",
    geonameid: 6697563,
  },
  {
    name: "Hitachi-Naka",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 6822096,
  },
  {
    name: "Chikusei",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 6822097,
  },
  {
    name: "Hitachi-ota",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 6822107,
  },
  {
    name: "Inashiki",
    country: "Japan",
    subcountry: "Ibaraki",
    geonameid: 6822108,
  },
  {
    name: "Chikuma",
    country: "Japan",
    subcountry: "Nagano",
    geonameid: 6822112,
  },
  {
    name: "Rittō",
    country: "Japan",
    subcountry: "Shiga",
    geonameid: 6822115,
  },
  {
    name: "Takashima",
    country: "Japan",
    subcountry: "Shiga",
    geonameid: 6822116,
  },
  {
    name: "Kōka",
    country: "Japan",
    subcountry: "Shiga",
    geonameid: 6822117,
  },
  {
    name: "Katsuragi",
    country: "Japan",
    subcountry: "Nara",
    geonameid: 6822119,
  },
  {
    name: "Nanto",
    country: "Japan",
    subcountry: "Toyama",
    geonameid: 6822123,
  },
  {
    name: "Kurobe-shi",
    country: "Japan",
    subcountry: "Toyama",
    geonameid: 6822126,
  },
  {
    name: "Tama",
    country: "Japan",
    subcountry: "Tokyo",
    geonameid: 6822129,
  },
  {
    name: "Tonami",
    country: "Japan",
    subcountry: "Toyama",
    geonameid: 6822139,
  },
  {
    name: "Kaga",
    country: "Japan",
    subcountry: "Ishikawa",
    geonameid: 6822141,
  },
  {
    name: "Matsuura",
    country: "Japan",
    subcountry: "Nagasaki",
    geonameid: 6822144,
  },
  {
    name: "Ōnojō",
    country: "Japan",
    subcountry: "Fukuoka",
    geonameid: 6822146,
  },
  {
    name: "Minami-Sōma",
    country: "Japan",
    subcountry: "Fukushima",
    geonameid: 6822149,
  },
  {
    name: "Midori",
    country: "Japan",
    subcountry: "Gunma",
    geonameid: 6822155,
  },
  {
    name: "Miyakojima",
    country: "Japan",
    subcountry: "Okinawa",
    geonameid: 6822158,
  },
  {
    name: "Hidaka",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 6822161,
  },
  {
    name: "Iruma",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 6822163,
  },
  {
    name: "Sōsa",
    country: "Japan",
    subcountry: "Chiba",
    geonameid: 6822167,
  },
  {
    name: "Sōma",
    country: "Japan",
    subcountry: "Fukushima",
    geonameid: 6822169,
  },
  {
    name: "Kinokawa",
    country: "Japan",
    subcountry: "Wakayama",
    geonameid: 6822171,
  },
  {
    name: "Kumano",
    country: "Japan",
    subcountry: "Mie",
    geonameid: 6822172,
  },
  {
    name: "Nasushiobara",
    country: "Japan",
    subcountry: "Tochigi",
    geonameid: 6822174,
  },
  {
    name: "Shimotsuke",
    country: "Japan",
    subcountry: "Tochigi",
    geonameid: 6822175,
  },
  {
    name: "Inzai",
    country: "Japan",
    subcountry: "Chiba",
    geonameid: 6822179,
  },
  {
    name: "Hachimantai",
    country: "Japan",
    subcountry: "Iwate",
    geonameid: 6822186,
  },
  {
    name: "Ōsaki",
    country: "Japan",
    subcountry: "Miyagi",
    geonameid: 6822188,
  },
  {
    name: "Higashimatsushima",
    country: "Japan",
    subcountry: "Miyagi",
    geonameid: 6822189,
  },
  {
    name: "Kurihara",
    country: "Japan",
    subcountry: "Miyagi",
    geonameid: 6822190,
  },
  {
    name: "Izunokuni",
    country: "Japan",
    subcountry: "Shizuoka",
    geonameid: 6822191,
  },
  {
    name: "Izu",
    country: "Japan",
    subcountry: "Shizuoka",
    geonameid: 6822192,
  },
  {
    name: "Kikugawa",
    country: "Japan",
    subcountry: "Shizuoka",
    geonameid: 6822193,
  },
  {
    name: "Kosai",
    country: "Japan",
    subcountry: "Shizuoka",
    geonameid: 6822194,
  },
  {
    name: "Susono",
    country: "Japan",
    subcountry: "Shizuoka",
    geonameid: 6822195,
  },
  {
    name: "Yurihonjō",
    country: "Japan",
    subcountry: "Akita",
    geonameid: 6822202,
  },
  {
    name: "Kita-Akita",
    country: "Japan",
    subcountry: "Akita",
    geonameid: 6822204,
  },
  {
    name: "Hirakawa",
    country: "Japan",
    subcountry: "Aomori",
    geonameid: 6822206,
  },
  {
    name: "Towada",
    country: "Japan",
    subcountry: "Aomori",
    geonameid: 6822207,
  },
  {
    name: "Kitanagoya",
    country: "Japan",
    subcountry: "Aichi",
    geonameid: 6822208,
  },
  {
    name: "Nisshin",
    country: "Japan",
    subcountry: "Aichi",
    geonameid: 6822209,
  },
  {
    name: "Chita",
    country: "Japan",
    subcountry: "Aichi",
    geonameid: 6822211,
  },
  {
    name: "Yamagata",
    country: "Japan",
    subcountry: "Gifu",
    geonameid: 6822213,
  },
  {
    name: "Hashima",
    country: "Japan",
    subcountry: "Gifu",
    geonameid: 6822214,
  },
  {
    name: "Kaizu",
    country: "Japan",
    subcountry: "Gifu",
    geonameid: 6822215,
  },
  {
    name: "Kani",
    country: "Japan",
    subcountry: "Gifu",
    geonameid: 6822216,
  },
  {
    name: "Minokamo",
    country: "Japan",
    subcountry: "Gifu",
    geonameid: 6822217,
  },
  {
    name: "Gujō",
    country: "Japan",
    subcountry: "Gifu",
    geonameid: 6822219,
  },
  {
    name: "Ena",
    country: "Japan",
    subcountry: "Gifu",
    geonameid: 6822220,
  },
  {
    name: "Jōetsu",
    country: "Japan",
    subcountry: "Niigata",
    geonameid: 6825489,
  },
  {
    name: "Minamiuonuma",
    country: "Japan",
    subcountry: "Niigata",
    geonameid: 6825490,
  },
  {
    name: "Sado",
    country: "Japan",
    subcountry: "Niigata",
    geonameid: 6825492,
  },
  {
    name: "Tainai",
    country: "Japan",
    subcountry: "Niigata",
    geonameid: 6825493,
  },
  {
    name: "Uonuma",
    country: "Japan",
    subcountry: "Niigata",
    geonameid: 6825494,
  },
  {
    name: "Habikino",
    country: "Japan",
    subcountry: "Ōsaka",
    geonameid: 6825496,
  },
  {
    name: "Hannan",
    country: "Japan",
    subcountry: "Ōsaka",
    geonameid: 6825497,
  },
  {
    name: "Hokuto",
    country: "Japan",
    subcountry: "Hokkaido",
    geonameid: 6862586,
  },
  {
    name: "Saitama",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 6940394,
  },
  {
    name: "Higashimurayama",
    country: "Japan",
    subcountry: "Tokyo",
    geonameid: 7279570,
  },
  {
    name: "Fujikawaguchiko",
    country: "Japan",
    subcountry: "Yamanashi",
    geonameid: 7281819,
  },
  {
    name: "Yawatahama",
    country: "Japan",
    subcountry: "Ehime",
    geonameid: 7303003,
  },
  {
    name: "Kirishima",
    country: "Japan",
    subcountry: "Kagoshima",
    geonameid: 7303138,
  },
  {
    name: "Arashiyama",
    country: "Japan",
    subcountry: "Kyoto",
    geonameid: 7303471,
  },
  {
    name: "Dazaifu",
    country: "Japan",
    subcountry: "Fukuoka",
    geonameid: 7422816,
  },
  {
    name: "Amakusa",
    country: "Japan",
    subcountry: "Kumamoto",
    geonameid: 7424125,
  },
  {
    name: "Kamigyō-ku",
    country: "Japan",
    subcountry: "Kyoto",
    geonameid: 8125829,
  },
  {
    name: "Buzen",
    country: "Japan",
    subcountry: "Fukuoka",
    geonameid: 8198709,
  },
  {
    name: "Nakano",
    country: "Japan",
    subcountry: "Tokyo",
    geonameid: 8715035,
  },
  {
    name: "Kanmaki",
    country: "Japan",
    subcountry: "Nara",
    geonameid: 9633110,
  },
  {
    name: "Sue",
    country: "Japan",
    subcountry: "Fukuoka",
    geonameid: 10267168,
  },
  {
    name: "Fujiyoshida",
    country: "Japan",
    subcountry: "Yamanashi",
    geonameid: 10629856,
  },
  {
    name: "Shonai",
    country: "Japan",
    subcountry: "Yamagata",
    geonameid: 10630004,
  },
  {
    name: "Yomitan",
    country: "Japan",
    subcountry: "Okinawa",
    geonameid: 10860988,
  },
  {
    name: "Matsubushi",
    country: "Japan",
    subcountry: "Saitama",
    geonameid: 10979195,
  },
  {
    name: "Minami-Alps",
    country: "Japan",
    subcountry: "Yamanashi",
    geonameid: 11205269,
  },
  {
    name: "Arao",
    country: "Japan",
    subcountry: "Kumamoto",
    geonameid: 11274040,
  },
  {
    name: "Miyota",
    country: "Japan",
    subcountry: "Nagano",
    geonameid: 11350714,
  },
  {
    name: "Iga",
    country: "Japan",
    subcountry: "Mie",
    geonameid: 11468270,
  },
  {
    name: "Kuwana",
    country: "Japan",
    subcountry: "Mie",
    geonameid: 11468429,
  },
  {
    name: "Hokuto",
    country: "Japan",
    subcountry: "Yamanashi",
    geonameid: 11524139,
  },
  {
    name: "Himi",
    country: "Japan",
    subcountry: "Toyama",
    geonameid: 11611221,
  },
  {
    name: "Takizawa",
    country: "Japan",
    subcountry: "Iwate",
    geonameid: 11611224,
  },
  {
    name: "Yasu",
    country: "Japan",
    subcountry: "Shiga",
    geonameid: 11611475,
  },
  {
    name: "Yamato",
    country: "Japan",
    subcountry: "Kanagawa",
    geonameid: 11611478,
  },
  {
    name: "Saito",
    country: "Japan",
    subcountry: "Miyazaki",
    geonameid: 11611608,
  },
  {
    name: "Mitoyo",
    country: "Japan",
    subcountry: "Kagawa",
    geonameid: 11611615,
  },
  {
    name: "Hyūga",
    country: "Japan",
    subcountry: "Miyazaki",
    geonameid: 11611625,
  },
  {
    name: "Sakai",
    country: "Japan",
    subcountry: "Fukui",
    geonameid: 11611626,
  },
  {
    name: "Hamura",
    country: "Japan",
    subcountry: "Tokyo",
    geonameid: 11611629,
  },
  {
    name: "Fuchū",
    country: "Japan",
    subcountry: "Tokyo",
    geonameid: 11611632,
  },
  {
    name: "Arida",
    country: "Japan",
    subcountry: "Wakayama",
    geonameid: 11611643,
  },
  {
    name: "Katō",
    country: "Japan",
    subcountry: "Hyōgo",
    geonameid: 11611935,
  },
  {
    name: "Tome",
    country: "Japan",
    subcountry: "Miyagi",
    geonameid: 11611941,
  },
  {
    name: "Kai",
    country: "Japan",
    subcountry: "Yamanashi",
    geonameid: 11612336,
  },
  {
    name: "Sakura",
    country: "Japan",
    subcountry: "Tochigi",
    geonameid: 11612337,
  },
  {
    name: "Shirakawa",
    country: "Japan",
    subcountry: "Fukushima",
    geonameid: 11612472,
  },
  {
    name: "Mizuho",
    country: "Japan",
    subcountry: "Gifu",
    geonameid: 11612473,
  },
  {
    name: "Kasai",
    country: "Japan",
    subcountry: "Hyōgo",
    geonameid: 11612478,
  },
  {
    name: "Minamiawaji",
    country: "Japan",
    subcountry: "Hyōgo",
    geonameid: 11612479,
  },
  {
    name: "Shisō",
    country: "Japan",
    subcountry: "Hyōgo",
    geonameid: 11612481,
  },
  {
    name: "Tanba",
    country: "Japan",
    subcountry: "Hyōgo",
    geonameid: 11612482,
  },
  {
    name: "Higashikagawa",
    country: "Japan",
    subcountry: "Kagawa",
    geonameid: 11612539,
  },
  {
    name: "Kōshi",
    country: "Japan",
    subcountry: "Kumamoto",
    geonameid: 11612553,
  },
  {
    name: "Uki",
    country: "Japan",
    subcountry: "Kumamoto",
    geonameid: 11612554,
  },
  {
    name: "Konan",
    country: "Japan",
    subcountry: "Shiga",
    geonameid: 11612571,
  },
  {
    name: "Chūō",
    country: "Japan",
    subcountry: "Yamanashi",
    geonameid: 11612585,
  },
  {
    name: "Fuefuki",
    country: "Japan",
    subcountry: "Yamanashi",
    geonameid: 11612588,
  },
  {
    name: "Kōshū",
    country: "Japan",
    subcountry: "Yamanashi",
    geonameid: 11612589,
  },
  {
    name: "Semboku",
    country: "Japan",
    subcountry: "Akita",
    geonameid: 11612707,
  },
  {
    name: "Agano",
    country: "Japan",
    subcountry: "Niigata",
    geonameid: 11837950,
  },
  {
    name: "Webuye",
    country: "Kenya",
    subcountry: "Bungoma",
    geonameid: 178202,
  },
  {
    name: "Wajir",
    country: "Kenya",
    subcountry: "Wajir",
    geonameid: 178443,
  },
  {
    name: "Voi",
    country: "Kenya",
    subcountry: "Taita Taveta",
    geonameid: 178522,
  },
  {
    name: "Thika",
    country: "Kenya",
    subcountry: "Nairobi Area",
    geonameid: 179330,
  },
  {
    name: "Ruiru",
    country: "Kenya",
    subcountry: "Kiambu",
    geonameid: 181032,
  },
  {
    name: "Rongai",
    country: "Kenya",
    subcountry: "Nakuru",
    geonameid: 181135,
  },
  {
    name: "Pumwani",
    country: "Kenya",
    subcountry: "Nairobi Area",
    geonameid: 181501,
  },
  {
    name: "Ogembo",
    country: "Kenya",
    subcountry: "Kisii",
    geonameid: 182498,
  },
  {
    name: "Nyeri",
    country: "Kenya",
    subcountry: "Nyeri",
    geonameid: 182701,
  },
  {
    name: "Nyahururu",
    country: "Kenya",
    subcountry: "Laikipia",
    geonameid: 183027,
  },
  {
    name: "Narok",
    country: "Kenya",
    subcountry: "Narok",
    geonameid: 184379,
  },
  {
    name: "Nanyuki",
    country: "Kenya",
    subcountry: "Laikipia",
    geonameid: 184433,
  },
  {
    name: "Nakuru",
    country: "Kenya",
    subcountry: "Nakuru",
    geonameid: 184622,
  },
  {
    name: "Naivasha",
    country: "Kenya",
    subcountry: "Nakuru",
    geonameid: 184707,
  },
  {
    name: "Nairobi",
    country: "Kenya",
    subcountry: "Nairobi Area",
    geonameid: 184745,
  },
  {
    name: "Mumias",
    country: "Kenya",
    subcountry: "Kakamega",
    geonameid: 185702,
  },
  {
    name: "Muhoroni",
    country: "Kenya",
    subcountry: "Kisumu",
    geonameid: 185939,
  },
  {
    name: "Moyale",
    country: "Kenya",
    subcountry: "Marsabit",
    geonameid: 186180,
  },
  {
    name: "Mombasa",
    country: "Kenya",
    subcountry: "Mombasa",
    geonameid: 186301,
  },
  {
    name: "Molo",
    country: "Kenya",
    subcountry: "Nakuru",
    geonameid: 186315,
  },
  {
    name: "Migori",
    country: "Kenya",
    subcountry: "Migori",
    geonameid: 186731,
  },
  {
    name: "Meru",
    country: "Kenya",
    subcountry: "Meru",
    geonameid: 186827,
  },
  {
    name: "Mbale",
    country: "Kenya",
    subcountry: "Vihiga",
    geonameid: 187113,
  },
  {
    name: "Marsabit",
    country: "Kenya",
    subcountry: "Marsabit",
    geonameid: 187585,
  },
  {
    name: "Maralal",
    country: "Kenya",
    subcountry: "Samburu",
    geonameid: 187725,
  },
  {
    name: "Mandera",
    country: "Kenya",
    subcountry: "Mandera",
    geonameid: 187896,
  },
  {
    name: "Malindi",
    country: "Kenya",
    subcountry: "Kilifi",
    geonameid: 187968,
  },
  {
    name: "Makueni Boma",
    country: "Kenya",
    subcountry: "Makueni",
    geonameid: 188080,
  },
  {
    name: "Machakos",
    country: "Kenya",
    subcountry: "Machakos",
    geonameid: 188492,
  },
  {
    name: "Lugulu",
    country: "Kenya",
    subcountry: "Busia",
    geonameid: 188657,
  },
  {
    name: "Lodwar",
    country: "Kenya",
    subcountry: "Turkana",
    geonameid: 189280,
  },
  {
    name: "Limuru",
    country: "Kenya",
    subcountry: "Kiambu",
    geonameid: 189386,
  },
  {
    name: "Lamu",
    country: "Kenya",
    subcountry: "Lamu",
    geonameid: 189741,
  },
  {
    name: "Kitui",
    country: "Kenya",
    subcountry: "Kitui",
    geonameid: 191038,
  },
  {
    name: "Kitale",
    country: "Kenya",
    subcountry: "Trans Nzoia",
    geonameid: 191220,
  },
  {
    name: "Kisumu",
    country: "Kenya",
    subcountry: "Kisumu",
    geonameid: 191245,
  },
  {
    name: "Kisii",
    country: "Kenya",
    subcountry: "Kisii",
    geonameid: 191299,
  },
  {
    name: "Kilifi",
    country: "Kenya",
    subcountry: "Kilifi",
    geonameid: 192067,
  },
  {
    name: "Kikuyu",
    country: "Kenya",
    subcountry: "Kiambu",
    geonameid: 192126,
  },
  {
    name: "Kiambu",
    country: "Kenya",
    subcountry: "Kiambu",
    geonameid: 192710,
  },
  {
    name: "Kerugoya",
    country: "Kenya",
    subcountry: "Kirinyaga",
    geonameid: 192859,
  },
  {
    name: "Kericho",
    country: "Kenya",
    subcountry: "Kericho",
    geonameid: 192900,
  },
  {
    name: "Karuri",
    country: "Kenya",
    subcountry: "Murang'A",
    geonameid: 193627,
  },
  {
    name: "Kapenguria",
    country: "Kenya",
    subcountry: "West Pokot",
    geonameid: 194160,
  },
  {
    name: "Kakamega",
    country: "Kenya",
    subcountry: "Kakamega",
    geonameid: 195272,
  },
  {
    name: "Kajiado",
    country: "Kenya",
    subcountry: "Kajiado",
    geonameid: 195298,
  },
  {
    name: "Kabarnet",
    country: "Kenya",
    subcountry: "Baringo",
    geonameid: 195821,
  },
  {
    name: "Iten",
    country: "Kenya",
    subcountry: "Elegeyo-Marakwet",
    geonameid: 196185,
  },
  {
    name: "Isiolo",
    country: "Kenya",
    subcountry: "Isiolo",
    geonameid: 196231,
  },
  {
    name: "Homa Bay",
    country: "Kenya",
    subcountry: "Homa Bay",
    geonameid: 196742,
  },
  {
    name: "Garissa",
    country: "Kenya",
    subcountry: "Garissa",
    geonameid: 197745,
  },
  {
    name: "Embu",
    country: "Kenya",
    subcountry: "Embu",
    geonameid: 198476,
  },
  {
    name: "Eldoret",
    country: "Kenya",
    subcountry: "Uasin Gishu",
    geonameid: 198629,
  },
  {
    name: "Busia",
    country: "Kenya",
    subcountry: "Busia",
    geonameid: 199989,
  },
  {
    name: "Bungoma",
    country: "Kenya",
    subcountry: "Bungoma",
    geonameid: 200067,
  },
  {
    name: "Athi River",
    country: "Kenya",
    subcountry: "Machakos",
    geonameid: 200787,
  },
  {
    name: "Siaya",
    country: "Kenya",
    subcountry: "Siaya",
    geonameid: 383388,
  },
  {
    name: "Ol Kalou",
    country: "Kenya",
    subcountry: "Nyandarua",
    geonameid: 7931933,
  },
  {
    name: "Suluktu",
    country: "Kyrgyzstan",
    subcountry: "Batken",
    geonameid: 1222562,
  },
  {
    name: "Razzakov",
    country: "Kyrgyzstan",
    subcountry: "Batken",
    geonameid: 1222662,
  },
  {
    name: "Balykchy",
    country: "Kyrgyzstan",
    subcountry: "Issyk-Kul",
    geonameid: 1527004,
  },
  {
    name: "Tokmok",
    country: "Kyrgyzstan",
    subcountry: "Chüy",
    geonameid: 1527199,
  },
  {
    name: "Tash-Kumyr",
    country: "Kyrgyzstan",
    subcountry: "Jalal-Abad",
    geonameid: 1527260,
  },
  {
    name: "Talas",
    country: "Kyrgyzstan",
    subcountry: "Talas",
    geonameid: 1527299,
  },
  {
    name: "Suzak",
    country: "Kyrgyzstan",
    subcountry: "Jalal-Abad",
    geonameid: 1527317,
  },
  {
    name: "Kyzyl-Suu",
    country: "Kyrgyzstan",
    subcountry: "Issyk-Kul",
    geonameid: 1527497,
  },
  {
    name: "Uzgen",
    country: "Kyrgyzstan",
    subcountry: "Osh",
    geonameid: 1527513,
  },
  {
    name: "Osh",
    country: "Kyrgyzstan",
    subcountry: "Osh",
    geonameid: 1527534,
  },
  {
    name: "Naryn",
    country: "Kyrgyzstan",
    subcountry: "Naryn",
    geonameid: 1527592,
  },
  {
    name: "Massy",
    country: "Kyrgyzstan",
    subcountry: "Jalal-Abad",
    geonameid: 1527689,
  },
  {
    name: "Lebedinovka",
    country: "Kyrgyzstan",
    subcountry: "Chüy",
    geonameid: 1527690,
  },
  {
    name: "Kyzyl-Kyya",
    country: "Kyrgyzstan",
    subcountry: "Batken",
    geonameid: 1527719,
  },
  {
    name: "Kochkor-Ata",
    country: "Kyrgyzstan",
    subcountry: "Jalal-Abad",
    geonameid: 1527903,
  },
  {
    name: "Kara Suu",
    country: "Kyrgyzstan",
    subcountry: "Osh",
    geonameid: 1528091,
  },
  {
    name: "Karakol",
    country: "Kyrgyzstan",
    subcountry: "Issyk-Kul",
    geonameid: 1528121,
  },
  {
    name: "Kara-Balta",
    country: "Kyrgyzstan",
    subcountry: "Chüy",
    geonameid: 1528182,
  },
  {
    name: "Kant",
    country: "Kyrgyzstan",
    subcountry: "Chüy",
    geonameid: 1528193,
  },
  {
    name: "Jalal-Abad",
    country: "Kyrgyzstan",
    subcountry: "Jalal-Abad",
    geonameid: 1528249,
  },
  {
    name: "Ivanovka",
    country: "Kyrgyzstan",
    subcountry: "Chüy",
    geonameid: 1528252,
  },
  {
    name: "Iradan",
    country: "Kyrgyzstan",
    subcountry: "Batken",
    geonameid: 1528283,
  },
  {
    name: "Nookat",
    country: "Kyrgyzstan",
    subcountry: "Osh",
    geonameid: 1528339,
  },
  {
    name: "Bishkek",
    country: "Kyrgyzstan",
    subcountry: "Bishkek",
    geonameid: 1528675,
  },
  {
    name: "Belovodskoye",
    country: "Kyrgyzstan",
    subcountry: "Chüy",
    geonameid: 1528702,
  },
  {
    name: "Bazar-Korgon",
    country: "Kyrgyzstan",
    subcountry: "Jalal-Abad",
    geonameid: 1528717,
  },
  {
    name: "Batken",
    country: "Kyrgyzstan",
    subcountry: "Batken",
    geonameid: 1528735,
  },
  {
    name: "Ala-Buka",
    country: "Kyrgyzstan",
    subcountry: "Jalal-Abad",
    geonameid: 1528875,
  },
  {
    name: "Toktogul",
    country: "Kyrgyzstan",
    subcountry: "Jalal-Abad",
    geonameid: 1538648,
  },
  {
    name: "Kara-Kulja",
    country: "Kyrgyzstan",
    subcountry: "Osh",
    geonameid: 8145969,
  },
  {
    name: "Phnom Penh",
    country: "Cambodia",
    subcountry: "Phnom Penh",
    geonameid: 1821306,
  },
  {
    name: "Ta Khmau",
    country: "Cambodia",
    subcountry: "Kandal",
    geonameid: 1821935,
  },
  {
    name: "Takeo",
    country: "Cambodia",
    subcountry: "Takeo",
    geonameid: 1821940,
  },
  {
    name: "Svay Rieng",
    country: "Cambodia",
    subcountry: "Svay Rieng",
    geonameid: 1821993,
  },
  {
    name: "Suong",
    country: "Cambodia",
    subcountry: "Tboung Khmum",
    geonameid: 1822019,
  },
  {
    name: "Stung Treng",
    country: "Cambodia",
    subcountry: "Stung Treng",
    geonameid: 1822029,
  },
  {
    name: "Sisophon",
    country: "Cambodia",
    subcountry: "Banteay Meanchey",
    geonameid: 1822207,
  },
  {
    name: "Siem Reap",
    country: "Cambodia",
    subcountry: "Siem Reap",
    geonameid: 1822214,
  },
  {
    name: "Prey Veng",
    country: "Cambodia",
    subcountry: "Prey Veng",
    geonameid: 1822610,
  },
  {
    name: "Pursat",
    country: "Cambodia",
    subcountry: "Pursat",
    geonameid: 1822768,
  },
  {
    name: "Phumĭ Véal Srê",
    country: "Cambodia",
    subcountry: "Takeo",
    geonameid: 1822906,
  },
  {
    name: "Samraong",
    country: "Cambodia",
    subcountry: "Ŏtâr Méanchey",
    geonameid: 1825093,
  },
  {
    name: "Tbeng Meanchey",
    country: "Cambodia",
    subcountry: "Preah Vihear",
    geonameid: 1830098,
  },
  {
    name: "Paoy Paet",
    country: "Cambodia",
    subcountry: "Banteay Meanchey",
    geonameid: 1830194,
  },
  {
    name: "Pailin",
    country: "Cambodia",
    subcountry: "Pailin",
    geonameid: 1830205,
  },
  {
    name: "Lumphat",
    country: "Cambodia",
    subcountry: "Ratanakiri",
    geonameid: 1830377,
  },
  {
    name: "Koh Kong",
    country: "Cambodia",
    subcountry: "Koh Kong",
    geonameid: 1830468,
  },
  {
    name: "Kratié",
    country: "Cambodia",
    subcountry: "Kratie",
    geonameid: 1830564,
  },
  {
    name: "Kampot",
    country: "Cambodia",
    subcountry: "Kampot",
    geonameid: 1831112,
  },
  {
    name: "Kampong Thom",
    country: "Cambodia",
    subcountry: "Kampong Thom",
    geonameid: 1831125,
  },
  {
    name: "Kampong Speu",
    country: "Cambodia",
    subcountry: "Kampong Speu",
    geonameid: 1831133,
  },
  {
    name: "Sihanoukville",
    country: "Cambodia",
    subcountry: "Preah Sihanouk",
    geonameid: 1831142,
  },
  {
    name: "Kampong Chhnang",
    country: "Cambodia",
    subcountry: "Kampong Chhnang",
    geonameid: 1831167,
  },
  {
    name: "Kampong Cham",
    country: "Cambodia",
    subcountry: "Kampong Cham",
    geonameid: 1831173,
  },
  {
    name: "Banlung",
    country: "Cambodia",
    subcountry: "Ratanakiri",
    geonameid: 1831732,
  },
  {
    name: "Battambang",
    country: "Cambodia",
    subcountry: "Battambang",
    geonameid: 1831797,
  },
  {
    name: "Smach Mean Chey",
    country: "Cambodia",
    subcountry: "Koh Kong",
    geonameid: 8740221,
  },
  {
    name: "Tarawa",
    country: "Kiribati",
    subcountry: "Gilbert Islands",
    geonameid: 2110257,
  },
  {
    name: "Moutsamoudou",
    country: "Comoros",
    subcountry: "Anjouan",
    geonameid: 921753,
  },
  {
    name: "Moroni",
    country: "Comoros",
    subcountry: "Grande Comore",
    geonameid: 921772,
  },
  {
    name: "Basseterre",
    country: "Saint Kitts and Nevis",
    subcountry: "Saint George Basseterre",
    geonameid: 3575551,
  },
  {
    name: "Yŏnan-ŭp",
    country: "North Korea",
    subcountry: "Hwanghae-namdo",
    geonameid: 1866569,
  },
  {
    name: "Wŏnsan",
    country: "North Korea",
    subcountry: "Kangwŏn-do",
    geonameid: 1866923,
  },
  {
    name: "T’ongch’ŏn-ŭp",
    country: "North Korea",
    subcountry: "Kangwŏn-do",
    geonameid: 1867927,
  },
  {
    name: "Sŭngho 1-tong",
    country: "North Korea",
    subcountry: "Pyongyang",
    geonameid: 1868998,
  },
  {
    name: "Sunch’ŏn",
    country: "North Korea",
    subcountry: "South Pyongan",
    geonameid: 1869012,
  },
  {
    name: "Sunan",
    country: "North Korea",
    subcountry: "Pyongyang",
    geonameid: 1869021,
  },
  {
    name: "Songnim-ni",
    country: "North Korea",
    subcountry: "Hwanghae-bukto",
    geonameid: 1869446,
  },
  {
    name: "Sil-li",
    country: "North Korea",
    subcountry: "South Pyongan",
    geonameid: 1870413,
  },
  {
    name: "Sinmak",
    country: "North Korea",
    subcountry: "Hwanghae-bukto",
    geonameid: 1870434,
  },
  {
    name: "Sinanju",
    country: "North Korea",
    subcountry: "South Pyongan",
    geonameid: 1870742,
  },
  {
    name: "Sariwŏn",
    country: "North Korea",
    subcountry: "Hwanghae-bukto",
    geonameid: 1870883,
  },
  {
    name: "Samho-rodongjagu",
    country: "North Korea",
    subcountry: "Hamgyŏng-namdo",
    geonameid: 1871484,
  },
  {
    name: "Pyongyang",
    country: "North Korea",
    subcountry: "Pyongyang",
    geonameid: 1871859,
  },
  {
    name: "P’yŏngsŏng",
    country: "North Korea",
    subcountry: "South Pyongan",
    geonameid: 1871871,
  },
  {
    name: "Ongjin",
    country: "North Korea",
    subcountry: "Hwanghae-namdo",
    geonameid: 1873172,
  },
  {
    name: "Namp’o",
    country: "North Korea",
    subcountry: "South Pyongan",
    geonameid: 1873757,
  },
  {
    name: "Kusŏng",
    country: "North Korea",
    subcountry: "P'yŏngan-bukto",
    geonameid: 1875107,
  },
  {
    name: "Kujang-ŭp",
    country: "North Korea",
    subcountry: "P'yŏngan-bukto",
    geonameid: 1875506,
  },
  {
    name: "Kowŏn-ŭp",
    country: "North Korea",
    subcountry: "Hamgyŏng-namdo",
    geonameid: 1875588,
  },
  {
    name: "Kosan",
    country: "North Korea",
    subcountry: "Kangwŏn-do",
    geonameid: 1875632,
  },
  {
    name: "Kangdong-ŭp",
    country: "North Korea",
    subcountry: "Pyongyang",
    geonameid: 1876153,
  },
  {
    name: "Kaesŏng",
    country: "North Korea",
    subcountry: "Hwanghae-namdo",
    geonameid: 1876373,
  },
  {
    name: "Hwangju-ŭp",
    country: "North Korea",
    subcountry: "Hwanghae-bukto",
    geonameid: 1876873,
  },
  {
    name: "Hŭngnam",
    country: "North Korea",
    subcountry: "Hamgyŏng-namdo",
    geonameid: 1877030,
  },
  {
    name: "Hŭkkyo-ri",
    country: "North Korea",
    subcountry: "Hwanghae-bukto",
    geonameid: 1877046,
  },
  {
    name: "Hoeyang",
    country: "North Korea",
    subcountry: "Kangwŏn-do",
    geonameid: 1877148,
  },
  {
    name: "Hamhŭng",
    country: "North Korea",
    subcountry: "Hamgyŏng-namdo",
    geonameid: 1877449,
  },
  {
    name: "Haeju",
    country: "North Korea",
    subcountry: "Hwanghae-namdo",
    geonameid: 1877615,
  },
  {
    name: "Chunghwa",
    country: "North Korea",
    subcountry: "Pyongyang",
    geonameid: 1877872,
  },
  {
    name: "Chŏngju",
    country: "North Korea",
    subcountry: "P'yŏngan-bukto",
    geonameid: 1878389,
  },
  {
    name: "Changyŏn",
    country: "North Korea",
    subcountry: "Hwanghae-namdo",
    geonameid: 1879029,
  },
  {
    name: "Chaeryŏng-ŭp",
    country: "North Korea",
    subcountry: "Hwanghae-namdo",
    geonameid: 1879487,
  },
  {
    name: "Ayang-ni",
    country: "North Korea",
    subcountry: "Hwanghae-namdo",
    geonameid: 1879544,
  },
  {
    name: "Anju",
    country: "North Korea",
    subcountry: "South Pyongan",
    geonameid: 1879613,
  },
  {
    name: "Anbyŏn-ŭp",
    country: "North Korea",
    subcountry: "Kangwŏn-do",
    geonameid: 1879672,
  },
  {
    name: "Anak",
    country: "North Korea",
    subcountry: "Hwanghae-bukto",
    geonameid: 1879682,
  },
  {
    name: "Yuktae-dong",
    country: "North Korea",
    subcountry: "Hamgyŏng-namdo",
    geonameid: 2038854,
  },
  {
    name: "Uiju",
    country: "North Korea",
    subcountry: "P'yŏngan-bukto",
    geonameid: 2039623,
  },
  {
    name: "Sŏnbong",
    country: "North Korea",
    subcountry: "Rason",
    geonameid: 2040674,
  },
  {
    name: "Sinŭiju",
    country: "North Korea",
    subcountry: "P'yŏngan-bukto",
    geonameid: 2040893,
  },
  {
    name: "Sakchu-ŭp",
    country: "North Korea",
    subcountry: "P'yŏngan-bukto",
    geonameid: 2041533,
  },
  {
    name: "Yŏnggwang-ŭp",
    country: "North Korea",
    subcountry: "Hamgyŏng-namdo",
    geonameid: 2042249,
  },
  {
    name: "Onsŏng",
    country: "North Korea",
    subcountry: "Hambuk",
    geonameid: 2042267,
  },
  {
    name: "Ranam",
    country: "North Korea",
    subcountry: "Hambuk",
    geonameid: 2042498,
  },
  {
    name: "Namyang",
    country: "North Korea",
    subcountry: "Hambuk",
    geonameid: 2042503,
  },
  {
    name: "Rajin",
    country: "North Korea",
    subcountry: "Rason",
    geonameid: 2042645,
  },
  {
    name: "Musan-ŭp",
    country: "North Korea",
    subcountry: "Hambuk",
    geonameid: 2042738,
  },
  {
    name: "Manp’o",
    country: "North Korea",
    subcountry: "Chagang-do",
    geonameid: 2042893,
  },
  {
    name: "Kyŏngsŏng",
    country: "North Korea",
    subcountry: "Hambuk",
    geonameid: 2042987,
  },
  {
    name: "Kilju",
    country: "North Korea",
    subcountry: "Hambuk",
    geonameid: 2043484,
  },
  {
    name: "Kapsan-ŭp",
    country: "North Korea",
    subcountry: "Yanggang-do",
    geonameid: 2043531,
  },
  {
    name: "Kanggye",
    country: "North Korea",
    subcountry: "Chagang-do",
    geonameid: 2043572,
  },
  {
    name: "Iwŏn-ŭp",
    country: "North Korea",
    subcountry: "Hamgyŏng-namdo",
    geonameid: 2043677,
  },
  {
    name: "Hyesan-dong",
    country: "North Korea",
    subcountry: "Yanggang-do",
    geonameid: 2043835,
  },
  {
    name: "Hyesan",
    country: "North Korea",
    subcountry: "Yanggang-do",
    geonameid: 2043837,
  },
  {
    name: "Hongwŏn",
    country: "North Korea",
    subcountry: "Hamgyŏng-namdo",
    geonameid: 2044050,
  },
  {
    name: "Hoeryŏng",
    country: "North Korea",
    subcountry: "Hambuk",
    geonameid: 2044091,
  },
  {
    name: "Chongjin",
    country: "North Korea",
    subcountry: "Hambuk",
    geonameid: 2044757,
  },
  {
    name: "Aoji",
    country: "North Korea",
    subcountry: "Hambuk",
    geonameid: 2045311,
  },
  {
    name: "Heunghae",
    country: "South Korea",
    subcountry: "Gyeongsangbuk-do",
    geonameid: 1832015,
  },
  {
    name: "Yeonil",
    country: "South Korea",
    subcountry: "Gyeongsangbuk-do",
    geonameid: 1832215,
  },
  {
    name: "Neietsu",
    country: "South Korea",
    subcountry: "Gangwon-do",
    geonameid: 1832257,
  },
  {
    name: "Yeongju",
    country: "South Korea",
    subcountry: "Gyeongsangbuk-do",
    geonameid: 1832384,
  },
  {
    name: "Yeonggwang",
    country: "South Korea",
    subcountry: "Jeollanam-do",
    geonameid: 1832501,
  },
  {
    name: "Yeongdong",
    country: "South Korea",
    subcountry: "North Chungcheong",
    geonameid: 1832566,
  },
  {
    name: "Eisen",
    country: "South Korea",
    subcountry: "Gyeongsangbuk-do",
    geonameid: 1832617,
  },
  {
    name: "Yeoju",
    country: "South Korea",
    subcountry: "Gyeonggi-do",
    geonameid: 1832743,
  },
  {
    name: "Yesan",
    country: "South Korea",
    subcountry: "Chungcheongnam-do",
    geonameid: 1832771,
  },
  {
    name: "Yangsan",
    country: "South Korea",
    subcountry: "Gyeongsangnam-do",
    geonameid: 1832828,
  },
  {
    name: "Yangp'yŏng",
    country: "South Korea",
    subcountry: "Gyeonggi-do",
    geonameid: 1832830,
  },
  {
    name: "Yangju",
    country: "South Korea",
    subcountry: "Gyeonggi-do",
    geonameid: 1832847,
  },
  {
    name: "Yanggu",
    country: "South Korea",
    subcountry: "Gangwon-do",
    geonameid: 1832909,
  },
  {
    name: "Wŏnju",
    country: "South Korea",
    subcountry: "Gangwon-do",
    geonameid: 1833105,
  },
  {
    name: "Wanju",
    country: "South Korea",
    subcountry: "Jeollabuk-do",
    geonameid: 1833466,
  },
  {
    name: "Waegwan",
    country: "South Korea",
    subcountry: "Gyeongsangbuk-do",
    geonameid: 1833514,
  },
  {
    name: "Ulsan",
    country: "South Korea",
    subcountry: "Ulsan",
    geonameid: 1833747,
  },
  {
    name: "Uijeongbu-si",
    country: "South Korea",
    subcountry: "Gyeonggi-do",
    geonameid: 1833788,
  },
  {
    name: "Tangjin",
    country: "South Korea",
    subcountry: "Chungcheongnam-do",
    geonameid: 1834885,
  },
  {
    name: "Taesal-li",
    country: "South Korea",
    subcountry: "Chungcheongnam-do",
    geonameid: 1835096,
  },
  {
    name: "Daejeon",
    country: "South Korea",
    subcountry: "Daejeon",
    geonameid: 1835235,
  },
  {
    name: "Daegu",
    country: "South Korea",
    subcountry: "Daegu",
    geonameid: 1835329,
  },
  {
    name: "Boryeong",
    country: "South Korea",
    subcountry: "Chungcheongnam-do",
    geonameid: 1835447,
  },
  {
    name: "T’aebaek",
    country: "South Korea",
    subcountry: "Gangwon-do",
    geonameid: 1835515,
  },
  {
    name: "Suwon",
    country: "South Korea",
    subcountry: "Gyeonggi-do",
    geonameid: 1835553,
  },
  {
    name: "Suncheon",
    country: "South Korea",
    subcountry: "Jeollanam-do",
    geonameid: 1835648,
  },
  {
    name: "Seoul",
    country: "South Korea",
    subcountry: "Seoul",
    geonameid: 1835848,
  },
  {
    name: "Seosan",
    country: "South Korea",
    subcountry: "Chungcheongnam-do",
    geonameid: 1835895,
  },
  {
    name: "Jenzan",
    country: "South Korea",
    subcountry: "Gyeongsangbuk-do",
    geonameid: 1835967,
  },
  {
    name: "Seonghwan",
    country: "South Korea",
    subcountry: "Chungcheongnam-do",
    geonameid: 1836208,
  },
  {
    name: "Sokcho",
    country: "South Korea",
    subcountry: "Gangwon-do",
    geonameid: 1836553,
  },
  {
    name: "Sangju",
    country: "South Korea",
    subcountry: "Gyeongsangbuk-do",
    geonameid: 1837706,
  },
  {
    name: "Santyoku",
    country: "South Korea",
    subcountry: "Gangwon-do",
    geonameid: 1838069,
  },
  {
    name: "Buyeo",
    country: "South Korea",
    subcountry: "Chungcheongnam-do",
    geonameid: 1838508,
  },
  {
    name: "Busan",
    country: "South Korea",
    subcountry: "Busan",
    geonameid: 1838524,
  },
  {
    name: "Bucheon-si",
    country: "South Korea",
    subcountry: "Gyeonggi-do",
    geonameid: 1838716,
  },
  {
    name: "Puan",
    country: "South Korea",
    subcountry: "Jeollabuk-do",
    geonameid: 1838722,
  },
  {
    name: "Beolgyo",
    country: "South Korea",
    subcountry: "Jeollanam-do",
    geonameid: 1839011,
  },
  {
    name: "Pohang",
    country: "South Korea",
    subcountry: "Gyeongsangbuk-do",
    geonameid: 1839071,
  },
  {
    name: "Osan",
    country: "South Korea",
    subcountry: "Gyeonggi-do",
    geonameid: 1839652,
  },
  {
    name: "Asan",
    country: "South Korea",
    subcountry: "Chungcheongnam-do",
    geonameid: 1839726,
  },
  {
    name: "Okcheon",
    country: "South Korea",
    subcountry: "North Chungcheong",
    geonameid: 1839873,
  },
  {
    name: "Kosong",
    country: "South Korea",
    subcountry: "Gangwon-do",
    geonameid: 1840179,
  },
  {
    name: "Nonsan",
    country: "South Korea",
    subcountry: "Chungcheongnam-do",
    geonameid: 1840211,
  },
  {
    name: "Nangen",
    country: "South Korea",
    subcountry: "Jeollabuk-do",
    geonameid: 1840379,
  },
  {
    name: "Naju",
    country: "South Korea",
    subcountry: "Jeollanam-do",
    geonameid: 1840536,
  },
  {
    name: "Munsan",
    country: "South Korea",
    subcountry: "Gyeonggi-do",
    geonameid: 1840862,
  },
  {
    name: "Mungyeong",
    country: "South Korea",
    subcountry: "Gyeongsangbuk-do",
    geonameid: 1840886,
  },
  {
    name: "Muan",
    country: "South Korea",
    subcountry: "Jeollanam-do",
    geonameid: 1840982,
  },
  {
    name: "Mokpo",
    country: "South Korea",
    subcountry: "Jeollanam-do",
    geonameid: 1841066,
  },
  {
    name: "Miryang",
    country: "South Korea",
    subcountry: "Gyeongsangnam-do",
    geonameid: 1841149,
  },
  {
    name: "Masan",
    country: "South Korea",
    subcountry: "Gwangju",
    geonameid: 1841246,
  },
  {
    name: "Gyeongsan-si",
    country: "South Korea",
    subcountry: "Gyeongsangbuk-do",
    geonameid: 1841598,
  },
  {
    name: "Gyeongju",
    country: "South Korea",
    subcountry: "Gyeongsangbuk-do",
    geonameid: 1841603,
  },
  {
    name: "Kwangyang",
    country: "South Korea",
    subcountry: "Jeollanam-do",
    geonameid: 1841775,
  },
  {
    name: "Gwangju",
    country: "South Korea",
    subcountry: "Gyeonggi-do",
    geonameid: 1841810,
  },
  {
    name: "Gwangju",
    country: "South Korea",
    subcountry: "Gwangju",
    geonameid: 1841811,
  },
  {
    name: "Kurye",
    country: "South Korea",
    subcountry: "Jeollanam-do",
    geonameid: 1841976,
  },
  {
    name: "Guri-si",
    country: "South Korea",
    subcountry: "Gyeonggi-do",
    geonameid: 1841988,
  },
  {
    name: "Kunwi",
    country: "South Korea",
    subcountry: "Gyeongsangbuk-do",
    geonameid: 1842016,
  },
  {
    name: "Gunsan",
    country: "South Korea",
    subcountry: "Jeollabuk-do",
    geonameid: 1842025,
  },
  {
    name: "Gunpo",
    country: "South Korea",
    subcountry: "Gyeonggi-do",
    geonameid: 1842030,
  },
  {
    name: "Kinzan",
    country: "South Korea",
    subcountry: "Chungcheongnam-do",
    geonameid: 1842153,
  },
  {
    name: "Gumi",
    country: "South Korea",
    subcountry: "Gyeongsangbuk-do",
    geonameid: 1842225,
  },
  {
    name: "Goyang-si",
    country: "South Korea",
    subcountry: "Gyeonggi-do",
    geonameid: 1842485,
  },
  {
    name: "Goseong",
    country: "South Korea",
    subcountry: "Gyeongsangnam-do",
    geonameid: 1842518,
  },
  {
    name: "Gongju",
    country: "South Korea",
    subcountry: "Chungcheongnam-do",
    geonameid: 1842616,
  },
  {
    name: "Kyosai",
    country: "South Korea",
    subcountry: "Gyeongsangnam-do",
    geonameid: 1842754,
  },
  {
    name: "Koesan",
    country: "South Korea",
    subcountry: "North Chungcheong",
    geonameid: 1842800,
  },
  {
    name: "Koch'ang",
    country: "South Korea",
    subcountry: "Jeollabuk-do",
    geonameid: 1842859,
  },
  {
    name: "Kimje",
    country: "South Korea",
    subcountry: "Jeollabuk-do",
    geonameid: 1842939,
  },
  {
    name: "Kimhae",
    country: "South Korea",
    subcountry: "Gyeongsangnam-do",
    geonameid: 1842943,
  },
  {
    name: "Gimcheon",
    country: "South Korea",
    subcountry: "Gyeongsangbuk-do",
    geonameid: 1842944,
  },
  {
    name: "Gijang",
    country: "South Korea",
    subcountry: "Busan",
    geonameid: 1842966,
  },
  {
    name: "Gapyeong",
    country: "South Korea",
    subcountry: "Gyeonggi-do",
    geonameid: 1843082,
  },
  {
    name: "Gangneung",
    country: "South Korea",
    subcountry: "Gangwon-do",
    geonameid: 1843137,
  },
  {
    name: "Ganghwa-gun",
    country: "South Korea",
    subcountry: "Incheon",
    geonameid: 1843163,
  },
  {
    name: "Iksan",
    country: "South Korea",
    subcountry: "Jeollabuk-do",
    geonameid: 1843491,
  },
  {
    name: "Incheon",
    country: "South Korea",
    subcountry: "Incheon",
    geonameid: 1843564,
  },
  {
    name: "Imsil",
    country: "South Korea",
    subcountry: "Jeollabuk-do",
    geonameid: 1843585,
  },
  {
    name: "Icheon-si",
    country: "South Korea",
    subcountry: "Gyeonggi-do",
    geonameid: 1843702,
  },
  {
    name: "Hwasun",
    country: "South Korea",
    subcountry: "Jeollanam-do",
    geonameid: 1843841,
  },
  {
    name: "Hwaseong-si",
    country: "South Korea",
    subcountry: "Gyeonggi-do",
    geonameid: 1843847,
  },
  {
    name: "Hwacheon",
    country: "South Korea",
    subcountry: "Gangwon-do",
    geonameid: 1844045,
  },
  {
    name: "Hongseong",
    country: "South Korea",
    subcountry: "Chungcheongnam-do",
    geonameid: 1844174,
  },
  {
    name: "Hongch’ŏn",
    country: "South Korea",
    subcountry: "Gangwon-do",
    geonameid: 1844191,
  },
  {
    name: "Hayang",
    country: "South Korea",
    subcountry: "Gyeongsangbuk-do",
    geonameid: 1844308,
  },
  {
    name: "Haenam",
    country: "South Korea",
    subcountry: "Jeollanam-do",
    geonameid: 1844751,
  },
  {
    name: "Chungju",
    country: "South Korea",
    subcountry: "North Chungcheong",
    geonameid: 1845033,
  },
  {
    name: "Chuncheon",
    country: "South Korea",
    subcountry: "Gangwon-do",
    geonameid: 1845136,
  },
  {
    name: "Jumunjin",
    country: "South Korea",
    subcountry: "Gangwon-do",
    geonameid: 1845142,
  },
  {
    name: "Jeonju",
    country: "South Korea",
    subcountry: "Jeollabuk-do",
    geonameid: 1845457,
  },
  {
    name: "Cheongsong gun",
    country: "South Korea",
    subcountry: "Gyeongsangbuk-do",
    geonameid: 1845519,
  },
  {
    name: "Cheongju-si",
    country: "South Korea",
    subcountry: "North Chungcheong",
    geonameid: 1845604,
  },
  {
    name: "Cheonan",
    country: "South Korea",
    subcountry: "Chungcheongnam-do",
    geonameid: 1845759,
  },
  {
    name: "Chinju",
    country: "South Korea",
    subcountry: "Gyeongsangnam-do",
    geonameid: 1846052,
  },
  {
    name: "Chinch'ŏn",
    country: "South Korea",
    subcountry: "North Chungcheong",
    geonameid: 1846095,
  },
  {
    name: "Jinan-gun",
    country: "South Korea",
    subcountry: "Jeollabuk-do",
    geonameid: 1846114,
  },
  {
    name: "Jeju City",
    country: "South Korea",
    subcountry: "Jeju-do",
    geonameid: 1846266,
  },
  {
    name: "Changwon",
    country: "South Korea",
    subcountry: "Gyeongsangnam-do",
    geonameid: 1846326,
  },
  {
    name: "Changsu",
    country: "South Korea",
    subcountry: "Jeollabuk-do",
    geonameid: 1846355,
  },
  {
    name: "Anyang-si",
    country: "South Korea",
    subcountry: "Gyeonggi-do",
    geonameid: 1846898,
  },
  {
    name: "Anseong",
    country: "South Korea",
    subcountry: "Gyeonggi-do",
    geonameid: 1846912,
  },
  {
    name: "Ansan-si",
    country: "South Korea",
    subcountry: "Gyeonggi-do",
    geonameid: 1846918,
  },
  {
    name: "Andong",
    country: "South Korea",
    subcountry: "Gyeongsangbuk-do",
    geonameid: 1846986,
  },
  {
    name: "Gaigeturi",
    country: "South Korea",
    subcountry: "Jeju-do",
    geonameid: 1847050,
  },
  {
    name: "Sinhyeon",
    country: "South Korea",
    subcountry: "Gyeongsangnam-do",
    geonameid: 1882056,
  },
  {
    name: "Yeosu",
    country: "South Korea",
    subcountry: "Jeollanam-do",
    geonameid: 1884138,
  },
  {
    name: "Yŏnmu",
    country: "South Korea",
    subcountry: "Chungcheongnam-do",
    geonameid: 1886598,
  },
  {
    name: "Donghae City",
    country: "South Korea",
    subcountry: "Gangwon-do",
    geonameid: 1892823,
  },
  {
    name: "Pubal",
    country: "South Korea",
    subcountry: "Gyeonggi-do",
    geonameid: 1896953,
  },
  {
    name: "Seongnam-si",
    country: "South Korea",
    subcountry: "Gyeonggi-do",
    geonameid: 1897000,
  },
  {
    name: "Hanam",
    country: "South Korea",
    subcountry: "Gyeonggi-do",
    geonameid: 1897007,
  },
  {
    name: "Hwado",
    country: "South Korea",
    subcountry: "Gyeonggi-do",
    geonameid: 1897118,
  },
  {
    name: "Namyangju",
    country: "South Korea",
    subcountry: "Gyeonggi-do",
    geonameid: 1897122,
  },
  {
    name: "Ungsang",
    country: "South Korea",
    subcountry: "Gyeongsangnam-do",
    geonameid: 1912205,
  },
  {
    name: "Wabu",
    country: "South Korea",
    subcountry: "Gyeonggi-do",
    geonameid: 1912209,
  },
  {
    name: "Naesŏ",
    country: "South Korea",
    subcountry: "Gyeongsangnam-do",
    geonameid: 1925936,
  },
  {
    name: "Hwawŏn",
    country: "South Korea",
    subcountry: "Daegu",
    geonameid: 1925943,
  },
  {
    name: "Gwangmyeong",
    country: "South Korea",
    subcountry: "Gyeonggi-do",
    geonameid: 1948005,
  },
  {
    name: "Sinan",
    country: "South Korea",
    subcountry: "Jeollanam-do",
    geonameid: 6395804,
  },
  {
    name: "Seogwipo",
    country: "South Korea",
    subcountry: "Jeju-do",
    geonameid: 6621166,
  },
  {
    name: "Changnyeong",
    country: "South Korea",
    subcountry: "Gyeongsangnam-do",
    geonameid: 6903078,
  },
  {
    name: "Sejong",
    country: "South Korea",
    subcountry: "Sejong-si",
    geonameid: 11523293,
  },
  {
    name: "Jeongeup",
    country: "South Korea",
    subcountry: "Jeollabuk-do",
    geonameid: 11695689,
  },
  {
    name: "Yeongam",
    country: "South Korea",
    subcountry: "Jeollanam-do",
    geonameid: 11762608,
  },
  {
    name: "Janūb as Surrah",
    country: "Kuwait",
    subcountry: "Al Farwaniyah",
    geonameid: 285603,
  },
  {
    name: "Ḩawallī",
    country: "Kuwait",
    subcountry: "Hawalli",
    geonameid: 285629,
  },
  {
    name: "Bayān",
    country: "Kuwait",
    subcountry: "Hawalli",
    geonameid: 285663,
  },
  {
    name: "As Sālimīyah",
    country: "Kuwait",
    subcountry: "Hawalli",
    geonameid: 285704,
  },
  {
    name: "Ar Rumaythīyah",
    country: "Kuwait",
    subcountry: "Hawalli",
    geonameid: 285726,
  },
  {
    name: "Ar Riqqah",
    country: "Kuwait",
    subcountry: "Al Aḩmadī",
    geonameid: 285728,
  },
  {
    name: "Al Manqaf",
    country: "Kuwait",
    subcountry: "Al Aḩmadī",
    geonameid: 285778,
  },
  {
    name: "Al Mahbūlah",
    country: "Kuwait",
    subcountry: "Al Aḩmadī",
    geonameid: 285782,
  },
  {
    name: "Kuwait City",
    country: "Kuwait",
    subcountry: "Al Asimah",
    geonameid: 285787,
  },
  {
    name: "Al Jahrā’",
    country: "Kuwait",
    subcountry: "Al Jahrāʼ",
    geonameid: 285799,
  },
  {
    name: "Al Faḩāḩīl",
    country: "Kuwait",
    subcountry: "Al Aḩmadī",
    geonameid: 285811,
  },
  {
    name: "Al Finţās",
    country: "Kuwait",
    subcountry: "Al Aḩmadī",
    geonameid: 285812,
  },
  {
    name: "Al Farwānīyah",
    country: "Kuwait",
    subcountry: "Al Farwaniyah",
    geonameid: 285815,
  },
  {
    name: "Al Aḩmadī",
    country: "Kuwait",
    subcountry: "Al Aḩmadī",
    geonameid: 285839,
  },
  {
    name: "Ad Dasmah",
    country: "Kuwait",
    subcountry: "Al Asimah",
    geonameid: 285856,
  },
  {
    name: "Salwá",
    country: "Kuwait",
    subcountry: "Hawalli",
    geonameid: 387958,
  },
  {
    name: "Ar Rābiyah",
    country: "Kuwait",
    subcountry: "Al Asimah",
    geonameid: 388065,
  },
  {
    name: "Şabāḩ as Sālim",
    country: "Kuwait",
    subcountry: "Mubārak al Kabīr",
    geonameid: 412800,
  },
  {
    name: "West Bay",
    country: "Cayman Islands",
    subcountry: "West Bay",
    geonameid: 3580477,
  },
  {
    name: "George Town",
    country: "Cayman Islands",
    subcountry: "George Town",
    geonameid: 3580661,
  },
  {
    name: "Zhanaozen",
    country: "Kazakhstan",
    subcountry: "Mangghystaū",
    geonameid: 607610,
  },
  {
    name: "Shalqar",
    country: "Kazakhstan",
    subcountry: "Aqtöbe",
    geonameid: 608359,
  },
  {
    name: "Shalkar",
    country: "Kazakhstan",
    subcountry: "Atyraū",
    geonameid: 608362,
  },
  {
    name: "Oral",
    country: "Kazakhstan",
    subcountry: "Batys Qazaqstan",
    geonameid: 608668,
  },
  {
    name: "Kandyagash",
    country: "Kazakhstan",
    subcountry: "Aqtöbe",
    geonameid: 608679,
  },
  {
    name: "Qulsary",
    country: "Kazakhstan",
    subcountry: "Atyraū",
    geonameid: 609123,
  },
  {
    name: "Khromtau",
    country: "Kazakhstan",
    subcountry: "Aqtöbe",
    geonameid: 609404,
  },
  {
    name: "Karagandy",
    country: "Kazakhstan",
    subcountry: "Karaganda",
    geonameid: 609655,
  },
  {
    name: "Embi",
    country: "Kazakhstan",
    subcountry: "Aqtöbe",
    geonameid: 609924,
  },
  {
    name: "Balykshi",
    country: "Kazakhstan",
    subcountry: "Atyraū",
    geonameid: 610445,
  },
  {
    name: "Atyrau",
    country: "Kazakhstan",
    subcountry: "Atyraū",
    geonameid: 610529,
  },
  {
    name: "Aktobe",
    country: "Kazakhstan",
    subcountry: "Aqtöbe",
    geonameid: 610611,
  },
  {
    name: "Shevchenko",
    country: "Kazakhstan",
    subcountry: "Mangghystaū",
    geonameid: 610612,
  },
  {
    name: "Aqsay",
    country: "Kazakhstan",
    subcountry: "Batys Qazaqstan",
    geonameid: 610613,
  },
  {
    name: "Altay",
    country: "Kazakhstan",
    subcountry: "East Kazakhstan",
    geonameid: 1516438,
  },
  {
    name: "Zhosaly",
    country: "Kazakhstan",
    subcountry: "Qyzylorda",
    geonameid: 1516519,
  },
  {
    name: "Zhezqazghan",
    country: "Kazakhstan",
    subcountry: "Ulytau Region",
    geonameid: 1516589,
  },
  {
    name: "Zhitikara",
    country: "Kazakhstan",
    subcountry: "Qostanay",
    geonameid: 1516601,
  },
  {
    name: "Zhangatas",
    country: "Kazakhstan",
    subcountry: "Zhambyl",
    geonameid: 1516788,
  },
  {
    name: "Novokazalinsk",
    country: "Kazakhstan",
    subcountry: "Qyzylorda",
    geonameid: 1516789,
  },
  {
    name: "Taraz",
    country: "Kazakhstan",
    subcountry: "Zhambyl",
    geonameid: 1516905,
  },
  {
    name: "Zaysan",
    country: "Kazakhstan",
    subcountry: "East Kazakhstan",
    geonameid: 1517060,
  },
  {
    name: "Zhangaqorghan",
    country: "Kazakhstan",
    subcountry: "Qyzylorda",
    geonameid: 1517323,
  },
  {
    name: "Turar Ryskulov",
    country: "Kazakhstan",
    subcountry: "South Kazakhstan",
    geonameid: 1517501,
  },
  {
    name: "Ushtobe",
    country: "Kazakhstan",
    subcountry: "Jetisu Region",
    geonameid: 1517637,
  },
  {
    name: "Turkestan",
    country: "Kazakhstan",
    subcountry: "South Kazakhstan",
    geonameid: 1517945,
  },
  {
    name: "Temirtau",
    country: "Kazakhstan",
    subcountry: "Karaganda",
    geonameid: 1518262,
  },
  {
    name: "Tekeli",
    country: "Kazakhstan",
    subcountry: "Jetisu Region",
    geonameid: 1518296,
  },
  {
    name: "Tasbuget",
    country: "Kazakhstan",
    subcountry: "Qyzylorda",
    geonameid: 1518431,
  },
  {
    name: "Talghar",
    country: "Kazakhstan",
    subcountry: "Almaty",
    geonameid: 1518518,
  },
  {
    name: "Taldykorgan",
    country: "Kazakhstan",
    subcountry: "Jetisu Region",
    geonameid: 1518542,
  },
  {
    name: "Shymkent",
    country: "Kazakhstan",
    subcountry: "Shymkent",
    geonameid: 1518980,
  },
  {
    name: "Shu",
    country: "Kazakhstan",
    subcountry: "Zhambyl",
    geonameid: 1519030,
  },
  {
    name: "Shemonaikha",
    country: "Kazakhstan",
    subcountry: "East Kazakhstan",
    geonameid: 1519226,
  },
  {
    name: "Shchuchinsk",
    country: "Kazakhstan",
    subcountry: "Aqmola",
    geonameid: 1519244,
  },
  {
    name: "Shakhtinsk",
    country: "Kazakhstan",
    subcountry: "Karaganda",
    geonameid: 1519327,
  },
  {
    name: "Semey",
    country: "Kazakhstan",
    subcountry: "Abai Region",
    geonameid: 1519422,
  },
  {
    name: "Saryaghash",
    country: "Kazakhstan",
    subcountry: "South Kazakhstan",
    geonameid: 1519673,
  },
  {
    name: "Sarqant",
    country: "Kazakhstan",
    subcountry: "Jetisu Region",
    geonameid: 1519691,
  },
  {
    name: "Soran",
    country: "Kazakhstan",
    subcountry: "Karaganda",
    geonameid: 1519725,
  },
  {
    name: "Rudnyy",
    country: "Kazakhstan",
    subcountry: "Qostanay",
    geonameid: 1519843,
  },
  {
    name: "Kyzylorda",
    country: "Kazakhstan",
    subcountry: "Qyzylorda",
    geonameid: 1519922,
  },
  {
    name: "Kostanay",
    country: "Kazakhstan",
    subcountry: "Qostanay",
    geonameid: 1519928,
  },
  {
    name: "Karatau",
    country: "Kazakhstan",
    subcountry: "Zhambyl",
    geonameid: 1519938,
  },
  {
    name: "Konayev",
    country: "Kazakhstan",
    subcountry: "Almaty Oblysy",
    geonameid: 1519948,
  },
  {
    name: "Petropavl",
    country: "Kazakhstan",
    subcountry: "North Kazakhstan",
    geonameid: 1520172,
  },
  {
    name: "Pavlodar",
    country: "Kazakhstan",
    subcountry: "Pavlodar Region",
    geonameid: 1520240,
  },
  {
    name: "Zharkent",
    country: "Kazakhstan",
    subcountry: "Jetisu Region",
    geonameid: 1520253,
  },
  {
    name: "Ust-Kamenogorsk",
    country: "Kazakhstan",
    subcountry: "East Kazakhstan",
    geonameid: 1520316,
  },
  {
    name: "Sarykemer",
    country: "Kazakhstan",
    subcountry: "Zhambyl",
    geonameid: 1520947,
  },
  {
    name: "Merke",
    country: "Kazakhstan",
    subcountry: "Zhambyl",
    geonameid: 1520969,
  },
  {
    name: "Makinsk",
    country: "Kazakhstan",
    subcountry: "Aqmola",
    geonameid: 1521230,
  },
  {
    name: "Lisakovsk",
    country: "Kazakhstan",
    subcountry: "Qostanay",
    geonameid: 1521315,
  },
  {
    name: "Baikonur",
    country: "Kazakhstan",
    subcountry: "Baikonur",
    geonameid: 1521368,
  },
  {
    name: "Ridder",
    country: "Kazakhstan",
    subcountry: "East Kazakhstan",
    geonameid: 1521370,
  },
  {
    name: "Lenger",
    country: "Kazakhstan",
    subcountry: "South Kazakhstan",
    geonameid: 1521379,
  },
  {
    name: "Kokshetau",
    country: "Kazakhstan",
    subcountry: "Aqmola",
    geonameid: 1522203,
  },
  {
    name: "Kentau",
    country: "Kazakhstan",
    subcountry: "South Kazakhstan",
    geonameid: 1522751,
  },
  {
    name: "Esik",
    country: "Kazakhstan",
    subcountry: "Almaty Oblysy",
    geonameid: 1523741,
  },
  {
    name: "Kalbatau",
    country: "Kazakhstan",
    subcountry: "Abai Region",
    geonameid: 1524245,
  },
  {
    name: "Aksu",
    country: "Kazakhstan",
    subcountry: "Pavlodar Region",
    geonameid: 1524298,
  },
  {
    name: "Otegen Batyra",
    country: "Kazakhstan",
    subcountry: "Almaty",
    geonameid: 1524308,
  },
  {
    name: "Ekibastuz",
    country: "Kazakhstan",
    subcountry: "Pavlodar Region",
    geonameid: 1524325,
  },
  {
    name: "Shiyeli",
    country: "Kazakhstan",
    subcountry: "Qyzylorda",
    geonameid: 1524801,
  },
  {
    name: "Shardara",
    country: "Kazakhstan",
    subcountry: "South Kazakhstan",
    geonameid: 1524889,
  },
  {
    name: "Burunday",
    country: "Kazakhstan",
    subcountry: "Almaty",
    geonameid: 1524958,
  },
  {
    name: "Aksu",
    country: "Kazakhstan",
    subcountry: "South Kazakhstan",
    geonameid: 1525462,
  },
  {
    name: "Balqash",
    country: "Kazakhstan",
    subcountry: "Karaganda",
    geonameid: 1525798,
  },
  {
    name: "Ayagoz",
    country: "Kazakhstan",
    subcountry: "Abai Region",
    geonameid: 1525988,
  },
  {
    name: "Atbasar",
    country: "Kazakhstan",
    subcountry: "Aqmola",
    geonameid: 1526038,
  },
  {
    name: "Arys",
    country: "Kazakhstan",
    subcountry: "South Kazakhstan",
    geonameid: 1526168,
  },
  {
    name: "Arkalyk",
    country: "Kazakhstan",
    subcountry: "Qostanay",
    geonameid: 1526193,
  },
  {
    name: "Aral",
    country: "Kazakhstan",
    subcountry: "Qyzylorda",
    geonameid: 1526265,
  },
  {
    name: "Astana",
    country: "Kazakhstan",
    subcountry: "Astana",
    geonameid: 1526273,
  },
  {
    name: "Almaty",
    country: "Kazakhstan",
    subcountry: "Almaty",
    geonameid: 1526384,
  },
  {
    name: "Akkol’",
    country: "Kazakhstan",
    subcountry: "Aqmola",
    geonameid: 1526797,
  },
  {
    name: "Abay",
    country: "Kazakhstan",
    subcountry: "Karaganda",
    geonameid: 1526970,
  },
  {
    name: "Stepnogorsk",
    country: "Kazakhstan",
    subcountry: "Aqmola",
    geonameid: 1537939,
  },
  {
    name: "Vientiane",
    country: "Laos",
    subcountry: "Vientiane Prefecture",
    geonameid: 1651944,
  },
  {
    name: "Xam Nua",
    country: "Laos",
    subcountry: "Houaphan",
    geonameid: 1652203,
  },
  {
    name: "Savannakhet",
    country: "Laos",
    subcountry: "Savannahkhét",
    geonameid: 1653316,
  },
  {
    name: "Pakse",
    country: "Laos",
    subcountry: "Champasak",
    geonameid: 1654379,
  },
  {
    name: "Muang Xay",
    country: "Laos",
    subcountry: "Oudômxai",
    geonameid: 1655078,
  },
  {
    name: "Vang Vieng",
    country: "Laos",
    subcountry: "Vientiane",
    geonameid: 1655087,
  },
  {
    name: "Muang Phônsavan",
    country: "Laos",
    subcountry: "Xiangkhoang",
    geonameid: 1655123,
  },
  {
    name: "Pakxan",
    country: "Laos",
    subcountry: "Bolikhamsai",
    geonameid: 1655140,
  },
  {
    name: "Thakhèk",
    country: "Laos",
    subcountry: "Khammouan",
    geonameid: 1655199,
  },
  {
    name: "Luang Prabang",
    country: "Laos",
    subcountry: "Louangphabang",
    geonameid: 1655559,
  },
  {
    name: "Ban Houakhoua",
    country: "Laos",
    subcountry: "Bokeo",
    geonameid: 1904391,
  },
  {
    name: "Zahlé",
    country: "Lebanon",
    subcountry: "Béqaa",
    geonameid: 266045,
  },
  {
    name: "Tripoli",
    country: "Lebanon",
    subcountry: "Liban-Nord",
    geonameid: 266826,
  },
  {
    name: "Tyre",
    country: "Lebanon",
    subcountry: "South Governorate",
    geonameid: 267008,
  },
  {
    name: "Sidon",
    country: "Lebanon",
    subcountry: "South Governorate",
    geonameid: 268064,
  },
  {
    name: "Ra’s Bayrūt",
    country: "Lebanon",
    subcountry: "Beyrouth",
    geonameid: 268743,
  },
  {
    name: "Jounieh",
    country: "Lebanon",
    subcountry: "Mont-Liban",
    geonameid: 273140,
  },
  {
    name: "Jbaïl",
    country: "Lebanon",
    subcountry: "Mont-Liban",
    geonameid: 273203,
  },
  {
    name: "Habboûch",
    country: "Lebanon",
    subcountry: "Nabatîyé",
    geonameid: 274874,
  },
  {
    name: "Bcharré",
    country: "Lebanon",
    subcountry: "Liban-Nord",
    geonameid: 276359,
  },
  {
    name: "Beirut",
    country: "Lebanon",
    subcountry: "Beyrouth",
    geonameid: 276781,
  },
  {
    name: "Baalbek",
    country: "Lebanon",
    subcountry: "Baalbek-Hermel",
    geonameid: 277130,
  },
  {
    name: "En Nâqoûra",
    country: "Lebanon",
    subcountry: "South Governorate",
    geonameid: 278832,
  },
  {
    name: "Nabatîyé et Tahta",
    country: "Lebanon",
    subcountry: "Nabatîyé",
    geonameid: 278913,
  },
  {
    name: "Ghazieh",
    country: "Lebanon",
    subcountry: "South Governorate",
    geonameid: 280155,
  },
  {
    name: "Castries",
    country: "Saint Lucia",
    subcountry: "Castries",
    geonameid: 3576812,
  },
  {
    name: "Vaduz",
    country: "Liechtenstein",
    subcountry: "Vaduz",
    geonameid: 3042030,
  },
  {
    name: "Welisara",
    country: "Sri Lanka",
    subcountry: "Western",
    geonameid: 1223648,
  },
  {
    name: "Weligama",
    country: "Sri Lanka",
    subcountry: "Southern",
    geonameid: 1223738,
  },
  {
    name: "Wattala",
    country: "Sri Lanka",
    subcountry: "Western",
    geonameid: 1224085,
  },
  {
    name: "Vavuniya",
    country: "Sri Lanka",
    subcountry: "Northern Province",
    geonameid: 1225018,
  },
  {
    name: "Valvedditturai",
    country: "Sri Lanka",
    subcountry: "Northern Province",
    geonameid: 1225142,
  },
  {
    name: "Vakarai",
    country: "Sri Lanka",
    subcountry: "Eastern Province",
    geonameid: 1225187,
  },
  {
    name: "Trincomalee",
    country: "Sri Lanka",
    subcountry: "Eastern Province",
    geonameid: 1226260,
  },
  {
    name: "Ratnapura",
    country: "Sri Lanka",
    subcountry: "Sabaragamuwa",
    geonameid: 1228730,
  },
  {
    name: "Puttalam",
    country: "Sri Lanka",
    subcountry: "North Western",
    geonameid: 1229293,
  },
  {
    name: "Point Pedro",
    country: "Sri Lanka",
    subcountry: "Northern Province",
    geonameid: 1229989,
  },
  {
    name: "Pita Kotte",
    country: "Sri Lanka",
    subcountry: "Western",
    geonameid: 1230089,
  },
  {
    name: "Peliyagoda",
    country: "Sri Lanka",
    subcountry: "Western",
    geonameid: 1230613,
  },
  {
    name: "Panadura",
    country: "Sri Lanka",
    subcountry: "Western",
    geonameid: 1231410,
  },
  {
    name: "Nuwara Eliya",
    country: "Sri Lanka",
    subcountry: "Central",
    geonameid: 1232783,
  },
  {
    name: "Negombo",
    country: "Sri Lanka",
    subcountry: "Western",
    geonameid: 1233369,
  },
  {
    name: "Mulleriyawa",
    country: "Sri Lanka",
    subcountry: "Western",
    geonameid: 1234378,
  },
  {
    name: "Dehiwala-Mount Lavinia",
    country: "Sri Lanka",
    subcountry: "Western",
    geonameid: 1234569,
  },
  {
    name: "Moratuwa",
    country: "Sri Lanka",
    subcountry: "Western",
    geonameid: 1234633,
  },
  {
    name: "Matara",
    country: "Sri Lanka",
    subcountry: "Southern",
    geonameid: 1235846,
  },
  {
    name: "Matale",
    country: "Sri Lanka",
    subcountry: "Central",
    geonameid: 1235855,
  },
  {
    name: "Maharagama",
    country: "Sri Lanka",
    subcountry: "Western",
    geonameid: 1236854,
  },
  {
    name: "Kurunegala",
    country: "Sri Lanka",
    subcountry: "North Western",
    geonameid: 1237980,
  },
  {
    name: "Sri Jayewardenepura Kotte",
    country: "Sri Lanka",
    subcountry: "Western",
    geonameid: 1238992,
  },
  {
    name: "Kotikawatta",
    country: "Sri Lanka",
    subcountry: "Western",
    geonameid: 1239047,
  },
  {
    name: "Kolonnawa",
    country: "Sri Lanka",
    subcountry: "Western",
    geonameid: 1239593,
  },
  {
    name: "Kelaniya",
    country: "Sri Lanka",
    subcountry: "Western",
    geonameid: 1240622,
  },
  {
    name: "Kegalle",
    country: "Sri Lanka",
    subcountry: "Sabaragamuwa",
    geonameid: 1240723,
  },
  {
    name: "Katunayaka",
    country: "Sri Lanka",
    subcountry: "Western",
    geonameid: 1240935,
  },
  {
    name: "Kataragama",
    country: "Sri Lanka",
    subcountry: "Uva",
    geonameid: 1241076,
  },
  {
    name: "Kandy",
    country: "Sri Lanka",
    subcountry: "Central",
    geonameid: 1241622,
  },
  {
    name: "Kandana",
    country: "Sri Lanka",
    subcountry: "Western",
    geonameid: 1241750,
  },
  {
    name: "Kalutara",
    country: "Sri Lanka",
    subcountry: "Western",
    geonameid: 1241964,
  },
  {
    name: "Kalmunai",
    country: "Sri Lanka",
    subcountry: "Eastern Province",
    geonameid: 1242110,
  },
  {
    name: "Jaffna",
    country: "Sri Lanka",
    subcountry: "Northern Province",
    geonameid: 1242833,
  },
  {
    name: "Ja Ela",
    country: "Sri Lanka",
    subcountry: "Western",
    geonameid: 1242835,
  },
  {
    name: "Homagama",
    country: "Sri Lanka",
    subcountry: "Western",
    geonameid: 1243936,
  },
  {
    name: "Hendala",
    country: "Sri Lanka",
    subcountry: "Western",
    geonameid: 1244397,
  },
  {
    name: "Hatton",
    country: "Sri Lanka",
    subcountry: "Central",
    geonameid: 1244596,
  },
  {
    name: "Hanwella Ihala",
    country: "Sri Lanka",
    subcountry: "Western",
    geonameid: 1244773,
  },
  {
    name: "Gampola",
    country: "Sri Lanka",
    subcountry: "Central",
    geonameid: 1246000,
  },
  {
    name: "Galle",
    country: "Sri Lanka",
    subcountry: "Southern",
    geonameid: 1246294,
  },
  {
    name: "Eravur Town",
    country: "Sri Lanka",
    subcountry: "Eastern Province",
    geonameid: 1246924,
  },
  {
    name: "Devinuwara",
    country: "Sri Lanka",
    subcountry: "Southern",
    geonameid: 1248158,
  },
  {
    name: "Dambulla",
    country: "Sri Lanka",
    subcountry: "Central",
    geonameid: 1248749,
  },
  {
    name: "Colombo",
    country: "Sri Lanka",
    subcountry: "Western",
    geonameid: 1248991,
  },
  {
    name: "Chilaw",
    country: "Sri Lanka",
    subcountry: "North Western",
    geonameid: 1249145,
  },
  {
    name: "Beruwala",
    country: "Sri Lanka",
    subcountry: "Western",
    geonameid: 1249931,
  },
  {
    name: "Bentota",
    country: "Sri Lanka",
    subcountry: "Southern",
    geonameid: 1249978,
  },
  {
    name: "Batticaloa",
    country: "Sri Lanka",
    subcountry: "Eastern Province",
    geonameid: 1250161,
  },
  {
    name: "Battaramulla South",
    country: "Sri Lanka",
    subcountry: "Western",
    geonameid: 1250164,
  },
  {
    name: "Badulla",
    country: "Sri Lanka",
    subcountry: "Uva",
    geonameid: 1250615,
  },
  {
    name: "Anuradhapura",
    country: "Sri Lanka",
    subcountry: "North Central",
    geonameid: 1251081,
  },
  {
    name: "Ampara",
    country: "Sri Lanka",
    subcountry: "Eastern Province",
    geonameid: 1251459,
  },
  {
    name: "Ambalangoda",
    country: "Sri Lanka",
    subcountry: "Southern",
    geonameid: 1251574,
  },
  {
    name: "Zwedru",
    country: "Liberia",
    subcountry: "Grand Gedeh",
    geonameid: 2272491,
  },
  {
    name: "New Yekepa",
    country: "Liberia",
    subcountry: "Nimba",
    geonameid: 2272790,
  },
  {
    name: "Voinjama",
    country: "Liberia",
    subcountry: "Lofa",
    geonameid: 2273312,
  },
  {
    name: "Monrovia",
    country: "Liberia",
    subcountry: "Montserrado",
    geonameid: 2274895,
  },
  {
    name: "Kakata",
    country: "Liberia",
    subcountry: "Margibi",
    geonameid: 2276086,
  },
  {
    name: "Harper",
    country: "Liberia",
    subcountry: "Maryland",
    geonameid: 2276492,
  },
  {
    name: "Greenville",
    country: "Liberia",
    subcountry: "Sinoe",
    geonameid: 2276600,
  },
  {
    name: "Gbarnga",
    country: "Liberia",
    subcountry: "Bong",
    geonameid: 2277060,
  },
  {
    name: "Buchanan",
    country: "Liberia",
    subcountry: "Grand Bassa",
    geonameid: 2278158,
  },
  {
    name: "Bensonville",
    country: "Liberia",
    subcountry: "Montserrado",
    geonameid: 2278682,
  },
  {
    name: "Quthing",
    country: "Lesotho",
    subcountry: "Quthing",
    geonameid: 932183,
  },
  {
    name: "Qacha’s Nek",
    country: "Lesotho",
    subcountry: "Qachaʼs Nek",
    geonameid: 932218,
  },
  {
    name: "Mohale’s Hoek",
    country: "Lesotho",
    subcountry: "Mohaleʼs Hoek",
    geonameid: 932438,
  },
  {
    name: "Maseru",
    country: "Lesotho",
    subcountry: "Maseru",
    geonameid: 932505,
  },
  {
    name: "Maputsoe",
    country: "Lesotho",
    subcountry: "Leribe",
    geonameid: 932521,
  },
  {
    name: "Mafeteng",
    country: "Lesotho",
    subcountry: "Mafeteng",
    geonameid: 932614,
  },
  {
    name: "Leribe",
    country: "Lesotho",
    subcountry: "Leribe",
    geonameid: 932698,
  },
  {
    name: "Butha-Buthe",
    country: "Lesotho",
    subcountry: "Butha-Buthe",
    geonameid: 932886,
  },
  {
    name: "Thaba-Tseka",
    country: "Lesotho",
    subcountry: "Thaba-Tseka",
    geonameid: 1106835,
  },
  {
    name: "Visaginas",
    country: "Lithuania",
    subcountry: "Utena",
    geonameid: 593063,
  },
  {
    name: "Vilnius",
    country: "Lithuania",
    subcountry: "Vilnius",
    geonameid: 593116,
  },
  {
    name: "Utena",
    country: "Lithuania",
    subcountry: "Utena",
    geonameid: 593672,
  },
  {
    name: "Ukmerge",
    country: "Lithuania",
    subcountry: "Vilnius",
    geonameid: 593733,
  },
  {
    name: "Telsiai",
    country: "Lithuania",
    subcountry: "Telsiai",
    geonameid: 593926,
  },
  {
    name: "Taurage",
    country: "Lithuania",
    subcountry: "Tauragė County",
    geonameid: 593959,
  },
  {
    name: "Šiauliai",
    country: "Lithuania",
    subcountry: "Siauliai",
    geonameid: 594739,
  },
  {
    name: "Radviliskis",
    country: "Lithuania",
    subcountry: "Siauliai",
    geonameid: 595449,
  },
  {
    name: "Plunge",
    country: "Lithuania",
    subcountry: "Telsiai",
    geonameid: 595689,
  },
  {
    name: "Panevėžys",
    country: "Lithuania",
    subcountry: "Panevėžys",
    geonameid: 596128,
  },
  {
    name: "Palanga",
    country: "Lithuania",
    subcountry: "Klaipėda County",
    geonameid: 596238,
  },
  {
    name: "Fabijoniškės",
    country: "Lithuania",
    subcountry: "Vilnius",
    geonameid: 596479,
  },
  {
    name: "Naujoji Vilnia",
    country: "Lithuania",
    subcountry: "Vilnius",
    geonameid: 596713,
  },
  {
    name: "Mazeikiai",
    country: "Lithuania",
    subcountry: "Telsiai",
    geonameid: 597188,
  },
  {
    name: "Marijampolė",
    country: "Lithuania",
    subcountry: "Marijampolė County",
    geonameid: 597231,
  },
  {
    name: "Kretinga",
    country: "Lithuania",
    subcountry: "Klaipėda County",
    geonameid: 597989,
  },
  {
    name: "Klaipėda",
    country: "Lithuania",
    subcountry: "Klaipėda County",
    geonameid: 598098,
  },
  {
    name: "Kėdainiai",
    country: "Lithuania",
    subcountry: "Kaunas",
    geonameid: 598272,
  },
  {
    name: "Kaunas",
    country: "Lithuania",
    subcountry: "Kaunas",
    geonameid: 598316,
  },
  {
    name: "Jonava",
    country: "Lithuania",
    subcountry: "Kaunas",
    geonameid: 598818,
  },
  {
    name: "Gargždai",
    country: "Lithuania",
    subcountry: "Klaipėda County",
    geonameid: 599506,
  },
  {
    name: "Antakalnis",
    country: "Lithuania",
    subcountry: "Vilnius",
    geonameid: 601041,
  },
  {
    name: "Alytus",
    country: "Lithuania",
    subcountry: "Alytus",
    geonameid: 601084,
  },
  {
    name: "Aleksotas",
    country: "Lithuania",
    subcountry: "Kaunas",
    geonameid: 601138,
  },
  {
    name: "Dainava (Kaunas)",
    country: "Lithuania",
    subcountry: "Kaunas",
    geonameid: 6618486,
  },
  {
    name: "Naujininkai",
    country: "Lithuania",
    subcountry: "Vilnius",
    geonameid: 6955408,
  },
  {
    name: "Karoliniškės",
    country: "Lithuania",
    subcountry: "Vilnius",
    geonameid: 8714608,
  },
  {
    name: "Šilainiai",
    country: "Lithuania",
    subcountry: "Kaunas",
    geonameid: 9610004,
  },
  {
    name: "Eiguliai",
    country: "Lithuania",
    subcountry: "Kaunas",
    geonameid: 9610008,
  },
  {
    name: "Pašilaičiai",
    country: "Lithuania",
    subcountry: "Vilnius",
    geonameid: 10062599,
  },
  {
    name: "Pilaitė",
    country: "Lithuania",
    subcountry: "Vilnius",
    geonameid: 10062600,
  },
  {
    name: "Justiniškės",
    country: "Lithuania",
    subcountry: "Vilnius",
    geonameid: 10062601,
  },
  {
    name: "Šeškinė",
    country: "Lithuania",
    subcountry: "Vilnius",
    geonameid: 10062602,
  },
  {
    name: "Lazdynai",
    country: "Lithuania",
    subcountry: "Vilnius",
    geonameid: 10062605,
  },
  {
    name: "Vilkpėdė",
    country: "Lithuania",
    subcountry: "Vilnius",
    geonameid: 10062606,
  },
  {
    name: "Naujamiestis",
    country: "Lithuania",
    subcountry: "Vilnius",
    geonameid: 10062607,
  },
  {
    name: "Luxembourg",
    country: "Luxembourg",
    subcountry: "Luxembourg",
    geonameid: 2960316,
  },
  {
    name: "Esch-sur-Alzette",
    country: "Luxembourg",
    subcountry: "Esch-sur-Alzette",
    geonameid: 2960596,
  },
  {
    name: "Dudelange",
    country: "Luxembourg",
    subcountry: "Esch-sur-Alzette",
    geonameid: 2960634,
  },
  {
    name: "Valmiera",
    country: "Latvia",
    subcountry: "Valmiera",
    geonameid: 453754,
  },
  {
    name: "Ventspils",
    country: "Latvia",
    subcountry: "Ventspils",
    geonameid: 454310,
  },
  {
    name: "Tukums",
    country: "Latvia",
    subcountry: "Tukums Municipality",
    geonameid: 454768,
  },
  {
    name: "Salaspils",
    country: "Latvia",
    subcountry: "Salaspils Municipality",
    geonameid: 455898,
  },
  {
    name: "Riga",
    country: "Latvia",
    subcountry: "Riga",
    geonameid: 456172,
  },
  {
    name: "Rēzekne",
    country: "Latvia",
    subcountry: "Rēzekne",
    geonameid: 456202,
  },
  {
    name: "Ogre",
    country: "Latvia",
    subcountry: "Ogre",
    geonameid: 457065,
  },
  {
    name: "Liepāja",
    country: "Latvia",
    subcountry: "Liepāja",
    geonameid: 457954,
  },
  {
    name: "Jūrmala",
    country: "Latvia",
    subcountry: "Jūrmala",
    geonameid: 459201,
  },
  {
    name: "Jelgava",
    country: "Latvia",
    subcountry: "Jelgava",
    geonameid: 459279,
  },
  {
    name: "Jēkabpils",
    country: "Latvia",
    subcountry: "Jēkabpils Municipality",
    geonameid: 459283,
  },
  {
    name: "Daugavpils",
    country: "Latvia",
    subcountry: "Daugavpils",
    geonameid: 460413,
  },
  {
    name: "Dārzciems",
    country: "Latvia",
    subcountry: "Alūksne Municipality",
    geonameid: 460433,
  },
  {
    name: "Cēsis",
    country: "Latvia",
    subcountry: "Cēsis Municipality",
    geonameid: 460570,
  },
  {
    name: "Tobruk",
    country: "Libya",
    subcountry: "Al Buţnān",
    geonameid: 81302,
  },
  {
    name: "Qaryat Sulūq",
    country: "Libya",
    subcountry: "Banghāzī",
    geonameid: 81604,
  },
  {
    name: "Darnah",
    country: "Libya",
    subcountry: "Darnah",
    geonameid: 87205,
  },
  {
    name: "Benghazi",
    country: "Libya",
    subcountry: "Banghāzī",
    geonameid: 88319,
  },
  {
    name: "Az Zuwaytīnah",
    country: "Libya",
    subcountry: "Al Wāḩāt",
    geonameid: 88380,
  },
  {
    name: "At Tāj",
    country: "Libya",
    subcountry: "Al Kufrah",
    geonameid: 88562,
  },
  {
    name: "Tūkrah",
    country: "Libya",
    subcountry: "Al Marj",
    geonameid: 88834,
  },
  {
    name: "Al Qubbah",
    country: "Libya",
    subcountry: "Darnah",
    geonameid: 88835,
  },
  {
    name: "Al Marj",
    country: "Libya",
    subcountry: "Al Marj",
    geonameid: 88903,
  },
  {
    name: "Al Jawf",
    country: "Libya",
    subcountry: "Al Kufrah",
    geonameid: 88962,
  },
  {
    name: "Al Bayḑā’",
    country: "Libya",
    subcountry: "Al Jabal al Akhḑar",
    geonameid: 89055,
  },
  {
    name: "Al Abyār",
    country: "Libya",
    subcountry: "Al Marj",
    geonameid: 89087,
  },
  {
    name: "Ajdabiya",
    country: "Libya",
    subcountry: "Al Wāḩāt",
    geonameid: 89113,
  },
  {
    name: "Zuwārah",
    country: "Libya",
    subcountry: "An Nuqāţ al Khams",
    geonameid: 2208425,
  },
  {
    name: "Zliten",
    country: "Libya",
    subcountry: "Mişrātah",
    geonameid: 2208485,
  },
  {
    name: "Zalţan",
    country: "Libya",
    subcountry: "An Nuqāţ al Khams",
    geonameid: 2208655,
  },
  {
    name: "Yafran",
    country: "Libya",
    subcountry: "Jabal al Gharbi",
    geonameid: 2208791,
  },
  {
    name: "Waddān",
    country: "Libya",
    subcountry: "Al Jufrah",
    geonameid: 2209055,
  },
  {
    name: "Tarhuna",
    country: "Libya",
    subcountry: "Al Marqab",
    geonameid: 2210221,
  },
  {
    name: "Tripoli",
    country: "Libya",
    subcountry: "Tripoli",
    geonameid: 2210247,
  },
  {
    name: "Tājūrā’",
    country: "Libya",
    subcountry: "Tripoli",
    geonameid: 2210394,
  },
  {
    name: "Sirte",
    country: "Libya",
    subcountry: "Surt",
    geonameid: 2210554,
  },
  {
    name: "Şurmān",
    country: "Libya",
    subcountry: "Az Zāwiyah",
    geonameid: 2210560,
  },
  {
    name: "Şabrātah",
    country: "Libya",
    subcountry: "Az Zāwiyah",
    geonameid: 2212771,
  },
  {
    name: "Sabhā",
    country: "Libya",
    subcountry: "Sabhā",
    geonameid: 2212775,
  },
  {
    name: "Nālūt",
    country: "Libya",
    subcountry: "Nālūt",
    geonameid: 2214433,
  },
  {
    name: "Murzuq",
    country: "Libya",
    subcountry: "Murzuq",
    geonameid: 2214603,
  },
  {
    name: "Mizdah",
    country: "Libya",
    subcountry: "Jabal al Gharbi",
    geonameid: 2214827,
  },
  {
    name: "Mişrātah",
    country: "Libya",
    subcountry: "Mişrātah",
    geonameid: 2214846,
  },
  {
    name: "Masallātah",
    country: "Libya",
    subcountry: "Al Marqab",
    geonameid: 2215163,
  },
  {
    name: "Hūn",
    country: "Libya",
    subcountry: "Al Jufrah",
    geonameid: 2216645,
  },
  {
    name: "Zawiya",
    country: "Libya",
    subcountry: "Az Zāwiyah",
    geonameid: 2216885,
  },
  {
    name: "Ghat",
    country: "Libya",
    subcountry: "Ghāt",
    geonameid: 2217351,
  },
  {
    name: "Gharyan",
    country: "Libya",
    subcountry: "Jabal al Gharbi",
    geonameid: 2217362,
  },
  {
    name: "Brak",
    country: "Libya",
    subcountry: "Ash Shāţiʼ",
    geonameid: 2218478,
  },
  {
    name: "Bani Walid",
    country: "Libya",
    subcountry: "Mişrātah",
    geonameid: 2218840,
  },
  {
    name: "Zintan",
    country: "Libya",
    subcountry: "Jabal al Gharbi",
    geonameid: 2218963,
  },
  {
    name: "Az Zāwīyah",
    country: "Libya",
    subcountry: "Az Zāwiyah",
    geonameid: 2218970,
  },
  {
    name: "Ubari",
    country: "Libya",
    subcountry: "Wādī al Ḩayāt",
    geonameid: 2219235,
  },
  {
    name: "Al Ajaylat",
    country: "Libya",
    subcountry: "An Nuqāţ al Khams",
    geonameid: 2219701,
  },
  {
    name: "Al Khums",
    country: "Libya",
    subcountry: "Al Marqab",
    geonameid: 2219905,
  },
  {
    name: "Al Jumayl",
    country: "Libya",
    subcountry: "An Nuqāţ al Khams",
    geonameid: 2219936,
  },
  {
    name: "Al Jadīd",
    country: "Libya",
    subcountry: "Sabhā",
    geonameid: 2219960,
  },
  {
    name: "Smara",
    country: "Morocco",
    subcountry: "Laâyoune-Sakia El Hamra",
    geonameid: 2461874,
  },
  {
    name: "Setti Fatma",
    country: "Morocco",
    subcountry: "Marrakesh-Safi",
    geonameid: 2526239,
  },
  {
    name: "Zaïo",
    country: "Morocco",
    subcountry: "Oriental",
    geonameid: 2526435,
  },
  {
    name: "Zagora",
    country: "Morocco",
    subcountry: "Drâa-Tafilalet",
    geonameid: 2526452,
  },
  {
    name: "Youssoufia",
    country: "Morocco",
    subcountry: "Marrakesh-Safi",
    geonameid: 2526488,
  },
  {
    name: "Tiznit",
    country: "Morocco",
    subcountry: "Souss-Massa",
    geonameid: 2527089,
  },
  {
    name: "Tirhanimîne",
    country: "Morocco",
    subcountry: "Tanger-Tetouan-Al Hoceima",
    geonameid: 2527645,
  },
  {
    name: "Tinghir",
    country: "Morocco",
    subcountry: "Drâa-Tafilalet",
    geonameid: 2527915,
  },
  {
    name: "Tiflet",
    country: "Morocco",
    subcountry: "Rabat-Salé-Kénitra",
    geonameid: 2528659,
  },
  {
    name: "Tétouan",
    country: "Morocco",
    subcountry: "Tanger-Tetouan-Al Hoceima",
    geonameid: 2528910,
  },
  {
    name: "Temara",
    country: "Morocco",
    subcountry: "Rabat-Salé-Kénitra",
    geonameid: 2529013,
  },
  {
    name: "Taza",
    country: "Morocco",
    subcountry: "Fès-Meknès",
    geonameid: 2529317,
  },
  {
    name: "Taroudant",
    country: "Morocco",
    subcountry: "Souss-Massa",
    geonameid: 2529649,
  },
  {
    name: "Taourirt",
    country: "Morocco",
    subcountry: "Oriental",
    geonameid: 2530048,
  },
  {
    name: "Taounate",
    country: "Morocco",
    subcountry: "Fès-Meknès",
    geonameid: 2530155,
  },
  {
    name: "Tan-Tan",
    country: "Morocco",
    subcountry: "Guelmim-Oued Noun",
    geonameid: 2530241,
  },
  {
    name: "Tangier",
    country: "Morocco",
    subcountry: "Tanger-Tetouan-Al Hoceima",
    geonameid: 2530335,
  },
  {
    name: "Tahla",
    country: "Morocco",
    subcountry: "Fès-Meknès",
    geonameid: 2531480,
  },
  {
    name: "Souq Larb’a al Gharb",
    country: "Morocco",
    subcountry: "Rabat-Salé-Kénitra",
    geonameid: 2532394,
  },
  {
    name: "Sidi Yahia El Gharb",
    country: "Morocco",
    subcountry: "Rabat-Salé-Kénitra",
    geonameid: 2532822,
  },
  {
    name: "Sidi Slimane",
    country: "Morocco",
    subcountry: "Rabat-Salé-Kénitra",
    geonameid: 2532945,
  },
  {
    name: "Sidi Qacem",
    country: "Morocco",
    subcountry: "Rabat-Salé-Kénitra",
    geonameid: 2533191,
  },
  {
    name: "Sidi Ifni",
    country: "Morocco",
    subcountry: "Souss-Massa",
    geonameid: 2534515,
  },
  {
    name: "Sidi Bennour",
    country: "Morocco",
    subcountry: "Casablanca-Settat",
    geonameid: 2536074,
  },
  {
    name: "Settat",
    country: "Morocco",
    subcountry: "Casablanca-Settat",
    geonameid: 2537406,
  },
  {
    name: "Sefrou",
    country: "Morocco",
    subcountry: "Fès-Meknès",
    geonameid: 2537545,
  },
  {
    name: "Sale",
    country: "Morocco",
    subcountry: "Rabat-Salé-Kénitra",
    geonameid: 2537763,
  },
  {
    name: "Safi",
    country: "Morocco",
    subcountry: "Marrakesh-Safi",
    geonameid: 2537881,
  },
  {
    name: "Reçani",
    country: "Morocco",
    subcountry: "Drâa-Tafilalet",
    geonameid: 2538027,
  },
  {
    name: "Rabat",
    country: "Morocco",
    subcountry: "Rabat-Salé-Kénitra",
    geonameid: 2538475,
  },
  {
    name: "Oulmes",
    country: "Morocco",
    subcountry: "Rabat-Salé-Kénitra",
    geonameid: 2538898,
  },
  {
    name: "Oulad Teïma",
    country: "Morocco",
    subcountry: "Souss-Massa",
    geonameid: 2539134,
  },
  {
    name: "Oujda-Angad",
    country: "Morocco",
    subcountry: "Oriental",
    geonameid: 2540483,
  },
  {
    name: "Oued Zem",
    country: "Morocco",
    subcountry: "Béni Mellal-Khénifra",
    geonameid: 2540689,
  },
  {
    name: "Ouezzane",
    country: "Morocco",
    subcountry: "Tanger-Tetouan-Al Hoceima",
    geonameid: 2540810,
  },
  {
    name: "Ouarzazat",
    country: "Morocco",
    subcountry: "Drâa-Tafilalet",
    geonameid: 2540850,
  },
  {
    name: "Nador",
    country: "Morocco",
    subcountry: "Oriental",
    geonameid: 2541479,
  },
  {
    name: "Al Aaroui",
    country: "Morocco",
    subcountry: "Oriental",
    geonameid: 2542013,
  },
  {
    name: "Mohammedia",
    country: "Morocco",
    subcountry: "Casablanca-Settat",
    geonameid: 2542051,
  },
  {
    name: "Midelt",
    country: "Morocco",
    subcountry: "Béni Mellal-Khénifra",
    geonameid: 2542227,
  },
  {
    name: "Meknès",
    country: "Morocco",
    subcountry: "Fès-Meknès",
    geonameid: 2542715,
  },
  {
    name: "Mechraa Bel Ksiri",
    country: "Morocco",
    subcountry: "Rabat-Salé-Kénitra",
    geonameid: 2542866,
  },
  {
    name: "Martil",
    country: "Morocco",
    subcountry: "Tanger-Tetouan-Al Hoceima",
    geonameid: 2542987,
  },
  {
    name: "Marrakesh",
    country: "Morocco",
    subcountry: "Marrakesh-Safi",
    geonameid: 2542997,
  },
  {
    name: "Larache",
    country: "Morocco",
    subcountry: "Tanger-Tetouan-Al Hoceima",
    geonameid: 2543549,
  },
  {
    name: "Ksar El Kebir",
    country: "Morocco",
    subcountry: "Tanger-Tetouan-Al Hoceima",
    geonameid: 2544001,
  },
  {
    name: "Khouribga",
    country: "Morocco",
    subcountry: "Béni Mellal-Khénifra",
    geonameid: 2544248,
  },
  {
    name: "Khenifra",
    country: "Morocco",
    subcountry: "Béni Mellal-Khénifra",
    geonameid: 2544333,
  },
  {
    name: "Kenitra",
    country: "Morocco",
    subcountry: "Rabat-Salé-Kénitra",
    geonameid: 2544571,
  },
  {
    name: "Kasba Tadla",
    country: "Morocco",
    subcountry: "Béni Mellal-Khénifra",
    geonameid: 2544720,
  },
  {
    name: "Jerada",
    country: "Morocco",
    subcountry: "Oriental",
    geonameid: 2545017,
  },
  {
    name: "Ifrane",
    country: "Morocco",
    subcountry: "Fès-Meknès",
    geonameid: 2546917,
  },
  {
    name: "Guercif",
    country: "Morocco",
    subcountry: "Fès-Meknès",
    geonameid: 2548489,
  },
  {
    name: "Guelmim",
    country: "Morocco",
    subcountry: "Guelmim-Oued Noun",
    geonameid: 2548526,
  },
  {
    name: "Fnidek",
    country: "Morocco",
    subcountry: "Tanger-Tetouan-Al Hoceima",
    geonameid: 2548818,
  },
  {
    name: "Al Fqih Ben Çalah",
    country: "Morocco",
    subcountry: "Béni Mellal-Khénifra",
    geonameid: 2548830,
  },
  {
    name: "Fès al Bali",
    country: "Morocco",
    subcountry: "Fès-Meknès",
    geonameid: 2548880,
  },
  {
    name: "Fès",
    country: "Morocco",
    subcountry: "Fès-Meknès",
    geonameid: 2548885,
  },
  {
    name: "Essaouira",
    country: "Morocco",
    subcountry: "Marrakesh-Safi",
    geonameid: 2549263,
  },
  {
    name: "Arfoud",
    country: "Morocco",
    subcountry: "Drâa-Tafilalet",
    geonameid: 2549356,
  },
  {
    name: "El Jadid",
    country: "Morocco",
    subcountry: "Casablanca-Settat",
    geonameid: 2550078,
  },
  {
    name: "El Hajeb",
    country: "Morocco",
    subcountry: "Fès-Meknès",
    geonameid: 2550252,
  },
  {
    name: "El Aïoun",
    country: "Morocco",
    subcountry: "Oriental",
    geonameid: 2550806,
  },
  {
    name: "Imzouren",
    country: "Morocco",
    subcountry: "Tanger-Tetouan-Al Hoceima",
    geonameid: 2550898,
  },
  {
    name: "Chefchaouen",
    country: "Morocco",
    subcountry: "Tanger-Tetouan-Al Hoceima",
    geonameid: 2553455,
  },
  {
    name: "Casablanca",
    country: "Morocco",
    subcountry: "Casablanca-Settat",
    geonameid: 2553604,
  },
  {
    name: "Bouznika",
    country: "Morocco",
    subcountry: "Casablanca-Settat",
    geonameid: 2553751,
  },
  {
    name: "Bouarfa",
    country: "Morocco",
    subcountry: "Oriental",
    geonameid: 2555157,
  },
  {
    name: "Berkane",
    country: "Morocco",
    subcountry: "Oriental",
    geonameid: 2555467,
  },
  {
    name: "Beni Mellal",
    country: "Morocco",
    subcountry: "Béni Mellal-Khénifra",
    geonameid: 2555745,
  },
  {
    name: "Berrechid",
    country: "Morocco",
    subcountry: "Casablanca-Settat",
    geonameid: 2556272,
  },
  {
    name: "Azrou",
    country: "Morocco",
    subcountry: "Fès-Meknès",
    geonameid: 2556464,
  },
  {
    name: "Azemmour",
    country: "Morocco",
    subcountry: "Casablanca-Settat",
    geonameid: 2556657,
  },
  {
    name: "Asilah",
    country: "Morocco",
    subcountry: "Tanger-Tetouan-Al Hoceima",
    geonameid: 2557055,
  },
  {
    name: "Khemisset",
    country: "Morocco",
    subcountry: "Rabat-Salé-Kénitra",
    geonameid: 2558470,
  },
  {
    name: "Al Hoceïma",
    country: "Morocco",
    subcountry: "Tanger-Tetouan-Al Hoceima",
    geonameid: 2558545,
  },
  {
    name: "Aïn Beni Mathar",
    country: "Morocco",
    subcountry: "Oriental",
    geonameid: 2560922,
  },
  {
    name: "Ahfir",
    country: "Morocco",
    subcountry: "Oriental",
    geonameid: 2561124,
  },
  {
    name: "Agadir",
    country: "Morocco",
    subcountry: "Souss-Massa",
    geonameid: 2561668,
  },
  {
    name: "Skhirate",
    country: "Morocco",
    subcountry: "Rabat-Salé-Kénitra",
    geonameid: 2562055,
  },
  {
    name: "Boujniba",
    country: "Morocco",
    subcountry: "Béni Mellal-Khénifra",
    geonameid: 6546693,
  },
  {
    name: "Errachidia",
    country: "Morocco",
    subcountry: "Drâa-Tafilalet",
    geonameid: 7280528,
  },
  {
    name: "Dakhla",
    country: "Morocco",
    subcountry: "Souss-Massa",
    geonameid: 8542188,
  },
  {
    name: "Salé Al Jadida",
    country: "Morocco",
    subcountry: "Rabat-Salé-Kénitra",
    geonameid: 10920963,
  },
  {
    name: "Bni Bouayach",
    country: "Morocco",
    subcountry: "Tanger-Tetouan-Al Hoceima",
    geonameid: 10958491,
  },
  {
    name: "Monte-Carlo",
    country: "Monaco",
    subcountry: "Municipality of Monaco",
    geonameid: 2992741,
  },
  {
    name: "Monaco",
    country: "Monaco",
    subcountry: "Municipality of Monaco",
    geonameid: 2993458,
  },
  {
    name: "Edineţ",
    country: "Moldova",
    subcountry: "Raionul Edineţ",
    geonameid: 617076,
  },
  {
    name: "Ungheni",
    country: "Moldova",
    subcountry: "Ungheni",
    geonameid: 617180,
  },
  {
    name: "Tiraspol",
    country: "Moldova",
    subcountry: "Transnistria",
    geonameid: 617239,
  },
  {
    name: "Strășeni",
    country: "Moldova",
    subcountry: "Strășeni",
    geonameid: 617302,
  },
  {
    name: "Bilicenii Vechi",
    country: "Moldova",
    subcountry: "Sîngerei",
    geonameid: 617345,
  },
  {
    name: "Soroca",
    country: "Moldova",
    subcountry: "Raionul Soroca",
    geonameid: 617367,
  },
  {
    name: "Slobozia",
    country: "Moldova",
    subcountry: "Transnistria",
    geonameid: 617381,
  },
  {
    name: "Rîbniţa",
    country: "Moldova",
    subcountry: "Transnistria",
    geonameid: 617486,
  },
  {
    name: "Orhei",
    country: "Moldova",
    subcountry: "Orhei",
    geonameid: 617638,
  },
  {
    name: "Hînceşti",
    country: "Moldova",
    subcountry: "Hînceşti",
    geonameid: 617993,
  },
  {
    name: "Codru",
    country: "Moldova",
    subcountry: "Chișinău Municipality",
    geonameid: 618054,
  },
  {
    name: "Căuşeni",
    country: "Moldova",
    subcountry: "Căuşeni",
    geonameid: 618120,
  },
  {
    name: "Floreşti",
    country: "Moldova",
    subcountry: "Floreşti",
    geonameid: 618329,
  },
  {
    name: "Dubăsari",
    country: "Moldova",
    subcountry: "Transnistria",
    geonameid: 618365,
  },
  {
    name: "Drochia",
    country: "Moldova",
    subcountry: "Drochia",
    geonameid: 618370,
  },
  {
    name: "Comrat",
    country: "Moldova",
    subcountry: "Găgăuzia",
    geonameid: 618405,
  },
  {
    name: "Chisinau",
    country: "Moldova",
    subcountry: "Chișinău Municipality",
    geonameid: 618426,
  },
  {
    name: "Ceadîr-Lunga",
    country: "Moldova",
    subcountry: "Găgăuzia",
    geonameid: 618450,
  },
  {
    name: "Cahul",
    country: "Moldova",
    subcountry: "Cahul",
    geonameid: 618456,
  },
  {
    name: "Bender",
    country: "Moldova",
    subcountry: "Bender Municipality",
    geonameid: 618577,
  },
  {
    name: "Bălţi",
    country: "Moldova",
    subcountry: "Bălţi",
    geonameid: 618605,
  },
  {
    name: "Podgorica",
    country: "Montenegro",
    subcountry: "Podgorica",
    geonameid: 3193044,
  },
  {
    name: "Pljevlja",
    country: "Montenegro",
    subcountry: "Pljevlja",
    geonameid: 3193161,
  },
  {
    name: "Nikšić",
    country: "Montenegro",
    subcountry: "Opština Nikšić",
    geonameid: 3194494,
  },
  {
    name: "Herceg Novi",
    country: "Montenegro",
    subcountry: "Herceg Novi",
    geonameid: 3199394,
  },
  {
    name: "Cetinje",
    country: "Montenegro",
    subcountry: "Cetinje",
    geonameid: 3202641,
  },
  {
    name: "Budva",
    country: "Montenegro",
    subcountry: "Budva",
    geonameid: 3203106,
  },
  {
    name: "Bijelo Polje",
    country: "Montenegro",
    subcountry: "Bijelo Polje",
    geonameid: 3204176,
  },
  {
    name: "Bar",
    country: "Montenegro",
    subcountry: "Bar",
    geonameid: 3204509,
  },
  {
    name: "Marigot",
    country: "Saint Martin",
    subcountry: "N/A",
    geonameid: 3578851,
  },
  {
    name: "Toamasina",
    country: "Madagascar",
    subcountry: "Atsinanana",
    geonameid: 1053384,
  },
  {
    name: "Vondrozo",
    country: "Madagascar",
    subcountry: "Atsimo-Atsinanana",
    geonameid: 1053507,
  },
  {
    name: "Vohipaho",
    country: "Madagascar",
    subcountry: "Atsimo-Atsinanana",
    geonameid: 1053778,
  },
  {
    name: "Vohibinany",
    country: "Madagascar",
    subcountry: "Atsinanana",
    geonameid: 1054035,
  },
  {
    name: "Vavatenina",
    country: "Madagascar",
    subcountry: "Analanjirofo",
    geonameid: 1054192,
  },
  {
    name: "Vangaindrano",
    country: "Madagascar",
    subcountry: "Atsimo-Atsinanana",
    geonameid: 1054329,
  },
  {
    name: "Tsiroanomandidy",
    country: "Madagascar",
    subcountry: "Bongolava",
    geonameid: 1054463,
  },
  {
    name: "Tsiombe",
    country: "Madagascar",
    subcountry: "Androy",
    geonameid: 1054500,
  },
  {
    name: "Tsaratanana",
    country: "Madagascar",
    subcountry: "Betsiboka",
    geonameid: 1055059,
  },
  {
    name: "Toliara",
    country: "Madagascar",
    subcountry: "Atsimo-Andrefana",
    geonameid: 1055429,
  },
  {
    name: "Tôlanaro",
    country: "Madagascar",
    subcountry: "Anosy",
    geonameid: 1055433,
  },
  {
    name: "Soavinandriana",
    country: "Madagascar",
    subcountry: "Itasy",
    geonameid: 1056151,
  },
  {
    name: "Soanindrariny",
    country: "Madagascar",
    subcountry: "Vakinankaratra",
    geonameid: 1056381,
  },
  {
    name: "Soanierana Ivongo",
    country: "Madagascar",
    subcountry: "Analanjirofo",
    geonameid: 1056386,
  },
  {
    name: "Sitampiky",
    country: "Madagascar",
    subcountry: "Boeny",
    geonameid: 1056531,
  },
  {
    name: "Sambava",
    country: "Madagascar",
    subcountry: "Sava",
    geonameid: 1056899,
  },
  {
    name: "Sakaraha",
    country: "Madagascar",
    subcountry: "Atsimo-Andrefana",
    geonameid: 1057095,
  },
  {
    name: "Sahavato",
    country: "Madagascar",
    subcountry: "Vatovavy Region",
    geonameid: 1057277,
  },
  {
    name: "Sadabe",
    country: "Madagascar",
    subcountry: "Analamanga",
    geonameid: 1057688,
  },
  {
    name: "Nosy Varika",
    country: "Madagascar",
    subcountry: "Vatovavy Region",
    geonameid: 1058080,
  },
  {
    name: "Morondava",
    country: "Madagascar",
    subcountry: "Menabe",
    geonameid: 1058381,
  },
  {
    name: "Moramanga",
    country: "Madagascar",
    subcountry: "Alaotra Mangoro",
    geonameid: 1058532,
  },
  {
    name: "Miandrivazo",
    country: "Madagascar",
    subcountry: "Menabe",
    geonameid: 1059051,
  },
  {
    name: "Miandrarivo",
    country: "Madagascar",
    subcountry: "Vakinankaratra",
    geonameid: 1059059,
  },
  {
    name: "Marovoay",
    country: "Madagascar",
    subcountry: "Boeny",
    geonameid: 1059507,
  },
  {
    name: "Marolambo",
    country: "Madagascar",
    subcountry: "Atsinanana",
    geonameid: 1060007,
  },
  {
    name: "Maroantsetra",
    country: "Madagascar",
    subcountry: "Analanjirofo",
    geonameid: 1060283,
  },
  {
    name: "Manjakandriana",
    country: "Madagascar",
    subcountry: "Analamanga",
    geonameid: 1060673,
  },
  {
    name: "Mananjary",
    country: "Madagascar",
    subcountry: "Vatovavy Region",
    geonameid: 1061335,
  },
  {
    name: "Mananara",
    country: "Madagascar",
    subcountry: "Analanjirofo",
    geonameid: 1061412,
  },
  {
    name: "Manakara",
    country: "Madagascar",
    subcountry: "Fitovinany Region",
    geonameid: 1061605,
  },
  {
    name: "Maintirano",
    country: "Madagascar",
    subcountry: "Melaky",
    geonameid: 1061912,
  },
  {
    name: "Mahanoro",
    country: "Madagascar",
    subcountry: "Atsinanana",
    geonameid: 1062553,
  },
  {
    name: "Mahajanga",
    country: "Madagascar",
    subcountry: "Boeny",
    geonameid: 1062663,
  },
  {
    name: "Maevatanana",
    country: "Madagascar",
    subcountry: "Betsiboka",
    geonameid: 1062842,
  },
  {
    name: "Ikongo",
    country: "Madagascar",
    subcountry: "Fitovinany Region",
    geonameid: 1064234,
  },
  {
    name: "Ikalamavony",
    country: "Madagascar",
    subcountry: "Upper Matsiatra",
    geonameid: 1064258,
  },
  {
    name: "Ihosy",
    country: "Madagascar",
    subcountry: "Ihorombe",
    geonameid: 1064275,
  },
  {
    name: "Ifanadiana",
    country: "Madagascar",
    subcountry: "Vatovavy Region",
    geonameid: 1064366,
  },
  {
    name: "Fianarantsoa",
    country: "Madagascar",
    subcountry: "Upper Matsiatra",
    geonameid: 1064890,
  },
  {
    name: "Fenoarivo Be",
    country: "Madagascar",
    subcountry: "Bongolava",
    geonameid: 1064978,
  },
  {
    name: "Fenoarivo Atsinanana",
    country: "Madagascar",
    subcountry: "Analanjirofo",
    geonameid: 1064980,
  },
  {
    name: "Faratsiho",
    country: "Madagascar",
    subcountry: "Vakinankaratra",
    geonameid: 1065140,
  },
  {
    name: "Farafangana",
    country: "Madagascar",
    subcountry: "Atsimo-Atsinanana",
    geonameid: 1065158,
  },
  {
    name: "Fandriana",
    country: "Madagascar",
    subcountry: "Amoron'i Mania",
    geonameid: 1065222,
  },
  {
    name: "Betioky",
    country: "Madagascar",
    subcountry: "Atsimo-Andrefana",
    geonameid: 1066310,
  },
  {
    name: "Betafo",
    country: "Madagascar",
    subcountry: "Vakinankaratra",
    geonameid: 1066514,
  },
  {
    name: "Beroroha",
    country: "Madagascar",
    subcountry: "Atsimo-Andrefana",
    geonameid: 1066831,
  },
  {
    name: "Belo sur Tsiribihina",
    country: "Madagascar",
    subcountry: "Menabe",
    geonameid: 1067531,
  },
  {
    name: "Beloha",
    country: "Madagascar",
    subcountry: "Androy",
    geonameid: 1067565,
  },
  {
    name: "Bealanana",
    country: "Madagascar",
    subcountry: "Sofia",
    geonameid: 1068670,
  },
  {
    name: "Arivonimamo",
    country: "Madagascar",
    subcountry: "Itasy",
    geonameid: 1068865,
  },
  {
    name: "Antsohimbondrona",
    country: "Madagascar",
    subcountry: "Diana",
    geonameid: 1068955,
  },
  {
    name: "Antsohihy",
    country: "Madagascar",
    subcountry: "Sofia",
    geonameid: 1068971,
  },
  {
    name: "Antsiranana",
    country: "Madagascar",
    subcountry: "Diana",
    geonameid: 1069129,
  },
  {
    name: "Antsirabe",
    country: "Madagascar",
    subcountry: "Vakinankaratra",
    geonameid: 1069166,
  },
  {
    name: "Antanifotsy",
    country: "Madagascar",
    subcountry: "Vakinankaratra",
    geonameid: 1070661,
  },
  {
    name: "Antananarivo",
    country: "Madagascar",
    subcountry: "Analamanga",
    geonameid: 1070940,
  },
  {
    name: "Antalaha",
    country: "Madagascar",
    subcountry: "Sava",
    geonameid: 1071296,
  },
  {
    name: "Ankazondandy",
    country: "Madagascar",
    subcountry: "Analamanga",
    geonameid: 1072711,
  },
  {
    name: "Ankazobe",
    country: "Madagascar",
    subcountry: "Analamanga",
    geonameid: 1072849,
  },
  {
    name: "Ankazoabo",
    country: "Madagascar",
    subcountry: "Atsimo-Andrefana",
    geonameid: 1072879,
  },
  {
    name: "Anjozorobe",
    country: "Madagascar",
    subcountry: "Analamanga",
    geonameid: 1073482,
  },
  {
    name: "Hell-Ville",
    country: "Madagascar",
    subcountry: "Diana",
    geonameid: 1076105,
  },
  {
    name: "Andilamena",
    country: "Madagascar",
    subcountry: "Alaotra Mangoro",
    geonameid: 1076194,
  },
  {
    name: "Andapa",
    country: "Madagascar",
    subcountry: "Sava",
    geonameid: 1076454,
  },
  {
    name: "Ampasimanolotra",
    country: "Madagascar",
    subcountry: "Atsinanana",
    geonameid: 1078171,
  },
  {
    name: "Amparafaravola",
    country: "Madagascar",
    subcountry: "Alaotra Mangoro",
    geonameid: 1078446,
  },
  {
    name: "Ampanihy",
    country: "Madagascar",
    subcountry: "Atsimo-Andrefana",
    geonameid: 1078553,
  },
  {
    name: "Ampahana",
    country: "Madagascar",
    subcountry: "Sava",
    geonameid: 1078966,
  },
  {
    name: "Ambovombe",
    country: "Madagascar",
    subcountry: "Androy",
    geonameid: 1079048,
  },
  {
    name: "Ambositra",
    country: "Madagascar",
    subcountry: "Amoron'i Mania",
    geonameid: 1079088,
  },
  {
    name: "Ambohitrolomahitsy",
    country: "Madagascar",
    subcountry: "Analamanga",
    geonameid: 1079777,
  },
  {
    name: "Amboasary",
    country: "Madagascar",
    subcountry: "Anosy",
    geonameid: 1081790,
  },
  {
    name: "Amboanjo",
    country: "Madagascar",
    subcountry: "Fitovinany Region",
    geonameid: 1081863,
  },
  {
    name: "Ambilobe",
    country: "Madagascar",
    subcountry: "Diana",
    geonameid: 1082243,
  },
  {
    name: "Ambatondrazaka",
    country: "Madagascar",
    subcountry: "Alaotra Mangoro",
    geonameid: 1082639,
  },
  {
    name: "Ambatolampy",
    country: "Madagascar",
    subcountry: "Vakinankaratra",
    geonameid: 1082992,
  },
  {
    name: "Ambatofinandrahana",
    country: "Madagascar",
    subcountry: "Amoron'i Mania",
    geonameid: 1083239,
  },
  {
    name: "Ambato Boeny",
    country: "Madagascar",
    subcountry: "Boeny",
    geonameid: 1083257,
  },
  {
    name: "Ambarakaraka",
    country: "Madagascar",
    subcountry: "Diana",
    geonameid: 1083676,
  },
  {
    name: "Ambanja",
    country: "Madagascar",
    subcountry: "Diana",
    geonameid: 1083724,
  },
  {
    name: "Ambalavao",
    country: "Madagascar",
    subcountry: "Upper Matsiatra",
    geonameid: 1083968,
  },
  {
    name: "Alarobia",
    country: "Madagascar",
    subcountry: "Analamanga",
    geonameid: 1084740,
  },
  {
    name: "Majuro",
    country: "Marshall Islands",
    subcountry: "Majuro Atoll",
    geonameid: 2113779,
  },
  {
    name: "RMI Capitol",
    country: "Marshall Islands",
    subcountry: "Majuro Atoll",
    geonameid: 7874852,
  },
  {
    name: "Zelino",
    country: "North Macedonia",
    subcountry: "Zhelino",
    geonameid: 783926,
  },
  {
    name: "Vinica",
    country: "North Macedonia",
    subcountry: "Vinica",
    geonameid: 784424,
  },
  {
    name: "Veles",
    country: "North Macedonia",
    subcountry: "Veles",
    geonameid: 785058,
  },
  {
    name: "Tetovo",
    country: "North Macedonia",
    subcountry: "Tetovo",
    geonameid: 785082,
  },
  {
    name: "Tearce",
    country: "North Macedonia",
    subcountry: "Tearce",
    geonameid: 785113,
  },
  {
    name: "Studeničani",
    country: "North Macedonia",
    subcountry: "Studenichani",
    geonameid: 785345,
  },
  {
    name: "Strumica",
    country: "North Macedonia",
    subcountry: "Strumica",
    geonameid: 785380,
  },
  {
    name: "Struga",
    country: "North Macedonia",
    subcountry: "Struga",
    geonameid: 785387,
  },
  {
    name: "Shtip",
    country: "North Macedonia",
    subcountry: "Shtip",
    geonameid: 785482,
  },
  {
    name: "Skopje",
    country: "North Macedonia",
    subcountry: "Grad Skopje",
    geonameid: 785842,
  },
  {
    name: "Saraj",
    country: "North Macedonia",
    subcountry: "Grad Skopje",
    geonameid: 786093,
  },
  {
    name: "Resen",
    country: "North Macedonia",
    subcountry: "Resen",
    geonameid: 786341,
  },
  {
    name: "Radovis",
    country: "North Macedonia",
    subcountry: "Radovish",
    geonameid: 786565,
  },
  {
    name: "Prilep",
    country: "North Macedonia",
    subcountry: "Prilep",
    geonameid: 786735,
  },
  {
    name: "Ohrid",
    country: "North Macedonia",
    subcountry: "Ohrid",
    geonameid: 787487,
  },
  {
    name: "Negotino",
    country: "North Macedonia",
    subcountry: "Vrapchishte",
    geonameid: 787715,
  },
  {
    name: "Negotino",
    country: "North Macedonia",
    subcountry: "Negotino",
    geonameid: 787716,
  },
  {
    name: "Lipkovo",
    country: "North Macedonia",
    subcountry: "Lipkovo",
    geonameid: 788654,
  },
  {
    name: "Kumanovo",
    country: "North Macedonia",
    subcountry: "Kumanovo",
    geonameid: 788886,
  },
  {
    name: "Kriva Palanka",
    country: "North Macedonia",
    subcountry: "Kriva Palanka",
    geonameid: 789045,
  },
  {
    name: "Kochani",
    country: "North Macedonia",
    subcountry: "Kochani",
    geonameid: 789403,
  },
  {
    name: "Kičevo",
    country: "North Macedonia",
    subcountry: "Kichevo",
    geonameid: 789527,
  },
  {
    name: "Kavadarci",
    country: "North Macedonia",
    subcountry: "Kavadarci",
    geonameid: 789541,
  },
  {
    name: "Kamenjane",
    country: "North Macedonia",
    subcountry: "Bogovinje",
    geonameid: 789611,
  },
  {
    name: "Gostivar",
    country: "North Macedonia",
    subcountry: "Gostivar",
    geonameid: 790295,
  },
  {
    name: "Gevgelija",
    country: "North Macedonia",
    subcountry: "Gevgelija",
    geonameid: 790744,
  },
  {
    name: "Gjorče Petro",
    country: "North Macedonia",
    subcountry: "Grad Skopje",
    geonameid: 791149,
  },
  {
    name: "Delcevo",
    country: "North Macedonia",
    subcountry: "Delchevo",
    geonameid: 791559,
  },
  {
    name: "Debar",
    country: "North Macedonia",
    subcountry: "Debar",
    geonameid: 791606,
  },
  {
    name: "Brvenica",
    country: "North Macedonia",
    subcountry: "Brvenica",
    geonameid: 792227,
  },
  {
    name: "Bogovinje",
    country: "North Macedonia",
    subcountry: "Bogovinje",
    geonameid: 792501,
  },
  {
    name: "Bitola",
    country: "North Macedonia",
    subcountry: "Bitola",
    geonameid: 792578,
  },
  {
    name: "Šuto Orizare",
    country: "North Macedonia",
    subcountry: "Grad Skopje",
    geonameid: 833258,
  },
  {
    name: "Butel",
    country: "North Macedonia",
    subcountry: "Grad Skopje",
    geonameid: 833260,
  },
  {
    name: "Čair",
    country: "North Macedonia",
    subcountry: "Grad Skopje",
    geonameid: 833262,
  },
  {
    name: "Ilinden",
    country: "North Macedonia",
    subcountry: "Ilinden",
    geonameid: 833357,
  },
  {
    name: "Kisela Voda",
    country: "North Macedonia",
    subcountry: "Grad Skopje",
    geonameid: 863675,
  },
  {
    name: "Centar Župa",
    country: "North Macedonia",
    subcountry: "Centar Zhupa",
    geonameid: 7886881,
  },
  {
    name: "Yorosso",
    country: "Mali",
    subcountry: "Sikasso",
    geonameid: 2448442,
  },
  {
    name: "Timbuktu",
    country: "Mali",
    subcountry: "Tombouctou",
    geonameid: 2449067,
  },
  {
    name: "Sikasso",
    country: "Mali",
    subcountry: "Sikasso",
    geonameid: 2451185,
  },
  {
    name: "Ségou",
    country: "Mali",
    subcountry: "Ségou",
    geonameid: 2451478,
  },
  {
    name: "San",
    country: "Mali",
    subcountry: "Ségou",
    geonameid: 2451778,
  },
  {
    name: "Sagalo",
    country: "Mali",
    subcountry: "Kayes",
    geonameid: 2451935,
  },
  {
    name: "Mopti",
    country: "Mali",
    subcountry: "Mopti",
    geonameid: 2453348,
  },
  {
    name: "Markala",
    country: "Mali",
    subcountry: "Ségou",
    geonameid: 2453662,
  },
  {
    name: "Koutiala",
    country: "Mali",
    subcountry: "Sikasso",
    geonameid: 2454268,
  },
  {
    name: "Koulikoro",
    country: "Mali",
    subcountry: "Koulikoro",
    geonameid: 2454530,
  },
  {
    name: "Kolokani",
    country: "Mali",
    subcountry: "Koulikoro",
    geonameid: 2454955,
  },
  {
    name: "Ké-Macina",
    country: "Mali",
    subcountry: "Ségou",
    geonameid: 2455465,
  },
  {
    name: "Kayes",
    country: "Mali",
    subcountry: "Kayes",
    geonameid: 2455518,
  },
  {
    name: "Kati",
    country: "Mali",
    subcountry: "Koulikoro",
    geonameid: 2455558,
  },
  {
    name: "Kangaba",
    country: "Mali",
    subcountry: "Koulikoro",
    geonameid: 2455735,
  },
  { name: "Gao", country: "Mali", subcountry: "Gao", geonameid: 2457163 },
  {
    name: "Djénné",
    country: "Mali",
    subcountry: "Mopti",
    geonameid: 2458589,
  },
  {
    name: "Bougouni",
    country: "Mali",
    subcountry: "Sikasso",
    geonameid: 2459775,
  },
  {
    name: "Banamba",
    country: "Mali",
    subcountry: "Koulikoro",
    geonameid: 2460546,
  },
  {
    name: "Bamako",
    country: "Mali",
    subcountry: "Bamako",
    geonameid: 2460596,
  },
  {
    name: "Bafoulabé",
    country: "Mali",
    subcountry: "Kayes",
    geonameid: 2460755,
  },
  {
    name: "Yenangyaung",
    country: "Myanmar",
    subcountry: "Magway",
    geonameid: 1285173,
  },
  {
    name: "Nyaungdon",
    country: "Myanmar",
    subcountry: "Ayeyarwady",
    geonameid: 1285871,
  },
  {
    name: "Yamethin",
    country: "Myanmar",
    subcountry: "Mandalay",
    geonameid: 1285899,
  },
  {
    name: "Wakema",
    country: "Myanmar",
    subcountry: "Ayeyarwady",
    geonameid: 1289828,
  },
  {
    name: "Twante",
    country: "Myanmar",
    subcountry: "Yangon",
    geonameid: 1290374,
  },
  {
    name: "Taungoo",
    country: "Myanmar",
    subcountry: "Bago",
    geonameid: 1290596,
  },
  {
    name: "Thongwa",
    country: "Myanmar",
    subcountry: "Yangon",
    geonameid: 1291193,
  },
  {
    name: "Thayetmyo",
    country: "Myanmar",
    subcountry: "Magway",
    geonameid: 1292037,
  },
  {
    name: "Thaton",
    country: "Myanmar",
    subcountry: "Mon",
    geonameid: 1292288,
  },
  {
    name: "Tharyarwady",
    country: "Myanmar",
    subcountry: "Bago",
    geonameid: 1292313,
  },
  {
    name: "Thanatpin",
    country: "Myanmar",
    subcountry: "Bago",
    geonameid: 1292579,
  },
  {
    name: "Dawei",
    country: "Myanmar",
    subcountry: "Tanintharyi",
    geonameid: 1293625,
  },
  {
    name: "Taunggyi",
    country: "Myanmar",
    subcountry: "Shan",
    geonameid: 1293960,
  },
  {
    name: "Taungdwingyi",
    country: "Myanmar",
    subcountry: "Magway",
    geonameid: 1294041,
  },
  {
    name: "Tachilek",
    country: "Myanmar",
    subcountry: "Shan",
    geonameid: 1295301,
  },
  {
    name: "Syriam",
    country: "Myanmar",
    subcountry: "Yangon",
    geonameid: 1295395,
  },
  {
    name: "Sittwe",
    country: "Myanmar",
    subcountry: "Rakhine",
    geonameid: 1295765,
  },
  {
    name: "Shwebo",
    country: "Myanmar",
    subcountry: "Sagain",
    geonameid: 1296736,
  },
  {
    name: "Sagaing",
    country: "Myanmar",
    subcountry: "Sagain",
    geonameid: 1298482,
  },
  {
    name: "Yangon",
    country: "Myanmar",
    subcountry: "Yangon",
    geonameid: 1298824,
  },
  {
    name: "Pyu",
    country: "Myanmar",
    subcountry: "Bago",
    geonameid: 1298911,
  },
  {
    name: "Pyinmana",
    country: "Myanmar",
    subcountry: "Nay Pyi Taw",
    geonameid: 1298987,
  },
  {
    name: "Pyay",
    country: "Myanmar",
    subcountry: "Bago",
    geonameid: 1299154,
  },
  {
    name: "Pyapon",
    country: "Myanmar",
    subcountry: "Ayeyarwady",
    geonameid: 1299237,
  },
  {
    name: "Bago",
    country: "Myanmar",
    subcountry: "Bago",
    geonameid: 1300466,
  },
  {
    name: "Paungde",
    country: "Myanmar",
    subcountry: "Bago",
    geonameid: 1300969,
  },
  {
    name: "Pakokku",
    country: "Myanmar",
    subcountry: "Magway",
    geonameid: 1302439,
  },
  {
    name: "Hpa-An",
    country: "Myanmar",
    subcountry: "Kayin",
    geonameid: 1302849,
  },
  {
    name: "Nyaunglebin",
    country: "Myanmar",
    subcountry: "Bago",
    geonameid: 1303406,
  },
  {
    name: "Myitkyina",
    country: "Myanmar",
    subcountry: "Kachin",
    geonameid: 1307741,
  },
  {
    name: "Myingyan",
    country: "Myanmar",
    subcountry: "Mandalay",
    geonameid: 1307835,
  },
  {
    name: "Myawadi",
    country: "Myanmar",
    subcountry: "Kayin",
    geonameid: 1308052,
  },
  {
    name: "Myanaung",
    country: "Myanmar",
    subcountry: "Ayeyarwady",
    geonameid: 1308204,
  },
  {
    name: "Mudon",
    country: "Myanmar",
    subcountry: "Mon",
    geonameid: 1308415,
  },
  {
    name: "Mawlamyinegyunn",
    country: "Myanmar",
    subcountry: "Ayeyarwady",
    geonameid: 1308464,
  },
  {
    name: "Mawlamyine",
    country: "Myanmar",
    subcountry: "Mon",
    geonameid: 1308465,
  },
  {
    name: "Monywa",
    country: "Myanmar",
    subcountry: "Sagain",
    geonameid: 1308522,
  },
  {
    name: "Mogok",
    country: "Myanmar",
    subcountry: "Mandalay",
    geonameid: 1308937,
  },
  {
    name: "Minbu",
    country: "Myanmar",
    subcountry: "Magway",
    geonameid: 1309289,
  },
  {
    name: "Myeik",
    country: "Myanmar",
    subcountry: "Tanintharyi",
    geonameid: 1309611,
  },
  {
    name: "Meiktila",
    country: "Myanmar",
    subcountry: "Mandalay",
    geonameid: 1309793,
  },
  {
    name: "Pyin Oo Lwin",
    country: "Myanmar",
    subcountry: "Mandalay",
    geonameid: 1309937,
  },
  {
    name: "Mawlaik",
    country: "Myanmar",
    subcountry: "Sagain",
    geonameid: 1310120,
  },
  {
    name: "Maubin",
    country: "Myanmar",
    subcountry: "Ayeyarwady",
    geonameid: 1310362,
  },
  {
    name: "Martaban",
    country: "Myanmar",
    subcountry: "Mon",
    geonameid: 1310460,
  },
  {
    name: "Mandalay",
    country: "Myanmar",
    subcountry: "Mandalay",
    geonameid: 1311874,
  },
  {
    name: "Magway",
    country: "Myanmar",
    subcountry: "Magway",
    geonameid: 1312609,
  },
  {
    name: "Loikaw",
    country: "Myanmar",
    subcountry: "Kayah",
    geonameid: 1313479,
  },
  {
    name: "Letpandan",
    country: "Myanmar",
    subcountry: "Bago",
    geonameid: 1314042,
  },
  {
    name: "Lashio",
    country: "Myanmar",
    subcountry: "Shan",
    geonameid: 1314759,
  },
  {
    name: "Kyaukse",
    country: "Myanmar",
    subcountry: "Mandalay",
    geonameid: 1316703,
  },
  {
    name: "Kyaikto",
    country: "Myanmar",
    subcountry: "Mon",
    geonameid: 1317375,
  },
  {
    name: "Kyaiklat",
    country: "Myanmar",
    subcountry: "Ayeyarwady",
    geonameid: 1317397,
  },
  {
    name: "Kyaikkami",
    country: "Myanmar",
    subcountry: "Mon",
    geonameid: 1317402,
  },
  {
    name: "Kēng Tung",
    country: "Myanmar",
    subcountry: "Shan",
    geonameid: 1319364,
  },
  {
    name: "Kayan",
    country: "Myanmar",
    subcountry: "Yangon",
    geonameid: 1319533,
  },
  {
    name: "Kawthoung",
    country: "Myanmar",
    subcountry: "Tanintharyi",
    geonameid: 1319573,
  },
  {
    name: "Kanbe",
    country: "Myanmar",
    subcountry: "Yangon",
    geonameid: 1320944,
  },
  {
    name: "Hinthada",
    country: "Myanmar",
    subcountry: "Ayeyarwady",
    geonameid: 1325211,
  },
  {
    name: "Hakha",
    country: "Myanmar",
    subcountry: "Chin",
    geonameid: 1325443,
  },
  {
    name: "Chauk",
    country: "Myanmar",
    subcountry: "Magway",
    geonameid: 1327659,
  },
  {
    name: "Bogale",
    country: "Myanmar",
    subcountry: "Ayeyarwady",
    geonameid: 1328121,
  },
  {
    name: "Bhamo",
    country: "Myanmar",
    subcountry: "Kachin",
    geonameid: 1328218,
  },
  {
    name: "Pathein",
    country: "Myanmar",
    subcountry: "Ayeyarwady",
    geonameid: 1328421,
  },
  {
    name: "Myaydo",
    country: "Myanmar",
    subcountry: "Magway",
    geonameid: 1329239,
  },
  {
    name: "Nay Pyi Taw",
    country: "Myanmar",
    subcountry: "Nay Pyi Taw",
    geonameid: 6611854,
  },
  {
    name: "Kyain Seikgyi Township",
    country: "Myanmar",
    subcountry: "Kayin",
    geonameid: 11810635,
  },
  {
    name: "Uliastay",
    country: "Mongolia",
    subcountry: "Dzabkhan",
    geonameid: 1515007,
  },
  {
    name: "Ulaangom",
    country: "Mongolia",
    subcountry: "Uvs Province",
    geonameid: 1515029,
  },
  {
    name: "Ölgii",
    country: "Mongolia",
    subcountry: "Bayan-Ölgiy",
    geonameid: 1515436,
  },
  {
    name: "Khovd",
    country: "Mongolia",
    subcountry: "Hovd",
    geonameid: 1516048,
  },
  {
    name: "Altai",
    country: "Mongolia",
    subcountry: "Govi-Altai Province",
    geonameid: 1516393,
  },
  {
    name: "Ulan Bator",
    country: "Mongolia",
    subcountry: "Ulaanbaatar",
    geonameid: 2028462,
  },
  {
    name: "Tsetserleg",
    country: "Mongolia",
    subcountry: "Arkhangai Province",
    geonameid: 2028606,
  },
  {
    name: "Sühbaatar",
    country: "Mongolia",
    subcountry: "Selenge",
    geonameid: 2029156,
  },
  {
    name: "Undurkhaan",
    country: "Mongolia",
    subcountry: "Hentiy",
    geonameid: 2029656,
  },
  {
    name: "Mörön",
    country: "Mongolia",
    subcountry: "Khövsgöl Province",
    geonameid: 2029945,
  },
  {
    name: "Hovd",
    country: "Mongolia",
    subcountry: "Övörhangay",
    geonameid: 2030474,
  },
  {
    name: "Erdenet",
    country: "Mongolia",
    subcountry: "Orhon",
    geonameid: 2031405,
  },
  {
    name: "Dzuunmod",
    country: "Mongolia",
    subcountry: "Central Aimak",
    geonameid: 2031517,
  },
  {
    name: "Dzüünharaa",
    country: "Mongolia",
    subcountry: "Selenge",
    geonameid: 2031533,
  },
  {
    name: "Darhan",
    country: "Mongolia",
    subcountry: "Darhan Uul",
    geonameid: 2031964,
  },
  {
    name: "Dalandzadgad",
    country: "Mongolia",
    subcountry: "Ömnögovĭ",
    geonameid: 2032007,
  },
  {
    name: "Saynshand",
    country: "Mongolia",
    subcountry: "East Gobi Aymag",
    geonameid: 2032081,
  },
  {
    name: "Bulgan",
    country: "Mongolia",
    subcountry: "Bulgan",
    geonameid: 2032201,
  },
  {
    name: "Bayanhongor",
    country: "Mongolia",
    subcountry: "Bayanhongor",
    geonameid: 2032533,
  },
  {
    name: "Baruun-Urt",
    country: "Mongolia",
    subcountry: "Sühbaatar",
    geonameid: 2032614,
  },
  {
    name: "Arvayheer",
    country: "Mongolia",
    subcountry: "Övörhangay",
    geonameid: 2032814,
  },
  {
    name: "Zuunmod",
    country: "Mongolia",
    subcountry: "Central Aimak",
    geonameid: 7648817,
  },
  {
    name: "Macau",
    country: "Macao",
    subcountry: "N/A",
    geonameid: 1821274,
  },
  {
    name: "Saipan",
    country: "Northern Mariana Islands",
    subcountry: "Saipan",
    geonameid: 7828758,
  },
  {
    name: "Saint-Joseph",
    country: "Martinique",
    subcountry: "Martinique",
    geonameid: 3569915,
  },
  {
    name: "Sainte-Marie",
    country: "Martinique",
    subcountry: "Martinique",
    geonameid: 3569926,
  },
  {
    name: "Le Robert",
    country: "Martinique",
    subcountry: "Martinique",
    geonameid: 3570412,
  },
  {
    name: "Le Lamentin",
    country: "Martinique",
    subcountry: "Martinique",
    geonameid: 3570428,
  },
  {
    name: "Le François",
    country: "Martinique",
    subcountry: "Martinique",
    geonameid: 3570429,
  },
  {
    name: "La Trinité",
    country: "Martinique",
    subcountry: "Martinique",
    geonameid: 3570446,
  },
  {
    name: "Fort-de-France",
    country: "Martinique",
    subcountry: "Martinique",
    geonameid: 3570675,
  },
  {
    name: "Ducos",
    country: "Martinique",
    subcountry: "Martinique",
    geonameid: 3570785,
  },
  {
    name: "Zouerate",
    country: "Mauritania",
    subcountry: "Tiris Zemmour",
    geonameid: 2375558,
  },
  {
    name: "Tékane",
    country: "Mauritania",
    subcountry: "Trarza",
    geonameid: 2376189,
  },
  {
    name: "Sélibaby",
    country: "Mauritania",
    subcountry: "Guidimaka",
    geonameid: 2376719,
  },
  {
    name: "Rosso",
    country: "Mauritania",
    subcountry: "Trarza",
    geonameid: 2376898,
  },
  {
    name: "Nouakchott",
    country: "Mauritania",
    subcountry: "N/A",
    geonameid: 2377450,
  },
  {
    name: "Nouadhibou",
    country: "Mauritania",
    subcountry: "Dakhlet Nouadhibou",
    geonameid: 2377457,
  },
  {
    name: "Néma",
    country: "Mauritania",
    subcountry: "Hodh Ech Chargi",
    geonameid: 2377539,
  },
  {
    name: "Kiffa",
    country: "Mauritania",
    subcountry: "Assaba",
    geonameid: 2378538,
  },
  {
    name: "Kaédi",
    country: "Mauritania",
    subcountry: "Gorgol",
    geonameid: 2378736,
  },
  {
    name: "Bogué",
    country: "Mauritania",
    subcountry: "Brakna",
    geonameid: 2380954,
  },
  {
    name: "Atar",
    country: "Mauritania",
    subcountry: "Adrar",
    geonameid: 2381334,
  },
  {
    name: "Aleg",
    country: "Mauritania",
    subcountry: "Brakna",
    geonameid: 2381659,
  },
  {
    name: "Tevragh Zeina",
    country: "Mauritania",
    subcountry: "Nouakchott Ouest",
    geonameid: 11009418,
  },
  {
    name: "Dar Naim",
    country: "Mauritania",
    subcountry: "Nouakchott Nord",
    geonameid: 11496397,
  },
  {
    name: "Plymouth",
    country: "Montserrat",
    subcountry: "Saint Anthony",
    geonameid: 3578069,
  },
  {
    name: "Brades",
    country: "Montserrat",
    subcountry: "Saint Peter",
    geonameid: 7266440,
  },
  {
    name: "Żabbar",
    country: "Malta",
    subcountry: "Ħaż-Żabbar",
    geonameid: 2562266,
  },
  {
    name: "Valletta",
    country: "Malta",
    subcountry: "Valletta",
    geonameid: 2562305,
  },
  {
    name: "Sliema",
    country: "Malta",
    subcountry: "Tas-Sliema",
    geonameid: 2562501,
  },
  {
    name: "San Pawl il-Baħar",
    country: "Malta",
    subcountry: "Saint Paul’s Bay",
    geonameid: 2562541,
  },
  {
    name: "Qormi",
    country: "Malta",
    subcountry: "Qormi",
    geonameid: 2562629,
  },
  {
    name: "Mosta",
    country: "Malta",
    subcountry: "Il-Mosta",
    geonameid: 2562704,
  },
  {
    name: "Birkirkara",
    country: "Malta",
    subcountry: "Birkirkara",
    geonameid: 2563191,
  },
  {
    name: "Vacoas",
    country: "Mauritius",
    subcountry: "Plaines Wilhems",
    geonameid: 933945,
  },
  {
    name: "Triolet",
    country: "Mauritius",
    subcountry: "Pamplemousses",
    geonameid: 933959,
  },
  {
    name: "Saint Pierre",
    country: "Mauritius",
    subcountry: "Moka",
    geonameid: 934032,
  },
  {
    name: "Quatre Bornes",
    country: "Mauritius",
    subcountry: "Plaines Wilhems",
    geonameid: 934131,
  },
  {
    name: "Port Louis",
    country: "Mauritius",
    subcountry: "Port Louis",
    geonameid: 934154,
  },
  {
    name: "Mahébourg",
    country: "Mauritius",
    subcountry: "Grand Port",
    geonameid: 934322,
  },
  {
    name: "Goodlands",
    country: "Mauritius",
    subcountry: "Rivière du Rempart",
    geonameid: 934488,
  },
  {
    name: "Curepipe",
    country: "Mauritius",
    subcountry: "Plaines Wilhems",
    geonameid: 934570,
  },
  {
    name: "Centre de Flacq",
    country: "Mauritius",
    subcountry: "Flacq",
    geonameid: 934631,
  },
  {
    name: "Bel Air Rivière Sèche",
    country: "Mauritius",
    subcountry: "Flacq",
    geonameid: 934750,
  },
  {
    name: "Beau Bassin-Rose Hill",
    country: "Mauritius",
    subcountry: "Plaines Wilhems",
    geonameid: 934765,
  },
  {
    name: "Bambous",
    country: "Mauritius",
    subcountry: "Black River",
    geonameid: 934778,
  },
  {
    name: "Le Hochet",
    country: "Mauritius",
    subcountry: "Pamplemousses",
    geonameid: 1106809,
  },
  {
    name: "Male",
    country: "Maldives",
    subcountry: "Kaafu Atoll",
    geonameid: 1282027,
  },
  {
    name: "Karonga",
    country: "Malawi",
    subcountry: "Northern Region",
    geonameid: 235715,
  },
  {
    name: "Zomba",
    country: "Malawi",
    subcountry: "Southern Region",
    geonameid: 923295,
  },
  {
    name: "Salima",
    country: "Malawi",
    subcountry: "Central Region",
    geonameid: 924055,
  },
  {
    name: "Rumphi",
    country: "Malawi",
    subcountry: "Northern Region",
    geonameid: 924102,
  },
  {
    name: "Nsanje",
    country: "Malawi",
    subcountry: "Southern Region",
    geonameid: 924572,
  },
  {
    name: "Nkhotakota",
    country: "Malawi",
    subcountry: "Central Region",
    geonameid: 924705,
  },
  {
    name: "Mzuzu",
    country: "Malawi",
    subcountry: "Northern Region",
    geonameid: 925475,
  },
  {
    name: "Mzimba",
    country: "Malawi",
    subcountry: "Northern Region",
    geonameid: 925498,
  },
  {
    name: "Mulanje",
    country: "Malawi",
    subcountry: "Southern Region",
    geonameid: 925789,
  },
  {
    name: "Mchinji",
    country: "Malawi",
    subcountry: "Central Region",
    geonameid: 926747,
  },
  {
    name: "Mangochi",
    country: "Malawi",
    subcountry: "Southern Region",
    geonameid: 927246,
  },
  {
    name: "Liwonde",
    country: "Malawi",
    subcountry: "Southern Region",
    geonameid: 927834,
  },
  {
    name: "Lilongwe",
    country: "Malawi",
    subcountry: "Central Region",
    geonameid: 927967,
  },
  {
    name: "Kasungu",
    country: "Malawi",
    subcountry: "Central Region",
    geonameid: 928534,
  },
  {
    name: "Dedza",
    country: "Malawi",
    subcountry: "Central Region",
    geonameid: 930025,
  },
  {
    name: "Blantyre",
    country: "Malawi",
    subcountry: "Southern Region",
    geonameid: 931755,
  },
  {
    name: "Balaka",
    country: "Malawi",
    subcountry: "Southern Region",
    geonameid: 931865,
  },
  {
    name: "San Fernando",
    country: "Mexico",
    subcountry: "Tamaulipas",
    geonameid: 3483197,
  },
  {
    name: "Ciudad Valles",
    country: "Mexico",
    subcountry: "San Luis Potosí",
    geonameid: 3483849,
  },
  {
    name: "Zumpango",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3513966,
  },
  {
    name: "Zumpango del Río",
    country: "Mexico",
    subcountry: "Guerrero",
    geonameid: 3513967,
  },
  {
    name: "Zacualtipán",
    country: "Mexico",
    subcountry: "Hidalgo",
    geonameid: 3514134,
  },
  {
    name: "Zacatlán",
    country: "Mexico",
    subcountry: "Puebla",
    geonameid: 3514148,
  },
  {
    name: "Zacatepec",
    country: "Mexico",
    subcountry: "Morelos",
    geonameid: 3514163,
  },
  {
    name: "Yecapixtla",
    country: "Mexico",
    subcountry: "Morelos",
    geonameid: 3514278,
  },
  {
    name: "Yautepec",
    country: "Mexico",
    subcountry: "Morelos",
    geonameid: 3514321,
  },
  {
    name: "Yajalón",
    country: "Mexico",
    subcountry: "Chiapas",
    geonameid: 3514349,
  },
  {
    name: "Xoxocotla",
    country: "Mexico",
    subcountry: "Morelos",
    geonameid: 3514398,
  },
  {
    name: "Xonacatlán",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3514409,
  },
  {
    name: "Xochitepec",
    country: "Mexico",
    subcountry: "Morelos",
    geonameid: 3514437,
  },
  {
    name: "Xochimilco",
    country: "Mexico",
    subcountry: "Mexico City",
    geonameid: 3514450,
  },
  {
    name: "Xicotepec de Juárez",
    country: "Mexico",
    subcountry: "Puebla",
    geonameid: 3514510,
  },
  {
    name: "Xico",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3514518,
  },
  {
    name: "Xico",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3514519,
  },
  {
    name: "Santa Ana Xalmimilulco",
    country: "Mexico",
    subcountry: "Puebla",
    geonameid: 3514597,
  },
  {
    name: "Álvaro Obregón",
    country: "Mexico",
    subcountry: "Mexico City",
    geonameid: 3514663,
  },
  {
    name: "Villahermosa",
    country: "Mexico",
    subcountry: "Tabasco",
    geonameid: 3514670,
  },
  {
    name: "Gustavo Adolfo Madero",
    country: "Mexico",
    subcountry: "Mexico City",
    geonameid: 3514674,
  },
  {
    name: "Villaflores",
    country: "Mexico",
    subcountry: "Chiapas",
    geonameid: 3514677,
  },
  {
    name: "Veracruz",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3514783,
  },
  {
    name: "Venustiano Carranza",
    country: "Mexico",
    subcountry: "Chiapas",
    geonameid: 3514785,
  },
  {
    name: "Valle Hermoso",
    country: "Mexico",
    subcountry: "Tamaulipas",
    geonameid: 3514868,
  },
  {
    name: "Valladolid",
    country: "Mexico",
    subcountry: "Yucatán",
    geonameid: 3514876,
  },
  {
    name: "Umán",
    country: "Mexico",
    subcountry: "Yucatán",
    geonameid: 3514929,
  },
  {
    name: "Tuxtla",
    country: "Mexico",
    subcountry: "Chiapas",
    geonameid: 3515001,
  },
  {
    name: "Túxpam de Rodríguez Cano",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3515011,
  },
  {
    name: "Tulum",
    country: "Mexico",
    subcountry: "Quintana Roo",
    geonameid: 3515040,
  },
  {
    name: "Tultitlán de Mariano Escobedo",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3515042,
  },
  {
    name: "Tultepec",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3515044,
  },
  {
    name: "Tulancingo",
    country: "Mexico",
    subcountry: "Hidalgo",
    geonameid: 3515062,
  },
  {
    name: "Tula de Allende",
    country: "Mexico",
    subcountry: "Hidalgo",
    geonameid: 3515064,
  },
  {
    name: "Santa Rosa Treinta",
    country: "Mexico",
    subcountry: "Morelos",
    geonameid: 3515163,
  },
  {
    name: "San Miguel Topilejo",
    country: "Mexico",
    subcountry: "Mexico City",
    geonameid: 3515259,
  },
  {
    name: "Toluca",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3515302,
  },
  {
    name: "San Bernardino Tlaxcalancingo",
    country: "Mexico",
    subcountry: "Puebla",
    geonameid: 3515358,
  },
  {
    name: "Tlaquiltenango",
    country: "Mexico",
    subcountry: "Morelos",
    geonameid: 3515373,
  },
  {
    name: "Tlapa de Comonfort",
    country: "Mexico",
    subcountry: "Guerrero",
    geonameid: 3515384,
  },
  {
    name: "Tlapacoyan",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3515386,
  },
  {
    name: "Tlalpan",
    country: "Mexico",
    subcountry: "Mexico City",
    geonameid: 3515428,
  },
  {
    name: "Tlalnepantla",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3515431,
  },
  {
    name: "Tláhuac",
    country: "Mexico",
    subcountry: "Mexico City",
    geonameid: 3515463,
  },
  {
    name: "Tizimín",
    country: "Mexico",
    subcountry: "Yucatán",
    geonameid: 3515504,
  },
  {
    name: "Tizayuca",
    country: "Mexico",
    subcountry: "Hidalgo",
    geonameid: 3515505,
  },
  {
    name: "Tixtla de Guerrero",
    country: "Mexico",
    subcountry: "Guerrero",
    geonameid: 3515510,
  },
  {
    name: "Ticul",
    country: "Mexico",
    subcountry: "Yucatán",
    geonameid: 3515665,
  },
  {
    name: "Teziutlan",
    country: "Mexico",
    subcountry: "Puebla",
    geonameid: 3515696,
  },
  {
    name: "Texcoco de Mora",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3515715,
  },
  {
    name: "Tequixquiac",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3515794,
  },
  {
    name: "Tequisquiapan",
    country: "Mexico",
    subcountry: "Querétaro",
    geonameid: 3515796,
  },
  {
    name: "Cuautitlán Izcalli",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3515807,
  },
  {
    name: "Tepotzotlán",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3515827,
  },
  {
    name: "Tepeji del Río de Ocampo",
    country: "Mexico",
    subcountry: "Hidalgo",
    geonameid: 3515887,
  },
  {
    name: "Tepeapulco",
    country: "Mexico",
    subcountry: "Hidalgo",
    geonameid: 3515902,
  },
  {
    name: "Tepeaca",
    country: "Mexico",
    subcountry: "Puebla",
    geonameid: 3515904,
  },
  {
    name: "Tepatlaxco de Hidalgo",
    country: "Mexico",
    subcountry: "Puebla",
    geonameid: 3515906,
  },
  {
    name: "Teopisca",
    country: "Mexico",
    subcountry: "Chiapas",
    geonameid: 3515938,
  },
  {
    name: "Teoloyucan",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3515942,
  },
  {
    name: "Tenosique",
    country: "Mexico",
    subcountry: "Tabasco",
    geonameid: 3515956,
  },
  {
    name: "Tenango de Arista",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3515993,
  },
  {
    name: "Temixco",
    country: "Mexico",
    subcountry: "Morelos",
    geonameid: 3516035,
  },
  {
    name: "Teloloapan",
    country: "Mexico",
    subcountry: "Guerrero",
    geonameid: 3516060,
  },
  {
    name: "Tecax",
    country: "Mexico",
    subcountry: "Yucatán",
    geonameid: 3516076,
  },
  {
    name: "Tehuacán",
    country: "Mexico",
    subcountry: "Puebla",
    geonameid: 3516109,
  },
  {
    name: "Tecamachalco",
    country: "Mexico",
    subcountry: "Puebla",
    geonameid: 3516188,
  },
  {
    name: "Teapa",
    country: "Mexico",
    subcountry: "Tabasco",
    geonameid: 3516210,
  },
  {
    name: "Taxco de Alarcón",
    country: "Mexico",
    subcountry: "Guerrero",
    geonameid: 3516225,
  },
  {
    name: "Tapachula",
    country: "Mexico",
    subcountry: "Chiapas",
    geonameid: 3516266,
  },
  {
    name: "Tantoyuca",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3516271,
  },
  {
    name: "Tamuín",
    country: "Mexico",
    subcountry: "San Luis Potosí",
    geonameid: 3516347,
  },
  {
    name: "Tampico",
    country: "Mexico",
    subcountry: "Tamaulipas",
    geonameid: 3516355,
  },
  {
    name: "Tamazunchale",
    country: "Mexico",
    subcountry: "San Luis Potosí",
    geonameid: 3516385,
  },
  {
    name: "Suchiapa",
    country: "Mexico",
    subcountry: "Chiapas",
    geonameid: 3516499,
  },
  {
    name: "Santo Domingo Tehuantepec",
    country: "Mexico",
    subcountry: "Oaxaca",
    geonameid: 3516843,
  },
  {
    name: "Santiago Tuxtla",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3516912,
  },
  {
    name: "Tetla",
    country: "Mexico",
    subcountry: "Tlaxcala",
    geonameid: 3516919,
  },
  {
    name: "Pinotepa Nacional",
    country: "Mexico",
    subcountry: "Oaxaca",
    geonameid: 3516926,
  },
  {
    name: "Santiago Tulantepec",
    country: "Mexico",
    subcountry: "Hidalgo",
    geonameid: 3516982,
  },
  {
    name: "Moyotzingo",
    country: "Mexico",
    subcountry: "Puebla",
    geonameid: 3517231,
  },
  {
    name: "Santa María Chimalhuacán",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3517270,
  },
  {
    name: "Santa María Atzompa",
    country: "Mexico",
    subcountry: "Oaxaca",
    geonameid: 3517280,
  },
  {
    name: "Heroica Ciudad de Tlaxiaco",
    country: "Mexico",
    subcountry: "Oaxaca",
    geonameid: 3517285,
  },
  {
    name: "Santa Cruz Xoxocotlán",
    country: "Mexico",
    subcountry: "Oaxaca",
    geonameid: 3517517,
  },
  {
    name: "Tecámac",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3517524,
  },
  {
    name: "Santa Ana Chiautempan",
    country: "Mexico",
    subcountry: "Tlaxcala",
    geonameid: 3517742,
  },
  {
    name: "Zinacatepec",
    country: "Mexico",
    subcountry: "Puebla",
    geonameid: 3517795,
  },
  {
    name: "San Salvador El Seco",
    country: "Mexico",
    subcountry: "Puebla",
    geonameid: 3517831,
  },
  {
    name: "San Salvador Atenco",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3517832,
  },
  {
    name: "San Rafael",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3517917,
  },
  {
    name: "San Pablo de las Salinas",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3518135,
  },
  {
    name: "San Pablo Autopan",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3518138,
  },
  {
    name: "Zinacantepec",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3518221,
  },
  {
    name: "San Miguel Coatlinchán",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3518277,
  },
  {
    name: "San Miguel Ajusco",
    country: "Mexico",
    subcountry: "Mexico City",
    geonameid: 3518293,
  },
  {
    name: "San Mateo Atenco",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3518387,
  },
  {
    name: "San Martin Texmelucan de Labastida",
    country: "Mexico",
    subcountry: "Puebla",
    geonameid: 3518407,
  },
  {
    name: "Teolocholco",
    country: "Mexico",
    subcountry: "Tlaxcala",
    geonameid: 3518475,
  },
  {
    name: "San Juan Zitlaltepec",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3518593,
  },
  {
    name: "San Juan Ixtayopan",
    country: "Mexico",
    subcountry: "Mexico City",
    geonameid: 3518650,
  },
  {
    name: "San Juan del Río",
    country: "Mexico",
    subcountry: "Querétaro",
    geonameid: 3518692,
  },
  {
    name: "Tuxtepec",
    country: "Mexico",
    subcountry: "Oaxaca",
    geonameid: 3518723,
  },
  {
    name: "San Jerónimo",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3519076,
  },
  {
    name: "San Francisco Tlalcilalcalpan",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3519249,
  },
  {
    name: "San Francisco Acuautla",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3519290,
  },
  {
    name: "Sanctorum",
    country: "Mexico",
    subcountry: "Puebla",
    geonameid: 3519531,
  },
  {
    name: "San Cristóbal de las Casas",
    country: "Mexico",
    subcountry: "Chiapas",
    geonameid: 3519537,
  },
  {
    name: "San Andrés Tuxtla",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3519907,
  },
  {
    name: "Salina Cruz",
    country: "Mexico",
    subcountry: "Oaxaca",
    geonameid: 3520064,
  },
  {
    name: "Rioverde",
    country: "Mexico",
    subcountry: "San Luis Potosí",
    geonameid: 3520235,
  },
  {
    name: "Ciudad Río Bravo",
    country: "Mexico",
    subcountry: "Tamaulipas",
    geonameid: 3520271,
  },
  {
    name: "Río Blanco",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3520274,
  },
  {
    name: "Reynosa",
    country: "Mexico",
    subcountry: "Tamaulipas",
    geonameid: 3520339,
  },
  {
    name: "Reforma",
    country: "Mexico",
    subcountry: "Chiapas",
    geonameid: 3520407,
  },
  {
    name: "Puerto Escondido",
    country: "Mexico",
    subcountry: "Oaxaca",
    geonameid: 3520994,
  },
  {
    name: "Puente de Ixtla",
    country: "Mexico",
    subcountry: "Morelos",
    geonameid: 3521051,
  },
  {
    name: "Puebla",
    country: "Mexico",
    subcountry: "Puebla",
    geonameid: 3521081,
  },
  {
    name: "Progreso de Alvaro Obregon",
    country: "Mexico",
    subcountry: "Hidalgo",
    geonameid: 3521103,
  },
  {
    name: "Progreso",
    country: "Mexico",
    subcountry: "Yucatán",
    geonameid: 3521108,
  },
  {
    name: "Poza Rica de Hidalgo",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3521168,
  },
  {
    name: "Polanco",
    country: "Mexico",
    subcountry: "Mexico City",
    geonameid: 3521305,
  },
  {
    name: "Playa del Carmen",
    country: "Mexico",
    subcountry: "Quintana Roo",
    geonameid: 3521342,
  },
  {
    name: "Pijijiapan",
    country: "Mexico",
    subcountry: "Chiapas",
    geonameid: 3521476,
  },
  {
    name: "Peto",
    country: "Mexico",
    subcountry: "Yucatán",
    geonameid: 3521596,
  },
  {
    name: "Perote",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3521628,
  },
  {
    name: "Paraiso",
    country: "Mexico",
    subcountry: "Tabasco",
    geonameid: 3521912,
  },
  {
    name: "Papantla de Olarte",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3521922,
  },
  {
    name: "Pánuco",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3521941,
  },
  {
    name: "Palmarito Tochapan",
    country: "Mexico",
    subcountry: "Puebla",
    geonameid: 3522118,
  },
  {
    name: "Palenque",
    country: "Mexico",
    subcountry: "Chiapas",
    geonameid: 3522164,
  },
  {
    name: "Pachuca de Soto",
    country: "Mexico",
    subcountry: "Hidalgo",
    geonameid: 3522210,
  },
  {
    name: "Ozumba de Alzate",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3522232,
  },
  {
    name: "San Pablo Oztotepec",
    country: "Mexico",
    subcountry: "Mexico City",
    geonameid: 3522246,
  },
  {
    name: "Oxkutzkab",
    country: "Mexico",
    subcountry: "Yucatán",
    geonameid: 3522251,
  },
  {
    name: "Orizaba",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3522307,
  },
  {
    name: "Ometepec",
    country: "Mexico",
    subcountry: "Guerrero",
    geonameid: 3522343,
  },
  {
    name: "Ocozocoautla de Espinosa",
    country: "Mexico",
    subcountry: "Chiapas",
    geonameid: 3522444,
  },
  {
    name: "Ocoyoacac",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3522445,
  },
  {
    name: "Ocotlán de Morelos",
    country: "Mexico",
    subcountry: "Oaxaca",
    geonameid: 3522451,
  },
  {
    name: "Ocosingo",
    country: "Mexico",
    subcountry: "Chiapas",
    geonameid: 3522484,
  },
  {
    name: "Oaxaca",
    country: "Mexico",
    subcountry: "Oaxaca",
    geonameid: 3522507,
  },
  {
    name: "Nuevo Laredo",
    country: "Mexico",
    subcountry: "Tamaulipas",
    geonameid: 3522551,
  },
  {
    name: "Nogales",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3522696,
  },
  {
    name: "Nicolás Romero",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3522732,
  },
  {
    name: "Naucalpan de Juárez",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3522790,
  },
  {
    name: "Naranjos",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3522804,
  },
  {
    name: "Nanchital de Lázaro Cárdenas del Río",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3522845,
  },
  {
    name: "Motul",
    country: "Mexico",
    subcountry: "Yucatán",
    geonameid: 3522924,
  },
  {
    name: "Motozintla",
    country: "Mexico",
    subcountry: "Chiapas",
    geonameid: 3522926,
  },
  {
    name: "Montemorelos",
    country: "Mexico",
    subcountry: "Nuevo León",
    geonameid: 3523011,
  },
  {
    name: "Santiago Momoxpan",
    country: "Mexico",
    subcountry: "Puebla",
    geonameid: 3523061,
  },
  {
    name: "Mixquiahuala de Juarez",
    country: "Mexico",
    subcountry: "Hidalgo",
    geonameid: 3523127,
  },
  {
    name: "Misantla",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3523141,
  },
  {
    name: "Miramar",
    country: "Mexico",
    subcountry: "Tamaulipas",
    geonameid: 3523149,
  },
  {
    name: "Minatitlán",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3523183,
  },
  {
    name: "Milpa Alta",
    country: "Mexico",
    subcountry: "Mexico City",
    geonameid: 3523202,
  },
  {
    name: "Miahuatlán de Porfirio Díaz",
    country: "Mexico",
    subcountry: "Oaxaca",
    geonameid: 3523240,
  },
  {
    name: "Metepec",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3523303,
  },
  {
    name: "Mérida",
    country: "Mexico",
    subcountry: "Yucatán",
    geonameid: 3523349,
  },
  {
    name: "Matías Romero",
    country: "Mexico",
    subcountry: "Oaxaca",
    geonameid: 3523450,
  },
  {
    name: "Heroica Matamoros",
    country: "Mexico",
    subcountry: "Tamaulipas",
    geonameid: 3523466,
  },
  {
    name: "Martínez de la Torre",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3523513,
  },
  {
    name: "Mapastepec",
    country: "Mexico",
    subcountry: "Chiapas",
    geonameid: 3523590,
  },
  {
    name: "Magdalena Contreras",
    country: "Mexico",
    subcountry: "Mexico City",
    geonameid: 3523760,
  },
  {
    name: "Macuspana",
    country: "Mexico",
    subcountry: "Tabasco",
    geonameid: 3523791,
  },
  {
    name: "Reyes Acozac",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3523900,
  },
  {
    name: "Los Reyes Acaquilpan",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3523908,
  },
  {
    name: "Los Reyes de Juárez",
    country: "Mexico",
    subcountry: "Puebla",
    geonameid: 3523909,
  },
  {
    name: "Linares",
    country: "Mexico",
    subcountry: "Nuevo León",
    geonameid: 3524348,
  },
  {
    name: "Libres",
    country: "Mexico",
    subcountry: "Puebla",
    geonameid: 3524374,
  },
  {
    name: "Lerma de Villada",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3524389,
  },
  {
    name: "Lerdo de Tejada",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3524391,
  },
  {
    name: "Las Rosas",
    country: "Mexico",
    subcountry: "Chiapas",
    geonameid: 3524618,
  },
  {
    name: "Las Margaritas",
    country: "Mexico",
    subcountry: "Chiapas",
    geonameid: 3524744,
  },
  {
    name: "Las Choapas",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3524903,
  },
  {
    name: "Magdalena Atlicpac",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3525424,
  },
  {
    name: "La Isla",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3525596,
  },
  {
    name: "San Antonio de la Cal",
    country: "Mexico",
    subcountry: "Oaxaca",
    geonameid: 3526138,
  },
  {
    name: "Kanasín",
    country: "Mexico",
    subcountry: "Yucatán",
    geonameid: 3526323,
  },
  {
    name: "Juchitepec",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3526355,
  },
  {
    name: "Juchitán de Zaragoza",
    country: "Mexico",
    subcountry: "Oaxaca",
    geonameid: 3526357,
  },
  {
    name: "José Cardel",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3526446,
  },
  {
    name: "Jojutla",
    country: "Mexico",
    subcountry: "Morelos",
    geonameid: 3526467,
  },
  {
    name: "Jiutepec",
    country: "Mexico",
    subcountry: "Morelos",
    geonameid: 3526485,
  },
  {
    name: "Jáltipan de Morelos",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3526593,
  },
  {
    name: "Jalpa de Méndez",
    country: "Mexico",
    subcountry: "Tabasco",
    geonameid: 3526603,
  },
  {
    name: "Xalatlaco",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3526611,
  },
  {
    name: "Xalapa de Enríquez",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3526617,
  },
  {
    name: "Izúcar de Matamoros",
    country: "Mexico",
    subcountry: "Puebla",
    geonameid: 3526657,
  },
  {
    name: "Izamal",
    country: "Mexico",
    subcountry: "Yucatán",
    geonameid: 3526662,
  },
  {
    name: "Ixtepec",
    country: "Mexico",
    subcountry: "Oaxaca",
    geonameid: 3526674,
  },
  {
    name: "Ixtapan de la Sal",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3526681,
  },
  {
    name: "Ixtapaluca",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3526682,
  },
  {
    name: "Iztapalapa",
    country: "Mexico",
    subcountry: "Mexico City",
    geonameid: 3526683,
  },
  {
    name: "Ixtaczoquitlán",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3526696,
  },
  {
    name: "Iztacalco",
    country: "Mexico",
    subcountry: "Mexico City",
    geonameid: 3526700,
  },
  {
    name: "Ixmiquilpan",
    country: "Mexico",
    subcountry: "Hidalgo",
    geonameid: 3526708,
  },
  {
    name: "Villa Independencia",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3526785,
  },
  {
    name: "Iguala de la Independencia",
    country: "Mexico",
    subcountry: "Guerrero",
    geonameid: 3526798,
  },
  {
    name: "Hunucmá",
    country: "Mexico",
    subcountry: "Yucatán",
    geonameid: 3526838,
  },
  {
    name: "Huixtla",
    country: "Mexico",
    subcountry: "Chiapas",
    geonameid: 3526855,
  },
  {
    name: "Ciudad de Huitzuco",
    country: "Mexico",
    subcountry: "Guerrero",
    geonameid: 3526864,
  },
  {
    name: "Huimanguillo",
    country: "Mexico",
    subcountry: "Tabasco",
    geonameid: 3526908,
  },
  {
    name: "Huejutla de Reyes",
    country: "Mexico",
    subcountry: "Hidalgo",
    geonameid: 3526952,
  },
  {
    name: "Huejotzingo",
    country: "Mexico",
    subcountry: "Puebla",
    geonameid: 3526953,
  },
  {
    name: "Huauchinango",
    country: "Mexico",
    subcountry: "Puebla",
    geonameid: 3526992,
  },
  {
    name: "Huatusco",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3526993,
  },
  {
    name: "Ciudad de Huajuapan de León",
    country: "Mexico",
    subcountry: "Oaxaca",
    geonameid: 3527023,
  },
  {
    name: "Comalapa",
    country: "Mexico",
    subcountry: "Chiapas",
    geonameid: 3527542,
  },
  {
    name: "Frontera",
    country: "Mexico",
    subcountry: "Tabasco",
    geonameid: 3527545,
  },
  {
    name: "Fortín de las Flores",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3527596,
  },
  {
    name: "Felipe Carrillo Puerto",
    country: "Mexico",
    subcountry: "Quintana Roo",
    geonameid: 3527639,
  },
  {
    name: "Escárcega",
    country: "Mexico",
    subcountry: "Campeche",
    geonameid: 3527795,
  },
  {
    name: "Emiliano Zapata",
    country: "Mexico",
    subcountry: "Morelos",
    geonameid: 3527879,
  },
  {
    name: "Emiliano Zapata",
    country: "Mexico",
    subcountry: "Chiapas",
    geonameid: 3527880,
  },
  {
    name: "Ciudad Mante",
    country: "Mexico",
    subcountry: "Tamaulipas",
    geonameid: 3528756,
  },
  {
    name: "Ecatepec de Morelos",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3529612,
  },
  {
    name: "Ébano",
    country: "Mexico",
    subcountry: "San Luis Potosí",
    geonameid: 3529619,
  },
  {
    name: "Cunduacán",
    country: "Mexico",
    subcountry: "Tabasco",
    geonameid: 3529886,
  },
  {
    name: "Cuernavaca",
    country: "Mexico",
    subcountry: "Morelos",
    geonameid: 3529947,
  },
  {
    name: "Cuautlancingo",
    country: "Mexico",
    subcountry: "Puebla",
    geonameid: 3529981,
  },
  {
    name: "Cuautla",
    country: "Mexico",
    subcountry: "Morelos",
    geonameid: 3529982,
  },
  {
    name: "Cuautitlán",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3529986,
  },
  {
    name: "Cuautepec de Hinojosa",
    country: "Mexico",
    subcountry: "Hidalgo",
    geonameid: 3529989,
  },
  {
    name: "Delegación Cuajimalpa de Morelos",
    country: "Mexico",
    subcountry: "Mexico City",
    geonameid: 3530049,
  },
  {
    name: "Cozumel",
    country: "Mexico",
    subcountry: "Quintana Roo",
    geonameid: 3530103,
  },
  {
    name: "Coyotepec",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3530123,
  },
  {
    name: "Coyoacán",
    country: "Mexico",
    subcountry: "Mexico City",
    geonameid: 3530139,
  },
  {
    name: "Cosoleacaque",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3530167,
  },
  {
    name: "Coscomatepec de Bravo",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3530175,
  },
  {
    name: "Cosamaloapan",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3530177,
  },
  {
    name: "Córdoba",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3530240,
  },
  {
    name: "Contla",
    country: "Mexico",
    subcountry: "Tlaxcala",
    geonameid: 3530276,
  },
  {
    name: "Comitán",
    country: "Mexico",
    subcountry: "Chiapas",
    geonameid: 3530367,
  },
  {
    name: "Comalcalco",
    country: "Mexico",
    subcountry: "Tabasco",
    geonameid: 3530385,
  },
  {
    name: "Coatzintla",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3530513,
  },
  {
    name: "Coatzacoalcos",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3530517,
  },
  {
    name: "Coatepec",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3530531,
  },
  {
    name: "Coacalco",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3530569,
  },
  {
    name: "Ciudad Victoria",
    country: "Mexico",
    subcountry: "Tamaulipas",
    geonameid: 3530580,
  },
  {
    name: "Ciudad Serdán",
    country: "Mexico",
    subcountry: "Puebla",
    geonameid: 3530584,
  },
  {
    name: "Ciudad Sahagun",
    country: "Mexico",
    subcountry: "Hidalgo",
    geonameid: 3530587,
  },
  {
    name: "Ciudad Nezahualcoyotl",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3530589,
  },
  {
    name: "Ciudad Miguel Alemán",
    country: "Mexico",
    subcountry: "Tamaulipas",
    geonameid: 3530590,
  },
  {
    name: "Ciudad Mendoza",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3530592,
  },
  {
    name: "Ciudad Madero",
    country: "Mexico",
    subcountry: "Tamaulipas",
    geonameid: 3530594,
  },
  {
    name: "Ciudad Fernández",
    country: "Mexico",
    subcountry: "San Luis Potosí",
    geonameid: 3530596,
  },
  {
    name: "Mexico City",
    country: "Mexico",
    subcountry: "Mexico City",
    geonameid: 3530597,
  },
  {
    name: "Ciudad del Carmen",
    country: "Mexico",
    subcountry: "Campeche",
    geonameid: 3530599,
  },
  {
    name: "Cintalapa de Figueroa",
    country: "Mexico",
    subcountry: "Chiapas",
    geonameid: 3530617,
  },
  {
    name: "Cholula",
    country: "Mexico",
    subcountry: "Puebla",
    geonameid: 3530757,
  },
  {
    name: "Chilpancingo",
    country: "Mexico",
    subcountry: "Guerrero",
    geonameid: 3530870,
  },
  {
    name: "Chilapa de Álvarez",
    country: "Mexico",
    subcountry: "Guerrero",
    geonameid: 3530886,
  },
  {
    name: "Chignahuapan",
    country: "Mexico",
    subcountry: "Puebla",
    geonameid: 3530908,
  },
  {
    name: "Chiconcuac",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3530932,
  },
  {
    name: "Chicoloapan",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3530937,
  },
  {
    name: "Chichén-Itzá",
    country: "Mexico",
    subcountry: "Yucatán",
    geonameid: 3530978,
  },
  {
    name: "Chiapa de Corzo",
    country: "Mexico",
    subcountry: "Chiapas",
    geonameid: 3531013,
  },
  {
    name: "Chetumal",
    country: "Mexico",
    subcountry: "Quintana Roo",
    geonameid: 3531023,
  },
  {
    name: "Champotón",
    country: "Mexico",
    subcountry: "Campeche",
    geonameid: 3531177,
  },
  {
    name: "Chalco",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3531200,
  },
  {
    name: "Cerro Azul",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3531321,
  },
  {
    name: "Catemaco",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3531416,
  },
  {
    name: "Carlos A. Carrillo",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3531556,
  },
  {
    name: "Cárdenas",
    country: "Mexico",
    subcountry: "San Luis Potosí",
    geonameid: 3531574,
  },
  {
    name: "Cárdenas",
    country: "Mexico",
    subcountry: "Tabasco",
    geonameid: 3531576,
  },
  {
    name: "Capulhuac de Mirafuentes",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3531598,
  },
  {
    name: "Cancún",
    country: "Mexico",
    subcountry: "Quintana Roo",
    geonameid: 3531673,
  },
  {
    name: "Campeche",
    country: "Mexico",
    subcountry: "Campeche",
    geonameid: 3531732,
  },
  {
    name: "Calpulalpan",
    country: "Mexico",
    subcountry: "Tlaxcala",
    geonameid: 3531784,
  },
  {
    name: "Cadereyta Jiménez",
    country: "Mexico",
    subcountry: "Nuevo León",
    geonameid: 3531862,
  },
  {
    name: "Cadereyta",
    country: "Mexico",
    subcountry: "Nuevo León",
    geonameid: 3531865,
  },
  {
    name: "Cacahoatán",
    country: "Mexico",
    subcountry: "Chiapas",
    geonameid: 3531904,
  },
  {
    name: "Berriozábal",
    country: "Mexico",
    subcountry: "Chiapas",
    geonameid: 3532254,
  },
  {
    name: "Banderilla",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3532414,
  },
  {
    name: "Azcapotzalco",
    country: "Mexico",
    subcountry: "Mexico City",
    geonameid: 3532497,
  },
  {
    name: "Ayutla de los Libres",
    country: "Mexico",
    subcountry: "Guerrero",
    geonameid: 3532499,
  },
  {
    name: "Axochiapan",
    country: "Mexico",
    subcountry: "Morelos",
    geonameid: 3532545,
  },
  {
    name: "Atlixco",
    country: "Mexico",
    subcountry: "Puebla",
    geonameid: 3532592,
  },
  {
    name: "Atlacomulco de Fabela",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3532617,
  },
  {
    name: "Ciudad López Mateos",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3532624,
  },
  {
    name: "Apizaco",
    country: "Mexico",
    subcountry: "Tlaxcala",
    geonameid: 3532792,
  },
  {
    name: "Apan",
    country: "Mexico",
    subcountry: "Hidalgo",
    geonameid: 3532815,
  },
  {
    name: "Amozoc de Mota",
    country: "Mexico",
    subcountry: "Puebla",
    geonameid: 3532881,
  },
  {
    name: "Amecameca",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3532899,
  },
  {
    name: "Alvarado",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3532964,
  },
  {
    name: "Altotonga",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3532969,
  },
  {
    name: "Altepexi",
    country: "Mexico",
    subcountry: "Puebla",
    geonameid: 3532989,
  },
  {
    name: "Altamira",
    country: "Mexico",
    subcountry: "Tamaulipas",
    geonameid: 3533005,
  },
  {
    name: "Allende",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3533056,
  },
  {
    name: "Álamo",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3533107,
  },
  {
    name: "Ajalpan",
    country: "Mexico",
    subcountry: "Puebla",
    geonameid: 3533126,
  },
  {
    name: "Agua Dulce",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3533269,
  },
  {
    name: "Actopan",
    country: "Mexico",
    subcountry: "Hidalgo",
    geonameid: 3533389,
  },
  {
    name: "San Lorenzo Acopilco",
    country: "Mexico",
    subcountry: "Mexico City",
    geonameid: 3533402,
  },
  {
    name: "Acayucan",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3533426,
  },
  {
    name: "Acatzingo",
    country: "Mexico",
    subcountry: "Puebla",
    geonameid: 3533433,
  },
  {
    name: "Acatlán de Osorio",
    country: "Mexico",
    subcountry: "Puebla",
    geonameid: 3533440,
  },
  {
    name: "Acapulco de Juárez",
    country: "Mexico",
    subcountry: "Guerrero",
    geonameid: 3533462,
  },
  {
    name: "Acajete",
    country: "Mexico",
    subcountry: "Puebla",
    geonameid: 3533486,
  },
  {
    name: "San Antonio Acahualco",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3533490,
  },
  {
    name: "Valente Diaz",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3761202,
  },
  {
    name: "Santiago Tlacotepec",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3762210,
  },
  {
    name: "Tierra Blanca",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3801276,
  },
  {
    name: "Playas del Rosario",
    country: "Mexico",
    subcountry: "Tabasco",
    geonameid: 3802723,
  },
  {
    name: "Río de Teapa",
    country: "Mexico",
    subcountry: "Tabasco",
    geonameid: 3802739,
  },
  {
    name: "Huamantla",
    country: "Mexico",
    subcountry: "Tlaxcala",
    geonameid: 3815324,
  },
  {
    name: "La Magdalena Tlaltelulco",
    country: "Mexico",
    subcountry: "Tlaxcala",
    geonameid: 3815375,
  },
  {
    name: "Zacatelco",
    country: "Mexico",
    subcountry: "Tlaxcala",
    geonameid: 3815392,
  },
  {
    name: "Tlaxcala",
    country: "Mexico",
    subcountry: "Tlaxcala",
    geonameid: 3815415,
  },
  {
    name: "Papalotla",
    country: "Mexico",
    subcountry: "Tlaxcala",
    geonameid: 3815447,
  },
  {
    name: "Villa Vicente Guerrero",
    country: "Mexico",
    subcountry: "Tlaxcala",
    geonameid: 3815453,
  },
  {
    name: "Tonalá",
    country: "Mexico",
    subcountry: "Chiapas",
    geonameid: 3816721,
  },
  {
    name: "Arriaga",
    country: "Mexico",
    subcountry: "Chiapas",
    geonameid: 3816739,
  },
  {
    name: "San Mateo Huitzilzingo",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3817641,
  },
  {
    name: "San Martín Cuautlalpan",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3817649,
  },
  {
    name: "Tulantongo",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3817714,
  },
  {
    name: "Tezoyuca",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3817731,
  },
  {
    name: "Tepexpan",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3817746,
  },
  {
    name: "Santa María Ajoloapan",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3817809,
  },
  {
    name: "San Andrés Cholula",
    country: "Mexico",
    subcountry: "Puebla",
    geonameid: 3818742,
  },
  {
    name: "Alto Lucero",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3824536,
  },
  {
    name: "Loma Bonita",
    country: "Mexico",
    subcountry: "Oaxaca",
    geonameid: 3824996,
  },
  {
    name: "Isla",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 3825011,
  },
  {
    name: "San Andrés Cuexcontitlán",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3827248,
  },
  {
    name: "San Mateo Otzacatipan",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3827254,
  },
  {
    name: "San Pedro Totoltepec",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3827255,
  },
  {
    name: "Santa María Totoltepec",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3827256,
  },
  {
    name: "San Francisco Cuaxusco",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3827263,
  },
  {
    name: "Benito Juarez",
    country: "Mexico",
    subcountry: "Mexico City",
    geonameid: 3827406,
  },
  {
    name: "Venustiano Carranza",
    country: "Mexico",
    subcountry: "Mexico City",
    geonameid: 3827407,
  },
  {
    name: "Miguel Hidalgo",
    country: "Mexico",
    subcountry: "Mexico City",
    geonameid: 3827408,
  },
  {
    name: "Cuauhtémoc",
    country: "Mexico",
    subcountry: "Mexico City",
    geonameid: 3827409,
  },
  {
    name: "Huixquilucan",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3827414,
  },
  {
    name: "Melchor Ocampo",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3827586,
  },
  {
    name: "Huilango",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3827588,
  },
  {
    name: "Santiago Teyahualco",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3827596,
  },
  {
    name: "Ojo de Agua",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3827598,
  },
  {
    name: "Buenavista",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3827606,
  },
  {
    name: "Miguel Alemán (La Doce)",
    country: "Mexico",
    subcountry: "Sonora",
    geonameid: 3970972,
  },
  {
    name: "Leyva Solano",
    country: "Mexico",
    subcountry: "Sinaloa",
    geonameid: 3976775,
  },
  {
    name: "Cihuatlán",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 3976999,
  },
  {
    name: "Lázaro Cárdenas",
    country: "Mexico",
    subcountry: "Baja California",
    geonameid: 3979174,
  },
  {
    name: "Santa Isabel",
    country: "Mexico",
    subcountry: "Baja California",
    geonameid: 3979442,
  },
  {
    name: "Guadalupe Victoria",
    country: "Mexico",
    subcountry: "Baja California",
    geonameid: 3979505,
  },
  {
    name: "Zinapécuaro",
    country: "Mexico",
    subcountry: "Michoacán",
    geonameid: 3979665,
  },
  {
    name: "Ixtapa-Zihuatanejo",
    country: "Mexico",
    subcountry: "Guerrero",
    geonameid: 3979673,
  },
  {
    name: "Zapotlanejo",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 3979717,
  },
  {
    name: "Zapotiltic",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 3979727,
  },
  {
    name: "Zapopan",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 3979770,
  },
  {
    name: "Zamora",
    country: "Mexico",
    subcountry: "Michoacán",
    geonameid: 3979802,
  },
  {
    name: "Zacoalco",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 3979822,
  },
  {
    name: "Zacatecas",
    country: "Mexico",
    subcountry: "Zacatecas",
    geonameid: 3979844,
  },
  {
    name: "Zacapú",
    country: "Mexico",
    subcountry: "Michoacán",
    geonameid: 3979846,
  },
  {
    name: "Yuriria",
    country: "Mexico",
    subcountry: "Guanajuato",
    geonameid: 3979855,
  },
  {
    name: "Yurécuaro",
    country: "Mexico",
    subcountry: "Michoacán",
    geonameid: 3979856,
  },
  {
    name: "Villa Hidalgo",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 3980169,
  },
  {
    name: "Villagrán",
    country: "Mexico",
    subcountry: "Guanajuato",
    geonameid: 3980174,
  },
  {
    name: "Frontera",
    country: "Mexico",
    subcountry: "Coahuila",
    geonameid: 3980180,
  },
  {
    name: "El Pueblito",
    country: "Mexico",
    subcountry: "Querétaro",
    geonameid: 3980187,
  },
  {
    name: "García",
    country: "Mexico",
    subcountry: "Nuevo León",
    geonameid: 3980190,
  },
  {
    name: "Ciudad de Villa de Álvarez",
    country: "Mexico",
    subcountry: "Colima",
    geonameid: 3980194,
  },
  {
    name: "Valle de Santiago",
    country: "Mexico",
    subcountry: "Guanajuato",
    geonameid: 3980605,
  },
  {
    name: "Valle de Bravo",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3980621,
  },
  {
    name: "Uruapan",
    country: "Mexico",
    subcountry: "Michoacán",
    geonameid: 3980760,
  },
  {
    name: "Uriangato",
    country: "Mexico",
    subcountry: "Guanajuato",
    geonameid: 3980777,
  },
  {
    name: "Tuzantla",
    country: "Mexico",
    subcountry: "Michoacán",
    geonameid: 3980833,
  },
  {
    name: "Tuxpan",
    country: "Mexico",
    subcountry: "Nayarit",
    geonameid: 3980841,
  },
  {
    name: "Tuxpan",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 3980844,
  },
  {
    name: "Torreón",
    country: "Mexico",
    subcountry: "Coahuila",
    geonameid: 3981254,
  },
  {
    name: "Tonalá",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 3981369,
  },
  {
    name: "Tlaquepaque",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 3981461,
  },
  {
    name: "Tlajomulco de Zúñiga",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 3981467,
  },
  {
    name: "Tijuana",
    country: "Mexico",
    subcountry: "Baja California",
    geonameid: 3981609,
  },
  {
    name: "Tesistán",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 3981791,
  },
  {
    name: "Tequila",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 3981885,
  },
  {
    name: "Tepic",
    country: "Mexico",
    subcountry: "Nayarit",
    geonameid: 3981941,
  },
  {
    name: "Tepatitlán de Morelos",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 3981984,
  },
  {
    name: "Tepalcatepec",
    country: "Mexico",
    subcountry: "Michoacán",
    geonameid: 3982007,
  },
  {
    name: "Teocaltiche",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 3982034,
  },
  {
    name: "Tejupilco de Hidalgo",
    country: "Mexico",
    subcountry: "México",
    geonameid: 3982121,
  },
  {
    name: "Técpan de Galeana",
    country: "Mexico",
    subcountry: "Guerrero",
    geonameid: 3982170,
  },
  {
    name: "Tecomán",
    country: "Mexico",
    subcountry: "Colima",
    geonameid: 3982213,
  },
  {
    name: "Tecate",
    country: "Mexico",
    subcountry: "Baja California",
    geonameid: 3982266,
  },
  {
    name: "Tangancícuaro de Arista",
    country: "Mexico",
    subcountry: "Michoacán",
    geonameid: 3982545,
  },
  {
    name: "Tamazula de Gordiano",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 3982567,
  },
  {
    name: "Tala",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 3982616,
  },
  {
    name: "Tacámbaro de Codallos",
    country: "Mexico",
    subcountry: "Michoacán",
    geonameid: 3982693,
  },
  {
    name: "Sombrerete",
    country: "Mexico",
    subcountry: "Zacatecas",
    geonameid: 3982887,
  },
  {
    name: "Soledad de Graciano Sánchez",
    country: "Mexico",
    subcountry: "San Luis Potosí",
    geonameid: 3982912,
  },
  {
    name: "Silao",
    country: "Mexico",
    subcountry: "Guanajuato",
    geonameid: 3983058,
  },
  {
    name: "Sayula",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 3983216,
  },
  {
    name: "Santiago Papasquiaro",
    country: "Mexico",
    subcountry: "Durango",
    geonameid: 3983631,
  },
  {
    name: "Santiago Ixcuintla",
    country: "Mexico",
    subcountry: "Nayarit",
    geonameid: 3983636,
  },
  {
    name: "Santiago",
    country: "Mexico",
    subcountry: "Nuevo León",
    geonameid: 3983671,
  },
  {
    name: "Santa Rosa Jauregui",
    country: "Mexico",
    subcountry: "Querétaro",
    geonameid: 3983820,
  },
  {
    name: "Santa Catarina",
    country: "Mexico",
    subcountry: "Nuevo León",
    geonameid: 3984583,
  },
  {
    name: "Santa Anita",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 3984679,
  },
  {
    name: "San Sebastián el Grande",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 3984790,
  },
  {
    name: "San Pedro",
    country: "Mexico",
    subcountry: "Coahuila",
    geonameid: 3985035,
  },
  {
    name: "San Pedro",
    country: "Mexico",
    subcountry: "Coahuila",
    geonameid: 3985129,
  },
  {
    name: "San Nicolás de los Garza",
    country: "Mexico",
    subcountry: "Nuevo León",
    geonameid: 3985241,
  },
  {
    name: "San Miguel el Alto",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 3985323,
  },
  {
    name: "San Miguel de Allende",
    country: "Mexico",
    subcountry: "Guanajuato",
    geonameid: 3985344,
  },
  {
    name: "San Luis Río Colorado",
    country: "Mexico",
    subcountry: "Sonora",
    geonameid: 3985604,
  },
  {
    name: "San Luis Potosí",
    country: "Mexico",
    subcountry: "San Luis Potosí",
    geonameid: 3985606,
  },
  {
    name: "San Luis de la Paz",
    country: "Mexico",
    subcountry: "Guanajuato",
    geonameid: 3985621,
  },
  {
    name: "Cabo San Lucas",
    country: "Mexico",
    subcountry: "Baja California Sur",
    geonameid: 3985710,
  },
  {
    name: "San Juan de los Lagos",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 3985865,
  },
  {
    name: "San José Iturbide",
    country: "Mexico",
    subcountry: "Guanajuato",
    geonameid: 3986088,
  },
  {
    name: "San José del Castillo",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 3986165,
  },
  {
    name: "San José del Cabo",
    country: "Mexico",
    subcountry: "Baja California Sur",
    geonameid: 3986172,
  },
  {
    name: "San Francisco del Rincón",
    country: "Mexico",
    subcountry: "Guanajuato",
    geonameid: 3986984,
  },
  {
    name: "San Francisco de los Romo",
    country: "Mexico",
    subcountry: "Aguascalientes",
    geonameid: 3986985,
  },
  {
    name: "San Felipe",
    country: "Mexico",
    subcountry: "Baja California",
    geonameid: 3987224,
  },
  {
    name: "San Felipe",
    country: "Mexico",
    subcountry: "Guanajuato",
    geonameid: 3987246,
  },
  {
    name: "Tlaltenango de Sánchez Román",
    country: "Mexico",
    subcountry: "Zacatecas",
    geonameid: 3987402,
  },
  {
    name: "San Buenaventura",
    country: "Mexico",
    subcountry: "Coahuila",
    geonameid: 3987500,
  },
  {
    name: "Nicolás R Casillas",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 3988025,
  },
  {
    name: "Salvatierra",
    country: "Mexico",
    subcountry: "Guanajuato",
    geonameid: 3988050,
  },
  {
    name: "Saltillo",
    country: "Mexico",
    subcountry: "Coahuila",
    geonameid: 3988086,
  },
  {
    name: "Salinas de Hidalgo",
    country: "Mexico",
    subcountry: "San Luis Potosí",
    geonameid: 3988169,
  },
  {
    name: "Salamanca",
    country: "Mexico",
    subcountry: "Guanajuato",
    geonameid: 3988214,
  },
  {
    name: "Sahuayo de Morelos",
    country: "Mexico",
    subcountry: "Michoacán",
    geonameid: 3988258,
  },
  {
    name: "Ciudad Sabinas Hidalgo",
    country: "Mexico",
    subcountry: "Nuevo León",
    geonameid: 3988327,
  },
  {
    name: "Sabinas",
    country: "Mexico",
    subcountry: "Coahuila",
    geonameid: 3988333,
  },
  {
    name: "Rosarito",
    country: "Mexico",
    subcountry: "Baja California",
    geonameid: 3988392,
  },
  {
    name: "El Rosario",
    country: "Mexico",
    subcountry: "Sinaloa",
    geonameid: 3988416,
  },
  {
    name: "Romita",
    country: "Mexico",
    subcountry: "Guanajuato",
    geonameid: 3988462,
  },
  {
    name: "Río Grande",
    country: "Mexico",
    subcountry: "Zacatecas",
    geonameid: 3988594,
  },
  {
    name: "Rincón de Romos",
    country: "Mexico",
    subcountry: "Aguascalientes",
    geonameid: 3988651,
  },
  {
    name: "Rancho La Gloria",
    country: "Mexico",
    subcountry: "Baja California",
    geonameid: 3990040,
  },
  {
    name: "Ramos Arizpe",
    country: "Mexico",
    subcountry: "Coahuila",
    geonameid: 3991043,
  },
  {
    name: "Santiago de Querétaro",
    country: "Mexico",
    subcountry: "Querétaro",
    geonameid: 3991164,
  },
  {
    name: "Puruándiro",
    country: "Mexico",
    subcountry: "Michoacán",
    geonameid: 3991219,
  },
  {
    name: "Purísima de Bustos",
    country: "Mexico",
    subcountry: "Guanajuato",
    geonameid: 3991226,
  },
  {
    name: "Puerto Vallarta",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 3991328,
  },
  {
    name: "Puerto Peñasco",
    country: "Mexico",
    subcountry: "Sonora",
    geonameid: 3991347,
  },
  {
    name: "Piedras Negras",
    country: "Mexico",
    subcountry: "Coahuila",
    geonameid: 3992619,
  },
  {
    name: "Petatlán",
    country: "Mexico",
    subcountry: "Guerrero",
    geonameid: 3992842,
  },
  {
    name: "Peribán de Ramos",
    country: "Mexico",
    subcountry: "Michoacán",
    geonameid: 3992919,
  },
  {
    name: "Pénjamo",
    country: "Mexico",
    subcountry: "Guanajuato",
    geonameid: 3992986,
  },
  {
    name: "Pátzcuaro",
    country: "Mexico",
    subcountry: "Michoacán",
    geonameid: 3993179,
  },
  {
    name: "Parras de la Fuente",
    country: "Mexico",
    subcountry: "Coahuila",
    geonameid: 3993335,
  },
  {
    name: "Paracho de Verduzco",
    country: "Mexico",
    subcountry: "Michoacán",
    geonameid: 3993457,
  },
  {
    name: "Palau",
    country: "Mexico",
    subcountry: "Coahuila",
    geonameid: 3993893,
  },
  {
    name: "Pabellón de Arteaga",
    country: "Mexico",
    subcountry: "Aguascalientes",
    geonameid: 3993985,
  },
  {
    name: "Ojinaga",
    country: "Mexico",
    subcountry: "Chihuahua",
    geonameid: 3994469,
  },
  {
    name: "Ocotlán",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 3994489,
  },
  {
    name: "Nuevo México",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 3994604,
  },
  {
    name: "Nuevo Casas Grandes",
    country: "Mexico",
    subcountry: "Chihuahua",
    geonameid: 3994616,
  },
  {
    name: "Nueva Rosita",
    country: "Mexico",
    subcountry: "Coahuila",
    geonameid: 3994667,
  },
  {
    name: "Nueva Italia de Ruiz",
    country: "Mexico",
    subcountry: "Michoacán",
    geonameid: 3994674,
  },
  {
    name: "Nochistlán de Mejía",
    country: "Mexico",
    subcountry: "Zacatecas",
    geonameid: 3994912,
  },
  {
    name: "Navolato",
    country: "Mexico",
    subcountry: "Sinaloa",
    geonameid: 3995017,
  },
  {
    name: "Navojoa",
    country: "Mexico",
    subcountry: "Sonora",
    geonameid: 3995019,
  },
  {
    name: "Nava",
    country: "Mexico",
    subcountry: "Coahuila",
    geonameid: 3995050,
  },
  {
    name: "Moroleón",
    country: "Mexico",
    subcountry: "Guanajuato",
    geonameid: 3995343,
  },
  {
    name: "Morelia",
    country: "Mexico",
    subcountry: "Michoacán",
    geonameid: 3995402,
  },
  {
    name: "Monterrey",
    country: "Mexico",
    subcountry: "Nuevo León",
    geonameid: 3995465,
  },
  {
    name: "Monclova",
    country: "Mexico",
    subcountry: "Coahuila",
    geonameid: 3995523,
  },
  {
    name: "Mezcales",
    country: "Mexico",
    subcountry: "Nayarit",
    geonameid: 3996030,
  },
  {
    name: "Mexicali",
    country: "Mexico",
    subcountry: "Baja California",
    geonameid: 3996069,
  },
  {
    name: "Meoqui",
    country: "Mexico",
    subcountry: "Chihuahua",
    geonameid: 3996234,
  },
  {
    name: "Ciudad Melchor Múzquiz",
    country: "Mexico",
    subcountry: "Coahuila",
    geonameid: 3996271,
  },
  {
    name: "Medina",
    country: "Mexico",
    subcountry: "Guanajuato",
    geonameid: 3996299,
  },
  {
    name: "Mazatlán",
    country: "Mexico",
    subcountry: "Sinaloa",
    geonameid: 3996322,
  },
  {
    name: "Matehuala",
    country: "Mexico",
    subcountry: "San Luis Potosí",
    geonameid: 3996387,
  },
  {
    name: "Matamoros",
    country: "Mexico",
    subcountry: "Coahuila",
    geonameid: 3996426,
  },
  {
    name: "Marfil",
    country: "Mexico",
    subcountry: "Guanajuato",
    geonameid: 3996595,
  },
  {
    name: "Maravatío de Ocampo",
    country: "Mexico",
    subcountry: "Michoacán",
    geonameid: 3996626,
  },
  {
    name: "Manzanillo",
    country: "Mexico",
    subcountry: "Colima",
    geonameid: 3996663,
  },
  {
    name: "Rodolfo Sánchez Taboada",
    country: "Mexico",
    subcountry: "Baja California",
    geonameid: 3996737,
  },
  {
    name: "Magdalena de Kino",
    country: "Mexico",
    subcountry: "Sonora",
    geonameid: 3996893,
  },
  {
    name: "Magdalena",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 3996910,
  },
  {
    name: "Madera",
    country: "Mexico",
    subcountry: "Chihuahua",
    geonameid: 3996956,
  },
  {
    name: "Los Reyes de Salgado",
    country: "Mexico",
    subcountry: "Michoacán",
    geonameid: 3997211,
  },
  {
    name: "Los Mochis",
    country: "Mexico",
    subcountry: "Sinaloa",
    geonameid: 3997479,
  },
  {
    name: "Loreto",
    country: "Mexico",
    subcountry: "Zacatecas",
    geonameid: 3998291,
  },
  {
    name: "León de los Aldama",
    country: "Mexico",
    subcountry: "Guanajuato",
    geonameid: 3998655,
  },
  {
    name: "Las Pintas de Arriba",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 3999325,
  },
  {
    name: "La Piedad",
    country: "Mexico",
    subcountry: "Michoacán",
    geonameid: 4000821,
  },
  {
    name: "La Paz",
    country: "Mexico",
    subcountry: "Baja California Sur",
    geonameid: 4000900,
  },
  {
    name: "La Orilla",
    country: "Mexico",
    subcountry: "Michoacán",
    geonameid: 4001056,
  },
  {
    name: "Lagos de Moreno",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 4002224,
  },
  {
    name: "La Cruz",
    country: "Mexico",
    subcountry: "Sinaloa",
    geonameid: 4002745,
  },
  {
    name: "La Barca",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 4003526,
  },
  {
    name: "Juventino Rosas",
    country: "Mexico",
    subcountry: "Guanajuato",
    geonameid: 4003662,
  },
  {
    name: "Ciudad Benito Juárez",
    country: "Mexico",
    subcountry: "Nuevo León",
    geonameid: 4003757,
  },
  {
    name: "Juan Aldama",
    country: "Mexico",
    subcountry: "Zacatecas",
    geonameid: 4003804,
  },
  {
    name: "Jocotepec",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 4003908,
  },
  {
    name: "Jiquílpan de Juárez",
    country: "Mexico",
    subcountry: "Michoacán",
    geonameid: 4003923,
  },
  {
    name: "Jesús María",
    country: "Mexico",
    subcountry: "Aguascalientes",
    geonameid: 4003995,
  },
  {
    name: "Jerez de García Salinas",
    country: "Mexico",
    subcountry: "Zacatecas",
    geonameid: 4004024,
  },
  {
    name: "Jaral del Progreso",
    country: "Mexico",
    subcountry: "Guanajuato",
    geonameid: 4004092,
  },
  {
    name: "Jamay",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 4004126,
  },
  {
    name: "Jalostotitlán",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 4004153,
  },
  {
    name: "Xalisco",
    country: "Mexico",
    subcountry: "Nayarit",
    geonameid: 4004159,
  },
  {
    name: "Jacona de Plancarte",
    country: "Mexico",
    subcountry: "Michoacán",
    geonameid: 4004198,
  },
  {
    name: "Ixtlán del Río",
    country: "Mexico",
    subcountry: "Nayarit",
    geonameid: 4004267,
  },
  {
    name: "Ixtapa",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 4004293,
  },
  {
    name: "Irapuato",
    country: "Mexico",
    subcountry: "Guanajuato",
    geonameid: 4004330,
  },
  {
    name: "Huetamo de Núñez",
    country: "Mexico",
    subcountry: "Michoacán",
    geonameid: 4004555,
  },
  {
    name: "Huatabampo",
    country: "Mexico",
    subcountry: "Sonora",
    geonameid: 4004647,
  },
  {
    name: "Parral",
    country: "Mexico",
    subcountry: "Chihuahua",
    geonameid: 4004867,
  },
  {
    name: "Heróica Zitácuaro",
    country: "Mexico",
    subcountry: "Michoacán",
    geonameid: 4004885,
  },
  {
    name: "Nogales",
    country: "Mexico",
    subcountry: "Sonora",
    geonameid: 4004886,
  },
  {
    name: "Heroica Caborca",
    country: "Mexico",
    subcountry: "Sonora",
    geonameid: 4004887,
  },
  {
    name: "Hermosillo",
    country: "Mexico",
    subcountry: "Sonora",
    geonameid: 4004898,
  },
  {
    name: "Heroica Guaymas",
    country: "Mexico",
    subcountry: "Sonora",
    geonameid: 4005143,
  },
  {
    name: "Guasave",
    country: "Mexico",
    subcountry: "Sinaloa",
    geonameid: 4005219,
  },
  {
    name: "Guanajuato",
    country: "Mexico",
    subcountry: "Guanajuato",
    geonameid: 4005270,
  },
  {
    name: "Guamúchil",
    country: "Mexico",
    subcountry: "Sinaloa",
    geonameid: 4005297,
  },
  {
    name: "Ciudad Guadalupe Victoria",
    country: "Mexico",
    subcountry: "Durango",
    geonameid: 4005380,
  },
  {
    name: "Guadalupe",
    country: "Mexico",
    subcountry: "Nuevo León",
    geonameid: 4005492,
  },
  {
    name: "Guadalupe",
    country: "Mexico",
    subcountry: "Zacatecas",
    geonameid: 4005509,
  },
  {
    name: "Guadalajara",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 4005539,
  },
  {
    name: "Gómez Palacio",
    country: "Mexico",
    subcountry: "Durango",
    geonameid: 4005775,
  },
  {
    name: "Vicente Guerrero",
    country: "Mexico",
    subcountry: "Durango",
    geonameid: 4005857,
  },
  {
    name: "Juan José Ríos",
    country: "Mexico",
    subcountry: "Sinaloa",
    geonameid: 4005864,
  },
  {
    name: "Ciudad General Escobedo",
    country: "Mexico",
    subcountry: "Nuevo León",
    geonameid: 4005867,
  },
  {
    name: "San Pedro Garza García",
    country: "Mexico",
    subcountry: "Nuevo León",
    geonameid: 4005937,
  },
  {
    name: "Fresnillo",
    country: "Mexico",
    subcountry: "Zacatecas",
    geonameid: 4006163,
  },
  {
    name: "Francisco I. Madero",
    country: "Mexico",
    subcountry: "Coahuila",
    geonameid: 4006194,
  },
  {
    name: "Escuinapa",
    country: "Mexico",
    subcountry: "Sinaloa",
    geonameid: 4006622,
  },
  {
    name: "Ensenada",
    country: "Mexico",
    subcountry: "Baja California",
    geonameid: 4006702,
  },
  {
    name: "Encarnación de Díaz",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 4006783,
  },
  {
    name: "Empalme",
    country: "Mexico",
    subcountry: "Sonora",
    geonameid: 4006806,
  },
  {
    name: "El Salto",
    country: "Mexico",
    subcountry: "Durango",
    geonameid: 4007673,
  },
  {
    name: "Pueblo Nuevo",
    country: "Mexico",
    subcountry: "Durango",
    geonameid: 4007676,
  },
  {
    name: "El Salto",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 4007682,
  },
  {
    name: "El Salto",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 4007684,
  },
  {
    name: "El Quince",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 4008224,
  },
  {
    name: "El Grullo",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 4009697,
  },
  {
    name: "Puebla",
    country: "Mexico",
    subcountry: "Baja California",
    geonameid: 4011469,
  },
  {
    name: "Esperanza",
    country: "Mexico",
    subcountry: "Sonora",
    geonameid: 4011668,
  },
  {
    name: "Victoria de Durango",
    country: "Mexico",
    subcountry: "Durango",
    geonameid: 4011743,
  },
  {
    name: "Culiacán",
    country: "Mexico",
    subcountry: "Sinaloa",
    geonameid: 4012176,
  },
  {
    name: "Cuauhtémoc",
    country: "Mexico",
    subcountry: "Chihuahua",
    geonameid: 4012406,
  },
  {
    name: "Coyula",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 4012605,
  },
  {
    name: "Villa de Costa Rica",
    country: "Mexico",
    subcountry: "Sinaloa",
    geonameid: 4012693,
  },
  {
    name: "Cortazar",
    country: "Mexico",
    subcountry: "Guanajuato",
    geonameid: 4012721,
  },
  {
    name: "Compostela",
    country: "Mexico",
    subcountry: "Nayarit",
    geonameid: 4013085,
  },
  {
    name: "Comonfort",
    country: "Mexico",
    subcountry: "Guanajuato",
    geonameid: 4013094,
  },
  {
    name: "Colima",
    country: "Mexico",
    subcountry: "Colima",
    geonameid: 4013516,
  },
  {
    name: "Ciudad Obregón",
    country: "Mexico",
    subcountry: "Sonora",
    geonameid: 4013704,
  },
  {
    name: "Ciudad Lerdo",
    country: "Mexico",
    subcountry: "Durango",
    geonameid: 4013706,
  },
  {
    name: "Ciudad Juárez",
    country: "Mexico",
    subcountry: "Chihuahua",
    geonameid: 4013708,
  },
  {
    name: "José Mariano Jiménez",
    country: "Mexico",
    subcountry: "Chihuahua",
    geonameid: 4013710,
  },
  {
    name: "Ciudad Hidalgo",
    country: "Mexico",
    subcountry: "Michoacán",
    geonameid: 4013712,
  },
  {
    name: "Ciudad Guzmán",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 4013714,
  },
  {
    name: "Ciudad Delicias",
    country: "Mexico",
    subcountry: "Chihuahua",
    geonameid: 4013720,
  },
  {
    name: "Ciudad Constitución",
    country: "Mexico",
    subcountry: "Baja California Sur",
    geonameid: 4013723,
  },
  {
    name: "Camargo",
    country: "Mexico",
    subcountry: "Chihuahua",
    geonameid: 4013724,
  },
  {
    name: "Anáhuac",
    country: "Mexico",
    subcountry: "Nuevo León",
    geonameid: 4013726,
  },
  {
    name: "Ciudad Altamirano",
    country: "Mexico",
    subcountry: "Guerrero",
    geonameid: 4013727,
  },
  {
    name: "Ciudad Acuña",
    country: "Mexico",
    subcountry: "Coahuila",
    geonameid: 4013728,
  },
  {
    name: "Ciénega de Flores",
    country: "Mexico",
    subcountry: "Nuevo León",
    geonameid: 4013892,
  },
  {
    name: "Chihuahua",
    country: "Mexico",
    subcountry: "Chihuahua",
    geonameid: 4014338,
  },
  {
    name: "Chapala",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 4014553,
  },
  {
    name: "Celaya",
    country: "Mexico",
    subcountry: "Guanajuato",
    geonameid: 4014875,
  },
  {
    name: "Castaños",
    country: "Mexico",
    subcountry: "Coahuila",
    geonameid: 4015022,
  },
  {
    name: "Cananea",
    country: "Mexico",
    subcountry: "Sonora",
    geonameid: 4015700,
  },
  {
    name: "Villa Juárez",
    country: "Mexico",
    subcountry: "Sinaloa",
    geonameid: 4015938,
  },
  {
    name: "Calvillo",
    country: "Mexico",
    subcountry: "Aguascalientes",
    geonameid: 4016086,
  },
  {
    name: "Víctor Rosales",
    country: "Mexico",
    subcountry: "Zacatecas",
    geonameid: 4016132,
  },
  {
    name: "Autlán de Navarro",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 4017957,
  },
  {
    name: "Atoyac de Álvarez",
    country: "Mexico",
    subcountry: "Guerrero",
    geonameid: 4017984,
  },
  {
    name: "Atotonilco el Alto",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 4017992,
  },
  {
    name: "Ciudad de Armería",
    country: "Mexico",
    subcountry: "Colima",
    geonameid: 4018227,
  },
  {
    name: "Ario de Rosales",
    country: "Mexico",
    subcountry: "Michoacán",
    geonameid: 4018254,
  },
  {
    name: "Arcelia",
    country: "Mexico",
    subcountry: "Guerrero",
    geonameid: 4018320,
  },
  {
    name: "Arandas",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 4018348,
  },
  {
    name: "Ciudad Apodaca",
    country: "Mexico",
    subcountry: "Nuevo León",
    geonameid: 4018390,
  },
  {
    name: "Apatzingán",
    country: "Mexico",
    subcountry: "Michoacán",
    geonameid: 4018400,
  },
  {
    name: "Apaseo el Grande",
    country: "Mexico",
    subcountry: "Guanajuato",
    geonameid: 4018403,
  },
  {
    name: "Apaseo el Alto",
    country: "Mexico",
    subcountry: "Guanajuato",
    geonameid: 4018404,
  },
  {
    name: "Ameca",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 4018582,
  },
  {
    name: "Allende",
    country: "Mexico",
    subcountry: "Coahuila",
    geonameid: 4018761,
  },
  {
    name: "Ciudad de Allende",
    country: "Mexico",
    subcountry: "Nuevo León",
    geonameid: 4018762,
  },
  {
    name: "Aldama",
    country: "Mexico",
    subcountry: "Chihuahua",
    geonameid: 4018831,
  },
  {
    name: "Ahualulco de Mercado",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 4019082,
  },
  {
    name: "Aguascalientes",
    country: "Mexico",
    subcountry: "Aguascalientes",
    geonameid: 4019233,
  },
  {
    name: "Agua Prieta",
    country: "Mexico",
    subcountry: "Sonora",
    geonameid: 4019260,
  },
  {
    name: "Acaponeta",
    country: "Mexico",
    subcountry: "Nayarit",
    geonameid: 4019819,
  },
  {
    name: "Acámbaro",
    country: "Mexico",
    subcountry: "Guanajuato",
    geonameid: 4019827,
  },
  {
    name: "Abasolo",
    country: "Mexico",
    subcountry: "Guanajuato",
    geonameid: 4019869,
  },
  {
    name: "Hidalgo",
    country: "Mexico",
    subcountry: "Nuevo León",
    geonameid: 4022735,
  },
  {
    name: "Dolores Hidalgo",
    country: "Mexico",
    subcountry: "Guanajuato",
    geonameid: 4023117,
  },
  {
    name: "Guacamayas",
    country: "Mexico",
    subcountry: "Michoacán",
    geonameid: 4026075,
  },
  {
    name: "Ciudad Lázaro Cárdenas",
    country: "Mexico",
    subcountry: "Michoacán",
    geonameid: 4026082,
  },
  {
    name: "San José del Valle",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 4029308,
  },
  {
    name: "Benito Juárez",
    country: "Mexico",
    subcountry: "Mexico City",
    geonameid: 6957079,
  },
  {
    name: "Colonia del Valle",
    country: "Mexico",
    subcountry: "Mexico City",
    geonameid: 7280708,
  },
  {
    name: "Colonia Lindavista",
    country: "Mexico",
    subcountry: "México",
    geonameid: 7280711,
  },
  {
    name: "Colonia Nativitas",
    country: "Mexico",
    subcountry: "Mexico City",
    geonameid: 7280718,
  },
  {
    name: "Las Delicias",
    country: "Mexico",
    subcountry: "Baja California",
    geonameid: 8599061,
  },
  {
    name: "Hacienda Santa Fe",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 8858085,
  },
  {
    name: "Fuentes del Valle",
    country: "Mexico",
    subcountry: "México",
    geonameid: 8858086,
  },
  {
    name: "San Salvador Tizatlalli",
    country: "Mexico",
    subcountry: "México",
    geonameid: 8858087,
  },
  {
    name: "Jardines de la Silla (Jardines)",
    country: "Mexico",
    subcountry: "Nuevo León",
    geonameid: 8858088,
  },
  {
    name: "San Buenaventura",
    country: "Mexico",
    subcountry: "México",
    geonameid: 8858089,
  },
  {
    name: "Santa Teresa",
    country: "Mexico",
    subcountry: "México",
    geonameid: 8858090,
  },
  {
    name: "San Jerónimo Cuatro Vientos",
    country: "Mexico",
    subcountry: "México",
    geonameid: 8858091,
  },
  {
    name: "San Martín Azcatepec",
    country: "Mexico",
    subcountry: "México",
    geonameid: 8858092,
  },
  {
    name: "Fraccionamiento Real Palmas",
    country: "Mexico",
    subcountry: "Nuevo León",
    geonameid: 8858093,
  },
  {
    name: "Pórticos de San Antonio",
    country: "Mexico",
    subcountry: "Baja California",
    geonameid: 8858094,
  },
  {
    name: "San Isidro",
    country: "Mexico",
    subcountry: "México",
    geonameid: 8858095,
  },
  {
    name: "Centro Familiar la Soledad",
    country: "Mexico",
    subcountry: "Guanajuato",
    geonameid: 8858096,
  },
  {
    name: "San José Guadalupe Otzacatipan",
    country: "Mexico",
    subcountry: "México",
    geonameid: 8858097,
  },
  {
    name: "Las Pintitas",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 8858098,
  },
  {
    name: "Emiliano Zapata",
    country: "Mexico",
    subcountry: "México",
    geonameid: 8858099,
  },
  {
    name: "San Antonio Tecómitl",
    country: "Mexico",
    subcountry: "Mexico City",
    geonameid: 8858100,
  },
  {
    name: "Licenciado Benito Juárez",
    country: "Mexico",
    subcountry: "Sinaloa",
    geonameid: 8858101,
  },
  {
    name: "Teotihuacán de Arista",
    country: "Mexico",
    subcountry: "México",
    geonameid: 8858102,
  },
  {
    name: "Jesús del Monte",
    country: "Mexico",
    subcountry: "México",
    geonameid: 8858103,
  },
  {
    name: "San Jorge Pueblo Nuevo",
    country: "Mexico",
    subcountry: "México",
    geonameid: 8858104,
  },
  {
    name: "Manuel Ojinaga",
    country: "Mexico",
    subcountry: "Chihuahua",
    geonameid: 8858105,
  },
  {
    name: "Terrazas del Valle",
    country: "Mexico",
    subcountry: "Baja California",
    geonameid: 8858106,
  },
  {
    name: "La Ermita",
    country: "Mexico",
    subcountry: "Guanajuato",
    geonameid: 8858107,
  },
  {
    name: "Lomas del Sur",
    country: "Mexico",
    subcountry: "Jalisco",
    geonameid: 8858108,
  },
  {
    name: "Parque Industrial Ciudad Mitras",
    country: "Mexico",
    subcountry: "Nuevo León",
    geonameid: 8858109,
  },
  {
    name: "Mitras Poniente",
    country: "Mexico",
    subcountry: "Nuevo León",
    geonameid: 8858110,
  },
  {
    name: "Villa del Prado 2da Sección",
    country: "Mexico",
    subcountry: "Baja California",
    geonameid: 8858111,
  },
  {
    name: "Tres de Mayo",
    country: "Mexico",
    subcountry: "Morelos",
    geonameid: 8858112,
  },
  {
    name: "Don Antonio",
    country: "Mexico",
    subcountry: "Hidalgo",
    geonameid: 8858113,
  },
  {
    name: "Casa Blanca",
    country: "Mexico",
    subcountry: "Puebla",
    geonameid: 8858116,
  },
  {
    name: "La Providencia Siglo XXI",
    country: "Mexico",
    subcountry: "Hidalgo",
    geonameid: 8858117,
  },
  {
    name: "Ampliación San Mateo",
    country: "Mexico",
    subcountry: "México",
    geonameid: 8858118,
  },
  {
    name: "Fraccionamiento Ciudad Olmeca",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 8858119,
  },
  {
    name: "San Rafael Tlanalapan",
    country: "Mexico",
    subcountry: "Puebla",
    geonameid: 8858120,
  },
  {
    name: "Tecámac de Felipe Villanueva",
    country: "Mexico",
    subcountry: "México",
    geonameid: 8858121,
  },
  {
    name: "Venceremos",
    country: "Mexico",
    subcountry: "Querétaro",
    geonameid: 8858122,
  },
  {
    name: "Alborada Jaltenco",
    country: "Mexico",
    subcountry: "México",
    geonameid: 8858123,
  },
  {
    name: "Crucecita",
    country: "Mexico",
    subcountry: "Oaxaca",
    geonameid: 8858124,
  },
  {
    name: "San Jose de los Olvera",
    country: "Mexico",
    subcountry: "Querétaro",
    geonameid: 9511750,
  },
  {
    name: "Zacapu",
    country: "Mexico",
    subcountry: "Michoacán",
    geonameid: 11044505,
  },
  {
    name: "Colonia del Sol",
    country: "Mexico",
    subcountry: "Baja California Sur",
    geonameid: 11121204,
  },
  {
    name: "Tres Valles",
    country: "Mexico",
    subcountry: "Veracruz",
    geonameid: 11839902,
  },
  {
    name: "Kuah",
    country: "Malaysia",
    subcountry: "Kedah",
    geonameid: 1222396,
  },
  {
    name: "Jerantut",
    country: "Malaysia",
    subcountry: "Pahang",
    geonameid: 1732602,
  },
  {
    name: "Raub",
    country: "Malaysia",
    subcountry: "Pahang",
    geonameid: 1732663,
  },
  {
    name: "Batu Pahat",
    country: "Malaysia",
    subcountry: "Johor",
    geonameid: 1732687,
  },
  {
    name: "Parit Raja",
    country: "Malaysia",
    subcountry: "Johor",
    geonameid: 1732698,
  },
  {
    name: "Pekan Nenas",
    country: "Malaysia",
    subcountry: "Johor",
    geonameid: 1732706,
  },
  {
    name: "Pontian Kechil",
    country: "Malaysia",
    subcountry: "Johor",
    geonameid: 1732711,
  },
  {
    name: "Kampung Pasir Gudang Baru",
    country: "Malaysia",
    subcountry: "Johor",
    geonameid: 1732721,
  },
  {
    name: "Kota Tinggi",
    country: "Malaysia",
    subcountry: "Johor",
    geonameid: 1732738,
  },
  {
    name: "Taman Senai",
    country: "Malaysia",
    subcountry: "Johor",
    geonameid: 1732741,
  },
  {
    name: "Kulai",
    country: "Malaysia",
    subcountry: "Johor",
    geonameid: 1732742,
  },
  {
    name: "Skudai",
    country: "Malaysia",
    subcountry: "Johor",
    geonameid: 1732745,
  },
  {
    name: "Johor Bahru",
    country: "Malaysia",
    subcountry: "Johor",
    geonameid: 1732752,
  },
  {
    name: "Kluang",
    country: "Malaysia",
    subcountry: "Johor",
    geonameid: 1732811,
  },
  {
    name: "Yong Peng",
    country: "Malaysia",
    subcountry: "Johor",
    geonameid: 1732814,
  },
  {
    name: "Mersing",
    country: "Malaysia",
    subcountry: "Johor",
    geonameid: 1732826,
  },
  {
    name: "Segamat",
    country: "Malaysia",
    subcountry: "Johor",
    geonameid: 1732846,
  },
  {
    name: "Tangkak",
    country: "Malaysia",
    subcountry: "Johor",
    geonameid: 1732857,
  },
  {
    name: "Muar",
    country: "Malaysia",
    subcountry: "Johor",
    geonameid: 1732869,
  },
  {
    name: "Bakri",
    country: "Malaysia",
    subcountry: "Johor",
    geonameid: 1732871,
  },
  {
    name: "Labis",
    country: "Malaysia",
    subcountry: "Johor",
    geonameid: 1732877,
  },
  {
    name: "Kuala Selangor",
    country: "Malaysia",
    subcountry: "Selangor",
    geonameid: 1732891,
  },
  {
    name: "Batang Berjuntai",
    country: "Malaysia",
    subcountry: "Selangor",
    geonameid: 1732892,
  },
  {
    name: "Batu Arang",
    country: "Malaysia",
    subcountry: "Selangor",
    geonameid: 1732893,
  },
  {
    name: "Shah Alam",
    country: "Malaysia",
    subcountry: "Selangor",
    geonameid: 1732903,
  },
  {
    name: "Klang",
    country: "Malaysia",
    subcountry: "Selangor",
    geonameid: 1732905,
  },
  {
    name: "Cukai",
    country: "Malaysia",
    subcountry: "Terengganu",
    geonameid: 1732945,
  },
  {
    name: "Kuala Lipis",
    country: "Malaysia",
    subcountry: "Pahang",
    geonameid: 1733023,
  },
  {
    name: "Papar",
    country: "Malaysia",
    subcountry: "Sabah",
    geonameid: 1733353,
  },
  {
    name: "Kota Kinabalu",
    country: "Malaysia",
    subcountry: "Sabah",
    geonameid: 1733432,
  },
  {
    name: "Donggongon",
    country: "Malaysia",
    subcountry: "Sabah",
    geonameid: 1733438,
  },
  {
    name: "Putatan",
    country: "Malaysia",
    subcountry: "Sabah",
    geonameid: 1733440,
  },
  {
    name: "Kinarut",
    country: "Malaysia",
    subcountry: "Sabah",
    geonameid: 1733449,
  },
  {
    name: "Ranau",
    country: "Malaysia",
    subcountry: "Sabah",
    geonameid: 1733502,
  },
  {
    name: "Semporna",
    country: "Malaysia",
    subcountry: "Sabah",
    geonameid: 1733697,
  },
  {
    name: "Labuan",
    country: "Malaysia",
    subcountry: "Labuan",
    geonameid: 1733782,
  },
  {
    name: "Beaufort",
    country: "Malaysia",
    subcountry: "Sabah",
    geonameid: 1733874,
  },
  {
    name: "Lahad Datu",
    country: "Malaysia",
    subcountry: "Sabah",
    geonameid: 1733953,
  },
  {
    name: "Sandakan",
    country: "Malaysia",
    subcountry: "Sabah",
    geonameid: 1734052,
  },
  {
    name: "Keningau",
    country: "Malaysia",
    subcountry: "Sabah",
    geonameid: 1734098,
  },
  {
    name: "Tawau",
    country: "Malaysia",
    subcountry: "Sabah",
    geonameid: 1734199,
  },
  {
    name: "Paka",
    country: "Malaysia",
    subcountry: "Terengganu",
    geonameid: 1734313,
  },
  {
    name: "Kertih",
    country: "Malaysia",
    subcountry: "Terengganu",
    geonameid: 1734316,
  },
  {
    name: "Kulim",
    country: "Malaysia",
    subcountry: "Kedah",
    geonameid: 1734393,
  },
  {
    name: "Bagan Serai",
    country: "Malaysia",
    subcountry: "Perak",
    geonameid: 1734409,
  },
  {
    name: "Bedong",
    country: "Malaysia",
    subcountry: "Kedah",
    geonameid: 1734439,
  },
  {
    name: "Simpang Empat",
    country: "Malaysia",
    subcountry: "Perak",
    geonameid: 1734576,
  },
  {
    name: "Taiping",
    country: "Malaysia",
    subcountry: "Perak",
    geonameid: 1734586,
  },
  {
    name: "Kuala Kangsar",
    country: "Malaysia",
    subcountry: "Perak",
    geonameid: 1734599,
  },
  {
    name: "Ipoh",
    country: "Malaysia",
    subcountry: "Perak",
    geonameid: 1734634,
  },
  {
    name: "Gua Musang",
    country: "Malaysia",
    subcountry: "Kelantan",
    geonameid: 1734651,
  },
  {
    name: "Kuala Terengganu",
    country: "Malaysia",
    subcountry: "Terengganu",
    geonameid: 1734705,
  },
  {
    name: "Marang",
    country: "Malaysia",
    subcountry: "Terengganu",
    geonameid: 1734715,
  },
  {
    name: "Tampin",
    country: "Malaysia",
    subcountry: "Negeri Sembilan",
    geonameid: 1734738,
  },
  {
    name: "Alor Gajah",
    country: "Malaysia",
    subcountry: "Melaka",
    geonameid: 1734745,
  },
  {
    name: "Kampung Ayer Keroh",
    country: "Malaysia",
    subcountry: "Melaka",
    geonameid: 1734753,
  },
  {
    name: "Sungai Udang",
    country: "Malaysia",
    subcountry: "Melaka",
    geonameid: 1734757,
  },
  {
    name: "Malacca",
    country: "Malaysia",
    subcountry: "Melaka",
    geonameid: 1734759,
  },
  {
    name: "Pelabuhan Klang",
    country: "Malaysia",
    subcountry: "Selangor",
    geonameid: 1734769,
  },
  {
    name: "Banting",
    country: "Malaysia",
    subcountry: "Selangor",
    geonameid: 1734781,
  },
  {
    name: "Jenjarum",
    country: "Malaysia",
    subcountry: "Selangor",
    geonameid: 1734793,
  },
  {
    name: "Semenyih",
    country: "Malaysia",
    subcountry: "Selangor",
    geonameid: 1734798,
  },
  {
    name: "Seremban",
    country: "Malaysia",
    subcountry: "Negeri Sembilan",
    geonameid: 1734810,
  },
  {
    name: "Port Dickson",
    country: "Malaysia",
    subcountry: "Negeri Sembilan",
    geonameid: 1734815,
  },
  {
    name: "Sepang",
    country: "Malaysia",
    subcountry: "Selangor",
    geonameid: 1734821,
  },
  {
    name: "Bahau",
    country: "Malaysia",
    subcountry: "Negeri Sembilan",
    geonameid: 1734839,
  },
  {
    name: "Kuala Pilah",
    country: "Malaysia",
    subcountry: "Negeri Sembilan",
    geonameid: 1734841,
  },
  {
    name: "Pekan",
    country: "Malaysia",
    subcountry: "Pahang",
    geonameid: 1734971,
  },
  {
    name: "Mentekab",
    country: "Malaysia",
    subcountry: "Pahang",
    geonameid: 1735018,
  },
  {
    name: "Temerluh",
    country: "Malaysia",
    subcountry: "Pahang",
    geonameid: 1735022,
  },
  {
    name: "Batu Feringgi",
    country: "Malaysia",
    subcountry: "Penang",
    geonameid: 1735074,
  },
  {
    name: "Butterworth",
    country: "Malaysia",
    subcountry: "Penang",
    geonameid: 1735076,
  },
  {
    name: "Perai",
    country: "Malaysia",
    subcountry: "Penang",
    geonameid: 1735077,
  },
  {
    name: "Bukit Mertajam",
    country: "Malaysia",
    subcountry: "Penang",
    geonameid: 1735079,
  },
  {
    name: "Nibong Tebal",
    country: "Malaysia",
    subcountry: "Penang",
    geonameid: 1735086,
  },
  {
    name: "Parit Buntar",
    country: "Malaysia",
    subcountry: "Perak",
    geonameid: 1735089,
  },
  {
    name: "Tasek Glugor",
    country: "Malaysia",
    subcountry: "Penang",
    geonameid: 1735093,
  },
  {
    name: "George Town",
    country: "Malaysia",
    subcountry: "Penang",
    geonameid: 1735106,
  },
  {
    name: "Serendah",
    country: "Malaysia",
    subcountry: "Selangor",
    geonameid: 1735148,
  },
  {
    name: "Rawang",
    country: "Malaysia",
    subcountry: "Selangor",
    geonameid: 1735150,
  },
  {
    name: "Petaling Jaya",
    country: "Malaysia",
    subcountry: "Selangor",
    geonameid: 1735158,
  },
  {
    name: "Kuala Lumpur",
    country: "Malaysia",
    subcountry: "Kuala Lumpur",
    geonameid: 1735161,
  },
  {
    name: "Ampang",
    country: "Malaysia",
    subcountry: "Kuala Lumpur",
    geonameid: 1735168,
  },
  {
    name: "Sabak Bernam",
    country: "Malaysia",
    subcountry: "Selangor",
    geonameid: 1735195,
  },
  {
    name: "Sungai Besar",
    country: "Malaysia",
    subcountry: "Selangor",
    geonameid: 1735199,
  },
  {
    name: "Kuantan",
    country: "Malaysia",
    subcountry: "Pahang",
    geonameid: 1735227,
  },
  {
    name: "Batu Gajah",
    country: "Malaysia",
    subcountry: "Perak",
    geonameid: 1735268,
  },
  {
    name: "Kampar",
    country: "Malaysia",
    subcountry: "Perak",
    geonameid: 1735274,
  },
  {
    name: "Tapah Road",
    country: "Malaysia",
    subcountry: "Perak",
    geonameid: 1735282,
  },
  {
    name: "Bidur",
    country: "Malaysia",
    subcountry: "Perak",
    geonameid: 1735287,
  },
  {
    name: "Mukah",
    country: "Malaysia",
    subcountry: "Sarawak",
    geonameid: 1735339,
  },
  {
    name: "Lumut",
    country: "Malaysia",
    subcountry: "Perak",
    geonameid: 1735450,
  },
  {
    name: "Teluk Intan",
    country: "Malaysia",
    subcountry: "Perak",
    geonameid: 1735459,
  },
  {
    name: "Gurun",
    country: "Malaysia",
    subcountry: "Kedah",
    geonameid: 1735485,
  },
  {
    name: "Sungai Petani",
    country: "Malaysia",
    subcountry: "Kedah",
    geonameid: 1735498,
  },
  {
    name: "Kepala Batas",
    country: "Malaysia",
    subcountry: "Penang",
    geonameid: 1735506,
  },
  {
    name: "Tanah Merah",
    country: "Malaysia",
    subcountry: "Kelantan",
    geonameid: 1735553,
  },
  {
    name: "Kuching",
    country: "Malaysia",
    subcountry: "Sarawak",
    geonameid: 1735634,
  },
  {
    name: "Simanggang",
    country: "Malaysia",
    subcountry: "Sarawak",
    geonameid: 1735799,
  },
  {
    name: "Sarikei",
    country: "Malaysia",
    subcountry: "Sarawak",
    geonameid: 1735837,
  },
  {
    name: "Sibu",
    country: "Malaysia",
    subcountry: "Sarawak",
    geonameid: 1735902,
  },
  {
    name: "Kangar",
    country: "Malaysia",
    subcountry: "Perlis",
    geonameid: 1736278,
  },
  {
    name: "Jitra",
    country: "Malaysia",
    subcountry: "Kedah",
    geonameid: 1736302,
  },
  {
    name: "Kuala Kedah",
    country: "Malaysia",
    subcountry: "Kedah",
    geonameid: 1736305,
  },
  {
    name: "Alor Setar",
    country: "Malaysia",
    subcountry: "Kedah",
    geonameid: 1736309,
  },
  {
    name: "Pasir Mas",
    country: "Malaysia",
    subcountry: "Kelantan",
    geonameid: 1736372,
  },
  {
    name: "Kota Bharu",
    country: "Malaysia",
    subcountry: "Kelantan",
    geonameid: 1736376,
  },
  {
    name: "Kudat",
    country: "Malaysia",
    subcountry: "Sabah",
    geonameid: 1736458,
  },
  {
    name: "Kapit",
    country: "Malaysia",
    subcountry: "Sarawak",
    geonameid: 1737185,
  },
  {
    name: "Bintulu",
    country: "Malaysia",
    subcountry: "Sarawak",
    geonameid: 1737486,
  },
  {
    name: "Lawas",
    country: "Malaysia",
    subcountry: "Sarawak",
    geonameid: 1737589,
  },
  {
    name: "Limbang",
    country: "Malaysia",
    subcountry: "Sarawak",
    geonameid: 1737714,
  },
  {
    name: "Marudi",
    country: "Malaysia",
    subcountry: "Sarawak",
    geonameid: 1737919,
  },
  {
    name: "Miri",
    country: "Malaysia",
    subcountry: "Sarawak",
    geonameid: 1738050,
  },
  {
    name: "Ulu Tiram",
    country: "Malaysia",
    subcountry: "Johor",
    geonameid: 1738294,
  },
  {
    name: "Tanjung Tokong",
    country: "Malaysia",
    subcountry: "Penang",
    geonameid: 1741550,
  },
  {
    name: "Tanjung Sepat",
    country: "Malaysia",
    subcountry: "Selangor",
    geonameid: 1741562,
  },
  {
    name: "Permatang Kuching",
    country: "Malaysia",
    subcountry: "Penang",
    geonameid: 1750500,
  },
  {
    name: "Peringat",
    country: "Malaysia",
    subcountry: "Kelantan",
    geonameid: 1750582,
  },
  {
    name: "Ladang Seri Kundang",
    country: "Malaysia",
    subcountry: "Selangor",
    geonameid: 1750974,
  },
  {
    name: "Pantai Remis",
    country: "Malaysia",
    subcountry: "Perak",
    geonameid: 1752256,
  },
  {
    name: "Kuang",
    country: "Malaysia",
    subcountry: "Selangor",
    geonameid: 1759486,
  },
  {
    name: "Klebang Besar",
    country: "Malaysia",
    subcountry: "Melaka",
    geonameid: 1761242,
  },
  {
    name: "Kampung Tanjung Karang",
    country: "Malaysia",
    subcountry: "Selangor",
    geonameid: 1763412,
  },
  {
    name: "Kampung Sungai Ara",
    country: "Malaysia",
    subcountry: "Penang",
    geonameid: 1764160,
  },
  {
    name: "Kampung Simpang Renggam",
    country: "Malaysia",
    subcountry: "Johor",
    geonameid: 1764318,
  },
  {
    name: "Kampong Pangkal Kalong",
    country: "Malaysia",
    subcountry: "Kelantan",
    geonameid: 1766249,
  },
  {
    name: "Kampong Masjid Tanah",
    country: "Malaysia",
    subcountry: "Melaka",
    geonameid: 1767021,
  },
  {
    name: "Kampong Kadok",
    country: "Malaysia",
    subcountry: "Kelantan",
    geonameid: 1768664,
  },
  {
    name: "Kampong Dungun",
    country: "Malaysia",
    subcountry: "Perak",
    geonameid: 1769612,
  },
  {
    name: "Kampung Bukit Baharu",
    country: "Malaysia",
    subcountry: "Melaka",
    geonameid: 1770351,
  },
  {
    name: "Kampung Baru Subang",
    country: "Malaysia",
    subcountry: "Selangor",
    geonameid: 1771023,
  },
  {
    name: "Kampung Baharu Nilai",
    country: "Malaysia",
    subcountry: "Negeri Sembilan",
    geonameid: 1771287,
  },
  {
    name: "Kampong Baharu Balakong",
    country: "Malaysia",
    subcountry: "Selangor",
    geonameid: 1771304,
  },
  {
    name: "Kampung Ayer Molek",
    country: "Malaysia",
    subcountry: "Melaka",
    geonameid: 1771485,
  },
  {
    name: "Bukit Rambai",
    country: "Malaysia",
    subcountry: "Melaka",
    geonameid: 1778290,
  },
  {
    name: "Bentong Town",
    country: "Malaysia",
    subcountry: "Pahang",
    geonameid: 1779790,
  },
  {
    name: "Batu Berendam",
    country: "Malaysia",
    subcountry: "Melaka",
    geonameid: 1780890,
  },
  {
    name: "Putrajaya",
    country: "Malaysia",
    subcountry: "Putrajaya",
    geonameid: 6697380,
  },
  {
    name: "Bandar Labuan",
    country: "Malaysia",
    subcountry: "Sabah",
    geonameid: 7302815,
  },
  {
    name: "Subang Jaya",
    country: "Malaysia",
    subcountry: "Selangor",
    geonameid: 8504423,
  },
  {
    name: "Putra Heights",
    country: "Malaysia",
    subcountry: "Selangor",
    geonameid: 10792382,
  },
  {
    name: "Xai-Xai",
    country: "Mozambique",
    subcountry: "Gaza",
    geonameid: 1024552,
  },
  {
    name: "Dondo",
    country: "Mozambique",
    subcountry: "Sofala",
    geonameid: 1024696,
  },
  {
    name: "Chinde",
    country: "Mozambique",
    subcountry: "Zambézia",
    geonameid: 1024697,
  },
  {
    name: "Macia",
    country: "Mozambique",
    subcountry: "Gaza",
    geonameid: 1024701,
  },
  {
    name: "Tete",
    country: "Mozambique",
    subcountry: "Tete",
    geonameid: 1026014,
  },
  {
    name: "Ressano Garcia",
    country: "Mozambique",
    subcountry: "Maputo Province",
    geonameid: 1028079,
  },
  {
    name: "Quelimane",
    country: "Mozambique",
    subcountry: "Zambézia",
    geonameid: 1028434,
  },
  {
    name: "Pemba",
    country: "Mozambique",
    subcountry: "Cabo Delgado",
    geonameid: 1028918,
  },
  {
    name: "Nampula",
    country: "Mozambique",
    subcountry: "Nampula",
    geonameid: 1033356,
  },
  {
    name: "Nacala",
    country: "Mozambique",
    subcountry: "Nampula",
    geonameid: 1035025,
  },
  {
    name: "Montepuez",
    country: "Mozambique",
    subcountry: "Cabo Delgado",
    geonameid: 1037125,
  },
  {
    name: "Mocímboa",
    country: "Mozambique",
    subcountry: "Cabo Delgado",
    geonameid: 1037370,
  },
  {
    name: "Mozambique",
    country: "Mozambique",
    subcountry: "Nampula",
    geonameid: 1037390,
  },
  {
    name: "Maxixe",
    country: "Mozambique",
    subcountry: "Inhambane",
    geonameid: 1039536,
  },
  {
    name: "Matola",
    country: "Mozambique",
    subcountry: "Maputo Province",
    geonameid: 1039854,
  },
  {
    name: "Maputo",
    country: "Mozambique",
    subcountry: "Maputo City",
    geonameid: 1040652,
  },
  {
    name: "Mandimba",
    country: "Mozambique",
    subcountry: "Niassa",
    geonameid: 1041190,
  },
  {
    name: "Lichinga",
    country: "Mozambique",
    subcountry: "Niassa",
    geonameid: 1043893,
  },
  {
    name: "Inhambane",
    country: "Mozambique",
    subcountry: "Inhambane",
    geonameid: 1045114,
  },
  {
    name: "Cuamba",
    country: "Mozambique",
    subcountry: "Niassa",
    geonameid: 1047660,
  },
  {
    name: "Chokwé",
    country: "Mozambique",
    subcountry: "Gaza",
    geonameid: 1048364,
  },
  {
    name: "Chimoio",
    country: "Mozambique",
    subcountry: "Manica",
    geonameid: 1049261,
  },
  {
    name: "Chibuto",
    country: "Mozambique",
    subcountry: "Gaza",
    geonameid: 1049861,
  },
  {
    name: "Beira",
    country: "Mozambique",
    subcountry: "Sofala",
    geonameid: 1052373,
  },
  {
    name: "António Enes",
    country: "Mozambique",
    subcountry: "Nampula",
    geonameid: 1052944,
  },
  {
    name: "Mutuáli",
    country: "Mozambique",
    subcountry: "Nampula",
    geonameid: 1088155,
  },
  {
    name: "Katima Mulilo",
    country: "Namibia",
    subcountry: "Zambezi",
    geonameid: 877178,
  },
  {
    name: "Windhoek",
    country: "Namibia",
    subcountry: "Khomas",
    geonameid: 3352136,
  },
  {
    name: "Swakopmund",
    country: "Namibia",
    subcountry: "Erongo",
    geonameid: 3352844,
  },
  {
    name: "Rundu",
    country: "Namibia",
    subcountry: "Kavango East",
    geonameid: 3353383,
  },
  {
    name: "Rehoboth",
    country: "Namibia",
    subcountry: "Hardap",
    geonameid: 3353540,
  },
  {
    name: "Otjiwarongo",
    country: "Namibia",
    subcountry: "Otjozondjupa",
    geonameid: 3353811,
  },
  {
    name: "Oshakati",
    country: "Namibia",
    subcountry: "Oshana",
    geonameid: 3354021,
  },
  {
    name: "Okahandja",
    country: "Namibia",
    subcountry: "Otjozondjupa",
    geonameid: 3354898,
  },
  {
    name: "Lüderitz",
    country: "Namibia",
    subcountry: "Karas",
    geonameid: 3355672,
  },
  {
    name: "Keetmanshoop",
    country: "Namibia",
    subcountry: "Karas",
    geonameid: 3356264,
  },
  {
    name: "Katutura",
    country: "Namibia",
    subcountry: "Khomas",
    geonameid: 3356294,
  },
  {
    name: "Grootfontein",
    country: "Namibia",
    subcountry: "Otjozondjupa",
    geonameid: 3357114,
  },
  {
    name: "Gobabis",
    country: "Namibia",
    subcountry: "Omaheke",
    geonameid: 3357247,
  },
  {
    name: "Walvis Bay",
    country: "Namibia",
    subcountry: "Erongo",
    geonameid: 3359638,
  },
  {
    name: "Nouméa",
    country: "New Caledonia",
    subcountry: "South Province",
    geonameid: 2139521,
  },
  {
    name: "Mont-Dore",
    country: "New Caledonia",
    subcountry: "South Province",
    geonameid: 2140066,
  },
  {
    name: "Dumbéa",
    country: "New Caledonia",
    subcountry: "South Province",
    geonameid: 2141394,
  },
  {
    name: "Birni N Konni",
    country: "Niger",
    subcountry: "Tahoua",
    geonameid: 2437732,
  },
  {
    name: "Zinder",
    country: "Niger",
    subcountry: "Zinder",
    geonameid: 2437798,
  },
  {
    name: "Tillabéri",
    country: "Niger",
    subcountry: "Tillabéri",
    geonameid: 2438678,
  },
  {
    name: "Tibiri",
    country: "Niger",
    subcountry: "Maradi",
    geonameid: 2438774,
  },
  {
    name: "Tessaoua",
    country: "Niger",
    subcountry: "Maradi",
    geonameid: 2438823,
  },
  {
    name: "Téra",
    country: "Niger",
    subcountry: "Tillabéri",
    geonameid: 2438855,
  },
  {
    name: "Tanout",
    country: "Niger",
    subcountry: "Zinder",
    geonameid: 2439155,
  },
  {
    name: "Tahoua",
    country: "Niger",
    subcountry: "Tahoua",
    geonameid: 2439376,
  },
  {
    name: "Niamey",
    country: "Niger",
    subcountry: "Niamey",
    geonameid: 2440485,
  },
  {
    name: "Nguigmi",
    country: "Niger",
    subcountry: "Diffa",
    geonameid: 2440495,
  },
  {
    name: "Mirriah",
    country: "Niger",
    subcountry: "Zinder",
    geonameid: 2440921,
  },
  {
    name: "Mayahi",
    country: "Niger",
    subcountry: "Maradi",
    geonameid: 2441194,
  },
  {
    name: "Matamey",
    country: "Niger",
    subcountry: "Zinder",
    geonameid: 2441217,
  },
  {
    name: "Maradi",
    country: "Niger",
    subcountry: "Maradi",
    geonameid: 2441291,
  },
  {
    name: "Magaria",
    country: "Niger",
    subcountry: "Zinder",
    geonameid: 2441482,
  },
  {
    name: "Madaoua",
    country: "Niger",
    subcountry: "Tahoua",
    geonameid: 2441530,
  },
  {
    name: "Illéla",
    country: "Niger",
    subcountry: "Tahoua",
    geonameid: 2443304,
  },
  {
    name: "Gaya",
    country: "Niger",
    subcountry: "Dosso",
    geonameid: 2444489,
  },
  {
    name: "Dosso",
    country: "Niger",
    subcountry: "Dosso",
    geonameid: 2445488,
  },
  {
    name: "Dogondoutchi",
    country: "Niger",
    subcountry: "Dosso",
    geonameid: 2445553,
  },
  {
    name: "Diffa",
    country: "Niger",
    subcountry: "Diffa",
    geonameid: 2445704,
  },
  {
    name: "Dakoro",
    country: "Niger",
    subcountry: "Maradi",
    geonameid: 2446267,
  },
  {
    name: "Ayorou",
    country: "Niger",
    subcountry: "Tillabéri",
    geonameid: 2447416,
  },
  {
    name: "Alaghsas",
    country: "Niger",
    subcountry: "Agadez",
    geonameid: 2447938,
  },
  {
    name: "Agadez",
    country: "Niger",
    subcountry: "Agadez",
    geonameid: 2448085,
  },
  {
    name: "Kingston",
    country: "Norfolk Island",
    subcountry: "N/A",
    geonameid: 2161314,
  },
  {
    name: "Zuru",
    country: "Nigeria",
    subcountry: "Kebbi",
    geonameid: 2317548,
  },
  {
    name: "Zungeru",
    country: "Nigeria",
    subcountry: "Niger",
    geonameid: 2317569,
  },
  {
    name: "Zaria",
    country: "Nigeria",
    subcountry: "Kaduna",
    geonameid: 2317765,
  },
  {
    name: "Yola",
    country: "Nigeria",
    subcountry: "Adamawa",
    geonameid: 2318044,
  },
  {
    name: "Yenagoa",
    country: "Nigeria",
    subcountry: "Bayelsa",
    geonameid: 2318123,
  },
  {
    name: "Wukari",
    country: "Nigeria",
    subcountry: "Taraba",
    geonameid: 2318921,
  },
  {
    name: "Wudil",
    country: "Nigeria",
    subcountry: "Kano",
    geonameid: 2318933,
  },
  {
    name: "Warri",
    country: "Nigeria",
    subcountry: "Delta",
    geonameid: 2319133,
  },
  {
    name: "Wamba",
    country: "Nigeria",
    subcountry: "Nassarawa",
    geonameid: 2319257,
  },
  {
    name: "Uyo",
    country: "Nigeria",
    subcountry: "Akwa Ibom",
    geonameid: 2319480,
  },
  {
    name: "Uromi",
    country: "Nigeria",
    subcountry: "Edo",
    geonameid: 2319668,
  },
  {
    name: "Umuahia",
    country: "Nigeria",
    subcountry: "Abia",
    geonameid: 2320576,
  },
  {
    name: "Ughelli",
    country: "Nigeria",
    subcountry: "Delta",
    geonameid: 2320829,
  },
  {
    name: "Ugep",
    country: "Nigeria",
    subcountry: "Cross River",
    geonameid: 2320831,
  },
  {
    name: "Uga",
    country: "Nigeria",
    subcountry: "Anambra",
    geonameid: 2320920,
  },
  {
    name: "Ubiaja",
    country: "Nigeria",
    subcountry: "Edo",
    geonameid: 2321031,
  },
  {
    name: "Tegina",
    country: "Nigeria",
    subcountry: "Niger",
    geonameid: 2322263,
  },
  {
    name: "Tambuwal",
    country: "Nigeria",
    subcountry: "Sokoto",
    geonameid: 2322495,
  },
  {
    name: "Talata Mafara",
    country: "Nigeria",
    subcountry: "Zamfara",
    geonameid: 2322529,
  },
  {
    name: "Takum",
    country: "Nigeria",
    subcountry: "Benue",
    geonameid: 2322552,
  },
  {
    name: "Suleja",
    country: "Nigeria",
    subcountry: "Niger",
    geonameid: 2322794,
  },
  {
    name: "Sokoto",
    country: "Nigeria",
    subcountry: "Sokoto",
    geonameid: 2322911,
  },
  {
    name: "Soba",
    country: "Nigeria",
    subcountry: "Kaduna",
    geonameid: 2322957,
  },
  {
    name: "Saki",
    country: "Nigeria",
    subcountry: "Oyo",
    geonameid: 2323390,
  },
  {
    name: "Shagamu",
    country: "Nigeria",
    subcountry: "Ogun",
    geonameid: 2323411,
  },
  {
    name: "Sapele",
    country: "Nigeria",
    subcountry: "Delta",
    geonameid: 2323675,
  },
  {
    name: "Rijau",
    country: "Nigeria",
    subcountry: "Niger",
    geonameid: 2324504,
  },
  {
    name: "Rano",
    country: "Nigeria",
    subcountry: "Kano",
    geonameid: 2324575,
  },
  {
    name: "Potiskum",
    country: "Nigeria",
    subcountry: "Yobe",
    geonameid: 2324767,
  },
  {
    name: "Port Harcourt",
    country: "Nigeria",
    subcountry: "Rivers",
    geonameid: 2324774,
  },
  {
    name: "Pindiga",
    country: "Nigeria",
    subcountry: "Gombe",
    geonameid: 2324857,
  },
  {
    name: "Patigi",
    country: "Nigeria",
    subcountry: "Kwara",
    geonameid: 2324960,
  },
  {
    name: "Pankshin",
    country: "Nigeria",
    subcountry: "Plateau",
    geonameid: 2325060,
  },
  {
    name: "Ozubulu",
    country: "Nigeria",
    subcountry: "Anambra",
    geonameid: 2325161,
  },
  {
    name: "Oyo",
    country: "Nigeria",
    subcountry: "Oyo",
    geonameid: 2325200,
  },
  {
    name: "Oyan",
    country: "Nigeria",
    subcountry: "Osun",
    geonameid: 2325249,
  },
  {
    name: "Owo",
    country: "Nigeria",
    subcountry: "Ondo",
    geonameid: 2325314,
  },
  {
    name: "Owerri",
    country: "Nigeria",
    subcountry: "Imo",
    geonameid: 2325330,
  },
  {
    name: "Otukpa",
    country: "Nigeria",
    subcountry: "Benue",
    geonameid: 2325437,
  },
  {
    name: "Otan Ayegbaju",
    country: "Nigeria",
    subcountry: "Osun",
    geonameid: 2325506,
  },
  {
    name: "Osogbo",
    country: "Nigeria",
    subcountry: "Osun",
    geonameid: 2325590,
  },
  {
    name: "Orita-Eruwa",
    country: "Nigeria",
    subcountry: "Oyo",
    geonameid: 2325733,
  },
  {
    name: "Onitsha",
    country: "Nigeria",
    subcountry: "Anambra",
    geonameid: 2326016,
  },
  {
    name: "Ondo",
    country: "Nigeria",
    subcountry: "Ondo",
    geonameid: 2326171,
  },
  {
    name: "Olupona",
    country: "Nigeria",
    subcountry: "Osun",
    geonameid: 2326302,
  },
  {
    name: "Okuta",
    country: "Nigeria",
    subcountry: "Kwara",
    geonameid: 2326811,
  },
  {
    name: "Okrika",
    country: "Nigeria",
    subcountry: "Rivers",
    geonameid: 2326899,
  },
  {
    name: "Okigwe",
    country: "Nigeria",
    subcountry: "Imo",
    geonameid: 2327143,
  },
  {
    name: "Okene",
    country: "Nigeria",
    subcountry: "Kogi",
    geonameid: 2327220,
  },
  {
    name: "Oke Mesi",
    country: "Nigeria",
    subcountry: "Osun",
    geonameid: 2327223,
  },
  {
    name: "Oke Ila",
    country: "Nigeria",
    subcountry: "Ekiti",
    geonameid: 2327233,
  },
  {
    name: "Ohafia-Ifigh",
    country: "Nigeria",
    subcountry: "Abia",
    geonameid: 2327494,
  },
  {
    name: "Ogwashi-Uku",
    country: "Nigeria",
    subcountry: "Delta",
    geonameid: 2327513,
  },
  {
    name: "Oguta",
    country: "Nigeria",
    subcountry: "Imo",
    geonameid: 2327521,
  },
  {
    name: "Ogoja",
    country: "Nigeria",
    subcountry: "Cross River",
    geonameid: 2327650,
  },
  {
    name: "Ogbomoso",
    country: "Nigeria",
    subcountry: "Oyo",
    geonameid: 2327735,
  },
  {
    name: "Ogaminana",
    country: "Nigeria",
    subcountry: "Kogi",
    geonameid: 2327827,
  },
  {
    name: "Offa",
    country: "Nigeria",
    subcountry: "Kwara",
    geonameid: 2327879,
  },
  {
    name: "Ode",
    country: "Nigeria",
    subcountry: "Ondo",
    geonameid: 2328090,
  },
  {
    name: "Obudu",
    country: "Nigeria",
    subcountry: "Cross River",
    geonameid: 2328151,
  },
  {
    name: "Obonoma",
    country: "Nigeria",
    subcountry: "Rivers",
    geonameid: 2328185,
  },
  {
    name: "Numan",
    country: "Nigeria",
    subcountry: "Adamawa",
    geonameid: 2328617,
  },
  {
    name: "Nsukka",
    country: "Nigeria",
    subcountry: "Enugu",
    geonameid: 2328684,
  },
  {
    name: "Nnewi",
    country: "Nigeria",
    subcountry: "Anambra",
    geonameid: 2328765,
  },
  {
    name: "Nkwerre",
    country: "Nigeria",
    subcountry: "Imo",
    geonameid: 2328790,
  },
  {
    name: "Nkpor",
    country: "Nigeria",
    subcountry: "Anambra",
    geonameid: 2328811,
  },
  {
    name: "Nguru",
    country: "Nigeria",
    subcountry: "Yobe",
    geonameid: 2328952,
  },
  {
    name: "Nasarawa",
    country: "Nigeria",
    subcountry: "Nassarawa",
    geonameid: 2329451,
  },
  {
    name: "Nafada",
    country: "Nigeria",
    subcountry: "Gombe",
    geonameid: 2329562,
  },
  {
    name: "Mubi",
    country: "Nigeria",
    subcountry: "Adamawa",
    geonameid: 2329821,
  },
  {
    name: "Moriki",
    country: "Nigeria",
    subcountry: "Zamfara",
    geonameid: 2329920,
  },
  {
    name: "Monguno",
    country: "Nigeria",
    subcountry: "Borno",
    geonameid: 2329946,
  },
  {
    name: "Mokwa",
    country: "Nigeria",
    subcountry: "Niger",
    geonameid: 2329981,
  },
  {
    name: "Modakeke",
    country: "Nigeria",
    subcountry: "Osun",
    geonameid: 2330028,
  },
  {
    name: "Minna",
    country: "Nigeria",
    subcountry: "Niger",
    geonameid: 2330100,
  },
  {
    name: "Marte",
    country: "Nigeria",
    subcountry: "Borno",
    geonameid: 2330719,
  },
  {
    name: "Malumfashi",
    country: "Nigeria",
    subcountry: "Katsina",
    geonameid: 2331005,
  },
  {
    name: "Makurdi",
    country: "Nigeria",
    subcountry: "Benue",
    geonameid: 2331140,
  },
  {
    name: "Makoko",
    country: "Nigeria",
    subcountry: "Lagos",
    geonameid: 2331158,
  },
  {
    name: "Maiduguri",
    country: "Nigeria",
    subcountry: "Borno",
    geonameid: 2331447,
  },
  {
    name: "Magumeri",
    country: "Nigeria",
    subcountry: "Borno",
    geonameid: 2331528,
  },
  {
    name: "Lokoja",
    country: "Nigeria",
    subcountry: "Kogi",
    geonameid: 2331939,
  },
  {
    name: "Lere",
    country: "Nigeria",
    subcountry: "Kaduna",
    geonameid: 2332079,
  },
  {
    name: "Lekki",
    country: "Nigeria",
    subcountry: "Lagos",
    geonameid: 2332121,
  },
  {
    name: "Lapai",
    country: "Nigeria",
    subcountry: "Niger",
    geonameid: 2332249,
  },
  {
    name: "Lalupon",
    country: "Nigeria",
    subcountry: "Oyo",
    geonameid: 2332357,
  },
  {
    name: "Lagos",
    country: "Nigeria",
    subcountry: "Lagos",
    geonameid: 2332459,
  },
  {
    name: "Lafiagi",
    country: "Nigeria",
    subcountry: "Kwara",
    geonameid: 2332504,
  },
  {
    name: "Lafia",
    country: "Nigeria",
    subcountry: "Nassarawa",
    geonameid: 2332515,
  },
  {
    name: "Kwale",
    country: "Nigeria",
    subcountry: "Delta",
    geonameid: 2332871,
  },
  {
    name: "Kumo",
    country: "Nigeria",
    subcountry: "Gombe",
    geonameid: 2333451,
  },
  {
    name: "Kumagunnam",
    country: "Nigeria",
    subcountry: "Yobe",
    geonameid: 2333490,
  },
  {
    name: "Kukawa",
    country: "Nigeria",
    subcountry: "Borno",
    geonameid: 2333563,
  },
  {
    name: "Kuje",
    country: "Nigeria",
    subcountry: "FCT",
    geonameid: 2333604,
  },
  {
    name: "Kontagora",
    country: "Nigeria",
    subcountry: "Niger",
    geonameid: 2334008,
  },
  {
    name: "Kiyawa",
    country: "Nigeria",
    subcountry: "Jigawa",
    geonameid: 2334306,
  },
  {
    name: "Kisi",
    country: "Nigeria",
    subcountry: "Oyo",
    geonameid: 2334327,
  },
  {
    name: "Keffi",
    country: "Nigeria",
    subcountry: "Nassarawa",
    geonameid: 2334652,
  },
  {
    name: "Kaura Namoda",
    country: "Nigeria",
    subcountry: "Zamfara",
    geonameid: 2334756,
  },
  {
    name: "Katsina-Ala",
    country: "Nigeria",
    subcountry: "Benue",
    geonameid: 2334801,
  },
  {
    name: "Katsina",
    country: "Nigeria",
    subcountry: "Katsina",
    geonameid: 2334802,
  },
  {
    name: "Kari",
    country: "Nigeria",
    subcountry: "Bauchi",
    geonameid: 2335015,
  },
  {
    name: "Kano",
    country: "Nigeria",
    subcountry: "Kano",
    geonameid: 2335204,
  },
  {
    name: "Kamba",
    country: "Nigeria",
    subcountry: "Kebbi",
    geonameid: 2335333,
  },
  {
    name: "Kaiama",
    country: "Nigeria",
    subcountry: "Kwara",
    geonameid: 2335596,
  },
  {
    name: "Kagoro",
    country: "Nigeria",
    subcountry: "Kaduna",
    geonameid: 2335614,
  },
  {
    name: "Kafanchan",
    country: "Nigeria",
    subcountry: "Kaduna",
    geonameid: 2335713,
  },
  {
    name: "Kaduna",
    country: "Nigeria",
    subcountry: "Kaduna",
    geonameid: 2335727,
  },
  {
    name: "Kachia",
    country: "Nigeria",
    subcountry: "Kaduna",
    geonameid: 2335798,
  },
  {
    name: "Kabba",
    country: "Nigeria",
    subcountry: "Kogi",
    geonameid: 2335843,
  },
  {
    name: "Jos",
    country: "Nigeria",
    subcountry: "Plateau",
    geonameid: 2335953,
  },
  {
    name: "Jimeta",
    country: "Nigeria",
    subcountry: "Adamawa",
    geonameid: 2336056,
  },
  {
    name: "Jega",
    country: "Nigeria",
    subcountry: "Kebbi",
    geonameid: 2336237,
  },
  {
    name: "Jebba",
    country: "Nigeria",
    subcountry: "Kwara",
    geonameid: 2336251,
  },
  {
    name: "Jalingo",
    country: "Nigeria",
    subcountry: "Taraba",
    geonameid: 2336589,
  },
  {
    name: "Iwo",
    country: "Nigeria",
    subcountry: "Osun",
    geonameid: 2336905,
  },
  {
    name: "Itu",
    country: "Nigeria",
    subcountry: "Akwa Ibom",
    geonameid: 2336985,
  },
  {
    name: "Isieke",
    country: "Nigeria",
    subcountry: "Ebonyi",
    geonameid: 2337148,
  },
  {
    name: "Ise-Ekiti",
    country: "Nigeria",
    subcountry: "Ekiti",
    geonameid: 2337207,
  },
  {
    name: "Isanlu-Itedoijowa",
    country: "Nigeria",
    subcountry: "Kogi",
    geonameid: 2337235,
  },
  {
    name: "Ipoti",
    country: "Nigeria",
    subcountry: "Ekiti",
    geonameid: 2337352,
  },
  {
    name: "Iperu",
    country: "Nigeria",
    subcountry: "Ogun",
    geonameid: 2337379,
  },
  {
    name: "Inisa",
    country: "Nigeria",
    subcountry: "Osun",
    geonameid: 2337490,
  },
  {
    name: "Ilorin",
    country: "Nigeria",
    subcountry: "Kwara",
    geonameid: 2337639,
  },
  {
    name: "Ilobu",
    country: "Nigeria",
    subcountry: "Osun",
    geonameid: 2337659,
  },
  {
    name: "Illela",
    country: "Nigeria",
    subcountry: "Sokoto",
    geonameid: 2337680,
  },
  {
    name: "Ilesa",
    country: "Nigeria",
    subcountry: "Osun",
    geonameid: 2337704,
  },
  {
    name: "Ilaro",
    country: "Nigeria",
    subcountry: "Ogun",
    geonameid: 2337759,
  },
  {
    name: "Ila Orangun",
    country: "Nigeria",
    subcountry: "Osun",
    geonameid: 2337765,
  },
  {
    name: "Ikot Ekpene",
    country: "Nigeria",
    subcountry: "Akwa Ibom",
    geonameid: 2338106,
  },
  {
    name: "Ikom",
    country: "Nigeria",
    subcountry: "Cross River",
    geonameid: 2338242,
  },
  {
    name: "Ikirun",
    country: "Nigeria",
    subcountry: "Osun",
    geonameid: 2338269,
  },
  {
    name: "Ikire",
    country: "Nigeria",
    subcountry: "Osun",
    geonameid: 2338273,
  },
  {
    name: "Ikere-Ekiti",
    country: "Nigeria",
    subcountry: "Ekiti",
    geonameid: 2338287,
  },
  {
    name: "Ikeja",
    country: "Nigeria",
    subcountry: "Lagos",
    geonameid: 2338313,
  },
  {
    name: "Ijero-Ekiti",
    country: "Nigeria",
    subcountry: "Ekiti",
    geonameid: 2338385,
  },
  {
    name: "Ijebu-Ode",
    country: "Nigeria",
    subcountry: "Ogun",
    geonameid: 2338400,
  },
  {
    name: "Ijebu-Jesa",
    country: "Nigeria",
    subcountry: "Osun",
    geonameid: 2338401,
  },
  {
    name: "Ijebu-Igbo",
    country: "Nigeria",
    subcountry: "Ogun",
    geonameid: 2338403,
  },
  {
    name: "Ihiala",
    country: "Nigeria",
    subcountry: "Anambra",
    geonameid: 2338497,
  },
  {
    name: "Igede-Ekiti",
    country: "Nigeria",
    subcountry: "Ekiti",
    geonameid: 2338630,
  },
  {
    name: "Igbo-Ukwu",
    country: "Nigeria",
    subcountry: "Anambra",
    geonameid: 2338640,
  },
  {
    name: "Igbor",
    country: "Nigeria",
    subcountry: "Benue",
    geonameid: 2338660,
  },
  {
    name: "Igbo-Ora",
    country: "Nigeria",
    subcountry: "Oyo",
    geonameid: 2338669,
  },
  {
    name: "Igboho",
    country: "Nigeria",
    subcountry: "Oyo",
    geonameid: 2338711,
  },
  {
    name: "Igbeti",
    country: "Nigeria",
    subcountry: "Oyo",
    geonameid: 2338772,
  },
  {
    name: "Igbara-Odo",
    country: "Nigeria",
    subcountry: "Ekiti",
    geonameid: 2338810,
  },
  {
    name: "Ifo",
    country: "Nigeria",
    subcountry: "Ogun",
    geonameid: 2338876,
  },
  {
    name: "Idanre",
    country: "Nigeria",
    subcountry: "Ondo",
    geonameid: 2339150,
  },
  {
    name: "Idah",
    country: "Nigeria",
    subcountry: "Kogi",
    geonameid: 2339156,
  },
  {
    name: "Ibi",
    country: "Nigeria",
    subcountry: "Taraba",
    geonameid: 2339287,
  },
  {
    name: "Ibeto",
    country: "Nigeria",
    subcountry: "Niger",
    geonameid: 2339293,
  },
  {
    name: "Ibadan",
    country: "Nigeria",
    subcountry: "Oyo",
    geonameid: 2339354,
  },
  {
    name: "Hadejia",
    country: "Nigeria",
    subcountry: "Jigawa",
    geonameid: 2339631,
  },
  {
    name: "Gwoza",
    country: "Nigeria",
    subcountry: "Borno",
    geonameid: 2339665,
  },
  {
    name: "Gwarzo",
    country: "Nigeria",
    subcountry: "Kano",
    geonameid: 2339756,
  },
  {
    name: "Gwaram",
    country: "Nigeria",
    subcountry: "Jigawa",
    geonameid: 2339786,
  },
  {
    name: "Gwadabawa",
    country: "Nigeria",
    subcountry: "Sokoto",
    geonameid: 2339892,
  },
  {
    name: "Gusau",
    country: "Nigeria",
    subcountry: "Zamfara",
    geonameid: 2339937,
  },
  {
    name: "Gummi",
    country: "Nigeria",
    subcountry: "Zamfara",
    geonameid: 2340086,
  },
  {
    name: "Gumel",
    country: "Nigeria",
    subcountry: "Jigawa",
    geonameid: 2340091,
  },
  {
    name: "Gombi",
    country: "Nigeria",
    subcountry: "Adamawa",
    geonameid: 2340446,
  },
  {
    name: "Gombe",
    country: "Nigeria",
    subcountry: "Gombe",
    geonameid: 2340451,
  },
  {
    name: "Gembu",
    country: "Nigeria",
    subcountry: "Taraba",
    geonameid: 2341275,
  },
  {
    name: "Geidam",
    country: "Nigeria",
    subcountry: "Yobe",
    geonameid: 2341294,
  },
  {
    name: "Gbongan",
    country: "Nigeria",
    subcountry: "Osun",
    geonameid: 2341355,
  },
  {
    name: "Gaya",
    country: "Nigeria",
    subcountry: "Kano",
    geonameid: 2341580,
  },
  {
    name: "Gashua",
    country: "Nigeria",
    subcountry: "Yobe",
    geonameid: 2341656,
  },
  {
    name: "Garko",
    country: "Nigeria",
    subcountry: "Gombe",
    geonameid: 2341758,
  },
  {
    name: "Ganye",
    country: "Nigeria",
    subcountry: "Adamawa",
    geonameid: 2341955,
  },
  {
    name: "Gamboru",
    country: "Nigeria",
    subcountry: "Borno",
    geonameid: 2342192,
  },
  {
    name: "Funtua",
    country: "Nigeria",
    subcountry: "Katsina",
    geonameid: 2342490,
  },
  {
    name: "Fiditi",
    country: "Nigeria",
    subcountry: "Oyo",
    geonameid: 2342628,
  },
  {
    name: "Ezza-Ohu",
    country: "Nigeria",
    subcountry: "Ebonyi",
    geonameid: 2342883,
  },
  {
    name: "Esuk Oron",
    country: "Nigeria",
    subcountry: "Akwa Ibom",
    geonameid: 2343093,
  },
  {
    name: "Epe",
    country: "Nigeria",
    subcountry: "Lagos",
    geonameid: 2343252,
  },
  {
    name: "Enugu-Ukwu",
    country: "Nigeria",
    subcountry: "Anambra",
    geonameid: 2343270,
  },
  {
    name: "Enugu-Ezike",
    country: "Nigeria",
    subcountry: "Enugu",
    geonameid: 2343273,
  },
  {
    name: "Enugu",
    country: "Nigeria",
    subcountry: "Enugu",
    geonameid: 2343279,
  },
  {
    name: "Emure-Ekiti",
    country: "Nigeria",
    subcountry: "Ekiti",
    geonameid: 2343299,
  },
  {
    name: "Elele",
    country: "Nigeria",
    subcountry: "Rivers",
    geonameid: 2343512,
  },
  {
    name: "Ekpoma",
    country: "Nigeria",
    subcountry: "Edo",
    geonameid: 2343641,
  },
  {
    name: "Eket",
    country: "Nigeria",
    subcountry: "Akwa Ibom",
    geonameid: 2343720,
  },
  {
    name: "Ejigbo",
    country: "Nigeria",
    subcountry: "Osun",
    geonameid: 2343784,
  },
  {
    name: "Eha Amufu",
    country: "Nigeria",
    subcountry: "Enugu",
    geonameid: 2343822,
  },
  {
    name: "Egbe",
    country: "Nigeria",
    subcountry: "Kogi",
    geonameid: 2343943,
  },
  {
    name: "Efon-Alaaye",
    country: "Nigeria",
    subcountry: "Ekiti",
    geonameid: 2343983,
  },
  {
    name: "Effium",
    country: "Nigeria",
    subcountry: "Ebonyi",
    geonameid: 2343985,
  },
  {
    name: "Ebute Ikorodu",
    country: "Nigeria",
    subcountry: "Lagos",
    geonameid: 2344082,
  },
  {
    name: "Dutsen Wai",
    country: "Nigeria",
    subcountry: "Kaduna",
    geonameid: 2344229,
  },
  {
    name: "Dutse",
    country: "Nigeria",
    subcountry: "Jigawa",
    geonameid: 2344245,
  },
  {
    name: "Dukku",
    country: "Nigeria",
    subcountry: "Gombe",
    geonameid: 2344418,
  },
  {
    name: "Doma",
    country: "Nigeria",
    subcountry: "Nassarawa",
    geonameid: 2344600,
  },
  {
    name: "Dikwa",
    country: "Nigeria",
    subcountry: "Borno",
    geonameid: 2344854,
  },
  {
    name: "Deba",
    country: "Nigeria",
    subcountry: "Gombe",
    geonameid: 2345029,
  },
  {
    name: "Daura",
    country: "Nigeria",
    subcountry: "Katsina",
    geonameid: 2345094,
  },
  {
    name: "Daura",
    country: "Nigeria",
    subcountry: "Yobe",
    geonameid: 2345096,
  },
  {
    name: "Darazo",
    country: "Nigeria",
    subcountry: "Bauchi",
    geonameid: 2345152,
  },
  {
    name: "Damboa",
    country: "Nigeria",
    subcountry: "Borno",
    geonameid: 2345498,
  },
  {
    name: "Damaturu",
    country: "Nigeria",
    subcountry: "Yobe",
    geonameid: 2345521,
  },
  {
    name: "Calabar",
    country: "Nigeria",
    subcountry: "Cross River",
    geonameid: 2346229,
  },
  {
    name: "Burutu",
    country: "Nigeria",
    subcountry: "Delta",
    geonameid: 2346317,
  },
  {
    name: "Bukuru",
    country: "Nigeria",
    subcountry: "Plateau",
    geonameid: 2346561,
  },
  {
    name: "Buguma",
    country: "Nigeria",
    subcountry: "Rivers",
    geonameid: 2346615,
  },
  {
    name: "Bonny",
    country: "Nigeria",
    subcountry: "Rivers",
    geonameid: 2346812,
  },
  {
    name: "Bode Saadu",
    country: "Nigeria",
    subcountry: "Kwara",
    geonameid: 2346951,
  },
  {
    name: "Biu",
    country: "Nigeria",
    subcountry: "Borno",
    geonameid: 2346995,
  },
  {
    name: "Birnin Kudu",
    country: "Nigeria",
    subcountry: "Jigawa",
    geonameid: 2347057,
  },
  {
    name: "Birnin Kebbi",
    country: "Nigeria",
    subcountry: "Kebbi",
    geonameid: 2347059,
  },
  {
    name: "Sofo-Birnin-Gwari",
    country: "Nigeria",
    subcountry: "Kaduna",
    geonameid: 2347061,
  },
  {
    name: "Biliri",
    country: "Nigeria",
    subcountry: "Gombe",
    geonameid: 2347155,
  },
  {
    name: "Bida",
    country: "Nigeria",
    subcountry: "Niger",
    geonameid: 2347209,
  },
  {
    name: "Benin City",
    country: "Nigeria",
    subcountry: "Edo",
    geonameid: 2347283,
  },
  {
    name: "Bende",
    country: "Nigeria",
    subcountry: "Abia",
    geonameid: 2347303,
  },
  {
    name: "Beli",
    country: "Nigeria",
    subcountry: "Taraba",
    geonameid: 2347330,
  },
  {
    name: "Bauchi",
    country: "Nigeria",
    subcountry: "Bauchi",
    geonameid: 2347470,
  },
  {
    name: "Baro",
    country: "Nigeria",
    subcountry: "Niger",
    geonameid: 2347592,
  },
  {
    name: "Bama",
    country: "Nigeria",
    subcountry: "Borno",
    geonameid: 2347954,
  },
  {
    name: "Badagry",
    country: "Nigeria",
    subcountry: "Lagos",
    geonameid: 2348395,
  },
  {
    name: "Babana",
    country: "Nigeria",
    subcountry: "Niger",
    geonameid: 2348507,
  },
  {
    name: "Azare",
    country: "Nigeria",
    subcountry: "Bauchi",
    geonameid: 2348595,
  },
  {
    name: "Awka",
    country: "Nigeria",
    subcountry: "Anambra",
    geonameid: 2348773,
  },
  {
    name: "Awgu",
    country: "Nigeria",
    subcountry: "Enugu",
    geonameid: 2348783,
  },
  {
    name: "Auchi",
    country: "Nigeria",
    subcountry: "Edo",
    geonameid: 2348892,
  },
  {
    name: "Atani",
    country: "Nigeria",
    subcountry: "Anambra",
    geonameid: 2349019,
  },
  {
    name: "Asaba",
    country: "Nigeria",
    subcountry: "Delta",
    geonameid: 2349276,
  },
  {
    name: "Argungu",
    country: "Nigeria",
    subcountry: "Kebbi",
    geonameid: 2349431,
  },
  {
    name: "Aramoko-Ekiti",
    country: "Nigeria",
    subcountry: "Ekiti",
    geonameid: 2349529,
  },
  {
    name: "Apomu",
    country: "Nigeria",
    subcountry: "Osun",
    geonameid: 2349558,
  },
  {
    name: "Anchau",
    country: "Nigeria",
    subcountry: "Kaduna",
    geonameid: 2349951,
  },
  {
    name: "Amaigbo",
    country: "Nigeria",
    subcountry: "Abia",
    geonameid: 2350249,
  },
  {
    name: "Akwanga",
    country: "Nigeria",
    subcountry: "Nassarawa",
    geonameid: 2350806,
  },
  {
    name: "Akure",
    country: "Nigeria",
    subcountry: "Ondo",
    geonameid: 2350841,
  },
  {
    name: "Aku",
    country: "Nigeria",
    subcountry: "Enugu",
    geonameid: 2350886,
  },
  {
    name: "Ajaokuta",
    country: "Nigeria",
    subcountry: "Kogi",
    geonameid: 2351470,
  },
  {
    name: "Agulu",
    country: "Nigeria",
    subcountry: "Anambra",
    geonameid: 2351740,
  },
  {
    name: "Agbor",
    country: "Nigeria",
    subcountry: "Delta",
    geonameid: 2351979,
  },
  {
    name: "Afikpo",
    country: "Nigeria",
    subcountry: "Ebonyi",
    geonameid: 2352250,
  },
  {
    name: "Ado-Odo",
    country: "Nigeria",
    subcountry: "Ogun",
    geonameid: 2352356,
  },
  {
    name: "Ado-Ekiti",
    country: "Nigeria",
    subcountry: "Ekiti",
    geonameid: 2352379,
  },
  {
    name: "Abuja",
    country: "Nigeria",
    subcountry: "FCT",
    geonameid: 2352778,
  },
  {
    name: "Abeokuta",
    country: "Nigeria",
    subcountry: "Ogun",
    geonameid: 2352947,
  },
  {
    name: "Abakaliki",
    country: "Nigeria",
    subcountry: "Ebonyi",
    geonameid: 2353099,
  },
  {
    name: "Aba",
    country: "Nigeria",
    subcountry: "Abia",
    geonameid: 2353151,
  },
  {
    name: "Degema Hulk",
    country: "Nigeria",
    subcountry: "Rivers",
    geonameid: 2591159,
  },
  {
    name: "Chakwama",
    country: "Nigeria",
    subcountry: "Jigawa",
    geonameid: 12129605,
  },
  {
    name: "Tipitapa",
    country: "Nicaragua",
    subcountry: "Managua Department",
    geonameid: 3616035,
  },
  {
    name: "Somoto",
    country: "Nicaragua",
    subcountry: "Madriz Department",
    geonameid: 3616232,
  },
  {
    name: "Somotillo",
    country: "Nicaragua",
    subcountry: "Chinandega",
    geonameid: 3616234,
  },
  {
    name: "Siuna",
    country: "Nicaragua",
    subcountry: "North Caribbean Coast",
    geonameid: 3616253,
  },
  {
    name: "San Rafael del Sur",
    country: "Nicaragua",
    subcountry: "Managua Department",
    geonameid: 3616594,
  },
  {
    name: "San Marcos",
    country: "Nicaragua",
    subcountry: "Carazo Department",
    geonameid: 3616682,
  },
  {
    name: "Rivas",
    country: "Nicaragua",
    subcountry: "Rivas",
    geonameid: 3617052,
  },
  {
    name: "Río Blanco",
    country: "Nicaragua",
    subcountry: "Matagalpa Department",
    geonameid: 3617069,
  },
  {
    name: "Rama",
    country: "Nicaragua",
    subcountry: "South Caribbean Coast",
    geonameid: 3617095,
  },
  {
    name: "Puerto Cabezas",
    country: "Nicaragua",
    subcountry: "North Caribbean Coast",
    geonameid: 3617154,
  },
  {
    name: "Ocotal",
    country: "Nicaragua",
    subcountry: "Nueva Segovia Department",
    geonameid: 3617448,
  },
  {
    name: "Nueva Guinea",
    country: "Nicaragua",
    subcountry: "South Caribbean Coast",
    geonameid: 3617459,
  },
  {
    name: "Nandaime",
    country: "Nicaragua",
    subcountry: "Granada Department",
    geonameid: 3617513,
  },
  {
    name: "Nagarote",
    country: "Nicaragua",
    subcountry: "León Department",
    geonameid: 3617522,
  },
  {
    name: "Matagalpa",
    country: "Nicaragua",
    subcountry: "Matagalpa Department",
    geonameid: 3617708,
  },
  {
    name: "Masaya",
    country: "Nicaragua",
    subcountry: "Masaya Department",
    geonameid: 3617723,
  },
  {
    name: "Masatepe",
    country: "Nicaragua",
    subcountry: "Masaya Department",
    geonameid: 3617725,
  },
  {
    name: "Managua",
    country: "Nicaragua",
    subcountry: "Managua Department",
    geonameid: 3617763,
  },
  {
    name: "León",
    country: "Nicaragua",
    subcountry: "León Department",
    geonameid: 3618030,
  },
  {
    name: "La Paz Centro",
    country: "Nicaragua",
    subcountry: "León Department",
    geonameid: 3618411,
  },
  {
    name: "Juigalpa",
    country: "Nicaragua",
    subcountry: "Chontales Department",
    geonameid: 3618908,
  },
  {
    name: "Jinotepe",
    country: "Nicaragua",
    subcountry: "Carazo Department",
    geonameid: 3618926,
  },
  {
    name: "Jinotega",
    country: "Nicaragua",
    subcountry: "Jinotega Department",
    geonameid: 3618929,
  },
  {
    name: "Jalapa",
    country: "Nicaragua",
    subcountry: "Nueva Segovia Department",
    geonameid: 3618954,
  },
  {
    name: "Granada",
    country: "Nicaragua",
    subcountry: "Granada Department",
    geonameid: 3619136,
  },
  {
    name: "Estelí",
    country: "Nicaragua",
    subcountry: "Estelí Department",
    geonameid: 3619194,
  },
  {
    name: "El Viejo",
    country: "Nicaragua",
    subcountry: "Chinandega",
    geonameid: 3619267,
  },
  {
    name: "El Crucero",
    country: "Nicaragua",
    subcountry: "Managua Department",
    geonameid: 3619853,
  },
  {
    name: "Diriamba",
    country: "Nicaragua",
    subcountry: "Carazo Department",
    geonameid: 3620170,
  },
  {
    name: "Corinto",
    country: "Nicaragua",
    subcountry: "Chinandega",
    geonameid: 3620269,
  },
  {
    name: "Chinandega",
    country: "Nicaragua",
    subcountry: "Chinandega",
    geonameid: 3620381,
  },
  {
    name: "Chichigalpa",
    country: "Nicaragua",
    subcountry: "Chinandega",
    geonameid: 3620390,
  },
  {
    name: "Camoapa",
    country: "Nicaragua",
    subcountry: "Boaco Department",
    geonameid: 3620544,
  },
  {
    name: "Boaco",
    country: "Nicaragua",
    subcountry: "Boaco Department",
    geonameid: 3620674,
  },
  {
    name: "Bluefields",
    country: "Nicaragua",
    subcountry: "South Caribbean Coast",
    geonameid: 3620680,
  },
  {
    name: "Ciudad Sandino",
    country: "Nicaragua",
    subcountry: "Managua Department",
    geonameid: 3828262,
  },
  {
    name: "Zwolle",
    country: "Netherlands",
    subcountry: "Overijssel",
    geonameid: 2743477,
  },
  {
    name: "Zwijndrecht",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2743493,
  },
  {
    name: "Zutphen",
    country: "Netherlands",
    subcountry: "Gelderland",
    geonameid: 2743608,
  },
  {
    name: "Zoetermeer",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2743856,
  },
  {
    name: "Zevenaar",
    country: "Netherlands",
    subcountry: "Gelderland",
    geonameid: 2743949,
  },
  {
    name: "Zeist",
    country: "Netherlands",
    subcountry: "Utrecht",
    geonameid: 2743977,
  },
  {
    name: "Zeewolde",
    country: "Netherlands",
    subcountry: "Flevoland",
    geonameid: 2743997,
  },
  {
    name: "Zandvoort",
    country: "Netherlands",
    subcountry: "North Holland",
    geonameid: 2744042,
  },
  {
    name: "Zaltbommel",
    country: "Netherlands",
    subcountry: "Gelderland",
    geonameid: 2744102,
  },
  {
    name: "Zaanstad",
    country: "Netherlands",
    subcountry: "North Holland",
    geonameid: 2744114,
  },
  {
    name: "Zaandam",
    country: "Netherlands",
    subcountry: "North Holland",
    geonameid: 2744118,
  },
  {
    name: "Woerden",
    country: "Netherlands",
    subcountry: "Utrecht",
    geonameid: 2744248,
  },
  {
    name: "Wisch",
    country: "Netherlands",
    subcountry: "Gelderland",
    geonameid: 2744324,
  },
  {
    name: "Winterswijk",
    country: "Netherlands",
    subcountry: "Gelderland",
    geonameid: 2744332,
  },
  {
    name: "Winschoten",
    country: "Netherlands",
    subcountry: "Groningen",
    geonameid: 2744344,
  },
  {
    name: "Wijk bij Duurstede",
    country: "Netherlands",
    subcountry: "Utrecht",
    geonameid: 2744483,
  },
  {
    name: "Wijchen",
    country: "Netherlands",
    subcountry: "Gelderland",
    geonameid: 2744514,
  },
  {
    name: "Wierden",
    country: "Netherlands",
    subcountry: "Overijssel",
    geonameid: 2744549,
  },
  {
    name: "Weesp",
    country: "Netherlands",
    subcountry: "North Holland",
    geonameid: 2744904,
  },
  {
    name: "Weert",
    country: "Netherlands",
    subcountry: "Limburg",
    geonameid: 2744911,
  },
  {
    name: "Wassenaar",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2744991,
  },
  {
    name: "Wageningen",
    country: "Netherlands",
    subcountry: "Gelderland",
    geonameid: 2745088,
  },
  {
    name: "Waddinxveen",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2745096,
  },
  {
    name: "Waalwijk",
    country: "Netherlands",
    subcountry: "North Brabant",
    geonameid: 2745123,
  },
  {
    name: "Vught",
    country: "Netherlands",
    subcountry: "North Brabant",
    geonameid: 2745154,
  },
  {
    name: "Voorschoten",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2745301,
  },
  {
    name: "Voorburg",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2745321,
  },
  {
    name: "Volendam",
    country: "Netherlands",
    subcountry: "North Holland",
    geonameid: 2745340,
  },
  {
    name: "Vlissingen",
    country: "Netherlands",
    subcountry: "Zeeland",
    geonameid: 2745392,
  },
  {
    name: "Vlaardingen",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2745467,
  },
  {
    name: "Vianen",
    country: "Netherlands",
    subcountry: "Utrecht",
    geonameid: 2745580,
  },
  {
    name: "Venray",
    country: "Netherlands",
    subcountry: "Limburg",
    geonameid: 2745634,
  },
  {
    name: "Venlo",
    country: "Netherlands",
    subcountry: "Limburg",
    geonameid: 2745641,
  },
  {
    name: "Velsen-Zuid",
    country: "Netherlands",
    subcountry: "North Holland",
    geonameid: 2745673,
  },
  {
    name: "Velp",
    country: "Netherlands",
    subcountry: "Gelderland",
    geonameid: 2745677,
  },
  {
    name: "Veghel",
    country: "Netherlands",
    subcountry: "North Brabant",
    geonameid: 2745726,
  },
  {
    name: "Veenendaal",
    country: "Netherlands",
    subcountry: "Utrecht",
    geonameid: 2745774,
  },
  {
    name: "Veendam",
    country: "Netherlands",
    subcountry: "Groningen",
    geonameid: 2745783,
  },
  {
    name: "Valkenswaard",
    country: "Netherlands",
    subcountry: "North Brabant",
    geonameid: 2745860,
  },
  {
    name: "Utrecht",
    country: "Netherlands",
    subcountry: "Utrecht",
    geonameid: 2745912,
  },
  {
    name: "Urk",
    country: "Netherlands",
    subcountry: "Flevoland",
    geonameid: 2745932,
  },
  {
    name: "Uithoorn",
    country: "Netherlands",
    subcountry: "North Holland",
    geonameid: 2745973,
  },
  {
    name: "Uden",
    country: "Netherlands",
    subcountry: "North Brabant",
    geonameid: 2746005,
  },
  {
    name: "Tubbergen",
    country: "Netherlands",
    subcountry: "Overijssel",
    geonameid: 2746133,
  },
  {
    name: "Tongelre",
    country: "Netherlands",
    subcountry: "North Brabant",
    geonameid: 2746215,
  },
  {
    name: "Tilburg",
    country: "Netherlands",
    subcountry: "North Brabant",
    geonameid: 2746301,
  },
  {
    name: "Tiel",
    country: "Netherlands",
    subcountry: "Gelderland",
    geonameid: 2746331,
  },
  {
    name: "Terneuzen",
    country: "Netherlands",
    subcountry: "Zeeland",
    geonameid: 2746420,
  },
  {
    name: "Tegelen",
    country: "Netherlands",
    subcountry: "Limburg",
    geonameid: 2746504,
  },
  {
    name: "Steenwijk",
    country: "Netherlands",
    subcountry: "Overijssel",
    geonameid: 2746766,
  },
  {
    name: "Steenbergen",
    country: "Netherlands",
    subcountry: "North Brabant",
    geonameid: 2746804,
  },
  {
    name: "Staphorst",
    country: "Netherlands",
    subcountry: "Overijssel",
    geonameid: 2746839,
  },
  {
    name: "Stadskanaal",
    country: "Netherlands",
    subcountry: "Groningen",
    geonameid: 2746860,
  },
  {
    name: "Spijkenisse",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2746932,
  },
  {
    name: "Soest",
    country: "Netherlands",
    subcountry: "Utrecht",
    geonameid: 2747034,
  },
  {
    name: "Sneek",
    country: "Netherlands",
    subcountry: "Friesland",
    geonameid: 2747063,
  },
  {
    name: "Sliedrecht",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2747169,
  },
  {
    name: "Sittard",
    country: "Netherlands",
    subcountry: "Limburg",
    geonameid: 2747203,
  },
  {
    name: "Sint-Oedenrode",
    country: "Netherlands",
    subcountry: "North Brabant",
    geonameid: 2747227,
  },
  {
    name: "'s-Hertogenbosch",
    country: "Netherlands",
    subcountry: "North Brabant",
    geonameid: 2747351,
  },
  {
    name: "'s-Gravenzande",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2747364,
  },
  {
    name: "The Hague",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2747373,
  },
  {
    name: "Schijndel",
    country: "Netherlands",
    subcountry: "North Brabant",
    geonameid: 2747584,
  },
  {
    name: "Schiedam",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2747596,
  },
  {
    name: "Schiebroek",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2747597,
  },
  {
    name: "Scheveningen",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2747599,
  },
  {
    name: "Sassenheim",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2747751,
  },
  {
    name: "Rotterdam",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2747891,
  },
  {
    name: "Roosendaal",
    country: "Netherlands",
    subcountry: "North Brabant",
    geonameid: 2747930,
  },
  {
    name: "Roermond",
    country: "Netherlands",
    subcountry: "Limburg",
    geonameid: 2748000,
  },
  {
    name: "Rijswijk",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2748076,
  },
  {
    name: "Rijen",
    country: "Netherlands",
    subcountry: "North Brabant",
    geonameid: 2748130,
  },
  {
    name: "Ridderkerk",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2748172,
  },
  {
    name: "Rhoon",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2748178,
  },
  {
    name: "Rhenen",
    country: "Netherlands",
    subcountry: "Utrecht",
    geonameid: 2748185,
  },
  {
    name: "Raalte",
    country: "Netherlands",
    subcountry: "Overijssel",
    geonameid: 2748371,
  },
  {
    name: "Putten",
    country: "Netherlands",
    subcountry: "Gelderland",
    geonameid: 2748392,
  },
  {
    name: "Purmerend",
    country: "Netherlands",
    subcountry: "North Holland",
    geonameid: 2748413,
  },
  {
    name: "Pijnacker",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2748591,
  },
  {
    name: "Papendrecht",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2748729,
  },
  {
    name: "Oud-Beijerland",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2749182,
  },
  {
    name: "Oss",
    country: "Netherlands",
    subcountry: "North Brabant",
    geonameid: 2749234,
  },
  {
    name: "Oosterhout",
    country: "Netherlands",
    subcountry: "North Brabant",
    geonameid: 2749450,
  },
  {
    name: "Ommoord",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2749604,
  },
  {
    name: "Oldenzaal",
    country: "Netherlands",
    subcountry: "Overijssel",
    geonameid: 2749644,
  },
  {
    name: "Oisterwijk",
    country: "Netherlands",
    subcountry: "North Brabant",
    geonameid: 2749680,
  },
  {
    name: "Oegstgeest",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2749723,
  },
  {
    name: "Nunspeet",
    country: "Netherlands",
    subcountry: "Gelderland",
    geonameid: 2749756,
  },
  {
    name: "Nuenen",
    country: "Netherlands",
    subcountry: "North Brabant",
    geonameid: 2749780,
  },
  {
    name: "Noordwijk-Binnen",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2749812,
  },
  {
    name: "Nijmegen",
    country: "Netherlands",
    subcountry: "Gelderland",
    geonameid: 2750053,
  },
  {
    name: "Nijkerk",
    country: "Netherlands",
    subcountry: "Gelderland",
    geonameid: 2750065,
  },
  {
    name: "Nieuwegein",
    country: "Netherlands",
    subcountry: "Utrecht",
    geonameid: 2750325,
  },
  {
    name: "Naarden",
    country: "Netherlands",
    subcountry: "North Holland",
    geonameid: 2750521,
  },
  {
    name: "Naaldwijk",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2750523,
  },
  {
    name: "Mijdrecht",
    country: "Netherlands",
    subcountry: "Utrecht",
    geonameid: 2750815,
  },
  {
    name: "Middelharnis",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2750884,
  },
  {
    name: "Middelburg",
    country: "Netherlands",
    subcountry: "Zeeland",
    geonameid: 2750896,
  },
  {
    name: "Merenwijk",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2750939,
  },
  {
    name: "Meppel",
    country: "Netherlands",
    subcountry: "Drenthe",
    geonameid: 2750947,
  },
  {
    name: "Medemblik",
    country: "Netherlands",
    subcountry: "North Holland",
    geonameid: 2751073,
  },
  {
    name: "Maastricht",
    country: "Netherlands",
    subcountry: "Limburg",
    geonameid: 2751283,
  },
  {
    name: "Maassluis",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2751285,
  },
  {
    name: "Maarssen",
    country: "Netherlands",
    subcountry: "Utrecht",
    geonameid: 2751316,
  },
  {
    name: "Losser",
    country: "Netherlands",
    subcountry: "Overijssel",
    geonameid: 2751424,
  },
  {
    name: "Loon op Zand",
    country: "Netherlands",
    subcountry: "North Brabant",
    geonameid: 2751456,
  },
  {
    name: "Lisse",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2751547,
  },
  {
    name: "Lindenholt",
    country: "Netherlands",
    subcountry: "Gelderland",
    geonameid: 2751582,
  },
  {
    name: "Lichtenvoorde",
    country: "Netherlands",
    subcountry: "Gelderland",
    geonameid: 2751651,
  },
  {
    name: "Leusden",
    country: "Netherlands",
    subcountry: "Utrecht",
    geonameid: 2751687,
  },
  {
    name: "Lelystad",
    country: "Netherlands",
    subcountry: "Flevoland",
    geonameid: 2751738,
  },
  {
    name: "Leiderdorp",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2751771,
  },
  {
    name: "Leiden",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2751773,
  },
  {
    name: "Leeuwarden",
    country: "Netherlands",
    subcountry: "Friesland",
    geonameid: 2751792,
  },
  {
    name: "Leerdam",
    country: "Netherlands",
    subcountry: "Utrecht",
    geonameid: 2751808,
  },
  {
    name: "Leek",
    country: "Netherlands",
    subcountry: "Groningen",
    geonameid: 2751834,
  },
  {
    name: "Krimpen aan den IJssel",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2752264,
  },
  {
    name: "Korrewegwijk",
    country: "Netherlands",
    subcountry: "Groningen",
    geonameid: 2752420,
  },
  {
    name: "Kerkrade",
    country: "Netherlands",
    subcountry: "Limburg",
    geonameid: 2752923,
  },
  {
    name: "Katwijk aan Zee",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2753010,
  },
  {
    name: "Kampen",
    country: "Netherlands",
    subcountry: "Overijssel",
    geonameid: 2753106,
  },
  {
    name: "IJsselstein",
    country: "Netherlands",
    subcountry: "Utrecht",
    geonameid: 2753355,
  },
  {
    name: "IJmuiden",
    country: "Netherlands",
    subcountry: "North Holland",
    geonameid: 2753376,
  },
  {
    name: "Huizen",
    country: "Netherlands",
    subcountry: "North Holland",
    geonameid: 2753468,
  },
  {
    name: "Hoorn",
    country: "Netherlands",
    subcountry: "North Holland",
    geonameid: 2753638,
  },
  {
    name: "Hoogvliet",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2753666,
  },
  {
    name: "Hoogezand",
    country: "Netherlands",
    subcountry: "Groningen",
    geonameid: 2753706,
  },
  {
    name: "Hoogeveen",
    country: "Netherlands",
    subcountry: "Drenthe",
    geonameid: 2753719,
  },
  {
    name: "Hoofddorp",
    country: "Netherlands",
    subcountry: "North Holland",
    geonameid: 2753801,
  },
  {
    name: "Hoge Vucht",
    country: "Netherlands",
    subcountry: "North Brabant",
    geonameid: 2753955,
  },
  {
    name: "Hoensbroek",
    country: "Netherlands",
    subcountry: "Limburg",
    geonameid: 2753996,
  },
  {
    name: "Hilversum",
    country: "Netherlands",
    subcountry: "North Holland",
    geonameid: 2754064,
  },
  {
    name: "Hillegom",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2754073,
  },
  {
    name: "Hengelo",
    country: "Netherlands",
    subcountry: "Overijssel",
    geonameid: 2754394,
  },
  {
    name: "Hendrik-Ido-Ambacht",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2754408,
  },
  {
    name: "Helmond",
    country: "Netherlands",
    subcountry: "North Brabant",
    geonameid: 2754447,
  },
  {
    name: "Hellevoetsluis",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2754454,
  },
  {
    name: "Heiloo",
    country: "Netherlands",
    subcountry: "North Holland",
    geonameid: 2754516,
  },
  {
    name: "Heerlen",
    country: "Netherlands",
    subcountry: "Limburg",
    geonameid: 2754652,
  },
  {
    name: "Heerhugowaard",
    country: "Netherlands",
    subcountry: "North Holland",
    geonameid: 2754659,
  },
  {
    name: "Heerenveen",
    country: "Netherlands",
    subcountry: "Friesland",
    geonameid: 2754669,
  },
  {
    name: "Heemstede",
    country: "Netherlands",
    subcountry: "North Holland",
    geonameid: 2754692,
  },
  {
    name: "Heemskerk",
    country: "Netherlands",
    subcountry: "North Holland",
    geonameid: 2754697,
  },
  {
    name: "Harlingen",
    country: "Netherlands",
    subcountry: "Friesland",
    geonameid: 2754817,
  },
  {
    name: "Harenkarspel",
    country: "Netherlands",
    subcountry: "North Holland",
    geonameid: 2754837,
  },
  {
    name: "Harderwijk",
    country: "Netherlands",
    subcountry: "Gelderland",
    geonameid: 2754848,
  },
  {
    name: "Hardenberg",
    country: "Netherlands",
    subcountry: "Overijssel",
    geonameid: 2754861,
  },
  {
    name: "Haarlem",
    country: "Netherlands",
    subcountry: "North Holland",
    geonameid: 2755003,
  },
  {
    name: "Haaksbergen",
    country: "Netherlands",
    subcountry: "Overijssel",
    geonameid: 2755030,
  },
  {
    name: "Groot IJsselmonde",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2755123,
  },
  {
    name: "Groningen",
    country: "Netherlands",
    subcountry: "Groningen",
    geonameid: 2755251,
  },
  {
    name: "Groesbeek",
    country: "Netherlands",
    subcountry: "Gelderland",
    geonameid: 2755272,
  },
  {
    name: "Gouda",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2755420,
  },
  {
    name: "Gorinchem",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2755434,
  },
  {
    name: "Goirle",
    country: "Netherlands",
    subcountry: "North Brabant",
    geonameid: 2755464,
  },
  {
    name: "Goes",
    country: "Netherlands",
    subcountry: "Zeeland",
    geonameid: 2755476,
  },
  {
    name: "Gennep",
    country: "Netherlands",
    subcountry: "Limburg",
    geonameid: 2755584,
  },
  {
    name: "Gemert",
    country: "Netherlands",
    subcountry: "North Brabant",
    geonameid: 2755605,
  },
  {
    name: "Geleen",
    country: "Netherlands",
    subcountry: "Limburg",
    geonameid: 2755616,
  },
  {
    name: "Geldrop",
    country: "Netherlands",
    subcountry: "North Brabant",
    geonameid: 2755619,
  },
  {
    name: "Geldermalsen",
    country: "Netherlands",
    subcountry: "Gelderland",
    geonameid: 2755633,
  },
  {
    name: "Geertruidenberg",
    country: "Netherlands",
    subcountry: "North Brabant",
    geonameid: 2755669,
  },
  {
    name: "Epe",
    country: "Netherlands",
    subcountry: "Gelderland",
    geonameid: 2756059,
  },
  {
    name: "Enschede",
    country: "Netherlands",
    subcountry: "Overijssel",
    geonameid: 2756071,
  },
  {
    name: "Enkhuizen",
    country: "Netherlands",
    subcountry: "North Holland",
    geonameid: 2756077,
  },
  {
    name: "Emmen",
    country: "Netherlands",
    subcountry: "Drenthe",
    geonameid: 2756136,
  },
  {
    name: "Emmeloord",
    country: "Netherlands",
    subcountry: "Flevoland",
    geonameid: 2756139,
  },
  {
    name: "Elst",
    country: "Netherlands",
    subcountry: "Gelderland",
    geonameid: 2756161,
  },
  {
    name: "Elburg",
    country: "Netherlands",
    subcountry: "Gelderland",
    geonameid: 2756232,
  },
  {
    name: "Eindhoven",
    country: "Netherlands",
    subcountry: "North Brabant",
    geonameid: 2756253,
  },
  {
    name: "Eibergen",
    country: "Netherlands",
    subcountry: "Gelderland",
    geonameid: 2756295,
  },
  {
    name: "Eersel",
    country: "Netherlands",
    subcountry: "North Brabant",
    geonameid: 2756342,
  },
  {
    name: "Ede",
    country: "Netherlands",
    subcountry: "Gelderland",
    geonameid: 2756429,
  },
  {
    name: "Duiven",
    country: "Netherlands",
    subcountry: "Gelderland",
    geonameid: 2756507,
  },
  {
    name: "Dronten",
    country: "Netherlands",
    subcountry: "Flevoland",
    geonameid: 2756559,
  },
  {
    name: "Driebergen-Rijsenburg",
    country: "Netherlands",
    subcountry: "Utrecht",
    geonameid: 2756619,
  },
  {
    name: "Drachten",
    country: "Netherlands",
    subcountry: "Friesland",
    geonameid: 2756644,
  },
  {
    name: "Dordrecht",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2756669,
  },
  {
    name: "Dongen",
    country: "Netherlands",
    subcountry: "North Brabant",
    geonameid: 2756723,
  },
  {
    name: "Doetinchem",
    country: "Netherlands",
    subcountry: "Gelderland",
    geonameid: 2756767,
  },
  {
    name: "Diemen",
    country: "Netherlands",
    subcountry: "North Holland",
    geonameid: 2756888,
  },
  {
    name: "Deventer",
    country: "Netherlands",
    subcountry: "Overijssel",
    geonameid: 2756987,
  },
  {
    name: "Den Helder",
    country: "Netherlands",
    subcountry: "North Holland",
    geonameid: 2757220,
  },
  {
    name: "De Meern",
    country: "Netherlands",
    subcountry: "Utrecht",
    geonameid: 2757295,
  },
  {
    name: "Delfzijl",
    country: "Netherlands",
    subcountry: "Groningen",
    geonameid: 2757340,
  },
  {
    name: "Delft",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2757345,
  },
  {
    name: "Dalfsen",
    country: "Netherlands",
    subcountry: "Overijssel",
    geonameid: 2757850,
  },
  {
    name: "Culemborg",
    country: "Netherlands",
    subcountry: "Gelderland",
    geonameid: 2757872,
  },
  {
    name: "Cranendonck",
    country: "Netherlands",
    subcountry: "North Brabant",
    geonameid: 2757890,
  },
  {
    name: "Castricum",
    country: "Netherlands",
    subcountry: "North Holland",
    geonameid: 2757991,
  },
  {
    name: "Capelle aan den IJssel",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2758012,
  },
  {
    name: "Bussum",
    country: "Netherlands",
    subcountry: "North Holland",
    geonameid: 2758064,
  },
  {
    name: "Brunssum",
    country: "Netherlands",
    subcountry: "Limburg",
    geonameid: 2758174,
  },
  {
    name: "Brummen",
    country: "Netherlands",
    subcountry: "Gelderland",
    geonameid: 2758177,
  },
  {
    name: "Breda",
    country: "Netherlands",
    subcountry: "North Brabant",
    geonameid: 2758401,
  },
  {
    name: "Boxtel",
    country: "Netherlands",
    subcountry: "North Brabant",
    geonameid: 2758460,
  },
  {
    name: "Boskoop",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2758547,
  },
  {
    name: "Borssele",
    country: "Netherlands",
    subcountry: "Zeeland",
    geonameid: 2758587,
  },
  {
    name: "Borne",
    country: "Netherlands",
    subcountry: "Overijssel",
    geonameid: 2758598,
  },
  {
    name: "Bodegraven",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2758765,
  },
  {
    name: "Beverwijk",
    country: "Netherlands",
    subcountry: "North Holland",
    geonameid: 2758998,
  },
  {
    name: "Beuningen",
    country: "Netherlands",
    subcountry: "Gelderland",
    geonameid: 2759016,
  },
  {
    name: "Best",
    country: "Netherlands",
    subcountry: "North Brabant",
    geonameid: 2759040,
  },
  {
    name: "Bergschenhoek",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2759113,
  },
  {
    name: "Bergeijk",
    country: "Netherlands",
    subcountry: "North Brabant",
    geonameid: 2759132,
  },
  {
    name: "Bergen op Zoom",
    country: "Netherlands",
    subcountry: "North Brabant",
    geonameid: 2759145,
  },
  {
    name: "Bergen",
    country: "Netherlands",
    subcountry: "North Holland",
    geonameid: 2759154,
  },
  {
    name: "Benthuizen",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2759178,
  },
  {
    name: "Barneveld",
    country: "Netherlands",
    subcountry: "Gelderland",
    geonameid: 2759407,
  },
  {
    name: "Barendrecht",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2759426,
  },
  {
    name: "Baarn",
    country: "Netherlands",
    subcountry: "Utrecht",
    geonameid: 2759544,
  },
  {
    name: "Assendelft",
    country: "Netherlands",
    subcountry: "North Holland",
    geonameid: 2759631,
  },
  {
    name: "Assen",
    country: "Netherlands",
    subcountry: "Drenthe",
    geonameid: 2759633,
  },
  {
    name: "Arnhem",
    country: "Netherlands",
    subcountry: "Gelderland",
    geonameid: 2759661,
  },
  {
    name: "Apeldoorn",
    country: "Netherlands",
    subcountry: "Gelderland",
    geonameid: 2759706,
  },
  {
    name: "Amsterdam",
    country: "Netherlands",
    subcountry: "North Holland",
    geonameid: 2759794,
  },
  {
    name: "Amstelveen",
    country: "Netherlands",
    subcountry: "North Holland",
    geonameid: 2759798,
  },
  {
    name: "Amersfoort",
    country: "Netherlands",
    subcountry: "Utrecht",
    geonameid: 2759821,
  },
  {
    name: "Alphen aan den Rijn",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2759875,
  },
  {
    name: "Almere Stad",
    country: "Netherlands",
    subcountry: "Flevoland",
    geonameid: 2759879,
  },
  {
    name: "Almelo",
    country: "Netherlands",
    subcountry: "Overijssel",
    geonameid: 2759887,
  },
  {
    name: "Alkmaar",
    country: "Netherlands",
    subcountry: "North Holland",
    geonameid: 2759899,
  },
  {
    name: "Alblasserdam",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 2759915,
  },
  {
    name: "Aalten",
    country: "Netherlands",
    subcountry: "Gelderland",
    geonameid: 2760123,
  },
  {
    name: "Aalsmeer",
    country: "Netherlands",
    subcountry: "North Holland",
    geonameid: 2760134,
  },
  {
    name: "Amsterdam-Zuidoost",
    country: "Netherlands",
    subcountry: "North Holland",
    geonameid: 6544881,
  },
  {
    name: "Berkel en Rodenrijs",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 6929992,
  },
  {
    name: "Ypenburg",
    country: "Netherlands",
    subcountry: "South Holland",
    geonameid: 6941548,
  },
  {
    name: "Alta",
    country: "Norway",
    subcountry: "Troms og Finnmark",
    geonameid: 847633,
  },
  {
    name: "Trondheim",
    country: "Norway",
    subcountry: "Trøndelag",
    geonameid: 3133880,
  },
  {
    name: "Tromsø",
    country: "Norway",
    subcountry: "Troms og Finnmark",
    geonameid: 3133895,
  },
  {
    name: "Tønsberg",
    country: "Norway",
    subcountry: "Vestfold og Telemark",
    geonameid: 3134331,
  },
  {
    name: "Steinkjer",
    country: "Norway",
    subcountry: "Trøndelag",
    geonameid: 3136947,
  },
  {
    name: "Stavanger",
    country: "Norway",
    subcountry: "Rogaland",
    geonameid: 3137115,
  },
  {
    name: "Skien",
    country: "Norway",
    subcountry: "Vestfold og Telemark",
    geonameid: 3139075,
  },
  {
    name: "Sarpsborg",
    country: "Norway",
    subcountry: "Viken",
    geonameid: 3140084,
  },
  {
    name: "Sandnes",
    country: "Norway",
    subcountry: "Rogaland",
    geonameid: 3140321,
  },
  {
    name: "Sandefjord",
    country: "Norway",
    subcountry: "Vestfold og Telemark",
    geonameid: 3140390,
  },
  {
    name: "Porsgrunn",
    country: "Norway",
    subcountry: "Vestfold og Telemark",
    geonameid: 3142657,
  },
  {
    name: "Oslo",
    country: "Norway",
    subcountry: "Oslo",
    geonameid: 3143244,
  },
  {
    name: "Nesttun",
    country: "Norway",
    subcountry: "Vestland",
    geonameid: 3144631,
  },
  {
    name: "Moss",
    country: "Norway",
    subcountry: "Viken",
    geonameid: 3145375,
  },
  {
    name: "Molde",
    country: "Norway",
    subcountry: "Møre og Romsdal",
    geonameid: 3145580,
  },
  {
    name: "Mo i Rana",
    country: "Norway",
    subcountry: "Nordland",
    geonameid: 3145614,
  },
  {
    name: "Lillestrøm",
    country: "Norway",
    subcountry: "Viken",
    geonameid: 3147465,
  },
  {
    name: "Lillehammer",
    country: "Norway",
    subcountry: "Innlandet",
    geonameid: 3147474,
  },
  {
    name: "Levanger",
    country: "Norway",
    subcountry: "Trøndelag",
    geonameid: 3147698,
  },
  {
    name: "Larvik",
    country: "Norway",
    subcountry: "Vestfold og Telemark",
    geonameid: 3148129,
  },
  {
    name: "Kristiansund",
    country: "Norway",
    subcountry: "Møre og Romsdal",
    geonameid: 3149312,
  },
  {
    name: "Kristiansand",
    country: "Norway",
    subcountry: "Agder",
    geonameid: 3149318,
  },
  {
    name: "Kongsvinger",
    country: "Norway",
    subcountry: "Innlandet",
    geonameid: 3149533,
  },
  {
    name: "Kongsberg",
    country: "Norway",
    subcountry: "Viken",
    geonameid: 3149563,
  },
  {
    name: "Horten",
    country: "Norway",
    subcountry: "Vestfold og Telemark",
    geonameid: 3151770,
  },
  {
    name: "Haugesund",
    country: "Norway",
    subcountry: "Rogaland",
    geonameid: 3153623,
  },
  {
    name: "Harstad",
    country: "Norway",
    subcountry: "Troms og Finnmark",
    geonameid: 3153823,
  },
  {
    name: "Hamar",
    country: "Norway",
    subcountry: "Innlandet",
    geonameid: 3154084,
  },
  {
    name: "Halden",
    country: "Norway",
    subcountry: "Viken",
    geonameid: 3154209,
  },
  {
    name: "Grimstad",
    country: "Norway",
    subcountry: "Agder",
    geonameid: 3155041,
  },
  {
    name: "Gjøvik",
    country: "Norway",
    subcountry: "Innlandet",
    geonameid: 3155573,
  },
  {
    name: "Fredrikstad",
    country: "Norway",
    subcountry: "Viken",
    geonameid: 3156529,
  },
  {
    name: "Drammen",
    country: "Norway",
    subcountry: "Viken",
    geonameid: 3159016,
  },
  {
    name: "Bodø",
    country: "Norway",
    subcountry: "Nordland",
    geonameid: 3160881,
  },
  {
    name: "Bergen",
    country: "Norway",
    subcountry: "Vestland",
    geonameid: 3161732,
  },
  {
    name: "Asker",
    country: "Norway",
    subcountry: "Viken",
    geonameid: 3162657,
  },
  {
    name: "Arendal",
    country: "Norway",
    subcountry: "Agder",
    geonameid: 3162955,
  },
  {
    name: "Ålesund",
    country: "Norway",
    subcountry: "Møre og Romsdal",
    geonameid: 3163392,
  },
  {
    name: "Ytrebygda",
    country: "Norway",
    subcountry: "Vestland",
    geonameid: 6697344,
  },
  {
    name: "Wāliṅ",
    country: "Nepal",
    subcountry: "Province 4",
    geonameid: 1282616,
  },
  {
    name: "Tulsīpur",
    country: "Nepal",
    subcountry: "Lumbini Province",
    geonameid: 1282635,
  },
  {
    name: "Ṭikāpur",
    country: "Nepal",
    subcountry: "Sudurpashchim Pradesh",
    geonameid: 1282666,
  },
  {
    name: "Tānsen",
    country: "Nepal",
    subcountry: "Lumbini Province",
    geonameid: 1282714,
  },
  {
    name: "Siraha",
    country: "Nepal",
    subcountry: "Province 2",
    geonameid: 1282770,
  },
  {
    name: "Rājbirāj",
    country: "Nepal",
    subcountry: "Province 2",
    geonameid: 1282884,
  },
  {
    name: "Pokhara",
    country: "Nepal",
    subcountry: "Province 4",
    geonameid: 1282898,
  },
  {
    name: "Pātan",
    country: "Nepal",
    subcountry: "Bagmati Province",
    geonameid: 1282931,
  },
  {
    name: "Panauti̇̄",
    country: "Nepal",
    subcountry: "Bagmati Province",
    geonameid: 1282950,
  },
  {
    name: "Malaṅgawā",
    country: "Nepal",
    subcountry: "Province 2",
    geonameid: 1283082,
  },
  {
    name: "Mahendranagar",
    country: "Nepal",
    subcountry: "Sudurpashchim Pradesh",
    geonameid: 1283095,
  },
  {
    name: "Lahān",
    country: "Nepal",
    subcountry: "Province 2",
    geonameid: 1283161,
  },
  {
    name: "Kirtipur",
    country: "Nepal",
    subcountry: "Bagmati Province",
    geonameid: 1283190,
  },
  {
    name: "Khā̃dbāri̇̄",
    country: "Nepal",
    subcountry: "Province 1",
    geonameid: 1283217,
  },
  {
    name: "Kathmandu",
    country: "Nepal",
    subcountry: "Bagmati Province",
    geonameid: 1283240,
  },
  {
    name: "Janakpur",
    country: "Nepal",
    subcountry: "Province 2",
    geonameid: 1283318,
  },
  {
    name: "Jaleshwar",
    country: "Nepal",
    subcountry: "Province 2",
    geonameid: 1283323,
  },
  {
    name: "Īṭahari̇̄",
    country: "Nepal",
    subcountry: "Province 1",
    geonameid: 1283329,
  },
  {
    name: "Ilām",
    country: "Nepal",
    subcountry: "Province 1",
    geonameid: 1283333,
  },
  {
    name: "Hetauda",
    country: "Nepal",
    subcountry: "Bagmati Province",
    geonameid: 1283339,
  },
  {
    name: "Gulariyā",
    country: "Nepal",
    subcountry: "Lumbini Province",
    geonameid: 1283368,
  },
  {
    name: "Gaur",
    country: "Nepal",
    subcountry: "Province 2",
    geonameid: 1283401,
  },
  {
    name: "Dhulikhel",
    country: "Nepal",
    subcountry: "Bagmati Province",
    geonameid: 1283448,
  },
  {
    name: "Dharān",
    country: "Nepal",
    subcountry: "Province 1",
    geonameid: 1283460,
  },
  {
    name: "Dhankutā",
    country: "Nepal",
    subcountry: "Province 1",
    geonameid: 1283465,
  },
  {
    name: "Dhangaḍhi̇̄",
    country: "Nepal",
    subcountry: "Sudurpashchim Pradesh",
    geonameid: 1283467,
  },
  {
    name: "Dārchulā",
    country: "Nepal",
    subcountry: "Sudurpashchim Pradesh",
    geonameid: 1283484,
  },
  {
    name: "Dailekh",
    country: "Nepal",
    subcountry: "Karnali Pradesh",
    geonameid: 1283496,
  },
  {
    name: "Dadeldhurā",
    country: "Nepal",
    subcountry: "Sudurpashchim Pradesh",
    geonameid: 1283499,
  },
  {
    name: "Butwāl",
    country: "Nepal",
    subcountry: "Lumbini Province",
    geonameid: 1283562,
  },
  {
    name: "Birgañj",
    country: "Nepal",
    subcountry: "Province 2",
    geonameid: 1283581,
  },
  {
    name: "Biratnagar",
    country: "Nepal",
    subcountry: "Province 1",
    geonameid: 1283582,
  },
  {
    name: "Bharatpur",
    country: "Nepal",
    subcountry: "Bagmati Province",
    geonameid: 1283613,
  },
  {
    name: "Siddharthanagar",
    country: "Nepal",
    subcountry: "Lumbini Province",
    geonameid: 1283621,
  },
  {
    name: "Bhadrapur",
    country: "Nepal",
    subcountry: "Province 1",
    geonameid: 1283628,
  },
  {
    name: "Banepā",
    country: "Nepal",
    subcountry: "Bagmati Province",
    geonameid: 1283679,
  },
  {
    name: "Bāglung",
    country: "Nepal",
    subcountry: "Province 4",
    geonameid: 1283711,
  },
  {
    name: "Birendranagar",
    country: "Nepal",
    subcountry: "Karnali Pradesh",
    geonameid: 6254843,
  },
  {
    name: "Dipayal",
    country: "Nepal",
    subcountry: "Sudurpashchim Pradesh",
    geonameid: 6254845,
  },
  {
    name: "Nepalgunj",
    country: "Nepal",
    subcountry: "Lumbini Province",
    geonameid: 6941099,
  },
  {
    name: "Panauti",
    country: "Nepal",
    subcountry: "Bagmati Province",
    geonameid: 7963596,
  },
  {
    name: "Inaruwa",
    country: "Nepal",
    subcountry: "Province 1",
    geonameid: 7997918,
  },
  {
    name: "Triyuga",
    country: "Nepal",
    subcountry: "Province 1",
    geonameid: 8410807,
  },
  {
    name: "Madhyapur Thimi",
    country: "Nepal",
    subcountry: "Bagmati Province",
    geonameid: 8411054,
  },
  {
    name: "Yaren",
    country: "Nauru",
    subcountry: "Yaren",
    geonameid: 7626461,
  },
  {
    name: "Alofi",
    country: "Niue",
    subcountry: "N/A",
    geonameid: 4036284,
  },
  {
    name: "Wellington",
    country: "New Zealand",
    subcountry: "Wellington",
    geonameid: 2179537,
  },
  {
    name: "Whanganui",
    country: "New Zealand",
    subcountry: "Manawatu-Wanganui",
    geonameid: 2179670,
  },
  {
    name: "Wainuiomata",
    country: "New Zealand",
    subcountry: "Wellington",
    geonameid: 2180118,
  },
  {
    name: "Timaru",
    country: "New Zealand",
    subcountry: "Canterbury",
    geonameid: 2181133,
  },
  {
    name: "Taupo",
    country: "New Zealand",
    subcountry: "Waikato",
    geonameid: 2181742,
  },
  {
    name: "Stoke",
    country: "New Zealand",
    subcountry: "Nelson",
    geonameid: 2182311,
  },
  {
    name: "Rolleston",
    country: "New Zealand",
    subcountry: "Canterbury",
    geonameid: 2183310,
  },
  {
    name: "Richmond",
    country: "New Zealand",
    subcountry: "Tasman",
    geonameid: 2183472,
  },
  {
    name: "Pukekohe East",
    country: "New Zealand",
    subcountry: "Auckland",
    geonameid: 2184155,
  },
  {
    name: "Porirua",
    country: "New Zealand",
    subcountry: "Wellington",
    geonameid: 2184397,
  },
  {
    name: "Paraparaumu",
    country: "New Zealand",
    subcountry: "Wellington",
    geonameid: 2184904,
  },
  {
    name: "Palmerston North",
    country: "New Zealand",
    subcountry: "Manawatu-Wanganui",
    geonameid: 2185018,
  },
  {
    name: "North Shore",
    country: "New Zealand",
    subcountry: "Auckland",
    geonameid: 2185964,
  },
  {
    name: "New Plymouth",
    country: "New Zealand",
    subcountry: "Taranaki",
    geonameid: 2186239,
  },
  {
    name: "Nelson",
    country: "New Zealand",
    subcountry: "Nelson",
    geonameid: 2186280,
  },
  {
    name: "Napier",
    country: "New Zealand",
    subcountry: "Hawke's Bay",
    geonameid: 2186313,
  },
  {
    name: "Manukau City",
    country: "New Zealand",
    subcountry: "Auckland",
    geonameid: 2187404,
  },
  {
    name: "Mangere",
    country: "New Zealand",
    subcountry: "Auckland",
    geonameid: 2187454,
  },
  {
    name: "Lower Hutt",
    country: "New Zealand",
    subcountry: "Wellington",
    geonameid: 2188164,
  },
  {
    name: "Karori",
    country: "New Zealand",
    subcountry: "Wellington",
    geonameid: 2189028,
  },
  {
    name: "Invercargill",
    country: "New Zealand",
    subcountry: "Southland",
    geonameid: 2189529,
  },
  {
    name: "Hastings",
    country: "New Zealand",
    subcountry: "Hawke's Bay",
    geonameid: 2190224,
  },
  {
    name: "Hamilton",
    country: "New Zealand",
    subcountry: "Waikato",
    geonameid: 2190324,
  },
  {
    name: "Dunedin",
    country: "New Zealand",
    subcountry: "Otago",
    geonameid: 2191562,
  },
  {
    name: "Christchurch",
    country: "New Zealand",
    subcountry: "Canterbury",
    geonameid: 2192362,
  },
  {
    name: "Avondale",
    country: "New Zealand",
    subcountry: "Auckland",
    geonameid: 2193703,
  },
  {
    name: "Auckland",
    country: "New Zealand",
    subcountry: "Auckland",
    geonameid: 2193733,
  },
  {
    name: "Levin",
    country: "New Zealand",
    subcountry: "Manawatu-Wanganui",
    geonameid: 2206371,
  },
  {
    name: "Gisborne",
    country: "New Zealand",
    subcountry: "Gisborne",
    geonameid: 2206854,
  },
  {
    name: "Masterton",
    country: "New Zealand",
    subcountry: "Wellington",
    geonameid: 2206890,
  },
  {
    name: "Tauranga",
    country: "New Zealand",
    subcountry: "Bay of Plenty",
    geonameid: 2208032,
  },
  {
    name: "Papakura",
    country: "New Zealand",
    subcountry: "Auckland",
    geonameid: 2208329,
  },
  {
    name: "Whakatane",
    country: "New Zealand",
    subcountry: "Bay of Plenty",
    geonameid: 2208330,
  },
  {
    name: "Ashburton",
    country: "New Zealand",
    subcountry: "Canterbury",
    geonameid: 6217081,
  },
  {
    name: "Rangiora",
    country: "New Zealand",
    subcountry: "Canterbury",
    geonameid: 6220565,
  },
  {
    name: "Whangarei",
    country: "New Zealand",
    subcountry: "Northland",
    geonameid: 6230919,
  },
  {
    name: "Takanini",
    country: "New Zealand",
    subcountry: "Auckland",
    geonameid: 6231568,
  },
  {
    name: "Mangere East",
    country: "New Zealand",
    subcountry: "Auckland",
    geonameid: 6231929,
  },
  {
    name: "Papatoetoe",
    country: "New Zealand",
    subcountry: "Auckland",
    geonameid: 6232008,
  },
  {
    name: "Otahuhu",
    country: "New Zealand",
    subcountry: "Auckland",
    geonameid: 6232009,
  },
  {
    name: "Manurewa",
    country: "New Zealand",
    subcountry: "Auckland",
    geonameid: 6232064,
  },
  {
    name: "Otara",
    country: "New Zealand",
    subcountry: "Auckland",
    geonameid: 6232067,
  },
  {
    name: "Blockhouse Bay",
    country: "New Zealand",
    subcountry: "Auckland",
    geonameid: 6232191,
  },
  {
    name: "New Lynn",
    country: "New Zealand",
    subcountry: "Auckland",
    geonameid: 6232192,
  },
  {
    name: "Epsom",
    country: "New Zealand",
    subcountry: "Auckland",
    geonameid: 6232235,
  },
  {
    name: "Remuera",
    country: "New Zealand",
    subcountry: "Auckland",
    geonameid: 6232305,
  },
  {
    name: "Massey East",
    country: "New Zealand",
    subcountry: "Auckland",
    geonameid: 6232326,
  },
  {
    name: "Te Atatu South",
    country: "New Zealand",
    subcountry: "Auckland",
    geonameid: 6232330,
  },
  {
    name: "Massey",
    country: "New Zealand",
    subcountry: "Auckland",
    geonameid: 6232390,
  },
  {
    name: "Cambridge",
    country: "New Zealand",
    subcountry: "Waikato",
    geonameid: 6240770,
  },
  {
    name: "Rotorua",
    country: "New Zealand",
    subcountry: "Bay of Plenty",
    geonameid: 6241325,
  },
  {
    name: "Blenheim",
    country: "New Zealand",
    subcountry: "Marlborough",
    geonameid: 6243926,
  },
  {
    name: "Upper Hutt",
    country: "New Zealand",
    subcountry: "Wellington",
    geonameid: 6244895,
  },
  {
    name: "Te Aro",
    country: "New Zealand",
    subcountry: "Wellington",
    geonameid: 10173827,
  },
  {
    name: "Linton Military Camp",
    country: "New Zealand",
    subcountry: "Manawatu-Wanganui",
    geonameid: 11903546,
  },
  {
    name: "Sur",
    country: "Oman",
    subcountry: "Southeastern Governorate",
    geonameid: 286245,
  },
  {
    name: "Sohar",
    country: "Oman",
    subcountry: "Al Batinah North",
    geonameid: 286282,
  },
  {
    name: "Sufālat Samā’il",
    country: "Oman",
    subcountry: "Ad Dakhiliyah",
    geonameid: 286293,
  },
  {
    name: "Shināş",
    country: "Oman",
    subcountry: "Al Batinah North",
    geonameid: 286402,
  },
  {
    name: "Şalālah",
    country: "Oman",
    subcountry: "Dhofar",
    geonameid: 286621,
  },
  {
    name: "Şaḩam",
    country: "Oman",
    subcountry: "Al Batinah North",
    geonameid: 286647,
  },
  {
    name: "Nizwá",
    country: "Oman",
    subcountry: "Ad Dakhiliyah",
    geonameid: 286987,
  },
  {
    name: "Muscat",
    country: "Oman",
    subcountry: "Muscat",
    geonameid: 287286,
  },
  {
    name: "Khasab",
    country: "Oman",
    subcountry: "Musandam Governorate",
    geonameid: 287614,
  },
  {
    name: "Izkī",
    country: "Oman",
    subcountry: "Ad Dakhiliyah",
    geonameid: 287814,
  },
  {
    name: "‘Ibrī",
    country: "Oman",
    subcountry: "Ad Dhahirah",
    geonameid: 287830,
  },
  {
    name: "Ibrā’",
    country: "Oman",
    subcountry: "Northeastern Governorate",
    geonameid: 287832,
  },
  {
    name: "Bidbid",
    country: "Oman",
    subcountry: "Ad Dakhiliyah",
    geonameid: 288721,
  },
  {
    name: "Bawshar",
    country: "Oman",
    subcountry: "Muscat",
    geonameid: 288764,
  },
  {
    name: "Barkā’",
    country: "Oman",
    subcountry: "Al Batinah South",
    geonameid: 288789,
  },
  {
    name: "Bahlā’",
    country: "Oman",
    subcountry: "Ad Dakhiliyah",
    geonameid: 288899,
  },
  {
    name: "Badīyah",
    country: "Oman",
    subcountry: "Northeastern Governorate",
    geonameid: 288902,
  },
  {
    name: "As Suwayq",
    country: "Oman",
    subcountry: "Al Batinah North",
    geonameid: 288955,
  },
  {
    name: "Seeb",
    country: "Oman",
    subcountry: "Muscat",
    geonameid: 288967,
  },
  {
    name: "Rustaq",
    country: "Oman",
    subcountry: "Al Batinah South",
    geonameid: 289011,
  },
  {
    name: "Liwá",
    country: "Oman",
    subcountry: "Al Batinah North",
    geonameid: 289174,
  },
  {
    name: "Al Khābūrah",
    country: "Oman",
    subcountry: "Al Batinah North",
    geonameid: 289199,
  },
  {
    name: "Al Buraymī",
    country: "Oman",
    subcountry: "Al Buraimi",
    geonameid: 289317,
  },
  {
    name: "Adam",
    country: "Oman",
    subcountry: "Ad Dakhiliyah",
    geonameid: 289433,
  },
  {
    name: "Yanqul",
    country: "Oman",
    subcountry: "Ad Dhahirah",
    geonameid: 411849,
  },
  {
    name: "Oman Smart Future City",
    country: "Oman",
    subcountry: "Al Batinah South",
    geonameid: 11809066,
  },
  {
    name: "Veracruz",
    country: "Panama",
    subcountry: "Panamá Oeste Province",
    geonameid: 3700164,
  },
  {
    name: "Tocumen",
    country: "Panama",
    subcountry: "Panamá",
    geonameid: 3700563,
  },
  {
    name: "Santiago de Veraguas",
    country: "Panama",
    subcountry: "Veraguas",
    geonameid: 3701117,
  },
  {
    name: "San Miguelito",
    country: "Panama",
    subcountry: "Panamá",
    geonameid: 3701329,
  },
  {
    name: "Sabanitas",
    country: "Panama",
    subcountry: "Colón",
    geonameid: 3701682,
  },
  {
    name: "Río Abajo",
    country: "Panama",
    subcountry: "Panamá",
    geonameid: 3701917,
  },
  {
    name: "Penonomé",
    country: "Panama",
    subcountry: "Coclé",
    geonameid: 3703068,
  },
  {
    name: "Pedregal",
    country: "Panama",
    subcountry: "Panamá",
    geonameid: 3703227,
  },
  {
    name: "Pedregal",
    country: "Panama",
    subcountry: "Chiriquí Province",
    geonameid: 3703229,
  },
  {
    name: "Parque Lefevre",
    country: "Panama",
    subcountry: "Panamá",
    geonameid: 3703346,
  },
  {
    name: "Panamá",
    country: "Panama",
    subcountry: "Panamá",
    geonameid: 3703443,
  },
  {
    name: "Las Cumbres",
    country: "Panama",
    subcountry: "Panamá",
    geonameid: 3706567,
  },
  {
    name: "La Concepción",
    country: "Panama",
    subcountry: "Chiriquí Province",
    geonameid: 3707899,
  },
  {
    name: "La Chorrera",
    country: "Panama",
    subcountry: "Panamá Oeste Province",
    geonameid: 3707961,
  },
  {
    name: "La Cabima",
    country: "Panama",
    subcountry: "Panamá",
    geonameid: 3708066,
  },
  {
    name: "Juan Díaz",
    country: "Panama",
    subcountry: "Panamá",
    geonameid: 3708306,
  },
  {
    name: "El Chorrillo",
    country: "Panama",
    subcountry: "Panamá",
    geonameid: 3711125,
  },
  {
    name: "David",
    country: "Panama",
    subcountry: "Chiriquí Province",
    geonameid: 3711668,
  },
  {
    name: "Curundú",
    country: "Panama",
    subcountry: "Panamá",
    geonameid: 3711699,
  },
  {
    name: "Colón",
    country: "Panama",
    subcountry: "Colón",
    geonameid: 3712076,
  },
  {
    name: "Chilibre",
    country: "Panama",
    subcountry: "Panamá",
    geonameid: 3712455,
  },
  {
    name: "Changuinola",
    country: "Panama",
    subcountry: "Bocas del Toro Province",
    geonameid: 3712560,
  },
  {
    name: "Cativá",
    country: "Panama",
    subcountry: "Colón",
    geonameid: 3712884,
  },
  {
    name: "Arraiján",
    country: "Panama",
    subcountry: "Panamá Oeste Province",
    geonameid: 3714637,
  },
  {
    name: "Ancón",
    country: "Panama",
    subcountry: "Panamá",
    geonameid: 3714734,
  },
  {
    name: "Alcalde Díaz",
    country: "Panama",
    subcountry: "Panamá",
    geonameid: 3714932,
  },
  {
    name: "Nuevo Belén",
    country: "Panama",
    subcountry: "Panamá",
    geonameid: 10180082,
  },
  {
    name: "Yurimaguas",
    country: "Peru",
    subcountry: "Loreto",
    geonameid: 3690654,
  },
  {
    name: "Virú",
    country: "Peru",
    subcountry: "La Libertad",
    geonameid: 3690875,
  },
  {
    name: "Uchiza",
    country: "Peru",
    subcountry: "San Martín",
    geonameid: 3691094,
  },
  {
    name: "Tumbes",
    country: "Peru",
    subcountry: "Tumbes",
    geonameid: 3691148,
  },
  {
    name: "Trujillo",
    country: "Peru",
    subcountry: "La Libertad",
    geonameid: 3691175,
  },
  {
    name: "Tocache",
    country: "Peru",
    subcountry: "San Martín",
    geonameid: 3691324,
  },
  {
    name: "Tingo María",
    country: "Peru",
    subcountry: "Huanuco",
    geonameid: 3691348,
  },
  {
    name: "Tambo Grande",
    country: "Peru",
    subcountry: "Piura",
    geonameid: 3691530,
  },
  {
    name: "Talara",
    country: "Peru",
    subcountry: "Piura",
    geonameid: 3691582,
  },
  {
    name: "Sullana",
    country: "Peru",
    subcountry: "Piura",
    geonameid: 3691674,
  },
  {
    name: "Sechura",
    country: "Peru",
    subcountry: "Piura",
    geonameid: 3691954,
  },
  {
    name: "Santiago de Cao",
    country: "Peru",
    subcountry: "La Libertad",
    geonameid: 3692073,
  },
  {
    name: "San Pedro de Lloc",
    country: "Peru",
    subcountry: "La Libertad",
    geonameid: 3692310,
  },
  {
    name: "San Juan",
    country: "Peru",
    subcountry: "Loreto",
    geonameid: 3692462,
  },
  {
    name: "Saña",
    country: "Peru",
    subcountry: "Lambayeque",
    geonameid: 3692667,
  },
  {
    name: "Rioja",
    country: "Peru",
    subcountry: "San Martín",
    geonameid: 3692863,
  },
  {
    name: "Querecotillo",
    country: "Peru",
    subcountry: "Piura",
    geonameid: 3693057,
  },
  {
    name: "Pucallpa",
    country: "Peru",
    subcountry: "Ucayali",
    geonameid: 3693345,
  },
  {
    name: "Piura",
    country: "Peru",
    subcountry: "Piura",
    geonameid: 3693528,
  },
  {
    name: "Pimentel",
    country: "Peru",
    subcountry: "Lambayeque",
    geonameid: 3693584,
  },
  {
    name: "Picsi",
    country: "Peru",
    subcountry: "Lambayeque",
    geonameid: 3693645,
  },
  {
    name: "Pátapo",
    country: "Peru",
    subcountry: "Lambayeque",
    geonameid: 3693826,
  },
  {
    name: "Paita",
    country: "Peru",
    subcountry: "Piura",
    geonameid: 3694112,
  },
  {
    name: "Paiján",
    country: "Peru",
    subcountry: "La Libertad",
    geonameid: 3694119,
  },
  {
    name: "Pacasmayo",
    country: "Peru",
    subcountry: "La Libertad",
    geonameid: 3694178,
  },
  {
    name: "Moyobamba",
    country: "Peru",
    subcountry: "San Martín",
    geonameid: 3694564,
  },
  {
    name: "Monsefú",
    country: "Peru",
    subcountry: "Lambayeque",
    geonameid: 3694666,
  },
  {
    name: "Moche",
    country: "Peru",
    subcountry: "La Libertad",
    geonameid: 3694725,
  },
  {
    name: "Marcavelica",
    country: "Peru",
    subcountry: "Piura",
    geonameid: 3694939,
  },
  {
    name: "La Unión",
    country: "Peru",
    subcountry: "Piura",
    geonameid: 3695466,
  },
  {
    name: "Laredo",
    country: "Peru",
    subcountry: "La Libertad",
    geonameid: 3695617,
  },
  {
    name: "La Peca",
    country: "Peru",
    subcountry: "Amazonas",
    geonameid: 3695675,
  },
  {
    name: "Lambayeque",
    country: "Peru",
    subcountry: "Lambayeque",
    geonameid: 3695754,
  },
  {
    name: "Juanjuí",
    country: "Peru",
    subcountry: "San Martín",
    geonameid: 3696057,
  },
  {
    name: "Jaén",
    country: "Peru",
    subcountry: "Cajamarca",
    geonameid: 3696150,
  },
  {
    name: "Iquitos",
    country: "Peru",
    subcountry: "Loreto",
    geonameid: 3696183,
  },
  {
    name: "Huaraz",
    country: "Peru",
    subcountry: "Ancash",
    geonameid: 3696378,
  },
  {
    name: "Huánuco",
    country: "Peru",
    subcountry: "Huanuco",
    geonameid: 3696417,
  },
  {
    name: "Huamachuco",
    country: "Peru",
    subcountry: "La Libertad",
    geonameid: 3696509,
  },
  {
    name: "Guadalupe",
    country: "Peru",
    subcountry: "La Libertad",
    geonameid: 3696847,
  },
  {
    name: "Ferreñafe",
    country: "Peru",
    subcountry: "Lambayeque",
    geonameid: 3697033,
  },
  {
    name: "Coishco",
    country: "Peru",
    subcountry: "Ancash",
    geonameid: 3697990,
  },
  {
    name: "Chulucanas",
    country: "Peru",
    subcountry: "Piura",
    geonameid: 3698105,
  },
  {
    name: "Chongoyape",
    country: "Peru",
    subcountry: "Lambayeque",
    geonameid: 3698176,
  },
  {
    name: "Chocope",
    country: "Peru",
    subcountry: "La Libertad",
    geonameid: 3698194,
  },
  {
    name: "Chimbote",
    country: "Peru",
    subcountry: "Ancash",
    geonameid: 3698304,
  },
  {
    name: "Chiclayo",
    country: "Peru",
    subcountry: "Lambayeque",
    geonameid: 3698350,
  },
  {
    name: "Chepén",
    country: "Peru",
    subcountry: "La Libertad",
    geonameid: 3698390,
  },
  {
    name: "Chachapoyas",
    country: "Peru",
    subcountry: "Amazonas",
    geonameid: 3698540,
  },
  {
    name: "Catacaos",
    country: "Peru",
    subcountry: "Piura",
    geonameid: 3698658,
  },
  {
    name: "Cajamarca",
    country: "Peru",
    subcountry: "Cajamarca",
    geonameid: 3699088,
  },
  {
    name: "Bellavista",
    country: "Peru",
    subcountry: "San Martín",
    geonameid: 3699364,
  },
  {
    name: "Bagua Grande",
    country: "Peru",
    subcountry: "Amazonas",
    geonameid: 3699484,
  },
  {
    name: "La Breita",
    country: "Peru",
    subcountry: "Piura",
    geonameid: 3814568,
  },
  {
    name: "Zarumilla",
    country: "Peru",
    subcountry: "Tumbes",
    geonameid: 3818398,
  },
  {
    name: "Belen",
    country: "Peru",
    subcountry: "Loreto",
    geonameid: 3827811,
  },
  {
    name: "Yunguyo",
    country: "Peru",
    subcountry: "Puno",
    geonameid: 3925476,
  },
  {
    name: "Yauri",
    country: "Peru",
    subcountry: "Cusco",
    geonameid: 3925590,
  },
  {
    name: "Yanacancha",
    country: "Peru",
    subcountry: "Huanuco",
    geonameid: 3925863,
  },
  {
    name: "Tarma",
    country: "Peru",
    subcountry: "Junin",
    geonameid: 3927758,
  },
  {
    name: "Tambopata",
    country: "Peru",
    subcountry: "Madre de Dios",
    geonameid: 3927942,
  },
  {
    name: "Tacna",
    country: "Peru",
    subcountry: "Tacna",
    geonameid: 3928128,
  },
  {
    name: "Santiago de Surco",
    country: "Peru",
    subcountry: "Lima region",
    geonameid: 3928245,
  },
  {
    name: "Sicuani",
    country: "Peru",
    subcountry: "Cusco",
    geonameid: 3928679,
  },
  {
    name: "Satipo",
    country: "Peru",
    subcountry: "Junin",
    geonameid: 3928924,
  },
  {
    name: "San Vicente de Cañete",
    country: "Peru",
    subcountry: "Lima region",
    geonameid: 3928993,
  },
  {
    name: "Santa Ana",
    country: "Peru",
    subcountry: "Cusco",
    geonameid: 3929295,
  },
  {
    name: "San Isidro",
    country: "Peru",
    subcountry: "Lima region",
    geonameid: 3929631,
  },
  {
    name: "San Clemente",
    country: "Peru",
    subcountry: "Ica",
    geonameid: 3929768,
  },
  {
    name: "Puno",
    country: "Peru",
    subcountry: "Puno",
    geonameid: 3931276,
  },
  {
    name: "Puerto Maldonado",
    country: "Peru",
    subcountry: "Madre de Dios",
    geonameid: 3931470,
  },
  {
    name: "Pisco",
    country: "Peru",
    subcountry: "Ica",
    geonameid: 3932145,
  },
  {
    name: "Paramonga",
    country: "Peru",
    subcountry: "Lima region",
    geonameid: 3933024,
  },
  {
    name: "Nuevo Imperial",
    country: "Peru",
    subcountry: "Lima region",
    geonameid: 3934239,
  },
  {
    name: "Nazca",
    country: "Peru",
    subcountry: "Ica",
    geonameid: 3934356,
  },
  {
    name: "Moquegua",
    country: "Peru",
    subcountry: "Moquegua",
    geonameid: 3934608,
  },
  {
    name: "Mollendo",
    country: "Peru",
    subcountry: "Arequipa",
    geonameid: 3934707,
  },
  {
    name: "Minas de Marcona",
    country: "Peru",
    subcountry: "Ica",
    geonameid: 3935288,
  },
  {
    name: "Mala",
    country: "Peru",
    subcountry: "Lima region",
    geonameid: 3935572,
  },
  {
    name: "Lima",
    country: "Peru",
    subcountry: "Lima",
    geonameid: 3936456,
  },
  {
    name: "La Oroya",
    country: "Peru",
    subcountry: "Junin",
    geonameid: 3936952,
  },
  {
    name: "Junín",
    country: "Peru",
    subcountry: "Junin",
    geonameid: 3937486,
  },
  {
    name: "Juliaca",
    country: "Peru",
    subcountry: "Puno",
    geonameid: 3937513,
  },
  {
    name: "Jauja",
    country: "Peru",
    subcountry: "Junin",
    geonameid: 3937733,
  },
  {
    name: "Imperial",
    country: "Peru",
    subcountry: "Lima region",
    geonameid: 3938396,
  },
  {
    name: "Ilo",
    country: "Peru",
    subcountry: "Moquegua",
    geonameid: 3938415,
  },
  {
    name: "Ilave",
    country: "Peru",
    subcountry: "Puno",
    geonameid: 3938451,
  },
  { name: "Ica", country: "Peru", subcountry: "Ica", geonameid: 3938527 },
  {
    name: "Huaura",
    country: "Peru",
    subcountry: "Lima region",
    geonameid: 3939023,
  },
  {
    name: "Huarmey",
    country: "Peru",
    subcountry: "Ancash",
    geonameid: 3939168,
  },
  {
    name: "Huaral",
    country: "Peru",
    subcountry: "Lima region",
    geonameid: 3939285,
  },
  {
    name: "Huanta",
    country: "Peru",
    subcountry: "Ayacucho",
    geonameid: 3939386,
  },
  {
    name: "Huancayo",
    country: "Peru",
    subcountry: "Junin",
    geonameid: 3939459,
  },
  {
    name: "Huancavelica",
    country: "Peru",
    subcountry: "Huancavelica",
    geonameid: 3939470,
  },
  {
    name: "Hualmay",
    country: "Peru",
    subcountry: "Lima region",
    geonameid: 3939761,
  },
  {
    name: "Huacho",
    country: "Peru",
    subcountry: "Lima region",
    geonameid: 3940002,
  },
  {
    name: "Cusco",
    country: "Peru",
    subcountry: "Cusco",
    geonameid: 3941584,
  },
  {
    name: "Chosica",
    country: "Peru",
    subcountry: "Lima region",
    geonameid: 3943423,
  },
  {
    name: "Chincha Alta",
    country: "Peru",
    subcountry: "Ica",
    geonameid: 3943789,
  },
  {
    name: "Chaupimarca",
    country: "Peru",
    subcountry: "Pasco",
    geonameid: 3944179,
  },
  {
    name: "Chancay",
    country: "Peru",
    subcountry: "Lima region",
    geonameid: 3944399,
  },
  {
    name: "Cerro de Pasco",
    country: "Peru",
    subcountry: "Pasco",
    geonameid: 3944797,
  },
  {
    name: "Camaná",
    country: "Peru",
    subcountry: "Arequipa",
    geonameid: 3945985,
  },
  {
    name: "Callao",
    country: "Peru",
    subcountry: "Callao",
    geonameid: 3946083,
  },
  {
    name: "Barranca",
    country: "Peru",
    subcountry: "Lima region",
    geonameid: 3946820,
  },
  {
    name: "Ayaviri",
    country: "Peru",
    subcountry: "Puno",
    geonameid: 3946985,
  },
  {
    name: "Ayacucho",
    country: "Peru",
    subcountry: "Ayacucho",
    geonameid: 3947019,
  },
  {
    name: "Arequipa",
    country: "Peru",
    subcountry: "Arequipa",
    geonameid: 3947322,
  },
  {
    name: "Andahuaylas",
    country: "Peru",
    subcountry: "Apurímac",
    geonameid: 3947740,
  },
  {
    name: "Abancay",
    country: "Peru",
    subcountry: "Apurímac",
    geonameid: 3948642,
  },
  {
    name: "Jacobo Hunter",
    country: "Peru",
    subcountry: "Arequipa",
    geonameid: 3949231,
  },
  {
    name: "La Rinconada",
    country: "Peru",
    subcountry: "Puno",
    geonameid: 7626291,
  },
  {
    name: "Santa Anita - Los Ficus",
    country: "Peru",
    subcountry: "Lima region",
    geonameid: 12157007,
  },
  {
    name: "San Martin",
    country: "Peru",
    subcountry: "Piura",
    geonameid: 12157008,
  },
  {
    name: "San Francisco De Borja",
    country: "Peru",
    subcountry: "Lima region",
    geonameid: 12157013,
  },
  {
    name: "Ciudad Satelite",
    country: "Peru",
    subcountry: "Arequipa",
    geonameid: 12157025,
  },
  {
    name: "Chilca",
    country: "Peru",
    subcountry: "Junin",
    geonameid: 12157030,
  },
  {
    name: "San Fernando",
    country: "Peru",
    subcountry: "Ucayali",
    geonameid: 12157037,
  },
  {
    name: "Jesus Maria",
    country: "Peru",
    subcountry: "Lima region",
    geonameid: 12157038,
  },
  {
    name: "Wanchaq",
    country: "Peru",
    subcountry: "Cusco",
    geonameid: 12157056,
  },
  {
    name: "Centenario",
    country: "Peru",
    subcountry: "Ancash",
    geonameid: 12157064,
  },
  {
    name: "Cono Norte",
    country: "Peru",
    subcountry: "Arequipa",
    geonameid: 12157065,
  },
  {
    name: "Carmen De La Legua Reynoso",
    country: "Peru",
    subcountry: "Callao",
    geonameid: 12157070,
  },
  {
    name: "La Banda",
    country: "Peru",
    subcountry: "San Martín",
    geonameid: 12157074,
  },
  {
    name: "Yanacancha",
    country: "Peru",
    subcountry: "Pasco",
    geonameid: 12157091,
  },
  {
    name: "El Pedregal",
    country: "Peru",
    subcountry: "Arequipa",
    geonameid: 12157092,
  },
  {
    name: "Santa Rosa",
    country: "Peru",
    subcountry: "Junin",
    geonameid: 12157093,
  },
  {
    name: "San Antonio",
    country: "Peru",
    subcountry: "Moquegua",
    geonameid: 12157094,
  },
  {
    name: "Selva Alegre",
    country: "Peru",
    subcountry: "Arequipa",
    geonameid: 12157128,
  },
  {
    name: "Santiago",
    country: "Peru",
    subcountry: "Cusco",
    geonameid: 12157129,
  },
  {
    name: "Breña",
    country: "Peru",
    subcountry: "Lima region",
    geonameid: 12165736,
  },
  {
    name: "Punaauia",
    country: "French Polynesia",
    subcountry: "Îles du Vent",
    geonameid: 4033779,
  },
  {
    name: "Papeete",
    country: "French Polynesia",
    subcountry: "Îles du Vent",
    geonameid: 4033936,
  },
  {
    name: "Faaa",
    country: "French Polynesia",
    subcountry: "Îles du Vent",
    geonameid: 4034561,
  },
  {
    name: "Wewak",
    country: "Papua New Guinea",
    subcountry: "East Sepik",
    geonameid: 2083537,
  },
  {
    name: "Port Moresby",
    country: "Papua New Guinea",
    subcountry: "National Capital",
    geonameid: 2088122,
  },
  {
    name: "Popondetta",
    country: "Papua New Guinea",
    subcountry: "Northern Province",
    geonameid: 2088163,
  },
  {
    name: "Mount Hagen",
    country: "Papua New Guinea",
    subcountry: "Western Highlands",
    geonameid: 2090409,
  },
  {
    name: "Mendi",
    country: "Papua New Guinea",
    subcountry: "Southern Highlands",
    geonameid: 2090990,
  },
  {
    name: "Madang",
    country: "Papua New Guinea",
    subcountry: "Madang",
    geonameid: 2091996,
  },
  {
    name: "Lae",
    country: "Papua New Guinea",
    subcountry: "Morobe",
    geonameid: 2092740,
  },
  {
    name: "Kokopo",
    country: "Papua New Guinea",
    subcountry: "East New Britain",
    geonameid: 2093685,
  },
  {
    name: "Kimbe",
    country: "Papua New Guinea",
    subcountry: "West New Britain",
    geonameid: 2093967,
  },
  {
    name: "Goroka",
    country: "Papua New Guinea",
    subcountry: "Eastern Highlands",
    geonameid: 2096742,
  },
  {
    name: "Daru",
    country: "Papua New Guinea",
    subcountry: "Western Province",
    geonameid: 2098329,
  },
  {
    name: "Bulolo",
    country: "Papua New Guinea",
    subcountry: "Morobe",
    geonameid: 2098869,
  },
  {
    name: "Arawa",
    country: "Papua New Guinea",
    subcountry: "Bougainville",
    geonameid: 2100633,
  },
  {
    name: "Zamboanga",
    country: "Philippines",
    subcountry: "Zamboanga Peninsula",
    geonameid: 1679432,
  },
  {
    name: "Wao",
    country: "Philippines",
    subcountry: "Autonomous Region in Muslim Mindanao",
    geonameid: 1679678,
  },
  {
    name: "Virac",
    country: "Philippines",
    subcountry: "Bicol",
    geonameid: 1679802,
  },
  {
    name: "Vigan",
    country: "Philippines",
    subcountry: "Ilocos",
    geonameid: 1679980,
  },
  {
    name: "Victorias",
    country: "Philippines",
    subcountry: "Western Visayas",
    geonameid: 1680007,
  },
  {
    name: "Victoria",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1680018,
  },
  {
    name: "Veruela",
    country: "Philippines",
    subcountry: "Caraga",
    geonameid: 1680040,
  },
  {
    name: "NIA Valencia",
    country: "Philippines",
    subcountry: "Northern Mindanao",
    geonameid: 1680116,
  },
  {
    name: "Urdaneta",
    country: "Philippines",
    subcountry: "Ilocos",
    geonameid: 1680197,
  },
  {
    name: "Ualog",
    country: "Philippines",
    subcountry: "Western Visayas",
    geonameid: 1680505,
  },
  {
    name: "Tupi",
    country: "Philippines",
    subcountry: "Soccsksargen",
    geonameid: 1680613,
  },
  {
    name: "Tunasan",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1680704,
  },
  {
    name: "Tuguegarao",
    country: "Philippines",
    subcountry: "Cagayan Valley",
    geonameid: 1680932,
  },
  {
    name: "Trento",
    country: "Philippines",
    subcountry: "Caraga",
    geonameid: 1681333,
  },
  {
    name: "Toledo",
    country: "Philippines",
    subcountry: "Central Visayas",
    geonameid: 1681602,
  },
  {
    name: "Tiwi",
    country: "Philippines",
    subcountry: "Bicol",
    geonameid: 1681676,
  },
  {
    name: "Tinongan",
    country: "Philippines",
    subcountry: "Western Visayas",
    geonameid: 1681766,
  },
  {
    name: "Ternate",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1682472,
  },
  {
    name: "Teresa",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1682478,
  },
  {
    name: "Telabastagan",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1682537,
  },
  {
    name: "Taytay",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1682598,
  },
  {
    name: "Tayabas",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1682659,
  },
  {
    name: "Tarlac City",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1682812,
  },
  {
    name: "Tanza",
    country: "Philippines",
    subcountry: "Metro Manila",
    geonameid: 1683013,
  },
  {
    name: "Tanjay",
    country: "Philippines",
    subcountry: "Central Visayas",
    geonameid: 1683088,
  },
  {
    name: "Tangub",
    country: "Philippines",
    subcountry: "Northern Mindanao",
    geonameid: 1683116,
  },
  {
    name: "Tandag",
    country: "Philippines",
    subcountry: "Caraga",
    geonameid: 1683302,
  },
  {
    name: "Tanay",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1683319,
  },
  {
    name: "Tanauan",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1683340,
  },
  {
    name: "Tanauan",
    country: "Philippines",
    subcountry: "Eastern Visayas",
    geonameid: 1683342,
  },
  {
    name: "Taloc",
    country: "Philippines",
    subcountry: "Western Visayas",
    geonameid: 1683800,
  },
  {
    name: "Talisay",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1683860,
  },
  {
    name: "Talisay",
    country: "Philippines",
    subcountry: "Western Visayas",
    geonameid: 1683877,
  },
  {
    name: "Talisay",
    country: "Philippines",
    subcountry: "Central Visayas",
    geonameid: 1683881,
  },
  {
    name: "Talavera",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1684016,
  },
  {
    name: "Talacogon",
    country: "Philippines",
    subcountry: "Caraga",
    geonameid: 1684137,
  },
  {
    name: "Magugpo Poblacion",
    country: "Philippines",
    subcountry: "Davao",
    geonameid: 1684269,
  },
  {
    name: "Taguig",
    country: "Philippines",
    subcountry: "Metro Manila",
    geonameid: 1684308,
  },
  {
    name: "Tagudin",
    country: "Philippines",
    subcountry: "Ilocos",
    geonameid: 1684320,
  },
  {
    name: "Tagoloan",
    country: "Philippines",
    subcountry: "Northern Mindanao",
    geonameid: 1684379,
  },
  {
    name: "Tagbilaran City",
    country: "Philippines",
    subcountry: "Central Visayas",
    geonameid: 1684497,
  },
  {
    name: "Tagaytay",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1684553,
  },
  {
    name: "Tagas",
    country: "Philippines",
    subcountry: "Bicol",
    geonameid: 1684577,
  },
  {
    name: "Tacurong",
    country: "Philippines",
    subcountry: "Soccsksargen",
    geonameid: 1684681,
  },
  {
    name: "Tacloban",
    country: "Philippines",
    subcountry: "Eastern Visayas",
    geonameid: 1684712,
  },
  {
    name: "Tabuk",
    country: "Philippines",
    subcountry: "Cordillera",
    geonameid: 1684803,
  },
  {
    name: "Tabaco",
    country: "Philippines",
    subcountry: "Bicol",
    geonameid: 1685117,
  },
  {
    name: "Taal",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1685146,
  },
  {
    name: "Surigao",
    country: "Philippines",
    subcountry: "Caraga",
    geonameid: 1685218,
  },
  {
    name: "Surallah",
    country: "Philippines",
    subcountry: "Soccsksargen",
    geonameid: 1685230,
  },
  {
    name: "Sumag",
    country: "Philippines",
    subcountry: "Western Visayas",
    geonameid: 1685349,
  },
  {
    name: "Subic",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1685577,
  },
  {
    name: "Suay",
    country: "Philippines",
    subcountry: "Western Visayas",
    geonameid: 1685622,
  },
  {
    name: "Sorsogon",
    country: "Philippines",
    subcountry: "Bicol",
    geonameid: 1685755,
  },
  {
    name: "Solano",
    country: "Philippines",
    subcountry: "Cagayan Valley",
    geonameid: 1685875,
  },
  {
    name: "Solana",
    country: "Philippines",
    subcountry: "Cagayan Valley",
    geonameid: 1685880,
  },
  {
    name: "Sitangkai",
    country: "Philippines",
    subcountry: "Autonomous Region in Muslim Mindanao",
    geonameid: 1686004,
  },
  {
    name: "Sipalay",
    country: "Philippines",
    subcountry: "Western Visayas",
    geonameid: 1686102,
  },
  {
    name: "Silang",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1686547,
  },
  {
    name: "Sibulan",
    country: "Philippines",
    subcountry: "Central Visayas",
    geonameid: 1686728,
  },
  {
    name: "Sexmoan",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1686933,
  },
  {
    name: "Lake Sebu",
    country: "Philippines",
    subcountry: "Soccsksargen",
    geonameid: 1687029,
  },
  {
    name: "Sariaya",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1687164,
  },
  {
    name: "San Vicente",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1687409,
  },
  {
    name: "Santo Tomas",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1687534,
  },
  {
    name: "Santol",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1687687,
  },
  {
    name: "Santiago",
    country: "Philippines",
    subcountry: "Cagayan Valley",
    geonameid: 1687801,
  },
  {
    name: "Santa Rosa",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1687894,
  },
  {
    name: "Santa Maria",
    country: "Philippines",
    subcountry: "Ilocos",
    geonameid: 1688017,
  },
  {
    name: "Santa Maria",
    country: "Philippines",
    subcountry: "Davao",
    geonameid: 1688058,
  },
  {
    name: "Santa Cruz",
    country: "Philippines",
    subcountry: "Metro Manila",
    geonameid: 1688216,
  },
  {
    name: "Santa Cruz",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1688232,
  },
  {
    name: "Santa Cruz",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1688248,
  },
  {
    name: "Santa Cruz",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1688253,
  },
  {
    name: "Santa Catalina",
    country: "Philippines",
    subcountry: "Central Visayas",
    geonameid: 1688363,
  },
  {
    name: "Santa Barbara",
    country: "Philippines",
    subcountry: "Ilocos",
    geonameid: 1688372,
  },
  {
    name: "Santa Ana",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1688398,
  },
  {
    name: "San Simon",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1688425,
  },
  {
    name: "San Pedro",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1688749,
  },
  {
    name: "San Pascual",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1688795,
  },
  {
    name: "San Pablo",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1688830,
  },
  {
    name: "San Nicolas",
    country: "Philippines",
    subcountry: "Ilocos",
    geonameid: 1688859,
  },
  {
    name: "San Narciso",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1688912,
  },
  {
    name: "San Miguel",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1688949,
  },
  {
    name: "San Miguel",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1688954,
  },
  {
    name: "San Mateo",
    country: "Philippines",
    subcountry: "Cagayan Valley",
    geonameid: 1689052,
  },
  {
    name: "San Mateo",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1689056,
  },
  {
    name: "San Mariano",
    country: "Philippines",
    subcountry: "Davao",
    geonameid: 1689087,
  },
  {
    name: "San Marcelino",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1689099,
  },
  {
    name: "San Luis",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1689129,
  },
  {
    name: "San Leonardo",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1689171,
  },
  {
    name: "San Juan",
    country: "Philippines",
    subcountry: "Metro Manila",
    geonameid: 1689286,
  },
  {
    name: "San Jose del Monte",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1689395,
  },
  {
    name: "San Jose",
    country: "Philippines",
    subcountry: "Bicol",
    geonameid: 1689498,
  },
  {
    name: "San Jose",
    country: "Philippines",
    subcountry: "Mimaropa",
    geonameid: 1689510,
  },
  {
    name: "San Ildefonso",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1689832,
  },
  {
    name: "San Francisco",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1689973,
  },
  {
    name: "Aurora",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1689994,
  },
  {
    name: "San Francisco",
    country: "Philippines",
    subcountry: "Caraga",
    geonameid: 1690019,
  },
  {
    name: "San Fernando",
    country: "Philippines",
    subcountry: "Ilocos",
    geonameid: 1690033,
  },
  {
    name: "San Fernando",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1690039,
  },
  {
    name: "San Fernando",
    country: "Philippines",
    subcountry: "Central Visayas",
    geonameid: 1690060,
  },
  {
    name: "San Antonio",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1690313,
  },
  {
    name: "San Antonio",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1690321,
  },
  {
    name: "Sampaloc",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1690570,
  },
  {
    name: "Samal",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1690664,
  },
  {
    name: "Samal",
    country: "Philippines",
    subcountry: "Davao",
    geonameid: 1690666,
  },
  {
    name: "Sagay",
    country: "Philippines",
    subcountry: "Western Visayas",
    geonameid: 1691150,
  },
  {
    name: "Sablayan",
    country: "Philippines",
    subcountry: "Mimaropa",
    geonameid: 1691280,
  },
  {
    name: "Roxas",
    country: "Philippines",
    subcountry: "Cagayan Valley",
    geonameid: 1691441,
  },
  {
    name: "Roxas City",
    country: "Philippines",
    subcountry: "Western Visayas",
    geonameid: 1691444,
  },
  {
    name: "Roxas",
    country: "Philippines",
    subcountry: "Mimaropa",
    geonameid: 1691446,
  },
  {
    name: "Romblon",
    country: "Philippines",
    subcountry: "Mimaropa",
    geonameid: 1691538,
  },
  {
    name: "Rizal",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1691606,
  },
  {
    name: "Recodo",
    country: "Philippines",
    subcountry: "Zamboanga Peninsula",
    geonameid: 1691804,
  },
  {
    name: "Ramos",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1691904,
  },
  {
    name: "Ramon",
    country: "Philippines",
    subcountry: "Cagayan Valley",
    geonameid: 1691911,
  },
  {
    name: "Quiapo",
    country: "Philippines",
    subcountry: "Metro Manila",
    geonameid: 1692184,
  },
  {
    name: "Quezon City",
    country: "Philippines",
    subcountry: "Metro Manila",
    geonameid: 1692192,
  },
  {
    name: "Quezon",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1692199,
  },
  {
    name: "Quezon",
    country: "Philippines",
    subcountry: "Northern Mindanao",
    geonameid: 1692214,
  },
  {
    name: "Pulupandan",
    country: "Philippines",
    subcountry: "Western Visayas",
    geonameid: 1692489,
  },
  {
    name: "Pulong Santa Cruz",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1692520,
  },
  {
    name: "Pulilan",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1692565,
  },
  {
    name: "Puerto Princesa",
    country: "Philippines",
    subcountry: "Mimaropa",
    geonameid: 1692685,
  },
  {
    name: "Port Area",
    country: "Philippines",
    subcountry: "Metro Manila",
    geonameid: 1692872,
  },
  {
    name: "Porac",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1692914,
  },
  {
    name: "Polomolok",
    country: "Philippines",
    subcountry: "Soccsksargen",
    geonameid: 1693077,
  },
  {
    name: "Polangui",
    country: "Philippines",
    subcountry: "Bicol",
    geonameid: 1693136,
  },
  {
    name: "Plaridel",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1693239,
  },
  {
    name: "Pio",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1693401,
  },
  {
    name: "Pinamungahan",
    country: "Philippines",
    subcountry: "Central Visayas",
    geonameid: 1693574,
  },
  {
    name: "Pinamalayan",
    country: "Philippines",
    subcountry: "Mimaropa",
    geonameid: 1693618,
  },
  {
    name: "Pililla",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1693778,
  },
  {
    name: "Pilar",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1693839,
  },
  {
    name: "Pila",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1693870,
  },
  {
    name: "Peñaranda",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1694075,
  },
  {
    name: "Patuto",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1694290,
  },
  {
    name: "Passi",
    country: "Philippines",
    subcountry: "Western Visayas",
    geonameid: 1694498,
  },
  {
    name: "Pasay",
    country: "Philippines",
    subcountry: "Metro Manila",
    geonameid: 1694611,
  },
  {
    name: "Parang",
    country: "Philippines",
    subcountry: "Autonomous Region in Muslim Mindanao",
    geonameid: 1694775,
  },
  {
    name: "Paranaque City",
    country: "Philippines",
    subcountry: "Metro Manila",
    geonameid: 1694781,
  },
  {
    name: "Paraiso",
    country: "Philippines",
    subcountry: "Western Visayas",
    geonameid: 1694791,
  },
  {
    name: "Papaya",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1694826,
  },
  {
    name: "Paombong",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1694861,
  },
  {
    name: "Pantubig",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1694914,
  },
  {
    name: "Paniqui",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1695097,
  },
  {
    name: "Pangil",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1695283,
  },
  {
    name: "Pandi",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1695462,
  },
  {
    name: "Pandacaqui",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1695583,
  },
  {
    name: "Panalanoy",
    country: "Philippines",
    subcountry: "Eastern Visayas",
    geonameid: 1695743,
  },
  {
    name: "Panabo",
    country: "Philippines",
    subcountry: "Davao",
    geonameid: 1695804,
  },
  {
    name: "Palo",
    country: "Philippines",
    subcountry: "Eastern Visayas",
    geonameid: 1696041,
  },
  {
    name: "Palayan City",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1696165,
  },
  {
    name: "Pagbilao",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1696614,
  },
  {
    name: "Pagaluñgan",
    country: "Philippines",
    subcountry: "Autonomous Region in Muslim Mindanao",
    geonameid: 1696683,
  },
  {
    name: "Pagadian",
    country: "Philippines",
    subcountry: "Zamboanga Peninsula",
    geonameid: 1696710,
  },
  {
    name: "Paete",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1696718,
  },
  {
    name: "Pacol",
    country: "Philippines",
    subcountry: "Western Visayas",
    geonameid: 1696814,
  },
  {
    name: "Paco",
    country: "Philippines",
    subcountry: "Metro Manila",
    geonameid: 1696817,
  },
  {
    name: "Ozamiz City",
    country: "Philippines",
    subcountry: "Northern Mindanao",
    geonameid: 1696899,
  },
  {
    name: "Oroquieta",
    country: "Philippines",
    subcountry: "Northern Mindanao",
    geonameid: 1697006,
  },
  {
    name: "Ormoc",
    country: "Philippines",
    subcountry: "Eastern Visayas",
    geonameid: 1697018,
  },
  {
    name: "Orion",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1697023,
  },
  {
    name: "Orani",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1697046,
  },
  {
    name: "Olongapo",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1697175,
  },
  {
    name: "Obando",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1697376,
  },
  {
    name: "Noveleta",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1697486,
  },
  {
    name: "Norzagaray",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1697497,
  },
  {
    name: "New Corella",
    country: "Philippines",
    subcountry: "Davao",
    geonameid: 1697773,
  },
  {
    name: "Navotas",
    country: "Philippines",
    subcountry: "Metro Manila",
    geonameid: 1697846,
  },
  {
    name: "Nasugbu",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1698030,
  },
  {
    name: "Narra",
    country: "Philippines",
    subcountry: "Mimaropa",
    geonameid: 1698103,
  },
  {
    name: "Naic",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1698548,
  },
  {
    name: "Nagcarlan",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1698740,
  },
  {
    name: "Naga",
    country: "Philippines",
    subcountry: "Bicol",
    geonameid: 1698829,
  },
  {
    name: "Naga",
    country: "Philippines",
    subcountry: "Central Visayas",
    geonameid: 1698839,
  },
  {
    name: "Nabunturan",
    country: "Philippines",
    subcountry: "Davao",
    geonameid: 1698887,
  },
  {
    name: "Nabua",
    country: "Philippines",
    subcountry: "Bicol",
    geonameid: 1698921,
  },
  {
    name: "Muricay",
    country: "Philippines",
    subcountry: "Zamboanga Peninsula",
    geonameid: 1699054,
  },
  {
    name: "Murcia",
    country: "Philippines",
    subcountry: "Western Visayas",
    geonameid: 1699060,
  },
  {
    name: "Muñoz",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1699088,
  },
  {
    name: "Morong",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1699204,
  },
  {
    name: "Morong",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1699205,
  },
  {
    name: "Rodriguez",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1699296,
  },
  {
    name: "Monkayo",
    country: "Philippines",
    subcountry: "Davao",
    geonameid: 1699323,
  },
  {
    name: "Molave",
    country: "Philippines",
    subcountry: "Zamboanga Peninsula",
    geonameid: 1699388,
  },
  {
    name: "Minglanilla",
    country: "Philippines",
    subcountry: "Central Visayas",
    geonameid: 1699572,
  },
  {
    name: "Midsayap",
    country: "Philippines",
    subcountry: "Soccsksargen",
    geonameid: 1699755,
  },
  {
    name: "Meycauayan",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1699802,
  },
  {
    name: "Mexico",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1699805,
  },
  {
    name: "Mercedes",
    country: "Philippines",
    subcountry: "Bicol",
    geonameid: 1699833,
  },
  {
    name: "Mendez-Nuñez",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1699858,
  },
  {
    name: "Mauban",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1700179,
  },
  {
    name: "Mati",
    country: "Philippines",
    subcountry: "Davao",
    geonameid: 1700360,
  },
  {
    name: "Masinloc",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1700665,
  },
  {
    name: "Masbate",
    country: "Philippines",
    subcountry: "Bicol",
    geonameid: 1700712,
  },
  {
    name: "Masantol",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1700753,
  },
  {
    name: "Mariveles",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1700868,
  },
  {
    name: "Marilao",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1700917,
  },
  {
    name: "Mariano",
    country: "Philippines",
    subcountry: "Northern Mindanao",
    geonameid: 1700980,
  },
  {
    name: "Marawi City",
    country: "Philippines",
    subcountry: "Autonomous Region in Muslim Mindanao",
    geonameid: 1701053,
  },
  {
    name: "Maramag",
    country: "Philippines",
    subcountry: "Northern Mindanao",
    geonameid: 1701124,
  },
  {
    name: "Maragondon",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1701149,
  },
  {
    name: "Mantampay",
    country: "Philippines",
    subcountry: "Northern Mindanao",
    geonameid: 1701472,
  },
  {
    name: "Mansilingan",
    country: "Philippines",
    subcountry: "Western Visayas",
    geonameid: 1701500,
  },
  {
    name: "Mansalay",
    country: "Philippines",
    subcountry: "Mimaropa",
    geonameid: 1701516,
  },
  {
    name: "Manolo Fortich",
    country: "Philippines",
    subcountry: "Northern Mindanao",
    geonameid: 1701537,
  },
  {
    name: "Manila",
    country: "Philippines",
    subcountry: "Metro Manila",
    geonameid: 1701668,
  },
  {
    name: "Manibaug Pasig",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1701692,
  },
  {
    name: "Mangaldan",
    country: "Philippines",
    subcountry: "Ilocos",
    geonameid: 1701872,
  },
  {
    name: "Mandaue City",
    country: "Philippines",
    subcountry: "Central Visayas",
    geonameid: 1701947,
  },
  {
    name: "Mandaluyong City",
    country: "Philippines",
    subcountry: "Metro Manila",
    geonameid: 1701966,
  },
  {
    name: "Mankayan",
    country: "Philippines",
    subcountry: "Cordillera",
    geonameid: 1702002,
  },
  {
    name: "Manay",
    country: "Philippines",
    subcountry: "Davao",
    geonameid: 1702032,
  },
  {
    name: "Manapla",
    country: "Philippines",
    subcountry: "Western Visayas",
    geonameid: 1702077,
  },
  {
    name: "Manaoag",
    country: "Philippines",
    subcountry: "Ilocos",
    geonameid: 1702096,
  },
  {
    name: "Mamburao",
    country: "Philippines",
    subcountry: "Mimaropa",
    geonameid: 1702263,
  },
  {
    name: "Mamatid",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1702372,
  },
  {
    name: "Malvar",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1702413,
  },
  {
    name: "Maluso",
    country: "Philippines",
    subcountry: "Autonomous Region in Muslim Mindanao",
    geonameid: 1702425,
  },
  {
    name: "Maluñgun",
    country: "Philippines",
    subcountry: "Soccsksargen",
    geonameid: 1702442,
  },
  {
    name: "Malolos",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1702540,
  },
  {
    name: "Malita",
    country: "Philippines",
    subcountry: "Davao",
    geonameid: 1702649,
  },
  {
    name: "Malilipot",
    country: "Philippines",
    subcountry: "Bicol",
    geonameid: 1702763,
  },
  {
    name: "Malaybalay",
    country: "Philippines",
    subcountry: "Northern Mindanao",
    geonameid: 1702934,
  },
  {
    name: "Malapatan",
    country: "Philippines",
    subcountry: "Soccsksargen",
    geonameid: 1703051,
  },
  {
    name: "Malanday",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1703115,
  },
  {
    name: "Malanday",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1703116,
  },
  {
    name: "Malabanban Norte",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1703355,
  },
  {
    name: "Makati City",
    country: "Philippines",
    subcountry: "Metro Manila",
    geonameid: 1703417,
  },
  {
    name: "Mahayag",
    country: "Philippines",
    subcountry: "Zamboanga Peninsula",
    geonameid: 1703598,
  },
  {
    name: "Magsaysay",
    country: "Philippines",
    subcountry: "Davao",
    geonameid: 1703773,
  },
  {
    name: "Magarao",
    country: "Philippines",
    subcountry: "Bicol",
    geonameid: 1704002,
  },
  {
    name: "Maganoy",
    country: "Philippines",
    subcountry: "Autonomous Region in Muslim Mindanao",
    geonameid: 1704021,
  },
  {
    name: "Magalang",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1704067,
  },
  {
    name: "Mabalacat City",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1704703,
  },
  {
    name: "Maasin",
    country: "Philippines",
    subcountry: "Eastern Visayas",
    geonameid: 1704758,
  },
  {
    name: "Maao",
    country: "Philippines",
    subcountry: "Western Visayas",
    geonameid: 1704781,
  },
  {
    name: "Lupon",
    country: "Philippines",
    subcountry: "Davao",
    geonameid: 1704968,
  },
  {
    name: "Lumbang",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1705190,
  },
  {
    name: "Lucena",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1705357,
  },
  {
    name: "Lucban",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1705367,
  },
  {
    name: "Lubao",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1705440,
  },
  {
    name: "Los Baños",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1705536,
  },
  {
    name: "Lopez",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1705572,
  },
  {
    name: "Loma de Gato",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1705771,
  },
  {
    name: "Loboc",
    country: "Philippines",
    subcountry: "Central Visayas",
    geonameid: 1705871,
  },
  {
    name: "Lipa City",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1706090,
  },
  {
    name: "Lingayen",
    country: "Philippines",
    subcountry: "Ilocos",
    geonameid: 1706188,
  },
  {
    name: "Limay",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1706361,
  },
  {
    name: "Liloan",
    country: "Philippines",
    subcountry: "Central Visayas",
    geonameid: 1706393,
  },
  {
    name: "Lilio",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1706402,
  },
  {
    name: "Libon",
    country: "Philippines",
    subcountry: "Bicol",
    geonameid: 1706609,
  },
  {
    name: "Libertad",
    country: "Philippines",
    subcountry: "Caraga",
    geonameid: 1706684,
  },
  {
    name: "Legaspi",
    country: "Philippines",
    subcountry: "Bicol",
    geonameid: 1706889,
  },
  {
    name: "Laur",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1707049,
  },
  {
    name: "La Trinidad",
    country: "Philippines",
    subcountry: "Cordillera",
    geonameid: 1707123,
  },
  {
    name: "Las Piñas",
    country: "Philippines",
    subcountry: "Metro Manila",
    geonameid: 1707174,
  },
  {
    name: "Lapu-Lapu City",
    country: "Philippines",
    subcountry: "Central Visayas",
    geonameid: 1707267,
  },
  {
    name: "La Paz",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1707324,
  },
  {
    name: "Laoang",
    country: "Philippines",
    subcountry: "Eastern Visayas",
    geonameid: 1707398,
  },
  {
    name: "Laoag",
    country: "Philippines",
    subcountry: "Ilocos",
    geonameid: 1707404,
  },
  {
    name: "Laguilayan",
    country: "Philippines",
    subcountry: "Soccsksargen",
    geonameid: 1708056,
  },
  {
    name: "La Castellana",
    country: "Philippines",
    subcountry: "Western Visayas",
    geonameid: 1708217,
  },
  {
    name: "La Carlota",
    country: "Philippines",
    subcountry: "Western Visayas",
    geonameid: 1708226,
  },
  {
    name: "Labo",
    country: "Philippines",
    subcountry: "Bicol",
    geonameid: 1708291,
  },
  {
    name: "Koronadal",
    country: "Philippines",
    subcountry: "Soccsksargen",
    geonameid: 1708522,
  },
  {
    name: "Kidapawan",
    country: "Philippines",
    subcountry: "Soccsksargen",
    geonameid: 1708824,
  },
  {
    name: "Kawit",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1709003,
  },
  {
    name: "Kalibo (poblacion)",
    country: "Philippines",
    subcountry: "Western Visayas",
    geonameid: 1709632,
  },
  {
    name: "Kabankalan",
    country: "Philippines",
    subcountry: "Western Visayas",
    geonameid: 1709968,
  },
  {
    name: "Kabacan",
    country: "Philippines",
    subcountry: "Soccsksargen",
    geonameid: 1710011,
  },
  {
    name: "Jose Pañganiban",
    country: "Philippines",
    subcountry: "Bicol",
    geonameid: 1710103,
  },
  {
    name: "Jolo",
    country: "Philippines",
    subcountry: "Autonomous Region in Muslim Mindanao",
    geonameid: 1710141,
  },
  {
    name: "Jasaan",
    country: "Philippines",
    subcountry: "Northern Mindanao",
    geonameid: 1710258,
  },
  {
    name: "Jalajala",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1710357,
  },
  {
    name: "Jagna",
    country: "Philippines",
    subcountry: "Central Visayas",
    geonameid: 1710378,
  },
  {
    name: "Jaen",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1710389,
  },
  {
    name: "Itogon",
    country: "Philippines",
    subcountry: "Cordillera",
    geonameid: 1710441,
  },
  {
    name: "Isulan",
    country: "Philippines",
    subcountry: "Soccsksargen",
    geonameid: 1710470,
  },
  {
    name: "Isabela",
    country: "Philippines",
    subcountry: "Western Visayas",
    geonameid: 1710518,
  },
  {
    name: "City of Isabela",
    country: "Philippines",
    subcountry: "Autonomous Region in Muslim Mindanao",
    geonameid: 1710519,
  },
  {
    name: "Irosin",
    country: "Philippines",
    subcountry: "Bicol",
    geonameid: 1710531,
  },
  {
    name: "Iriga City",
    country: "Philippines",
    subcountry: "Bicol",
    geonameid: 1710544,
  },
  {
    name: "Ipil",
    country: "Philippines",
    subcountry: "Zamboanga Peninsula",
    geonameid: 1710612,
  },
  {
    name: "Indang",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1710770,
  },
  {
    name: "Imus",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1710914,
  },
  {
    name: "Iloilo",
    country: "Philippines",
    subcountry: "Western Visayas",
    geonameid: 1711005,
  },
  {
    name: "Iligan City",
    country: "Philippines",
    subcountry: "Soccsksargen",
    geonameid: 1711082,
  },
  {
    name: "Iligan",
    country: "Philippines",
    subcountry: "Northern Mindanao",
    geonameid: 1711084,
  },
  {
    name: "Ilagan",
    country: "Philippines",
    subcountry: "Cagayan Valley",
    geonameid: 1711146,
  },
  {
    name: "Iba",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1711437,
  },
  {
    name: "Hinigaran",
    country: "Philippines",
    subcountry: "Western Visayas",
    geonameid: 1711621,
  },
  {
    name: "Himamaylan",
    country: "Philippines",
    subcountry: "Western Visayas",
    geonameid: 1711718,
  },
  {
    name: "Hermosa",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1711829,
  },
  {
    name: "Hagonoy",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1711982,
  },
  {
    name: "Guyong",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1712051,
  },
  {
    name: "Gumaca",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1712162,
  },
  {
    name: "Guiset East",
    country: "Philippines",
    subcountry: "Ilocos",
    geonameid: 1712232,
  },
  {
    name: "Guimba",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1712488,
  },
  {
    name: "Guihulñgan",
    country: "Philippines",
    subcountry: "Central Visayas",
    geonameid: 1712520,
  },
  {
    name: "Guiguinto",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1712531,
  },
  {
    name: "Goa",
    country: "Philippines",
    subcountry: "Bicol",
    geonameid: 1712808,
  },
  {
    name: "Glan",
    country: "Philippines",
    subcountry: "Soccsksargen",
    geonameid: 1712819,
  },
  {
    name: "Gerona",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1713004,
  },
  {
    name: "General Trias",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1713014,
  },
  {
    name: "General Tinio",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1713018,
  },
  {
    name: "General Santos",
    country: "Philippines",
    subcountry: "Soccsksargen",
    geonameid: 1713022,
  },
  {
    name: "General Mamerto Natividad",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1713027,
  },
  {
    name: "Gapan",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1713226,
  },
  {
    name: "Escalante",
    country: "Philippines",
    subcountry: "Western Visayas",
    geonameid: 1713818,
  },
  {
    name: "Saravia",
    country: "Philippines",
    subcountry: "Western Visayas",
    geonameid: 1713857,
  },
  {
    name: "Dumaguete",
    country: "Philippines",
    subcountry: "Central Visayas",
    geonameid: 1714201,
  },
  {
    name: "Don Carlos",
    country: "Philippines",
    subcountry: "Northern Mindanao",
    geonameid: 1714441,
  },
  {
    name: "Domalanoan",
    country: "Philippines",
    subcountry: "Ilocos",
    geonameid: 1714482,
  },
  {
    name: "Dologon",
    country: "Philippines",
    subcountry: "Northern Mindanao",
    geonameid: 1714519,
  },
  {
    name: "Dipolog",
    country: "Philippines",
    subcountry: "Zamboanga Peninsula",
    geonameid: 1714674,
  },
  {
    name: "Dinalupihan",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1714766,
  },
  {
    name: "Digos",
    country: "Philippines",
    subcountry: "Davao",
    geonameid: 1714956,
  },
  {
    name: "Diadi",
    country: "Philippines",
    subcountry: "Cagayan Valley",
    geonameid: 1715094,
  },
  {
    name: "Del Pilar",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1715169,
  },
  {
    name: "Davao",
    country: "Philippines",
    subcountry: "Davao",
    geonameid: 1715348,
  },
  {
    name: "Dasmariñas",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1715430,
  },
  {
    name: "Dapitan",
    country: "Philippines",
    subcountry: "Zamboanga Peninsula",
    geonameid: 1715542,
  },
  {
    name: "Danao",
    country: "Philippines",
    subcountry: "Central Visayas",
    geonameid: 1715804,
  },
  {
    name: "Danao",
    country: "Philippines",
    subcountry: "Central Visayas",
    geonameid: 1715812,
  },
  {
    name: "Dagupan",
    country: "Philippines",
    subcountry: "Ilocos",
    geonameid: 1716198,
  },
  {
    name: "Daet",
    country: "Philippines",
    subcountry: "Bicol",
    geonameid: 1716287,
  },
  {
    name: "Cuenca",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1716618,
  },
  {
    name: "Cotabato",
    country: "Philippines",
    subcountry: "Autonomous Region in Muslim Mindanao",
    geonameid: 1716771,
  },
  {
    name: "Cordova",
    country: "Philippines",
    subcountry: "Central Visayas",
    geonameid: 1716858,
  },
  {
    name: "Consolacion",
    country: "Philippines",
    subcountry: "Central Visayas",
    geonameid: 1716924,
  },
  {
    name: "Concepcion",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1716995,
  },
  {
    name: "Concepcion Ibaba",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1717008,
  },
  {
    name: "Compostela",
    country: "Philippines",
    subcountry: "Central Visayas",
    geonameid: 1717051,
  },
  {
    name: "Compostela",
    country: "Philippines",
    subcountry: "Davao",
    geonameid: 1717053,
  },
  {
    name: "Cebu City",
    country: "Philippines",
    subcountry: "Central Visayas",
    geonameid: 1717512,
  },
  {
    name: "Cavite City",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1717641,
  },
  {
    name: "Catbalogan",
    country: "Philippines",
    subcountry: "Eastern Visayas",
    geonameid: 1717911,
  },
  {
    name: "Catarman",
    country: "Philippines",
    subcountry: "Eastern Visayas",
    geonameid: 1717926,
  },
  {
    name: "Catanauan",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1717960,
  },
  {
    name: "Castillejos",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1718078,
  },
  {
    name: "Carmona",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1718306,
  },
  {
    name: "Cogan",
    country: "Philippines",
    subcountry: "Central Visayas",
    geonameid: 1718328,
  },
  {
    name: "Carigara",
    country: "Philippines",
    subcountry: "Eastern Visayas",
    geonameid: 1718393,
  },
  {
    name: "Cardona",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1718426,
  },
  {
    name: "Carcar",
    country: "Philippines",
    subcountry: "Central Visayas",
    geonameid: 1718436,
  },
  {
    name: "Capas",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1718722,
  },
  {
    name: "Canlaon",
    country: "Philippines",
    subcountry: "Central Visayas",
    geonameid: 1719053,
  },
  {
    name: "Candelaria",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1719274,
  },
  {
    name: "Candaba",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1719329,
  },
  {
    name: "Camiling",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1719683,
  },
  {
    name: "Calumpit",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1720034,
  },
  {
    name: "Calumpang",
    country: "Philippines",
    subcountry: "Metro Manila",
    geonameid: 1720052,
  },
  {
    name: "Caloocan City",
    country: "Philippines",
    subcountry: "Metro Manila",
    geonameid: 1720151,
  },
  {
    name: "Calbayog City",
    country: "Philippines",
    subcountry: "Eastern Visayas",
    geonameid: 1720402,
  },
  {
    name: "Calauan",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1720464,
  },
  {
    name: "Calauag",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1720472,
  },
  {
    name: "Calatagan",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1720499,
  },
  {
    name: "Calasiao",
    country: "Philippines",
    subcountry: "Ilocos",
    geonameid: 1720508,
  },
  {
    name: "Calapan",
    country: "Philippines",
    subcountry: "Mimaropa",
    geonameid: 1720561,
  },
  {
    name: "Calamba",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1720681,
  },
  {
    name: "Calaca",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1720751,
  },
  {
    name: "Calabanga",
    country: "Philippines",
    subcountry: "Bicol",
    geonameid: 1720793,
  },
  {
    name: "Cainta",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1720840,
  },
  {
    name: "Cagayan de Oro",
    country: "Philippines",
    subcountry: "Northern Mindanao",
    geonameid: 1721080,
  },
  {
    name: "Cadiz",
    country: "Philippines",
    subcountry: "Western Visayas",
    geonameid: 1721168,
  },
  {
    name: "Cabuyao",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1721281,
  },
  {
    name: "Cabiao",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1721636,
  },
  {
    name: "Cabayangan",
    country: "Philippines",
    subcountry: "Davao",
    geonameid: 1721695,
  },
  {
    name: "Cabanatuan City",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1721906,
  },
  {
    name: "Cabagan",
    country: "Philippines",
    subcountry: "Cagayan Valley",
    geonameid: 1722005,
  },
  {
    name: "Cabadbaran",
    country: "Philippines",
    subcountry: "Caraga",
    geonameid: 1722032,
  },
  {
    name: "Butuan",
    country: "Philippines",
    subcountry: "Caraga",
    geonameid: 1722186,
  },
  {
    name: "Bustos",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1722267,
  },
  {
    name: "Boroon",
    country: "Philippines",
    subcountry: "Northern Mindanao",
    geonameid: 1722356,
  },
  {
    name: "Burgos",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1722433,
  },
  {
    name: "Bunawan",
    country: "Philippines",
    subcountry: "Caraga",
    geonameid: 1722731,
  },
  {
    name: "Buluan",
    country: "Philippines",
    subcountry: "Autonomous Region in Muslim Mindanao",
    geonameid: 1722818,
  },
  {
    name: "Bulaon",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1722930,
  },
  {
    name: "Bulan",
    country: "Philippines",
    subcountry: "Bicol",
    geonameid: 1722985,
  },
  {
    name: "Bulacan",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1723066,
  },
  {
    name: "Buhi",
    country: "Philippines",
    subcountry: "Bicol",
    geonameid: 1723166,
  },
  {
    name: "Bugo",
    country: "Philippines",
    subcountry: "Northern Mindanao",
    geonameid: 1723257,
  },
  {
    name: "Buenavista",
    country: "Philippines",
    subcountry: "Caraga",
    geonameid: 1723481,
  },
  {
    name: "Budta",
    country: "Philippines",
    subcountry: "Autonomous Region in Muslim Mindanao",
    geonameid: 1723510,
  },
  {
    name: "Botolan",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1723822,
  },
  {
    name: "Borongan",
    country: "Philippines",
    subcountry: "Eastern Visayas",
    geonameid: 1723893,
  },
  {
    name: "Bongao",
    country: "Philippines",
    subcountry: "Autonomous Region in Muslim Mindanao",
    geonameid: 1724088,
  },
  {
    name: "Bongabon",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1724106,
  },
  {
    name: "Bogo",
    country: "Philippines",
    subcountry: "Central Visayas",
    geonameid: 1724435,
  },
  {
    name: "Bocaue",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1724489,
  },
  {
    name: "Bislig",
    country: "Philippines",
    subcountry: "Caraga",
    geonameid: 1724767,
  },
  {
    name: "Binonga",
    country: "Philippines",
    subcountry: "Western Visayas",
    geonameid: 1724933,
  },
  {
    name: "Binondo",
    country: "Philippines",
    subcountry: "Metro Manila",
    geonameid: 1724936,
  },
  {
    name: "Binmaley",
    country: "Philippines",
    subcountry: "Ilocos",
    geonameid: 1724956,
  },
  {
    name: "Binangonan",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1725094,
  },
  {
    name: "Biñan",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1725115,
  },
  {
    name: "Binalbagan",
    country: "Philippines",
    subcountry: "Western Visayas",
    geonameid: 1725157,
  },
  {
    name: "Bignay Uno",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1725359,
  },
  {
    name: "Upper Bicutan",
    country: "Philippines",
    subcountry: "Metro Manila",
    geonameid: 1725426,
  },
  {
    name: "Bel Air",
    country: "Philippines",
    subcountry: "Metro Manila",
    geonameid: 1725627,
  },
  {
    name: "Bayugan",
    country: "Philippines",
    subcountry: "Caraga",
    geonameid: 1725684,
  },
  {
    name: "Bayombong",
    country: "Philippines",
    subcountry: "Cagayan Valley",
    geonameid: 1725729,
  },
  {
    name: "Baybay",
    country: "Philippines",
    subcountry: "Eastern Visayas",
    geonameid: 1725799,
  },
  {
    name: "Bayawan",
    country: "Philippines",
    subcountry: "Central Visayas",
    geonameid: 1725804,
  },
  {
    name: "Bayambang",
    country: "Philippines",
    subcountry: "Ilocos",
    geonameid: 1725863,
  },
  {
    name: "Bay",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1725919,
  },
  {
    name: "Bauang",
    country: "Philippines",
    subcountry: "Ilocos",
    geonameid: 1725983,
  },
  {
    name: "Bauan",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1725991,
  },
  {
    name: "Bato",
    country: "Philippines",
    subcountry: "Bicol",
    geonameid: 1726156,
  },
  {
    name: "Batangas",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1726280,
  },
  {
    name: "Batac City",
    country: "Philippines",
    subcountry: "Ilocos",
    geonameid: 1726339,
  },
  {
    name: "Baras",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1726765,
  },
  {
    name: "Bantayan",
    country: "Philippines",
    subcountry: "Central Visayas",
    geonameid: 1727043,
  },
  {
    name: "Bansalan",
    country: "Philippines",
    subcountry: "Davao",
    geonameid: 1727080,
  },
  {
    name: "Bañga",
    country: "Philippines",
    subcountry: "Soccsksargen",
    geonameid: 1727400,
  },
  {
    name: "Bambang",
    country: "Philippines",
    subcountry: "Cagayan Valley",
    geonameid: 1727663,
  },
  {
    name: "Baliuag",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1727995,
  },
  {
    name: "Balayan",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1728336,
  },
  {
    name: "Balanga",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1728523,
  },
  {
    name: "Balamban",
    country: "Philippines",
    subcountry: "Central Visayas",
    geonameid: 1728546,
  },
  {
    name: "Balagtas",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1728584,
  },
  {
    name: "Bais",
    country: "Philippines",
    subcountry: "Central Visayas",
    geonameid: 1728772,
  },
  {
    name: "Bah-Bah",
    country: "Philippines",
    subcountry: "Caraga",
    geonameid: 1728825,
  },
  {
    name: "Baguio",
    country: "Philippines",
    subcountry: "Cordillera",
    geonameid: 1728930,
  },
  {
    name: "Bago City",
    country: "Philippines",
    subcountry: "Western Visayas",
    geonameid: 1729085,
  },
  {
    name: "Baggabag B",
    country: "Philippines",
    subcountry: "Cagayan Valley",
    geonameid: 1729324,
  },
  {
    name: "Bacoor",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1729524,
  },
  {
    name: "Bacolod City",
    country: "Philippines",
    subcountry: "Western Visayas",
    geonameid: 1729564,
  },
  {
    name: "Baclaran",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1729613,
  },
  {
    name: "Babo-Pangulo",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1729734,
  },
  {
    name: "Baao",
    country: "Philippines",
    subcountry: "Bicol",
    geonameid: 1729814,
  },
  {
    name: "Atimonan",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1729987,
  },
  {
    name: "Asia",
    country: "Philippines",
    subcountry: "Western Visayas",
    geonameid: 1730097,
  },
  {
    name: "Aringay",
    country: "Philippines",
    subcountry: "Ilocos",
    geonameid: 1730171,
  },
  {
    name: "Arayat",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1730225,
  },
  {
    name: "Aparri",
    country: "Philippines",
    subcountry: "Cagayan Valley",
    geonameid: 1730398,
  },
  {
    name: "Apalit",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1730413,
  },
  {
    name: "Antipolo",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1730501,
  },
  {
    name: "Angono",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1730713,
  },
  {
    name: "Angeles City",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1730737,
  },
  {
    name: "Angat",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1730749,
  },
  {
    name: "Amadeo",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1731212,
  },
  {
    name: "Alicia",
    country: "Philippines",
    subcountry: "Cagayan Valley",
    geonameid: 1731486,
  },
  {
    name: "Aliaga",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1731528,
  },
  {
    name: "Alaminos",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1731686,
  },
  {
    name: "Alabel",
    country: "Philippines",
    subcountry: "Soccsksargen",
    geonameid: 1731744,
  },
  {
    name: "Agoo",
    country: "Philippines",
    subcountry: "Ilocos",
    geonameid: 1731959,
  },
  {
    name: "Abuyog",
    country: "Philippines",
    subcountry: "Eastern Visayas",
    geonameid: 1732312,
  },
  {
    name: "Abucay",
    country: "Philippines",
    subcountry: "Central Luzon",
    geonameid: 1732354,
  },
  {
    name: "Bagong Pagasa",
    country: "Philippines",
    subcountry: "Calabarzon",
    geonameid: 1966336,
  },
  {
    name: "Malingao",
    country: "Philippines",
    subcountry: "Soccsksargen",
    geonameid: 1978681,
  },
  {
    name: "Bagong Silangan",
    country: "Philippines",
    subcountry: "Metro Manila",
    geonameid: 7090987,
  },
  {
    name: "Pasig City",
    country: "Philippines",
    subcountry: "Metro Manila",
    geonameid: 7290466,
  },
  {
    name: "Pandan",
    country: "Philippines",
    subcountry: "Western Visayas",
    geonameid: 8299649,
  },
  {
    name: "Ayala Alabang",
    country: "Philippines",
    subcountry: "Metro Manila",
    geonameid: 8335226,
  },
  {
    name: "Banco Filipino Homes",
    country: "Philippines",
    subcountry: "Metro Manila",
    geonameid: 8534157,
  },
  {
    name: "Apas",
    country: "Philippines",
    subcountry: "Central Visayas",
    geonameid: 10628881,
  },
  {
    name: "Chuhar Jamali",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1108161,
  },
  {
    name: "Rawalakot",
    country: "Pakistan",
    subcountry: "Azad Kashmir",
    geonameid: 1161983,
  },
  {
    name: "Pir Jo Goth",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1161991,
  },
  {
    name: "Khairpur Mir’s",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1162004,
  },
  {
    name: "Zhob",
    country: "Pakistan",
    subcountry: "Balochistan",
    geonameid: 1162105,
  },
  {
    name: "Zaida",
    country: "Pakistan",
    subcountry: "Khyber Pakhtunkhwa",
    geonameid: 1162261,
  },
  {
    name: "Zahir Pir",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1162275,
  },
  {
    name: "Zafarwal",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1162285,
  },
  {
    name: "Yazman",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1162316,
  },
  {
    name: "Wazirabad",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1162456,
  },
  {
    name: "Chak Five Hundred Seventy-five",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1162572,
  },
  {
    name: "Warah",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1162589,
  },
  {
    name: "Vihari",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1162813,
  },
  {
    name: "Utmanzai",
    country: "Pakistan",
    subcountry: "Khyber Pakhtunkhwa",
    geonameid: 1162855,
  },
  {
    name: "Uthal",
    country: "Pakistan",
    subcountry: "Balochistan",
    geonameid: 1162862,
  },
  {
    name: "Usta Muhammad",
    country: "Pakistan",
    subcountry: "Balochistan",
    geonameid: 1162868,
  },
  {
    name: "Umarkot",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1162959,
  },
  {
    name: "Ubauro",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1163021,
  },
  {
    name: "Turbat",
    country: "Pakistan",
    subcountry: "Balochistan",
    geonameid: 1163054,
  },
  {
    name: "Tordher",
    country: "Pakistan",
    subcountry: "Khyber Pakhtunkhwa",
    geonameid: 1163198,
  },
  {
    name: "Topi",
    country: "Pakistan",
    subcountry: "Khyber Pakhtunkhwa",
    geonameid: 1163224,
  },
  {
    name: "Toba Tek Singh",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1163272,
  },
  {
    name: "Thul",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1163414,
  },
  {
    name: "Thatta",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1163582,
  },
  {
    name: "Tharu Shah",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1163595,
  },
  {
    name: "Taunsa",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1163724,
  },
  {
    name: "Tank",
    country: "Pakistan",
    subcountry: "Khyber Pakhtunkhwa",
    geonameid: 1163905,
  },
  {
    name: "Tangi",
    country: "Pakistan",
    subcountry: "Khyber Pakhtunkhwa",
    geonameid: 1163927,
  },
  {
    name: "Tando Muhammad Khan",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1163952,
  },
  {
    name: "Tando Jam",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1163958,
  },
  {
    name: "Tando Allahyar",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1163965,
  },
  {
    name: "Tando Adam",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1163967,
  },
  {
    name: "Tandlianwala",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1163968,
  },
  {
    name: "Talhar",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1164045,
  },
  {
    name: "Talamba",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1164064,
  },
  {
    name: "Talagang",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1164069,
  },
  {
    name: "Thal",
    country: "Pakistan",
    subcountry: "Khyber Pakhtunkhwa",
    geonameid: 1164076,
  },
  {
    name: "Swabi",
    country: "Pakistan",
    subcountry: "Khyber Pakhtunkhwa",
    geonameid: 1164216,
  },
  {
    name: "Surkhpur",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1164245,
  },
  {
    name: "Sukkur",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1164408,
  },
  {
    name: "Sukheke Mandi",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1164419,
  },
  {
    name: "Sodhri",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1164679,
  },
  {
    name: "Sita Road",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1164716,
  },
  {
    name: "Sinjhoro",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1164776,
  },
  {
    name: "Sillanwali",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1164825,
  },
  {
    name: "Sibi",
    country: "Pakistan",
    subcountry: "Balochistan",
    geonameid: 1164896,
  },
  {
    name: "Sialkot",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1164909,
  },
  {
    name: "Shujaabad",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1164970,
  },
  {
    name: "Shorkot",
    country: "Pakistan",
    subcountry: "Khyber Pakhtunkhwa",
    geonameid: 1164987,
  },
  {
    name: "Shikarpur",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1165108,
  },
  {
    name: "Shekhupura",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1165221,
  },
  {
    name: "Sharqpur Sharif",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1165260,
  },
  {
    name: "Shakargarh",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1165388,
  },
  {
    name: "Shahr Sultan",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1165486,
  },
  {
    name: "Shahpur Chakar",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1165507,
  },
  {
    name: "Shahkot",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1165569,
  },
  {
    name: "Shahdadpur",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1165635,
  },
  {
    name: "Shahdad Kot",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1165638,
  },
  {
    name: "Shabqadar",
    country: "Pakistan",
    subcountry: "Khyber Pakhtunkhwa",
    geonameid: 1165744,
  },
  {
    name: "Sehwan",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1165789,
  },
  {
    name: "Sargodha",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1166000,
  },
  {
    name: "Sarai Sidhu",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1166062,
  },
  {
    name: "Sarai Naurang",
    country: "Pakistan",
    subcountry: "Khyber Pakhtunkhwa",
    geonameid: 1166066,
  },
  {
    name: "Sarai Alamgir",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1166073,
  },
  {
    name: "Sangla Hill",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1166146,
  },
  {
    name: "Sanghar",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1166164,
  },
  {
    name: "Sambrial",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1166265,
  },
  {
    name: "Sakrand",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1166381,
  },
  {
    name: "Sahiwal",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1166547,
  },
  {
    name: "Sahiwal",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1166548,
  },
  {
    name: "Saddiqabad",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1166652,
  },
  {
    name: "Rohri",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1166827,
  },
  {
    name: "Renala Khurd",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1166933,
  },
  {
    name: "Rawalpindi",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1166993,
  },
  {
    name: "Ratodero",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1167031,
  },
  {
    name: "Ranipur",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1167142,
  },
  {
    name: "Rajanpur",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1167380,
  },
  {
    name: "Raja Jang",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1167386,
  },
  {
    name: "Raiwind",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1167398,
  },
  {
    name: "Rahim Yar Khan",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1167460,
  },
  {
    name: "Goth Radhan",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1167501,
  },
  {
    name: "Chenab Nagar",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1167507,
  },
  {
    name: "Quetta",
    country: "Pakistan",
    subcountry: "Balochistan",
    geonameid: 1167528,
  },
  {
    name: "Kambar",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1167622,
  },
  {
    name: "Qadirpur Ran",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1167648,
  },
  {
    name: "Pishin",
    country: "Pakistan",
    subcountry: "Balochistan",
    geonameid: 1167821,
  },
  {
    name: "Pir Mahal",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1167873,
  },
  {
    name: "Pindi Gheb",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1168015,
  },
  {
    name: "Pindi Bhattian",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1168021,
  },
  {
    name: "Pind Dadan Khan",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1168036,
  },
  {
    name: "Phalia",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1168166,
  },
  {
    name: "Peshawar",
    country: "Pakistan",
    subcountry: "Khyber Pakhtunkhwa",
    geonameid: 1168197,
  },
  {
    name: "Pattoki",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1168226,
  },
  {
    name: "Pasrur",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1168307,
  },
  {
    name: "Pasni",
    country: "Pakistan",
    subcountry: "Balochistan",
    geonameid: 1168312,
  },
  {
    name: "Pano Aqil",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1168412,
  },
  {
    name: "Pakpattan",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1168555,
  },
  {
    name: "Paharpur",
    country: "Pakistan",
    subcountry: "Khyber Pakhtunkhwa",
    geonameid: 1168633,
  },
  {
    name: "Pad Idan",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1168652,
  },
  {
    name: "Pabbi",
    country: "Pakistan",
    subcountry: "Khyber Pakhtunkhwa",
    geonameid: 1168680,
  },
  {
    name: "Okara",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1168718,
  },
  {
    name: "Nushki",
    country: "Pakistan",
    subcountry: "Balochistan",
    geonameid: 1168749,
  },
  {
    name: "New Mirpur",
    country: "Pakistan",
    subcountry: "Azad Kashmir",
    geonameid: 1169027,
  },
  {
    name: "Nawabshah",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1169116,
  },
  {
    name: "Naushahro Firoz",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1169143,
  },
  {
    name: "Naushahra Virkan",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1169145,
  },
  {
    name: "Naudero",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1169187,
  },
  {
    name: "Nasirabad",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1169254,
  },
  {
    name: "Narowal",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1169278,
  },
  {
    name: "Narang Mandi",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1169334,
  },
  {
    name: "Naukot",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1169367,
  },
  {
    name: "Nankana Sahib",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1169372,
  },
  {
    name: "Muzaffargarh",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1169605,
  },
  {
    name: "Muzaffarābād",
    country: "Pakistan",
    subcountry: "Azad Kashmir",
    geonameid: 1169607,
  },
  {
    name: "Mustafabad",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1169620,
  },
  {
    name: "Murree",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1169684,
  },
  {
    name: "Muridke",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1169692,
  },
  {
    name: "Multan",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1169825,
  },
  {
    name: "Moro",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1170013,
  },
  {
    name: "Mithi",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1170219,
  },
  {
    name: "Mitha Tiwana",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1170222,
  },
  {
    name: "Mirpur Mathelo",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1170294,
  },
  {
    name: "Mirpur Khas",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1170295,
  },
  {
    name: "Mingora",
    country: "Pakistan",
    subcountry: "Khyber Pakhtunkhwa",
    geonameid: 1170395,
  },
  {
    name: "Minchianabad",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1170398,
  },
  {
    name: "Mianwali",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1170425,
  },
  {
    name: "Mian Channun",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1170486,
  },
  {
    name: "Mehrabpur",
    country: "Pakistan",
    subcountry: "Balochistan",
    geonameid: 1170564,
  },
  {
    name: "Mehar",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1170584,
  },
  {
    name: "Matli",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1170667,
  },
  {
    name: "Matiari",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1170677,
  },
  {
    name: "Mastung",
    country: "Pakistan",
    subcountry: "Balochistan",
    geonameid: 1170706,
  },
  {
    name: "Mardan",
    country: "Pakistan",
    subcountry: "Khyber Pakhtunkhwa",
    geonameid: 1170880,
  },
  {
    name: "Mansehra",
    country: "Pakistan",
    subcountry: "Khyber Pakhtunkhwa",
    geonameid: 1170951,
  },
  {
    name: "Mangla",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1171050,
  },
  {
    name: "Mandi Bahauddin",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1171123,
  },
  {
    name: "Mananwala",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1171165,
  },
  {
    name: "Mamu Kanjan",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1171198,
  },
  {
    name: "Malir Cantonment",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1171305,
  },
  {
    name: "Malakwal",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1171376,
  },
  {
    name: "Mailsi",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1171502,
  },
  {
    name: "Mach",
    country: "Pakistan",
    subcountry: "Balochistan",
    geonameid: 1171757,
  },
  {
    name: "Loralai",
    country: "Pakistan",
    subcountry: "Balochistan",
    geonameid: 1171868,
  },
  {
    name: "Lodhran",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1171965,
  },
  {
    name: "Layyah",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1172035,
  },
  {
    name: "Larkana",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1172128,
  },
  {
    name: "Lalian",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1172295,
  },
  {
    name: "Lala Musa",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1172318,
  },
  {
    name: "Lakki",
    country: "Pakistan",
    subcountry: "Khyber Pakhtunkhwa",
    geonameid: 1172339,
  },
  {
    name: "Lahore",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1172451,
  },
  {
    name: "Ladhewala Waraich",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1172488,
  },
  {
    name: "Lachi",
    country: "Pakistan",
    subcountry: "Khyber Pakhtunkhwa",
    geonameid: 1172513,
  },
  {
    name: "Kunri",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1172657,
  },
  {
    name: "Kunjah",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1172663,
  },
  {
    name: "Kundian",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1172682,
  },
  {
    name: "Kulachi",
    country: "Pakistan",
    subcountry: "Khyber Pakhtunkhwa",
    geonameid: 1172779,
  },
  {
    name: "Kot Samaba",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1172888,
  },
  {
    name: "Kotri",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1172904,
  },
  {
    name: "Kot Radha Kishan",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1172915,
  },
  {
    name: "Kot Mumin",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1172964,
  },
  {
    name: "Kot Malik Barkhurdar",
    country: "Pakistan",
    subcountry: "Balochistan",
    geonameid: 1172993,
  },
  {
    name: "Kotli Loharan",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1173025,
  },
  {
    name: "Kotli",
    country: "Pakistan",
    subcountry: "Azad Kashmir",
    geonameid: 1173055,
  },
  {
    name: "Kot Ghulam Muhammad",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1173272,
  },
  {
    name: "Kot Diji",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1173302,
  },
  {
    name: "Kot Addu",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1173378,
  },
  {
    name: "Kohat",
    country: "Pakistan",
    subcountry: "Khyber Pakhtunkhwa",
    geonameid: 1173491,
  },
  {
    name: "Khuzdar",
    country: "Pakistan",
    subcountry: "Balochistan",
    geonameid: 1173664,
  },
  {
    name: "Khushāb",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1173687,
  },
  {
    name: "Khurrianwala",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1173692,
  },
  {
    name: "Khewra",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1173920,
  },
  {
    name: "Kharian",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1174042,
  },
  {
    name: "Kharan",
    country: "Pakistan",
    subcountry: "Balochistan",
    geonameid: 1174062,
  },
  {
    name: "Khanpur",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1174167,
  },
  {
    name: "Khanpur Mahar",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1174171,
  },
  {
    name: "Khangarh",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1174211,
  },
  {
    name: "Khangah Dogran",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1174217,
  },
  {
    name: "Khalabat",
    country: "Pakistan",
    subcountry: "Khyber Pakhtunkhwa",
    geonameid: 1174301,
  },
  {
    name: "Khairpur Nathan Shah",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1174344,
  },
  {
    name: "Khairpur Tamewah",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1174355,
  },
  {
    name: "Khairpur",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1174357,
  },
  {
    name: "Kasur",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1174625,
  },
  {
    name: "Kashmor",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1174653,
  },
  {
    name: "Karor",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1174720,
  },
  {
    name: "Karachi",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1174872,
  },
  {
    name: "Kanganpur",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1174984,
  },
  {
    name: "Kandiaro",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1175010,
  },
  {
    name: "Kandhkot",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1175021,
  },
  {
    name: "Kamra",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1175082,
  },
  {
    name: "Kamoke",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1175088,
  },
  {
    name: "Chak One Hundred Twenty Nine Left",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1175098,
  },
  {
    name: "Kamar Mushani",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1175125,
  },
  {
    name: "Kamalia",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1175156,
  },
  {
    name: "Kalur Kot",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1175180,
  },
  {
    name: "Kallar Kahar",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1175232,
  },
  {
    name: "Kaleke Mandi",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1175283,
  },
  {
    name: "Kalat",
    country: "Pakistan",
    subcountry: "Balochistan",
    geonameid: 1175296,
  },
  {
    name: "Kalabagh",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1175365,
  },
  {
    name: "Kahuta",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1175436,
  },
  {
    name: "Kahror Pakka",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1175446,
  },
  {
    name: "Kahna Nau",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1175453,
  },
  {
    name: "Kabirwala",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1175560,
  },
  {
    name: "Johi",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1175678,
  },
  {
    name: "Jiwani",
    country: "Pakistan",
    subcountry: "Balochistan",
    geonameid: 1175712,
  },
  {
    name: "Chak Jhumra",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1175748,
  },
  {
    name: "Jhol",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1175762,
  },
  {
    name: "Jhelum",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1175864,
  },
  {
    name: "Jhawarian",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1175870,
  },
  {
    name: "Jhang Sadr",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1175892,
  },
  {
    name: "Jauharabad",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1176022,
  },
  {
    name: "Jatoi Shimali",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1176035,
  },
  {
    name: "Jaranwala",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1176106,
  },
  {
    name: "Jand",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1176218,
  },
  {
    name: "Jampur",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1176241,
  },
  {
    name: "Jalalpur Pirwala",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1176358,
  },
  {
    name: "Jalalpur Jattan",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1176368,
  },
  {
    name: "Jahanian Shah",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1176444,
  },
  {
    name: "Jacobabad",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1176515,
  },
  {
    name: "Islamabad",
    country: "Pakistan",
    subcountry: "Islamabad",
    geonameid: 1176615,
  },
  {
    name: "Hyderabad",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1176734,
  },
  {
    name: "Hujra Shah Muqim",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1176800,
  },
  {
    name: "Hingorja",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1176889,
  },
  {
    name: "Hazro City",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1176948,
  },
  {
    name: "Havelian",
    country: "Pakistan",
    subcountry: "Khyber Pakhtunkhwa",
    geonameid: 1176995,
  },
  {
    name: "Haveli Lakha",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1176997,
  },
  {
    name: "Hasilpur",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1177042,
  },
  {
    name: "Chak Thirty-one -Eleven Left",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1177064,
  },
  {
    name: "Harunabad",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1177073,
  },
  {
    name: "Harnoli",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1177089,
  },
  {
    name: "Haripur",
    country: "Pakistan",
    subcountry: "Khyber Pakhtunkhwa",
    geonameid: 1177107,
  },
  {
    name: "Hangu",
    country: "Pakistan",
    subcountry: "Khyber Pakhtunkhwa",
    geonameid: 1177203,
  },
  {
    name: "Hala",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1177278,
  },
  {
    name: "Hafizabad",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1177384,
  },
  {
    name: "Hadali",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1177397,
  },
  {
    name: "Gwadar",
    country: "Pakistan",
    subcountry: "Balochistan",
    geonameid: 1177446,
  },
  {
    name: "Gujrat",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1177654,
  },
  {
    name: "Gujranwala",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1177662,
  },
  {
    name: "Gujar Khan",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1177682,
  },
  {
    name: "Gojra",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1178231,
  },
  {
    name: "Ghotki",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1178456,
  },
  {
    name: "Ghauspur",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1178560,
  },
  {
    name: "Gharo",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1178587,
  },
  {
    name: "Garh Maharaja",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1178841,
  },
  {
    name: "Gambat",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1179061,
  },
  {
    name: "Fort Abbas",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1179223,
  },
  {
    name: "Fazilpur",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1179255,
  },
  {
    name: "Fatehpur",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1179305,
  },
  {
    name: "Faruka",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1179346,
  },
  {
    name: "Faqirwali",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1179377,
  },
  {
    name: "Faisalabad",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1179400,
  },
  {
    name: "Eminabad",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1179406,
  },
  {
    name: "Dunyapur",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1179450,
  },
  {
    name: "Dunga Bunga",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1179463,
  },
  {
    name: "Dullewala",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1179496,
  },
  {
    name: "Upper Dir",
    country: "Pakistan",
    subcountry: "Khyber Pakhtunkhwa",
    geonameid: 1179757,
  },
  {
    name: "Dipalpur",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1179760,
  },
  {
    name: "Dinga",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1179790,
  },
  {
    name: "Dijkot",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1179834,
  },
  {
    name: "Digri",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1179837,
  },
  {
    name: "Dhoro Naro",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1179902,
  },
  {
    name: "Dhanot",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1180133,
  },
  {
    name: "Dera Ismail Khan",
    country: "Pakistan",
    subcountry: "Khyber Pakhtunkhwa",
    geonameid: 1180281,
  },
  {
    name: "Dera Ghazi Khan",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1180289,
  },
  {
    name: "Dera Bugti",
    country: "Pakistan",
    subcountry: "Balochistan",
    geonameid: 1180295,
  },
  {
    name: "Daur",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1180374,
  },
  {
    name: "Daud Khel",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1180419,
  },
  {
    name: "Daska Kalan",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1180436,
  },
  {
    name: "Darya Khan",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1180454,
  },
  {
    name: "Dajal",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1180752,
  },
  {
    name: "Dadu",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1180809,
  },
  {
    name: "Dadhar",
    country: "Pakistan",
    subcountry: "Balochistan",
    geonameid: 1180825,
  },
  {
    name: "Chunian",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1180942,
  },
  {
    name: "Chuhar Kana",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1180983,
  },
  {
    name: "Chhor",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1181022,
  },
  {
    name: "Choa Saidan Shah",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1181053,
  },
  {
    name: "Chishtian",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1181073,
  },
  {
    name: "Chiniot",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1181096,
  },
  {
    name: "Chichawatni",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1181163,
  },
  {
    name: "Chawinda",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1181352,
  },
  {
    name: "Charsadda",
    country: "Pakistan",
    subcountry: "Khyber Pakhtunkhwa",
    geonameid: 1181439,
  },
  {
    name: "Chaman",
    country: "Pakistan",
    subcountry: "Balochistan",
    geonameid: 1181611,
  },
  {
    name: "Chakwal",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1181636,
  },
  {
    name: "Chak Azam Sahu",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1181887,
  },
  {
    name: "Burewala",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1182092,
  },
  {
    name: "Bhopalwala",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1182577,
  },
  {
    name: "Bhit Shah",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1182607,
  },
  {
    name: "Bhimber",
    country: "Pakistan",
    subcountry: "Azad Kashmir",
    geonameid: 1182637,
  },
  {
    name: "Bhera",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1182665,
  },
  {
    name: "Bhawana",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1182682,
  },
  {
    name: "Bhan",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1182775,
  },
  {
    name: "Bhalwal",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1182787,
  },
  {
    name: "Bhakkar",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1182815,
  },
  {
    name: "Mianke Mor",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1182829,
  },
  {
    name: "Bela",
    country: "Pakistan",
    subcountry: "Balochistan",
    geonameid: 1182998,
  },
  {
    name: "Bat Khela",
    country: "Pakistan",
    subcountry: "Khyber Pakhtunkhwa",
    geonameid: 1183090,
  },
  {
    name: "Battagram",
    country: "Pakistan",
    subcountry: "Khyber Pakhtunkhwa",
    geonameid: 1183105,
  },
  {
    name: "Basirpur",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1183224,
  },
  {
    name: "Bannu",
    country: "Pakistan",
    subcountry: "Khyber Pakhtunkhwa",
    geonameid: 1183460,
  },
  {
    name: "Bahawalpur",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1183880,
  },
  {
    name: "Bahawalnagar",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1183883,
  },
  {
    name: "Badin",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1184055,
  },
  {
    name: "Baddomalhi",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1184075,
  },
  {
    name: "Attock City",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1184249,
  },
  {
    name: "Arifwala",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1184370,
  },
  {
    name: "Aman Garh",
    country: "Pakistan",
    subcountry: "Khyber Pakhtunkhwa",
    geonameid: 1184569,
  },
  {
    name: "Alipur",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1184655,
  },
  {
    name: "Akora",
    country: "Pakistan",
    subcountry: "Khyber Pakhtunkhwa",
    geonameid: 1184752,
  },
  {
    name: "Ahmadpur East",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1184845,
  },
  {
    name: "Abbottabad",
    country: "Pakistan",
    subcountry: "Khyber Pakhtunkhwa",
    geonameid: 1185056,
  },
  {
    name: "Bahawalnagar",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1332083,
  },
  {
    name: "Nowshera Cantonment",
    country: "Pakistan",
    subcountry: "Khyber Pakhtunkhwa",
    geonameid: 1341204,
  },
  {
    name: "Ahmadpur Sial",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1356491,
  },
  {
    name: "New Badah",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1357699,
  },
  {
    name: "Setharja Old",
    country: "Pakistan",
    subcountry: "Sindh",
    geonameid: 1412008,
  },
  {
    name: "Sook Kalan",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 1412851,
  },
  {
    name: "Risalpur Cantonment",
    country: "Pakistan",
    subcountry: "Khyber Pakhtunkhwa",
    geonameid: 1448637,
  },
  {
    name: "Malakwal City",
    country: "Pakistan",
    subcountry: "Punjab",
    geonameid: 6457378,
  },
  {
    name: "Żyrardów",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 752967,
  },
  {
    name: "Żoliborz",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 753142,
  },
  {
    name: "Zielonka",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 753276,
  },
  {
    name: "Zamość",
    country: "Poland",
    subcountry: "Lublin",
    geonameid: 753866,
  },
  {
    name: "Zambrów",
    country: "Poland",
    subcountry: "Podlasie",
    geonameid: 753895,
  },
  {
    name: "Ząbki",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 754351,
  },
  {
    name: "Wyszków",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 754454,
  },
  {
    name: "Wołomin",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 754800,
  },
  {
    name: "Wola",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 755330,
  },
  {
    name: "Włochy",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 755475,
  },
  {
    name: "Wieliczka",
    country: "Poland",
    subcountry: "Lesser Poland",
    geonameid: 755889,
  },
  {
    name: "Wesoła",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 756004,
  },
  {
    name: "Wawer",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 756092,
  },
  {
    name: "Warsaw",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 756135,
  },
  {
    name: "Ursus",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 756320,
  },
  {
    name: "Tomaszów Mazowiecki",
    country: "Poland",
    subcountry: "Łódź Voivodeship",
    geonameid: 756867,
  },
  {
    name: "Tomaszów Lubelski",
    country: "Poland",
    subcountry: "Lublin",
    geonameid: 756868,
  },
  {
    name: "Tarnów",
    country: "Poland",
    subcountry: "Lesser Poland",
    geonameid: 757026,
  },
  {
    name: "Tarnobrzeg",
    country: "Poland",
    subcountry: "Subcarpathia",
    geonameid: 757033,
  },
  {
    name: "Targówek",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 757065,
  },
  {
    name: "Szczytno",
    country: "Poland",
    subcountry: "Warmia-Masuria",
    geonameid: 757357,
  },
  {
    name: "Świdnik",
    country: "Poland",
    subcountry: "Lublin",
    geonameid: 757692,
  },
  {
    name: "Suwałki",
    country: "Poland",
    subcountry: "Podlasie",
    geonameid: 757718,
  },
  {
    name: "Sulejówek",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 757809,
  },
  {
    name: "Staszów",
    country: "Poland",
    subcountry: "Świętokrzyskie",
    geonameid: 758252,
  },
  {
    name: "Starachowice",
    country: "Poland",
    subcountry: "Świętokrzyskie",
    geonameid: 758390,
  },
  {
    name: "Stalowa Wola",
    country: "Poland",
    subcountry: "Subcarpathia",
    geonameid: 758445,
  },
  {
    name: "Śródmieście",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 758470,
  },
  {
    name: "Sokołów Podlaski",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 758626,
  },
  {
    name: "Sokółka",
    country: "Poland",
    subcountry: "Podlasie",
    geonameid: 758651,
  },
  {
    name: "Sochaczew",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 758682,
  },
  {
    name: "Skierniewice",
    country: "Poland",
    subcountry: "Łódź Voivodeship",
    geonameid: 759123,
  },
  {
    name: "Skarżysko-Kamienna",
    country: "Poland",
    subcountry: "Świętokrzyskie",
    geonameid: 759141,
  },
  {
    name: "Siemiatycze",
    country: "Poland",
    subcountry: "Podlasie",
    geonameid: 759320,
  },
  {
    name: "Siedlce",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 759412,
  },
  {
    name: "Sanok",
    country: "Poland",
    subcountry: "Subcarpathia",
    geonameid: 759591,
  },
  {
    name: "Sandomierz",
    country: "Poland",
    subcountry: "Świętokrzyskie",
    geonameid: 759603,
  },
  {
    name: "Rzeszów",
    country: "Poland",
    subcountry: "Subcarpathia",
    geonameid: 759734,
  },
  {
    name: "Ropczyce",
    country: "Poland",
    subcountry: "Subcarpathia",
    geonameid: 760343,
  },
  {
    name: "Rembertów",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 760503,
  },
  {
    name: "Rawa Mazowiecka",
    country: "Poland",
    subcountry: "Łódź Voivodeship",
    geonameid: 760584,
  },
  {
    name: "Radzyń Podlaski",
    country: "Poland",
    subcountry: "Lublin",
    geonameid: 760680,
  },
  {
    name: "Radom",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 760778,
  },
  {
    name: "Pułtusk",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 760917,
  },
  {
    name: "Puławy",
    country: "Poland",
    subcountry: "Lublin",
    geonameid: 760924,
  },
  {
    name: "Przeworsk",
    country: "Poland",
    subcountry: "Subcarpathia",
    geonameid: 761131,
  },
  {
    name: "Przemyśl",
    country: "Poland",
    subcountry: "Subcarpathia",
    geonameid: 761168,
  },
  {
    name: "Przasnysz",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 761218,
  },
  {
    name: "Pruszków",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 761228,
  },
  {
    name: "Płońsk",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 762021,
  },
  {
    name: "Pisz",
    country: "Poland",
    subcountry: "Warmia-Masuria",
    geonameid: 762120,
  },
  {
    name: "Pionki",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 762199,
  },
  {
    name: "Piastów",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 762381,
  },
  {
    name: "Piaseczno",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 762423,
  },
  {
    name: "Otwock",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 762788,
  },
  {
    name: "Ostrów Mazowiecka",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 762850,
  },
  {
    name: "Ostrowiec Świętokrzyski",
    country: "Poland",
    subcountry: "Świętokrzyskie",
    geonameid: 762863,
  },
  {
    name: "Ostrołęka",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 762909,
  },
  {
    name: "Opoczno",
    country: "Poland",
    subcountry: "Łódź Voivodeship",
    geonameid: 763111,
  },
  {
    name: "Olsztyn",
    country: "Poland",
    subcountry: "Warmia-Masuria",
    geonameid: 763166,
  },
  {
    name: "Olecko",
    country: "Poland",
    subcountry: "Warmia-Masuria",
    geonameid: 763291,
  },
  {
    name: "Ochota",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 763442,
  },
  {
    name: "Nowy Targ",
    country: "Poland",
    subcountry: "Lesser Poland",
    geonameid: 763523,
  },
  {
    name: "Nowy Sącz",
    country: "Poland",
    subcountry: "Lesser Poland",
    geonameid: 763534,
  },
  {
    name: "Nowy Dwór Mazowiecki",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 763556,
  },
  {
    name: "Nisko",
    country: "Poland",
    subcountry: "Subcarpathia",
    geonameid: 763829,
  },
  {
    name: "Mrągowo",
    country: "Poland",
    subcountry: "Warmia-Masuria",
    geonameid: 764312,
  },
  {
    name: "Mokotów",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 764484,
  },
  {
    name: "Mława",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 764634,
  },
  {
    name: "Mińsk Mazowiecki",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 764679,
  },
  {
    name: "Milanówek",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 764749,
  },
  {
    name: "Mielec",
    country: "Poland",
    subcountry: "Subcarpathia",
    geonameid: 764849,
  },
  {
    name: "Międzyrzec Podlaski",
    country: "Poland",
    subcountry: "Lublin",
    geonameid: 764862,
  },
  {
    name: "Marki",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 765191,
  },
  {
    name: "Łuków",
    country: "Poland",
    subcountry: "Lublin",
    geonameid: 765749,
  },
  {
    name: "Lublin",
    country: "Poland",
    subcountry: "Lublin",
    geonameid: 765876,
  },
  {
    name: "Lubartów",
    country: "Poland",
    subcountry: "Lublin",
    geonameid: 765927,
  },
  {
    name: "Łomża",
    country: "Poland",
    subcountry: "Podlasie",
    geonameid: 766027,
  },
  {
    name: "Łomianki",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 766042,
  },
  {
    name: "Lidzbark Warmiński",
    country: "Poland",
    subcountry: "Warmia-Masuria",
    geonameid: 766307,
  },
  {
    name: "Legionowo",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 766555,
  },
  {
    name: "Łęczna",
    country: "Poland",
    subcountry: "Lublin",
    geonameid: 766583,
  },
  {
    name: "Łapy",
    country: "Poland",
    subcountry: "Podlasie",
    geonameid: 766783,
  },
  {
    name: "Łańcut",
    country: "Poland",
    subcountry: "Subcarpathia",
    geonameid: 766810,
  },
  {
    name: "Krosno",
    country: "Poland",
    subcountry: "Subcarpathia",
    geonameid: 767470,
  },
  {
    name: "Krasnystaw",
    country: "Poland",
    subcountry: "Lublin",
    geonameid: 767605,
  },
  {
    name: "Kraśnik",
    country: "Poland",
    subcountry: "Lublin",
    geonameid: 767623,
  },
  {
    name: "Kozienice",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 767814,
  },
  {
    name: "Konstancin-Jeziorna",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 768216,
  },
  {
    name: "Końskie",
    country: "Poland",
    subcountry: "Świętokrzyskie",
    geonameid: 768218,
  },
  {
    name: "Kobyłka",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 768905,
  },
  {
    name: "Kielce",
    country: "Poland",
    subcountry: "Świętokrzyskie",
    geonameid: 769250,
  },
  {
    name: "Kętrzyn",
    country: "Poland",
    subcountry: "Warmia-Masuria",
    geonameid: 769274,
  },
  {
    name: "Kabaty",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 769893,
  },
  {
    name: "Józefów",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 769981,
  },
  {
    name: "Jędrzejów",
    country: "Poland",
    subcountry: "Świętokrzyskie",
    geonameid: 770157,
  },
  {
    name: "Jasło",
    country: "Poland",
    subcountry: "Subcarpathia",
    geonameid: 770293,
  },
  {
    name: "Jarosław",
    country: "Poland",
    subcountry: "Subcarpathia",
    geonameid: 770380,
  },
  {
    name: "Hrubieszów",
    country: "Poland",
    subcountry: "Lublin",
    geonameid: 770966,
  },
  {
    name: "Hajnówka",
    country: "Poland",
    subcountry: "Podlasie",
    geonameid: 771158,
  },
  {
    name: "Grodzisk Mazowiecki",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 771401,
  },
  {
    name: "Grajewo",
    country: "Poland",
    subcountry: "Podlasie",
    geonameid: 771506,
  },
  {
    name: "Gorlice",
    country: "Poland",
    subcountry: "Lesser Poland",
    geonameid: 771804,
  },
  {
    name: "Giżycko",
    country: "Poland",
    subcountry: "Warmia-Masuria",
    geonameid: 772195,
  },
  {
    name: "Gierłoż",
    country: "Poland",
    subcountry: "Warmia-Masuria",
    geonameid: 772227,
  },
  {
    name: "Garwolin",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 772339,
  },
  {
    name: "Ełk",
    country: "Poland",
    subcountry: "Warmia-Masuria",
    geonameid: 772621,
  },
  {
    name: "Działdowo",
    country: "Poland",
    subcountry: "Warmia-Masuria",
    geonameid: 772748,
  },
  {
    name: "Dęblin",
    country: "Poland",
    subcountry: "Lublin",
    geonameid: 773357,
  },
  {
    name: "Dębica",
    country: "Poland",
    subcountry: "Subcarpathia",
    geonameid: 773380,
  },
  {
    name: "Ciechanów",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 774208,
  },
  {
    name: "Chełm",
    country: "Poland",
    subcountry: "Lublin",
    geonameid: 774558,
  },
  {
    name: "Busko-Zdrój",
    country: "Poland",
    subcountry: "Świętokrzyskie",
    geonameid: 774747,
  },
  {
    name: "Brzesko",
    country: "Poland",
    subcountry: "Lesser Poland",
    geonameid: 775183,
  },
  {
    name: "Bochnia",
    country: "Poland",
    subcountry: "Lesser Poland",
    geonameid: 775758,
  },
  {
    name: "Biłgoraj",
    country: "Poland",
    subcountry: "Lublin",
    geonameid: 775922,
  },
  {
    name: "Bielsk Podlaski",
    country: "Poland",
    subcountry: "Podlasie",
    geonameid: 775986,
  },
  {
    name: "Bielany",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 776029,
  },
  {
    name: "Białystok",
    country: "Poland",
    subcountry: "Podlasie",
    geonameid: 776069,
  },
  {
    name: "Białołeka",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 776103,
  },
  {
    name: "Biała Podlaska",
    country: "Poland",
    subcountry: "Lublin",
    geonameid: 776175,
  },
  {
    name: "Bemowo",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 776251,
  },
  {
    name: "Bartoszyce",
    country: "Poland",
    subcountry: "Warmia-Masuria",
    geonameid: 776337,
  },
  {
    name: "Augustów",
    country: "Poland",
    subcountry: "Podlasie",
    geonameid: 776597,
  },
  {
    name: "Żywiec",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3079855,
  },
  {
    name: "Żory",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3080004,
  },
  {
    name: "Złotów",
    country: "Poland",
    subcountry: "Greater Poland",
    geonameid: 3080071,
  },
  {
    name: "Złotoryja",
    country: "Poland",
    subcountry: "Lower Silesia",
    geonameid: 3080074,
  },
  {
    name: "Zielona Góra",
    country: "Poland",
    subcountry: "Lubusz",
    geonameid: 3080165,
  },
  {
    name: "Zgorzelec",
    country: "Poland",
    subcountry: "Lower Silesia",
    geonameid: 3080231,
  },
  {
    name: "Zgierz",
    country: "Poland",
    subcountry: "Łódź Voivodeship",
    geonameid: 3080251,
  },
  {
    name: "Zduńska Wola",
    country: "Poland",
    subcountry: "Łódź Voivodeship",
    geonameid: 3080414,
  },
  {
    name: "Zawiercie",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3080526,
  },
  {
    name: "Żary",
    country: "Poland",
    subcountry: "Lubusz",
    geonameid: 3080644,
  },
  {
    name: "Zakopane",
    country: "Poland",
    subcountry: "Lesser Poland",
    geonameid: 3080866,
  },
  {
    name: "Żagań",
    country: "Poland",
    subcountry: "Lubusz",
    geonameid: 3080944,
  },
  {
    name: "Zabrze",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3080985,
  },
  {
    name: "Ząbkowice Śląskie",
    country: "Poland",
    subcountry: "Lower Silesia",
    geonameid: 3081046,
  },
  {
    name: "Września",
    country: "Poland",
    subcountry: "Greater Poland",
    geonameid: 3081324,
  },
  {
    name: "Wrocław",
    country: "Poland",
    subcountry: "Lower Silesia",
    geonameid: 3081368,
  },
  {
    name: "Wodzisław Śląski",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3081677,
  },
  {
    name: "Włocławek",
    country: "Poland",
    subcountry: "Kujawsko-Pomorskie",
    geonameid: 3081741,
  },
  {
    name: "Wieluń",
    country: "Poland",
    subcountry: "Łódź Voivodeship",
    geonameid: 3082197,
  },
  {
    name: "Wejherowo",
    country: "Poland",
    subcountry: "Pomerania",
    geonameid: 3082473,
  },
  {
    name: "Wałcz",
    country: "Poland",
    subcountry: "West Pomerania",
    geonameid: 3082704,
  },
  {
    name: "Wałbrzych",
    country: "Poland",
    subcountry: "Lower Silesia",
    geonameid: 3082707,
  },
  {
    name: "Wągrowiec",
    country: "Poland",
    subcountry: "Greater Poland",
    geonameid: 3082712,
  },
  {
    name: "Wadowice",
    country: "Poland",
    subcountry: "Lesser Poland",
    geonameid: 3082722,
  },
  {
    name: "Ustroń",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3082751,
  },
  {
    name: "Ustka",
    country: "Poland",
    subcountry: "Pomerania",
    geonameid: 3082756,
  },
  {
    name: "Tychy",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3082914,
  },
  {
    name: "Turek",
    country: "Poland",
    subcountry: "Greater Poland",
    geonameid: 3082998,
  },
  {
    name: "Trzebinia",
    country: "Poland",
    subcountry: "Lesser Poland",
    geonameid: 3083111,
  },
  {
    name: "Trzcianka",
    country: "Poland",
    subcountry: "Greater Poland",
    geonameid: 3083185,
  },
  {
    name: "Toruń",
    country: "Poland",
    subcountry: "Kujawsko-Pomorskie",
    geonameid: 3083271,
  },
  {
    name: "Tczew",
    country: "Poland",
    subcountry: "Pomerania",
    geonameid: 3083426,
  },
  {
    name: "Tarnowskie Góry",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3083440,
  },
  {
    name: "Szczecinek",
    country: "Poland",
    subcountry: "West Pomerania",
    geonameid: 3083826,
  },
  {
    name: "Szczecin",
    country: "Poland",
    subcountry: "West Pomerania",
    geonameid: 3083829,
  },
  {
    name: "Szamotuły",
    country: "Poland",
    subcountry: "Greater Poland",
    geonameid: 3083878,
  },
  {
    name: "Świnoujście",
    country: "Poland",
    subcountry: "West Pomerania",
    geonameid: 3083955,
  },
  {
    name: "Świętochłowice",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3083988,
  },
  {
    name: "Świebodzin",
    country: "Poland",
    subcountry: "Lubusz",
    geonameid: 3084062,
  },
  {
    name: "Świecie",
    country: "Poland",
    subcountry: "Kujawsko-Pomorskie",
    geonameid: 3084074,
  },
  {
    name: "Świebodzice",
    country: "Poland",
    subcountry: "Lower Silesia",
    geonameid: 3084084,
  },
  {
    name: "Świdwin",
    country: "Poland",
    subcountry: "West Pomerania",
    geonameid: 3084085,
  },
  {
    name: "Świdnica",
    country: "Poland",
    subcountry: "Lower Silesia",
    geonameid: 3084093,
  },
  {
    name: "Swarzędz",
    country: "Poland",
    subcountry: "Greater Poland",
    geonameid: 3084130,
  },
  {
    name: "Sulechów",
    country: "Poland",
    subcountry: "Lubusz",
    geonameid: 3084241,
  },
  {
    name: "Strzelce Opolskie",
    country: "Poland",
    subcountry: "Opole Voivodeship",
    geonameid: 3084415,
  },
  {
    name: "Strzegom",
    country: "Poland",
    subcountry: "Lower Silesia",
    geonameid: 3084440,
  },
  {
    name: "Starogard Gdański",
    country: "Poland",
    subcountry: "Pomerania",
    geonameid: 3084826,
  },
  {
    name: "Stargard",
    country: "Poland",
    subcountry: "West Pomerania",
    geonameid: 3084840,
  },
  {
    name: "Środa Wielkopolska",
    country: "Poland",
    subcountry: "Greater Poland",
    geonameid: 3085045,
  },
  {
    name: "Śrem",
    country: "Poland",
    subcountry: "Greater Poland",
    geonameid: 3085056,
  },
  {
    name: "Sosnowiec",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3085128,
  },
  {
    name: "Sopot",
    country: "Poland",
    subcountry: "Pomerania",
    geonameid: 3085151,
  },
  {
    name: "Solec Kujawski",
    country: "Poland",
    subcountry: "Kujawsko-Pomorskie",
    geonameid: 3085172,
  },
  {
    name: "Słupsk",
    country: "Poland",
    subcountry: "Pomerania",
    geonameid: 3085450,
  },
  {
    name: "Słubice",
    country: "Poland",
    subcountry: "Lubusz",
    geonameid: 3085495,
  },
  {
    name: "Skawina",
    country: "Poland",
    subcountry: "Lesser Poland",
    geonameid: 3085807,
  },
  {
    name: "Sierpc",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 3085941,
  },
  {
    name: "Sieradz",
    country: "Poland",
    subcountry: "Łódź Voivodeship",
    geonameid: 3085978,
  },
  {
    name: "Siemianowice Śląskie",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3086024,
  },
  {
    name: "Rypin",
    country: "Poland",
    subcountry: "Kujawsko-Pomorskie",
    geonameid: 3086511,
  },
  {
    name: "Rydułtowy",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3086531,
  },
  {
    name: "Rybnik",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3086586,
  },
  {
    name: "Rumia",
    country: "Poland",
    subcountry: "Pomerania",
    geonameid: 3086706,
  },
  {
    name: "Ruda Śląska",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3086800,
  },
  {
    name: "Reda",
    country: "Poland",
    subcountry: "Pomerania",
    geonameid: 3087281,
  },
  {
    name: "Rawicz",
    country: "Poland",
    subcountry: "Greater Poland",
    geonameid: 3087307,
  },
  {
    name: "Radzionków",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3087418,
  },
  {
    name: "Radomsko",
    country: "Poland",
    subcountry: "Łódź Voivodeship",
    geonameid: 3087497,
  },
  {
    name: "Radlin",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3087529,
  },
  {
    name: "Racibórz",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3087584,
  },
  {
    name: "Pyskowice",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3087628,
  },
  {
    name: "Pszczyna",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3087705,
  },
  {
    name: "Pruszcz Gdański",
    country: "Poland",
    subcountry: "Pomerania",
    geonameid: 3088034,
  },
  {
    name: "Prudnik",
    country: "Poland",
    subcountry: "Opole Voivodeship",
    geonameid: 3088065,
  },
  {
    name: "Poznań",
    country: "Poland",
    subcountry: "Greater Poland",
    geonameid: 3088171,
  },
  {
    name: "Polkowice",
    country: "Poland",
    subcountry: "Lower Silesia",
    geonameid: 3088435,
  },
  {
    name: "Police",
    country: "Poland",
    subcountry: "West Pomerania",
    geonameid: 3088461,
  },
  {
    name: "Płock",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 3088825,
  },
  {
    name: "Pleszew",
    country: "Poland",
    subcountry: "Greater Poland",
    geonameid: 3088848,
  },
  {
    name: "Piotrków Trybunalski",
    country: "Poland",
    subcountry: "Łódź Voivodeship",
    geonameid: 3088972,
  },
  {
    name: "Piła",
    country: "Poland",
    subcountry: "Greater Poland",
    geonameid: 3089033,
  },
  {
    name: "Piekary Śląskie",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3089125,
  },
  {
    name: "Pabianice",
    country: "Poland",
    subcountry: "Łódź Voivodeship",
    geonameid: 3089578,
  },
  {
    name: "Ozorków",
    country: "Poland",
    subcountry: "Łódź Voivodeship",
    geonameid: 3089582,
  },
  {
    name: "Oświęcim",
    country: "Poland",
    subcountry: "Lesser Poland",
    geonameid: 3089658,
  },
  {
    name: "Ostrów Wielkopolski",
    country: "Poland",
    subcountry: "Greater Poland",
    geonameid: 3089684,
  },
  {
    name: "Ostróda",
    country: "Poland",
    subcountry: "Warmia-Masuria",
    geonameid: 3089779,
  },
  {
    name: "Orzesze",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3089965,
  },
  {
    name: "Opole",
    country: "Poland",
    subcountry: "Opole Voivodeship",
    geonameid: 3090048,
  },
  {
    name: "Olkusz",
    country: "Poland",
    subcountry: "Lesser Poland",
    geonameid: 3090146,
  },
  {
    name: "Oleśnica",
    country: "Poland",
    subcountry: "Lower Silesia",
    geonameid: 3090170,
  },
  {
    name: "Oława",
    country: "Poland",
    subcountry: "Lower Silesia",
    geonameid: 3090205,
  },
  {
    name: "Oborniki",
    country: "Poland",
    subcountry: "Greater Poland",
    geonameid: 3090403,
  },
  {
    name: "Nysa",
    country: "Poland",
    subcountry: "Opole Voivodeship",
    geonameid: 3090436,
  },
  {
    name: "Nowy Tomyśl",
    country: "Poland",
    subcountry: "Greater Poland",
    geonameid: 3090452,
  },
  {
    name: "Nowogard",
    country: "Poland",
    subcountry: "West Pomerania",
    geonameid: 3090558,
  },
  {
    name: "Nowa Sól",
    country: "Poland",
    subcountry: "Lubusz",
    geonameid: 3090764,
  },
  {
    name: "Nowa Ruda",
    country: "Poland",
    subcountry: "Lower Silesia",
    geonameid: 3090768,
  },
  {
    name: "Namysłów",
    country: "Poland",
    subcountry: "Opole Voivodeship",
    geonameid: 3091141,
  },
  {
    name: "Nakło nad Notecią",
    country: "Poland",
    subcountry: "Kujawsko-Pomorskie",
    geonameid: 3091150,
  },
  {
    name: "Myszków",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3091217,
  },
  {
    name: "Mysłowice",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3091232,
  },
  {
    name: "Myślenice",
    country: "Poland",
    subcountry: "Lesser Poland",
    geonameid: 3091256,
  },
  {
    name: "Mikołów",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3091831,
  },
  {
    name: "Międzyrzecz",
    country: "Poland",
    subcountry: "Lubusz",
    geonameid: 3091969,
  },
  {
    name: "Malbork",
    country: "Poland",
    subcountry: "Pomerania",
    geonameid: 3092472,
  },
  {
    name: "Luboń",
    country: "Poland",
    subcountry: "Greater Poland",
    geonameid: 3092856,
  },
  {
    name: "Lubliniec",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3092906,
  },
  {
    name: "Lubin",
    country: "Poland",
    subcountry: "Lower Silesia",
    geonameid: 3092931,
  },
  {
    name: "Lubań",
    country: "Poland",
    subcountry: "Lower Silesia",
    geonameid: 3093040,
  },
  {
    name: "Łowicz",
    country: "Poland",
    subcountry: "Łódź Voivodeship",
    geonameid: 3093066,
  },
  {
    name: "Łódź",
    country: "Poland",
    subcountry: "Łódź Voivodeship",
    geonameid: 3093133,
  },
  {
    name: "Libiąż",
    country: "Poland",
    subcountry: "Lesser Poland",
    geonameid: 3093457,
  },
  {
    name: "Leszno",
    country: "Poland",
    subcountry: "Greater Poland",
    geonameid: 3093524,
  },
  {
    name: "Legnica",
    country: "Poland",
    subcountry: "Lower Silesia",
    geonameid: 3093692,
  },
  {
    name: "Lędziny",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3093708,
  },
  {
    name: "Łęczyca",
    country: "Poland",
    subcountry: "Łódź Voivodeship",
    geonameid: 3093726,
  },
  {
    name: "Lębork",
    country: "Poland",
    subcountry: "Pomerania",
    geonameid: 3093739,
  },
  {
    name: "Łaziska Górne",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3093785,
  },
  {
    name: "Łask",
    country: "Poland",
    subcountry: "Łódź Voivodeship",
    geonameid: 3093902,
  },
  {
    name: "Kwidzyn",
    country: "Poland",
    subcountry: "Pomerania",
    geonameid: 3094086,
  },
  {
    name: "Kutno",
    country: "Poland",
    subcountry: "Łódź Voivodeship",
    geonameid: 3094170,
  },
  {
    name: "Krotoszyn",
    country: "Poland",
    subcountry: "Greater Poland",
    geonameid: 3094625,
  },
  {
    name: "Krapkowice",
    country: "Poland",
    subcountry: "Opole Voivodeship",
    geonameid: 3094788,
  },
  {
    name: "Kraków",
    country: "Poland",
    subcountry: "Lesser Poland",
    geonameid: 3094802,
  },
  {
    name: "Koszalin",
    country: "Poland",
    subcountry: "West Pomerania",
    geonameid: 3095049,
  },
  {
    name: "Kostrzyn nad Odrą",
    country: "Poland",
    subcountry: "Lubusz",
    geonameid: 3095057,
  },
  {
    name: "Kościerzyna",
    country: "Poland",
    subcountry: "Pomerania",
    geonameid: 3095126,
  },
  {
    name: "Kościan",
    country: "Poland",
    subcountry: "Greater Poland",
    geonameid: 3095151,
  },
  {
    name: "Konstantynów Łódzki",
    country: "Poland",
    subcountry: "Łódź Voivodeship",
    geonameid: 3095277,
  },
  {
    name: "Konin",
    country: "Poland",
    subcountry: "Greater Poland",
    geonameid: 3095321,
  },
  {
    name: "Kołobrzeg",
    country: "Poland",
    subcountry: "West Pomerania",
    geonameid: 3095795,
  },
  {
    name: "Koło",
    country: "Poland",
    subcountry: "Greater Poland",
    geonameid: 3095797,
  },
  {
    name: "Knurów",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3095971,
  },
  {
    name: "Kluczbork",
    country: "Poland",
    subcountry: "Opole Voivodeship",
    geonameid: 3096003,
  },
  {
    name: "Kłodzko",
    country: "Poland",
    subcountry: "Lower Silesia",
    geonameid: 3096053,
  },
  {
    name: "Kęty",
    country: "Poland",
    subcountry: "Lesser Poland",
    geonameid: 3096328,
  },
  {
    name: "Kędzierzyn-Koźle",
    country: "Poland",
    subcountry: "Opole Voivodeship",
    geonameid: 3096372,
  },
  {
    name: "Katowice",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3096472,
  },
  {
    name: "Kartuzy",
    country: "Poland",
    subcountry: "Pomerania",
    geonameid: 3096525,
  },
  {
    name: "Kamienna Góra",
    country: "Poland",
    subcountry: "Lower Silesia",
    geonameid: 3096779,
  },
  {
    name: "Kalisz",
    country: "Poland",
    subcountry: "Greater Poland",
    geonameid: 3096880,
  },
  {
    name: "Jelenia Góra",
    country: "Poland",
    subcountry: "Lower Silesia",
    geonameid: 3097257,
  },
  {
    name: "Jelcz",
    country: "Poland",
    subcountry: "Lower Silesia",
    geonameid: 3097271,
  },
  {
    name: "Jaworzno",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3097333,
  },
  {
    name: "Jawor",
    country: "Poland",
    subcountry: "Lower Silesia",
    geonameid: 3097367,
  },
  {
    name: "Jastrzębie Zdrój",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3097391,
  },
  {
    name: "Jarocin",
    country: "Poland",
    subcountry: "Greater Poland",
    geonameid: 3097528,
  },
  {
    name: "Inowrocław",
    country: "Poland",
    subcountry: "Kujawsko-Pomorskie",
    geonameid: 3097872,
  },
  {
    name: "Iława",
    country: "Poland",
    subcountry: "Warmia-Masuria",
    geonameid: 3097902,
  },
  {
    name: "Gubin",
    country: "Poland",
    subcountry: "Lubusz",
    geonameid: 3098130,
  },
  {
    name: "Gryfino",
    country: "Poland",
    subcountry: "West Pomerania",
    geonameid: 3098200,
  },
  {
    name: "Gryfice",
    country: "Poland",
    subcountry: "West Pomerania",
    geonameid: 3098201,
  },
  {
    name: "Grudziądz",
    country: "Poland",
    subcountry: "Kujawsko-Pomorskie",
    geonameid: 3098218,
  },
  {
    name: "Gostynin",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 3098619,
  },
  {
    name: "Gostyń",
    country: "Poland",
    subcountry: "Greater Poland",
    geonameid: 3098625,
  },
  {
    name: "Gorzów Wielkopolski",
    country: "Poland",
    subcountry: "Lubusz",
    geonameid: 3098722,
  },
  {
    name: "Goleniów",
    country: "Poland",
    subcountry: "West Pomerania",
    geonameid: 3098966,
  },
  {
    name: "Gniezno",
    country: "Poland",
    subcountry: "Greater Poland",
    geonameid: 3099112,
  },
  {
    name: "Głuchołazy",
    country: "Poland",
    subcountry: "Opole Voivodeship",
    geonameid: 3099169,
  },
  {
    name: "Głowno",
    country: "Poland",
    subcountry: "Łódź Voivodeship",
    geonameid: 3099180,
  },
  {
    name: "Głogów",
    country: "Poland",
    subcountry: "Lower Silesia",
    geonameid: 3099213,
  },
  {
    name: "Gliwice",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3099230,
  },
  {
    name: "Gdynia",
    country: "Poland",
    subcountry: "Pomerania",
    geonameid: 3099424,
  },
  {
    name: "Gdańsk",
    country: "Poland",
    subcountry: "Pomerania",
    geonameid: 3099434,
  },
  {
    name: "Fordon",
    country: "Poland",
    subcountry: "Kujawsko-Pomorskie",
    geonameid: 3099654,
  },
  {
    name: "Elbląg",
    country: "Poland",
    subcountry: "Warmia-Masuria",
    geonameid: 3099759,
  },
  {
    name: "Dzierżoniów",
    country: "Poland",
    subcountry: "Lower Silesia",
    geonameid: 3099828,
  },
  {
    name: "Dąbrowa Górnicza",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3100796,
  },
  {
    name: "Częstochowa",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3100946,
  },
  {
    name: "Czerwionka-Leszczyny",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3100974,
  },
  {
    name: "Czeladź",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3101057,
  },
  {
    name: "Czechowice-Dziedzice",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3101076,
  },
  {
    name: "Cieszyn",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3101321,
  },
  {
    name: "Chrzanów",
    country: "Poland",
    subcountry: "Lesser Poland",
    geonameid: 3101547,
  },
  {
    name: "Choszczno",
    country: "Poland",
    subcountry: "West Pomerania",
    geonameid: 3101613,
  },
  {
    name: "Chorzów",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3101619,
  },
  {
    name: "Chojnice",
    country: "Poland",
    subcountry: "Pomerania",
    geonameid: 3101672,
  },
  {
    name: "Chodzież",
    country: "Poland",
    subcountry: "Greater Poland",
    geonameid: 3101680,
  },
  {
    name: "Chełmża",
    country: "Poland",
    subcountry: "Kujawsko-Pomorskie",
    geonameid: 3101787,
  },
  {
    name: "Chełmno",
    country: "Poland",
    subcountry: "Kujawsko-Pomorskie",
    geonameid: 3101795,
  },
  {
    name: "Bytów",
    country: "Poland",
    subcountry: "Pomerania",
    geonameid: 3101943,
  },
  {
    name: "Bytom",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3101950,
  },
  {
    name: "Bydgoszcz",
    country: "Poland",
    subcountry: "Kujawsko-Pomorskie",
    geonameid: 3102014,
  },
  {
    name: "Brzeg",
    country: "Poland",
    subcountry: "Opole Voivodeship",
    geonameid: 3102459,
  },
  {
    name: "Brodnica",
    country: "Poland",
    subcountry: "Kujawsko-Pomorskie",
    geonameid: 3102627,
  },
  {
    name: "Braniewo",
    country: "Poland",
    subcountry: "Warmia-Masuria",
    geonameid: 3102677,
  },
  {
    name: "Bolesławiec",
    country: "Poland",
    subcountry: "Lower Silesia",
    geonameid: 3102987,
  },
  {
    name: "Boguszów-Gorce",
    country: "Poland",
    subcountry: "Lower Silesia",
    geonameid: 3103034,
  },
  {
    name: "Bogatynia",
    country: "Poland",
    subcountry: "Lower Silesia",
    geonameid: 3103096,
  },
  {
    name: "Bieruń",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3103365,
  },
  {
    name: "Bielsko-Biala",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3103402,
  },
  {
    name: "Bielawa",
    country: "Poland",
    subcountry: "Lower Silesia",
    geonameid: 3103476,
  },
  {
    name: "Białogard",
    country: "Poland",
    subcountry: "West Pomerania",
    geonameid: 3103556,
  },
  {
    name: "Bełchatów",
    country: "Poland",
    subcountry: "Łódź Voivodeship",
    geonameid: 3103709,
  },
  {
    name: "Będzin",
    country: "Poland",
    subcountry: "Silesia",
    geonameid: 3103719,
  },
  {
    name: "Andrychów",
    country: "Poland",
    subcountry: "Lesser Poland",
    geonameid: 3104115,
  },
  {
    name: "Aleksandrów Łódzki",
    country: "Poland",
    subcountry: "Łódź Voivodeship",
    geonameid: 3104132,
  },
  {
    name: "Ursynów",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 6545326,
  },
  {
    name: "Praga Północ",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 6545347,
  },
  {
    name: "Praga Południe",
    country: "Poland",
    subcountry: "Mazovia",
    geonameid: 6545348,
  },
  {
    name: "Jelcz Laskowice",
    country: "Poland",
    subcountry: "Lower Silesia",
    geonameid: 7303641,
  },
  {
    name: "Osiedle Kosmonautów",
    country: "Poland",
    subcountry: "Lower Silesia",
    geonameid: 12047617,
  },
  {
    name: "Rejon placu Grunwaldzkiego",
    country: "Poland",
    subcountry: "Lower Silesia",
    geonameid: 12047623,
  },
  {
    name: "Rejon ulicy Traugutta",
    country: "Poland",
    subcountry: "Lower Silesia",
    geonameid: 12047628,
  },
  {
    name: "Kozanów",
    country: "Poland",
    subcountry: "Lower Silesia",
    geonameid: 12047636,
  },
  {
    name: "Rejon placu Świętego Macieja",
    country: "Poland",
    subcountry: "Lower Silesia",
    geonameid: 12047644,
  },
  {
    name: "Różanka-Polanka",
    country: "Poland",
    subcountry: "Lower Silesia",
    geonameid: 12047651,
  },
  {
    name: "Saint-Pierre",
    country: "Saint Pierre and Miquelon",
    subcountry: "Saint-Pierre",
    geonameid: 3424934,
  },
  {
    name: "Adamstown",
    country: "Pitcairn",
    subcountry: "N/A",
    geonameid: 4030723,
  },
  {
    name: "Aguadilla",
    country: "Puerto Rico",
    subcountry: "Aguadilla",
    geonameid: 4562506,
  },
  {
    name: "Arecibo",
    country: "Puerto Rico",
    subcountry: "Arecibo",
    geonameid: 4562635,
  },
  {
    name: "Barceloneta",
    country: "Puerto Rico",
    subcountry: "Barceloneta",
    geonameid: 4562768,
  },
  {
    name: "Bayamón",
    country: "Puerto Rico",
    subcountry: "Bayamón",
    geonameid: 4562831,
  },
  {
    name: "Caguas",
    country: "Puerto Rico",
    subcountry: "Caguas",
    geonameid: 4563008,
  },
  {
    name: "Candelaria",
    country: "Puerto Rico",
    subcountry: "Toa Baja",
    geonameid: 4563122,
  },
  {
    name: "Carolina",
    country: "Puerto Rico",
    subcountry: "Carolina",
    geonameid: 4563243,
  },
  {
    name: "Cataño",
    country: "Puerto Rico",
    subcountry: "Cataño",
    geonameid: 4563298,
  },
  {
    name: "Cayey",
    country: "Puerto Rico",
    subcountry: "Cayey",
    geonameid: 4563308,
  },
  {
    name: "Fajardo",
    country: "Puerto Rico",
    subcountry: "Fajardo",
    geonameid: 4564946,
  },
  {
    name: "Guayama",
    country: "Puerto Rico",
    subcountry: "Guayama",
    geonameid: 4565105,
  },
  {
    name: "Guaynabo",
    country: "Puerto Rico",
    subcountry: "Guaynabo",
    geonameid: 4565119,
  },
  {
    name: "Humacao",
    country: "Puerto Rico",
    subcountry: "Humacao",
    geonameid: 4565564,
  },
  {
    name: "Levittown",
    country: "Puerto Rico",
    subcountry: "Toa Baja",
    geonameid: 4566002,
  },
  {
    name: "Manatí",
    country: "Puerto Rico",
    subcountry: "Manatí",
    geonameid: 4566137,
  },
  {
    name: "Mayagüez",
    country: "Puerto Rico",
    subcountry: "Mayagüez",
    geonameid: 4566385,
  },
  {
    name: "Ponce",
    country: "Puerto Rico",
    subcountry: "Ponce",
    geonameid: 4566880,
  },
  {
    name: "San Juan",
    country: "Puerto Rico",
    subcountry: "San Juan",
    geonameid: 4568127,
  },
  {
    name: "Trujillo Alto",
    country: "Puerto Rico",
    subcountry: "Trujillo Alto",
    geonameid: 4568451,
  },
  {
    name: "Vega Baja",
    country: "Puerto Rico",
    subcountry: "Vega Baja",
    geonameid: 4568533,
  },
  {
    name: "Yauco",
    country: "Puerto Rico",
    subcountry: "Yauco",
    geonameid: 4568917,
  },
  {
    name: "Rafaḩ",
    country: "Palestinian Territory",
    subcountry: "Gaza Strip",
    geonameid: 281102,
  },
  {
    name: "An Nuşayrāt",
    country: "Palestinian Territory",
    subcountry: "Gaza Strip",
    geonameid: 281109,
  },
  {
    name: "Khān Yūnis",
    country: "Palestinian Territory",
    subcountry: "Gaza Strip",
    geonameid: 281124,
  },
  {
    name: "Jabālyā",
    country: "Palestinian Territory",
    subcountry: "Gaza Strip",
    geonameid: 281129,
  },
  {
    name: "Gaza",
    country: "Palestinian Territory",
    subcountry: "Gaza Strip",
    geonameid: 281133,
  },
  {
    name: "Dayr al Balaḩ",
    country: "Palestinian Territory",
    subcountry: "Gaza Strip",
    geonameid: 281141,
  },
  {
    name: "Bayt Lāhyā",
    country: "Palestinian Territory",
    subcountry: "Gaza Strip",
    geonameid: 281145,
  },
  {
    name: "Bayt Ḩānūn",
    country: "Palestinian Territory",
    subcountry: "Gaza Strip",
    geonameid: 281146,
  },
  {
    name: "Banī Suhaylā",
    country: "Palestinian Territory",
    subcountry: "Gaza Strip",
    geonameid: 281148,
  },
  {
    name: "Al Burayj",
    country: "Palestinian Territory",
    subcountry: "Gaza Strip",
    geonameid: 281161,
  },
  {
    name: "‘Abasān al Kabīrah",
    country: "Palestinian Territory",
    subcountry: "Gaza Strip",
    geonameid: 281165,
  },
  {
    name: "Yaţţā",
    country: "Palestinian Territory",
    subcountry: "West Bank",
    geonameid: 281292,
  },
  {
    name: "Ţūlkarm",
    country: "Palestinian Territory",
    subcountry: "West Bank",
    geonameid: 281577,
  },
  {
    name: "Ţūbās",
    country: "Palestinian Territory",
    subcountry: "West Bank",
    geonameid: 281581,
  },
  {
    name: "Surif City",
    country: "Palestinian Territory",
    subcountry: "West Bank",
    geonameid: 281715,
  },
  {
    name: "Sa‘īr",
    country: "Palestinian Territory",
    subcountry: "West Bank",
    geonameid: 281793,
  },
  {
    name: "Ramallah",
    country: "Palestinian Territory",
    subcountry: "West Bank",
    geonameid: 282239,
  },
  {
    name: "Qalqīlyah",
    country: "Palestinian Territory",
    subcountry: "West Bank",
    geonameid: 282457,
  },
  {
    name: "Qabāţīyah",
    country: "Palestinian Territory",
    subcountry: "West Bank",
    geonameid: 282476,
  },
  {
    name: "Nablus",
    country: "Palestinian Territory",
    subcountry: "West Bank",
    geonameid: 282615,
  },
  {
    name: "Ma‘ale Adummim",
    country: "Palestinian Territory",
    subcountry: "West Bank",
    geonameid: 282993,
  },
  {
    name: "Janīn",
    country: "Palestinian Territory",
    subcountry: "West Bank",
    geonameid: 283506,
  },
  {
    name: "Idhnā",
    country: "Palestinian Territory",
    subcountry: "West Bank",
    geonameid: 283621,
  },
  {
    name: "Ḩalḩūl",
    country: "Palestinian Territory",
    subcountry: "West Bank",
    geonameid: 283806,
  },
  {
    name: "Dūrā",
    country: "Palestinian Territory",
    subcountry: "West Bank",
    geonameid: 284011,
  },
  {
    name: "Bethlehem",
    country: "Palestinian Territory",
    subcountry: "West Bank",
    geonameid: 284315,
  },
  {
    name: "Bayt Jālā",
    country: "Palestinian Territory",
    subcountry: "West Bank",
    geonameid: 284324,
  },
  {
    name: "Battir",
    country: "Palestinian Territory",
    subcountry: "West Bank",
    geonameid: 284375,
  },
  {
    name: "Banī Na‘īm",
    country: "Palestinian Territory",
    subcountry: "West Bank",
    geonameid: 284431,
  },
  {
    name: "Balāţah",
    country: "Palestinian Territory",
    subcountry: "West Bank",
    geonameid: 284446,
  },
  {
    name: "Az̧ Z̧āhirīyah",
    country: "Palestinian Territory",
    subcountry: "West Bank",
    geonameid: 284486,
  },
  {
    name: "‘Aţārūt",
    country: "Palestinian Territory",
    subcountry: "West Bank",
    geonameid: 284572,
  },
  {
    name: "As Samū‘",
    country: "Palestinian Territory",
    subcountry: "West Bank",
    geonameid: 284583,
  },
  {
    name: "Ar Rām wa Ḑāḩiyat al Barīd",
    country: "Palestinian Territory",
    subcountry: "West Bank",
    geonameid: 284890,
  },
  {
    name: "Jericho",
    country: "Palestinian Territory",
    subcountry: "West Bank",
    geonameid: 284899,
  },
  {
    name: "Al Yāmūn",
    country: "Palestinian Territory",
    subcountry: "West Bank",
    geonameid: 284999,
  },
  {
    name: "Hebron",
    country: "Palestinian Territory",
    subcountry: "West Bank",
    geonameid: 285066,
  },
  {
    name: "Al Bīrah",
    country: "Palestinian Territory",
    subcountry: "West Bank",
    geonameid: 285108,
  },
  {
    name: "Al ‘Ayzarīyah",
    country: "Palestinian Territory",
    subcountry: "West Bank",
    geonameid: 285111,
  },
  {
    name: "Old City",
    country: "Palestinian Territory",
    subcountry: "West Bank",
    geonameid: 6945291,
  },
  {
    name: "Al Qarārah",
    country: "Palestinian Territory",
    subcountry: "Gaza Strip",
    geonameid: 6967865,
  },
  {
    name: "Az Zuwāydah",
    country: "Palestinian Territory",
    subcountry: "Gaza Strip",
    geonameid: 6967990,
  },
  {
    name: "East Jerusalem",
    country: "Palestinian Territory",
    subcountry: "West Bank",
    geonameid: 7303419,
  },
  {
    name: "Vila Franca de Xira",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 2261639,
  },
  {
    name: "Vialonga",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 2261697,
  },
  {
    name: "Torres Vedras",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 2262581,
  },
  {
    name: "Torres Novas",
    country: "Portugal",
    subcountry: "Santarém",
    geonameid: 2262582,
  },
  {
    name: "Tomar",
    country: "Portugal",
    subcountry: "Santarém",
    geonameid: 2262644,
  },
  {
    name: "Tavira",
    country: "Portugal",
    subcountry: "Faro",
    geonameid: 2262744,
  },
  {
    name: "Sintra",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 2262912,
  },
  {
    name: "Sesimbra",
    country: "Portugal",
    subcountry: "Setúbal",
    geonameid: 2262957,
  },
  {
    name: "Setúbal",
    country: "Portugal",
    subcountry: "Setúbal",
    geonameid: 2262963,
  },
  {
    name: "São Martinho",
    country: "Portugal",
    subcountry: "Madeira",
    geonameid: 2263284,
  },
  {
    name: "São João da Talha",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 2263326,
  },
  {
    name: "São Domingos de Rana",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 2263352,
  },
  {
    name: "Santarém",
    country: "Portugal",
    subcountry: "Santarém",
    geonameid: 2263480,
  },
  {
    name: "Santa Iria da Azóia",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 2263523,
  },
  {
    name: "Sacavém",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 2263667,
  },
  {
    name: "Rio de Mouro",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 2263827,
  },
  {
    name: "Ramada",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 2264087,
  },
  {
    name: "Queluz",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 2264268,
  },
  {
    name: "Quarteira",
    country: "Portugal",
    subcountry: "Faro",
    geonameid: 2264299,
  },
  {
    name: "Póvoa de Santa Iria",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 2264359,
  },
  {
    name: "Portimão",
    country: "Portugal",
    subcountry: "Faro",
    geonameid: 2264456,
  },
  {
    name: "Portalegre",
    country: "Portugal",
    subcountry: "Portalegre",
    geonameid: 2264508,
  },
  {
    name: "Pontinha",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 2264526,
  },
  {
    name: "Pombal",
    country: "Portugal",
    subcountry: "Leiria",
    geonameid: 2264575,
  },
  {
    name: "Pinhal Novo",
    country: "Portugal",
    subcountry: "Setúbal",
    geonameid: 2264718,
  },
  {
    name: "Piedade",
    country: "Portugal",
    subcountry: "Setúbal",
    geonameid: 2264736,
  },
  {
    name: "Peniche",
    country: "Portugal",
    subcountry: "Leiria",
    geonameid: 2264923,
  },
  {
    name: "Parede",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 2265169,
  },
  {
    name: "Palmela",
    country: "Portugal",
    subcountry: "Setúbal",
    geonameid: 2265223,
  },
  {
    name: "Paço de Arcos",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 2265326,
  },
  {
    name: "Olivais",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 2265432,
  },
  {
    name: "Olhão",
    country: "Portugal",
    subcountry: "Faro",
    geonameid: 2265447,
  },
  {
    name: "Oeiras",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 2265464,
  },
  {
    name: "Odivelas",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 2265467,
  },
  {
    name: "Moscavide e Portela",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 2265726,
  },
  {
    name: "Montijo",
    country: "Portugal",
    subcountry: "Setúbal",
    geonameid: 2265788,
  },
  {
    name: "Monte Estoril",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 2265927,
  },
  {
    name: "Monsanto",
    country: "Portugal",
    subcountry: "Santarém",
    geonameid: 2266249,
  },
  {
    name: "Moita",
    country: "Portugal",
    subcountry: "Setúbal",
    geonameid: 2266319,
  },
  {
    name: "Massamá",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 2266621,
  },
  {
    name: "Marinha Grande",
    country: "Portugal",
    subcountry: "Leiria",
    geonameid: 2266703,
  },
  {
    name: "Loures",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 2266977,
  },
  {
    name: "Loulé",
    country: "Portugal",
    subcountry: "Faro",
    geonameid: 2266988,
  },
  {
    name: "Lisbon",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 2267057,
  },
  {
    name: "Linda-a-Velha",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 2267067,
  },
  {
    name: "Leiria",
    country: "Portugal",
    subcountry: "Leiria",
    geonameid: 2267095,
  },
  {
    name: "Lavradio",
    country: "Portugal",
    subcountry: "Setúbal",
    geonameid: 2267112,
  },
  {
    name: "Laranjeiro",
    country: "Portugal",
    subcountry: "Faro",
    geonameid: 2267131,
  },
  {
    name: "Laranjeiro",
    country: "Portugal",
    subcountry: "Setúbal",
    geonameid: 2267141,
  },
  {
    name: "Lagos",
    country: "Portugal",
    subcountry: "Faro",
    geonameid: 2267226,
  },
  {
    name: "Funchal",
    country: "Portugal",
    subcountry: "Madeira",
    geonameid: 2267827,
  },
  {
    name: "Faro",
    country: "Portugal",
    subcountry: "Faro",
    geonameid: 2268339,
  },
  {
    name: "Évora",
    country: "Portugal",
    subcountry: "Évora",
    geonameid: 2268406,
  },
  {
    name: "Estoril",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 2268436,
  },
  {
    name: "Entroncamento",
    country: "Portugal",
    subcountry: "Santarém",
    geonameid: 2268575,
  },
  {
    name: "Corroios",
    country: "Portugal",
    subcountry: "Setúbal",
    geonameid: 2269041,
  },
  {
    name: "Charneca de Caparica",
    country: "Portugal",
    subcountry: "Setúbal",
    geonameid: 2269282,
  },
  {
    name: "Castelo Branco",
    country: "Portugal",
    subcountry: "Castelo Branco",
    geonameid: 2269514,
  },
  {
    name: "Cascais",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 2269594,
  },
  {
    name: "Carnaxide",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 2270157,
  },
  {
    name: "Carcavelos",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 2270184,
  },
  {
    name: "Caparica",
    country: "Portugal",
    subcountry: "Setúbal",
    geonameid: 2270229,
  },
  {
    name: "Caniço",
    country: "Portugal",
    subcountry: "Madeira",
    geonameid: 2270258,
  },
  {
    name: "Camarate",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 2270377,
  },
  {
    name: "Câmara de Lobos",
    country: "Portugal",
    subcountry: "Madeira",
    geonameid: 2270380,
  },
  {
    name: "Caldas da Rainha",
    country: "Portugal",
    subcountry: "Leiria",
    geonameid: 2270437,
  },
  {
    name: "Cacém",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 2270503,
  },
  {
    name: "Benfica",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 2270962,
  },
  {
    name: "Belas",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 2270981,
  },
  {
    name: "Beja",
    country: "Portugal",
    subcountry: "Beja",
    geonameid: 2270985,
  },
  {
    name: "Barreiro",
    country: "Portugal",
    subcountry: "Setúbal",
    geonameid: 2271071,
  },
  {
    name: "Arrentela",
    country: "Portugal",
    subcountry: "Setúbal",
    geonameid: 2271473,
  },
  {
    name: "Amora",
    country: "Portugal",
    subcountry: "Setúbal",
    geonameid: 2271680,
  },
  {
    name: "Amadora",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 2271772,
  },
  {
    name: "Almada",
    country: "Portugal",
    subcountry: "Setúbal",
    geonameid: 2271961,
  },
  {
    name: "Algueirão",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 2271977,
  },
  {
    name: "Algés",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 2271985,
  },
  {
    name: "Alcobaça",
    country: "Portugal",
    subcountry: "Leiria",
    geonameid: 2272147,
  },
  {
    name: "Alcabideche",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 2272215,
  },
  {
    name: "Albufeira",
    country: "Portugal",
    subcountry: "Faro",
    geonameid: 2272222,
  },
  {
    name: "Viseu",
    country: "Portugal",
    subcountry: "Viseu",
    geonameid: 2732265,
  },
  {
    name: "Vila Real",
    country: "Portugal",
    subcountry: "Vila Real",
    geonameid: 2732438,
  },
  {
    name: "Vilar de Andorinho",
    country: "Portugal",
    subcountry: "Porto",
    geonameid: 2732475,
  },
  {
    name: "Vila Nova de Gaia",
    country: "Portugal",
    subcountry: "Porto",
    geonameid: 2732544,
  },
  {
    name: "Vila do Conde",
    country: "Portugal",
    subcountry: "Porto",
    geonameid: 2732649,
  },
  {
    name: "Viana do Castelo",
    country: "Portugal",
    subcountry: "Viana do Castelo",
    geonameid: 2732773,
  },
  {
    name: "Valongo",
    country: "Portugal",
    subcountry: "Porto",
    geonameid: 2732978,
  },
  {
    name: "Trofa",
    country: "Portugal",
    subcountry: "Porto",
    geonameid: 2733352,
  },
  {
    name: "Sequeira",
    country: "Portugal",
    subcountry: "Guarda",
    geonameid: 2734106,
  },
  {
    name: "Senhora da Hora",
    country: "Portugal",
    subcountry: "Porto",
    geonameid: 2734140,
  },
  {
    name: "São Pedro da Cova",
    country: "Portugal",
    subcountry: "Porto",
    geonameid: 2734363,
  },
  {
    name: "São Mamede de Infesta",
    country: "Portugal",
    subcountry: "Porto",
    geonameid: 2734434,
  },
  {
    name: "São João da Madeira",
    country: "Portugal",
    subcountry: "Aveiro",
    geonameid: 2734484,
  },
  {
    name: "Santo António dos Olivais",
    country: "Portugal",
    subcountry: "Coimbra",
    geonameid: 2734585,
  },
  {
    name: "Rio Tinto",
    country: "Portugal",
    subcountry: "Porto",
    geonameid: 2735083,
  },
  {
    name: "Póvoa de Varzim",
    country: "Portugal",
    subcountry: "Porto",
    geonameid: 2735787,
  },
  {
    name: "Porto",
    country: "Portugal",
    subcountry: "Porto",
    geonameid: 2735943,
  },
  {
    name: "Ponte de Lima",
    country: "Portugal",
    subcountry: "Viana do Castelo",
    geonameid: 2736041,
  },
  {
    name: "Pedroso",
    country: "Portugal",
    subcountry: "Porto",
    geonameid: 2736521,
  },
  {
    name: "Paredes",
    country: "Portugal",
    subcountry: "Porto",
    geonameid: 2736657,
  },
  {
    name: "Ovar",
    country: "Portugal",
    subcountry: "Aveiro",
    geonameid: 2736930,
  },
  {
    name: "Oliveira do Douro",
    country: "Portugal",
    subcountry: "Porto",
    geonameid: 2737039,
  },
  {
    name: "Monção",
    country: "Portugal",
    subcountry: "Viana do Castelo",
    geonameid: 2737523,
  },
  {
    name: "Matosinhos",
    country: "Portugal",
    subcountry: "Porto",
    geonameid: 2737824,
  },
  {
    name: "Maia",
    country: "Portugal",
    subcountry: "Porto",
    geonameid: 2738014,
  },
  {
    name: "Leça do Bailio",
    country: "Portugal",
    subcountry: "Porto",
    geonameid: 2738347,
  },
  {
    name: "Leça da Palmeira",
    country: "Portugal",
    subcountry: "Porto",
    geonameid: 2738348,
  },
  {
    name: "Ílhavo",
    country: "Portugal",
    subcountry: "Aveiro",
    geonameid: 2738707,
  },
  {
    name: "Guimarães",
    country: "Portugal",
    subcountry: "Braga",
    geonameid: 2738752,
  },
  {
    name: "Guarda",
    country: "Portugal",
    subcountry: "Guarda",
    geonameid: 2738785,
  },
  {
    name: "Gondomar",
    country: "Portugal",
    subcountry: "Porto",
    geonameid: 2738925,
  },
  {
    name: "Figueira da Foz",
    country: "Portugal",
    subcountry: "Coimbra",
    geonameid: 2739590,
  },
  {
    name: "Felgueiras",
    country: "Portugal",
    subcountry: "Porto",
    geonameid: 2739693,
  },
  {
    name: "Feira",
    country: "Portugal",
    subcountry: "Aveiro",
    geonameid: 2739723,
  },
  {
    name: "Fânzeres",
    country: "Portugal",
    subcountry: "Porto",
    geonameid: 2739756,
  },
  {
    name: "Fafe",
    country: "Portugal",
    subcountry: "Braga",
    geonameid: 2739788,
  },
  {
    name: "Esposende",
    country: "Portugal",
    subcountry: "Braga",
    geonameid: 2739848,
  },
  {
    name: "Espinho",
    country: "Portugal",
    subcountry: "Aveiro",
    geonameid: 2739868,
  },
  {
    name: "Ermesinde",
    country: "Portugal",
    subcountry: "Porto",
    geonameid: 2739997,
  },
  {
    name: "Custoias",
    country: "Portugal",
    subcountry: "Guarda",
    geonameid: 2740174,
  },
  {
    name: "Covilhã",
    country: "Portugal",
    subcountry: "Castelo Branco",
    geonameid: 2740313,
  },
  {
    name: "Condeixa-a-Nova",
    country: "Portugal",
    subcountry: "Coimbra",
    geonameid: 2740593,
  },
  {
    name: "Coimbra",
    country: "Portugal",
    subcountry: "Coimbra",
    geonameid: 2740637,
  },
  {
    name: "Chaves",
    country: "Portugal",
    subcountry: "Vila Real",
    geonameid: 2740761,
  },
  {
    name: "Canidelo",
    country: "Portugal",
    subcountry: "Porto",
    geonameid: 2741551,
  },
  {
    name: "Cabeceiras de Basto",
    country: "Portugal",
    subcountry: "Braga",
    geonameid: 2741865,
  },
  {
    name: "Bragança",
    country: "Portugal",
    subcountry: "Bragança",
    geonameid: 2742027,
  },
  {
    name: "Braga",
    country: "Portugal",
    subcountry: "Braga",
    geonameid: 2742032,
  },
  {
    name: "Bougado",
    country: "Portugal",
    subcountry: "Porto",
    geonameid: 2742051,
  },
  {
    name: "Barcelos",
    country: "Portugal",
    subcountry: "Braga",
    geonameid: 2742416,
  },
  {
    name: "Baião",
    country: "Portugal",
    subcountry: "Porto",
    geonameid: 2742504,
  },
  {
    name: "Baguim do Monte",
    country: "Portugal",
    subcountry: "Porto",
    geonameid: 2742506,
  },
  {
    name: "Aveiro",
    country: "Portugal",
    subcountry: "Aveiro",
    geonameid: 2742611,
  },
  {
    name: "Arcos de Valdevez",
    country: "Portugal",
    subcountry: "Viana do Castelo",
    geonameid: 2742804,
  },
  {
    name: "Alfena",
    country: "Portugal",
    subcountry: "Porto",
    geonameid: 2743095,
  },
  {
    name: "Águas Santas",
    country: "Portugal",
    subcountry: "Porto",
    geonameid: 2743304,
  },
  {
    name: "Quinta Do Conde",
    country: "Portugal",
    subcountry: "Setúbal",
    geonameid: 6559488,
  },
  {
    name: "Alfragide",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 6930153,
  },
  {
    name: "Alvalade",
    country: "Portugal",
    subcountry: "Lisbon",
    geonameid: 6930162,
  },
  {
    name: "Ponta Delgada",
    country: "Portugal",
    subcountry: "Azores",
    geonameid: 6941014,
  },
  {
    name: "Azeitão",
    country: "Portugal",
    subcountry: "Setúbal",
    geonameid: 11808241,
  },
  {
    name: "Ngerulmud",
    country: "Palau",
    subcountry: "Melekeok",
    geonameid: 8063361,
  },
  {
    name: "Villarrica",
    country: "Paraguay",
    subcountry: "Guairá",
    geonameid: 3436714,
  },
  {
    name: "Villa Hayes",
    country: "Paraguay",
    subcountry: "Presidente Hayes",
    geonameid: 3436725,
  },
  {
    name: "Villa Elisa",
    country: "Paraguay",
    subcountry: "Central",
    geonameid: 3436728,
  },
  {
    name: "San Lorenzo",
    country: "Paraguay",
    subcountry: "Central",
    geonameid: 3437056,
  },
  {
    name: "San Juan Bautista",
    country: "Paraguay",
    subcountry: "Misiones",
    geonameid: 3437063,
  },
  {
    name: "San Antonio",
    country: "Paraguay",
    subcountry: "Central",
    geonameid: 3437127,
  },
  {
    name: "Presidente Franco",
    country: "Paraguay",
    subcountry: "Alto Paraná",
    geonameid: 3437444,
  },
  {
    name: "Pilar",
    country: "Paraguay",
    subcountry: "Ñeembucú",
    geonameid: 3437526,
  },
  {
    name: "Pedro Juan Caballero",
    country: "Paraguay",
    subcountry: "Amambay",
    geonameid: 3437547,
  },
  {
    name: "Nemby",
    country: "Paraguay",
    subcountry: "Central",
    geonameid: 3437665,
  },
  {
    name: "Limpio",
    country: "Paraguay",
    subcountry: "Central",
    geonameid: 3437842,
  },
  {
    name: "Lambaré",
    country: "Paraguay",
    subcountry: "Central",
    geonameid: 3437863,
  },
  {
    name: "Itauguá",
    country: "Paraguay",
    subcountry: "Central",
    geonameid: 3437918,
  },
  {
    name: "Itá",
    country: "Paraguay",
    subcountry: "Central",
    geonameid: 3437954,
  },
  {
    name: "Fernando de la Mora",
    country: "Paraguay",
    subcountry: "Central",
    geonameid: 3438115,
  },
  {
    name: "Encarnación",
    country: "Paraguay",
    subcountry: "Itapúa",
    geonameid: 3438735,
  },
  {
    name: "Coronel Oviedo",
    country: "Paraguay",
    subcountry: "Caaguazú",
    geonameid: 3438819,
  },
  {
    name: "Concepción",
    country: "Paraguay",
    subcountry: "Concepción",
    geonameid: 3438834,
  },
  {
    name: "Mariano Roque Alonso",
    country: "Paraguay",
    subcountry: "Central",
    geonameid: 3438995,
  },
  {
    name: "Ciudad del Este",
    country: "Paraguay",
    subcountry: "Alto Paraná",
    geonameid: 3439101,
  },
  {
    name: "Capiatá",
    country: "Paraguay",
    subcountry: "Central",
    geonameid: 3439214,
  },
  {
    name: "Caazapá",
    country: "Paraguay",
    subcountry: "Caazapá",
    geonameid: 3439297,
  },
  {
    name: "Caaguazú",
    country: "Paraguay",
    subcountry: "Caaguazú",
    geonameid: 3439317,
  },
  {
    name: "Caacupé",
    country: "Paraguay",
    subcountry: "Cordillera",
    geonameid: 3439320,
  },
  {
    name: "Asunción",
    country: "Paraguay",
    subcountry: "Asunción",
    geonameid: 3439389,
  },
  {
    name: "Filadelfia",
    country: "Paraguay",
    subcountry: "Boquerón",
    geonameid: 3867291,
  },
  {
    name: "Umm Şalāl Muḩammad",
    country: "Qatar",
    subcountry: "Baladīyat Umm Şalāl",
    geonameid: 289523,
  },
  {
    name: "Ar Rayyān",
    country: "Qatar",
    subcountry: "Baladīyat ar Rayyān",
    geonameid: 289888,
  },
  {
    name: "Al Wakrah",
    country: "Qatar",
    subcountry: "Al Wakrah",
    geonameid: 289915,
  },
  {
    name: "Al Khawr",
    country: "Qatar",
    subcountry: "Al Khor",
    geonameid: 289962,
  },
  {
    name: "Doha",
    country: "Qatar",
    subcountry: "Baladīyat ad Dawḩah",
    geonameid: 290030,
  },
  {
    name: "Saint-Pierre",
    country: "Reunion",
    subcountry: "Réunion",
    geonameid: 935214,
  },
  {
    name: "Saint-Paul",
    country: "Reunion",
    subcountry: "Réunion",
    geonameid: 935221,
  },
  {
    name: "Saint-Louis",
    country: "Reunion",
    subcountry: "Réunion",
    geonameid: 935223,
  },
  {
    name: "Saint-Leu",
    country: "Reunion",
    subcountry: "Réunion",
    geonameid: 935225,
  },
  {
    name: "Saint-Joseph",
    country: "Reunion",
    subcountry: "Réunion",
    geonameid: 935227,
  },
  {
    name: "Sainte-Suzanne",
    country: "Reunion",
    subcountry: "Réunion",
    geonameid: 935248,
  },
  {
    name: "Sainte-Marie",
    country: "Reunion",
    subcountry: "Réunion",
    geonameid: 935255,
  },
  {
    name: "Saint-Denis",
    country: "Reunion",
    subcountry: "Réunion",
    geonameid: 935264,
  },
  {
    name: "Saint-Benoît",
    country: "Reunion",
    subcountry: "Réunion",
    geonameid: 935267,
  },
  {
    name: "Saint-André",
    country: "Reunion",
    subcountry: "Réunion",
    geonameid: 935268,
  },
  {
    name: "Le Tampon",
    country: "Reunion",
    subcountry: "Réunion",
    geonameid: 935582,
  },
  {
    name: "Le Port",
    country: "Reunion",
    subcountry: "Réunion",
    geonameid: 935616,
  },
  {
    name: "La Possession",
    country: "Reunion",
    subcountry: "Réunion",
    geonameid: 935691,
  },
  {
    name: "Piton Saint-Leu",
    country: "Reunion",
    subcountry: "Réunion",
    geonameid: 7932385,
  },
  {
    name: "Zimnicea",
    country: "Romania",
    subcountry: "Teleorman",
    geonameid: 662187,
  },
  {
    name: "Zărnești",
    country: "Romania",
    subcountry: "Brașov",
    geonameid: 662284,
  },
  {
    name: "Zalău",
    country: "Romania",
    subcountry: "Sălaj",
    geonameid: 662334,
  },
  {
    name: "Vulcan",
    country: "Romania",
    subcountry: "Hunedoara",
    geonameid: 662432,
  },
  {
    name: "Voluntari",
    country: "Romania",
    subcountry: "Ilfov",
    geonameid: 662476,
  },
  {
    name: "Vişeu de Sus",
    country: "Romania",
    subcountry: "Maramureş",
    geonameid: 662699,
  },
  {
    name: "Vatra Dornei",
    country: "Romania",
    subcountry: "Suceava",
    geonameid: 663100,
  },
  {
    name: "Vaslui",
    country: "Romania",
    subcountry: "Vaslui",
    geonameid: 663118,
  },
  {
    name: "Urziceni",
    country: "Romania",
    subcountry: "Ialomița",
    geonameid: 664074,
  },
  {
    name: "Turnu Măgurele",
    country: "Romania",
    subcountry: "Teleorman",
    geonameid: 664437,
  },
  {
    name: "Turda",
    country: "Romania",
    subcountry: "Cluj",
    geonameid: 664460,
  },
  {
    name: "Tulcea",
    country: "Romania",
    subcountry: "Tulcea",
    geonameid: 664518,
  },
  {
    name: "Târnăveni",
    country: "Romania",
    subcountry: "Mureș",
    geonameid: 664963,
  },
  {
    name: "Târgu Secuiesc",
    country: "Romania",
    subcountry: "Covasna",
    geonameid: 665000,
  },
  {
    name: "Târgu Neamţ",
    country: "Romania",
    subcountry: "Neamț",
    geonameid: 665003,
  },
  {
    name: "Târgu-Mureş",
    country: "Romania",
    subcountry: "Mureș",
    geonameid: 665004,
  },
  {
    name: "Târgu Jiu",
    country: "Romania",
    subcountry: "Gorj",
    geonameid: 665010,
  },
  {
    name: "Târgovişte",
    country: "Romania",
    subcountry: "Dâmbovița",
    geonameid: 665024,
  },
  {
    name: "Timişoara",
    country: "Romania",
    subcountry: "Timiș",
    geonameid: 665087,
  },
  {
    name: "Tecuci",
    country: "Romania",
    subcountry: "Galați",
    geonameid: 665355,
  },
  {
    name: "Suceava",
    country: "Romania",
    subcountry: "Suceava",
    geonameid: 665850,
  },
  {
    name: "Slatina",
    country: "Romania",
    subcountry: "Olt",
    geonameid: 666767,
  },
  {
    name: "Şimleu Silvaniei",
    country: "Romania",
    subcountry: "Sălaj",
    geonameid: 667101,
  },
  {
    name: "Sighetu Marmaţiei",
    country: "Romania",
    subcountry: "Maramureş",
    geonameid: 667227,
  },
  {
    name: "Sibiu",
    country: "Romania",
    subcountry: "Sibiu",
    geonameid: 667268,
  },
  {
    name: "Sfântu Gheorghe",
    country: "Romania",
    subcountry: "Covasna",
    geonameid: 667303,
  },
  {
    name: "Sebeş",
    country: "Romania",
    subcountry: "Alba",
    geonameid: 667526,
  },
  {
    name: "Satu Mare",
    country: "Romania",
    subcountry: "Satu Mare",
    geonameid: 667873,
  },
  {
    name: "Salonta",
    country: "Romania",
    subcountry: "Bihor",
    geonameid: 668129,
  },
  {
    name: "Săcele",
    country: "Romania",
    subcountry: "Brașov",
    geonameid: 668314,
  },
  {
    name: "Roșiorii de Vede",
    country: "Romania",
    subcountry: "Teleorman",
    geonameid: 668605,
  },
  {
    name: "Roman",
    country: "Romania",
    subcountry: "Neamț",
    geonameid: 668732,
  },
  {
    name: "Râşnov",
    country: "Romania",
    subcountry: "Brașov",
    geonameid: 668828,
  },
  {
    name: "Râmnicu Vâlcea",
    country: "Romania",
    subcountry: "Vâlcea",
    geonameid: 668872,
  },
  {
    name: "Râmnicu Sărat",
    country: "Romania",
    subcountry: "Buzău",
    geonameid: 668873,
  },
  {
    name: "Reşiţa",
    country: "Romania",
    subcountry: "Caraș-Severin",
    geonameid: 668954,
  },
  {
    name: "Reghin-Sat",
    country: "Romania",
    subcountry: "Mureș",
    geonameid: 668995,
  },
  {
    name: "Rădăuți",
    country: "Romania",
    subcountry: "Suceava",
    geonameid: 669289,
  },
  {
    name: "Popeşti-Leordeni",
    country: "Romania",
    subcountry: "Ilfov",
    geonameid: 669870,
  },
  {
    name: "Ploieşti",
    country: "Romania",
    subcountry: "Prahova",
    geonameid: 670474,
  },
  {
    name: "Piteşti",
    country: "Romania",
    subcountry: "Arges",
    geonameid: 670609,
  },
  {
    name: "Piatra Neamţ",
    country: "Romania",
    subcountry: "Neamț",
    geonameid: 670889,
  },
  {
    name: "Petroşani",
    country: "Romania",
    subcountry: "Hunedoara",
    geonameid: 670938,
  },
  {
    name: "Petrila",
    country: "Romania",
    subcountry: "Hunedoara",
    geonameid: 670969,
  },
  {
    name: "Pantelimon",
    country: "Romania",
    subcountry: "Ilfov",
    geonameid: 671382,
  },
  {
    name: "Orăştie",
    country: "Romania",
    subcountry: "Hunedoara",
    geonameid: 671757,
  },
  {
    name: "Oradea",
    country: "Romania",
    subcountry: "Bihor",
    geonameid: 671768,
  },
  {
    name: "Olteniţa",
    country: "Romania",
    subcountry: "Călărași",
    geonameid: 671832,
  },
  {
    name: "Odorheiu Secuiesc",
    country: "Romania",
    subcountry: "Harghita",
    geonameid: 671964,
  },
  {
    name: "Ocna Mureş",
    country: "Romania",
    subcountry: "Alba",
    geonameid: 672024,
  },
  {
    name: "Năvodari",
    country: "Romania",
    subcountry: "Constanța",
    geonameid: 672486,
  },
  {
    name: "Motru",
    country: "Romania",
    subcountry: "Gorj",
    geonameid: 672757,
  },
  {
    name: "Moreni",
    country: "Romania",
    subcountry: "Dâmbovița",
    geonameid: 672862,
  },
  {
    name: "Moineşti",
    country: "Romania",
    subcountry: "Bacău",
    geonameid: 672926,
  },
  {
    name: "Mizil",
    country: "Romania",
    subcountry: "Prahova",
    geonameid: 673033,
  },
  {
    name: "Miercurea-Ciuc",
    country: "Romania",
    subcountry: "Harghita",
    geonameid: 673441,
  },
  {
    name: "Mediaş",
    country: "Romania",
    subcountry: "Sibiu",
    geonameid: 673634,
  },
  {
    name: "Medgidia",
    country: "Romania",
    subcountry: "Constanța",
    geonameid: 673636,
  },
  {
    name: "Mangalia",
    country: "Romania",
    subcountry: "Constanța",
    geonameid: 673921,
  },
  {
    name: "Lupeni",
    country: "Romania",
    subcountry: "Hunedoara",
    geonameid: 674295,
  },
  {
    name: "Lugoj",
    country: "Romania",
    subcountry: "Timiș",
    geonameid: 674531,
  },
  {
    name: "Luduş",
    country: "Romania",
    subcountry: "Mureș",
    geonameid: 674541,
  },
  {
    name: "Iaşi",
    country: "Romania",
    subcountry: "Iași",
    geonameid: 675810,
  },
  {
    name: "Huşi",
    country: "Romania",
    subcountry: "Vaslui",
    geonameid: 675892,
  },
  {
    name: "Hunedoara",
    country: "Romania",
    subcountry: "Hunedoara",
    geonameid: 675918,
  },
  {
    name: "Gura Humorului",
    country: "Romania",
    subcountry: "Suceava",
    geonameid: 676527,
  },
  {
    name: "Giurgiu",
    country: "Romania",
    subcountry: "Giurgiu",
    geonameid: 677106,
  },
  {
    name: "Gherla",
    country: "Romania",
    subcountry: "Cluj",
    geonameid: 677429,
  },
  {
    name: "Gheorgheni",
    country: "Romania",
    subcountry: "Harghita",
    geonameid: 677458,
  },
  {
    name: "Galaţi",
    country: "Romania",
    subcountry: "Galați",
    geonameid: 677697,
  },
  {
    name: "Găeşti",
    country: "Romania",
    subcountry: "Dâmbovița",
    geonameid: 677742,
  },
  {
    name: "Focșani",
    country: "Romania",
    subcountry: "Vrancea",
    geonameid: 678015,
  },
  {
    name: "Filiaşi",
    country: "Romania",
    subcountry: "Dolj",
    geonameid: 678261,
  },
  {
    name: "Fetești-Gară",
    country: "Romania",
    subcountry: "Ialomița",
    geonameid: 678301,
  },
  {
    name: "Feteşti",
    country: "Romania",
    subcountry: "Ialomița",
    geonameid: 678306,
  },
  {
    name: "Fălticeni",
    country: "Romania",
    subcountry: "Suceava",
    geonameid: 678459,
  },
  {
    name: "Făgăraș",
    country: "Romania",
    subcountry: "Brașov",
    geonameid: 678499,
  },
  {
    name: "Drobeta-Turnu Severin",
    country: "Romania",
    subcountry: "Mehedinți",
    geonameid: 678817,
  },
  {
    name: "Drăgăşani",
    country: "Romania",
    subcountry: "Vâlcea",
    geonameid: 678978,
  },
  {
    name: "Dorohoi",
    country: "Romania",
    subcountry: "Botoșani",
    geonameid: 679065,
  },
  {
    name: "Deva",
    country: "Romania",
    subcountry: "Hunedoara",
    geonameid: 679452,
  },
  {
    name: "Dej",
    country: "Romania",
    subcountry: "Cluj",
    geonameid: 679550,
  },
  {
    name: "Curtea de Argeş",
    country: "Romania",
    subcountry: "Arges",
    geonameid: 679907,
  },
  {
    name: "Cugir",
    country: "Romania",
    subcountry: "Alba",
    geonameid: 679995,
  },
  {
    name: "Craiova",
    country: "Romania",
    subcountry: "Dolj",
    geonameid: 680332,
  },
  {
    name: "Corabia",
    country: "Romania",
    subcountry: "Olt",
    geonameid: 680897,
  },
  {
    name: "Constanţa",
    country: "Romania",
    subcountry: "Constanța",
    geonameid: 680963,
  },
  {
    name: "Comăneşti",
    country: "Romania",
    subcountry: "Bacău",
    geonameid: 681017,
  },
  {
    name: "Codlea",
    country: "Romania",
    subcountry: "Brașov",
    geonameid: 681179,
  },
  {
    name: "Cluj-Napoca",
    country: "Romania",
    subcountry: "Cluj",
    geonameid: 681290,
  },
  {
    name: "Cisnădie",
    country: "Romania",
    subcountry: "Sibiu",
    geonameid: 681502,
  },
  {
    name: "Câmpulung Moldovenesc",
    country: "Romania",
    subcountry: "Suceava",
    geonameid: 681845,
  },
  {
    name: "Câmpina",
    country: "Romania",
    subcountry: "Prahova",
    geonameid: 681862,
  },
  {
    name: "Câmpia Turzii",
    country: "Romania",
    subcountry: "Cluj",
    geonameid: 681865,
  },
  {
    name: "Cernavodă",
    country: "Romania",
    subcountry: "Constanța",
    geonameid: 682321,
  },
  {
    name: "Carei",
    country: "Romania",
    subcountry: "Satu Mare",
    geonameid: 682685,
  },
  {
    name: "Caransebeş",
    country: "Romania",
    subcountry: "Caraș-Severin",
    geonameid: 682729,
  },
  {
    name: "Caracal",
    country: "Romania",
    subcountry: "Olt",
    geonameid: 682747,
  },
  {
    name: "Calafat",
    country: "Romania",
    subcountry: "Dolj",
    geonameid: 683034,
  },
  {
    name: "Buzău",
    country: "Romania",
    subcountry: "Buzău",
    geonameid: 683123,
  },
  {
    name: "Buhuşi",
    country: "Romania",
    subcountry: "Bacău",
    geonameid: 683365,
  },
  {
    name: "Buftea",
    country: "Romania",
    subcountry: "Ilfov",
    geonameid: 683394,
  },
  {
    name: "Bucharest",
    country: "Romania",
    subcountry: "București",
    geonameid: 683506,
  },
  {
    name: "Breaza",
    country: "Romania",
    subcountry: "Prahova",
    geonameid: 683760,
  },
  {
    name: "Braşov",
    country: "Romania",
    subcountry: "Brașov",
    geonameid: 683844,
  },
  {
    name: "Brăila",
    country: "Romania",
    subcountry: "Brăila",
    geonameid: 683902,
  },
  {
    name: "Brad",
    country: "Romania",
    subcountry: "Hunedoara",
    geonameid: 683974,
  },
  {
    name: "Botoşani",
    country: "Romania",
    subcountry: "Botoșani",
    geonameid: 684039,
  },
  {
    name: "Borşa",
    country: "Romania",
    subcountry: "Maramureş",
    geonameid: 684156,
  },
  {
    name: "Bocşa",
    country: "Romania",
    subcountry: "Caraș-Severin",
    geonameid: 684490,
  },
  {
    name: "Blaj",
    country: "Romania",
    subcountry: "Alba",
    geonameid: 684612,
  },
  {
    name: "Bistriţa",
    country: "Romania",
    subcountry: "Bistrița-Năsăud",
    geonameid: 684657,
  },
  {
    name: "Bârlad",
    country: "Romania",
    subcountry: "Vaslui",
    geonameid: 684802,
  },
  {
    name: "Balş",
    country: "Romania",
    subcountry: "Olt",
    geonameid: 685586,
  },
  {
    name: "Băileşti",
    country: "Romania",
    subcountry: "Dolj",
    geonameid: 685785,
  },
  {
    name: "Băicoi",
    country: "Romania",
    subcountry: "Prahova",
    geonameid: 685811,
  },
  {
    name: "Baia Sprie",
    country: "Romania",
    subcountry: "Maramureş",
    geonameid: 685823,
  },
  {
    name: "Baia Mare",
    country: "Romania",
    subcountry: "Maramureş",
    geonameid: 685826,
  },
  {
    name: "Bacău",
    country: "Romania",
    subcountry: "Bacău",
    geonameid: 685948,
  },
  {
    name: "Arad",
    country: "Romania",
    subcountry: "Arad",
    geonameid: 686254,
  },
  {
    name: "Alexandria",
    country: "Romania",
    subcountry: "Teleorman",
    geonameid: 686502,
  },
  {
    name: "Alba Iulia",
    country: "Romania",
    subcountry: "Alba",
    geonameid: 686578,
  },
  {
    name: "Aiud",
    country: "Romania",
    subcountry: "Alba",
    geonameid: 686590,
  },
  {
    name: "Adjud",
    country: "Romania",
    subcountry: "Vrancea",
    geonameid: 686669,
  },
  {
    name: "Paşcani",
    country: "Romania",
    subcountry: "Iași",
    geonameid: 6945426,
  },
  {
    name: "Mioveni",
    country: "Romania",
    subcountry: "Arges",
    geonameid: 7733099,
  },
  {
    name: "Sighișoara",
    country: "Romania",
    subcountry: "Mureș",
    geonameid: 8436351,
  },
  {
    name: "Slobozia",
    country: "Romania",
    subcountry: "Ialomița",
    geonameid: 8581467,
  },
  {
    name: "Sector 1",
    country: "Romania",
    subcountry: "București",
    geonameid: 11048317,
  },
  {
    name: "Sector 2",
    country: "Romania",
    subcountry: "București",
    geonameid: 11048318,
  },
  {
    name: "Sector 3",
    country: "Romania",
    subcountry: "București",
    geonameid: 11048319,
  },
  {
    name: "Sector 4",
    country: "Romania",
    subcountry: "București",
    geonameid: 11048320,
  },
  {
    name: "Sector 5",
    country: "Romania",
    subcountry: "București",
    geonameid: 11048322,
  },
  {
    name: "Sector 6",
    country: "Romania",
    subcountry: "București",
    geonameid: 11048323,
  },
  {
    name: "Zrenjanin",
    country: "Serbia",
    subcountry: "Vojvodina",
    geonameid: 783814,
  },
  {
    name: "Zemun",
    country: "Serbia",
    subcountry: "Central Serbia",
    geonameid: 783920,
  },
  {
    name: "Zaječar",
    country: "Serbia",
    subcountry: "Central Serbia",
    geonameid: 784024,
  },
  {
    name: "Vršac",
    country: "Serbia",
    subcountry: "Vojvodina",
    geonameid: 784136,
  },
  {
    name: "Vranje",
    country: "Serbia",
    subcountry: "Central Serbia",
    geonameid: 784227,
  },
  {
    name: "Trstenik",
    country: "Serbia",
    subcountry: "Central Serbia",
    geonameid: 784873,
  },
  {
    name: "Stara Pazova",
    country: "Serbia",
    subcountry: "Vojvodina",
    geonameid: 785559,
  },
  {
    name: "Sremčica",
    country: "Serbia",
    subcountry: "Central Serbia",
    geonameid: 785615,
  },
  {
    name: "Smederevska Palanka",
    country: "Serbia",
    subcountry: "Central Serbia",
    geonameid: 785753,
  },
  {
    name: "Smederevo",
    country: "Serbia",
    subcountry: "Central Serbia",
    geonameid: 785756,
  },
  {
    name: "Senta",
    country: "Serbia",
    subcountry: "Vojvodina",
    geonameid: 785965,
  },
  {
    name: "Prokuplje",
    country: "Serbia",
    subcountry: "Central Serbia",
    geonameid: 786690,
  },
  {
    name: "Požarevac",
    country: "Serbia",
    subcountry: "Central Serbia",
    geonameid: 786827,
  },
  {
    name: "Pirot",
    country: "Serbia",
    subcountry: "Central Serbia",
    geonameid: 787050,
  },
  {
    name: "Pančevo",
    country: "Serbia",
    subcountry: "Vojvodina",
    geonameid: 787237,
  },
  {
    name: "Obrenovac",
    country: "Serbia",
    subcountry: "Central Serbia",
    geonameid: 787516,
  },
  {
    name: "Novi Pazar",
    country: "Serbia",
    subcountry: "Central Serbia",
    geonameid: 787595,
  },
  {
    name: "Nova Pazova",
    country: "Serbia",
    subcountry: "Vojvodina",
    geonameid: 787615,
  },
  {
    name: "Niš",
    country: "Serbia",
    subcountry: "Central Serbia",
    geonameid: 787657,
  },
  {
    name: "Negotin",
    country: "Serbia",
    subcountry: "Central Serbia",
    geonameid: 787718,
  },
  {
    name: "Leskovac",
    country: "Serbia",
    subcountry: "Central Serbia",
    geonameid: 788709,
  },
  {
    name: "Lazarevac",
    country: "Serbia",
    subcountry: "Central Serbia",
    geonameid: 788771,
  },
  {
    name: "Kruševac",
    country: "Serbia",
    subcountry: "Central Serbia",
    geonameid: 788975,
  },
  {
    name: "Kraljevo",
    country: "Serbia",
    subcountry: "Central Serbia",
    geonameid: 789107,
  },
  {
    name: "Kragujevac",
    country: "Serbia",
    subcountry: "Central Serbia",
    geonameid: 789128,
  },
  {
    name: "Kikinda",
    country: "Serbia",
    subcountry: "Vojvodina",
    geonameid: 789518,
  },
  {
    name: "Jagodina",
    country: "Serbia",
    subcountry: "Central Serbia",
    geonameid: 789923,
  },
  {
    name: "Inđija",
    country: "Serbia",
    subcountry: "Vojvodina",
    geonameid: 790015,
  },
  {
    name: "Gornji Milanovac",
    country: "Serbia",
    subcountry: "Central Serbia",
    geonameid: 790367,
  },
  {
    name: "Ćuprija",
    country: "Serbia",
    subcountry: "Central Serbia",
    geonameid: 791678,
  },
  {
    name: "Čačak",
    country: "Serbia",
    subcountry: "Central Serbia",
    geonameid: 792078,
  },
  {
    name: "Bor",
    country: "Serbia",
    subcountry: "Central Serbia",
    geonameid: 792456,
  },
  {
    name: "Belgrade",
    country: "Serbia",
    subcountry: "Central Serbia",
    geonameid: 792680,
  },
  {
    name: "Bečej",
    country: "Serbia",
    subcountry: "Vojvodina",
    geonameid: 792814,
  },
  {
    name: "Aranđelovac",
    country: "Serbia",
    subcountry: "Central Serbia",
    geonameid: 793111,
  },
  {
    name: "Vrbas",
    country: "Serbia",
    subcountry: "Vojvodina",
    geonameid: 3187297,
  },
  {
    name: "Valjevo",
    country: "Serbia",
    subcountry: "Central Serbia",
    geonameid: 3188402,
  },
  {
    name: "Užice",
    country: "Serbia",
    subcountry: "Central Serbia",
    geonameid: 3188434,
  },
  {
    name: "Subotica",
    country: "Serbia",
    subcountry: "Vojvodina",
    geonameid: 3189595,
  },
  {
    name: "Sremska Mitrovica",
    country: "Serbia",
    subcountry: "Vojvodina",
    geonameid: 3190103,
  },
  {
    name: "Sombor",
    country: "Serbia",
    subcountry: "Vojvodina",
    geonameid: 3190342,
  },
  {
    name: "Šabac",
    country: "Serbia",
    subcountry: "Central Serbia",
    geonameid: 3191376,
  },
  {
    name: "Ruma",
    country: "Serbia",
    subcountry: "Vojvodina",
    geonameid: 3191429,
  },
  {
    name: "Novi Sad",
    country: "Serbia",
    subcountry: "Vojvodina",
    geonameid: 3194360,
  },
  {
    name: "Bačka Topola",
    country: "Serbia",
    subcountry: "Vojvodina",
    geonameid: 3204672,
  },
  {
    name: "Bačka Palanka",
    country: "Serbia",
    subcountry: "Vojvodina",
    geonameid: 3204674,
  },
  {
    name: "Apatin",
    country: "Serbia",
    subcountry: "Vojvodina",
    geonameid: 3204793,
  },
  {
    name: "Knjazevac",
    country: "Serbia",
    subcountry: "Central Serbia",
    geonameid: 6619277,
  },
  {
    name: "Udomlya",
    country: "Russia",
    subcountry: "Tver Oblast",
    geonameid: 452949,
  },
  {
    name: "Sosnovka",
    country: "Russia",
    subcountry: "St.-Petersburg",
    geonameid: 461698,
  },
  {
    name: "Sasovo",
    country: "Russia",
    subcountry: "Ryazan Oblast",
    geonameid: 461699,
  },
  {
    name: "Zyuzino",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 461740,
  },
  {
    name: "Zyablikovo",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 461835,
  },
  {
    name: "Zverevo",
    country: "Russia",
    subcountry: "Rostov",
    geonameid: 461910,
  },
  {
    name: "Zvenigorod",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 461920,
  },
  {
    name: "Zlatoust",
    country: "Russia",
    subcountry: "Chelyabinsk",
    geonameid: 462444,
  },
  {
    name: "Zimovniki",
    country: "Russia",
    subcountry: "Rostov",
    geonameid: 462522,
  },
  {
    name: "Zhulebino",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 462745,
  },
  {
    name: "Zhukovsky",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 462755,
  },
  {
    name: "Zhukovka",
    country: "Russia",
    subcountry: "Bryansk Oblast",
    geonameid: 462822,
  },
  {
    name: "Zhirnovsk",
    country: "Russia",
    subcountry: "Volgograd Oblast",
    geonameid: 462984,
  },
  {
    name: "Zhigulevsk",
    country: "Russia",
    subcountry: "Samara Oblast",
    geonameid: 463082,
  },
  {
    name: "Zherdevka",
    country: "Russia",
    subcountry: "Tambov Oblast",
    geonameid: 463217,
  },
  {
    name: "Zheleznovodsk",
    country: "Russia",
    subcountry: "Stavropol Kray",
    geonameid: 463340,
  },
  {
    name: "Zheleznogorsk",
    country: "Russia",
    subcountry: "Kursk Oblast",
    geonameid: 463343,
  },
  {
    name: "Zheleznodorozhnyy",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 463355,
  },
  {
    name: "Zernograd",
    country: "Russia",
    subcountry: "Rostov",
    geonameid: 463637,
  },
  {
    name: "Zelenokumsk",
    country: "Russia",
    subcountry: "Stavropol Kray",
    geonameid: 463824,
  },
  {
    name: "Zelenogradsk",
    country: "Russia",
    subcountry: "Kaliningrad Oblast",
    geonameid: 463828,
  },
  {
    name: "Zelenograd",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 463829,
  },
  {
    name: "Zelenodolsk",
    country: "Russia",
    subcountry: "Tatarstan Republic",
    geonameid: 463835,
  },
  {
    name: "Zelenchukskaya",
    country: "Russia",
    subcountry: "Karachayevo-Cherkesiya Republic",
    geonameid: 463885,
  },
  {
    name: "Zavolzh’ye",
    country: "Russia",
    subcountry: "Nizhny Novgorod Oblast",
    geonameid: 464101,
  },
  {
    name: "Zavety Il’icha",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 464176,
  },
  {
    name: "Zarechnyy",
    country: "Russia",
    subcountry: "Penza Oblast",
    geonameid: 464625,
  },
  {
    name: "Zaraysk",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 464687,
  },
  {
    name: "Zapolyarnyy",
    country: "Russia",
    subcountry: "Murmansk",
    geonameid: 464790,
  },
  {
    name: "Zamoskvorech’ye",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 465057,
  },
  {
    name: "Zainsk",
    country: "Russia",
    subcountry: "Tatarstan Republic",
    geonameid: 465543,
  },
  {
    name: "Yur’yev-Pol’skiy",
    country: "Russia",
    subcountry: "Vladimir Oblast",
    geonameid: 466215,
  },
  {
    name: "Yoshkar-Ola",
    country: "Russia",
    subcountry: "Mariy-El Republic",
    geonameid: 466806,
  },
  {
    name: "Yeysk",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 466885,
  },
  {
    name: "Yessentukskaya",
    country: "Russia",
    subcountry: "Stavropol Kray",
    geonameid: 466989,
  },
  {
    name: "Yessentuki",
    country: "Russia",
    subcountry: "Stavropol Kray",
    geonameid: 466990,
  },
  {
    name: "Yershov",
    country: "Russia",
    subcountry: "Saratov Oblast",
    geonameid: 467120,
  },
  {
    name: "Yemva",
    country: "Russia",
    subcountry: "Komi",
    geonameid: 467525,
  },
  {
    name: "Yelizavetinskaya",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 467854,
  },
  {
    name: "Yelets",
    country: "Russia",
    subcountry: "Lipetsk Oblast",
    geonameid: 467978,
  },
  {
    name: "Yelan’",
    country: "Russia",
    subcountry: "Volgograd Oblast",
    geonameid: 468063,
  },
  {
    name: "Yelabuga",
    country: "Russia",
    subcountry: "Tatarstan Republic",
    geonameid: 468082,
  },
  {
    name: "Yegor’yevsk",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 468250,
  },
  {
    name: "Yegorlykskaya",
    country: "Russia",
    subcountry: "Rostov",
    geonameid: 468307,
  },
  {
    name: "Yefremov",
    country: "Russia",
    subcountry: "Tula Oblast",
    geonameid: 468390,
  },
  {
    name: "Yasnyy",
    country: "Russia",
    subcountry: "Orenburg Oblast",
    geonameid: 468657,
  },
  {
    name: "Yasnogorsk",
    country: "Russia",
    subcountry: "Tula Oblast",
    geonameid: 468671,
  },
  {
    name: "Yasenevo",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 468809,
  },
  {
    name: "Yartsevo",
    country: "Russia",
    subcountry: "Smolensk Oblast",
    geonameid: 468866,
  },
  {
    name: "Yaroslavl",
    country: "Russia",
    subcountry: "Yaroslavl Oblast",
    geonameid: 468902,
  },
  {
    name: "Yaransk",
    country: "Russia",
    subcountry: "Kirov Oblast",
    geonameid: 469005,
  },
  {
    name: "Yanaul",
    country: "Russia",
    subcountry: "Bashkortostan Republic",
    geonameid: 469178,
  },
  {
    name: "Yagry",
    country: "Russia",
    subcountry: "Arkhangelskaya",
    geonameid: 469707,
  },
  {
    name: "Yablonovskiy",
    country: "Russia",
    subcountry: "Adygeya Republic",
    geonameid: 469844,
  },
  {
    name: "Vyshniy Volochëk",
    country: "Russia",
    subcountry: "Tver Oblast",
    geonameid: 470252,
  },
  {
    name: "Vyselki",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 470338,
  },
  {
    name: "Vyksa",
    country: "Russia",
    subcountry: "Nizhny Novgorod Oblast",
    geonameid: 470444,
  },
  {
    name: "Vykhino-Zhulebino",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 470451,
  },
  {
    name: "Vyborg",
    country: "Russia",
    subcountry: "Leningradskaya Oblast'",
    geonameid: 470546,
  },
  {
    name: "Vyazniki",
    country: "Russia",
    subcountry: "Vladimir Oblast",
    geonameid: 470666,
  },
  {
    name: "Vyaz’ma",
    country: "Russia",
    subcountry: "Smolensk Oblast",
    geonameid: 470676,
  },
  {
    name: "Vyatskiye Polyany",
    country: "Russia",
    subcountry: "Kirov Oblast",
    geonameid: 470734,
  },
  {
    name: "Vsevolozhsk",
    country: "Russia",
    subcountry: "Leningradskaya Oblast'",
    geonameid: 471101,
  },
  {
    name: "Votkinsk",
    country: "Russia",
    subcountry: "Udmurtiya Republic",
    geonameid: 471430,
  },
  {
    name: "Vostryakovo",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 471456,
  },
  {
    name: "Vostryakovo",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 471457,
  },
  {
    name: "Voskresensk",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 471656,
  },
  {
    name: "Voronezh",
    country: "Russia",
    subcountry: "Voronezh Oblast",
    geonameid: 472045,
  },
  {
    name: "Altuf’yevskiy",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 472072,
  },
  {
    name: "Vorob’yovo",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 472079,
  },
  {
    name: "Volzhsky",
    country: "Russia",
    subcountry: "Volgograd Oblast",
    geonameid: 472231,
  },
  {
    name: "Volzhsk",
    country: "Russia",
    subcountry: "Mariy-El Republic",
    geonameid: 472234,
  },
  {
    name: "Vol’sk",
    country: "Russia",
    subcountry: "Saratov Oblast",
    geonameid: 472278,
  },
  {
    name: "Volokolamsk",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 472433,
  },
  {
    name: "Vologda",
    country: "Russia",
    subcountry: "Vologda Oblast",
    geonameid: 472459,
  },
  {
    name: "Volkhov",
    country: "Russia",
    subcountry: "Leningradskaya Oblast'",
    geonameid: 472722,
  },
  {
    name: "Nagornyy",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 472732,
  },
  {
    name: "Volgorechensk",
    country: "Russia",
    subcountry: "Kostroma Oblast",
    geonameid: 472750,
  },
  {
    name: "Volgograd",
    country: "Russia",
    subcountry: "Volgograd Oblast",
    geonameid: 472757,
  },
  {
    name: "Volgodonsk",
    country: "Russia",
    subcountry: "Rostov",
    geonameid: 472761,
  },
  {
    name: "Novovladykino",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 473127,
  },
  {
    name: "Vladimir",
    country: "Russia",
    subcountry: "Vladimir Oblast",
    geonameid: 473247,
  },
  {
    name: "Vladikavkaz",
    country: "Russia",
    subcountry: "North Ossetia–Alania",
    geonameid: 473249,
  },
  {
    name: "Vidnoye",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 473778,
  },
  {
    name: "Vichuga",
    country: "Russia",
    subcountry: "Ivanovo Oblast",
    geonameid: 473788,
  },
  {
    name: "Veshnyaki",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 473972,
  },
  {
    name: "Vereshchagino",
    country: "Russia",
    subcountry: "Perm Krai",
    geonameid: 475777,
  },
  {
    name: "Venëv",
    country: "Russia",
    subcountry: "Tula Oblast",
    geonameid: 475881,
  },
  {
    name: "Vel’sk",
    country: "Russia",
    subcountry: "Arkhangelskaya",
    geonameid: 475938,
  },
  {
    name: "Velikiy Ustyug",
    country: "Russia",
    subcountry: "Vologda Oblast",
    geonameid: 476062,
  },
  {
    name: "Velikiye Luki",
    country: "Russia",
    subcountry: "Pskov Oblast",
    geonameid: 476077,
  },
  {
    name: "Vatutino",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 476368,
  },
  {
    name: "Valuyki",
    country: "Russia",
    subcountry: "Belgorod Oblast",
    geonameid: 477192,
  },
  {
    name: "Valday",
    country: "Russia",
    subcountry: "Novgorod Oblast",
    geonameid: 477301,
  },
  {
    name: "Vagonoremont",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 477377,
  },
  {
    name: "Uzlovaya",
    country: "Russia",
    subcountry: "Tula Oblast",
    geonameid: 477494,
  },
  {
    name: "Uvarovo",
    country: "Russia",
    subcountry: "Tambov Oblast",
    geonameid: 477626,
  },
  {
    name: "Uva",
    country: "Russia",
    subcountry: "Udmurtiya Republic",
    geonameid: 477656,
  },
  {
    name: "Ust’-Labinsk",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 478044,
  },
  {
    name: "Ust’-Katav",
    country: "Russia",
    subcountry: "Chelyabinsk",
    geonameid: 478071,
  },
  {
    name: "Ust’-Dzheguta",
    country: "Russia",
    subcountry: "Karachayevo-Cherkesiya Republic",
    geonameid: 478130,
  },
  {
    name: "Usman’",
    country: "Russia",
    subcountry: "Lipetsk Oblast",
    geonameid: 478317,
  },
  {
    name: "Uryupinsk",
    country: "Russia",
    subcountry: "Volgograd Oblast",
    geonameid: 478544,
  },
  {
    name: "Urus-Martan",
    country: "Russia",
    subcountry: "Chechnya",
    geonameid: 478581,
  },
  {
    name: "Uritsk",
    country: "Russia",
    subcountry: "St.-Petersburg",
    geonameid: 478724,
  },
  {
    name: "Unecha",
    country: "Russia",
    subcountry: "Bryansk Oblast",
    geonameid: 479028,
  },
  {
    name: "Ulyanovsk",
    country: "Russia",
    subcountry: "Ulyanovsk",
    geonameid: 479123,
  },
  {
    name: "Ukhta",
    country: "Russia",
    subcountry: "Komi",
    geonameid: 479411,
  },
  {
    name: "Uglich",
    country: "Russia",
    subcountry: "Yaroslavl Oblast",
    geonameid: 479532,
  },
  {
    name: "Ufa",
    country: "Russia",
    subcountry: "Bashkortostan Republic",
    geonameid: 479561,
  },
  {
    name: "Uchkeken",
    country: "Russia",
    subcountry: "Karachayevo-Cherkesiya Republic",
    geonameid: 479687,
  },
  {
    name: "Uchaly",
    country: "Russia",
    subcountry: "Bashkortostan Republic",
    geonameid: 479703,
  },
  {
    name: "Tyrnyauz",
    country: "Russia",
    subcountry: "Kabardino-Balkariya Republic",
    geonameid: 479933,
  },
  {
    name: "Tver",
    country: "Russia",
    subcountry: "Tver Oblast",
    geonameid: 480060,
  },
  {
    name: "Tuymazy",
    country: "Russia",
    subcountry: "Bashkortostan Republic",
    geonameid: 480089,
  },
  {
    name: "Tutayev",
    country: "Russia",
    subcountry: "Yaroslavl Oblast",
    geonameid: 480122,
  },
  {
    name: "Tula",
    country: "Russia",
    subcountry: "Tula Oblast",
    geonameid: 480562,
  },
  {
    name: "Tuchkovo",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 480685,
  },
  {
    name: "Tuapse",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 480716,
  },
  {
    name: "Tsimlyansk",
    country: "Russia",
    subcountry: "Rostov",
    geonameid: 480876,
  },
  {
    name: "Trubchevsk",
    country: "Russia",
    subcountry: "Bryansk Oblast",
    geonameid: 481350,
  },
  {
    name: "Troparëvo",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 481453,
  },
  {
    name: "Troitskaya",
    country: "Russia",
    subcountry: "Ingushetiya Republic",
    geonameid: 481605,
  },
  {
    name: "Troitsk",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 481608,
  },
  {
    name: "Tosno",
    country: "Russia",
    subcountry: "Leningradskaya Oblast'",
    geonameid: 481964,
  },
  {
    name: "Torzhok",
    country: "Russia",
    subcountry: "Tver Oblast",
    geonameid: 481985,
  },
  {
    name: "Tomilino",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 482260,
  },
  {
    name: "Tolyatti",
    country: "Russia",
    subcountry: "Samara Oblast",
    geonameid: 482283,
  },
  {
    name: "Timashyovsk",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 482965,
  },
  {
    name: "Tikhvin",
    country: "Russia",
    subcountry: "Leningradskaya Oblast'",
    geonameid: 483019,
  },
  {
    name: "Tikhoretsk",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 483029,
  },
  {
    name: "Teykovo",
    country: "Russia",
    subcountry: "Ivanovo Oblast",
    geonameid: 483137,
  },
  {
    name: "Terek",
    country: "Russia",
    subcountry: "Kabardino-Balkariya Republic",
    geonameid: 483495,
  },
  {
    name: "Tyoply Stan",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 483551,
  },
  {
    name: "Temryuk",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 483661,
  },
  {
    name: "Tekstil’shchiki",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 483826,
  },
  {
    name: "Tbilisskaya",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 483883,
  },
  {
    name: "Tambov",
    country: "Russia",
    subcountry: "Tambov Oblast",
    geonameid: 484646,
  },
  {
    name: "Agidel’",
    country: "Russia",
    subcountry: "Bashkortostan Republic",
    geonameid: 484856,
  },
  {
    name: "Taganrog",
    country: "Russia",
    subcountry: "Rostov",
    geonameid: 484907,
  },
  {
    name: "Taganskiy",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 484912,
  },
  {
    name: "Syzran",
    country: "Russia",
    subcountry: "Samara Oblast",
    geonameid: 484972,
  },
  {
    name: "Syktyvkar",
    country: "Russia",
    subcountry: "Komi",
    geonameid: 485239,
  },
  {
    name: "Svobody",
    country: "Russia",
    subcountry: "Stavropol Kray",
    geonameid: 485432,
  },
  {
    name: "Sviblovo",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 485630,
  },
  {
    name: "Svetogorsk",
    country: "Russia",
    subcountry: "Leningradskaya Oblast'",
    geonameid: 485639,
  },
  {
    name: "Svetlyy",
    country: "Russia",
    subcountry: "Kaliningrad Oblast",
    geonameid: 485660,
  },
  {
    name: "Svetlograd",
    country: "Russia",
    subcountry: "Stavropol Kray",
    geonameid: 485698,
  },
  {
    name: "Suvorovskaya",
    country: "Russia",
    subcountry: "Stavropol Kray",
    geonameid: 485871,
  },
  {
    name: "Suvorov",
    country: "Russia",
    subcountry: "Tula Oblast",
    geonameid: 485888,
  },
  {
    name: "Surovikino",
    country: "Russia",
    subcountry: "Volgograd Oblast",
    geonameid: 486071,
  },
  {
    name: "Surkhakhi",
    country: "Russia",
    subcountry: "Ingushetiya Republic",
    geonameid: 486110,
  },
  {
    name: "Sukhinichi",
    country: "Russia",
    subcountry: "Kaluga Oblast",
    geonameid: 486665,
  },
  {
    name: "Stupino",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 486968,
  },
  {
    name: "Strunino",
    country: "Russia",
    subcountry: "Vladimir Oblast",
    geonameid: 487095,
  },
  {
    name: "Stroitel",
    country: "Russia",
    subcountry: "Belgorod Oblast",
    geonameid: 487147,
  },
  {
    name: "Strogino",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 487150,
  },
  {
    name: "Sterlitamak",
    country: "Russia",
    subcountry: "Bashkortostan Republic",
    geonameid: 487495,
  },
  {
    name: "Stavropol’",
    country: "Russia",
    subcountry: "Stavropol Kray",
    geonameid: 487846,
  },
  {
    name: "Staryy Oskol",
    country: "Russia",
    subcountry: "Belgorod Oblast",
    geonameid: 487928,
  },
  {
    name: "Staroshcherbinovskaya",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 488635,
  },
  {
    name: "Starominskaya",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 488742,
  },
  {
    name: "Starodub",
    country: "Russia",
    subcountry: "Bryansk Oblast",
    geonameid: 488852,
  },
  {
    name: "Staraya Russa",
    country: "Russia",
    subcountry: "Novgorod Oblast",
    geonameid: 489088,
  },
  {
    name: "Staraya Kupavna",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 489162,
  },
  {
    name: "Staraya Derevnya",
    country: "Russia",
    subcountry: "St.-Petersburg",
    geonameid: 489226,
  },
  {
    name: "Sovetsk",
    country: "Russia",
    subcountry: "Kirov Oblast",
    geonameid: 490067,
  },
  {
    name: "Sovetsk",
    country: "Russia",
    subcountry: "Kaliningrad Oblast",
    geonameid: 490068,
  },
  {
    name: "Sosnovyy Bor",
    country: "Russia",
    subcountry: "Leningradskaya Oblast'",
    geonameid: 490172,
  },
  {
    name: "Sosnovaya Polyana",
    country: "Russia",
    subcountry: "St.-Petersburg",
    geonameid: 490377,
  },
  {
    name: "Sosnogorsk",
    country: "Russia",
    subcountry: "Komi",
    geonameid: 490391,
  },
  {
    name: "Sortavala",
    country: "Russia",
    subcountry: "Karelia",
    geonameid: 490466,
  },
  {
    name: "Sorochinsk",
    country: "Russia",
    subcountry: "Orenburg Oblast",
    geonameid: 490554,
  },
  {
    name: "Solntsevo",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 490971,
  },
  {
    name: "Solnechnogorsk",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 490996,
  },
  {
    name: "Sol’-Iletsk",
    country: "Russia",
    subcountry: "Orenburg Oblast",
    geonameid: 491019,
  },
  {
    name: "Solikamsk",
    country: "Russia",
    subcountry: "Perm Krai",
    geonameid: 491023,
  },
  {
    name: "Sokol’niki",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 491250,
  },
  {
    name: "Sokol",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 491280,
  },
  {
    name: "Sokol",
    country: "Russia",
    subcountry: "Vologda Oblast",
    geonameid: 491281,
  },
  {
    name: "Sofrino",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 491352,
  },
  {
    name: "Sochi",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 491422,
  },
  {
    name: "Sobinka",
    country: "Russia",
    subcountry: "Vladimir Oblast",
    geonameid: 491480,
  },
  {
    name: "Smolensk",
    country: "Russia",
    subcountry: "Smolensk Oblast",
    geonameid: 491687,
  },
  {
    name: "Slobodskoy",
    country: "Russia",
    subcountry: "Kirov Oblast",
    geonameid: 491882,
  },
  {
    name: "Slobodka",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 491895,
  },
  {
    name: "Slavyansk-na-Kubani",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 492094,
  },
  {
    name: "Slantsy",
    country: "Russia",
    subcountry: "Leningradskaya Oblast'",
    geonameid: 492162,
  },
  {
    name: "Skopin",
    country: "Russia",
    subcountry: "Ryazan Oblast",
    geonameid: 492376,
  },
  {
    name: "Skhodnya",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 492448,
  },
  {
    name: "Sim",
    country: "Russia",
    subcountry: "Chelyabinsk",
    geonameid: 492944,
  },
  {
    name: "Sibay",
    country: "Russia",
    subcountry: "Bashkortostan Republic",
    geonameid: 493160,
  },
  {
    name: "Shuya",
    country: "Russia",
    subcountry: "Ivanovo Oblast",
    geonameid: 493231,
  },
  {
    name: "Shushary",
    country: "Russia",
    subcountry: "St.-Petersburg",
    geonameid: 493316,
  },
  {
    name: "Shumerlya",
    country: "Russia",
    subcountry: "Chuvashia",
    geonameid: 493463,
  },
  {
    name: "Mikhaylovsk",
    country: "Russia",
    subcountry: "Stavropol Kray",
    geonameid: 493702,
  },
  {
    name: "Shilovo",
    country: "Russia",
    subcountry: "Ryazan Oblast",
    geonameid: 494427,
  },
  {
    name: "Sheksna",
    country: "Russia",
    subcountry: "Vologda Oblast",
    geonameid: 495062,
  },
  {
    name: "Shebekino",
    country: "Russia",
    subcountry: "Belgorod Oblast",
    geonameid: 495112,
  },
  {
    name: "Shchukino",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 495136,
  },
  {
    name: "Shchigry",
    country: "Russia",
    subcountry: "Kursk Oblast",
    geonameid: 495206,
  },
  {
    name: "Shcherbinka",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 495260,
  },
  {
    name: "Shchyolkovo",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 495344,
  },
  {
    name: "Shchëkino",
    country: "Russia",
    subcountry: "Tula Oblast",
    geonameid: 495394,
  },
  {
    name: "Shatura",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 495518,
  },
  {
    name: "Shar’ya",
    country: "Russia",
    subcountry: "Kostroma Oblast",
    geonameid: 495619,
  },
  {
    name: "Shali",
    country: "Russia",
    subcountry: "Chechnya",
    geonameid: 495957,
  },
  {
    name: "Shakhun’ya",
    country: "Russia",
    subcountry: "Nizhny Novgorod Oblast",
    geonameid: 496012,
  },
  {
    name: "Shakhty",
    country: "Russia",
    subcountry: "Rostov",
    geonameid: 496015,
  },
  {
    name: "Severskaya",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 496267,
  },
  {
    name: "Severo-Zadonsk",
    country: "Russia",
    subcountry: "Tula Oblast",
    geonameid: 496269,
  },
  {
    name: "Severoural’sk",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 496275,
  },
  {
    name: "Severomorsk",
    country: "Russia",
    subcountry: "Murmansk",
    geonameid: 496278,
  },
  {
    name: "Severodvinsk",
    country: "Russia",
    subcountry: "Arkhangelskaya",
    geonameid: 496285,
  },
  {
    name: "Severnyy",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 496348,
  },
  {
    name: "Setun’",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 496456,
  },
  {
    name: "Sestroretsk",
    country: "Russia",
    subcountry: "St.-Petersburg",
    geonameid: 496478,
  },
  {
    name: "Sertolovo",
    country: "Russia",
    subcountry: "Leningradskaya Oblast'",
    geonameid: 496519,
  },
  {
    name: "Serpukhov",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 496527,
  },
  {
    name: "Sergiyev Posad",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 496638,
  },
  {
    name: "Sergach",
    country: "Russia",
    subcountry: "Nizhny Novgorod Oblast",
    geonameid: 496802,
  },
  {
    name: "Serdobsk",
    country: "Russia",
    subcountry: "Penza Oblast",
    geonameid: 496934,
  },
  {
    name: "Semiluki",
    country: "Russia",
    subcountry: "Voronezh Oblast",
    geonameid: 497206,
  },
  {
    name: "Semikarakorsk",
    country: "Russia",
    subcountry: "Rostov",
    geonameid: 497218,
  },
  {
    name: "Semënovskoye",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 497271,
  },
  {
    name: "Semënov",
    country: "Russia",
    subcountry: "Nizhny Novgorod Oblast",
    geonameid: 497450,
  },
  {
    name: "Sel’tso",
    country: "Russia",
    subcountry: "Bryansk Oblast",
    geonameid: 497610,
  },
  {
    name: "Segezha",
    country: "Russia",
    subcountry: "Karelia",
    geonameid: 497927,
  },
  {
    name: "Satka",
    country: "Russia",
    subcountry: "Chelyabinsk",
    geonameid: 498418,
  },
  {
    name: "Sarov",
    country: "Russia",
    subcountry: "Nizhny Novgorod Oblast",
    geonameid: 498525,
  },
  {
    name: "Saratov",
    country: "Russia",
    subcountry: "Saratov Oblast",
    geonameid: 498677,
  },
  {
    name: "Sarapul",
    country: "Russia",
    subcountry: "Udmurtiya Republic",
    geonameid: 498687,
  },
  {
    name: "Saransk",
    country: "Russia",
    subcountry: "Mordoviya Republic",
    geonameid: 498698,
  },
  {
    name: "Saraktash",
    country: "Russia",
    subcountry: "Orenburg Oblast",
    geonameid: 498708,
  },
  {
    name: "Saint Petersburg",
    country: "Russia",
    subcountry: "St.-Petersburg",
    geonameid: 498817,
  },
  {
    name: "Samara",
    country: "Russia",
    subcountry: "Samara Oblast",
    geonameid: 499099,
  },
  {
    name: "Sal’sk",
    country: "Russia",
    subcountry: "Rostov",
    geonameid: 499161,
  },
  {
    name: "Salavat",
    country: "Russia",
    subcountry: "Bashkortostan Republic",
    geonameid: 499292,
  },
  {
    name: "Safonovo",
    country: "Russia",
    subcountry: "Smolensk Oblast",
    geonameid: 499453,
  },
  {
    name: "Rzhev",
    country: "Russia",
    subcountry: "Tver Oblast",
    geonameid: 499717,
  },
  {
    name: "Rybnoye",
    country: "Russia",
    subcountry: "Ryazan Oblast",
    geonameid: 499975,
  },
  {
    name: "Rybinsk",
    country: "Russia",
    subcountry: "Yaroslavl Oblast",
    geonameid: 500004,
  },
  {
    name: "Rybatskoye",
    country: "Russia",
    subcountry: "Leningradskaya Oblast'",
    geonameid: 500019,
  },
  {
    name: "Ryazhsk",
    country: "Russia",
    subcountry: "Ryazan Oblast",
    geonameid: 500047,
  },
  {
    name: "Ryazan’",
    country: "Russia",
    subcountry: "Ryazan Oblast",
    geonameid: 500096,
  },
  {
    name: "Ruzayevka",
    country: "Russia",
    subcountry: "Mordoviya Republic",
    geonameid: 500299,
  },
  {
    name: "Rublëvo",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 500843,
  },
  {
    name: "Rtishchevo",
    country: "Russia",
    subcountry: "Saratov Oblast",
    geonameid: 500886,
  },
  {
    name: "Rostov-na-Donu",
    country: "Russia",
    subcountry: "Rostov",
    geonameid: 501175,
  },
  {
    name: "Rostov",
    country: "Russia",
    subcountry: "Yaroslavl Oblast",
    geonameid: 501183,
  },
  {
    name: "Rostokino",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 501187,
  },
  {
    name: "Rossosh’",
    country: "Russia",
    subcountry: "Voronezh Oblast",
    geonameid: 501215,
  },
  {
    name: "Rossosh’",
    country: "Russia",
    subcountry: "Voronezh Oblast",
    geonameid: 501231,
  },
  {
    name: "Roslavl’",
    country: "Russia",
    subcountry: "Smolensk Oblast",
    geonameid: 501283,
  },
  {
    name: "Roshal’",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 501320,
  },
  {
    name: "Rodniki",
    country: "Russia",
    subcountry: "Ivanovo Oblast",
    geonameid: 501730,
  },
  {
    name: "Revda",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 502011,
  },
  {
    name: "Reutov",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 502018,
  },
  {
    name: "Razumnoye",
    country: "Russia",
    subcountry: "Belgorod Oblast",
    geonameid: 502400,
  },
  {
    name: "Rayevskiy",
    country: "Russia",
    subcountry: "Bashkortostan Republic",
    geonameid: 502540,
  },
  {
    name: "Rasskazovo",
    country: "Russia",
    subcountry: "Tambov Oblast",
    geonameid: 502793,
  },
  {
    name: "Ramenskoye",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 502965,
  },
  {
    name: "Ramenki",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 502971,
  },
  {
    name: "Pyatigorsk",
    country: "Russia",
    subcountry: "Stavropol Kray",
    geonameid: 503550,
  },
  {
    name: "Pushkino",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 503977,
  },
  {
    name: "Pushkin",
    country: "Russia",
    subcountry: "St.-Petersburg",
    geonameid: 504003,
  },
  {
    name: "Pushchino",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 504042,
  },
  {
    name: "Pugachev",
    country: "Russia",
    subcountry: "Saratov Oblast",
    geonameid: 504250,
  },
  {
    name: "Pskov",
    country: "Russia",
    subcountry: "Pskov Oblast",
    geonameid: 504341,
  },
  {
    name: "Protvino",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 504576,
  },
  {
    name: "Proletarsk",
    country: "Russia",
    subcountry: "Rostov",
    geonameid: 504831,
  },
  {
    name: "Prokhladnyy",
    country: "Russia",
    subcountry: "Kabardino-Balkariya Republic",
    geonameid: 504935,
  },
  {
    name: "Priyutovo",
    country: "Russia",
    subcountry: "Bashkortostan Republic",
    geonameid: 505014,
  },
  {
    name: "Privolzhskiy",
    country: "Russia",
    subcountry: "Saratov Oblast",
    geonameid: 505057,
  },
  {
    name: "Privolzhsk",
    country: "Russia",
    subcountry: "Ivanovo Oblast",
    geonameid: 505060,
  },
  {
    name: "Priozërsk",
    country: "Russia",
    subcountry: "Leningradskaya Oblast'",
    geonameid: 505230,
  },
  {
    name: "Primorsko-Akhtarsk",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 505259,
  },
  {
    name: "Pridonskoy",
    country: "Russia",
    subcountry: "Voronezh Oblast",
    geonameid: 505421,
  },
  {
    name: "Povorino",
    country: "Russia",
    subcountry: "Voronezh Oblast",
    geonameid: 505806,
  },
  {
    name: "Kotlovka",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 506043,
  },
  {
    name: "Annino",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 506117,
  },
  {
    name: "Polyarnyye Zori",
    country: "Russia",
    subcountry: "Murmansk",
    geonameid: 506762,
  },
  {
    name: "Polyarnyy",
    country: "Russia",
    subcountry: "Murmansk",
    geonameid: 506763,
  },
  {
    name: "Pokrovskoye-Streshnëvo",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 507338,
  },
  {
    name: "Pokrov",
    country: "Russia",
    subcountry: "Vladimir Oblast",
    geonameid: 507599,
  },
  {
    name: "Pokhvistnevo",
    country: "Russia",
    subcountry: "Samara Oblast",
    geonameid: 507624,
  },
  {
    name: "Podporozh’ye",
    country: "Russia",
    subcountry: "Leningradskaya Oblast'",
    geonameid: 508034,
  },
  {
    name: "Podolsk",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 508101,
  },
  {
    name: "Pochep",
    country: "Russia",
    subcountry: "Bryansk Oblast",
    geonameid: 508656,
  },
  {
    name: "Ryazanskiy",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 508751,
  },
  {
    name: "Plavsk",
    country: "Russia",
    subcountry: "Tula Oblast",
    geonameid: 509052,
  },
  {
    name: "Pikalëvo",
    country: "Russia",
    subcountry: "Leningradskaya Oblast'",
    geonameid: 509598,
  },
  {
    name: "Petushki",
    country: "Russia",
    subcountry: "Vladimir Oblast",
    geonameid: 509697,
  },
  {
    name: "Petrozavodsk",
    country: "Russia",
    subcountry: "Karelia",
    geonameid: 509820,
  },
  {
    name: "Petrovskaya",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 509981,
  },
  {
    name: "Petrovsk",
    country: "Russia",
    subcountry: "Saratov Oblast",
    geonameid: 509987,
  },
  {
    name: "Petrodvorets",
    country: "Russia",
    subcountry: "St.-Petersburg",
    geonameid: 510225,
  },
  {
    name: "Peterhof",
    country: "Russia",
    subcountry: "St.-Petersburg",
    geonameid: 510291,
  },
  {
    name: "Pestovo",
    country: "Russia",
    subcountry: "Novgorod Oblast",
    geonameid: 510364,
  },
  {
    name: "Pervouralsk",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 510808,
  },
  {
    name: "Perm",
    country: "Russia",
    subcountry: "Perm Krai",
    geonameid: 511196,
  },
  {
    name: "Pereslavl’-Zalesskiy",
    country: "Russia",
    subcountry: "Yaroslavl Oblast",
    geonameid: 511359,
  },
  {
    name: "Novo-Peredelkino",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 511510,
  },
  {
    name: "Penza",
    country: "Russia",
    subcountry: "Penza Oblast",
    geonameid: 511565,
  },
  {
    name: "Pechora",
    country: "Russia",
    subcountry: "Komi",
    geonameid: 511794,
  },
  {
    name: "Pavlovskiy Posad",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 512023,
  },
  {
    name: "Pavlovskaya",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 512051,
  },
  {
    name: "Pavlovsk",
    country: "Russia",
    subcountry: "St.-Petersburg",
    geonameid: 512052,
  },
  {
    name: "Pavlovsk",
    country: "Russia",
    subcountry: "Voronezh Oblast",
    geonameid: 512053,
  },
  {
    name: "Pashkovskiy",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 512382,
  },
  {
    name: "Pallasovka",
    country: "Russia",
    subcountry: "Volgograd Oblast",
    geonameid: 513042,
  },
  {
    name: "Ozëry",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 513378,
  },
  {
    name: "Ozerki",
    country: "Russia",
    subcountry: "St.-Petersburg",
    geonameid: 513471,
  },
  {
    name: "Otradnyy",
    country: "Russia",
    subcountry: "Samara Oblast",
    geonameid: 513883,
  },
  {
    name: "Otradnoye",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 513896,
  },
  {
    name: "Otradnoye",
    country: "Russia",
    subcountry: "Leningradskaya Oblast'",
    geonameid: 513898,
  },
  {
    name: "Otradnaya",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 513911,
  },
  {
    name: "Ostrov",
    country: "Russia",
    subcountry: "Pskov Oblast",
    geonameid: 514171,
  },
  {
    name: "Ostrogozhsk",
    country: "Russia",
    subcountry: "Voronezh Oblast",
    geonameid: 514198,
  },
  {
    name: "Ostashkov",
    country: "Russia",
    subcountry: "Tver Oblast",
    geonameid: 514259,
  },
  {
    name: "Ostankinskiy",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 514284,
  },
  {
    name: "Osa",
    country: "Russia",
    subcountry: "Perm Krai",
    geonameid: 514706,
  },
  {
    name: "Orsk",
    country: "Russia",
    subcountry: "Orenburg Oblast",
    geonameid: 514734,
  },
  {
    name: "Orlovskiy",
    country: "Russia",
    subcountry: "Rostov",
    geonameid: 514796,
  },
  {
    name: "Orenburg",
    country: "Russia",
    subcountry: "Orenburg Oblast",
    geonameid: 515003,
  },
  {
    name: "Orël",
    country: "Russia",
    subcountry: "Oryol oblast",
    geonameid: 515012,
  },
  {
    name: "Orekhovo-Zuyevo",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 515024,
  },
  {
    name: "Orekhovo-Borisovo Severnoye",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 515027,
  },
  {
    name: "Sunzha",
    country: "Russia",
    subcountry: "Ingushetiya Republic",
    geonameid: 515083,
  },
  {
    name: "Onega",
    country: "Russia",
    subcountry: "Arkhangelskaya",
    geonameid: 515246,
  },
  {
    name: "Omutninsk",
    country: "Russia",
    subcountry: "Kirov Oblast",
    geonameid: 515267,
  },
  {
    name: "Olenegorsk",
    country: "Russia",
    subcountry: "Murmansk",
    geonameid: 515698,
  },
  {
    name: "Tsotsin-Yurt",
    country: "Russia",
    subcountry: "Chechnya",
    geonameid: 515804,
  },
  {
    name: "Oktyabrsky",
    country: "Russia",
    subcountry: "Bashkortostan Republic",
    geonameid: 515879,
  },
  {
    name: "Oktyabr’sk",
    country: "Russia",
    subcountry: "Samara Oblast",
    geonameid: 515938,
  },
  {
    name: "Odintsovo",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 516215,
  },
  {
    name: "Ochër",
    country: "Russia",
    subcountry: "Perm Krai",
    geonameid: 516256,
  },
  {
    name: "Ochakovo-Matveyevskoye",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 516264,
  },
  {
    name: "Obninsk",
    country: "Russia",
    subcountry: "Kaluga Oblast",
    geonameid: 516436,
  },
  {
    name: "Nytva",
    country: "Russia",
    subcountry: "Perm Krai",
    geonameid: 516576,
  },
  {
    name: "Nyandoma",
    country: "Russia",
    subcountry: "Arkhangelskaya",
    geonameid: 516647,
  },
  {
    name: "Nurlat",
    country: "Russia",
    subcountry: "Tatarstan Republic",
    geonameid: 516716,
  },
  {
    name: "Novy Oskol",
    country: "Russia",
    subcountry: "Belgorod Oblast",
    geonameid: 516931,
  },
  {
    name: "Novyye Kuz’minki",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 517121,
  },
  {
    name: "Novyye Cherëmushki",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 517161,
  },
  {
    name: "Novozybkov",
    country: "Russia",
    subcountry: "Bryansk Oblast",
    geonameid: 517269,
  },
  {
    name: "Novovoronezh",
    country: "Russia",
    subcountry: "Voronezh Oblast",
    geonameid: 517716,
  },
  {
    name: "Novouzensk",
    country: "Russia",
    subcountry: "Saratov Oblast",
    geonameid: 517739,
  },
  {
    name: "Novoul’yanovsk",
    country: "Russia",
    subcountry: "Ulyanovsk",
    geonameid: 517766,
  },
  {
    name: "Novotroitsk",
    country: "Russia",
    subcountry: "Orenburg Oblast",
    geonameid: 517836,
  },
  {
    name: "Novotitarovskaya",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 517842,
  },
  {
    name: "Novoshakhtinsk",
    country: "Russia",
    subcountry: "Rostov",
    geonameid: 517963,
  },
  {
    name: "Novorossiysk",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 518255,
  },
  {
    name: "Novopokrovskaya",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 518325,
  },
  {
    name: "Novopavlovsk",
    country: "Russia",
    subcountry: "Stavropol Kray",
    geonameid: 518383,
  },
  {
    name: "Novomoskovsk",
    country: "Russia",
    subcountry: "Tula Oblast",
    geonameid: 518557,
  },
  {
    name: "Novomichurinsk",
    country: "Russia",
    subcountry: "Ryazan Oblast",
    geonameid: 518602,
  },
  {
    name: "Novokuz’minki",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 518657,
  },
  {
    name: "Novokuybyshevsk",
    country: "Russia",
    subcountry: "Samara Oblast",
    geonameid: 518659,
  },
  {
    name: "Novokubansk",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 518682,
  },
  {
    name: "Novokhovrino",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 518740,
  },
  {
    name: "Novogireyevo",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 518879,
  },
  {
    name: "Novodvinsk",
    country: "Russia",
    subcountry: "Arkhangelskaya",
    geonameid: 518909,
  },
  {
    name: "Novocherkassk",
    country: "Russia",
    subcountry: "Rostov",
    geonameid: 518970,
  },
  {
    name: "Novocheboksarsk",
    country: "Russia",
    subcountry: "Chuvashia",
    geonameid: 518976,
  },
  {
    name: "Novoanninskiy",
    country: "Russia",
    subcountry: "Volgograd Oblast",
    geonameid: 519062,
  },
  {
    name: "Novoaleksandrovsk",
    country: "Russia",
    subcountry: "Stavropol Kray",
    geonameid: 519106,
  },
  {
    name: "Velikiy Novgorod",
    country: "Russia",
    subcountry: "Novgorod Oblast",
    geonameid: 519336,
  },
  {
    name: "Novaya Usman’",
    country: "Russia",
    subcountry: "Voronezh Oblast",
    geonameid: 519447,
  },
  {
    name: "Novaya Derevnya",
    country: "Russia",
    subcountry: "St.-Petersburg",
    geonameid: 519711,
  },
  {
    name: "Noginsk",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 520068,
  },
  {
    name: "Nizhnyaya Tura",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 520204,
  },
  {
    name: "Nizhny Tagil",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 520494,
  },
  {
    name: "Nizhniy Novgorod",
    country: "Russia",
    subcountry: "Nizhny Novgorod Oblast",
    geonameid: 520555,
  },
  {
    name: "Nizhniy Lomov",
    country: "Russia",
    subcountry: "Penza Oblast",
    geonameid: 520574,
  },
  {
    name: "Nizhnekamsk",
    country: "Russia",
    subcountry: "Tatarstan Republic",
    geonameid: 521118,
  },
  {
    name: "Nikulino",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 521416,
  },
  {
    name: "Nikol’skoye",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 521500,
  },
  {
    name: "Nikol’skoye",
    country: "Russia",
    subcountry: "Leningradskaya Oblast'",
    geonameid: 521509,
  },
  {
    name: "Nikol’sk",
    country: "Russia",
    subcountry: "Penza Oblast",
    geonameid: 521776,
  },
  {
    name: "Nikolayevsk",
    country: "Russia",
    subcountry: "Volgograd Oblast",
    geonameid: 521874,
  },
  {
    name: "Nikel",
    country: "Russia",
    subcountry: "Murmansk",
    geonameid: 522260,
  },
  {
    name: "Nezlobnaya",
    country: "Russia",
    subcountry: "Stavropol Kray",
    geonameid: 522301,
  },
  {
    name: "Nevinnomyssk",
    country: "Russia",
    subcountry: "Stavropol Kray",
    geonameid: 522377,
  },
  {
    name: "Nevel’",
    country: "Russia",
    subcountry: "Pskov Oblast",
    geonameid: 522410,
  },
  {
    name: "Nesterovskaya",
    country: "Russia",
    subcountry: "Ingushetiya Republic",
    geonameid: 522470,
  },
  {
    name: "Nerekhta",
    country: "Russia",
    subcountry: "Kostroma Oblast",
    geonameid: 522594,
  },
  {
    name: "Nelidovo",
    country: "Russia",
    subcountry: "Tver Oblast",
    geonameid: 522775,
  },
  {
    name: "Neftekamsk",
    country: "Russia",
    subcountry: "Bashkortostan Republic",
    geonameid: 522942,
  },
  {
    name: "Neftegorsk",
    country: "Russia",
    subcountry: "Samara Oblast",
    geonameid: 522945,
  },
  {
    name: "Nazran’",
    country: "Russia",
    subcountry: "Ingushetiya Republic",
    geonameid: 523064,
  },
  {
    name: "Nar'yan-Mar",
    country: "Russia",
    subcountry: "Nenets",
    geonameid: 523392,
  },
  {
    name: "Nartkala",
    country: "Russia",
    subcountry: "Kabardino-Balkariya Republic",
    geonameid: 523405,
  },
  {
    name: "Naro-Fominsk",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 523426,
  },
  {
    name: "Nalchik",
    country: "Russia",
    subcountry: "Kabardino-Balkariya Republic",
    geonameid: 523523,
  },
  {
    name: "Nakhabino",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 523553,
  },
  {
    name: "Naberezhnyye Chelny",
    country: "Russia",
    subcountry: "Tatarstan Republic",
    geonameid: 523750,
  },
  {
    name: "Mytishchi",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 523812,
  },
  {
    name: "Murom",
    country: "Russia",
    subcountry: "Vladimir Oblast",
    geonameid: 524294,
  },
  {
    name: "Murmansk",
    country: "Russia",
    subcountry: "Murmansk",
    geonameid: 524305,
  },
  {
    name: "Mtsensk",
    country: "Russia",
    subcountry: "Oryol oblast",
    geonameid: 524640,
  },
  {
    name: "Mozhga",
    country: "Russia",
    subcountry: "Udmurtiya Republic",
    geonameid: 524699,
  },
  {
    name: "Mozhaysk",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 524712,
  },
  {
    name: "Mozdok",
    country: "Russia",
    subcountry: "North Ossetia–Alania",
    geonameid: 524736,
  },
  {
    name: "Mostovskoy",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 524809,
  },
  {
    name: "Moscow",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 524901,
  },
  {
    name: "Morshansk",
    country: "Russia",
    subcountry: "Tambov Oblast",
    geonameid: 525138,
  },
  {
    name: "Morozovsk",
    country: "Russia",
    subcountry: "Rostov",
    geonameid: 525162,
  },
  {
    name: "Monino",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 525396,
  },
  {
    name: "Monchegorsk",
    country: "Russia",
    subcountry: "Murmansk",
    geonameid: 525404,
  },
  {
    name: "Mineralnye Vody",
    country: "Russia",
    subcountry: "Stavropol Kray",
    geonameid: 526480,
  },
  {
    name: "Millerovo",
    country: "Russia",
    subcountry: "Rostov",
    geonameid: 526558,
  },
  {
    name: "Mikhaylovka",
    country: "Russia",
    subcountry: "Volgograd Oblast",
    geonameid: 527012,
  },
  {
    name: "Mikhalkovo",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 527057,
  },
  {
    name: "Michurinsk",
    country: "Russia",
    subcountry: "Tambov Oblast",
    geonameid: 527191,
  },
  {
    name: "Metallostroy",
    country: "Russia",
    subcountry: "St.-Petersburg",
    geonameid: 527361,
  },
  {
    name: "Menzelinsk",
    country: "Russia",
    subcountry: "Tatarstan Republic",
    geonameid: 527529,
  },
  {
    name: "Mendeleyevsk",
    country: "Russia",
    subcountry: "Tatarstan Republic",
    geonameid: 527579,
  },
  {
    name: "Meleuz",
    country: "Russia",
    subcountry: "Bashkortostan Republic",
    geonameid: 527717,
  },
  {
    name: "Melenki",
    country: "Russia",
    subcountry: "Vladimir Oblast",
    geonameid: 527740,
  },
  {
    name: "Medvezh’yegorsk",
    country: "Russia",
    subcountry: "Karelia",
    geonameid: 527888,
  },
  {
    name: "Medvedovskaya",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 527968,
  },
  {
    name: "Medvedevo",
    country: "Russia",
    subcountry: "Mariy-El Republic",
    geonameid: 528056,
  },
  {
    name: "Mednogorsk",
    country: "Russia",
    subcountry: "Orenburg Oblast",
    geonameid: 528109,
  },
  {
    name: "Maykop",
    country: "Russia",
    subcountry: "Adygeya Republic",
    geonameid: 528293,
  },
  {
    name: "Matveyevskoye",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 528454,
  },
  {
    name: "Marks",
    country: "Russia",
    subcountry: "Saratov Oblast",
    geonameid: 529073,
  },
  {
    name: "Mar’ino",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 529237,
  },
  {
    name: "Manturovo",
    country: "Russia",
    subcountry: "Kostroma Oblast",
    geonameid: 529505,
  },
  {
    name: "Yaroslavskiy",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 530088,
  },
  {
    name: "Maloyaroslavets",
    country: "Russia",
    subcountry: "Kaluga Oblast",
    geonameid: 530849,
  },
  {
    name: "Malgobek",
    country: "Russia",
    subcountry: "Ingushetiya Republic",
    geonameid: 531129,
  },
  {
    name: "Malakhovka",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 531820,
  },
  {
    name: "Makhachkala",
    country: "Russia",
    subcountry: "Dagestan",
    geonameid: 532096,
  },
  {
    name: "Magnitogorsk",
    country: "Russia",
    subcountry: "Chelyabinsk",
    geonameid: 532288,
  },
  {
    name: "Lyudinovo",
    country: "Russia",
    subcountry: "Kaluga Oblast",
    geonameid: 532459,
  },
  {
    name: "Lyublino",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 532535,
  },
  {
    name: "Lyubertsy",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 532615,
  },
  {
    name: "Lytkarino",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 532657,
  },
  {
    name: "Lys’va",
    country: "Russia",
    subcountry: "Perm Krai",
    geonameid: 532675,
  },
  {
    name: "Lyskovo",
    country: "Russia",
    subcountry: "Nizhny Novgorod Oblast",
    geonameid: 532715,
  },
  {
    name: "Luzhniki",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 533067,
  },
  {
    name: "Lukhovitsy",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 533543,
  },
  {
    name: "Luga",
    country: "Russia",
    subcountry: "Leningradskaya Oblast'",
    geonameid: 533690,
  },
  {
    name: "Losino-Petrovskiy",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 534015,
  },
  {
    name: "Lomonosov",
    country: "Russia",
    subcountry: "St.-Petersburg",
    geonameid: 534341,
  },
  {
    name: "Lodeynoye Pole",
    country: "Russia",
    subcountry: "Leningradskaya Oblast'",
    geonameid: 534560,
  },
  {
    name: "Lobnya",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 534595,
  },
  {
    name: "Livny",
    country: "Russia",
    subcountry: "Oryol oblast",
    geonameid: 534701,
  },
  {
    name: "Liski",
    country: "Russia",
    subcountry: "Voronezh Oblast",
    geonameid: 534838,
  },
  {
    name: "Lipetsk",
    country: "Russia",
    subcountry: "Lipetsk Oblast",
    geonameid: 535121,
  },
  {
    name: "Likino-Dulevo",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 535243,
  },
  {
    name: "Likhobory",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 535270,
  },
  {
    name: "Lianozovo",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 535330,
  },
  {
    name: "L’govskiy",
    country: "Russia",
    subcountry: "Kursk Oblast",
    geonameid: 535334,
  },
  {
    name: "Komendantsky aerodrom",
    country: "Russia",
    subcountry: "St.-Petersburg",
    geonameid: 535729,
  },
  {
    name: "Lermontov",
    country: "Russia",
    subcountry: "Stavropol Kray",
    geonameid: 535886,
  },
  {
    name: "Leonovo",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 535966,
  },
  {
    name: "Leninskiye Gory",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 536098,
  },
  {
    name: "Leninsk",
    country: "Russia",
    subcountry: "Volgograd Oblast",
    geonameid: 536156,
  },
  {
    name: "Leninogorsk",
    country: "Russia",
    subcountry: "Tatarstan Republic",
    geonameid: 536162,
  },
  {
    name: "Tsaritsyno",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 536164,
  },
  {
    name: "Leningradskaya",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 536200,
  },
  {
    name: "Yubileyny",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 536206,
  },
  {
    name: "Lefortovo",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 536398,
  },
  {
    name: "Lebedyan’",
    country: "Russia",
    subcountry: "Lipetsk Oblast",
    geonameid: 536518,
  },
  {
    name: "Lazarevskoye",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 536625,
  },
  {
    name: "Lakinsk",
    country: "Russia",
    subcountry: "Vladimir Oblast",
    geonameid: 537107,
  },
  {
    name: "Labinsk",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 537281,
  },
  {
    name: "Dugulubgey",
    country: "Russia",
    subcountry: "Kabardino-Balkariya Republic",
    geonameid: 537345,
  },
  {
    name: "Kuznetsk",
    country: "Russia",
    subcountry: "Penza Oblast",
    geonameid: 537737,
  },
  {
    name: "Kuz’minki",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 537832,
  },
  {
    name: "Kuvandyk",
    country: "Russia",
    subcountry: "Orenburg Oblast",
    geonameid: 538138,
  },
  {
    name: "Kuskovo",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 538321,
  },
  {
    name: "Kushva",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 538340,
  },
  {
    name: "Kushchyovskaya",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 538416,
  },
  {
    name: "Kusa",
    country: "Russia",
    subcountry: "Chelyabinsk",
    geonameid: 538442,
  },
  {
    name: "Kur’yanovo",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 538472,
  },
  {
    name: "Kursk",
    country: "Russia",
    subcountry: "Kursk Oblast",
    geonameid: 538560,
  },
  {
    name: "Kurovskoye",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 538601,
  },
  {
    name: "Kurganinsk",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 538836,
  },
  {
    name: "Kurchatov",
    country: "Russia",
    subcountry: "Kursk Oblast",
    geonameid: 538908,
  },
  {
    name: "Kurchaloy",
    country: "Russia",
    subcountry: "Chechnya",
    geonameid: 538913,
  },
  {
    name: "Kupchino",
    country: "Russia",
    subcountry: "St.-Petersburg",
    geonameid: 539061,
  },
  {
    name: "Kungur",
    country: "Russia",
    subcountry: "Perm Krai",
    geonameid: 539147,
  },
  {
    name: "Kumertau",
    country: "Russia",
    subcountry: "Bashkortostan Republic",
    geonameid: 539283,
  },
  {
    name: "Kulebaki",
    country: "Russia",
    subcountry: "Nizhny Novgorod Oblast",
    geonameid: 539555,
  },
  {
    name: "Kukmor",
    country: "Russia",
    subcountry: "Tatarstan Republic",
    geonameid: 539689,
  },
  {
    name: "Kudymkar",
    country: "Russia",
    subcountry: "Perm Krai",
    geonameid: 539817,
  },
  {
    name: "Kudrovo",
    country: "Russia",
    subcountry: "Leningradskaya Oblast'",
    geonameid: 539839,
  },
  {
    name: "Kudepsta",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 539907,
  },
  {
    name: "Kubinka",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 540030,
  },
  {
    name: "Kstovo",
    country: "Russia",
    subcountry: "Nizhny Novgorod Oblast",
    geonameid: 540103,
  },
  {
    name: "Krymsk",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 540251,
  },
  {
    name: "Kropotkin",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 540761,
  },
  {
    name: "Kronstadt",
    country: "Russia",
    subcountry: "St.-Petersburg",
    geonameid: 540771,
  },
  {
    name: "Krasnyy Sulin",
    country: "Russia",
    subcountry: "Rostov",
    geonameid: 541404,
  },
  {
    name: "Biryulëvo Zapadnoye",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 541406,
  },
  {
    name: "Krasnoye Selo",
    country: "Russia",
    subcountry: "St.-Petersburg",
    geonameid: 542000,
  },
  {
    name: "Krasnovishersk",
    country: "Russia",
    subcountry: "Perm Krai",
    geonameid: 542184,
  },
  {
    name: "Krasnoufimsk",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 542199,
  },
  {
    name: "Krasnokamsk",
    country: "Russia",
    subcountry: "Perm Krai",
    geonameid: 542327,
  },
  {
    name: "Krasnogvardeyskoye",
    country: "Russia",
    subcountry: "Stavropol Kray",
    geonameid: 542334,
  },
  {
    name: "Krasnogorsk",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 542374,
  },
  {
    name: "Krasnodar",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 542420,
  },
  {
    name: "Krasnoarmeyskaya",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 542461,
  },
  {
    name: "Krasnoarmeysk",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 542463,
  },
  {
    name: "Krasnoarmeysk",
    country: "Russia",
    subcountry: "Saratov Oblast",
    geonameid: 542464,
  },
  {
    name: "Presnenskiy",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 542634,
  },
  {
    name: "Koz’modem’yansk",
    country: "Russia",
    subcountry: "Mariy-El Republic",
    geonameid: 543018,
  },
  {
    name: "Kozhukhovo",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 543254,
  },
  {
    name: "Kozeyevo",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 543344,
  },
  {
    name: "Kozel’sk",
    country: "Russia",
    subcountry: "Kaluga Oblast",
    geonameid: 543348,
  },
  {
    name: "Kovylkino",
    country: "Russia",
    subcountry: "Mordoviya Republic",
    geonameid: 543436,
  },
  {
    name: "Kovrov",
    country: "Russia",
    subcountry: "Vladimir Oblast",
    geonameid: 543460,
  },
  {
    name: "Kovdor",
    country: "Russia",
    subcountry: "Murmansk",
    geonameid: 543508,
  },
  {
    name: "Kotovsk",
    country: "Russia",
    subcountry: "Tambov Oblast",
    geonameid: 543605,
  },
  {
    name: "Kotovo",
    country: "Russia",
    subcountry: "Volgograd Oblast",
    geonameid: 543633,
  },
  {
    name: "Kotlas",
    country: "Russia",
    subcountry: "Arkhangelskaya",
    geonameid: 543704,
  },
  {
    name: "Kotel’nikovo",
    country: "Russia",
    subcountry: "Volgograd Oblast",
    geonameid: 543728,
  },
  {
    name: "Kotel’niki",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 543731,
  },
  {
    name: "Kotel’nich",
    country: "Russia",
    subcountry: "Kirov Oblast",
    geonameid: 543737,
  },
  {
    name: "Kostroma",
    country: "Russia",
    subcountry: "Kostroma Oblast",
    geonameid: 543878,
  },
  {
    name: "Kostomuksha",
    country: "Russia",
    subcountry: "Karelia",
    geonameid: 543899,
  },
  {
    name: "Kosaya Gora",
    country: "Russia",
    subcountry: "Tula Oblast",
    geonameid: 544293,
  },
  {
    name: "Koryazhma",
    country: "Russia",
    subcountry: "Arkhangelskaya",
    geonameid: 544370,
  },
  {
    name: "Korenovsk",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 544896,
  },
  {
    name: "Konstantinovsk",
    country: "Russia",
    subcountry: "Rostov",
    geonameid: 545277,
  },
  {
    name: "Kondopoga",
    country: "Russia",
    subcountry: "Karelia",
    geonameid: 545626,
  },
  {
    name: "Konakovo",
    country: "Russia",
    subcountry: "Tver Oblast",
    geonameid: 545673,
  },
  {
    name: "Kommunar",
    country: "Russia",
    subcountry: "Leningradskaya Oblast'",
    geonameid: 545788,
  },
  {
    name: "Kolpino",
    country: "Russia",
    subcountry: "St.-Petersburg",
    geonameid: 546105,
  },
  {
    name: "Kolomyagi",
    country: "Russia",
    subcountry: "St.-Petersburg",
    geonameid: 546225,
  },
  {
    name: "Kolomna",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 546230,
  },
  {
    name: "Kolomenskoye",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 546244,
  },
  {
    name: "Kol’chugino",
    country: "Russia",
    subcountry: "Vladimir Oblast",
    geonameid: 546521,
  },
  {
    name: "Kokhma",
    country: "Russia",
    subcountry: "Ivanovo Oblast",
    geonameid: 546672,
  },
  {
    name: "Klintsy",
    country: "Russia",
    subcountry: "Bryansk Oblast",
    geonameid: 547475,
  },
  {
    name: "Klin",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 547523,
  },
  {
    name: "Klimovsk",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 547560,
  },
  {
    name: "Kizlyar",
    country: "Russia",
    subcountry: "Dagestan",
    geonameid: 547840,
  },
  {
    name: "Kizilyurt",
    country: "Russia",
    subcountry: "Dagestan",
    geonameid: 547849,
  },
  {
    name: "Kizel",
    country: "Russia",
    subcountry: "Perm Krai",
    geonameid: 547875,
  },
  {
    name: "Kislovodsk",
    country: "Russia",
    subcountry: "Stavropol Kray",
    geonameid: 548114,
  },
  {
    name: "Kirzhach",
    country: "Russia",
    subcountry: "Vladimir Oblast",
    geonameid: 548278,
  },
  {
    name: "Kirsanov",
    country: "Russia",
    subcountry: "Tambov Oblast",
    geonameid: 548330,
  },
  {
    name: "Kirovsk",
    country: "Russia",
    subcountry: "Murmansk",
    geonameid: 548391,
  },
  {
    name: "Kirovsk",
    country: "Russia",
    subcountry: "Leningradskaya Oblast'",
    geonameid: 548392,
  },
  {
    name: "Kirovo-Chepetsk",
    country: "Russia",
    subcountry: "Kirov Oblast",
    geonameid: 548395,
  },
  {
    name: "Kirov",
    country: "Russia",
    subcountry: "Kirov Oblast",
    geonameid: 548408,
  },
  {
    name: "Kirov",
    country: "Russia",
    subcountry: "Kaluga Oblast",
    geonameid: 548410,
  },
  {
    name: "Kirishi",
    country: "Russia",
    subcountry: "Leningradskaya Oblast'",
    geonameid: 548442,
  },
  {
    name: "Kireyevsk",
    country: "Russia",
    subcountry: "Tula Oblast",
    geonameid: 548506,
  },
  {
    name: "Kingisepp",
    country: "Russia",
    subcountry: "Leningradskaya Oblast'",
    geonameid: 548602,
  },
  {
    name: "Kineshma",
    country: "Russia",
    subcountry: "Ivanovo Oblast",
    geonameid: 548605,
  },
  {
    name: "Kinel’-Cherkassy",
    country: "Russia",
    subcountry: "Samara Oblast",
    geonameid: 548622,
  },
  {
    name: "Kinel’",
    country: "Russia",
    subcountry: "Samara Oblast",
    geonameid: 548625,
  },
  {
    name: "Kimry",
    country: "Russia",
    subcountry: "Tver Oblast",
    geonameid: 548652,
  },
  {
    name: "Kimovsk",
    country: "Russia",
    subcountry: "Tula Oblast",
    geonameid: 548658,
  },
  {
    name: "Khot'kovo",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 549373,
  },
  {
    name: "Khosta",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 549424,
  },
  {
    name: "Khoroshëvo-Mnevniki",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 549479,
  },
  {
    name: "Kholmskiy",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 549741,
  },
  {
    name: "Khimki",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 550280,
  },
  {
    name: "Khasavyurt",
    country: "Russia",
    subcountry: "Dagestan",
    geonameid: 550478,
  },
  {
    name: "Kharabali",
    country: "Russia",
    subcountry: "Astrakhan Oblast",
    geonameid: 550671,
  },
  {
    name: "Khadyzhensk",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 550846,
  },
  {
    name: "Kazan",
    country: "Russia",
    subcountry: "Tatarstan Republic",
    geonameid: 551487,
  },
  {
    name: "Katav-Ivanovsk",
    country: "Russia",
    subcountry: "Chelyabinsk",
    geonameid: 551794,
  },
  {
    name: "Kastanayevo",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 551835,
  },
  {
    name: "Kaspiysk",
    country: "Russia",
    subcountry: "Dagestan",
    geonameid: 551847,
  },
  {
    name: "Kasimov",
    country: "Russia",
    subcountry: "Ryazan Oblast",
    geonameid: 551891,
  },
  {
    name: "Kashira",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 551964,
  },
  {
    name: "Kashin",
    country: "Russia",
    subcountry: "Tver Oblast",
    geonameid: 551986,
  },
  {
    name: "Karachev",
    country: "Russia",
    subcountry: "Bryansk Oblast",
    geonameid: 552920,
  },
  {
    name: "Karachayevsk",
    country: "Russia",
    subcountry: "Karachayevo-Cherkesiya Republic",
    geonameid: 552924,
  },
  {
    name: "Karabulak",
    country: "Russia",
    subcountry: "Ingushetiya Republic",
    geonameid: 552951,
  },
  {
    name: "Karabanovo",
    country: "Russia",
    subcountry: "Vladimir Oblast",
    geonameid: 552977,
  },
  {
    name: "Kapotnya",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 553034,
  },
  {
    name: "Kantyshevo",
    country: "Russia",
    subcountry: "Ingushetiya Republic",
    geonameid: 553092,
  },
  {
    name: "Kanevskaya",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 553152,
  },
  {
    name: "Kandalaksha",
    country: "Russia",
    subcountry: "Murmansk",
    geonameid: 553190,
  },
  {
    name: "Kanash",
    country: "Russia",
    subcountry: "Chuvashia",
    geonameid: 553216,
  },
  {
    name: "Kamyzyak",
    country: "Russia",
    subcountry: "Astrakhan Oblast",
    geonameid: 553248,
  },
  {
    name: "Kamyshin",
    country: "Russia",
    subcountry: "Volgograd Oblast",
    geonameid: 553287,
  },
  {
    name: "Kamensk-Shakhtinsky",
    country: "Russia",
    subcountry: "Rostov",
    geonameid: 553399,
  },
  {
    name: "Kaluga",
    country: "Russia",
    subcountry: "Kaluga Oblast",
    geonameid: 553915,
  },
  {
    name: "Kalininsk",
    country: "Russia",
    subcountry: "Saratov Oblast",
    geonameid: 554199,
  },
  {
    name: "Korolev",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 554233,
  },
  {
    name: "Kaliningrad",
    country: "Russia",
    subcountry: "Kaliningrad Oblast",
    geonameid: 554234,
  },
  {
    name: "Kalach-na-Donu",
    country: "Russia",
    subcountry: "Volgograd Oblast",
    geonameid: 554397,
  },
  {
    name: "Kalach",
    country: "Russia",
    subcountry: "Voronezh Oblast",
    geonameid: 554410,
  },
  {
    name: "Kachkanar",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 554599,
  },
  {
    name: "Kabanovo",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 554679,
  },
  {
    name: "Izobil’nyy",
    country: "Russia",
    subcountry: "Stavropol Kray",
    geonameid: 554770,
  },
  {
    name: "Izmaylovo",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 554787,
  },
  {
    name: "Izhevsk",
    country: "Russia",
    subcountry: "Udmurtiya Republic",
    geonameid: 554840,
  },
  {
    name: "Izberbash",
    country: "Russia",
    subcountry: "Dagestan",
    geonameid: 554894,
  },
  {
    name: "Ivanteyevka",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 555111,
  },
  {
    name: "Ivanovskoye",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 555129,
  },
  {
    name: "Ivanovo",
    country: "Russia",
    subcountry: "Ivanovo Oblast",
    geonameid: 555312,
  },
  {
    name: "Istra",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 555746,
  },
  {
    name: "Ishimbay",
    country: "Russia",
    subcountry: "Bashkortostan Republic",
    geonameid: 555980,
  },
  {
    name: "Ipatovo",
    country: "Russia",
    subcountry: "Stavropol Kray",
    geonameid: 556230,
  },
  {
    name: "Inza",
    country: "Russia",
    subcountry: "Ulyanovsk",
    geonameid: 556283,
  },
  {
    name: "Inozemtsevo",
    country: "Russia",
    subcountry: "Stavropol Kray",
    geonameid: 556320,
  },
  {
    name: "Il’skiy",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 556951,
  },
  {
    name: "Igra",
    country: "Russia",
    subcountry: "Udmurtiya Republic",
    geonameid: 557469,
  },
  {
    name: "Gus’-Khrustal’nyy",
    country: "Russia",
    subcountry: "Vladimir Oblast",
    geonameid: 557775,
  },
  {
    name: "Gusev",
    country: "Russia",
    subcountry: "Kaliningrad Oblast",
    geonameid: 557882,
  },
  {
    name: "Gul’kevichi",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 558066,
  },
  {
    name: "Gukovo",
    country: "Russia",
    subcountry: "Rostov",
    geonameid: 558082,
  },
  {
    name: "Gudermes",
    country: "Russia",
    subcountry: "Chechnya",
    geonameid: 558118,
  },
  {
    name: "Gubkin",
    country: "Russia",
    subcountry: "Belgorod Oblast",
    geonameid: 558146,
  },
  {
    name: "Gubakha",
    country: "Russia",
    subcountry: "Perm Krai",
    geonameid: 558209,
  },
  {
    name: "Gryazovets",
    country: "Russia",
    subcountry: "Vologda Oblast",
    geonameid: 558236,
  },
  {
    name: "Gryazi",
    country: "Russia",
    subcountry: "Lipetsk Oblast",
    geonameid: 558312,
  },
  {
    name: "Groznyy",
    country: "Russia",
    subcountry: "Chechnya",
    geonameid: 558418,
  },
  {
    name: "Gribanovskiy",
    country: "Russia",
    subcountry: "Voronezh Oblast",
    geonameid: 558799,
  },
  {
    name: "Grazhdanka",
    country: "Russia",
    subcountry: "St.-Petersburg",
    geonameid: 559029,
  },
  {
    name: "Goryachiy Klyuch",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 559317,
  },
  {
    name: "Goryachevodskiy",
    country: "Russia",
    subcountry: "Stavropol Kray",
    geonameid: 559320,
  },
  {
    name: "Gorodishche",
    country: "Russia",
    subcountry: "Volgograd Oblast",
    geonameid: 559654,
  },
  {
    name: "Gorodets",
    country: "Russia",
    subcountry: "Nizhny Novgorod Oblast",
    geonameid: 559678,
  },
  {
    name: "Gorelovo",
    country: "Russia",
    subcountry: "St.-Petersburg",
    geonameid: 560142,
  },
  {
    name: "Gol’yanovo",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 560465,
  },
  {
    name: "Golitsyno",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 560756,
  },
  {
    name: "Glazov",
    country: "Russia",
    subcountry: "Udmurtiya Republic",
    geonameid: 561347,
  },
  {
    name: "Giaginskaya",
    country: "Russia",
    subcountry: "Adygeya Republic",
    geonameid: 561515,
  },
  {
    name: "Georgiyevsk",
    country: "Russia",
    subcountry: "Stavropol Kray",
    geonameid: 561627,
  },
  {
    name: "Gelendzhik",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 561667,
  },
  {
    name: "Gay",
    country: "Russia",
    subcountry: "Orenburg Oblast",
    geonameid: 561731,
  },
  {
    name: "Gavrilov-Yam",
    country: "Russia",
    subcountry: "Yaroslavl Oblast",
    geonameid: 561762,
  },
  {
    name: "Gatchina",
    country: "Russia",
    subcountry: "Leningradskaya Oblast'",
    geonameid: 561887,
  },
  {
    name: "Galich",
    country: "Russia",
    subcountry: "Kostroma Oblast",
    geonameid: 562161,
  },
  {
    name: "Gagarin",
    country: "Russia",
    subcountry: "Smolensk Oblast",
    geonameid: 562237,
  },
  {
    name: "Furmanov",
    country: "Russia",
    subcountry: "Ivanovo Oblast",
    geonameid: 562309,
  },
  {
    name: "Fryazino",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 562319,
  },
  {
    name: "Fryazevo",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 562321,
  },
  {
    name: "Frolovo",
    country: "Russia",
    subcountry: "Volgograd Oblast",
    geonameid: 562389,
  },
  {
    name: "Fili",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 562820,
  },
  {
    name: "Ezhva",
    country: "Russia",
    subcountry: "Komi",
    geonameid: 563379,
  },
  {
    name: "Engels",
    country: "Russia",
    subcountry: "Saratov Oblast",
    geonameid: 563464,
  },
  {
    name: "Enem",
    country: "Russia",
    subcountry: "Adygeya Republic",
    geonameid: 563472,
  },
  {
    name: "Elista",
    country: "Russia",
    subcountry: "Kalmykiya Republic",
    geonameid: 563514,
  },
  {
    name: "Elektrougli",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 563522,
  },
  {
    name: "Elektrostal’",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 563523,
  },
  {
    name: "Elektrogorsk",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 563524,
  },
  {
    name: "Ekazhevo",
    country: "Russia",
    subcountry: "Ingushetiya Republic",
    geonameid: 563551,
  },
  {
    name: "Dzerzhinskiy",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 563705,
  },
  {
    name: "Dzerzhinsk",
    country: "Russia",
    subcountry: "Nizhny Novgorod Oblast",
    geonameid: 563708,
  },
  {
    name: "Dyurtyuli",
    country: "Russia",
    subcountry: "Bashkortostan Republic",
    geonameid: 563719,
  },
  {
    name: "Dyat’kovo",
    country: "Russia",
    subcountry: "Bryansk Oblast",
    geonameid: 563822,
  },
  {
    name: "Dubovka",
    country: "Russia",
    subcountry: "Volgograd Oblast",
    geonameid: 564654,
  },
  {
    name: "Dubna",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 564719,
  },
  {
    name: "Dorogomilovo",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 565197,
  },
  {
    name: "Donskoye",
    country: "Russia",
    subcountry: "Stavropol Kray",
    geonameid: 565289,
  },
  {
    name: "Donskoy",
    country: "Russia",
    subcountry: "Tula Oblast",
    geonameid: 565290,
  },
  {
    name: "Donetsk",
    country: "Russia",
    subcountry: "Rostov",
    geonameid: 565348,
  },
  {
    name: "Domodedovo",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 565381,
  },
  {
    name: "Dolgoprudnyy",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 565614,
  },
  {
    name: "Dobryanka",
    country: "Russia",
    subcountry: "Perm Krai",
    geonameid: 565778,
  },
  {
    name: "Dmitrov",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 565955,
  },
  {
    name: "Divnoye",
    country: "Russia",
    subcountry: "Stavropol Kray",
    geonameid: 566155,
  },
  {
    name: "Dinskaya",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 566181,
  },
  {
    name: "Dimitrovgrad",
    country: "Russia",
    subcountry: "Ulyanovsk",
    geonameid: 566199,
  },
  {
    name: "Desnogorsk",
    country: "Russia",
    subcountry: "Smolensk Oblast",
    geonameid: 566384,
  },
  {
    name: "Derbent",
    country: "Russia",
    subcountry: "Dagestan",
    geonameid: 566532,
  },
  {
    name: "Dedovsk",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 566854,
  },
  {
    name: "Davydkovo",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 566976,
  },
  {
    name: "Davlekanovo",
    country: "Russia",
    subcountry: "Bashkortostan Republic",
    geonameid: 567006,
  },
  {
    name: "Dankov",
    country: "Russia",
    subcountry: "Lipetsk Oblast",
    geonameid: 567109,
  },
  {
    name: "Danilov",
    country: "Russia",
    subcountry: "Yaroslavl Oblast",
    geonameid: 567183,
  },
  {
    name: "Dagestanskiye Ogni",
    country: "Russia",
    subcountry: "Dagestan",
    geonameid: 567290,
  },
  {
    name: "Dachnoye",
    country: "Russia",
    subcountry: "St.-Petersburg",
    geonameid: 567311,
  },
  {
    name: "Chusovoy",
    country: "Russia",
    subcountry: "Perm Krai",
    geonameid: 567434,
  },
  {
    name: "Chudovo",
    country: "Russia",
    subcountry: "Novgorod Oblast",
    geonameid: 567774,
  },
  {
    name: "Chistopol’",
    country: "Russia",
    subcountry: "Tatarstan Republic",
    geonameid: 567990,
  },
  {
    name: "Chishmy",
    country: "Russia",
    subcountry: "Bashkortostan Republic",
    geonameid: 568012,
  },
  {
    name: "Chernyanka",
    country: "Russia",
    subcountry: "Belgorod Oblast",
    geonameid: 568587,
  },
  {
    name: "Chernyakhovsk",
    country: "Russia",
    subcountry: "Kaliningrad Oblast",
    geonameid: 568595,
  },
  {
    name: "Chernushka",
    country: "Russia",
    subcountry: "Perm Krai",
    geonameid: 568608,
  },
  {
    name: "Chernogolovka",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 568808,
  },
  {
    name: "Cherkessk",
    country: "Russia",
    subcountry: "Karachayevo-Cherkesiya Republic",
    geonameid: 569154,
  },
  {
    name: "Cherepovets",
    country: "Russia",
    subcountry: "Vologda Oblast",
    geonameid: 569223,
  },
  {
    name: "Cherëmushki",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 569273,
  },
  {
    name: "Chekhov",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 569591,
  },
  {
    name: "Chegem",
    country: "Russia",
    subcountry: "Kabardino-Balkariya Republic",
    geonameid: 569639,
  },
  {
    name: "Cheboksary",
    country: "Russia",
    subcountry: "Chuvashia",
    geonameid: 569696,
  },
  {
    name: "Chaykovskiy",
    country: "Russia",
    subcountry: "Perm Krai",
    geonameid: 569742,
  },
  {
    name: "Chapayevsk",
    country: "Russia",
    subcountry: "Samara Oblast",
    geonameid: 569955,
  },
  {
    name: "Buzuluk",
    country: "Russia",
    subcountry: "Orenburg Oblast",
    geonameid: 570427,
  },
  {
    name: "Buynaksk",
    country: "Russia",
    subcountry: "Dagestan",
    geonameid: 570479,
  },
  {
    name: "Buy",
    country: "Russia",
    subcountry: "Kostroma Oblast",
    geonameid: 570508,
  },
  {
    name: "Buturlinovka",
    country: "Russia",
    subcountry: "Voronezh Oblast",
    geonameid: 570563,
  },
  {
    name: "Buinsk",
    country: "Russia",
    subcountry: "Tatarstan Republic",
    geonameid: 571155,
  },
  {
    name: "Buguruslan",
    country: "Russia",
    subcountry: "Orenburg Oblast",
    geonameid: 571159,
  },
  {
    name: "Bugulma",
    country: "Russia",
    subcountry: "Tatarstan Republic",
    geonameid: 571170,
  },
  {
    name: "Budyonnovsk",
    country: "Russia",
    subcountry: "Stavropol Kray",
    geonameid: 571306,
  },
  {
    name: "Bryukhovetskaya",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 571420,
  },
  {
    name: "Bryansk",
    country: "Russia",
    subcountry: "Bryansk Oblast",
    geonameid: 571476,
  },
  {
    name: "Bronnitsy",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 571557,
  },
  {
    name: "Brateyevo",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 571741,
  },
  {
    name: "Borovichi",
    country: "Russia",
    subcountry: "Novgorod Oblast",
    geonameid: 572154,
  },
  {
    name: "Borisoglebsk",
    country: "Russia",
    subcountry: "Voronezh Oblast",
    geonameid: 572525,
  },
  {
    name: "Bor",
    country: "Russia",
    subcountry: "Nizhny Novgorod Oblast",
    geonameid: 572665,
  },
  {
    name: "Bol’shaya Setun’",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 574675,
  },
  {
    name: "Bologoye",
    country: "Russia",
    subcountry: "Tver Oblast",
    geonameid: 575349,
  },
  {
    name: "Boksitogorsk",
    country: "Russia",
    subcountry: "Leningradskaya Oblast'",
    geonameid: 575410,
  },
  {
    name: "Boguchar",
    country: "Russia",
    subcountry: "Voronezh Oblast",
    geonameid: 575457,
  },
  {
    name: "Bogorodskoye",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 575505,
  },
  {
    name: "Bogorodsk",
    country: "Russia",
    subcountry: "Nizhny Novgorod Oblast",
    geonameid: 575560,
  },
  {
    name: "Bogoroditsk",
    country: "Russia",
    subcountry: "Tula Oblast",
    geonameid: 575591,
  },
  {
    name: "Bobrov",
    country: "Russia",
    subcountry: "Voronezh Oblast",
    geonameid: 575948,
  },
  {
    name: "Blagoveshchensk",
    country: "Russia",
    subcountry: "Bashkortostan Republic",
    geonameid: 576116,
  },
  {
    name: "Blagodarnyy",
    country: "Russia",
    subcountry: "Stavropol Kray",
    geonameid: 576172,
  },
  {
    name: "Biryulëvo",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 576279,
  },
  {
    name: "Birsk",
    country: "Russia",
    subcountry: "Bashkortostan Republic",
    geonameid: 576317,
  },
  {
    name: "Bibirevo",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 576432,
  },
  {
    name: "Bezhetsk",
    country: "Russia",
    subcountry: "Tver Oblast",
    geonameid: 576566,
  },
  {
    name: "Bezenchuk",
    country: "Russia",
    subcountry: "Samara Oblast",
    geonameid: 576590,
  },
  {
    name: "Beslan",
    country: "Russia",
    subcountry: "North Ossetia–Alania",
    geonameid: 576697,
  },
  {
    name: "Berezniki",
    country: "Russia",
    subcountry: "Perm Krai",
    geonameid: 577206,
  },
  {
    name: "Beloretsk",
    country: "Russia",
    subcountry: "Bashkortostan Republic",
    geonameid: 577881,
  },
  {
    name: "Belorechensk",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 577893,
  },
  {
    name: "Beloozyorskiy",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 577901,
  },
  {
    name: "Belgorod",
    country: "Russia",
    subcountry: "Belgorod Oblast",
    geonameid: 578072,
  },
  {
    name: "Belëv",
    country: "Russia",
    subcountry: "Tula Oblast",
    geonameid: 578091,
  },
  {
    name: "Belebey",
    country: "Russia",
    subcountry: "Bashkortostan Republic",
    geonameid: 578120,
  },
  {
    name: "Belaya Kalitva",
    country: "Russia",
    subcountry: "Rostov",
    geonameid: 578155,
  },
  {
    name: "Belaya Glina",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 578169,
  },
  {
    name: "Baymak",
    country: "Russia",
    subcountry: "Bashkortostan Republic",
    geonameid: 578534,
  },
  {
    name: "Bavly",
    country: "Russia",
    subcountry: "Tatarstan Republic",
    geonameid: 578638,
  },
  {
    name: "Bataysk",
    country: "Russia",
    subcountry: "Rostov",
    geonameid: 578740,
  },
  {
    name: "Barysh",
    country: "Russia",
    subcountry: "Ulyanovsk",
    geonameid: 578931,
  },
  {
    name: "Balezino",
    country: "Russia",
    subcountry: "Udmurtiya Republic",
    geonameid: 579432,
  },
  {
    name: "Balashov",
    country: "Russia",
    subcountry: "Saratov Oblast",
    geonameid: 579460,
  },
  {
    name: "Balashikha",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 579464,
  },
  {
    name: "Balakovo",
    country: "Russia",
    subcountry: "Saratov Oblast",
    geonameid: 579492,
  },
  {
    name: "Novaya Balakhna",
    country: "Russia",
    subcountry: "Nizhny Novgorod Oblast",
    geonameid: 579514,
  },
  {
    name: "Balabanovo",
    country: "Russia",
    subcountry: "Kaluga Oblast",
    geonameid: 579529,
  },
  {
    name: "Baksan",
    country: "Russia",
    subcountry: "Kabardino-Balkariya Republic",
    geonameid: 579574,
  },
  {
    name: "Bakal",
    country: "Russia",
    subcountry: "Chelyabinsk",
    geonameid: 579738,
  },
  {
    name: "Bagayevskaya",
    country: "Russia",
    subcountry: "Rostov",
    geonameid: 579771,
  },
  {
    name: "Babushkin",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 579870,
  },
  {
    name: "Azov",
    country: "Russia",
    subcountry: "Rostov",
    geonameid: 580054,
  },
  {
    name: "Avtury",
    country: "Russia",
    subcountry: "Chechnya",
    geonameid: 580218,
  },
  {
    name: "Avtovo",
    country: "Russia",
    subcountry: "St.-Petersburg",
    geonameid: 580222,
  },
  {
    name: "Atkarsk",
    country: "Russia",
    subcountry: "Saratov Oblast",
    geonameid: 580420,
  },
  {
    name: "Astrakhan",
    country: "Russia",
    subcountry: "Astrakhan Oblast",
    geonameid: 580497,
  },
  {
    name: "Asha",
    country: "Russia",
    subcountry: "Chelyabinsk",
    geonameid: 580660,
  },
  {
    name: "Arzgir",
    country: "Russia",
    subcountry: "Stavropol Kray",
    geonameid: 580716,
  },
  {
    name: "Arzamas",
    country: "Russia",
    subcountry: "Nizhny Novgorod Oblast",
    geonameid: 580724,
  },
  {
    name: "Arsk",
    country: "Russia",
    subcountry: "Tatarstan Republic",
    geonameid: 580850,
  },
  {
    name: "Armavir",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 580922,
  },
  {
    name: "Arkhangel’sk",
    country: "Russia",
    subcountry: "Arkhangelskaya",
    geonameid: 581049,
  },
  {
    name: "Argun",
    country: "Russia",
    subcountry: "Chechnya",
    geonameid: 581126,
  },
  {
    name: "Ardon",
    country: "Russia",
    subcountry: "North Ossetia–Alania",
    geonameid: 581179,
  },
  {
    name: "Apsheronsk",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 581313,
  },
  {
    name: "Aprelevka",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 581321,
  },
  {
    name: "Apatity",
    country: "Russia",
    subcountry: "Murmansk",
    geonameid: 581357,
  },
  {
    name: "Anna",
    country: "Russia",
    subcountry: "Voronezh Oblast",
    geonameid: 581671,
  },
  {
    name: "Andreyevskoye",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 581928,
  },
  {
    name: "Anapa",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 582182,
  },
  {
    name: "Amin’yevo",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 582266,
  },
  {
    name: "Al’met’yevsk",
    country: "Russia",
    subcountry: "Tatarstan Republic",
    geonameid: 582432,
  },
  {
    name: "Aleksin",
    country: "Russia",
    subcountry: "Tula Oblast",
    geonameid: 582750,
  },
  {
    name: "Alekseyevka",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 582846,
  },
  {
    name: "Alexeyevka",
    country: "Russia",
    subcountry: "Belgorod Oblast",
    geonameid: 582956,
  },
  {
    name: "Aleksandrovskoye",
    country: "Russia",
    subcountry: "Stavropol Kray",
    geonameid: 582993,
  },
  {
    name: "Aleksandrovsk",
    country: "Russia",
    subcountry: "Perm Krai",
    geonameid: 583041,
  },
  {
    name: "Aleksandrov",
    country: "Russia",
    subcountry: "Vladimir Oblast",
    geonameid: 583350,
  },
  {
    name: "Alatyr’",
    country: "Russia",
    subcountry: "Chuvashia",
    geonameid: 583437,
  },
  {
    name: "Levoberezhnyy",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 583589,
  },
  {
    name: "Aksay",
    country: "Russia",
    subcountry: "Rostov",
    geonameid: 583673,
  },
  {
    name: "Akhtyrskiy",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 583785,
  },
  {
    name: "Akhtubinsk",
    country: "Russia",
    subcountry: "Astrakhan Oblast",
    geonameid: 583798,
  },
  {
    name: "Agryz",
    country: "Russia",
    subcountry: "Tatarstan Republic",
    geonameid: 583983,
  },
  {
    name: "Afipskiy",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 584126,
  },
  {
    name: "Adler",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 584243,
  },
  {
    name: "Achkhoy-Martan",
    country: "Russia",
    subcountry: "Chechnya",
    geonameid: 584298,
  },
  {
    name: "Abinsk",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 584441,
  },
  {
    name: "Abdulino",
    country: "Russia",
    subcountry: "Orenburg Oblast",
    geonameid: 584471,
  },
  {
    name: "Vasil’yevo",
    country: "Russia",
    subcountry: "Tatarstan Republic",
    geonameid: 611182,
  },
  {
    name: "Ryl’sk",
    country: "Russia",
    subcountry: "Kursk Oblast",
    geonameid: 695019,
  },
  {
    name: "Neftekumsk",
    country: "Russia",
    subcountry: "Stavropol Kray",
    geonameid: 797781,
  },
  {
    name: "Alagir",
    country: "Russia",
    subcountry: "North Ossetia–Alania",
    geonameid: 802078,
  },
  {
    name: "Persianovka",
    country: "Russia",
    subcountry: "Rostov",
    geonameid: 802714,
  },
  {
    name: "Annino",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 819552,
  },
  {
    name: "Dagomys",
    country: "Russia",
    subcountry: "Krasnodar Krai",
    geonameid: 823674,
  },
  {
    name: "Pavlovo",
    country: "Russia",
    subcountry: "Nizhny Novgorod Oblast",
    geonameid: 827329,
  },
  {
    name: "Belidzhi",
    country: "Russia",
    subcountry: "Dagestan",
    geonameid: 828055,
  },
  {
    name: "Lesnoy",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 829005,
  },
  {
    name: "Trëkhgornyy",
    country: "Russia",
    subcountry: "Chelyabinsk",
    geonameid: 830844,
  },
  {
    name: "Mirnyy",
    country: "Russia",
    subcountry: "Arkhangelskaya",
    geonameid: 831129,
  },
  {
    name: "Znamensk",
    country: "Russia",
    subcountry: "Astrakhan Oblast",
    geonameid: 831130,
  },
  {
    name: "Zarechnyy",
    country: "Russia",
    subcountry: "Penza Oblast",
    geonameid: 831165,
  },
  {
    name: "Kochubeyevskoye",
    country: "Russia",
    subcountry: "Stavropol Kray",
    geonameid: 841006,
  },
  {
    name: "Vnukovo",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 857689,
  },
  {
    name: "Moskovskiy",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 857690,
  },
  {
    name: "Usinsk",
    country: "Russia",
    subcountry: "Komi",
    geonameid: 863061,
  },
  {
    name: "Obukhovo",
    country: "Russia",
    subcountry: "St.-Petersburg",
    geonameid: 873901,
  },
  {
    name: "Staryy Malgobek",
    country: "Russia",
    subcountry: "Ingushetiya Republic",
    geonameid: 874045,
  },
  {
    name: "Zavodoukovsk",
    country: "Russia",
    subcountry: "Tyumen Oblast",
    geonameid: 1485357,
  },
  {
    name: "Zarinsk",
    country: "Russia",
    subcountry: "Altai Krai",
    geonameid: 1485439,
  },
  {
    name: "Zarechnyy",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 1485445,
  },
  {
    name: "Yuzhnyy",
    country: "Russia",
    subcountry: "Altai Krai",
    geonameid: 1485627,
  },
  {
    name: "Yuzhnoural’sk",
    country: "Russia",
    subcountry: "Chelyabinsk",
    geonameid: 1485634,
  },
  {
    name: "Yurga",
    country: "Russia",
    subcountry: "Kuzbass",
    geonameid: 1485724,
  },
  {
    name: "Yeniseysk",
    country: "Russia",
    subcountry: "Krasnoyarsk Krai",
    geonameid: 1485997,
  },
  {
    name: "Yemanzhelinsk",
    country: "Russia",
    subcountry: "Chelyabinsk",
    geonameid: 1486039,
  },
  {
    name: "Yekaterinburg",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 1486209,
  },
  {
    name: "Yashkino",
    country: "Russia",
    subcountry: "Kuzbass",
    geonameid: 1486298,
  },
  {
    name: "Yarovoye",
    country: "Russia",
    subcountry: "Altai Krai",
    geonameid: 1486340,
  },
  {
    name: "Yalutorovsk",
    country: "Russia",
    subcountry: "Tyumen Oblast",
    geonameid: 1486468,
  },
  {
    name: "Vorkuta",
    country: "Russia",
    subcountry: "Komi",
    geonameid: 1486910,
  },
  {
    name: "Vorgashor",
    country: "Russia",
    subcountry: "Komi",
    geonameid: 1486913,
  },
  {
    name: "Verkhnyaya Salda",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 1487277,
  },
  {
    name: "Verkhnyaya Pyshma",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 1487281,
  },
  {
    name: "Verkhniy Ufaley",
    country: "Russia",
    subcountry: "Chelyabinsk",
    geonameid: 1487394,
  },
  {
    name: "Uzhur",
    country: "Russia",
    subcountry: "Krasnoyarsk Krai",
    geonameid: 1487882,
  },
  {
    name: "Zelenogorsk",
    country: "Russia",
    subcountry: "Krasnoyarsk Krai",
    geonameid: 1488253,
  },
  {
    name: "Uray",
    country: "Russia",
    subcountry: "Khanty-Mansia",
    geonameid: 1488429,
  },
  {
    name: "Tyumen",
    country: "Russia",
    subcountry: "Tyumen Oblast",
    geonameid: 1488754,
  },
  {
    name: "Turinsk",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 1488933,
  },
  {
    name: "Troitsk",
    country: "Russia",
    subcountry: "Chelyabinsk",
    geonameid: 1489246,
  },
  {
    name: "Topki",
    country: "Russia",
    subcountry: "Kuzbass",
    geonameid: 1489394,
  },
  {
    name: "Tomsk",
    country: "Russia",
    subcountry: "Tomsk Oblast",
    geonameid: 1489425,
  },
  {
    name: "Toguchin",
    country: "Russia",
    subcountry: "Novosibirsk Oblast",
    geonameid: 1489508,
  },
  {
    name: "Tobolsk",
    country: "Russia",
    subcountry: "Tyumen Oblast",
    geonameid: 1489530,
  },
  {
    name: "Tayshet",
    country: "Russia",
    subcountry: "Irkutsk Oblast",
    geonameid: 1489870,
  },
  {
    name: "Tayga",
    country: "Russia",
    subcountry: "Kuzbass",
    geonameid: 1489907,
  },
  {
    name: "Tavda",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 1489962,
  },
  {
    name: "Tatarsk",
    country: "Russia",
    subcountry: "Novosibirsk Oblast",
    geonameid: 1490003,
  },
  {
    name: "Tashtagol",
    country: "Russia",
    subcountry: "Kuzbass",
    geonameid: 1490042,
  },
  {
    name: "Tarko-Sale",
    country: "Russia",
    subcountry: "Yamalo-Nenets",
    geonameid: 1490085,
  },
  {
    name: "Tara",
    country: "Russia",
    subcountry: "Omsk Oblast",
    geonameid: 1490140,
  },
  {
    name: "Talnakh",
    country: "Russia",
    subcountry: "Krasnoyarsk Krai",
    geonameid: 1490256,
  },
  {
    name: "Tal’menka",
    country: "Russia",
    subcountry: "Altai Krai",
    geonameid: 1490266,
  },
  {
    name: "Talitsa",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 1490277,
  },
  {
    name: "Talitsa",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 1490281,
  },
  {
    name: "Sysert’",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 1490402,
  },
  {
    name: "Suzun",
    country: "Russia",
    subcountry: "Novosibirsk Oblast",
    geonameid: 1490551,
  },
  {
    name: "Surgut",
    country: "Russia",
    subcountry: "Khanty-Mansia",
    geonameid: 1490624,
  },
  {
    name: "Sukhoy Log",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 1490686,
  },
  {
    name: "Strezhevoy",
    country: "Russia",
    subcountry: "Tomsk Oblast",
    geonameid: 1490796,
  },
  {
    name: "Sredneuralsk",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 1491159,
  },
  {
    name: "Sovetskiy",
    country: "Russia",
    subcountry: "Khanty-Mansia",
    geonameid: 1491230,
  },
  {
    name: "Sosnovoborsk",
    country: "Russia",
    subcountry: "Krasnoyarsk Krai",
    geonameid: 1491291,
  },
  {
    name: "Slavgorod",
    country: "Russia",
    subcountry: "Altai Krai",
    geonameid: 1491706,
  },
  {
    name: "Shushenskoye",
    country: "Russia",
    subcountry: "Krasnoyarsk Krai",
    geonameid: 1491953,
  },
  {
    name: "Shumikha",
    country: "Russia",
    subcountry: "Kurgan Oblast",
    geonameid: 1491999,
  },
  {
    name: "Sharypovo",
    country: "Russia",
    subcountry: "Krasnoyarsk Krai",
    geonameid: 1492401,
  },
  {
    name: "Shadrinsk",
    country: "Russia",
    subcountry: "Kurgan Oblast",
    geonameid: 1492517,
  },
  {
    name: "Serov",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 1492663,
  },
  {
    name: "Sayanogorsk",
    country: "Russia",
    subcountry: "Khakasiya Republic",
    geonameid: 1492893,
  },
  {
    name: "Salekhard",
    country: "Russia",
    subcountry: "Yamalo-Nenets",
    geonameid: 1493197,
  },
  {
    name: "Rubtsovsk",
    country: "Russia",
    subcountry: "Altai Krai",
    geonameid: 1493467,
  },
  {
    name: "Rezh",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 1493648,
  },
  {
    name: "Reftinskiy",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 1493687,
  },
  {
    name: "Promyshlennaya",
    country: "Russia",
    subcountry: "Kuzbass",
    geonameid: 1494091,
  },
  {
    name: "Prokop’yevsk",
    country: "Russia",
    subcountry: "Kuzbass",
    geonameid: 1494114,
  },
  {
    name: "Poykovskiy",
    country: "Russia",
    subcountry: "Khanty-Mansia",
    geonameid: 1494276,
  },
  {
    name: "Polysayevo",
    country: "Russia",
    subcountry: "Kuzbass",
    geonameid: 1494456,
  },
  {
    name: "Polevskoy",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 1494573,
  },
  {
    name: "Plast",
    country: "Russia",
    subcountry: "Chelyabinsk",
    geonameid: 1494907,
  },
  {
    name: "Osinniki",
    country: "Russia",
    subcountry: "Kuzbass",
    geonameid: 1495974,
  },
  {
    name: "Omsk",
    country: "Russia",
    subcountry: "Omsk Oblast",
    geonameid: 1496153,
  },
  {
    name: "Ob’",
    country: "Russia",
    subcountry: "Novosibirsk Oblast",
    geonameid: 1496421,
  },
  {
    name: "Nyagan",
    country: "Russia",
    subcountry: "Khanty-Mansia",
    geonameid: 1496476,
  },
  {
    name: "Noyabrsk",
    country: "Russia",
    subcountry: "Yamalo-Nenets",
    geonameid: 1496503,
  },
  {
    name: "Novyy Urengoy",
    country: "Russia",
    subcountry: "Yamalo-Nenets",
    geonameid: 1496511,
  },
  {
    name: "Novosilikatnyy",
    country: "Russia",
    subcountry: "Altai Krai",
    geonameid: 1496739,
  },
  {
    name: "Novosibirsk",
    country: "Russia",
    subcountry: "Novosibirsk Oblast",
    geonameid: 1496747,
  },
  {
    name: "Novokuznetsk",
    country: "Russia",
    subcountry: "Kuzbass",
    geonameid: 1496990,
  },
  {
    name: "Novoaltaysk",
    country: "Russia",
    subcountry: "Altai Krai",
    geonameid: 1497173,
  },
  {
    name: "Norilsk",
    country: "Russia",
    subcountry: "Krasnoyarsk Krai",
    geonameid: 1497337,
  },
  {
    name: "Nizhnyaya Salda",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 1497393,
  },
  {
    name: "Nizhnevartovsk",
    country: "Russia",
    subcountry: "Khanty-Mansia",
    geonameid: 1497543,
  },
  {
    name: "Nizhneudinsk",
    country: "Russia",
    subcountry: "Irkutsk Oblast",
    geonameid: 1497549,
  },
  {
    name: "Nev’yansk",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 1497795,
  },
  {
    name: "Nefteyugansk",
    country: "Russia",
    subcountry: "Khanty-Mansia",
    geonameid: 1497917,
  },
  {
    name: "Nazarovo",
    country: "Russia",
    subcountry: "Krasnoyarsk Krai",
    geonameid: 1497951,
  },
  {
    name: "Nadym",
    country: "Russia",
    subcountry: "Yamalo-Nenets",
    geonameid: 1498087,
  },
  {
    name: "Myski",
    country: "Russia",
    subcountry: "Kuzbass",
    geonameid: 1498129,
  },
  {
    name: "Minusinsk",
    country: "Russia",
    subcountry: "Krasnoyarsk Krai",
    geonameid: 1498693,
  },
  {
    name: "Miass",
    country: "Russia",
    subcountry: "Chelyabinsk",
    geonameid: 1498894,
  },
  {
    name: "Mezhdurechensk",
    country: "Russia",
    subcountry: "Kuzbass",
    geonameid: 1498920,
  },
  {
    name: "Megion",
    country: "Russia",
    subcountry: "Khanty-Mansia",
    geonameid: 1499053,
  },
  {
    name: "Mayma",
    country: "Russia",
    subcountry: "Altai",
    geonameid: 1499163,
  },
  {
    name: "Mariinsk",
    country: "Russia",
    subcountry: "Kuzbass",
    geonameid: 1499350,
  },
  {
    name: "Linëvo",
    country: "Russia",
    subcountry: "Novosibirsk Oblast",
    geonameid: 1500532,
  },
  {
    name: "Lesosibirsk",
    country: "Russia",
    subcountry: "Krasnoyarsk Krai",
    geonameid: 1500607,
  },
  {
    name: "Leninsk-Kuznetsky",
    country: "Russia",
    subcountry: "Kuzbass",
    geonameid: 1500665,
  },
  {
    name: "Labytnangi",
    country: "Russia",
    subcountry: "Yamalo-Nenets",
    geonameid: 1500933,
  },
  {
    name: "Kyzyl",
    country: "Russia",
    subcountry: "Republic of Tyva",
    geonameid: 1500973,
  },
  {
    name: "Kyshtym",
    country: "Russia",
    subcountry: "Chelyabinsk",
    geonameid: 1500997,
  },
  {
    name: "Kuybyshev",
    country: "Russia",
    subcountry: "Novosibirsk Oblast",
    geonameid: 1501141,
  },
  {
    name: "Kurtamysh",
    country: "Russia",
    subcountry: "Kurgan Oblast",
    geonameid: 1501255,
  },
  {
    name: "Kurgan",
    country: "Russia",
    subcountry: "Kurgan Oblast",
    geonameid: 1501321,
  },
  {
    name: "Kupino",
    country: "Russia",
    subcountry: "Novosibirsk Oblast",
    geonameid: 1501365,
  },
  {
    name: "Kulunda",
    country: "Russia",
    subcountry: "Altai Krai",
    geonameid: 1501460,
  },
  {
    name: "Krasnoyarsk",
    country: "Russia",
    subcountry: "Krasnoyarsk Krai",
    geonameid: 1502026,
  },
  {
    name: "Krasnoural’sk",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 1502060,
  },
  {
    name: "Krasnoturinsk",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 1502061,
  },
  {
    name: "Krasnoobsk",
    country: "Russia",
    subcountry: "Novosibirsk Oblast",
    geonameid: 1502091,
  },
  {
    name: "Korkino",
    country: "Russia",
    subcountry: "Chelyabinsk",
    geonameid: 1502536,
  },
  {
    name: "Kopeysk",
    country: "Russia",
    subcountry: "Chelyabinsk",
    geonameid: 1502603,
  },
  {
    name: "Yugorsk",
    country: "Russia",
    subcountry: "Khanty-Mansia",
    geonameid: 1502725,
  },
  {
    name: "Kolpashevo",
    country: "Russia",
    subcountry: "Tomsk Oblast",
    geonameid: 1502862,
  },
  {
    name: "Kodinsk",
    country: "Russia",
    subcountry: "Krasnoyarsk Krai",
    geonameid: 1503037,
  },
  {
    name: "Kochenëvo",
    country: "Russia",
    subcountry: "Novosibirsk Oblast",
    geonameid: 1503082,
  },
  {
    name: "Kiselëvsk",
    country: "Russia",
    subcountry: "Kuzbass",
    geonameid: 1503277,
  },
  {
    name: "Kirovgrad",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 1503335,
  },
  {
    name: "Khanty-Mansiysk",
    country: "Russia",
    subcountry: "Khanty-Mansia",
    geonameid: 1503772,
  },
  {
    name: "Kemerovo",
    country: "Russia",
    subcountry: "Kuzbass",
    geonameid: 1503901,
  },
  {
    name: "Kedrovka",
    country: "Russia",
    subcountry: "Kuzbass",
    geonameid: 1503940,
  },
  {
    name: "Kayyerkan",
    country: "Russia",
    subcountry: "Krasnoyarsk Krai",
    geonameid: 1504139,
  },
  {
    name: "Kataysk",
    country: "Russia",
    subcountry: "Kurgan Oblast",
    geonameid: 1504212,
  },
  {
    name: "Kasli",
    country: "Russia",
    subcountry: "Chelyabinsk",
    geonameid: 1504251,
  },
  {
    name: "Kartaly",
    country: "Russia",
    subcountry: "Chelyabinsk",
    geonameid: 1504317,
  },
  {
    name: "Karpinsk",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 1504343,
  },
  {
    name: "Karasuk",
    country: "Russia",
    subcountry: "Novosibirsk Oblast",
    geonameid: 1504489,
  },
  {
    name: "Karabash",
    country: "Russia",
    subcountry: "Chelyabinsk",
    geonameid: 1504636,
  },
  {
    name: "Kansk",
    country: "Russia",
    subcountry: "Krasnoyarsk Krai",
    geonameid: 1504682,
  },
  {
    name: "Kamyshlov",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 1504769,
  },
  {
    name: "Kamensk-Ural’skiy",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 1504826,
  },
  {
    name: "Kamen’-na-Obi",
    country: "Russia",
    subcountry: "Altai Krai",
    geonameid: 1504871,
  },
  {
    name: "Kaltan",
    country: "Russia",
    subcountry: "Kuzbass",
    geonameid: 1504972,
  },
  {
    name: "Kalachinsk",
    country: "Russia",
    subcountry: "Omsk Oblast",
    geonameid: 1505074,
  },
  {
    name: "Ivdel’",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 1505260,
  },
  {
    name: "Iskitim",
    country: "Russia",
    subcountry: "Novosibirsk Oblast",
    geonameid: 1505429,
  },
  {
    name: "Ishim",
    country: "Russia",
    subcountry: "Tyumen Oblast",
    geonameid: 1505453,
  },
  {
    name: "Irbit",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 1505526,
  },
  {
    name: "Ilanskiy",
    country: "Russia",
    subcountry: "Krasnoyarsk Krai",
    geonameid: 1505933,
  },
  {
    name: "Gur’yevsk",
    country: "Russia",
    subcountry: "Kuzbass",
    geonameid: 1506073,
  },
  {
    name: "Gornyak",
    country: "Russia",
    subcountry: "Altai Krai",
    geonameid: 1506260,
  },
  {
    name: "Gorno-Altaysk",
    country: "Russia",
    subcountry: "Altai",
    geonameid: 1506271,
  },
  {
    name: "Dudinka",
    country: "Russia",
    subcountry: "Krasnoyarsk Krai",
    geonameid: 1507116,
  },
  {
    name: "Divnogorsk",
    country: "Russia",
    subcountry: "Krasnoyarsk Krai",
    geonameid: 1507379,
  },
  {
    name: "Degtyarsk",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 1507488,
  },
  {
    name: "Chunskiy",
    country: "Russia",
    subcountry: "Irkutsk Oblast",
    geonameid: 1507636,
  },
  {
    name: "Chernogorsk",
    country: "Russia",
    subcountry: "Khakasiya Republic",
    geonameid: 1508054,
  },
  {
    name: "Cherepanovo",
    country: "Russia",
    subcountry: "Novosibirsk Oblast",
    geonameid: 1508161,
  },
  {
    name: "Chelyabinsk",
    country: "Russia",
    subcountry: "Chelyabinsk",
    geonameid: 1508291,
  },
  {
    name: "Chebarkul’",
    country: "Russia",
    subcountry: "Chelyabinsk",
    geonameid: 1508350,
  },
  {
    name: "Borovskiy",
    country: "Russia",
    subcountry: "Tyumen Oblast",
    geonameid: 1508879,
  },
  {
    name: "Borodino",
    country: "Russia",
    subcountry: "Krasnoyarsk Krai",
    geonameid: 1508943,
  },
  {
    name: "Bolotnoye",
    country: "Russia",
    subcountry: "Novosibirsk Oblast",
    geonameid: 1509819,
  },
  {
    name: "Bogotol",
    country: "Russia",
    subcountry: "Krasnoyarsk Krai",
    geonameid: 1509852,
  },
  {
    name: "Bogdanovich",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 1509888,
  },
  {
    name: "Biysk",
    country: "Russia",
    subcountry: "Altai Krai",
    geonameid: 1510018,
  },
  {
    name: "Beryozovsky",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 1510203,
  },
  {
    name: "Berëzovskiy",
    country: "Russia",
    subcountry: "Kuzbass",
    geonameid: 1510205,
  },
  {
    name: "Berëzovka",
    country: "Russia",
    subcountry: "Krasnoyarsk Krai",
    geonameid: 1510255,
  },
  {
    name: "Berdsk",
    country: "Russia",
    subcountry: "Novosibirsk Oblast",
    geonameid: 1510350,
  },
  {
    name: "Beloyarskiy",
    country: "Russia",
    subcountry: "Khanty-Mansia",
    geonameid: 1510450,
  },
  {
    name: "Belovo",
    country: "Russia",
    subcountry: "Kuzbass",
    geonameid: 1510469,
  },
  {
    name: "Barnaul",
    country: "Russia",
    subcountry: "Altai Krai",
    geonameid: 1510853,
  },
  {
    name: "Barabinsk",
    country: "Russia",
    subcountry: "Novosibirsk Oblast",
    geonameid: 1510916,
  },
  {
    name: "Asino",
    country: "Russia",
    subcountry: "Tomsk Oblast",
    geonameid: 1511309,
  },
  {
    name: "Asbest",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 1511330,
  },
  {
    name: "Artëmovskiy",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 1511368,
  },
  {
    name: "Aramil",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 1511466,
  },
  {
    name: "Anzhero-Sudzhensk",
    country: "Russia",
    subcountry: "Kuzbass",
    geonameid: 1511494,
  },
  {
    name: "Aleysk",
    country: "Russia",
    subcountry: "Altai Krai",
    geonameid: 1511783,
  },
  {
    name: "Alapayevsk",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 1511954,
  },
  {
    name: "Akademgorodok",
    country: "Russia",
    subcountry: "Novosibirsk Oblast",
    geonameid: 1512086,
  },
  {
    name: "Achinsk",
    country: "Russia",
    subcountry: "Krasnoyarsk Krai",
    geonameid: 1512165,
  },
  {
    name: "Abaza",
    country: "Russia",
    subcountry: "Khakasiya Republic",
    geonameid: 1512205,
  },
  {
    name: "Abakan",
    country: "Russia",
    subcountry: "Khakasiya Republic",
    geonameid: 1512236,
  },
  {
    name: "Snezhinsk",
    country: "Russia",
    subcountry: "Chelyabinsk",
    geonameid: 1536289,
  },
  {
    name: "Ozersk",
    country: "Russia",
    subcountry: "Chelyabinsk",
    geonameid: 1538634,
  },
  {
    name: "Zheleznogorsk",
    country: "Russia",
    subcountry: "Krasnoyarsk Krai",
    geonameid: 1538635,
  },
  {
    name: "Novoural’sk",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 1538636,
  },
  {
    name: "Seversk",
    country: "Russia",
    subcountry: "Tomsk Oblast",
    geonameid: 1538637,
  },
  {
    name: "Gubkinskiy",
    country: "Russia",
    subcountry: "Yamalo-Nenets",
    geonameid: 1539209,
  },
  {
    name: "Raduzhny",
    country: "Russia",
    subcountry: "Khanty-Mansia",
    geonameid: 1540356,
  },
  {
    name: "Muravlenko",
    country: "Russia",
    subcountry: "Yamalo-Nenets",
    geonameid: 1540711,
  },
  {
    name: "Lyantor",
    country: "Russia",
    subcountry: "Khanty-Mansia",
    geonameid: 1541359,
  },
  {
    name: "Zima",
    country: "Russia",
    subcountry: "Irkutsk Oblast",
    geonameid: 2012484,
  },
  {
    name: "Zheleznogorsk-Ilimskiy",
    country: "Russia",
    subcountry: "Irkutsk Oblast",
    geonameid: 2012557,
  },
  {
    name: "Zeya",
    country: "Russia",
    subcountry: "Amur Oblast",
    geonameid: 2012593,
  },
  {
    name: "Yakutsk",
    country: "Russia",
    subcountry: "Sakha",
    geonameid: 2013159,
  },
  {
    name: "Vyazemskiy",
    country: "Russia",
    subcountry: "Khabarovsk",
    geonameid: 2013229,
  },
  {
    name: "Vrangel’",
    country: "Russia",
    subcountry: "Primorye",
    geonameid: 2013258,
  },
  {
    name: "Vladivostok",
    country: "Russia",
    subcountry: "Primorye",
    geonameid: 2013348,
  },
  {
    name: "Vikhorevka",
    country: "Russia",
    subcountry: "Irkutsk Oblast",
    geonameid: 2013399,
  },
  {
    name: "Ust’-Kut",
    country: "Russia",
    subcountry: "Irkutsk Oblast",
    geonameid: 2013923,
  },
  {
    name: "Ust’-Ilimsk",
    country: "Russia",
    subcountry: "Irkutsk Oblast",
    geonameid: 2013952,
  },
  {
    name: "Ussuriysk",
    country: "Russia",
    subcountry: "Primorye",
    geonameid: 2014006,
  },
  {
    name: "Usol’ye-Sibirskoye",
    country: "Russia",
    subcountry: "Irkutsk Oblast",
    geonameid: 2014022,
  },
  {
    name: "Ulan-Ude",
    country: "Russia",
    subcountry: "Buryatiya Republic",
    geonameid: 2014407,
  },
  {
    name: "Udachny",
    country: "Russia",
    subcountry: "Sakha",
    geonameid: 2014624,
  },
  {
    name: "Tynda",
    country: "Russia",
    subcountry: "Amur Oblast",
    geonameid: 2014718,
  },
  {
    name: "Tulun",
    country: "Russia",
    subcountry: "Irkutsk Oblast",
    geonameid: 2014927,
  },
  {
    name: "Trudovoye",
    country: "Russia",
    subcountry: "Primorye",
    geonameid: 2015051,
  },
  {
    name: "Fokino",
    country: "Russia",
    subcountry: "Primorye",
    geonameid: 2015310,
  },
  {
    name: "Svobodnyy",
    country: "Russia",
    subcountry: "Amur Oblast",
    geonameid: 2015833,
  },
  {
    name: "Spassk-Dal’niy",
    country: "Russia",
    subcountry: "Primorye",
    geonameid: 2016187,
  },
  {
    name: "Slyudyanka",
    country: "Russia",
    subcountry: "Irkutsk Oblast",
    geonameid: 2016422,
  },
  {
    name: "Shimanovsk",
    country: "Russia",
    subcountry: "Amur Oblast",
    geonameid: 2016701,
  },
  {
    name: "Shelekhov",
    country: "Russia",
    subcountry: "Irkutsk Oblast",
    geonameid: 2016764,
  },
  {
    name: "Severobaykal’sk",
    country: "Russia",
    subcountry: "Buryatiya Republic",
    geonameid: 2016910,
  },
  {
    name: "Raychikhinsk",
    country: "Russia",
    subcountry: "Amur Oblast",
    geonameid: 2017487,
  },
  {
    name: "Petrovsk-Zabaykal’skiy",
    country: "Russia",
    subcountry: "Zabaykalskiy (Transbaikal) Kray",
    geonameid: 2017945,
  },
  {
    name: "Partizansk",
    country: "Russia",
    subcountry: "Primorye",
    geonameid: 2018116,
  },
  {
    name: "Neryungri",
    country: "Russia",
    subcountry: "Sakha",
    geonameid: 2019309,
  },
  {
    name: "Nerchinsk",
    country: "Russia",
    subcountry: "Zabaykalskiy (Transbaikal) Kray",
    geonameid: 2019326,
  },
  {
    name: "Nakhodka",
    country: "Russia",
    subcountry: "Primorye",
    geonameid: 2019528,
  },
  {
    name: "Mirny",
    country: "Russia",
    subcountry: "Sakha",
    geonameid: 2019951,
  },
  {
    name: "Luchegorsk",
    country: "Russia",
    subcountry: "Primorye",
    geonameid: 2020689,
  },
  {
    name: "Lesozavodsk",
    country: "Russia",
    subcountry: "Primorye",
    geonameid: 2020812,
  },
  {
    name: "Lensk",
    country: "Russia",
    subcountry: "Sakha",
    geonameid: 2020838,
  },
  {
    name: "Kyakhta",
    country: "Russia",
    subcountry: "Buryatiya Republic",
    geonameid: 2021066,
  },
  {
    name: "Krasnokamensk",
    country: "Russia",
    subcountry: "Zabaykalskiy (Transbaikal) Kray",
    geonameid: 2021618,
  },
  {
    name: "Komsomolsk-on-Amur",
    country: "Russia",
    subcountry: "Khabarovsk",
    geonameid: 2021851,
  },
  {
    name: "Khabarovsk",
    country: "Russia",
    subcountry: "Khabarovsk",
    geonameid: 2022890,
  },
  {
    name: "Kavalerovo",
    country: "Russia",
    subcountry: "Primorye",
    geonameid: 2023058,
  },
  {
    name: "Irkutsk",
    country: "Russia",
    subcountry: "Irkutsk Oblast",
    geonameid: 2023469,
  },
  {
    name: "Gusinoozyorsk",
    country: "Russia",
    subcountry: "Buryatiya Republic",
    geonameid: 2023782,
  },
  {
    name: "Dalnerechensk",
    country: "Russia",
    subcountry: "Primorye",
    geonameid: 2025159,
  },
  {
    name: "Chita",
    country: "Russia",
    subcountry: "Zabaykalskiy (Transbaikal) Kray",
    geonameid: 2025339,
  },
  {
    name: "Cheremkhovo",
    country: "Russia",
    subcountry: "Irkutsk Oblast",
    geonameid: 2025527,
  },
  {
    name: "Borzya",
    country: "Russia",
    subcountry: "Zabaykalskiy (Transbaikal) Kray",
    geonameid: 2026126,
  },
  {
    name: "Bol’shoy Kamen’",
    country: "Russia",
    subcountry: "Primorye",
    geonameid: 2026303,
  },
  {
    name: "Bodaybo",
    country: "Russia",
    subcountry: "Irkutsk Oblast",
    geonameid: 2026583,
  },
  {
    name: "Blagoveshchensk",
    country: "Russia",
    subcountry: "Amur Oblast",
    geonameid: 2026609,
  },
  {
    name: "Birobidzhan",
    country: "Russia",
    subcountry: "Jewish Autonomous Oblast",
    geonameid: 2026643,
  },
  {
    name: "Bikin",
    country: "Russia",
    subcountry: "Khabarovsk",
    geonameid: 2026696,
  },
  {
    name: "Belogorsk",
    country: "Russia",
    subcountry: "Amur Oblast",
    geonameid: 2026895,
  },
  {
    name: "Baykal’sk",
    country: "Russia",
    subcountry: "Irkutsk Oblast",
    geonameid: 2026979,
  },
  {
    name: "Aykhal",
    country: "Russia",
    subcountry: "Sakha",
    geonameid: 2027296,
  },
  {
    name: "Artëm",
    country: "Russia",
    subcountry: "Primorye",
    geonameid: 2027456,
  },
  {
    name: "Arsen’yev",
    country: "Russia",
    subcountry: "Primorye",
    geonameid: 2027468,
  },
  {
    name: "Angarsk",
    country: "Russia",
    subcountry: "Irkutsk Oblast",
    geonameid: 2027667,
  },
  {
    name: "Amursk",
    country: "Russia",
    subcountry: "Khabarovsk",
    geonameid: 2027749,
  },
  {
    name: "Aldan",
    country: "Russia",
    subcountry: "Sakha",
    geonameid: 2027968,
  },
  {
    name: "Aginskoye",
    country: "Russia",
    subcountry: "Zabaykalskiy (Transbaikal) Kray",
    geonameid: 2028078,
  },
  {
    name: "Dalnegorsk",
    country: "Russia",
    subcountry: "Primorye",
    geonameid: 2051471,
  },
  {
    name: "Bratsk",
    country: "Russia",
    subcountry: "Irkutsk Oblast",
    geonameid: 2051523,
  },
  {
    name: "Sayansk",
    country: "Russia",
    subcountry: "Irkutsk Oblast",
    geonameid: 2055166,
  },
  {
    name: "Khabarovsk Vtoroy",
    country: "Russia",
    subcountry: "Khabarovsk",
    geonameid: 2056752,
  },
  {
    name: "Markova",
    country: "Russia",
    subcountry: "Irkutsk Oblast",
    geonameid: 2056881,
  },
  {
    name: "Vilyuchinsk",
    country: "Russia",
    subcountry: "Kamchatka",
    geonameid: 2118647,
  },
  {
    name: "Yuzhno-Sakhalinsk",
    country: "Russia",
    subcountry: "Sakhalin Oblast",
    geonameid: 2119441,
  },
  {
    name: "Yelizovo",
    country: "Russia",
    subcountry: "Kamchatka",
    geonameid: 2119538,
  },
  {
    name: "Vanino",
    country: "Russia",
    subcountry: "Khabarovsk",
    geonameid: 2119932,
  },
  {
    name: "Sovetskaya Gavan’",
    country: "Russia",
    subcountry: "Khabarovsk",
    geonameid: 2121052,
  },
  {
    name: "Poronaysk",
    country: "Russia",
    subcountry: "Sakhalin Oblast",
    geonameid: 2121909,
  },
  {
    name: "Petropavlovsk-Kamchatsky",
    country: "Russia",
    subcountry: "Kamchatka",
    geonameid: 2122104,
  },
  {
    name: "Okha",
    country: "Russia",
    subcountry: "Sakhalin Oblast",
    geonameid: 2122614,
  },
  {
    name: "Nikolayevsk-on-Amure",
    country: "Russia",
    subcountry: "Khabarovsk",
    geonameid: 2122850,
  },
  {
    name: "Nevel’sk",
    country: "Russia",
    subcountry: "Sakhalin Oblast",
    geonameid: 2122894,
  },
  {
    name: "Magadan",
    country: "Russia",
    subcountry: "Magadan Oblast",
    geonameid: 2123628,
  },
  {
    name: "Korsakov",
    country: "Russia",
    subcountry: "Sakhalin Oblast",
    geonameid: 2124286,
  },
  {
    name: "Kholmsk",
    country: "Russia",
    subcountry: "Sakhalin Oblast",
    geonameid: 2124615,
  },
  {
    name: "Anadyr",
    country: "Russia",
    subcountry: "Chukotka",
    geonameid: 2127202,
  },
  {
    name: "Baltiysk",
    country: "Russia",
    subcountry: "Kaliningrad Oblast",
    geonameid: 2609906,
  },
  {
    name: "Isakogorka",
    country: "Russia",
    subcountry: "Arkhangelskaya",
    geonameid: 6315399,
  },
  {
    name: "Krasnoznamensk",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 6417459,
  },
  {
    name: "Chertanovo Yuzhnoye",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 6418146,
  },
  {
    name: "Zagor’ye",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 6418201,
  },
  {
    name: "Orekhovo-Borisovo",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 6418220,
  },
  {
    name: "Metrogorodok",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 6418787,
  },
  {
    name: "Kogalym",
    country: "Russia",
    subcountry: "Khanty-Mansia",
    geonameid: 6695754,
  },
  {
    name: "Pyt-Yakh",
    country: "Russia",
    subcountry: "Khanty-Mansia",
    geonameid: 6696686,
  },
  {
    name: "Langepas",
    country: "Russia",
    subcountry: "Khanty-Mansia",
    geonameid: 6696767,
  },
  {
    name: "Lesnoy",
    country: "Russia",
    subcountry: "Sverdlovsk Oblast",
    geonameid: 6853140,
  },
  {
    name: "Zarya",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 7117880,
  },
  {
    name: "Raduzhnyy",
    country: "Russia",
    subcountry: "Vladimir Oblast",
    geonameid: 7117885,
  },
  {
    name: "Nizhnesortymskiy",
    country: "Russia",
    subcountry: "Khanty-Mansia",
    geonameid: 7287775,
  },
  {
    name: "Pokachi",
    country: "Russia",
    subcountry: "Khanty-Mansia",
    geonameid: 7289676,
  },
  {
    name: "Izluchinsk",
    country: "Russia",
    subcountry: "Khanty-Mansia",
    geonameid: 7290697,
  },
  {
    name: "Krasnaya Glinka",
    country: "Russia",
    subcountry: "Orenburg Oblast",
    geonameid: 7496732,
  },
  {
    name: "Kurortnyy",
    country: "Russia",
    subcountry: "Leningradskaya Oblast'",
    geonameid: 8436165,
  },
  {
    name: "Chernaya Rechka",
    country: "Russia",
    subcountry: "Leningradskaya Oblast'",
    geonameid: 8504946,
  },
  {
    name: "Untolovo",
    country: "Russia",
    subcountry: "Leningradskaya Oblast'",
    geonameid: 8504947,
  },
  {
    name: "Petrogradka",
    country: "Russia",
    subcountry: "St.-Petersburg",
    geonameid: 8504948,
  },
  {
    name: "Vasyl'evsky Ostrov",
    country: "Russia",
    subcountry: "St.-Petersburg",
    geonameid: 8504949,
  },
  {
    name: "Parnas",
    country: "Russia",
    subcountry: "Leningradskaya Oblast'",
    geonameid: 8504950,
  },
  {
    name: "Kalininskiy",
    country: "Russia",
    subcountry: "St.-Petersburg",
    geonameid: 8504951,
  },
  {
    name: "Krasnogvargeisky",
    country: "Russia",
    subcountry: "St.-Petersburg",
    geonameid: 8504952,
  },
  {
    name: "Admiralteisky",
    country: "Russia",
    subcountry: "St.-Petersburg",
    geonameid: 8504953,
  },
  {
    name: "Krestovskiy ostrov",
    country: "Russia",
    subcountry: "Leningradskaya Oblast'",
    geonameid: 8504955,
  },
  {
    name: "Akademicheskoe",
    country: "Russia",
    subcountry: "Leningradskaya Oblast'",
    geonameid: 8504958,
  },
  {
    name: "Finlyandskiy",
    country: "Russia",
    subcountry: "Leningradskaya Oblast'",
    geonameid: 8504959,
  },
  {
    name: "Centralniy",
    country: "Russia",
    subcountry: "St.-Petersburg",
    geonameid: 8504960,
  },
  {
    name: "Svetlanovskiy",
    country: "Russia",
    subcountry: "Leningradskaya Oblast'",
    geonameid: 8504964,
  },
  {
    name: "Sampsonievskiy",
    country: "Russia",
    subcountry: "Leningradskaya Oblast'",
    geonameid: 8504965,
  },
  {
    name: "Vostochnoe Degunino",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 8505053,
  },
  {
    name: "Dzerzhinsky",
    country: "Russia",
    subcountry: "Moscow Oblast",
    geonameid: 8521440,
  },
  {
    name: "Obruchevo",
    country: "Russia",
    subcountry: "Moscow",
    geonameid: 11238229,
  },
  {
    name: "Fedorovskiy",
    country: "Russia",
    subcountry: "Khanty-Mansia",
    geonameid: 11886891,
  },
  {
    name: "Mezgor'e",
    country: "Russia",
    subcountry: "Bashkortostan Republic",
    geonameid: 12041452,
  },
  {
    name: "Rwamagana",
    country: "Rwanda",
    subcountry: "Eastern Province",
    geonameid: 201463,
  },
  {
    name: "Musanze",
    country: "Rwanda",
    subcountry: "Northern Province",
    geonameid: 201521,
  },
  {
    name: "Nzega",
    country: "Rwanda",
    subcountry: "Southern Province",
    geonameid: 201865,
  },
  {
    name: "Kigali",
    country: "Rwanda",
    subcountry: "Kigali",
    geonameid: 202061,
  },
  {
    name: "Kibuye",
    country: "Rwanda",
    subcountry: "Western Province",
    geonameid: 202065,
  },
  {
    name: "Kibungo",
    country: "Rwanda",
    subcountry: "Eastern Province",
    geonameid: 202068,
  },
  {
    name: "Gitarama",
    country: "Rwanda",
    subcountry: "Southern Province",
    geonameid: 202217,
  },
  {
    name: "Cyangugu",
    country: "Rwanda",
    subcountry: "Western Province",
    geonameid: 202326,
  },
  {
    name: "Gisenyi",
    country: "Rwanda",
    subcountry: "Western Province",
    geonameid: 202905,
  },
  {
    name: "Byumba",
    country: "Rwanda",
    subcountry: "Northern Province",
    geonameid: 203104,
  },
  {
    name: "Butare",
    country: "Rwanda",
    subcountry: "Southern Province",
    geonameid: 203112,
  },
  {
    name: "Yanbu",
    country: "Saudi Arabia",
    subcountry: "Medina Region",
    geonameid: 100425,
  },
  {
    name: "Umluj",
    country: "Saudi Arabia",
    subcountry: "Tabuk Region",
    geonameid: 100926,
  },
  {
    name: "Turaif",
    country: "Saudi Arabia",
    subcountry: "Northern Borders Region",
    geonameid: 101312,
  },
  {
    name: "Turabah",
    country: "Saudi Arabia",
    subcountry: "Mecca Region",
    geonameid: 101322,
  },
  {
    name: "Tārūt",
    country: "Saudi Arabia",
    subcountry: "Eastern Province",
    geonameid: 101554,
  },
  {
    name: "Tabuk",
    country: "Saudi Arabia",
    subcountry: "Tabuk Region",
    geonameid: 101628,
  },
  {
    name: "Ţubarjal",
    country: "Saudi Arabia",
    subcountry: "Al Jawf Region",
    geonameid: 101631,
  },
  {
    name: "Sulţānah",
    country: "Saudi Arabia",
    subcountry: "Medina Region",
    geonameid: 101760,
  },
  {
    name: "Sayhāt",
    country: "Saudi Arabia",
    subcountry: "Eastern Province",
    geonameid: 102318,
  },
  {
    name: "Şāmitah",
    country: "Saudi Arabia",
    subcountry: "Jazan Region",
    geonameid: 102451,
  },
  {
    name: "Sakakah",
    country: "Saudi Arabia",
    subcountry: "Al Jawf Region",
    geonameid: 102527,
  },
  {
    name: "Şafwá",
    country: "Saudi Arabia",
    subcountry: "Eastern Province",
    geonameid: 102585,
  },
  {
    name: "Şabyā",
    country: "Saudi Arabia",
    subcountry: "Jazan Region",
    geonameid: 102651,
  },
  {
    name: "Raḩīmah",
    country: "Saudi Arabia",
    subcountry: "Eastern Province",
    geonameid: 102985,
  },
  {
    name: "Rābigh",
    country: "Saudi Arabia",
    subcountry: "Mecca Region",
    geonameid: 103035,
  },
  {
    name: "Qal‘at Bīshah",
    country: "Saudi Arabia",
    subcountry: "'Asir Region",
    geonameid: 103369,
  },
  {
    name: "Najrān",
    country: "Saudi Arabia",
    subcountry: "Najran Region",
    geonameid: 103630,
  },
  {
    name: "Mecca",
    country: "Saudi Arabia",
    subcountry: "Mecca Region",
    geonameid: 104515,
  },
  {
    name: "Khamis Mushait",
    country: "Saudi Arabia",
    subcountry: "'Asir Region",
    geonameid: 105072,
  },
  {
    name: "Jizan",
    country: "Saudi Arabia",
    subcountry: "Jazan Region",
    geonameid: 105299,
  },
  {
    name: "Jeddah",
    country: "Saudi Arabia",
    subcountry: "Mecca Region",
    geonameid: 105343,
  },
  {
    name: "Ha'il",
    country: "Saudi Arabia",
    subcountry: "Ha'il Region",
    geonameid: 106281,
  },
  {
    name: "Hafar Al-Batin",
    country: "Saudi Arabia",
    subcountry: "Eastern Province",
    geonameid: 106297,
  },
  {
    name: "Duba",
    country: "Saudi Arabia",
    subcountry: "Tabuk Region",
    geonameid: 106909,
  },
  {
    name: "Buraydah",
    country: "Saudi Arabia",
    subcountry: "Al-Qassim Region",
    geonameid: 107304,
  },
  {
    name: "Abqaiq",
    country: "Saudi Arabia",
    subcountry: "Eastern Province",
    geonameid: 107312,
  },
  {
    name: "Badr Ḩunayn",
    country: "Saudi Arabia",
    subcountry: "Medina Region",
    geonameid: 107744,
  },
  {
    name: "Az Zulfī",
    country: "Saudi Arabia",
    subcountry: "Riyadh Region",
    geonameid: 107781,
  },
  {
    name: "Dhahran",
    country: "Saudi Arabia",
    subcountry: "Eastern Province",
    geonameid: 107797,
  },
  {
    name: "Aţ Ţaraf",
    country: "Saudi Arabia",
    subcountry: "Eastern Province",
    geonameid: 107959,
  },
  {
    name: "Ta’if",
    country: "Saudi Arabia",
    subcountry: "Mecca Region",
    geonameid: 107968,
  },
  {
    name: "As Sulayyil",
    country: "Saudi Arabia",
    subcountry: "Riyadh Region",
    geonameid: 108048,
  },
  {
    name: "Riyadh",
    country: "Saudi Arabia",
    subcountry: "Riyadh Region",
    geonameid: 108410,
  },
  {
    name: "Ar Rass",
    country: "Saudi Arabia",
    subcountry: "Al-Qassim Region",
    geonameid: 108435,
  },
  {
    name: "Arar",
    country: "Saudi Arabia",
    subcountry: "Northern Borders Region",
    geonameid: 108512,
  },
  {
    name: "An Nimas",
    country: "Saudi Arabia",
    subcountry: "'Asir Region",
    geonameid: 108617,
  },
  {
    name: "Qurayyat",
    country: "Saudi Arabia",
    subcountry: "Al Jawf Region",
    geonameid: 108648,
  },
  {
    name: "Al Wajh",
    country: "Saudi Arabia",
    subcountry: "Tabuk Region",
    geonameid: 108773,
  },
  {
    name: "Al-`Ula",
    country: "Saudi Arabia",
    subcountry: "Medina Region",
    geonameid: 108841,
  },
  {
    name: "Qaisumah",
    country: "Saudi Arabia",
    subcountry: "Eastern Province",
    geonameid: 108918,
  },
  {
    name: "Al Qaţīf",
    country: "Saudi Arabia",
    subcountry: "Eastern Province",
    geonameid: 108927,
  },
  {
    name: "Al Munayzilah",
    country: "Saudi Arabia",
    subcountry: "Eastern Province",
    geonameid: 109059,
  },
  {
    name: "Al Mubarraz",
    country: "Saudi Arabia",
    subcountry: "Eastern Province",
    geonameid: 109101,
  },
  {
    name: "Al Mithnab",
    country: "Saudi Arabia",
    subcountry: "Al-Qassim Region",
    geonameid: 109131,
  },
  {
    name: "Medina",
    country: "Saudi Arabia",
    subcountry: "Medina Region",
    geonameid: 109223,
  },
  {
    name: "Khobar",
    country: "Saudi Arabia",
    subcountry: "Eastern Province",
    geonameid: 109323,
  },
  {
    name: "Al Kharj",
    country: "Saudi Arabia",
    subcountry: "Riyadh Region",
    geonameid: 109353,
  },
  {
    name: "Al Khafjī",
    country: "Saudi Arabia",
    subcountry: "Eastern Province",
    geonameid: 109380,
  },
  {
    name: "Al Jumūm",
    country: "Saudi Arabia",
    subcountry: "Mecca Region",
    geonameid: 109417,
  },
  {
    name: "Al Jubayl",
    country: "Saudi Arabia",
    subcountry: "Eastern Province",
    geonameid: 109435,
  },
  {
    name: "Al Hufūf",
    country: "Saudi Arabia",
    subcountry: "Eastern Province",
    geonameid: 109571,
  },
  {
    name: "Al Bukayrīyah",
    country: "Saudi Arabia",
    subcountry: "Al-Qassim Region",
    geonameid: 109878,
  },
  {
    name: "Al Baţţālīyah",
    country: "Saudi Arabia",
    subcountry: "Eastern Province",
    geonameid: 109915,
  },
  {
    name: "Al Bahah",
    country: "Saudi Arabia",
    subcountry: "Al Bahah Region",
    geonameid: 109953,
  },
  {
    name: "Afif",
    country: "Saudi Arabia",
    subcountry: "Riyadh Region",
    geonameid: 110250,
  },
  {
    name: "Ad Dilam",
    country: "Saudi Arabia",
    subcountry: "Riyadh Region",
    geonameid: 110314,
  },
  {
    name: "Ad Dawādimī",
    country: "Saudi Arabia",
    subcountry: "Riyadh Region",
    geonameid: 110325,
  },
  {
    name: "Dammam",
    country: "Saudi Arabia",
    subcountry: "Eastern Province",
    geonameid: 110336,
  },
  {
    name: "Abū ‘Arīsh",
    country: "Saudi Arabia",
    subcountry: "Jazan Region",
    geonameid: 110619,
  },
  {
    name: "Abha",
    country: "Saudi Arabia",
    subcountry: "'Asir Region",
    geonameid: 110690,
  },
  {
    name: "Ash Shafā",
    country: "Saudi Arabia",
    subcountry: "Mecca Region",
    geonameid: 410096,
  },
  {
    name: "Sabt Alalayah",
    country: "Saudi Arabia",
    subcountry: "'Asir Region",
    geonameid: 11670045,
  },
  {
    name: "Bariq",
    country: "Saudi Arabia",
    subcountry: "'Asir Region",
    geonameid: 12495725,
  },
  {
    name: "Honiara",
    country: "Solomon Islands",
    subcountry: "Honiara",
    geonameid: 2108502,
  },
  {
    name: "Victoria",
    country: "Seychelles",
    subcountry: "English River",
    geonameid: 241131,
  },
  {
    name: "Zalingei",
    country: "Sudan",
    subcountry: "Central Darfur",
    geonameid: 363533,
  },
  {
    name: "Wad Medani",
    country: "Sudan",
    subcountry: "Al Jazīrah",
    geonameid: 364103,
  },
  {
    name: "Umm Ruwaba",
    country: "Sudan",
    subcountry: "North Kordofan",
    geonameid: 364706,
  },
  {
    name: "Omdurman",
    country: "Sudan",
    subcountry: "Khartoum",
    geonameid: 365137,
  },
  {
    name: "Tokār",
    country: "Sudan",
    subcountry: "Red Sea",
    geonameid: 366323,
  },
  {
    name: "Tandaltī",
    country: "Sudan",
    subcountry: "White Nile",
    geonameid: 366426,
  },
  {
    name: "Singa",
    country: "Sudan",
    subcountry: "Sinnār",
    geonameid: 366847,
  },
  {
    name: "Shendi",
    country: "Sudan",
    subcountry: "River Nile",
    geonameid: 367308,
  },
  {
    name: "Sawākin",
    country: "Sudan",
    subcountry: "Red Sea",
    geonameid: 367544,
  },
  {
    name: "Sinnar",
    country: "Sudan",
    subcountry: "Sinnār",
    geonameid: 367644,
  },
  {
    name: "Rabak",
    country: "Sudan",
    subcountry: "White Nile",
    geonameid: 368277,
  },
  {
    name: "Nyala",
    country: "Sudan",
    subcountry: "Southern Darfur",
    geonameid: 369004,
  },
  {
    name: "Maiurno",
    country: "Sudan",
    subcountry: "Sinnār",
    geonameid: 370838,
  },
  {
    name: "Kosti",
    country: "Sudan",
    subcountry: "White Nile",
    geonameid: 371760,
  },
  {
    name: "Kuraymah",
    country: "Sudan",
    subcountry: "Northern State",
    geonameid: 371870,
  },
  {
    name: "Kināna",
    country: "Sudan",
    subcountry: "Sinnār",
    geonameid: 372386,
  },
  {
    name: "Kassala",
    country: "Sudan",
    subcountry: "Kassala",
    geonameid: 372753,
  },
  {
    name: "Kadugli",
    country: "Sudan",
    subcountry: "Southern Kordofan",
    geonameid: 373141,
  },
  {
    name: "Doka",
    country: "Sudan",
    subcountry: "Al Qaḑārif",
    geonameid: 376332,
  },
  {
    name: "Dilling",
    country: "Sudan",
    subcountry: "Southern Kordofan",
    geonameid: 376450,
  },
  {
    name: "Port Sudan",
    country: "Sudan",
    subcountry: "Red Sea",
    geonameid: 377039,
  },
  {
    name: "Berber",
    country: "Sudan",
    subcountry: "River Nile",
    geonameid: 377690,
  },
  {
    name: "Bārah",
    country: "Sudan",
    subcountry: "North Kordofan",
    geonameid: 377724,
  },
  {
    name: "Atbara",
    country: "Sudan",
    subcountry: "River Nile",
    geonameid: 378231,
  },
  {
    name: "As Sūkī",
    country: "Sudan",
    subcountry: "Sinnār",
    geonameid: 378271,
  },
  {
    name: "Ar Ruseris",
    country: "Sudan",
    subcountry: "Blue Nile",
    geonameid: 378459,
  },
  {
    name: "Ar Rahad",
    country: "Sudan",
    subcountry: "North Kordofan",
    geonameid: 378493,
  },
  {
    name: "An Nuhūd",
    country: "Sudan",
    subcountry: "West Kordofan State",
    geonameid: 378699,
  },
  {
    name: "El Obeid",
    country: "Sudan",
    subcountry: "North Kordofan",
    geonameid: 379003,
  },
  {
    name: "Al Qiţena",
    country: "Sudan",
    subcountry: "White Nile",
    geonameid: 379014,
  },
  {
    name: "Al Qadarif",
    country: "Sudan",
    subcountry: "Al Qaḑārif",
    geonameid: 379062,
  },
  {
    name: "Al Mijlad",
    country: "Sudan",
    subcountry: "West Kordofan State",
    geonameid: 379102,
  },
  {
    name: "Al Manāqil",
    country: "Sudan",
    subcountry: "Al Jazīrah",
    geonameid: 379149,
  },
  {
    name: "Khartoum",
    country: "Sudan",
    subcountry: "Khartoum",
    geonameid: 379252,
  },
  {
    name: "Geneina",
    country: "Sudan",
    subcountry: "Western Darfur",
    geonameid: 379303,
  },
  {
    name: "Al Hilāliyya",
    country: "Sudan",
    subcountry: "Al Jazīrah",
    geonameid: 379406,
  },
  {
    name: "Al Ḩawātah",
    country: "Sudan",
    subcountry: "Al Qaḑārif",
    geonameid: 379416,
  },
  {
    name: "Al Hasaheisa",
    country: "Sudan",
    subcountry: "Al Jazīrah",
    geonameid: 379427,
  },
  {
    name: "El Fasher",
    country: "Sudan",
    subcountry: "Northern Darfur",
    geonameid: 379555,
  },
  {
    name: "El Bauga",
    country: "Sudan",
    subcountry: "River Nile",
    geonameid: 379630,
  },
  {
    name: "Ad Douiem",
    country: "Sudan",
    subcountry: "White Nile",
    geonameid: 380129,
  },
  {
    name: "El Daein",
    country: "Sudan",
    subcountry: "Eastern Darfur",
    geonameid: 380148,
  },
  {
    name: "Ad Dindar",
    country: "Sudan",
    subcountry: "Sinnār",
    geonameid: 380151,
  },
  {
    name: "Ed Damer",
    country: "Sudan",
    subcountry: "River Nile",
    geonameid: 380173,
  },
  {
    name: "Ad-Damazin",
    country: "Sudan",
    subcountry: "Blue Nile",
    geonameid: 380174,
  },
  {
    name: "Abū Zabad",
    country: "Sudan",
    subcountry: "West Kordofan State",
    geonameid: 380348,
  },
  {
    name: "Abu Jibeha",
    country: "Sudan",
    subcountry: "Southern Kordofan",
    geonameid: 380757,
  },
  {
    name: "Gereida",
    country: "Sudan",
    subcountry: "Southern Darfur",
    geonameid: 8504621,
  },
  {
    name: "Umeå",
    country: "Sweden",
    subcountry: "Västerbotten",
    geonameid: 602150,
  },
  {
    name: "Skellefteå",
    country: "Sweden",
    subcountry: "Västerbotten",
    geonameid: 602913,
  },
  {
    name: "Piteå",
    country: "Sweden",
    subcountry: "Norrbotten",
    geonameid: 603570,
  },
  {
    name: "Luleå",
    country: "Sweden",
    subcountry: "Norrbotten",
    geonameid: 604490,
  },
  {
    name: "Kiruna",
    country: "Sweden",
    subcountry: "Norrbotten",
    geonameid: 605155,
  },
  {
    name: "Boden",
    country: "Sweden",
    subcountry: "Norrbotten",
    geonameid: 606531,
  },
  {
    name: "Ystad",
    country: "Sweden",
    subcountry: "Skåne",
    geonameid: 2662149,
  },
  {
    name: "Visby",
    country: "Sweden",
    subcountry: "Gotland",
    geonameid: 2662689,
  },
  {
    name: "Växjö",
    country: "Sweden",
    subcountry: "Kronoberg",
    geonameid: 2663536,
  },
  {
    name: "Västra Frölunda",
    country: "Sweden",
    subcountry: "Västra Götaland",
    geonameid: 2664050,
  },
  {
    name: "Västervik",
    country: "Sweden",
    subcountry: "Kalmar",
    geonameid: 2664203,
  },
  {
    name: "Västerås",
    country: "Sweden",
    subcountry: "Västmanland",
    geonameid: 2664454,
  },
  {
    name: "Vasastan",
    country: "Sweden",
    subcountry: "Stockholm",
    geonameid: 2664740,
  },
  {
    name: "Värnamo",
    country: "Sweden",
    subcountry: "Jönköping",
    geonameid: 2664855,
  },
  {
    name: "Varberg",
    country: "Sweden",
    subcountry: "Halland",
    geonameid: 2664996,
  },
  {
    name: "Vänersborg",
    country: "Sweden",
    subcountry: "Västra Götaland",
    geonameid: 2665171,
  },
  {
    name: "Vallentuna",
    country: "Sweden",
    subcountry: "Stockholm",
    geonameid: 2665452,
  },
  {
    name: "Uppsala",
    country: "Sweden",
    subcountry: "Uppsala",
    geonameid: 2666199,
  },
  {
    name: "Upplands Väsby",
    country: "Sweden",
    subcountry: "Stockholm",
    geonameid: 2666238,
  },
  {
    name: "Uddevalla",
    country: "Sweden",
    subcountry: "Västra Götaland",
    geonameid: 2666670,
  },
  {
    name: "Tumba",
    country: "Sweden",
    subcountry: "Stockholm",
    geonameid: 2667094,
  },
  {
    name: "Tullinge",
    country: "Sweden",
    subcountry: "Stockholm",
    geonameid: 2667109,
  },
  {
    name: "Trollhättan",
    country: "Sweden",
    subcountry: "Västra Götaland",
    geonameid: 2667303,
  },
  {
    name: "Trelleborg",
    country: "Sweden",
    subcountry: "Skåne",
    geonameid: 2667402,
  },
  {
    name: "Täby",
    country: "Sweden",
    subcountry: "Stockholm",
    geonameid: 2669772,
  },
  {
    name: "Sundsvall",
    country: "Sweden",
    subcountry: "Västernorrland",
    geonameid: 2670781,
  },
  {
    name: "Sundbyberg",
    country: "Sweden",
    subcountry: "Stockholm",
    geonameid: 2670879,
  },
  {
    name: "Stockholm",
    country: "Sweden",
    subcountry: "Stockholm",
    geonameid: 2673730,
  },
  {
    name: "Staffanstorp",
    country: "Sweden",
    subcountry: "Skåne",
    geonameid: 2674649,
  },
  {
    name: "Solna",
    country: "Sweden",
    subcountry: "Stockholm",
    geonameid: 2675397,
  },
  {
    name: "Sollentuna",
    country: "Sweden",
    subcountry: "Stockholm",
    geonameid: 2675408,
  },
  {
    name: "Södertälje",
    country: "Sweden",
    subcountry: "Stockholm",
    geonameid: 2676176,
  },
  {
    name: "Södermalm",
    country: "Sweden",
    subcountry: "Stockholm",
    geonameid: 2676209,
  },
  {
    name: "Skövde",
    country: "Sweden",
    subcountry: "Västra Götaland",
    geonameid: 2677234,
  },
  {
    name: "Sandviken",
    country: "Sweden",
    subcountry: "Gävleborg",
    geonameid: 2680075,
  },
  {
    name: "Råsunda",
    country: "Sweden",
    subcountry: "Stockholm",
    geonameid: 2683034,
  },
  {
    name: "Partille",
    country: "Sweden",
    subcountry: "Västra Götaland",
    geonameid: 2684395,
  },
  {
    name: "Östersund",
    country: "Sweden",
    subcountry: "Jämtland",
    geonameid: 2685750,
  },
  {
    name: "Östermalm",
    country: "Sweden",
    subcountry: "Stockholm",
    geonameid: 2685828,
  },
  {
    name: "Oskarshamn",
    country: "Sweden",
    subcountry: "Kalmar",
    geonameid: 2686162,
  },
  {
    name: "Örnsköldsvik",
    country: "Sweden",
    subcountry: "Västernorrland",
    geonameid: 2686469,
  },
  {
    name: "Örebro",
    country: "Sweden",
    subcountry: "Örebro",
    geonameid: 2686657,
  },
  {
    name: "Nyköping",
    country: "Sweden",
    subcountry: "Södermanland",
    geonameid: 2687700,
  },
  {
    name: "Norrtälje",
    country: "Sweden",
    subcountry: "Stockholm",
    geonameid: 2688250,
  },
  {
    name: "Norrköping",
    country: "Sweden",
    subcountry: "Östergötland",
    geonameid: 2688368,
  },
  {
    name: "Nässjö",
    country: "Sweden",
    subcountry: "Jönköping",
    geonameid: 2690170,
  },
  {
    name: "Nacka",
    country: "Sweden",
    subcountry: "Stockholm",
    geonameid: 2690580,
  },
  {
    name: "Motala",
    country: "Sweden",
    subcountry: "Östergötland",
    geonameid: 2690960,
  },
  {
    name: "Mölnlycke",
    country: "Sweden",
    subcountry: "Västra Götaland",
    geonameid: 2691440,
  },
  {
    name: "Mölndal",
    country: "Sweden",
    subcountry: "Västra Götaland",
    geonameid: 2691459,
  },
  {
    name: "Märsta",
    country: "Sweden",
    subcountry: "Stockholm",
    geonameid: 2692475,
  },
  {
    name: "Mariestad",
    country: "Sweden",
    subcountry: "Västra Götaland",
    geonameid: 2692613,
  },
  {
    name: "Malmö",
    country: "Sweden",
    subcountry: "Skåne",
    geonameid: 2692969,
  },
  {
    name: "Lund",
    country: "Sweden",
    subcountry: "Skåne",
    geonameid: 2693678,
  },
  {
    name: "Ludvika",
    country: "Sweden",
    subcountry: "Dalarna",
    geonameid: 2693759,
  },
  {
    name: "Ljungby",
    country: "Sweden",
    subcountry: "Kronoberg",
    geonameid: 2694560,
  },
  {
    name: "Linköping",
    country: "Sweden",
    subcountry: "Östergötland",
    geonameid: 2694762,
  },
  {
    name: "Lidköping",
    country: "Sweden",
    subcountry: "Västra Götaland",
    geonameid: 2696329,
  },
  {
    name: "Lidingö",
    country: "Sweden",
    subcountry: "Stockholm",
    geonameid: 2696334,
  },
  {
    name: "Lerum",
    country: "Sweden",
    subcountry: "Västra Götaland",
    geonameid: 2696503,
  },
  {
    name: "Landskrona",
    country: "Sweden",
    subcountry: "Skåne",
    geonameid: 2697720,
  },
  {
    name: "Kungsholmen",
    country: "Sweden",
    subcountry: "Stockholm",
    geonameid: 2698691,
  },
  {
    name: "Kungsbacka",
    country: "Sweden",
    subcountry: "Halland",
    geonameid: 2698729,
  },
  {
    name: "Kungälv",
    country: "Sweden",
    subcountry: "Västra Götaland",
    geonameid: 2698739,
  },
  {
    name: "Kumla",
    country: "Sweden",
    subcountry: "Örebro",
    geonameid: 2698767,
  },
  {
    name: "Kristinehamn",
    country: "Sweden",
    subcountry: "Värmland",
    geonameid: 2699282,
  },
  {
    name: "Kristianstad",
    country: "Sweden",
    subcountry: "Skåne",
    geonameid: 2699310,
  },
  {
    name: "Köping",
    country: "Sweden",
    subcountry: "Västmanland",
    geonameid: 2699791,
  },
  {
    name: "Kinna",
    country: "Sweden",
    subcountry: "Västra Götaland",
    geonameid: 2700839,
  },
  {
    name: "Katrineholm",
    country: "Sweden",
    subcountry: "Södermanland",
    geonameid: 2701223,
  },
  {
    name: "Karlstad",
    country: "Sweden",
    subcountry: "Värmland",
    geonameid: 2701680,
  },
  {
    name: "Karlskrona",
    country: "Sweden",
    subcountry: "Blekinge",
    geonameid: 2701713,
  },
  {
    name: "Karlskoga",
    country: "Sweden",
    subcountry: "Örebro",
    geonameid: 2701715,
  },
  {
    name: "Karlshamn",
    country: "Sweden",
    subcountry: "Blekinge",
    geonameid: 2701727,
  },
  {
    name: "Kalmar",
    country: "Sweden",
    subcountry: "Kalmar",
    geonameid: 2702261,
  },
  {
    name: "Jönköping",
    country: "Sweden",
    subcountry: "Jönköping",
    geonameid: 2702979,
  },
  {
    name: "Jakobsberg",
    country: "Sweden",
    subcountry: "Stockholm",
    geonameid: 2703396,
  },
  {
    name: "Huskvarna",
    country: "Sweden",
    subcountry: "Jönköping",
    geonameid: 2704136,
  },
  {
    name: "Hudiksvall",
    country: "Sweden",
    subcountry: "Gävleborg",
    geonameid: 2704613,
  },
  {
    name: "Huddinge",
    country: "Sweden",
    subcountry: "Stockholm",
    geonameid: 2704620,
  },
  {
    name: "Helsingborg",
    country: "Sweden",
    subcountry: "Skåne",
    geonameid: 2706767,
  },
  {
    name: "Hässleholm",
    country: "Sweden",
    subcountry: "Skåne",
    geonameid: 2707399,
  },
  {
    name: "Härnösand",
    country: "Sweden",
    subcountry: "Västernorrland",
    geonameid: 2707684,
  },
  {
    name: "Haninge",
    country: "Sweden",
    subcountry: "Stockholm",
    geonameid: 2707953,
  },
  {
    name: "Halmstad",
    country: "Sweden",
    subcountry: "Halland",
    geonameid: 2708365,
  },
  {
    name: "Gustavsberg",
    country: "Sweden",
    subcountry: "Stockholm",
    geonameid: 2709628,
  },
  {
    name: "Göteborg",
    country: "Sweden",
    subcountry: "Västra Götaland",
    geonameid: 2711537,
  },
  {
    name: "Gävle",
    country: "Sweden",
    subcountry: "Gävleborg",
    geonameid: 2712414,
  },
  {
    name: "Gamla Uppsala",
    country: "Sweden",
    subcountry: "Uppsala",
    geonameid: 2712993,
  },
  {
    name: "Falun",
    country: "Sweden",
    subcountry: "Dalarna",
    geonameid: 2715459,
  },
  {
    name: "Falköping",
    country: "Sweden",
    subcountry: "Västra Götaland",
    geonameid: 2715568,
  },
  {
    name: "Falkenberg",
    country: "Sweden",
    subcountry: "Halland",
    geonameid: 2715573,
  },
  {
    name: "Eslöv",
    country: "Sweden",
    subcountry: "Skåne",
    geonameid: 2715946,
  },
  {
    name: "Eskilstuna",
    country: "Sweden",
    subcountry: "Södermanland",
    geonameid: 2715953,
  },
  {
    name: "Enköping",
    country: "Sweden",
    subcountry: "Uppsala",
    geonameid: 2716166,
  },
  {
    name: "Bromma",
    country: "Sweden",
    subcountry: "Stockholm",
    geonameid: 2719111,
  },
  {
    name: "Borlänge",
    country: "Sweden",
    subcountry: "Dalarna",
    geonameid: 2720383,
  },
  {
    name: "Borås",
    country: "Sweden",
    subcountry: "Västra Götaland",
    geonameid: 2720501,
  },
  {
    name: "Boo",
    country: "Sweden",
    subcountry: "Stockholm",
    geonameid: 2721259,
  },
  {
    name: "Björlanda",
    country: "Sweden",
    subcountry: "Västra Götaland",
    geonameid: 2721946,
  },
  {
    name: "Årsta",
    country: "Sweden",
    subcountry: "Stockholm",
    geonameid: 2725201,
  },
  {
    name: "Ängelholm",
    country: "Sweden",
    subcountry: "Skåne",
    geonameid: 2725901,
  },
  {
    name: "Alingsås",
    country: "Sweden",
    subcountry: "Västra Götaland",
    geonameid: 2726756,
  },
  {
    name: "Åkersberga",
    country: "Sweden",
    subcountry: "Stockholm",
    geonameid: 2727234,
  },
  {
    name: "Majorna",
    country: "Sweden",
    subcountry: "Västra Götaland",
    geonameid: 6619708,
  },
  {
    name: "Tensta",
    country: "Sweden",
    subcountry: "Stockholm",
    geonameid: 7304427,
  },
  {
    name: "Singapore",
    country: "Singapore",
    subcountry: "N/A",
    geonameid: 1880252,
  },
  {
    name: "Geylang",
    country: "Singapore",
    subcountry: "N/A",
    geonameid: 1880668,
  },
  {
    name: "Woodlands",
    country: "Singapore",
    subcountry: "N/A",
    geonameid: 1882316,
  },
  {
    name: "Marine Parade",
    country: "Singapore",
    subcountry: "N/A",
    geonameid: 1882778,
  },
  {
    name: "Queenstown Estate",
    country: "Singapore",
    subcountry: "N/A",
    geonameid: 1884386,
  },
  {
    name: "Jamestown",
    country: "Saint Helena",
    subcountry: "Saint Helena",
    geonameid: 3370903,
  },
  {
    name: "Trbovlje",
    country: "Slovenia",
    subcountry: "Trbovlje",
    geonameid: 3188915,
  },
  {
    name: "Velenje",
    country: "Slovenia",
    subcountry: "Velenje",
    geonameid: 3189075,
  },
  {
    name: "Ptuj",
    country: "Slovenia",
    subcountry: "Ptuj",
    geonameid: 3192241,
  },
  {
    name: "Novo Mesto",
    country: "Slovenia",
    subcountry: "Novo Mesto",
    geonameid: 3194351,
  },
  {
    name: "Maribor",
    country: "Slovenia",
    subcountry: "Maribor",
    geonameid: 3195506,
  },
  {
    name: "Ljubljana",
    country: "Slovenia",
    subcountry: "Ljubljana",
    geonameid: 3196359,
  },
  {
    name: "Kranj",
    country: "Slovenia",
    subcountry: "Kranj",
    geonameid: 3197378,
  },
  {
    name: "Koper",
    country: "Slovenia",
    subcountry: "Koper-Capodistria",
    geonameid: 3197753,
  },
  {
    name: "Celje",
    country: "Slovenia",
    subcountry: "Celje",
    geonameid: 3202781,
  },
  {
    name: "Longyearbyen",
    country: "Svalbard and Jan Mayen",
    subcountry: "Svalbard",
    geonameid: 2729907,
  },
  {
    name: "Vranov nad Topľou",
    country: "Slovakia",
    subcountry: "Prešovský kraj",
    geonameid: 723195,
  },
  {
    name: "Trebišov",
    country: "Slovakia",
    subcountry: "Košický kraj",
    geonameid: 723358,
  },
  {
    name: "Stará Ľubovňa",
    country: "Slovakia",
    subcountry: "Prešovský kraj",
    geonameid: 723505,
  },
  {
    name: "Spišská Nová Ves",
    country: "Slovakia",
    subcountry: "Košický kraj",
    geonameid: 723526,
  },
  {
    name: "Snina",
    country: "Slovakia",
    subcountry: "Prešovský kraj",
    geonameid: 723559,
  },
  {
    name: "Rožňava",
    country: "Slovakia",
    subcountry: "Košický kraj",
    geonameid: 723713,
  },
  {
    name: "Rimavská Sobota",
    country: "Slovakia",
    subcountry: "Banskobystrický kraj",
    geonameid: 723736,
  },
  {
    name: "Prešov",
    country: "Slovakia",
    subcountry: "Prešovský kraj",
    geonameid: 723819,
  },
  {
    name: "Poprad",
    country: "Slovakia",
    subcountry: "Prešovský kraj",
    geonameid: 723846,
  },
  {
    name: "Michalovce",
    country: "Slovakia",
    subcountry: "Košický kraj",
    geonameid: 724144,
  },
  {
    name: "Košice",
    country: "Slovakia",
    subcountry: "Košický kraj",
    geonameid: 724443,
  },
  {
    name: "Kežmarok",
    country: "Slovakia",
    subcountry: "Prešovský kraj",
    geonameid: 724503,
  },
  {
    name: "Humenné",
    country: "Slovakia",
    subcountry: "Prešovský kraj",
    geonameid: 724627,
  },
  {
    name: "Bardejov",
    country: "Slovakia",
    subcountry: "Prešovský kraj",
    geonameid: 725168,
  },
  {
    name: "Zvolen",
    country: "Slovakia",
    subcountry: "Banskobystrický kraj",
    geonameid: 3056459,
  },
  {
    name: "Zlaté Moravce",
    country: "Slovakia",
    subcountry: "Nitriansky kraj",
    geonameid: 3056495,
  },
  {
    name: "Žilina",
    country: "Slovakia",
    subcountry: "Žilinský kraj",
    geonameid: 3056508,
  },
  {
    name: "Žiar nad Hronom",
    country: "Slovakia",
    subcountry: "Banskobystrický kraj",
    geonameid: 3056523,
  },
  {
    name: "Trnava",
    country: "Slovakia",
    subcountry: "Trnava",
    geonameid: 3057124,
  },
  {
    name: "Trenčín",
    country: "Slovakia",
    subcountry: "Trenčiansky kraj",
    geonameid: 3057140,
  },
  {
    name: "Stupava",
    country: "Slovakia",
    subcountry: "Bratislavský Kraj",
    geonameid: 3057384,
  },
  {
    name: "Staré Mesto",
    country: "Slovakia",
    subcountry: "Bratislavský Kraj",
    geonameid: 3057478,
  },
  {
    name: "Skalica",
    country: "Slovakia",
    subcountry: "Trnava",
    geonameid: 3057630,
  },
  {
    name: "Senica",
    country: "Slovakia",
    subcountry: "Trnava",
    geonameid: 3057691,
  },
  {
    name: "Šaľa",
    country: "Slovakia",
    subcountry: "Nitriansky kraj",
    geonameid: 3057769,
  },
  {
    name: "Ružomberok",
    country: "Slovakia",
    subcountry: "Žilinský kraj",
    geonameid: 3057789,
  },
  {
    name: "Púchov",
    country: "Slovakia",
    subcountry: "Trenčiansky kraj",
    geonameid: 3057963,
  },
  {
    name: "Prievidza",
    country: "Slovakia",
    subcountry: "Trenčiansky kraj",
    geonameid: 3058000,
  },
  {
    name: "Považská Bystrica",
    country: "Slovakia",
    subcountry: "Trenčiansky kraj",
    geonameid: 3058060,
  },
  {
    name: "Piešťany",
    country: "Slovakia",
    subcountry: "Trnava",
    geonameid: 3058202,
  },
  {
    name: "Pezinok",
    country: "Slovakia",
    subcountry: "Bratislavský Kraj",
    geonameid: 3058210,
  },
  {
    name: "Partizánske",
    country: "Slovakia",
    subcountry: "Trenčiansky kraj",
    geonameid: 3058268,
  },
  {
    name: "Nové Zámky",
    country: "Slovakia",
    subcountry: "Nitriansky kraj",
    geonameid: 3058472,
  },
  {
    name: "Nové Mesto nad Váhom",
    country: "Slovakia",
    subcountry: "Trenčiansky kraj",
    geonameid: 3058477,
  },
  {
    name: "Nitra",
    country: "Slovakia",
    subcountry: "Nitriansky kraj",
    geonameid: 3058531,
  },
  {
    name: "Martin",
    country: "Slovakia",
    subcountry: "Žilinský kraj",
    geonameid: 3058780,
  },
  {
    name: "Malacky",
    country: "Slovakia",
    subcountry: "Bratislavský Kraj",
    geonameid: 3058897,
  },
  {
    name: "Lučenec",
    country: "Slovakia",
    subcountry: "Banskobystrický kraj",
    geonameid: 3058986,
  },
  {
    name: "Liptovský Mikuláš",
    country: "Slovakia",
    subcountry: "Žilinský kraj",
    geonameid: 3059050,
  },
  {
    name: "Levice",
    country: "Slovakia",
    subcountry: "Nitriansky kraj",
    geonameid: 3059101,
  },
  {
    name: "Kysucké Nové Mesto",
    country: "Slovakia",
    subcountry: "Žilinský kraj",
    geonameid: 3059179,
  },
  {
    name: "Komárno",
    country: "Slovakia",
    subcountry: "Nitriansky kraj",
    geonameid: 3059436,
  },
  {
    name: "Hlohovec",
    country: "Slovakia",
    subcountry: "Trnava",
    geonameid: 3060095,
  },
  {
    name: "Handlová",
    country: "Slovakia",
    subcountry: "Trenčiansky kraj",
    geonameid: 3060139,
  },
  {
    name: "Galanta",
    country: "Slovakia",
    subcountry: "Trnava",
    geonameid: 3060219,
  },
  {
    name: "Dunajská Streda",
    country: "Slovakia",
    subcountry: "Trnava",
    geonameid: 3060308,
  },
  {
    name: "Dubnica nad Váhom",
    country: "Slovakia",
    subcountry: "Trenčiansky kraj",
    geonameid: 3060346,
  },
  {
    name: "Dolný Kubín",
    country: "Slovakia",
    subcountry: "Žilinský kraj",
    geonameid: 3060405,
  },
  {
    name: "Čadca",
    country: "Slovakia",
    subcountry: "Žilinský kraj",
    geonameid: 3060835,
  },
  {
    name: "Brezno",
    country: "Slovakia",
    subcountry: "Banskobystrický kraj",
    geonameid: 3060950,
  },
  {
    name: "Bratislava",
    country: "Slovakia",
    subcountry: "Bratislavský Kraj",
    geonameid: 3060972,
  },
  {
    name: "Banská Bystrica",
    country: "Slovakia",
    subcountry: "Banskobystrický kraj",
    geonameid: 3061186,
  },
  {
    name: "Bánovce nad Bebravou",
    country: "Slovakia",
    subcountry: "Trenčiansky kraj",
    geonameid: 3061188,
  },
  {
    name: "Waterloo",
    country: "Sierra Leone",
    subcountry: "Western Area",
    geonameid: 2403094,
  },
  {
    name: "Segbwema",
    country: "Sierra Leone",
    subcountry: "Eastern Province",
    geonameid: 2404041,
  },
  {
    name: "Port Loko",
    country: "Sierra Leone",
    subcountry: "North West",
    geonameid: 2404433,
  },
  {
    name: "Makeni",
    country: "Sierra Leone",
    subcountry: "Northern Province",
    geonameid: 2406407,
  },
  {
    name: "Lunsar",
    country: "Sierra Leone",
    subcountry: "Northern Province",
    geonameid: 2406916,
  },
  {
    name: "Koidu",
    country: "Sierra Leone",
    subcountry: "Eastern Province",
    geonameid: 2407656,
  },
  {
    name: "Kenema",
    country: "Sierra Leone",
    subcountry: "Eastern Province",
    geonameid: 2407790,
  },
  {
    name: "Kabala",
    country: "Sierra Leone",
    subcountry: "Northern Province",
    geonameid: 2408329,
  },
  {
    name: "Freetown",
    country: "Sierra Leone",
    subcountry: "Western Area",
    geonameid: 2409306,
  },
  {
    name: "Bumpe",
    country: "Sierra Leone",
    subcountry: "Southern Province",
    geonameid: 2409823,
  },
  {
    name: "Bo",
    country: "Sierra Leone",
    subcountry: "Southern Province",
    geonameid: 2410048,
  },
  {
    name: "Goderich",
    country: "Sierra Leone",
    subcountry: "Western Area",
    geonameid: 9191693,
  },
  {
    name: "San Marino",
    country: "San Marino",
    subcountry: "San Marino",
    geonameid: 3168070,
  },
  {
    name: "Ziguinchor",
    country: "Senegal",
    subcountry: "Ziguinchor",
    geonameid: 2243940,
  },
  {
    name: "Vélingara",
    country: "Senegal",
    subcountry: "Kolda",
    geonameid: 2244177,
  },
  {
    name: "Touba",
    country: "Senegal",
    subcountry: "Diourbel",
    geonameid: 2244322,
  },
  {
    name: "Tiébo",
    country: "Senegal",
    subcountry: "Diourbel",
    geonameid: 2244616,
  },
  {
    name: "Thiès Nones",
    country: "Senegal",
    subcountry: "Thiès",
    geonameid: 2244799,
  },
  {
    name: "Thiès",
    country: "Senegal",
    subcountry: "Thiès",
    geonameid: 2244802,
  },
  {
    name: "Tambacounda",
    country: "Senegal",
    subcountry: "Tambacounda",
    geonameid: 2244991,
  },
  {
    name: "Sédhiou",
    country: "Senegal",
    subcountry: "Sédhiou",
    geonameid: 2245704,
  },
  {
    name: "Saint-Louis",
    country: "Senegal",
    subcountry: "Saint-Louis",
    geonameid: 2246452,
  },
  {
    name: "Richard-Toll",
    country: "Senegal",
    subcountry: "Saint-Louis",
    geonameid: 2246544,
  },
  {
    name: "Pout",
    country: "Senegal",
    subcountry: "Thiès",
    geonameid: 2246606,
  },
  {
    name: "Pourham",
    country: "Senegal",
    subcountry: "Fatick",
    geonameid: 2246608,
  },
  {
    name: "Pikine",
    country: "Senegal",
    subcountry: "Dakar",
    geonameid: 2246678,
  },
  {
    name: "Nioro du Rip",
    country: "Senegal",
    subcountry: "Kaolack",
    geonameid: 2247157,
  },
  {
    name: "Nguékhokh",
    country: "Senegal",
    subcountry: "Thiès",
    geonameid: 2247381,
  },
  {
    name: "Ndibène Dahra",
    country: "Senegal",
    subcountry: "Louga",
    geonameid: 2247813,
  },
  {
    name: "Mékhé",
    country: "Senegal",
    subcountry: "Thiès",
    geonameid: 2248409,
  },
  {
    name: "Mbaké",
    country: "Senegal",
    subcountry: "Diourbel",
    geonameid: 2248698,
  },
  {
    name: "Matam",
    country: "Senegal",
    subcountry: "Matam",
    geonameid: 2248752,
  },
  {
    name: "Louga",
    country: "Senegal",
    subcountry: "Louga",
    geonameid: 2249222,
  },
  {
    name: "Kolda",
    country: "Senegal",
    subcountry: "Kolda",
    geonameid: 2249782,
  },
  {
    name: "Kédougou",
    country: "Senegal",
    subcountry: "Kédougou",
    geonameid: 2250645,
  },
  {
    name: "Kayar",
    country: "Senegal",
    subcountry: "Thiès",
    geonameid: 2250677,
  },
  {
    name: "Kaolack",
    country: "Senegal",
    subcountry: "Kaolack",
    geonameid: 2250805,
  },
  {
    name: "Kaffrine",
    country: "Senegal",
    subcountry: "Kaffrine",
    geonameid: 2251007,
  },
  {
    name: "Joal-Fadiout",
    country: "Senegal",
    subcountry: "Thiès",
    geonameid: 2251084,
  },
  {
    name: "Guinguinéo",
    country: "Senegal",
    subcountry: "Fatick",
    geonameid: 2251230,
  },
  {
    name: "Dara",
    country: "Senegal",
    subcountry: "Louga",
    geonameid: 2253277,
  },
  {
    name: "Dakar",
    country: "Senegal",
    subcountry: "Dakar",
    geonameid: 2253354,
  },
  {
    name: "Bignona",
    country: "Senegal",
    subcountry: "Ziguinchor",
    geonameid: 2253901,
  },
  {
    name: "N’diareme limamoulaye",
    country: "Senegal",
    subcountry: "Dakar",
    geonameid: 11101616,
  },
  {
    name: "Wanlaweyn",
    country: "Somalia",
    subcountry: "Lower Shabeelle",
    geonameid: 50672,
  },
  {
    name: "Qoryooley",
    country: "Somalia",
    subcountry: "Lower Shabeelle",
    geonameid: 52867,
  },
  {
    name: "Qandala",
    country: "Somalia",
    subcountry: "Bari",
    geonameid: 53157,
  },
  {
    name: "Mogadishu",
    country: "Somalia",
    subcountry: "Banaadir",
    geonameid: 53654,
  },
  {
    name: "Marka",
    country: "Somalia",
    subcountry: "Lower Shabeelle",
    geonameid: 54225,
  },
  {
    name: "Luuq",
    country: "Somalia",
    subcountry: "Gedo",
    geonameid: 54715,
  },
  {
    name: "Kismayo",
    country: "Somalia",
    subcountry: "Lower Juba",
    geonameid: 55671,
  },
  {
    name: "Jilib",
    country: "Somalia",
    subcountry: "Middle Juba",
    geonameid: 56166,
  },
  {
    name: "Jawhar",
    country: "Somalia",
    subcountry: "Middle Shabele",
    geonameid: 56335,
  },
  {
    name: "Jamaame",
    country: "Somalia",
    subcountry: "Lower Juba",
    geonameid: 56399,
  },
  {
    name: "Hargeysa",
    country: "Somalia",
    subcountry: "Woqooyi Galbeed",
    geonameid: 57289,
  },
  {
    name: "Garoowe",
    country: "Somalia",
    subcountry: "Nugaal",
    geonameid: 58933,
  },
  {
    name: "Gaalkacyo",
    country: "Somalia",
    subcountry: "Mudug",
    geonameid: 59611,
  },
  {
    name: "Eyl",
    country: "Somalia",
    subcountry: "Nugaal",
    geonameid: 60019,
  },
  {
    name: "Diinsoor",
    country: "Somalia",
    subcountry: "Bay",
    geonameid: 60809,
  },
  {
    name: "Ceerigaabo",
    country: "Somalia",
    subcountry: "Sanaag",
    geonameid: 62691,
  },
  {
    name: "Ceeldheer",
    country: "Somalia",
    subcountry: "Galguduud",
    geonameid: 62788,
  },
  {
    name: "Cabudwaaq",
    country: "Somalia",
    subcountry: "Galguduud",
    geonameid: 63400,
  },
  {
    name: "Buurhakaba",
    country: "Somalia",
    subcountry: "Bay",
    geonameid: 63571,
  },
  {
    name: "Buulobarde",
    country: "Somalia",
    subcountry: "Hiiraan",
    geonameid: 63689,
  },
  {
    name: "Burao",
    country: "Somalia",
    subcountry: "Togdheer",
    geonameid: 63795,
  },
  {
    name: "Bosaso",
    country: "Somalia",
    subcountry: "Bari",
    geonameid: 64013,
  },
  {
    name: "Berbera",
    country: "Somalia",
    subcountry: "Woqooyi Galbeed",
    geonameid: 64435,
  },
  {
    name: "Beledweyne",
    country: "Somalia",
    subcountry: "Hiiraan",
    geonameid: 64460,
  },
  {
    name: "Baidoa",
    country: "Somalia",
    subcountry: "Bay",
    geonameid: 64536,
  },
  {
    name: "Baardheere",
    country: "Somalia",
    subcountry: "Gedo",
    geonameid: 65170,
  },
  {
    name: "Afgooye",
    country: "Somalia",
    subcountry: "Lower Shabeelle",
    geonameid: 65785,
  },
  {
    name: "Balanbale",
    country: "Somalia",
    subcountry: "Galguduud",
    geonameid: 342803,
  },
  {
    name: "Laascaanood",
    country: "Somalia",
    subcountry: "Sool",
    geonameid: 400769,
  },
  {
    name: "Saaxo",
    country: "Somalia",
    subcountry: "Mudug",
    geonameid: 6311111,
  },
  {
    name: "Dhabad",
    country: "Somalia",
    subcountry: "Galguduud",
    geonameid: 6311126,
  },
  {
    name: "Baki",
    country: "Somalia",
    subcountry: "Awdal",
    geonameid: 8045596,
  },
  {
    name: "Beled Hawo",
    country: "Somalia",
    subcountry: "Gedo",
    geonameid: 12212406,
  },
  {
    name: "Paramaribo",
    country: "Suriname",
    subcountry: "Paramaribo",
    geonameid: 3383330,
  },
  {
    name: "Lelydorp",
    country: "Suriname",
    subcountry: "Wanica",
    geonameid: 3383714,
  },
  {
    name: "Yei",
    country: "South Sudan",
    subcountry: "Central Equatoria",
    geonameid: 363619,
  },
  {
    name: "Yambio",
    country: "South Sudan",
    subcountry: "Western Equatoria",
    geonameid: 363656,
  },
  {
    name: "Winejok",
    country: "South Sudan",
    subcountry: "Northern Bahr al Ghazal",
    geonameid: 363807,
  },
  {
    name: "Wau",
    country: "South Sudan",
    subcountry: "Western Bahr al Ghazal",
    geonameid: 363885,
  },
  {
    name: "Aweil",
    country: "South Sudan",
    subcountry: "Northern Bahr al Ghazal",
    geonameid: 364367,
  },
  {
    name: "Torit",
    country: "South Sudan",
    subcountry: "Eastern Equatoria",
    geonameid: 365742,
  },
  {
    name: "Tonj",
    country: "South Sudan",
    subcountry: "Warrap",
    geonameid: 365763,
  },
  {
    name: "Rumbek",
    country: "South Sudan",
    subcountry: "Lakes",
    geonameid: 367927,
  },
  {
    name: "Malakal",
    country: "South Sudan",
    subcountry: "Upper Nile",
    geonameid: 370737,
  },
  {
    name: "Leer",
    country: "South Sudan",
    subcountry: "Unity",
    geonameid: 371466,
  },
  {
    name: "Kuacjok",
    country: "South Sudan",
    subcountry: "Warrap",
    geonameid: 371712,
  },
  {
    name: "Kafia Kingi",
    country: "South Sudan",
    subcountry: "Western Bahr al Ghazal",
    geonameid: 373130,
  },
  {
    name: "Juba",
    country: "South Sudan",
    subcountry: "Central Equatoria",
    geonameid: 373303,
  },
  {
    name: "Gogrial",
    country: "South Sudan",
    subcountry: "Warrap",
    geonameid: 374739,
  },
  {
    name: "Pajok",
    country: "South Sudan",
    subcountry: "Eastern Equatoria",
    geonameid: 375495,
  },
  {
    name: "Bor",
    country: "South Sudan",
    subcountry: "Jonglei",
    geonameid: 377241,
  },
  {
    name: "São Tomé",
    country: "Sao Tome and Principe",
    subcountry: "São Tomé Island",
    geonameid: 2410763,
  },
  {
    name: "Zacatecoluca",
    country: "El Salvador",
    subcountry: "La Paz",
    geonameid: 3582805,
  },
  {
    name: "Usulután",
    country: "El Salvador",
    subcountry: "Usulután",
    geonameid: 3582883,
  },
  {
    name: "Soyapango",
    country: "El Salvador",
    subcountry: "San Salvador",
    geonameid: 3583096,
  },
  {
    name: "Sonzacate",
    country: "El Salvador",
    subcountry: "Sonsonate",
    geonameid: 3583098,
  },
  {
    name: "Sonsonate",
    country: "El Salvador",
    subcountry: "Sonsonate",
    geonameid: 3583102,
  },
  {
    name: "Sensuntepeque",
    country: "El Salvador",
    subcountry: "Cabañas",
    geonameid: 3583158,
  },
  {
    name: "San Vicente",
    country: "El Salvador",
    subcountry: "San Vicente",
    geonameid: 3583178,
  },
  {
    name: "Santiago de María",
    country: "El Salvador",
    subcountry: "Usulután",
    geonameid: 3583199,
  },
  {
    name: "Santa Ana",
    country: "El Salvador",
    subcountry: "Santa Ana",
    geonameid: 3583334,
  },
  {
    name: "San Salvador",
    country: "El Salvador",
    subcountry: "San Salvador",
    geonameid: 3583361,
  },
  {
    name: "San Rafael Oriente",
    country: "El Salvador",
    subcountry: "San Miguel",
    geonameid: 3583379,
  },
  {
    name: "San Miguel",
    country: "El Salvador",
    subcountry: "San Miguel",
    geonameid: 3583446,
  },
  {
    name: "San Martín",
    country: "El Salvador",
    subcountry: "Cuscatlán",
    geonameid: 3583471,
  },
  {
    name: "San Marcos",
    country: "El Salvador",
    subcountry: "San Salvador",
    geonameid: 3583480,
  },
  {
    name: "San Francisco",
    country: "El Salvador",
    subcountry: "Morazán",
    geonameid: 3583747,
  },
  {
    name: "Quezaltepeque",
    country: "El Salvador",
    subcountry: "La Libertad",
    geonameid: 3583981,
  },
  {
    name: "Puerto El Triunfo",
    country: "El Salvador",
    subcountry: "Usulután",
    geonameid: 3584003,
  },
  {
    name: "Santa Tecla",
    country: "El Salvador",
    subcountry: "La Libertad",
    geonameid: 3584257,
  },
  {
    name: "Metapán",
    country: "El Salvador",
    subcountry: "Santa Ana",
    geonameid: 3584384,
  },
  {
    name: "Mejicanos",
    country: "El Salvador",
    subcountry: "San Salvador",
    geonameid: 3584399,
  },
  {
    name: "La Unión",
    country: "El Salvador",
    subcountry: "La Unión",
    geonameid: 3584772,
  },
  {
    name: "La Libertad",
    country: "El Salvador",
    subcountry: "La Libertad",
    geonameid: 3585157,
  },
  {
    name: "Izalco",
    country: "El Salvador",
    subcountry: "Sonsonate",
    geonameid: 3585473,
  },
  {
    name: "Ilopango",
    country: "El Salvador",
    subcountry: "San Salvador",
    geonameid: 3585484,
  },
  {
    name: "Delgado",
    country: "El Salvador",
    subcountry: "San Salvador",
    geonameid: 3586814,
  },
  {
    name: "Cuscatancingo",
    country: "El Salvador",
    subcountry: "San Salvador",
    geonameid: 3586833,
  },
  {
    name: "Cojutepeque",
    country: "El Salvador",
    subcountry: "Cuscatlán",
    geonameid: 3586977,
  },
  {
    name: "Chalchuapa",
    country: "El Salvador",
    subcountry: "Santa Ana",
    geonameid: 3587086,
  },
  {
    name: "Chalatenango",
    country: "El Salvador",
    subcountry: "Chalatenango",
    geonameid: 3587091,
  },
  {
    name: "Ayutuxtepeque",
    country: "El Salvador",
    subcountry: "San Salvador",
    geonameid: 3587308,
  },
  {
    name: "Apopa",
    country: "El Salvador",
    subcountry: "San Salvador",
    geonameid: 3587345,
  },
  {
    name: "Antiguo Cuscatlán",
    country: "El Salvador",
    subcountry: "La Libertad",
    geonameid: 3587362,
  },
  {
    name: "Ahuachapán",
    country: "El Salvador",
    subcountry: "Ahuachapán",
    geonameid: 3587426,
  },
  {
    name: "Aguilares",
    country: "El Salvador",
    subcountry: "San Salvador",
    geonameid: 3587428,
  },
  {
    name: "Acajutla",
    country: "El Salvador",
    subcountry: "Sonsonate",
    geonameid: 3587498,
  },
  {
    name: "Philipsburg",
    country: "Sint Maarten",
    subcountry: "N/A",
    geonameid: 3513392,
  },
  {
    name: "Yabrūd",
    country: "Syria",
    subcountry: "Rif-dimashq",
    geonameid: 162627,
  },
  {
    name: "Ţayyibat al Imām",
    country: "Syria",
    subcountry: "Hama",
    geonameid: 163270,
  },
  {
    name: "Ţarţūs",
    country: "Syria",
    subcountry: "Tartus",
    geonameid: 163345,
  },
  {
    name: "Tall Rif‘at",
    country: "Syria",
    subcountry: "Aleppo",
    geonameid: 163476,
  },
  {
    name: "Tallkalakh",
    country: "Syria",
    subcountry: "Homs",
    geonameid: 163533,
  },
  {
    name: "Tallbīsah",
    country: "Syria",
    subcountry: "Homs",
    geonameid: 163779,
  },
  {
    name: "Ţafas",
    country: "Syria",
    subcountry: "Daraa",
    geonameid: 163806,
  },
  {
    name: "Tadmur",
    country: "Syria",
    subcountry: "Homs",
    geonameid: 163808,
  },
  {
    name: "Tādif",
    country: "Syria",
    subcountry: "Aleppo",
    geonameid: 163811,
  },
  {
    name: "Şūrān",
    country: "Syria",
    subcountry: "Hama",
    geonameid: 163915,
  },
  {
    name: "Subaykhān",
    country: "Syria",
    subcountry: "Deir ez-Zor",
    geonameid: 164025,
  },
  {
    name: "Shaykh Miskīn",
    country: "Syria",
    subcountry: "Daraa",
    geonameid: 164328,
  },
  {
    name: "Saraqib",
    country: "Syria",
    subcountry: "Idlib",
    geonameid: 164816,
  },
  {
    name: "Salqīn",
    country: "Syria",
    subcountry: "Idlib",
    geonameid: 164898,
  },
  {
    name: "As Salamīyah",
    country: "Syria",
    subcountry: "Hama",
    geonameid: 164947,
  },
  {
    name: "Şāfītā",
    country: "Syria",
    subcountry: "Tartus",
    geonameid: 165060,
  },
  {
    name: "Qaţanā",
    country: "Syria",
    subcountry: "Rif-dimashq",
    geonameid: 165929,
  },
  {
    name: "Jāsim",
    country: "Syria",
    subcountry: "Daraa",
    geonameid: 165997,
  },
  {
    name: "Qārah",
    country: "Syria",
    subcountry: "Rif-dimashq",
    geonameid: 166111,
  },
  {
    name: "Kabbasin",
    country: "Syria",
    subcountry: "Aleppo",
    geonameid: 166285,
  },
  {
    name: "Nubl",
    country: "Syria",
    subcountry: "Aleppo",
    geonameid: 166331,
  },
  {
    name: "Maşyāf",
    country: "Syria",
    subcountry: "Hama",
    geonameid: 167046,
  },
  {
    name: "Manbij",
    country: "Syria",
    subcountry: "Aleppo",
    geonameid: 167357,
  },
  {
    name: "Ma‘arratmişrīn",
    country: "Syria",
    subcountry: "Idlib",
    geonameid: 167605,
  },
  {
    name: "Khān Shaykhūn",
    country: "Syria",
    subcountry: "Idlib",
    geonameid: 168325,
  },
  {
    name: "Kafr Zaytā",
    country: "Syria",
    subcountry: "Hama",
    geonameid: 168620,
  },
  {
    name: "Kafr Takhārīm",
    country: "Syria",
    subcountry: "Idlib",
    geonameid: 168629,
  },
  {
    name: "Kafranbel",
    country: "Syria",
    subcountry: "Idlib",
    geonameid: 168661,
  },
  {
    name: "Kafr Lāhā",
    country: "Syria",
    subcountry: "Homs",
    geonameid: 168668,
  },
  {
    name: "Jisr ash Shughūr",
    country: "Syria",
    subcountry: "Idlib",
    geonameid: 169023,
  },
  {
    name: "Jayrūd",
    country: "Syria",
    subcountry: "Rif-dimashq",
    geonameid: 169113,
  },
  {
    name: "Jarābulus",
    country: "Syria",
    subcountry: "Aleppo",
    geonameid: 169179,
  },
  {
    name: "Jablah",
    country: "Syria",
    subcountry: "Latakia",
    geonameid: 169304,
  },
  {
    name: "‘Irbīn",
    country: "Syria",
    subcountry: "Rif-dimashq",
    geonameid: 169372,
  },
  {
    name: "Inkhil",
    country: "Syria",
    subcountry: "Daraa",
    geonameid: 169375,
  },
  {
    name: "Idlib",
    country: "Syria",
    subcountry: "Idlib",
    geonameid: 169389,
  },
  {
    name: "Homs",
    country: "Syria",
    subcountry: "Homs",
    geonameid: 169577,
  },
  {
    name: "Ḩarastā",
    country: "Syria",
    subcountry: "Rif-dimashq",
    geonameid: 169897,
  },
  {
    name: "Ḩamāh",
    country: "Syria",
    subcountry: "Hama",
    geonameid: 170017,
  },
  {
    name: "Ḩalfāyā",
    country: "Syria",
    subcountry: "Hama",
    geonameid: 170044,
  },
  {
    name: "Aleppo",
    country: "Syria",
    subcountry: "Aleppo",
    geonameid: 170063,
  },
  {
    name: "Dūmā",
    country: "Syria",
    subcountry: "Rif-dimashq",
    geonameid: 170592,
  },
  {
    name: "Damascus",
    country: "Syria",
    subcountry: "Dimashq",
    geonameid: 170654,
  },
  {
    name: "Dayr Ḩāfir",
    country: "Syria",
    subcountry: "Aleppo",
    geonameid: 170785,
  },
  {
    name: "Deir ez-Zor",
    country: "Syria",
    subcountry: "Deir ez-Zor",
    geonameid: 170794,
  },
  {
    name: "Ad Darbāsīyah",
    country: "Syria",
    subcountry: "Al-Hasakah",
    geonameid: 170887,
  },
  {
    name: "Dārayyā",
    country: "Syria",
    subcountry: "Rif-dimashq",
    geonameid: 170892,
  },
  {
    name: "Dar‘ā",
    country: "Syria",
    subcountry: "Daraa",
    geonameid: 170905,
  },
  {
    name: "Binnish",
    country: "Syria",
    subcountry: "Idlib",
    geonameid: 171451,
  },
  {
    name: "Batabo",
    country: "Syria",
    subcountry: "Aleppo",
    geonameid: 171694,
  },
  {
    name: "Bāniyās",
    country: "Syria",
    subcountry: "Tartus",
    geonameid: 171830,
  },
  {
    name: "Az Zabadānī",
    country: "Syria",
    subcountry: "Rif-dimashq",
    geonameid: 172059,
  },
  {
    name: "I‘zāz",
    country: "Syria",
    subcountry: "Aleppo",
    geonameid: 172082,
  },
  {
    name: "‘Ayn al ‘Arab",
    country: "Syria",
    subcountry: "Aleppo",
    geonameid: 172256,
  },
  {
    name: "At Tall",
    country: "Syria",
    subcountry: "Rif-dimashq",
    geonameid: 172349,
  },
  {
    name: "Ath Thawrah",
    country: "Syria",
    subcountry: "Ar-Raqqah",
    geonameid: 172374,
  },
  {
    name: "As-Suwayda",
    country: "Syria",
    subcountry: "As-Suwayda",
    geonameid: 172408,
  },
  {
    name: "Aş Şanamayn",
    country: "Syria",
    subcountry: "Daraa",
    geonameid: 172469,
  },
  {
    name: "As Safīrah",
    country: "Syria",
    subcountry: "Aleppo",
    geonameid: 172503,
  },
  {
    name: "Ar Rastan",
    country: "Syria",
    subcountry: "Homs",
    geonameid: 172946,
  },
  {
    name: "Ar Raqqah",
    country: "Syria",
    subcountry: "Ar-Raqqah",
    geonameid: 172955,
  },
  {
    name: "An Nabk",
    country: "Syria",
    subcountry: "Rif-dimashq",
    geonameid: 173193,
  },
  {
    name: "Al Quţayfah",
    country: "Syria",
    subcountry: "Rif-dimashq",
    geonameid: 173312,
  },
  {
    name: "Al Quşayr",
    country: "Syria",
    subcountry: "Homs",
    geonameid: 173322,
  },
  {
    name: "Al Qunayţirah",
    country: "Syria",
    subcountry: "Quneitra",
    geonameid: 173334,
  },
  {
    name: "Al Qaryatayn",
    country: "Syria",
    subcountry: "Homs",
    geonameid: 173361,
  },
  {
    name: "Al Mayādīn",
    country: "Syria",
    subcountry: "Deir ez-Zor",
    geonameid: 173480,
  },
  {
    name: "Latakia",
    country: "Syria",
    subcountry: "Latakia",
    geonameid: 173576,
  },
  {
    name: "Al Kiswah",
    country: "Syria",
    subcountry: "Rif-dimashq",
    geonameid: 173598,
  },
  {
    name: "Al Ḩasakah",
    country: "Syria",
    subcountry: "Al-Hasakah",
    geonameid: 173811,
  },
  {
    name: "Al Ḩirāk",
    country: "Syria",
    subcountry: "Daraa",
    geonameid: 173819,
  },
  {
    name: "Al Bāb",
    country: "Syria",
    subcountry: "Aleppo",
    geonameid: 174018,
  },
  {
    name: "‘Afrīn",
    country: "Syria",
    subcountry: "Aleppo",
    geonameid: 174186,
  },
  {
    name: "Ad Dānā",
    country: "Syria",
    subcountry: "Idlib",
    geonameid: 174259,
  },
  {
    name: "Ālbū Kamāl",
    country: "Syria",
    subcountry: "Deir ez-Zor",
    geonameid: 174448,
  },
  {
    name: "Hajīn",
    country: "Syria",
    subcountry: "Deir ez-Zor",
    geonameid: 174506,
  },
  {
    name: "Mbabane",
    country: "Eswatini",
    subcountry: "Hhohho",
    geonameid: 934985,
  },
  {
    name: "Manzini",
    country: "Eswatini",
    subcountry: "Manzini",
    geonameid: 934995,
  },
  {
    name: "Lobamba",
    country: "Eswatini",
    subcountry: "Hhohho",
    geonameid: 935048,
  },
  {
    name: "Cockburn Town",
    country: "Turks and Caicos Islands",
    subcountry: "N/A",
    geonameid: 3576994,
  },
  {
    name: "Fada",
    country: "Chad",
    subcountry: "Ennedi-Ouest",
    geonameid: 244128,
  },
  {
    name: "Am-Timan",
    country: "Chad",
    subcountry: "Salamat",
    geonameid: 245338,
  },
  {
    name: "Abéché",
    country: "Chad",
    subcountry: "Ouadaï",
    geonameid: 245785,
  },
  {
    name: "Sarh",
    country: "Chad",
    subcountry: "Moyen-Chari",
    geonameid: 2425791,
  },
  {
    name: "Pala",
    country: "Chad",
    subcountry: "Mayo-Kebbi Ouest",
    geonameid: 2426240,
  },
  {
    name: "Oum Hadjer",
    country: "Chad",
    subcountry: "Batha",
    geonameid: 2426370,
  },
  {
    name: "N'Djamena",
    country: "Chad",
    subcountry: "N’Djaména",
    geonameid: 2427123,
  },
  {
    name: "Moussoro",
    country: "Chad",
    subcountry: "Barh el Gazel",
    geonameid: 2427336,
  },
  {
    name: "Moundou",
    country: "Chad",
    subcountry: "Logone Occidental",
    geonameid: 2427455,
  },
  {
    name: "Mongo",
    country: "Chad",
    subcountry: "Guéra",
    geonameid: 2427637,
  },
  {
    name: "Mboursou Léré",
    country: "Chad",
    subcountry: "Mayo-Kebbi Ouest",
    geonameid: 2428042,
  },
  {
    name: "Massakory",
    country: "Chad",
    subcountry: "Hadjer-Lamis",
    geonameid: 2428228,
  },
  {
    name: "Massaguet",
    country: "Chad",
    subcountry: "Hadjer-Lamis",
    geonameid: 2428231,
  },
  {
    name: "Mao",
    country: "Chad",
    subcountry: "Kanem",
    geonameid: 2428394,
  },
  {
    name: "Laï",
    country: "Chad",
    subcountry: "Tandjilé",
    geonameid: 2429296,
  },
  {
    name: "Kyabé",
    country: "Chad",
    subcountry: "Moyen-Chari",
    geonameid: 2429344,
  },
  {
    name: "Koumra",
    country: "Chad",
    subcountry: "Mandoul",
    geonameid: 2429605,
  },
  {
    name: "Kelo",
    country: "Chad",
    subcountry: "Tandjilé",
    geonameid: 2430506,
  },
  {
    name: "Dourbali",
    country: "Chad",
    subcountry: "Chari-Baguirmi",
    geonameid: 2433055,
  },
  {
    name: "Doba",
    country: "Chad",
    subcountry: "Logone Oriental",
    geonameid: 2433437,
  },
  {
    name: "Bongor",
    country: "Chad",
    subcountry: "Mayo-Kebbi Est",
    geonameid: 2434910,
  },
  {
    name: "Bitkine",
    country: "Chad",
    subcountry: "Guéra",
    geonameid: 2435124,
  },
  {
    name: "Benoy",
    country: "Chad",
    subcountry: "Logone Occidental",
    geonameid: 2435508,
  },
  {
    name: "Ati",
    country: "Chad",
    subcountry: "Batha",
    geonameid: 2436400,
  },
  {
    name: "Port-aux-Français",
    country: "French Southern Territories",
    subcountry: "Kerguelen",
    geonameid: 1546102,
  },
  {
    name: "Vogan",
    country: "Togo",
    subcountry: "Maritime",
    geonameid: 2363490,
  },
  {
    name: "Tsévié",
    country: "Togo",
    subcountry: "Maritime",
    geonameid: 2363534,
  },
  {
    name: "Tchamba",
    country: "Togo",
    subcountry: "Centrale",
    geonameid: 2363908,
  },
  {
    name: "Sotouboua",
    country: "Togo",
    subcountry: "Centrale",
    geonameid: 2364079,
  },
  {
    name: "Sokodé",
    country: "Togo",
    subcountry: "Centrale",
    geonameid: 2364104,
  },
  {
    name: "Notsé",
    country: "Togo",
    subcountry: "Plateaux",
    geonameid: 2364752,
  },
  {
    name: "Niamtougou",
    country: "Togo",
    subcountry: "Kara",
    geonameid: 2364812,
  },
  {
    name: "Mango",
    country: "Togo",
    subcountry: "Savanes",
    geonameid: 2365190,
  },
  {
    name: "Lomé",
    country: "Togo",
    subcountry: "Maritime",
    geonameid: 2365267,
  },
  {
    name: "Kpalimé",
    country: "Togo",
    subcountry: "Plateaux",
    geonameid: 2365560,
  },
  {
    name: "Kara",
    country: "Togo",
    subcountry: "Kara",
    geonameid: 2366152,
  },
  {
    name: "Dapaong",
    country: "Togo",
    subcountry: "Savanes",
    geonameid: 2367164,
  },
  {
    name: "Bassar",
    country: "Togo",
    subcountry: "Kara",
    geonameid: 2367568,
  },
  {
    name: "Bafilo",
    country: "Togo",
    subcountry: "Kara",
    geonameid: 2367656,
  },
  {
    name: "Badou",
    country: "Togo",
    subcountry: "Plateaux",
    geonameid: 2367660,
  },
  {
    name: "Atakpamé",
    country: "Togo",
    subcountry: "Plateaux",
    geonameid: 2367886,
  },
  {
    name: "Aného",
    country: "Togo",
    subcountry: "Maritime",
    geonameid: 2367990,
  },
  {
    name: "Ban Talat Yai",
    country: "Thailand",
    subcountry: "Phuket",
    geonameid: 1117652,
  },
  {
    name: "Ban Talat Nua",
    country: "Thailand",
    subcountry: "Phuket",
    geonameid: 1117656,
  },
  {
    name: "Sam Roi Yot",
    country: "Thailand",
    subcountry: "Prachuap Khiri Khan",
    geonameid: 1117823,
  },
  {
    name: "Phetchaburi",
    country: "Thailand",
    subcountry: "Phetchaburi",
    geonameid: 1149698,
  },
  {
    name: "Trang",
    country: "Thailand",
    subcountry: "Trang",
    geonameid: 1150007,
  },
  {
    name: "Thung Song",
    country: "Thailand",
    subcountry: "Nakhon Si Thammarat",
    geonameid: 1150085,
  },
  {
    name: "Thoen",
    country: "Thailand",
    subcountry: "Lampang",
    geonameid: 1150154,
  },
  {
    name: "Thap Than",
    country: "Thailand",
    subcountry: "Uthai Thani",
    geonameid: 1150210,
  },
  {
    name: "Tha Muang",
    country: "Thailand",
    subcountry: "Kanchanaburi",
    geonameid: 1150246,
  },
  {
    name: "Tha Maka",
    country: "Thailand",
    subcountry: "Kanchanaburi",
    geonameid: 1150275,
  },
  {
    name: "Tak",
    country: "Thailand",
    subcountry: "Tak",
    geonameid: 1150490,
  },
  {
    name: "Surat Thani",
    country: "Thailand",
    subcountry: "Surat Thani",
    geonameid: 1150515,
  },
  {
    name: "Sukhothai",
    country: "Thailand",
    subcountry: "Sukhothai",
    geonameid: 1150533,
  },
  {
    name: "Si Satchanalai",
    country: "Thailand",
    subcountry: "Sukhothai",
    geonameid: 1150624,
  },
  {
    name: "Sawankhalok",
    country: "Thailand",
    subcountry: "Sukhothai",
    geonameid: 1150681,
  },
  {
    name: "San Pa Tong",
    country: "Thailand",
    subcountry: "Chiang Mai",
    geonameid: 1150728,
  },
  {
    name: "San Kamphaeng",
    country: "Thailand",
    subcountry: "Chiang Mai",
    geonameid: 1150732,
  },
  {
    name: "Ron Phibun",
    country: "Thailand",
    subcountry: "Nakhon Si Thammarat",
    geonameid: 1150921,
  },
  {
    name: "Ratchaburi",
    country: "Thailand",
    subcountry: "Ratchaburi",
    geonameid: 1150954,
  },
  {
    name: "Ranong",
    country: "Thailand",
    subcountry: "Ranong",
    geonameid: 1150965,
  },
  {
    name: "Pran Buri",
    country: "Thailand",
    subcountry: "Prachuap Khiri Khan",
    geonameid: 1151063,
  },
  {
    name: "Prachuap Khiri Khan",
    country: "Thailand",
    subcountry: "Prachuap Khiri Khan",
    geonameid: 1151074,
  },
  {
    name: "Tha Kham",
    country: "Thailand",
    subcountry: "Surat Thani",
    geonameid: 1151211,
  },
  {
    name: "Phuket",
    country: "Thailand",
    subcountry: "Phuket",
    geonameid: 1151254,
  },
  {
    name: "Photharam",
    country: "Thailand",
    subcountry: "Ratchaburi",
    geonameid: 1151340,
  },
  {
    name: "Phayao",
    country: "Thailand",
    subcountry: "Phayao",
    geonameid: 1151426,
  },
  {
    name: "Pa Sang",
    country: "Thailand",
    subcountry: "Lamphun",
    geonameid: 1151528,
  },
  {
    name: "Nakhon Si Thammarat",
    country: "Thailand",
    subcountry: "Nakhon Si Thammarat",
    geonameid: 1151933,
  },
  {
    name: "Mae Sot",
    country: "Thailand",
    subcountry: "Tak",
    geonameid: 1152188,
  },
  {
    name: "Mae Sai",
    country: "Thailand",
    subcountry: "Chiang Rai",
    geonameid: 1152194,
  },
  {
    name: "Mae Ramat",
    country: "Thailand",
    subcountry: "Tak",
    geonameid: 1152202,
  },
  {
    name: "Mae Chan",
    country: "Thailand",
    subcountry: "Chiang Rai",
    geonameid: 1152227,
  },
  {
    name: "Lat Yao",
    country: "Thailand",
    subcountry: "Nakhon Sawan",
    geonameid: 1152377,
  },
  {
    name: "Lang Suan",
    country: "Thailand",
    subcountry: "Chumphon",
    geonameid: 1152432,
  },
  {
    name: "Lamphun",
    country: "Thailand",
    subcountry: "Lamphun",
    geonameid: 1152468,
  },
  {
    name: "Lampang",
    country: "Thailand",
    subcountry: "Lampang",
    geonameid: 1152473,
  },
  {
    name: "Kui Buri",
    country: "Thailand",
    subcountry: "Prachuap Khiri Khan",
    geonameid: 1152562,
  },
  {
    name: "Krabi",
    country: "Thailand",
    subcountry: "Krabi",
    geonameid: 1152633,
  },
  {
    name: "Khao Yoi",
    country: "Thailand",
    subcountry: "Phetchaburi",
    geonameid: 1152919,
  },
  {
    name: "Khanu Woralaksaburi",
    country: "Thailand",
    subcountry: "Kamphaeng Phet",
    geonameid: 1152953,
  },
  {
    name: "Kathu",
    country: "Thailand",
    subcountry: "Phuket",
    geonameid: 1153035,
  },
  {
    name: "Kanchanaburi",
    country: "Thailand",
    subcountry: "Kanchanaburi",
    geonameid: 1153081,
  },
  {
    name: "Kamphaeng Phet",
    country: "Thailand",
    subcountry: "Kamphaeng Phet",
    geonameid: 1153090,
  },
  {
    name: "Huai Yot",
    country: "Thailand",
    subcountry: "Trang",
    geonameid: 1153241,
  },
  {
    name: "Hua Hin",
    country: "Thailand",
    subcountry: "Prachuap Khiri Khan",
    geonameid: 1153269,
  },
  {
    name: "Hang Dong",
    country: "Thailand",
    subcountry: "Chiang Mai",
    geonameid: 1153386,
  },
  {
    name: "Dok Kham Tai",
    country: "Thailand",
    subcountry: "Phayao",
    geonameid: 1153464,
  },
  {
    name: "Damnoen Saduak",
    country: "Thailand",
    subcountry: "Ratchaburi",
    geonameid: 1153513,
  },
  {
    name: "Chumphon",
    country: "Thailand",
    subcountry: "Chumphon",
    geonameid: 1153557,
  },
  {
    name: "Chom Bueng",
    country: "Thailand",
    subcountry: "Ratchaburi",
    geonameid: 1153646,
  },
  {
    name: "Chiang Rai",
    country: "Thailand",
    subcountry: "Chiang Rai",
    geonameid: 1153669,
  },
  {
    name: "Chiang Mai",
    country: "Thailand",
    subcountry: "Chiang Mai",
    geonameid: 1153671,
  },
  {
    name: "Cha-am",
    country: "Thailand",
    subcountry: "Phetchaburi",
    geonameid: 1153807,
  },
  {
    name: "Bo Phloi",
    country: "Thailand",
    subcountry: "Kanchanaburi",
    geonameid: 1153850,
  },
  {
    name: "Ban Tak",
    country: "Thailand",
    subcountry: "Tak",
    geonameid: 1154677,
  },
  {
    name: "Ko Samui",
    country: "Thailand",
    subcountry: "Surat Thani",
    geonameid: 1154689,
  },
  {
    name: "Ban Pong",
    country: "Thailand",
    subcountry: "Ratchaburi",
    geonameid: 1155139,
  },
  {
    name: "Ban Na San",
    country: "Thailand",
    subcountry: "Surat Thani",
    geonameid: 1156046,
  },
  {
    name: "Ban Na",
    country: "Thailand",
    subcountry: "Sukhothai",
    geonameid: 1156257,
  },
  {
    name: "Bang Saphan",
    country: "Thailand",
    subcountry: "Prachuap Khiri Khan",
    geonameid: 1157662,
  },
  {
    name: "Bang Phae",
    country: "Thailand",
    subcountry: "Ratchaburi",
    geonameid: 1157683,
  },
  {
    name: "Nong Kung Si",
    country: "Thailand",
    subcountry: "Kalasin",
    geonameid: 1595679,
  },
  {
    name: "Ban Nong Wua So",
    country: "Thailand",
    subcountry: "Udon Thani",
    geonameid: 1599640,
  },
  {
    name: "Ban Mai",
    country: "Thailand",
    subcountry: "Songkhla",
    geonameid: 1601579,
  },
  {
    name: "Ban Huai Thalaeng",
    country: "Thailand",
    subcountry: "Nakhon Ratchasima",
    geonameid: 1603235,
  },
  {
    name: "Ban Khlong Bang Sao Thong",
    country: "Thailand",
    subcountry: "Samut Prakan",
    geonameid: 1604452,
  },
  {
    name: "Na Klang",
    country: "Thailand",
    subcountry: "Nong Bua Lam Phu",
    geonameid: 1604654,
  },
  {
    name: "Yasothon",
    country: "Thailand",
    subcountry: "Yasothon",
    geonameid: 1604769,
  },
  {
    name: "Yaring",
    country: "Thailand",
    subcountry: "Pattani",
    geonameid: 1604771,
  },
  {
    name: "Yala",
    country: "Thailand",
    subcountry: "Yala",
    geonameid: 1604870,
  },
  {
    name: "Wiset Chaichan",
    country: "Thailand",
    subcountry: "Ang Thong",
    geonameid: 1605018,
  },
  {
    name: "Wichian Buri",
    country: "Thailand",
    subcountry: "Phetchabun",
    geonameid: 1605024,
  },
  {
    name: "Warin Chamrap",
    country: "Thailand",
    subcountry: "Ubon Ratchathani",
    geonameid: 1605069,
  },
  {
    name: "Wang Saphung",
    country: "Thailand",
    subcountry: "Loei",
    geonameid: 1605102,
  },
  {
    name: "Wang Noi",
    country: "Thailand",
    subcountry: "Phra Nakhon Si Ayutthaya",
    geonameid: 1605118,
  },
  {
    name: "Wang Nam Yen",
    country: "Thailand",
    subcountry: "Sa Kaeo",
    geonameid: 1605119,
  },
  {
    name: "Uttaradit",
    country: "Thailand",
    subcountry: "Uttaradit",
    geonameid: 1605215,
  },
  {
    name: "Uthai Thani",
    country: "Thailand",
    subcountry: "Uthai Thani",
    geonameid: 1605221,
  },
  {
    name: "Udon Thani",
    country: "Thailand",
    subcountry: "Udon Thani",
    geonameid: 1605239,
  },
  {
    name: "Ubon Ratchathani",
    country: "Thailand",
    subcountry: "Ubon Ratchathani",
    geonameid: 1605245,
  },
  {
    name: "Trat",
    country: "Thailand",
    subcountry: "Trat",
    geonameid: 1605279,
  },
  {
    name: "Tha Yang",
    country: "Thailand",
    subcountry: "Phetchaburi",
    geonameid: 1605467,
  },
  {
    name: "Tha Ruea",
    country: "Thailand",
    subcountry: "Phra Nakhon Si Ayutthaya",
    geonameid: 1605509,
  },
  {
    name: "Thap Khlo",
    country: "Thailand",
    subcountry: "Phichit",
    geonameid: 1605538,
  },
  {
    name: "Tha Mai",
    country: "Thailand",
    subcountry: "Chanthaburi",
    geonameid: 1605601,
  },
  {
    name: "Tha Bo",
    country: "Thailand",
    subcountry: "Nong Khai",
    geonameid: 1605677,
  },
  {
    name: "Taphan Hin",
    country: "Thailand",
    subcountry: "Phichit",
    geonameid: 1605754,
  },
  {
    name: "Tak Bai",
    country: "Thailand",
    subcountry: "Narathiwat",
    geonameid: 1605957,
  },
  {
    name: "Surin",
    country: "Thailand",
    subcountry: "Surin",
    geonameid: 1606030,
  },
  {
    name: "Suphan Buri",
    country: "Thailand",
    subcountry: "Suphanburi",
    geonameid: 1606033,
  },
  {
    name: "Su-ngai Kolok",
    country: "Thailand",
    subcountry: "Narathiwat",
    geonameid: 1606050,
  },
  {
    name: "Songkhla",
    country: "Thailand",
    subcountry: "Songkhla",
    geonameid: 1606147,
  },
  {
    name: "Si Sa Ket",
    country: "Thailand",
    subcountry: "Si Sa Ket",
    geonameid: 1606239,
  },
  {
    name: "Si Racha",
    country: "Thailand",
    subcountry: "Chon Buri",
    geonameid: 1606250,
  },
  {
    name: "Sing Buri",
    country: "Thailand",
    subcountry: "Sing Buri",
    geonameid: 1606270,
  },
  {
    name: "Seka",
    country: "Thailand",
    subcountry: "Bueng Kan",
    geonameid: 1606343,
  },
  {
    name: "Sawang Daen Din",
    country: "Thailand",
    subcountry: "Sakon Nakhon",
    geonameid: 1606350,
  },
  {
    name: "Satun",
    country: "Thailand",
    subcountry: "Satun",
    geonameid: 1606376,
  },
  {
    name: "Sattahip",
    country: "Thailand",
    subcountry: "Chon Buri",
    geonameid: 1606386,
  },
  {
    name: "Saraburi",
    country: "Thailand",
    subcountry: "Saraburi",
    geonameid: 1606418,
  },
  {
    name: "Samut Songkhram",
    country: "Thailand",
    subcountry: "Samut Songkhram",
    geonameid: 1606586,
  },
  {
    name: "Samut Sakhon",
    country: "Thailand",
    subcountry: "Samut Sakhon",
    geonameid: 1606588,
  },
  {
    name: "Samut Prakan",
    country: "Thailand",
    subcountry: "Samut Prakan",
    geonameid: 1606590,
  },
  {
    name: "Sam Phran",
    country: "Thailand",
    subcountry: "Nakhon Pathom",
    geonameid: 1606638,
  },
  {
    name: "Sakon Nakhon",
    country: "Thailand",
    subcountry: "Sakon Nakhon",
    geonameid: 1606790,
  },
  {
    name: "Sa Kaeo",
    country: "Thailand",
    subcountry: "Sa Kaeo",
    geonameid: 1606807,
  },
  {
    name: "Sadao",
    country: "Thailand",
    subcountry: "Songkhla",
    geonameid: 1606939,
  },
  {
    name: "Roi Et",
    country: "Thailand",
    subcountry: "Roi Et",
    geonameid: 1607001,
  },
  {
    name: "Rayong",
    country: "Thailand",
    subcountry: "Rayong",
    geonameid: 1607017,
  },
  {
    name: "Ranot",
    country: "Thailand",
    subcountry: "Songkhla",
    geonameid: 1607068,
  },
  {
    name: "Ra-ngae",
    country: "Thailand",
    subcountry: "Narathiwat",
    geonameid: 1607083,
  },
  {
    name: "Prakhon Chai",
    country: "Thailand",
    subcountry: "Buriram",
    geonameid: 1607257,
  },
  {
    name: "Prachin Buri",
    country: "Thailand",
    subcountry: "Prachin Buri",
    geonameid: 1607280,
  },
  {
    name: "Phu Kradueng",
    country: "Thailand",
    subcountry: "Loei",
    geonameid: 1607435,
  },
  {
    name: "Phu Khiao",
    country: "Thailand",
    subcountry: "Chaiyaphum",
    geonameid: 1607439,
  },
  {
    name: "Phra Pradaeng",
    country: "Thailand",
    subcountry: "Samut Prakan",
    geonameid: 1607508,
  },
  {
    name: "Phra Phutthabat",
    country: "Thailand",
    subcountry: "Saraburi",
    geonameid: 1607512,
  },
  {
    name: "Phra Nakhon Si Ayutthaya",
    country: "Thailand",
    subcountry: "Phra Nakhon Si Ayutthaya",
    geonameid: 1607532,
  },
  {
    name: "Phrae",
    country: "Thailand",
    subcountry: "Phrae",
    geonameid: 1607552,
  },
  {
    name: "Phon Charoen",
    country: "Thailand",
    subcountry: "Nong Khai",
    geonameid: 1607615,
  },
  {
    name: "Phitsanulok",
    country: "Thailand",
    subcountry: "Phitsanulok",
    geonameid: 1607708,
  },
  {
    name: "Phichit",
    country: "Thailand",
    subcountry: "Phichit",
    geonameid: 1607725,
  },
  {
    name: "Phibun Mangsahan",
    country: "Thailand",
    subcountry: "Ubon Ratchathani",
    geonameid: 1607730,
  },
  {
    name: "Phetchabun",
    country: "Thailand",
    subcountry: "Phetchabun",
    geonameid: 1607737,
  },
  {
    name: "Phatthalung",
    country: "Thailand",
    subcountry: "Phatthalung",
    geonameid: 1607779,
  },
  {
    name: "Phasi Charoen",
    country: "Thailand",
    subcountry: "Bangkok",
    geonameid: 1607782,
  },
  {
    name: "Phan Thong",
    country: "Thailand",
    subcountry: "Chon Buri",
    geonameid: 1607793,
  },
  {
    name: "Phanom Sarakham",
    country: "Thailand",
    subcountry: "Chachoengsao",
    geonameid: 1607801,
  },
  {
    name: "Phanat Nikhom",
    country: "Thailand",
    subcountry: "Chon Buri",
    geonameid: 1607838,
  },
  {
    name: "Phak Hai",
    country: "Thailand",
    subcountry: "Phra Nakhon Si Ayutthaya",
    geonameid: 1607865,
  },
  {
    name: "Pattani",
    country: "Thailand",
    subcountry: "Pattani",
    geonameid: 1607978,
  },
  {
    name: "Pathum Thani",
    country: "Thailand",
    subcountry: "Pathum Thani",
    geonameid: 1607983,
  },
  {
    name: "Pak Phanang",
    country: "Thailand",
    subcountry: "Nakhon Si Thammarat",
    geonameid: 1608033,
  },
  {
    name: "Pak Kret",
    country: "Thailand",
    subcountry: "Nonthaburi",
    geonameid: 1608048,
  },
  {
    name: "Pak Chong",
    country: "Thailand",
    subcountry: "Nakhon Ratchasima",
    geonameid: 1608057,
  },
  {
    name: "Mueang Nonthaburi",
    country: "Thailand",
    subcountry: "Nonthaburi",
    geonameid: 1608133,
  },
  {
    name: "Non Sung",
    country: "Thailand",
    subcountry: "Nakhon Ratchasima",
    geonameid: 1608136,
  },
  {
    name: "Nong Phai",
    country: "Thailand",
    subcountry: "Phetchabun",
    geonameid: 1608191,
  },
  {
    name: "Nong Khai",
    country: "Thailand",
    subcountry: "Nong Khai",
    geonameid: 1608232,
  },
  {
    name: "Nong Khae",
    country: "Thailand",
    subcountry: "Saraburi",
    geonameid: 1608239,
  },
  {
    name: "Nong Bua Lamphu",
    country: "Thailand",
    subcountry: "Nong Bua Lam Phu",
    geonameid: 1608269,
  },
  {
    name: "Narathiwat",
    country: "Thailand",
    subcountry: "Narathiwat",
    geonameid: 1608409,
  },
  {
    name: "Nang Rong",
    country: "Thailand",
    subcountry: "Buriram",
    geonameid: 1608424,
  },
  {
    name: "Nan",
    country: "Thailand",
    subcountry: "Nan",
    geonameid: 1608452,
  },
  {
    name: "Nam Som",
    country: "Thailand",
    subcountry: "Udon Thani",
    geonameid: 1608462,
  },
  {
    name: "Nakhon Sawan",
    country: "Thailand",
    subcountry: "Nakhon Sawan",
    geonameid: 1608527,
  },
  {
    name: "Nakhon Ratchasima",
    country: "Thailand",
    subcountry: "Nakhon Ratchasima",
    geonameid: 1608529,
  },
  {
    name: "Nakhon Phanom",
    country: "Thailand",
    subcountry: "Nakhon Phanom",
    geonameid: 1608531,
  },
  {
    name: "Nakhon Pathom",
    country: "Thailand",
    subcountry: "Nakhon Pathom",
    geonameid: 1608534,
  },
  {
    name: "Nakhon Nayok",
    country: "Thailand",
    subcountry: "Nakhon Nayok",
    geonameid: 1608539,
  },
  {
    name: "Nakhon Luang",
    country: "Thailand",
    subcountry: "Phra Nakhon Si Ayutthaya",
    geonameid: 1608541,
  },
  {
    name: "Mukdahan",
    country: "Thailand",
    subcountry: "Mukdahan",
    geonameid: 1608597,
  },
  {
    name: "Makkasan",
    country: "Thailand",
    subcountry: "Bangkok",
    geonameid: 1608797,
  },
  {
    name: "Maha Sarakham",
    country: "Thailand",
    subcountry: "Maha Sarakham",
    geonameid: 1608900,
  },
  {
    name: "Lop Buri",
    country: "Thailand",
    subcountry: "Lopburi",
    geonameid: 1609032,
  },
  {
    name: "Lom Sak",
    country: "Thailand",
    subcountry: "Phetchabun",
    geonameid: 1609043,
  },
  {
    name: "Loei",
    country: "Thailand",
    subcountry: "Loei",
    geonameid: 1609071,
  },
  {
    name: "Laem Sing",
    country: "Thailand",
    subcountry: "Chanthaburi",
    geonameid: 1609278,
  },
  {
    name: "Kut Chap",
    country: "Thailand",
    subcountry: "Udon Thani",
    geonameid: 1609324,
  },
  {
    name: "Kuchinarai",
    country: "Thailand",
    subcountry: "Kalasin",
    geonameid: 1609345,
  },
  {
    name: "Bangkok",
    country: "Thailand",
    subcountry: "Bangkok",
    geonameid: 1609350,
  },
  {
    name: "Krathum Baen",
    country: "Thailand",
    subcountry: "Samut Sakhon",
    geonameid: 1609395,
  },
  {
    name: "Klaeng",
    country: "Thailand",
    subcountry: "Rayong",
    geonameid: 1609610,
  },
  {
    name: "Khon Kaen",
    country: "Thailand",
    subcountry: "Khon Kaen",
    geonameid: 1609776,
  },
  {
    name: "Khon Buri",
    country: "Thailand",
    subcountry: "Nakhon Ratchasima",
    geonameid: 1609795,
  },
  {
    name: "Khlong Luang",
    country: "Thailand",
    subcountry: "Pathum Thani",
    geonameid: 1609899,
  },
  {
    name: "Khao Wong",
    country: "Thailand",
    subcountry: "Kalasin",
    geonameid: 1609990,
  },
  {
    name: "Kaset Wisai",
    country: "Thailand",
    subcountry: "Roi Et",
    geonameid: 1610185,
  },
  {
    name: "Kaset Sombun",
    country: "Thailand",
    subcountry: "Chaiyaphum",
    geonameid: 1610187,
  },
  {
    name: "Kantharalak",
    country: "Thailand",
    subcountry: "Si Sa Ket",
    geonameid: 1610227,
  },
  {
    name: "Kamalasai",
    country: "Thailand",
    subcountry: "Kalasin",
    geonameid: 1610459,
  },
  {
    name: "Kalasin",
    country: "Thailand",
    subcountry: "Kalasin",
    geonameid: 1610469,
  },
  {
    name: "Kaeng Khoi",
    country: "Thailand",
    subcountry: "Saraburi",
    geonameid: 1610503,
  },
  {
    name: "Kaeng Khro",
    country: "Thailand",
    subcountry: "Chaiyaphum",
    geonameid: 1610505,
  },
  {
    name: "Kabin Buri",
    country: "Thailand",
    subcountry: "Prachin Buri",
    geonameid: 1610538,
  },
  {
    name: "Hat Yai",
    country: "Thailand",
    subcountry: "Songkhla",
    geonameid: 1610780,
  },
  {
    name: "Det Udom",
    country: "Thailand",
    subcountry: "Ubon Ratchathani",
    geonameid: 1610940,
  },
  {
    name: "Den Chai",
    country: "Thailand",
    subcountry: "Phrae",
    geonameid: 1610943,
  },
  {
    name: "Dan Khun Thot",
    country: "Thailand",
    subcountry: "Nakhon Ratchasima",
    geonameid: 1610963,
  },
  {
    name: "Chum Phae",
    country: "Thailand",
    subcountry: "Khon Kaen",
    geonameid: 1611026,
  },
  {
    name: "Chon Daen",
    country: "Thailand",
    subcountry: "Phetchabun",
    geonameid: 1611106,
  },
  {
    name: "Chon Buri",
    country: "Thailand",
    subcountry: "Chon Buri",
    geonameid: 1611110,
  },
  {
    name: "Chok Chai",
    country: "Thailand",
    subcountry: "Nakhon Ratchasima",
    geonameid: 1611135,
  },
  {
    name: "Chanthaburi",
    country: "Thailand",
    subcountry: "Chanthaburi",
    geonameid: 1611269,
  },
  {
    name: "Chaiyaphum",
    country: "Thailand",
    subcountry: "Chaiyaphum",
    geonameid: 1611407,
  },
  {
    name: "Chai Nat",
    country: "Thailand",
    subcountry: "Chai Nat",
    geonameid: 1611416,
  },
  {
    name: "Chai Badan",
    country: "Thailand",
    subcountry: "Lopburi",
    geonameid: 1611424,
  },
  {
    name: "Chachoengsao",
    country: "Thailand",
    subcountry: "Chachoengsao",
    geonameid: 1611439,
  },
  {
    name: "Buri Ram",
    country: "Thailand",
    subcountry: "Buriram",
    geonameid: 1611453,
  },
  {
    name: "Bua Yai",
    country: "Thailand",
    subcountry: "Nakhon Ratchasima",
    geonameid: 1611492,
  },
  {
    name: "Betong",
    country: "Thailand",
    subcountry: "Yala",
    geonameid: 1611635,
  },
  {
    name: "Ban Selaphum",
    country: "Thailand",
    subcountry: "Roi Et",
    geonameid: 1613284,
  },
  {
    name: "Ban Phe",
    country: "Thailand",
    subcountry: "Rayong",
    geonameid: 1614288,
  },
  {
    name: "Pattaya",
    country: "Thailand",
    subcountry: "Chon Buri",
    geonameid: 1614295,
  },
  {
    name: "Ban Phan Don",
    country: "Thailand",
    subcountry: "Udon Thani",
    geonameid: 1614336,
  },
  {
    name: "Ban Phai",
    country: "Thailand",
    subcountry: "Khon Kaen",
    geonameid: 1614455,
  },
  {
    name: "Ban Phaeo",
    country: "Thailand",
    subcountry: "Samut Sakhon",
    geonameid: 1614465,
  },
  {
    name: "Ban Mo",
    country: "Thailand",
    subcountry: "Saraburi",
    geonameid: 1616658,
  },
  {
    name: "Ban Lam Luk Ka",
    country: "Thailand",
    subcountry: "Pathum Thani",
    geonameid: 1617111,
  },
  {
    name: "Bang Rakam",
    country: "Thailand",
    subcountry: "Phitsanulok",
    geonameid: 1619276,
  },
  {
    name: "Bang Racham",
    country: "Thailand",
    subcountry: "Sing Buri",
    geonameid: 1619281,
  },
  {
    name: "Bang Pakong",
    country: "Thailand",
    subcountry: "Chachoengsao",
    geonameid: 1619363,
  },
  {
    name: "Bang Pa-in",
    country: "Thailand",
    subcountry: "Phra Nakhon Si Ayutthaya",
    geonameid: 1619369,
  },
  {
    name: "Bang Mun Nak",
    country: "Thailand",
    subcountry: "Phichit",
    geonameid: 1619400,
  },
  {
    name: "Bang Len",
    country: "Thailand",
    subcountry: "Nakhon Pathom",
    geonameid: 1619415,
  },
  {
    name: "Bang Lamung",
    country: "Thailand",
    subcountry: "Chon Buri",
    geonameid: 1619423,
  },
  {
    name: "Bang Kruai",
    country: "Thailand",
    subcountry: "Nonthaburi",
    geonameid: 1619434,
  },
  {
    name: "Bang Krathum",
    country: "Thailand",
    subcountry: "Phitsanulok",
    geonameid: 1619437,
  },
  {
    name: "Bang Bua Thong",
    country: "Thailand",
    subcountry: "Nonthaburi",
    geonameid: 1619602,
  },
  {
    name: "Bang Ban",
    country: "Thailand",
    subcountry: "Phra Nakhon Si Ayutthaya",
    geonameid: 1619616,
  },
  {
    name: "Ban Dung",
    country: "Thailand",
    subcountry: "Udon Thani",
    geonameid: 1619650,
  },
  {
    name: "Ban Chang",
    country: "Thailand",
    subcountry: "Rayong",
    geonameid: 1620254,
  },
  {
    name: "Ban Bueng",
    country: "Thailand",
    subcountry: "Chon Buri",
    geonameid: 1620371,
  },
  {
    name: "Ban Talat Bueng",
    country: "Thailand",
    subcountry: "Chon Buri",
    geonameid: 1620442,
  },
  {
    name: "Ban Bang Kadi Pathum Thani",
    country: "Thailand",
    subcountry: "Phra Nakhon Si Ayutthaya",
    geonameid: 1620875,
  },
  {
    name: "Bang Bo District",
    country: "Thailand",
    subcountry: "Samut Prakan",
    geonameid: 1620919,
  },
  {
    name: "Aranyaprathet",
    country: "Thailand",
    subcountry: "Sa Kaeo",
    geonameid: 1621020,
  },
  {
    name: "Amnat Charoen",
    country: "Thailand",
    subcountry: "Amnat Charoen",
    geonameid: 1621060,
  },
  {
    name: "Amphoe Sikhiu",
    country: "Thailand",
    subcountry: "Nakhon Ratchasima",
    geonameid: 1948015,
  },
  {
    name: "Wichit",
    country: "Thailand",
    subcountry: "Phuket",
    geonameid: 6696291,
  },
  {
    name: "Ban Chalong",
    country: "Thailand",
    subcountry: "Phuket",
    geonameid: 7091861,
  },
  {
    name: "Ban Ratsada",
    country: "Thailand",
    subcountry: "Phuket",
    geonameid: 7091912,
  },
  {
    name: "Yovon",
    country: "Tajikistan",
    subcountry: "Khatlon",
    geonameid: 1220112,
  },
  {
    name: "Hulbuk",
    country: "Tajikistan",
    subcountry: "Khatlon",
    geonameid: 1220163,
  },
  {
    name: "Vakhsh",
    country: "Tajikistan",
    subcountry: "Khatlon",
    geonameid: 1220219,
  },
  {
    name: "Istaravshan",
    country: "Tajikistan",
    subcountry: "Sughd",
    geonameid: 1220253,
  },
  {
    name: "Bokhtar",
    country: "Tajikistan",
    subcountry: "Khatlon",
    geonameid: 1220747,
  },
  {
    name: "Panjakent",
    country: "Tajikistan",
    subcountry: "Sughd",
    geonameid: 1220798,
  },
  {
    name: "Farkhor",
    country: "Tajikistan",
    subcountry: "Khatlon",
    geonameid: 1220826,
  },
  {
    name: "Vahdat",
    country: "Tajikistan",
    subcountry: "Republican Subordination",
    geonameid: 1220855,
  },
  {
    name: "Norak",
    country: "Tajikistan",
    subcountry: "Khatlon",
    geonameid: 1220905,
  },
  {
    name: "Kŭlob",
    country: "Tajikistan",
    subcountry: "Khatlon",
    geonameid: 1221194,
  },
  {
    name: "Kolkhozobod",
    country: "Tajikistan",
    subcountry: "Khatlon",
    geonameid: 1221259,
  },
  {
    name: "Khorugh",
    country: "Tajikistan",
    subcountry: "Gorno-Badakhshan",
    geonameid: 1221328,
  },
  {
    name: "Ishqoshim",
    country: "Tajikistan",
    subcountry: "Gorno-Badakhshan",
    geonameid: 1221614,
  },
  {
    name: "Hisor",
    country: "Tajikistan",
    subcountry: "Republican Subordination",
    geonameid: 1221714,
  },
  {
    name: "Dushanbe",
    country: "Tajikistan",
    subcountry: "Dushanbe",
    geonameid: 1221874,
  },
  {
    name: "Danghara",
    country: "Tajikistan",
    subcountry: "Khatlon",
    geonameid: 1221965,
  },
  {
    name: "Chubek",
    country: "Tajikistan",
    subcountry: "Khatlon",
    geonameid: 1221997,
  },
  {
    name: "Boshkengash",
    country: "Tajikistan",
    subcountry: "Dushanbe",
    geonameid: 1222107,
  },
  {
    name: "Tursunzoda",
    country: "Tajikistan",
    subcountry: "Republican Subordination",
    geonameid: 1282601,
  },
  {
    name: "Taboshar",
    country: "Tajikistan",
    subcountry: "Sughd",
    geonameid: 1514829,
  },
  {
    name: "Proletar",
    country: "Tajikistan",
    subcountry: "Sughd",
    geonameid: 1514839,
  },
  {
    name: "Khujand",
    country: "Tajikistan",
    subcountry: "Sughd",
    geonameid: 1514879,
  },
  {
    name: "Qayroqqum",
    country: "Tajikistan",
    subcountry: "Sughd",
    geonameid: 1514883,
  },
  {
    name: "Konibodom",
    country: "Tajikistan",
    subcountry: "Sughd",
    geonameid: 1514891,
  },
  {
    name: "Isfara",
    country: "Tajikistan",
    subcountry: "Sughd",
    geonameid: 1514896,
  },
  {
    name: "Buston",
    country: "Tajikistan",
    subcountry: "Sughd",
    geonameid: 1538311,
  },
  {
    name: "Moskovskiy",
    country: "Tajikistan",
    subcountry: "Khatlon",
    geonameid: 8416817,
  },
  {
    name: "Suai",
    country: "Timor Leste",
    subcountry: "Cova Lima",
    geonameid: 1626459,
  },
  {
    name: "Maubara",
    country: "Timor Leste",
    subcountry: "Liquiçá",
    geonameid: 1635826,
  },
  {
    name: "Maliana",
    country: "Timor Leste",
    subcountry: "Bobonaro",
    geonameid: 1636670,
  },
  {
    name: "Likisá",
    country: "Timor Leste",
    subcountry: "Liquiçá",
    geonameid: 1637730,
  },
  {
    name: "Dili",
    country: "Timor Leste",
    subcountry: "Díli",
    geonameid: 1645457,
  },
  {
    name: "Baukau",
    country: "Timor Leste",
    subcountry: "Baucau",
    geonameid: 1649539,
  },
  {
    name: "Aileu",
    country: "Timor Leste",
    subcountry: "Aileu",
    geonameid: 1651816,
  },
  {
    name: "Lospalos",
    country: "Timor Leste",
    subcountry: "Lautém",
    geonameid: 1937274,
  },
  {
    name: "Venilale",
    country: "Timor Leste",
    subcountry: "Baucau",
    geonameid: 1943235,
  },
  {
    name: "Balkanabat",
    country: "Turkmenistan",
    subcountry: "Balkan",
    geonameid: 161616,
  },
  {
    name: "Kaka",
    country: "Turkmenistan",
    subcountry: "Ahal",
    geonameid: 161901,
  },
  {
    name: "Gumdag",
    country: "Turkmenistan",
    subcountry: "Balkan",
    geonameid: 161943,
  },
  {
    name: "Bereket",
    country: "Turkmenistan",
    subcountry: "Balkan",
    geonameid: 161974,
  },
  {
    name: "Abadan",
    country: "Turkmenistan",
    subcountry: "Ahal",
    geonameid: 162099,
  },
  {
    name: "Baharly",
    country: "Turkmenistan",
    subcountry: "Ahal",
    geonameid: 162158,
  },
  {
    name: "Ashgabat",
    country: "Turkmenistan",
    subcountry: "Ashgabat",
    geonameid: 162183,
  },
  {
    name: "Änew",
    country: "Turkmenistan",
    subcountry: "Ahal",
    geonameid: 162199,
  },
  {
    name: "Yylanly",
    country: "Turkmenistan",
    subcountry: "Daşoguz",
    geonameid: 601432,
  },
  {
    name: "Tagta",
    country: "Turkmenistan",
    subcountry: "Daşoguz",
    geonameid: 601475,
  },
  {
    name: "Türkmenbaşy",
    country: "Turkmenistan",
    subcountry: "Balkan",
    geonameid: 601594,
  },
  {
    name: "Köneürgench",
    country: "Turkmenistan",
    subcountry: "Daşoguz",
    geonameid: 601608,
  },
  {
    name: "Boldumsaz",
    country: "Turkmenistan",
    subcountry: "Daşoguz",
    geonameid: 601661,
  },
  {
    name: "Daşoguz",
    country: "Turkmenistan",
    subcountry: "Daşoguz",
    geonameid: 601734,
  },
  {
    name: "Yolöten",
    country: "Turkmenistan",
    subcountry: "Mary",
    geonameid: 1218021,
  },
  {
    name: "Tejen",
    country: "Turkmenistan",
    subcountry: "Ahal",
    geonameid: 1218239,
  },
  {
    name: "Seydi",
    country: "Turkmenistan",
    subcountry: "Mary",
    geonameid: 1218420,
  },
  {
    name: "Saýat",
    country: "Turkmenistan",
    subcountry: "Lebap",
    geonameid: 1218436,
  },
  {
    name: "Mary",
    country: "Turkmenistan",
    subcountry: "Mary",
    geonameid: 1218667,
  },
  {
    name: "Kerki",
    country: "Turkmenistan",
    subcountry: "Lebap",
    geonameid: 1219002,
  },
  {
    name: "Gowurdak",
    country: "Turkmenistan",
    subcountry: "Lebap",
    geonameid: 1219392,
  },
  {
    name: "Türkmenabat",
    country: "Turkmenistan",
    subcountry: "Lebap",
    geonameid: 1219649,
  },
  {
    name: "Bayramaly",
    country: "Turkmenistan",
    subcountry: "Mary",
    geonameid: 1219762,
  },
  {
    name: "Gazojak",
    country: "Turkmenistan",
    subcountry: "Lebap",
    geonameid: 1514792,
  },
  {
    name: "Zaghouan",
    country: "Tunisia",
    subcountry: "Zaghouan Governorate",
    geonameid: 2464041,
  },
  {
    name: "Oued Lill",
    country: "Tunisia",
    subcountry: "Manouba",
    geonameid: 2464168,
  },
  {
    name: "Tunis",
    country: "Tunisia",
    subcountry: "Tunis Governorate",
    geonameid: 2464470,
  },
  {
    name: "Tozeur",
    country: "Tunisia",
    subcountry: "Tozeur Governorate",
    geonameid: 2464648,
  },
  {
    name: "Tataouine",
    country: "Tunisia",
    subcountry: "Tataouine",
    geonameid: 2464701,
  },
  {
    name: "Thala",
    country: "Tunisia",
    subcountry: "Kasserine Governorate",
    geonameid: 2464795,
  },
  {
    name: "Takelsa",
    country: "Tunisia",
    subcountry: "Nabeul Governorate",
    geonameid: 2464804,
  },
  {
    name: "Tajerouine",
    country: "Tunisia",
    subcountry: "Kef Governorate",
    geonameid: 2464809,
  },
  {
    name: "Sousse",
    country: "Tunisia",
    subcountry: "Sousse Governorate",
    geonameid: 2464915,
  },
  {
    name: "Siliana",
    country: "Tunisia",
    subcountry: "Siliana Governorate",
    geonameid: 2465030,
  },
  {
    name: "Sidi Bouzid",
    country: "Tunisia",
    subcountry: "Sidi Bouzid Governorate",
    geonameid: 2465840,
  },
  {
    name: "Skanes",
    country: "Tunisia",
    subcountry: "Monastir Governorate",
    geonameid: 2467246,
  },
  {
    name: "Sfax",
    country: "Tunisia",
    subcountry: "Sfax Governorate",
    geonameid: 2467454,
  },
  {
    name: "La Sebala du Mornag",
    country: "Tunisia",
    subcountry: "Ben Arous Governorate",
    geonameid: 2467521,
  },
  {
    name: "Radès",
    country: "Tunisia",
    subcountry: "Ben Arous Governorate",
    geonameid: 2467815,
  },
  {
    name: "Ksour Essaf",
    country: "Tunisia",
    subcountry: "Mahdia Governorate",
    geonameid: 2467856,
  },
  {
    name: "Korba",
    country: "Tunisia",
    subcountry: "Nabeul Governorate",
    geonameid: 2467920,
  },
  {
    name: "Kélibia",
    country: "Tunisia",
    subcountry: "Nabeul Governorate",
    geonameid: 2467959,
  },
  {
    name: "Kebili",
    country: "Tunisia",
    subcountry: "Kebili Governorate",
    geonameid: 2468018,
  },
  {
    name: "Ksar Hellal",
    country: "Tunisia",
    subcountry: "Monastir Governorate",
    geonameid: 2468106,
  },
  {
    name: "Carthage",
    country: "Tunisia",
    subcountry: "Tunis Governorate",
    geonameid: 2468245,
  },
  {
    name: "El Fahs",
    country: "Tunisia",
    subcountry: "Zaghouan Governorate",
    geonameid: 2468285,
  },
  {
    name: "Galaat el Andeless",
    country: "Tunisia",
    subcountry: "Ariana Governorate",
    geonameid: 2468329,
  },
  {
    name: "Gafsa",
    country: "Tunisia",
    subcountry: "Gafsa",
    geonameid: 2468353,
  },
  {
    name: "Gabès",
    country: "Tunisia",
    subcountry: "Gabès Governorate",
    geonameid: 2468369,
  },
  {
    name: "Nefta",
    country: "Tunisia",
    subcountry: "Tozeur Governorate",
    geonameid: 2468561,
  },
  {
    name: "Nabeul",
    country: "Tunisia",
    subcountry: "Nabeul Governorate",
    geonameid: 2468579,
  },
  {
    name: "Midoun",
    country: "Tunisia",
    subcountry: "Medenine Governorate",
    geonameid: 2468925,
  },
  {
    name: "Mateur",
    country: "Tunisia",
    subcountry: "Bizerte Governorate",
    geonameid: 2469088,
  },
  {
    name: "Msaken",
    country: "Tunisia",
    subcountry: "Sousse Governorate",
    geonameid: 2469140,
  },
  {
    name: "Menzel Jemil",
    country: "Tunisia",
    subcountry: "Bizerte Governorate",
    geonameid: 2469256,
  },
  {
    name: "Mennzel Bou Zelfa",
    country: "Tunisia",
    subcountry: "Nabeul Governorate",
    geonameid: 2469262,
  },
  {
    name: "Menzel Bourguiba",
    country: "Tunisia",
    subcountry: "Bizerte Governorate",
    geonameid: 2469264,
  },
  {
    name: "Menzel Abderhaman",
    country: "Tunisia",
    subcountry: "Bizerte Governorate",
    geonameid: 2469268,
  },
  {
    name: "Manouba",
    country: "Tunisia",
    subcountry: "Manouba",
    geonameid: 2469274,
  },
  {
    name: "Medjez el Bab",
    country: "Tunisia",
    subcountry: "Béja Governorate",
    geonameid: 2469386,
  },
  {
    name: "Medenine",
    country: "Tunisia",
    subcountry: "Medenine Governorate",
    geonameid: 2469473,
  },
  {
    name: "Jendouba",
    country: "Tunisia",
    subcountry: "Jendouba Governorate",
    geonameid: 2470088,
  },
  {
    name: "Zarzis",
    country: "Tunisia",
    subcountry: "Medenine Governorate",
    geonameid: 2470173,
  },
  {
    name: "Djemmal",
    country: "Tunisia",
    subcountry: "Monastir Governorate",
    geonameid: 2470191,
  },
  {
    name: "Houmt El Souk",
    country: "Tunisia",
    subcountry: "Medenine Governorate",
    geonameid: 2470384,
  },
  {
    name: "Hammam Sousse",
    country: "Tunisia",
    subcountry: "Sousse Governorate",
    geonameid: 2470579,
  },
  {
    name: "Hammam-Lif",
    country: "Tunisia",
    subcountry: "Ben Arous Governorate",
    geonameid: 2470588,
  },
  {
    name: "La Goulette",
    country: "Tunisia",
    subcountry: "Tunis Governorate",
    geonameid: 2470656,
  },
  {
    name: "Ghardimaou",
    country: "Tunisia",
    subcountry: "Jendouba Governorate",
    geonameid: 2471003,
  },
  {
    name: "Douz",
    country: "Tunisia",
    subcountry: "Kebili Governorate",
    geonameid: 2471287,
  },
  {
    name: "Douar Tindja",
    country: "Tunisia",
    subcountry: "Bizerte Governorate",
    geonameid: 2471475,
  },
  {
    name: "Dar Chabanne",
    country: "Tunisia",
    subcountry: "Nabeul Governorate",
    geonameid: 2471637,
  },
  {
    name: "Ben Arous",
    country: "Tunisia",
    subcountry: "Ben Arous Governorate",
    geonameid: 2472479,
  },
  {
    name: "Bizerte",
    country: "Tunisia",
    subcountry: "Bizerte Governorate",
    geonameid: 2472706,
  },
  {
    name: "Beni Khiar",
    country: "Tunisia",
    subcountry: "Nabeul Governorate",
    geonameid: 2472722,
  },
  {
    name: "Béja",
    country: "Tunisia",
    subcountry: "Béja Governorate",
    geonameid: 2472774,
  },
  {
    name: "Zouila",
    country: "Tunisia",
    subcountry: "Mahdia Governorate",
    geonameid: 2472833,
  },
  {
    name: "Chebba",
    country: "Tunisia",
    subcountry: "Mahdia Governorate",
    geonameid: 2473229,
  },
  {
    name: "Ariana",
    country: "Tunisia",
    subcountry: "Ariana Governorate",
    geonameid: 2473247,
  },
  {
    name: "Ar Rudayyif",
    country: "Tunisia",
    subcountry: "Gafsa",
    geonameid: 2473257,
  },
  {
    name: "Ouardenine",
    country: "Tunisia",
    subcountry: "Monastir Governorate",
    geonameid: 2473420,
  },
  {
    name: "Kairouan",
    country: "Tunisia",
    subcountry: "Kairouan",
    geonameid: 2473449,
  },
  {
    name: "Kasserine",
    country: "Tunisia",
    subcountry: "Kasserine Governorate",
    geonameid: 2473457,
  },
  {
    name: "Gremda",
    country: "Tunisia",
    subcountry: "Sfax Governorate",
    geonameid: 2473470,
  },
  {
    name: "Monastir",
    country: "Tunisia",
    subcountry: "Monastir Governorate",
    geonameid: 2473493,
  },
  {
    name: "La Mohammedia",
    country: "Tunisia",
    subcountry: "Tunis Governorate",
    geonameid: 2473499,
  },
  {
    name: "Metlaoui",
    country: "Tunisia",
    subcountry: "Gafsa",
    geonameid: 2473517,
  },
  {
    name: "Al Marsá",
    country: "Tunisia",
    subcountry: "Tunis Governorate",
    geonameid: 2473540,
  },
  {
    name: "Mahdia",
    country: "Tunisia",
    subcountry: "Mahdia Governorate",
    geonameid: 2473572,
  },
  {
    name: "El Kef",
    country: "Tunisia",
    subcountry: "Kef Governorate",
    geonameid: 2473634,
  },
  {
    name: "El Jem",
    country: "Tunisia",
    subcountry: "Mahdia Governorate",
    geonameid: 2473654,
  },
  {
    name: "Hammamet",
    country: "Tunisia",
    subcountry: "Nabeul Governorate",
    geonameid: 2473744,
  },
  {
    name: "El Hamma",
    country: "Tunisia",
    subcountry: "Gabès Governorate",
    geonameid: 2473747,
  },
  {
    name: "Bekalta",
    country: "Tunisia",
    subcountry: "Monastir Governorate",
    geonameid: 2473826,
  },
  {
    name: "El Alia",
    country: "Tunisia",
    subcountry: "Bizerte Governorate",
    geonameid: 2473876,
  },
  {
    name: "Akouda",
    country: "Tunisia",
    subcountry: "Sousse Governorate",
    geonameid: 2473913,
  },
  {
    name: "Douane",
    country: "Tunisia",
    subcountry: "Nabeul Governorate",
    geonameid: 2581754,
  },
  {
    name: "Ezzouhour",
    country: "Tunisia",
    subcountry: "Sousse Governorate",
    geonameid: 11204573,
  },
  {
    name: "Nuku‘alofa",
    country: "Tonga",
    subcountry: "Tongatapu",
    geonameid: 4032402,
  },
  {
    name: "Yüksekova",
    country: "Turkey",
    subcountry: "Hakkâri",
    geonameid: 296173,
  },
  {
    name: "Yozgat",
    country: "Turkey",
    subcountry: "Yozgat",
    geonameid: 296562,
  },
  {
    name: "Yeşilli",
    country: "Turkey",
    subcountry: "Mardin",
    geonameid: 296832,
  },
  {
    name: "Erzin",
    country: "Turkey",
    subcountry: "Hatay",
    geonameid: 296852,
  },
  {
    name: "Yerköy",
    country: "Turkey",
    subcountry: "Yozgat",
    geonameid: 296895,
  },
  {
    name: "Didim",
    country: "Turkey",
    subcountry: "Aydın",
    geonameid: 297090,
  },
  {
    name: "Yatağan",
    country: "Turkey",
    subcountry: "Muğla",
    geonameid: 297564,
  },
  {
    name: "Yalvaç",
    country: "Turkey",
    subcountry: "Isparta",
    geonameid: 297789,
  },
  {
    name: "Yahyalı",
    country: "Turkey",
    subcountry: "Kayseri",
    geonameid: 297917,
  },
  {
    name: "Viranşehir",
    country: "Turkey",
    subcountry: "Şanlıurfa",
    geonameid: 298033,
  },
  {
    name: "Varto",
    country: "Turkey",
    subcountry: "Muş",
    geonameid: 298088,
  },
  {
    name: "Van",
    country: "Turkey",
    subcountry: "Van",
    geonameid: 298117,
  },
  {
    name: "Cimin",
    country: "Turkey",
    subcountry: "Erzincan",
    geonameid: 298230,
  },
  {
    name: "Uşak",
    country: "Turkey",
    subcountry: "Uşak",
    geonameid: 298299,
  },
  {
    name: "Urla",
    country: "Turkey",
    subcountry: "İzmir Province",
    geonameid: 298316,
  },
  {
    name: "Ürgüp",
    country: "Turkey",
    subcountry: "Nevşehir Province",
    geonameid: 298326,
  },
  {
    name: "Şanlıurfa",
    country: "Turkey",
    subcountry: "Şanlıurfa",
    geonameid: 298333,
  },
  {
    name: "Turgutlu",
    country: "Turkey",
    subcountry: "Manisa",
    geonameid: 298806,
  },
  {
    name: "Tunceli",
    country: "Turkey",
    subcountry: "Tunceli",
    geonameid: 298846,
  },
  {
    name: "Torbalı",
    country: "Turkey",
    subcountry: "İzmir Province",
    geonameid: 298935,
  },
  {
    name: "Tire",
    country: "Turkey",
    subcountry: "İzmir Province",
    geonameid: 299137,
  },
  {
    name: "Tekirova",
    country: "Turkey",
    subcountry: "Antalya",
    geonameid: 299445,
  },
  {
    name: "Tavşanlı",
    country: "Turkey",
    subcountry: "Kütahya",
    geonameid: 299545,
  },
  {
    name: "Tatvan",
    country: "Turkey",
    subcountry: "Bitlis",
    geonameid: 299582,
  },
  {
    name: "Tarsus",
    country: "Turkey",
    subcountry: "Mersin",
    geonameid: 299817,
  },
  {
    name: "Talas",
    country: "Turkey",
    subcountry: "Kayseri",
    geonameid: 299900,
  },
  {
    name: "Susurluk",
    country: "Turkey",
    subcountry: "Balıkesir",
    geonameid: 300058,
  },
  {
    name: "Suruç",
    country: "Turkey",
    subcountry: "Şanlıurfa",
    geonameid: 300075,
  },
  {
    name: "Sorgun",
    country: "Turkey",
    subcountry: "Yozgat",
    geonameid: 300352,
  },
  {
    name: "Soma",
    country: "Turkey",
    subcountry: "Manisa",
    geonameid: 300371,
  },
  {
    name: "Solhan",
    country: "Turkey",
    subcountry: "Bingöl",
    geonameid: 300377,
  },
  {
    name: "Söke",
    country: "Turkey",
    subcountry: "Aydın",
    geonameid: 300399,
  },
  {
    name: "Siverek",
    country: "Turkey",
    subcountry: "Şanlıurfa",
    geonameid: 300614,
  },
  {
    name: "Sivas",
    country: "Turkey",
    subcountry: "Sivas",
    geonameid: 300619,
  },
  {
    name: "Şırnak",
    country: "Turkey",
    subcountry: "Şırnak",
    geonameid: 300640,
  },
  {
    name: "Simav",
    country: "Turkey",
    subcountry: "Kütahya",
    geonameid: 300791,
  },
  {
    name: "Silvan",
    country: "Turkey",
    subcountry: "Diyarbakır Province",
    geonameid: 300796,
  },
  {
    name: "Silopi",
    country: "Turkey",
    subcountry: "Şırnak",
    geonameid: 300797,
  },
  {
    name: "Silifke",
    country: "Turkey",
    subcountry: "Mersin",
    geonameid: 300808,
  },
  {
    name: "Siirt",
    country: "Turkey",
    subcountry: "Siirt",
    geonameid: 300822,
  },
  {
    name: "Seydişehir",
    country: "Turkey",
    subcountry: "Konya",
    geonameid: 301010,
  },
  {
    name: "Serinyol",
    country: "Turkey",
    subcountry: "Hatay",
    geonameid: 301089,
  },
  {
    name: "Serik",
    country: "Turkey",
    subcountry: "Antalya",
    geonameid: 301101,
  },
  {
    name: "Şereflikoçhisar",
    country: "Turkey",
    subcountry: "Ankara",
    geonameid: 301116,
  },
  {
    name: "Senirkent",
    country: "Turkey",
    subcountry: "Isparta",
    geonameid: 301172,
  },
  {
    name: "Şemdinli",
    country: "Turkey",
    subcountry: "Hakkâri",
    geonameid: 301209,
  },
  {
    name: "Selçuk",
    country: "Turkey",
    subcountry: "İzmir Province",
    geonameid: 301256,
  },
  {
    name: "Seferihisar",
    country: "Turkey",
    subcountry: "İzmir Province",
    geonameid: 301350,
  },
  {
    name: "Şarkışla",
    country: "Turkey",
    subcountry: "Sivas",
    geonameid: 301537,
  },
  {
    name: "Şarkîkaraağaç",
    country: "Turkey",
    subcountry: "Isparta",
    geonameid: 301539,
  },
  {
    name: "Sarayköy",
    country: "Turkey",
    subcountry: "Denizli",
    geonameid: 301827,
  },
  {
    name: "Sandıklı",
    country: "Turkey",
    subcountry: "Afyonkarahisar Province",
    geonameid: 301911,
  },
  {
    name: "Salihli",
    country: "Turkey",
    subcountry: "Manisa",
    geonameid: 302043,
  },
  {
    name: "Reyhanlı",
    country: "Turkey",
    subcountry: "Hatay",
    geonameid: 302355,
  },
  {
    name: "Polatlı",
    country: "Turkey",
    subcountry: "Ankara",
    geonameid: 302525,
  },
  {
    name: "Pazarcık",
    country: "Turkey",
    subcountry: "Kahramanmaraş",
    geonameid: 302800,
  },
  {
    name: "Patnos",
    country: "Turkey",
    subcountry: "Ağrı",
    geonameid: 302819,
  },
  {
    name: "Pasinler",
    country: "Turkey",
    subcountry: "Erzurum",
    geonameid: 302824,
  },
  {
    name: "Osmaniye",
    country: "Turkey",
    subcountry: "Osmaniye",
    geonameid: 303195,
  },
  {
    name: "Ortaköy",
    country: "Turkey",
    subcountry: "Aksaray",
    geonameid: 303290,
  },
  {
    name: "Ortaca",
    country: "Turkey",
    subcountry: "Muğla",
    geonameid: 303354,
  },
  {
    name: "Ödemiş",
    country: "Turkey",
    subcountry: "İzmir Province",
    geonameid: 303700,
  },
  {
    name: "Nusaybin",
    country: "Turkey",
    subcountry: "Mardin",
    geonameid: 303750,
  },
  {
    name: "Nizip",
    country: "Turkey",
    subcountry: "Gaziantep",
    geonameid: 303798,
  },
  {
    name: "Niğde",
    country: "Turkey",
    subcountry: "Niğde Province",
    geonameid: 303827,
  },
  {
    name: "Nevşehir",
    country: "Turkey",
    subcountry: "Nevşehir Province",
    geonameid: 303831,
  },
  {
    name: "Nazilli",
    country: "Turkey",
    subcountry: "Aydın",
    geonameid: 303873,
  },
  {
    name: "Mut",
    country: "Turkey",
    subcountry: "Mersin",
    geonameid: 304013,
  },
  {
    name: "Muş",
    country: "Turkey",
    subcountry: "Muş",
    geonameid: 304081,
  },
  {
    name: "Muğla",
    country: "Turkey",
    subcountry: "Muğla",
    geonameid: 304184,
  },
  {
    name: "Mucur",
    country: "Turkey",
    subcountry: "Kırşehir",
    geonameid: 304196,
  },
  {
    name: "Milas",
    country: "Turkey",
    subcountry: "Muğla",
    geonameid: 304355,
  },
  {
    name: "Midyat",
    country: "Turkey",
    subcountry: "Mardin",
    geonameid: 304382,
  },
  {
    name: "Mersin",
    country: "Turkey",
    subcountry: "Mersin",
    geonameid: 304531,
  },
  {
    name: "Menemen",
    country: "Turkey",
    subcountry: "İzmir Province",
    geonameid: 304612,
  },
  {
    name: "Marmaris",
    country: "Turkey",
    subcountry: "Muğla",
    geonameid: 304782,
  },
  {
    name: "Mardin",
    country: "Turkey",
    subcountry: "Mardin",
    geonameid: 304797,
  },
  {
    name: "Manisa",
    country: "Turkey",
    subcountry: "Manisa",
    geonameid: 304827,
  },
  {
    name: "Manavgat",
    country: "Turkey",
    subcountry: "Antalya",
    geonameid: 304854,
  },
  {
    name: "Malazgirt",
    country: "Turkey",
    subcountry: "Muş",
    geonameid: 304916,
  },
  {
    name: "Malatya",
    country: "Turkey",
    subcountry: "Malatya",
    geonameid: 304922,
  },
  {
    name: "Mahmutlar",
    country: "Turkey",
    subcountry: "Antalya",
    geonameid: 304964,
  },
  {
    name: "Lice",
    country: "Turkey",
    subcountry: "Diyarbakır Province",
    geonameid: 305089,
  },
  {
    name: "Kütahya",
    country: "Turkey",
    subcountry: "Kütahya",
    geonameid: 305268,
  },
  {
    name: "Kuşadası",
    country: "Turkey",
    subcountry: "Aydın",
    geonameid: 305359,
  },
  {
    name: "Kurtalan",
    country: "Turkey",
    subcountry: "Siirt",
    geonameid: 305532,
  },
  {
    name: "Beykonak",
    country: "Turkey",
    subcountry: "Antalya",
    geonameid: 305680,
  },
  {
    name: "Kulu",
    country: "Turkey",
    subcountry: "Konya",
    geonameid: 305742,
  },
  {
    name: "Kulp",
    country: "Turkey",
    subcountry: "Diyarbakır Province",
    geonameid: 305750,
  },
  {
    name: "Kula",
    country: "Turkey",
    subcountry: "Manisa",
    geonameid: 305810,
  },
  {
    name: "Kozluk",
    country: "Turkey",
    subcountry: "Batman",
    geonameid: 306041,
  },
  {
    name: "Kozan",
    country: "Turkey",
    subcountry: "Adana",
    geonameid: 306112,
  },
  {
    name: "Kovancılar",
    country: "Turkey",
    subcountry: "Elazığ",
    geonameid: 306207,
  },
  {
    name: "Korkuteli",
    country: "Turkey",
    subcountry: "Antalya",
    geonameid: 306474,
  },
  {
    name: "Konya",
    country: "Turkey",
    subcountry: "Konya",
    geonameid: 306571,
  },
  {
    name: "Kızıltepe",
    country: "Turkey",
    subcountry: "Mardin",
    geonameid: 307084,
  },
  {
    name: "Serinhisar",
    country: "Turkey",
    subcountry: "Denizli",
    geonameid: 307211,
  },
  {
    name: "Kırşehir",
    country: "Turkey",
    subcountry: "Kırşehir",
    geonameid: 307515,
  },
  {
    name: "Kırkağaç",
    country: "Turkey",
    subcountry: "Manisa",
    geonameid: 307623,
  },
  {
    name: "Kırıkkale",
    country: "Turkey",
    subcountry: "Kırıkkale",
    geonameid: 307654,
  },
  {
    name: "Kırıkhan",
    country: "Turkey",
    subcountry: "Hatay",
    geonameid: 307657,
  },
  {
    name: "Kilis",
    country: "Turkey",
    subcountry: "Kilis",
    geonameid: 307864,
  },
  {
    name: "Keskin",
    country: "Turkey",
    subcountry: "Kırıkkale",
    geonameid: 308024,
  },
  {
    name: "Kemer",
    country: "Turkey",
    subcountry: "Antalya",
    geonameid: 308220,
  },
  {
    name: "Kemalpaşa",
    country: "Turkey",
    subcountry: "İzmir Province",
    geonameid: 308224,
  },
  {
    name: "Kayseri",
    country: "Turkey",
    subcountry: "Kayseri",
    geonameid: 308464,
  },
  {
    name: "Karapınar",
    country: "Turkey",
    subcountry: "Konya",
    geonameid: 309415,
  },
  {
    name: "Karaman",
    country: "Turkey",
    subcountry: "Karaman",
    geonameid: 309527,
  },
  {
    name: "Ağrı",
    country: "Turkey",
    subcountry: "Ağrı",
    geonameid: 309647,
  },
  {
    name: "Karakoçan",
    country: "Turkey",
    subcountry: "Elazığ",
    geonameid: 309663,
  },
  {
    name: "Karaçoban",
    country: "Turkey",
    subcountry: "Erzurum",
    geonameid: 310004,
  },
  {
    name: "Kaman",
    country: "Turkey",
    subcountry: "Kırşehir",
    geonameid: 310641,
  },
  {
    name: "Kâhta",
    country: "Turkey",
    subcountry: "Adıyaman Province",
    geonameid: 310855,
  },
  {
    name: "Kahramanmaraş",
    country: "Turkey",
    subcountry: "Kahramanmaraş",
    geonameid: 310859,
  },
  {
    name: "Kadirli",
    country: "Turkey",
    subcountry: "Osmaniye",
    geonameid: 310892,
  },
  {
    name: "Kadınhanı",
    country: "Turkey",
    subcountry: "Konya",
    geonameid: 310907,
  },
  {
    name: "İzmir",
    country: "Turkey",
    subcountry: "İzmir Province",
    geonameid: 311046,
  },
  {
    name: "Isparta",
    country: "Turkey",
    subcountry: "Isparta",
    geonameid: 311073,
  },
  {
    name: "İskenderun",
    country: "Turkey",
    subcountry: "Hatay",
    geonameid: 311111,
  },
  {
    name: "İncirliova",
    country: "Turkey",
    subcountry: "Aydın",
    geonameid: 311314,
  },
  {
    name: "İmamoğlu",
    country: "Turkey",
    subcountry: "Adana",
    geonameid: 311453,
  },
  {
    name: "Ilgın",
    country: "Turkey",
    subcountry: "Konya",
    geonameid: 311553,
  },
  {
    name: "Iğdır",
    country: "Turkey",
    subcountry: "Iğdır",
    geonameid: 311665,
  },
  {
    name: "İdil",
    country: "Turkey",
    subcountry: "Şırnak",
    geonameid: 311704,
  },
  {
    name: "Hizan",
    country: "Turkey",
    subcountry: "Bitlis",
    geonameid: 312024,
  },
  {
    name: "Hınıs",
    country: "Turkey",
    subcountry: "Erzurum",
    geonameid: 312114,
  },
  {
    name: "Hilvan",
    country: "Turkey",
    subcountry: "Şanlıurfa",
    geonameid: 312134,
  },
  {
    name: "Hadim",
    country: "Turkey",
    subcountry: "Konya",
    geonameid: 312899,
  },
  {
    name: "Hacılar",
    country: "Turkey",
    subcountry: "Kayseri",
    geonameid: 313013,
  },
  {
    name: "Güroymak",
    country: "Turkey",
    subcountry: "Bitlis",
    geonameid: 313331,
  },
  {
    name: "Gölbaşı",
    country: "Turkey",
    subcountry: "Adıyaman Province",
    geonameid: 314136,
  },
  {
    name: "Göksun",
    country: "Turkey",
    subcountry: "Kahramanmaraş",
    geonameid: 314188,
  },
  {
    name: "Genç",
    country: "Turkey",
    subcountry: "Bingöl",
    geonameid: 314648,
  },
  {
    name: "Gemerek",
    country: "Turkey",
    subcountry: "Sivas",
    geonameid: 314665,
  },
  {
    name: "Gediz",
    country: "Turkey",
    subcountry: "Kütahya",
    geonameid: 314716,
  },
  {
    name: "Gazipaşa",
    country: "Turkey",
    subcountry: "Antalya",
    geonameid: 314812,
  },
  {
    name: "Gaziantep",
    country: "Turkey",
    subcountry: "Gaziantep",
    geonameid: 314830,
  },
  {
    name: "Foça",
    country: "Turkey",
    subcountry: "İzmir Province",
    geonameid: 314903,
  },
  {
    name: "Fethiye",
    country: "Turkey",
    subcountry: "Muğla",
    geonameid: 314967,
  },
  {
    name: "Ezine",
    country: "Turkey",
    subcountry: "Canakkale",
    geonameid: 315061,
  },
  {
    name: "Eskişehir",
    country: "Turkey",
    subcountry: "Eskişehir",
    geonameid: 315202,
  },
  {
    name: "Erzurum",
    country: "Turkey",
    subcountry: "Erzurum",
    geonameid: 315368,
  },
  {
    name: "Erzincan",
    country: "Turkey",
    subcountry: "Erzincan",
    geonameid: 315373,
  },
  {
    name: "Ermenek",
    country: "Turkey",
    subcountry: "Karaman",
    geonameid: 315401,
  },
  {
    name: "Ergani",
    country: "Turkey",
    subcountry: "Diyarbakır Province",
    geonameid: 315468,
  },
  {
    name: "Ereğli",
    country: "Turkey",
    subcountry: "Konya",
    geonameid: 315498,
  },
  {
    name: "Erdemli",
    country: "Turkey",
    subcountry: "Mersin",
    geonameid: 315515,
  },
  {
    name: "Erciş",
    country: "Turkey",
    subcountry: "Van",
    geonameid: 315530,
  },
  {
    name: "Emirdağ",
    country: "Turkey",
    subcountry: "Afyonkarahisar Province",
    geonameid: 315621,
  },
  {
    name: "Emet",
    country: "Turkey",
    subcountry: "Kütahya",
    geonameid: 315639,
  },
  {
    name: "Elmalı",
    country: "Turkey",
    subcountry: "Antalya",
    geonameid: 315697,
  },
  {
    name: "Elmadağ",
    country: "Turkey",
    subcountry: "Ankara",
    geonameid: 315720,
  },
  {
    name: "Eleşkirt",
    country: "Turkey",
    subcountry: "Ağrı",
    geonameid: 315758,
  },
  {
    name: "Elbistan",
    country: "Turkey",
    subcountry: "Kahramanmaraş",
    geonameid: 315795,
  },
  {
    name: "Elazığ",
    country: "Turkey",
    subcountry: "Elazığ",
    geonameid: 315808,
  },
  {
    name: "Eğirdir",
    country: "Turkey",
    subcountry: "Isparta",
    geonameid: 315905,
  },
  {
    name: "Edremit",
    country: "Turkey",
    subcountry: "Balıkesir",
    geonameid: 315985,
  },
  {
    name: "Dursunbey",
    country: "Turkey",
    subcountry: "Balıkesir",
    geonameid: 316102,
  },
  {
    name: "Dörtyol",
    country: "Turkey",
    subcountry: "Hatay",
    geonameid: 316284,
  },
  {
    name: "Doğubayazıt",
    country: "Turkey",
    subcountry: "Ağrı",
    geonameid: 316411,
  },
  {
    name: "Diyarbakır",
    country: "Turkey",
    subcountry: "Diyarbakır Province",
    geonameid: 316541,
  },
  {
    name: "Diyadin",
    country: "Turkey",
    subcountry: "Ağrı",
    geonameid: 316542,
  },
  {
    name: "Dinar",
    country: "Turkey",
    subcountry: "Afyonkarahisar Province",
    geonameid: 316634,
  },
  {
    name: "Develi",
    country: "Turkey",
    subcountry: "Kayseri",
    geonameid: 316795,
  },
  {
    name: "Denizli",
    country: "Turkey",
    subcountry: "Denizli",
    geonameid: 317109,
  },
  {
    name: "Demirci",
    country: "Turkey",
    subcountry: "Manisa",
    geonameid: 317241,
  },
  {
    name: "Dargeçit",
    country: "Turkey",
    subcountry: "Mardin",
    geonameid: 317587,
  },
  {
    name: "Darende",
    country: "Turkey",
    subcountry: "Malatya",
    geonameid: 317588,
  },
  {
    name: "Çumra",
    country: "Turkey",
    subcountry: "Konya",
    geonameid: 317844,
  },
  {
    name: "Menderes",
    country: "Turkey",
    subcountry: "İzmir Province",
    geonameid: 317851,
  },
  {
    name: "Hakkâri",
    country: "Turkey",
    subcountry: "Hakkâri",
    geonameid: 318137,
  },
  {
    name: "Cizre",
    country: "Turkey",
    subcountry: "Şırnak",
    geonameid: 318253,
  },
  {
    name: "Çine",
    country: "Turkey",
    subcountry: "Aydın",
    geonameid: 318372,
  },
  {
    name: "Ceylanpınar",
    country: "Turkey",
    subcountry: "Şanlıurfa",
    geonameid: 318668,
  },
  {
    name: "Ceyhan",
    country: "Turkey",
    subcountry: "Adana",
    geonameid: 318675,
  },
  {
    name: "Çeşme",
    country: "Turkey",
    subcountry: "İzmir Province",
    geonameid: 318755,
  },
  {
    name: "Çermik",
    country: "Turkey",
    subcountry: "Diyarbakır Province",
    geonameid: 318766,
  },
  {
    name: "Çay",
    country: "Turkey",
    subcountry: "Afyonkarahisar Province",
    geonameid: 319104,
  },
  {
    name: "Çağlayancerit",
    country: "Turkey",
    subcountry: "Kahramanmaraş",
    geonameid: 320004,
  },
  {
    name: "Burhaniye",
    country: "Turkey",
    subcountry: "Balıkesir",
    geonameid: 320369,
  },
  {
    name: "Burdur",
    country: "Turkey",
    subcountry: "Burdur",
    geonameid: 320392,
  },
  {
    name: "Bulanık",
    country: "Turkey",
    subcountry: "Muş",
    geonameid: 320448,
  },
  {
    name: "Bucak",
    country: "Turkey",
    subcountry: "Burdur",
    geonameid: 320533,
  },
  {
    name: "Bozyazı",
    country: "Turkey",
    subcountry: "Mersin",
    geonameid: 320552,
  },
  {
    name: "Bozüyük",
    country: "Turkey",
    subcountry: "Bilecik",
    geonameid: 320557,
  },
  {
    name: "Bozova",
    country: "Turkey",
    subcountry: "Şanlıurfa",
    geonameid: 320581,
  },
  {
    name: "Bor",
    country: "Turkey",
    subcountry: "Niğde Province",
    geonameid: 320871,
  },
  {
    name: "Bolvadin",
    country: "Turkey",
    subcountry: "Afyonkarahisar Province",
    geonameid: 320879,
  },
  {
    name: "Bodrum",
    country: "Turkey",
    subcountry: "Muğla",
    geonameid: 320995,
  },
  {
    name: "Bitlis",
    country: "Turkey",
    subcountry: "Bitlis",
    geonameid: 321025,
  },
  {
    name: "Bismil",
    country: "Turkey",
    subcountry: "Diyarbakır Province",
    geonameid: 321031,
  },
  {
    name: "Birecik",
    country: "Turkey",
    subcountry: "Şanlıurfa",
    geonameid: 321062,
  },
  {
    name: "Bingöl",
    country: "Turkey",
    subcountry: "Bingöl",
    geonameid: 321082,
  },
  {
    name: "Bigadiç",
    country: "Turkey",
    subcountry: "Balıkesir",
    geonameid: 321136,
  },
  {
    name: "Beyşehir",
    country: "Turkey",
    subcountry: "Konya",
    geonameid: 321191,
  },
  {
    name: "Besni",
    country: "Turkey",
    subcountry: "Adıyaman Province",
    geonameid: 321337,
  },
  {
    name: "Bergama",
    country: "Turkey",
    subcountry: "İzmir Province",
    geonameid: 321426,
  },
  {
    name: "Belen",
    country: "Turkey",
    subcountry: "Hatay",
    geonameid: 321572,
  },
  {
    name: "Belek",
    country: "Turkey",
    subcountry: "Antalya",
    geonameid: 321580,
  },
  {
    name: "Bayındır",
    country: "Turkey",
    subcountry: "İzmir Province",
    geonameid: 321786,
  },
  {
    name: "Batman",
    country: "Turkey",
    subcountry: "Batman",
    geonameid: 321836,
  },
  {
    name: "Baskil",
    country: "Turkey",
    subcountry: "Elazığ",
    geonameid: 321929,
  },
  {
    name: "Banaz",
    country: "Turkey",
    subcountry: "Uşak",
    geonameid: 322051,
  },
  {
    name: "Balıkesir",
    country: "Turkey",
    subcountry: "Balıkesir",
    geonameid: 322165,
  },
  {
    name: "Ayvalık",
    country: "Turkey",
    subcountry: "Balıkesir",
    geonameid: 322673,
  },
  {
    name: "Aydın",
    country: "Turkey",
    subcountry: "Aydın",
    geonameid: 322830,
  },
  {
    name: "Aşkale",
    country: "Turkey",
    subcountry: "Erzurum",
    geonameid: 323094,
  },
  {
    name: "Antalya",
    country: "Turkey",
    subcountry: "Antalya",
    geonameid: 323777,
  },
  {
    name: "Antakya",
    country: "Turkey",
    subcountry: "Hatay",
    geonameid: 323779,
  },
  {
    name: "Ankara",
    country: "Turkey",
    subcountry: "Ankara",
    geonameid: 323786,
  },
  {
    name: "Anamur",
    country: "Turkey",
    subcountry: "Mersin",
    geonameid: 323828,
  },
  {
    name: "Aliağa",
    country: "Turkey",
    subcountry: "İzmir Province",
    geonameid: 324106,
  },
  {
    name: "Alaşehir",
    country: "Turkey",
    subcountry: "Manisa",
    geonameid: 324172,
  },
  {
    name: "Alanya",
    country: "Turkey",
    subcountry: "Antalya",
    geonameid: 324190,
  },
  {
    name: "Akşehir",
    country: "Turkey",
    subcountry: "Konya",
    geonameid: 324490,
  },
  {
    name: "Aksaray",
    country: "Turkey",
    subcountry: "Aksaray",
    geonameid: 324496,
  },
  {
    name: "Akhisar",
    country: "Turkey",
    subcountry: "Manisa",
    geonameid: 324698,
  },
  {
    name: "Akdağmadeni",
    country: "Turkey",
    subcountry: "Yozgat",
    geonameid: 324768,
  },
  {
    name: "Akçakale",
    country: "Turkey",
    subcountry: "Şanlıurfa",
    geonameid: 324944,
  },
  {
    name: "Ahlat",
    country: "Turkey",
    subcountry: "Bitlis",
    geonameid: 325103,
  },
  {
    name: "Afyonkarahisar",
    country: "Turkey",
    subcountry: "Afyonkarahisar Province",
    geonameid: 325303,
  },
  {
    name: "Afşin",
    country: "Turkey",
    subcountry: "Kahramanmaraş",
    geonameid: 325304,
  },
  {
    name: "Adıyaman",
    country: "Turkey",
    subcountry: "Adıyaman Province",
    geonameid: 325330,
  },
  {
    name: "Adilcevaz",
    country: "Turkey",
    subcountry: "Bitlis",
    geonameid: 325336,
  },
  {
    name: "Adana",
    country: "Turkey",
    subcountry: "Adana",
    geonameid: 325363,
  },
  {
    name: "Denizciler",
    country: "Turkey",
    subcountry: "Hatay",
    geonameid: 438400,
  },
  {
    name: "Batikent",
    country: "Turkey",
    subcountry: "Ankara",
    geonameid: 442301,
  },
  {
    name: "Dalaman",
    country: "Turkey",
    subcountry: "Muğla",
    geonameid: 447273,
  },
  {
    name: "Zonguldak",
    country: "Turkey",
    subcountry: "Zonguldak",
    geonameid: 737022,
  },
  {
    name: "Zile",
    country: "Turkey",
    subcountry: "Tokat",
    geonameid: 737054,
  },
  {
    name: "Zeytinburnu",
    country: "Turkey",
    subcountry: "Istanbul",
    geonameid: 737071,
  },
  {
    name: "Yomra",
    country: "Turkey",
    subcountry: "Trabzon",
    geonameid: 737421,
  },
  {
    name: "Yenişehir",
    country: "Turkey",
    subcountry: "Bursa Province",
    geonameid: 737611,
  },
  {
    name: "Körfez",
    country: "Turkey",
    subcountry: "Kocaeli",
    geonameid: 737961,
  },
  {
    name: "Yalova",
    country: "Turkey",
    subcountry: "Yalova",
    geonameid: 738025,
  },
  {
    name: "Yakuplu",
    country: "Turkey",
    subcountry: "Istanbul",
    geonameid: 738064,
  },
  {
    name: "Vezirköprü",
    country: "Turkey",
    subcountry: "Samsun",
    geonameid: 738167,
  },
  {
    name: "Vakfıkebir",
    country: "Turkey",
    subcountry: "Trabzon",
    geonameid: 738228,
  },
  {
    name: "Uzunköprü",
    country: "Turkey",
    subcountry: "Edirne",
    geonameid: 738251,
  },
  {
    name: "Üsküdar",
    country: "Turkey",
    subcountry: "Istanbul",
    geonameid: 738329,
  },
  {
    name: "Ünye",
    country: "Turkey",
    subcountry: "Ordu",
    geonameid: 738349,
  },
  {
    name: "Umraniye",
    country: "Turkey",
    subcountry: "Istanbul",
    geonameid: 738377,
  },
  {
    name: "Turhal",
    country: "Turkey",
    subcountry: "Tokat",
    geonameid: 738618,
  },
  {
    name: "Trabzon",
    country: "Turkey",
    subcountry: "Trabzon",
    geonameid: 738648,
  },
  {
    name: "Tosya",
    country: "Turkey",
    subcountry: "Kastamonu",
    geonameid: 738662,
  },
  {
    name: "Tokat",
    country: "Turkey",
    subcountry: "Tokat",
    geonameid: 738743,
  },
  {
    name: "Tirebolu",
    country: "Turkey",
    subcountry: "Giresun",
    geonameid: 738753,
  },
  {
    name: "Terme",
    country: "Turkey",
    subcountry: "Samsun",
    geonameid: 738803,
  },
  {
    name: "Tepecik",
    country: "Turkey",
    subcountry: "Istanbul",
    geonameid: 738858,
  },
  {
    name: "Tekkeköy",
    country: "Turkey",
    subcountry: "Samsun",
    geonameid: 738907,
  },
  {
    name: "Tekirdağ",
    country: "Turkey",
    subcountry: "Tekirdağ",
    geonameid: 738927,
  },
  {
    name: "Taşova",
    country: "Turkey",
    subcountry: "Amasya",
    geonameid: 739015,
  },
  {
    name: "Taşköprü",
    country: "Turkey",
    subcountry: "Kastamonu",
    geonameid: 739061,
  },
  {
    name: "Suşehri",
    country: "Turkey",
    subcountry: "Sivas",
    geonameid: 739209,
  },
  {
    name: "Sürmene",
    country: "Turkey",
    subcountry: "Trabzon",
    geonameid: 739215,
  },
  {
    name: "Sungurlu",
    country: "Turkey",
    subcountry: "Çorum",
    geonameid: 739236,
  },
  {
    name: "Suluova",
    country: "Turkey",
    subcountry: "Amasya",
    geonameid: 739251,
  },
  {
    name: "Şişli",
    country: "Turkey",
    subcountry: "Istanbul",
    geonameid: 739549,
  },
  {
    name: "Sinop",
    country: "Turkey",
    subcountry: "Sinop",
    geonameid: 739600,
  },
  {
    name: "Silivri",
    country: "Turkey",
    subcountry: "Istanbul",
    geonameid: 739634,
  },
  {
    name: "Şebin Karahisar",
    country: "Turkey",
    subcountry: "Giresun",
    geonameid: 739914,
  },
  {
    name: "Sarıkamış",
    country: "Turkey",
    subcountry: "Kars Province",
    geonameid: 740088,
  },
  {
    name: "Sapanca",
    country: "Turkey",
    subcountry: "Sakarya",
    geonameid: 740230,
  },
  {
    name: "Samsun",
    country: "Turkey",
    subcountry: "Samsun",
    geonameid: 740264,
  },
  {
    name: "Safranbolu",
    country: "Turkey",
    subcountry: "Karabük Province",
    geonameid: 740430,
  },
  {
    name: "Rize",
    country: "Turkey",
    subcountry: "Rize Province",
    geonameid: 740483,
  },
  {
    name: "Osmaneli",
    country: "Turkey",
    subcountry: "Bilecik",
    geonameid: 740881,
  },
  {
    name: "Osmancık",
    country: "Turkey",
    subcountry: "Çorum",
    geonameid: 740883,
  },
  {
    name: "Orhangazi",
    country: "Turkey",
    subcountry: "Bursa Province",
    geonameid: 741045,
  },
  {
    name: "Ordu",
    country: "Turkey",
    subcountry: "Ordu",
    geonameid: 741100,
  },
  {
    name: "Oltu",
    country: "Turkey",
    subcountry: "Erzurum",
    geonameid: 741160,
  },
  {
    name: "Of",
    country: "Turkey",
    subcountry: "Trabzon",
    geonameid: 741240,
  },
  {
    name: "Niksar",
    country: "Turkey",
    subcountry: "Tokat",
    geonameid: 741304,
  },
  {
    name: "Nallıhan",
    country: "Turkey",
    subcountry: "Ankara",
    geonameid: 741347,
  },
  {
    name: "Mustafakemalpaşa",
    country: "Turkey",
    subcountry: "Bursa Province",
    geonameid: 741385,
  },
  {
    name: "Mudanya",
    country: "Turkey",
    subcountry: "Bursa Province",
    geonameid: 741487,
  },
  {
    name: "Mimarsinan",
    country: "Turkey",
    subcountry: "Istanbul",
    geonameid: 741529,
  },
  {
    name: "Merzifon",
    country: "Turkey",
    subcountry: "Amasya",
    geonameid: 741609,
  },
  {
    name: "Maltepe",
    country: "Turkey",
    subcountry: "Istanbul",
    geonameid: 741763,
  },
  {
    name: "Malkara",
    country: "Turkey",
    subcountry: "Tekirdağ",
    geonameid: 741771,
  },
  {
    name: "Lüleburgaz",
    country: "Turkey",
    subcountry: "Kırklareli",
    geonameid: 741855,
  },
  {
    name: "Kumru",
    country: "Turkey",
    subcountry: "Ordu",
    geonameid: 742238,
  },
  {
    name: "Korgan",
    country: "Turkey",
    subcountry: "Ordu",
    geonameid: 742658,
  },
  {
    name: "Kocaali",
    country: "Turkey",
    subcountry: "Sakarya",
    geonameid: 742902,
  },
  {
    name: "Kızılcahamam",
    country: "Turkey",
    subcountry: "Ankara",
    geonameid: 743051,
  },
  {
    name: "Kırklareli",
    country: "Turkey",
    subcountry: "Kırklareli",
    geonameid: 743166,
  },
  {
    name: "Kestel",
    country: "Turkey",
    subcountry: "Bursa Province",
    geonameid: 743404,
  },
  {
    name: "Keşan",
    country: "Turkey",
    subcountry: "Edirne",
    geonameid: 743439,
  },
  {
    name: "Kelkit",
    country: "Turkey",
    subcountry: "Gümüşhane Province",
    geonameid: 743537,
  },
  {
    name: "Kazan",
    country: "Turkey",
    subcountry: "Ankara",
    geonameid: 743615,
  },
  {
    name: "Kavaklı",
    country: "Turkey",
    subcountry: "Istanbul",
    geonameid: 743818,
  },
  {
    name: "Kastamonu",
    country: "Turkey",
    subcountry: "Kastamonu",
    geonameid: 743882,
  },
  {
    name: "Kars",
    country: "Turkey",
    subcountry: "Kars Province",
    geonameid: 743952,
  },
  {
    name: "Karasu",
    country: "Turkey",
    subcountry: "Sakarya",
    geonameid: 744092,
  },
  {
    name: "Karasu Mahallesi",
    country: "Turkey",
    subcountry: "Sakarya",
    geonameid: 744093,
  },
  {
    name: "Karamürsel",
    country: "Turkey",
    subcountry: "Kocaeli",
    geonameid: 744168,
  },
  {
    name: "Karacabey",
    country: "Turkey",
    subcountry: "Bursa Province",
    geonameid: 744537,
  },
  {
    name: "Karabük",
    country: "Turkey",
    subcountry: "Karabük Province",
    geonameid: 744562,
  },
  {
    name: "Kağızman",
    country: "Turkey",
    subcountry: "Kars Province",
    geonameid: 744873,
  },
  {
    name: "İznik",
    country: "Turkey",
    subcountry: "Bursa Province",
    geonameid: 745026,
  },
  {
    name: "İzmit",
    country: "Turkey",
    subcountry: "Kocaeli",
    geonameid: 745028,
  },
  {
    name: "Istanbul",
    country: "Turkey",
    subcountry: "Istanbul",
    geonameid: 745044,
  },
  {
    name: "İskilip",
    country: "Turkey",
    subcountry: "Çorum",
    geonameid: 745076,
  },
  {
    name: "İnegol",
    country: "Turkey",
    subcountry: "Bursa Province",
    geonameid: 745169,
  },
  {
    name: "Horasan",
    country: "Turkey",
    subcountry: "Erzurum",
    geonameid: 745527,
  },
  {
    name: "Hopa",
    country: "Turkey",
    subcountry: "Artvin",
    geonameid: 745530,
  },
  {
    name: "Hendek",
    country: "Turkey",
    subcountry: "Sakarya",
    geonameid: 745664,
  },
  {
    name: "Hayrabolu",
    country: "Turkey",
    subcountry: "Tekirdağ",
    geonameid: 745697,
  },
  {
    name: "Havza",
    country: "Turkey",
    subcountry: "Samsun",
    geonameid: 745714,
  },
  {
    name: "Gürsu",
    country: "Turkey",
    subcountry: "Bursa Province",
    geonameid: 746232,
  },
  {
    name: "Gürpınar",
    country: "Turkey",
    subcountry: "Istanbul",
    geonameid: 746234,
  },
  {
    name: "Gürgentepe",
    country: "Turkey",
    subcountry: "Ordu",
    geonameid: 746252,
  },
  {
    name: "Gümüşhane",
    country: "Turkey",
    subcountry: "Gümüşhane Province",
    geonameid: 746425,
  },
  {
    name: "Görele",
    country: "Turkey",
    subcountry: "Giresun",
    geonameid: 746565,
  },
  {
    name: "Gönen",
    country: "Turkey",
    subcountry: "Balıkesir",
    geonameid: 746574,
  },
  {
    name: "Gölcük",
    country: "Turkey",
    subcountry: "Kocaeli",
    geonameid: 746666,
  },
  {
    name: "Giresun",
    country: "Turkey",
    subcountry: "Giresun",
    geonameid: 746881,
  },
  {
    name: "Geyve",
    country: "Turkey",
    subcountry: "Sakarya",
    geonameid: 746898,
  },
  {
    name: "Gerede",
    country: "Turkey",
    subcountry: "Bolu",
    geonameid: 746940,
  },
  {
    name: "Gemlik",
    country: "Turkey",
    subcountry: "Bursa Province",
    geonameid: 746958,
  },
  {
    name: "Gelibolu",
    country: "Turkey",
    subcountry: "Canakkale",
    geonameid: 746983,
  },
  {
    name: "Gebze",
    country: "Turkey",
    subcountry: "Kocaeli",
    geonameid: 747014,
  },
  {
    name: "Ferizli",
    country: "Turkey",
    subcountry: "Sakarya",
    geonameid: 747135,
  },
  {
    name: "Fatsa",
    country: "Turkey",
    subcountry: "Ordu",
    geonameid: 747155,
  },
  {
    name: "Esenyurt",
    country: "Turkey",
    subcountry: "Istanbul",
    geonameid: 747323,
  },
  {
    name: "Esenler",
    country: "Turkey",
    subcountry: "Istanbul",
    geonameid: 747340,
  },
  {
    name: "Ereğli",
    country: "Turkey",
    subcountry: "Zonguldak",
    geonameid: 747471,
  },
  {
    name: "Erdek",
    country: "Turkey",
    subcountry: "Balıkesir",
    geonameid: 747482,
  },
  {
    name: "Erbaa",
    country: "Turkey",
    subcountry: "Tokat",
    geonameid: 747489,
  },
  {
    name: "Eminönü",
    country: "Turkey",
    subcountry: "Istanbul",
    geonameid: 747538,
  },
  {
    name: "Edirne",
    country: "Turkey",
    subcountry: "Edirne",
    geonameid: 747712,
  },
  {
    name: "Düzce",
    country: "Turkey",
    subcountry: "Düzce",
    geonameid: 747764,
  },
  {
    name: "Devrek",
    country: "Turkey",
    subcountry: "Zonguldak",
    geonameid: 748167,
  },
  {
    name: "Derince",
    country: "Turkey",
    subcountry: "Kocaeli",
    geonameid: 748208,
  },
  {
    name: "Çubuk",
    country: "Turkey",
    subcountry: "Ankara",
    geonameid: 748870,
  },
  {
    name: "Çorum",
    country: "Turkey",
    subcountry: "Çorum",
    geonameid: 748879,
  },
  {
    name: "Çorlu",
    country: "Turkey",
    subcountry: "Tekirdağ",
    geonameid: 748893,
  },
  {
    name: "Çerkezköy",
    country: "Turkey",
    subcountry: "Tekirdağ",
    geonameid: 749274,
  },
  {
    name: "Çerkeş",
    country: "Turkey",
    subcountry: "Çankırı",
    geonameid: 749279,
  },
  {
    name: "Çayeli",
    country: "Turkey",
    subcountry: "Rize Province",
    geonameid: 749502,
  },
  {
    name: "Çaycuma",
    country: "Turkey",
    subcountry: "Zonguldak",
    geonameid: 749508,
  },
  {
    name: "Çatalca",
    country: "Turkey",
    subcountry: "Istanbul",
    geonameid: 749644,
  },
  {
    name: "Çarşamba",
    country: "Turkey",
    subcountry: "Samsun",
    geonameid: 749704,
  },
  {
    name: "Çankırı",
    country: "Turkey",
    subcountry: "Çankırı",
    geonameid: 749748,
  },
  {
    name: "Çanakkale",
    country: "Turkey",
    subcountry: "Canakkale",
    geonameid: 749780,
  },
  {
    name: "Çan",
    country: "Turkey",
    subcountry: "Canakkale",
    geonameid: 749795,
  },
  {
    name: "Bursa",
    country: "Turkey",
    subcountry: "Bursa Province",
    geonameid: 750269,
  },
  {
    name: "Bulancak",
    country: "Turkey",
    subcountry: "Giresun",
    geonameid: 750317,
  },
  {
    name: "Boyabat",
    country: "Turkey",
    subcountry: "Sinop",
    geonameid: 750468,
  },
  {
    name: "Bolu",
    country: "Turkey",
    subcountry: "Bolu",
    geonameid: 750516,
  },
  {
    name: "Bilecik",
    country: "Turkey",
    subcountry: "Bilecik",
    geonameid: 750598,
  },
  {
    name: "Biga",
    country: "Turkey",
    subcountry: "Canakkale",
    geonameid: 750605,
  },
  {
    name: "Beypazarı",
    country: "Turkey",
    subcountry: "Ankara",
    geonameid: 750637,
  },
  {
    name: "Beşikdüzü",
    country: "Turkey",
    subcountry: "Trabzon",
    geonameid: 750735,
  },
  {
    name: "Bayburt",
    country: "Turkey",
    subcountry: "Bayburt Province",
    geonameid: 750938,
  },
  {
    name: "Bartın",
    country: "Turkey",
    subcountry: "Bartın",
    geonameid: 751057,
  },
  {
    name: "Bandırma",
    country: "Turkey",
    subcountry: "Balıkesir",
    geonameid: 751077,
  },
  {
    name: "Bağcılar",
    country: "Turkey",
    subcountry: "Istanbul",
    geonameid: 751324,
  },
  {
    name: "Bafra",
    country: "Turkey",
    subcountry: "Samsun",
    geonameid: 751335,
  },
  {
    name: "Babaeski",
    country: "Turkey",
    subcountry: "Kırklareli",
    geonameid: 751371,
  },
  {
    name: "Artvin",
    country: "Turkey",
    subcountry: "Artvin",
    geonameid: 751817,
  },
  {
    name: "Arsin",
    country: "Turkey",
    subcountry: "Trabzon",
    geonameid: 751838,
  },
  {
    name: "Arnavutköy",
    country: "Turkey",
    subcountry: "Istanbul",
    geonameid: 751868,
  },
  {
    name: "Arhavi",
    country: "Turkey",
    subcountry: "Artvin",
    geonameid: 751931,
  },
  {
    name: "Ardeşen",
    country: "Turkey",
    subcountry: "Rize Province",
    geonameid: 751949,
  },
  {
    name: "Ardahan",
    country: "Turkey",
    subcountry: "Ardahan",
    geonameid: 751952,
  },
  {
    name: "Araklı",
    country: "Turkey",
    subcountry: "Trabzon",
    geonameid: 751971,
  },
  {
    name: "Amasya",
    country: "Turkey",
    subcountry: "Amasya",
    geonameid: 752015,
  },
  {
    name: "Alaplı",
    country: "Turkey",
    subcountry: "Zonguldak",
    geonameid: 752184,
  },
  {
    name: "Alaca",
    country: "Turkey",
    subcountry: "Çorum",
    geonameid: 752278,
  },
  {
    name: "Akyurt",
    country: "Turkey",
    subcountry: "Ankara",
    geonameid: 752284,
  },
  {
    name: "Akyazı",
    country: "Turkey",
    subcountry: "Sakarya",
    geonameid: 752288,
  },
  {
    name: "Akçakoca",
    country: "Turkey",
    subcountry: "Düzce",
    geonameid: 752584,
  },
  {
    name: "Akçaabat",
    country: "Turkey",
    subcountry: "Trabzon",
    geonameid: 752627,
  },
  {
    name: "Adapazarı",
    country: "Turkey",
    subcountry: "Sakarya",
    geonameid: 752850,
  },
  {
    name: "Espiye",
    country: "Turkey",
    subcountry: "Giresun",
    geonameid: 831432,
  },
  {
    name: "Merter Keresteciler",
    country: "Turkey",
    subcountry: "Istanbul",
    geonameid: 6354984,
  },
  {
    name: "güngören merter",
    country: "Turkey",
    subcountry: "Istanbul",
    geonameid: 6354985,
  },
  {
    name: "Turgutreis",
    country: "Turkey",
    subcountry: "Muğla",
    geonameid: 6620290,
  },
  {
    name: "Sarigerme",
    country: "Turkey",
    subcountry: "Muğla",
    geonameid: 6692524,
  },
  {
    name: "Ataşehir",
    country: "Turkey",
    subcountry: "Istanbul",
    geonameid: 6947637,
  },
  {
    name: "Başakşehir",
    country: "Turkey",
    subcountry: "Istanbul",
    geonameid: 6947639,
  },
  {
    name: "Beylikdüzü",
    country: "Turkey",
    subcountry: "Istanbul",
    geonameid: 6947640,
  },
  {
    name: "Büyükçekmece",
    country: "Turkey",
    subcountry: "Istanbul",
    geonameid: 6947641,
  },
  {
    name: "Çankaya",
    country: "Turkey",
    subcountry: "Ankara",
    geonameid: 6955677,
  },
  {
    name: "Bahçelievler",
    country: "Turkey",
    subcountry: "Istanbul",
    geonameid: 7627067,
  },
  {
    name: "Sultangazi",
    country: "Turkey",
    subcountry: "Istanbul",
    geonameid: 7628416,
  },
  {
    name: "Sultanbeyli",
    country: "Turkey",
    subcountry: "Istanbul",
    geonameid: 7628419,
  },
  {
    name: "Sancaktepe",
    country: "Turkey",
    subcountry: "Istanbul",
    geonameid: 7628420,
  },
  {
    name: "Karabağlar",
    country: "Turkey",
    subcountry: "İzmir Province",
    geonameid: 7701384,
  },
  {
    name: "Muratpaşa",
    country: "Turkey",
    subcountry: "Antalya",
    geonameid: 8074174,
  },
  {
    name: "Merkezefendi",
    country: "Turkey",
    subcountry: "Denizli",
    geonameid: 11238838,
  },
  {
    name: "Tunapuna",
    country: "Trinidad and Tobago",
    subcountry: "Tunapuna/Piarco",
    geonameid: 3573576,
  },
  {
    name: "Scarborough",
    country: "Trinidad and Tobago",
    subcountry: "Tobago",
    geonameid: 3573703,
  },
  {
    name: "Sangre Grande",
    country: "Trinidad and Tobago",
    subcountry: "Sangre Grande",
    geonameid: 3573732,
  },
  {
    name: "San Fernando",
    country: "Trinidad and Tobago",
    subcountry: "San Fernando",
    geonameid: 3573738,
  },
  {
    name: "Rio Claro",
    country: "Trinidad and Tobago",
    subcountry: "Mayaro",
    geonameid: 3573840,
  },
  {
    name: "Port of Spain",
    country: "Trinidad and Tobago",
    subcountry: "Port of Spain",
    geonameid: 3573890,
  },
  {
    name: "Point Fortin",
    country: "Trinidad and Tobago",
    subcountry: "Point Fortin",
    geonameid: 3573899,
  },
  {
    name: "Paradise",
    country: "Trinidad and Tobago",
    subcountry: "Tunapuna/Piarco",
    geonameid: 3573989,
  },
  {
    name: "Mon Repos",
    country: "Trinidad and Tobago",
    subcountry: "San Fernando",
    geonameid: 3574116,
  },
  {
    name: "Marabella",
    country: "Trinidad and Tobago",
    subcountry: "San Fernando",
    geonameid: 3574194,
  },
  {
    name: "Laventille",
    country: "Trinidad and Tobago",
    subcountry: "San Juan/Laventille",
    geonameid: 3574309,
  },
  {
    name: "Chaguanas",
    country: "Trinidad and Tobago",
    subcountry: "Chaguanas",
    geonameid: 3574810,
  },
  {
    name: "Arima",
    country: "Trinidad and Tobago",
    subcountry: "Borough of Arima",
    geonameid: 3575051,
  },
  {
    name: "Funafuti",
    country: "Tuvalu",
    subcountry: "Funafuti",
    geonameid: 2110394,
  },
  {
    name: "Douliu",
    country: "Taiwan",
    subcountry: "Taiwan",
    geonameid: 1665196,
  },
  {
    name: "Yongkang",
    country: "Taiwan",
    subcountry: "Taiwan",
    geonameid: 1665221,
  },
  {
    name: "Yujing",
    country: "Taiwan",
    subcountry: "Taiwan",
    geonameid: 1665357,
  },
  {
    name: "Yuanlin",
    country: "Taiwan",
    subcountry: "Taiwan",
    geonameid: 1665443,
  },
  {
    name: "Yingge",
    country: "Taiwan",
    subcountry: "Taipei",
    geonameid: 1665491,
  },
  {
    name: "Wufeng",
    country: "Taiwan",
    subcountry: "Taiwan",
    geonameid: 1665892,
  },
  {
    name: "Donggang",
    country: "Taiwan",
    subcountry: "Taiwan",
    geonameid: 1666596,
  },
  {
    name: "Taipei",
    country: "Taiwan",
    subcountry: "Taiwan",
    geonameid: 1668341,
  },
  {
    name: "Tainan",
    country: "Taiwan",
    subcountry: "Taiwan",
    geonameid: 1668355,
  },
  {
    name: "Taichung",
    country: "Taiwan",
    subcountry: "Taiwan",
    geonameid: 1668399,
  },
  {
    name: "Daxi",
    country: "Taiwan",
    subcountry: "Taiwan",
    geonameid: 1668467,
  },
  {
    name: "Shulin",
    country: "Taiwan",
    subcountry: "Taipei",
    geonameid: 1668875,
  },
  {
    name: "Banqiao",
    country: "Taiwan",
    subcountry: "Taipei",
    geonameid: 1670029,
  },
  {
    name: "Sanxia",
    country: "Taiwan",
    subcountry: "Taipei",
    geonameid: 1670106,
  },
  {
    name: "Sanzhi",
    country: "Taiwan",
    subcountry: "Taipei",
    geonameid: 1670157,
  },
  {
    name: "Puli",
    country: "Taiwan",
    subcountry: "Taiwan",
    geonameid: 1670310,
  },
  {
    name: "Bade",
    country: "Taiwan",
    subcountry: "Taiwan",
    geonameid: 1670909,
  },
  {
    name: "Neihu",
    country: "Taiwan",
    subcountry: "Taiwan",
    geonameid: 1671467,
  },
  {
    name: "Nantou",
    country: "Taiwan",
    subcountry: "Taiwan",
    geonameid: 1671566,
  },
  {
    name: "Magong",
    country: "Taiwan",
    subcountry: "Taiwan",
    geonameid: 1672228,
  },
  {
    name: "Lugu",
    country: "Taiwan",
    subcountry: "Taiwan",
    geonameid: 1672551,
  },
  {
    name: "Kaohsiung",
    country: "Taiwan",
    subcountry: "Takao",
    geonameid: 1673820,
  },
  {
    name: "Yilan",
    country: "Taiwan",
    subcountry: "Taiwan",
    geonameid: 1674199,
  },
  {
    name: "Hualien City",
    country: "Taiwan",
    subcountry: "Taiwan",
    geonameid: 1674504,
  },
  {
    name: "Hsinchu",
    country: "Taiwan",
    subcountry: "Taiwan",
    geonameid: 1675151,
  },
  {
    name: "Xizhi",
    country: "Taiwan",
    subcountry: "Taipei",
    geonameid: 1675393,
  },
  {
    name: "Hengchun",
    country: "Taiwan",
    subcountry: "Taiwan",
    geonameid: 1676242,
  },
  {
    name: "Jincheng",
    country: "Taiwan",
    subcountry: "Fukien",
    geonameid: 1678008,
  },
  {
    name: "Keelung",
    country: "Taiwan",
    subcountry: "Taiwan",
    geonameid: 1678228,
  },
  {
    name: "Taoyuan City",
    country: "Taiwan",
    subcountry: "Taiwan",
    geonameid: 6696918,
  },
  {
    name: "Zhongxing New Village",
    country: "Taiwan",
    subcountry: "Taiwan",
    geonameid: 7601921,
  },
  {
    name: "Zanzibar",
    country: "Tanzania",
    subcountry: "Zanzibar Urban/West",
    geonameid: 148730,
  },
  {
    name: "Wete",
    country: "Tanzania",
    subcountry: "Pemba North",
    geonameid: 148842,
  },
  {
    name: "Vwawa",
    country: "Tanzania",
    subcountry: "Songwe",
    geonameid: 148942,
  },
  {
    name: "Vikindu",
    country: "Tanzania",
    subcountry: "Pwani",
    geonameid: 148987,
  },
  {
    name: "Uyovu",
    country: "Tanzania",
    subcountry: "Geita",
    geonameid: 149027,
  },
  {
    name: "Uvinza",
    country: "Tanzania",
    subcountry: "Kigoma",
    geonameid: 149050,
  },
  {
    name: "Ushirombo",
    country: "Tanzania",
    subcountry: "Geita",
    geonameid: 149129,
  },
  {
    name: "Usevia",
    country: "Tanzania",
    subcountry: "Katavi",
    geonameid: 149132,
  },
  {
    name: "Usagara",
    country: "Tanzania",
    subcountry: "Mwanza",
    geonameid: 149151,
  },
  {
    name: "Usa River",
    country: "Tanzania",
    subcountry: "Arusha",
    geonameid: 149155,
  },
  {
    name: "Urambo",
    country: "Tanzania",
    subcountry: "Tabora",
    geonameid: 149172,
  },
  {
    name: "Tunduma",
    country: "Tanzania",
    subcountry: "Songwe",
    geonameid: 149402,
  },
  {
    name: "Tumbi",
    country: "Tanzania",
    subcountry: "Tabora",
    geonameid: 149418,
  },
  {
    name: "Tukuyu",
    country: "Tanzania",
    subcountry: "Mbeya",
    geonameid: 149437,
  },
  {
    name: "Tinde",
    country: "Tanzania",
    subcountry: "Shinyanga",
    geonameid: 149512,
  },
  {
    name: "Tarime",
    country: "Tanzania",
    subcountry: "Mara",
    geonameid: 149581,
  },
  {
    name: "Tanga",
    country: "Tanzania",
    subcountry: "Tanga",
    geonameid: 149606,
  },
  {
    name: "Tabora",
    country: "Tanzania",
    subcountry: "Tabora",
    geonameid: 149658,
  },
  {
    name: "Sumbawanga",
    country: "Tanzania",
    subcountry: "Rukwa",
    geonameid: 149703,
  },
  {
    name: "Songwa",
    country: "Tanzania",
    subcountry: "Shinyanga",
    geonameid: 149775,
  },
  {
    name: "Somanda",
    country: "Tanzania",
    subcountry: "Simiyu",
    geonameid: 149792,
  },
  {
    name: "Sokoni",
    country: "Tanzania",
    subcountry: "Zanzibar Central/South",
    geonameid: 149812,
  },
  {
    name: "Sirari",
    country: "Tanzania",
    subcountry: "Mara",
    geonameid: 149854,
  },
  {
    name: "Singida",
    country: "Tanzania",
    subcountry: "Singida",
    geonameid: 149879,
  },
  {
    name: "Sikonge",
    country: "Tanzania",
    subcountry: "Tabora",
    geonameid: 149929,
  },
  {
    name: "Shinyanga",
    country: "Tanzania",
    subcountry: "Shinyanga",
    geonameid: 150006,
  },
  {
    name: "Shelui",
    country: "Tanzania",
    subcountry: "Singida",
    geonameid: 150037,
  },
  {
    name: "Sepuka",
    country: "Tanzania",
    subcountry: "Singida",
    geonameid: 150099,
  },
  {
    name: "Same",
    country: "Tanzania",
    subcountry: "Kilimanjaro",
    geonameid: 150276,
  },
  {
    name: "Rulenge",
    country: "Tanzania",
    subcountry: "Kagera",
    geonameid: 150436,
  },
  {
    name: "Rujewa",
    country: "Tanzania",
    subcountry: "Mbeya",
    geonameid: 150453,
  },
  {
    name: "Puma",
    country: "Tanzania",
    subcountry: "Singida",
    geonameid: 150634,
  },
  {
    name: "Old Shinyanga",
    country: "Tanzania",
    subcountry: "Shinyanga",
    geonameid: 150885,
  },
  {
    name: "Nzega",
    country: "Tanzania",
    subcountry: "Tabora",
    geonameid: 150930,
  },
  {
    name: "Nyamuswa",
    country: "Tanzania",
    subcountry: "Mara",
    geonameid: 151108,
  },
  {
    name: "Nyalikungu",
    country: "Tanzania",
    subcountry: "Simiyu",
    geonameid: 151211,
  },
  {
    name: "Nyakabindi",
    country: "Tanzania",
    subcountry: "Simiyu",
    geonameid: 151266,
  },
  {
    name: "Nsunga",
    country: "Tanzania",
    subcountry: "Kagera",
    geonameid: 151363,
  },
  {
    name: "Nshamba",
    country: "Tanzania",
    subcountry: "Kagera",
    geonameid: 151373,
  },
  {
    name: "Njombe",
    country: "Tanzania",
    subcountry: "Njombe",
    geonameid: 151479,
  },
  {
    name: "Nguruka",
    country: "Tanzania",
    subcountry: "Kigoma",
    geonameid: 151567,
  },
  {
    name: "Ngudu",
    country: "Tanzania",
    subcountry: "Mwanza",
    geonameid: 151599,
  },
  {
    name: "Ngerengere",
    country: "Tanzania",
    subcountry: "Morogoro",
    geonameid: 151678,
  },
  {
    name: "Ngara",
    country: "Tanzania",
    subcountry: "Kagera",
    geonameid: 151711,
  },
  {
    name: "Nangwa",
    country: "Tanzania",
    subcountry: "Manyara",
    geonameid: 151929,
  },
  {
    name: "Namanyere",
    country: "Tanzania",
    subcountry: "Rukwa",
    geonameid: 151986,
  },
  {
    name: "Mwanza",
    country: "Tanzania",
    subcountry: "Mwanza",
    geonameid: 152224,
  },
  {
    name: "Mwadui",
    country: "Tanzania",
    subcountry: "Shinyanga",
    geonameid: 152376,
  },
  {
    name: "Mvomero",
    country: "Tanzania",
    subcountry: "Pwani",
    geonameid: 152403,
  },
  {
    name: "Musoma",
    country: "Tanzania",
    subcountry: "Mara",
    geonameid: 152451,
  },
  {
    name: "Muriti",
    country: "Tanzania",
    subcountry: "Mara",
    geonameid: 152497,
  },
  {
    name: "Mungaa",
    country: "Tanzania",
    subcountry: "Singida",
    geonameid: 152546,
  },
  {
    name: "Muheza",
    country: "Tanzania",
    subcountry: "Tanga",
    geonameid: 152632,
  },
  {
    name: "Mugumu",
    country: "Tanzania",
    subcountry: "Mara",
    geonameid: 152663,
  },
  {
    name: "Mtwango",
    country: "Tanzania",
    subcountry: "Njombe",
    geonameid: 152718,
  },
  {
    name: "Mto wa Mbu",
    country: "Tanzania",
    subcountry: "Arusha",
    geonameid: 152743,
  },
  {
    name: "Mtinko",
    country: "Tanzania",
    subcountry: "Singida",
    geonameid: 152781,
  },
  {
    name: "Msowero",
    country: "Tanzania",
    subcountry: "Morogoro",
    geonameid: 152933,
  },
  {
    name: "Mpwapwa",
    country: "Tanzania",
    subcountry: "Dodoma",
    geonameid: 153094,
  },
  {
    name: "Mpanda",
    country: "Tanzania",
    subcountry: "Katavi",
    geonameid: 153176,
  },
  {
    name: "Moshi",
    country: "Tanzania",
    subcountry: "Kilimanjaro",
    geonameid: 153209,
  },
  {
    name: "Morogoro",
    country: "Tanzania",
    subcountry: "Morogoro",
    geonameid: 153220,
  },
  {
    name: "Mlowo",
    country: "Tanzania",
    subcountry: "Songwe",
    geonameid: 153352,
  },
  {
    name: "Mlimba",
    country: "Tanzania",
    subcountry: "Morogoro",
    geonameid: 153384,
  },
  {
    name: "Mlangali",
    country: "Tanzania",
    subcountry: "Njombe",
    geonameid: 153408,
  },
  {
    name: "Mlandizi",
    country: "Tanzania",
    subcountry: "Pwani",
    geonameid: 153412,
  },
  {
    name: "Mlalo",
    country: "Tanzania",
    subcountry: "Tanga",
    geonameid: 153423,
  },
  {
    name: "Mkuranga",
    country: "Tanzania",
    subcountry: "Pwani",
    geonameid: 153482,
  },
  {
    name: "Mwandiga",
    country: "Tanzania",
    subcountry: "Kigoma",
    geonameid: 153709,
  },
  {
    name: "Misungwi",
    country: "Tanzania",
    subcountry: "Mwanza",
    geonameid: 153759,
  },
  {
    name: "Mikumi",
    country: "Tanzania",
    subcountry: "Morogoro",
    geonameid: 153871,
  },
  {
    name: "Mhango",
    country: "Tanzania",
    subcountry: "Shinyanga",
    geonameid: 154002,
  },
  {
    name: "Mgandu",
    country: "Tanzania",
    subcountry: "Singida",
    geonameid: 154097,
  },
  {
    name: "Mbuguni",
    country: "Tanzania",
    subcountry: "Arusha",
    geonameid: 154321,
  },
  {
    name: "Mbeya",
    country: "Tanzania",
    subcountry: "Mbeya",
    geonameid: 154380,
  },
  {
    name: "Mazinde",
    country: "Tanzania",
    subcountry: "Tanga",
    geonameid: 154470,
  },
  {
    name: "Matui",
    country: "Tanzania",
    subcountry: "Tanga",
    geonameid: 154566,
  },
  {
    name: "Matai",
    country: "Tanzania",
    subcountry: "Rukwa",
    geonameid: 154638,
  },
  {
    name: "Maswa",
    country: "Tanzania",
    subcountry: "Simiyu",
    geonameid: 154648,
  },
  {
    name: "Masumbwe",
    country: "Tanzania",
    subcountry: "Geita",
    geonameid: 154654,
  },
  {
    name: "Maramba",
    country: "Tanzania",
    subcountry: "Tanga",
    geonameid: 154780,
  },
  {
    name: "Malinyi",
    country: "Tanzania",
    subcountry: "Morogoro",
    geonameid: 155016,
  },
  {
    name: "Malampaka",
    country: "Tanzania",
    subcountry: "Simiyu",
    geonameid: 155056,
  },
  {
    name: "Makuyuni",
    country: "Tanzania",
    subcountry: "Tanga",
    geonameid: 155076,
  },
  {
    name: "Makumbako",
    country: "Tanzania",
    subcountry: "Njombe",
    geonameid: 155101,
  },
  {
    name: "Mahanje",
    country: "Tanzania",
    subcountry: "Ruvuma",
    geonameid: 155285,
  },
  {
    name: "Kihangara",
    country: "Tanzania",
    subcountry: "Mwanza",
    geonameid: 155307,
  },
  {
    name: "Magugu",
    country: "Tanzania",
    subcountry: "Manyara",
    geonameid: 155310,
  },
  {
    name: "Magomeni",
    country: "Tanzania",
    subcountry: "Dar es Salaam",
    geonameid: 155321,
  },
  {
    name: "Magole",
    country: "Tanzania",
    subcountry: "Morogoro",
    geonameid: 155334,
  },
  {
    name: "Mafinga",
    country: "Tanzania",
    subcountry: "Iringa",
    geonameid: 155405,
  },
  {
    name: "Mabama",
    country: "Tanzania",
    subcountry: "Tabora",
    geonameid: 155515,
  },
  {
    name: "Lushoto",
    country: "Tanzania",
    subcountry: "Tanga",
    geonameid: 155569,
  },
  {
    name: "Lugoba",
    country: "Tanzania",
    subcountry: "Pwani",
    geonameid: 155743,
  },
  {
    name: "Liwale",
    country: "Tanzania",
    subcountry: "Lindi",
    geonameid: 155921,
  },
  {
    name: "Lembeni",
    country: "Tanzania",
    subcountry: "Kilimanjaro",
    geonameid: 156025,
  },
  {
    name: "Lalago",
    country: "Tanzania",
    subcountry: "Simiyu",
    geonameid: 156080,
  },
  {
    name: "Laela",
    country: "Tanzania",
    subcountry: "Rukwa",
    geonameid: 156098,
  },
  {
    name: "Kyela",
    country: "Tanzania",
    subcountry: "Mbeya",
    geonameid: 156111,
  },
  {
    name: "Kondoa",
    country: "Tanzania",
    subcountry: "Dodoma",
    geonameid: 156510,
  },
  {
    name: "Kiwira",
    country: "Tanzania",
    subcountry: "Mbeya",
    geonameid: 156627,
  },
  {
    name: "Kishapu",
    country: "Tanzania",
    subcountry: "Shinyanga",
    geonameid: 156963,
  },
  {
    name: "Kisesa",
    country: "Tanzania",
    subcountry: "Simiyu",
    geonameid: 156974,
  },
  {
    name: "Kirando",
    country: "Tanzania",
    subcountry: "Rukwa",
    geonameid: 157107,
  },
  {
    name: "Kiomboi",
    country: "Tanzania",
    subcountry: "Singida",
    geonameid: 157198,
  },
  {
    name: "Kingori",
    country: "Tanzania",
    subcountry: "Arusha",
    geonameid: 157268,
  },
  {
    name: "Kilosa",
    country: "Tanzania",
    subcountry: "Morogoro",
    geonameid: 157403,
  },
  {
    name: "Kigoma",
    country: "Tanzania",
    subcountry: "Kigoma",
    geonameid: 157738,
  },
  {
    name: "Kidodi",
    country: "Tanzania",
    subcountry: "Morogoro",
    geonameid: 157826,
  },
  {
    name: "Kidatu",
    country: "Tanzania",
    subcountry: "Morogoro",
    geonameid: 157863,
  },
  {
    name: "Kibondo",
    country: "Tanzania",
    subcountry: "Kigoma",
    geonameid: 157960,
  },
  {
    name: "Kibiti",
    country: "Tanzania",
    subcountry: "Pwani",
    geonameid: 157977,
  },
  {
    name: "Kibara",
    country: "Tanzania",
    subcountry: "Mara",
    geonameid: 158016,
  },
  {
    name: "Kibakwe",
    country: "Tanzania",
    subcountry: "Dodoma",
    geonameid: 158024,
  },
  {
    name: "Kibaha",
    country: "Tanzania",
    subcountry: "Pwani",
    geonameid: 158027,
  },
  {
    name: "Katumba",
    country: "Tanzania",
    subcountry: "Mbeya",
    geonameid: 158151,
  },
  {
    name: "Katoro",
    country: "Tanzania",
    subcountry: "Geita",
    geonameid: 158160,
  },
  {
    name: "Katerero",
    country: "Tanzania",
    subcountry: "Kagera",
    geonameid: 158179,
  },
  {
    name: "Kasulu",
    country: "Tanzania",
    subcountry: "Kigoma",
    geonameid: 158214,
  },
  {
    name: "Kasamwa",
    country: "Tanzania",
    subcountry: "Geita",
    geonameid: 158289,
  },
  {
    name: "Kiratu",
    country: "Tanzania",
    subcountry: "Arusha",
    geonameid: 158324,
  },
  {
    name: "Kamachumu",
    country: "Tanzania",
    subcountry: "Kagera",
    geonameid: 158492,
  },
  {
    name: "Kakonko",
    country: "Tanzania",
    subcountry: "Kigoma",
    geonameid: 158563,
  },
  {
    name: "Kahama",
    country: "Tanzania",
    subcountry: "Shinyanga",
    geonameid: 158597,
  },
  {
    name: "Kabanga",
    country: "Tanzania",
    subcountry: "Kagera",
    geonameid: 158684,
  },
  {
    name: "Izazi",
    country: "Tanzania",
    subcountry: "Iringa",
    geonameid: 158825,
  },
  {
    name: "Itigi",
    country: "Tanzania",
    subcountry: "Singida",
    geonameid: 158904,
  },
  {
    name: "Isaka",
    country: "Tanzania",
    subcountry: "Shinyanga",
    geonameid: 159045,
  },
  {
    name: "Iringa",
    country: "Tanzania",
    subcountry: "Iringa",
    geonameid: 159071,
  },
  {
    name: "Ipinda",
    country: "Tanzania",
    subcountry: "Mbeya",
    geonameid: 159107,
  },
  {
    name: "Ilula",
    country: "Tanzania",
    subcountry: "Iringa",
    geonameid: 159179,
  },
  {
    name: "Ilongero",
    country: "Tanzania",
    subcountry: "Singida",
    geonameid: 159186,
  },
  {
    name: "Ilembula",
    country: "Tanzania",
    subcountry: "Njombe",
    geonameid: 159218,
  },
  {
    name: "Ikungi",
    country: "Tanzania",
    subcountry: "Singida",
    geonameid: 159267,
  },
  {
    name: "Igurusi",
    country: "Tanzania",
    subcountry: "Mbeya",
    geonameid: 159380,
  },
  {
    name: "Igunga",
    country: "Tanzania",
    subcountry: "Tabora",
    geonameid: 159386,
  },
  {
    name: "Igugunu",
    country: "Tanzania",
    subcountry: "Singida",
    geonameid: 159398,
  },
  {
    name: "Ifakara",
    country: "Tanzania",
    subcountry: "Morogoro",
    geonameid: 159492,
  },
  {
    name: "Hedaru",
    country: "Tanzania",
    subcountry: "Kilimanjaro",
    geonameid: 159647,
  },
  {
    name: "Geita",
    country: "Tanzania",
    subcountry: "Geita",
    geonameid: 159908,
  },
  {
    name: "Geiro",
    country: "Tanzania",
    subcountry: "Morogoro",
    geonameid: 159909,
  },
  {
    name: "Galappo",
    country: "Tanzania",
    subcountry: "Manyara",
    geonameid: 159951,
  },
  {
    name: "Dongobesh",
    country: "Tanzania",
    subcountry: "Manyara",
    geonameid: 160172,
  },
  {
    name: "Dodoma",
    country: "Tanzania",
    subcountry: "Dodoma",
    geonameid: 160196,
  },
  {
    name: "Dar es Salaam",
    country: "Tanzania",
    subcountry: "Dar es Salaam",
    geonameid: 160263,
  },
  {
    name: "Dareda",
    country: "Tanzania",
    subcountry: "Manyara",
    geonameid: 160266,
  },
  {
    name: "Chimala",
    country: "Tanzania",
    subcountry: "Mbeya",
    geonameid: 160464,
  },
  {
    name: "Chato",
    country: "Tanzania",
    subcountry: "Geita",
    geonameid: 160552,
  },
  {
    name: "Chanika",
    country: "Tanzania",
    subcountry: "Tanga",
    geonameid: 160592,
  },
  {
    name: "Chalinze",
    country: "Tanzania",
    subcountry: "Pwani",
    geonameid: 160660,
  },
  {
    name: "Chala",
    country: "Tanzania",
    subcountry: "Rukwa",
    geonameid: 160670,
  },
  {
    name: "Chake Chake",
    country: "Tanzania",
    subcountry: "Pemba South",
    geonameid: 160677,
  },
  {
    name: "Butiama",
    country: "Tanzania",
    subcountry: "Mara",
    geonameid: 160798,
  },
  {
    name: "Buseresere",
    country: "Tanzania",
    subcountry: "Geita",
    geonameid: 160833,
  },
  {
    name: "Bungu",
    country: "Tanzania",
    subcountry: "Pwani",
    geonameid: 160877,
  },
  {
    name: "Bunda",
    country: "Tanzania",
    subcountry: "Mara",
    geonameid: 160892,
  },
  {
    name: "Bukoba",
    country: "Tanzania",
    subcountry: "Kagera",
    geonameid: 160961,
  },
  {
    name: "Bugarama",
    country: "Tanzania",
    subcountry: "Kagera",
    geonameid: 161023,
  },
  {
    name: "Biharamulo",
    country: "Tanzania",
    subcountry: "Kagera",
    geonameid: 161154,
  },
  {
    name: "Basotu",
    country: "Tanzania",
    subcountry: "Manyara",
    geonameid: 161197,
  },
  {
    name: "Bashanet",
    country: "Tanzania",
    subcountry: "Manyara",
    geonameid: 161204,
  },
  {
    name: "Bariadi",
    country: "Tanzania",
    subcountry: "Simiyu",
    geonameid: 161218,
  },
  {
    name: "Bagamoyo",
    country: "Tanzania",
    subcountry: "Pwani",
    geonameid: 161290,
  },
  {
    name: "Babati",
    country: "Tanzania",
    subcountry: "Manyara",
    geonameid: 161312,
  },
  {
    name: "Arusha",
    country: "Tanzania",
    subcountry: "Arusha",
    geonameid: 161325,
  },
  {
    name: "Tingi",
    country: "Tanzania",
    subcountry: "Ruvuma",
    geonameid: 877384,
  },
  {
    name: "Tandahimba",
    country: "Tanzania",
    subcountry: "Mtwara",
    geonameid: 877391,
  },
  {
    name: "Songea",
    country: "Tanzania",
    subcountry: "Ruvuma",
    geonameid: 877401,
  },
  {
    name: "Nyangao",
    country: "Tanzania",
    subcountry: "Lindi",
    geonameid: 877471,
  },
  {
    name: "Newala Kisimani",
    country: "Tanzania",
    subcountry: "Mtwara",
    geonameid: 877532,
  },
  {
    name: "Nanyamba",
    country: "Tanzania",
    subcountry: "Mtwara",
    geonameid: 877581,
  },
  {
    name: "Nangomba",
    country: "Tanzania",
    subcountry: "Mtwara",
    geonameid: 877597,
  },
  {
    name: "Nanganga",
    country: "Tanzania",
    subcountry: "Mtwara",
    geonameid: 877605,
  },
  {
    name: "Nachingwea",
    country: "Tanzania",
    subcountry: "Lindi",
    geonameid: 877702,
  },
  {
    name: "Mtwara",
    country: "Tanzania",
    subcountry: "Mtwara",
    geonameid: 877747,
  },
  {
    name: "Mbinga",
    country: "Tanzania",
    subcountry: "Ruvuma",
    geonameid: 877998,
  },
  {
    name: "Matiri",
    country: "Tanzania",
    subcountry: "Ruvuma",
    geonameid: 878041,
  },
  {
    name: "Masasi",
    country: "Tanzania",
    subcountry: "Mtwara",
    geonameid: 878058,
  },
  {
    name: "Maposeni",
    country: "Tanzania",
    subcountry: "Ruvuma",
    geonameid: 878073,
  },
  {
    name: "Lukuledi",
    country: "Tanzania",
    subcountry: "Mtwara",
    geonameid: 878195,
  },
  {
    name: "Luchingu",
    country: "Tanzania",
    subcountry: "Mtwara",
    geonameid: 878223,
  },
  {
    name: "Lindi",
    country: "Tanzania",
    subcountry: "Lindi",
    geonameid: 878281,
  },
  {
    name: "Kitama",
    country: "Tanzania",
    subcountry: "Mtwara",
    geonameid: 878367,
  },
  {
    name: "Kigonsera",
    country: "Tanzania",
    subcountry: "Ruvuma",
    geonameid: 878400,
  },
  {
    name: "Merelani",
    country: "Tanzania",
    subcountry: "Arusha",
    geonameid: 6640202,
  },
  {
    name: "Lebedyn",
    country: "Ukraine",
    subcountry: "Sumy",
    geonameid: 613273,
  },
  {
    name: "Druzhkivka",
    country: "Ukraine",
    subcountry: "Donetsk",
    geonameid: 616743,
  },
  {
    name: "Zvenihorodka",
    country: "Ukraine",
    subcountry: "Cherkasy",
    geonameid: 686803,
  },
  {
    name: "Zuhres",
    country: "Ukraine",
    subcountry: "Donetsk",
    geonameid: 686818,
  },
  {
    name: "Zolotonosha",
    country: "Ukraine",
    subcountry: "Cherkasy",
    geonameid: 686875,
  },
  {
    name: "Zolochiv",
    country: "Ukraine",
    subcountry: "Lviv",
    geonameid: 686896,
  },
  {
    name: "Znamyanka",
    country: "Ukraine",
    subcountry: "Kirovohrad",
    geonameid: 686919,
  },
  {
    name: "Zhytomyr",
    country: "Ukraine",
    subcountry: "Zhytomyr",
    geonameid: 686967,
  },
  {
    name: "Zhmerynka",
    country: "Ukraine",
    subcountry: "Vinnytsia",
    geonameid: 687116,
  },
  {
    name: "Zhovti Vody",
    country: "Ukraine",
    subcountry: "Dnipropetrovsk",
    geonameid: 687196,
  },
  {
    name: "Zdolbuniv",
    country: "Ukraine",
    subcountry: "Rivne",
    geonameid: 687432,
  },
  {
    name: "Zaporizhzhya",
    country: "Ukraine",
    subcountry: "Zaporizhzhia",
    geonameid: 687700,
  },
  {
    name: "Yuzhne",
    country: "Ukraine",
    subcountry: "Odessa",
    geonameid: 687997,
  },
  {
    name: "Yevpatoriya",
    country: "Ukraine",
    subcountry: "Crimea",
    geonameid: 688105,
  },
  {
    name: "Yenakiieve",
    country: "Ukraine",
    subcountry: "Donetsk",
    geonameid: 688148,
  },
  {
    name: "Yasynuvata",
    country: "Ukraine",
    subcountry: "Donetsk",
    geonameid: 688373,
  },
  {
    name: "Yalta",
    country: "Ukraine",
    subcountry: "Crimea",
    geonameid: 688533,
  },
  {
    name: "Yahotyn",
    country: "Ukraine",
    subcountry: "Kiev",
    geonameid: 688587,
  },
  {
    name: "Vyshhorod",
    country: "Ukraine",
    subcountry: "Kiev",
    geonameid: 688723,
  },
  {
    name: "Vynohradiv",
    country: "Ukraine",
    subcountry: "Transcarpathia",
    geonameid: 688746,
  },
  {
    name: "Voznesensk",
    country: "Ukraine",
    subcountry: "Mykolaiv",
    geonameid: 688860,
  },
  {
    name: "Volochysk",
    country: "Ukraine",
    subcountry: "Khmelnytskyi",
    geonameid: 689159,
  },
  {
    name: "Volnovakha",
    country: "Ukraine",
    subcountry: "Donetsk",
    geonameid: 689198,
  },
  {
    name: "Vilnohirsk",
    country: "Ukraine",
    subcountry: "Dnipropetrovsk",
    geonameid: 689200,
  },
  {
    name: "Vovchansk",
    country: "Ukraine",
    subcountry: "Kharkiv",
    geonameid: 689304,
  },
  {
    name: "Volodymyr-Volynskyi",
    country: "Ukraine",
    subcountry: "Volyn",
    geonameid: 689378,
  },
  {
    name: "Vyshneve",
    country: "Ukraine",
    subcountry: "Kiev",
    geonameid: 689487,
  },
  {
    name: "Vinnytsya",
    country: "Ukraine",
    subcountry: "Vinnytsia",
    geonameid: 689558,
  },
  {
    name: "Vilnyansk",
    country: "Ukraine",
    subcountry: "Zaporizhzhia",
    geonameid: 689584,
  },
  {
    name: "Verkhnodniprovsk",
    country: "Ukraine",
    subcountry: "Dnipropetrovsk",
    geonameid: 689916,
  },
  {
    name: "Vatutine",
    country: "Ukraine",
    subcountry: "Cherkasy",
    geonameid: 690312,
  },
  {
    name: "Vasylkiv",
    country: "Ukraine",
    subcountry: "Kiev",
    geonameid: 690412,
  },
  {
    name: "Uzhgorod",
    country: "Ukraine",
    subcountry: "Transcarpathia",
    geonameid: 690548,
  },
  {
    name: "Uman",
    country: "Ukraine",
    subcountry: "Cherkasy",
    geonameid: 690688,
  },
  {
    name: "Tulchyn",
    country: "Ukraine",
    subcountry: "Vinnytsia",
    geonameid: 691016,
  },
  {
    name: "Oleshky",
    country: "Ukraine",
    subcountry: "Kherson",
    geonameid: 691037,
  },
  {
    name: "Truskavets",
    country: "Ukraine",
    subcountry: "Lviv",
    geonameid: 691179,
  },
  {
    name: "Trostianets",
    country: "Ukraine",
    subcountry: "Sumy",
    geonameid: 691255,
  },
  {
    name: "Chystyakove",
    country: "Ukraine",
    subcountry: "Donetsk",
    geonameid: 691374,
  },
  {
    name: "Tokmak",
    country: "Ukraine",
    subcountry: "Zaporizhzhia",
    geonameid: 691469,
  },
  {
    name: "Ternivka",
    country: "Ukraine",
    subcountry: "Dnipropetrovsk",
    geonameid: 691628,
  },
  {
    name: "Ternopil",
    country: "Ukraine",
    subcountry: "Ternopil",
    geonameid: 691650,
  },
  {
    name: "Sievierodonetsk",
    country: "Ukraine",
    subcountry: "Luhansk",
    geonameid: 691999,
  },
  {
    name: "Svitlovodsk",
    country: "Ukraine",
    subcountry: "Kirovohrad",
    geonameid: 692087,
  },
  {
    name: "Dovzhansk",
    country: "Ukraine",
    subcountry: "Luhansk",
    geonameid: 692105,
  },
  {
    name: "Svatove",
    country: "Ukraine",
    subcountry: "Luhansk",
    geonameid: 692118,
  },
  {
    name: "Svalyava",
    country: "Ukraine",
    subcountry: "Transcarpathia",
    geonameid: 692129,
  },
  {
    name: "Sumy",
    country: "Ukraine",
    subcountry: "Sumy",
    geonameid: 692194,
  },
  {
    name: "Sudak",
    country: "Ukraine",
    subcountry: "Crimea",
    geonameid: 692315,
  },
  {
    name: "Stryi",
    country: "Ukraine",
    subcountry: "Lviv",
    geonameid: 692372,
  },
  {
    name: "Stebnyk",
    country: "Ukraine",
    subcountry: "Lviv",
    geonameid: 692632,
  },
  {
    name: "Starokostyantyniv",
    country: "Ukraine",
    subcountry: "Khmelnytskyi",
    geonameid: 692818,
  },
  {
    name: "Starobilsk",
    country: "Ukraine",
    subcountry: "Luhansk",
    geonameid: 692832,
  },
  {
    name: "Kadiyivka",
    country: "Ukraine",
    subcountry: "Luhansk",
    geonameid: 692975,
  },
  {
    name: "Sokal",
    country: "Ukraine",
    subcountry: "Lviv",
    geonameid: 693301,
  },
  {
    name: "Snizhne",
    country: "Ukraine",
    subcountry: "Donetsk",
    geonameid: 693381,
  },
  {
    name: "Smila",
    country: "Ukraine",
    subcountry: "Cherkasy",
    geonameid: 693457,
  },
  {
    name: "Sloviansk",
    country: "Ukraine",
    subcountry: "Donetsk",
    geonameid: 693468,
  },
  {
    name: "Slavuta",
    country: "Ukraine",
    subcountry: "Khmelnytskyi",
    geonameid: 693581,
  },
  {
    name: "Skvyra",
    country: "Ukraine",
    subcountry: "Kiev",
    geonameid: 693615,
  },
  {
    name: "Skadovsk",
    country: "Ukraine",
    subcountry: "Kherson",
    geonameid: 693709,
  },
  {
    name: "Synelnykove",
    country: "Ukraine",
    subcountry: "Dnipropetrovsk",
    geonameid: 693796,
  },
  {
    name: "Simferopol",
    country: "Ukraine",
    subcountry: "Crimea",
    geonameid: 693805,
  },
  {
    name: "Shpola",
    country: "Ukraine",
    subcountry: "Cherkasy",
    geonameid: 693920,
  },
  {
    name: "Shostka",
    country: "Ukraine",
    subcountry: "Sumy",
    geonameid: 693942,
  },
  {
    name: "Shepetivka",
    country: "Ukraine",
    subcountry: "Khmelnytskyi",
    geonameid: 694216,
  },
  {
    name: "Shakhtarsk",
    country: "Ukraine",
    subcountry: "Donetsk",
    geonameid: 694382,
  },
  {
    name: "Sevastopol",
    country: "Ukraine",
    subcountry: "Sevastopol City",
    geonameid: 694423,
  },
  {
    name: "Selydove",
    country: "Ukraine",
    subcountry: "Donetsk",
    geonameid: 694677,
  },
  {
    name: "Sarny",
    country: "Ukraine",
    subcountry: "Rivne",
    geonameid: 694792,
  },
  {
    name: "Sambir",
    country: "Ukraine",
    subcountry: "Lviv",
    geonameid: 694864,
  },
  {
    name: "Saki",
    country: "Ukraine",
    subcountry: "Crimea",
    geonameid: 694910,
  },
  {
    name: "Rubizhne",
    country: "Ukraine",
    subcountry: "Luhansk",
    geonameid: 695274,
  },
  {
    name: "Rozdilna",
    country: "Ukraine",
    subcountry: "Odessa",
    geonameid: 695344,
  },
  {
    name: "Kurakhove",
    country: "Ukraine",
    subcountry: "Donetsk",
    geonameid: 695357,
  },
  {
    name: "Rovenky",
    country: "Ukraine",
    subcountry: "Luhansk",
    geonameid: 695379,
  },
  {
    name: "Romny",
    country: "Ukraine",
    subcountry: "Sumy",
    geonameid: 695464,
  },
  {
    name: "Rivne",
    country: "Ukraine",
    subcountry: "Rivne",
    geonameid: 695594,
  },
  {
    name: "Rakhiv",
    country: "Ukraine",
    subcountry: "Transcarpathia",
    geonameid: 695859,
  },
  {
    name: "Radomyshl",
    country: "Ukraine",
    subcountry: "Zhytomyr",
    geonameid: 695912,
  },
  {
    name: "Pyatykhatky",
    country: "Ukraine",
    subcountry: "Dnipropetrovsk",
    geonameid: 695965,
  },
  {
    name: "Pryluky",
    country: "Ukraine",
    subcountry: "Chernihiv",
    geonameid: 696108,
  },
  {
    name: "Popasna",
    country: "Ukraine",
    subcountry: "Luhansk",
    geonameid: 696566,
  },
  {
    name: "Poltava",
    country: "Ukraine",
    subcountry: "Poltava",
    geonameid: 696643,
  },
  {
    name: "Polonne",
    country: "Ukraine",
    subcountry: "Khmelnytskyi",
    geonameid: 696660,
  },
  {
    name: "Polohy",
    country: "Ukraine",
    subcountry: "Zaporizhzhia",
    geonameid: 696677,
  },
  {
    name: "Pidhorodne",
    country: "Ukraine",
    subcountry: "Dnipropetrovsk",
    geonameid: 696943,
  },
  {
    name: "Pervomaiskyi",
    country: "Ukraine",
    subcountry: "Kharkiv",
    geonameid: 697576,
  },
  {
    name: "Pervomaisk",
    country: "Ukraine",
    subcountry: "Luhansk",
    geonameid: 697592,
  },
  {
    name: "Pervomaysk",
    country: "Ukraine",
    subcountry: "Mykolaiv",
    geonameid: 697593,
  },
  {
    name: "Pershotravensk",
    country: "Ukraine",
    subcountry: "Dnipropetrovsk",
    geonameid: 697616,
  },
  {
    name: "Pereiaslav",
    country: "Ukraine",
    subcountry: "Kiev",
    geonameid: 697637,
  },
  {
    name: "Perevalsk",
    country: "Ukraine",
    subcountry: "Luhansk",
    geonameid: 697650,
  },
  {
    name: "Pavlohrad",
    country: "Ukraine",
    subcountry: "Dnipropetrovsk",
    geonameid: 697889,
  },
  {
    name: "Ovruch",
    country: "Ukraine",
    subcountry: "Zhytomyr",
    geonameid: 698131,
  },
  {
    name: "Pokrov",
    country: "Ukraine",
    subcountry: "Dnipropetrovsk",
    geonameid: 698436,
  },
  {
    name: "Oleksandriya",
    country: "Ukraine",
    subcountry: "Kirovohrad",
    geonameid: 698625,
  },
  {
    name: "Odesa",
    country: "Ukraine",
    subcountry: "Odessa",
    geonameid: 698740,
  },
  {
    name: "Obukhiv",
    country: "Ukraine",
    subcountry: "Kiev",
    geonameid: 698782,
  },
  {
    name: "Novovolynsk",
    country: "Ukraine",
    subcountry: "Volyn",
    geonameid: 699035,
  },
  {
    name: "Novoukrayinka",
    country: "Ukraine",
    subcountry: "Kirovohrad",
    geonameid: 699078,
  },
  {
    name: "Novomoskovsk",
    country: "Ukraine",
    subcountry: "Dnipropetrovsk",
    geonameid: 699445,
  },
  {
    name: "Zviahel",
    country: "Ukraine",
    subcountry: "Zhytomyr",
    geonameid: 699553,
  },
  {
    name: "Nova Kakhovka",
    country: "Ukraine",
    subcountry: "Kherson",
    geonameid: 699839,
  },
  {
    name: "Nizhyn",
    country: "Ukraine",
    subcountry: "Chernihiv",
    geonameid: 699942,
  },
  {
    name: "Nikopol",
    country: "Ukraine",
    subcountry: "Dnipropetrovsk",
    geonameid: 700051,
  },
  {
    name: "Netishyn",
    country: "Ukraine",
    subcountry: "Khmelnytskyi",
    geonameid: 700261,
  },
  {
    name: "Nadvirna",
    country: "Ukraine",
    subcountry: "Ivano-Frankivsk",
    geonameid: 700507,
  },
  {
    name: "Mykolayiv",
    country: "Ukraine",
    subcountry: "Mykolaiv",
    geonameid: 700569,
  },
  {
    name: "Mukachevo",
    country: "Ukraine",
    subcountry: "Transcarpathia",
    geonameid: 700646,
  },
  {
    name: "Mostyska",
    country: "Ukraine",
    subcountry: "Lviv",
    geonameid: 700696,
  },
  {
    name: "Molodohvardiisk",
    country: "Ukraine",
    subcountry: "Luhansk",
    geonameid: 700829,
  },
  {
    name: "Mohyliv-Podilskyy",
    country: "Ukraine",
    subcountry: "Vinnytsia",
    geonameid: 700918,
  },
  {
    name: "Myrhorod",
    country: "Ukraine",
    subcountry: "Poltava",
    geonameid: 701075,
  },
  {
    name: "Merefa",
    country: "Ukraine",
    subcountry: "Kharkiv",
    geonameid: 701347,
  },
  {
    name: "Melitopol",
    country: "Ukraine",
    subcountry: "Zaporizhzhia",
    geonameid: 701404,
  },
  {
    name: "Mariupol",
    country: "Ukraine",
    subcountry: "Donetsk",
    geonameid: 701822,
  },
  {
    name: "Marhanets",
    country: "Ukraine",
    subcountry: "Dnipropetrovsk",
    geonameid: 701855,
  },
  {
    name: "Malyn",
    country: "Ukraine",
    subcountry: "Zhytomyr",
    geonameid: 702116,
  },
  {
    name: "Makiivka",
    country: "Ukraine",
    subcountry: "Donetsk",
    geonameid: 702320,
  },
  {
    name: "Lyubotyn",
    country: "Ukraine",
    subcountry: "Kharkiv",
    geonameid: 702417,
  },
  {
    name: "Lviv",
    country: "Ukraine",
    subcountry: "Lviv",
    geonameid: 702550,
  },
  {
    name: "Lutuhyne",
    country: "Ukraine",
    subcountry: "Luhansk",
    geonameid: 702563,
  },
  {
    name: "Lutsk",
    country: "Ukraine",
    subcountry: "Volyn",
    geonameid: 702569,
  },
  {
    name: "Luhansk",
    country: "Ukraine",
    subcountry: "Luhansk",
    geonameid: 702658,
  },
  {
    name: "Lubny",
    country: "Ukraine",
    subcountry: "Poltava",
    geonameid: 702723,
  },
  {
    name: "Lozova",
    country: "Ukraine",
    subcountry: "Kharkiv",
    geonameid: 702760,
  },
  {
    name: "Lysychansk",
    country: "Ukraine",
    subcountry: "Luhansk",
    geonameid: 702972,
  },
  {
    name: "Ladyzhyn",
    country: "Ukraine",
    subcountry: "Vinnytsia",
    geonameid: 703428,
  },
  {
    name: "Kyiv",
    country: "Ukraine",
    subcountry: "Kyiv City",
    geonameid: 703448,
  },
  {
    name: "Kurakhovo",
    country: "Ukraine",
    subcountry: "Donetsk",
    geonameid: 703646,
  },
  {
    name: "Kupiansk",
    country: "Ukraine",
    subcountry: "Kharkiv",
    geonameid: 703656,
  },
  {
    name: "Kryvyy Rih",
    country: "Ukraine",
    subcountry: "Dnipropetrovsk",
    geonameid: 703845,
  },
  {
    name: "Krolevets",
    country: "Ukraine",
    subcountry: "Sumy",
    geonameid: 704000,
  },
  {
    name: "Kreminna",
    country: "Ukraine",
    subcountry: "Luhansk",
    geonameid: 704138,
  },
  {
    name: "Kremenets",
    country: "Ukraine",
    subcountry: "Ternopil",
    geonameid: 704143,
  },
  {
    name: "Kremenchuk",
    country: "Ukraine",
    subcountry: "Poltava",
    geonameid: 704147,
  },
  {
    name: "Khrustalnyi",
    country: "Ukraine",
    subcountry: "Luhansk",
    geonameid: 704202,
  },
  {
    name: "Lyman",
    country: "Ukraine",
    subcountry: "Donetsk",
    geonameid: 704204,
  },
  {
    name: "Yany Kapu",
    country: "Ukraine",
    subcountry: "Crimea",
    geonameid: 704362,
  },
  {
    name: "Krasnohrad",
    country: "Ukraine",
    subcountry: "Kharkiv",
    geonameid: 704388,
  },
  {
    name: "Sorokyne",
    country: "Ukraine",
    subcountry: "Luhansk",
    geonameid: 704403,
  },
  {
    name: "Pokrovsk",
    country: "Ukraine",
    subcountry: "Donetsk",
    geonameid: 704422,
  },
  {
    name: "Krasyliv",
    country: "Ukraine",
    subcountry: "Khmelnytskyi",
    geonameid: 704492,
  },
  {
    name: "Kramatorsk",
    country: "Ukraine",
    subcountry: "Donetsk",
    geonameid: 704508,
  },
  {
    name: "Kivsharivka",
    country: "Ukraine",
    subcountry: "Kharkiv",
    geonameid: 704608,
  },
  {
    name: "Kovel",
    country: "Ukraine",
    subcountry: "Volyn",
    geonameid: 704617,
  },
  {
    name: "Kotsiubynske",
    country: "Ukraine",
    subcountry: "Kyiv City",
    geonameid: 704670,
  },
  {
    name: "Podilsk",
    country: "Ukraine",
    subcountry: "Odessa",
    geonameid: 704679,
  },
  {
    name: "Kostopil",
    country: "Ukraine",
    subcountry: "Rivne",
    geonameid: 704737,
  },
  {
    name: "Korsun-Shevchenkivskyy",
    country: "Ukraine",
    subcountry: "Cherkasy",
    geonameid: 704858,
  },
  {
    name: "Korostyshiv",
    country: "Ukraine",
    subcountry: "Zhytomyr",
    geonameid: 704885,
  },
  {
    name: "Korosten",
    country: "Ukraine",
    subcountry: "Zhytomyr",
    geonameid: 704901,
  },
  {
    name: "Kostiantynivka",
    country: "Ukraine",
    subcountry: "Donetsk",
    geonameid: 705104,
  },
  {
    name: "Konotop",
    country: "Ukraine",
    subcountry: "Sumy",
    geonameid: 705135,
  },
  {
    name: "Slobozhans’ke",
    country: "Ukraine",
    subcountry: "Kharkiv",
    geonameid: 705183,
  },
  {
    name: "Kolomyia",
    country: "Ukraine",
    subcountry: "Ivano-Frankivsk",
    geonameid: 705392,
  },
  {
    name: "Khrestivka",
    country: "Ukraine",
    subcountry: "Donetsk",
    geonameid: 705797,
  },
  {
    name: "Holubivka",
    country: "Ukraine",
    subcountry: "Luhansk",
    geonameid: 705809,
  },
  {
    name: "Kropyvnytskyy",
    country: "Ukraine",
    subcountry: "Kirovohrad",
    geonameid: 705812,
  },
  {
    name: "Kiliya",
    country: "Ukraine",
    subcountry: "Odessa",
    geonameid: 705883,
  },
  {
    name: "Khust",
    country: "Ukraine",
    subcountry: "Transcarpathia",
    geonameid: 706165,
  },
  {
    name: "Khmelnytskyi",
    country: "Ukraine",
    subcountry: "Khmelnytskyi",
    geonameid: 706369,
  },
  {
    name: "Khmilnyk",
    country: "Ukraine",
    subcountry: "Vinnytsia",
    geonameid: 706380,
  },
  {
    name: "Kherson",
    country: "Ukraine",
    subcountry: "Kherson",
    geonameid: 706448,
  },
  {
    name: "Khartsyzk",
    country: "Ukraine",
    subcountry: "Donetsk",
    geonameid: 706466,
  },
  {
    name: "Kharkiv",
    country: "Ukraine",
    subcountry: "Kharkiv",
    geonameid: 706483,
  },
  {
    name: "Kerch",
    country: "Ukraine",
    subcountry: "Crimea",
    geonameid: 706524,
  },
  {
    name: "Kozyatyn",
    country: "Ukraine",
    subcountry: "Vinnytsia",
    geonameid: 706571,
  },
  {
    name: "Kaniv",
    country: "Ukraine",
    subcountry: "Cherkasy",
    geonameid: 706900,
  },
  {
    name: "Kamianets-Podilskyi",
    country: "Ukraine",
    subcountry: "Khmelnytskyi",
    geonameid: 706950,
  },
  {
    name: "Kalush",
    country: "Ukraine",
    subcountry: "Ivano-Frankivsk",
    geonameid: 707099,
  },
  {
    name: "Kalynivka",
    country: "Ukraine",
    subcountry: "Vinnytsia",
    geonameid: 707155,
  },
  {
    name: "Kakhovka",
    country: "Ukraine",
    subcountry: "Kherson",
    geonameid: 707244,
  },
  {
    name: "Izium",
    country: "Ukraine",
    subcountry: "Kharkiv",
    geonameid: 707292,
  },
  {
    name: "Iziaslav",
    country: "Ukraine",
    subcountry: "Khmelnytskyi",
    geonameid: 707296,
  },
  {
    name: "Izmail",
    country: "Ukraine",
    subcountry: "Odessa",
    geonameid: 707308,
  },
  {
    name: "Ivano-Frankivsk",
    country: "Ukraine",
    subcountry: "Ivano-Frankivsk",
    geonameid: 707471,
  },
  {
    name: "Irpin",
    country: "Ukraine",
    subcountry: "Kiev",
    geonameid: 707565,
  },
  {
    name: "Ilovays’k",
    country: "Ukraine",
    subcountry: "Donetsk",
    geonameid: 707679,
  },
  {
    name: "Chornomors’k",
    country: "Ukraine",
    subcountry: "Odessa",
    geonameid: 707688,
  },
  {
    name: "Horodok",
    country: "Ukraine",
    subcountry: "Khmelnytskyi",
    geonameid: 707752,
  },
  {
    name: "Horlivka",
    country: "Ukraine",
    subcountry: "Donetsk",
    geonameid: 707753,
  },
  {
    name: "Hlukhiv",
    country: "Ukraine",
    subcountry: "Sumy",
    geonameid: 707758,
  },
  {
    name: "Hostomel",
    country: "Ukraine",
    subcountry: "Kiev",
    geonameid: 708251,
  },
  {
    name: "Horodok",
    country: "Ukraine",
    subcountry: "Lviv",
    geonameid: 708313,
  },
  {
    name: "Henichesk",
    country: "Ukraine",
    subcountry: "Kherson",
    geonameid: 708878,
  },
  {
    name: "Haysyn",
    country: "Ukraine",
    subcountry: "Vinnytsia",
    geonameid: 708901,
  },
  {
    name: "Hadyach",
    country: "Ukraine",
    subcountry: "Poltava",
    geonameid: 709054,
  },
  {
    name: "Feodosiya",
    country: "Ukraine",
    subcountry: "Crimea",
    geonameid: 709161,
  },
  {
    name: "Fastiv",
    country: "Ukraine",
    subcountry: "Kiev",
    geonameid: 709248,
  },
  {
    name: "Enerhodar",
    country: "Ukraine",
    subcountry: "Zaporizhzhia",
    geonameid: 709276,
  },
  {
    name: "Dzhankoi",
    country: "Ukraine",
    subcountry: "Crimea",
    geonameid: 709334,
  },
  {
    name: "Toretsk",
    country: "Ukraine",
    subcountry: "Donetsk",
    geonameid: 709354,
  },
  {
    name: "Dunayivtsi",
    country: "Ukraine",
    subcountry: "Khmelnytskyi",
    geonameid: 709429,
  },
  {
    name: "Dubno",
    country: "Ukraine",
    subcountry: "Rivne",
    geonameid: 709540,
  },
  {
    name: "Drohobych",
    country: "Ukraine",
    subcountry: "Lviv",
    geonameid: 709611,
  },
  {
    name: "Donetsk",
    country: "Ukraine",
    subcountry: "Donetsk",
    geonameid: 709717,
  },
  {
    name: "Dolyna",
    country: "Ukraine",
    subcountry: "Ivano-Frankivsk",
    geonameid: 709755,
  },
  {
    name: "Dolynska",
    country: "Ukraine",
    subcountry: "Kirovohrad",
    geonameid: 709782,
  },
  {
    name: "Dokuchaievsk",
    country: "Ukraine",
    subcountry: "Donetsk",
    geonameid: 709835,
  },
  {
    name: "Dobropillia",
    country: "Ukraine",
    subcountry: "Donetsk",
    geonameid: 709900,
  },
  {
    name: "Dnipro",
    country: "Ukraine",
    subcountry: "Dnipropetrovsk",
    geonameid: 709930,
  },
  {
    name: "Kamyanske",
    country: "Ukraine",
    subcountry: "Dnipropetrovsk",
    geonameid: 709932,
  },
  {
    name: "Dniprorudne",
    country: "Ukraine",
    subcountry: "Zaporizhzhia",
    geonameid: 709960,
  },
  {
    name: "Myrnohrad",
    country: "Ukraine",
    subcountry: "Donetsk",
    geonameid: 710035,
  },
  {
    name: "Derhachi",
    country: "Ukraine",
    subcountry: "Kharkiv",
    geonameid: 710098,
  },
  {
    name: "Debaltseve",
    country: "Ukraine",
    subcountry: "Donetsk",
    geonameid: 710229,
  },
  {
    name: "Chuhuiv",
    country: "Ukraine",
    subcountry: "Kharkiv",
    geonameid: 710374,
  },
  {
    name: "Chortkiv",
    country: "Ukraine",
    subcountry: "Ternopil",
    geonameid: 710400,
  },
  {
    name: "Chervonopartyzansk",
    country: "Ukraine",
    subcountry: "Luhansk",
    geonameid: 710548,
  },
  {
    name: "Chervonohrad",
    country: "Ukraine",
    subcountry: "Lviv",
    geonameid: 710554,
  },
  {
    name: "Chernivtsi",
    country: "Ukraine",
    subcountry: "Chernivtsi",
    geonameid: 710719,
  },
  {
    name: "Chernihiv",
    country: "Ukraine",
    subcountry: "Chernihiv",
    geonameid: 710735,
  },
  {
    name: "Cherkasy",
    country: "Ukraine",
    subcountry: "Cherkasy",
    geonameid: 710791,
  },
  {
    name: "Bucha",
    country: "Ukraine",
    subcountry: "Kiev",
    geonameid: 711350,
  },
  {
    name: "Brianka",
    country: "Ukraine",
    subcountry: "Luhansk",
    geonameid: 711369,
  },
  {
    name: "Brovary",
    country: "Ukraine",
    subcountry: "Kiev",
    geonameid: 711390,
  },
  {
    name: "Brody",
    country: "Ukraine",
    subcountry: "Lviv",
    geonameid: 711416,
  },
  {
    name: "Boiarka",
    country: "Ukraine",
    subcountry: "Kiev",
    geonameid: 711515,
  },
  {
    name: "Boryspil",
    country: "Ukraine",
    subcountry: "Kiev",
    geonameid: 711660,
  },
  {
    name: "Boryslav",
    country: "Ukraine",
    subcountry: "Lviv",
    geonameid: 711669,
  },
  {
    name: "Bolhrad",
    country: "Ukraine",
    subcountry: "Odessa",
    geonameid: 711841,
  },
  {
    name: "Bohuslav",
    country: "Ukraine",
    subcountry: "Kiev",
    geonameid: 711867,
  },
  {
    name: "Bohodukhiv",
    country: "Ukraine",
    subcountry: "Kharkiv",
    geonameid: 711894,
  },
  {
    name: "Bilhorod-Dnistrovskyi",
    country: "Ukraine",
    subcountry: "Odessa",
    geonameid: 712160,
  },
  {
    name: "Bila Tserkva",
    country: "Ukraine",
    subcountry: "Kiev",
    geonameid: 712165,
  },
  {
    name: "Berezhany",
    country: "Ukraine",
    subcountry: "Ternopil",
    geonameid: 712374,
  },
  {
    name: "Berezan",
    country: "Ukraine",
    subcountry: "Kiev",
    geonameid: 712389,
  },
  {
    name: "Berehove",
    country: "Ukraine",
    subcountry: "Transcarpathia",
    geonameid: 712423,
  },
  {
    name: "Berdychiv",
    country: "Ukraine",
    subcountry: "Zhytomyr",
    geonameid: 712441,
  },
  {
    name: "Berdyansk",
    country: "Ukraine",
    subcountry: "Zaporizhzhia",
    geonameid: 712451,
  },
  {
    name: "Bilopillia",
    country: "Ukraine",
    subcountry: "Sumy",
    geonameid: 712559,
  },
  {
    name: "Bilohirsk",
    country: "Ukraine",
    subcountry: "Crimea",
    geonameid: 712587,
  },
  {
    name: "Bar",
    country: "Ukraine",
    subcountry: "Vinnytsia",
    geonameid: 712861,
  },
  {
    name: "Balta",
    country: "Ukraine",
    subcountry: "Odessa",
    geonameid: 712886,
  },
  {
    name: "Balakliia",
    country: "Ukraine",
    subcountry: "Kharkiv",
    geonameid: 712926,
  },
  {
    name: "Balaklava",
    country: "Ukraine",
    subcountry: "Sevastopol City",
    geonameid: 712930,
  },
  {
    name: "Bakhmach",
    country: "Ukraine",
    subcountry: "Chernihiv",
    geonameid: 712967,
  },
  {
    name: "Bakhchysarai",
    country: "Ukraine",
    subcountry: "Crimea",
    geonameid: 712969,
  },
  {
    name: "Avdiivka",
    country: "Ukraine",
    subcountry: "Donetsk",
    geonameid: 713122,
  },
  {
    name: "Bakhmut",
    country: "Ukraine",
    subcountry: "Donetsk",
    geonameid: 713174,
  },
  {
    name: "Armyansk",
    country: "Ukraine",
    subcountry: "Crimea",
    geonameid: 713203,
  },
  {
    name: "Apostolove",
    country: "Ukraine",
    subcountry: "Dnipropetrovsk",
    geonameid: 713245,
  },
  {
    name: "Antratsyt",
    country: "Ukraine",
    subcountry: "Luhansk",
    geonameid: 713259,
  },
  {
    name: "Amvrosiivka",
    country: "Ukraine",
    subcountry: "Donetsk",
    geonameid: 713504,
  },
  {
    name: "Alushta",
    country: "Ukraine",
    subcountry: "Crimea",
    geonameid: 713513,
  },
  {
    name: "Alchevsk",
    country: "Ukraine",
    subcountry: "Luhansk",
    geonameid: 713716,
  },
  {
    name: "Okhtyrka",
    country: "Ukraine",
    subcountry: "Sumy",
    geonameid: 713749,
  },
  {
    name: "Horishni Plavni",
    country: "Ukraine",
    subcountry: "Poltava",
    geonameid: 6559559,
  },
  {
    name: "Slavutych",
    country: "Ukraine",
    subcountry: "Kiev",
    geonameid: 6930327,
  },
  {
    name: "Yuzhnoukrayinsk",
    country: "Ukraine",
    subcountry: "Mykolaiv",
    geonameid: 7525990,
  },
  {
    name: "Varash",
    country: "Ukraine",
    subcountry: "Rivne",
    geonameid: 8341919,
  },
  {
    name: "Novoyavorivs'k",
    country: "Ukraine",
    subcountry: "Lviv",
    geonameid: 8468760,
  },
  {
    name: "Reni",
    country: "Ukraine",
    subcountry: "Odessa",
    geonameid: 12129128,
  },
  {
    name: "Yumbe",
    country: "Uganda",
    subcountry: "Northern Region",
    geonameid: 225835,
  },
  {
    name: "Wobulenzi",
    country: "Uganda",
    subcountry: "Central Region",
    geonameid: 225858,
  },
  {
    name: "Wakiso",
    country: "Uganda",
    subcountry: "Central Region",
    geonameid: 225964,
  },
  {
    name: "Tororo",
    country: "Uganda",
    subcountry: "Eastern Region",
    geonameid: 226110,
  },
  {
    name: "Soroti",
    country: "Uganda",
    subcountry: "Eastern Region",
    geonameid: 226234,
  },
  {
    name: "Pallisa",
    country: "Uganda",
    subcountry: "Eastern Region",
    geonameid: 226823,
  },
  {
    name: "Paidha",
    country: "Uganda",
    subcountry: "Northern Region",
    geonameid: 226853,
  },
  {
    name: "Nyachera",
    country: "Uganda",
    subcountry: "Western Region",
    geonameid: 227528,
  },
  {
    name: "Ntungamo",
    country: "Uganda",
    subcountry: "Western Region",
    geonameid: 227592,
  },
  {
    name: "Ntungamo",
    country: "Uganda",
    subcountry: "Western Region",
    geonameid: 227593,
  },
  {
    name: "Njeru",
    country: "Uganda",
    subcountry: "Central Region",
    geonameid: 227812,
  },
  {
    name: "Nebbi",
    country: "Uganda",
    subcountry: "Northern Region",
    geonameid: 227904,
  },
  {
    name: "Namasuba",
    country: "Uganda",
    subcountry: "Central Region",
    geonameid: 228227,
  },
  {
    name: "Mukono",
    country: "Uganda",
    subcountry: "Central Region",
    geonameid: 228853,
  },
  {
    name: "Mubende",
    country: "Uganda",
    subcountry: "Central Region",
    geonameid: 228971,
  },
  {
    name: "Moyo",
    country: "Uganda",
    subcountry: "Northern Region",
    geonameid: 229059,
  },
  {
    name: "Mityana",
    country: "Uganda",
    subcountry: "Central Region",
    geonameid: 229139,
  },
  {
    name: "Mbarara",
    country: "Uganda",
    subcountry: "Western Region",
    geonameid: 229268,
  },
  {
    name: "Mbale",
    country: "Uganda",
    subcountry: "Eastern Region",
    geonameid: 229278,
  },
  {
    name: "Masindi",
    country: "Uganda",
    subcountry: "Western Region",
    geonameid: 229362,
  },
  {
    name: "Masaka",
    country: "Uganda",
    subcountry: "Central Region",
    geonameid: 229380,
  },
  {
    name: "Luwero",
    country: "Uganda",
    subcountry: "Central Region",
    geonameid: 229746,
  },
  {
    name: "Lugazi",
    country: "Uganda",
    subcountry: "Central Region",
    geonameid: 229911,
  },
  {
    name: "Lira",
    country: "Uganda",
    subcountry: "Northern Region",
    geonameid: 230166,
  },
  {
    name: "Kyenjojo",
    country: "Uganda",
    subcountry: "Western Region",
    geonameid: 230299,
  },
  {
    name: "Kotido",
    country: "Uganda",
    subcountry: "Northern Region",
    geonameid: 230617,
  },
  {
    name: "Kitgum",
    country: "Uganda",
    subcountry: "Northern Region",
    geonameid: 230893,
  },
  {
    name: "Kireka",
    country: "Uganda",
    subcountry: "Central Region",
    geonameid: 231139,
  },
  {
    name: "Kayunga",
    country: "Uganda",
    subcountry: "Central Region",
    geonameid: 231696,
  },
  {
    name: "Kasese",
    country: "Uganda",
    subcountry: "Western Region",
    geonameid: 232066,
  },
  {
    name: "Kamwenge",
    country: "Uganda",
    subcountry: "Western Region",
    geonameid: 232371,
  },
  {
    name: "Kampala",
    country: "Uganda",
    subcountry: "Central Region",
    geonameid: 232422,
  },
  {
    name: "Kabale",
    country: "Uganda",
    subcountry: "Western Region",
    geonameid: 233070,
  },
  {
    name: "Jinja",
    country: "Uganda",
    subcountry: "Eastern Region",
    geonameid: 233114,
  },
  {
    name: "Iganga",
    country: "Uganda",
    subcountry: "Eastern Region",
    geonameid: 233275,
  },
  {
    name: "Ibanda",
    country: "Uganda",
    subcountry: "Western Region",
    geonameid: 233299,
  },
  {
    name: "Hoima",
    country: "Uganda",
    subcountry: "Western Region",
    geonameid: 233312,
  },
  {
    name: "Gulu",
    country: "Uganda",
    subcountry: "Northern Region",
    geonameid: 233346,
  },
  {
    name: "Fort Portal",
    country: "Uganda",
    subcountry: "Western Region",
    geonameid: 233476,
  },
  {
    name: "Entebbe",
    country: "Uganda",
    subcountry: "Central Region",
    geonameid: 233508,
  },
  {
    name: "Bwizibwera",
    country: "Uganda",
    subcountry: "Western Region",
    geonameid: 233730,
  },
  {
    name: "Buwenge",
    country: "Uganda",
    subcountry: "Eastern Region",
    geonameid: 233886,
  },
  {
    name: "Busia",
    country: "Uganda",
    subcountry: "Eastern Region",
    geonameid: 234077,
  },
  {
    name: "Busembatia",
    country: "Uganda",
    subcountry: "Eastern Region",
    geonameid: 234092,
  },
  {
    name: "Bundibugyo",
    country: "Uganda",
    subcountry: "Western Region",
    geonameid: 234178,
  },
  {
    name: "Bugiri",
    country: "Uganda",
    subcountry: "Eastern Region",
    geonameid: 234565,
  },
  {
    name: "Arua",
    country: "Uganda",
    subcountry: "Northern Region",
    geonameid: 235039,
  },
  {
    name: "Apac",
    country: "Uganda",
    subcountry: "Northern Region",
    geonameid: 235130,
  },
  {
    name: "Adjumani",
    country: "Uganda",
    subcountry: "Northern Region",
    geonameid: 235489,
  },
  {
    name: "Fort Hunt",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4046704,
  },
  {
    name: "Bessemer",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4048023,
  },
  {
    name: "Paducah",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4048662,
  },
  {
    name: "Birmingham",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4049979,
  },
  {
    name: "Cordova",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4050552,
  },
  {
    name: "Center Point",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4054378,
  },
  {
    name: "Cullman",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4057835,
  },
  {
    name: "Daphne",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4058219,
  },
  {
    name: "Decatur",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4058553,
  },
  {
    name: "Dothan",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4059102,
  },
  {
    name: "East Florence",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4059870,
  },
  {
    name: "Enterprise",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4060791,
  },
  {
    name: "Fairhope",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4061234,
  },
  {
    name: "Florence",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4062577,
  },
  {
    name: "Foley",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4062644,
  },
  {
    name: "Gadsden",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4063619,
  },
  {
    name: "Helena",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4066811,
  },
  {
    name: "Homewood",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4067927,
  },
  {
    name: "Hoover",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4067994,
  },
  {
    name: "Hueytown",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4068446,
  },
  {
    name: "Huntsville",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4068590,
  },
  {
    name: "Madison",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4074267,
  },
  {
    name: "Millbrook",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4076239,
  },
  {
    name: "Mobile",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4076598,
  },
  {
    name: "Montgomery",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4076784,
  },
  {
    name: "Mountain Brook",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4078646,
  },
  {
    name: "Northport",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4080555,
  },
  {
    name: "Opelika",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4081644,
  },
  {
    name: "Oxford",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4081914,
  },
  {
    name: "Pelham",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4082569,
  },
  {
    name: "Phenix City",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4082866,
  },
  {
    name: "Prattville",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4084796,
  },
  {
    name: "Prichard",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4084888,
  },
  {
    name: "Selma",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4089114,
  },
  {
    name: "Talladega",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4092788,
  },
  {
    name: "Tillmans Corner",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4093753,
  },
  {
    name: "Troy",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4094163,
  },
  {
    name: "Trussville",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4094212,
  },
  {
    name: "Tuscaloosa",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4094455,
  },
  {
    name: "Vestavia Hills",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4095415,
  },
  {
    name: "Bella Vista",
    country: "United States",
    subcountry: "Arkansas",
    geonameid: 4101114,
  },
  {
    name: "Benton",
    country: "United States",
    subcountry: "Arkansas",
    geonameid: 4101241,
  },
  {
    name: "Bentonville",
    country: "United States",
    subcountry: "Arkansas",
    geonameid: 4101260,
  },
  {
    name: "Bryant",
    country: "United States",
    subcountry: "Arkansas",
    geonameid: 4103448,
  },
  {
    name: "Cabot",
    country: "United States",
    subcountry: "Arkansas",
    geonameid: 4103957,
  },
  {
    name: "Conway",
    country: "United States",
    subcountry: "Arkansas",
    geonameid: 4106458,
  },
  {
    name: "El Dorado",
    country: "United States",
    subcountry: "Arkansas",
    geonameid: 4109785,
  },
  {
    name: "Fayetteville",
    country: "United States",
    subcountry: "Arkansas",
    geonameid: 4110486,
  },
  {
    name: "Fort Smith",
    country: "United States",
    subcountry: "Arkansas",
    geonameid: 4111410,
  },
  {
    name: "Hot Springs",
    country: "United States",
    subcountry: "Arkansas",
    geonameid: 4115412,
  },
  {
    name: "Jacksonville",
    country: "United States",
    subcountry: "Arkansas",
    geonameid: 4116315,
  },
  {
    name: "Jonesboro",
    country: "United States",
    subcountry: "Arkansas",
    geonameid: 4116834,
  },
  {
    name: "Little Rock",
    country: "United States",
    subcountry: "Arkansas",
    geonameid: 4119403,
  },
  {
    name: "Maumelle",
    country: "United States",
    subcountry: "Arkansas",
    geonameid: 4120792,
  },
  {
    name: "North Little Rock",
    country: "United States",
    subcountry: "Arkansas",
    geonameid: 4124112,
  },
  {
    name: "Paragould",
    country: "United States",
    subcountry: "Arkansas",
    geonameid: 4125388,
  },
  {
    name: "Pine Bluff",
    country: "United States",
    subcountry: "Arkansas",
    geonameid: 4126226,
  },
  {
    name: "Rogers",
    country: "United States",
    subcountry: "Arkansas",
    geonameid: 4128894,
  },
  {
    name: "Russellville",
    country: "United States",
    subcountry: "Arkansas",
    geonameid: 4129397,
  },
  {
    name: "Searcy",
    country: "United States",
    subcountry: "Arkansas",
    geonameid: 4130430,
  },
  {
    name: "Siloam Springs",
    country: "United States",
    subcountry: "Arkansas",
    geonameid: 4131116,
  },
  {
    name: "Springdale",
    country: "United States",
    subcountry: "Arkansas",
    geonameid: 4132093,
  },
  {
    name: "Texarkana",
    country: "United States",
    subcountry: "Arkansas",
    geonameid: 4133367,
  },
  {
    name: "Van Buren",
    country: "United States",
    subcountry: "Arkansas",
    geonameid: 4134716,
  },
  {
    name: "West Memphis",
    country: "United States",
    subcountry: "Arkansas",
    geonameid: 4135865,
  },
  {
    name: "Adams Morgan",
    country: "United States",
    subcountry: "Washington, D.C.",
    geonameid: 4137457,
  },
  {
    name: "Shaw",
    country: "United States",
    subcountry: "Washington, D.C.",
    geonameid: 4140463,
  },
  {
    name: "Washington",
    country: "United States",
    subcountry: "Washington, D.C.",
    geonameid: 4140963,
  },
  {
    name: "Bear",
    country: "United States",
    subcountry: "Delaware",
    geonameid: 4141363,
  },
  {
    name: "Dover",
    country: "United States",
    subcountry: "Delaware",
    geonameid: 4142290,
  },
  {
    name: "Middletown",
    country: "United States",
    subcountry: "Delaware",
    geonameid: 4143637,
  },
  {
    name: "Newark",
    country: "United States",
    subcountry: "Delaware",
    geonameid: 4143861,
  },
  {
    name: "Wilmington",
    country: "United States",
    subcountry: "Delaware",
    geonameid: 4145381,
  },
  {
    name: "Allapattah",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4145805,
  },
  {
    name: "Altamonte Springs",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4145941,
  },
  {
    name: "Apopka",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4146166,
  },
  {
    name: "Auburndale",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4146389,
  },
  {
    name: "Aventura",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4146429,
  },
  {
    name: "Bartow",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4146723,
  },
  {
    name: "Bayonet Point",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4146901,
  },
  {
    name: "Bayshore Gardens",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4146934,
  },
  {
    name: "Belle Glade",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4147241,
  },
  {
    name: "Bellview",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4147290,
  },
  {
    name: "Bloomingdale",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4148207,
  },
  {
    name: "Boca Del Mar",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4148399,
  },
  {
    name: "Boca Raton",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4148411,
  },
  {
    name: "Bonita Springs",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4148533,
  },
  {
    name: "Boynton Beach",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4148677,
  },
  {
    name: "Bradenton",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4148708,
  },
  {
    name: "Brandon",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4148757,
  },
  {
    name: "Brent",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4148803,
  },
  {
    name: "Brownsville",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4149077,
  },
  {
    name: "Buenaventura Lakes",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4149269,
  },
  {
    name: "Cantonment",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4149956,
  },
  {
    name: "Cape Coral",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4149962,
  },
  {
    name: "Carol City",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4150066,
  },
  {
    name: "Carrollwood",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4150115,
  },
  {
    name: "Carrollwood Village",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4150118,
  },
  {
    name: "Casselberry",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4150190,
  },
  {
    name: "Citrus Park",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4151157,
  },
  {
    name: "Clearwater",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4151316,
  },
  {
    name: "Clermont",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4151352,
  },
  {
    name: "Cocoa",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4151440,
  },
  {
    name: "Coconut Creek",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4151455,
  },
  {
    name: "Coconut Grove",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4151460,
  },
  {
    name: "Cooper City",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4151824,
  },
  {
    name: "Coral Gables",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4151871,
  },
  {
    name: "Coral Springs",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4151909,
  },
  {
    name: "Coral Terrace",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4151921,
  },
  {
    name: "Country Walk",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4152064,
  },
  {
    name: "Country Club",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4152093,
  },
  {
    name: "Crestview",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4152311,
  },
  {
    name: "Cutler",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4152564,
  },
  {
    name: "Cutler Ridge",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4152574,
  },
  {
    name: "Dania Beach",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4152772,
  },
  {
    name: "Davie",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4152820,
  },
  {
    name: "Daytona Beach",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4152872,
  },
  {
    name: "DeLand",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4152890,
  },
  {
    name: "DeBary",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4152926,
  },
  {
    name: "Deerfield Beach",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4153071,
  },
  {
    name: "Delray Beach",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4153132,
  },
  {
    name: "Deltona",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4153146,
  },
  {
    name: "Doral",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4153471,
  },
  {
    name: "Dunedin",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4153759,
  },
  {
    name: "East Lake",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4154008,
  },
  {
    name: "East Naples",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4154031,
  },
  {
    name: "East Pensacola Heights",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4154047,
  },
  {
    name: "Edgewater",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4154205,
  },
  {
    name: "Egypt Lake-Leto",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4154280,
  },
  {
    name: "Ensley",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4154489,
  },
  {
    name: "Estero",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4154568,
  },
  {
    name: "Eustis",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4154606,
  },
  {
    name: "Ferry Pass",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4155017,
  },
  {
    name: "Flagami",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4155529,
  },
  {
    name: "Fleming Island",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4155594,
  },
  {
    name: "Florida Ridge",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4155726,
  },
  {
    name: "Fort Lauderdale",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4155966,
  },
  {
    name: "Fort Myers",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4155995,
  },
  {
    name: "Fort Pierce",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4156018,
  },
  {
    name: "Fort Walton Beach",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4156042,
  },
  {
    name: "Fountainebleau",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4156091,
  },
  {
    name: "Fruit Cove",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4156331,
  },
  {
    name: "Gainesville",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4156404,
  },
  {
    name: "Glenvar Heights",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4156857,
  },
  {
    name: "Golden Gate",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4156920,
  },
  {
    name: "Golden Glades",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4156931,
  },
  {
    name: "Greenacres City",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4157467,
  },
  {
    name: "Haines City",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4157827,
  },
  {
    name: "Hallandale Beach",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4157898,
  },
  {
    name: "Hialeah",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4158476,
  },
  {
    name: "Hialeah Gardens",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4158482,
  },
  {
    name: "Holiday",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4158865,
  },
  {
    name: "Hollywood",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4158928,
  },
  {
    name: "Homestead",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4159050,
  },
  {
    name: "Immokalee",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4159553,
  },
  {
    name: "Iona",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4159805,
  },
  {
    name: "Ives Estates",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4159896,
  },
  {
    name: "Jacksonville",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4160021,
  },
  {
    name: "Jacksonville Beach",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4160023,
  },
  {
    name: "Jasmine Estates",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4160100,
  },
  {
    name: "Jupiter",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4160610,
  },
  {
    name: "Kendale Lakes",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4160705,
  },
  {
    name: "Kendall",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4160711,
  },
  {
    name: "Key West",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4160812,
  },
  {
    name: "Keystone",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4160822,
  },
  {
    name: "Kissimmee",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4160983,
  },
  {
    name: "Lake Butler",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4161178,
  },
  {
    name: "Lake Magdalene",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4161313,
  },
  {
    name: "Lake Mary",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4161373,
  },
  {
    name: "Lake Wales",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4161400,
  },
  {
    name: "Lake Worth",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4161422,
  },
  {
    name: "Lake Worth Corridor",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4161424,
  },
  {
    name: "Lakeland",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4161438,
  },
  {
    name: "Lakeside",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4161461,
  },
  {
    name: "Land O' Lakes",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4161534,
  },
  {
    name: "Largo",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4161580,
  },
  {
    name: "Lauderdale Lakes",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4161616,
  },
  {
    name: "Lauderhill",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4161625,
  },
  {
    name: "Lealman",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4161705,
  },
  {
    name: "Leesburg",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4161771,
  },
  {
    name: "Lehigh Acres",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4161785,
  },
  {
    name: "Leisure City",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4161797,
  },
  {
    name: "Lutz",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4163033,
  },
  {
    name: "Lynn Haven",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4163049,
  },
  {
    name: "Maitland",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4163220,
  },
  {
    name: "Marco Island",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4163388,
  },
  {
    name: "Margate",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4163407,
  },
  {
    name: "Meadow Woods",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4163918,
  },
  {
    name: "Melbourne",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4163971,
  },
  {
    name: "Merritt Island",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4164092,
  },
  {
    name: "Miami",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4164138,
  },
  {
    name: "Miami Beach",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4164143,
  },
  {
    name: "Miami Gardens",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4164167,
  },
  {
    name: "Miami Lakes",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4164186,
  },
  {
    name: "Miramar",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4164601,
  },
  {
    name: "Myrtle Grove",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4165519,
  },
  {
    name: "Naples",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4165565,
  },
  {
    name: "Navarre",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4165637,
  },
  {
    name: "New Port Richey",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4165869,
  },
  {
    name: "New Smyrna Beach",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4165913,
  },
  {
    name: "Norland",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4166066,
  },
  {
    name: "North Fort Myers",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4166195,
  },
  {
    name: "North Lauderdale",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4166222,
  },
  {
    name: "North Miami",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4166232,
  },
  {
    name: "North Miami Beach",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4166233,
  },
  {
    name: "North Port",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4166274,
  },
  {
    name: "Oak Ridge",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4166583,
  },
  {
    name: "Oakland Park",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4166638,
  },
  {
    name: "Ocala",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4166673,
  },
  {
    name: "Ocoee",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4166776,
  },
  {
    name: "Ojus",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4166805,
  },
  {
    name: "Opa-locka",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4167003,
  },
  {
    name: "Orlando",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4167147,
  },
  {
    name: "Ormond Beach",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4167178,
  },
  {
    name: "Oviedo",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4167348,
  },
  {
    name: "Pace",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4167424,
  },
  {
    name: "Palm Bay",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4167499,
  },
  {
    name: "Palm Beach Gardens",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4167519,
  },
  {
    name: "Palm City",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4167536,
  },
  {
    name: "Palm Coast",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4167538,
  },
  {
    name: "Palm Harbor",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4167545,
  },
  {
    name: "Palm Springs",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4167583,
  },
  {
    name: "Palm Valley",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4167601,
  },
  {
    name: "Palmetto Bay",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4167634,
  },
  {
    name: "Panama City",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4167694,
  },
  {
    name: "Parkland",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4167829,
  },
  {
    name: "Pembroke Pines",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4168139,
  },
  {
    name: "Pensacola",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4168228,
  },
  {
    name: "Pine Hills",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4168459,
  },
  {
    name: "Pinecrest",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4168590,
  },
  {
    name: "Pinellas Park",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4168630,
  },
  {
    name: "Pinewood",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4168659,
  },
  {
    name: "Plant City",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4168773,
  },
  {
    name: "Plantation",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4168782,
  },
  {
    name: "Poinciana",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4168930,
  },
  {
    name: "Pompano Beach",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4169014,
  },
  {
    name: "Ponte Vedra Beach",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4169060,
  },
  {
    name: "Port Charlotte",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4169130,
  },
  {
    name: "Port Orange",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4169156,
  },
  {
    name: "Port Saint Lucie",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4169171,
  },
  {
    name: "Princeton",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4169345,
  },
  {
    name: "Punta Gorda",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4169452,
  },
  {
    name: "Punta Gorda Isles",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4169455,
  },
  {
    name: "Richmond West",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4170005,
  },
  {
    name: "Riverview",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4170156,
  },
  {
    name: "Riviera Beach",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4170174,
  },
  {
    name: "Rockledge",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4170358,
  },
  {
    name: "Royal Palm Beach",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4170617,
  },
  {
    name: "Ruskin",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4170688,
  },
  {
    name: "Safety Harbor",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4170797,
  },
  {
    name: "Saint Cloud",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4170965,
  },
  {
    name: "St. Petersburg",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4171563,
  },
  {
    name: "San Carlos Park",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4171782,
  },
  {
    name: "Sanford",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4172086,
  },
  {
    name: "Santa Rosa Beach",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4172094,
  },
  {
    name: "Sarasota",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4172131,
  },
  {
    name: "Sebastian",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4172372,
  },
  {
    name: "Seminole",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4172434,
  },
  {
    name: "South Bradenton",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4173392,
  },
  {
    name: "South Miami Heights",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4173497,
  },
  {
    name: "Southchase",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4173600,
  },
  {
    name: "Spring Hill",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4173838,
  },
  {
    name: "Stuart",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4174201,
  },
  {
    name: "Sun City Center",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4174317,
  },
  {
    name: "Sunny Isles Beach",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4174383,
  },
  {
    name: "Sunrise",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4174402,
  },
  {
    name: "Sunset",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4174425,
  },
  {
    name: "Sweetwater",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4174600,
  },
  {
    name: "Tallahassee",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4174715,
  },
  {
    name: "Tamarac",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4174738,
  },
  {
    name: "Tamiami",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4174744,
  },
  {
    name: "Tampa",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4174757,
  },
  {
    name: "Tarpon Springs",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4174855,
  },
  {
    name: "Tavares",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4174861,
  },
  {
    name: "Temple Terrace",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4174969,
  },
  {
    name: "The Crossings",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4175091,
  },
  {
    name: "The Hammocks",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4175117,
  },
  {
    name: "The Villages",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4175179,
  },
  {
    name: "Three Lakes",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4175296,
  },
  {
    name: "Titusville",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4175437,
  },
  {
    name: "Town 'n' Country",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4175538,
  },
  {
    name: "University Park",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4176217,
  },
  {
    name: "Valrico",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4176318,
  },
  {
    name: "Venice",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4176380,
  },
  {
    name: "Vero Beach",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4176409,
  },
  {
    name: "Wekiwa Springs",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4177671,
  },
  {
    name: "Wellington",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4177703,
  },
  {
    name: "Wesley Chapel",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4177727,
  },
  {
    name: "Westchase",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4177779,
  },
  {
    name: "West Hollywood",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4177834,
  },
  {
    name: "West Little River",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4177865,
  },
  {
    name: "West Melbourne",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4177872,
  },
  {
    name: "West Palm Beach",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4177887,
  },
  {
    name: "West Park",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4177897,
  },
  {
    name: "West Pensacola",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4177908,
  },
  {
    name: "West and East Lealman",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4177960,
  },
  {
    name: "Westchester",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4177965,
  },
  {
    name: "Weston",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4178003,
  },
  {
    name: "Winter Garden",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4178550,
  },
  {
    name: "Winter Haven",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4178552,
  },
  {
    name: "Winter Park",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4178560,
  },
  {
    name: "Winter Springs",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4178573,
  },
  {
    name: "Wright",
    country: "United States",
    subcountry: "Florida",
    geonameid: 4178775,
  },
  {
    name: "Acworth",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4179074,
  },
  {
    name: "Albany",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4179320,
  },
  {
    name: "Alpharetta",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4179574,
  },
  {
    name: "Americus",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4179667,
  },
  {
    name: "Athens",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4180386,
  },
  {
    name: "Atlanta",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4180439,
  },
  {
    name: "Augusta",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4180531,
  },
  {
    name: "Belvedere Park",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4181936,
  },
  {
    name: "Brookhaven",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4184530,
  },
  {
    name: "Brunswick",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4184845,
  },
  {
    name: "Calhoun",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4185657,
  },
  {
    name: "Canton",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4186213,
  },
  {
    name: "Carrollton",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4186416,
  },
  {
    name: "Cartersville",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4186531,
  },
  {
    name: "Chamblee",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4187204,
  },
  {
    name: "Columbus",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4188985,
  },
  {
    name: "Conyers",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4189213,
  },
  {
    name: "Dalton",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4190581,
  },
  {
    name: "Decatur",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4191124,
  },
  {
    name: "Douglasville",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4191955,
  },
  {
    name: "Dublin",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4192205,
  },
  {
    name: "Duluth",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4192289,
  },
  {
    name: "Dunwoody",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4192375,
  },
  {
    name: "East Point",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4192674,
  },
  {
    name: "Evans",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4193699,
  },
  {
    name: "Fayetteville",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4194474,
  },
  {
    name: "Forest Park",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4195701,
  },
  {
    name: "Gainesville",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4196586,
  },
  {
    name: "Griffin",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4198322,
  },
  {
    name: "Hinesville",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4200671,
  },
  {
    name: "Kennesaw",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4203696,
  },
  {
    name: "Kingsland",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4204007,
  },
  {
    name: "LaGrange",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4204230,
  },
  {
    name: "Lawrenceville",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4205196,
  },
  {
    name: "Lithia Springs",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4205885,
  },
  {
    name: "Mableton",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4207226,
  },
  {
    name: "Macon",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4207400,
  },
  {
    name: "Marietta",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4207783,
  },
  {
    name: "Martinez",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4207981,
  },
  {
    name: "McDonough",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4208442,
  },
  {
    name: "Milledgeville",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4209448,
  },
  {
    name: "Newnan",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4212684,
  },
  {
    name: "Norcross",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4212888,
  },
  {
    name: "North Atlanta",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4212937,
  },
  {
    name: "North Decatur",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4212992,
  },
  {
    name: "North Druid Hills",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4212995,
  },
  {
    name: "Peachtree City",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4215110,
  },
  {
    name: "Peachtree Corners",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4215114,
  },
  {
    name: "Perry",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4215391,
  },
  {
    name: "Pooler",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4216948,
  },
  {
    name: "Redan",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4218165,
  },
  {
    name: "Riverdale",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4219001,
  },
  {
    name: "Rome",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4219762,
  },
  {
    name: "Roswell",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4219934,
  },
  {
    name: "St. Marys",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4220629,
  },
  {
    name: "Sandy Springs",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4221333,
  },
  {
    name: "Savannah",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4221552,
  },
  {
    name: "Smyrna",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4223379,
  },
  {
    name: "Snellville",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4223413,
  },
  {
    name: "Statesboro",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4224413,
  },
  {
    name: "Stockbridge",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4224681,
  },
  {
    name: "Sugar Hill",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4225039,
  },
  {
    name: "Suwanee",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4225309,
  },
  {
    name: "Thomasville",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4226348,
  },
  {
    name: "Tifton",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4226552,
  },
  {
    name: "Tucker",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4227213,
  },
  {
    name: "Union City",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4227777,
  },
  {
    name: "Valdosta",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4228147,
  },
  {
    name: "Warner Robins",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4229476,
  },
  {
    name: "Wilmington Island",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4231354,
  },
  {
    name: "Winder",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4231523,
  },
  {
    name: "Woodstock",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 4231874,
  },
  {
    name: "Alton",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4232679,
  },
  {
    name: "Belleville",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4233813,
  },
  {
    name: "Carbondale",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4235193,
  },
  {
    name: "Charleston",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4235668,
  },
  {
    name: "Collinsville",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4236191,
  },
  {
    name: "Decatur",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4236895,
  },
  {
    name: "East Saint Louis",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4237579,
  },
  {
    name: "Edwardsville",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4237717,
  },
  {
    name: "Fairview Heights",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4238132,
  },
  {
    name: "Godfrey",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4239509,
  },
  {
    name: "Granite City",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4239714,
  },
  {
    name: "Jacksonville",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4241704,
  },
  {
    name: "Marion",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4243899,
  },
  {
    name: "Mattoon",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4244099,
  },
  {
    name: "Mount Vernon",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4245152,
  },
  {
    name: "O'Fallon",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4245926,
  },
  {
    name: "Quincy",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4247703,
  },
  {
    name: "Springfield",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4250542,
  },
  {
    name: "Upper Alton",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4251841,
  },
  {
    name: "Avon",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4254021,
  },
  {
    name: "Bloomington",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4254679,
  },
  {
    name: "Broad Ripple",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4254957,
  },
  {
    name: "Brownsburg",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4255056,
  },
  {
    name: "Carmel",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4255466,
  },
  {
    name: "Clarksville",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4255836,
  },
  {
    name: "Columbus",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4256038,
  },
  {
    name: "Evansville",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4257227,
  },
  {
    name: "Fishers",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4257494,
  },
  {
    name: "Greenfield",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4258285,
  },
  {
    name: "Greenwood",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4258313,
  },
  {
    name: "Indianapolis",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4259418,
  },
  {
    name: "Jasper",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4259640,
  },
  {
    name: "Jeffersonville",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4259671,
  },
  {
    name: "Lawrence",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4260210,
  },
  {
    name: "New Albany",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4262045,
  },
  {
    name: "New Castle",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4262072,
  },
  {
    name: "Plainfield",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4263108,
  },
  {
    name: "Richmond",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4263681,
  },
  {
    name: "Seymour",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4264617,
  },
  {
    name: "Shelbyville",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4264688,
  },
  {
    name: "Terre Haute",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4265737,
  },
  {
    name: "Vincennes",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4266307,
  },
  {
    name: "Zionsville",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4267336,
  },
  {
    name: "Derby",
    country: "United States",
    subcountry: "Kansas",
    geonameid: 4270356,
  },
  {
    name: "Emporia",
    country: "United States",
    subcountry: "Kansas",
    geonameid: 4271086,
  },
  {
    name: "Gardner",
    country: "United States",
    subcountry: "Kansas",
    geonameid: 4271935,
  },
  {
    name: "Great Bend",
    country: "United States",
    subcountry: "Kansas",
    geonameid: 4272340,
  },
  {
    name: "Hays",
    country: "United States",
    subcountry: "Kansas",
    geonameid: 4272782,
  },
  {
    name: "Hutchinson",
    country: "United States",
    subcountry: "Kansas",
    geonameid: 4273299,
  },
  {
    name: "Junction City",
    country: "United States",
    subcountry: "Kansas",
    geonameid: 4273680,
  },
  {
    name: "Kansas City",
    country: "United States",
    subcountry: "Kansas",
    geonameid: 4273837,
  },
  {
    name: "Lawrence",
    country: "United States",
    subcountry: "Kansas",
    geonameid: 4274277,
  },
  {
    name: "Leavenworth",
    country: "United States",
    subcountry: "Kansas",
    geonameid: 4274305,
  },
  {
    name: "Leawood",
    country: "United States",
    subcountry: "Kansas",
    geonameid: 4274317,
  },
  {
    name: "Lenexa",
    country: "United States",
    subcountry: "Kansas",
    geonameid: 4274356,
  },
  {
    name: "Manhattan",
    country: "United States",
    subcountry: "Kansas",
    geonameid: 4274994,
  },
  {
    name: "Newton",
    country: "United States",
    subcountry: "Kansas",
    geonameid: 4276248,
  },
  {
    name: "Olathe",
    country: "United States",
    subcountry: "Kansas",
    geonameid: 4276614,
  },
  {
    name: "Overland Park",
    country: "United States",
    subcountry: "Kansas",
    geonameid: 4276873,
  },
  {
    name: "Pittsburg",
    country: "United States",
    subcountry: "Kansas",
    geonameid: 4277241,
  },
  {
    name: "Prairie Village",
    country: "United States",
    subcountry: "Kansas",
    geonameid: 4277718,
  },
  {
    name: "Salina",
    country: "United States",
    subcountry: "Kansas",
    geonameid: 4278890,
  },
  {
    name: "Shawnee",
    country: "United States",
    subcountry: "Kansas",
    geonameid: 4279247,
  },
  {
    name: "Topeka",
    country: "United States",
    subcountry: "Kansas",
    geonameid: 4280539,
  },
  {
    name: "Wichita",
    country: "United States",
    subcountry: "Kansas",
    geonameid: 4281730,
  },
  {
    name: "Ashland",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4282757,
  },
  {
    name: "Bowling Green",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4285268,
  },
  {
    name: "Burlington",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4286281,
  },
  {
    name: "Covington",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4288809,
  },
  {
    name: "Danville",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4289445,
  },
  {
    name: "Elizabethtown",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4290988,
  },
  {
    name: "Erlanger",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4291255,
  },
  {
    name: "Fern Creek",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4291620,
  },
  {
    name: "Florence",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4291945,
  },
  {
    name: "Fort Thomas",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4292071,
  },
  {
    name: "Frankfort",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4292188,
  },
  {
    name: "Georgetown",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4292686,
  },
  {
    name: "Henderson",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4294494,
  },
  {
    name: "Highview",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4294799,
  },
  {
    name: "Hopkinsville",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4295251,
  },
  {
    name: "Independence",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4295776,
  },
  {
    name: "Ironville",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4295940,
  },
  {
    name: "Jeffersontown",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4296218,
  },
  {
    name: "Lexington",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4297983,
  },
  {
    name: "Lexington-Fayette",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4297999,
  },
  {
    name: "Louisville",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4299276,
  },
  {
    name: "Madisonville",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4299670,
  },
  {
    name: "Meads",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4300488,
  },
  {
    name: "Murray",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4302035,
  },
  {
    name: "Newburg",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4302504,
  },
  {
    name: "Newport",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4302529,
  },
  {
    name: "Nicholasville",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4302561,
  },
  {
    name: "Okolona",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4303012,
  },
  {
    name: "Owensboro",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4303436,
  },
  {
    name: "Pleasure Ridge Park",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4304713,
  },
  {
    name: "Radcliff",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4305504,
  },
  {
    name: "Richmond",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4305974,
  },
  {
    name: "Saint Matthews",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4307238,
  },
  {
    name: "Shelbyville",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4308122,
  },
  {
    name: "Shively",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4308225,
  },
  {
    name: "Valley Station",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4311963,
  },
  {
    name: "Winchester",
    country: "United States",
    subcountry: "Kentucky",
    geonameid: 4313697,
  },
  {
    name: "Alexandria",
    country: "United States",
    subcountry: "Louisiana",
    geonameid: 4314550,
  },
  {
    name: "Baton Rouge",
    country: "United States",
    subcountry: "Louisiana",
    geonameid: 4315588,
  },
  {
    name: "Bayou Cane",
    country: "United States",
    subcountry: "Louisiana",
    geonameid: 4315768,
  },
  {
    name: "Bossier City",
    country: "United States",
    subcountry: "Louisiana",
    geonameid: 4317639,
  },
  {
    name: "Central",
    country: "United States",
    subcountry: "Louisiana",
    geonameid: 4319435,
  },
  {
    name: "Chalmette",
    country: "United States",
    subcountry: "Louisiana",
    geonameid: 4319518,
  },
  {
    name: "Estelle",
    country: "United States",
    subcountry: "Louisiana",
    geonameid: 4323873,
  },
  {
    name: "Gretna",
    country: "United States",
    subcountry: "Louisiana",
    geonameid: 4326575,
  },
  {
    name: "Hammond",
    country: "United States",
    subcountry: "Louisiana",
    geonameid: 4326868,
  },
  {
    name: "Harvey",
    country: "United States",
    subcountry: "Louisiana",
    geonameid: 4327047,
  },
  {
    name: "Houma",
    country: "United States",
    subcountry: "Louisiana",
    geonameid: 4328010,
  },
  {
    name: "Kenner",
    country: "United States",
    subcountry: "Louisiana",
    geonameid: 4329753,
  },
  {
    name: "Lafayette",
    country: "United States",
    subcountry: "Louisiana",
    geonameid: 4330145,
  },
  {
    name: "Lake Charles",
    country: "United States",
    subcountry: "Louisiana",
    geonameid: 4330236,
  },
  {
    name: "Laplace",
    country: "United States",
    subcountry: "Louisiana",
    geonameid: 4330525,
  },
  {
    name: "Marrero",
    country: "United States",
    subcountry: "Louisiana",
    geonameid: 4332628,
  },
  {
    name: "Metairie",
    country: "United States",
    subcountry: "Louisiana",
    geonameid: 4333177,
  },
  {
    name: "Metairie Terrace",
    country: "United States",
    subcountry: "Louisiana",
    geonameid: 4333190,
  },
  {
    name: "Monroe",
    country: "United States",
    subcountry: "Louisiana",
    geonameid: 4333669,
  },
  {
    name: "Natchitoches",
    country: "United States",
    subcountry: "Louisiana",
    geonameid: 4334720,
  },
  {
    name: "New Iberia",
    country: "United States",
    subcountry: "Louisiana",
    geonameid: 4334971,
  },
  {
    name: "New Orleans",
    country: "United States",
    subcountry: "Louisiana",
    geonameid: 4335045,
  },
  {
    name: "Opelousas",
    country: "United States",
    subcountry: "Louisiana",
    geonameid: 4336153,
  },
  {
    name: "Prairieville",
    country: "United States",
    subcountry: "Louisiana",
    geonameid: 4338012,
  },
  {
    name: "Ruston",
    country: "United States",
    subcountry: "Louisiana",
    geonameid: 4339348,
  },
  {
    name: "Shenandoah",
    country: "United States",
    subcountry: "Louisiana",
    geonameid: 4341378,
  },
  {
    name: "Shreveport",
    country: "United States",
    subcountry: "Louisiana",
    geonameid: 4341513,
  },
  {
    name: "Slidell",
    country: "United States",
    subcountry: "Louisiana",
    geonameid: 4341727,
  },
  {
    name: "Sulphur",
    country: "United States",
    subcountry: "Louisiana",
    geonameid: 4342816,
  },
  {
    name: "Terrytown",
    country: "United States",
    subcountry: "Louisiana",
    geonameid: 4343327,
  },
  {
    name: "Zachary",
    country: "United States",
    subcountry: "Louisiana",
    geonameid: 4346788,
  },
  {
    name: "Aberdeen",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4346913,
  },
  {
    name: "Adelphi",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4346991,
  },
  {
    name: "Annapolis",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4347242,
  },
  {
    name: "Arbutus",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4347371,
  },
  {
    name: "Arnold",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4347426,
  },
  {
    name: "Aspen Hill",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4347553,
  },
  {
    name: "Baltimore",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4347778,
  },
  {
    name: "Ballenger Creek",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4347839,
  },
  {
    name: "Beltsville",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4348353,
  },
  {
    name: "Bethesda",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4348599,
  },
  {
    name: "Bowie",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4349159,
  },
  {
    name: "Calverton",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4350160,
  },
  {
    name: "Camp Springs",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4350288,
  },
  {
    name: "Carney",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4350413,
  },
  {
    name: "Catonsville",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4350635,
  },
  {
    name: "Chillum",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4351383,
  },
  {
    name: "Cloverly",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4351851,
  },
  {
    name: "Clinton",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4351871,
  },
  {
    name: "Cockeysville",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4351887,
  },
  {
    name: "College Park",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4351977,
  },
  {
    name: "Columbia",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4352053,
  },
  {
    name: "Crofton",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4352539,
  },
  {
    name: "Cumberland",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4352681,
  },
  {
    name: "Damascus",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4352728,
  },
  {
    name: "Dundalk",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4353765,
  },
  {
    name: "East Riverdale",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4353925,
  },
  {
    name: "Easton",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4353962,
  },
  {
    name: "Edgewood",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4354087,
  },
  {
    name: "Eldersburg",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4354163,
  },
  {
    name: "Elkton",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4354234,
  },
  {
    name: "Elkridge",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4354256,
  },
  {
    name: "Ellicott City",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4354265,
  },
  {
    name: "Essex",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4354428,
  },
  {
    name: "Fairland",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4354573,
  },
  {
    name: "Ferndale",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4354821,
  },
  {
    name: "Fort Washington",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4355355,
  },
  {
    name: "Frederick",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4355585,
  },
  {
    name: "Gaithersburg",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4355843,
  },
  {
    name: "Germantown",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4356050,
  },
  {
    name: "Glassmanor",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4356165,
  },
  {
    name: "Glen Burnie",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4356188,
  },
  {
    name: "Green Haven",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4356783,
  },
  {
    name: "Greenbelt",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4356847,
  },
  {
    name: "Gwynn Oak",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4357116,
  },
  {
    name: "Hagerstown",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4357141,
  },
  {
    name: "Hanover",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4357340,
  },
  {
    name: "Hillcrest Heights",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4358082,
  },
  {
    name: "Hunt Valley",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4358701,
  },
  {
    name: "Hyattsville",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4358821,
  },
  {
    name: "Ilchester",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4358864,
  },
  {
    name: "Lake Shore",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4360201,
  },
  {
    name: "Landover",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4360287,
  },
  {
    name: "Langley Park",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4360314,
  },
  {
    name: "Laurel",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4360369,
  },
  {
    name: "Lochearn",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4360954,
  },
  {
    name: "Maryland City",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4361831,
  },
  {
    name: "Middle River",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4362344,
  },
  {
    name: "Milford Mill",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4362438,
  },
  {
    name: "Montgomery Village",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4362743,
  },
  {
    name: "North Bel Air",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4363836,
  },
  {
    name: "North Bethesda",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4363843,
  },
  {
    name: "North Potomac",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4363990,
  },
  {
    name: "Odenton",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4364362,
  },
  {
    name: "Olney",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4364537,
  },
  {
    name: "Owings Mills",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4364727,
  },
  {
    name: "Oxon Hill",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4364759,
  },
  {
    name: "Parkville",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4364946,
  },
  {
    name: "Parole",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4364964,
  },
  {
    name: "Pasadena",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4364990,
  },
  {
    name: "Perry Hall",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4365227,
  },
  {
    name: "Pikesville",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4365387,
  },
  {
    name: "Potomac",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4366001,
  },
  {
    name: "Randallstown",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4366476,
  },
  {
    name: "Redland",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4366593,
  },
  {
    name: "Reisterstown",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4366647,
  },
  {
    name: "Rockville",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4367175,
  },
  {
    name: "Rosedale",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4367372,
  },
  {
    name: "Rossville",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4367419,
  },
  {
    name: "Saint Charles",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4367734,
  },
  {
    name: "Salisbury",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4368711,
  },
  {
    name: "Scaggsville",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4368918,
  },
  {
    name: "Seabrook",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4369076,
  },
  {
    name: "Severn",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4369190,
  },
  {
    name: "Severna Park",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4369224,
  },
  {
    name: "Silver Spring",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4369596,
  },
  {
    name: "South Bel Air",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4369928,
  },
  {
    name: "South Gate",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4369964,
  },
  {
    name: "South Laurel",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4369978,
  },
  {
    name: "Suitland",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4370616,
  },
  {
    name: "Takoma Park",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4370890,
  },
  {
    name: "Towson",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4371582,
  },
  {
    name: "Waldorf",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4372599,
  },
  {
    name: "West Elkridge",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4373104,
  },
  {
    name: "Westminster",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4373238,
  },
  {
    name: "Wheaton",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4373349,
  },
  {
    name: "White Oak",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4373449,
  },
  {
    name: "Woodlawn",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 4374054,
  },
  {
    name: "Affton",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4374513,
  },
  {
    name: "Arnold",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4375087,
  },
  {
    name: "Ballwin",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4375663,
  },
  {
    name: "Belton",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4376482,
  },
  {
    name: "Blue Springs",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4377664,
  },
  {
    name: "Cape Girardeau",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4379966,
  },
  {
    name: "Chesterfield",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4381072,
  },
  {
    name: "Clayton",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4381478,
  },
  {
    name: "Columbia",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4381982,
  },
  {
    name: "Concord",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4382072,
  },
  {
    name: "Creve Coeur",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4382837,
  },
  {
    name: "East Independence",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4385018,
  },
  {
    name: "Farmington",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4386289,
  },
  {
    name: "Ferguson",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4386387,
  },
  {
    name: "Florissant",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4386802,
  },
  {
    name: "Gladstone",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4387990,
  },
  {
    name: "Grandview",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4388460,
  },
  {
    name: "Hannibal",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4389418,
  },
  {
    name: "Hazelwood",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4389967,
  },
  {
    name: "Independence",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4391812,
  },
  {
    name: "Jefferson City",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4392388,
  },
  {
    name: "Joplin",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4392768,
  },
  {
    name: "Kansas City",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4393217,
  },
  {
    name: "Kirkwood",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4393739,
  },
  {
    name: "Lee's Summit",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4394870,
  },
  {
    name: "Lemay",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4394905,
  },
  {
    name: "Liberty",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4395052,
  },
  {
    name: "Manchester",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4396915,
  },
  {
    name: "Maryland Heights",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4397340,
  },
  {
    name: "Mehlville",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4397962,
  },
  {
    name: "Nixa",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4400648,
  },
  {
    name: "O'Fallon",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4401242,
  },
  {
    name: "Oakville",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4401618,
  },
  {
    name: "Overland",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4402178,
  },
  {
    name: "Ozark",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4402245,
  },
  {
    name: "Poplar Bluff",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4404233,
  },
  {
    name: "Raymore",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4405180,
  },
  {
    name: "Raytown",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4405188,
  },
  {
    name: "Republic",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4405434,
  },
  {
    name: "Rolla",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4406282,
  },
  {
    name: "Saint Charles",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4406831,
  },
  {
    name: "Saint Joseph",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4407010,
  },
  {
    name: "St. Louis",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4407066,
  },
  {
    name: "Saint Peters",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4407237,
  },
  {
    name: "Sedalia",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4408000,
  },
  {
    name: "Sikeston",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4408672,
  },
  {
    name: "Spanish Lake",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4409591,
  },
  {
    name: "Springfield",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4409896,
  },
  {
    name: "University City",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4412697,
  },
  {
    name: "Warrensburg",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4413595,
  },
  {
    name: "Webster Groves",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4413872,
  },
  {
    name: "Wentzville",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4414001,
  },
  {
    name: "Wildwood",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 4414749,
  },
  {
    name: "Biloxi",
    country: "United States",
    subcountry: "Mississippi",
    geonameid: 4418478,
  },
  {
    name: "Brandon",
    country: "United States",
    subcountry: "Mississippi",
    geonameid: 4419290,
  },
  {
    name: "Clarksdale",
    country: "United States",
    subcountry: "Mississippi",
    geonameid: 4421935,
  },
  {
    name: "Clinton",
    country: "United States",
    subcountry: "Mississippi",
    geonameid: 4422133,
  },
  {
    name: "Columbus",
    country: "United States",
    subcountry: "Mississippi",
    geonameid: 4422442,
  },
  {
    name: "Gautier",
    country: "United States",
    subcountry: "Mississippi",
    geonameid: 4427569,
  },
  {
    name: "Greenville",
    country: "United States",
    subcountry: "Mississippi",
    geonameid: 4428475,
  },
  {
    name: "Greenwood",
    country: "United States",
    subcountry: "Mississippi",
    geonameid: 4428495,
  },
  {
    name: "Gulfport",
    country: "United States",
    subcountry: "Mississippi",
    geonameid: 4428667,
  },
  {
    name: "Hattiesburg",
    country: "United States",
    subcountry: "Mississippi",
    geonameid: 4429295,
  },
  {
    name: "Hernando",
    country: "United States",
    subcountry: "Mississippi",
    geonameid: 4429589,
  },
  {
    name: "Horn Lake",
    country: "United States",
    subcountry: "Mississippi",
    geonameid: 4430400,
  },
  {
    name: "Jackson",
    country: "United States",
    subcountry: "Mississippi",
    geonameid: 4431410,
  },
  {
    name: "Laurel",
    country: "United States",
    subcountry: "Mississippi",
    geonameid: 4433039,
  },
  {
    name: "Long Beach",
    country: "United States",
    subcountry: "Mississippi",
    geonameid: 4434069,
  },
  {
    name: "Madison",
    country: "United States",
    subcountry: "Mississippi",
    geonameid: 4434663,
  },
  {
    name: "Meridian",
    country: "United States",
    subcountry: "Mississippi",
    geonameid: 4435764,
  },
  {
    name: "Natchez",
    country: "United States",
    subcountry: "Mississippi",
    geonameid: 4437982,
  },
  {
    name: "Ocean Springs",
    country: "United States",
    subcountry: "Mississippi",
    geonameid: 4439506,
  },
  {
    name: "Olive Branch",
    country: "United States",
    subcountry: "Mississippi",
    geonameid: 4439869,
  },
  {
    name: "Oxford",
    country: "United States",
    subcountry: "Mississippi",
    geonameid: 4440076,
  },
  {
    name: "Pascagoula",
    country: "United States",
    subcountry: "Mississippi",
    geonameid: 4440397,
  },
  {
    name: "Pearl",
    country: "United States",
    subcountry: "Mississippi",
    geonameid: 4440559,
  },
  {
    name: "Ridgeland",
    country: "United States",
    subcountry: "Mississippi",
    geonameid: 4443296,
  },
  {
    name: "Southaven",
    country: "United States",
    subcountry: "Mississippi",
    geonameid: 4446675,
  },
  {
    name: "Starkville",
    country: "United States",
    subcountry: "Mississippi",
    geonameid: 4447161,
  },
  {
    name: "Tupelo",
    country: "United States",
    subcountry: "Mississippi",
    geonameid: 4448903,
  },
  {
    name: "Vicksburg",
    country: "United States",
    subcountry: "Mississippi",
    geonameid: 4449620,
  },
  {
    name: "West Gulfport",
    country: "United States",
    subcountry: "Mississippi",
    geonameid: 4450687,
  },
  {
    name: "Albemarle",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4452303,
  },
  {
    name: "Apex",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4452808,
  },
  {
    name: "Asheboro",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4453035,
  },
  {
    name: "Asheville",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4453066,
  },
  {
    name: "Boone",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4456703,
  },
  {
    name: "Burlington",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4458228,
  },
  {
    name: "Carrboro",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4459343,
  },
  {
    name: "Cary",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4459467,
  },
  {
    name: "Chapel Hill",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4460162,
  },
  {
    name: "Charlotte",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4460243,
  },
  {
    name: "Clayton",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4460943,
  },
  {
    name: "Clemmons",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4461015,
  },
  {
    name: "Concord",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4461574,
  },
  {
    name: "Cornelius",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4461941,
  },
  {
    name: "Durham",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4464368,
  },
  {
    name: "Eden",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4464873,
  },
  {
    name: "Elizabeth City",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4465088,
  },
  {
    name: "Fayetteville",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4466033,
  },
  {
    name: "Fuquay-Varina",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4467485,
  },
  {
    name: "Garner",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4467657,
  },
  {
    name: "Gastonia",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4467732,
  },
  {
    name: "Goldsboro",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4468261,
  },
  {
    name: "Greensboro",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4469146,
  },
  {
    name: "Greenville",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4469160,
  },
  {
    name: "Havelock",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4470244,
  },
  {
    name: "Henderson",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4470566,
  },
  {
    name: "Hickory",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4470778,
  },
  {
    name: "High Point",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4471025,
  },
  {
    name: "Holly Springs",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4471641,
  },
  {
    name: "Hope Mills",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4471851,
  },
  {
    name: "Huntersville",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4472370,
  },
  {
    name: "Indian Trail",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4472687,
  },
  {
    name: "Jacksonville",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4473083,
  },
  {
    name: "Kannapolis",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4474040,
  },
  {
    name: "Kernersville",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4474221,
  },
  {
    name: "Kinston",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4474436,
  },
  {
    name: "Laurinburg",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4475347,
  },
  {
    name: "Leland",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4475622,
  },
  {
    name: "Lenoir",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4475640,
  },
  {
    name: "Lexington",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4475773,
  },
  {
    name: "Lumberton",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4477525,
  },
  {
    name: "Matthews",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4478334,
  },
  {
    name: "Mint Hill",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4479759,
  },
  {
    name: "Monroe",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4479946,
  },
  {
    name: "Mooresville",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4480125,
  },
  {
    name: "Morganton",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4480219,
  },
  {
    name: "Morrisville",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4480285,
  },
  {
    name: "New Bern",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4481682,
  },
  {
    name: "Pinehurst",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4485272,
  },
  {
    name: "Raleigh",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4487042,
  },
  {
    name: "Roanoke Rapids",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4488232,
  },
  {
    name: "Rocky Mount",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4488762,
  },
  {
    name: "Salisbury",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4489985,
  },
  {
    name: "Sanford",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4490329,
  },
  {
    name: "Shelby",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4491180,
  },
  {
    name: "Stallings",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4493186,
  },
  {
    name: "Statesville",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4493316,
  },
  {
    name: "Thomasville",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4494942,
  },
  {
    name: "Wake Forest",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4497290,
  },
  {
    name: "West Raleigh",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4498303,
  },
  {
    name: "Wilmington",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4499379,
  },
  {
    name: "Wilson",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4499389,
  },
  {
    name: "Winston-Salem",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 4499612,
  },
  {
    name: "Atlantic City",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 4500546,
  },
  {
    name: "Bayville",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 4500688,
  },
  {
    name: "Bridgeton",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 4500942,
  },
  {
    name: "Camden",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 4501018,
  },
  {
    name: "Cherry Hill",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 4501198,
  },
  {
    name: "Glassboro",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 4501931,
  },
  {
    name: "Jackson",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 4502434,
  },
  {
    name: "Lindenwold",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 4502687,
  },
  {
    name: "Maple Shade",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 4502901,
  },
  {
    name: "Millville",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 4503078,
  },
  {
    name: "Mount Laurel",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 4503136,
  },
  {
    name: "Ocean Acres",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 4503346,
  },
  {
    name: "Pennsauken",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 4503548,
  },
  {
    name: "Pleasantville",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 4503646,
  },
  {
    name: "Sewell",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 4504048,
  },
  {
    name: "Sicklerville",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 4504118,
  },
  {
    name: "South Vineland",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 4504225,
  },
  {
    name: "Toms River",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 4504476,
  },
  {
    name: "Vincentown",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 4504618,
  },
  {
    name: "Vineland",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 4504621,
  },
  {
    name: "Williamstown",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 4504871,
  },
  {
    name: "Athens",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 4505542,
  },
  {
    name: "Beavercreek",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 4506008,
  },
  {
    name: "Centerville",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 4508204,
  },
  {
    name: "Cincinnati",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 4508722,
  },
  {
    name: "Columbus",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 4509177,
  },
  {
    name: "Dayton",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 4509884,
  },
  {
    name: "Fairborn",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 4511263,
  },
  {
    name: "Fairfield",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 4511283,
  },
  {
    name: "Forest Park",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 4512060,
  },
  {
    name: "Grove City",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 4513409,
  },
  {
    name: "Hamilton",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 4513575,
  },
  {
    name: "Huber Heights",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 4514746,
  },
  {
    name: "Kettering",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 4515843,
  },
  {
    name: "Lancaster",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 4516233,
  },
  {
    name: "Lebanon",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 4516412,
  },
  {
    name: "Mason",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 4517698,
  },
  {
    name: "Miamisburg",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 4518188,
  },
  {
    name: "Middletown",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 4518264,
  },
  {
    name: "Norwood",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 4519995,
  },
  {
    name: "Oxford",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 4520760,
  },
  {
    name: "Pataskala",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 4520905,
  },
  {
    name: "Pickerington",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 4521209,
  },
  {
    name: "Portsmouth",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 4521816,
  },
  {
    name: "Reynoldsburg",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 4522411,
  },
  {
    name: "Riverside",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 4522586,
  },
  {
    name: "Springboro",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 4525304,
  },
  {
    name: "Springfield",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 4525353,
  },
  {
    name: "Trotwood",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 4526576,
  },
  {
    name: "Upper Arlington",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 4526993,
  },
  {
    name: "Vandalia",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 4527124,
  },
  {
    name: "White Oak",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 4528259,
  },
  {
    name: "Whitehall",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 4528291,
  },
  {
    name: "Xenia",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 4528810,
  },
  {
    name: "Zanesville",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 4528923,
  },
  {
    name: "Ada",
    country: "United States",
    subcountry: "Oklahoma",
    geonameid: 4529096,
  },
  {
    name: "Altus",
    country: "United States",
    subcountry: "Oklahoma",
    geonameid: 4529292,
  },
  {
    name: "Ardmore",
    country: "United States",
    subcountry: "Oklahoma",
    geonameid: 4529469,
  },
  {
    name: "Bartlesville",
    country: "United States",
    subcountry: "Oklahoma",
    geonameid: 4529987,
  },
  {
    name: "Bethany",
    country: "United States",
    subcountry: "Oklahoma",
    geonameid: 4530372,
  },
  {
    name: "Bixby",
    country: "United States",
    subcountry: "Oklahoma",
    geonameid: 4530801,
  },
  {
    name: "Broken Arrow",
    country: "United States",
    subcountry: "Oklahoma",
    geonameid: 4531405,
  },
  {
    name: "Chickasha",
    country: "United States",
    subcountry: "Oklahoma",
    geonameid: 4533029,
  },
  {
    name: "Claremore",
    country: "United States",
    subcountry: "Oklahoma",
    geonameid: 4533580,
  },
  {
    name: "Del City",
    country: "United States",
    subcountry: "Oklahoma",
    geonameid: 4534934,
  },
  {
    name: "Duncan",
    country: "United States",
    subcountry: "Oklahoma",
    geonameid: 4535389,
  },
  {
    name: "Durant",
    country: "United States",
    subcountry: "Oklahoma",
    geonameid: 4535414,
  },
  {
    name: "Edmond",
    country: "United States",
    subcountry: "Oklahoma",
    geonameid: 4535740,
  },
  {
    name: "El Reno",
    country: "United States",
    subcountry: "Oklahoma",
    geonameid: 4535783,
  },
  {
    name: "Enid",
    country: "United States",
    subcountry: "Oklahoma",
    geonameid: 4535961,
  },
  {
    name: "Jenks",
    country: "United States",
    subcountry: "Oklahoma",
    geonameid: 4539615,
  },
  {
    name: "Lawton",
    country: "United States",
    subcountry: "Oklahoma",
    geonameid: 4540737,
  },
  {
    name: "McAlester",
    country: "United States",
    subcountry: "Oklahoma",
    geonameid: 4542367,
  },
  {
    name: "Midwest City",
    country: "United States",
    subcountry: "Oklahoma",
    geonameid: 4542765,
  },
  {
    name: "Moore",
    country: "United States",
    subcountry: "Oklahoma",
    geonameid: 4542975,
  },
  {
    name: "Muskogee",
    country: "United States",
    subcountry: "Oklahoma",
    geonameid: 4543338,
  },
  {
    name: "Mustang",
    country: "United States",
    subcountry: "Oklahoma",
    geonameid: 4543352,
  },
  {
    name: "Norman",
    country: "United States",
    subcountry: "Oklahoma",
    geonameid: 4543762,
  },
  {
    name: "Oklahoma City",
    country: "United States",
    subcountry: "Oklahoma",
    geonameid: 4544349,
  },
  {
    name: "Owasso",
    country: "United States",
    subcountry: "Oklahoma",
    geonameid: 4547407,
  },
  {
    name: "Ponca City",
    country: "United States",
    subcountry: "Oklahoma",
    geonameid: 4548267,
  },
  {
    name: "Sand Springs",
    country: "United States",
    subcountry: "Oklahoma",
    geonameid: 4550659,
  },
  {
    name: "Sapulpa",
    country: "United States",
    subcountry: "Oklahoma",
    geonameid: 4550881,
  },
  {
    name: "Shawnee",
    country: "United States",
    subcountry: "Oklahoma",
    geonameid: 4551177,
  },
  {
    name: "Stillwater",
    country: "United States",
    subcountry: "Oklahoma",
    geonameid: 4552215,
  },
  {
    name: "Tahlequah",
    country: "United States",
    subcountry: "Oklahoma",
    geonameid: 4552707,
  },
  {
    name: "Tulsa",
    country: "United States",
    subcountry: "Oklahoma",
    geonameid: 4553433,
  },
  {
    name: "Yukon",
    country: "United States",
    subcountry: "Oklahoma",
    geonameid: 4556165,
  },
  {
    name: "Chambersburg",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 4557109,
  },
  {
    name: "Chester",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 4557137,
  },
  {
    name: "Drexel Hill",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 4557606,
  },
  {
    name: "Hanover",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 4558475,
  },
  {
    name: "Pennsport",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 4560303,
  },
  {
    name: "Philadelphia",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 4560349,
  },
  {
    name: "Springfield",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 4561407,
  },
  {
    name: "West Chester",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 4562144,
  },
  {
    name: "Wharton",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 4562193,
  },
  {
    name: "Whitman",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 4562237,
  },
  {
    name: "York",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 4562407,
  },
  {
    name: "Aiken",
    country: "United States",
    subcountry: "South Carolina",
    geonameid: 4569067,
  },
  {
    name: "Anderson",
    country: "United States",
    subcountry: "South Carolina",
    geonameid: 4569298,
  },
  {
    name: "Bluffton",
    country: "United States",
    subcountry: "South Carolina",
    geonameid: 4571722,
  },
  {
    name: "Charleston",
    country: "United States",
    subcountry: "South Carolina",
    geonameid: 4574324,
  },
  {
    name: "Clemson",
    country: "United States",
    subcountry: "South Carolina",
    geonameid: 4574989,
  },
  {
    name: "Columbia",
    country: "United States",
    subcountry: "South Carolina",
    geonameid: 4575352,
  },
  {
    name: "Conway",
    country: "United States",
    subcountry: "South Carolina",
    geonameid: 4575461,
  },
  {
    name: "Easley",
    country: "United States",
    subcountry: "South Carolina",
    geonameid: 4577263,
  },
  {
    name: "Florence",
    country: "United States",
    subcountry: "South Carolina",
    geonameid: 4578737,
  },
  {
    name: "Goose Creek",
    country: "United States",
    subcountry: "South Carolina",
    geonameid: 4580098,
  },
  {
    name: "Greenville",
    country: "United States",
    subcountry: "South Carolina",
    geonameid: 4580543,
  },
  {
    name: "Greenwood",
    country: "United States",
    subcountry: "South Carolina",
    geonameid: 4580569,
  },
  {
    name: "Greer",
    country: "United States",
    subcountry: "South Carolina",
    geonameid: 4580599,
  },
  {
    name: "Hanahan",
    country: "United States",
    subcountry: "South Carolina",
    geonameid: 4581023,
  },
  {
    name: "Hilton Head Island",
    country: "United States",
    subcountry: "South Carolina",
    geonameid: 4581832,
  },
  {
    name: "Hilton Head",
    country: "United States",
    subcountry: "South Carolina",
    geonameid: 4581833,
  },
  {
    name: "Lexington",
    country: "United States",
    subcountry: "South Carolina",
    geonameid: 4585000,
  },
  {
    name: "Mauldin",
    country: "United States",
    subcountry: "South Carolina",
    geonameid: 4586523,
  },
  {
    name: "Mount Pleasant",
    country: "United States",
    subcountry: "South Carolina",
    geonameid: 4588165,
  },
  {
    name: "Myrtle Beach",
    country: "United States",
    subcountry: "South Carolina",
    geonameid: 4588718,
  },
  {
    name: "North Augusta",
    country: "United States",
    subcountry: "South Carolina",
    geonameid: 4589368,
  },
  {
    name: "North Charleston",
    country: "United States",
    subcountry: "South Carolina",
    geonameid: 4589387,
  },
  {
    name: "North Myrtle Beach",
    country: "United States",
    subcountry: "South Carolina",
    geonameid: 4589446,
  },
  {
    name: "Rock Hill",
    country: "United States",
    subcountry: "South Carolina",
    geonameid: 4593142,
  },
  {
    name: "Saint Andrews",
    country: "United States",
    subcountry: "South Carolina",
    geonameid: 4593724,
  },
  {
    name: "Seven Oaks",
    country: "United States",
    subcountry: "South Carolina",
    geonameid: 4595374,
  },
  {
    name: "Simpsonville",
    country: "United States",
    subcountry: "South Carolina",
    geonameid: 4595864,
  },
  {
    name: "Socastee",
    country: "United States",
    subcountry: "South Carolina",
    geonameid: 4596208,
  },
  {
    name: "Spartanburg",
    country: "United States",
    subcountry: "South Carolina",
    geonameid: 4597200,
  },
  {
    name: "Summerville",
    country: "United States",
    subcountry: "South Carolina",
    geonameid: 4597919,
  },
  {
    name: "Sumter",
    country: "United States",
    subcountry: "South Carolina",
    geonameid: 4597948,
  },
  {
    name: "Taylors",
    country: "United States",
    subcountry: "South Carolina",
    geonameid: 4598353,
  },
  {
    name: "Wade Hampton",
    country: "United States",
    subcountry: "South Carolina",
    geonameid: 4599937,
  },
  {
    name: "West Columbia",
    country: "United States",
    subcountry: "South Carolina",
    geonameid: 4600541,
  },
  {
    name: "Bartlett",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4604183,
  },
  {
    name: "Brentwood",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4608408,
  },
  {
    name: "Brentwood Estates",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4608418,
  },
  {
    name: "Bristol",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4608657,
  },
  {
    name: "Chattanooga",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4612862,
  },
  {
    name: "Clarksville",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4613868,
  },
  {
    name: "Cleveland",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4614088,
  },
  {
    name: "Collierville",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4614748,
  },
  {
    name: "Columbia",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4614867,
  },
  {
    name: "Cookeville",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4615145,
  },
  {
    name: "Dickson",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4618057,
  },
  {
    name: "Dyersburg",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4619800,
  },
  {
    name: "East Brainerd",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4619943,
  },
  {
    name: "East Chattanooga",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4619947,
  },
  {
    name: "East Ridge",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4620131,
  },
  {
    name: "Ellendale",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4620732,
  },
  {
    name: "Farragut",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4621846,
  },
  {
    name: "Franklin",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4623560,
  },
  {
    name: "Gallatin",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4624180,
  },
  {
    name: "Germantown",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4624601,
  },
  {
    name: "Goodlettsville",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4625282,
  },
  {
    name: "Greeneville",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4626334,
  },
  {
    name: "Hendersonville",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4628735,
  },
  {
    name: "Hermitage",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4628929,
  },
  {
    name: "Jackson",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4632595,
  },
  {
    name: "Johnson City",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4633419,
  },
  {
    name: "Kingsport",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4634662,
  },
  {
    name: "Knoxville",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4634946,
  },
  {
    name: "La Vergne",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4635031,
  },
  {
    name: "Lebanon",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4636045,
  },
  {
    name: "Maryville",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4639848,
  },
  {
    name: "Memphis",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4641239,
  },
  {
    name: "Morristown",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4642938,
  },
  {
    name: "Mount Juliet",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4643336,
  },
  {
    name: "Murfreesboro",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4644312,
  },
  {
    name: "Nashville",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4644585,
  },
  {
    name: "New South Memphis",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4645421,
  },
  {
    name: "Oak Ridge",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4646571,
  },
  {
    name: "Sevierville",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4656585,
  },
  {
    name: "Shelbyville",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4657077,
  },
  {
    name: "Smyrna",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4658590,
  },
  {
    name: "Spring Hill",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4659446,
  },
  {
    name: "Springfield",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4659557,
  },
  {
    name: "Tullahoma",
    country: "United States",
    subcountry: "Tennessee",
    geonameid: 4663494,
  },
  {
    name: "Abilene",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4669635,
  },
  {
    name: "Addison",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4669828,
  },
  {
    name: "Alamo",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4670074,
  },
  {
    name: "Aldine",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4670146,
  },
  {
    name: "Alice",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4670234,
  },
  {
    name: "Alief",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4670249,
  },
  {
    name: "Allen",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4670300,
  },
  {
    name: "Alton",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4670555,
  },
  {
    name: "Alvin",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4670592,
  },
  {
    name: "Angleton",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4670866,
  },
  {
    name: "Arlington",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4671240,
  },
  {
    name: "Atascocita",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4671524,
  },
  {
    name: "Austin",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4671654,
  },
  {
    name: "Balch Springs",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4672059,
  },
  {
    name: "Baytown",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4672731,
  },
  {
    name: "Beaumont",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4672989,
  },
  {
    name: "Bedford",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4673094,
  },
  {
    name: "Bellaire",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4673353,
  },
  {
    name: "Belton",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4673425,
  },
  {
    name: "Benbrook",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4673482,
  },
  {
    name: "Brenham",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4676206,
  },
  {
    name: "Brownsville",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4676740,
  },
  {
    name: "Brownwood",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4676798,
  },
  {
    name: "Brushy Creek",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4676920,
  },
  {
    name: "Bryan",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4677008,
  },
  {
    name: "Burleson",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4677551,
  },
  {
    name: "Canyon Lake",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4678901,
  },
  {
    name: "Carrollton",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4679195,
  },
  {
    name: "Cedar Hill",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4679803,
  },
  {
    name: "Cedar Park",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4679867,
  },
  {
    name: "Channelview",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4680388,
  },
  {
    name: "Cibolo",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4681462,
  },
  {
    name: "Cinco Ranch",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4681485,
  },
  {
    name: "Cleburne",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4681976,
  },
  {
    name: "Cloverleaf",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4682127,
  },
  {
    name: "College Station",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4682464,
  },
  {
    name: "Colleyville",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4682478,
  },
  {
    name: "Conroe",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4682991,
  },
  {
    name: "Converse",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4683021,
  },
  {
    name: "Coppell",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4683217,
  },
  {
    name: "Copperas Cove",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4683244,
  },
  {
    name: "Corinth",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4683317,
  },
  {
    name: "Corpus Christi",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4683416,
  },
  {
    name: "Corsicana",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4683462,
  },
  {
    name: "Cypress",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4684724,
  },
  {
    name: "Dallas",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4684888,
  },
  {
    name: "DeSoto",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4685524,
  },
  {
    name: "Deer Park",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4685737,
  },
  {
    name: "Denison",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4685892,
  },
  {
    name: "Denton",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4685907,
  },
  {
    name: "Dickinson",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4686163,
  },
  {
    name: "Donna",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4686593,
  },
  {
    name: "Duncanville",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4687331,
  },
  {
    name: "Edinburg",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4688275,
  },
  {
    name: "Ennis",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4689311,
  },
  {
    name: "Euless",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4689550,
  },
  {
    name: "Farmers Branch",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4690198,
  },
  {
    name: "Flower Mound",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4691585,
  },
  {
    name: "Forney",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4691833,
  },
  {
    name: "Fort Worth",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4691930,
  },
  {
    name: "Fresno",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4692400,
  },
  {
    name: "Friendswood",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4692521,
  },
  {
    name: "Frisco",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4692559,
  },
  {
    name: "Gainesville",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4692746,
  },
  {
    name: "Galveston",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4692883,
  },
  {
    name: "Garland",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4693003,
  },
  {
    name: "Gatesville",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4693150,
  },
  {
    name: "Georgetown",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4693342,
  },
  {
    name: "Grand Prairie",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4694482,
  },
  {
    name: "Grapevine",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4694568,
  },
  {
    name: "Greenville",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4695066,
  },
  {
    name: "Groves",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4695317,
  },
  {
    name: "Haltom City",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4695912,
  },
  {
    name: "Harker Heights",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4696202,
  },
  {
    name: "Harlingen",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4696233,
  },
  {
    name: "Highland Village",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4697645,
  },
  {
    name: "Houston",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4699066,
  },
  {
    name: "Humble",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4699442,
  },
  {
    name: "Huntsville",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4699540,
  },
  {
    name: "Hurst",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4699575,
  },
  {
    name: "Hutto",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4699626,
  },
  {
    name: "Irving",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4700168,
  },
  {
    name: "Jollyville",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4701458,
  },
  {
    name: "Katy",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4702732,
  },
  {
    name: "Keller",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4702828,
  },
  {
    name: "Kerrville",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4703078,
  },
  {
    name: "Killeen",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4703223,
  },
  {
    name: "Kingsville",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4703384,
  },
  {
    name: "Kyle",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4703811,
  },
  {
    name: "La Marque",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4704027,
  },
  {
    name: "La Porte",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4704108,
  },
  {
    name: "Lake Jackson",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4704628,
  },
  {
    name: "Lancaster",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4705191,
  },
  {
    name: "Laredo",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4705349,
  },
  {
    name: "League City",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4705692,
  },
  {
    name: "Leander",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4705708,
  },
  {
    name: "Lewisville",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4706057,
  },
  {
    name: "Little Elm",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4706736,
  },
  {
    name: "Live Oak",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4707055,
  },
  {
    name: "Longview",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4707814,
  },
  {
    name: "Lufkin",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4708308,
  },
  {
    name: "Mansfield",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4709013,
  },
  {
    name: "Marshall",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4709272,
  },
  {
    name: "McAllen",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4709796,
  },
  {
    name: "McKinney",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4710178,
  },
  {
    name: "Mercedes",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4710749,
  },
  {
    name: "Mesquite",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4710826,
  },
  {
    name: "Midlothian",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4711156,
  },
  {
    name: "Mission",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4711725,
  },
  {
    name: "Mission Bend",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4711729,
  },
  {
    name: "Missouri City",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4711801,
  },
  {
    name: "Mount Pleasant",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4712933,
  },
  {
    name: "Murphy",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4713507,
  },
  {
    name: "Nacogdoches",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4713735,
  },
  {
    name: "Nederland",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4713932,
  },
  {
    name: "New Braunfels",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4714131,
  },
  {
    name: "New Territory",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4714582,
  },
  {
    name: "North Richland Hills",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4715292,
  },
  {
    name: "Orange",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4716805,
  },
  {
    name: "Palestine",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4717232,
  },
  {
    name: "Paris",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4717560,
  },
  {
    name: "Pasadena",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4717782,
  },
  {
    name: "Pearland",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4718097,
  },
  {
    name: "Pecan Grove",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4718209,
  },
  {
    name: "Pflugerville",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4718711,
  },
  {
    name: "Pharr",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4718721,
  },
  {
    name: "Plano",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4719457,
  },
  {
    name: "Port Arthur",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4720039,
  },
  {
    name: "Portland",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4720131,
  },
  {
    name: "Prosper",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4720833,
  },
  {
    name: "Richardson",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4722625,
  },
  {
    name: "Rockwall",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4723406,
  },
  {
    name: "Rosenberg",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4723914,
  },
  {
    name: "Round Rock",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4724129,
  },
  {
    name: "Rowlett",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4724194,
  },
  {
    name: "Sachse",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4724564,
  },
  {
    name: "Saginaw",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4724642,
  },
  {
    name: "San Antonio",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4726206,
  },
  {
    name: "San Benito",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4726290,
  },
  {
    name: "San Juan",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4726440,
  },
  {
    name: "San Marcos",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4726491,
  },
  {
    name: "Schertz",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4727326,
  },
  {
    name: "Seagoville",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4727605,
  },
  {
    name: "Seguin",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4727756,
  },
  {
    name: "Sherman",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4728328,
  },
  {
    name: "South Houston",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4733042,
  },
  {
    name: "Southlake",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4733313,
  },
  {
    name: "Spring",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4733624,
  },
  {
    name: "Stafford",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4734005,
  },
  {
    name: "Stephenville",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4734350,
  },
  {
    name: "Sugar Land",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4734825,
  },
  {
    name: "Sulphur Springs",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4734909,
  },
  {
    name: "Taylor",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4735702,
  },
  {
    name: "Temple",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4735966,
  },
  {
    name: "Terrell",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4736028,
  },
  {
    name: "Texarkana",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4736096,
  },
  {
    name: "Texas City",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4736134,
  },
  {
    name: "The Colony",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4736388,
  },
  {
    name: "The Woodlands",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4736476,
  },
  {
    name: "Tyler",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4738214,
  },
  {
    name: "Universal City",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4738574,
  },
  {
    name: "University Park",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4738606,
  },
  {
    name: "Uvalde",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4738721,
  },
  {
    name: "Victoria",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4739157,
  },
  {
    name: "Waco",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4739526,
  },
  {
    name: "Watauga",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4740214,
  },
  {
    name: "Waxahachie",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4740328,
  },
  {
    name: "Weatherford",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4740364,
  },
  {
    name: "Weslaco",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4740629,
  },
  {
    name: "West University Place",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4741100,
  },
  {
    name: "White Settlement",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4741616,
  },
  {
    name: "Wichita Falls",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4741752,
  },
  {
    name: "Wylie",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4743275,
  },
  {
    name: "Alexandria",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4744091,
  },
  {
    name: "Annandale",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4744468,
  },
  {
    name: "Arlington",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4744709,
  },
  {
    name: "Ashburn",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4744870,
  },
  {
    name: "Baileys Crossroads",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4745272,
  },
  {
    name: "Blacksburg",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4747845,
  },
  {
    name: "Bon Air",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4748305,
  },
  {
    name: "Bristol",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4748993,
  },
  {
    name: "Buckhall",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4749627,
  },
  {
    name: "Burke",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4749950,
  },
  {
    name: "Cave Spring",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4751421,
  },
  {
    name: "Centreville",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4751839,
  },
  {
    name: "Chantilly",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4751935,
  },
  {
    name: "Charlottesville",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4752031,
  },
  {
    name: "Cherry Hill",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4752136,
  },
  {
    name: "Chesapeake",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4752186,
  },
  {
    name: "Chester",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4752229,
  },
  {
    name: "Christiansburg",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4752665,
  },
  {
    name: "Colonial Heights",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4753671,
  },
  {
    name: "Culpeper",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4754966,
  },
  {
    name: "Dale City",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4755158,
  },
  {
    name: "Danville",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4755280,
  },
  {
    name: "East Hampton",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4756955,
  },
  {
    name: "Fairfax",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4758023,
  },
  {
    name: "Franconia",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4759968,
  },
  {
    name: "Fredericksburg",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4760059,
  },
  {
    name: "Front Royal",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4760232,
  },
  {
    name: "Great Falls",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4761951,
  },
  {
    name: "Hampton",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4762894,
  },
  {
    name: "Harrisonburg",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4763231,
  },
  {
    name: "Herndon",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4763793,
  },
  {
    name: "Highland Springs",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4764127,
  },
  {
    name: "Hopewell",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4764826,
  },
  {
    name: "Hybla Valley",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4765520,
  },
  {
    name: "Idylwood",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4765553,
  },
  {
    name: "Lake Ridge",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4768351,
  },
  {
    name: "Laurel",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4768678,
  },
  {
    name: "Leesburg",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4769125,
  },
  {
    name: "Lincolnia",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4769608,
  },
  {
    name: "Linton Hall",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4769667,
  },
  {
    name: "Lorton",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4770714,
  },
  {
    name: "Lynchburg",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4771075,
  },
  {
    name: "Manassas",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4771401,
  },
  {
    name: "Manassas Park",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4771414,
  },
  {
    name: "McLean",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4772354,
  },
  {
    name: "Mechanicsville",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4772566,
  },
  {
    name: "Merrifield",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4772735,
  },
  {
    name: "Montclair",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4773677,
  },
  {
    name: "Newport News",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4776024,
  },
  {
    name: "Norfolk",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4776222,
  },
  {
    name: "Oakton",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4776970,
  },
  {
    name: "Petersburg",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4778626,
  },
  {
    name: "Portsmouth",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4779999,
  },
  {
    name: "Portsmouth Heights",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4780011,
  },
  {
    name: "Radford",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4780837,
  },
  {
    name: "Reston",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4781530,
  },
  {
    name: "Richmond",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4781708,
  },
  {
    name: "Roanoke",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4782167,
  },
  {
    name: "Rose Hill",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4782864,
  },
  {
    name: "Salem",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4784112,
  },
  {
    name: "Short Pump",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4785576,
  },
  {
    name: "South Riding",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4786667,
  },
  {
    name: "South Suffolk",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4786714,
  },
  {
    name: "Springfield",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4787117,
  },
  {
    name: "Staunton",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4787440,
  },
  {
    name: "Sterling",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4787534,
  },
  {
    name: "Sudley",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4788145,
  },
  {
    name: "Suffolk",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4788158,
  },
  {
    name: "Tuckahoe",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4790207,
  },
  {
    name: "Tysons Corner",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4790534,
  },
  {
    name: "Vienna",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4791160,
  },
  {
    name: "Virginia Beach",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4791259,
  },
  {
    name: "Waynesboro",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4792522,
  },
  {
    name: "West Lynchburg",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4792867,
  },
  {
    name: "West Springfield",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4792901,
  },
  {
    name: "Williamsburg",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4793846,
  },
  {
    name: "Winchester",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4794120,
  },
  {
    name: "Wolf Trap",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4794350,
  },
  {
    name: "Woodlawn",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 4794531,
  },
  {
    name: "Beckley",
    country: "United States",
    subcountry: "West Virginia",
    geonameid: 4798308,
  },
  {
    name: "Charleston",
    country: "United States",
    subcountry: "West Virginia",
    geonameid: 4801859,
  },
  {
    name: "Clarksburg",
    country: "United States",
    subcountry: "West Virginia",
    geonameid: 4802316,
  },
  {
    name: "Fairmont",
    country: "United States",
    subcountry: "West Virginia",
    geonameid: 4805404,
  },
  {
    name: "Huntington",
    country: "United States",
    subcountry: "West Virginia",
    geonameid: 4809537,
  },
  {
    name: "Martinsburg",
    country: "United States",
    subcountry: "West Virginia",
    geonameid: 4813878,
  },
  {
    name: "Morgantown",
    country: "United States",
    subcountry: "West Virginia",
    geonameid: 4815352,
  },
  {
    name: "Parkersburg",
    country: "United States",
    subcountry: "West Virginia",
    geonameid: 4817641,
  },
  {
    name: "Sherwood",
    country: "United States",
    subcountry: "Arkansas",
    geonameid: 4828193,
  },
  {
    name: "Franklin",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4828382,
  },
  {
    name: "Chillicothe",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 4828890,
  },
  {
    name: "Bay City",
    country: "United States",
    subcountry: "Texas",
    geonameid: 4829307,
  },
  {
    name: "Alabaster",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4829762,
  },
  {
    name: "Albertville",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4829791,
  },
  {
    name: "Anniston",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4830198,
  },
  {
    name: "Athens",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4830668,
  },
  {
    name: "Auburn",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 4830796,
  },
  {
    name: "Glendale Heights",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4832038,
  },
  {
    name: "North Andover",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4832272,
  },
  {
    name: "Revere",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4832294,
  },
  {
    name: "Danbury",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4832353,
  },
  {
    name: "Darien",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4832425,
  },
  {
    name: "Inkster",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4832554,
  },
  {
    name: "Cleveland Heights",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 4833320,
  },
  {
    name: "East Hartford",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4833403,
  },
  {
    name: "East Haven",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4833425,
  },
  {
    name: "East Norwalk",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4833505,
  },
  {
    name: "Enfield",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4834040,
  },
  {
    name: "Fairfield",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4834157,
  },
  {
    name: "Farmington",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4834272,
  },
  {
    name: "Glastonbury",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4835003,
  },
  {
    name: "Guilford",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4835512,
  },
  {
    name: "Hamden",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4835654,
  },
  {
    name: "Hartford",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4835797,
  },
  {
    name: "Killingly Center",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4837278,
  },
  {
    name: "Ledyard",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4837648,
  },
  {
    name: "Madison",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4838116,
  },
  {
    name: "Manchester",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4838174,
  },
  {
    name: "Mansfield City",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4838204,
  },
  {
    name: "Meriden",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4838524,
  },
  {
    name: "Middletown",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4838633,
  },
  {
    name: "Milford",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4838652,
  },
  {
    name: "Montville Center",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4838887,
  },
  {
    name: "Naugatuck",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4839222,
  },
  {
    name: "New Britain",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4839292,
  },
  {
    name: "New Canaan",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4839319,
  },
  {
    name: "New Haven",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4839366,
  },
  {
    name: "New London",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4839416,
  },
  {
    name: "Newington",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4839497,
  },
  {
    name: "North Haven",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4839704,
  },
  {
    name: "North Stamford",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4839745,
  },
  {
    name: "Norwalk",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4839822,
  },
  {
    name: "Norwich",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4839843,
  },
  {
    name: "Plainfield",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4840755,
  },
  {
    name: "Plainville",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4840767,
  },
  {
    name: "Seymour",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4842818,
  },
  {
    name: "Shelton",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4842898,
  },
  {
    name: "South Windsor",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4843353,
  },
  {
    name: "Southbury",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4843362,
  },
  {
    name: "Stamford",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4843564,
  },
  {
    name: "Storrs",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4843786,
  },
  {
    name: "Stratford",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4843811,
  },
  {
    name: "Torrington",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4844309,
  },
  {
    name: "Trumbull",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4844459,
  },
  {
    name: "Wallingford",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4845056,
  },
  {
    name: "Waterbury",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4845193,
  },
  {
    name: "West Hartford",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4845411,
  },
  {
    name: "West Haven",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4845419,
  },
  {
    name: "West Torrington",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4845519,
  },
  {
    name: "Westport",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4845585,
  },
  {
    name: "Wethersfield",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4845612,
  },
  {
    name: "Willimantic",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4845823,
  },
  {
    name: "Wilton",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4845871,
  },
  {
    name: "Windham",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4845898,
  },
  {
    name: "Windsor",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4845920,
  },
  {
    name: "Wolcott",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 4845984,
  },
  {
    name: "Altoona",
    country: "United States",
    subcountry: "Iowa",
    geonameid: 4846757,
  },
  {
    name: "Ames",
    country: "United States",
    subcountry: "Iowa",
    geonameid: 4846834,
  },
  {
    name: "Ankeny",
    country: "United States",
    subcountry: "Iowa",
    geonameid: 4846960,
  },
  {
    name: "Bettendorf",
    country: "United States",
    subcountry: "Iowa",
    geonameid: 4848489,
  },
  {
    name: "Burlington",
    country: "United States",
    subcountry: "Iowa",
    geonameid: 4849826,
  },
  {
    name: "Cedar Falls",
    country: "United States",
    subcountry: "Iowa",
    geonameid: 4850699,
  },
  {
    name: "Cedar Rapids",
    country: "United States",
    subcountry: "Iowa",
    geonameid: 4850751,
  },
  {
    name: "Clinton",
    country: "United States",
    subcountry: "Iowa",
    geonameid: 4852022,
  },
  {
    name: "Clive",
    country: "United States",
    subcountry: "Iowa",
    geonameid: 4852065,
  },
  {
    name: "Coralville",
    country: "United States",
    subcountry: "Iowa",
    geonameid: 4852640,
  },
  {
    name: "Council Bluffs",
    country: "United States",
    subcountry: "Iowa",
    geonameid: 4852832,
  },
  {
    name: "Davenport",
    country: "United States",
    subcountry: "Iowa",
    geonameid: 4853423,
  },
  {
    name: "Des Moines",
    country: "United States",
    subcountry: "Iowa",
    geonameid: 4853828,
  },
  {
    name: "Dubuque",
    country: "United States",
    subcountry: "Iowa",
    geonameid: 4854529,
  },
  {
    name: "Fort Dodge",
    country: "United States",
    subcountry: "Iowa",
    geonameid: 4857486,
  },
  {
    name: "Indianola",
    country: "United States",
    subcountry: "Iowa",
    geonameid: 4861719,
  },
  {
    name: "Iowa City",
    country: "United States",
    subcountry: "Iowa",
    geonameid: 4862034,
  },
  {
    name: "Johnston",
    country: "United States",
    subcountry: "Iowa",
    geonameid: 4862760,
  },
  {
    name: "Marion",
    country: "United States",
    subcountry: "Iowa",
    geonameid: 4866263,
  },
  {
    name: "Marshalltown",
    country: "United States",
    subcountry: "Iowa",
    geonameid: 4866371,
  },
  {
    name: "Mason City",
    country: "United States",
    subcountry: "Iowa",
    geonameid: 4866445,
  },
  {
    name: "Muscatine",
    country: "United States",
    subcountry: "Iowa",
    geonameid: 4868404,
  },
  {
    name: "Newton",
    country: "United States",
    subcountry: "Iowa",
    geonameid: 4868907,
  },
  {
    name: "North Liberty",
    country: "United States",
    subcountry: "Iowa",
    geonameid: 4869195,
  },
  {
    name: "Ottumwa",
    country: "United States",
    subcountry: "Iowa",
    geonameid: 4870380,
  },
  {
    name: "Sioux City",
    country: "United States",
    subcountry: "Iowa",
    geonameid: 4876523,
  },
  {
    name: "Urbandale",
    country: "United States",
    subcountry: "Iowa",
    geonameid: 4879890,
  },
  {
    name: "Waterloo",
    country: "United States",
    subcountry: "Iowa",
    geonameid: 4880889,
  },
  {
    name: "Waukee",
    country: "United States",
    subcountry: "Iowa",
    geonameid: 4880981,
  },
  {
    name: "West Des Moines",
    country: "United States",
    subcountry: "Iowa",
    geonameid: 4881346,
  },
  {
    name: "Addison",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4882920,
  },
  {
    name: "Albany Park",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4883012,
  },
  {
    name: "Algonquin",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4883078,
  },
  {
    name: "Alsip",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4883207,
  },
  {
    name: "Arlington Heights",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4883555,
  },
  {
    name: "Ashburn",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4883679,
  },
  {
    name: "Aurora",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4883817,
  },
  {
    name: "Avondale",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4883904,
  },
  {
    name: "Bartlett",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4884141,
  },
  {
    name: "Batavia",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4884192,
  },
  {
    name: "Bellwood",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4884434,
  },
  {
    name: "Belmont Cragin",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4884442,
  },
  {
    name: "Belvidere",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4884453,
  },
  {
    name: "Bensenville",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4884509,
  },
  {
    name: "Berwyn",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4884597,
  },
  {
    name: "Bloomingdale",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4885156,
  },
  {
    name: "Bloomington",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4885164,
  },
  {
    name: "Blue Island",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4885186,
  },
  {
    name: "Bolingbrook",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4885265,
  },
  {
    name: "Bourbonnais",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4885342,
  },
  {
    name: "Bradley",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4885418,
  },
  {
    name: "Bridgeport",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4885565,
  },
  {
    name: "Bridgeview",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4885573,
  },
  {
    name: "Brighton Park",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4885597,
  },
  {
    name: "Brookfield",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4885689,
  },
  {
    name: "Buffalo Grove",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4885955,
  },
  {
    name: "Burbank",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4885983,
  },
  {
    name: "Calumet City",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4886255,
  },
  {
    name: "Carol Stream",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4886662,
  },
  {
    name: "Carpentersville",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4886676,
  },
  {
    name: "Cary",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4886738,
  },
  {
    name: "Champaign",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4887158,
  },
  {
    name: "Chatham",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4887284,
  },
  {
    name: "Chicago",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4887398,
  },
  {
    name: "Chicago Heights",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4887442,
  },
  {
    name: "Chicago Lawn",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4887463,
  },
  {
    name: "Cicero",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4888015,
  },
  {
    name: "Country Club Hills",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4888892,
  },
  {
    name: "Crest Hill",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4889107,
  },
  {
    name: "Crystal Lake",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4889229,
  },
  {
    name: "Danville",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4889426,
  },
  {
    name: "Darien",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4889447,
  },
  {
    name: "DeKalb",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4889553,
  },
  {
    name: "Deerfield",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4889668,
  },
  {
    name: "Des Plaines",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4889772,
  },
  {
    name: "Dixon",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4889959,
  },
  {
    name: "Dolton",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4890009,
  },
  {
    name: "Douglas",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4890075,
  },
  {
    name: "Downers Grove",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4890119,
  },
  {
    name: "East Garfield Park",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4890507,
  },
  {
    name: "East Moline",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4890536,
  },
  {
    name: "East Peoria",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4890549,
  },
  {
    name: "Edgewater",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4890701,
  },
  {
    name: "Elgin",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4890864,
  },
  {
    name: "Elk Grove Village",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4890925,
  },
  {
    name: "Elmhurst",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4891010,
  },
  {
    name: "Elmwood Park",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4891051,
  },
  {
    name: "Englewood",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4891176,
  },
  {
    name: "Evanston",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4891382,
  },
  {
    name: "Evergreen Park",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4891431,
  },
  {
    name: "Frankfort",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4893037,
  },
  {
    name: "Franklin Park",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4893070,
  },
  {
    name: "Freeport",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4893171,
  },
  {
    name: "Gage Park",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4893365,
  },
  {
    name: "Galesburg",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4893392,
  },
  {
    name: "Geneva",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4893591,
  },
  {
    name: "Glen Ellyn",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4893811,
  },
  {
    name: "Glenview",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4893886,
  },
  {
    name: "Goodings Grove",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4894061,
  },
  {
    name: "Grand Boulevard",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4894320,
  },
  {
    name: "Grayslake",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4894465,
  },
  {
    name: "Gurnee",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4894861,
  },
  {
    name: "Hanover Park",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4895066,
  },
  {
    name: "Harvey",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4895298,
  },
  {
    name: "Highland Park",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4895876,
  },
  {
    name: "Hinsdale",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4896012,
  },
  {
    name: "Hoffman Estates",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4896075,
  },
  {
    name: "Homer Glen",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4896336,
  },
  {
    name: "Homewood",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4896353,
  },
  {
    name: "Huntley",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4896691,
  },
  {
    name: "Hyde Park",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4896728,
  },
  {
    name: "Irving Park",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4897543,
  },
  {
    name: "Joliet",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4898015,
  },
  {
    name: "Kankakee",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4898182,
  },
  {
    name: "Kenwood",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4898401,
  },
  {
    name: "La Grange",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4898846,
  },
  {
    name: "Lake Forest",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4899012,
  },
  {
    name: "Lake Zurich",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4899170,
  },
  {
    name: "Lake in the Hills",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4899184,
  },
  {
    name: "Lansing",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4899340,
  },
  {
    name: "Lemont",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4899581,
  },
  {
    name: "Libertyville",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4899739,
  },
  {
    name: "Lincoln Park",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4899911,
  },
  {
    name: "Lincoln Square",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4899966,
  },
  {
    name: "Lisle",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4900080,
  },
  {
    name: "Lockport",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4900292,
  },
  {
    name: "Logan Square",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4900358,
  },
  {
    name: "Lombard",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4900373,
  },
  {
    name: "Loves Park",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4900579,
  },
  {
    name: "Lower West Side",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4900611,
  },
  {
    name: "Machesney Park",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4900801,
  },
  {
    name: "Macomb",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4900817,
  },
  {
    name: "Matteson",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4901445,
  },
  {
    name: "Maywood",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4901514,
  },
  {
    name: "McHenry",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4901663,
  },
  {
    name: "McKinley Park",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4901710,
  },
  {
    name: "Melrose Park",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4901868,
  },
  {
    name: "Mokena",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4902475,
  },
  {
    name: "Moline",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4902476,
  },
  {
    name: "Montgomery",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4902559,
  },
  {
    name: "Morgan Park",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4902667,
  },
  {
    name: "Morton",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4902754,
  },
  {
    name: "Morton Grove",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4902763,
  },
  {
    name: "Mount Greenwood",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4902900,
  },
  {
    name: "Mount Prospect",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4903024,
  },
  {
    name: "Mundelein",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4903184,
  },
  {
    name: "Naperville",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4903279,
  },
  {
    name: "Near North Side",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4903360,
  },
  {
    name: "Near South Side",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4903363,
  },
  {
    name: "New City",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4903466,
  },
  {
    name: "New Lenox",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4903535,
  },
  {
    name: "Niles",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4903730,
  },
  {
    name: "Normal",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4903780,
  },
  {
    name: "North Aurora",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4903818,
  },
  {
    name: "North Center",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4903858,
  },
  {
    name: "North Chicago",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4903862,
  },
  {
    name: "North Lawndale",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4903940,
  },
  {
    name: "North Peoria",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4903976,
  },
  {
    name: "Northbrook",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4904056,
  },
  {
    name: "Oak Forest",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4904286,
  },
  {
    name: "Oak Lawn",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4904365,
  },
  {
    name: "Oak Park",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4904381,
  },
  {
    name: "Orland Park",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4904937,
  },
  {
    name: "Oswego",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4904996,
  },
  {
    name: "Ottawa",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4905006,
  },
  {
    name: "Palatine",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4905211,
  },
  {
    name: "Palos Hills",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4905263,
  },
  {
    name: "Park Forest",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4905337,
  },
  {
    name: "Park Ridge",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4905367,
  },
  {
    name: "Pekin",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4905599,
  },
  {
    name: "Peoria",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4905687,
  },
  {
    name: "Plainfield",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4906125,
  },
  {
    name: "Portage Park",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4906500,
  },
  {
    name: "Prospect Heights",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4906882,
  },
  {
    name: "Rock Island",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4907907,
  },
  {
    name: "Rockford",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4907959,
  },
  {
    name: "Rogers Park",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4908033,
  },
  {
    name: "Rolling Meadows",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4908052,
  },
  {
    name: "Romeoville",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4908068,
  },
  {
    name: "Roselle",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4908173,
  },
  {
    name: "Round Lake",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4908236,
  },
  {
    name: "Round Lake Beach",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4908237,
  },
  {
    name: "St. Charles",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4908737,
  },
  {
    name: "Schaumburg",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4910713,
  },
  {
    name: "Shorewood",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4911418,
  },
  {
    name: "Skokie",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4911600,
  },
  {
    name: "South Chicago",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4911863,
  },
  {
    name: "South Elgin",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4911893,
  },
  {
    name: "South Holland",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4911934,
  },
  {
    name: "South Lawndale",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4911951,
  },
  {
    name: "South Shore",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4912013,
  },
  {
    name: "Sterling",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4912499,
  },
  {
    name: "Streamwood",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4912691,
  },
  {
    name: "Sycamore",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4913110,
  },
  {
    name: "Tinley Park",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4913723,
  },
  {
    name: "Uptown",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4914557,
  },
  {
    name: "Urbana",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4914570,
  },
  {
    name: "Vernon Hills",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4914738,
  },
  {
    name: "Villa Park",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4914830,
  },
  {
    name: "Wasco",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4915539,
  },
  {
    name: "Washington",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4915545,
  },
  {
    name: "Waukegan",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4915734,
  },
  {
    name: "West Chicago",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4915963,
  },
  {
    name: "West Elsdon",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4915987,
  },
  {
    name: "West Englewood",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4915989,
  },
  {
    name: "West Garfield Park",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4916003,
  },
  {
    name: "West Lawn",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4916028,
  },
  {
    name: "West Ridge",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4916079,
  },
  {
    name: "West Town",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4916118,
  },
  {
    name: "Westchester",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4916140,
  },
  {
    name: "Westmont",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4916207,
  },
  {
    name: "Wheaton",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4916288,
  },
  {
    name: "Wheeling",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4916311,
  },
  {
    name: "Wilmette",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4916732,
  },
  {
    name: "Woodlawn",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4917067,
  },
  {
    name: "Woodridge",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4917089,
  },
  {
    name: "Woodstock",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4917123,
  },
  {
    name: "Yorkville",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4917298,
  },
  {
    name: "Zion",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 4917358,
  },
  {
    name: "Anderson",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4917592,
  },
  {
    name: "Crawfordsville",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4919381,
  },
  {
    name: "Crown Point",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4919451,
  },
  {
    name: "Dyer",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4919820,
  },
  {
    name: "East Chicago",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4919857,
  },
  {
    name: "Elkhart",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4919987,
  },
  {
    name: "Fort Wayne",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4920423,
  },
  {
    name: "Frankfort",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4920473,
  },
  {
    name: "Gary",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4920607,
  },
  {
    name: "Goshen",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4920808,
  },
  {
    name: "Granger",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4920869,
  },
  {
    name: "Griffith",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4920986,
  },
  {
    name: "Hammond",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4921100,
  },
  {
    name: "Highland",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4921402,
  },
  {
    name: "Hobart",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4921476,
  },
  {
    name: "Huntington",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4921725,
  },
  {
    name: "Kokomo",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4922388,
  },
  {
    name: "LaPorte",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4922459,
  },
  {
    name: "Lafayette",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4922462,
  },
  {
    name: "Lebanon",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4922673,
  },
  {
    name: "Logansport",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4922968,
  },
  {
    name: "Marion",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4923210,
  },
  {
    name: "Merrillville",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4923482,
  },
  {
    name: "Michigan City",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4923531,
  },
  {
    name: "Mishawaka",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4923670,
  },
  {
    name: "Muncie",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4924006,
  },
  {
    name: "Munster",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4924014,
  },
  {
    name: "New Haven",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4924104,
  },
  {
    name: "Noblesville",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4924198,
  },
  {
    name: "Portage",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4925006,
  },
  {
    name: "Schererville",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4926170,
  },
  {
    name: "South Bend",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4926563,
  },
  {
    name: "Valparaiso",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4927537,
  },
  {
    name: "West Lafayette",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4928096,
  },
  {
    name: "Westfield",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 4928118,
  },
  {
    name: "Abington",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4928662,
  },
  {
    name: "Acton",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4928703,
  },
  {
    name: "Agawam",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4928788,
  },
  {
    name: "Amesbury",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4929004,
  },
  {
    name: "Amherst",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4929022,
  },
  {
    name: "Amherst Center",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4929023,
  },
  {
    name: "Arlington",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4929180,
  },
  {
    name: "Ashland",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4929283,
  },
  {
    name: "Attleboro",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4929399,
  },
  {
    name: "Auburn",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4929417,
  },
  {
    name: "Barnstable",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4929771,
  },
  {
    name: "Belmont",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4930282,
  },
  {
    name: "Beverly",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4930505,
  },
  {
    name: "Beverly Cove",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4930511,
  },
  {
    name: "Billerica",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4930577,
  },
  {
    name: "Boston",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4930956,
  },
  {
    name: "Brockton",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4931429,
  },
  {
    name: "Brookline",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4931482,
  },
  {
    name: "Burlington",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4931737,
  },
  {
    name: "Cambridge",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4931972,
  },
  {
    name: "Canton",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4932214,
  },
  {
    name: "Chelmsford",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4932869,
  },
  {
    name: "Chelsea",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4932879,
  },
  {
    name: "Chicopee",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4933002,
  },
  {
    name: "Concord",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4933743,
  },
  {
    name: "Danvers",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4934500,
  },
  {
    name: "Dedham",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4934664,
  },
  {
    name: "Dracut",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4935038,
  },
  {
    name: "Duxbury",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4935211,
  },
  {
    name: "East Longmeadow",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4935434,
  },
  {
    name: "Easthampton",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4935582,
  },
  {
    name: "Easton",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4935623,
  },
  {
    name: "Everett",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4936008,
  },
  {
    name: "Fairhaven",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4936087,
  },
  {
    name: "Fall River",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4936159,
  },
  {
    name: "Fitchburg",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4936812,
  },
  {
    name: "Framingham",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4937230,
  },
  {
    name: "Framingham Center",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4937232,
  },
  {
    name: "Franklin",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4937276,
  },
  {
    name: "Gardner",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4937557,
  },
  {
    name: "Gloucester",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4937829,
  },
  {
    name: "Grafton",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4938048,
  },
  {
    name: "Greenfield",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4938378,
  },
  {
    name: "Hanover",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4938836,
  },
  {
    name: "Haverhill",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4939085,
  },
  {
    name: "Holden",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4939647,
  },
  {
    name: "Holyoke",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4939783,
  },
  {
    name: "Jamaica Plain",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4940764,
  },
  {
    name: "Lawrence",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4941720,
  },
  {
    name: "Leominster",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4941873,
  },
  {
    name: "Lexington",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4941935,
  },
  {
    name: "Longmeadow",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4942508,
  },
  {
    name: "Lowell",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4942618,
  },
  {
    name: "Ludlow",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4942744,
  },
  {
    name: "Lynn",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4942807,
  },
  {
    name: "Malden",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4942939,
  },
  {
    name: "Mansfield",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4943021,
  },
  {
    name: "Marblehead",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4943097,
  },
  {
    name: "Marlborough",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4943170,
  },
  {
    name: "Medford",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4943629,
  },
  {
    name: "Melrose",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4943677,
  },
  {
    name: "Methuen",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4943828,
  },
  {
    name: "Middleborough",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4943888,
  },
  {
    name: "Milford",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4943958,
  },
  {
    name: "Milton",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4944193,
  },
  {
    name: "Natick",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4944994,
  },
  {
    name: "Needham",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4945055,
  },
  {
    name: "New Bedford",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4945121,
  },
  {
    name: "Newburyport",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4945256,
  },
  {
    name: "Newton",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4945283,
  },
  {
    name: "North Chicopee",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4945588,
  },
  {
    name: "Northampton",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4945819,
  },
  {
    name: "Norton",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4945911,
  },
  {
    name: "Norwood",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4945952,
  },
  {
    name: "Palmer",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4946620,
  },
  {
    name: "Peabody",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4946863,
  },
  {
    name: "Pittsfield",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4947459,
  },
  {
    name: "Quincy",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4948247,
  },
  {
    name: "Randolph",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4948403,
  },
  {
    name: "Reading",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4948462,
  },
  {
    name: "Rockland",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4948924,
  },
  {
    name: "Salem",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4950065,
  },
  {
    name: "Saugus",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4950267,
  },
  {
    name: "Shrewsbury",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4950898,
  },
  {
    name: "Somerset",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4951248,
  },
  {
    name: "Somerville",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4951257,
  },
  {
    name: "South Boston",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4951305,
  },
  {
    name: "South Hadley",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4951397,
  },
  {
    name: "South Peabody",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4951473,
  },
  {
    name: "Southbridge",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4951594,
  },
  {
    name: "Springfield",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4951788,
  },
  {
    name: "Stoneham",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4952121,
  },
  {
    name: "Stoughton",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4952206,
  },
  {
    name: "Sudbury",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4952320,
  },
  {
    name: "Swansea",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4952487,
  },
  {
    name: "Taunton",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4952629,
  },
  {
    name: "Tewksbury",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4952762,
  },
  {
    name: "Wakefield",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4954265,
  },
  {
    name: "Waltham",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4954380,
  },
  {
    name: "Watertown",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4954611,
  },
  {
    name: "Wellesley",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4954738,
  },
  {
    name: "West Springfield",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4955089,
  },
  {
    name: "Westfield",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4955190,
  },
  {
    name: "Westford",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4955219,
  },
  {
    name: "Weymouth",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4955336,
  },
  {
    name: "Wilmington",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4955840,
  },
  {
    name: "Winchester",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4955884,
  },
  {
    name: "Winthrop",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4955993,
  },
  {
    name: "Woburn",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4956032,
  },
  {
    name: "Worcester",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4956184,
  },
  {
    name: "Yarmouth",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 4956335,
  },
  {
    name: "Auburn",
    country: "United States",
    subcountry: "Maine",
    geonameid: 4956976,
  },
  {
    name: "Augusta",
    country: "United States",
    subcountry: "Maine",
    geonameid: 4957003,
  },
  {
    name: "Bangor",
    country: "United States",
    subcountry: "Maine",
    geonameid: 4957280,
  },
  {
    name: "Biddeford",
    country: "United States",
    subcountry: "Maine",
    geonameid: 4958141,
  },
  {
    name: "Brunswick",
    country: "United States",
    subcountry: "Maine",
    geonameid: 4959473,
  },
  {
    name: "Lewiston",
    country: "United States",
    subcountry: "Maine",
    geonameid: 4969398,
  },
  {
    name: "Portland",
    country: "United States",
    subcountry: "Maine",
    geonameid: 4975802,
  },
  {
    name: "Saco",
    country: "United States",
    subcountry: "Maine",
    geonameid: 4977222,
  },
  {
    name: "Sanford",
    country: "United States",
    subcountry: "Maine",
    geonameid: 4977762,
  },
  {
    name: "South Portland",
    country: "United States",
    subcountry: "Maine",
    geonameid: 4979244,
  },
  {
    name: "South Portland Gardens",
    country: "United States",
    subcountry: "Maine",
    geonameid: 4979245,
  },
  {
    name: "Waterville",
    country: "United States",
    subcountry: "Maine",
    geonameid: 4982236,
  },
  {
    name: "West Scarborough",
    country: "United States",
    subcountry: "Maine",
    geonameid: 4982720,
  },
  {
    name: "Westbrook",
    country: "United States",
    subcountry: "Maine",
    geonameid: 4982753,
  },
  {
    name: "Adrian",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4983811,
  },
  {
    name: "Allen Park",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4984016,
  },
  {
    name: "Allendale",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4984029,
  },
  {
    name: "Ann Arbor",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4984247,
  },
  {
    name: "Auburn Hills",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4984565,
  },
  {
    name: "Battle Creek",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4985153,
  },
  {
    name: "Bay City",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4985180,
  },
  {
    name: "Berkley",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4985744,
  },
  {
    name: "Birmingham",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4986172,
  },
  {
    name: "Burton",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4987482,
  },
  {
    name: "Canton",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4987990,
  },
  {
    name: "Clinton Township",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4989133,
  },
  {
    name: "Dearborn",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4990510,
  },
  {
    name: "Dearborn Heights",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4990512,
  },
  {
    name: "Detroit",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4990729,
  },
  {
    name: "East Lansing",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4991640,
  },
  {
    name: "Eastpointe",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4991735,
  },
  {
    name: "Farmington Hills",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4992523,
  },
  {
    name: "Ferndale",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4992635,
  },
  {
    name: "Flint",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4992982,
  },
  {
    name: "Forest Hills",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4993125,
  },
  {
    name: "Garden City",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4993659,
  },
  {
    name: "Grand Rapids",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4994358,
  },
  {
    name: "Grandville",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4994391,
  },
  {
    name: "Grosse Pointe Woods",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4994871,
  },
  {
    name: "Hamtramck",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4995197,
  },
  {
    name: "Haslett",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4995514,
  },
  {
    name: "Hazel Park",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4995664,
  },
  {
    name: "Holland",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4996248,
  },
  {
    name: "Holt",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4996306,
  },
  {
    name: "Jackson",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4997384,
  },
  {
    name: "Jenison",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4997500,
  },
  {
    name: "Kalamazoo",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4997787,
  },
  {
    name: "Kentwood",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4998018,
  },
  {
    name: "Lansing",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4998830,
  },
  {
    name: "Lincoln Park",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4999311,
  },
  {
    name: "Livonia",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 4999837,
  },
  {
    name: "Madison Heights",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5000500,
  },
  {
    name: "Marquette",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5000947,
  },
  {
    name: "Midland",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5001929,
  },
  {
    name: "Monroe",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5002344,
  },
  {
    name: "Mount Clemens",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5002656,
  },
  {
    name: "Mount Pleasant",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5002714,
  },
  {
    name: "Muskegon",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5003132,
  },
  {
    name: "Norton Shores",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5004005,
  },
  {
    name: "Novi",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5004062,
  },
  {
    name: "Oak Park",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5004188,
  },
  {
    name: "Okemos",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5004359,
  },
  {
    name: "Pontiac",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5006166,
  },
  {
    name: "Port Huron",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5006233,
  },
  {
    name: "Portage",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5006250,
  },
  {
    name: "Redford",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5006917,
  },
  {
    name: "Rochester Hills",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5007402,
  },
  {
    name: "Romulus",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5007531,
  },
  {
    name: "Roseville",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5007655,
  },
  {
    name: "Royal Oak",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5007804,
  },
  {
    name: "Saginaw",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5007989,
  },
  {
    name: "Shelby",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5009586,
  },
  {
    name: "Southfield",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5010636,
  },
  {
    name: "Southgate",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5010646,
  },
  {
    name: "Saint Clair Shores",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5010978,
  },
  {
    name: "Sterling Heights",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5011148,
  },
  {
    name: "Taylor",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5011908,
  },
  {
    name: "Traverse City",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5012495,
  },
  {
    name: "Trenton",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5012521,
  },
  {
    name: "Troy",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5012639,
  },
  {
    name: "Walker",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5013924,
  },
  {
    name: "Warren",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5014051,
  },
  {
    name: "Waterford",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5014130,
  },
  {
    name: "Waverly",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5014208,
  },
  {
    name: "Wayne",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5014224,
  },
  {
    name: "Westland",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5014681,
  },
  {
    name: "Wyandotte",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5015599,
  },
  {
    name: "Wyoming",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5015618,
  },
  {
    name: "Ypsilanti",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 5015688,
  },
  {
    name: "Albert Lea",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5016024,
  },
  {
    name: "Andover",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5016374,
  },
  {
    name: "Anoka",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5016450,
  },
  {
    name: "Apple Valley",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5016494,
  },
  {
    name: "Austin",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5016884,
  },
  {
    name: "Blaine",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5018651,
  },
  {
    name: "Bloomington",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5018739,
  },
  {
    name: "Brooklyn Center",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5019330,
  },
  {
    name: "Brooklyn Park",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5019335,
  },
  {
    name: "Buffalo",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5019588,
  },
  {
    name: "Burnsville",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5019767,
  },
  {
    name: "Champlin",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5020859,
  },
  {
    name: "Chanhassen",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5020881,
  },
  {
    name: "Chaska",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5020938,
  },
  {
    name: "Columbia Heights",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5021828,
  },
  {
    name: "Coon Rapids",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5022025,
  },
  {
    name: "Cottage Grove",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5022134,
  },
  {
    name: "Crystal",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5023571,
  },
  {
    name: "Duluth",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5024719,
  },
  {
    name: "Eagan",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5024825,
  },
  {
    name: "Eden Prairie",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5025219,
  },
  {
    name: "Edina",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5025264,
  },
  {
    name: "Elk River",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5025471,
  },
  {
    name: "Faribault",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5026291,
  },
  {
    name: "Farmington",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5026321,
  },
  {
    name: "Forest Lake",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5027117,
  },
  {
    name: "Fridley",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5027482,
  },
  {
    name: "Golden Valley",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5028163,
  },
  {
    name: "Ham Lake",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5029181,
  },
  {
    name: "Hastings",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5029500,
  },
  {
    name: "Hibbing",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5030005,
  },
  {
    name: "Hopkins",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5030670,
  },
  {
    name: "Inver Grove Heights",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5031412,
  },
  {
    name: "Lakeville",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5034059,
  },
  {
    name: "Lino Lakes",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5034767,
  },
  {
    name: "Mankato",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5036420,
  },
  {
    name: "Maple Grove",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5036493,
  },
  {
    name: "Maplewood",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5036588,
  },
  {
    name: "Minneapolis",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5037649,
  },
  {
    name: "Minnetonka",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5037784,
  },
  {
    name: "Minnetonka Mills",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5037790,
  },
  {
    name: "Moorhead",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5038108,
  },
  {
    name: "New Brighton",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5039080,
  },
  {
    name: "New Hope",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5039094,
  },
  {
    name: "Northfield",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5039675,
  },
  {
    name: "Oakdale",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5039978,
  },
  {
    name: "Otsego",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5040477,
  },
  {
    name: "Owatonna",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5040647,
  },
  {
    name: "Plymouth",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5041926,
  },
  {
    name: "Prior Lake",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5042373,
  },
  {
    name: "Ramsey",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5042561,
  },
  {
    name: "Red Wing",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5042773,
  },
  {
    name: "Richfield",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5043193,
  },
  {
    name: "Rochester",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5043473,
  },
  {
    name: "Rosemount",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5043779,
  },
  {
    name: "Roseville",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5043799,
  },
  {
    name: "Saint Cloud",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5044407,
  },
  {
    name: "Saint Louis Park",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5045021,
  },
  {
    name: "Saint Michael",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5045258,
  },
  {
    name: "Saint Paul",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5045360,
  },
  {
    name: "Sartell",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5046001,
  },
  {
    name: "Savage",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5046063,
  },
  {
    name: "Shakopee",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5046997,
  },
  {
    name: "Shoreview",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5047234,
  },
  {
    name: "South Saint Paul",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5048033,
  },
  {
    name: "Stillwater",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5048814,
  },
  {
    name: "West Coon Rapids",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5052361,
  },
  {
    name: "West Saint Paul",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5052467,
  },
  {
    name: "White Bear Lake",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5052658,
  },
  {
    name: "Willmar",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5052916,
  },
  {
    name: "Winona",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5053156,
  },
  {
    name: "Woodbury",
    country: "United States",
    subcountry: "Minnesota",
    geonameid: 5053358,
  },
  {
    name: "Kirksville",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 5055787,
  },
  {
    name: "Fargo",
    country: "United States",
    subcountry: "North Dakota",
    geonameid: 5059163,
  },
  {
    name: "Grand Forks",
    country: "United States",
    subcountry: "North Dakota",
    geonameid: 5059429,
  },
  {
    name: "Jamestown",
    country: "United States",
    subcountry: "North Dakota",
    geonameid: 5059836,
  },
  {
    name: "West Fargo",
    country: "United States",
    subcountry: "North Dakota",
    geonameid: 5062458,
  },
  {
    name: "Bellevue",
    country: "United States",
    subcountry: "Nebraska",
    geonameid: 5063805,
  },
  {
    name: "Columbus",
    country: "United States",
    subcountry: "Nebraska",
    geonameid: 5066001,
  },
  {
    name: "Fremont",
    country: "United States",
    subcountry: "Nebraska",
    geonameid: 5068725,
  },
  {
    name: "Grand Island",
    country: "United States",
    subcountry: "Nebraska",
    geonameid: 5069297,
  },
  {
    name: "Hastings",
    country: "United States",
    subcountry: "Nebraska",
    geonameid: 5069802,
  },
  {
    name: "Kearney",
    country: "United States",
    subcountry: "Nebraska",
    geonameid: 5071348,
  },
  {
    name: "La Vista",
    country: "United States",
    subcountry: "Nebraska",
    geonameid: 5071665,
  },
  {
    name: "Lincoln",
    country: "United States",
    subcountry: "Nebraska",
    geonameid: 5072006,
  },
  {
    name: "Norfolk",
    country: "United States",
    subcountry: "Nebraska",
    geonameid: 5073965,
  },
  {
    name: "Omaha",
    country: "United States",
    subcountry: "Nebraska",
    geonameid: 5074472,
  },
  {
    name: "Papillion",
    country: "United States",
    subcountry: "Nebraska",
    geonameid: 5074792,
  },
  {
    name: "Bedford",
    country: "United States",
    subcountry: "New Hampshire",
    geonameid: 5083221,
  },
  {
    name: "Concord",
    country: "United States",
    subcountry: "New Hampshire",
    geonameid: 5084868,
  },
  {
    name: "Derry",
    country: "United States",
    subcountry: "New Hampshire",
    geonameid: 5085374,
  },
  {
    name: "Derry Village",
    country: "United States",
    subcountry: "New Hampshire",
    geonameid: 5085382,
  },
  {
    name: "Dover",
    country: "United States",
    subcountry: "New Hampshire",
    geonameid: 5085520,
  },
  {
    name: "East Concord",
    country: "United States",
    subcountry: "New Hampshire",
    geonameid: 5085688,
  },
  {
    name: "Keene",
    country: "United States",
    subcountry: "New Hampshire",
    geonameid: 5088262,
  },
  {
    name: "Laconia",
    country: "United States",
    subcountry: "New Hampshire",
    geonameid: 5088438,
  },
  {
    name: "Manchester",
    country: "United States",
    subcountry: "New Hampshire",
    geonameid: 5089178,
  },
  {
    name: "Merrimack",
    country: "United States",
    subcountry: "New Hampshire",
    geonameid: 5089478,
  },
  {
    name: "Nashua",
    country: "United States",
    subcountry: "New Hampshire",
    geonameid: 5090046,
  },
  {
    name: "Portsmouth",
    country: "United States",
    subcountry: "New Hampshire",
    geonameid: 5091383,
  },
  {
    name: "Rochester",
    country: "United States",
    subcountry: "New Hampshire",
    geonameid: 5091872,
  },
  {
    name: "Salem",
    country: "United States",
    subcountry: "New Hampshire",
    geonameid: 5092268,
  },
  {
    name: "Asbury Park",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5095281,
  },
  {
    name: "Avenel",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5095325,
  },
  {
    name: "Basking Ridge",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5095409,
  },
  {
    name: "Bayonne",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5095445,
  },
  {
    name: "Belleville",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5095549,
  },
  {
    name: "Bergenfield",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5095611,
  },
  {
    name: "Bloomfield",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5095779,
  },
  {
    name: "Carteret",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5096316,
  },
  {
    name: "Cliffside Park",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5096686,
  },
  {
    name: "Clifton",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5096699,
  },
  {
    name: "Colonia",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5096798,
  },
  {
    name: "Cranford",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5097017,
  },
  {
    name: "Denville",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5097239,
  },
  {
    name: "Dover",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5097315,
  },
  {
    name: "Dumont",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5097357,
  },
  {
    name: "East Brunswick",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5097402,
  },
  {
    name: "East Orange",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5097441,
  },
  {
    name: "Edison",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5097529,
  },
  {
    name: "Elizabeth",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5097598,
  },
  {
    name: "Elmwood Park",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5097627,
  },
  {
    name: "Englewood",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5097672,
  },
  {
    name: "Ewing",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5097751,
  },
  {
    name: "Fair Lawn",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5097773,
  },
  {
    name: "Fords",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5098109,
  },
  {
    name: "Fort Lee",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5098135,
  },
  {
    name: "Garfield",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5098343,
  },
  {
    name: "Hackensack",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5098706,
  },
  {
    name: "Harrison",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5098863,
  },
  {
    name: "Hawthorne",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5098909,
  },
  {
    name: "Hillsborough",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5099079,
  },
  {
    name: "Hillside",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5099093,
  },
  {
    name: "Hoboken",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5099133,
  },
  {
    name: "Hopatcong Hills",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5099292,
  },
  {
    name: "Irvington",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5099724,
  },
  {
    name: "Iselin",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5099738,
  },
  {
    name: "Jersey City",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5099836,
  },
  {
    name: "Kearny",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5099967,
  },
  {
    name: "Lakewood",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5100280,
  },
  {
    name: "Linden",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5100506,
  },
  {
    name: "Livingston",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5100572,
  },
  {
    name: "Lodi",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5100604,
  },
  {
    name: "Long Branch",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5100619,
  },
  {
    name: "Lyndhurst",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5100706,
  },
  {
    name: "Madison",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5100748,
  },
  {
    name: "Mahwah",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5100776,
  },
  {
    name: "Maplewood",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5100854,
  },
  {
    name: "Marlboro",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5100886,
  },
  {
    name: "Middletown",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5101170,
  },
  {
    name: "Montclair",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5101334,
  },
  {
    name: "Morristown",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5101427,
  },
  {
    name: "New Brunswick",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5101717,
  },
  {
    name: "New Milford",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5101766,
  },
  {
    name: "Newark",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5101798,
  },
  {
    name: "North Arlington",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5101873,
  },
  {
    name: "North Bergen",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5101879,
  },
  {
    name: "North Plainfield",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5101938,
  },
  {
    name: "Nutley",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5102076,
  },
  {
    name: "Old Bridge",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5102162,
  },
  {
    name: "Orange",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5102213,
  },
  {
    name: "Palisades Park",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5102369,
  },
  {
    name: "Paramus",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5102387,
  },
  {
    name: "Parsippany",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5102427,
  },
  {
    name: "Passaic",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5102443,
  },
  {
    name: "Paterson",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5102466,
  },
  {
    name: "Perth Amboy",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5102578,
  },
  {
    name: "Piscataway",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5102713,
  },
  {
    name: "Plainfield",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5102720,
  },
  {
    name: "Point Pleasant",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5102796,
  },
  {
    name: "Princeton",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5102922,
  },
  {
    name: "Rahway",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5103055,
  },
  {
    name: "Ramsey",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5103086,
  },
  {
    name: "Ridgewood",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5103269,
  },
  {
    name: "Roselle",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5103500,
  },
  {
    name: "Rutherford",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5103580,
  },
  {
    name: "Sayreville",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5104404,
  },
  {
    name: "Sayreville Junction",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5104405,
  },
  {
    name: "Scotch Plains",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5104473,
  },
  {
    name: "Secaucus",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5104504,
  },
  {
    name: "Somerset",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5104755,
  },
  {
    name: "South Old Bridge",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5104835,
  },
  {
    name: "South Orange",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5104836,
  },
  {
    name: "South Plainfield",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5104844,
  },
  {
    name: "South River",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5104853,
  },
  {
    name: "Sparta",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5104882,
  },
  {
    name: "Summit",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5105127,
  },
  {
    name: "Teaneck",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5105262,
  },
  {
    name: "Tinton Falls",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5105433,
  },
  {
    name: "Trenton",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5105496,
  },
  {
    name: "Union",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5105608,
  },
  {
    name: "Union City",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5105634,
  },
  {
    name: "Voorhees",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5105860,
  },
  {
    name: "Wayne",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5106160,
  },
  {
    name: "West Milford",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5106279,
  },
  {
    name: "West New York",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5106292,
  },
  {
    name: "West Orange",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5106298,
  },
  {
    name: "Westfield",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5106331,
  },
  {
    name: "Willingboro",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5106453,
  },
  {
    name: "Woodbridge",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5106529,
  },
  {
    name: "Wyckoff",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 5106615,
  },
  {
    name: "Albany",
    country: "United States",
    subcountry: "New York",
    geonameid: 5106834,
  },
  {
    name: "Amherst",
    country: "United States",
    subcountry: "New York",
    geonameid: 5107129,
  },
  {
    name: "Amsterdam",
    country: "United States",
    subcountry: "New York",
    geonameid: 5107152,
  },
  {
    name: "Astoria",
    country: "United States",
    subcountry: "New York",
    geonameid: 5107464,
  },
  {
    name: "Auburn",
    country: "United States",
    subcountry: "New York",
    geonameid: 5107505,
  },
  {
    name: "Baldwin",
    country: "United States",
    subcountry: "New York",
    geonameid: 5107760,
  },
  {
    name: "Batavia",
    country: "United States",
    subcountry: "New York",
    geonameid: 5108093,
  },
  {
    name: "Bath Beach",
    country: "United States",
    subcountry: "New York",
    geonameid: 5108111,
  },
  {
    name: "Bay Shore",
    country: "United States",
    subcountry: "New York",
    geonameid: 5108169,
  },
  {
    name: "Baychester",
    country: "United States",
    subcountry: "New York",
    geonameid: 5108186,
  },
  {
    name: "Bayside",
    country: "United States",
    subcountry: "New York",
    geonameid: 5108193,
  },
  {
    name: "Bellmore",
    country: "United States",
    subcountry: "New York",
    geonameid: 5108707,
  },
  {
    name: "Bensonhurst",
    country: "United States",
    subcountry: "New York",
    geonameid: 5108815,
  },
  {
    name: "Bethpage",
    country: "United States",
    subcountry: "New York",
    geonameid: 5108955,
  },
  {
    name: "Binghamton",
    country: "United States",
    subcountry: "New York",
    geonameid: 5109177,
  },
  {
    name: "Borough Park",
    country: "United States",
    subcountry: "New York",
    geonameid: 5109790,
  },
  {
    name: "Brentwood",
    country: "United States",
    subcountry: "New York",
    geonameid: 5110077,
  },
  {
    name: "Brighton",
    country: "United States",
    subcountry: "New York",
    geonameid: 5110159,
  },
  {
    name: "Brighton Beach",
    country: "United States",
    subcountry: "New York",
    geonameid: 5110161,
  },
  {
    name: "The Bronx",
    country: "United States",
    subcountry: "New York",
    geonameid: 5110266,
  },
  {
    name: "Brooklyn",
    country: "United States",
    subcountry: "New York",
    geonameid: 5110302,
  },
  {
    name: "Brooklyn Heights",
    country: "United States",
    subcountry: "New York",
    geonameid: 5110309,
  },
  {
    name: "Brownsville",
    country: "United States",
    subcountry: "New York",
    geonameid: 5110446,
  },
  {
    name: "Buffalo",
    country: "United States",
    subcountry: "New York",
    geonameid: 5110629,
  },
  {
    name: "Bushwick",
    country: "United States",
    subcountry: "New York",
    geonameid: 5110918,
  },
  {
    name: "Cambria Heights",
    country: "United States",
    subcountry: "New York",
    geonameid: 5111141,
  },
  {
    name: "Canarsie",
    country: "United States",
    subcountry: "New York",
    geonameid: 5111412,
  },
  {
    name: "Centereach",
    country: "United States",
    subcountry: "New York",
    geonameid: 5112035,
  },
  {
    name: "Central Islip",
    country: "United States",
    subcountry: "New York",
    geonameid: 5112078,
  },
  {
    name: "Cheektowaga",
    country: "United States",
    subcountry: "New York",
    geonameid: 5112375,
  },
  {
    name: "Chinatown",
    country: "United States",
    subcountry: "New York",
    geonameid: 5112540,
  },
  {
    name: "Cicero",
    country: "United States",
    subcountry: "New York",
    geonameid: 5112710,
  },
  {
    name: "Clay",
    country: "United States",
    subcountry: "New York",
    geonameid: 5112861,
  },
  {
    name: "Clifton Park",
    country: "United States",
    subcountry: "New York",
    geonameid: 5112961,
  },
  {
    name: "Cohoes",
    country: "United States",
    subcountry: "New York",
    geonameid: 5113142,
  },
  {
    name: "College Point",
    country: "United States",
    subcountry: "New York",
    geonameid: 5113302,
  },
  {
    name: "Commack",
    country: "United States",
    subcountry: "New York",
    geonameid: 5113412,
  },
  {
    name: "Coney Island",
    country: "United States",
    subcountry: "New York",
    geonameid: 5113481,
  },
  {
    name: "Copiague",
    country: "United States",
    subcountry: "New York",
    geonameid: 5113683,
  },
  {
    name: "Coram",
    country: "United States",
    subcountry: "New York",
    geonameid: 5113694,
  },
  {
    name: "Corona",
    country: "United States",
    subcountry: "New York",
    geonameid: 5113779,
  },
  {
    name: "Cortland",
    country: "United States",
    subcountry: "New York",
    geonameid: 5113790,
  },
  {
    name: "Cypress Hills",
    country: "United States",
    subcountry: "New York",
    geonameid: 5114418,
  },
  {
    name: "Deer Park",
    country: "United States",
    subcountry: "New York",
    geonameid: 5114731,
  },
  {
    name: "Depew",
    country: "United States",
    subcountry: "New York",
    geonameid: 5114900,
  },
  {
    name: "Dix Hills",
    country: "United States",
    subcountry: "New York",
    geonameid: 5115107,
  },
  {
    name: "Dyker Heights",
    country: "United States",
    subcountry: "New York",
    geonameid: 5115614,
  },
  {
    name: "East Amherst",
    country: "United States",
    subcountry: "New York",
    geonameid: 5115699,
  },
  {
    name: "East Elmhurst",
    country: "United States",
    subcountry: "New York",
    geonameid: 5115835,
  },
  {
    name: "East Flatbush",
    country: "United States",
    subcountry: "New York",
    geonameid: 5115843,
  },
  {
    name: "East Meadow",
    country: "United States",
    subcountry: "New York",
    geonameid: 5115960,
  },
  {
    name: "East Massapequa",
    country: "United States",
    subcountry: "New York",
    geonameid: 5115962,
  },
  {
    name: "East New York",
    country: "United States",
    subcountry: "New York",
    geonameid: 5115985,
  },
  {
    name: "East Northport",
    country: "United States",
    subcountry: "New York",
    geonameid: 5115989,
  },
  {
    name: "East Patchogue",
    country: "United States",
    subcountry: "New York",
    geonameid: 5116004,
  },
  {
    name: "East Setauket",
    country: "United States",
    subcountry: "New York",
    geonameid: 5116060,
  },
  {
    name: "East Tremont",
    country: "United States",
    subcountry: "New York",
    geonameid: 5116083,
  },
  {
    name: "East Village",
    country: "United States",
    subcountry: "New York",
    geonameid: 5116093,
  },
  {
    name: "Eastchester",
    country: "United States",
    subcountry: "New York",
    geonameid: 5116118,
  },
  {
    name: "Eggertsville",
    country: "United States",
    subcountry: "New York",
    geonameid: 5116303,
  },
  {
    name: "Elmhurst",
    country: "United States",
    subcountry: "New York",
    geonameid: 5116495,
  },
  {
    name: "Elmira",
    country: "United States",
    subcountry: "New York",
    geonameid: 5116497,
  },
  {
    name: "Elmont",
    country: "United States",
    subcountry: "New York",
    geonameid: 5116508,
  },
  {
    name: "Emerson Hill",
    country: "United States",
    subcountry: "New York",
    geonameid: 5116570,
  },
  {
    name: "Far Rockaway",
    country: "United States",
    subcountry: "New York",
    geonameid: 5116917,
  },
  {
    name: "Farmingville",
    country: "United States",
    subcountry: "New York",
    geonameid: 5116937,
  },
  {
    name: "Flatbush",
    country: "United States",
    subcountry: "New York",
    geonameid: 5117378,
  },
  {
    name: "Flatlands",
    country: "United States",
    subcountry: "New York",
    geonameid: 5117388,
  },
  {
    name: "Floral Park",
    country: "United States",
    subcountry: "New York",
    geonameid: 5117438,
  },
  {
    name: "Fordham",
    country: "United States",
    subcountry: "New York",
    geonameid: 5117549,
  },
  {
    name: "Forest Hills",
    country: "United States",
    subcountry: "New York",
    geonameid: 5117575,
  },
  {
    name: "Fort Hamilton",
    country: "United States",
    subcountry: "New York",
    geonameid: 5117663,
  },
  {
    name: "Franklin Square",
    country: "United States",
    subcountry: "New York",
    geonameid: 5117891,
  },
  {
    name: "Freeport",
    country: "United States",
    subcountry: "New York",
    geonameid: 5117949,
  },
  {
    name: "Fresh Meadows",
    country: "United States",
    subcountry: "New York",
    geonameid: 5118005,
  },
  {
    name: "Garden City",
    country: "United States",
    subcountry: "New York",
    geonameid: 5118226,
  },
  {
    name: "Glen Cove",
    country: "United States",
    subcountry: "New York",
    geonameid: 5118626,
  },
  {
    name: "Glendale",
    country: "United States",
    subcountry: "New York",
    geonameid: 5118670,
  },
  {
    name: "Gloversville",
    country: "United States",
    subcountry: "New York",
    geonameid: 5118743,
  },
  {
    name: "Grand Island",
    country: "United States",
    subcountry: "New York",
    geonameid: 5119019,
  },
  {
    name: "Graniteville",
    country: "United States",
    subcountry: "New York",
    geonameid: 5119049,
  },
  {
    name: "Gravesend",
    country: "United States",
    subcountry: "New York",
    geonameid: 5119167,
  },
  {
    name: "Great Kills",
    country: "United States",
    subcountry: "New York",
    geonameid: 5119211,
  },
  {
    name: "Greenburgh",
    country: "United States",
    subcountry: "New York",
    geonameid: 5119347,
  },
  {
    name: "Greenpoint",
    country: "United States",
    subcountry: "New York",
    geonameid: 5119383,
  },
  {
    name: "Harlem",
    country: "United States",
    subcountry: "New York",
    geonameid: 5120034,
  },
  {
    name: "Harrison",
    country: "United States",
    subcountry: "New York",
    geonameid: 5120095,
  },
  {
    name: "Hauppauge",
    country: "United States",
    subcountry: "New York",
    geonameid: 5120228,
  },
  {
    name: "Hell's Kitchen",
    country: "United States",
    subcountry: "New York",
    geonameid: 5120442,
  },
  {
    name: "Hempstead",
    country: "United States",
    subcountry: "New York",
    geonameid: 5120478,
  },
  {
    name: "Henrietta",
    country: "United States",
    subcountry: "New York",
    geonameid: 5120521,
  },
  {
    name: "Hicksville",
    country: "United States",
    subcountry: "New York",
    geonameid: 5120656,
  },
  {
    name: "Hillside",
    country: "United States",
    subcountry: "New York",
    geonameid: 5120824,
  },
  {
    name: "Holbrook",
    country: "United States",
    subcountry: "New York",
    geonameid: 5120987,
  },
  {
    name: "Hollis",
    country: "United States",
    subcountry: "New York",
    geonameid: 5121026,
  },
  {
    name: "Holtsville",
    country: "United States",
    subcountry: "New York",
    geonameid: 5121163,
  },
  {
    name: "Howard Beach",
    country: "United States",
    subcountry: "New York",
    geonameid: 5121407,
  },
  {
    name: "Huntington",
    country: "United States",
    subcountry: "New York",
    geonameid: 5121636,
  },
  {
    name: "Huntington Station",
    country: "United States",
    subcountry: "New York",
    geonameid: 5121650,
  },
  {
    name: "Hunts Point",
    country: "United States",
    subcountry: "New York",
    geonameid: 5121666,
  },
  {
    name: "Irondequoit",
    country: "United States",
    subcountry: "New York",
    geonameid: 5122331,
  },
  {
    name: "Islip",
    country: "United States",
    subcountry: "New York",
    geonameid: 5122413,
  },
  {
    name: "Ithaca",
    country: "United States",
    subcountry: "New York",
    geonameid: 5122432,
  },
  {
    name: "Jackson Heights",
    country: "United States",
    subcountry: "New York",
    geonameid: 5122477,
  },
  {
    name: "Jamaica",
    country: "United States",
    subcountry: "New York",
    geonameid: 5122520,
  },
  {
    name: "Jamestown",
    country: "United States",
    subcountry: "New York",
    geonameid: 5122534,
  },
  {
    name: "Kenmore",
    country: "United States",
    subcountry: "New York",
    geonameid: 5123247,
  },
  {
    name: "Kensington",
    country: "United States",
    subcountry: "New York",
    geonameid: 5123280,
  },
  {
    name: "Kew Gardens",
    country: "United States",
    subcountry: "New York",
    geonameid: 5123344,
  },
  {
    name: "Kings Bridge",
    country: "United States",
    subcountry: "New York",
    geonameid: 5123443,
  },
  {
    name: "Kings Park",
    country: "United States",
    subcountry: "New York",
    geonameid: 5123456,
  },
  {
    name: "Kingston",
    country: "United States",
    subcountry: "New York",
    geonameid: 5123477,
  },
  {
    name: "Kiryas Joel",
    country: "United States",
    subcountry: "New York",
    geonameid: 5123533,
  },
  {
    name: "Lackawanna",
    country: "United States",
    subcountry: "New York",
    geonameid: 5123718,
  },
  {
    name: "Lake Ronkonkoma",
    country: "United States",
    subcountry: "New York",
    geonameid: 5123840,
  },
  {
    name: "Latham",
    country: "United States",
    subcountry: "New York",
    geonameid: 5124045,
  },
  {
    name: "Laurelton",
    country: "United States",
    subcountry: "New York",
    geonameid: 5124078,
  },
  {
    name: "Levittown",
    country: "United States",
    subcountry: "New York",
    geonameid: 5124276,
  },
  {
    name: "Lindenhurst",
    country: "United States",
    subcountry: "New York",
    geonameid: 5124497,
  },
  {
    name: "Lockport",
    country: "United States",
    subcountry: "New York",
    geonameid: 5125011,
  },
  {
    name: "Long Beach",
    country: "United States",
    subcountry: "New York",
    geonameid: 5125086,
  },
  {
    name: "Long Island City",
    country: "United States",
    subcountry: "New York",
    geonameid: 5125125,
  },
  {
    name: "Lynbrook",
    country: "United States",
    subcountry: "New York",
    geonameid: 5125523,
  },
  {
    name: "Mamaroneck",
    country: "United States",
    subcountry: "New York",
    geonameid: 5125738,
  },
  {
    name: "Manhattan",
    country: "United States",
    subcountry: "New York",
    geonameid: 5125771,
  },
  {
    name: "Mariners Harbor",
    country: "United States",
    subcountry: "New York",
    geonameid: 5126013,
  },
  {
    name: "Maspeth",
    country: "United States",
    subcountry: "New York",
    geonameid: 5126180,
  },
  {
    name: "Massapequa",
    country: "United States",
    subcountry: "New York",
    geonameid: 5126183,
  },
  {
    name: "Massapequa Park",
    country: "United States",
    subcountry: "New York",
    geonameid: 5126187,
  },
  {
    name: "Mastic",
    country: "United States",
    subcountry: "New York",
    geonameid: 5126208,
  },
  {
    name: "Medford",
    country: "United States",
    subcountry: "New York",
    geonameid: 5126518,
  },
  {
    name: "Melrose",
    country: "United States",
    subcountry: "New York",
    geonameid: 5126550,
  },
  {
    name: "Melville",
    country: "United States",
    subcountry: "New York",
    geonameid: 5126555,
  },
  {
    name: "Merrick",
    country: "United States",
    subcountry: "New York",
    geonameid: 5126630,
  },
  {
    name: "Middle Village",
    country: "United States",
    subcountry: "New York",
    geonameid: 5126827,
  },
  {
    name: "Middletown",
    country: "United States",
    subcountry: "New York",
    geonameid: 5126842,
  },
  {
    name: "Mineola",
    country: "United States",
    subcountry: "New York",
    geonameid: 5127134,
  },
  {
    name: "Monsey",
    country: "United States",
    subcountry: "New York",
    geonameid: 5127315,
  },
  {
    name: "Morris Heights",
    country: "United States",
    subcountry: "New York",
    geonameid: 5127536,
  },
  {
    name: "Morrisania",
    country: "United States",
    subcountry: "New York",
    geonameid: 5127550,
  },
  {
    name: "Mott Haven",
    country: "United States",
    subcountry: "New York",
    geonameid: 5127670,
  },
  {
    name: "Mount Vernon",
    country: "United States",
    subcountry: "New York",
    geonameid: 5127835,
  },
  {
    name: "Nanuet",
    country: "United States",
    subcountry: "New York",
    geonameid: 5128266,
  },
  {
    name: "New City",
    country: "United States",
    subcountry: "New York",
    geonameid: 5128481,
  },
  {
    name: "New Rochelle",
    country: "United States",
    subcountry: "New York",
    geonameid: 5128549,
  },
  {
    name: "New Springville",
    country: "United States",
    subcountry: "New York",
    geonameid: 5128566,
  },
  {
    name: "New York City",
    country: "United States",
    subcountry: "New York",
    geonameid: 5128581,
  },
  {
    name: "Newburgh",
    country: "United States",
    subcountry: "New York",
    geonameid: 5128654,
  },
  {
    name: "Niagara Falls",
    country: "United States",
    subcountry: "New York",
    geonameid: 5128723,
  },
  {
    name: "North Amityville",
    country: "United States",
    subcountry: "New York",
    geonameid: 5128884,
  },
  {
    name: "North Babylon",
    country: "United States",
    subcountry: "New York",
    geonameid: 5128886,
  },
  {
    name: "North Bay Shore",
    country: "United States",
    subcountry: "New York",
    geonameid: 5128898,
  },
  {
    name: "North Bellmore",
    country: "United States",
    subcountry: "New York",
    geonameid: 5128904,
  },
  {
    name: "North Massapequa",
    country: "United States",
    subcountry: "New York",
    geonameid: 5129134,
  },
  {
    name: "North Tonawanda",
    country: "United States",
    subcountry: "New York",
    geonameid: 5129245,
  },
  {
    name: "North Valley Stream",
    country: "United States",
    subcountry: "New York",
    geonameid: 5129248,
  },
  {
    name: "Oceanside",
    country: "United States",
    subcountry: "New York",
    geonameid: 5129603,
  },
  {
    name: "Ossining",
    country: "United States",
    subcountry: "New York",
    geonameid: 5130045,
  },
  {
    name: "Oswego",
    country: "United States",
    subcountry: "New York",
    geonameid: 5130081,
  },
  {
    name: "Ozone Park",
    country: "United States",
    subcountry: "New York",
    geonameid: 5130334,
  },
  {
    name: "Park Slope",
    country: "United States",
    subcountry: "New York",
    geonameid: 5130561,
  },
  {
    name: "Parkchester",
    country: "United States",
    subcountry: "New York",
    geonameid: 5130572,
  },
  {
    name: "Pearl River",
    country: "United States",
    subcountry: "New York",
    geonameid: 5130780,
  },
  {
    name: "Peekskill",
    country: "United States",
    subcountry: "New York",
    geonameid: 5130831,
  },
  {
    name: "Plainview",
    country: "United States",
    subcountry: "New York",
    geonameid: 5131638,
  },
  {
    name: "Plattsburgh",
    country: "United States",
    subcountry: "New York",
    geonameid: 5131692,
  },
  {
    name: "Port Chester",
    country: "United States",
    subcountry: "New York",
    geonameid: 5132002,
  },
  {
    name: "Port Richmond",
    country: "United States",
    subcountry: "New York",
    geonameid: 5132028,
  },
  {
    name: "Port Washington",
    country: "United States",
    subcountry: "New York",
    geonameid: 5132029,
  },
  {
    name: "Poughkeepsie",
    country: "United States",
    subcountry: "New York",
    geonameid: 5132143,
  },
  {
    name: "Queens Village",
    country: "United States",
    subcountry: "New York",
    geonameid: 5133271,
  },
  {
    name: "Queens",
    country: "United States",
    subcountry: "New York",
    geonameid: 5133273,
  },
  {
    name: "Queensbury",
    country: "United States",
    subcountry: "New York",
    geonameid: 5133279,
  },
  {
    name: "Rego Park",
    country: "United States",
    subcountry: "New York",
    geonameid: 5133640,
  },
  {
    name: "Richmond Hill",
    country: "United States",
    subcountry: "New York",
    geonameid: 5133825,
  },
  {
    name: "Ridgewood",
    country: "United States",
    subcountry: "New York",
    geonameid: 5133858,
  },
  {
    name: "Rochester",
    country: "United States",
    subcountry: "New York",
    geonameid: 5134086,
  },
  {
    name: "Rockville Centre",
    country: "United States",
    subcountry: "New York",
    geonameid: 5134203,
  },
  {
    name: "Rome",
    country: "United States",
    subcountry: "New York",
    geonameid: 5134295,
  },
  {
    name: "Ronkonkoma",
    country: "United States",
    subcountry: "New York",
    geonameid: 5134316,
  },
  {
    name: "Roosevelt",
    country: "United States",
    subcountry: "New York",
    geonameid: 5134323,
  },
  {
    name: "Rosedale",
    country: "United States",
    subcountry: "New York",
    geonameid: 5134395,
  },
  {
    name: "Rossville",
    country: "United States",
    subcountry: "New York",
    geonameid: 5134449,
  },
  {
    name: "Rotterdam",
    country: "United States",
    subcountry: "New York",
    geonameid: 5134453,
  },
  {
    name: "Rye",
    country: "United States",
    subcountry: "New York",
    geonameid: 5134693,
  },
  {
    name: "Saratoga Springs",
    country: "United States",
    subcountry: "New York",
    geonameid: 5136334,
  },
  {
    name: "Sayville",
    country: "United States",
    subcountry: "New York",
    geonameid: 5136421,
  },
  {
    name: "Scarsdale",
    country: "United States",
    subcountry: "New York",
    geonameid: 5136433,
  },
  {
    name: "Schenectady",
    country: "United States",
    subcountry: "New York",
    geonameid: 5136454,
  },
  {
    name: "Seaford",
    country: "United States",
    subcountry: "New York",
    geonameid: 5137507,
  },
  {
    name: "Selden",
    country: "United States",
    subcountry: "New York",
    geonameid: 5137600,
  },
  {
    name: "Sheepshead Bay",
    country: "United States",
    subcountry: "New York",
    geonameid: 5137849,
  },
  {
    name: "Shirley",
    country: "United States",
    subcountry: "New York",
    geonameid: 5138022,
  },
  {
    name: "Smithtown",
    country: "United States",
    subcountry: "New York",
    geonameid: 5138539,
  },
  {
    name: "South Ozone Park",
    country: "United States",
    subcountry: "New York",
    geonameid: 5138950,
  },
  {
    name: "Springfield Gardens",
    country: "United States",
    subcountry: "New York",
    geonameid: 5139287,
  },
  {
    name: "Spring Valley",
    country: "United States",
    subcountry: "New York",
    geonameid: 5139301,
  },
  {
    name: "Staten Island",
    country: "United States",
    subcountry: "New York",
    geonameid: 5139568,
  },
  {
    name: "Sunnyside",
    country: "United States",
    subcountry: "New York",
    geonameid: 5140221,
  },
  {
    name: "Syosset",
    country: "United States",
    subcountry: "New York",
    geonameid: 5140402,
  },
  {
    name: "Syracuse",
    country: "United States",
    subcountry: "New York",
    geonameid: 5140405,
  },
  {
    name: "Terrace Heights",
    country: "United States",
    subcountry: "New York",
    geonameid: 5140675,
  },
  {
    name: "Throgs Neck",
    country: "United States",
    subcountry: "New York",
    geonameid: 5140945,
  },
  {
    name: "Tremont",
    country: "United States",
    subcountry: "New York",
    geonameid: 5141342,
  },
  {
    name: "Troy",
    country: "United States",
    subcountry: "New York",
    geonameid: 5141502,
  },
  {
    name: "Uniondale",
    country: "United States",
    subcountry: "New York",
    geonameid: 5141927,
  },
  {
    name: "Unionport",
    country: "United States",
    subcountry: "New York",
    geonameid: 5141930,
  },
  {
    name: "University Heights",
    country: "United States",
    subcountry: "New York",
    geonameid: 5141963,
  },
  {
    name: "Utica",
    country: "United States",
    subcountry: "New York",
    geonameid: 5142056,
  },
  {
    name: "Valley Stream",
    country: "United States",
    subcountry: "New York",
    geonameid: 5142109,
  },
  {
    name: "Van Nest",
    country: "United States",
    subcountry: "New York",
    geonameid: 5142182,
  },
  {
    name: "Vestal",
    country: "United States",
    subcountry: "New York",
    geonameid: 5142296,
  },
  {
    name: "Wakefield",
    country: "United States",
    subcountry: "New York",
    geonameid: 5143056,
  },
  {
    name: "Wantagh",
    country: "United States",
    subcountry: "New York",
    geonameid: 5143198,
  },
  {
    name: "Washington Heights",
    country: "United States",
    subcountry: "New York",
    geonameid: 5143307,
  },
  {
    name: "Watertown",
    country: "United States",
    subcountry: "New York",
    geonameid: 5143396,
  },
  {
    name: "West Albany",
    country: "United States",
    subcountry: "New York",
    geonameid: 5143620,
  },
  {
    name: "West Babylon",
    country: "United States",
    subcountry: "New York",
    geonameid: 5143630,
  },
  {
    name: "West Hempstead",
    country: "United States",
    subcountry: "New York",
    geonameid: 5143832,
  },
  {
    name: "West Islip",
    country: "United States",
    subcountry: "New York",
    geonameid: 5143866,
  },
  {
    name: "West Seneca",
    country: "United States",
    subcountry: "New York",
    geonameid: 5143992,
  },
  {
    name: "Westbury",
    country: "United States",
    subcountry: "New York",
    geonameid: 5144040,
  },
  {
    name: "White Plains",
    country: "United States",
    subcountry: "New York",
    geonameid: 5144336,
  },
  {
    name: "Whitestone",
    country: "United States",
    subcountry: "New York",
    geonameid: 5144400,
  },
  {
    name: "Williamsburg",
    country: "United States",
    subcountry: "New York",
    geonameid: 5144580,
  },
  {
    name: "Woodhaven",
    country: "United States",
    subcountry: "New York",
    geonameid: 5144975,
  },
  {
    name: "Woodmere",
    country: "United States",
    subcountry: "New York",
    geonameid: 5145028,
  },
  {
    name: "Woodrow",
    country: "United States",
    subcountry: "New York",
    geonameid: 5145034,
  },
  {
    name: "Woodside",
    country: "United States",
    subcountry: "New York",
    geonameid: 5145067,
  },
  {
    name: "Yonkers",
    country: "United States",
    subcountry: "New York",
    geonameid: 5145215,
  },
  {
    name: "Akron",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5145476,
  },
  {
    name: "Alliance",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5145607,
  },
  {
    name: "Ashland",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5146055,
  },
  {
    name: "Ashtabula",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5146089,
  },
  {
    name: "Aurora",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5146233,
  },
  {
    name: "Austintown",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5146256,
  },
  {
    name: "Avon",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5146277,
  },
  {
    name: "Avon Center",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5146282,
  },
  {
    name: "Avon Lake",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5146286,
  },
  {
    name: "Barberton",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5146491,
  },
  {
    name: "Bay Village",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5146675,
  },
  {
    name: "Berea",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5147097,
  },
  {
    name: "Boardman",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5147784,
  },
  {
    name: "Bowling Green",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5147968,
  },
  {
    name: "Broadview Heights",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5148273,
  },
  {
    name: "Brook Park",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5148326,
  },
  {
    name: "Brunswick",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5148480,
  },
  {
    name: "Canton",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5149222,
  },
  {
    name: "Cleveland",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5150529,
  },
  {
    name: "Collinwood",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5150792,
  },
  {
    name: "Cuyahoga Falls",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5151613,
  },
  {
    name: "Defiance",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5151861,
  },
  {
    name: "Delaware",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5151891,
  },
  {
    name: "Dublin",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5152333,
  },
  {
    name: "East Cleveland",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5152599,
  },
  {
    name: "Eastlake",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5152833,
  },
  {
    name: "Elyria",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5153207,
  },
  {
    name: "Euclid",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5153420,
  },
  {
    name: "Fairview Park",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5153680,
  },
  {
    name: "Findlay",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5153924,
  },
  {
    name: "Fremont",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5155207,
  },
  {
    name: "Gahanna",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5155393,
  },
  {
    name: "Garfield Heights",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5155499,
  },
  {
    name: "Glenville",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5155858,
  },
  {
    name: "Green",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5156371,
  },
  {
    name: "Hilliard",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5157588,
  },
  {
    name: "Hough",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5158067,
  },
  {
    name: "Hudson",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5158164,
  },
  {
    name: "Kent",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5159537,
  },
  {
    name: "Lakewood",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5160315,
  },
  {
    name: "Lima",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5160783,
  },
  {
    name: "Lorain",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5161262,
  },
  {
    name: "Mansfield",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5161723,
  },
  {
    name: "Maple Heights",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5161803,
  },
  {
    name: "Marion",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5161902,
  },
  {
    name: "Marysville",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5162077,
  },
  {
    name: "Massillon",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5162097,
  },
  {
    name: "Mayfield Heights",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5162188,
  },
  {
    name: "Medina",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5162512,
  },
  {
    name: "Mentor",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5162645,
  },
  {
    name: "Middleburg Heights",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5162851,
  },
  {
    name: "Mount Vernon",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5163799,
  },
  {
    name: "New Philadelphia",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5164390,
  },
  {
    name: "Newark",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5164466,
  },
  {
    name: "Niles",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5164582,
  },
  {
    name: "North Canton",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5164706,
  },
  {
    name: "North Olmsted",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5164862,
  },
  {
    name: "North Ridgeville",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5164903,
  },
  {
    name: "North Royalton",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5164916,
  },
  {
    name: "Norwalk",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5165101,
  },
  {
    name: "Oregon",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5165734,
  },
  {
    name: "Painesville",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5166009,
  },
  {
    name: "Parma",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5166177,
  },
  {
    name: "Parma Heights",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5166184,
  },
  {
    name: "Perrysburg",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5166516,
  },
  {
    name: "Piqua",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5166819,
  },
  {
    name: "Rocky River",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5168491,
  },
  {
    name: "Sandusky",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5170691,
  },
  {
    name: "Shaker Heights",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5171728,
  },
  {
    name: "Sidney",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5172078,
  },
  {
    name: "Solon",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5172387,
  },
  {
    name: "South Euclid",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5172485,
  },
  {
    name: "Steubenville",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5173048,
  },
  {
    name: "Stow",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5173171,
  },
  {
    name: "Streetsboro",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5173210,
  },
  {
    name: "Strongsville",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5173237,
  },
  {
    name: "Sylvania",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5173572,
  },
  {
    name: "Tallmadge",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5173623,
  },
  {
    name: "Tiffin",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5173930,
  },
  {
    name: "Toledo",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5174035,
  },
  {
    name: "Troy",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5174358,
  },
  {
    name: "Twinsburg",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5174550,
  },
  {
    name: "Wadsworth",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5175496,
  },
  {
    name: "Warren",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5175865,
  },
  {
    name: "Westerville",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5176472,
  },
  {
    name: "Westlake",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5176517,
  },
  {
    name: "Willoughby",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5176937,
  },
  {
    name: "Wooster",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5177358,
  },
  {
    name: "Youngstown",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 5177568,
  },
  {
    name: "Abington",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5177773,
  },
  {
    name: "Allentown",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5178127,
  },
  {
    name: "Allison Park",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5178165,
  },
  {
    name: "Altoona",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5178195,
  },
  {
    name: "Back Mountain",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5178800,
  },
  {
    name: "Baldwin",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5178940,
  },
  {
    name: "Bensalem",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5179995,
  },
  {
    name: "Bethel Park",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5180199,
  },
  {
    name: "Bethlehem",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5180225,
  },
  {
    name: "Carlisle",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5183234,
  },
  {
    name: "Easton",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5188140,
  },
  {
    name: "Erie",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5188843,
  },
  {
    name: "Harrisburg",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5192726,
  },
  {
    name: "Hazleton",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5193011,
  },
  {
    name: "Hermitage",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5193309,
  },
  {
    name: "Johnstown",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5195561,
  },
  {
    name: "King of Prussia",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5196220,
  },
  {
    name: "Lancaster",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5197079,
  },
  {
    name: "Lansdale",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5197159,
  },
  {
    name: "Lebanon",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5197517,
  },
  {
    name: "Levittown",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5197796,
  },
  {
    name: "Limerick",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5198034,
  },
  {
    name: "McKeesport",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5200499,
  },
  {
    name: "Monroeville",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5201734,
  },
  {
    name: "Mount Lebanon",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5202215,
  },
  {
    name: "Murrysville",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5202765,
  },
  {
    name: "New Castle",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5203127,
  },
  {
    name: "Nicetown-Tioga",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5203393,
  },
  {
    name: "Norristown",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5203506,
  },
  {
    name: "Penn Hills",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5205377,
  },
  {
    name: "Phoenixville",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5205849,
  },
  {
    name: "Pittsburgh",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5206379,
  },
  {
    name: "Plum",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5206606,
  },
  {
    name: "Pottstown",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5207069,
  },
  {
    name: "Radnor",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5207490,
  },
  {
    name: "Reading",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5207728,
  },
  {
    name: "Scranton",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5211303,
  },
  {
    name: "State College",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5213681,
  },
  {
    name: "Upper Saint Clair",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5216895,
  },
  {
    name: "Wayne",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5218270,
  },
  {
    name: "West Mifflin",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5218802,
  },
  {
    name: "Whitehall Township",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5219287,
  },
  {
    name: "Wilkes-Barre",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5219488,
  },
  {
    name: "Wilkinsburg",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5219501,
  },
  {
    name: "Williamsport",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5219585,
  },
  {
    name: "Willow Grove",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 5219619,
  },
  {
    name: "Barrington",
    country: "United States",
    subcountry: "Rhode Island",
    geonameid: 5220798,
  },
  {
    name: "Bristol",
    country: "United States",
    subcountry: "Rhode Island",
    geonameid: 5221077,
  },
  {
    name: "Central Falls",
    country: "United States",
    subcountry: "Rhode Island",
    geonameid: 5221341,
  },
  {
    name: "Coventry",
    country: "United States",
    subcountry: "Rhode Island",
    geonameid: 5221637,
  },
  {
    name: "Cranston",
    country: "United States",
    subcountry: "Rhode Island",
    geonameid: 5221659,
  },
  {
    name: "Cumberland",
    country: "United States",
    subcountry: "Rhode Island",
    geonameid: 5221703,
  },
  {
    name: "East Providence",
    country: "United States",
    subcountry: "Rhode Island",
    geonameid: 5221931,
  },
  {
    name: "Middletown",
    country: "United States",
    subcountry: "Rhode Island",
    geonameid: 5223358,
  },
  {
    name: "Narragansett",
    country: "United States",
    subcountry: "Rhode Island",
    geonameid: 5223505,
  },
  {
    name: "Newport",
    country: "United States",
    subcountry: "Rhode Island",
    geonameid: 5223593,
  },
  {
    name: "North Kingstown",
    country: "United States",
    subcountry: "Rhode Island",
    geonameid: 5223672,
  },
  {
    name: "North Providence",
    country: "United States",
    subcountry: "Rhode Island",
    geonameid: 5223681,
  },
  {
    name: "Pawtucket",
    country: "United States",
    subcountry: "Rhode Island",
    geonameid: 5223869,
  },
  {
    name: "Portsmouth",
    country: "United States",
    subcountry: "Rhode Island",
    geonameid: 5224082,
  },
  {
    name: "Providence",
    country: "United States",
    subcountry: "Rhode Island",
    geonameid: 5224151,
  },
  {
    name: "Smithfield",
    country: "United States",
    subcountry: "Rhode Island",
    geonameid: 5224949,
  },
  {
    name: "Warwick",
    country: "United States",
    subcountry: "Rhode Island",
    geonameid: 5225507,
  },
  {
    name: "West Warwick",
    country: "United States",
    subcountry: "Rhode Island",
    geonameid: 5225627,
  },
  {
    name: "Westerly",
    country: "United States",
    subcountry: "Rhode Island",
    geonameid: 5225631,
  },
  {
    name: "Woonsocket",
    country: "United States",
    subcountry: "Rhode Island",
    geonameid: 5225809,
  },
  {
    name: "Aberdeen",
    country: "United States",
    subcountry: "South Dakota",
    geonameid: 5225857,
  },
  {
    name: "Brookings",
    country: "United States",
    subcountry: "South Dakota",
    geonameid: 5226534,
  },
  {
    name: "Mitchell",
    country: "United States",
    subcountry: "South Dakota",
    geonameid: 5229794,
  },
  {
    name: "Sioux Falls",
    country: "United States",
    subcountry: "South Dakota",
    geonameid: 5231851,
  },
  {
    name: "Watertown",
    country: "United States",
    subcountry: "South Dakota",
    geonameid: 5232741,
  },
  {
    name: "Burlington",
    country: "United States",
    subcountry: "Vermont",
    geonameid: 5234372,
  },
  {
    name: "Colchester",
    country: "United States",
    subcountry: "Vermont",
    geonameid: 5235024,
  },
  {
    name: "Rutland",
    country: "United States",
    subcountry: "Vermont",
    geonameid: 5240509,
  },
  {
    name: "South Burlington",
    country: "United States",
    subcountry: "Vermont",
    geonameid: 5241248,
  },
  {
    name: "Appleton",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5244080,
  },
  {
    name: "Ashwaubenon",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5244267,
  },
  {
    name: "Beaver Dam",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5245193,
  },
  {
    name: "Bellevue",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5245359,
  },
  {
    name: "Beloit",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5245387,
  },
  {
    name: "Brookfield",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5246835,
  },
  {
    name: "Caledonia",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5247415,
  },
  {
    name: "Cudahy",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5249871,
  },
  {
    name: "De Pere",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5250201,
  },
  {
    name: "Eau Claire",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5251436,
  },
  {
    name: "Fitchburg",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5253219,
  },
  {
    name: "Fond du Lac",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5253352,
  },
  {
    name: "Franklin",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5253710,
  },
  {
    name: "Germantown",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5254218,
  },
  {
    name: "Green Bay",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5254962,
  },
  {
    name: "Greenfield",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5255068,
  },
  {
    name: "Howard",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5257029,
  },
  {
    name: "Janesville",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5257754,
  },
  {
    name: "Kaukauna",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5258296,
  },
  {
    name: "Kenosha",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5258393,
  },
  {
    name: "La Crosse",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5258957,
  },
  {
    name: "Madison",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5261457,
  },
  {
    name: "Manitowoc",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5261585,
  },
  {
    name: "Marshfield",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5261969,
  },
  {
    name: "Menasha",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5262596,
  },
  {
    name: "Menomonee Falls",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5262630,
  },
  {
    name: "Menomonie",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5262634,
  },
  {
    name: "Mequon",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5262649,
  },
  {
    name: "Middleton",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5262838,
  },
  {
    name: "Milwaukee",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5263045,
  },
  {
    name: "Muskego",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5264049,
  },
  {
    name: "Neenah",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5264223,
  },
  {
    name: "New Berlin",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5264381,
  },
  {
    name: "North La Crosse",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5264870,
  },
  {
    name: "Oak Creek",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5265228,
  },
  {
    name: "Oconomowoc",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5265499,
  },
  {
    name: "Onalaska",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5265702,
  },
  {
    name: "Oshkosh",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5265838,
  },
  {
    name: "Pleasant Prairie",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5267403,
  },
  {
    name: "Racine",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5268249,
  },
  {
    name: "River Falls",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5268986,
  },
  {
    name: "Sheboygan",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5272893,
  },
  {
    name: "South Milwaukee",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5273812,
  },
  {
    name: "Stevens Point",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5274644,
  },
  {
    name: "Sun Prairie",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5275020,
  },
  {
    name: "Superior",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5275191,
  },
  {
    name: "Watertown",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5278005,
  },
  {
    name: "Waukesha",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5278052,
  },
  {
    name: "Wausau",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5278120,
  },
  {
    name: "Wauwatosa",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5278159,
  },
  {
    name: "West Allis",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5278420,
  },
  {
    name: "West Bend",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5278422,
  },
  {
    name: "Weston",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5278693,
  },
  {
    name: "Wisconsin Rapids",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 5279436,
  },
  {
    name: "Weirton",
    country: "United States",
    subcountry: "West Virginia",
    geonameid: 5280814,
  },
  {
    name: "Weirton Heights",
    country: "United States",
    subcountry: "West Virginia",
    geonameid: 5280822,
  },
  {
    name: "Wheeling",
    country: "United States",
    subcountry: "West Virginia",
    geonameid: 5280854,
  },
  {
    name: "Ansonia",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 5281551,
  },
  {
    name: "Bloomfield",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 5282526,
  },
  {
    name: "Bridgeport",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 5282804,
  },
  {
    name: "Bristol",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 5282835,
  },
  {
    name: "Branford",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 5283054,
  },
  {
    name: "Cheshire",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 5283837,
  },
  {
    name: "Fillmore",
    country: "United States",
    subcountry: "California",
    geonameid: 5284756,
  },
  {
    name: "Buckeye",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5287262,
  },
  {
    name: "Bullhead City",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5287565,
  },
  {
    name: "Casa Grande",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5288636,
  },
  {
    name: "Casas Adobes",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5288661,
  },
  {
    name: "Catalina Foothills",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5288786,
  },
  {
    name: "Chandler",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5289282,
  },
  {
    name: "Deer Valley",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5292387,
  },
  {
    name: "Douglas",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5293083,
  },
  {
    name: "Drexel Heights",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5293183,
  },
  {
    name: "El Mirage",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5293996,
  },
  {
    name: "Eloy",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5294167,
  },
  {
    name: "Flagstaff",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5294810,
  },
  {
    name: "Florence",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5294902,
  },
  {
    name: "Flowing Wells",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5294937,
  },
  {
    name: "Fortuna Foothills",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5295143,
  },
  {
    name: "Fountain Hills",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5295177,
  },
  {
    name: "Gilbert",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5295903,
  },
  {
    name: "Glendale",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5295985,
  },
  {
    name: "Goodyear",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5296266,
  },
  {
    name: "Green Valley",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5296802,
  },
  {
    name: "Kingman",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5301067,
  },
  {
    name: "Lake Havasu City",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5301388,
  },
  {
    name: "Marana",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5303705,
  },
  {
    name: "Maricopa",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5303752,
  },
  {
    name: "Maryvale",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5303929,
  },
  {
    name: "Mesa",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5304391,
  },
  {
    name: "Nogales",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5306611,
  },
  {
    name: "Oro Valley",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5307540,
  },
  {
    name: "Payson",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5308305,
  },
  {
    name: "Peoria",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5308480,
  },
  {
    name: "Phoenix",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5308655,
  },
  {
    name: "Prescott",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5309842,
  },
  {
    name: "Prescott Valley",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5309858,
  },
  {
    name: "Queen Creek",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5310193,
  },
  {
    name: "Rio Rico",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5311433,
  },
  {
    name: "Sahuarita",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5312544,
  },
  {
    name: "San Luis",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5312913,
  },
  {
    name: "Scottsdale",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5313457,
  },
  {
    name: "Sierra Vista",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5314328,
  },
  {
    name: "Somerton",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5315062,
  },
  {
    name: "Sun City",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5316201,
  },
  {
    name: "Sun City West",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5316205,
  },
  {
    name: "Surprise",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5316428,
  },
  {
    name: "Tanque Verde",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5316890,
  },
  {
    name: "Tempe",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5317058,
  },
  {
    name: "Tempe Junction",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5317071,
  },
  {
    name: "Tucson",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5318313,
  },
  {
    name: "Yuma",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5322053,
  },
  {
    name: "Adelanto",
    country: "United States",
    subcountry: "California",
    geonameid: 5322400,
  },
  {
    name: "Agoura",
    country: "United States",
    subcountry: "California",
    geonameid: 5322551,
  },
  {
    name: "Agoura Hills",
    country: "United States",
    subcountry: "California",
    geonameid: 5322553,
  },
  {
    name: "Alameda",
    country: "United States",
    subcountry: "California",
    geonameid: 5322737,
  },
  {
    name: "Albany",
    country: "United States",
    subcountry: "California",
    geonameid: 5322850,
  },
  {
    name: "Alhambra",
    country: "United States",
    subcountry: "California",
    geonameid: 5323060,
  },
  {
    name: "Aliso Viejo",
    country: "United States",
    subcountry: "California",
    geonameid: 5323163,
  },
  {
    name: "Altadena",
    country: "United States",
    subcountry: "California",
    geonameid: 5323525,
  },
  {
    name: "Alum Rock",
    country: "United States",
    subcountry: "California",
    geonameid: 5323566,
  },
  {
    name: "American Canyon",
    country: "United States",
    subcountry: "California",
    geonameid: 5323694,
  },
  {
    name: "Anaheim",
    country: "United States",
    subcountry: "California",
    geonameid: 5323810,
  },
  {
    name: "Antelope",
    country: "United States",
    subcountry: "California",
    geonameid: 5324105,
  },
  {
    name: "Antioch",
    country: "United States",
    subcountry: "California",
    geonameid: 5324200,
  },
  {
    name: "Apple Valley",
    country: "United States",
    subcountry: "California",
    geonameid: 5324363,
  },
  {
    name: "Arcadia",
    country: "United States",
    subcountry: "California",
    geonameid: 5324477,
  },
  {
    name: "Arroyo Grande",
    country: "United States",
    subcountry: "California",
    geonameid: 5324802,
  },
  {
    name: "Artesia",
    country: "United States",
    subcountry: "California",
    geonameid: 5324862,
  },
  {
    name: "Arvin",
    country: "United States",
    subcountry: "California",
    geonameid: 5324903,
  },
  {
    name: "Ashland",
    country: "United States",
    subcountry: "California",
    geonameid: 5325011,
  },
  {
    name: "Atascadero",
    country: "United States",
    subcountry: "California",
    geonameid: 5325111,
  },
  {
    name: "Atwater",
    country: "United States",
    subcountry: "California",
    geonameid: 5325187,
  },
  {
    name: "Avocado Heights",
    country: "United States",
    subcountry: "California",
    geonameid: 5325372,
  },
  {
    name: "Azusa",
    country: "United States",
    subcountry: "California",
    geonameid: 5325423,
  },
  {
    name: "Bakersfield",
    country: "United States",
    subcountry: "California",
    geonameid: 5325738,
  },
  {
    name: "Baldwin Park",
    country: "United States",
    subcountry: "California",
    geonameid: 5325866,
  },
  {
    name: "Banning",
    country: "United States",
    subcountry: "California",
    geonameid: 5326032,
  },
  {
    name: "Barstow",
    country: "United States",
    subcountry: "California",
    geonameid: 5326297,
  },
  {
    name: "Barstow Heights",
    country: "United States",
    subcountry: "California",
    geonameid: 5326305,
  },
  {
    name: "Bay Point",
    country: "United States",
    subcountry: "California",
    geonameid: 5326561,
  },
  {
    name: "Beaumont",
    country: "United States",
    subcountry: "California",
    geonameid: 5327098,
  },
  {
    name: "Bell",
    country: "United States",
    subcountry: "California",
    geonameid: 5327298,
  },
  {
    name: "Bell Gardens",
    country: "United States",
    subcountry: "California",
    geonameid: 5327319,
  },
  {
    name: "Bellflower",
    country: "United States",
    subcountry: "California",
    geonameid: 5327422,
  },
  {
    name: "Belmont",
    country: "United States",
    subcountry: "California",
    geonameid: 5327455,
  },
  {
    name: "Benicia",
    country: "United States",
    subcountry: "California",
    geonameid: 5327550,
  },
  {
    name: "Berkeley",
    country: "United States",
    subcountry: "California",
    geonameid: 5327684,
  },
  {
    name: "Beverly Hills",
    country: "United States",
    subcountry: "California",
    geonameid: 5328041,
  },
  {
    name: "Bloomington",
    country: "United States",
    subcountry: "California",
    geonameid: 5329408,
  },
  {
    name: "Blythe",
    country: "United States",
    subcountry: "California",
    geonameid: 5329649,
  },
  {
    name: "Bostonia",
    country: "United States",
    subcountry: "California",
    geonameid: 5330167,
  },
  {
    name: "Boyle Heights",
    country: "United States",
    subcountry: "California",
    geonameid: 5330413,
  },
  {
    name: "Brawley",
    country: "United States",
    subcountry: "California",
    geonameid: 5330567,
  },
  {
    name: "Brea",
    country: "United States",
    subcountry: "California",
    geonameid: 5330582,
  },
  {
    name: "Brentwood",
    country: "United States",
    subcountry: "California",
    geonameid: 5330642,
  },
  {
    name: "Buena Park",
    country: "United States",
    subcountry: "California",
    geonameid: 5331575,
  },
  {
    name: "Burbank",
    country: "United States",
    subcountry: "California",
    geonameid: 5331835,
  },
  {
    name: "Burlingame",
    country: "United States",
    subcountry: "California",
    geonameid: 5331920,
  },
  {
    name: "Calabasas",
    country: "United States",
    subcountry: "California",
    geonameid: 5332593,
  },
  {
    name: "Calexico",
    country: "United States",
    subcountry: "California",
    geonameid: 5332698,
  },
  {
    name: "Camarillo",
    country: "United States",
    subcountry: "California",
    geonameid: 5333180,
  },
  {
    name: "Cameron Park",
    country: "United States",
    subcountry: "California",
    geonameid: 5333282,
  },
  {
    name: "Campbell",
    country: "United States",
    subcountry: "California",
    geonameid: 5333689,
  },
  {
    name: "Canoga Park",
    country: "United States",
    subcountry: "California",
    geonameid: 5333913,
  },
  {
    name: "Canyon Country",
    country: "United States",
    subcountry: "California",
    geonameid: 5333944,
  },
  {
    name: "Carlsbad",
    country: "United States",
    subcountry: "California",
    geonameid: 5334223,
  },
  {
    name: "Carmichael",
    country: "United States",
    subcountry: "California",
    geonameid: 5334336,
  },
  {
    name: "Carson",
    country: "United States",
    subcountry: "California",
    geonameid: 5334519,
  },
  {
    name: "Castaic",
    country: "United States",
    subcountry: "California",
    geonameid: 5334799,
  },
  {
    name: "Castro Valley",
    country: "United States",
    subcountry: "California",
    geonameid: 5334928,
  },
  {
    name: "Cathedral City",
    country: "United States",
    subcountry: "California",
    geonameid: 5335006,
  },
  {
    name: "Ceres",
    country: "United States",
    subcountry: "California",
    geonameid: 5335650,
  },
  {
    name: "Cerritos",
    country: "United States",
    subcountry: "California",
    geonameid: 5335663,
  },
  {
    name: "Chatsworth",
    country: "United States",
    subcountry: "California",
    geonameid: 5336054,
  },
  {
    name: "Chico",
    country: "United States",
    subcountry: "California",
    geonameid: 5336269,
  },
  {
    name: "Chinatown",
    country: "United States",
    subcountry: "California",
    geonameid: 5336477,
  },
  {
    name: "Chino",
    country: "United States",
    subcountry: "California",
    geonameid: 5336537,
  },
  {
    name: "Chino Hills",
    country: "United States",
    subcountry: "California",
    geonameid: 5336545,
  },
  {
    name: "Chowchilla",
    country: "United States",
    subcountry: "California",
    geonameid: 5336667,
  },
  {
    name: "Chula Vista",
    country: "United States",
    subcountry: "California",
    geonameid: 5336899,
  },
  {
    name: "Citrus Heights",
    country: "United States",
    subcountry: "California",
    geonameid: 5337561,
  },
  {
    name: "Claremont",
    country: "United States",
    subcountry: "California",
    geonameid: 5337696,
  },
  {
    name: "Clearlake",
    country: "United States",
    subcountry: "California",
    geonameid: 5337908,
  },
  {
    name: "Clovis",
    country: "United States",
    subcountry: "California",
    geonameid: 5338122,
  },
  {
    name: "Coachella",
    country: "United States",
    subcountry: "California",
    geonameid: 5338166,
  },
  {
    name: "Coalinga",
    country: "United States",
    subcountry: "California",
    geonameid: 5338196,
  },
  {
    name: "Colton",
    country: "United States",
    subcountry: "California",
    geonameid: 5338783,
  },
  {
    name: "Compton",
    country: "United States",
    subcountry: "California",
    geonameid: 5339066,
  },
  {
    name: "Concord",
    country: "United States",
    subcountry: "California",
    geonameid: 5339111,
  },
  {
    name: "Corcoran",
    country: "United States",
    subcountry: "California",
    geonameid: 5339539,
  },
  {
    name: "Corona",
    country: "United States",
    subcountry: "California",
    geonameid: 5339631,
  },
  {
    name: "Coronado",
    country: "United States",
    subcountry: "California",
    geonameid: 5339663,
  },
  {
    name: "Costa Mesa",
    country: "United States",
    subcountry: "California",
    geonameid: 5339840,
  },
  {
    name: "Covina",
    country: "United States",
    subcountry: "California",
    geonameid: 5340175,
  },
  {
    name: "Cudahy",
    country: "United States",
    subcountry: "California",
    geonameid: 5341051,
  },
  {
    name: "Culver City",
    country: "United States",
    subcountry: "California",
    geonameid: 5341114,
  },
  {
    name: "Cupertino",
    country: "United States",
    subcountry: "California",
    geonameid: 5341145,
  },
  {
    name: "Cypress",
    country: "United States",
    subcountry: "California",
    geonameid: 5341256,
  },
  {
    name: "Daly City",
    country: "United States",
    subcountry: "California",
    geonameid: 5341430,
  },
  {
    name: "Dana Point",
    country: "United States",
    subcountry: "California",
    geonameid: 5341483,
  },
  {
    name: "Danville",
    country: "United States",
    subcountry: "California",
    geonameid: 5341531,
  },
  {
    name: "Davis",
    country: "United States",
    subcountry: "California",
    geonameid: 5341704,
  },
  {
    name: "Delano",
    country: "United States",
    subcountry: "California",
    geonameid: 5342485,
  },
  {
    name: "Desert Hot Springs",
    country: "United States",
    subcountry: "California",
    geonameid: 5342710,
  },
  {
    name: "Diamond Bar",
    country: "United States",
    subcountry: "California",
    geonameid: 5342992,
  },
  {
    name: "Dinuba",
    country: "United States",
    subcountry: "California",
    geonameid: 5343171,
  },
  {
    name: "Dixon",
    country: "United States",
    subcountry: "California",
    geonameid: 5343303,
  },
  {
    name: "Downey",
    country: "United States",
    subcountry: "California",
    geonameid: 5343858,
  },
  {
    name: "Duarte",
    country: "United States",
    subcountry: "California",
    geonameid: 5344147,
  },
  {
    name: "Dublin",
    country: "United States",
    subcountry: "California",
    geonameid: 5344157,
  },
  {
    name: "East Rancho Dominguez",
    country: "United States",
    subcountry: "California",
    geonameid: 5344817,
  },
  {
    name: "East Hemet",
    country: "United States",
    subcountry: "California",
    geonameid: 5344942,
  },
  {
    name: "East Los Angeles",
    country: "United States",
    subcountry: "California",
    geonameid: 5344994,
  },
  {
    name: "East Palo Alto",
    country: "United States",
    subcountry: "California",
    geonameid: 5345032,
  },
  {
    name: "El Cajon",
    country: "United States",
    subcountry: "California",
    geonameid: 5345529,
  },
  {
    name: "El Centro",
    country: "United States",
    subcountry: "California",
    geonameid: 5345609,
  },
  {
    name: "El Cerrito",
    country: "United States",
    subcountry: "California",
    geonameid: 5345623,
  },
  {
    name: "El Dorado Hills",
    country: "United States",
    subcountry: "California",
    geonameid: 5345679,
  },
  {
    name: "El Monte",
    country: "United States",
    subcountry: "California",
    geonameid: 5345743,
  },
  {
    name: "El Segundo",
    country: "United States",
    subcountry: "California",
    geonameid: 5345860,
  },
  {
    name: "Elk Grove",
    country: "United States",
    subcountry: "California",
    geonameid: 5346111,
  },
  {
    name: "Encinitas",
    country: "United States",
    subcountry: "California",
    geonameid: 5346646,
  },
  {
    name: "Encino",
    country: "United States",
    subcountry: "California",
    geonameid: 5346649,
  },
  {
    name: "Escondido",
    country: "United States",
    subcountry: "California",
    geonameid: 5346827,
  },
  {
    name: "Fair Oaks",
    country: "United States",
    subcountry: "California",
    geonameid: 5347287,
  },
  {
    name: "Fairfield",
    country: "United States",
    subcountry: "California",
    geonameid: 5347335,
  },
  {
    name: "Fallbrook",
    country: "United States",
    subcountry: "California",
    geonameid: 5347578,
  },
  {
    name: "Florin",
    country: "United States",
    subcountry: "California",
    geonameid: 5349613,
  },
  {
    name: "Folsom",
    country: "United States",
    subcountry: "California",
    geonameid: 5349705,
  },
  {
    name: "Fontana",
    country: "United States",
    subcountry: "California",
    geonameid: 5349755,
  },
  {
    name: "Foothill Farms",
    country: "United States",
    subcountry: "California",
    geonameid: 5349803,
  },
  {
    name: "Foster City",
    country: "United States",
    subcountry: "California",
    geonameid: 5350159,
  },
  {
    name: "Fountain Valley",
    country: "United States",
    subcountry: "California",
    geonameid: 5350207,
  },
  {
    name: "Fremont",
    country: "United States",
    subcountry: "California",
    geonameid: 5350734,
  },
  {
    name: "Fresno",
    country: "United States",
    subcountry: "California",
    geonameid: 5350937,
  },
  {
    name: "Fullerton",
    country: "United States",
    subcountry: "California",
    geonameid: 5351247,
  },
  {
    name: "Galt",
    country: "United States",
    subcountry: "California",
    geonameid: 5351428,
  },
  {
    name: "Garden Grove",
    country: "United States",
    subcountry: "California",
    geonameid: 5351515,
  },
  {
    name: "Gardena",
    country: "United States",
    subcountry: "California",
    geonameid: 5351549,
  },
  {
    name: "Gilroy",
    country: "United States",
    subcountry: "California",
    geonameid: 5352214,
  },
  {
    name: "Glen Avon",
    country: "United States",
    subcountry: "California",
    geonameid: 5352350,
  },
  {
    name: "Glendale",
    country: "United States",
    subcountry: "California",
    geonameid: 5352423,
  },
  {
    name: "Glendora",
    country: "United States",
    subcountry: "California",
    geonameid: 5352439,
  },
  {
    name: "Goleta",
    country: "United States",
    subcountry: "California",
    geonameid: 5352963,
  },
  {
    name: "Granite Bay",
    country: "United States",
    subcountry: "California",
    geonameid: 5353530,
  },
  {
    name: "Greenfield",
    country: "United States",
    subcountry: "California",
    geonameid: 5354172,
  },
  {
    name: "Hacienda Heights",
    country: "United States",
    subcountry: "California",
    geonameid: 5354819,
  },
  {
    name: "Hanford",
    country: "United States",
    subcountry: "California",
    geonameid: 5355180,
  },
  {
    name: "Hawthorne",
    country: "United States",
    subcountry: "California",
    geonameid: 5355828,
  },
  {
    name: "Hayward",
    country: "United States",
    subcountry: "California",
    geonameid: 5355933,
  },
  {
    name: "Hemet",
    country: "United States",
    subcountry: "California",
    geonameid: 5356277,
  },
  {
    name: "Hercules",
    country: "United States",
    subcountry: "California",
    geonameid: 5356451,
  },
  {
    name: "Hermosa Beach",
    country: "United States",
    subcountry: "California",
    geonameid: 5356521,
  },
  {
    name: "Hesperia",
    country: "United States",
    subcountry: "California",
    geonameid: 5356576,
  },
  {
    name: "Highland",
    country: "United States",
    subcountry: "California",
    geonameid: 5356868,
  },
  {
    name: "Hollister",
    country: "United States",
    subcountry: "California",
    geonameid: 5357499,
  },
  {
    name: "Hollywood",
    country: "United States",
    subcountry: "California",
    geonameid: 5357527,
  },
  {
    name: "Huntington Beach",
    country: "United States",
    subcountry: "California",
    geonameid: 5358705,
  },
  {
    name: "Huntington Park",
    country: "United States",
    subcountry: "California",
    geonameid: 5358736,
  },
  {
    name: "Imperial",
    country: "United States",
    subcountry: "California",
    geonameid: 5359052,
  },
  {
    name: "Imperial Beach",
    country: "United States",
    subcountry: "California",
    geonameid: 5359054,
  },
  {
    name: "Indio",
    country: "United States",
    subcountry: "California",
    geonameid: 5359446,
  },
  {
    name: "Inglewood",
    country: "United States",
    subcountry: "California",
    geonameid: 5359488,
  },
  {
    name: "Irvine",
    country: "United States",
    subcountry: "California",
    geonameid: 5359777,
  },
  {
    name: "Isla Vista",
    country: "United States",
    subcountry: "California",
    geonameid: 5359864,
  },
  {
    name: "Koreatown",
    country: "United States",
    subcountry: "California",
    geonameid: 5363748,
  },
  {
    name: "La Cañada Flintridge",
    country: "United States",
    subcountry: "California",
    geonameid: 5363859,
  },
  {
    name: "La Habra",
    country: "United States",
    subcountry: "California",
    geonameid: 5363922,
  },
  {
    name: "La Jolla",
    country: "United States",
    subcountry: "California",
    geonameid: 5363943,
  },
  {
    name: "La Mesa",
    country: "United States",
    subcountry: "California",
    geonameid: 5363990,
  },
  {
    name: "La Mirada",
    country: "United States",
    subcountry: "California",
    geonameid: 5364007,
  },
  {
    name: "La Palma",
    country: "United States",
    subcountry: "California",
    geonameid: 5364022,
  },
  {
    name: "La Presa",
    country: "United States",
    subcountry: "California",
    geonameid: 5364059,
  },
  {
    name: "La Puente",
    country: "United States",
    subcountry: "California",
    geonameid: 5364066,
  },
  {
    name: "La Quinta",
    country: "United States",
    subcountry: "California",
    geonameid: 5364079,
  },
  {
    name: "La Verne",
    country: "United States",
    subcountry: "California",
    geonameid: 5364134,
  },
  {
    name: "Ladera Ranch",
    country: "United States",
    subcountry: "California",
    geonameid: 5364199,
  },
  {
    name: "Lafayette",
    country: "United States",
    subcountry: "California",
    geonameid: 5364226,
  },
  {
    name: "Laguna",
    country: "United States",
    subcountry: "California",
    geonameid: 5364271,
  },
  {
    name: "Laguna Beach",
    country: "United States",
    subcountry: "California",
    geonameid: 5364275,
  },
  {
    name: "Laguna Hills",
    country: "United States",
    subcountry: "California",
    geonameid: 5364306,
  },
  {
    name: "Laguna Niguel",
    country: "United States",
    subcountry: "California",
    geonameid: 5364329,
  },
  {
    name: "Laguna Woods",
    country: "United States",
    subcountry: "California",
    geonameid: 5364369,
  },
  {
    name: "Lake Elsinore",
    country: "United States",
    subcountry: "California",
    geonameid: 5364499,
  },
  {
    name: "Lake Forest",
    country: "United States",
    subcountry: "California",
    geonameid: 5364514,
  },
  {
    name: "Lakeside",
    country: "United States",
    subcountry: "California",
    geonameid: 5364782,
  },
  {
    name: "Lakewood",
    country: "United States",
    subcountry: "California",
    geonameid: 5364855,
  },
  {
    name: "Lamont",
    country: "United States",
    subcountry: "California",
    geonameid: 5364916,
  },
  {
    name: "Lancaster",
    country: "United States",
    subcountry: "California",
    geonameid: 5364940,
  },
  {
    name: "Lathrop",
    country: "United States",
    subcountry: "California",
    geonameid: 5365425,
  },
  {
    name: "Lawndale",
    country: "United States",
    subcountry: "California",
    geonameid: 5365603,
  },
  {
    name: "Lemon Grove",
    country: "United States",
    subcountry: "California",
    geonameid: 5365893,
  },
  {
    name: "Lemoore",
    country: "United States",
    subcountry: "California",
    geonameid: 5365918,
  },
  {
    name: "Lennox",
    country: "United States",
    subcountry: "California",
    geonameid: 5365937,
  },
  {
    name: "Lincoln",
    country: "United States",
    subcountry: "California",
    geonameid: 5366375,
  },
  {
    name: "Linda",
    country: "United States",
    subcountry: "California",
    geonameid: 5366531,
  },
  {
    name: "Live Oak",
    country: "United States",
    subcountry: "California",
    geonameid: 5367314,
  },
  {
    name: "Livermore",
    country: "United States",
    subcountry: "California",
    geonameid: 5367440,
  },
  {
    name: "Lodi",
    country: "United States",
    subcountry: "California",
    geonameid: 5367565,
  },
  {
    name: "Loma Linda",
    country: "United States",
    subcountry: "California",
    geonameid: 5367696,
  },
  {
    name: "Lomita",
    country: "United States",
    subcountry: "California",
    geonameid: 5367767,
  },
  {
    name: "Lompoc",
    country: "United States",
    subcountry: "California",
    geonameid: 5367788,
  },
  {
    name: "Long Beach",
    country: "United States",
    subcountry: "California",
    geonameid: 5367929,
  },
  {
    name: "Los Altos",
    country: "United States",
    subcountry: "California",
    geonameid: 5368335,
  },
  {
    name: "Los Angeles",
    country: "United States",
    subcountry: "California",
    geonameid: 5368361,
  },
  {
    name: "Los Banos",
    country: "United States",
    subcountry: "California",
    geonameid: 5368453,
  },
  {
    name: "Los Gatos",
    country: "United States",
    subcountry: "California",
    geonameid: 5368518,
  },
  {
    name: "Lynwood",
    country: "United States",
    subcountry: "California",
    geonameid: 5369367,
  },
  {
    name: "Madera",
    country: "United States",
    subcountry: "California",
    geonameid: 5369568,
  },
  {
    name: "Manhattan Beach",
    country: "United States",
    subcountry: "California",
    geonameid: 5370082,
  },
  {
    name: "Manteca",
    country: "United States",
    subcountry: "California",
    geonameid: 5370164,
  },
  {
    name: "Marina",
    country: "United States",
    subcountry: "California",
    geonameid: 5370493,
  },
  {
    name: "Martinez",
    country: "United States",
    subcountry: "California",
    geonameid: 5370868,
  },
  {
    name: "Maywood",
    country: "United States",
    subcountry: "California",
    geonameid: 5371261,
  },
  {
    name: "Mead Valley",
    country: "United States",
    subcountry: "California",
    geonameid: 5371858,
  },
  {
    name: "Menifee",
    country: "United States",
    subcountry: "California",
    geonameid: 5372205,
  },
  {
    name: "Menlo Park",
    country: "United States",
    subcountry: "California",
    geonameid: 5372223,
  },
  {
    name: "Merced",
    country: "United States",
    subcountry: "California",
    geonameid: 5372253,
  },
  {
    name: "Millbrae",
    country: "United States",
    subcountry: "California",
    geonameid: 5373129,
  },
  {
    name: "Milpitas",
    country: "United States",
    subcountry: "California",
    geonameid: 5373327,
  },
  {
    name: "Jurupa Valley",
    country: "United States",
    subcountry: "California",
    geonameid: 5373492,
  },
  {
    name: "Mira Mesa",
    country: "United States",
    subcountry: "California",
    geonameid: 5373497,
  },
  {
    name: "Mission District",
    country: "United States",
    subcountry: "California",
    geonameid: 5373628,
  },
  {
    name: "Mission Viejo",
    country: "United States",
    subcountry: "California",
    geonameid: 5373763,
  },
  {
    name: "Modesto",
    country: "United States",
    subcountry: "California",
    geonameid: 5373900,
  },
  {
    name: "Monrovia",
    country: "United States",
    subcountry: "California",
    geonameid: 5374175,
  },
  {
    name: "Montclair",
    country: "United States",
    subcountry: "California",
    geonameid: 5374232,
  },
  {
    name: "Montebello",
    country: "United States",
    subcountry: "California",
    geonameid: 5374322,
  },
  {
    name: "Monterey",
    country: "United States",
    subcountry: "California",
    geonameid: 5374361,
  },
  {
    name: "Monterey Park",
    country: "United States",
    subcountry: "California",
    geonameid: 5374406,
  },
  {
    name: "Moorpark",
    country: "United States",
    subcountry: "California",
    geonameid: 5374648,
  },
  {
    name: "Moraga",
    country: "United States",
    subcountry: "California",
    geonameid: 5374671,
  },
  {
    name: "Moreno Valley",
    country: "United States",
    subcountry: "California",
    geonameid: 5374732,
  },
  {
    name: "Morgan Hill",
    country: "United States",
    subcountry: "California",
    geonameid: 5374764,
  },
  {
    name: "Mountain View",
    country: "United States",
    subcountry: "California",
    geonameid: 5375480,
  },
  {
    name: "Murrieta",
    country: "United States",
    subcountry: "California",
    geonameid: 5375911,
  },
  {
    name: "Napa",
    country: "United States",
    subcountry: "California",
    geonameid: 5376095,
  },
  {
    name: "National City",
    country: "United States",
    subcountry: "California",
    geonameid: 5376200,
  },
  {
    name: "Newark",
    country: "United States",
    subcountry: "California",
    geonameid: 5376803,
  },
  {
    name: "Newport Beach",
    country: "United States",
    subcountry: "California",
    geonameid: 5376890,
  },
  {
    name: "Nipomo",
    country: "United States",
    subcountry: "California",
    geonameid: 5377100,
  },
  {
    name: "Norco",
    country: "United States",
    subcountry: "California",
    geonameid: 5377199,
  },
  {
    name: "North Highlands",
    country: "United States",
    subcountry: "California",
    geonameid: 5377640,
  },
  {
    name: "North Hollywood",
    country: "United States",
    subcountry: "California",
    geonameid: 5377654,
  },
  {
    name: "Northridge",
    country: "United States",
    subcountry: "California",
    geonameid: 5377985,
  },
  {
    name: "Norwalk",
    country: "United States",
    subcountry: "California",
    geonameid: 5377995,
  },
  {
    name: "Novato",
    country: "United States",
    subcountry: "California",
    geonameid: 5378044,
  },
  {
    name: "Oakdale",
    country: "United States",
    subcountry: "California",
    geonameid: 5378500,
  },
  {
    name: "Oakland",
    country: "United States",
    subcountry: "California",
    geonameid: 5378538,
  },
  {
    name: "Oakley",
    country: "United States",
    subcountry: "California",
    geonameid: 5378566,
  },
  {
    name: "Oceanside",
    country: "United States",
    subcountry: "California",
    geonameid: 5378771,
  },
  {
    name: "Oildale",
    country: "United States",
    subcountry: "California",
    geonameid: 5378870,
  },
  {
    name: "Ontario",
    country: "United States",
    subcountry: "California",
    geonameid: 5379439,
  },
  {
    name: "Orange",
    country: "United States",
    subcountry: "California",
    geonameid: 5379513,
  },
  {
    name: "Orangevale",
    country: "United States",
    subcountry: "California",
    geonameid: 5379566,
  },
  {
    name: "Orcutt",
    country: "United States",
    subcountry: "California",
    geonameid: 5379609,
  },
  {
    name: "Orinda",
    country: "United States",
    subcountry: "California",
    geonameid: 5379678,
  },
  {
    name: "Oroville",
    country: "United States",
    subcountry: "California",
    geonameid: 5379759,
  },
  {
    name: "Oxnard",
    country: "United States",
    subcountry: "California",
    geonameid: 5380184,
  },
  {
    name: "Pacifica",
    country: "United States",
    subcountry: "California",
    geonameid: 5380420,
  },
  {
    name: "Pacific Grove",
    country: "United States",
    subcountry: "California",
    geonameid: 5380437,
  },
  {
    name: "Palm Desert",
    country: "United States",
    subcountry: "California",
    geonameid: 5380626,
  },
  {
    name: "Palm Springs",
    country: "United States",
    subcountry: "California",
    geonameid: 5380668,
  },
  {
    name: "Palmdale",
    country: "United States",
    subcountry: "California",
    geonameid: 5380698,
  },
  {
    name: "Palo Alto",
    country: "United States",
    subcountry: "California",
    geonameid: 5380748,
  },
  {
    name: "Paradise",
    country: "United States",
    subcountry: "California",
    geonameid: 5381002,
  },
  {
    name: "Paramount",
    country: "United States",
    subcountry: "California",
    geonameid: 5381110,
  },
  {
    name: "Parlier",
    country: "United States",
    subcountry: "California",
    geonameid: 5381325,
  },
  {
    name: "Pasadena",
    country: "United States",
    subcountry: "California",
    geonameid: 5381396,
  },
  {
    name: "Paso Robles",
    country: "United States",
    subcountry: "California",
    geonameid: 5381438,
  },
  {
    name: "Patterson",
    country: "United States",
    subcountry: "California",
    geonameid: 5381515,
  },
  {
    name: "Perris",
    country: "United States",
    subcountry: "California",
    geonameid: 5382146,
  },
  {
    name: "Petaluma",
    country: "United States",
    subcountry: "California",
    geonameid: 5382232,
  },
  {
    name: "Pico Rivera",
    country: "United States",
    subcountry: "California",
    geonameid: 5382496,
  },
  {
    name: "Pinole",
    country: "United States",
    subcountry: "California",
    geonameid: 5383187,
  },
  {
    name: "Pittsburg",
    country: "United States",
    subcountry: "California",
    geonameid: 5383465,
  },
  {
    name: "Placentia",
    country: "United States",
    subcountry: "California",
    geonameid: 5383527,
  },
  {
    name: "Pleasant Hill",
    country: "United States",
    subcountry: "California",
    geonameid: 5383720,
  },
  {
    name: "Pleasanton",
    country: "United States",
    subcountry: "California",
    geonameid: 5383777,
  },
  {
    name: "Pomona",
    country: "United States",
    subcountry: "California",
    geonameid: 5384170,
  },
  {
    name: "Port Hueneme",
    country: "United States",
    subcountry: "California",
    geonameid: 5384339,
  },
  {
    name: "Porterville",
    country: "United States",
    subcountry: "California",
    geonameid: 5384471,
  },
  {
    name: "Poway",
    country: "United States",
    subcountry: "California",
    geonameid: 5384690,
  },
  {
    name: "Prunedale",
    country: "United States",
    subcountry: "California",
    geonameid: 5385082,
  },
  {
    name: "Ramona",
    country: "United States",
    subcountry: "California",
    geonameid: 5385793,
  },
  {
    name: "Rancho Cordova",
    country: "United States",
    subcountry: "California",
    geonameid: 5385941,
  },
  {
    name: "Rancho Cucamonga",
    country: "United States",
    subcountry: "California",
    geonameid: 5385955,
  },
  {
    name: "Rancho Mirage",
    country: "United States",
    subcountry: "California",
    geonameid: 5386015,
  },
  {
    name: "Rancho Palos Verdes",
    country: "United States",
    subcountry: "California",
    geonameid: 5386035,
  },
  {
    name: "Rancho Penasquitos",
    country: "United States",
    subcountry: "California",
    geonameid: 5386039,
  },
  {
    name: "Rancho San Diego",
    country: "United States",
    subcountry: "California",
    geonameid: 5386053,
  },
  {
    name: "Rancho Santa Margarita",
    country: "United States",
    subcountry: "California",
    geonameid: 5386082,
  },
  {
    name: "Redlands",
    country: "United States",
    subcountry: "California",
    geonameid: 5386754,
  },
  {
    name: "Redondo Beach",
    country: "United States",
    subcountry: "California",
    geonameid: 5386785,
  },
  {
    name: "Redwood City",
    country: "United States",
    subcountry: "California",
    geonameid: 5386834,
  },
  {
    name: "Reedley",
    country: "United States",
    subcountry: "California",
    geonameid: 5386984,
  },
  {
    name: "Rialto",
    country: "United States",
    subcountry: "California",
    geonameid: 5387288,
  },
  {
    name: "Richmond",
    country: "United States",
    subcountry: "California",
    geonameid: 5387428,
  },
  {
    name: "Ridgecrest",
    country: "United States",
    subcountry: "California",
    geonameid: 5387494,
  },
  {
    name: "Rio Linda",
    country: "United States",
    subcountry: "California",
    geonameid: 5387687,
  },
  {
    name: "Ripon",
    country: "United States",
    subcountry: "California",
    geonameid: 5387749,
  },
  {
    name: "Riverbank",
    country: "United States",
    subcountry: "California",
    geonameid: 5387844,
  },
  {
    name: "Riverside",
    country: "United States",
    subcountry: "California",
    geonameid: 5387877,
  },
  {
    name: "Rocklin",
    country: "United States",
    subcountry: "California",
    geonameid: 5388319,
  },
  {
    name: "Rohnert Park",
    country: "United States",
    subcountry: "California",
    geonameid: 5388564,
  },
  {
    name: "Rosamond",
    country: "United States",
    subcountry: "California",
    geonameid: 5388735,
  },
  {
    name: "Rosemead",
    country: "United States",
    subcountry: "California",
    geonameid: 5388867,
  },
  {
    name: "Rosemont",
    country: "United States",
    subcountry: "California",
    geonameid: 5388873,
  },
  {
    name: "Roseville",
    country: "United States",
    subcountry: "California",
    geonameid: 5388881,
  },
  {
    name: "Rowland Heights",
    country: "United States",
    subcountry: "California",
    geonameid: 5389126,
  },
  {
    name: "Rubidoux",
    country: "United States",
    subcountry: "California",
    geonameid: 5389213,
  },
  {
    name: "Sacramento",
    country: "United States",
    subcountry: "California",
    geonameid: 5389489,
  },
  {
    name: "Salinas",
    country: "United States",
    subcountry: "California",
    geonameid: 5391295,
  },
  {
    name: "San Bernardino",
    country: "United States",
    subcountry: "California",
    geonameid: 5391710,
  },
  {
    name: "San Bruno",
    country: "United States",
    subcountry: "California",
    geonameid: 5391749,
  },
  {
    name: "San Carlos",
    country: "United States",
    subcountry: "California",
    geonameid: 5391760,
  },
  {
    name: "San Clemente",
    country: "United States",
    subcountry: "California",
    geonameid: 5391791,
  },
  {
    name: "San Diego",
    country: "United States",
    subcountry: "California",
    geonameid: 5391811,
  },
  {
    name: "San Dimas",
    country: "United States",
    subcountry: "California",
    geonameid: 5391891,
  },
  {
    name: "San Fernando",
    country: "United States",
    subcountry: "California",
    geonameid: 5391945,
  },
  {
    name: "San Francisco",
    country: "United States",
    subcountry: "California",
    geonameid: 5391959,
  },
  {
    name: "San Gabriel",
    country: "United States",
    subcountry: "California",
    geonameid: 5392034,
  },
  {
    name: "San Jacinto",
    country: "United States",
    subcountry: "California",
    geonameid: 5392090,
  },
  {
    name: "San Jose",
    country: "United States",
    subcountry: "California",
    geonameid: 5392171,
  },
  {
    name: "San Juan Capistrano",
    country: "United States",
    subcountry: "California",
    geonameid: 5392229,
  },
  {
    name: "San Leandro",
    country: "United States",
    subcountry: "California",
    geonameid: 5392263,
  },
  {
    name: "San Lorenzo",
    country: "United States",
    subcountry: "California",
    geonameid: 5392281,
  },
  {
    name: "San Luis Obispo",
    country: "United States",
    subcountry: "California",
    geonameid: 5392323,
  },
  {
    name: "San Marcos",
    country: "United States",
    subcountry: "California",
    geonameid: 5392368,
  },
  {
    name: "San Mateo",
    country: "United States",
    subcountry: "California",
    geonameid: 5392423,
  },
  {
    name: "San Pablo",
    country: "United States",
    subcountry: "California",
    geonameid: 5392508,
  },
  {
    name: "San Pedro",
    country: "United States",
    subcountry: "California",
    geonameid: 5392528,
  },
  {
    name: "San Rafael",
    country: "United States",
    subcountry: "California",
    geonameid: 5392567,
  },
  {
    name: "San Ramon",
    country: "United States",
    subcountry: "California",
    geonameid: 5392593,
  },
  {
    name: "Sanger",
    country: "United States",
    subcountry: "California",
    geonameid: 5392868,
  },
  {
    name: "Santa Ana",
    country: "United States",
    subcountry: "California",
    geonameid: 5392900,
  },
  {
    name: "Santa Barbara",
    country: "United States",
    subcountry: "California",
    geonameid: 5392952,
  },
  {
    name: "Santa Clara",
    country: "United States",
    subcountry: "California",
    geonameid: 5393015,
  },
  {
    name: "Santa Clarita",
    country: "United States",
    subcountry: "California",
    geonameid: 5393049,
  },
  {
    name: "Santa Cruz",
    country: "United States",
    subcountry: "California",
    geonameid: 5393052,
  },
  {
    name: "Santa Fe Springs",
    country: "United States",
    subcountry: "California",
    geonameid: 5393128,
  },
  {
    name: "Santa Maria",
    country: "United States",
    subcountry: "California",
    geonameid: 5393180,
  },
  {
    name: "Santa Monica",
    country: "United States",
    subcountry: "California",
    geonameid: 5393212,
  },
  {
    name: "Santa Paula",
    country: "United States",
    subcountry: "California",
    geonameid: 5393245,
  },
  {
    name: "Santa Rosa",
    country: "United States",
    subcountry: "California",
    geonameid: 5393287,
  },
  {
    name: "Santee",
    country: "United States",
    subcountry: "California",
    geonameid: 5393429,
  },
  {
    name: "Saratoga",
    country: "United States",
    subcountry: "California",
    geonameid: 5393485,
  },
  {
    name: "Seal Beach",
    country: "United States",
    subcountry: "California",
    geonameid: 5394086,
  },
  {
    name: "Seaside",
    country: "United States",
    subcountry: "California",
    geonameid: 5394136,
  },
  {
    name: "Selma",
    country: "United States",
    subcountry: "California",
    geonameid: 5394329,
  },
  {
    name: "North Hills",
    country: "United States",
    subcountry: "California",
    geonameid: 5394409,
  },
  {
    name: "Shafter",
    country: "United States",
    subcountry: "California",
    geonameid: 5394842,
  },
  {
    name: "Sherman Oaks",
    country: "United States",
    subcountry: "California",
    geonameid: 5395244,
  },
  {
    name: "Simi Valley",
    country: "United States",
    subcountry: "California",
    geonameid: 5396003,
  },
  {
    name: "Soledad",
    country: "United States",
    subcountry: "California",
    geonameid: 5397018,
  },
  {
    name: "South El Monte",
    country: "United States",
    subcountry: "California",
    geonameid: 5397376,
  },
  {
    name: "South Gate",
    country: "United States",
    subcountry: "California",
    geonameid: 5397603,
  },
  {
    name: "South Lake Tahoe",
    country: "United States",
    subcountry: "California",
    geonameid: 5397664,
  },
  {
    name: "South Pasadena",
    country: "United States",
    subcountry: "California",
    geonameid: 5397717,
  },
  {
    name: "South San Francisco",
    country: "United States",
    subcountry: "California",
    geonameid: 5397765,
  },
  {
    name: "South San Jose Hills",
    country: "United States",
    subcountry: "California",
    geonameid: 5397777,
  },
  {
    name: "South Whittier",
    country: "United States",
    subcountry: "California",
    geonameid: 5397841,
  },
  {
    name: "South Yuba City",
    country: "United States",
    subcountry: "California",
    geonameid: 5397851,
  },
  {
    name: "Spring Valley",
    country: "United States",
    subcountry: "California",
    geonameid: 5398277,
  },
  {
    name: "Stanton",
    country: "United States",
    subcountry: "California",
    geonameid: 5398630,
  },
  {
    name: "Stockton",
    country: "United States",
    subcountry: "California",
    geonameid: 5399020,
  },
  {
    name: "Studio City",
    country: "United States",
    subcountry: "California",
    geonameid: 5399438,
  },
  {
    name: "Suisun",
    country: "United States",
    subcountry: "California",
    geonameid: 5399629,
  },
  {
    name: "Sun City",
    country: "United States",
    subcountry: "California",
    geonameid: 5399901,
  },
  {
    name: "Sunland",
    country: "United States",
    subcountry: "California",
    geonameid: 5399976,
  },
  {
    name: "Sunnyvale",
    country: "United States",
    subcountry: "California",
    geonameid: 5400075,
  },
  {
    name: "Temecula",
    country: "United States",
    subcountry: "California",
    geonameid: 5401395,
  },
  {
    name: "Temple City",
    country: "United States",
    subcountry: "California",
    geonameid: 5401469,
  },
  {
    name: "Thousand Oaks",
    country: "United States",
    subcountry: "California",
    geonameid: 5402405,
  },
  {
    name: "Torrance",
    country: "United States",
    subcountry: "California",
    geonameid: 5403022,
  },
  {
    name: "Tracy",
    country: "United States",
    subcountry: "California",
    geonameid: 5403191,
  },
  {
    name: "Truckee",
    country: "United States",
    subcountry: "California",
    geonameid: 5403676,
  },
  {
    name: "Tujunga",
    country: "United States",
    subcountry: "California",
    geonameid: 5403767,
  },
  {
    name: "Tulare",
    country: "United States",
    subcountry: "California",
    geonameid: 5403783,
  },
  {
    name: "Turlock",
    country: "United States",
    subcountry: "California",
    geonameid: 5404024,
  },
  {
    name: "Tustin",
    country: "United States",
    subcountry: "California",
    geonameid: 5404119,
  },
  {
    name: "North Tustin",
    country: "United States",
    subcountry: "California",
    geonameid: 5404122,
  },
  {
    name: "Twentynine Palms",
    country: "United States",
    subcountry: "California",
    geonameid: 5404198,
  },
  {
    name: "Ukiah",
    country: "United States",
    subcountry: "California",
    geonameid: 5404476,
  },
  {
    name: "Union City",
    country: "United States",
    subcountry: "California",
    geonameid: 5404555,
  },
  {
    name: "Universal City",
    country: "United States",
    subcountry: "California",
    geonameid: 5404794,
  },
  {
    name: "Upland",
    country: "United States",
    subcountry: "California",
    geonameid: 5404915,
  },
  {
    name: "Vacaville",
    country: "United States",
    subcountry: "California",
    geonameid: 5405228,
  },
  {
    name: "Valencia",
    country: "United States",
    subcountry: "California",
    geonameid: 5405288,
  },
  {
    name: "Valinda",
    country: "United States",
    subcountry: "California",
    geonameid: 5405326,
  },
  {
    name: "Vallejo",
    country: "United States",
    subcountry: "California",
    geonameid: 5405380,
  },
  {
    name: "Van Nuys",
    country: "United States",
    subcountry: "California",
    geonameid: 5405693,
  },
  {
    name: "Venice",
    country: "United States",
    subcountry: "California",
    geonameid: 5405841,
  },
  {
    name: "Ventura",
    country: "United States",
    subcountry: "California",
    geonameid: 5405878,
  },
  {
    name: "Victorville",
    country: "United States",
    subcountry: "California",
    geonameid: 5406222,
  },
  {
    name: "Vincent",
    country: "United States",
    subcountry: "California",
    geonameid: 5406421,
  },
  {
    name: "Visalia",
    country: "United States",
    subcountry: "California",
    geonameid: 5406567,
  },
  {
    name: "Vista",
    country: "United States",
    subcountry: "California",
    geonameid: 5406602,
  },
  {
    name: "Walnut",
    country: "United States",
    subcountry: "California",
    geonameid: 5406976,
  },
  {
    name: "Walnut Creek",
    country: "United States",
    subcountry: "California",
    geonameid: 5406990,
  },
  {
    name: "Walnut Park",
    country: "United States",
    subcountry: "California",
    geonameid: 5407030,
  },
  {
    name: "Watsonville",
    country: "United States",
    subcountry: "California",
    geonameid: 5407529,
  },
  {
    name: "West Carson",
    country: "United States",
    subcountry: "California",
    geonameid: 5407908,
  },
  {
    name: "West Covina",
    country: "United States",
    subcountry: "California",
    geonameid: 5407933,
  },
  {
    name: "West Hollywood",
    country: "United States",
    subcountry: "California",
    geonameid: 5408076,
  },
  {
    name: "West Puente Valley",
    country: "United States",
    subcountry: "California",
    geonameid: 5408191,
  },
  {
    name: "West Sacramento",
    country: "United States",
    subcountry: "California",
    geonameid: 5408211,
  },
  {
    name: "Westminster",
    country: "United States",
    subcountry: "California",
    geonameid: 5408406,
  },
  {
    name: "Westmont",
    country: "United States",
    subcountry: "California",
    geonameid: 5408431,
  },
  {
    name: "Whittier",
    country: "United States",
    subcountry: "California",
    geonameid: 5409059,
  },
  {
    name: "Wildomar",
    country: "United States",
    subcountry: "California",
    geonameid: 5409260,
  },
  {
    name: "Willowbrook",
    country: "United States",
    subcountry: "California",
    geonameid: 5409768,
  },
  {
    name: "Windsor",
    country: "United States",
    subcountry: "California",
    geonameid: 5410004,
  },
  {
    name: "Winter Gardens",
    country: "United States",
    subcountry: "California",
    geonameid: 5410129,
  },
  {
    name: "Woodland",
    country: "United States",
    subcountry: "California",
    geonameid: 5410430,
  },
  {
    name: "Woodland Hills",
    country: "United States",
    subcountry: "California",
    geonameid: 5410438,
  },
  {
    name: "Yorba Linda",
    country: "United States",
    subcountry: "California",
    geonameid: 5410902,
  },
  {
    name: "Yuba City",
    country: "United States",
    subcountry: "California",
    geonameid: 5411015,
  },
  {
    name: "Yucaipa",
    country: "United States",
    subcountry: "California",
    geonameid: 5411046,
  },
  {
    name: "Yucca Valley",
    country: "United States",
    subcountry: "California",
    geonameid: 5411079,
  },
  {
    name: "Arvada",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5412199,
  },
  {
    name: "Aurora",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5412347,
  },
  {
    name: "Brighton",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5414941,
  },
  {
    name: "Broomfield",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5415035,
  },
  {
    name: "Cañon City",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5416005,
  },
  {
    name: "Castle Rock",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5416329,
  },
  {
    name: "Castlewood",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5416357,
  },
  {
    name: "Centennial",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5416541,
  },
  {
    name: "Cimarron Hills",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5417041,
  },
  {
    name: "Clifton",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5417258,
  },
  {
    name: "Colorado Springs",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5417598,
  },
  {
    name: "Columbine",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5417657,
  },
  {
    name: "Commerce City",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5417737,
  },
  {
    name: "Denver",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5419384,
  },
  {
    name: "Durango",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5420241,
  },
  {
    name: "Englewood",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5421250,
  },
  {
    name: "Fountain",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5422191,
  },
  {
    name: "Golden",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5423294,
  },
  {
    name: "Grand Junction",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5423573,
  },
  {
    name: "Greenwood Village",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5423908,
  },
  {
    name: "Highlands Ranch",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5425043,
  },
  {
    name: "Ken Caryl",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5427207,
  },
  {
    name: "Lafayette",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5427771,
  },
  {
    name: "Lakewood",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5427946,
  },
  {
    name: "Littleton",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5429032,
  },
  {
    name: "Louisville",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5429522,
  },
  {
    name: "Montrose",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5431710,
  },
  {
    name: "Northglenn",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5433124,
  },
  {
    name: "Parker",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5434006,
  },
  {
    name: "Pueblo",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5435464,
  },
  {
    name: "Pueblo West",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5435477,
  },
  {
    name: "Sherrelwood",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5438567,
  },
  {
    name: "Southglenn",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5439752,
  },
  {
    name: "Thornton",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5441492,
  },
  {
    name: "Westminster",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5443910,
  },
  {
    name: "Wheat Ridge",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5443948,
  },
  {
    name: "Dodge City",
    country: "United States",
    subcountry: "Kansas",
    geonameid: 5445298,
  },
  {
    name: "Garden City",
    country: "United States",
    subcountry: "Kansas",
    geonameid: 5445439,
  },
  {
    name: "Liberal",
    country: "United States",
    subcountry: "Kansas",
    geonameid: 5445820,
  },
  {
    name: "Alamogordo",
    country: "United States",
    subcountry: "New Mexico",
    geonameid: 5454627,
  },
  {
    name: "Albuquerque",
    country: "United States",
    subcountry: "New Mexico",
    geonameid: 5454711,
  },
  {
    name: "Carlsbad",
    country: "United States",
    subcountry: "New Mexico",
    geonameid: 5460459,
  },
  {
    name: "Clovis",
    country: "United States",
    subcountry: "New Mexico",
    geonameid: 5462393,
  },
  {
    name: "Farmington",
    country: "United States",
    subcountry: "New Mexico",
    geonameid: 5467328,
  },
  {
    name: "Gallup",
    country: "United States",
    subcountry: "New Mexico",
    geonameid: 5468773,
  },
  {
    name: "Hobbs",
    country: "United States",
    subcountry: "New Mexico",
    geonameid: 5471578,
  },
  {
    name: "Las Cruces",
    country: "United States",
    subcountry: "New Mexico",
    geonameid: 5475352,
  },
  {
    name: "Los Lunas",
    country: "United States",
    subcountry: "New Mexico",
    geonameid: 5476913,
  },
  {
    name: "Rio Rancho",
    country: "United States",
    subcountry: "New Mexico",
    geonameid: 5487811,
  },
  {
    name: "Roswell",
    country: "United States",
    subcountry: "New Mexico",
    geonameid: 5488441,
  },
  {
    name: "Santa Fe",
    country: "United States",
    subcountry: "New Mexico",
    geonameid: 5490263,
  },
  {
    name: "South Valley",
    country: "United States",
    subcountry: "New Mexico",
    geonameid: 5492450,
  },
  {
    name: "Sunland Park",
    country: "United States",
    subcountry: "New Mexico",
    geonameid: 5493403,
  },
  {
    name: "Boulder City",
    country: "United States",
    subcountry: "Nevada",
    geonameid: 5500539,
  },
  {
    name: "Carson City",
    country: "United States",
    subcountry: "Nevada",
    geonameid: 5501344,
  },
  {
    name: "Enterprise",
    country: "United States",
    subcountry: "Nevada",
    geonameid: 5503766,
  },
  {
    name: "Fernley",
    country: "United States",
    subcountry: "Nevada",
    geonameid: 5504003,
  },
  {
    name: "Henderson",
    country: "United States",
    subcountry: "Nevada",
    geonameid: 5505411,
  },
  {
    name: "Las Vegas",
    country: "United States",
    subcountry: "Nevada",
    geonameid: 5506956,
  },
  {
    name: "Mesquite",
    country: "United States",
    subcountry: "Nevada",
    geonameid: 5508180,
  },
  {
    name: "North Las Vegas",
    country: "United States",
    subcountry: "Nevada",
    geonameid: 5509403,
  },
  {
    name: "Pahrump",
    country: "United States",
    subcountry: "Nevada",
    geonameid: 5509851,
  },
  {
    name: "Paradise",
    country: "United States",
    subcountry: "Nevada",
    geonameid: 5509952,
  },
  {
    name: "Reno",
    country: "United States",
    subcountry: "Nevada",
    geonameid: 5511077,
  },
  {
    name: "Spanish Springs",
    country: "United States",
    subcountry: "Nevada",
    geonameid: 5512827,
  },
  {
    name: "Sparks",
    country: "United States",
    subcountry: "Nevada",
    geonameid: 5512862,
  },
  {
    name: "Spring Valley",
    country: "United States",
    subcountry: "Nevada",
    geonameid: 5512909,
  },
  {
    name: "Sun Valley",
    country: "United States",
    subcountry: "Nevada",
    geonameid: 5513307,
  },
  {
    name: "Sunrise Manor",
    country: "United States",
    subcountry: "Nevada",
    geonameid: 5513343,
  },
  {
    name: "Whitney",
    country: "United States",
    subcountry: "Nevada",
    geonameid: 5515110,
  },
  {
    name: "Winchester",
    country: "United States",
    subcountry: "Nevada",
    geonameid: 5515345,
  },
  {
    name: "Amarillo",
    country: "United States",
    subcountry: "Texas",
    geonameid: 5516233,
  },
  {
    name: "Big Spring",
    country: "United States",
    subcountry: "Texas",
    geonameid: 5517061,
  },
  {
    name: "Del Rio",
    country: "United States",
    subcountry: "Texas",
    geonameid: 5520076,
  },
  {
    name: "Dumas",
    country: "United States",
    subcountry: "Texas",
    geonameid: 5520552,
  },
  {
    name: "Eagle Pass",
    country: "United States",
    subcountry: "Texas",
    geonameid: 5520677,
  },
  {
    name: "El Paso",
    country: "United States",
    subcountry: "Texas",
    geonameid: 5520993,
  },
  {
    name: "Hereford",
    country: "United States",
    subcountry: "Texas",
    geonameid: 5523074,
  },
  {
    name: "Horizon City",
    country: "United States",
    subcountry: "Texas",
    geonameid: 5523369,
  },
  {
    name: "Lubbock",
    country: "United States",
    subcountry: "Texas",
    geonameid: 5525577,
  },
  {
    name: "Midland",
    country: "United States",
    subcountry: "Texas",
    geonameid: 5526337,
  },
  {
    name: "Odessa",
    country: "United States",
    subcountry: "Texas",
    geonameid: 5527554,
  },
  {
    name: "Pampa",
    country: "United States",
    subcountry: "Texas",
    geonameid: 5527953,
  },
  {
    name: "Plainview",
    country: "United States",
    subcountry: "Texas",
    geonameid: 5528450,
  },
  {
    name: "San Angelo",
    country: "United States",
    subcountry: "Texas",
    geonameid: 5530022,
  },
  {
    name: "Socorro",
    country: "United States",
    subcountry: "Texas",
    geonameid: 5530932,
  },
  {
    name: "Socorro Mission Number 1 Colonia",
    country: "United States",
    subcountry: "Texas",
    geonameid: 5530937,
  },
  {
    name: "West Odessa",
    country: "United States",
    subcountry: "Texas",
    geonameid: 5533366,
  },
  {
    name: "Cedar City",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5536630,
  },
  {
    name: "Hurricane",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5540831,
  },
  {
    name: "Saint George",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5546220,
  },
  {
    name: "Washington",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5549222,
  },
  {
    name: "Wasco",
    country: "United States",
    subcountry: "California",
    geonameid: 5550368,
  },
  {
    name: "Alhambra",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5551123,
  },
  {
    name: "Anthem",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5551498,
  },
  {
    name: "Apache Junction",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5551535,
  },
  {
    name: "Avondale",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5552301,
  },
  {
    name: "Ahwatukee Foothills",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 5552450,
  },
  {
    name: "Juneau",
    country: "United States",
    subcountry: "Alaska",
    geonameid: 5554072,
  },
  {
    name: "Arcata",
    country: "United States",
    subcountry: "California",
    geonameid: 5558953,
  },
  {
    name: "Bayside",
    country: "United States",
    subcountry: "California",
    geonameid: 5559320,
  },
  {
    name: "Eureka",
    country: "United States",
    subcountry: "California",
    geonameid: 5563397,
  },
  {
    name: "McKinleyville",
    country: "United States",
    subcountry: "California",
    geonameid: 5567770,
  },
  {
    name: "Redding",
    country: "United States",
    subcountry: "California",
    geonameid: 5570160,
  },
  {
    name: "Susanville",
    country: "United States",
    subcountry: "California",
    geonameid: 5572400,
  },
  {
    name: "Boulder",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5574991,
  },
  {
    name: "Erie",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5576859,
  },
  {
    name: "Evans",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5576909,
  },
  {
    name: "Fort Collins",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5577147,
  },
  {
    name: "Greeley",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5577592,
  },
  {
    name: "Longmont",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5579276,
  },
  {
    name: "Loveland",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5579368,
  },
  {
    name: "Windsor",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 5583509,
  },
  {
    name: "Boise",
    country: "United States",
    subcountry: "Idaho",
    geonameid: 5586437,
  },
  {
    name: "Caldwell",
    country: "United States",
    subcountry: "Idaho",
    geonameid: 5587698,
  },
  {
    name: "Coeur d'Alene",
    country: "United States",
    subcountry: "Idaho",
    geonameid: 5589173,
  },
  {
    name: "Eagle",
    country: "United States",
    subcountry: "Idaho",
    geonameid: 5591778,
  },
  {
    name: "Idaho Falls",
    country: "United States",
    subcountry: "Idaho",
    geonameid: 5596475,
  },
  {
    name: "Kuna",
    country: "United States",
    subcountry: "Idaho",
    geonameid: 5597955,
  },
  {
    name: "Lewiston",
    country: "United States",
    subcountry: "Idaho",
    geonameid: 5598538,
  },
  {
    name: "Lewiston Orchards",
    country: "United States",
    subcountry: "Idaho",
    geonameid: 5598542,
  },
  {
    name: "Meridian",
    country: "United States",
    subcountry: "Idaho",
    geonameid: 5600685,
  },
  {
    name: "Moscow",
    country: "United States",
    subcountry: "Idaho",
    geonameid: 5601538,
  },
  {
    name: "Nampa",
    country: "United States",
    subcountry: "Idaho",
    geonameid: 5601933,
  },
  {
    name: "Pocatello",
    country: "United States",
    subcountry: "Idaho",
    geonameid: 5604045,
  },
  {
    name: "Post Falls",
    country: "United States",
    subcountry: "Idaho",
    geonameid: 5604353,
  },
  {
    name: "Rexburg",
    country: "United States",
    subcountry: "Idaho",
    geonameid: 5605242,
  },
  {
    name: "Twin Falls",
    country: "United States",
    subcountry: "Idaho",
    geonameid: 5610810,
  },
  {
    name: "Billings",
    country: "United States",
    subcountry: "Montana",
    geonameid: 5640350,
  },
  {
    name: "Bozeman",
    country: "United States",
    subcountry: "Montana",
    geonameid: 5641727,
  },
  {
    name: "Butte",
    country: "United States",
    subcountry: "Montana",
    geonameid: 5642934,
  },
  {
    name: "Great Falls",
    country: "United States",
    subcountry: "Montana",
    geonameid: 5655240,
  },
  {
    name: "Helena",
    country: "United States",
    subcountry: "Montana",
    geonameid: 5656882,
  },
  {
    name: "Kalispell",
    country: "United States",
    subcountry: "Montana",
    geonameid: 5660340,
  },
  {
    name: "Missoula",
    country: "United States",
    subcountry: "Montana",
    geonameid: 5666639,
  },
  {
    name: "Bismarck",
    country: "United States",
    subcountry: "North Dakota",
    geonameid: 5688025,
  },
  {
    name: "Dickinson",
    country: "United States",
    subcountry: "North Dakota",
    geonameid: 5688789,
  },
  {
    name: "Mandan",
    country: "United States",
    subcountry: "North Dakota",
    geonameid: 5690366,
  },
  {
    name: "Minot",
    country: "United States",
    subcountry: "North Dakota",
    geonameid: 5690532,
  },
  {
    name: "Williston",
    country: "United States",
    subcountry: "North Dakota",
    geonameid: 5692947,
  },
  {
    name: "North Platte",
    country: "United States",
    subcountry: "Nebraska",
    geonameid: 5697939,
  },
  {
    name: "Elko",
    country: "United States",
    subcountry: "Nevada",
    geonameid: 5703670,
  },
  {
    name: "Albany",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5710756,
  },
  {
    name: "Aloha",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5711099,
  },
  {
    name: "Altamont",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5711149,
  },
  {
    name: "Ashland",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5711789,
  },
  {
    name: "Beaverton",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5713376,
  },
  {
    name: "Bend",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5713587,
  },
  {
    name: "Bethany",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5713759,
  },
  {
    name: "Canby",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5717758,
  },
  {
    name: "Central Point",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5718601,
  },
  {
    name: "Coos Bay",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5720495,
  },
  {
    name: "Corvallis",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5720727,
  },
  {
    name: "Dallas",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5722064,
  },
  {
    name: "Eugene",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5725846,
  },
  {
    name: "Forest Grove",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5727190,
  },
  {
    name: "Four Corners",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5727382,
  },
  {
    name: "Grants Pass",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5729080,
  },
  {
    name: "Gresham",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5729485,
  },
  {
    name: "Happy Valley",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5730183,
  },
  {
    name: "Hayesville",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5730675,
  },
  {
    name: "Hermiston",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5731070,
  },
  {
    name: "Hillsboro",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5731371,
  },
  {
    name: "Keizer",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5734711,
  },
  {
    name: "Klamath Falls",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5735238,
  },
  {
    name: "Lake Oswego",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5735724,
  },
  {
    name: "Lebanon",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5736218,
  },
  {
    name: "Lents",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5736378,
  },
  {
    name: "McMinnville",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5739936,
  },
  {
    name: "Medford",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5740099,
  },
  {
    name: "Milwaukie",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5740900,
  },
  {
    name: "Newberg",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5742726,
  },
  {
    name: "Oak Grove",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5743731,
  },
  {
    name: "Oregon City",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5744253,
  },
  {
    name: "Pendleton",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5745380,
  },
  {
    name: "Portland",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5746545,
  },
  {
    name: "Redmond",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5747882,
  },
  {
    name: "Roseburg",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5749352,
  },
  {
    name: "Salem",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5750162,
  },
  {
    name: "Sherwood",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5751632,
  },
  {
    name: "Springfield",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5754005,
  },
  {
    name: "The Dalles",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5756304,
  },
  {
    name: "Tigard",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5756758,
  },
  {
    name: "Troutdale",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5757477,
  },
  {
    name: "Tualatin",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5757506,
  },
  {
    name: "West Linn",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5760009,
  },
  {
    name: "Wilsonville",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5761287,
  },
  {
    name: "Woodburn",
    country: "United States",
    subcountry: "Oregon",
    geonameid: 5761708,
  },
  {
    name: "Rapid City",
    country: "United States",
    subcountry: "South Dakota",
    geonameid: 5768233,
  },
  {
    name: "Bountiful",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5771826,
  },
  {
    name: "Brigham City",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5771960,
  },
  {
    name: "Centerville",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5772654,
  },
  {
    name: "Clearfield",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5772959,
  },
  {
    name: "Clinton",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5773001,
  },
  {
    name: "Cottonwood Heights",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5773304,
  },
  {
    name: "Draper",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5774001,
  },
  {
    name: "Eagle Mountain",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5774215,
  },
  {
    name: "East Millcreek",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5774301,
  },
  {
    name: "Farmington",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5774662,
  },
  {
    name: "Herriman",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5775782,
  },
  {
    name: "Highland",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5775863,
  },
  {
    name: "Holladay",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5776008,
  },
  {
    name: "Kaysville",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5776715,
  },
  {
    name: "Kearns",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5776727,
  },
  {
    name: "Layton",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5777107,
  },
  {
    name: "Lehi",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5777224,
  },
  {
    name: "Logan",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5777544,
  },
  {
    name: "Magna",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5777793,
  },
  {
    name: "Midvale",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5778244,
  },
  {
    name: "Millcreek",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5778352,
  },
  {
    name: "Murray",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5778755,
  },
  {
    name: "North Ogden",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5779036,
  },
  {
    name: "North Salt Lake",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5779068,
  },
  {
    name: "Ogden",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5779206,
  },
  {
    name: "Orem",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5779334,
  },
  {
    name: "Payson",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5779548,
  },
  {
    name: "Pleasant Grove",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5779816,
  },
  {
    name: "Provo",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5780026,
  },
  {
    name: "Riverton",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5780557,
  },
  {
    name: "Roy",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5780802,
  },
  {
    name: "Salt Lake City",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5780993,
  },
  {
    name: "Sandy",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5781061,
  },
  {
    name: "Sandy Hills",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5781070,
  },
  {
    name: "Saratoga Springs",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5781087,
  },
  {
    name: "South Jordan Heights",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5781765,
  },
  {
    name: "South Jordan",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5781770,
  },
  {
    name: "South Ogden",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5781783,
  },
  {
    name: "South Salt Lake",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5781794,
  },
  {
    name: "Spanish Fork",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5781860,
  },
  {
    name: "Springville",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5781993,
  },
  {
    name: "Syracuse",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5782391,
  },
  {
    name: "Taylorsville",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5782476,
  },
  {
    name: "Tooele",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5783695,
  },
  {
    name: "West Jordan",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5784549,
  },
  {
    name: "West Valley City",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5784607,
  },
  {
    name: "Aberdeen",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5785243,
  },
  {
    name: "Anacortes",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5785657,
  },
  {
    name: "Arlington",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5785868,
  },
  {
    name: "Auburn",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5785965,
  },
  {
    name: "Battle Ground",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5786485,
  },
  {
    name: "Bellevue",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5786882,
  },
  {
    name: "Bellingham",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5786899,
  },
  {
    name: "Bonney Lake",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5787776,
  },
  {
    name: "Bothell",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5787829,
  },
  {
    name: "Bremerton",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5788054,
  },
  {
    name: "Burien",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5788516,
  },
  {
    name: "Camas",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5788822,
  },
  {
    name: "Centralia",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5789683,
  },
  {
    name: "Cottage Lake",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5790971,
  },
  {
    name: "Covington",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5791159,
  },
  {
    name: "Des Moines",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5792244,
  },
  {
    name: "Edmonds",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5793427,
  },
  {
    name: "Ellensburg",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5793639,
  },
  {
    name: "Everett",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5793933,
  },
  {
    name: "Fairwood",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5794097,
  },
  {
    name: "Federal Way",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5794245,
  },
  {
    name: "Five Corners",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5794559,
  },
  {
    name: "Frederickson",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5795011,
  },
  {
    name: "Graham",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5795906,
  },
  {
    name: "Hazel Dell",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5796984,
  },
  {
    name: "Issaquah",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5798487,
  },
  {
    name: "Kenmore",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5799587,
  },
  {
    name: "Kennewick",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5799610,
  },
  {
    name: "Kent",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5799625,
  },
  {
    name: "Kirkland",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5799841,
  },
  {
    name: "Lacey",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5800112,
  },
  {
    name: "Lake Stevens",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5800317,
  },
  {
    name: "Lakewood",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5800420,
  },
  {
    name: "Longview",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5801617,
  },
  {
    name: "Lynnwood",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5802049,
  },
  {
    name: "Maple Valley",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5802340,
  },
  {
    name: "Martha Lake",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5802493,
  },
  {
    name: "Marysville",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5802570,
  },
  {
    name: "Mercer Island",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5803139,
  },
  {
    name: "Mill Creek",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5803457,
  },
  {
    name: "Monroe",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5803786,
  },
  {
    name: "Moses Lake",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5803990,
  },
  {
    name: "Mount Vernon",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5804127,
  },
  {
    name: "Mountlake Terrace",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5804191,
  },
  {
    name: "Mukilteo",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5804306,
  },
  {
    name: "North Creek",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5804953,
  },
  {
    name: "Oak Harbor",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5805441,
  },
  {
    name: "Olympia",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5805687,
  },
  {
    name: "Opportunity",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5805782,
  },
  {
    name: "Orchards",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5805815,
  },
  {
    name: "Parkland",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5806253,
  },
  {
    name: "Pasco",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5806298,
  },
  {
    name: "Port Angeles",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5807212,
  },
  {
    name: "Pullman",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5807540,
  },
  {
    name: "Puyallup",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5807575,
  },
  {
    name: "Redmond",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5808079,
  },
  {
    name: "Renton",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5808189,
  },
  {
    name: "Richland",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5808276,
  },
  {
    name: "Salmon Creek",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5809333,
  },
  {
    name: "Sammamish",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5809402,
  },
  {
    name: "SeaTac",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5809805,
  },
  {
    name: "Seattle",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5809844,
  },
  {
    name: "Shoreline",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5810301,
  },
  {
    name: "Silverdale",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5810490,
  },
  {
    name: "South Hill",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5811456,
  },
  {
    name: "Spanaway",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5811581,
  },
  {
    name: "Spokane",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5811696,
  },
  {
    name: "Spokane Valley",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5811729,
  },
  {
    name: "Sunnyside",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5812604,
  },
  {
    name: "Tacoma",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5812944,
  },
  {
    name: "Tukwila",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5814043,
  },
  {
    name: "Tumwater",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5814095,
  },
  {
    name: "University Place",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5814450,
  },
  {
    name: "Vancouver",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5814616,
  },
  {
    name: "Walla Walla",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5814916,
  },
  {
    name: "Washougal",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5815136,
  },
  {
    name: "Wenatchee",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5815342,
  },
  {
    name: "West Lake Sammamish",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5815538,
  },
  {
    name: "West Lake Stevens",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5815539,
  },
  {
    name: "Bainbridge Island",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5816320,
  },
  {
    name: "Yakima",
    country: "United States",
    subcountry: "Washington",
    geonameid: 5816605,
  },
  {
    name: "Casper",
    country: "United States",
    subcountry: "Wyoming",
    geonameid: 5820705,
  },
  {
    name: "Cheyenne",
    country: "United States",
    subcountry: "Wyoming",
    geonameid: 5821086,
  },
  {
    name: "Gillette",
    country: "United States",
    subcountry: "Wyoming",
    geonameid: 5826027,
  },
  {
    name: "Laramie",
    country: "United States",
    subcountry: "Wyoming",
    geonameid: 5830062,
  },
  {
    name: "Rock Springs",
    country: "United States",
    subcountry: "Wyoming",
    geonameid: 5836898,
  },
  {
    name: "Sheridan",
    country: "United States",
    subcountry: "Wyoming",
    geonameid: 5838198,
  },
  {
    name: "American Fork",
    country: "United States",
    subcountry: "Utah",
    geonameid: 5844096,
  },
  {
    name: "Kahului",
    country: "United States",
    subcountry: "Hawaii",
    geonameid: 5847411,
  },
  {
    name: "Kailua",
    country: "United States",
    subcountry: "Hawaii",
    geonameid: 5847486,
  },
  {
    name: "Kaneohe",
    country: "United States",
    subcountry: "Hawaii",
    geonameid: 5848189,
  },
  {
    name: "Kīhei",
    country: "United States",
    subcountry: "Hawaii",
    geonameid: 5849297,
  },
  {
    name: "Makakilo City",
    country: "United States",
    subcountry: "Hawaii",
    geonameid: 5850554,
  },
  {
    name: "Mililani Town",
    country: "United States",
    subcountry: "Hawaii",
    geonameid: 5851030,
  },
  {
    name: "Pearl City",
    country: "United States",
    subcountry: "Hawaii",
    geonameid: 5852275,
  },
  {
    name: "Wahiawā",
    country: "United States",
    subcountry: "Hawaii",
    geonameid: 5853992,
  },
  {
    name: "Wailuku",
    country: "United States",
    subcountry: "Hawaii",
    geonameid: 5854496,
  },
  {
    name: "Waipahu",
    country: "United States",
    subcountry: "Hawaii",
    geonameid: 5854686,
  },
  {
    name: "‘Ewa Gentry",
    country: "United States",
    subcountry: "Hawaii",
    geonameid: 5855070,
  },
  {
    name: "Hilo",
    country: "United States",
    subcountry: "Hawaii",
    geonameid: 5855927,
  },
  {
    name: "Honolulu",
    country: "United States",
    subcountry: "Hawaii",
    geonameid: 5856195,
  },
  {
    name: "Eagle River",
    country: "United States",
    subcountry: "Alaska",
    geonameid: 5861187,
  },
  {
    name: "Fairbanks",
    country: "United States",
    subcountry: "Alaska",
    geonameid: 5861897,
  },
  {
    name: "Anchorage",
    country: "United States",
    subcountry: "Alaska",
    geonameid: 5879400,
  },
  {
    name: "Badger",
    country: "United States",
    subcountry: "Alaska",
    geonameid: 5879898,
  },
  {
    name: "Milton",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 6331908,
  },
  {
    name: "Johns Creek",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 6331909,
  },
  {
    name: "Cutler Bay",
    country: "United States",
    subcountry: "Florida",
    geonameid: 6332309,
  },
  {
    name: "Morningside Heights",
    country: "United States",
    subcountry: "New York",
    geonameid: 6332422,
  },
  {
    name: "East Harlem",
    country: "United States",
    subcountry: "New York",
    geonameid: 6332428,
  },
  {
    name: "Alafaya",
    country: "United States",
    subcountry: "Florida",
    geonameid: 6332439,
  },
  {
    name: "Millburn",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 6332745,
  },
  {
    name: "Briarwood",
    country: "United States",
    subcountry: "New York",
    geonameid: 6640032,
  },
  {
    name: "Stevenson Ranch",
    country: "United States",
    subcountry: "California",
    geonameid: 6690773,
  },
  {
    name: "Fort Liberty",
    country: "United States",
    subcountry: "North Carolina",
    geonameid: 6941080,
  },
  {
    name: "Kapolei",
    country: "United States",
    subcountry: "Hawaii",
    geonameid: 6957263,
  },
  {
    name: "City of Milford (balance)",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 7160204,
  },
  {
    name: "City of Sammamish",
    country: "United States",
    subcountry: "Washington",
    geonameid: 7174365,
  },
  {
    name: "Silver Firs",
    country: "United States",
    subcountry: "Washington",
    geonameid: 7176035,
  },
  {
    name: "Vineyard",
    country: "United States",
    subcountry: "California",
    geonameid: 7176039,
  },
  {
    name: "Gramercy Park",
    country: "United States",
    subcountry: "New York",
    geonameid: 7184841,
  },
  {
    name: "Kew Gardens Hills",
    country: "United States",
    subcountry: "New York",
    geonameid: 7250691,
  },
  {
    name: "Wallingford Center",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 7257422,
  },
  {
    name: "Braintree",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 7257540,
  },
  {
    name: "North Attleborough Center",
    country: "United States",
    subcountry: "Massachusetts",
    geonameid: 7257726,
  },
  {
    name: "Bel Air North",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 7257991,
  },
  {
    name: "Bel Air South",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 7257992,
  },
  {
    name: "Mercerville-Hamilton Square",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 7258271,
  },
  {
    name: "Oxon Hill-Glassmanor",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 7258432,
  },
  {
    name: "Gates-North Gates",
    country: "United States",
    subcountry: "New York",
    geonameid: 7258633,
  },
  {
    name: "Greater Upper Marlboro",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 7258671,
  },
  {
    name: "West Falls Church",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 7258780,
  },
  {
    name: "Lanham-Seabrook",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 7258832,
  },
  {
    name: "Lutherville-Timonium",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 7258897,
  },
  {
    name: "Setauket-East Setauket",
    country: "United States",
    subcountry: "New York",
    geonameid: 7258965,
  },
  {
    name: "St. Charles",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 7259034,
  },
  {
    name: "Suitland-Silver Hill",
    country: "United States",
    subcountry: "Maryland",
    geonameid: 7259061,
  },
  {
    name: "Fort Leonard Wood",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 7259265,
  },
  {
    name: "Saginaw Township North",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 7259480,
  },
  {
    name: "West Bloomfield Township",
    country: "United States",
    subcountry: "Michigan",
    geonameid: 7259621,
  },
  {
    name: "East Lake-Orient Park",
    country: "United States",
    subcountry: "Florida",
    geonameid: 7259705,
  },
  {
    name: "Four Corners",
    country: "United States",
    subcountry: "Florida",
    geonameid: 7259780,
  },
  {
    name: "Greater Northdale",
    country: "United States",
    subcountry: "Florida",
    geonameid: 7259823,
  },
  {
    name: "Candler-McAfee",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 7260019,
  },
  {
    name: "Sandalfoot Cove",
    country: "United States",
    subcountry: "Florida",
    geonameid: 7260095,
  },
  {
    name: "University",
    country: "United States",
    subcountry: "Florida",
    geonameid: 7260219,
  },
  {
    name: "Vero Beach South",
    country: "United States",
    subcountry: "Florida",
    geonameid: 7260233,
  },
  {
    name: "Kendall West",
    country: "United States",
    subcountry: "Florida",
    geonameid: 7260327,
  },
  {
    name: "Palm River-Clair Mel",
    country: "United States",
    subcountry: "Florida",
    geonameid: 7260548,
  },
  {
    name: "Arden-Arcade",
    country: "United States",
    subcountry: "California",
    geonameid: 7260806,
  },
  {
    name: "Bryn Mawr-Skyway",
    country: "United States",
    subcountry: "Washington",
    geonameid: 7260966,
  },
  {
    name: "Casa de Oro-Mount Helix",
    country: "United States",
    subcountry: "California",
    geonameid: 7261029,
  },
  {
    name: "Florence-Graham",
    country: "United States",
    subcountry: "California",
    geonameid: 7261268,
  },
  {
    name: "Fort Hood",
    country: "United States",
    subcountry: "Texas",
    geonameid: 7261291,
  },
  {
    name: "Inglewood-Finn Hill",
    country: "United States",
    subcountry: "Washington",
    geonameid: 7261476,
  },
  {
    name: "La Crescenta-Montrose",
    country: "United States",
    subcountry: "California",
    geonameid: 7261553,
  },
  {
    name: "East Hill-Meridian",
    country: "United States",
    subcountry: "Washington",
    geonameid: 7261759,
  },
  {
    name: "Picnic Point-North Lynnwood",
    country: "United States",
    subcountry: "Washington",
    geonameid: 7262110,
  },
  {
    name: "Security-Widefield",
    country: "United States",
    subcountry: "Colorado",
    geonameid: 7262349,
  },
  {
    name: "Union Hill-Novelty Hill",
    country: "United States",
    subcountry: "Washington",
    geonameid: 7262428,
  },
  {
    name: "Vincent",
    country: "United States",
    subcountry: "California",
    geonameid: 7262464,
  },
  {
    name: "West Whittier-Los Nietos",
    country: "United States",
    subcountry: "California",
    geonameid: 7262518,
  },
  {
    name: "Summerlin South",
    country: "United States",
    subcountry: "Nevada",
    geonameid: 7262622,
  },
  {
    name: "Makakilo",
    country: "United States",
    subcountry: "Hawaii",
    geonameid: 7262761,
  },
  {
    name: "Schofield Barracks",
    country: "United States",
    subcountry: "Hawaii",
    geonameid: 7262790,
  },
  {
    name: "Tri-Cities",
    country: "United States",
    subcountry: "Washington",
    geonameid: 7289169,
  },
  {
    name: "San Tan Valley",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 7310164,
  },
  {
    name: "Midway",
    country: "United States",
    subcountry: "Florida",
    geonameid: 7315234,
  },
  {
    name: "Oakleaf Plantation",
    country: "United States",
    subcountry: "Florida",
    geonameid: 7315237,
  },
  {
    name: "East Honolulu",
    country: "United States",
    subcountry: "Hawaii",
    geonameid: 7315245,
  },
  {
    name: "Old Jamestown",
    country: "United States",
    subcountry: "Missouri",
    geonameid: 7315274,
  },
  {
    name: "Bothell West",
    country: "United States",
    subcountry: "Washington",
    geonameid: 7315409,
  },
  {
    name: "Eastmont",
    country: "United States",
    subcountry: "Washington",
    geonameid: 7315412,
  },
  {
    name: "Mill Creek East",
    country: "United States",
    subcountry: "Washington",
    geonameid: 7315418,
  },
  {
    name: "Enchanted Hills",
    country: "United States",
    subcountry: "New Mexico",
    geonameid: 7839240,
  },
  {
    name: "West Hills",
    country: "United States",
    subcountry: "California",
    geonameid: 8030162,
  },
  {
    name: "Detroit-Shoreway",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 8062662,
  },
  {
    name: "Clark-Fulton",
    country: "United States",
    subcountry: "Ohio",
    geonameid: 8062667,
  },
  {
    name: "The Acreage",
    country: "United States",
    subcountry: "Florida",
    geonameid: 8096113,
  },
  {
    name: "Eastvale",
    country: "United States",
    subcountry: "California",
    geonameid: 8096217,
  },
  {
    name: "Oak Hill",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 8097131,
  },
  {
    name: "Bridgewater",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 8299576,
  },
  {
    name: "Warren Township",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 8299577,
  },
  {
    name: "Fairfield Heights",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 8347326,
  },
  {
    name: "Chicago Loop",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 8436065,
  },
  {
    name: "Greater Grand Crossing",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 8436083,
  },
  {
    name: "Auburn Gresham",
    country: "United States",
    subcountry: "Illinois",
    geonameid: 8436084,
  },
  {
    name: "Financial District",
    country: "United States",
    subcountry: "New York",
    geonameid: 8436473,
  },
  {
    name: "Sunset Park",
    country: "United States",
    subcountry: "New York",
    geonameid: 8436486,
  },
  {
    name: "South Kingstown",
    country: "United States",
    subcountry: "Rhode Island",
    geonameid: 8436572,
  },
  {
    name: "Noe Valley",
    country: "United States",
    subcountry: "California",
    geonameid: 8449772,
  },
  {
    name: "Visitacion Valley",
    country: "United States",
    subcountry: "California",
    geonameid: 8449777,
  },
  {
    name: "La Porte",
    country: "United States",
    subcountry: "Indiana",
    geonameid: 8449910,
  },
  {
    name: "Randolph",
    country: "United States",
    subcountry: "New Jersey",
    geonameid: 8469295,
  },
  {
    name: "Mount Pleasant",
    country: "United States",
    subcountry: "Wisconsin",
    geonameid: 8478941,
  },
  {
    name: "Northdale",
    country: "United States",
    subcountry: "Florida",
    geonameid: 8479411,
  },
  {
    name: "Waterford",
    country: "United States",
    subcountry: "Connecticut",
    geonameid: 8480031,
  },
  {
    name: "Meadowbrook",
    country: "United States",
    subcountry: "Virginia",
    geonameid: 8480062,
  },
  {
    name: "Lincoln",
    country: "United States",
    subcountry: "Rhode Island",
    geonameid: 8531960,
  },
  {
    name: "Johnston",
    country: "United States",
    subcountry: "Rhode Island",
    geonameid: 8604682,
  },
  {
    name: "Hot Springs National Park",
    country: "United States",
    subcountry: "Arkansas",
    geonameid: 8605040,
  },
  {
    name: "Dixiana",
    country: "United States",
    subcountry: "Alabama",
    geonameid: 8605041,
  },
  {
    name: "Cranberry Township",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 8643098,
  },
  {
    name: "Center City",
    country: "United States",
    subcountry: "Pennsylvania",
    geonameid: 9958118,
  },
  {
    name: "Silver Lake",
    country: "United States",
    subcountry: "California",
    geonameid: 10104153,
  },
  {
    name: "Echo Park",
    country: "United States",
    subcountry: "California",
    geonameid: 10104154,
  },
  {
    name: "St. Johns",
    country: "United States",
    subcountry: "Florida",
    geonameid: 11704266,
  },
  {
    name: "Stonecrest",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 11748973,
  },
  {
    name: "Cortlandt Manor",
    country: "United States",
    subcountry: "New York",
    geonameid: 11811570,
  },
  {
    name: "Valley Glen",
    country: "United States",
    subcountry: "California",
    geonameid: 11838960,
  },
  {
    name: "Encanto",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 11979227,
  },
  {
    name: "Central City",
    country: "United States",
    subcountry: "Arizona",
    geonameid: 11979238,
  },
  {
    name: "South Fulton",
    country: "United States",
    subcountry: "Georgia",
    geonameid: 12541728,
  },
  {
    name: "Young",
    country: "Uruguay",
    subcountry: "Río Negro Department",
    geonameid: 3439525,
  },
  {
    name: "Trinidad",
    country: "Uruguay",
    subcountry: "Flores Department",
    geonameid: 3439748,
  },
  {
    name: "Treinta y Tres",
    country: "Uruguay",
    subcountry: "Treinta y Tres Department",
    geonameid: 3439781,
  },
  {
    name: "Tacuarembó",
    country: "Uruguay",
    subcountry: "Tacuarembó Department",
    geonameid: 3440034,
  },
  {
    name: "Santa Lucía",
    country: "Uruguay",
    subcountry: "Canelones",
    geonameid: 3440571,
  },
  {
    name: "San José de Mayo",
    country: "Uruguay",
    subcountry: "San José Department",
    geonameid: 3440639,
  },
  {
    name: "San Carlos",
    country: "Uruguay",
    subcountry: "Maldonado",
    geonameid: 3440696,
  },
  {
    name: "Salto",
    country: "Uruguay",
    subcountry: "Salto Department",
    geonameid: 3440714,
  },
  {
    name: "Rocha",
    country: "Uruguay",
    subcountry: "Rocha Department",
    geonameid: 3440777,
  },
  {
    name: "Rivera",
    country: "Uruguay",
    subcountry: "Rivera Department",
    geonameid: 3440781,
  },
  {
    name: "Progreso",
    country: "Uruguay",
    subcountry: "Canelones",
    geonameid: 3440963,
  },
  {
    name: "Paysandú",
    country: "Uruguay",
    subcountry: "Paysandú Department",
    geonameid: 3441243,
  },
  {
    name: "Paso de Carrasco",
    country: "Uruguay",
    subcountry: "Canelones",
    geonameid: 3441292,
  },
  {
    name: "Pando",
    country: "Uruguay",
    subcountry: "Canelones",
    geonameid: 3441354,
  },
  {
    name: "Montevideo",
    country: "Uruguay",
    subcountry: "Montevideo Department",
    geonameid: 3441575,
  },
  {
    name: "Minas",
    country: "Uruguay",
    subcountry: "Lavalleja",
    geonameid: 3441665,
  },
  {
    name: "Mercedes",
    country: "Uruguay",
    subcountry: "Soriano",
    geonameid: 3441684,
  },
  {
    name: "Melo",
    country: "Uruguay",
    subcountry: "Cerro Largo",
    geonameid: 3441702,
  },
  {
    name: "Maldonado",
    country: "Uruguay",
    subcountry: "Maldonado",
    geonameid: 3441894,
  },
  {
    name: "Las Piedras",
    country: "Uruguay",
    subcountry: "Canelones",
    geonameid: 3442057,
  },
  {
    name: "La Paz",
    country: "Uruguay",
    subcountry: "Canelones",
    geonameid: 3442098,
  },
  {
    name: "Fray Bentos",
    country: "Uruguay",
    subcountry: "Río Negro Department",
    geonameid: 3442568,
  },
  {
    name: "Florida",
    country: "Uruguay",
    subcountry: "Florida",
    geonameid: 3442585,
  },
  {
    name: "Durazno",
    country: "Uruguay",
    subcountry: "Durazno Department",
    geonameid: 3442727,
  },
  {
    name: "Dolores",
    country: "Uruguay",
    subcountry: "Soriano",
    geonameid: 3442750,
  },
  {
    name: "Delta del Tigre",
    country: "Uruguay",
    subcountry: "San José Department",
    geonameid: 3442778,
  },
  {
    name: "Colonia del Sacramento",
    country: "Uruguay",
    subcountry: "Colonia",
    geonameid: 3443013,
  },
  {
    name: "Carmelo",
    country: "Uruguay",
    subcountry: "Colonia",
    geonameid: 3443341,
  },
  {
    name: "Canelones",
    country: "Uruguay",
    subcountry: "Canelones",
    geonameid: 3443413,
  },
  {
    name: "Artigas",
    country: "Uruguay",
    subcountry: "Artigas",
    geonameid: 3443758,
  },
  {
    name: "Barros Blancos",
    country: "Uruguay",
    subcountry: "Canelones",
    geonameid: 10098279,
  },
  {
    name: "Nukus",
    country: "Uzbekistan",
    subcountry: "Karakalpakstan",
    geonameid: 601294,
  },
  {
    name: "Qŭnghirot",
    country: "Uzbekistan",
    subcountry: "Karakalpakstan",
    geonameid: 601323,
  },
  {
    name: "Xo‘jayli Shahri",
    country: "Uzbekistan",
    subcountry: "Karakalpakstan",
    geonameid: 601339,
  },
  {
    name: "Oltinko‘l",
    country: "Uzbekistan",
    subcountry: "Karakalpakstan",
    geonameid: 601417,
  },
  {
    name: "Zomin Shaharchasi",
    country: "Uzbekistan",
    subcountry: "Jizzax",
    geonameid: 1215694,
  },
  {
    name: "Urgut Shahri",
    country: "Uzbekistan",
    subcountry: "Samarqand",
    geonameid: 1215839,
  },
  {
    name: "Tirmiz",
    country: "Uzbekistan",
    subcountry: "Surxondaryo",
    geonameid: 1215957,
  },
  {
    name: "Sho‘rchi",
    country: "Uzbekistan",
    subcountry: "Surxondaryo",
    geonameid: 1216115,
  },
  {
    name: "Shahrisabz",
    country: "Uzbekistan",
    subcountry: "Qashqadaryo",
    geonameid: 1216187,
  },
  {
    name: "Samarkand",
    country: "Uzbekistan",
    subcountry: "Samarqand",
    geonameid: 1216265,
  },
  {
    name: "Qarshi",
    country: "Uzbekistan",
    subcountry: "Qashqadaryo",
    geonameid: 1216311,
  },
  {
    name: "Muborak",
    country: "Uzbekistan",
    subcountry: "Qashqadaryo",
    geonameid: 1216475,
  },
  {
    name: "Kitob",
    country: "Uzbekistan",
    subcountry: "Qashqadaryo",
    geonameid: 1216787,
  },
  {
    name: "Kattaqo’rg’on Shahri",
    country: "Uzbekistan",
    subcountry: "Samarqand",
    geonameid: 1216982,
  },
  {
    name: "Koson",
    country: "Uzbekistan",
    subcountry: "Qashqadaryo",
    geonameid: 1217007,
  },
  {
    name: "Karakul’",
    country: "Uzbekistan",
    subcountry: "Bukhara",
    geonameid: 1217084,
  },
  {
    name: "Kogon Shahri",
    country: "Uzbekistan",
    subcountry: "Bukhara",
    geonameid: 1217180,
  },
  {
    name: "G‘uzor",
    country: "Uzbekistan",
    subcountry: "Qashqadaryo",
    geonameid: 1217262,
  },
  {
    name: "Galaosiyo Shahri",
    country: "Uzbekistan",
    subcountry: "Bukhara",
    geonameid: 1217340,
  },
  {
    name: "Juma Shahri",
    country: "Uzbekistan",
    subcountry: "Samarqand",
    geonameid: 1217362,
  },
  {
    name: "Denov",
    country: "Uzbekistan",
    subcountry: "Surxondaryo",
    geonameid: 1217474,
  },
  {
    name: "Chiroqchi",
    country: "Uzbekistan",
    subcountry: "Qashqadaryo",
    geonameid: 1217540,
  },
  {
    name: "Chelak",
    country: "Uzbekistan",
    subcountry: "Samarqand",
    geonameid: 1217569,
  },
  {
    name: "Bulung’ur Shahri",
    country: "Uzbekistan",
    subcountry: "Samarqand",
    geonameid: 1217658,
  },
  {
    name: "Bukhara",
    country: "Uzbekistan",
    subcountry: "Bukhara",
    geonameid: 1217662,
  },
  {
    name: "Beshkent",
    country: "Uzbekistan",
    subcountry: "Qashqadaryo",
    geonameid: 1217703,
  },
  {
    name: "Boysun",
    country: "Uzbekistan",
    subcountry: "Surxondaryo",
    geonameid: 1217734,
  },
  {
    name: "Oqtosh",
    country: "Uzbekistan",
    subcountry: "Samarqand",
    geonameid: 1217926,
  },
  {
    name: "Zafar",
    country: "Uzbekistan",
    subcountry: "Toshkent",
    geonameid: 1512287,
  },
  {
    name: "Yaypan",
    country: "Uzbekistan",
    subcountry: "Fergana",
    geonameid: 1512320,
  },
  {
    name: "Yangiyŭl",
    country: "Uzbekistan",
    subcountry: "Toshkent",
    geonameid: 1512339,
  },
  {
    name: "Yangiyer",
    country: "Uzbekistan",
    subcountry: "Sirdaryo Region",
    geonameid: 1512342,
  },
  {
    name: "Yangirabot",
    country: "Uzbekistan",
    subcountry: "Navoiy",
    geonameid: 1512348,
  },
  {
    name: "Yangiqo‘rg‘on",
    country: "Uzbekistan",
    subcountry: "Namangan",
    geonameid: 1512350,
  },
  {
    name: "Yangiobod",
    country: "Uzbekistan",
    subcountry: "Toshkent",
    geonameid: 1512372,
  },
  {
    name: "Vobkent Shahri",
    country: "Uzbekistan",
    subcountry: "Bukhara",
    geonameid: 1512423,
  },
  {
    name: "Uychi",
    country: "Uzbekistan",
    subcountry: "Namangan",
    geonameid: 1512449,
  },
  {
    name: "Urganch",
    country: "Uzbekistan",
    subcountry: "Xorazm",
    geonameid: 1512473,
  },
  {
    name: "Dashtobod",
    country: "Uzbekistan",
    subcountry: "Jizzax",
    geonameid: 1512480,
  },
  {
    name: "Uchqŭrghon Shahri",
    country: "Uzbekistan",
    subcountry: "Namangan",
    geonameid: 1512501,
  },
  {
    name: "Tŭytepa",
    country: "Uzbekistan",
    subcountry: "Toshkent",
    geonameid: 1512524,
  },
  {
    name: "To‘rqao‘rg‘on",
    country: "Uzbekistan",
    subcountry: "Namangan",
    geonameid: 1512549,
  },
  {
    name: "Toshloq",
    country: "Uzbekistan",
    subcountry: "Fergana",
    geonameid: 1512568,
  },
  {
    name: "Tashkent",
    country: "Uzbekistan",
    subcountry: "Tashkent",
    geonameid: 1512569,
  },
  {
    name: "Toshbuloq",
    country: "Uzbekistan",
    subcountry: "Namangan",
    geonameid: 1512658,
  },
  {
    name: "Sirdaryo",
    country: "Uzbekistan",
    subcountry: "Sirdaryo Region",
    geonameid: 1512770,
  },
  {
    name: "Shovot",
    country: "Uzbekistan",
    subcountry: "Xorazm",
    geonameid: 1512790,
  },
  {
    name: "Shofirkon Shahri",
    country: "Uzbekistan",
    subcountry: "Bukhara",
    geonameid: 1512838,
  },
  {
    name: "Salor",
    country: "Uzbekistan",
    subcountry: "Toshkent",
    geonameid: 1512934,
  },
  {
    name: "Qo’shko’pir",
    country: "Uzbekistan",
    subcountry: "Xorazm",
    geonameid: 1512978,
  },
  {
    name: "Qo‘qon",
    country: "Uzbekistan",
    subcountry: "Fergana",
    geonameid: 1512979,
  },
  {
    name: "Piskent",
    country: "Uzbekistan",
    subcountry: "Toshkent",
    geonameid: 1512986,
  },
  {
    name: "Payshamba Shahri",
    country: "Uzbekistan",
    subcountry: "Samarqand",
    geonameid: 1513011,
  },
  {
    name: "Parkent",
    country: "Uzbekistan",
    subcountry: "Toshkent",
    geonameid: 1513017,
  },
  {
    name: "Pop",
    country: "Uzbekistan",
    subcountry: "Namangan",
    geonameid: 1513023,
  },
  {
    name: "Paxtakor Shahri",
    country: "Uzbekistan",
    subcountry: "Jizzax",
    geonameid: 1513038,
  },
  {
    name: "Olmaliq",
    country: "Uzbekistan",
    subcountry: "Toshkent",
    geonameid: 1513064,
  },
  {
    name: "Ohangaron",
    country: "Uzbekistan",
    subcountry: "Toshkent",
    geonameid: 1513072,
  },
  {
    name: "Nurota",
    country: "Uzbekistan",
    subcountry: "Navoiy",
    geonameid: 1513087,
  },
  {
    name: "Novyy Turtkul’",
    country: "Uzbekistan",
    subcountry: "Karakalpakstan",
    geonameid: 1513092,
  },
  {
    name: "Navoiy",
    country: "Uzbekistan",
    subcountry: "Navoiy",
    geonameid: 1513131,
  },
  {
    name: "Namangan",
    country: "Uzbekistan",
    subcountry: "Namangan",
    geonameid: 1513157,
  },
  {
    name: "Marg‘ilon",
    country: "Uzbekistan",
    subcountry: "Fergana",
    geonameid: 1513243,
  },
  {
    name: "Manghit",
    country: "Uzbekistan",
    subcountry: "Karakalpakstan",
    geonameid: 1513245,
  },
  {
    name: "Asaka",
    country: "Uzbekistan",
    subcountry: "Andijon",
    geonameid: 1513271,
  },
  {
    name: "Quvasoy",
    country: "Uzbekistan",
    subcountry: "Fergana",
    geonameid: 1513331,
  },
  {
    name: "Qo‘rg‘ontepa",
    country: "Uzbekistan",
    subcountry: "Andijon",
    geonameid: 1513364,
  },
  {
    name: "Kirguli",
    country: "Uzbekistan",
    subcountry: "Fergana",
    geonameid: 1513555,
  },
  {
    name: "Qibray",
    country: "Uzbekistan",
    subcountry: "Toshkent",
    geonameid: 1513567,
  },
  {
    name: "Xonobod",
    country: "Uzbekistan",
    subcountry: "Andijon",
    geonameid: 1513578,
  },
  {
    name: "Xo‘jaobod",
    country: "Uzbekistan",
    subcountry: "Andijon",
    geonameid: 1513600,
  },
  {
    name: "Xiva",
    country: "Uzbekistan",
    subcountry: "Xorazm",
    geonameid: 1513604,
  },
  {
    name: "Haqqulobod",
    country: "Uzbekistan",
    subcountry: "Namangan",
    geonameid: 1513655,
  },
  {
    name: "Kosonsoy",
    country: "Uzbekistan",
    subcountry: "Namangan",
    geonameid: 1513714,
  },
  {
    name: "Jizzax",
    country: "Uzbekistan",
    subcountry: "Jizzax",
    geonameid: 1513886,
  },
  {
    name: "Iskandar",
    country: "Uzbekistan",
    subcountry: "Toshkent",
    geonameid: 1513900,
  },
  {
    name: "Qorasuv",
    country: "Uzbekistan",
    subcountry: "Andijon",
    geonameid: 1513953,
  },
  {
    name: "Hazorasp",
    country: "Uzbekistan",
    subcountry: "Xorazm",
    geonameid: 1513957,
  },
  {
    name: "Gurlan",
    country: "Uzbekistan",
    subcountry: "Xorazm",
    geonameid: 1513962,
  },
  {
    name: "Guliston",
    country: "Uzbekistan",
    subcountry: "Sirdaryo Region",
    geonameid: 1513966,
  },
  {
    name: "G’ijduvon Shahri",
    country: "Uzbekistan",
    subcountry: "Bukhara",
    geonameid: 1513983,
  },
  {
    name: "G‘azalkent",
    country: "Uzbekistan",
    subcountry: "Toshkent",
    geonameid: 1513996,
  },
  {
    name: "Gagarin Shahri",
    country: "Uzbekistan",
    subcountry: "Jizzax",
    geonameid: 1514011,
  },
  {
    name: "Fergana",
    country: "Uzbekistan",
    subcountry: "Fergana",
    geonameid: 1514019,
  },
  {
    name: "Jalolquduq",
    country: "Uzbekistan",
    subcountry: "Andijon",
    geonameid: 1514109,
  },
  {
    name: "Do’stlik Shahri",
    country: "Uzbekistan",
    subcountry: "Jizzax",
    geonameid: 1514125,
  },
  {
    name: "Druzhba",
    country: "Uzbekistan",
    subcountry: "Xorazm",
    geonameid: 1514140,
  },
  {
    name: "Dardoq",
    country: "Uzbekistan",
    subcountry: "Andijon",
    geonameid: 1514174,
  },
  {
    name: "Chust",
    country: "Uzbekistan",
    subcountry: "Namangan",
    geonameid: 1514192,
  },
  {
    name: "Chirchiq",
    country: "Uzbekistan",
    subcountry: "Toshkent",
    geonameid: 1514210,
  },
  {
    name: "Chinoz",
    country: "Uzbekistan",
    subcountry: "Toshkent",
    geonameid: 1514215,
  },
  {
    name: "Chortoq",
    country: "Uzbekistan",
    subcountry: "Namangan",
    geonameid: 1514258,
  },
  {
    name: "Bo‘ka",
    country: "Uzbekistan",
    subcountry: "Toshkent",
    geonameid: 1514330,
  },
  {
    name: "Beshariq",
    country: "Uzbekistan",
    subcountry: "Fergana",
    geonameid: 1514382,
  },
  {
    name: "Beruniy",
    country: "Uzbekistan",
    subcountry: "Karakalpakstan",
    geonameid: 1514387,
  },
  {
    name: "Bektemir",
    country: "Uzbekistan",
    subcountry: "Tashkent",
    geonameid: 1514396,
  },
  {
    name: "Bekobod",
    country: "Uzbekistan",
    subcountry: "Toshkent",
    geonameid: 1514402,
  },
  {
    name: "Angren",
    country: "Uzbekistan",
    subcountry: "Toshkent",
    geonameid: 1514581,
  },
  {
    name: "Andijon",
    country: "Uzbekistan",
    subcountry: "Andijon",
    geonameid: 1514588,
  },
  {
    name: "Oltiariq",
    country: "Uzbekistan",
    subcountry: "Fergana",
    geonameid: 1514615,
  },
  {
    name: "Oyim",
    country: "Uzbekistan",
    subcountry: "Andijon",
    geonameid: 1514716,
  },
  {
    name: "Quva",
    country: "Uzbekistan",
    subcountry: "Fergana",
    geonameid: 1526979,
  },
  {
    name: "Sultonobod",
    country: "Uzbekistan",
    subcountry: "Andijon",
    geonameid: 1538533,
  },
  {
    name: "Vatican City",
    country: "Vatican",
    subcountry: "N/A",
    geonameid: 6691831,
  },
  {
    name: "Kingstown",
    country: "Saint Vincent and the Grenadines",
    subcountry: "Saint George",
    geonameid: 3577887,
  },
  {
    name: "Kingstown Park",
    country: "Saint Vincent and the Grenadines",
    subcountry: "Saint George",
    geonameid: 3748726,
  },
  {
    name: "La Asunción",
    country: "Venezuela",
    subcountry: "Nueva Esparta",
    geonameid: 3480908,
  },
  {
    name: "Anaco",
    country: "Venezuela",
    subcountry: "Anzoátegui",
    geonameid: 3486270,
  },
  {
    name: "Alto Barinas",
    country: "Venezuela",
    subcountry: "Barinas",
    geonameid: 3487903,
  },
  {
    name: "Zaraza",
    country: "Venezuela",
    subcountry: "Guárico",
    geonameid: 3625066,
  },
  {
    name: "Yumare",
    country: "Venezuela",
    subcountry: "Yaracuy",
    geonameid: 3625155,
  },
  {
    name: "Yaritagua",
    country: "Venezuela",
    subcountry: "Yaracuy",
    geonameid: 3625207,
  },
  {
    name: "Villa de Cura",
    country: "Venezuela",
    subcountry: "Aragua",
    geonameid: 3625341,
  },
  {
    name: "Villa Bruzual",
    country: "Venezuela",
    subcountry: "Portuguesa",
    geonameid: 3625346,
  },
  {
    name: "Valle de La Pascua",
    country: "Venezuela",
    subcountry: "Guárico",
    geonameid: 3625515,
  },
  {
    name: "Valera",
    country: "Venezuela",
    subcountry: "Trujillo",
    geonameid: 3625542,
  },
  {
    name: "Valencia",
    country: "Venezuela",
    subcountry: "Carabobo",
    geonameid: 3625549,
  },
  {
    name: "Ureña",
    country: "Venezuela",
    subcountry: "Táchira",
    geonameid: 3625655,
  },
  {
    name: "Urachiche",
    country: "Venezuela",
    subcountry: "Yaracuy",
    geonameid: 3625696,
  },
  {
    name: "Upata",
    country: "Venezuela",
    subcountry: "Bolívar",
    geonameid: 3625710,
  },
  {
    name: "Turmero",
    country: "Venezuela",
    subcountry: "Aragua",
    geonameid: 3625829,
  },
  {
    name: "Tumeremo",
    country: "Venezuela",
    subcountry: "Bolívar",
    geonameid: 3625892,
  },
  {
    name: "Tucupita",
    country: "Venezuela",
    subcountry: "Delta Amacuro",
    geonameid: 3625929,
  },
  {
    name: "Tucupido",
    country: "Venezuela",
    subcountry: "Guárico",
    geonameid: 3625944,
  },
  {
    name: "Tucaní",
    country: "Venezuela",
    subcountry: "Mérida",
    geonameid: 3625963,
  },
  {
    name: "Tucacas",
    country: "Venezuela",
    subcountry: "Falcón",
    geonameid: 3625965,
  },
  {
    name: "Trujillo",
    country: "Venezuela",
    subcountry: "Trujillo",
    geonameid: 3625979,
  },
  {
    name: "Tovar",
    country: "Venezuela",
    subcountry: "Mérida",
    geonameid: 3626047,
  },
  {
    name: "Tinaquillo",
    country: "Venezuela",
    subcountry: "Cojedes",
    geonameid: 3626219,
  },
  {
    name: "Tinaco",
    country: "Venezuela",
    subcountry: "Cojedes",
    geonameid: 3626235,
  },
  {
    name: "Timotes",
    country: "Venezuela",
    subcountry: "Mérida",
    geonameid: 3626237,
  },
  {
    name: "Tía Juana",
    country: "Venezuela",
    subcountry: "Zulia",
    geonameid: 3626302,
  },
  {
    name: "Temblador",
    country: "Venezuela",
    subcountry: "Monagas",
    geonameid: 3626352,
  },
  {
    name: "Táriba",
    country: "Venezuela",
    subcountry: "Táchira",
    geonameid: 3626402,
  },
  {
    name: "Tabay",
    country: "Venezuela",
    subcountry: "Mérida",
    geonameid: 3626595,
  },
  {
    name: "Soledad",
    country: "Venezuela",
    subcountry: "Anzoátegui",
    geonameid: 3626741,
  },
  {
    name: "Socopó",
    country: "Venezuela",
    subcountry: "Barinas",
    geonameid: 3626764,
  },
  {
    name: "Santa Teresa del Tuy",
    country: "Venezuela",
    subcountry: "Miranda",
    geonameid: 3627047,
  },
  {
    name: "Santa Rita",
    country: "Venezuela",
    subcountry: "Zulia",
    geonameid: 3627186,
  },
  {
    name: "Santa Elena de Uairén",
    country: "Venezuela",
    subcountry: "Bolívar",
    geonameid: 3627382,
  },
  {
    name: "Santa Cruz de Mora",
    country: "Venezuela",
    subcountry: "Mérida",
    geonameid: 3627418,
  },
  {
    name: "Santa Cruz de Mara",
    country: "Venezuela",
    subcountry: "Zulia",
    geonameid: 3627420,
  },
  {
    name: "Santa Bárbara",
    country: "Venezuela",
    subcountry: "Barinas",
    geonameid: 3627561,
  },
  {
    name: "Santa Ana",
    country: "Venezuela",
    subcountry: "Nueva Esparta",
    geonameid: 3627593,
  },
  {
    name: "Santa Ana",
    country: "Venezuela",
    subcountry: "Táchira",
    geonameid: 3627614,
  },
  {
    name: "San Rafael de Onoto",
    country: "Venezuela",
    subcountry: "Portuguesa",
    geonameid: 3627680,
  },
  {
    name: "San Rafael",
    country: "Venezuela",
    subcountry: "Zulia",
    geonameid: 3627713,
  },
  {
    name: "San Mateo",
    country: "Venezuela",
    subcountry: "Aragua",
    geonameid: 3627968,
  },
  {
    name: "San Juan de los Morros",
    country: "Venezuela",
    subcountry: "Guárico",
    geonameid: 3628053,
  },
  {
    name: "Colón",
    country: "Venezuela",
    subcountry: "Táchira",
    geonameid: 3628060,
  },
  {
    name: "San Juan Bautista",
    country: "Venezuela",
    subcountry: "Nueva Esparta",
    geonameid: 3628066,
  },
  {
    name: "San José de Barlovento",
    country: "Venezuela",
    subcountry: "Miranda",
    geonameid: 3628129,
  },
  {
    name: "San José de Guanipa",
    country: "Venezuela",
    subcountry: "Anzoátegui",
    geonameid: 3628142,
  },
  {
    name: "San Joaquín",
    country: "Venezuela",
    subcountry: "Carabobo",
    geonameid: 3628267,
  },
  {
    name: "San Felipe",
    country: "Venezuela",
    subcountry: "Yaracuy",
    geonameid: 3628423,
  },
  {
    name: "San Cristóbal",
    country: "Venezuela",
    subcountry: "Táchira",
    geonameid: 3628473,
  },
  {
    name: "San Carlos del Zulia",
    country: "Venezuela",
    subcountry: "Zulia",
    geonameid: 3628489,
  },
  {
    name: "San Carlos",
    country: "Venezuela",
    subcountry: "Cojedes",
    geonameid: 3628503,
  },
  {
    name: "Sanare",
    country: "Venezuela",
    subcountry: "Lara",
    geonameid: 3628545,
  },
  {
    name: "San Antonio del Táchira",
    country: "Venezuela",
    subcountry: "Táchira",
    geonameid: 3628549,
  },
  {
    name: "San Antonio de Los Altos",
    country: "Venezuela",
    subcountry: "Miranda",
    geonameid: 3628550,
  },
  {
    name: "Sabaneta",
    country: "Venezuela",
    subcountry: "Barinas",
    geonameid: 3628853,
  },
  {
    name: "Sabana de Parra",
    country: "Venezuela",
    subcountry: "Yaracuy",
    geonameid: 3628918,
  },
  {
    name: "Rubio",
    country: "Venezuela",
    subcountry: "Táchira",
    geonameid: 3628952,
  },
  {
    name: "La Villa del Rosario",
    country: "Venezuela",
    subcountry: "Zulia",
    geonameid: 3628966,
  },
  {
    name: "Río Chico",
    country: "Venezuela",
    subcountry: "Miranda",
    geonameid: 3629102,
  },
  {
    name: "Quíbor",
    country: "Venezuela",
    subcountry: "Lara",
    geonameid: 3629419,
  },
  {
    name: "Punto Fijo",
    country: "Venezuela",
    subcountry: "Falcón",
    geonameid: 3629576,
  },
  {
    name: "Punta de Piedras",
    country: "Venezuela",
    subcountry: "Nueva Esparta",
    geonameid: 3629601,
  },
  {
    name: "Punta de Mata",
    country: "Venezuela",
    subcountry: "Monagas",
    geonameid: 3629606,
  },
  {
    name: "Punta Cardón",
    country: "Venezuela",
    subcountry: "Falcón",
    geonameid: 3629614,
  },
  {
    name: "Puerto Píritu",
    country: "Venezuela",
    subcountry: "Anzoátegui",
    geonameid: 3629653,
  },
  {
    name: "Puerto La Cruz",
    country: "Venezuela",
    subcountry: "Anzoátegui",
    geonameid: 3629672,
  },
  {
    name: "Puerto Cumarebo",
    country: "Venezuela",
    subcountry: "Falcón",
    geonameid: 3629696,
  },
  {
    name: "Puerto Cabello",
    country: "Venezuela",
    subcountry: "Carabobo",
    geonameid: 3629706,
  },
  {
    name: "Puerto Ayacucho",
    country: "Venezuela",
    subcountry: "Amazonas",
    geonameid: 3629710,
  },
  {
    name: "Pueblo Nuevo",
    country: "Venezuela",
    subcountry: "Falcón",
    geonameid: 3629768,
  },
  {
    name: "Porlamar",
    country: "Venezuela",
    subcountry: "Nueva Esparta",
    geonameid: 3629965,
  },
  {
    name: "Píritu",
    country: "Venezuela",
    subcountry: "Portuguesa",
    geonameid: 3630089,
  },
  {
    name: "Petare",
    country: "Venezuela",
    subcountry: "Miranda",
    geonameid: 3630297,
  },
  {
    name: "Pariaguán",
    country: "Venezuela",
    subcountry: "Anzoátegui",
    geonameid: 3630687,
  },
  {
    name: "Pampatar",
    country: "Venezuela",
    subcountry: "Nueva Esparta",
    geonameid: 3630893,
  },
  {
    name: "Pampanito",
    country: "Venezuela",
    subcountry: "Trujillo",
    geonameid: 3630894,
  },
  {
    name: "Pampán",
    country: "Venezuela",
    subcountry: "Trujillo",
    geonameid: 3630896,
  },
  {
    name: "Palo Negro",
    country: "Venezuela",
    subcountry: "Aragua",
    geonameid: 3630932,
  },
  {
    name: "Palmira",
    country: "Venezuela",
    subcountry: "Táchira",
    geonameid: 3630982,
  },
  {
    name: "Ospino",
    country: "Venezuela",
    subcountry: "Portuguesa",
    geonameid: 3631208,
  },
  {
    name: "Ocumare del Tuy",
    country: "Venezuela",
    subcountry: "Miranda",
    geonameid: 3631412,
  },
  {
    name: "Obispos",
    country: "Venezuela",
    subcountry: "Barinas",
    geonameid: 3631431,
  },
  {
    name: "Nueva Bolivia",
    country: "Venezuela",
    subcountry: "Mérida",
    geonameid: 3631465,
  },
  {
    name: "Nirgua",
    country: "Venezuela",
    subcountry: "Yaracuy",
    geonameid: 3631507,
  },
  {
    name: "Motatán",
    country: "Venezuela",
    subcountry: "Trujillo",
    geonameid: 3631791,
  },
  {
    name: "Morón",
    country: "Venezuela",
    subcountry: "Carabobo",
    geonameid: 3631878,
  },
  {
    name: "Montalbán",
    country: "Venezuela",
    subcountry: "Carabobo",
    geonameid: 3632072,
  },
  {
    name: "Miranda",
    country: "Venezuela",
    subcountry: "Carabobo",
    geonameid: 3632198,
  },
  {
    name: "Michelena",
    country: "Venezuela",
    subcountry: "Táchira",
    geonameid: 3632260,
  },
  {
    name: "Mérida",
    country: "Venezuela",
    subcountry: "Mérida",
    geonameid: 3632308,
  },
  {
    name: "Mene Grande",
    country: "Venezuela",
    subcountry: "Zulia",
    geonameid: 3632399,
  },
  {
    name: "Mene de Mauroa",
    country: "Venezuela",
    subcountry: "Falcón",
    geonameid: 3632401,
  },
  {
    name: "Mariara",
    country: "Venezuela",
    subcountry: "Carabobo",
    geonameid: 3632929,
  },
  {
    name: "Maracay",
    country: "Venezuela",
    subcountry: "Aragua",
    geonameid: 3632998,
  },
  {
    name: "Maracaibo",
    country: "Venezuela",
    subcountry: "Zulia",
    geonameid: 3633009,
  },
  {
    name: "Mamporal",
    country: "Venezuela",
    subcountry: "Miranda",
    geonameid: 3633248,
  },
  {
    name: "Maiquetía",
    country: "Venezuela",
    subcountry: "Vargas",
    geonameid: 3633341,
  },
  {
    name: "Machiques",
    country: "Venezuela",
    subcountry: "Zulia",
    geonameid: 3633444,
  },
  {
    name: "Los Teques",
    country: "Venezuela",
    subcountry: "Miranda",
    geonameid: 3633622,
  },
  {
    name: "Los Rastrojos",
    country: "Venezuela",
    subcountry: "Lara",
    geonameid: 3633677,
  },
  {
    name: "Los Dos Caminos",
    country: "Venezuela",
    subcountry: "Miranda",
    geonameid: 3634184,
  },
  {
    name: "La Victoria",
    country: "Venezuela",
    subcountry: "Aragua",
    geonameid: 3634922,
  },
  {
    name: "La Vela de Coro",
    country: "Venezuela",
    subcountry: "Falcón",
    geonameid: 3634965,
  },
  {
    name: "Las Vegas",
    country: "Venezuela",
    subcountry: "Cojedes",
    geonameid: 3635260,
  },
  {
    name: "Las Tejerías",
    country: "Venezuela",
    subcountry: "Aragua",
    geonameid: 3635325,
  },
  {
    name: "La Paragua",
    country: "Venezuela",
    subcountry: "Bolívar",
    geonameid: 3636861,
  },
  {
    name: "Lagunillas",
    country: "Venezuela",
    subcountry: "Zulia",
    geonameid: 3637623,
  },
  {
    name: "Lagunillas",
    country: "Venezuela",
    subcountry: "Mérida",
    geonameid: 3637624,
  },
  {
    name: "La Guaira",
    country: "Venezuela",
    subcountry: "Vargas",
    geonameid: 3637721,
  },
  {
    name: "La Concepción",
    country: "Venezuela",
    subcountry: "Zulia",
    geonameid: 3638371,
  },
  {
    name: "Concepción",
    country: "Venezuela",
    subcountry: "Zulia",
    geonameid: 3638374,
  },
  {
    name: "La Azulita",
    country: "Venezuela",
    subcountry: "Mérida",
    geonameid: 3638904,
  },
  {
    name: "Judibana",
    country: "Venezuela",
    subcountry: "Falcón",
    geonameid: 3639086,
  },
  {
    name: "Juan Griego",
    country: "Venezuela",
    subcountry: "Nueva Esparta",
    geonameid: 3639107,
  },
  {
    name: "Higuerote",
    country: "Venezuela",
    subcountry: "Miranda",
    geonameid: 3639526,
  },
  {
    name: "Güiria",
    country: "Venezuela",
    subcountry: "Sucre",
    geonameid: 3639725,
  },
  {
    name: "Güigüe",
    country: "Venezuela",
    subcountry: "Carabobo",
    geonameid: 3639747,
  },
  {
    name: "Guatire",
    country: "Venezuela",
    subcountry: "Miranda",
    geonameid: 3639898,
  },
  {
    name: "Guasipati",
    country: "Venezuela",
    subcountry: "Bolívar",
    geonameid: 3639922,
  },
  {
    name: "Guarenas",
    country: "Venezuela",
    subcountry: "Miranda",
    geonameid: 3640049,
  },
  {
    name: "Guanarito",
    country: "Venezuela",
    subcountry: "Portuguesa",
    geonameid: 3640215,
  },
  {
    name: "Guanare",
    country: "Venezuela",
    subcountry: "Portuguesa",
    geonameid: 3640226,
  },
  {
    name: "Guama",
    country: "Venezuela",
    subcountry: "Yaracuy",
    geonameid: 3640324,
  },
  {
    name: "Guacara",
    country: "Venezuela",
    subcountry: "Carabobo",
    geonameid: 3640465,
  },
  {
    name: "Escuque",
    country: "Venezuela",
    subcountry: "Trujillo",
    geonameid: 3640956,
  },
  {
    name: "Encontrados",
    country: "Venezuela",
    subcountry: "Zulia",
    geonameid: 3641008,
  },
  {
    name: "El Vigía",
    country: "Venezuela",
    subcountry: "Mérida",
    geonameid: 3641099,
  },
  {
    name: "El Tocuyo",
    country: "Venezuela",
    subcountry: "Lara",
    geonameid: 3641275,
  },
  {
    name: "El Tigre",
    country: "Venezuela",
    subcountry: "Anzoátegui",
    geonameid: 3641351,
  },
  {
    name: "El Sombrero",
    country: "Venezuela",
    subcountry: "Guárico",
    geonameid: 3641440,
  },
  {
    name: "El Pao",
    country: "Venezuela",
    subcountry: "Cojedes",
    geonameid: 3642260,
  },
  {
    name: "Elorza",
    country: "Venezuela",
    subcountry: "Apure",
    geonameid: 3642390,
  },
  {
    name: "Lecherías",
    country: "Venezuela",
    subcountry: "Anzoátegui",
    geonameid: 3642497,
  },
  {
    name: "El Limón",
    country: "Venezuela",
    subcountry: "Aragua",
    geonameid: 3642833,
  },
  {
    name: "El Hatillo",
    country: "Venezuela",
    subcountry: "Miranda",
    geonameid: 3643031,
  },
  {
    name: "El Dorado",
    country: "Venezuela",
    subcountry: "Bolívar",
    geonameid: 3643353,
  },
  {
    name: "Ejido",
    country: "Venezuela",
    subcountry: "Mérida",
    geonameid: 3644417,
  },
  {
    name: "Duaca",
    country: "Venezuela",
    subcountry: "Lara",
    geonameid: 3644440,
  },
  {
    name: "Dabajuro",
    country: "Venezuela",
    subcountry: "Falcón",
    geonameid: 3644571,
  },
  {
    name: "Cumanacoa",
    country: "Venezuela",
    subcountry: "Sucre",
    geonameid: 3644767,
  },
  {
    name: "Cumaná",
    country: "Venezuela",
    subcountry: "Sucre",
    geonameid: 3644768,
  },
  {
    name: "Cúa",
    country: "Venezuela",
    subcountry: "Miranda",
    geonameid: 3644918,
  },
  {
    name: "Coro",
    country: "Venezuela",
    subcountry: "Falcón",
    geonameid: 3645213,
  },
  {
    name: "Coloncito",
    country: "Venezuela",
    subcountry: "Táchira",
    geonameid: 3645360,
  },
  {
    name: "Cocorote",
    country: "Venezuela",
    subcountry: "Yaracuy",
    geonameid: 3645469,
  },
  {
    name: "Clarines",
    country: "Venezuela",
    subcountry: "Anzoátegui",
    geonameid: 3645522,
  },
  {
    name: "Ciudad Piar",
    country: "Venezuela",
    subcountry: "Bolívar",
    geonameid: 3645525,
  },
  {
    name: "Ciudad Ojeda",
    country: "Venezuela",
    subcountry: "Zulia",
    geonameid: 3645527,
  },
  {
    name: "Ciudad Guayana",
    country: "Venezuela",
    subcountry: "Bolívar",
    geonameid: 3645528,
  },
  {
    name: "Ciudad Bolivia",
    country: "Venezuela",
    subcountry: "Barinas",
    geonameid: 3645531,
  },
  {
    name: "Ciudad Bolívar",
    country: "Venezuela",
    subcountry: "Bolívar",
    geonameid: 3645532,
  },
  {
    name: "Chivacoa",
    country: "Venezuela",
    subcountry: "Yaracuy",
    geonameid: 3645671,
  },
  {
    name: "Chiquinquirá",
    country: "Venezuela",
    subcountry: "Zulia",
    geonameid: 3645727,
  },
  {
    name: "Charallave",
    country: "Venezuela",
    subcountry: "Miranda",
    geonameid: 3645854,
  },
  {
    name: "Chaguaramas",
    country: "Venezuela",
    subcountry: "Guárico",
    geonameid: 3645944,
  },
  {
    name: "Chacao",
    country: "Venezuela",
    subcountry: "Miranda",
    geonameid: 3645981,
  },
  {
    name: "Tacarigua",
    country: "Venezuela",
    subcountry: "Carabobo",
    geonameid: 3646062,
  },
  {
    name: "Caucagüito",
    country: "Venezuela",
    subcountry: "Miranda",
    geonameid: 3646169,
  },
  {
    name: "Caucagua",
    country: "Venezuela",
    subcountry: "Miranda",
    geonameid: 3646175,
  },
  {
    name: "Catia La Mar",
    country: "Venezuela",
    subcountry: "Vargas",
    geonameid: 3646190,
  },
  {
    name: "Casigua El Cubo",
    country: "Venezuela",
    subcountry: "Zulia",
    geonameid: 3646296,
  },
  {
    name: "Casanay",
    country: "Venezuela",
    subcountry: "Sucre",
    geonameid: 3646316,
  },
  {
    name: "Carúpano",
    country: "Venezuela",
    subcountry: "Sucre",
    geonameid: 3646382,
  },
  {
    name: "Carrizal",
    country: "Venezuela",
    subcountry: "Miranda",
    geonameid: 3646451,
  },
  {
    name: "Carora",
    country: "Venezuela",
    subcountry: "Lara",
    geonameid: 3646487,
  },
  {
    name: "Caripito",
    country: "Venezuela",
    subcountry: "Monagas",
    geonameid: 3646534,
  },
  {
    name: "Cariaco",
    country: "Venezuela",
    subcountry: "Sucre",
    geonameid: 3646581,
  },
  {
    name: "Caracas",
    country: "Venezuela",
    subcountry: "Distrito Federal",
    geonameid: 3646738,
  },
  {
    name: "Caraballeda",
    country: "Venezuela",
    subcountry: "Vargas",
    geonameid: 3646767,
  },
  {
    name: "Cantaura",
    country: "Venezuela",
    subcountry: "Anzoátegui",
    geonameid: 3646869,
  },
  {
    name: "Camaguán",
    country: "Venezuela",
    subcountry: "Guárico",
    geonameid: 3647400,
  },
  {
    name: "Calabozo",
    country: "Venezuela",
    subcountry: "Guárico",
    geonameid: 3647444,
  },
  {
    name: "Caja Seca",
    country: "Venezuela",
    subcountry: "Zulia",
    geonameid: 3647462,
  },
  {
    name: "Caicara",
    country: "Venezuela",
    subcountry: "Monagas",
    geonameid: 3647535,
  },
  {
    name: "Caicara del Orinoco",
    country: "Venezuela",
    subcountry: "Bolívar",
    geonameid: 3647537,
  },
  {
    name: "Cagua",
    country: "Venezuela",
    subcountry: "Aragua",
    geonameid: 3647549,
  },
  {
    name: "Cabudare",
    country: "Venezuela",
    subcountry: "Lara",
    geonameid: 3647637,
  },
  {
    name: "Cabimas",
    country: "Venezuela",
    subcountry: "Zulia",
    geonameid: 3647651,
  },
  {
    name: "Boraure",
    country: "Venezuela",
    subcountry: "Yaracuy",
    geonameid: 3648042,
  },
  {
    name: "Boconoito",
    country: "Venezuela",
    subcountry: "Portuguesa",
    geonameid: 3648127,
  },
  {
    name: "Boconó",
    country: "Venezuela",
    subcountry: "Trujillo",
    geonameid: 3648132,
  },
  {
    name: "Biruaca",
    country: "Venezuela",
    subcountry: "Apure",
    geonameid: 3648279,
  },
  {
    name: "Bejuma",
    country: "Venezuela",
    subcountry: "Carabobo",
    geonameid: 3648386,
  },
  {
    name: "Baruta",
    country: "Venezuela",
    subcountry: "Miranda",
    geonameid: 3648439,
  },
  {
    name: "Barrancas",
    country: "Venezuela",
    subcountry: "Barinas",
    geonameid: 3648506,
  },
  {
    name: "Barrancas",
    country: "Venezuela",
    subcountry: "Monagas",
    geonameid: 3648507,
  },
  {
    name: "Barquisimeto",
    country: "Venezuela",
    subcountry: "Lara",
    geonameid: 3648522,
  },
  {
    name: "Barinitas",
    country: "Venezuela",
    subcountry: "Barinas",
    geonameid: 3648540,
  },
  {
    name: "Barinas",
    country: "Venezuela",
    subcountry: "Barinas",
    geonameid: 3648546,
  },
  {
    name: "Barcelona",
    country: "Venezuela",
    subcountry: "Anzoátegui",
    geonameid: 3648559,
  },
  {
    name: "Bailadores",
    country: "Venezuela",
    subcountry: "Mérida",
    geonameid: 3648685,
  },
  {
    name: "Aroa",
    country: "Venezuela",
    subcountry: "Yaracuy",
    geonameid: 3648873,
  },
  {
    name: "Araya",
    country: "Venezuela",
    subcountry: "Sucre",
    geonameid: 3649005,
  },
  {
    name: "Araure",
    country: "Venezuela",
    subcountry: "Portuguesa",
    geonameid: 3649017,
  },
  {
    name: "Aragua de Barcelona",
    country: "Venezuela",
    subcountry: "Anzoátegui",
    geonameid: 3649100,
  },
  {
    name: "Altagracia de Orituco",
    country: "Venezuela",
    subcountry: "Guárico",
    geonameid: 3649408,
  },
  {
    name: "Los Puertos de Altagracia",
    country: "Venezuela",
    subcountry: "Zulia",
    geonameid: 3649417,
  },
  {
    name: "Achaguas",
    country: "Venezuela",
    subcountry: "Apure",
    geonameid: 3649810,
  },
  {
    name: "Acarigua",
    country: "Venezuela",
    subcountry: "Portuguesa",
    geonameid: 3649833,
  },
  {
    name: "San Josecito",
    country: "Venezuela",
    subcountry: "Táchira",
    geonameid: 3758764,
  },
  {
    name: "Maturín",
    country: "Venezuela",
    subcountry: "Monagas",
    geonameid: 3778045,
  },
  {
    name: "La Fría",
    country: "Venezuela",
    subcountry: "Táchira",
    geonameid: 3795152,
  },
  {
    name: "La Grita",
    country: "Venezuela",
    subcountry: "Táchira",
    geonameid: 3795170,
  },
  {
    name: "Capacho Nuevo",
    country: "Venezuela",
    subcountry: "Táchira",
    geonameid: 3795218,
  },
  {
    name: "El Cafetal",
    country: "Venezuela",
    subcountry: "Miranda",
    geonameid: 3803449,
  },
  {
    name: "La Dolorita",
    country: "Venezuela",
    subcountry: "Miranda",
    geonameid: 3803651,
  },
  {
    name: "Guasdualito",
    country: "Venezuela",
    subcountry: "Apure",
    geonameid: 3804949,
  },
  {
    name: "San Fernando de Apure",
    country: "Venezuela",
    subcountry: "Apure",
    geonameid: 3805673,
  },
  {
    name: "Santa Cruz de los Taques",
    country: "Venezuela",
    subcountry: "Falcón",
    geonameid: 7909705,
  },
  {
    name: "Road Town",
    country: "British Virgin Islands",
    subcountry: "N/A",
    geonameid: 3577430,
  },
  {
    name: "Charlotte Amalie",
    country: "U.S. Virgin Islands",
    subcountry: "Saint Thomas Island",
    geonameid: 4795467,
  },
  {
    name: "Saint Croix",
    country: "U.S. Virgin Islands",
    subcountry: "Saint Croix Island",
    geonameid: 4796512,
  },
  {
    name: "Yên Vinh",
    country: "Vietnam",
    subcountry: "Nghệ An",
    geonameid: 1560037,
  },
  {
    name: "Yên Bái",
    country: "Vietnam",
    subcountry: "Yên Bái",
    geonameid: 1560349,
  },
  {
    name: "Xuân Mai",
    country: "Vietnam",
    subcountry: "Hanoi",
    geonameid: 1560551,
  },
  {
    name: "Vũng Tàu",
    country: "Vietnam",
    subcountry: "Bà Rịa-Vũng Tàu",
    geonameid: 1562414,
  },
  {
    name: "Vị Thanh",
    country: "Vietnam",
    subcountry: "Hậu Giang",
    geonameid: 1562538,
  },
  {
    name: "Vĩnh Yên",
    country: "Vietnam",
    subcountry: "Vĩnh Phúc",
    geonameid: 1562548,
  },
  {
    name: "Vĩnh Long",
    country: "Vietnam",
    subcountry: "Vĩnh Long",
    geonameid: 1562693,
  },
  {
    name: "Vĩnh Châu",
    country: "Vietnam",
    subcountry: "Sóc Trăng",
    geonameid: 1562773,
  },
  {
    name: "Vinh",
    country: "Vietnam",
    subcountry: "Nghệ An",
    geonameid: 1562798,
  },
  {
    name: "Việt Trì",
    country: "Vietnam",
    subcountry: "Phú Thọ",
    geonameid: 1562820,
  },
  {
    name: "Thành Phố Uông Bí",
    country: "Vietnam",
    subcountry: "Quảng Ninh",
    geonameid: 1563241,
  },
  {
    name: "Tuy Hòa",
    country: "Vietnam",
    subcountry: "Phú Yên",
    geonameid: 1563281,
  },
  {
    name: "Tuyên Quang",
    country: "Vietnam",
    subcountry: "Tuyên Quang",
    geonameid: 1563287,
  },
  {
    name: "Trà Vinh",
    country: "Vietnam",
    subcountry: "Trà Vinh",
    geonameid: 1563926,
  },
  {
    name: "Thủ Dầu Một",
    country: "Vietnam",
    subcountry: "Bình Dương",
    geonameid: 1565022,
  },
  {
    name: "Thốt Nốt",
    country: "Vietnam",
    subcountry: "Can Tho",
    geonameid: 1565136,
  },
  {
    name: "Thới Lai",
    country: "Vietnam",
    subcountry: "Can Tho",
    geonameid: 1565157,
  },
  {
    name: "Ho Chi Minh City",
    country: "Vietnam",
    subcountry: "Ho Chi Minh",
    geonameid: 1566083,
  },
  {
    name: "Thanh Hóa",
    country: "Vietnam",
    subcountry: "Thanh Hóa",
    geonameid: 1566166,
  },
  {
    name: "Thái Nguyên",
    country: "Vietnam",
    subcountry: "Thái Nguyên",
    geonameid: 1566319,
  },
  {
    name: "Thái Bình",
    country: "Vietnam",
    subcountry: "Thái Bình",
    geonameid: 1566346,
  },
  {
    name: "Tây Ninh",
    country: "Vietnam",
    subcountry: "Tây Ninh Province",
    geonameid: 1566559,
  },
  {
    name: "Tân An",
    country: "Vietnam",
    subcountry: "Long An",
    geonameid: 1567069,
  },
  {
    name: "Tam Kỳ",
    country: "Vietnam",
    subcountry: "Quảng Nam",
    geonameid: 1567148,
  },
  {
    name: "Sơn Tây",
    country: "Vietnam",
    subcountry: "Hanoi",
    geonameid: 1567621,
  },
  {
    name: "Sơn La",
    country: "Vietnam",
    subcountry: "Sơn La",
    geonameid: 1567681,
  },
  {
    name: "Sông Cầu",
    country: "Vietnam",
    subcountry: "Phú Yên",
    geonameid: 1567723,
  },
  {
    name: "Sóc Trăng",
    country: "Vietnam",
    subcountry: "Sóc Trăng",
    geonameid: 1567788,
  },
  {
    name: "Sa Dec",
    country: "Vietnam",
    subcountry: "Đồng Tháp",
    geonameid: 1568212,
  },
  {
    name: "Rạch Giá",
    country: "Vietnam",
    subcountry: "Kiến Giang",
    geonameid: 1568510,
  },
  {
    name: "Qui Nhon",
    country: "Vietnam",
    subcountry: "Bình Định",
    geonameid: 1568574,
  },
  {
    name: "Quảng Ngãi",
    country: "Vietnam",
    subcountry: "Quảng Ngãi Province",
    geonameid: 1568770,
  },
  {
    name: "Pleiku",
    country: "Vietnam",
    subcountry: "Gia Lai",
    geonameid: 1569684,
  },
  {
    name: "Phủ Lý",
    country: "Vietnam",
    subcountry: "Hà Nam",
    geonameid: 1570449,
  },
  {
    name: "Phú Khương",
    country: "Vietnam",
    subcountry: "Tây Ninh Province",
    geonameid: 1570549,
  },
  {
    name: "Phong Điền",
    country: "Vietnam",
    subcountry: "Can Tho",
    geonameid: 1570864,
  },
  {
    name: "Phan Thiết",
    country: "Vietnam",
    subcountry: "Bình Thuận",
    geonameid: 1571058,
  },
  {
    name: "Phan Rang-Tháp Chàm",
    country: "Vietnam",
    subcountry: "Ninh Thuận",
    geonameid: 1571067,
  },
  {
    name: "Ô Môn",
    country: "Vietnam",
    subcountry: "Can Tho",
    geonameid: 1571644,
  },
  {
    name: "Ninh Hòa",
    country: "Vietnam",
    subcountry: "Khánh Hòa",
    geonameid: 1571951,
  },
  {
    name: "Ninh Bình",
    country: "Vietnam",
    subcountry: "Ninh Bình",
    geonameid: 1571968,
  },
  {
    name: "Nha Trang",
    country: "Vietnam",
    subcountry: "Khánh Hòa",
    geonameid: 1572151,
  },
  {
    name: "Nhà Bè",
    country: "Vietnam",
    subcountry: "Ho Chi Minh",
    geonameid: 1572249,
  },
  {
    name: "Nghĩa Lộ",
    country: "Vietnam",
    subcountry: "Yên Bái",
    geonameid: 1572565,
  },
  {
    name: "Nam Định",
    country: "Vietnam",
    subcountry: "Nam Định",
    geonameid: 1573517,
  },
  {
    name: "Mỹ Tho",
    country: "Vietnam",
    subcountry: "Tiền Giang",
    geonameid: 1574023,
  },
  {
    name: "Mường Lay",
    country: "Vietnam",
    subcountry: "Ðiện Biên",
    geonameid: 1574257,
  },
  {
    name: "Móng Cái",
    country: "Vietnam",
    subcountry: "Quảng Ninh",
    geonameid: 1574507,
  },
  {
    name: "Long Xuyên",
    country: "Vietnam",
    subcountry: "An Giang",
    geonameid: 1575627,
  },
  {
    name: "Lào Cai",
    country: "Vietnam",
    subcountry: "Lào Cai",
    geonameid: 1576303,
  },
  {
    name: "Lạng Sơn",
    country: "Vietnam",
    subcountry: "Lạng Sơn",
    geonameid: 1576633,
  },
  {
    name: "La Gi",
    country: "Vietnam",
    subcountry: "Bình Thuận",
    geonameid: 1577995,
  },
  {
    name: "Kon Tum",
    country: "Vietnam",
    subcountry: "Kon Tum",
    geonameid: 1578500,
  },
  {
    name: "Hưng Yên",
    country: "Vietnam",
    subcountry: "Hưng Yên",
    geonameid: 1580142,
  },
  {
    name: "Huế",
    country: "Vietnam",
    subcountry: "Thừa Thiên-Huế",
    geonameid: 1580240,
  },
  {
    name: "Hạ Long",
    country: "Vietnam",
    subcountry: "Quảng Ninh",
    geonameid: 1580410,
  },
  {
    name: "Hoi An",
    country: "Vietnam",
    subcountry: "Quảng Nam",
    geonameid: 1580541,
  },
  {
    name: "Hòa Bình",
    country: "Vietnam",
    subcountry: "Hòa Bình",
    geonameid: 1580830,
  },
  {
    name: "Hà Tĩnh",
    country: "Vietnam",
    subcountry: "Hà Tĩnh",
    geonameid: 1581047,
  },
  {
    name: "Hà Tiên",
    country: "Vietnam",
    subcountry: "Kiến Giang",
    geonameid: 1581052,
  },
  {
    name: "Hanoi",
    country: "Vietnam",
    subcountry: "Hanoi",
    geonameid: 1581130,
  },
  {
    name: "Haiphong",
    country: "Vietnam",
    subcountry: "Haiphong",
    geonameid: 1581298,
  },
  {
    name: "Hải Dương",
    country: "Vietnam",
    subcountry: "Hải Dương",
    geonameid: 1581326,
  },
  {
    name: "Hà Giang",
    country: "Vietnam",
    subcountry: "Hà Giang",
    geonameid: 1581349,
  },
  {
    name: "Hà Đông",
    country: "Vietnam",
    subcountry: "Hanoi",
    geonameid: 1581364,
  },
  {
    name: "Gò Công",
    country: "Vietnam",
    subcountry: "Tiền Giang",
    geonameid: 1581529,
  },
  {
    name: "Gia Nghĩa",
    country: "Vietnam",
    subcountry: "Ðắk Nông",
    geonameid: 1581834,
  },
  {
    name: "Đưc Trọng",
    country: "Vietnam",
    subcountry: "Lâm Đồng",
    geonameid: 1582173,
  },
  {
    name: "Đồng Xoài",
    country: "Vietnam",
    subcountry: "Bình Phước",
    geonameid: 1582436,
  },
  {
    name: "Đồng Hới",
    country: "Vietnam",
    subcountry: "Quảng Bình",
    geonameid: 1582886,
  },
  {
    name: "Ðông Hà",
    country: "Vietnam",
    subcountry: "Quảng Trị",
    geonameid: 1582926,
  },
  {
    name: "Dien Bien Phu",
    country: "Vietnam",
    subcountry: "Ðiện Biên",
    geonameid: 1583477,
  },
  {
    name: "Dĩ An",
    country: "Vietnam",
    subcountry: "Bình Dương",
    geonameid: 1583518,
  },
  {
    name: "Da Nang",
    country: "Vietnam",
    subcountry: "Da Nang",
    geonameid: 1583992,
  },
  {
    name: "Ðà Lạt",
    country: "Vietnam",
    subcountry: "Lâm Đồng",
    geonameid: 1584071,
  },
  {
    name: "Đại Lộc",
    country: "Vietnam",
    subcountry: "Quảng Nam",
    geonameid: 1584301,
  },
  {
    name: "Củ Chi",
    country: "Vietnam",
    subcountry: "Ho Chi Minh",
    geonameid: 1584661,
  },
  {
    name: "Cờ Đỏ",
    country: "Vietnam",
    subcountry: "Can Tho",
    geonameid: 1584784,
  },
  {
    name: "Cổ Lóa",
    country: "Vietnam",
    subcountry: "Hanoi",
    geonameid: 1584955,
  },
  {
    name: "Chí Linh",
    country: "Vietnam",
    subcountry: "Hải Dương",
    geonameid: 1585489,
  },
  {
    name: "Châu Đốc",
    country: "Vietnam",
    subcountry: "An Giang",
    geonameid: 1585660,
  },
  {
    name: "Cát Bà",
    country: "Vietnam",
    subcountry: "Haiphong",
    geonameid: 1586052,
  },
  {
    name: "Cao Lãnh",
    country: "Vietnam",
    subcountry: "Đồng Tháp",
    geonameid: 1586151,
  },
  {
    name: "Cao Bằng",
    country: "Vietnam",
    subcountry: "Cao Bằng",
    geonameid: 1586185,
  },
  {
    name: "Cần Thơ",
    country: "Vietnam",
    subcountry: "Can Tho",
    geonameid: 1586203,
  },
  {
    name: "Cần Giờ",
    country: "Vietnam",
    subcountry: "Ho Chi Minh",
    geonameid: 1586288,
  },
  {
    name: "Cần Giuộc",
    country: "Vietnam",
    subcountry: "Long An",
    geonameid: 1586296,
  },
  {
    name: "Cam Ranh",
    country: "Vietnam",
    subcountry: "Khánh Hòa",
    geonameid: 1586350,
  },
  {
    name: "Cẩm Phả Mines",
    country: "Vietnam",
    subcountry: "Quảng Ninh",
    geonameid: 1586357,
  },
  {
    name: "Cẩm Phả",
    country: "Vietnam",
    subcountry: "Quảng Ninh",
    geonameid: 1586360,
  },
  {
    name: "Cà Mau",
    country: "Vietnam",
    subcountry: "Cà Mau",
    geonameid: 1586443,
  },
  {
    name: "Cái Răng",
    country: "Vietnam",
    subcountry: "Can Tho",
    geonameid: 1586519,
  },
  {
    name: "Buôn Ma Thuột",
    country: "Vietnam",
    subcountry: "Đắk Lắk",
    geonameid: 1586896,
  },
  {
    name: "Buôn Hồ",
    country: "Vietnam",
    subcountry: "Đắk Lắk",
    geonameid: 1586989,
  },
  {
    name: "Bình Thủy",
    country: "Vietnam",
    subcountry: "Can Tho",
    geonameid: 1587759,
  },
  {
    name: "Bỉm Sơn",
    country: "Vietnam",
    subcountry: "Thanh Hóa",
    geonameid: 1587919,
  },
  {
    name: "Biên Hòa",
    country: "Vietnam",
    subcountry: "Đồng Nai",
    geonameid: 1587923,
  },
  {
    name: "Bến Tre",
    country: "Vietnam",
    subcountry: "Bến Tre",
    geonameid: 1587976,
  },
  {
    name: "Bảo Lộc",
    country: "Vietnam",
    subcountry: "Lâm Đồng",
    geonameid: 1588275,
  },
  {
    name: "Bắc Ninh",
    country: "Vietnam",
    subcountry: "Bắc Ninh",
    geonameid: 1591449,
  },
  {
    name: "Bạc Liêu",
    country: "Vietnam",
    subcountry: "Bạc Liêu",
    geonameid: 1591474,
  },
  {
    name: "Bắc Giang",
    country: "Vietnam",
    subcountry: "Bắc Giang",
    geonameid: 1591527,
  },
  {
    name: "Bắc Kạn",
    country: "Vietnam",
    subcountry: "Bắc Kạn",
    geonameid: 1591538,
  },
  {
    name: "Cung Kiệm",
    country: "Vietnam",
    subcountry: "Bắc Ninh",
    geonameid: 8340760,
  },
  {
    name: "Bình Minh",
    country: "Vietnam",
    subcountry: "Vĩnh Long",
    geonameid: 8539621,
  },
  {
    name: "Ea Drăng",
    country: "Vietnam",
    subcountry: "Đắk Lắk",
    geonameid: 8724987,
  },
  {
    name: "Đinh Văn",
    country: "Vietnam",
    subcountry: "Lâm Đồng",
    geonameid: 8991407,
  },
  {
    name: "Vĩnh Thạnh",
    country: "Vietnam",
    subcountry: "Can Tho",
    geonameid: 9533392,
  },
  {
    name: "Thị Trấn Tân Thành",
    country: "Vietnam",
    subcountry: "Đồng Tháp",
    geonameid: 12061022,
  },
  {
    name: "Quận Đức Thịnh",
    country: "Vietnam",
    subcountry: "Đồng Tháp",
    geonameid: 12166273,
  },
  {
    name: "Quận Đức Thành",
    country: "Vietnam",
    subcountry: "Đồng Tháp",
    geonameid: 12166275,
  },
  {
    name: "Huyện Lâm Hà",
    country: "Vietnam",
    subcountry: "Lâm Đồng",
    geonameid: 12217184,
  },
  {
    name: "Phú Quốc",
    country: "Vietnam",
    subcountry: "Kiến Giang",
    geonameid: 12253704,
  },
  {
    name: "thị xã Quảng Trị",
    country: "Vietnam",
    subcountry: "Quảng Trị",
    geonameid: 12261368,
  },
  {
    name: "Quang Minh",
    country: "Vietnam",
    subcountry: "Hanoi",
    geonameid: 12382295,
  },
  {
    name: "Thuận An",
    country: "Vietnam",
    subcountry: "Bình Dương",
    geonameid: 12382296,
  },
  {
    name: "Port-Vila",
    country: "Vanuatu",
    subcountry: "Shefa",
    geonameid: 2135171,
  },
  {
    name: "Mata-Utu",
    country: "Wallis and Futuna",
    subcountry: "Uvea",
    geonameid: 4034821,
  },
  {
    name: "Apia",
    country: "Samoa",
    subcountry: "Tuamasaga",
    geonameid: 4035413,
  },
  {
    name: "Zvečan",
    country: "Kosovo",
    subcountry: "Mitrovica",
    geonameid: 783770,
  },
  {
    name: "Vushtrri",
    country: "Kosovo",
    subcountry: "Mitrovica",
    geonameid: 784097,
  },
  {
    name: "Vitina",
    country: "Kosovo",
    subcountry: "Gjilan",
    geonameid: 784372,
  },
  {
    name: "Ferizaj",
    country: "Kosovo",
    subcountry: "Ferizaj",
    geonameid: 784759,
  },
  {
    name: "Suva Reka",
    country: "Kosovo",
    subcountry: "Prizren",
    geonameid: 785238,
  },
  {
    name: "Shtime",
    country: "Kosovo",
    subcountry: "Ferizaj",
    geonameid: 785485,
  },
  {
    name: "Prizren",
    country: "Kosovo",
    subcountry: "Prizren",
    geonameid: 786712,
  },
  {
    name: "Pristina",
    country: "Kosovo",
    subcountry: "Pristina",
    geonameid: 786714,
  },
  {
    name: "Podujeva",
    country: "Kosovo",
    subcountry: "Pristina",
    geonameid: 786950,
  },
  {
    name: "Peć",
    country: "Kosovo",
    subcountry: "Pec",
    geonameid: 787157,
  },
  {
    name: "Orahovac",
    country: "Kosovo",
    subcountry: "Gjakova",
    geonameid: 787456,
  },
  {
    name: "Llazicë",
    country: "Kosovo",
    subcountry: "Prizren",
    geonameid: 788470,
  },
  {
    name: "Leposaviq",
    country: "Kosovo",
    subcountry: "Mitrovica",
    geonameid: 788731,
  },
  {
    name: "Mitrovicë",
    country: "Kosovo",
    subcountry: "Mitrovica",
    geonameid: 789225,
  },
  {
    name: "Kosovo Polje",
    country: "Kosovo",
    subcountry: "Pristina",
    geonameid: 789228,
  },
  {
    name: "Istok",
    country: "Kosovo",
    subcountry: "Pec",
    geonameid: 789996,
  },
  {
    name: "Gjilan",
    country: "Kosovo",
    subcountry: "Gjilan",
    geonameid: 790674,
  },
  {
    name: "Glogovac",
    country: "Kosovo",
    subcountry: "Pristina",
    geonameid: 790701,
  },
  {
    name: "Dragash",
    country: "Kosovo",
    subcountry: "Prizren",
    geonameid: 791122,
  },
  {
    name: "Deçan",
    country: "Kosovo",
    subcountry: "Gjakova",
    geonameid: 791580,
  },
  {
    name: "Gjakovë",
    country: "Kosovo",
    subcountry: "Gjakova",
    geonameid: 791646,
  },
  {
    name: "Zinjibār",
    country: "Yemen",
    subcountry: "Abyan Governorate",
    geonameid: 69426,
  },
  {
    name: "Zabīd",
    country: "Yemen",
    subcountry: "Al Hudaydah",
    geonameid: 69500,
  },
  {
    name: "Yarīm",
    country: "Yemen",
    subcountry: "Ibb Governorate",
    geonameid: 69559,
  },
  {
    name: "Taiz",
    country: "Yemen",
    subcountry: "Ta‘izz",
    geonameid: 70225,
  },
  {
    name: "Sayyān",
    country: "Yemen",
    subcountry: "Sanaa Governorate",
    geonameid: 70979,
  },
  {
    name: "Sanaa",
    country: "Yemen",
    subcountry: "Amanat Alasimah",
    geonameid: 71137,
  },
  {
    name: "Saḩar",
    country: "Yemen",
    subcountry: "Sanaa Governorate",
    geonameid: 71273,
  },
  {
    name: "Sa'dah",
    country: "Yemen",
    subcountry: "Şa‘dah",
    geonameid: 71334,
  },
  {
    name: "Ma'rib",
    country: "Yemen",
    subcountry: "Ma’rib",
    geonameid: 72968,
  },
  {
    name: "Laḩij",
    country: "Yemen",
    subcountry: "Laḩij",
    geonameid: 73560,
  },
  {
    name: "Ibb",
    country: "Yemen",
    subcountry: "Ibb Governorate",
    geonameid: 74477,
  },
  {
    name: "Ḩajjah",
    country: "Yemen",
    subcountry: "Ḩajjah",
    geonameid: 75337,
  },
  {
    name: "Dhī as Sufāl",
    country: "Yemen",
    subcountry: "Ibb Governorate",
    geonameid: 76154,
  },
  {
    name: "Dhamār",
    country: "Yemen",
    subcountry: "Dhamār",
    geonameid: 76184,
  },
  {
    name: "Bayt al Faqīh",
    country: "Yemen",
    subcountry: "Al Hudaydah",
    geonameid: 76991,
  },
  {
    name: "Bājil",
    country: "Yemen",
    subcountry: "Al Hudaydah",
    geonameid: 77408,
  },
  {
    name: "Ataq",
    country: "Yemen",
    subcountry: "Shabwah",
    geonameid: 77726,
  },
  {
    name: "‘Amrān",
    country: "Yemen",
    subcountry: "Omran",
    geonameid: 78428,
  },
  {
    name: "Mukalla",
    country: "Yemen",
    subcountry: "Muhafazat Hadramaout",
    geonameid: 78754,
  },
  {
    name: "Al Ḩudaydah",
    country: "Yemen",
    subcountry: "Al Hudaydah",
    geonameid: 79415,
  },
  {
    name: "Al Ḩazm",
    country: "Yemen",
    subcountry: "Al Jawf",
    geonameid: 79455,
  },
  {
    name: "Al Bayda",
    country: "Yemen",
    subcountry: "Al Bayda",
    geonameid: 79836,
  },
  {
    name: "Aden",
    country: "Yemen",
    subcountry: "Aden",
    geonameid: 415189,
  },
  {
    name: "Mamoudzou",
    country: "Mayotte",
    subcountry: "Mamoudzou",
    geonameid: 921815,
  },
  {
    name: "Dzaoudzi",
    country: "Mayotte",
    subcountry: "Dzaoudzi",
    geonameid: 921900,
  },
  {
    name: "Koungou",
    country: "Mayotte",
    subcountry: "Koungou",
    geonameid: 1090225,
  },
  {
    name: "Roodepoort",
    country: "South Africa",
    subcountry: "Gauteng",
    geonameid: 936374,
  },
  {
    name: "Zeerust",
    country: "South Africa",
    subcountry: "North-West",
    geonameid: 937136,
  },
  {
    name: "Wolmaransstad",
    country: "South Africa",
    subcountry: "North-West",
    geonameid: 938457,
  },
  {
    name: "White River",
    country: "South Africa",
    subcountry: "Mpumalanga",
    geonameid: 938694,
  },
  {
    name: "Emalahleni",
    country: "South Africa",
    subcountry: "Mpumalanga",
    geonameid: 939270,
  },
  {
    name: "Westonaria",
    country: "South Africa",
    subcountry: "Gauteng",
    geonameid: 940316,
  },
  {
    name: "Wesselsbron",
    country: "South Africa",
    subcountry: "Orange Free State",
    geonameid: 940424,
  },
  {
    name: "Welkom",
    country: "South Africa",
    subcountry: "Orange Free State",
    geonameid: 940909,
  },
  {
    name: "Warrenton",
    country: "South Africa",
    subcountry: "Northern Cape",
    geonameid: 941931,
  },
  {
    name: "Bela Bela",
    country: "South Africa",
    subcountry: "Limpopo",
    geonameid: 941966,
  },
  {
    name: "Vryheid",
    country: "South Africa",
    subcountry: "KwaZulu-Natal",
    geonameid: 942470,
  },
  {
    name: "Vryburg",
    country: "South Africa",
    subcountry: "North-West",
    geonameid: 942511,
  },
  {
    name: "Volksrust",
    country: "South Africa",
    subcountry: "Mpumalanga",
    geonameid: 943032,
  },
  {
    name: "Virginia",
    country: "South Africa",
    subcountry: "Orange Free State",
    geonameid: 943882,
  },
  {
    name: "Viljoenskroon",
    country: "South Africa",
    subcountry: "Orange Free State",
    geonameid: 943960,
  },
  {
    name: "Vereeniging",
    country: "South Africa",
    subcountry: "Gauteng",
    geonameid: 944385,
  },
  {
    name: "Vanderbijlpark",
    country: "South Africa",
    subcountry: "Gauteng",
    geonameid: 944986,
  },
  {
    name: "Upington",
    country: "South Africa",
    subcountry: "Northern Cape",
    geonameid: 945945,
  },
  {
    name: "Mthatha",
    country: "South Africa",
    subcountry: "Eastern Cape",
    geonameid: 946058,
  },
  {
    name: "eMkhomazi",
    country: "South Africa",
    subcountry: "KwaZulu-Natal",
    geonameid: 946128,
  },
  {
    name: "Ulundi",
    country: "South Africa",
    subcountry: "KwaZulu-Natal",
    geonameid: 946257,
  },
  {
    name: "Uitenhage",
    country: "South Africa",
    subcountry: "Eastern Cape",
    geonameid: 946877,
  },
  {
    name: "Tzaneen",
    country: "South Africa",
    subcountry: "Limpopo",
    geonameid: 946973,
  },
  {
    name: "Thohoyandou",
    country: "South Africa",
    subcountry: "Limpopo",
    geonameid: 949224,
  },
  {
    name: "Theunissen",
    country: "South Africa",
    subcountry: "Orange Free State",
    geonameid: 949282,
  },
  {
    name: "Thaba Nchu",
    country: "South Africa",
    subcountry: "Orange Free State",
    geonameid: 949703,
  },
  {
    name: "Tembisa",
    country: "South Africa",
    subcountry: "Gauteng",
    geonameid: 949880,
  },
  {
    name: "Stutterheim",
    country: "South Africa",
    subcountry: "Eastern Cape",
    geonameid: 951650,
  },
  {
    name: "Stilfontein",
    country: "South Africa",
    subcountry: "North-West",
    geonameid: 952192,
  },
  {
    name: "KwaDukuza",
    country: "South Africa",
    subcountry: "KwaZulu-Natal",
    geonameid: 952734,
  },
  {
    name: "Standerton",
    country: "South Africa",
    subcountry: "Mpumalanga",
    geonameid: 952747,
  },
  {
    name: "Springs",
    country: "South Africa",
    subcountry: "Gauteng",
    geonameid: 952865,
  },
  {
    name: "Soweto",
    country: "South Africa",
    subcountry: "Gauteng",
    geonameid: 953781,
  },
  {
    name: "Somerset East",
    country: "South Africa",
    subcountry: "Eastern Cape",
    geonameid: 954161,
  },
  {
    name: "Siyabuswa",
    country: "South Africa",
    subcountry: "Mpumalanga",
    geonameid: 955313,
  },
  {
    name: "Senekal",
    country: "South Africa",
    subcountry: "Orange Free State",
    geonameid: 956507,
  },
  {
    name: "Secunda",
    country: "South Africa",
    subcountry: "Mpumalanga",
    geonameid: 956767,
  },
  {
    name: "Scottburgh",
    country: "South Africa",
    subcountry: "KwaZulu-Natal",
    geonameid: 956878,
  },
  {
    name: "Schweizer-Reneke",
    country: "South Africa",
    subcountry: "North-West",
    geonameid: 956907,
  },
  {
    name: "Sasolburg",
    country: "South Africa",
    subcountry: "Orange Free State",
    geonameid: 957487,
  },
  {
    name: "Rustenburg",
    country: "South Africa",
    subcountry: "North-West",
    geonameid: 958724,
  },
  {
    name: "Riversdale",
    country: "South Africa",
    subcountry: "Western Cape",
    geonameid: 961152,
  },
  {
    name: "Richmond",
    country: "South Africa",
    subcountry: "KwaZulu-Natal",
    geonameid: 962330,
  },
  {
    name: "Richards Bay",
    country: "South Africa",
    subcountry: "KwaZulu-Natal",
    geonameid: 962367,
  },
  {
    name: "Reitz",
    country: "South Africa",
    subcountry: "Orange Free State",
    geonameid: 962847,
  },
  {
    name: "Randfontein",
    country: "South Africa",
    subcountry: "Gauteng",
    geonameid: 963230,
  },
  {
    name: "Randburg",
    country: "South Africa",
    subcountry: "Gauteng",
    geonameid: 963241,
  },
  {
    name: "Queenstown",
    country: "South Africa",
    subcountry: "Eastern Cape",
    geonameid: 963516,
  },
  {
    name: "Queensdale",
    country: "South Africa",
    subcountry: "Eastern Cape",
    geonameid: 963525,
  },
  {
    name: "Pretoria",
    country: "South Africa",
    subcountry: "Gauteng",
    geonameid: 964137,
  },
  {
    name: "Mokopane",
    country: "South Africa",
    subcountry: "Limpopo",
    geonameid: 964315,
  },
  {
    name: "Potchefstroom",
    country: "South Africa",
    subcountry: "North-West",
    geonameid: 964349,
  },
  {
    name: "Postmasburg",
    country: "South Africa",
    subcountry: "Northern Cape",
    geonameid: 964363,
  },
  {
    name: "Port Shepstone",
    country: "South Africa",
    subcountry: "KwaZulu-Natal",
    geonameid: 964406,
  },
  {
    name: "Port Elizabeth",
    country: "South Africa",
    subcountry: "Eastern Cape",
    geonameid: 964420,
  },
  {
    name: "Port Alfred",
    country: "South Africa",
    subcountry: "Eastern Cape",
    geonameid: 964432,
  },
  {
    name: "Plettenberg Bay",
    country: "South Africa",
    subcountry: "Western Cape",
    geonameid: 964712,
  },
  {
    name: "Pinetown",
    country: "South Africa",
    subcountry: "KwaZulu-Natal",
    geonameid: 965154,
  },
  {
    name: "Piet Retief",
    country: "South Africa",
    subcountry: "Mpumalanga",
    geonameid: 965241,
  },
  {
    name: "Polokwane",
    country: "South Africa",
    subcountry: "Limpopo",
    geonameid: 965289,
  },
  {
    name: "Pietermaritzburg",
    country: "South Africa",
    subcountry: "KwaZulu-Natal",
    geonameid: 965301,
  },
  {
    name: "Phuthaditjhaba",
    country: "South Africa",
    subcountry: "Orange Free State",
    geonameid: 965401,
  },
  {
    name: "Phalaborwa",
    country: "South Africa",
    subcountry: "Limpopo",
    geonameid: 965528,
  },
  {
    name: "Parys",
    country: "South Africa",
    subcountry: "Orange Free State",
    geonameid: 966166,
  },
  {
    name: "Pampierstad",
    country: "South Africa",
    subcountry: "Northern Cape",
    geonameid: 966380,
  },
  {
    name: "Oudtshoorn",
    country: "South Africa",
    subcountry: "Western Cape",
    geonameid: 967106,
  },
  {
    name: "Modimolle",
    country: "South Africa",
    subcountry: "Limpopo",
    geonameid: 968665,
  },
  {
    name: "Nkowakowa",
    country: "South Africa",
    subcountry: "Limpopo",
    geonameid: 970341,
  },
  {
    name: "Nigel",
    country: "South Africa",
    subcountry: "Gauteng",
    geonameid: 970566,
  },
  {
    name: "Newcastle",
    country: "South Africa",
    subcountry: "KwaZulu-Natal",
    geonameid: 971421,
  },
  {
    name: "Nelspruit",
    country: "South Africa",
    subcountry: "Mpumalanga",
    geonameid: 971534,
  },
  {
    name: "Mpumalanga",
    country: "South Africa",
    subcountry: "KwaZulu-Natal",
    geonameid: 973111,
  },
  {
    name: "Mpophomeni",
    country: "South Africa",
    subcountry: "KwaZulu-Natal",
    geonameid: 973139,
  },
  {
    name: "Mossel Bay",
    country: "South Africa",
    subcountry: "Western Cape",
    geonameid: 973709,
  },
  {
    name: "Montagu",
    country: "South Africa",
    subcountry: "Western Cape",
    geonameid: 974611,
  },
  {
    name: "Mondlo",
    country: "South Africa",
    subcountry: "KwaZulu-Natal",
    geonameid: 974670,
  },
  {
    name: "Mmabatho",
    country: "South Africa",
    subcountry: "North-West",
    geonameid: 975436,
  },
  {
    name: "Middelburg",
    country: "South Africa",
    subcountry: "Eastern Cape",
    geonameid: 976358,
  },
  {
    name: "Middelburg",
    country: "South Africa",
    subcountry: "Mpumalanga",
    geonameid: 976361,
  },
  {
    name: "Margate",
    country: "South Africa",
    subcountry: "KwaZulu-Natal",
    geonameid: 978895,
  },
  {
    name: "Mabopane",
    country: "South Africa",
    subcountry: "Gauteng",
    geonameid: 980921,
  },
  {
    name: "Lydenburg",
    country: "South Africa",
    subcountry: "Mpumalanga",
    geonameid: 981158,
  },
  {
    name: "Louis Trichardt",
    country: "South Africa",
    subcountry: "Limpopo",
    geonameid: 981827,
  },
  {
    name: "Lichtenburg",
    country: "South Africa",
    subcountry: "North-West",
    geonameid: 982899,
  },
  {
    name: "Lebowakgomo",
    country: "South Africa",
    subcountry: "Limpopo",
    geonameid: 984087,
  },
  {
    name: "Lady Frere",
    country: "South Africa",
    subcountry: "Eastern Cape",
    geonameid: 985011,
  },
  {
    name: "Ladybrand",
    country: "South Africa",
    subcountry: "Orange Free State",
    geonameid: 985015,
  },
  {
    name: "Kutloanong",
    country: "South Africa",
    subcountry: "Orange Free State",
    geonameid: 986083,
  },
  {
    name: "Kruisfontein",
    country: "South Africa",
    subcountry: "Eastern Cape",
    geonameid: 986717,
  },
  {
    name: "Krugersdorp",
    country: "South Africa",
    subcountry: "Gauteng",
    geonameid: 986822,
  },
  {
    name: "Kroonstad",
    country: "South Africa",
    subcountry: "Orange Free State",
    geonameid: 986846,
  },
  {
    name: "Kriel",
    country: "South Africa",
    subcountry: "Mpumalanga",
    geonameid: 987202,
  },
  {
    name: "Komatipoort",
    country: "South Africa",
    subcountry: "Mpumalanga",
    geonameid: 988290,
  },
  {
    name: "Kokstad",
    country: "South Africa",
    subcountry: "KwaZulu-Natal",
    geonameid: 988356,
  },
  {
    name: "Knysna",
    country: "South Africa",
    subcountry: "Western Cape",
    geonameid: 988698,
  },
  {
    name: "Klerksdorp",
    country: "South Africa",
    subcountry: "North-West",
    geonameid: 989921,
  },
  {
    name: "Kimberley",
    country: "South Africa",
    subcountry: "Northern Cape",
    geonameid: 990930,
  },
  {
    name: "Johannesburg",
    country: "South Africa",
    subcountry: "Gauteng",
    geonameid: 993800,
  },
  {
    name: "Howick",
    country: "South Africa",
    subcountry: "KwaZulu-Natal",
    geonameid: 995202,
  },
  {
    name: "Hennenman",
    country: "South Africa",
    subcountry: "Orange Free State",
    geonameid: 996918,
  },
  {
    name: "Hendrina",
    country: "South Africa",
    subcountry: "Mpumalanga",
    geonameid: 996930,
  },
  {
    name: "Heilbron",
    country: "South Africa",
    subcountry: "Orange Free State",
    geonameid: 997140,
  },
  {
    name: "Heidelberg",
    country: "South Africa",
    subcountry: "Gauteng",
    geonameid: 997151,
  },
  {
    name: "Harrismith",
    country: "South Africa",
    subcountry: "Orange Free State",
    geonameid: 997751,
  },
  {
    name: "Grahamstown",
    country: "South Africa",
    subcountry: "Eastern Cape",
    geonameid: 1000501,
  },
  {
    name: "Graaff-Reinet",
    country: "South Africa",
    subcountry: "Eastern Cape",
    geonameid: 1000543,
  },
  {
    name: "Giyani",
    country: "South Africa",
    subcountry: "Limpopo",
    geonameid: 1001860,
  },
  {
    name: "George",
    country: "South Africa",
    subcountry: "Western Cape",
    geonameid: 1002145,
  },
  {
    name: "Ga-Rankuwa",
    country: "South Africa",
    subcountry: "North-West",
    geonameid: 1002851,
  },
  {
    name: "Fort Beaufort",
    country: "South Africa",
    subcountry: "Eastern Cape",
    geonameid: 1003953,
  },
  {
    name: "Fochville",
    country: "South Africa",
    subcountry: "North-West",
    geonameid: 1004109,
  },
  {
    name: "eSikhaleni",
    country: "South Africa",
    subcountry: "KwaZulu-Natal",
    geonameid: 1005029,
  },
  {
    name: "Ermelo",
    country: "South Africa",
    subcountry: "Mpumalanga",
    geonameid: 1005125,
  },
  {
    name: "Empangeni",
    country: "South Africa",
    subcountry: "KwaZulu-Natal",
    geonameid: 1005544,
  },
  {
    name: "eMbalenhle",
    country: "South Africa",
    subcountry: "Mpumalanga",
    geonameid: 1005646,
  },
  {
    name: "Edenvale",
    country: "South Africa",
    subcountry: "Gauteng",
    geonameid: 1006834,
  },
  {
    name: "East London",
    country: "South Africa",
    subcountry: "Eastern Cape",
    geonameid: 1006984,
  },
  {
    name: "Durban",
    country: "South Africa",
    subcountry: "KwaZulu-Natal",
    geonameid: 1007311,
  },
  {
    name: "Dundee",
    country: "South Africa",
    subcountry: "KwaZulu-Natal",
    geonameid: 1007400,
  },
  {
    name: "Duiwelskloof",
    country: "South Africa",
    subcountry: "Limpopo",
    geonameid: 1007514,
  },
  {
    name: "Driefontein",
    country: "South Africa",
    subcountry: "Mpumalanga",
    geonameid: 1008261,
  },
  {
    name: "Delmas",
    country: "South Africa",
    subcountry: "Mpumalanga",
    geonameid: 1011031,
  },
  {
    name: "De Aar",
    country: "South Africa",
    subcountry: "Northern Cape",
    geonameid: 1011632,
  },
  {
    name: "Cullinan",
    country: "South Africa",
    subcountry: "Gauteng",
    geonameid: 1012413,
  },
  {
    name: "Cradock",
    country: "South Africa",
    subcountry: "Eastern Cape",
    geonameid: 1012600,
  },
  {
    name: "Christiana",
    country: "South Africa",
    subcountry: "North-West",
    geonameid: 1013550,
  },
  {
    name: "Carletonville",
    country: "South Africa",
    subcountry: "Gauteng",
    geonameid: 1014073,
  },
  {
    name: "Butterworth",
    country: "South Africa",
    subcountry: "Eastern Cape",
    geonameid: 1014489,
  },
  {
    name: "Bronkhorstspruit",
    country: "South Africa",
    subcountry: "Gauteng",
    geonameid: 1015504,
  },
  {
    name: "Brits",
    country: "South Africa",
    subcountry: "North-West",
    geonameid: 1015621,
  },
  {
    name: "Brakpan",
    country: "South Africa",
    subcountry: "Gauteng",
    geonameid: 1016181,
  },
  {
    name: "Botshabelo",
    country: "South Africa",
    subcountry: "Orange Free State",
    geonameid: 1016670,
  },
  {
    name: "Bothaville",
    country: "South Africa",
    subcountry: "Orange Free State",
    geonameid: 1016698,
  },
  {
    name: "Boksburg",
    country: "South Africa",
    subcountry: "Gauteng",
    geonameid: 1017780,
  },
  {
    name: "Bloemhof",
    country: "South Africa",
    subcountry: "North-West",
    geonameid: 1018673,
  },
  {
    name: "Bloemfontein",
    country: "South Africa",
    subcountry: "Orange Free State",
    geonameid: 1018725,
  },
  {
    name: "Bhisho",
    country: "South Africa",
    subcountry: "Eastern Cape",
    geonameid: 1019330,
  },
  {
    name: "Bethlehem",
    country: "South Africa",
    subcountry: "Orange Free State",
    geonameid: 1019704,
  },
  {
    name: "Bethal",
    country: "South Africa",
    subcountry: "Mpumalanga",
    geonameid: 1019760,
  },
  {
    name: "Benoni",
    country: "South Africa",
    subcountry: "Gauteng",
    geonameid: 1020098,
  },
  {
    name: "Beaufort West",
    country: "South Africa",
    subcountry: "Western Cape",
    geonameid: 1020641,
  },
  {
    name: "Barberton",
    country: "South Africa",
    subcountry: "Mpumalanga",
    geonameid: 1021086,
  },
  {
    name: "Ballito",
    country: "South Africa",
    subcountry: "KwaZulu-Natal",
    geonameid: 1021360,
  },
  {
    name: "Balfour",
    country: "South Africa",
    subcountry: "Mpumalanga",
    geonameid: 1021396,
  },
  {
    name: "Allanridge",
    country: "South Africa",
    subcountry: "Orange Free State",
    geonameid: 1023287,
  },
  {
    name: "Aliwal North",
    country: "South Africa",
    subcountry: "Eastern Cape",
    geonameid: 1023309,
  },
  {
    name: "Alberton",
    country: "South Africa",
    subcountry: "Gauteng",
    geonameid: 1023441,
  },
  {
    name: "Ekangala",
    country: "South Africa",
    subcountry: "Gauteng",
    geonameid: 1105726,
  },
  {
    name: "Midrand",
    country: "South Africa",
    subcountry: "Gauteng",
    geonameid: 1105776,
  },
  {
    name: "Centurion",
    country: "South Africa",
    subcountry: "Gauteng",
    geonameid: 1105777,
  },
  {
    name: "Worcester",
    country: "South Africa",
    subcountry: "Western Cape",
    geonameid: 3359041,
  },
  {
    name: "Wellington",
    country: "South Africa",
    subcountry: "Western Cape",
    geonameid: 3359510,
  },
  {
    name: "Vredenburg",
    country: "South Africa",
    subcountry: "Western Cape",
    geonameid: 3359741,
  },
  {
    name: "Stellenbosch",
    country: "South Africa",
    subcountry: "Western Cape",
    geonameid: 3361025,
  },
  {
    name: "Saldanha",
    country: "South Africa",
    subcountry: "Western Cape",
    geonameid: 3361934,
  },
  {
    name: "Robertson",
    country: "South Africa",
    subcountry: "Western Cape",
    geonameid: 3362349,
  },
  {
    name: "Paarl",
    country: "South Africa",
    subcountry: "Western Cape",
    geonameid: 3363094,
  },
  {
    name: "Malmesbury",
    country: "South Africa",
    subcountry: "Western Cape",
    geonameid: 3364346,
  },
  {
    name: "Lansdowne",
    country: "South Africa",
    subcountry: "Western Cape",
    geonameid: 3364682,
  },
  {
    name: "Kraaifontein",
    country: "South Africa",
    subcountry: "Western Cape",
    geonameid: 3365083,
  },
  {
    name: "Hermanus",
    country: "South Africa",
    subcountry: "Western Cape",
    geonameid: 3366880,
  },
  {
    name: "Grabouw",
    country: "South Africa",
    subcountry: "Western Cape",
    geonameid: 3367513,
  },
  {
    name: "Ceres",
    country: "South Africa",
    subcountry: "Western Cape",
    geonameid: 3369129,
  },
  {
    name: "Cape Town",
    country: "South Africa",
    subcountry: "Western Cape",
    geonameid: 3369157,
  },
  {
    name: "Atlantis",
    country: "South Africa",
    subcountry: "Western Cape",
    geonameid: 3370352,
  },
  {
    name: "Rondebosch",
    country: "South Africa",
    subcountry: "Western Cape",
    geonameid: 7302802,
  },
  {
    name: "Midstream",
    country: "South Africa",
    subcountry: "Gauteng",
    geonameid: 8030233,
  },
  {
    name: "Retreat",
    country: "South Africa",
    subcountry: "Western Cape",
    geonameid: 8604596,
  },
  {
    name: "Diepsloot",
    country: "South Africa",
    subcountry: "Gauteng",
    geonameid: 8764562,
  },
  {
    name: "Riverlea",
    country: "South Africa",
    subcountry: "Gauteng",
    geonameid: 11205175,
  },
  {
    name: "Nchelenge",
    country: "Zambia",
    subcountry: "Luapula",
    geonameid: 175499,
  },
  {
    name: "Mbala",
    country: "Zambia",
    subcountry: "Northern",
    geonameid: 176146,
  },
  {
    name: "Kawambwa",
    country: "Zambia",
    subcountry: "Luapula",
    geonameid: 176555,
  },
  {
    name: "Siavonga",
    country: "Zambia",
    subcountry: "Southern",
    geonameid: 898188,
  },
  {
    name: "Sesheke",
    country: "Zambia",
    subcountry: "Western",
    geonameid: 898905,
  },
  {
    name: "Samfya",
    country: "Zambia",
    subcountry: "Luapula",
    geonameid: 899274,
  },
  {
    name: "Petauke",
    country: "Zambia",
    subcountry: "Eastern",
    geonameid: 899825,
  },
  {
    name: "Ndola",
    country: "Zambia",
    subcountry: "Copperbelt",
    geonameid: 901344,
  },
  {
    name: "Mumbwa",
    country: "Zambia",
    subcountry: "Central",
    geonameid: 904422,
  },
  {
    name: "Mufulira",
    country: "Zambia",
    subcountry: "Copperbelt",
    geonameid: 905395,
  },
  {
    name: "Mpika",
    country: "Zambia",
    subcountry: "Muchinga",
    geonameid: 905846,
  },
  {
    name: "Monze",
    country: "Zambia",
    subcountry: "Southern",
    geonameid: 906044,
  },
  {
    name: "Mongu",
    country: "Zambia",
    subcountry: "Western",
    geonameid: 906054,
  },
  {
    name: "Mazabuka",
    country: "Zambia",
    subcountry: "Southern",
    geonameid: 907111,
  },
  {
    name: "Mansa",
    country: "Zambia",
    subcountry: "Luapula",
    geonameid: 907770,
  },
  {
    name: "Lusaka",
    country: "Zambia",
    subcountry: "Lusaka",
    geonameid: 909137,
  },
  {
    name: "Luanshya",
    country: "Zambia",
    subcountry: "Copperbelt",
    geonameid: 909863,
  },
  {
    name: "Livingstone",
    country: "Zambia",
    subcountry: "Southern",
    geonameid: 910111,
  },
  {
    name: "Kitwe",
    country: "Zambia",
    subcountry: "Copperbelt",
    geonameid: 911148,
  },
  {
    name: "Kasama",
    country: "Zambia",
    subcountry: "Northern",
    geonameid: 912764,
  },
  {
    name: "Kapiri Mposhi",
    country: "Zambia",
    subcountry: "Central",
    geonameid: 913029,
  },
  {
    name: "Kansanshi",
    country: "Zambia",
    subcountry: "North-Western",
    geonameid: 913613,
  },
  {
    name: "Kalulushi",
    country: "Zambia",
    subcountry: "Copperbelt",
    geonameid: 914959,
  },
  {
    name: "Kafue",
    country: "Zambia",
    subcountry: "Lusaka",
    geonameid: 915883,
  },
  {
    name: "Kabwe",
    country: "Zambia",
    subcountry: "Central",
    geonameid: 916095,
  },
  {
    name: "Choma",
    country: "Zambia",
    subcountry: "Southern",
    geonameid: 917748,
  },
  {
    name: "Chipata",
    country: "Zambia",
    subcountry: "Eastern",
    geonameid: 918702,
  },
  {
    name: "Chingola",
    country: "Zambia",
    subcountry: "Copperbelt",
    geonameid: 919009,
  },
  {
    name: "Chililabombwe",
    country: "Zambia",
    subcountry: "Copperbelt",
    geonameid: 919544,
  },
  {
    name: "Zvishavane",
    country: "Zimbabwe",
    subcountry: "Masvingo",
    geonameid: 878549,
  },
  {
    name: "Victoria Falls",
    country: "Zimbabwe",
    subcountry: "Matabeleland North",
    geonameid: 879431,
  },
  {
    name: "Shurugwi",
    country: "Zimbabwe",
    subcountry: "Midlands",
    geonameid: 881164,
  },
  {
    name: "Ruwa",
    country: "Zimbabwe",
    subcountry: "Mashonaland East",
    geonameid: 882009,
  },
  {
    name: "Rusape",
    country: "Zimbabwe",
    subcountry: "Manicaland",
    geonameid: 882100,
  },
  {
    name: "Redcliff",
    country: "Zimbabwe",
    subcountry: "Midlands",
    geonameid: 882599,
  },
  {
    name: "Norton",
    country: "Zimbabwe",
    subcountry: "Mashonaland West",
    geonameid: 884141,
  },
  {
    name: "Mutare",
    country: "Zimbabwe",
    subcountry: "Manicaland",
    geonameid: 884979,
  },
  {
    name: "Masvingo",
    country: "Zimbabwe",
    subcountry: "Masvingo",
    geonameid: 886763,
  },
  {
    name: "Marondera",
    country: "Zimbabwe",
    subcountry: "Mashonaland East",
    geonameid: 886990,
  },
  {
    name: "Kwekwe",
    country: "Zimbabwe",
    subcountry: "Midlands",
    geonameid: 888710,
  },
  {
    name: "Karoi",
    country: "Zimbabwe",
    subcountry: "Mashonaland West",
    geonameid: 889191,
  },
  {
    name: "Kariba",
    country: "Zimbabwe",
    subcountry: "Mashonaland West",
    geonameid: 889215,
  },
  {
    name: "Kadoma",
    country: "Zimbabwe",
    subcountry: "Mashonaland West",
    geonameid: 889453,
  },
  {
    name: "Hwange",
    country: "Zimbabwe",
    subcountry: "Matabeleland North",
    geonameid: 889942,
  },
  {
    name: "Harare",
    country: "Zimbabwe",
    subcountry: "Harare",
    geonameid: 890299,
  },
  {
    name: "Gweru",
    country: "Zimbabwe",
    subcountry: "Midlands",
    geonameid: 890422,
  },
  {
    name: "Gwanda",
    country: "Zimbabwe",
    subcountry: "Matabeleland South",
    geonameid: 890516,
  },
  {
    name: "Gokwe",
    country: "Zimbabwe",
    subcountry: "Midlands",
    geonameid: 890983,
  },
  {
    name: "Chiredzi",
    country: "Zimbabwe",
    subcountry: "Masvingo",
    geonameid: 893485,
  },
  {
    name: "Chipinge",
    country: "Zimbabwe",
    subcountry: "Manicaland",
    geonameid: 893549,
  },
  {
    name: "Chinhoyi",
    country: "Zimbabwe",
    subcountry: "Mashonaland West",
    geonameid: 893697,
  },
  {
    name: "Chegutu",
    country: "Zimbabwe",
    subcountry: "Mashonaland West",
    geonameid: 894239,
  },
  {
    name: "Bulawayo",
    country: "Zimbabwe",
    subcountry: "Bulawayo",
    geonameid: 894701,
  },
  {
    name: "Bindura",
    country: "Zimbabwe",
    subcountry: "Mashonaland Central",
    geonameid: 895061,
  },
  {
    name: "Beitbridge",
    country: "Zimbabwe",
    subcountry: "Matabeleland South",
    geonameid: 895269,
  },
  {
    name: "Epworth",
    country: "Zimbabwe",
    subcountry: "Harare",
    geonameid: 1085510,
  },
  {
    name: "Chitungwiza",
    country: "Zimbabwe",
    subcountry: "Harare",
    geonameid: 1106542,
  },
]
interface CountryOption {
  label: string
  value: string
}
export function getUniqueCountryOptions(
  worldCities: {
    name: string
    country: string
    subcountry: string
    geonameid: number
  }[],
) {
  const countries = new Set<string>()
  worldCities.forEach((city) => countries.add(city.country))

  const countryOptions: CountryOption[] = [
    { label: "Ethiopia", value: "Ethiopia" },
    // { label: "United States", value: "United States" },
  ]

  // Array.from(countries)
  //   .filter((country) => country !== "Ethiopia" && country !== "United States")
  //   .sort()
  //   .forEach((country) => {
  //     countryOptions.push({ label: country, value: country })
  //   })

  return countryOptions
}
export function getStatesByCountry(countryName?: string) {
  const states = worldCities.filter((city) => city.country === countryName)

  const stateOptions = states.map((city, i) => {
    return { label: city.subcountry, value: city.subcountry, key: i }
  })

  return stateOptions.filter(
    (state, index, self) =>
      index === self.findIndex((t) => t.label === state.label),
  )
}
export function getCitiesByState(stateName?: string) {
  const cities = worldCities.filter((city) => city.subcountry === stateName)

  const cityOptions = cities.map((city, i) => {
    return { label: city.name, value: city.name, key: i }
  })

  return cityOptions.filter(
    (city, index, self) =>
      index === self.findIndex((t) => t.label === city.label),
  )
}
export function getCitiesByCountry(countryName?: string) {
  const cities = worldCities.filter((city) => city.country === countryName)

  const cityOptions = cities.map((city, i) => {
    return { label: city.name, value: city.name, key: i }
  })

  return cityOptions.filter(
    (city, index, self) =>
      index === self.findIndex((t) => t.label === city.label),
  )
}
